// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: public_api.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  AlgoServiceCommandList,
  AlgoState,
  AlgoStateList,
  AlgoStatus,
  algoStatusFromJSON,
  algoStatusToJSON,
  AlgoType,
  algoTypeFromJSON,
  algoTypeToJSON,
  HedgeMechanism,
  hedgeMechanismFromJSON,
  hedgeMechanismToJSON,
} from './algo'
import {
  AccountFeesList,
  AccountRole,
  accountRoleFromJSON,
  accountRoleToJSON,
  AccountSummaryList,
  ParadigmBindingState,
  paradigmBindingStateFromJSON,
  paradigmBindingStateToJSON,
  PlanLevel,
  planLevelFromJSON,
  planLevelToJSON,
  PortfolioDataList,
  PublicAccountList,
  StreamKind,
  streamKindFromJSON,
  streamKindToJSON,
} from './common/account'
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  Confirm2faSetupRequest,
  Confirm2faSetupResponse,
  ConfirmPasskeyLoginRequest,
  ConfirmPasskeyLoginResponse,
  ConfirmPasskeySetupRequest,
  ConfirmPasskeySetupResponse,
  DeletePasskeyRequest,
  DeletePasskeyResponse,
  Disable2faRequest,
  Disable2faResponse,
  Get2faBackupCodesRequest,
  Get2faBackupCodesResponse,
  GetUserPasskeysRequest,
  GetUserPasskeysResponse,
  GoogleLoginRequest,
  GoogleLoginResponse,
  ListSessionsRequest,
  ListSessionsResponse,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  LogoutResponse,
  PasskeyLoginRequest,
  PasskeyLoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  RevokeAllOtherSessionsRequest,
  RevokeAllOtherSessionsResponse,
  RevokeSessionRequest,
  RevokeSessionResponse,
  SendStepUpCodeRequest,
  SendStepUpCodeResponse,
  Setup2faRequest,
  Setup2faResponse,
  SetupPasskeyRequest,
  SetupPasskeyResponse,
  SignupRequest,
  SignupResponse,
  Verify2faLoginRequest,
  Verify2faLoginResponse,
  Verify2faRequest,
  Verify2faResponse,
} from './common/auth'
import {
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  InstrumentTradeList,
  Order,
  OrderList,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
  OrderStatus,
  orderStatusFromJSON,
  orderStatusToJSON,
  OrderType,
  orderTypeFromJSON,
  orderTypeToJSON,
  Position,
  PositionList,
  TimeInForce,
  timeInForceFromJSON,
  timeInForceToJSON,
  Trade,
  TradeList,
  TransferList,
} from './common/trading'
import {
  AccountDataStreamType,
  accountDataStreamTypeFromJSON,
  accountDataStreamTypeToJSON,
  AccountDataType,
  accountDataTypeFromJSON,
  accountDataTypeToJSON,
  AnalyticsType,
  analyticsTypeFromJSON,
  analyticsTypeToJSON,
  ChartTimeframe,
  chartTimeframeFromJSON,
  chartTimeframeToJSON,
  Exchange,
  ExchangeDataType,
  exchangeDataTypeFromJSON,
  exchangeDataTypeToJSON,
  exchangeFromJSON,
  exchangeToJSON,
  IncrementalTickerList,
  Instrument,
  InstrumentKind,
  instrumentKindFromJSON,
  instrumentKindToJSON,
  InstrumentList as InstrumentList1,
  InstrumentStateList,
  InstrumentType,
  instrumentTypeFromJSON,
  instrumentTypeToJSON,
  MarketDataType,
  marketDataTypeFromJSON,
  marketDataTypeToJSON,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  OrderBookList,
  TickerList,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './common/types'
import { OrderExecutionCommandList } from './execution'
import { TestIntentCompilerRequest, TradeIntent } from './intent_compiler'
import { ServiceNotification } from './notifications'
import {
  CreatePresetRequest,
  CreatePresetResponse,
  DeletePresetRequest,
  DeletePresetResponse,
  ExecutePresetRequest,
  ExecutePresetResponse,
  GetPresetRequest,
  GetPresetResponse,
  ListPresetsRequest,
  ListPresetsResponse,
  UpdatePresetRequest,
  UpdatePresetResponse,
} from './preset'
import {
  AutoApprove,
  AutoRetry,
  RfqAccept,
  RfqHedgeLeg,
  RfqLeg,
  RfqMakerQuoteList,
  RfqMakerRfqList,
  RfqNetwork,
  rfqNetworkFromJSON,
  rfqNetworkToJSON,
  RfqQuoteSide,
  rfqQuoteSideFromJSON,
  rfqQuoteSideToJSON,
  RfqState,
  rfqStateFromJSON,
  rfqStateToJSON,
  RfqUpdate,
  RfqUpdateList,
} from './rfq'
import {
  Trigger,
  TriggerConditionType,
  triggerConditionTypeFromJSON,
  triggerConditionTypeToJSON,
  TriggerEvaluationSnapshot,
} from './triggers'

export const protobufPackage = 'public_api'

/** FXStreet API enums: https://calendar-api.fxstreet.com/swagger/index.html */
export enum EventVolatility {
  EVENT_VOLATILITY_UNSPECIFIED = 0,
  EVENT_VOLATILITY_NONE = 1,
  EVENT_VOLATILITY_LOW = 2,
  EVENT_VOLATILITY_MEDIUM = 3,
  EVENT_VOLATILITY_HIGH = 4,
  UNRECOGNIZED = -1,
}

export function eventVolatilityFromJSON(object: any): EventVolatility {
  switch (object) {
    case 0:
    case 'EVENT_VOLATILITY_UNSPECIFIED':
      return EventVolatility.EVENT_VOLATILITY_UNSPECIFIED
    case 1:
    case 'EVENT_VOLATILITY_NONE':
      return EventVolatility.EVENT_VOLATILITY_NONE
    case 2:
    case 'EVENT_VOLATILITY_LOW':
      return EventVolatility.EVENT_VOLATILITY_LOW
    case 3:
    case 'EVENT_VOLATILITY_MEDIUM':
      return EventVolatility.EVENT_VOLATILITY_MEDIUM
    case 4:
    case 'EVENT_VOLATILITY_HIGH':
      return EventVolatility.EVENT_VOLATILITY_HIGH
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EventVolatility.UNRECOGNIZED
  }
}

export function eventVolatilityToJSON(object: EventVolatility): string {
  switch (object) {
    case EventVolatility.EVENT_VOLATILITY_UNSPECIFIED:
      return 'EVENT_VOLATILITY_UNSPECIFIED'
    case EventVolatility.EVENT_VOLATILITY_NONE:
      return 'EVENT_VOLATILITY_NONE'
    case EventVolatility.EVENT_VOLATILITY_LOW:
      return 'EVENT_VOLATILITY_LOW'
    case EventVolatility.EVENT_VOLATILITY_MEDIUM:
      return 'EVENT_VOLATILITY_MEDIUM'
    case EventVolatility.EVENT_VOLATILITY_HIGH:
      return 'EVENT_VOLATILITY_HIGH'
    case EventVolatility.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum EventPotency {
  EVENT_POTENCY_UNSPECIFIED = 0,
  EVENT_POTENCY_ZERO = 1,
  EVENT_POTENCY_K = 2,
  EVENT_POTENCY_M = 3,
  EVENT_POTENCY_B = 4,
  EVENT_POTENCY_T = 5,
  UNRECOGNIZED = -1,
}

export function eventPotencyFromJSON(object: any): EventPotency {
  switch (object) {
    case 0:
    case 'EVENT_POTENCY_UNSPECIFIED':
      return EventPotency.EVENT_POTENCY_UNSPECIFIED
    case 1:
    case 'EVENT_POTENCY_ZERO':
      return EventPotency.EVENT_POTENCY_ZERO
    case 2:
    case 'EVENT_POTENCY_K':
      return EventPotency.EVENT_POTENCY_K
    case 3:
    case 'EVENT_POTENCY_M':
      return EventPotency.EVENT_POTENCY_M
    case 4:
    case 'EVENT_POTENCY_B':
      return EventPotency.EVENT_POTENCY_B
    case 5:
    case 'EVENT_POTENCY_T':
      return EventPotency.EVENT_POTENCY_T
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EventPotency.UNRECOGNIZED
  }
}

export function eventPotencyToJSON(object: EventPotency): string {
  switch (object) {
    case EventPotency.EVENT_POTENCY_UNSPECIFIED:
      return 'EVENT_POTENCY_UNSPECIFIED'
    case EventPotency.EVENT_POTENCY_ZERO:
      return 'EVENT_POTENCY_ZERO'
    case EventPotency.EVENT_POTENCY_K:
      return 'EVENT_POTENCY_K'
    case EventPotency.EVENT_POTENCY_M:
      return 'EVENT_POTENCY_M'
    case EventPotency.EVENT_POTENCY_B:
      return 'EVENT_POTENCY_B'
    case EventPotency.EVENT_POTENCY_T:
      return 'EVENT_POTENCY_T'
    case EventPotency.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum EventPeriodType {
  EVENT_PERIOD_TYPE_UNSPECIFIED = 0,
  EVENT_PERIOD_TYPE_NONE = 1,
  EVENT_PERIOD_TYPE_DAY = 2,
  EVENT_PERIOD_TYPE_MONTH = 3,
  EVENT_PERIOD_TYPE_QUARTER = 4,
  UNRECOGNIZED = -1,
}

export function eventPeriodTypeFromJSON(object: any): EventPeriodType {
  switch (object) {
    case 0:
    case 'EVENT_PERIOD_TYPE_UNSPECIFIED':
      return EventPeriodType.EVENT_PERIOD_TYPE_UNSPECIFIED
    case 1:
    case 'EVENT_PERIOD_TYPE_NONE':
      return EventPeriodType.EVENT_PERIOD_TYPE_NONE
    case 2:
    case 'EVENT_PERIOD_TYPE_DAY':
      return EventPeriodType.EVENT_PERIOD_TYPE_DAY
    case 3:
    case 'EVENT_PERIOD_TYPE_MONTH':
      return EventPeriodType.EVENT_PERIOD_TYPE_MONTH
    case 4:
    case 'EVENT_PERIOD_TYPE_QUARTER':
      return EventPeriodType.EVENT_PERIOD_TYPE_QUARTER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EventPeriodType.UNRECOGNIZED
  }
}

export function eventPeriodTypeToJSON(object: EventPeriodType): string {
  switch (object) {
    case EventPeriodType.EVENT_PERIOD_TYPE_UNSPECIFIED:
      return 'EVENT_PERIOD_TYPE_UNSPECIFIED'
    case EventPeriodType.EVENT_PERIOD_TYPE_NONE:
      return 'EVENT_PERIOD_TYPE_NONE'
    case EventPeriodType.EVENT_PERIOD_TYPE_DAY:
      return 'EVENT_PERIOD_TYPE_DAY'
    case EventPeriodType.EVENT_PERIOD_TYPE_MONTH:
      return 'EVENT_PERIOD_TYPE_MONTH'
    case EventPeriodType.EVENT_PERIOD_TYPE_QUARTER:
      return 'EVENT_PERIOD_TYPE_QUARTER'
    case EventPeriodType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ScreenerFlag {
  SCREENER_FLAG_UNSPECIFIED = 0,
  SCREENER_FLAG_PUMPING = 1,
  SCREENER_FLAG_DUMPING = 2,
  SCREENER_FLAG_HIGH_VOL = 3,
  SCREENER_FLAG_SQUEEZE = 4,
  SCREENER_FLAG_OI_SURGE = 5,
  SCREENER_FLAG_THIN_BOOK = 6,
  SCREENER_FLAG_FUNDING_EXTREME = 7,
  UNRECOGNIZED = -1,
}

export function screenerFlagFromJSON(object: any): ScreenerFlag {
  switch (object) {
    case 0:
    case 'SCREENER_FLAG_UNSPECIFIED':
      return ScreenerFlag.SCREENER_FLAG_UNSPECIFIED
    case 1:
    case 'SCREENER_FLAG_PUMPING':
      return ScreenerFlag.SCREENER_FLAG_PUMPING
    case 2:
    case 'SCREENER_FLAG_DUMPING':
      return ScreenerFlag.SCREENER_FLAG_DUMPING
    case 3:
    case 'SCREENER_FLAG_HIGH_VOL':
      return ScreenerFlag.SCREENER_FLAG_HIGH_VOL
    case 4:
    case 'SCREENER_FLAG_SQUEEZE':
      return ScreenerFlag.SCREENER_FLAG_SQUEEZE
    case 5:
    case 'SCREENER_FLAG_OI_SURGE':
      return ScreenerFlag.SCREENER_FLAG_OI_SURGE
    case 6:
    case 'SCREENER_FLAG_THIN_BOOK':
      return ScreenerFlag.SCREENER_FLAG_THIN_BOOK
    case 7:
    case 'SCREENER_FLAG_FUNDING_EXTREME':
      return ScreenerFlag.SCREENER_FLAG_FUNDING_EXTREME
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ScreenerFlag.UNRECOGNIZED
  }
}

export function screenerFlagToJSON(object: ScreenerFlag): string {
  switch (object) {
    case ScreenerFlag.SCREENER_FLAG_UNSPECIFIED:
      return 'SCREENER_FLAG_UNSPECIFIED'
    case ScreenerFlag.SCREENER_FLAG_PUMPING:
      return 'SCREENER_FLAG_PUMPING'
    case ScreenerFlag.SCREENER_FLAG_DUMPING:
      return 'SCREENER_FLAG_DUMPING'
    case ScreenerFlag.SCREENER_FLAG_HIGH_VOL:
      return 'SCREENER_FLAG_HIGH_VOL'
    case ScreenerFlag.SCREENER_FLAG_SQUEEZE:
      return 'SCREENER_FLAG_SQUEEZE'
    case ScreenerFlag.SCREENER_FLAG_OI_SURGE:
      return 'SCREENER_FLAG_OI_SURGE'
    case ScreenerFlag.SCREENER_FLAG_THIN_BOOK:
      return 'SCREENER_FLAG_THIN_BOOK'
    case ScreenerFlag.SCREENER_FLAG_FUNDING_EXTREME:
      return 'SCREENER_FLAG_FUNDING_EXTREME'
    case ScreenerFlag.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * ENG-929. Which of the four Fed datasets a range request wants; the response is
 * the `DataPayload` variant matching it, the same contract
 * `GetAnalyticRangeRequest` uses for the options analytics.
 */
export enum EconomicDataset {
  ECONOMIC_DATASET_UNSPECIFIED = 0,
  ECONOMIC_DATASET_INFLATION = 1,
  ECONOMIC_DATASET_INFLATION_EXPECTATIONS = 2,
  ECONOMIC_DATASET_LABOR_MARKET = 3,
  ECONOMIC_DATASET_TREASURY_YIELDS = 4,
  UNRECOGNIZED = -1,
}

export function economicDatasetFromJSON(object: any): EconomicDataset {
  switch (object) {
    case 0:
    case 'ECONOMIC_DATASET_UNSPECIFIED':
      return EconomicDataset.ECONOMIC_DATASET_UNSPECIFIED
    case 1:
    case 'ECONOMIC_DATASET_INFLATION':
      return EconomicDataset.ECONOMIC_DATASET_INFLATION
    case 2:
    case 'ECONOMIC_DATASET_INFLATION_EXPECTATIONS':
      return EconomicDataset.ECONOMIC_DATASET_INFLATION_EXPECTATIONS
    case 3:
    case 'ECONOMIC_DATASET_LABOR_MARKET':
      return EconomicDataset.ECONOMIC_DATASET_LABOR_MARKET
    case 4:
    case 'ECONOMIC_DATASET_TREASURY_YIELDS':
      return EconomicDataset.ECONOMIC_DATASET_TREASURY_YIELDS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EconomicDataset.UNRECOGNIZED
  }
}

export function economicDatasetToJSON(object: EconomicDataset): string {
  switch (object) {
    case EconomicDataset.ECONOMIC_DATASET_UNSPECIFIED:
      return 'ECONOMIC_DATASET_UNSPECIFIED'
    case EconomicDataset.ECONOMIC_DATASET_INFLATION:
      return 'ECONOMIC_DATASET_INFLATION'
    case EconomicDataset.ECONOMIC_DATASET_INFLATION_EXPECTATIONS:
      return 'ECONOMIC_DATASET_INFLATION_EXPECTATIONS'
    case EconomicDataset.ECONOMIC_DATASET_LABOR_MARKET:
      return 'ECONOMIC_DATASET_LABOR_MARKET'
    case EconomicDataset.ECONOMIC_DATASET_TREASURY_YIELDS:
      return 'ECONOMIC_DATASET_TREASURY_YIELDS'
    case EconomicDataset.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Describes the precision of the announcement, not its duration: a `DATE` event
 * may still carry a `date_end` months out, so this does not map onto
 * `EventPeriodType`.
 */
export enum CoinMarketCalDateType {
  COIN_MARKET_CAL_DATE_TYPE_UNSPECIFIED = 0,
  COIN_MARKET_CAL_DATE_TYPE_DATE = 1,
  COIN_MARKET_CAL_DATE_TYPE_MONTH = 2,
  COIN_MARKET_CAL_DATE_TYPE_QUARTER = 3,
  UNRECOGNIZED = -1,
}

export function coinMarketCalDateTypeFromJSON(object: any): CoinMarketCalDateType {
  switch (object) {
    case 0:
    case 'COIN_MARKET_CAL_DATE_TYPE_UNSPECIFIED':
      return CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_UNSPECIFIED
    case 1:
    case 'COIN_MARKET_CAL_DATE_TYPE_DATE':
      return CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_DATE
    case 2:
    case 'COIN_MARKET_CAL_DATE_TYPE_MONTH':
      return CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_MONTH
    case 3:
    case 'COIN_MARKET_CAL_DATE_TYPE_QUARTER':
      return CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_QUARTER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CoinMarketCalDateType.UNRECOGNIZED
  }
}

export function coinMarketCalDateTypeToJSON(object: CoinMarketCalDateType): string {
  switch (object) {
    case CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_UNSPECIFIED:
      return 'COIN_MARKET_CAL_DATE_TYPE_UNSPECIFIED'
    case CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_DATE:
      return 'COIN_MARKET_CAL_DATE_TYPE_DATE'
    case CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_MONTH:
      return 'COIN_MARKET_CAL_DATE_TYPE_MONTH'
    case CoinMarketCalDateType.COIN_MARKET_CAL_DATE_TYPE_QUARTER:
      return 'COIN_MARKET_CAL_DATE_TYPE_QUARTER'
    case CoinMarketCalDateType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * On-demand refcounted CLOB subscription control (ENG-530 Phase 1 step 4).
 * Consumers (Phase 2: alerts at its per-subject 0->1 / 1->0 edges) publish this
 * fire-and-forget on the dedicated control subject `polymarket.subscribe`; the
 * data crate keeps a per-token want count and opens/closes the CLOB market WS on
 * the 0->1 / 1->0 transition. WANT and UNWANT fold into one path (one subject,
 * one decode) rather than two parallel subjects.
 */
export enum PolymarketSubscriptionAction {
  POLYMARKET_SUBSCRIPTION_ACTION_UNSPECIFIED = 0,
  POLYMARKET_SUBSCRIPTION_ACTION_WANT = 1,
  POLYMARKET_SUBSCRIPTION_ACTION_UNWANT = 2,
  UNRECOGNIZED = -1,
}

export function polymarketSubscriptionActionFromJSON(object: any): PolymarketSubscriptionAction {
  switch (object) {
    case 0:
    case 'POLYMARKET_SUBSCRIPTION_ACTION_UNSPECIFIED':
      return PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_UNSPECIFIED
    case 1:
    case 'POLYMARKET_SUBSCRIPTION_ACTION_WANT':
      return PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_WANT
    case 2:
    case 'POLYMARKET_SUBSCRIPTION_ACTION_UNWANT':
      return PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_UNWANT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PolymarketSubscriptionAction.UNRECOGNIZED
  }
}

export function polymarketSubscriptionActionToJSON(object: PolymarketSubscriptionAction): string {
  switch (object) {
    case PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_UNSPECIFIED:
      return 'POLYMARKET_SUBSCRIPTION_ACTION_UNSPECIFIED'
    case PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_WANT:
      return 'POLYMARKET_SUBSCRIPTION_ACTION_WANT'
    case PolymarketSubscriptionAction.POLYMARKET_SUBSCRIPTION_ACTION_UNWANT:
      return 'POLYMARKET_SUBSCRIPTION_ACTION_UNWANT'
    case PolymarketSubscriptionAction.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ExecutionAnalyticsTargetType {
  EXECUTION_ANALYTICS_TARGET_TYPE_UNSPECIFIED = 0,
  EXECUTION_ANALYTICS_TARGET_TYPE_ALGO = 1,
  EXECUTION_ANALYTICS_TARGET_TYPE_ORDER = 2,
  UNRECOGNIZED = -1,
}

export function executionAnalyticsTargetTypeFromJSON(object: any): ExecutionAnalyticsTargetType {
  switch (object) {
    case 0:
    case 'EXECUTION_ANALYTICS_TARGET_TYPE_UNSPECIFIED':
      return ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_UNSPECIFIED
    case 1:
    case 'EXECUTION_ANALYTICS_TARGET_TYPE_ALGO':
      return ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_ALGO
    case 2:
    case 'EXECUTION_ANALYTICS_TARGET_TYPE_ORDER':
      return ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_ORDER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExecutionAnalyticsTargetType.UNRECOGNIZED
  }
}

export function executionAnalyticsTargetTypeToJSON(object: ExecutionAnalyticsTargetType): string {
  switch (object) {
    case ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_UNSPECIFIED:
      return 'EXECUTION_ANALYTICS_TARGET_TYPE_UNSPECIFIED'
    case ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_ALGO:
      return 'EXECUTION_ANALYTICS_TARGET_TYPE_ALGO'
    case ExecutionAnalyticsTargetType.EXECUTION_ANALYTICS_TARGET_TYPE_ORDER:
      return 'EXECUTION_ANALYTICS_TARGET_TYPE_ORDER'
    case ExecutionAnalyticsTargetType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Controls how `orders` is populated in ExecutionAnalytics responses.
 * UNSPECIFIED is treated as LATEST_PER_ORDER for backwards compatibility.
 */
export enum OrderInclusion {
  ORDER_INCLUSION_UNSPECIFIED = 0,
  ORDER_INCLUSION_NONE = 1,
  ORDER_INCLUSION_LATEST_PER_ORDER = 2,
  ORDER_INCLUSION_FULL_HISTORY_PER_ORDER = 3,
  UNRECOGNIZED = -1,
}

export function orderInclusionFromJSON(object: any): OrderInclusion {
  switch (object) {
    case 0:
    case 'ORDER_INCLUSION_UNSPECIFIED':
      return OrderInclusion.ORDER_INCLUSION_UNSPECIFIED
    case 1:
    case 'ORDER_INCLUSION_NONE':
      return OrderInclusion.ORDER_INCLUSION_NONE
    case 2:
    case 'ORDER_INCLUSION_LATEST_PER_ORDER':
      return OrderInclusion.ORDER_INCLUSION_LATEST_PER_ORDER
    case 3:
    case 'ORDER_INCLUSION_FULL_HISTORY_PER_ORDER':
      return OrderInclusion.ORDER_INCLUSION_FULL_HISTORY_PER_ORDER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OrderInclusion.UNRECOGNIZED
  }
}

export function orderInclusionToJSON(object: OrderInclusion): string {
  switch (object) {
    case OrderInclusion.ORDER_INCLUSION_UNSPECIFIED:
      return 'ORDER_INCLUSION_UNSPECIFIED'
    case OrderInclusion.ORDER_INCLUSION_NONE:
      return 'ORDER_INCLUSION_NONE'
    case OrderInclusion.ORDER_INCLUSION_LATEST_PER_ORDER:
      return 'ORDER_INCLUSION_LATEST_PER_ORDER'
    case OrderInclusion.ORDER_INCLUSION_FULL_HISTORY_PER_ORDER:
      return 'ORDER_INCLUSION_FULL_HISTORY_PER_ORDER'
    case OrderInclusion.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Paradigm (paradigm.co) RFQ desk account binding. A Paradigm desk labels its
 * own trading accounts with free-text nicknames; ConnectDesk registers desk
 * credentials, ListAccounts cross-matches nicknames against this user's
 * Deribit trade history, and LinkAccount records the binding. See
 * docs/superpowers/specs/2026-08-21-paradigm-account-binding-design.md.
 *
 * PARADIGM_BINDING_EVIDENCE_UNSPECIFIED == every pre-existing row and every
 * message from an older client — prost decodes an absent field to 0. It
 * means "no data", never "unknown but safe".
 */
export enum ParadigmBindingEvidence {
  /** PARADIGM_BINDING_EVIDENCE_UNSPECIFIED - == "no data" on old rows */
  PARADIGM_BINDING_EVIDENCE_UNSPECIFIED = 0,
  PARADIGM_BINDING_EVIDENCE_PROVEN_THIS_ACCOUNT = 1,
  PARADIGM_BINDING_EVIDENCE_PROVEN_OTHER_ACCOUNT = 2,
  PARADIGM_BINDING_EVIDENCE_NO_HISTORY = 3,
  UNRECOGNIZED = -1,
}

export function paradigmBindingEvidenceFromJSON(object: any): ParadigmBindingEvidence {
  switch (object) {
    case 0:
    case 'PARADIGM_BINDING_EVIDENCE_UNSPECIFIED':
      return ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_UNSPECIFIED
    case 1:
    case 'PARADIGM_BINDING_EVIDENCE_PROVEN_THIS_ACCOUNT':
      return ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_PROVEN_THIS_ACCOUNT
    case 2:
    case 'PARADIGM_BINDING_EVIDENCE_PROVEN_OTHER_ACCOUNT':
      return ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_PROVEN_OTHER_ACCOUNT
    case 3:
    case 'PARADIGM_BINDING_EVIDENCE_NO_HISTORY':
      return ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_NO_HISTORY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ParadigmBindingEvidence.UNRECOGNIZED
  }
}

export function paradigmBindingEvidenceToJSON(object: ParadigmBindingEvidence): string {
  switch (object) {
    case ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_UNSPECIFIED:
      return 'PARADIGM_BINDING_EVIDENCE_UNSPECIFIED'
    case ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_PROVEN_THIS_ACCOUNT:
      return 'PARADIGM_BINDING_EVIDENCE_PROVEN_THIS_ACCOUNT'
    case ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_PROVEN_OTHER_ACCOUNT:
      return 'PARADIGM_BINDING_EVIDENCE_PROVEN_OTHER_ACCOUNT'
    case ParadigmBindingEvidence.PARADIGM_BINDING_EVIDENCE_NO_HISTORY:
      return 'PARADIGM_BINDING_EVIDENCE_NO_HISTORY'
    case ParadigmBindingEvidence.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * MAINTENANCE / UNPLANNED_OUTAGE are reserved for a future alert service; the
 * calendar engine only ever emits OPEN / CLOSED.
 */
export enum ExchangeStatusType {
  EXCHANGE_STATUS_TYPE_UNSPECIFIED = 0,
  EXCHANGE_STATUS_TYPE_OPEN = 1,
  EXCHANGE_STATUS_TYPE_CLOSED = 2,
  EXCHANGE_STATUS_TYPE_MAINTENANCE = 3,
  EXCHANGE_STATUS_TYPE_UNPLANNED_OUTAGE = 4,
  UNRECOGNIZED = -1,
}

export function exchangeStatusTypeFromJSON(object: any): ExchangeStatusType {
  switch (object) {
    case 0:
    case 'EXCHANGE_STATUS_TYPE_UNSPECIFIED':
      return ExchangeStatusType.EXCHANGE_STATUS_TYPE_UNSPECIFIED
    case 1:
    case 'EXCHANGE_STATUS_TYPE_OPEN':
      return ExchangeStatusType.EXCHANGE_STATUS_TYPE_OPEN
    case 2:
    case 'EXCHANGE_STATUS_TYPE_CLOSED':
      return ExchangeStatusType.EXCHANGE_STATUS_TYPE_CLOSED
    case 3:
    case 'EXCHANGE_STATUS_TYPE_MAINTENANCE':
      return ExchangeStatusType.EXCHANGE_STATUS_TYPE_MAINTENANCE
    case 4:
    case 'EXCHANGE_STATUS_TYPE_UNPLANNED_OUTAGE':
      return ExchangeStatusType.EXCHANGE_STATUS_TYPE_UNPLANNED_OUTAGE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExchangeStatusType.UNRECOGNIZED
  }
}

export function exchangeStatusTypeToJSON(object: ExchangeStatusType): string {
  switch (object) {
    case ExchangeStatusType.EXCHANGE_STATUS_TYPE_UNSPECIFIED:
      return 'EXCHANGE_STATUS_TYPE_UNSPECIFIED'
    case ExchangeStatusType.EXCHANGE_STATUS_TYPE_OPEN:
      return 'EXCHANGE_STATUS_TYPE_OPEN'
    case ExchangeStatusType.EXCHANGE_STATUS_TYPE_CLOSED:
      return 'EXCHANGE_STATUS_TYPE_CLOSED'
    case ExchangeStatusType.EXCHANGE_STATUS_TYPE_MAINTENANCE:
      return 'EXCHANGE_STATUS_TYPE_MAINTENANCE'
    case ExchangeStatusType.EXCHANGE_STATUS_TYPE_UNPLANNED_OUTAGE:
      return 'EXCHANGE_STATUS_TYPE_UNPLANNED_OUTAGE'
    case ExchangeStatusType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum VenueHealthChange {
  VENUE_HEALTH_CHANGE_UNSPECIFIED = 0,
  VENUE_HEALTH_CHANGE_DATA = 1,
  VENUE_HEALTH_CHANGE_TRADING = 2,
  UNRECOGNIZED = -1,
}

export function venueHealthChangeFromJSON(object: any): VenueHealthChange {
  switch (object) {
    case 0:
    case 'VENUE_HEALTH_CHANGE_UNSPECIFIED':
      return VenueHealthChange.VENUE_HEALTH_CHANGE_UNSPECIFIED
    case 1:
    case 'VENUE_HEALTH_CHANGE_DATA':
      return VenueHealthChange.VENUE_HEALTH_CHANGE_DATA
    case 2:
    case 'VENUE_HEALTH_CHANGE_TRADING':
      return VenueHealthChange.VENUE_HEALTH_CHANGE_TRADING
    case -1:
    case 'UNRECOGNIZED':
    default:
      return VenueHealthChange.UNRECOGNIZED
  }
}

export function venueHealthChangeToJSON(object: VenueHealthChange): string {
  switch (object) {
    case VenueHealthChange.VENUE_HEALTH_CHANGE_UNSPECIFIED:
      return 'VENUE_HEALTH_CHANGE_UNSPECIFIED'
    case VenueHealthChange.VENUE_HEALTH_CHANGE_DATA:
      return 'VENUE_HEALTH_CHANGE_DATA'
    case VenueHealthChange.VENUE_HEALTH_CHANGE_TRADING:
      return 'VENUE_HEALTH_CHANGE_TRADING'
    case VenueHealthChange.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * ENG-613 #2/#3 — options volume leaderboards (24h snapshot over trades_options).
 * Quote measures require index_price (populated for Deribit options).
 */
export enum OptionsVolumeMeasure {
  OPTIONS_VOLUME_MEASURE_UNSPECIFIED = 0,
  /** OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE - sum(quantity) */
  OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE = 1,
  /** OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE - sum(quantity * index_price) */
  OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE = 2,
  /** OPTIONS_VOLUME_MEASURE_PREMIUM_BASE - sum(quantity * price) */
  OPTIONS_VOLUME_MEASURE_PREMIUM_BASE = 3,
  /** OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE - sum(quantity * price * index_price) */
  OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE = 4,
  UNRECOGNIZED = -1,
}

export function optionsVolumeMeasureFromJSON(object: any): OptionsVolumeMeasure {
  switch (object) {
    case 0:
    case 'OPTIONS_VOLUME_MEASURE_UNSPECIFIED':
      return OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_UNSPECIFIED
    case 1:
    case 'OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE':
      return OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE
    case 2:
    case 'OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE':
      return OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE
    case 3:
    case 'OPTIONS_VOLUME_MEASURE_PREMIUM_BASE':
      return OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_PREMIUM_BASE
    case 4:
    case 'OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE':
      return OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsVolumeMeasure.UNRECOGNIZED
  }
}

export function optionsVolumeMeasureToJSON(object: OptionsVolumeMeasure): string {
  switch (object) {
    case OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_UNSPECIFIED:
      return 'OPTIONS_VOLUME_MEASURE_UNSPECIFIED'
    case OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE:
      return 'OPTIONS_VOLUME_MEASURE_NOTIONAL_BASE'
    case OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE:
      return 'OPTIONS_VOLUME_MEASURE_NOTIONAL_QUOTE'
    case OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_PREMIUM_BASE:
      return 'OPTIONS_VOLUME_MEASURE_PREMIUM_BASE'
    case OptionsVolumeMeasure.OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE:
      return 'OPTIONS_VOLUME_MEASURE_PREMIUM_QUOTE'
    case OptionsVolumeMeasure.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsVolumeGroupBy {
  OPTIONS_VOLUME_GROUP_BY_UNSPECIFIED = 0,
  /** OPTIONS_VOLUME_GROUP_BY_EXPIRY - #2: one row per expiration */
  OPTIONS_VOLUME_GROUP_BY_EXPIRY = 1,
  /** OPTIONS_VOLUME_GROUP_BY_CONTRACT - #3: top-N contracts */
  OPTIONS_VOLUME_GROUP_BY_CONTRACT = 2,
  UNRECOGNIZED = -1,
}

export function optionsVolumeGroupByFromJSON(object: any): OptionsVolumeGroupBy {
  switch (object) {
    case 0:
    case 'OPTIONS_VOLUME_GROUP_BY_UNSPECIFIED':
      return OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_UNSPECIFIED
    case 1:
    case 'OPTIONS_VOLUME_GROUP_BY_EXPIRY':
      return OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_EXPIRY
    case 2:
    case 'OPTIONS_VOLUME_GROUP_BY_CONTRACT':
      return OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_CONTRACT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsVolumeGroupBy.UNRECOGNIZED
  }
}

export function optionsVolumeGroupByToJSON(object: OptionsVolumeGroupBy): string {
  switch (object) {
    case OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_UNSPECIFIED:
      return 'OPTIONS_VOLUME_GROUP_BY_UNSPECIFIED'
    case OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_EXPIRY:
      return 'OPTIONS_VOLUME_GROUP_BY_EXPIRY'
    case OptionsVolumeGroupBy.OPTIONS_VOLUME_GROUP_BY_CONTRACT:
      return 'OPTIONS_VOLUME_GROUP_BY_CONTRACT'
    case OptionsVolumeGroupBy.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum BlockTradeMode {
  /** BLOCK_TRADE_MODE_UNSPECIFIED - treated as ALL */
  BLOCK_TRADE_MODE_UNSPECIFIED = 0,
  /** BLOCK_TRADE_MODE_ALL - no block filter */
  BLOCK_TRADE_MODE_ALL = 1,
  /** BLOCK_TRADE_MODE_ONLY - only trades with a block_trade_id */
  BLOCK_TRADE_MODE_ONLY = 2,
  /** BLOCK_TRADE_MODE_NONE - only trades without a block_trade_id */
  BLOCK_TRADE_MODE_NONE = 3,
  UNRECOGNIZED = -1,
}

export function blockTradeModeFromJSON(object: any): BlockTradeMode {
  switch (object) {
    case 0:
    case 'BLOCK_TRADE_MODE_UNSPECIFIED':
      return BlockTradeMode.BLOCK_TRADE_MODE_UNSPECIFIED
    case 1:
    case 'BLOCK_TRADE_MODE_ALL':
      return BlockTradeMode.BLOCK_TRADE_MODE_ALL
    case 2:
    case 'BLOCK_TRADE_MODE_ONLY':
      return BlockTradeMode.BLOCK_TRADE_MODE_ONLY
    case 3:
    case 'BLOCK_TRADE_MODE_NONE':
      return BlockTradeMode.BLOCK_TRADE_MODE_NONE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return BlockTradeMode.UNRECOGNIZED
  }
}

export function blockTradeModeToJSON(object: BlockTradeMode): string {
  switch (object) {
    case BlockTradeMode.BLOCK_TRADE_MODE_UNSPECIFIED:
      return 'BLOCK_TRADE_MODE_UNSPECIFIED'
    case BlockTradeMode.BLOCK_TRADE_MODE_ALL:
      return 'BLOCK_TRADE_MODE_ALL'
    case BlockTradeMode.BLOCK_TRADE_MODE_ONLY:
      return 'BLOCK_TRADE_MODE_ONLY'
    case BlockTradeMode.BLOCK_TRADE_MODE_NONE:
      return 'BLOCK_TRADE_MODE_NONE'
    case BlockTradeMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** ENG-613 #5 — top contracts by open interest. */
export enum OptionsOiRankMode {
  OPTIONS_OI_RANK_MODE_UNSPECIFIED = 0,
  /** OPTIONS_OI_RANK_MODE_OI - top-N by current OI */
  OPTIONS_OI_RANK_MODE_OI = 1,
  /** OPTIONS_OI_RANK_MODE_OI_CHANGE_24H - top-N by 24h OI change */
  OPTIONS_OI_RANK_MODE_OI_CHANGE_24H = 2,
  UNRECOGNIZED = -1,
}

export function optionsOiRankModeFromJSON(object: any): OptionsOiRankMode {
  switch (object) {
    case 0:
    case 'OPTIONS_OI_RANK_MODE_UNSPECIFIED':
      return OptionsOiRankMode.OPTIONS_OI_RANK_MODE_UNSPECIFIED
    case 1:
    case 'OPTIONS_OI_RANK_MODE_OI':
      return OptionsOiRankMode.OPTIONS_OI_RANK_MODE_OI
    case 2:
    case 'OPTIONS_OI_RANK_MODE_OI_CHANGE_24H':
      return OptionsOiRankMode.OPTIONS_OI_RANK_MODE_OI_CHANGE_24H
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsOiRankMode.UNRECOGNIZED
  }
}

export function optionsOiRankModeToJSON(object: OptionsOiRankMode): string {
  switch (object) {
    case OptionsOiRankMode.OPTIONS_OI_RANK_MODE_UNSPECIFIED:
      return 'OPTIONS_OI_RANK_MODE_UNSPECIFIED'
    case OptionsOiRankMode.OPTIONS_OI_RANK_MODE_OI:
      return 'OPTIONS_OI_RANK_MODE_OI'
    case OptionsOiRankMode.OPTIONS_OI_RANK_MODE_OI_CHANGE_24H:
      return 'OPTIONS_OI_RANK_MODE_OI_CHANGE_24H'
    case OptionsOiRankMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Rank mode for the funding leaderboard. APR normalizes per-venue intervals so
 * rates are cross-venue comparable; RATE_ABS ranks the raw per-interval rate.
 */
export enum FundingRankMode {
  FUNDING_RANK_MODE_UNSPECIFIED = 0,
  /** FUNDING_APR - rank by annualized rate (cross-venue comparable) */
  FUNDING_APR = 1,
  /** FUNDING_RATE_ABS - rank by |per-interval rate| */
  FUNDING_RATE_ABS = 2,
  UNRECOGNIZED = -1,
}

export function fundingRankModeFromJSON(object: any): FundingRankMode {
  switch (object) {
    case 0:
    case 'FUNDING_RANK_MODE_UNSPECIFIED':
      return FundingRankMode.FUNDING_RANK_MODE_UNSPECIFIED
    case 1:
    case 'FUNDING_APR':
      return FundingRankMode.FUNDING_APR
    case 2:
    case 'FUNDING_RATE_ABS':
      return FundingRankMode.FUNDING_RATE_ABS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return FundingRankMode.UNRECOGNIZED
  }
}

export function fundingRankModeToJSON(object: FundingRankMode): string {
  switch (object) {
    case FundingRankMode.FUNDING_RANK_MODE_UNSPECIFIED:
      return 'FUNDING_RANK_MODE_UNSPECIFIED'
    case FundingRankMode.FUNDING_APR:
      return 'FUNDING_APR'
    case FundingRankMode.FUNDING_RATE_ABS:
      return 'FUNDING_RATE_ABS'
    case FundingRankMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Which fit produced an SviPoint. `book` and `marks` come from the venue data
 * services (vol-fit-runtime); `analytics` from the analytics service's minute
 * fit of chains no venue service owns.
 */
export enum SviSourceKind {
  SVI_SOURCE_KIND_UNSPECIFIED = 0,
  SVI_SOURCE_KIND_BOOK = 1,
  SVI_SOURCE_KIND_MARKS = 2,
  SVI_SOURCE_KIND_ANALYTICS = 3,
  UNRECOGNIZED = -1,
}

export function sviSourceKindFromJSON(object: any): SviSourceKind {
  switch (object) {
    case 0:
    case 'SVI_SOURCE_KIND_UNSPECIFIED':
      return SviSourceKind.SVI_SOURCE_KIND_UNSPECIFIED
    case 1:
    case 'SVI_SOURCE_KIND_BOOK':
      return SviSourceKind.SVI_SOURCE_KIND_BOOK
    case 2:
    case 'SVI_SOURCE_KIND_MARKS':
      return SviSourceKind.SVI_SOURCE_KIND_MARKS
    case 3:
    case 'SVI_SOURCE_KIND_ANALYTICS':
      return SviSourceKind.SVI_SOURCE_KIND_ANALYTICS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SviSourceKind.UNRECOGNIZED
  }
}

export function sviSourceKindToJSON(object: SviSourceKind): string {
  switch (object) {
    case SviSourceKind.SVI_SOURCE_KIND_UNSPECIFIED:
      return 'SVI_SOURCE_KIND_UNSPECIFIED'
    case SviSourceKind.SVI_SOURCE_KIND_BOOK:
      return 'SVI_SOURCE_KIND_BOOK'
    case SviSourceKind.SVI_SOURCE_KIND_MARKS:
      return 'SVI_SOURCE_KIND_MARKS'
    case SviSourceKind.SVI_SOURCE_KIND_ANALYTICS:
      return 'SVI_SOURCE_KIND_ANALYTICS'
    case SviSourceKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * What a bucketed return is measured between: whether a bar's span includes the
 * hours the venue is shut, not how wide the bar is. Rides on all three bucketed
 * charts, and only the weekday one's bar is a whole trade date — an hour bar is
 * one hour, a session bar one 8h block.
 */
export enum ReturnBasis {
  RETURN_BASIS_UNSPECIFIED = 0,
  /** RETURN_BASIS_CLOSE_TO_CLOSE - Each bar opens where the previous one closed, so no move falls between bars. */
  RETURN_BASIS_CLOSE_TO_CLOSE = 1,
  /**
   * RETURN_BASIS_INTRADAY - The bar spans only the hours that traded, so the close-to-open move lands in
   * no bar. Weekday and hour charts only: a venue that shuts overnight has no 8h
   * session grid, and its session requests are refused rather than answered.
   */
  RETURN_BASIS_INTRADAY = 2,
  UNRECOGNIZED = -1,
}

export function returnBasisFromJSON(object: any): ReturnBasis {
  switch (object) {
    case 0:
    case 'RETURN_BASIS_UNSPECIFIED':
      return ReturnBasis.RETURN_BASIS_UNSPECIFIED
    case 1:
    case 'RETURN_BASIS_CLOSE_TO_CLOSE':
      return ReturnBasis.RETURN_BASIS_CLOSE_TO_CLOSE
    case 2:
    case 'RETURN_BASIS_INTRADAY':
      return ReturnBasis.RETURN_BASIS_INTRADAY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ReturnBasis.UNRECOGNIZED
  }
}

export function returnBasisToJSON(object: ReturnBasis): string {
  switch (object) {
    case ReturnBasis.RETURN_BASIS_UNSPECIFIED:
      return 'RETURN_BASIS_UNSPECIFIED'
    case ReturnBasis.RETURN_BASIS_CLOSE_TO_CLOSE:
      return 'RETURN_BASIS_CLOSE_TO_CLOSE'
    case ReturnBasis.RETURN_BASIS_INTRADAY:
      return 'RETURN_BASIS_INTRADAY'
    case ReturnBasis.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum IntentItemTrack {
  INTENT_ITEM_TRACK_UNSPECIFIED = 0,
  INTENT_ITEM_TRACK_ACTION = 1,
  INTENT_ITEM_TRACK_ALGO_SUBSCRIPTION = 2,
  INTENT_ITEM_TRACK_MANAGEMENT = 3,
  UNRECOGNIZED = -1,
}

export function intentItemTrackFromJSON(object: any): IntentItemTrack {
  switch (object) {
    case 0:
    case 'INTENT_ITEM_TRACK_UNSPECIFIED':
      return IntentItemTrack.INTENT_ITEM_TRACK_UNSPECIFIED
    case 1:
    case 'INTENT_ITEM_TRACK_ACTION':
      return IntentItemTrack.INTENT_ITEM_TRACK_ACTION
    case 2:
    case 'INTENT_ITEM_TRACK_ALGO_SUBSCRIPTION':
      return IntentItemTrack.INTENT_ITEM_TRACK_ALGO_SUBSCRIPTION
    case 3:
    case 'INTENT_ITEM_TRACK_MANAGEMENT':
      return IntentItemTrack.INTENT_ITEM_TRACK_MANAGEMENT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return IntentItemTrack.UNRECOGNIZED
  }
}

export function intentItemTrackToJSON(object: IntentItemTrack): string {
  switch (object) {
    case IntentItemTrack.INTENT_ITEM_TRACK_UNSPECIFIED:
      return 'INTENT_ITEM_TRACK_UNSPECIFIED'
    case IntentItemTrack.INTENT_ITEM_TRACK_ACTION:
      return 'INTENT_ITEM_TRACK_ACTION'
    case IntentItemTrack.INTENT_ITEM_TRACK_ALGO_SUBSCRIPTION:
      return 'INTENT_ITEM_TRACK_ALGO_SUBSCRIPTION'
    case IntentItemTrack.INTENT_ITEM_TRACK_MANAGEMENT:
      return 'INTENT_ITEM_TRACK_MANAGEMENT'
    case IntentItemTrack.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum IntentPipelineStage {
  INTENT_PIPELINE_STAGE_UNSPECIFIED = 0,
  INTENT_PIPELINE_STAGE_ACCOUNT_SNAPSHOT = 1,
  INTENT_PIPELINE_STAGE_RESOLVE = 2,
  INTENT_PIPELINE_STAGE_CROSS_ACTION = 3,
  INTENT_PIPELINE_STAGE_SIZING = 4,
  INTENT_PIPELINE_STAGE_ANCHOR = 5,
  INTENT_PIPELINE_STAGE_BUILD = 6,
  INTENT_PIPELINE_STAGE_GUARD = 7,
  INTENT_PIPELINE_STAGE_TRIGGER = 8,
  INTENT_PIPELINE_STAGE_EMIT = 9,
  UNRECOGNIZED = -1,
}

export function intentPipelineStageFromJSON(object: any): IntentPipelineStage {
  switch (object) {
    case 0:
    case 'INTENT_PIPELINE_STAGE_UNSPECIFIED':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_UNSPECIFIED
    case 1:
    case 'INTENT_PIPELINE_STAGE_ACCOUNT_SNAPSHOT':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_ACCOUNT_SNAPSHOT
    case 2:
    case 'INTENT_PIPELINE_STAGE_RESOLVE':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_RESOLVE
    case 3:
    case 'INTENT_PIPELINE_STAGE_CROSS_ACTION':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_CROSS_ACTION
    case 4:
    case 'INTENT_PIPELINE_STAGE_SIZING':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_SIZING
    case 5:
    case 'INTENT_PIPELINE_STAGE_ANCHOR':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_ANCHOR
    case 6:
    case 'INTENT_PIPELINE_STAGE_BUILD':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_BUILD
    case 7:
    case 'INTENT_PIPELINE_STAGE_GUARD':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_GUARD
    case 8:
    case 'INTENT_PIPELINE_STAGE_TRIGGER':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_TRIGGER
    case 9:
    case 'INTENT_PIPELINE_STAGE_EMIT':
      return IntentPipelineStage.INTENT_PIPELINE_STAGE_EMIT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return IntentPipelineStage.UNRECOGNIZED
  }
}

export function intentPipelineStageToJSON(object: IntentPipelineStage): string {
  switch (object) {
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_UNSPECIFIED:
      return 'INTENT_PIPELINE_STAGE_UNSPECIFIED'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_ACCOUNT_SNAPSHOT:
      return 'INTENT_PIPELINE_STAGE_ACCOUNT_SNAPSHOT'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_RESOLVE:
      return 'INTENT_PIPELINE_STAGE_RESOLVE'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_CROSS_ACTION:
      return 'INTENT_PIPELINE_STAGE_CROSS_ACTION'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_SIZING:
      return 'INTENT_PIPELINE_STAGE_SIZING'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_ANCHOR:
      return 'INTENT_PIPELINE_STAGE_ANCHOR'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_BUILD:
      return 'INTENT_PIPELINE_STAGE_BUILD'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_GUARD:
      return 'INTENT_PIPELINE_STAGE_GUARD'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_TRIGGER:
      return 'INTENT_PIPELINE_STAGE_TRIGGER'
    case IntentPipelineStage.INTENT_PIPELINE_STAGE_EMIT:
      return 'INTENT_PIPELINE_STAGE_EMIT'
    case IntentPipelineStage.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RefusalReason {
  REFUSAL_REASON_UNSPECIFIED = 0,
  REFUSAL_REASON_UNSUPPORTED_STRUCTURE = 1,
  REFUSAL_REASON_AMBIGUOUS_AMOUNT = 2,
  REFUSAL_REASON_AMBIGUOUS_INSTRUMENT = 3,
  REFUSAL_REASON_AMBIGUOUS_POSITION = 4,
  REFUSAL_REASON_INVALID_EXPIRY = 5,
  REFUSAL_REASON_INVALID_STRIKE = 6,
  REFUSAL_REASON_INVALID_PRICE = 7,
  REFUSAL_REASON_INVALID_TRIGGER = 8,
  REFUSAL_REASON_DUPLICATE_CLIENT_ACTION_ID = 9,
  REFUSAL_REASON_UNRESOLVABLE_REFERENCE = 10,
  REFUSAL_REASON_CAPABILITY_GATED = 11,
  REFUSAL_REASON_INVALID_REQUEST = 12,
  REFUSAL_REASON_REQUIRED_DATA_UNAVAILABLE = 13,
  REFUSAL_REASON_SIZING_CAP_EXCEEDED = 14,
  REFUSAL_REASON_EXECUTION_STYLE_UPGRADE_DISABLED = 15,
  REFUSAL_REASON_REDUCE_ONLY_VIOLATION = 16,
  REFUSAL_REASON_POST_ONLY_VIOLATION = 17,
  REFUSAL_REASON_UNKNOWN_ORDER_OR_ALGO_ID = 18,
  REFUSAL_REASON_CROSS_ACTION_CYCLE = 19,
  REFUSAL_REASON_ANCHOR_INCOMPATIBLE = 20,
  REFUSAL_REASON_INVALID_ACTION_REFERENCE = 21,
  REFUSAL_REASON_RESOLUTION_FAILED = 22,
  /**
   * REFUSAL_REASON_DELTA_ALREADY_AT_TARGET - The computed hedge order rounds to zero (or below the resolved
   * instrument's minimum tradable size) because the scope's current delta is
   * already within the target — there is nothing to trade.
   */
  REFUSAL_REASON_DELTA_ALREADY_AT_TARGET = 23,
  UNRECOGNIZED = -1,
}

export function refusalReasonFromJSON(object: any): RefusalReason {
  switch (object) {
    case 0:
    case 'REFUSAL_REASON_UNSPECIFIED':
      return RefusalReason.REFUSAL_REASON_UNSPECIFIED
    case 1:
    case 'REFUSAL_REASON_UNSUPPORTED_STRUCTURE':
      return RefusalReason.REFUSAL_REASON_UNSUPPORTED_STRUCTURE
    case 2:
    case 'REFUSAL_REASON_AMBIGUOUS_AMOUNT':
      return RefusalReason.REFUSAL_REASON_AMBIGUOUS_AMOUNT
    case 3:
    case 'REFUSAL_REASON_AMBIGUOUS_INSTRUMENT':
      return RefusalReason.REFUSAL_REASON_AMBIGUOUS_INSTRUMENT
    case 4:
    case 'REFUSAL_REASON_AMBIGUOUS_POSITION':
      return RefusalReason.REFUSAL_REASON_AMBIGUOUS_POSITION
    case 5:
    case 'REFUSAL_REASON_INVALID_EXPIRY':
      return RefusalReason.REFUSAL_REASON_INVALID_EXPIRY
    case 6:
    case 'REFUSAL_REASON_INVALID_STRIKE':
      return RefusalReason.REFUSAL_REASON_INVALID_STRIKE
    case 7:
    case 'REFUSAL_REASON_INVALID_PRICE':
      return RefusalReason.REFUSAL_REASON_INVALID_PRICE
    case 8:
    case 'REFUSAL_REASON_INVALID_TRIGGER':
      return RefusalReason.REFUSAL_REASON_INVALID_TRIGGER
    case 9:
    case 'REFUSAL_REASON_DUPLICATE_CLIENT_ACTION_ID':
      return RefusalReason.REFUSAL_REASON_DUPLICATE_CLIENT_ACTION_ID
    case 10:
    case 'REFUSAL_REASON_UNRESOLVABLE_REFERENCE':
      return RefusalReason.REFUSAL_REASON_UNRESOLVABLE_REFERENCE
    case 11:
    case 'REFUSAL_REASON_CAPABILITY_GATED':
      return RefusalReason.REFUSAL_REASON_CAPABILITY_GATED
    case 12:
    case 'REFUSAL_REASON_INVALID_REQUEST':
      return RefusalReason.REFUSAL_REASON_INVALID_REQUEST
    case 13:
    case 'REFUSAL_REASON_REQUIRED_DATA_UNAVAILABLE':
      return RefusalReason.REFUSAL_REASON_REQUIRED_DATA_UNAVAILABLE
    case 14:
    case 'REFUSAL_REASON_SIZING_CAP_EXCEEDED':
      return RefusalReason.REFUSAL_REASON_SIZING_CAP_EXCEEDED
    case 15:
    case 'REFUSAL_REASON_EXECUTION_STYLE_UPGRADE_DISABLED':
      return RefusalReason.REFUSAL_REASON_EXECUTION_STYLE_UPGRADE_DISABLED
    case 16:
    case 'REFUSAL_REASON_REDUCE_ONLY_VIOLATION':
      return RefusalReason.REFUSAL_REASON_REDUCE_ONLY_VIOLATION
    case 17:
    case 'REFUSAL_REASON_POST_ONLY_VIOLATION':
      return RefusalReason.REFUSAL_REASON_POST_ONLY_VIOLATION
    case 18:
    case 'REFUSAL_REASON_UNKNOWN_ORDER_OR_ALGO_ID':
      return RefusalReason.REFUSAL_REASON_UNKNOWN_ORDER_OR_ALGO_ID
    case 19:
    case 'REFUSAL_REASON_CROSS_ACTION_CYCLE':
      return RefusalReason.REFUSAL_REASON_CROSS_ACTION_CYCLE
    case 20:
    case 'REFUSAL_REASON_ANCHOR_INCOMPATIBLE':
      return RefusalReason.REFUSAL_REASON_ANCHOR_INCOMPATIBLE
    case 21:
    case 'REFUSAL_REASON_INVALID_ACTION_REFERENCE':
      return RefusalReason.REFUSAL_REASON_INVALID_ACTION_REFERENCE
    case 22:
    case 'REFUSAL_REASON_RESOLUTION_FAILED':
      return RefusalReason.REFUSAL_REASON_RESOLUTION_FAILED
    case 23:
    case 'REFUSAL_REASON_DELTA_ALREADY_AT_TARGET':
      return RefusalReason.REFUSAL_REASON_DELTA_ALREADY_AT_TARGET
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RefusalReason.UNRECOGNIZED
  }
}

export function refusalReasonToJSON(object: RefusalReason): string {
  switch (object) {
    case RefusalReason.REFUSAL_REASON_UNSPECIFIED:
      return 'REFUSAL_REASON_UNSPECIFIED'
    case RefusalReason.REFUSAL_REASON_UNSUPPORTED_STRUCTURE:
      return 'REFUSAL_REASON_UNSUPPORTED_STRUCTURE'
    case RefusalReason.REFUSAL_REASON_AMBIGUOUS_AMOUNT:
      return 'REFUSAL_REASON_AMBIGUOUS_AMOUNT'
    case RefusalReason.REFUSAL_REASON_AMBIGUOUS_INSTRUMENT:
      return 'REFUSAL_REASON_AMBIGUOUS_INSTRUMENT'
    case RefusalReason.REFUSAL_REASON_AMBIGUOUS_POSITION:
      return 'REFUSAL_REASON_AMBIGUOUS_POSITION'
    case RefusalReason.REFUSAL_REASON_INVALID_EXPIRY:
      return 'REFUSAL_REASON_INVALID_EXPIRY'
    case RefusalReason.REFUSAL_REASON_INVALID_STRIKE:
      return 'REFUSAL_REASON_INVALID_STRIKE'
    case RefusalReason.REFUSAL_REASON_INVALID_PRICE:
      return 'REFUSAL_REASON_INVALID_PRICE'
    case RefusalReason.REFUSAL_REASON_INVALID_TRIGGER:
      return 'REFUSAL_REASON_INVALID_TRIGGER'
    case RefusalReason.REFUSAL_REASON_DUPLICATE_CLIENT_ACTION_ID:
      return 'REFUSAL_REASON_DUPLICATE_CLIENT_ACTION_ID'
    case RefusalReason.REFUSAL_REASON_UNRESOLVABLE_REFERENCE:
      return 'REFUSAL_REASON_UNRESOLVABLE_REFERENCE'
    case RefusalReason.REFUSAL_REASON_CAPABILITY_GATED:
      return 'REFUSAL_REASON_CAPABILITY_GATED'
    case RefusalReason.REFUSAL_REASON_INVALID_REQUEST:
      return 'REFUSAL_REASON_INVALID_REQUEST'
    case RefusalReason.REFUSAL_REASON_REQUIRED_DATA_UNAVAILABLE:
      return 'REFUSAL_REASON_REQUIRED_DATA_UNAVAILABLE'
    case RefusalReason.REFUSAL_REASON_SIZING_CAP_EXCEEDED:
      return 'REFUSAL_REASON_SIZING_CAP_EXCEEDED'
    case RefusalReason.REFUSAL_REASON_EXECUTION_STYLE_UPGRADE_DISABLED:
      return 'REFUSAL_REASON_EXECUTION_STYLE_UPGRADE_DISABLED'
    case RefusalReason.REFUSAL_REASON_REDUCE_ONLY_VIOLATION:
      return 'REFUSAL_REASON_REDUCE_ONLY_VIOLATION'
    case RefusalReason.REFUSAL_REASON_POST_ONLY_VIOLATION:
      return 'REFUSAL_REASON_POST_ONLY_VIOLATION'
    case RefusalReason.REFUSAL_REASON_UNKNOWN_ORDER_OR_ALGO_ID:
      return 'REFUSAL_REASON_UNKNOWN_ORDER_OR_ALGO_ID'
    case RefusalReason.REFUSAL_REASON_CROSS_ACTION_CYCLE:
      return 'REFUSAL_REASON_CROSS_ACTION_CYCLE'
    case RefusalReason.REFUSAL_REASON_ANCHOR_INCOMPATIBLE:
      return 'REFUSAL_REASON_ANCHOR_INCOMPATIBLE'
    case RefusalReason.REFUSAL_REASON_INVALID_ACTION_REFERENCE:
      return 'REFUSAL_REASON_INVALID_ACTION_REFERENCE'
    case RefusalReason.REFUSAL_REASON_RESOLUTION_FAILED:
      return 'REFUSAL_REASON_RESOLUTION_FAILED'
    case RefusalReason.REFUSAL_REASON_DELTA_ALREADY_AT_TARGET:
      return 'REFUSAL_REASON_DELTA_ALREADY_AT_TARGET'
    case RefusalReason.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum WarningSeverity {
  WARNING_SEVERITY_UNSPECIFIED = 0,
  /** WARNING_SEVERITY_INFO - Just a heads up (e.g., "This market is illiquid") */
  WARNING_SEVERITY_INFO = 1,
  /** WARNING_SEVERITY_WARNING - Requires user confirmation (e.g., "High slippage expected") */
  WARNING_SEVERITY_WARNING = 2,
  /** WARNING_SEVERITY_BLOCKER - Cannot execute (e.g., "Insufficient funds") */
  WARNING_SEVERITY_BLOCKER = 3,
  UNRECOGNIZED = -1,
}

export function warningSeverityFromJSON(object: any): WarningSeverity {
  switch (object) {
    case 0:
    case 'WARNING_SEVERITY_UNSPECIFIED':
      return WarningSeverity.WARNING_SEVERITY_UNSPECIFIED
    case 1:
    case 'WARNING_SEVERITY_INFO':
      return WarningSeverity.WARNING_SEVERITY_INFO
    case 2:
    case 'WARNING_SEVERITY_WARNING':
      return WarningSeverity.WARNING_SEVERITY_WARNING
    case 3:
    case 'WARNING_SEVERITY_BLOCKER':
      return WarningSeverity.WARNING_SEVERITY_BLOCKER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return WarningSeverity.UNRECOGNIZED
  }
}

export function warningSeverityToJSON(object: WarningSeverity): string {
  switch (object) {
    case WarningSeverity.WARNING_SEVERITY_UNSPECIFIED:
      return 'WARNING_SEVERITY_UNSPECIFIED'
    case WarningSeverity.WARNING_SEVERITY_INFO:
      return 'WARNING_SEVERITY_INFO'
    case WarningSeverity.WARNING_SEVERITY_WARNING:
      return 'WARNING_SEVERITY_WARNING'
    case WarningSeverity.WARNING_SEVERITY_BLOCKER:
      return 'WARNING_SEVERITY_BLOCKER'
    case WarningSeverity.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RecommendedAction {
  RECOMMENDED_ACTION_UNSPECIFIED = 0,
  /** RECOMMENDED_ACTION_REDUCE_SIZE - --- Sizing & Capital Actions --- */
  RECOMMENDED_ACTION_REDUCE_SIZE = 1,
  /** RECOMMENDED_ACTION_DEPOSIT_FUNDS - E.g., for INSUFFICIENT_FUNDS */
  RECOMMENDED_ACTION_DEPOSIT_FUNDS = 2,
  /** RECOMMENDED_ACTION_USE_TWAP - --- Execution Strategy Actions --- */
  RECOMMENDED_ACTION_USE_TWAP = 3,
  /** RECOMMENDED_ACTION_USE_LIMIT - E.g., "Set a hard ceiling on price" */
  RECOMMENDED_ACTION_USE_LIMIT = 4,
  /** RECOMMENDED_ACTION_INCREASE_DURATION - E.g., "Change 5 mins to 1 hour" */
  RECOMMENDED_ACTION_INCREASE_DURATION = 5,
  /** RECOMMENDED_ACTION_USE_LIMIT_CHASE - E.g., "Convert this aggressive limit order to limit chase" */
  RECOMMENDED_ACTION_USE_LIMIT_CHASE = 8,
  /** RECOMMENDED_ACTION_BALANCE_LEGS - --- Multi-Leg / Options Actions --- */
  RECOMMENDED_ACTION_BALANCE_LEGS = 6,
  /** RECOMMENDED_ACTION_ALIGN_EXPIRIES - E.g., "Fix the mismatched dates in your calendar spread" */
  RECOMMENDED_ACTION_ALIGN_EXPIRIES = 7,
  UNRECOGNIZED = -1,
}

export function recommendedActionFromJSON(object: any): RecommendedAction {
  switch (object) {
    case 0:
    case 'RECOMMENDED_ACTION_UNSPECIFIED':
      return RecommendedAction.RECOMMENDED_ACTION_UNSPECIFIED
    case 1:
    case 'RECOMMENDED_ACTION_REDUCE_SIZE':
      return RecommendedAction.RECOMMENDED_ACTION_REDUCE_SIZE
    case 2:
    case 'RECOMMENDED_ACTION_DEPOSIT_FUNDS':
      return RecommendedAction.RECOMMENDED_ACTION_DEPOSIT_FUNDS
    case 3:
    case 'RECOMMENDED_ACTION_USE_TWAP':
      return RecommendedAction.RECOMMENDED_ACTION_USE_TWAP
    case 4:
    case 'RECOMMENDED_ACTION_USE_LIMIT':
      return RecommendedAction.RECOMMENDED_ACTION_USE_LIMIT
    case 5:
    case 'RECOMMENDED_ACTION_INCREASE_DURATION':
      return RecommendedAction.RECOMMENDED_ACTION_INCREASE_DURATION
    case 8:
    case 'RECOMMENDED_ACTION_USE_LIMIT_CHASE':
      return RecommendedAction.RECOMMENDED_ACTION_USE_LIMIT_CHASE
    case 6:
    case 'RECOMMENDED_ACTION_BALANCE_LEGS':
      return RecommendedAction.RECOMMENDED_ACTION_BALANCE_LEGS
    case 7:
    case 'RECOMMENDED_ACTION_ALIGN_EXPIRIES':
      return RecommendedAction.RECOMMENDED_ACTION_ALIGN_EXPIRIES
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RecommendedAction.UNRECOGNIZED
  }
}

export function recommendedActionToJSON(object: RecommendedAction): string {
  switch (object) {
    case RecommendedAction.RECOMMENDED_ACTION_UNSPECIFIED:
      return 'RECOMMENDED_ACTION_UNSPECIFIED'
    case RecommendedAction.RECOMMENDED_ACTION_REDUCE_SIZE:
      return 'RECOMMENDED_ACTION_REDUCE_SIZE'
    case RecommendedAction.RECOMMENDED_ACTION_DEPOSIT_FUNDS:
      return 'RECOMMENDED_ACTION_DEPOSIT_FUNDS'
    case RecommendedAction.RECOMMENDED_ACTION_USE_TWAP:
      return 'RECOMMENDED_ACTION_USE_TWAP'
    case RecommendedAction.RECOMMENDED_ACTION_USE_LIMIT:
      return 'RECOMMENDED_ACTION_USE_LIMIT'
    case RecommendedAction.RECOMMENDED_ACTION_INCREASE_DURATION:
      return 'RECOMMENDED_ACTION_INCREASE_DURATION'
    case RecommendedAction.RECOMMENDED_ACTION_USE_LIMIT_CHASE:
      return 'RECOMMENDED_ACTION_USE_LIMIT_CHASE'
    case RecommendedAction.RECOMMENDED_ACTION_BALANCE_LEGS:
      return 'RECOMMENDED_ACTION_BALANCE_LEGS'
    case RecommendedAction.RECOMMENDED_ACTION_ALIGN_EXPIRIES:
      return 'RECOMMENDED_ACTION_ALIGN_EXPIRIES'
    case RecommendedAction.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum WarningCode {
  WARNING_CODE_UNSPECIFIED = 0,
  /**
   * WARNING_CODE_HIGH_MARKET_IMPACT - ----------------------------------------------------------------
   * 1. MARKET & EXECUTION RISKS (Slippage, Liquidity)
   * ----------------------------------------------------------------
   */
  WARNING_CODE_HIGH_MARKET_IMPACT = 100,
  /** WARNING_CODE_ILLIQUID_INSTRUMENT - Spread is unusually wide or volume is zero. */
  WARNING_CODE_ILLIQUID_INSTRUMENT = 101,
  /** WARNING_CODE_STALE_PRICING - Backend couldn't fetch a fresh mark price; using old data. */
  WARNING_CODE_STALE_PRICING = 102,
  /** WARNING_CODE_BELOW_MIN_NOTIONAL - Exchange might reject this for being too small. */
  WARNING_CODE_BELOW_MIN_NOTIONAL = 103,
  /** WARNING_CODE_DENOMINATION_INFERRED - Intent processor flipped Base↔Quote because the AI-supplied denomination produced an over-cap notional, but the other interpretation is reasonable. Info severity. */
  WARNING_CODE_DENOMINATION_INFERRED = 104,
  /** WARNING_CODE_SIZE_EXCEEDS_CAP - Both denominations exceed the per-asset USD cap. Blocker severity. */
  WARNING_CODE_SIZE_EXCEEDS_CAP = 105,
  /** WARNING_CODE_ALREADY_AT_TARGET - Delta is already within target now; a triggered hedge may still do nothing when it fires. */
  WARNING_CODE_ALREADY_AT_TARGET = 106,
  /**
   * WARNING_CODE_INSUFFICIENT_FUNDS - ----------------------------------------------------------------
   * 2. PORTFOLIO & MARGIN RISKS (Balance, Liquidation)
   * ----------------------------------------------------------------
   */
  WARNING_CODE_INSUFFICIENT_FUNDS = 200,
  /** WARNING_CODE_INSUFFICIENT_MARGIN - Derivative order exceeds available buying power. */
  WARNING_CODE_INSUFFICIENT_MARGIN = 201,
  /** WARNING_CODE_HIGH_LIQUIDATION_RISK - Executing this will push portfolio margin dangerously close to maintenance levels. */
  WARNING_CODE_HIGH_LIQUIDATION_RISK = 202,
  /** WARNING_CODE_NAKED_SHORT_EXPOSURE - Selling naked options with theoretically infinite risk. */
  WARNING_CODE_NAKED_SHORT_EXPOSURE = 203,
  /**
   * WARNING_CODE_UNBALANCED_LEGS - ----------------------------------------------------------------
   * 3. COMPLEX STRATEGY RISKS (Options, Spreads, Multi-Leg)
   * ----------------------------------------------------------------
   */
  WARNING_CODE_UNBALANCED_LEGS = 300,
  /** WARNING_CODE_ASYMMETRIC_CORRIDOR - Call/Put corridor has mismatched strikes/widths. */
  WARNING_CODE_ASYMMETRIC_CORRIDOR = 301,
  /** WARNING_CODE_EXPIRY_MISMATCH - Legs in a spread have different expiration dates (Calendar spread risk). */
  WARNING_CODE_EXPIRY_MISMATCH = 302,
  /**
   * WARNING_CODE_TWAP_DURATION_TOO_SHORT - ----------------------------------------------------------------
   * 4. SYSTEM & ROUTING RISKS
   * ----------------------------------------------------------------
   */
  WARNING_CODE_TWAP_DURATION_TOO_SHORT = 400,
  /** WARNING_CODE_INSTRUMENT_NOT_FOUND - Backend couldn't resolve the requested instrument (unknown symbol, missing market, stale cache). The chat clarification flow can prompt the user to pick a different one. */
  WARNING_CODE_INSTRUMENT_NOT_FOUND = 401,
  UNRECOGNIZED = -1,
}

export function warningCodeFromJSON(object: any): WarningCode {
  switch (object) {
    case 0:
    case 'WARNING_CODE_UNSPECIFIED':
      return WarningCode.WARNING_CODE_UNSPECIFIED
    case 100:
    case 'WARNING_CODE_HIGH_MARKET_IMPACT':
      return WarningCode.WARNING_CODE_HIGH_MARKET_IMPACT
    case 101:
    case 'WARNING_CODE_ILLIQUID_INSTRUMENT':
      return WarningCode.WARNING_CODE_ILLIQUID_INSTRUMENT
    case 102:
    case 'WARNING_CODE_STALE_PRICING':
      return WarningCode.WARNING_CODE_STALE_PRICING
    case 103:
    case 'WARNING_CODE_BELOW_MIN_NOTIONAL':
      return WarningCode.WARNING_CODE_BELOW_MIN_NOTIONAL
    case 104:
    case 'WARNING_CODE_DENOMINATION_INFERRED':
      return WarningCode.WARNING_CODE_DENOMINATION_INFERRED
    case 105:
    case 'WARNING_CODE_SIZE_EXCEEDS_CAP':
      return WarningCode.WARNING_CODE_SIZE_EXCEEDS_CAP
    case 106:
    case 'WARNING_CODE_ALREADY_AT_TARGET':
      return WarningCode.WARNING_CODE_ALREADY_AT_TARGET
    case 200:
    case 'WARNING_CODE_INSUFFICIENT_FUNDS':
      return WarningCode.WARNING_CODE_INSUFFICIENT_FUNDS
    case 201:
    case 'WARNING_CODE_INSUFFICIENT_MARGIN':
      return WarningCode.WARNING_CODE_INSUFFICIENT_MARGIN
    case 202:
    case 'WARNING_CODE_HIGH_LIQUIDATION_RISK':
      return WarningCode.WARNING_CODE_HIGH_LIQUIDATION_RISK
    case 203:
    case 'WARNING_CODE_NAKED_SHORT_EXPOSURE':
      return WarningCode.WARNING_CODE_NAKED_SHORT_EXPOSURE
    case 300:
    case 'WARNING_CODE_UNBALANCED_LEGS':
      return WarningCode.WARNING_CODE_UNBALANCED_LEGS
    case 301:
    case 'WARNING_CODE_ASYMMETRIC_CORRIDOR':
      return WarningCode.WARNING_CODE_ASYMMETRIC_CORRIDOR
    case 302:
    case 'WARNING_CODE_EXPIRY_MISMATCH':
      return WarningCode.WARNING_CODE_EXPIRY_MISMATCH
    case 400:
    case 'WARNING_CODE_TWAP_DURATION_TOO_SHORT':
      return WarningCode.WARNING_CODE_TWAP_DURATION_TOO_SHORT
    case 401:
    case 'WARNING_CODE_INSTRUMENT_NOT_FOUND':
      return WarningCode.WARNING_CODE_INSTRUMENT_NOT_FOUND
    case -1:
    case 'UNRECOGNIZED':
    default:
      return WarningCode.UNRECOGNIZED
  }
}

export function warningCodeToJSON(object: WarningCode): string {
  switch (object) {
    case WarningCode.WARNING_CODE_UNSPECIFIED:
      return 'WARNING_CODE_UNSPECIFIED'
    case WarningCode.WARNING_CODE_HIGH_MARKET_IMPACT:
      return 'WARNING_CODE_HIGH_MARKET_IMPACT'
    case WarningCode.WARNING_CODE_ILLIQUID_INSTRUMENT:
      return 'WARNING_CODE_ILLIQUID_INSTRUMENT'
    case WarningCode.WARNING_CODE_STALE_PRICING:
      return 'WARNING_CODE_STALE_PRICING'
    case WarningCode.WARNING_CODE_BELOW_MIN_NOTIONAL:
      return 'WARNING_CODE_BELOW_MIN_NOTIONAL'
    case WarningCode.WARNING_CODE_DENOMINATION_INFERRED:
      return 'WARNING_CODE_DENOMINATION_INFERRED'
    case WarningCode.WARNING_CODE_SIZE_EXCEEDS_CAP:
      return 'WARNING_CODE_SIZE_EXCEEDS_CAP'
    case WarningCode.WARNING_CODE_ALREADY_AT_TARGET:
      return 'WARNING_CODE_ALREADY_AT_TARGET'
    case WarningCode.WARNING_CODE_INSUFFICIENT_FUNDS:
      return 'WARNING_CODE_INSUFFICIENT_FUNDS'
    case WarningCode.WARNING_CODE_INSUFFICIENT_MARGIN:
      return 'WARNING_CODE_INSUFFICIENT_MARGIN'
    case WarningCode.WARNING_CODE_HIGH_LIQUIDATION_RISK:
      return 'WARNING_CODE_HIGH_LIQUIDATION_RISK'
    case WarningCode.WARNING_CODE_NAKED_SHORT_EXPOSURE:
      return 'WARNING_CODE_NAKED_SHORT_EXPOSURE'
    case WarningCode.WARNING_CODE_UNBALANCED_LEGS:
      return 'WARNING_CODE_UNBALANCED_LEGS'
    case WarningCode.WARNING_CODE_ASYMMETRIC_CORRIDOR:
      return 'WARNING_CODE_ASYMMETRIC_CORRIDOR'
    case WarningCode.WARNING_CODE_EXPIRY_MISMATCH:
      return 'WARNING_CODE_EXPIRY_MISMATCH'
    case WarningCode.WARNING_CODE_TWAP_DURATION_TOO_SHORT:
      return 'WARNING_CODE_TWAP_DURATION_TOO_SHORT'
    case WarningCode.WARNING_CODE_INSTRUMENT_NOT_FOUND:
      return 'WARNING_CODE_INSTRUMENT_NOT_FOUND'
    case WarningCode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Cadence of public market data (order books, tickers, trades, analytics) on
 * this connection. The user's own account data (orders, fills, positions,
 * notifications) always goes out at the default cadence.
 */
export enum StreamInterval {
  /** STREAM_INTERVAL_UNSPECIFIED - server default, 250 ms */
  STREAM_INTERVAL_UNSPECIFIED = 0,
  STREAM_INTERVAL_MS_250 = 1,
  /** STREAM_INTERVAL_MS_1000 - e.g. mobile / metered links */
  STREAM_INTERVAL_MS_1000 = 2,
  UNRECOGNIZED = -1,
}

export function streamIntervalFromJSON(object: any): StreamInterval {
  switch (object) {
    case 0:
    case 'STREAM_INTERVAL_UNSPECIFIED':
      return StreamInterval.STREAM_INTERVAL_UNSPECIFIED
    case 1:
    case 'STREAM_INTERVAL_MS_250':
      return StreamInterval.STREAM_INTERVAL_MS_250
    case 2:
    case 'STREAM_INTERVAL_MS_1000':
      return StreamInterval.STREAM_INTERVAL_MS_1000
    case -1:
    case 'UNRECOGNIZED':
    default:
      return StreamInterval.UNRECOGNIZED
  }
}

export function streamIntervalToJSON(object: StreamInterval): string {
  switch (object) {
    case StreamInterval.STREAM_INTERVAL_UNSPECIFIED:
      return 'STREAM_INTERVAL_UNSPECIFIED'
    case StreamInterval.STREAM_INTERVAL_MS_250:
      return 'STREAM_INTERVAL_MS_250'
    case StreamInterval.STREAM_INTERVAL_MS_1000:
      return 'STREAM_INTERVAL_MS_1000'
    case StreamInterval.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PositionViewMode {
  POSITION_VIEW_MODE_UNSPECIFIED = 0,
  POSITION_VIEW_MODE_UNSORTED = 1,
  POSITION_VIEW_MODE_CUSTOM = 2,
  POSITION_VIEW_MODE_AUTO = 3,
  UNRECOGNIZED = -1,
}

export function positionViewModeFromJSON(object: any): PositionViewMode {
  switch (object) {
    case 0:
    case 'POSITION_VIEW_MODE_UNSPECIFIED':
      return PositionViewMode.POSITION_VIEW_MODE_UNSPECIFIED
    case 1:
    case 'POSITION_VIEW_MODE_UNSORTED':
      return PositionViewMode.POSITION_VIEW_MODE_UNSORTED
    case 2:
    case 'POSITION_VIEW_MODE_CUSTOM':
      return PositionViewMode.POSITION_VIEW_MODE_CUSTOM
    case 3:
    case 'POSITION_VIEW_MODE_AUTO':
      return PositionViewMode.POSITION_VIEW_MODE_AUTO
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PositionViewMode.UNRECOGNIZED
  }
}

export function positionViewModeToJSON(object: PositionViewMode): string {
  switch (object) {
    case PositionViewMode.POSITION_VIEW_MODE_UNSPECIFIED:
      return 'POSITION_VIEW_MODE_UNSPECIFIED'
    case PositionViewMode.POSITION_VIEW_MODE_UNSORTED:
      return 'POSITION_VIEW_MODE_UNSORTED'
    case PositionViewMode.POSITION_VIEW_MODE_CUSTOM:
      return 'POSITION_VIEW_MODE_CUSTOM'
    case PositionViewMode.POSITION_VIEW_MODE_AUTO:
      return 'POSITION_VIEW_MODE_AUTO'
    case PositionViewMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PositionViewEntryKind {
  POSITION_VIEW_ENTRY_KIND_UNSPECIFIED = 0,
  POSITION_VIEW_ENTRY_KIND_GROUP = 1,
  POSITION_VIEW_ENTRY_KIND_POSITION = 2,
  UNRECOGNIZED = -1,
}

export function positionViewEntryKindFromJSON(object: any): PositionViewEntryKind {
  switch (object) {
    case 0:
    case 'POSITION_VIEW_ENTRY_KIND_UNSPECIFIED':
      return PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_UNSPECIFIED
    case 1:
    case 'POSITION_VIEW_ENTRY_KIND_GROUP':
      return PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_GROUP
    case 2:
    case 'POSITION_VIEW_ENTRY_KIND_POSITION':
      return PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_POSITION
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PositionViewEntryKind.UNRECOGNIZED
  }
}

export function positionViewEntryKindToJSON(object: PositionViewEntryKind): string {
  switch (object) {
    case PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_UNSPECIFIED:
      return 'POSITION_VIEW_ENTRY_KIND_UNSPECIFIED'
    case PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_GROUP:
      return 'POSITION_VIEW_ENTRY_KIND_GROUP'
    case PositionViewEntryKind.POSITION_VIEW_ENTRY_KIND_POSITION:
      return 'POSITION_VIEW_ENTRY_KIND_POSITION'
    case PositionViewEntryKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionPriceSource {
  OPTION_PRICE_SOURCE_UNSPECIFIED = 0,
  OPTION_PRICE_SOURCE_MARK = 1,
  OPTION_PRICE_SOURCE_MID = 2,
  OPTION_PRICE_SOURCE_WEIGHTED_MID = 3,
  /**
   * OPTION_PRICE_SOURCE_AMBERDATA - The loop that wrote these VOL_SURFACES keys is gone and nothing replaces
   * it, so risk_simulation rejects this value rather than answering from a
   * surface it cannot build. Use MARK, MID or WEIGHTED_MID; the number stays
   * reserved.
   *
   * @deprecated
   */
  OPTION_PRICE_SOURCE_AMBERDATA = 4,
  UNRECOGNIZED = -1,
}

export function optionPriceSourceFromJSON(object: any): OptionPriceSource {
  switch (object) {
    case 0:
    case 'OPTION_PRICE_SOURCE_UNSPECIFIED':
      return OptionPriceSource.OPTION_PRICE_SOURCE_UNSPECIFIED
    case 1:
    case 'OPTION_PRICE_SOURCE_MARK':
      return OptionPriceSource.OPTION_PRICE_SOURCE_MARK
    case 2:
    case 'OPTION_PRICE_SOURCE_MID':
      return OptionPriceSource.OPTION_PRICE_SOURCE_MID
    case 3:
    case 'OPTION_PRICE_SOURCE_WEIGHTED_MID':
      return OptionPriceSource.OPTION_PRICE_SOURCE_WEIGHTED_MID
    case 4:
    case 'OPTION_PRICE_SOURCE_AMBERDATA':
      return OptionPriceSource.OPTION_PRICE_SOURCE_AMBERDATA
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionPriceSource.UNRECOGNIZED
  }
}

export function optionPriceSourceToJSON(object: OptionPriceSource): string {
  switch (object) {
    case OptionPriceSource.OPTION_PRICE_SOURCE_UNSPECIFIED:
      return 'OPTION_PRICE_SOURCE_UNSPECIFIED'
    case OptionPriceSource.OPTION_PRICE_SOURCE_MARK:
      return 'OPTION_PRICE_SOURCE_MARK'
    case OptionPriceSource.OPTION_PRICE_SOURCE_MID:
      return 'OPTION_PRICE_SOURCE_MID'
    case OptionPriceSource.OPTION_PRICE_SOURCE_WEIGHTED_MID:
      return 'OPTION_PRICE_SOURCE_WEIGHTED_MID'
    case OptionPriceSource.OPTION_PRICE_SOURCE_AMBERDATA:
      return 'OPTION_PRICE_SOURCE_AMBERDATA'
    case OptionPriceSource.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum SimulationPriceRangeKind {
  /** SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED - Defaults to ABSOLUTE for backward compatibility. */
  SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED = 0,
  /** SIMULATION_PRICE_RANGE_KIND_ABSOLUTE - value_lower / value_upper are exact prices. */
  SIMULATION_PRICE_RANGE_KIND_ABSOLUTE = 1,
  /**
   * SIMULATION_PRICE_RANGE_KIND_PERCENT - value_lower / value_upper are fractions of the current mark price,
   * e.g. 0.30 = 30%.  Resolved server-side via the price KV.
   */
  SIMULATION_PRICE_RANGE_KIND_PERCENT = 2,
  UNRECOGNIZED = -1,
}

export function simulationPriceRangeKindFromJSON(object: any): SimulationPriceRangeKind {
  switch (object) {
    case 0:
    case 'SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED':
      return SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED
    case 1:
    case 'SIMULATION_PRICE_RANGE_KIND_ABSOLUTE':
      return SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_ABSOLUTE
    case 2:
    case 'SIMULATION_PRICE_RANGE_KIND_PERCENT':
      return SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_PERCENT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SimulationPriceRangeKind.UNRECOGNIZED
  }
}

export function simulationPriceRangeKindToJSON(object: SimulationPriceRangeKind): string {
  switch (object) {
    case SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED:
      return 'SIMULATION_PRICE_RANGE_KIND_UNSPECIFIED'
    case SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_ABSOLUTE:
      return 'SIMULATION_PRICE_RANGE_KIND_ABSOLUTE'
    case SimulationPriceRangeKind.SIMULATION_PRICE_RANGE_KIND_PERCENT:
      return 'SIMULATION_PRICE_RANGE_KIND_PERCENT'
    case SimulationPriceRangeKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum RiskSimulationMarginRegime {
  RISK_SIMULATION_MARGIN_REGIME_UNSPECIFIED = 0,
  /** RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD - Per-position standard rules, linear legs margined on mark notional. */
  RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD = 1,
  /**
   * RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD - Per-position standard rules, linear IM fixed on ENTRY notional
   * (Bybit isolated, Hyperliquid/Lighter isolated positions).
   */
  RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD = 2,
  /** RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO - Worst loss of the pool over a price/vol shock grid. */
  RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO = 3,
  UNRECOGNIZED = -1,
}

export function riskSimulationMarginRegimeFromJSON(object: any): RiskSimulationMarginRegime {
  switch (object) {
    case 0:
    case 'RISK_SIMULATION_MARGIN_REGIME_UNSPECIFIED':
      return RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_UNSPECIFIED
    case 1:
    case 'RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD':
      return RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD
    case 2:
    case 'RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD':
      return RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD
    case 3:
    case 'RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO':
      return RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO
    case -1:
    case 'UNRECOGNIZED':
    default:
      return RiskSimulationMarginRegime.UNRECOGNIZED
  }
}

export function riskSimulationMarginRegimeToJSON(object: RiskSimulationMarginRegime): string {
  switch (object) {
    case RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_UNSPECIFIED:
      return 'RISK_SIMULATION_MARGIN_REGIME_UNSPECIFIED'
    case RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD:
      return 'RISK_SIMULATION_MARGIN_REGIME_CROSS_STANDARD'
    case RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD:
      return 'RISK_SIMULATION_MARGIN_REGIME_ISOLATED_STANDARD'
    case RiskSimulationMarginRegime.RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO:
      return 'RISK_SIMULATION_MARGIN_REGIME_PORTFOLIO'
    case RiskSimulationMarginRegime.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Which CandleList field families the client wants populated. Empty = ALL
 * (legacy clients predate this field). Unpopulated families come back as
 * empty arrays (zero wire cost) and their DB joins/scans are skipped.
 */
export enum CandleFamily {
  /** CANDLE_FAMILY_UNSPECIFIED - ignored; empty list is the ALL signal */
  CANDLE_FAMILY_UNSPECIFIED = 0,
  /** CANDLE_FAMILY_CORE - ticks, OHLC, volume_base/quote, vwap, twap — always populated */
  CANDLE_FAMILY_CORE = 1,
  /** CANDLE_FAMILY_ORDER_FLOW - buy/sell/net volumes (base+quote CVD), trade counts, avg sizes, delta_percentage */
  CANDLE_FAMILY_ORDER_FLOW = 2,
  /** CANDLE_FAMILY_LIQUIDATIONS - total/buy/sell liq, liqwap, liq counts, taker/maker, net_liquidations */
  CANDLE_FAMILY_LIQUIDATIONS = 3,
  /** CANDLE_FAMILY_BLOCK_INCL - _block_incl variants (skips the block-incl MV join) */
  CANDLE_FAMILY_BLOCK_INCL = 4,
  /** CANDLE_FAMILY_VOLATILITY - realized_volatility, vwap_twap_spread */
  CANDLE_FAMILY_VOLATILITY = 5,
  /** CANDLE_FAMILY_FUNDING_OI - funding + OI OHLC (skips the derivative_metrics join) */
  CANDLE_FAMILY_FUNDING_OI = 6,
  /**
   * CANDLE_FAMILY_AGGREGATE_OI - Cross-exchange aggregates. Only meaningful when ChartDataRequest.symbol
   * names an asset (BTC) rather than an instrument, and they reuse the
   * per-instrument CandleList fields rather than adding parallel ones:
   */
  CANDLE_FAMILY_AGGREGATE_OI = 7,
  /** CANDLE_FAMILY_AGGREGATE_FUNDING - funding_rate_* and funding_apr_*, OI-weighted across the legs */
  CANDLE_FAMILY_AGGREGATE_FUNDING = 8,
  /** CANDLE_FAMILY_AGGREGATE_CVD - buy/sell/net_buy_volume_base, delta_percentage, net_buy_volume_quote */
  CANDLE_FAMILY_AGGREGATE_CVD = 9,
  UNRECOGNIZED = -1,
}

export function candleFamilyFromJSON(object: any): CandleFamily {
  switch (object) {
    case 0:
    case 'CANDLE_FAMILY_UNSPECIFIED':
      return CandleFamily.CANDLE_FAMILY_UNSPECIFIED
    case 1:
    case 'CANDLE_FAMILY_CORE':
      return CandleFamily.CANDLE_FAMILY_CORE
    case 2:
    case 'CANDLE_FAMILY_ORDER_FLOW':
      return CandleFamily.CANDLE_FAMILY_ORDER_FLOW
    case 3:
    case 'CANDLE_FAMILY_LIQUIDATIONS':
      return CandleFamily.CANDLE_FAMILY_LIQUIDATIONS
    case 4:
    case 'CANDLE_FAMILY_BLOCK_INCL':
      return CandleFamily.CANDLE_FAMILY_BLOCK_INCL
    case 5:
    case 'CANDLE_FAMILY_VOLATILITY':
      return CandleFamily.CANDLE_FAMILY_VOLATILITY
    case 6:
    case 'CANDLE_FAMILY_FUNDING_OI':
      return CandleFamily.CANDLE_FAMILY_FUNDING_OI
    case 7:
    case 'CANDLE_FAMILY_AGGREGATE_OI':
      return CandleFamily.CANDLE_FAMILY_AGGREGATE_OI
    case 8:
    case 'CANDLE_FAMILY_AGGREGATE_FUNDING':
      return CandleFamily.CANDLE_FAMILY_AGGREGATE_FUNDING
    case 9:
    case 'CANDLE_FAMILY_AGGREGATE_CVD':
      return CandleFamily.CANDLE_FAMILY_AGGREGATE_CVD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CandleFamily.UNRECOGNIZED
  }
}

export function candleFamilyToJSON(object: CandleFamily): string {
  switch (object) {
    case CandleFamily.CANDLE_FAMILY_UNSPECIFIED:
      return 'CANDLE_FAMILY_UNSPECIFIED'
    case CandleFamily.CANDLE_FAMILY_CORE:
      return 'CANDLE_FAMILY_CORE'
    case CandleFamily.CANDLE_FAMILY_ORDER_FLOW:
      return 'CANDLE_FAMILY_ORDER_FLOW'
    case CandleFamily.CANDLE_FAMILY_LIQUIDATIONS:
      return 'CANDLE_FAMILY_LIQUIDATIONS'
    case CandleFamily.CANDLE_FAMILY_BLOCK_INCL:
      return 'CANDLE_FAMILY_BLOCK_INCL'
    case CandleFamily.CANDLE_FAMILY_VOLATILITY:
      return 'CANDLE_FAMILY_VOLATILITY'
    case CandleFamily.CANDLE_FAMILY_FUNDING_OI:
      return 'CANDLE_FAMILY_FUNDING_OI'
    case CandleFamily.CANDLE_FAMILY_AGGREGATE_OI:
      return 'CANDLE_FAMILY_AGGREGATE_OI'
    case CandleFamily.CANDLE_FAMILY_AGGREGATE_FUNDING:
      return 'CANDLE_FAMILY_AGGREGATE_FUNDING'
    case CandleFamily.CANDLE_FAMILY_AGGREGATE_CVD:
      return 'CANDLE_FAMILY_AGGREGATE_CVD'
    case CandleFamily.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Which instruments a cross-exchange aggregate folds together. A leg's type is
 * resolved from the instrument cache, never from the symbol alone — perps and
 * dated futures are both InstrumentKind::Future and are separated by
 * funding_interval, and ETF tickers carry the ticker as their base currency.
 */
export enum CrossExchangeInstrumentType {
  CROSS_EXCHANGE_INSTRUMENT_TYPE_UNSPECIFIED = 0,
  CROSS_EXCHANGE_INSTRUMENT_TYPE_SPOT = 1,
  CROSS_EXCHANGE_INSTRUMENT_TYPE_PERPETUAL = 2,
  CROSS_EXCHANGE_INSTRUMENT_TYPE_DATED_FUTURE = 3,
  /** CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF - spot ETFs on an equity venue (IBIT, ETHA) */
  CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF = 4,
  UNRECOGNIZED = -1,
}

export function crossExchangeInstrumentTypeFromJSON(object: any): CrossExchangeInstrumentType {
  switch (object) {
    case 0:
    case 'CROSS_EXCHANGE_INSTRUMENT_TYPE_UNSPECIFIED':
      return CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_UNSPECIFIED
    case 1:
    case 'CROSS_EXCHANGE_INSTRUMENT_TYPE_SPOT':
      return CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_SPOT
    case 2:
    case 'CROSS_EXCHANGE_INSTRUMENT_TYPE_PERPETUAL':
      return CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_PERPETUAL
    case 3:
    case 'CROSS_EXCHANGE_INSTRUMENT_TYPE_DATED_FUTURE':
      return CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_DATED_FUTURE
    case 4:
    case 'CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF':
      return CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CrossExchangeInstrumentType.UNRECOGNIZED
  }
}

export function crossExchangeInstrumentTypeToJSON(object: CrossExchangeInstrumentType): string {
  switch (object) {
    case CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_UNSPECIFIED:
      return 'CROSS_EXCHANGE_INSTRUMENT_TYPE_UNSPECIFIED'
    case CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_SPOT:
      return 'CROSS_EXCHANGE_INSTRUMENT_TYPE_SPOT'
    case CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_PERPETUAL:
      return 'CROSS_EXCHANGE_INSTRUMENT_TYPE_PERPETUAL'
    case CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_DATED_FUTURE:
      return 'CROSS_EXCHANGE_INSTRUMENT_TYPE_DATED_FUTURE'
    case CrossExchangeInstrumentType.CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF:
      return 'CROSS_EXCHANGE_INSTRUMENT_TYPE_ETF'
    case CrossExchangeInstrumentType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Which messaging platform a link belongs to. An enum from the first release
 * even with one platform implemented: the value is persisted in the link
 * store's partition key, so adding a platform later must not mean rewriting
 * rows or reinterpreting an absent field as "Telegram".
 *
 * One value on purpose. A platform named here but not built is a promise this
 * contract makes to every client that reads it, and removing an enum value
 * once it has shipped means `reserved` rather than deletion — so a platform
 * earns its value when it has a bot, not when it is planned. Adding one later
 * is a new value, which is free and wire-safe; no tag is reserved below
 * because none has ever been published.
 */
export enum MessagingChannel {
  MESSAGING_CHANNEL_UNSPECIFIED = 0,
  MESSAGING_CHANNEL_TELEGRAM = 1,
  UNRECOGNIZED = -1,
}

export function messagingChannelFromJSON(object: any): MessagingChannel {
  switch (object) {
    case 0:
    case 'MESSAGING_CHANNEL_UNSPECIFIED':
      return MessagingChannel.MESSAGING_CHANNEL_UNSPECIFIED
    case 1:
    case 'MESSAGING_CHANNEL_TELEGRAM':
      return MessagingChannel.MESSAGING_CHANNEL_TELEGRAM
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MessagingChannel.UNRECOGNIZED
  }
}

export function messagingChannelToJSON(object: MessagingChannel): string {
  switch (object) {
    case MessagingChannel.MESSAGING_CHANNEL_UNSPECIFIED:
      return 'MESSAGING_CHANNEL_UNSPECIFIED'
    case MessagingChannel.MESSAGING_CHANNEL_TELEGRAM:
      return 'MESSAGING_CHANNEL_TELEGRAM'
    case MessagingChannel.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Which bot a link belongs to. A separate axis from the platform, not a
 * refinement of it: a user talks to the research bot and the notifications bot
 * over the same platform, and will talk to further bots later.
 *
 * It is a second enum rather than extra `MessagingChannel` variants
 * (`TELEGRAM_RESEARCH`, ...) because that is a cross-product — every new bot
 * would need one variant per platform and a proto change — and it makes the
 * channel enum mean two things at once.
 *
 * Load-bearing, and not merely descriptive. On a Telegram private chat the
 * chat id IS the user's global Telegram id, identical for every bot they talk
 * to, so without this axis two bots produce the SAME link row: the second
 * redemption overwrites the first and retires its session, silently
 * disconnecting a bot the user never touched. The same argument the channel
 * axis already makes — a nonce minted for one surface must not be redeemable
 * from another — applies here, and a link store keyed on only one of the two
 * axes enforces only half of it.
 */
export enum MessagingSurface {
  MESSAGING_SURFACE_UNSPECIFIED = 0,
  MESSAGING_SURFACE_RESEARCH = 1,
  MESSAGING_SURFACE_NOTIFICATIONS = 2,
  UNRECOGNIZED = -1,
}

export function messagingSurfaceFromJSON(object: any): MessagingSurface {
  switch (object) {
    case 0:
    case 'MESSAGING_SURFACE_UNSPECIFIED':
      return MessagingSurface.MESSAGING_SURFACE_UNSPECIFIED
    case 1:
    case 'MESSAGING_SURFACE_RESEARCH':
      return MessagingSurface.MESSAGING_SURFACE_RESEARCH
    case 2:
    case 'MESSAGING_SURFACE_NOTIFICATIONS':
      return MessagingSurface.MESSAGING_SURFACE_NOTIFICATIONS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MessagingSurface.UNRECOGNIZED
  }
}

export function messagingSurfaceToJSON(object: MessagingSurface): string {
  switch (object) {
    case MessagingSurface.MESSAGING_SURFACE_UNSPECIFIED:
      return 'MESSAGING_SURFACE_UNSPECIFIED'
    case MessagingSurface.MESSAGING_SURFACE_RESEARCH:
      return 'MESSAGING_SURFACE_RESEARCH'
    case MessagingSurface.MESSAGING_SURFACE_NOTIFICATIONS:
      return 'MESSAGING_SURFACE_NOTIFICATIONS'
    case MessagingSurface.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** What a credit history entry is. */
export enum CreditLedgerKind {
  CREDIT_LEDGER_KIND_UNSPECIFIED = 0,
  /** CREDIT_LEDGER_KIND_SPEND - one UTC day's debits */
  CREDIT_LEDGER_KIND_SPEND = 1,
  /** CREDIT_LEDGER_KIND_REFUND - credits returned for a failed request */
  CREDIT_LEDGER_KIND_REFUND = 2,
  /** CREDIT_LEDGER_KIND_PURCHASE - a top-up the customer bought */
  CREDIT_LEDGER_KIND_PURCHASE = 3,
  /** CREDIT_LEDGER_KIND_AUTO_REFILL - an off-session refill charge */
  CREDIT_LEDGER_KIND_AUTO_REFILL = 4,
  /** CREDIT_LEDGER_KIND_ADMIN_GRANT - granted by an operator */
  CREDIT_LEDGER_KIND_ADMIN_GRANT = 5,
  /** CREDIT_LEDGER_KIND_OPENING - the balance held before this history started */
  CREDIT_LEDGER_KIND_OPENING = 6,
  /** CREDIT_LEDGER_KIND_CLAWBACK - credits taken back for a Stripe refund or dispute */
  CREDIT_LEDGER_KIND_CLAWBACK = 7,
  UNRECOGNIZED = -1,
}

export function creditLedgerKindFromJSON(object: any): CreditLedgerKind {
  switch (object) {
    case 0:
    case 'CREDIT_LEDGER_KIND_UNSPECIFIED':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_UNSPECIFIED
    case 1:
    case 'CREDIT_LEDGER_KIND_SPEND':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_SPEND
    case 2:
    case 'CREDIT_LEDGER_KIND_REFUND':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_REFUND
    case 3:
    case 'CREDIT_LEDGER_KIND_PURCHASE':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_PURCHASE
    case 4:
    case 'CREDIT_LEDGER_KIND_AUTO_REFILL':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_AUTO_REFILL
    case 5:
    case 'CREDIT_LEDGER_KIND_ADMIN_GRANT':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_ADMIN_GRANT
    case 6:
    case 'CREDIT_LEDGER_KIND_OPENING':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_OPENING
    case 7:
    case 'CREDIT_LEDGER_KIND_CLAWBACK':
      return CreditLedgerKind.CREDIT_LEDGER_KIND_CLAWBACK
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CreditLedgerKind.UNRECOGNIZED
  }
}

export function creditLedgerKindToJSON(object: CreditLedgerKind): string {
  switch (object) {
    case CreditLedgerKind.CREDIT_LEDGER_KIND_UNSPECIFIED:
      return 'CREDIT_LEDGER_KIND_UNSPECIFIED'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_SPEND:
      return 'CREDIT_LEDGER_KIND_SPEND'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_REFUND:
      return 'CREDIT_LEDGER_KIND_REFUND'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_PURCHASE:
      return 'CREDIT_LEDGER_KIND_PURCHASE'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_AUTO_REFILL:
      return 'CREDIT_LEDGER_KIND_AUTO_REFILL'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_ADMIN_GRANT:
      return 'CREDIT_LEDGER_KIND_ADMIN_GRANT'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_OPENING:
      return 'CREDIT_LEDGER_KIND_OPENING'
    case CreditLedgerKind.CREDIT_LEDGER_KIND_CLAWBACK:
      return 'CREDIT_LEDGER_KIND_CLAWBACK'
    case CreditLedgerKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface MessageSubject {
  marketDataStream?: MarketDataStream | undefined
  exchangeData?: ExchangeData | undefined
  /** This is for internal only, not recommended to be used */
  account?: AccountData | undefined
  accountStream?: AccountDataStream | undefined
  /** This is for internal only, not recommended to be used / not doing anything */
  execution?: Execution | undefined
  chartDataStream?: ChartDataStream | undefined
  serviceNotifications?: Notifications | undefined
  economicCalendarStream?: EconomicCalendarStream | undefined
  executionAnalyticsStream?: ExecutionAnalyticsStream | undefined
  /**
   * ENG-462 — options analytic timeseries (processed data,
   * cron-polled REST republished). Parallel to `market_data_stream`
   * (raw Subscribe-driven) and `chart_data_stream` (native candles).
   */
  analyticsStream?: AnalyticsStream | undefined
  dbNewsStream?: DbNewsStream | undefined
  triggerConditionStream?: TriggerConditionStream | undefined
  optionsVolumeStream?: OptionsVolumeStream | undefined
  optionsTradesStream?: OptionsTradesStream | undefined
  exchangeStatusStream?: ExchangeStatusStream | undefined
  polymarketSignalStream?: PolymarketSignalStream | undefined
  venueHealthStream?: VenueHealthStream | undefined
  alpacaNewsStream?: AlpacaNewsStream | undefined
  twitterStream?: TwitterStream | undefined
  coinmarketcalEventStream?: CoinMarketCalEventStream | undefined
  tokenUnlockStream?: TokenUnlockStream | undefined
  treeNewsStream?: TreeNewsStream | undefined
  marketScreenerStream?: MarketScreenerStream | undefined
  orderbookHeatmapStream?: OrderbookHeatmapStream | undefined
}

/**
 * Broadcast subject for real-time economic calendar events from FXStreet.
 * No fields needed — subscribes to all events (public data, no per-account filtering).
 */
export interface EconomicCalendarStream {}

/** Request historical economic calendar events from QuestDB. */
export interface EconomicCalendarHistoryRequest {
  /** Unix timestamp ms — start of date range */
  from?: string | undefined
  /** Unix timestamp ms — end of date range */
  to?: string | undefined
  /** max rows, default 50 */
  limit?: number | undefined
  /** pagination offset */
  offset?: number | undefined
  /** filter to one recurring FXStreet event */
  eventId?: string | undefined
  /** dbnews label; resolved to an event_id server-side */
  eeType?: string | undefined
}

export interface EconomicCalendarEventList {
  events: EconomicCalendarEvent[]
}

/** FXStreet EventDate — https://calendar-api.fxstreet.com/swagger/index.html */
export interface EconomicCalendarEvent {
  /** recurrent event ID */
  eventId: string
  /** event occurrence ID */
  eventDateId: string
  /** e.g. "Retail Sales (MoM)" */
  name: string
  /** ISO 3166-1: US, EU, JP, ... */
  countryCode: string
  /** ISO 4217: USD, EUR, JPY, ... */
  currencyCode: string
  /** Unix timestamp ms */
  dateUtc: string
  /** NONE, LOW, MEDIUM, HIGH */
  volatility?: EventVolatility | undefined
  /** ZERO, K, M, B, T — nullable */
  potency?: EventPotency | undefined
  actual?: number | undefined
  revised?: number | undefined
  consensus?: number | undefined
  previous?: number | undefined
  ratioDeviation?: number | undefined
  isBetterThanExpected?: boolean | undefined
  isAllDay: boolean
  isTentative: boolean
  isPreliminary: boolean
  isReport?: boolean | undefined
  isSpeech?: boolean | undefined
  /** %, $, €, ¥, £ — nullable (null for speeches/meetings) */
  unit?: string | undefined
  /** Unix timestamp ms */
  periodDateUtc?: string | undefined
  /** NONE, DAY, MONTH, QUARTER — nullable */
  periodType?: EventPeriodType | undefined
  /** Unix timestamp ms (FXStreet sends seconds, converted on ingest) */
  lastUpdated?: string | undefined
}

export interface DbNewsStream {}

/**
 * dbws.io tags each coin with a reason: which coins (`matches`) and why (`reason`,
 * e.g. the source link or handle). One post can carry several, with different
 * reasons per coin subset.
 */
export interface DbNewsCoinReason {
  reason: string
  matches: string[]
}

export interface DbNewsPost {
  postId: string
  newsType: string
  text: string
  link: string
  description: string
  coins: string[]
  coinReasons: DbNewsCoinReason[]
  eeType: string
  filterReasons: string[]
  highlightedWords: string[]
  tweeterHandle: string
  telegramId: string
  avatarLink: string
  img: string
  tags: string[]
  ts: string
}

export interface DbNewsHistoryRequest {
  limit?: number | undefined
  offset?: number | undefined
  /** Unix timestamp ms */
  from?: string | undefined
  /** Unix timestamp ms */
  to?: string | undefined
  newsType?: string | undefined
  coin?: string | undefined
}

export interface DbNewsPostList {
  posts: DbNewsPost[]
}

export interface AlpacaNewsStream {}

export interface AlpacaNewsPost {
  id: string
  headline: string
  author: string
  summary: string
  content: string
  url: string
  source: string
  symbols: string[]
  /** Populated only by REST backfill; the live WS never sends images. */
  images: string[]
  createdAt: string
  updatedAt: string
}

export interface AlpacaNewsHistoryRequest {
  limit?: number | undefined
  offset?: number | undefined
  from?: string | undefined
  to?: string | undefined
  symbol?: string | undefined
  source?: string | undefined
}

export interface AlpacaNewsPostList {
  posts: AlpacaNewsPost[]
}

/** ENG-1026 — Tree News (Tree of Alpha), an aggregated crypto news + social feed. */
export interface TreeNewsStream {}

/**
 * Market screener: one row per base asset across the perp venues, built once
 * in public-api and fanned out to every subscriber. The first frame on a
 * subscription is a snapshot; later frames are deltas where an unset group
 * means "unchanged". A value that is unknown is left unset, never sent as 0.
 */
export interface MarketScreenerStream {
  /**
   * Empty = every screener venue. Sorted and de-duplicated into the subject
   * token, so the order the client sends does not matter.
   */
  exchanges: Exchange[]
}

/**
 * The order-book heatmap's still-open column, live: about once a second
 * while the book changes, an `OrderbookHeatmap` with one column holding the
 * book as it is now (`ts_ms` = when it was taken, `timeframe` unset). The
 * same column serves every timeframe — draw it over whichever bar is open.
 * Closed bars come from `OrderbookHeatmapRequest`, which holds each bar's
 * opening snapshot. Subscribe to listed instruments only.
 */
export interface OrderbookHeatmapStream {
  exchange: Exchange
  symbol: string
}

/** Returns the current snapshot frame for the same filter, from memory. */
export interface GetMarketScreenerRequest {
  exchanges: Exchange[]
}

export interface MarketScreenerFrame {
  /** Echoes the subscription: "ALL" or the sorted venue names joined by ",". */
  filterToken: string
  /** +1 per frame for this token. A gap means a frame was missed: resubscribe. */
  seq: string
  asOfMs: string
  /**
   * true: `rows` is the full set and replaces the table. false: merge by
   * `asset`, one group at a time.
   */
  snapshot: boolean
  rows: ScreenerRow[]
  removedAssets: string[]
}

export interface ScreenerRow {
  /** normalised base, e.g. "BTC" */
  asset: string
  /** refreshed every 1 s */
  live: ScreenerLive | undefined
  /** every 60 s */
  windows: ScreenerWindows | undefined
  /** every 60 s */
  derivs: ScreenerDerivs | undefined
  /** every 60 s */
  book: ScreenerBook | undefined
  /** catalog and market cap, >= 10 min */
  meta: ScreenerMeta | undefined
  /** Sent whenever the flag set changes; empty `values` means cleared. */
  flags: ScreenerFlags | undefined
  /** Per-venue breakdown, on snapshots and 60 s frames only. */
  venues: ScreenerVenue[]
}

export interface ScreenerLive {
  /** mark, else last, of the reference instrument */
  price: number
  changePct24h?: number | undefined
}

export interface ScreenerWindow {
  tradeCount: string
  changePct?: number | undefined
  volumeUsd: number
  /** taker buy minus taker sell */
  volumeDeltaUsd: number
  /** stdev of 1m close-to-close log returns, not annualised */
  stdevPct?: number | undefined
  takerBuyPct?: number | undefined
  liqLongUsd?: number | undefined
  liqShortUsd?: number | undefined
}

export interface ScreenerWindows {
  w5m: ScreenerWindow | undefined
  w15m: ScreenerWindow | undefined
  asOfMs: string
  stale: boolean
}

export interface ScreenerDerivs {
  /** OI-weighted across venues */
  fundingRateHourly?: number | undefined
  fundingApr?: number | undefined
  openInterestUsd?: number | undefined
  oiChangePct1h?: number | undefined
  oiChangePct24h?: number | undefined
  /** highest minus lowest venue rate */
  fundingSpreadHourly?: number | undefined
  asOfMs: string
  stale: boolean
}

export interface ScreenerBook {
  spreadBps?: number | undefined
  /** bid + ask notional within +/-50 bps of mid */
  depth50bpsUsd?: number | undefined
  /** ob_metrics pressure_ratio */
  imbalance?: number | undefined
  asOfMs: string
  stale: boolean
}

export interface ScreenerMeta {
  referenceSymbol: string
  referenceExchange: Exchange
  marketCapUsd?: number | undefined
  fdvUsd?: number | undefined
  venues: Exchange[]
}

export interface ScreenerFlags {
  values: ScreenerFlag[]
}

export interface ScreenerVenue {
  exchange: Exchange
  symbol: string
  windows: ScreenerWindows | undefined
  derivs: ScreenerDerivs | undefined
  book: ScreenerBook | undefined
}

/**
 * One exchange listing for a suggested coin. Note the symbol here carries no
 * separator (`BTCUSDT`) while `TreeNewsPost.symbols` uses one (`BTC_USDT`) —
 * two conventions inside the same item, on the wire.
 */
export interface TreeNewsSymbol {
  /** binance | binance-futures | bybit-perps | ... */
  exchange: string
  symbol: string
}

/** Tree's own coin extraction over the item's text. */
export interface TreeNewsSuggestion {
  coin: string
  /** the literal strings matched in the text */
  found: string[]
  symbols: TreeNewsSymbol[]
  /**
   * `double`, not an integer type: of 3044 sampled values 2812 are ints, 207 are
   * floats and 25 are null, so an integer parse silently drops 7% of suggestions.
   *
   * And `double` rather than the `string` the decimal convention asks for: this is
   * a token supply count, nothing sums it for equality, and the vendor already
   * sends it as a JSON number — 4 of 3448 sampled values exceed 2^53 (max 1.8e17),
   * so the precision is lost upstream and a string here would only preserve our
   * own re-rendering of an already-rounded f64.
   *
   * `optional` because the vendor sends `null` on 25 of 3044 sampled suggestions.
   * A bare `double` renders those as `0`, which reads as a real zero-supply token
   * rather than "not published" — the same absent-vs-zero collapse the two float
   * fields below already avoid by being optional.
   */
  supply?: number | undefined
  priceMove1h?: number | undefined
  maxMove1h?: number | undefined
  isAccountMapped: boolean
}

/**
 * An @-mention Tree resolved out of a social post. `coin` is set only where it
 * mapped the handle to one.
 */
export interface TreeNewsMention {
  handle: string
  id: string
  coin: string
}

/**
 * One Tree News item. The wire has TWO shapes that share only `_id`, `title`,
 * `time` and `suggestions`, and the server normalises neither:
 *   social  — `source` ABSENT, `type: "direct"`, text in `body`, link in `link`
 *   article — `source` present, text in `en`, link in `url`
 * Both are normalised into this one message on ingest. See
 * `services/newsfeed/src/tree_news_ws.rs`.
 */
export interface TreeNewsPost {
  /**
   * `_id`. NOT numeric: a tweet snowflake, a Truth Social id, or an alphanumeric
   * blob like `1788907827707WECCPfIitUSiRtCDAtCotUSwRtMV` on article items.
   */
  id: string
  /**
   * Blogs | Terminal | Binance EN | Bithumb | Upbit | Scrapers | Proposals |
   * usGov | Telegram | Twitter. Free text, never an enum: three of these appear
   * only on the WS, `Telegram` only in the vendor docs. "Twitter" is synthesised
   * for `type == "direct"` and also covers Truth Social, Farcaster and Binance
   * Square posts.
   */
  source: string
  /** outlet (COINTELEGRAPH, WHITEHOUSE, ...), may be empty */
  sourceName: string
  title: string
  /** social `body`, else article `en`; may be empty */
  body: string
  /** article `url`, else social `link` */
  url: string
  icon: string
  image: string
  /** social only, on 4.8% of frames */
  video: string
  /** top-level `coin` united with every `suggestions[].coin` */
  coins: string[]
  /** top-level `symbols`, separator form (BTC_USDT) */
  symbols: string[]
  isReply: boolean
  isRetweet: boolean
  isQuote: boolean
  isSelfReply: boolean
  /** `info.twitterId` */
  twitterId: string
  /** `info.truthId`, set on Truth Social posts */
  truthId: string
  /** epoch ms; the only timestamp the live socket sends */
  time: string
  suggestions: TreeNewsSuggestion[]
  /**
   * Both are sent on 44.7% of frames and are almost always EMPTY — `urls` was `[]`
   * on all 432 sampled occurrences and `mentions` non-empty on 2. An empty list
   * here is the normal state, not a parse failure; nothing may alert on it.
   */
  mentions: TreeNewsMention[]
  urls: string[]
  /**
   * Price at publication, keyed by the vendor's own symbol spelling:
   * {"OGUSDT": 2.785, "OGBTC": 4.13e-05}. On the WS as well as on REST.
   */
  firstPrice: { [key: string]: number }
}

export interface TreeNewsPost_FirstPriceEntry {
  key: string
  value: number
}

export interface TreeNewsHistoryRequest {
  limit?: number | undefined
  offset?: number | undefined
  from?: string | undefined
  to?: string | undefined
  coin?: string | undefined
  source?: string | undefined
}

export interface TreeNewsPostList {
  posts: TreeNewsPost[]
}

/**
 * Discovery endpoint for DB News (dbws.io) trigger filters. dbws.io publishes no
 * taxonomy and adds sources on demand, so the frontend reads the currently-seen
 * values from here to populate `triggers.DbNewsCondition` filter dropdowns
 * (news_type/ee_type/coins/tags) instead of hardcoding an enum. The trigger does
 * plain case-insensitive string comparison, so these are UI hints, not a sealed
 * contract — a user may still filter on a value not in the list.
 */
export interface GetDbNewsVocabularyRequest {}

/**
 * Distinct DB News filter values currently observed in stored posts. Each list is
 * deduped and sorted. `news_types`/`ee_types` are the complete SYMBOL-column sets
 * (cheap dictionary read); `coins`/`tags` are flattened from a recent window to
 * bound the scan. `ee_types` is only populated for news_type "Economic Event".
 */
export interface DbNewsVocabulary {
  newsTypes: string[]
  eeTypes: string[]
  coins: string[]
  tags: string[]
}

export interface TwitterStream {}

export interface TwitterPost {
  postId: string
  /**
   * Author handle, taken from the matching stream rule's tag — the stream is
   * one rule per handle so no billed user lookup is needed.
   */
  handle: string
  /**
   * X truncates long posts in `text` with no marker; this carries
   * `note_tweet.text` when present, so it is the full body either way.
   */
  text: string
  lang: string
  conversationId: string
  /**
   * "replied_to" | "quoted", empty for a top-level post. Retweets are filtered
   * out at the stream rule.
   */
  referencedType: string
  referencedPostId: string
  cashtags: string[]
  hashtags: string[]
  mentions: string[]
  urls: string[]
  mediaUrls: string[]
  createdAt: string
}

export interface TwitterPostList {
  posts: TwitterPost[]
}

export interface GetTwitterPostHistoryRequest {
  handle?: string | undefined
  cashtag?: string | undefined
  /** Unix timestamp ms */
  from?: string | undefined
  /** Unix timestamp ms */
  to?: string | undefined
  limit?: number | undefined
  offset?: number | undefined
}

/**
 * Historical range query. `from`/`to` are Unix ms; omitting them gives the last
 * five years, which three of the four series report monthly.
 *
 * The series start at **1970-01-01, which is Unix ms 0** — QuestDB cannot hold
 * an older designated timestamp, and the vendor's earlier history (CPI to 1947,
 * labor to 1948, treasury to 1962) is deliberately not stored. `from = 0` is
 * therefore a real bound asking for everything, not an unset field, which is why
 * these are `optional` rather than zero-sentinelled.
 */
export interface EconomicDataRequest {
  dataset: EconomicDataset
  /** Unix timestamp ms */
  from?: string | undefined
  /** Unix timestamp ms */
  to?: string | undefined
}

/**
 * In every point below, a null value means the vendor published nothing for that
 * field on that date. For the old rows that means the series did not exist yet
 * (the Fed published no 2-year constant maturity in 1962), never that the fetch
 * failed. Rates and ratios are percent unless noted.
 */
export interface EconomicInflationPoint {
  /** Unix timestamp ms, midnight UTC */
  date: string
  /** CPI-U index, NOT seasonally adjusted */
  cpi?: number | undefined
  /** CPI ex food and energy */
  cpiCore?: number | undefined
  /** headline YoY inflation rate */
  cpiYearOverYear?: number | undefined
  /** PCE price index */
  pce?: number | undefined
  /** the Fed's preferred core measure */
  pceCore?: number | undefined
  /** nominal PCE, BILLIONS of USD */
  pceSpending?: number | undefined
}

export interface EconomicInflationList {
  points: EconomicInflationPoint[]
}

export interface EconomicInflationExpectationsPoint {
  date: string
  /** TIPS breakevens: the market's expected average inflation over the horizon. */
  forwardYears5To10?: number | undefined
  market5Year?: number | undefined
  market10Year?: number | undefined
  /** Cleveland Fed model estimates, which unlike the breakevens run to 1982. */
  model1Year?: number | undefined
  model5Year?: number | undefined
  model10Year?: number | undefined
  model30Year?: number | undefined
}

export interface EconomicInflationExpectationsList {
  points: EconomicInflationExpectationsPoint[]
}

export interface EconomicLaborMarketPoint {
  date: string
  /** FRED UNRATE */
  unemploymentRate?: number | undefined
  /** FRED CIVPART */
  laborForceParticipationRate?: number | undefined
  /** FRED CES0500000003, USD */
  avgHourlyEarnings?: number | undefined
  /** FRED JTSJOL, THOUSANDS */
  jobOpenings?: number | undefined
}

export interface EconomicLaborMarketList {
  points: EconomicLaborMarketPoint[]
}

/**
 * Constant maturity, quoted on an investment basis (FRED DGS*).
 *
 * `yield_6_month`, `yield_3_year`, `yield_7_year` and `yield_20_year` are part
 * of the vendor's contract but are null on every row of the history so far.
 * They are carried so that they start flowing without a schema change, not
 * because they hold data today.
 */
export interface EconomicTreasuryYieldPoint {
  date: string
  yield1Month?: number | undefined
  yield3Month?: number | undefined
  yield6Month?: number | undefined
  yield1Year?: number | undefined
  yield2Year?: number | undefined
  yield3Year?: number | undefined
  yield5Year?: number | undefined
  yield7Year?: number | undefined
  yield10Year?: number | undefined
  yield20Year?: number | undefined
  yield30Year?: number | undefined
}

export interface EconomicTreasuryYieldList {
  points: EconomicTreasuryYieldPoint[]
}

export interface EtfFundFlowsRequest {
  /** BTC | ETH | SOL | HYPE. Empty means all four combined. */
  asset: string
  /** Unix timestamp ms */
  from: string
  /** Unix timestamp ms */
  to: string
  /**
   * One point per (day, fund) instead of one per day, for the per-fund
   * breakdown table. Requires `asset` — a combined breakdown would interleave
   * the funds of four different coins into one table — and every point then
   * carries `composite_ticker`.
   */
  byFund: boolean
}

export interface EtfFlowPoint {
  /** Unix timestamp ms, midnight UTC */
  date: string
  /**
   * Sum of the flows reported for that day. A fund that did not report
   * contributes nothing, which is what a zero net flow means.
   */
  fundFlow: number
  /**
   * Total nav × shares_outstanding across the asset's funds, or one fund's own
   * on a `by_fund` response — see `composite_ticker`. A fund that did not
   * report that day carries its last known value forward, so on an incomplete
   * day this mixes marks from different dates.
   */
  aum: number
  /**
   * The asset's own USD price that day, for overlaying on the flow chart and
   * for the coin-denominated view (`fund_flow / price`, `aum / price`). Last
   * trade of the asset's reference perp in the UTC day `date` names, so a close
   * on every completed day. Null on a combined request, which has no single
   * price; on a day the perp has no candle for; and on every point at once when
   * the price lookup failed, which leaves the flows and AUM still valid.
   */
  price?: number | undefined
  /**
   * The fund this point belongs to, set only on a `by_fund` response. `aum` is
   * then that one fund's own carried-forward nav × shares, which sums across
   * the day's funds to the `aum` a non-`by_fund` request reports for that day.
   * Absent on an aggregate point, which spans every fund and so has no ticker.
   */
  compositeTicker?: string | undefined
}

export interface EtfFlowSeries {
  points: EtfFlowPoint[]
}

export interface CoinMarketCalEventStream {}

export interface CoinMarketCalEvent {
  eventId: string
  slug: string
  title: string
  description: string
  /** Unix timestamp ms */
  eventDate: string
  /** Unix timestamp ms */
  dateEnd?: string | undefined
  dateType: CoinMarketCalDateType
  /**
   * True means `event_date` is a hedge (a deadline or window boundary) — render
   * `displayed_date` verbatim rather than formatting `event_date`.
   */
  isEstimated: boolean
  displayedDate: string
  categories: string[]
  coinSlugs: string[]
  coinSymbols: string[]
  /**
   * Editorial score 0.0–10.0. Unscored across almost the whole archive — the
   * upstream backfilled it only from ~2026-06-20 on.
   */
  impact?: number | undefined
  impactSummary: string
  sourceUrl: string
  snapshotUrl: string
  /** Unix timestamp ms */
  lastVerifiedAt?: string | undefined
  /** Unix timestamp ms */
  createdAt: string
  /** Unix timestamp ms */
  updatedAt?: string | undefined
  /**
   * Set on a removal tombstone. The upstream cancellations feed carries only an
   * id and this timestamp, so every other field is empty on such a message —
   * match it against a previously-streamed event by `event_id`.
   */
  cancelledAt?: string | undefined
}

export interface CoinMarketCalEventList {
  events: CoinMarketCalEvent[]
}

export interface GetCoinMarketCalEventsRequest {
  /** Unix timestamp ms — defaults to the start of today, UTC */
  from?: string | undefined
  /** Unix timestamp ms — unbounded by default */
  to?: string | undefined
  limit?: number | undefined
  offset?: number | undefined
  /** matches either a coin slug or a symbol */
  coin?: string | undefined
  category?: string | undefined
}

export interface TokenUnlockStream {}

/** One allocation's share of a single unlock event, or of one day's emission. */
export interface TokenUnlockAllocation {
  allocationName: string
  /**
   * One of six vendor buckets (Community, Founder / Team, Others, Private
   * Investors, Public Investors, Reserve). A free string, not an enum: the
   * vendor adds buckets without versioning the API.
   */
  standardAllocationName: string
  cliffAmount: number
  cliffValue: number
  /**
   * "second" | "hour" | "day" | "week" | "month" | "year" | "unknown" | "".
   * Free string for the same reason, and because "" is a live value.
   */
  unlockPrecision: string
  /** Sent only by the per-token endpoint; absent on the market-wide sweep. */
  unlockDate?: string | undefined
  referencePrice?: number | undefined
  referencePriceUpdatedAt?: string | undefined
}

export interface TokenUnlockEvent {
  /**
   * The vendor slug, from the token catalog. This is the join key — NOT the
   * symbol, which is not unique (626 catalog entries, 624 distinct symbols).
   */
  tokenId: string
  tokenSymbol: string
  tokenName: string
  /**
   * A scheduled ESTIMATE, not an appointment. The vendor withholds
   * privately-sourced changes made inside 14 days of an unlock and publishes
   * them 7-14 days AFTER the event, so a near-dated unlock can still move.
   */
  unlockDate: string
  totalCliffAmount: number
  /**
   * USD at `reference_price`, which for a forward-dated unlock is today's spot
   * projected forward — not a price forecast.
   */
  totalCliffValue: number
  /**
   * PERCENT (11.6 means 11.6% of market cap), not a fraction. Absent when the
   * vendor prices no cliff for the token — independently of `market_cap`, which
   * has a different source.
   */
  valueToMarketCap?: number | undefined
  /**
   * A property of the TOKEN, not of this unlock. On the REST calendar it is the
   * catalog's figure, refreshed daily for the whole catalog, so every event of a
   * token carries it and not just its next one. On the live subject it is the
   * sweep payload's own figure instead, present only on the unlock being
   * re-priced — the two can differ by whatever spot did between them. Absent
   * where the vendor publishes no market cap.
   */
  marketCap?: number | undefined
  releasedPercentage?: number | undefined
  referencePrice?: number | undefined
  /**
   * The date the reference price is APPLIED to, not when it was taken — on a
   * forward-dated unlock the vendor sets it equal to `unlock_date`. Use
   * `valuation_observed_at` for freshness.
   */
  referencePriceUpdatedAt?: string | undefined
  listedMethod: string
  dataSource: string
  allocationBreakdown: TokenUnlockAllocation[]
  latestUpdateDate: string
  /**
   * Our ingest stamp for the walk that last returned this event (ms).
   *
   * There are no removal messages. A rescheduled unlock is expressed by the
   * token's events carrying a newer stamp; anything older is superseded and the
   * history endpoint stops serving it. Hold a token's newest stamp as its
   * authoritative schedule and discard what you still have below it.
   *
   * **Absent on the live subject.** A streamed event is a daily re-pricing of
   * one unlock, not a statement about a token's whole schedule, so it carries
   * no stamp — treat it as a valuation refresh for an event you already hold
   * from history, and never as evidence that the rest of the schedule is stale.
   */
  lastSeenAt?: string | undefined
  /**
   * Set only on each token's next unlock, which a daily market-wide sweep
   * re-prices. This is the freshness signal for the USD-denominated fields.
   */
  valuationObservedAt?: string | undefined
}

export interface TokenUnlockEventList {
  events: TokenUnlockEvent[]
}

export interface TokenEmissionPoint {
  /** Unix ms, the day's start */
  emissionDate: string
  /** Unix ms */
  periodEnd: string
  unlockAmount: number
  unlockValue: number
  referencePrice: number
  totalCumulativeUnlockedAmount: number
  /** `cliff_amount` / `cliff_value` carry the day's per-allocation amount. */
  allocations: TokenUnlockAllocation[]
}

export interface TokenEmissionSeries {
  tokenId: string
  tokenSymbol: string
  points: TokenEmissionPoint[]
}

export interface GetTokenUnlocksRequest {
  /** Unix ms — defaults to the start of today, UTC */
  from?: string | undefined
  /** Unix ms — unbounded by default */
  to?: string | undefined
  limit?: number | undefined
  offset?: number | undefined
  /** matches the slug or the symbol, case-insensitive */
  token?: string | undefined
  /** percent */
  minValueToMarketCap?: number | undefined
  minMarketCap?: number | undefined
}

export interface GetTokenEmissionRequest {
  /** slug or symbol; required */
  token: string
  /** Unix ms */
  from?: string | undefined
  /** Unix ms */
  to?: string | undefined
}

export interface Notifications {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
}

export interface MarketDataStream {
  exchange: Exchange
  symbol: string
  dataType: MarketDataType
  /**
   * ORDER_BOOK only: levels per side the client wants. 0 or absent = the whole
   * book, which is what every client got before this field existed. The server
   * serves the nearest capped stream it publishes and echoes what it actually
   * gave back in `Subscribed`, so a client must read that rather than assume it
   * got exactly what it asked for. Not part of the subject's identity — the
   * NATS subject this maps to carries the depth as a suffix instead.
   */
  depth: number
}

export interface ExchangeData {
  exchange: Exchange
  dataType: ExchangeDataType
}

export interface ExchangeStatusStream {
  exchange: Exchange
}

export interface VenueHealthStream {
  exchange: Exchange
}

export interface AccountData {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  dataType: AccountDataType
}

export interface AccountDataStream {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  dataType: AccountDataStreamType
}

export interface ChartDataStream {
  symbol: string
  exchange: Exchange
  timeframe: ChartTimeframe
}

/**
 * ENG-462 — options analytics subject. `symbol` is `currency` for §2-9
 * (e.g. "BTC", "ETH") and `DVOL_<currency>` for §10 (Volatility Index).
 */
export interface AnalyticsStream {
  exchange: Exchange
  symbol: string
  analyticsType: AnalyticsType
}

/**
 * Polymarket data-only signal (ENG-530). The data-provider crate consumes the
 * CLOB order book internally and emits only the YES mid (probability in 0..1)
 * on this dedicated per-token subject, which the database-writer does NOT
 * consume — so the ephemeral signal is never persisted to QuestDB (mirrors
 * DbNewsStream / news.db_news). Keyed on the outcome token so refcounted
 * subscribe/unsubscribe is per-market.
 */
export interface PolymarketSignalStream {
  tokenId: string
}

export interface PolymarketSignal {
  /** Polymarket outcome (ERC-1155) token id */
  tokenId: string
  /** YES mid as a probability in 0..1 (decimal string) */
  yesMid: string
  /** book-derived-at timestamp, unix ms */
  tsMs: string
}

/**
 * On-demand market resolution, answered over NATS request-reply on subject
 * `polymarket.resolve`. Standalone messages: the response rides the RR reply,
 * not a DataPayload / MessageSubject stream.
 */
export interface PolymarketResolveRequest {
  /** free-text search */
  text?: string | undefined
  slug?: string | undefined
  conditionId?: string | undefined
  tokenId?: string | undefined
}

export interface PolymarketResolvedToken {
  /** outcome (ERC-1155) token id; keys the CLOB book */
  tokenId: string
  /** e.g. "Yes" / "No" */
  outcome: string
  pairedTokenId: string
}

export interface PolymarketResolvedMarket {
  conditionId: string
  question: string
  slug: string
  /** 0 when absent */
  endDateMs: string
  /** 2 for a binary market */
  tokens: PolymarketResolvedToken[]
}

export interface PolymarketResolveResponse {
  markets: PolymarketResolvedMarket[]
}

export interface PolymarketSubscriptionRequest {
  /** outcome (ERC-1155) token id, decimal */
  tokenId: string
  action: PolymarketSubscriptionAction
}

export interface Execution {
  accountId: string
  /**
   * Routes the published `OrderExecutionCommand` to the venue service
   * that owns the account. Always populated post Phase 4.
   */
  tradeVenue: TradeVenue
}

export interface ExecutionAnalyticsStream {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  targetType: ExecutionAnalyticsTargetType
  targetId: string
}

export interface TriggerConditionStream {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  registrationId: string
  triggerId: string
}

export interface ExecutionAnalyticsRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  targetType: ExecutionAnalyticsTargetType
  targetId: string
  /** Unix timestamp ms, optional override for generated snapshots */
  from?: string | undefined
  /** Unix timestamp ms, optional override for generated snapshots */
  to?: string | undefined
  /** How much order detail to include. Defaults to LATEST_PER_ORDER. */
  includeOrders: OrderInclusion
  /** Whether to include trades. Unset defaults to true. */
  includeTrades?: boolean | undefined
  /**
   * Whether to compute market VWAP/TWAP benchmarks. Unset defaults to true.
   * The live stream sets this false on its fast first frame and recomputes on a
   * throttle; setting it false on the one-shot RPC skips the market scan entirely.
   */
  includeBenchmarks?: boolean | undefined
}

export interface ExecutionAlgorithmStats {
  currentAvgFillPrice?: string | undefined
  currentAvgFillPriceInclFees?: string | undefined
  amountFilledQuote: string
  amountFilledBase: string
  timeRunningMs: string
  timeRemainingMs?: string | undefined
  feesPaidQuote: string
  feesPaidBase: string
  makerVolumeQuote: string
  makerVolumeBase: string
  takerVolumeQuote: string
  takerVolumeBase: string
  /** percent of market volume during execution window */
  participationRate?: string | undefined
  currentAvgFillPriceIv?: string | undefined
  currentAvgFillPriceInclFeesIv?: string | undefined
}

export interface ExecutionPerformanceBenchmarks {
  arrivalPrice?: string | undefined
  arrivalPriceInclSlippage?: string | undefined
  arrivalPriceInclSlippageFees?: string | undefined
  departurePrice?: string | undefined
  departurePriceInclSlippage?: string | undefined
  departurePriceInclSlippageFees?: string | undefined
  vwap?: string | undefined
  vwapInclFees?: string | undefined
  twap?: string | undefined
  twapInclFees?: string | undefined
  currentMarketMidPrice?: string | undefined
  currentMarketMarkPrice?: string | undefined
  arrivalPriceIv?: string | undefined
  arrivalPriceInclSlippageIv?: string | undefined
  arrivalPriceInclSlippageFeesIv?: string | undefined
  departurePriceIv?: string | undefined
  departurePriceInclSlippageIv?: string | undefined
  departurePriceInclSlippageFeesIv?: string | undefined
  vwapIv?: string | undefined
  vwapInclFeesIv?: string | undefined
  twapIv?: string | undefined
  twapInclFeesIv?: string | undefined
  currentMarketMidPriceIv?: string | undefined
  currentMarketMarkPriceIv?: string | undefined
}

export interface ExecutionAnalyticsOverlay {
  name: string
  value: string
}

/**
 * Drilldown: every child order of an algo (latest state per order_id, or full
 * state-update history when include_history=true). Reuses the same DB query
 * path as the analytics builder so results are consistent.
 */
export interface GetOrdersForAlgoRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  algoId: string
  includeHistory: boolean
  /**
   * When true, also walk parent_id and pull orders from every descendant algo.
   * Defaults to true so callers get the same view the analytics builder uses.
   */
  includeDescendants?: boolean | undefined
}

/**
 * Drilldown: every fill on a single order. Cheap because trades are keyed
 * directly by order_id.
 */
export interface GetTradesForOrderRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  orderId: string
}

/**
 * Drilldown: trades across an algo (and, by default, its descendants), newest
 * first, with optional time window and limit. Replaces the per-order trade
 * fan-out for the analytics screen and backs the "load all / export" actions.
 */
export interface GetTradesForAlgoRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  algoId: string
  /** When true (default), walk parent_id and include every descendant's trades. */
  includeDescendants?: boolean | undefined
  /** Unix timestamp ms, inclusive lower bound */
  from?: string | undefined
  /** Unix timestamp ms, inclusive upper bound */
  to?: string | undefined
  /** max rows, newest first; unset = no limit */
  limit?: number | undefined
}

/**
 * Drilldown: full state-update timeline of one order. Each row is a snapshot;
 * successive rows can be diffed to render the lifecycle (Pending → Open →
 * PartiallyFilled → Filled / Cancelled / etc).
 */
export interface GetOrderStateHistoryRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  orderId: string
}

export interface RfqAnalyticsRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  /** set => single-RFQ detail mode; unset => aggregate */
  rfqId?: string | undefined
  /** ms, filters on ts */
  from?: string | undefined
  /** ms */
  to?: string | undefined
  /** optional: restrict maker stats to these aliases */
  makerFilter: string[]
}

export interface RfqMakerStat {
  /** "ANONYMOUS" bucket for masked quotes */
  alias: string
  rfqsQuoted: number
  quotesProvided: number
  wins: number
  winRate: string
  avgSpreadToMark: string
  avgQuoteAmount: string
  /**
   * Which network this maker quoted on. Deribit maker aliases and Paradigm
   * counterparty names are separate namespaces, so a row is scoped to one
   * network and the same alias on both yields two rows, never a merged one.
   * Stats are computed per (alias, network) for the same reason: averaging a
   * Deribit spread with a Paradigm one produces a number that describes
   * neither. See RfqNetwork in rfq.proto.
   */
  rfqNetwork: RfqNetwork
}

export interface RfqWorkflowStats {
  total: number
  filled: number
  expired: number
  cancelled: number
  open: number
  fillRate: string
  avgTimeToFirstQuoteMs?: string | undefined
  avgTimeToFillMs?: string | undefined
  avgMakersResponding: string
  filledNotional: string
}

export interface RfqExecutionQualityStats {
  sampleSize: number
  avgEdgeVsMark: string
  avgAcceptedVsBestQuote: string
}

export interface RfqAlgoStats {
  total: number
  filled: number
  gaveUp: number
  avgRetriesToFill: string
  pctFilledWithinThreshold: string
  pctExpiredWithoutMeeting: string
  avgTimeToFillMs?: string | undefined
  avgRealizedOffsetVsThreshold: string
}

export interface RfqStateTransition {
  state: RfqState
  atMs: string
  /**
   * Which network stamped this transition. An RFQ fanned out to both networks
   * interleaves two independent lifecycles in this one list; without the
   * network the timeline reads as a single RFQ that reopened after it was
   * cancelled. See RfqNetwork in rfq.proto.
   */
  rfqNetwork: RfqNetwork
}

export interface RfqQuoteTimelinePoint {
  observedAtMs: string
  bestBid?: string | undefined
  bestAsk?: string | undefined
  packageMark?: string | undefined
  askSpreadToMark?: string | undefined
  makersResponding: number
  /**
   * Which network's book this point observed. Points are grouped per
   * (observed_at_ms, network), so two networks quoting in the same
   * millisecond produce two points rather than one row whose "best bid" and
   * "best ask" came from different books — a spread that was never quotable.
   * See RfqNetwork in rfq.proto.
   */
  rfqNetwork: RfqNetwork
}

export interface RfqDetail {
  rfqId: string
  finalState: RfqState
  transitions: RfqStateTransition[]
  quoteTimeline: RfqQuoteTimelinePoint[]
  makers: RfqMakerStat[]
  acceptedPrice?: string | undefined
  acceptedEdgeVsMark?: string | undefined
  timeToFirstQuoteMs?: string | undefined
  timeToFillMs?: string | undefined
}

export interface RfqAnalytics {
  accountId: string
  from?: string | undefined
  to?: string | undefined
  workflow?: RfqWorkflowStats | undefined
  executionQuality?: RfqExecutionQualityStats | undefined
  makers: RfqMakerStat[]
  algo?: RfqAlgoStats | undefined
  detail?: RfqDetail | undefined
}

/**
 * Multi-account answer to a RfqAnalyticsRequest carrying `account_ids`. Each
 * element keeps its own `account_id`; the DataPayload envelope's is empty.
 * Chosen by the request's shape, never by how many accounts resolved: a request
 * setting `account_ids` gets this variant even for one element. Only a legacy
 * `account_id`-only request gets the singular `rfq_analytics`.
 */
export interface RfqAnalyticsList {
  analytics: RfqAnalytics[]
}

export interface ExecutionAnalytics {
  accountId: string
  targetType: ExecutionAnalyticsTargetType
  targetId: string
  exchange: Exchange
  symbol: string
  side: OrderSide
  algoType?: AlgoType | undefined
  algoStatus?: AlgoStatus | undefined
  submittedAt: string
  completedAt?: string | undefined
  isActive: boolean
  stats: ExecutionAlgorithmStats | undefined
  benchmarks: ExecutionPerformanceBenchmarks | undefined
  /**
   * Semantics depend on the request's `include_orders` flag:
   *   NONE                       → empty
   *   LATEST_PER_ORDER (default) → one row per order_id, latest state
   *   FULL_HISTORY_PER_ORDER     → every state-update row, ASC by timestamp
   */
  orders: Order[]
  trades: Trade[]
  overlays: ExecutionAnalyticsOverlay[]
  generatedAt: string
  /**
   * Latest state of every descendant algo in the parent_id subtree (ALGO
   * targets only). Always populated so the UI can render the algo tree
   * even without history. The root algo itself is described by the top-level
   * fields above and is not duplicated here.
   */
  childAlgos: AlgoState[]
}

/**
 * Multi-account answer to an ExecutionAnalyticsRequest carrying `account_ids`.
 * Each element keeps its own `account_id`; the DataPayload envelope's is empty.
 * Chosen by the request's shape, never by how many accounts resolved: a request
 * setting `account_ids` gets this variant even for one element. Only a legacy
 * `account_id`-only request gets the singular `execution_analytics`.
 */
export interface ExecutionAnalyticsList {
  analytics: ExecutionAnalytics[]
}

export interface DataPayload {
  /**
   * Authoritative account this payload belongs to, stamped server-side from
   * the originating subscription — never trusted from producer-populated
   * fields on individual items below. Empty for non-account-scoped data
   * (market data, analytics, etc).
   */
  accountId: string
  trades?: TradeList | undefined
  positions?: PositionList | undefined
  instruments?: InstrumentList1 | undefined
  tickers?: TickerList | undefined
  orderBooks?: OrderBookList | undefined
  portfolioData?: PortfolioDataList | undefined
  instrumentTrades?: InstrumentTradeList | undefined
  /** Add for external API */
  unifiedOrders?: UnifiedOrderList | undefined
  chartData?: ChartData | undefined
  incrementalTickers?: IncrementalTickerList | undefined
  notification?: ServiceNotification | undefined
  portfolioLineChart?: PortfolioLineChart | undefined
  volSurfaceGenerationResult?: VolSurfaceGenerationResult | undefined
  riskSimulationResult?: RiskSimulationResult | undefined
  economicCalendarEvent?: EconomicCalendarEvent | undefined
  economicCalendarEventList?: EconomicCalendarEventList | undefined
  instrumentStates?: InstrumentStateList | undefined
  executionAnalytics?: ExecutionAnalytics | undefined
  venues?: VenueList | undefined
  exchanges?: ExchangeList | undefined
  orders?: OrderList | undefined
  algoStates?: AlgoStateList | undefined
  /** ENG-462 options analytic streams. */
  volMetrics24h?: VolMetrics24hList | undefined
  putCallRatio?: PutCallRatioList | undefined
  deltaSurfaceConstant?: DeltaSurfaceConstantList | undefined
  deltaSurfaceFloating?: DeltaSurfaceFloatingList | undefined
  impliedVsRealized?: ImpliedVsRealizedList | undefined
  termStructureConstant?: TermStructureConstantList | undefined
  termStructureFloating?: TermStructureFloatingList | undefined
  termStructureRichness?: TermStructureRichnessList | undefined
  volatilityIndex?: VolatilityIndexList | undefined
  dbNewsPost?: DbNewsPost | undefined
  dbNewsPostList?: DbNewsPostList | undefined
  triggerEvaluationSnapshot?: TriggerEvaluationSnapshot | undefined
  dbNewsVocabulary?: DbNewsVocabulary | undefined
  exchangeStatus?: ExchangeStatus | undefined
  venueSchedules?: VenueScheduleList | undefined
  rfqUpdates?: RfqUpdateList | undefined
  rfqAnalytics?: RfqAnalytics | undefined
  rfqAccept?: RfqAccept | undefined
  skewConstant?: SkewConstantList | undefined
  skewFloating?: SkewFloatingList | undefined
  optionsVolumeLeaderboard?: OptionsVolumeLeaderboard | undefined
  optionsVolumeSeries?: OptionsVolumeSeries | undefined
  optionsVolumeStreamUpdate?: OptionsVolumeStreamUpdate | undefined
  optionsOiSeries?: OptionsOiSeries | undefined
  optionsOiLeaderboard?: OptionsOiLeaderboard | undefined
  fundingSeries?: FundingSeries | undefined
  fundingLeaderboard?: FundingLeaderboard | undefined
  accountFees?: AccountFeesList | undefined
  accountSummary?: AccountSummaryList | undefined
  transfers?: TransferList | undefined
  polymarketSignal?: PolymarketSignal | undefined
  orderbookMetricsSeries?: OrderbookMetricsSeries | undefined
  impliedMove?: ImpliedMove | undefined
  ivPercentile?: IvPercentile | undefined
  maxPain?: MaxPain | undefined
  usdGamma?: UsdGammaList | undefined
  gex?: GexList | undefined
  volCones?: VolConeList | undefined
  rvSeasonalityDow?: RvSeasonalityList | undefined
  rvSeasonalityMoy?: RvSeasonalityList | undefined
  greeksByExpiry?: GreeksByExpiry | undefined
  venueHealth?: VenueHealth | undefined
  alpacaNewsPost?: AlpacaNewsPost | undefined
  alpacaNewsPostList?: AlpacaNewsPostList | undefined
  visibleRangeProfile?: VisibleRangeProfile | undefined
  twitterPost?: TwitterPost | undefined
  twitterPostList?: TwitterPostList | undefined
  /**
   * Multi-account variants. Sent instead of their singular siblings when the
   * request carried `account_ids`; `account_id` above is then empty and each
   * element self-attributes. Tag 68 is an unexplained gap in this oneof with
   * no `reserved` marker — do not reuse it.
   */
  portfolioLineChartList?: PortfolioLineChartList | undefined
  executionAnalyticsList?: ExecutionAnalyticsList | undefined
  rfqAnalyticsList?: RfqAnalyticsList | undefined
  fedwatchProbabilities?: FedwatchProbabilityList | undefined
  etfFlowSeries?: EtfFlowSeries | undefined
  coinmarketcalEvent?: CoinMarketCalEvent | undefined
  coinmarketcalEventList?: CoinMarketCalEventList | undefined
  optionsStrikeFlow?: OptionsStrikeFlow | undefined
  gexAggregate?: GexAggregate | undefined
  /**
   * ENG-929 — the variant sent is the one matching the request's
   * `EconomicDataset`, like the options analytics above.
   */
  economicInflation?: EconomicInflationList | undefined
  economicInflationExpectations?: EconomicInflationExpectationsList | undefined
  economicLaborMarket?: EconomicLaborMarketList | undefined
  economicTreasuryYields?: EconomicTreasuryYieldList | undefined
  /**
   * DOW, HOUR and SESSION all answer with the bucketed list; the `bucket`
   * string self-identifies, so there is no separate discriminator.
   */
  bucketedReturns?: BucketedReturnList | undefined
  sessionCumulativeReturns?: SessionCumulativeReturnList | undefined
  liquidationLevelProfile?: LiquidationLevelProfile | undefined
  stopLevelProfile?: StopLevelProfile | undefined
  /** ENG-956 — Tokenomist token unlock schedules and daily emission. */
  tokenUnlockEvent?: TokenUnlockEvent | undefined
  tokenUnlockEventList?: TokenUnlockEventList | undefined
  tokenEmissionSeries?: TokenEmissionSeries | undefined
  svi?: SviList | undefined
  optionsOiByStrike?: OptionsOiByStrike | undefined
  /** ENG-1026 — Tree News. */
  treeNewsPost?: TreeNewsPost | undefined
  treeNewsPostList?: TreeNewsPostList | undefined
  /**
   * Shares `RvSeasonalityList` with the weekday and month series — `bucket`
   * ("00".."23" here) is what tells the three apart.
   */
  rvSeasonalityHour?: RvSeasonalityList | undefined
  surfaceCurrencies?: SurfaceCurrencyList | undefined
  marketScreenerFrame?: MarketScreenerFrame | undefined
  volFitReferences?: VolFitReferenceList | undefined
  orderbookHeatmap?: OrderbookHeatmap | undefined
  /**
   * RFQ maker stream (ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER). Routed on the
   * LIST's account_id; an empty list is a real frame (maker unavailable /
   * nothing open).
   */
  rfqMakerRfqs?: RfqMakerRfqList | undefined
  rfqMakerQuotes?: RfqMakerQuoteList | undefined
  perpPositions?: PerpPositionsSnapshot | undefined
  oiPressure?: OpenInterestPressureList | undefined
}

/**
 * What a trade venue can place, declared in the backend's venue registry and
 * served so the frontend can render per venue. `supported_algos` is derived
 * server-side from the other fields; it is never configured.
 * Spec: oems_v2 docs/superpowers/specs/2026-10-12-venue-capabilities-design.md
 */
export interface VenueCapabilities {
  orderTypes: OrderType[]
  /** Checked on LIMIT orders only; a MARKET order's TIF is ignored. */
  timeInForce: TimeInForce[]
  postOnly: boolean
  reduceOnly: boolean
  amend: boolean
  venueTriggers: boolean
  partialClose: boolean
  supportedAlgos: AlgoType[]
  /**
   * Declared, never derived: true only where the trade-venue service
   * implements taker RFQ (Deribit and Derive today).
   */
  rfq: boolean
}

/**
 * Static venue/exchange discovery payloads. Driven by the public-api
 * service config; the frontend uses these to gate signup options
 * (`get_venues`) and to populate per-venue exchange selectors
 * (`get_exchanges`).
 */
export interface VenueInfo {
  tradeVenue: TradeVenue
  /**
   * Operationally enabled. When false, existing accounts continue to
   * function (read-only views, history), but order routing for the
   * venue is disabled at the public-api boundary.
   */
  enabled: boolean
  /**
   * Whether new accounts can be created for this venue. Independent of
   * `enabled` — we may keep an established venue running while pausing
   * new signups during migrations or onboarding freezes.
   */
  newAccount: boolean
  /**
   * Present only for venues onboarded via OAuth (Bybit). Drives the
   * frontend's "connect with OAuth" popup.
   */
  oauth?: OauthConfig | undefined
  /**
   * What the user must grant when creating an API key for this venue, and
   * where to create it. Present only for venues onboarded by pasting a key;
   * absent where we mint credentials ourselves (Hyperliquid agent wallets,
   * Derive session keys, Lighter subaccount keys) — absent means render
   * nothing, never fall back to another venue's instructions.
   */
  apiKeyGuide?: ApiKeyGuide | undefined
  /**
   * Absent means unknown (an older backend); the frontend keeps today's
   * behaviour. Never required: external consumers pin this submodule.
   */
  capabilities?: VenueCapabilities | undefined
}

export interface VenueList {
  venues: VenueInfo[]
}

/**
 * Onboarding instructions for a manual-API-key venue, served by GetVenues so
 * the frontend renders what the backend actually enforces instead of its own
 * copy. URLs are environment-correct: dev serves the venue's testnet hosts.
 */
export interface ApiKeyGuide {
  /** Venue page where the user creates the key. */
  createKeyUrl: string
  /**
   * Venue's written walkthrough, when it is a different page from
   * `create_key_url`. Absent means the two are the same — link
   * `create_key_url` for both.
   */
  guideUrl?: string | undefined
  permissions: VenuePermission[]
  /**
   * Venue-specific caveat rendered under the list, e.g. Toss having no
   * sandbox. Absent means no caveat.
   */
  note?: string | undefined
}

/** One permission the user ticks in the venue's key-creation UI. */
export interface VenuePermission {
  /**
   * Wording as it appears in the venue's own UI, so the user can match it
   * by eye — e.g. "Trade: read_write".
   */
  label: string
  /**
   * The scope token the backend checks on the venue's auth response, e.g.
   * "trade:read_write". Absent when the venue exposes no machine-readable
   * scope (Bybit, Upbit, Toss); the label is then instructional only, and
   * a wrong key surfaces as an auth failure rather than a missing scope.
   */
  scope?: string | undefined
}

/**
 * OAuth client metadata delivered to the frontend via GetVenues. token_url and
 * client_secret are server-side only. The redirect is frontend-owned (the
 * frontend builds <host>/api/oauth/<venue>), so it is not sent here.
 */
export interface OauthConfig {
  authorizeUrl: string
  clientId: string
  /**
   * Backend-dictated authorize params. Deribit uses the authorization-code
   * flow with explicit scopes; Bybit leaves these unset (frontend unchanged).
   */
  scope?: string | undefined
  responseType?: string | undefined
}

/** Mint a single-use CSRF state nonce before opening the Bybit OAuth popup. */
export interface BybitOauthMintStateRequest {
  accountId: string
}

export interface BybitOauthMintStateResponse {
  state: string
}

/**
 * Exchange the one-time `code` from the Bybit OAuth redirect for permanent
 * api_key/secret. Response is the shared Success/Error.
 */
export interface BybitOauthExchangeCodeRequest {
  accountId: string
  code: string
  state: string
  /** Frontend's own <host>/api/oauth/bybit; backend validates against the allowlist. */
  redirectUri: string
}

/**
 * Deribit OAuth (Registered Partner Model). Mirrors the Bybit shape; the
 * exchange yields a stable user_id stored as the account's oauth_subject —
 * there is no per-account api_key/secret for Deribit OAuth accounts.
 */
export interface DeribitOauthMintStateRequest {
  accountId: string
}

export interface DeribitOauthMintStateResponse {
  state: string
}

/**
 * Exchange the one-time `code` from the Deribit app_authorization redirect.
 * Response is the shared Success/Error.
 */
export interface DeribitOauthExchangeCodeRequest {
  accountId: string
  code: string
  state: string
  /** Frontend's own <host>/api/oauth/deribit; backend validates + signs it into the exchange body. */
  redirectUri: string
}

/**
 * Hyperliquid agent-wallet onboarding. Unlike the OAuth venues, the server mints
 * an agent (API) wallet keypair and returns the EIP-712 typed-data payloads the
 * customer's own wallet signs (approveAgent + optionally approveBuilderFee); the
 * master key never reaches the backend.
 */
export interface HyperliquidPrepareAgentRequest {
  accountId: string
  /**
   * Wallet's currently-active EVM chain id (decimal), read from eth_chainId.
   * Stamped into the EIP-712 domain.chainId / action signatureChainId so the
   * customer's wallet signs without a network switch (MetaMask enforces
   * domain.chainId == active chainId). Hyperliquid recovers the signer
   * off-chain and accepts any value. Optional for back-compat: unset/0 falls
   * back to the backend default.
   */
  signatureChainId: number
  /**
   * The customer's master wallet address (the wallet they will sign with).
   * Optional: when set, prepare does a non-authoritative pre-check and tells the
   * frontend if this wallet is already linked to another ACTIVE account, before
   * the user signs. The authoritative single-owner guard is the reservation
   * conditional-write at confirm.
   */
  masterAddress?: string | undefined
}

export interface HyperliquidPrepareAgentResponse {
  /** The freshly minted agent (API) wallet address the customer approves. */
  agentAddress: string
  /** EIP-712 typed-data (JSON) for the approveAgent action; the frontend wallet signs it. */
  approveAgentPayload: string
  /** EIP-712 typed-data (JSON) for approveBuilderFee; unset when builder codes are gated off. */
  approveBuilderFeePayload?: string | undefined
}

/**
 * Confirm the customer's signatures. The backend submits approveAgent (and
 * approveBuilderFee when present) to Hyperliquid /exchange, stores master_address,
 * and activates the account. Response is the shared Success/Error.
 */
export interface HyperliquidConfirmAgentRequest {
  accountId: string
  /** The customer's master account address (signer of the approvals). */
  masterAddress: string
  /** Signature (hex) over the approveAgent typed-data. */
  approveAgentSignature: string
  /** Signature (hex) over approveBuilderFee; set only when a payload was returned. */
  approveBuilderFeeSignature?: string | undefined
}

/**
 * Disconnect (unlink) a Hyperliquid agent-wallet account. OWNER-gated. Clears the
 * stored agent credentials (status -> Inactive) and releases the master
 * reservation so the wallet can be relinked elsewhere. The on-chain agent is NOT
 * deregistered (it goes inert once we stop signing and expires on its own).
 */
export interface HyperliquidDisconnectAgentRequest {
  accountId: string
}

/**
 * List a Hyperliquid wallet's sub-accounts for the connection picker.
 * Always called strictly AFTER confirm_agent (never with an unverified
 * address) — master_address here is already the account's own stored,
 * verified master. wallet_connected reflects STORED registry state (a live
 * unexpired agent for this master+user), independent of whether the /info
 * call itself succeeds.
 */
export interface HyperliquidListSubaccountsRequest {
  /** the anchor account (admin-gated) */
  accountId: string
  /** connected wallet address, verified by this point */
  masterAddress: string
}

export interface HyperliquidSubaccountInfo {
  address: string
  name: string
  /** reserved by ANY OrderX account */
  alreadyLinked: boolean
  /** non-empty only when linked by the caller's own anchor */
  linkedAccountId: string
}

export interface HyperliquidListSubaccountsResponse {
  /** live, unexpired agent stored for (master, user) */
  walletConnected: boolean
  subaccounts: HyperliquidSubaccountInfo[]
  /** plan-cap headroom for sibling accounts */
  remainingAccountSlots: number
}

/**
 * Batch-link sub-accounts to new sibling OrderX accounts. Zero wallet
 * signatures: the stored agent key (shared with the anchor) covers every
 * sub-account. Only the anchor account may call this. subaccount_addresses
 * may be empty (a valid no-op — the picker step allows finishing with zero
 * additional selections).
 */
export interface HyperliquidLinkSubaccountsRequest {
  /** the anchor account */
  accountId: string
  masterAddress: string
  /** additional sub-accounts to link; may be empty */
  subaccountAddresses: string[]
}

export interface HyperliquidLinkedSlot {
  subaccountAddress: string
  /** "" when linking this slot failed */
  accountId: string
  /** non-empty only on per-slot failure */
  error: string
}

export interface HyperliquidLinkSubaccountsResponse {
  slots: HyperliquidLinkedSlot[]
}

/**
 * Derive (derive.xyz) session-key onboarding. The customer's wallet is their
 * own EOA and it is the account owner on Derive; there is no smart-contract
 * wallet and nothing is broadcast on-chain. prepare mints a session key and
 * builds the unsigned set_session_key Action — an EIP-712 struct over
 * Derive's Action type, domain-separated per network — returning it as an
 * eth_signTypedData_v4 payload for the wallet to sign. confirm recovers the
 * signer from the Action the backend itself persisted, then POSTs
 * private/set_session_key with that action signature plus a separate
 * session-authentication signature over the login timestamp.
 *
 * confirm registers a WALLET, not an account: one session key covers the
 * subaccounts named below, so linking accounts to subaccounts is a separate,
 * explicit DeriveLinkSubaccounts step (see below).
 */
export interface DerivePrepareSessionKeyRequest {
  accountId: string
  /**
   * Wallet address (the customer's EOA — "Signer" and owner in one) this
   * onboarding targets. REQUIRED: it is the Action's owner and signer, so
   * the frontend must connect the wallet before calling prepare. Empty is a
   * hard error.
   */
  walletAddress: string
  /**
   * The subaccounts this key may trade, as the customer chose them in the
   * picker. REQUIRED and non-empty: an empty list registers a key over every
   * subaccount the wallet will ever own, including ones OrderX never linked,
   * and private/edit_session_key cannot narrow one afterwards. The ids are
   * baked into the Action the customer signs, so they cannot be widened
   * server-side either — linking new subaccounts re-registers the key.
   *
   * Call DeriveListSubaccounts first: its owner-signed form lists without a
   * key already existing, which is what makes choosing-before-signing
   * possible.
   */
  subaccountIds: string[]
}

export interface DerivePrepareSessionKeyResponse {
  sessionKeyAddress: string
  /**
   * Deprecated — the Matching contract does not exist on Derive's settlement
   * chain and nothing reads this. Kept on the wire per this repo's proto
   * conventions (fields are never removed, only reserved/deprecated). Sent
   * empty.
   *
   * @deprecated
   */
  matchingContractAddress: string
  /**
   * Deprecated — always false. Subaccount discovery and linking belong to
   * the DeriveListSubaccounts/DeriveLinkSubaccounts RPCs.
   *
   * @deprecated
   */
  needsSubaccount: boolean
  /**
   * Backend-chosen session-key expiry (unix seconds), NOT
   * customer-configurable — it is a field of the Action in typed_data_json
   * below, so a client-chosen value could never apply to a different expiry.
   */
  registrationExpiryUnixSeconds: string
  /**
   * Deprecated — there is no UserOperation. Sign typed_data_json instead.
   *
   * @deprecated
   */
  userOpHash: string
  /**
   * The full eth_signTypedData_v4 payload for the wallet to sign: the
   * EIP712Domain, the Action type, and the message the backend built and
   * persisted. Pass it to the wallet verbatim — the frontend's only job is
   * to sign it, not to construct or interpret it, and confirm checks the
   * returned signature against the Action it persisted, never against
   * anything the client sends back.
   */
  typedDataJson: string
  /**
   * The chain the domain separator in typed_data_json binds to (1 mainnet,
   * 11155111 Sepolia). Wallets that pre-flight a typed-data request against
   * their connected network need this to prompt for the right one.
   */
  chainId: string
}

/**
 * Submits the two signatures private/set_session_key needs, both from the
 * wallet identified by wallet_address. The backend recovers the action
 * signature's signer against the Action IT persisted at prepare time — never
 * against anything the client sends — and requires it to equal that wallet
 * before forwarding the registration to Derive.
 */
export interface DeriveConfirmSessionKeyRequest {
  accountId: string
  walletAddress: string
  /**
   * Deprecated — was the broadcast registerSessionKey tx hash under the old
   * direct-eth_sendTransaction design. Unused; kept on the wire per this
   * repo's proto conventions (fields are never removed, only
   * reserved/deprecated).
   *
   * @deprecated
   */
  registrationTxHash: string
  /**
   * Deprecated — superseded by the DeriveListSubaccounts/
   * DeriveLinkSubaccounts RPCs, which own all subaccount discovery and
   * linking.
   *
   * @deprecated
   */
  subaccountId: number
  /**
   * Deprecated — there is no UserOperation. Send action_signature instead.
   *
   * @deprecated
   */
  userOpSignature: string
  /**
   * eth_signTypedData_v4 signature over the prepare response's
   * typed_data_json, unmodified.
   */
  actionSignature: string
  /**
   * Unix milliseconds the login_signature below was produced for. Derive
   * rejects a stale one, and so does this backend before spending a round
   * trip on it.
   */
  loginTimestampMs: string
  /**
   * personal_sign signature over login_timestamp_ms rendered as a decimal
   * string. This authenticates the private/set_session_key request itself,
   * which the session key being registered cannot yet sign for.
   */
  loginSignature: string
}

/**
 * Disconnect (unlink) a Derive session-key account. OWNER-gated. Clears the
 * stored session key; does not deregister it onchain (customer can do that
 * themselves via their wallet — see the research doc §3.6 escape hatch).
 */
export interface DeriveDisconnectRequest {
  accountId: string
}

/**
 * List a Derive wallet's subaccounts for the connection picker. Subaccounts
 * are read from Derive's authenticated REST API, which is the only place
 * they exist, so the call needs one of two credentials: the login signature
 * below, or a live stored session key for the caller's (wallet, user) pair.
 * With neither, the response is wallet_connected=false and an empty list —
 * an empty list is never evidence the wallet has no subaccounts, only that
 * we cannot see them yet, so the frontend must run the connect/sign step
 * rather than offer to create one.
 */
export interface DeriveListSubaccountsRequest {
  /** initiating Derive account (admin-gated) */
  accountId: string
  /** the customer's EOA, same as prepare */
  walletAddress: string
  /**
   * Owner-signed listing, for the first call of onboarding — before any
   * session key exists to list with. Derive authorises a wallet to read its
   * own subaccounts on its login header alone, so these carry that header:
   * unix milliseconds, and the personal_sign signature over that number's
   * decimal string. Send both or neither; neither means "use the stored
   * session key", which is what every later listing does.
   */
  loginTimestampMs: string
  loginSignature: string
}

export interface DeriveSubaccountInfo {
  subaccountId: string
  /** reserved by ANY OrderX account */
  alreadyLinked: boolean
  /** non-empty only when linked by the caller's own account */
  linkedAccountId: string
  /** "" when unknown */
  currency: string
  /** "SM" | "PM" | "" */
  marginType: string
  /** decimal string, "" when unknown */
  balanceUsd: string
  /**
   * Spot USDC this subaccount holds, decimal string, "" when unknown. Not
   * balance_usd: a subaccount holding ETH against borrowed USDC prices well
   * above zero and still has nothing a spot transfer can move, so this is
   * what decides whether it can fund a create. Negative is possible.
   */
  usdcBalance: string
}

export interface DeriveListSubaccountsResponse {
  /** live unexpired session key stored for (wallet, user) */
  walletConnected: boolean
  /**
   * The wallet the subaccounts hang off — the customer's own EOA. Named for
   * the smart-contract wallet that used to hold them; the name is on the
   * wire and stays.
   */
  scwAddress: string
  subaccounts: DeriveSubaccountInfo[]
  /** plan-cap headroom for NEW sibling accounts */
  remainingAccountSlots: number
  /** 0 = initiating account has no subaccount yet (its link consumes the first slot) */
  initiatingSubaccountId: string
  /** server cap on selections per link request */
  maxSlotsPerLink: number
  /**
   * USDC each create moves out of the funding subaccount, decimal string.
   * Not a charge: it lands in the customer's own new subaccount. Derive takes
   * its sequencer fee (~1 USDC) out of it and refuses any create crediting
   * under 5 USDC. Server-configured, so the picker states the real figure.
   */
  subaccountCreateAmountUsd: string
}

/**
 * Batch-link subaccounts to OrderX accounts. Zero wallet signatures: the
 * stored session key covers everything. If the initiating account has no
 * subaccount yet it takes the first slot; every further slot spawns a
 * sibling OrderX account (proxy + DDB row) linked to its subaccount.
 * create_count fresh subaccounts are created via Derive's API first.
 */
export interface DeriveLinkSubaccountsRequest {
  accountId: string
  walletAddress: string
  /** existing subaccounts to link */
  subaccountIds: string[]
  /** brand-new subaccounts to create */
  createCount: number
  /**
   * Subaccount every create draws its funding from. 0 = let the server pick
   * (the newest one whose USDC covers it). A create is refused when the
   * chosen subaccount's USDC leg cannot cover the transfer, which is not the
   * same as its displayed value: a subaccount can price well above the amount
   * on collateral a spot transfer cannot move.
   */
  fundingSubaccountId: string
}

export interface DeriveLinkedSlot {
  /** 0 when creation itself failed */
  subaccountId: string
  /** "" when the slot failed before an account existed */
  accountId: string
  accountName: string
  ok: boolean
  /** "" on success */
  error: string
}

export interface DeriveLinkSubaccountsResponse {
  slots: DeriveLinkedSlot[]
}

/**
 * List a Lighter L1 address's sub-accounts for the connection picker, via
 * the unauthenticated accountsByL1Address endpoint (works even before any
 * API key has been registered for this address).
 */
export interface LighterListSubaccountsRequest {
  /** initiating OrderX account (admin-gated) */
  accountId: string
  /** Ethereum address that owns the Lighter account(s) */
  l1Address: string
}

export interface LighterSubaccountInfo {
  accountIndex: string
  /** reserved by ANY OrderX account */
  alreadyLinked: boolean
  /** non-empty only when linked by the caller's own account */
  linkedAccountId: string
  /** "main" | "sub" | ""(unknown from this listing) */
  accountType: string
}

export interface LighterListSubaccountsResponse {
  subaccounts: LighterSubaccountInfo[]
  remainingAccountSlots: number
}

/**
 * Wallet-driven key minting is a two-step exchange (Task 6): the backend
 * generates a fresh keypair and returns the L1 personal_sign text; once the
 * customer's wallet signs it, the frontend submits the signature here to
 * complete the ChangePubKey tx and receive a handle for LighterLinkSubaccounts
 * to reference — the backend never sends the newly-minted secret key to the
 * frontend at any point.
 */
export interface LighterPrepareSubaccountKeyRequest {
  accountId: string
  l1Address: string
  /** existing sub-account, or a fresh index for a new one */
  accountIndex: string
  apiKeyIndex: number
}

export interface LighterPrepareSubaccountKeyResponse {
  /** opaque handle, references server-held pending key material */
  preparedKeyId: string
  /** exact TemplateChangePubKey text for the wallet to sign */
  personalSignText: string
}

export interface LighterConfirmSubaccountKeyRequest {
  preparedKeyId: string
  /** the wallet's signature over personal_sign_text, hex-encoded per eth_sign convention */
  personalSignSignature: string
}

export interface LighterConfirmSubaccountKeyResponse {
  ok: boolean
  /** "" on success — e.g. non-empty on ChangePubKey submission rejection */
  error: string
}

/**
 * Batch-link Lighter sub-accounts to OrderX accounts. Each slot's key comes
 * from exactly one of two sources: a caller-pasted secret (paste-N-keys
 * fallback, for keys minted outside our flow entirely) or a prepared_key_id
 * from a completed Prepare/Confirm exchange above (wallet-driven flow) — the
 * backend never accepts a raw secret that IT generated back from the caller,
 * since it already holds it server-side from the Prepare step.
 */
export interface LighterLinkSubaccountsRequest {
  accountId: string
  l1Address: string
  links: LighterSubaccountLink[]
}

export interface LighterSubaccountLink {
  accountIndex: string
  apiKeyIndex: number
  /** paste-fallback: encrypted at rest immediately on receipt, never logged */
  pastedApiKeySecret?: string | undefined
  /** wallet-driven: references a completed LighterConfirmSubaccountKey exchange */
  preparedKeyId?: string | undefined
}

export interface LighterLinkedSlot {
  accountIndex: string
  /** "" when the slot failed before an account existed */
  accountId: string
  accountName: string
  ok: boolean
  /** "" on success */
  error: string
}

export interface LighterLinkSubaccountsResponse {
  slots: LighterLinkedSlot[]
}

/**
 * Lighter Partner Attribution consent. Before OrderX may attribute a customer's
 * order flow to its integrator account (and charge the integrator fee on it),
 * the customer signs an on-chain ApproveIntegrator tx. That tx needs BOTH an L2
 * Schnorr signature from their already-registered API key (built server-side)
 * and an L1 personal_sign from their wallet — hence the same two-step shape as
 * LighterPrepareSubaccountKey above, not a single call.
 *
 * Opt-in and never assumed: completing onboarding leaves an account unapproved,
 * and orders from an unapproved account are signed with no attribution at all.
 */
export interface LighterPrepareIntegratorConsentRequest {
  accountId: string
}

export interface LighterPrepareIntegratorConsentResponse {
  /** opaque handle, references the server-held L2-signed tx */
  preparedConsentId: string
  /** exact TemplateL2ApproveIntegrator text for the wallet to sign */
  personalSignText: string
  /** what the customer is approving — shown in the consent UI */
  integratorAccountIndex: string
  /** fee ceiling being approved, value/1e6 (1 bp = 100) */
  maxFeeUnits: number
  /**
   * This account already has a recorded consent. Not a refusal — re-approving
   * is how a customer refreshes the expiry or moves to a changed rate — but the
   * UI should say so rather than presenting a first-time grant.
   */
  alreadyApproved: boolean
}

export interface LighterConfirmIntegratorConsentRequest {
  preparedConsentId: string
  /** the wallet's signature over personal_sign_text, hex-encoded per eth_sign convention */
  personalSignSignature: string
}

export interface LighterConfirmIntegratorConsentResponse {
  ok: boolean
  /** "" on success — e.g. non-empty on ApproveIntegrator submission rejection */
  error: string
}

/**
 * Set the leverage every subsequent open on (account, instrument) is sent with.
 * First venue: Papertrade (TRADE_VENUE_PAPERTRADE). The backend validates
 * 1..=Instrument.max_leverage for the instrument's exchange and stores the
 * setting; the venue reads it at send time. OWNER/TRADE-gated.
 */
export interface SetLeverageRequest {
  accountId: string
  /** normalized symbol, e.g. BTC-PERP */
  instrument: string
  leverage: number
}

/** Echoes the stored setting. */
export interface SetLeverageResponse {
  accountId: string
  instrument: string
  leverage: number
}

/**
 * Read the account's stored settings (today: Papertrade per-instrument leverage).
 * READ-gated. Any venue may be asked; a venue without a setting answers with
 * an empty map and no default. One typed message that grows by fields.
 */
export interface GetAccountSettingsRequest {
  accountId: string
}

export interface AccountSettings {
  accountId: string
  /** Normalized symbol (e.g. BTC-PERP) → stored leverage. Symbols never set are absent. */
  leverage: { [key: string]: number }
  /**
   * Leverage used for a symbol with no stored entry. Unset when the venue
   * takes no per-instrument leverage.
   */
  defaultLeverage?: number | undefined
}

export interface AccountSettings_LeverageEntry {
  key: string
  value: number
}

/**
 * Papertrade session-key onboarding (BACKEND SUBMITS, like Hyperliquid agent
 * wallets). Prepare mints the session key and returns the RegisterSessionKey
 * EIP-712 typed data for the customer's wallet to sign.
 */
export interface PapertradePrepareSessionKeyRequest {
  accountId: string
  /** The customer's HyperEVM wallet address (the signer). */
  walletAddress: string
}

export interface PapertradePrepareSessionKeyResponse {
  /** The minted session key's address (the `key` the wallet authorises). */
  sessionKeyAddress: string
  /** EIP-712 typed-data JSON (domain, types, primaryType, message) to sign. */
  typedDataJson: string
  /** EIP-712 domain chainId (HyperEVM 999). */
  chainId: number
  /** Session-key expiry, Unix seconds (now + 30 days). */
  registrationExpiryUnixSeconds: string
}

/**
 * Relay the wallet's signature. The backend submits registerSessionKey to
 * Papertrade, waits for the key to appear in the wallet's sessionKeys, stores
 * the encrypted session key and activates the account. Response is the shared
 * Success/Error.
 */
export interface PapertradeConfirmSessionKeyRequest {
  accountId: string
  walletAddress: string
  /** Signature (hex, 65 bytes) over the typed data from prepare. */
  signature: string
}

/**
 * Disconnect a Papertrade account. OWNER-gated. Clears the stored session key
 * (status -> Inactive) and releases the wallet registry row.
 */
export interface PapertradeDisconnectRequest {
  accountId: string
}

export interface ParadigmAccountInfo {
  accountName: string
  /** trades seen under this nickname */
  paradigmTradeCount: number
  /** of those, matched in user_trades */
  matchedTradeCount: number
  lastTradedAtMs?: string | undefined
  evidence: ParadigmBindingEvidence
  /** the equivalence set (see `sun`) */
  matchedAccountIds: string[]
}

export interface ParadigmConnectDeskRequest {
  accountId: string
  accessKey: string
  secretKey: string
}

export interface ParadigmConnectDeskResponse {
  deskId: string
  /** absent until this desk has sent one TAKER RFQ */
  deskName?: string | undefined
}

export interface ParadigmListAccountsRequest {
  accountId: string
}

export interface ParadigmListAccountsResponse {
  accounts: ParadigmAccountInfo[]
}

export interface ParadigmLinkAccountRequest {
  accountId: string
  accountName: string
}

export interface ParadigmLinkAccountResponse {
  state: ParadigmBindingState
}

/**
 * Disconnect (unlink) an account's Paradigm desk binding. OWNER-gated, and
 * deliberately NOT plan-gated — a user whose plan lapsed must still be able to
 * unwind a binding they can no longer create. Clears all four binding fields
 * (including `paradigm_desk_id`), so reconnecting means re-entering the desk
 * credentials; the desk's own credential record survives, because one desk can
 * back several accounts. Reuses Success as the response.
 */
export interface ParadigmDisconnectRequest {
  accountId: string
}

/**
 * Permanently delete an account that has never reached ACTIVE (so no trade
 * history is possible). Owner-gated. The backend re-verifies eligibility
 * server-side on a fresh read — a stale client claiming "never activated" is
 * rejected, not trusted. Reuses Success as the response.
 */
export interface CancelPendingAccountRequest {
  accountId: string
}

export interface CreateCheckoutSessionRequest {
  /**
   * Where Stripe Checkout returns the user. The frontend sends its own origin's
   * URLs so a shared backend (staging + prod hit the same API) redirects back to
   * the originating site. Each is exact-match validated against the server's
   * billing redirect allowlist (same pattern as the OAuth redirect_uri); unset
   * falls back to the server's configured default.
   */
  successUrl: string
  cancelUrl: string
  /**
   * Stripe price id to subscribe to — chosen from GetPlans. Validated server-side
   * against the configured catalog (an unknown id ⇒ 400). This is the only thing
   * that selects plan + interval, so adding a plan/interval is config-only.
   */
  priceId: string
}

export interface CreateCheckoutSessionResponse {
  checkoutUrl: string
}

export interface GetSubscriptionRequest {}

export interface GetSubscriptionResponse {
  /** Stripe subscription status verbatim ("active", "past_due", …); empty when no record */
  status: string
  /** effective resolved level (what the gates enforce) */
  planLevel: PlanLevel
  currentPeriodEnd: string
  cancelAtPeriodEnd: boolean
  /** exactly what plan_level unlocks; resolved server-side, never hardcode the table on the client */
  capabilities: Capabilities | undefined
  /**
   * Display label for the account-status badge: "ESSENTIAL", "PRO", or "CUSTOM"
   * (CUSTOM = an operator tier override / comp, where capabilities may exceed the
   * billing plan_level). Render verbatim; gate features off `capabilities`, not this.
   *
   * Renamed from "FREE" (oems_v2 #463) so the badge matches the pricing card.
   * There is no version gate: a consumer still comparing against "FREE" silently
   * stops recognising the $0 tier, so accept both tokens across the deploy window.
   * PlanLevel keeps the name PLAN_LEVEL_FREE — enum names are never renamed — so
   * the level and the label are deliberately different words.
   */
  planLabel: string
  /**
   * True while this user can still claim their one-time free trial (never
   * subscribed before). Once false, stop advertising the trial. The offered
   * length per plan is Plan.trial_period_days from GetPlans.
   */
  trialEligible: boolean
  /**
   * True when the user has a live Stripe subscription (active/trialing/past_due).
   * Render "Manage subscription" (OpenBillingPortal) instead of a new checkout,
   * and route all tier/interval changes through the portal. False on the $0 tier
   * and for operator-comped users (no Stripe sub) → render Subscribe.
   */
  subscriptionActive: boolean
}

/**
 * What a plan level unlocks. Resolved server-side from the same config table the
 * enforcement gates use (shared/config entitlements.rs) so the client never
 * drifts from what the backend will actually allow.
 */
export interface Capabilities {
  allowedAlgos: AlgoType[]
  allowedVenues: TradeVenue[]
  allowedStreamKinds: StreamKind[]
  maxAccounts: number
  /** extra (non-owner) members an account may be shared with; 0 = sharing disabled */
  maxSharedMembers: number
  /** Sub-algo / sub-feature granularity (gate within an otherwise-allowed algo): */
  allowedTriggerConditions: TriggerConditionType[]
  /** e.g. FREE = [TWAP] only */
  allowedHedgeMechanisms: HedgeMechanism[]
  /** e.g. IMPLIED_VS_REALIZED is PRO */
  allowedAnalyticsTypes: AnalyticsType[]
  /** named feature flags, e.g. "risk_simulation" */
  allowedFeatures: string[]
}

export interface OpenBillingPortalRequest {
  /**
   * Where the Stripe Billing Portal returns the user (frontend's own origin).
   * Exact-match validated against the billing redirect allowlist; unset falls
   * back to the server's configured default.
   */
  returnUrl: string
}

export interface OpenBillingPortalResponse {
  portalUrl: string
}

/**
 * Public plan catalog. Unauthenticated — a pricing page may render pre-login.
 * Everything here is config + Stripe driven (no per-user data), so adding a plan
 * or changing a price is a Stripe + config edit with no proto/code change.
 */
export interface GetPlansRequest {}

export interface GetPlansResponse {
  plans: Plan[]
  /**
   * Stripe publishable key (public, safe to ship to the browser). Provided here
   * so the frontend needs no Stripe env of its own; empty when unconfigured. Our
   * checkout flow is hosted-redirect and does NOT require it — it's only for
   * optional client-side Stripe.js / pricing widgets.
   */
  publishableKey: string
}

/**
 * A purchasable plan: an entitlement level, its Stripe prices (one per interval),
 * and exactly what it unlocks. Prices are fetched live from Stripe so Dashboard
 * edits surface with no redeploy.
 */
export interface Plan {
  level: PlanLevel
  /** display label, e.g. "Pro" */
  label: string
  /** one per billing interval (monthly, yearly, …) */
  prices: Price[]
  /**
   * What this plan unlocks — resolved server-side from the same entitlements
   * table the gates use, so the pricing page can't drift from enforcement.
   */
  capabilities: Capabilities | undefined
  /**
   * Offered one-time free-trial length (days) for a first-time subscriber; 0 =
   * none. Drives a "Try for free, N days" badge. The price is still charged after
   * the trial; eligibility (one-time) is per-user — see GetSubscriptionResponse.
   */
  trialPeriodDays: number
}

/**
 * One Stripe price (a single billing interval) for a plan. Amounts are live from
 * Stripe; the frontend passes `price_id` back to CreateCheckoutSession.
 */
export interface Price {
  priceId: string
  /** smallest currency unit (e.g. cents); 0 if unknown */
  unitAmount: string
  /** ISO 4217 lowercase, e.g. "usd" */
  currency: string
  /** Stripe recurring interval: "day"/"week"/"month"/"year" */
  interval: string
  /** e.g. 1 (every interval), 3 (quarterly), … */
  intervalCount: number
  /**
   * Optional struck-through "was" amount for a promo: set a plan's price to the
   * discounted Stripe price and point `compare_at_price_id` at the original in
   * config; absent = no promo. Smallest currency unit, same currency.
   */
  compareAtAmount?: string | undefined
}

export interface ExchangeList {
  exchanges: Exchange[]
}

export interface InstrumentList {
  instruments: Instrument[]
}

export interface ExchangeStatus {
  exchange: Exchange
  status: ExchangeStatusType
  /** Epoch ms (UTC) at which the current status began. */
  sinceMs: string
  /**
   * Epoch ms (UTC) of the next scheduled boundary. Unset for always-open
   * venues (crypto), which never change.
   */
  nextChangeMs?: string | undefined
  /**
   * Data-role host → venue WS round-trip latency (ms). Not the end user's
   * latency; the FE must label it as the venue link, not the client link.
   */
  latencyMs?: number | undefined
}

/**
 * Two-dimensional venue availability from the active outage monitor. `data`
 * mirrors public-feed health (the ConnectivityBeacon's signal, consumed as
 * input); `trading` reflects a live order round-trip probe. Separate from
 * ExchangeStatus (single data-only enum) so trading can recover independently
 * of data — the 07-07 incident had data back ~5.5 min before trading.
 */
export interface VenueHealth {
  exchange: Exchange
  /**
   * Verbatim from the venue's ConnectivityBeacon, so MAINTENANCE stays
   * distinguishable from an unplanned outage. UNSPECIFIED means the monitor has
   * never observed this venue's beacon — never read it as healthy.
   */
  data: ExchangeStatusType
  /**
   * Absent until an order probe has actually completed a round-trip. A monitor
   * with no probe configured must say nothing here rather than assume tradeable.
   */
  trading?: boolean | undefined
  whatChanged: VenueHealthChange
  /**
   * Epoch ms (UTC) of the transition that produced this emit; on heartbeat
   * emits it is the most recent transition instant.
   */
  sinceMs: string
}

/**
 * One venue's static weekly "Regular Hours" rules, in the venue's local
 * timezone, for FE tooltips/caching without client-side calculation. Crypto
 * venues set always_open=true and leave weekly_sessions empty. weekly_sessions
 * are the regular recurring hours; holidays and session_overrides list the dated
 * exceptions so a chart can cut closed days and shortened sessions from its time
 * axis. Actual current open/closed (overnight, live outages) still comes from
 * get_venue_status.
 */
export interface VenueSchedule {
  exchange: Exchange
  /** IANA timezone name (e.g. "America/New_York"); "UTC" for always-open venues. */
  timezone: string
  alwaysOpen: boolean
  weeklySessions: WeeklySession[]
  /**
   * Local dates (YYYYMMDD) on which the venue's regular weekday session does
   * not open, from 2022 through the calendar's forward horizon (~5 years).
   * Empty for always-open venues.
   */
  holidays: string[]
  /**
   * Sessions whose local hours differ from weekly_sessions (early closes, late
   * opens). Same range as holidays.
   */
  sessionOverrides: VenueSchedule_SessionOverride[]
}

/** One dated departure from the weekly rule, in the venue's local timezone. */
export interface VenueSchedule_SessionOverride {
  /** YYYYMMDD local, the session's label */
  date: string
  /**
   * "HH:MM" 24h local. On a venue whose regular session spans midnight
   * (GLBX: 17:00 -> 17:00 CT) open falls on the calendar day before date.
   */
  open: string
  /** "HH:MM" 24h local */
  close: string
}

/** Regular trading window for one weekday, in the venue's local timezone. */
export interface WeeklySession {
  /** 0 = Monday … 6 = Sunday */
  weekday: number
  /** "HH:MM" 24h local */
  open: string
  /** "HH:MM" 24h local */
  close: string
}

export interface VenueScheduleList {
  schedules: VenueSchedule[]
}

/**
 * §2 — minute snapshot per (currency, expiration). One snapshot tick yields
 * N rows, one per expiry slice. Carries ATM IV, butterflies (15/25-delta),
 * risk reversals (15/25-delta), and underlying price; each `*_change` is
 * the 24-hour delta vs the reading 24 hours earlier, absent until the
 * producer holds a day of its own history.
 */
export interface VolMetrics24hPoint {
  /** observation tick (request time) */
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  /** f64 in API; Decimal string here */
  daysToExpiration: string
  atm?: string | undefined
  atmChange?: string | undefined
  butterfly15?: string | undefined
  butterfly15Change?: string | undefined
  butterfly25?: string | undefined
  butterfly25Change?: string | undefined
  riskReversal15?: string | undefined
  riskReversal15Change?: string | undefined
  riskReversal25?: string | undefined
  riskReversal25Change?: string | undefined
  underlyingPrice?: string | undefined
  underlyingPriceChange?: string | undefined
}

export interface VolMetrics24hList {
  items: VolMetrics24hPoint[]
}

export interface PutCallRatioPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  /**
   * BOTH ratios come from one read — keep them together.
   * Source fields: putCallRatioOpenInterest, putCallRatioVolume24hr.
   */
  putCallRatioOpenInterest?: string | undefined
  putCallRatioVolume24h?: string | undefined
  /**
   * Spot overlay. The PCR row carries no price of its own, so this is
   * ASOF-joined from `implied_vs_realized` (same hourly cadence) on the range
   * path only; absent on the snapshot and the analytics_stream tick, and null
   * once that series stalls beyond the join tolerance.
   */
  indexPrice?: string | undefined
}

export interface PutCallRatioList {
  items: PutCallRatioPoint[]
}

/**
 * §4 — one row per (timestamp, currency, days_to_expiration). Each row is
 * a per-DTE delta surface slice — 10 call deltas (5..45 by 5), 10 put
 * deltas (5..45 by 5), the 50-delta line, and ATM IV. Multiplier, open
 * interest, index/underlying price are carried alongside for analytic
 * consumers that need per-tenor context.
 */
export interface DeltaSurfaceConstantPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  /** f64 in the API (e.g. 0.243 for the front-week tenor) — string Decimal. */
  daysToExpiration: string
  multiplier?: string | undefined
  openInterest?: string | undefined
  indexPrice?: string | undefined
  underlyingPrice?: string | undefined
  atm?: string | undefined
  delta50?: string | undefined
  deltaCall05?: string | undefined
  deltaCall10?: string | undefined
  deltaCall15?: string | undefined
  deltaCall20?: string | undefined
  deltaCall25?: string | undefined
  deltaCall30?: string | undefined
  deltaCall35?: string | undefined
  deltaCall40?: string | undefined
  deltaCall45?: string | undefined
  deltaPut05?: string | undefined
  deltaPut10?: string | undefined
  deltaPut15?: string | undefined
  deltaPut20?: string | undefined
  deltaPut25?: string | undefined
  deltaPut30?: string | undefined
  deltaPut35?: string | undefined
  deltaPut40?: string | undefined
  deltaPut45?: string | undefined
  /**
   * The book's own spot, as opposed to `index_price`/`underlying_price` above,
   * which are this slice's forward. Optional because a row may have no spot:
   * the venue publishes none (GLBX, OPRA), or the row predates the producer
   * that stamps it. Hide a spot overlay where it is missing — do not infer the
   * venue's capabilities from it. Same field and same meaning as
   * `GexPoint.book_index_price`.
   */
  bookIndexPrice?: string | undefined
}

export interface DeltaSurfaceConstantList {
  items: DeltaSurfaceConstantPoint[]
}

/**
 * §5 — same shape as the constant-tenor surface but keyed on a concrete
 * expiry timestamp instead of a constant DTE bucket. `expiration_ts_ms`
 * is parsed from the API's ISO8601 `expirationTimestamp` field.
 */
export interface DeltaSurfaceFloatingPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  daysToExpiration: string
  multiplier?: string | undefined
  openInterest?: string | undefined
  indexPrice?: string | undefined
  underlyingPrice?: string | undefined
  atm?: string | undefined
  delta50?: string | undefined
  deltaCall05?: string | undefined
  deltaCall10?: string | undefined
  deltaCall15?: string | undefined
  deltaCall20?: string | undefined
  deltaCall25?: string | undefined
  deltaCall30?: string | undefined
  deltaCall35?: string | undefined
  deltaCall40?: string | undefined
  deltaCall45?: string | undefined
  deltaPut05?: string | undefined
  deltaPut10?: string | undefined
  deltaPut15?: string | undefined
  deltaPut20?: string | undefined
  deltaPut25?: string | undefined
  deltaPut30?: string | undefined
  deltaPut35?: string | undefined
  deltaPut40?: string | undefined
  deltaPut45?: string | undefined
  /**
   * The book's own spot, as opposed to `index_price`/`underlying_price` above,
   * which are this slice's forward. Optional because a row may have no spot:
   * the venue publishes none (GLBX, OPRA), or the row predates the producer
   * that stamps it. Hide a spot overlay where it is missing — do not infer the
   * venue's capabilities from it. Same field and same meaning as
   * `GexPoint.book_index_price`.
   */
  bookIndexPrice?: string | undefined
}

export interface DeltaSurfaceFloatingList {
  items: DeltaSurfaceFloatingPoint[]
}

/**
 * Per-delta skew derived from the delta-surface tables:
 * `skew_0N = delta_call_0N - delta_put_0N`. One row per surface slice;
 * a bucket is absent when either side's IV is null. Constant-tenor variant
 * keyed by `days_to_expiration`, floating by concrete `expiration_ts_ms`.
 * `index_price` is this slice's forward, on every venue we produce: the shared
 * surface builder fills the delta-surface table's `index_price` and
 * `underlying_price` columns with the same forward at r = 0, for the Databento
 * books (GLBX, OPRA) and the crypto books alike. Pre-cutover Amberdata rows are
 * the one exception — there `index_price` carried the vendor's spot index and
 * `underlying_price` a separate per-expiry forward — so the column is not
 * comparable across row vintages. For a spot overlay read `book_index_price`
 * instead: the book's own spot, populated only where the venue publishes one.
 * One value per row: the maturities of a single timestamp repeat it only
 * approximately, since downsampling takes `LAST()` per maturity.
 */
export interface SkewConstantPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  daysToExpiration: string
  skew05?: string | undefined
  skew10?: string | undefined
  skew15?: string | undefined
  skew20?: string | undefined
  skew25?: string | undefined
  skew30?: string | undefined
  skew35?: string | undefined
  skew40?: string | undefined
  skew45?: string | undefined
  indexPrice?: string | undefined
  /**
   * The book's own spot, as opposed to `index_price` above, which is this
   * slice's forward. Optional because a row may have no spot: the venue
   * publishes none (GLBX, OPRA), or the row predates the producer that
   * stamps it. Hide a spot overlay where it is missing — do not infer the
   * venue's capabilities from it. Same field and same meaning as
   * `GexPoint.book_index_price`.
   */
  bookIndexPrice?: string | undefined
}

export interface SkewConstantList {
  items: SkewConstantPoint[]
}

export interface SkewFloatingPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  daysToExpiration: string
  skew05?: string | undefined
  skew10?: string | undefined
  skew15?: string | undefined
  skew20?: string | undefined
  skew25?: string | undefined
  skew30?: string | undefined
  skew35?: string | undefined
  skew40?: string | undefined
  skew45?: string | undefined
  indexPrice?: string | undefined
  /**
   * The book's own spot, as opposed to `index_price` above, which is this
   * slice's forward. Optional because a row may have no spot: the venue
   * publishes none (GLBX, OPRA), or the row predates the producer that
   * stamps it. Hide a spot overlay where it is missing — do not infer the
   * venue's capabilities from it. Same field and same meaning as
   * `GexPoint.book_index_price`.
   */
  bookIndexPrice?: string | undefined
}

export interface SkewFloatingList {
  items: SkewFloatingPoint[]
}

/**
 * One cell of the CME FedWatch probability tree: the market-implied chance the
 * Fed Funds target range sits at `target_lower_bp` once the FOMC meeting on
 * `meeting_date` has happened. Probabilities are unconditional, so the cells
 * sharing a `(timestamp_ms, meeting_date)` sum to one.
 */
export interface FedwatchProbabilityPoint {
  timestampMs: string
  exchange: Exchange
  /**
   * Futures root the tree was built from (`ZQ`), in the slot the other
   * analytics use for a currency.
   */
  currency: string
  /** FOMC announcement date as `YYYY-MM-DD`. */
  meetingDate: string
  /** Lower bound of the target range this cell describes, in basis points. */
  targetLowerBp: number
  /**
   * Move from the target range standing today, in basis points. Negative for a
   * cut. Kept alongside the absolute bound so a client can label a row without
   * knowing what the current target was at the time of the snapshot.
   */
  cumulativeMoveBp: number
  /** Decimal as string, 0..1. */
  probability: string
}

export interface FedwatchProbabilityList {
  items: FedwatchProbabilityPoint[]
}

export interface OptionsVolumeLeaderboardEntry {
  /** contract symbol (CONTRACT grouping); absent for EXPIRY */
  symbol?: string | undefined
  /** contract expiration (present for both groupings) */
  expiryMs?: string | undefined
  /** total volume in the requested measure (decimal string) */
  volume: string
  /** populated only when option_type filter is absent (All) */
  callVolume?: string | undefined
  /** populated only when option_type filter is absent (All) */
  putVolume?: string | undefined
}

export interface OptionsVolumeLeaderboard {
  exchange: Exchange
  underlying: string
  volumeMeasure: OptionsVolumeMeasure
  groupBy: OptionsVolumeGroupBy
  entries: OptionsVolumeLeaderboardEntry[]
}

/** ENG-613 #1 — per-underlying options volume time-series at chart timeframes. */
export interface OptionsVolumeBucket {
  timestampMs: string
  /** total in the requested measure (= call + put, decimal string) */
  volume: string
  callVolume: string
  putVolume: string
}

export interface OptionsVolumeSeries {
  exchange: Exchange
  underlying: string
  timeframe: ChartTimeframe
  volumeMeasure: OptionsVolumeMeasure
  buckets: OptionsVolumeBucket[]
}

/**
 * One (bucket, strike) cell of the strike-flow heatmap. Net flow is
 * `buy_volume - sell_volume`; both sides ship so the split stays recoverable.
 */
export interface OptionsStrikeFlowCell {
  strike: string
  buyVolume: string
  sellVolume: string
}

export interface OptionsStrikeFlowBucket {
  timestampMs: string
  /**
   * Averaged over the trades this bucket aggregates. Honours `expiry_ms` only on
   * GLBX, where index_price is the per-expiry forward rather than one shared
   * underlying index. Absent where the venue carried no index price at that time
   * (Bybit before 2026-07-29).
   */
  avgIndexPrice?: string | undefined
  /** Sparse — a strike absent here had no flow in this bucket. */
  cells: OptionsStrikeFlowCell[]
}

/**
 * Strike × time flow heatmap over the raw options tape. `strikes` is the y-axis
 * roster, ranked by total volume across the whole window, so it is stable across
 * buckets while `cells` is sparse.
 */
export interface OptionsStrikeFlow {
  exchange: Exchange
  underlying: string
  timeframe: ChartTimeframe
  volumeMeasure: OptionsVolumeMeasure
  expiryMs?: string | undefined
  strikes: string[]
  buckets: OptionsStrikeFlowBucket[]
}

/**
 * ENG-613 #1 — live options-volume stream subject. Data-type-keyed (not
 * analytics_stream, which is push-only and FE-unsubscribable); FE
 * fanout-subscribes like chart_data_stream.
 */
export interface OptionsVolumeStream {
  exchange: Exchange
  underlying: string
  timeframe: ChartTimeframe
}

/**
 * ENG-613 #1 — one live bucket for the options_volume_stream subject.
 * Carries all 8 raw component sums (side × measure) so a single
 * subscription serves every measure and the All/Call/Put split is derived
 * client-side (all = call + put). Mirrors the options_volume_1m MV columns.
 */
export interface OptionsVolumeStreamUpdate {
  exchange: Exchange
  underlying: string
  timeframe: ChartTimeframe
  /** bucket start */
  timestampMs: string
  /** sum(quantity) */
  callNotionalBase: string
  /** sum(quantity * index_price) */
  callNotionalQuote: string
  /** sum(quantity * price) */
  callPremiumBase: string
  /** sum(quantity * price * index_price) */
  callPremiumQuote: string
  putNotionalBase: string
  putNotionalQuote: string
  putPremiumBase: string
  putPremiumQuote: string
}

/**
 * ENG-613 #8 — live per-underlying options-trades stream with server-side
 * filters. Public market data, but filtered per subscription (size threshold
 * is continuous, so a shared fanout subject can't serve differently-filtered
 * clients). public-api spawns one task per subscription that reads the raw
 * trades wildcard, applies these filters, and forwards matching trades.
 */
export interface OptionsTradesStream {
  exchange: Exchange
  underlying: string
  /** absent = All (put + call) */
  optionType?: OptionType | undefined
  blockMode: BlockTradeMode
  /**
   * Size floor: keep trades whose `size_measure` value is >= `min_size`.
   * Both absent = no size filter. size_measure × min_size are f64 because the
   * source trade fields (quantity/price/index_price) are f64 on the wire.
   */
  sizeMeasure?: OptionsVolumeMeasure | undefined
  minSize?: number | undefined
}

/**
 * ENG-613 #4 — per-underlying options open-interest time-series. Chart-parity
 * timeframes but 1m+ only (option OI is 1m-sampled at the source). Reuses
 * OptionsVolumeMeasure (notional/premium × quote/base) over open_interest.
 */
export interface OptionsOiBucket {
  timestampMs: string
  /** total in the requested measure (= call + put, decimal string) */
  oi: string
  callOi: string
  putOi: string
}

export interface OptionsOiSeries {
  exchange: Exchange
  underlying: string
  /** MIN_1 and up */
  timeframe: ChartTimeframe
  measure: OptionsVolumeMeasure
  buckets: OptionsOiBucket[]
}

export interface OptionsOiLeaderboardEntry {
  /** contract symbol (a contract is one side, no put/call split) */
  symbol: string
  expiryMs?: string | undefined
  /** current OI in the requested measure (decimal string) */
  oi: string
  /** current − OI 24h ago (signed decimal string) */
  oiChange24h: string
}

export interface OptionsOiLeaderboard {
  exchange: Exchange
  underlying: string
  measure: OptionsVolumeMeasure
  mode: OptionsOiRankMode
  entries: OptionsOiLeaderboardEntry[]
}

/**
 * One strike of the open-interest snapshot, summed over every live expiry.
 * A side reports "0" rather than an absent field, and that zero is ambiguous by
 * construction: nothing listed, listed with zero open interest, or (quote and
 * premium measures) listed without a price to value it. Read it as "no
 * measurable open interest", nothing stronger.
 *
 * The change columns sum per-contract deltas over the contracts live NOW, so a
 * contract that settled inside the window contributes 0, not a decrease.
 */
export interface OptionsOiStrikePoint {
  /** decimal string, normalized */
  strike: string
  callOi: string
  putOi: string
  /** signed */
  callOiChange24h: string
  /** signed */
  putOiChange24h: string
}

/**
 * Open interest per strike across every live expiry, with each side's 24h
 * change. Snapshot; the strike axis of the Option Open Interest widget. Totals
 * here are not comparable to OptionsOiSeries for the same measure — the series
 * carries an expiring contract to the end of its bucket while this drops it at
 * settlement.
 */
export interface OptionsOiByStrike {
  exchange: Exchange
  underlying: string
  measure: OptionsVolumeMeasure
  points: OptionsOiStrikePoint[]
}

/** Per-expiry 1σ implied move from ATM IV (atm × √T). Snapshot. */
export interface GetImpliedMoveRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
}

export interface ImpliedMovePoint {
  expiryMs: string
  daysToExpiration: number
  /** 1σ move as % of spot (ATM IV × √T); FE appends % */
  oneSigma: string
  /** 1σ move in USD (spot × 1σ fraction); absent if no spot */
  oneSigmaUsd?: string | undefined
}

export interface ImpliedMove {
  exchange: Exchange
  underlying: string
  points: ImpliedMovePoint[]
}

/**
 * ATM IV percentile per constant-maturity tenor: where the latest ATM IV
 * sits within its own trailing 90-day distribution. Snapshot.
 */
export interface GetIvPercentileRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
}

export interface IvPercentilePoint {
  /** constant tenor: 1,2,3,7,14,21,30,60,90,180 */
  daysToExpiration: number
  /** latest ATM IV (percent); FE appends % */
  current: string
  /** % of 90d window at/below current (0-100) */
  percentileRank: string
  /** ATM IV percentiles over the 90d window (percent) */
  p5: string
  p25: string
  p50: string
  p75: string
  p95: string
  /** observations in the window */
  sampleCount: string
}

export interface IvPercentile {
  exchange: Exchange
  underlying: string
  points: IvPercentilePoint[]
}

/**
 * Max pain per expiry: the settlement strike that minimizes total option-holder
 * payoff (Σ OI × ITM value) over the latest OI chain. Snapshot.
 */
export interface GetMaxPainRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
}

export interface MaxPainPoint {
  expiryMs: string
  /** settlement strike minimizing holder payoff */
  maxPainStrike: string
  /** Σ open interest across the expiry's chain */
  totalOi: string
}

export interface MaxPain {
  exchange: Exchange
  underlying: string
  /** spot at snapshot (spot-vs-max-pain distance) */
  underlyingPrice?: string | undefined
  points: MaxPainPoint[]
}

/**
 * A3 — perpetual funding-rate signals. Series carries the raw per-interval
 * rate from `derivative_metrics`; `funding_apr` is annualized server-side from
 * the instrument's funding interval so it's cross-venue comparable.
 */
export interface FundingPoint {
  timestampMs: string
  /** decimal string, venue-native per-interval rate */
  fundingRate: string
  /** annualized, stamped server-side */
  fundingApr?: string | undefined
}

export interface FundingSeries {
  exchange: Exchange
  symbol: string
  points: FundingPoint[]
}

export interface FundingLeaderboardEntry {
  symbol: string
  /** venue-native per-interval rate (decimal string) */
  fundingRate: string
  /** annualized, stamped server-side */
  fundingApr?: string | undefined
  openInterest?: string | undefined
}

export interface FundingLeaderboard {
  exchange: Exchange
  mode: FundingRankMode
  entries: FundingLeaderboardEntry[]
}

export interface GetFundingSeriesRequest {
  exchange: Exchange
  symbol: string
  fromMs?: string | undefined
  toMs?: string | undefined
  limit?: number | undefined
}

export interface GetFundingLeaderboardRequest {
  exchange: Exchange
  mode: FundingRankMode
  limit?: number | undefined
}

/**
 * Historical orderbook-metrics series from the ob_metrics MV pyramid
 * (1s tier: 30d retention; 1h tier: unbounded). Depth tiers are the 7
 * write-side buckets: 5/10/25/50/100/250/500 bps — nothing else exists
 * historically. Values are doubles (chart-parallel-array convention),
 * not decimal strings.
 */
export interface OrderbookMetricsSeriesRequest {
  exchange: Exchange
  symbol: string
  timeframe: ChartTimeframe
  fromMs?: string | undefined
  toMs?: string | undefined
  /** default 1500, server-capped */
  limit?: number | undefined
  /** subset of {5,10,25,50,100,250,500}; empty = no depth columns */
  depthTiersBps: number[]
}

export interface OrderbookDepthTierSeries {
  bps: number
  /** avg resting bid liquidity within bps of mid */
  bidVal: number[]
  askVal: number[]
  /** avg order counts (fractional: time-weighted avg) */
  bidCnt: number[]
  askCnt: number[]
}

export interface OrderbookMetricsSeries {
  exchange: Exchange
  symbol: string
  timeframe: ChartTimeframe
  /** Parallel arrays keyed by ticks_ms. */
  ticksMs: string[]
  /** time-weighted avg */
  spreadBps: number[]
  /** worst intra-bucket spread (vacuum detection) */
  spreadBpsMax: number[]
  /** bids / (bids + asks) */
  pressureRatio: number[]
  bidLiquidityTotal: number[]
  askLiquidityTotal: number[]
  midPrice: number[]
  depthTiers: OrderbookDepthTierSeries[]
}

/**
 * Order-book liquidity heatmap: resting size bucketed by price around mid
 * (see OrderbookHeatmapColumn for the grid), one snapshot per bucket of `timeframe`. Same timeframes as
 * ChartDataRequest from 60 up (no sub-minute tier); a coarser width returns
 * each bucket's first snapshot, as a candle's open is its first trade.
 * History: 1m–15m widths reach back 30 days; 1h and up are kept
 * indefinitely. The still-open bucket is served too, as its opening
 * snapshot; to keep it current, draw over it from `OrderbookHeatmapStream`.
 */
export interface OrderbookHeatmapRequest {
  exchange: Exchange
  symbol: string
  /** MIN_1 and up */
  timeframe: ChartTimeframe
  fromMs?: string | undefined
  toMs?: string | undefined
  /** snapshots; default 300, server-capped at 1500 */
  limit?: number | undefined
}

/**
 * One snapshot. Each carries its own grid: the bucket width follows price
 * as 5 × 10^(floor(log10 mid) − 4) — $5 for BTC at 81k, $50 from 100k,
 * $0.5 for ETH at 2.5k, 0.0005 for XRP at 2.5 — kept until mid leaves
 * that width's power of ten by more than 5%, so it can differ between
 * snapshots in one response. Rows written before 2026-10-09 used an older
 * rule; always read `bucket_width` rather than deriving it.
 *
 * The band is ±25% of mid or 750 buckets a side, whichever is narrower
 * (BTC at 81k: about ±4.6%).
 *
 * bids[i] is the size resting in [bid_start - i*w, bid_start - i*w + w),
 * walking down from the bucket holding the best bid; asks[i] is
 * [ask_start + i*w, ask_start + i*w + w), walking up from the best ask's.
 * Each array ends at the band edge or at the venue's last visible level,
 * whichever is nearer, so a short array means a shallow feed (Bybit sends
 * 200 levels) — not an empty book beyond it.
 *
 * Sizes are the venue's native book quantity (contracts, base units, or USD
 * for inverse books), not notional: colour relative to the instrument.
 */
export interface OrderbookHeatmapColumn {
  /** bucket start */
  tsMs: string
  midPrice: number
  /** w */
  bucketWidth: number
  bidStart: number
  askStart: number
  bids: number[]
  asks: number[]
}

export interface OrderbookHeatmap {
  exchange: Exchange
  symbol: string
  timeframe: ChartTimeframe
  /** oldest first */
  columns: OrderbookHeatmapColumn[]
}

/**
 * Per-side open interest on a venue that exposes it (Papertrade: the
 * `/state/trading` instrument tuple, longOiRaw at index 19 and shortOiRaw at
 * index 20, base quantity with 18 decimals, priced at the relayed mark).
 * Notionals are quote-currency decimal strings.
 */
export interface OpenInterestPressure {
  symbol: string
  exchange: Exchange
  longNotional: string
  shortNotional: string
  /** Unix ms */
  timestamp: string
}

export interface OpenInterestPressureList {
  items: OpenInterestPressure[]
}

/**
 * §6 — one point per (timestamp, currency). Carries 5 ATM-IV tenors and
 * 2 realized-vol windows side-by-side, plus index price and log return.
 * API drops tenor keys on currencies with no listed contract at that
 * tenor (e.g. SOL_USDC has no 6-month options → atm_180 absent).
 */
export interface ImpliedVsRealizedPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  indexPrice?: string | undefined
  lnReturn?: string | undefined
  atm7?: string | undefined
  atm30?: string | undefined
  atm60?: string | undefined
  atm90?: string | undefined
  atm180?: string | undefined
  realizedVolatility7?: string | undefined
  realizedVolatility30?: string | undefined
}

export interface ImpliedVsRealizedList {
  items: ImpliedVsRealizedPoint[]
}

/**
 * Aggregate dealer gamma normalized to USD, inferred from the taker tape,
 * ScalarSeries: one row per snapshot. `normalized_gamma_usd` is the dollar gamma;
 * `normalized_gamma_native` is the same in coin units.
 */
export interface UsdGammaPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  normalizedGammaNative?: string | undefined
  normalizedGammaUsd?: string | undefined
  /**
   * The book's spot at this observation, for a price overlay. Optional because a
   * row may have no spot: the venue publishes none (GLBX, OPRA), or the row
   * predates the producer that stamps it. Hide the overlay where it is missing
   * — do not infer the venue's capabilities from it.
   */
  bookIndexPrice?: string | undefined
}

export interface UsdGammaList {
  items: UsdGammaPoint[]
}

/**
 * Per-instrument dealer gamma exposure inferred from the taker tape,
 * PerExpirySurface: one row per option instrument in the latest snapshot.
 * Snapshot-only, so history accrues from the live series.
 */
export interface GexPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  /**
   * Venue symbol, e.g. BTC-1JUL26-54000-P — the id the option chain and the
   * trades tape key on. Rows before the cutover carry the vendor's normalized
   * form (DERIBIT-BTC-01JUL26-54000.0-P), so a range spanning it returns both.
   */
  instrument: string
  /** "C" / "P" */
  putCall: string
  strike?: string | undefined
  dealerNetInventory?: string | undefined
  /**
   * The vendor's "total" came from dealer positioning we do not receive; our
   * inference has exactly one figure, the net. Left unset rather than repeated
   * from field 8. Rows before the cutover keep the vendor's values.
   *
   * @deprecated
   */
  dealerTotalInventory?: string | undefined
  gammaLevel?: string | undefined
  /**
   * This expiry's own forward — the price `gamma_level` was measured at, and
   * the one `GetGexAggregate` squares it by. It varies row to row, so folding
   * it across a snapshot lands on the longest-dated expiry. Rows before the
   * cutover carry a book-level index here instead.
   */
  indexPrice?: string | undefined
  /**
   * The book's spot, identical on every row of a snapshot: the one reference
   * line to draw, now that field 11 varies per expiry. Absent on GLBX and OPRA,
   * which have no index series of their own.
   */
  bookIndexPrice?: string | undefined
}

export interface GexList {
  items: GexPoint[]
}

/**
 * Realized-volatility cones of the underlying SPOT (keyed on a spot
 * exchange/pair). One row per rolling window; snapshot-stamped
 * at observation time. All vols are percent.
 */
export interface VolConePoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  /** 1, 7, 14, 30, 90, 180 */
  windowDays: string
  current?: string | undefined
  min?: string | undefined
  max?: string | undefined
  p25?: string | undefined
  p50?: string | undefined
  p75?: string | undefined
  /**
   * Rolling observations behind the distribution, so a cone built from eight
   * windows is distinguishable from one built from eight hundred. A window with
   * a gap emits nothing, so a broken index series shows up here as a count well
   * below the hours in the range. Absent on rows before the cutover.
   */
  observations?: string | undefined
}

export interface VolConeList {
  items: VolConePoint[]
}

export interface SviPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  /**
   * Fractional DAYS, while the `T` in `sqrt(w(k) / T)` above is in years —
   * divide by 365. Not optional: the parameters cannot be turned back into a
   * vol without the tenor, so a row that lost it would look complete and be
   * unusable.
   */
  daysToExpiration: string
  /**
   * The forward the fit was measured against. Without it the parameters cannot
   * be turned back into a vol, since k is log-moneyness against this.
   */
  forward?: string | undefined
  sviA?: string | undefined
  sviB?: string | undefined
  sviRho?: string | undefined
  sviM?: string | undefined
  sviSigma?: string | undefined
  /** RMSE of the fit against the quotes it used, in vol points (vol × 100). */
  fitRmseVolpts?: string | undefined
  /** Quotes the fit used, after filtering and outlier removal. */
  quoteCount?: number | undefined
  /** Largest absolute fit error over those quotes, in vol points. */
  maxAbsErrVolpts?: string | undefined
  /**
   * When these parameters were fitted. Says the fit loop is alive, NOT that
   * the surface is current: a last-good fit is republished unchanged while
   * its inputs age. Read inputs_newest_ts_ms for that.
   */
  fittedAtMs?: string | undefined
  /**
   * "svi_raw", or "ssvi" for a thin expiry fitted as a slice of the SSVI
   * surface through the full expiries.
   */
  model?: string | undefined
  /**
   * true when American option mids were converted to European (BAW on the
   * future) before the fit; a consumer pricing European options reads the
   * parameters as-is.
   */
  deAmericanized?: boolean | undefined
  /**
   * Data-clock time of the newest and oldest input the fit used: per quote,
   * the earlier of its last BBO change and its forward's (a quote is only as
   * current as the older of the two prices it is priced against). Surface age is
   * now − inputs_newest_ts_ms, and a refit of old inputs does not reset it.
   */
  inputsNewestTsMs?: string | undefined
  inputsOldestTsMs?: string | undefined
  sourceKind?: SviSourceKind | undefined
  /**
   * marks fits only: the realized vol (vol points) the marks guard anchored
   * on; absent for book and analytics fits.
   */
  rvGuardVolpts?: string | undefined
  /**
   * The chain's own index at fit time (Deribit `index_price`, Bybit
   * `indexPrice`, Derive `I`, GLBX the front-month future). Persisted into
   * svi_params.index_price; the realized-vol family is computed from it.
   */
  indexPrice?: string | undefined
}

export interface SviList {
  items: SviPoint[]
  /**
   * The exchange calendar the fit's variance clock used
   * (vol_fit.calendar_overrides can point a crypto chain at EXCHANGE_GLBX).
   */
  calendar?: Exchange | undefined
}

/**
 * Realized-volatility seasonality of the underlying SPOT.
 * `bucket` is the weekday (MON..SUN) or month (JAN..DEC); shared shape for both.
 */
export interface RvSeasonalityPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  bucket: string
  historicalVolatility?: string | undefined
}

export interface RvSeasonalityList {
  items: RvSeasonalityPoint[]
}

/**
 * Average return per calendar bucket, computed on read from the chart MVs.
 * Every bucket of the fixed set is emitted — 7 weekdays, 24 hours or 3 session
 * blocks — so a gap in the data is a `samples: 0` row rather than a missing one.
 */
export interface BucketedReturnPoint {
  exchange: Exchange
  symbol: string
  /**
   * Venue-local trade date for MON..SUN and APAC|EU|US, but plain UTC for the
   * hour axis — the three charts are not on one clock, and converting the hour
   * labels to match its neighbours shifts that chart by the venue's offset.
   */
  bucket: string
  /** absent when the bucket has no data, or */
  avgReturnPct?: string | undefined
  /**
   * when the value will not round-trip
   * through a 96-bit decimal
   */
  samples: string
}

export interface BucketedReturnList {
  items: BucketedReturnPoint[]
  /**
   * Actual span behind the rows; narrower than the request when the window
   * predates the instrument or the source tier's retention.
   */
  coveredFromMs?: string | undefined
  coveredToMs?: string | undefined
  /**
   * How each bar's return was computed. Not derivable downstream: knowing the
   * venue's hours does not say whether a bar spans close-to-close or only the
   * hours it traded, and the gap is material (-0.131 pp/day on IBIT).
   */
  basis: ReturnBasis
}

/**
 * One line per session block: what holding only that block would have compounded
 * to over the window. `limit` counts rows across all three curves rather than
 * points per curve, and is kept from the newest end — so a clipped response
 * starts mid-curve rather than at zero.
 */
export interface SessionCumulativeReturnPoint {
  /**
   * Start of the block's trade date on the venue's grid, not of the block. The
   * day's three buckets tile it in sequence, so stamping block starts would put
   * the three curves 8h apart; stamping the trade date lands them on one x.
   *
   * So this is NOT unique in the list: key on (timestamp_ms, bucket). A trade
   * date carries *up to* three points — a block with no trades emits no row —
   * so positional chunking into triples plots one curve's values on another.
   *
   * Its UTC calendar date is also not the trade date's name: on GLBX the day
   * opens 17:00 America/Chicago, so 2026-09-02 is stamped 2026-09-01T22:00Z.
   * Label from the venue's rollover, not from this instant's UTC date.
   */
  timestampMs: string
  exchange: Exchange
  symbol: string
  bucket: string
  /**
   * Same absence rule as `BucketedReturnPoint.avg_return_pct`. One block whose
   * compounded value overflows takes every later point on that curve with it.
   */
  cumulativeReturnPct?: string | undefined
}

export interface SessionCumulativeReturnList {
  items: SessionCumulativeReturnPoint[]
  /**
   * Span of the emitted points, not of the source, unlike the identically-named
   * fields on `BucketedReturnList`: `limit` drops the oldest blocks first, so a
   * clipped response narrows `covered_from_ms` along with the curve.
   */
  coveredFromMs?: string | undefined
  coveredToMs?: string | undefined
}

/**
 * Open-interest-weighted option greeks aggregated per expiry,
 * split call/put/net. Computed on read from `derivative_metrics` OI + the
 * instrument cache's mark IV (Deribit mark_iv, a fraction); crypto r/q≈0.
 * Sign conventions match the positions hub: theta per-day, vega/rho per 1%.
 */
export interface GetGreeksByExpiryRequest {
  exchange: Exchange
  underlying: string
}

export interface GreeksByExpiryPoint {
  expiryMs: string
  callDelta: string
  putDelta: string
  netDelta: string
  callGamma: string
  putGamma: string
  netGamma: string
  callVega: string
  putVega: string
  netVega: string
  callTheta: string
  putTheta: string
  netTheta: string
  callRho: string
  putRho: string
  netRho: string
}

export interface GreeksByExpiry {
  exchange: Exchange
  underlying: string
  points: GreeksByExpiryPoint[]
}

/**
 * Dealer gamma from the latest `gex` snapshot, rolled up four ways for the
 * gamma-profile charts. Every `gamma_usd` is USD notional of the underlying
 * dealers must trade to re-hedge a 1% spot move (dealer gamma x spot x 1%),
 * the same convention as the positions hub's per-position `gamma_usd`.
 */
export interface GetGexAggregateRequest {
  exchange: Exchange
  currency: string
}

/** Gamma per strike, summed across expirations. */
export interface GexByStrikePoint {
  strike?: string | undefined
  gammaUsd?: string | undefined
}

/** Gamma per strike within one expiration. */
export interface GexByExpiryStrikePoint {
  expirationTsMs: string
  strike?: string | undefined
  gammaUsd?: string | undefined
}

export interface GexByExpiryTypePoint {
  expirationTsMs: string
  /** "C" / "P" */
  putCall: string
  gammaUsd?: string | undefined
}

/**
 * Gamma hedging flow an expiration would produce on a 1% move, split by
 * direction: `upside` are the strikes a rally moves toward, `downside` those a
 * selloff moves toward. Each contract is classified against its own index
 * price, so the two together equal that expiration's total. Sign carries the
 * volatility read — positive dampens the move, negative amplifies it.
 */
export interface GexSpotVolPoint {
  expirationTsMs: string
  upsideGammaUsd?: string | undefined
  downsideGammaUsd?: string | undefined
}

/**
 * `timestamp_ms` is the snapshot these roll-ups came from and doubles as the
 * staleness check (the feed is hourly). It is ABSENT, not 0, when no snapshot
 * qualifies — 0 would be the epoch, i.e. a 56-year-old snapshot to that check.
 * `index_price` is a display reference only; it is not what the upside/downside
 * split compares against.
 */
export interface GexAggregate {
  exchange: Exchange
  currency: string
  timestampMs?: string | undefined
  /**
   * The book's spot — `GexPoint.book_index_price` taken, not a reduction over
   * the groups. Absent on GLBX and OPRA; the gamma series stay exact there.
   */
  indexPrice?: string | undefined
  byStrike: GexByStrikePoint[]
  byExpiryStrike: GexByExpiryStrikePoint[]
  byExpiryType: GexByExpiryTypePoint[]
  spotVol: GexSpotVolPoint[]
}

/**
 * §7 — term structure on constant-DTE buckets. One row per (timestamp,
 * currency, days_to_expiration). days_to_expiration is integer here
 * (1, 2, 3, 7, 14, 21, 30, 60, 90, 180); the API returns a fixed grid.
 * `fwd_atm` is null on the shortest tenor (insufficient samples).
 */
export interface TermStructureConstantPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  daysToExpiration: number
  atm?: string | undefined
  fwdAtm?: string | undefined
}

export interface TermStructureConstantList {
  items: TermStructureConstantPoint[]
}

/**
 * §8 — term structure on floating expiry. One row per (timestamp,
 * currency, expiration). `days_to_expiration` is fractional (kept as
 * string Decimal) and `expiration_ts_ms` is parsed from the API's
 * ISO8601 `expirationTimestamp` field.
 */
export interface TermStructureFloatingPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  expirationTsMs: string
  daysToExpiration: string
  atm?: string | undefined
  fwdAtm?: string | undefined
}

export interface TermStructureFloatingList {
  items: TermStructureFloatingPoint[]
}

/**
 * §9 — one point per (timestamp, currency). Carries the 5 ATM-IV tenors
 * used to compute the richness ratio plus the counter / ratio / richness
 * scalars. Source field names use lowercase `atmNNdays` — preserved here.
 */
export interface TermStructureRichnessPoint {
  timestampMs: string
  exchange: Exchange
  currency: string
  atm7days?: string | undefined
  atm30days?: string | undefined
  atm60days?: string | undefined
  atm90days?: string | undefined
  atm180days?: string | undefined
  /**
   * `counter` is integer in the API (number of tenor data points
   * available); kept as int32 since it never carries fractional values.
   */
  counter: number
  ratio?: string | undefined
  richness?: string | undefined
  /**
   * The book's spot at this observation, for a price overlay. Optional because a
   * row may have no spot: the venue publishes none (GLBX, OPRA), or the row
   * predates the producer that stamps it. Hide the overlay where it is missing
   * — do not infer the venue's capabilities from it.
   */
  bookIndexPrice?: string | undefined
}

export interface TermStructureRichnessList {
  items: TermStructureRichnessPoint[]
}

/**
 * Every `(exchange, currency)` the delta surfaces have carried recently — i.e.
 * the books that actually have an options surface to chart, which is not
 * derivable from the instrument catalog: the surface tables key on a vendor
 * namespace (`BTC_USDC`, `SOL_USDC`) rather than on a canonical group or a base
 * currency.
 *
 * Serves the instrument pickers that must offer only assets with options. No
 * request fields: the whole set is a few dozen rows, so one call beats a
 * per-exchange fan-out, and the client groups by `exchange` itself.
 */
export interface GetSurfaceCurrenciesRequest {}

/**
 * D28: the live reference surfaces — every (exchange, chain, source_kind)
 * with an svi_params row fitted within the last hour. Market-wide; cached.
 */
export interface ListVolFitReferencesRequest {}

export interface VolFitReference {
  exchange: Exchange
  chain: string
  sourceKind: SviSourceKind
  newestFitTsMs: string
  expirationTsMs: string[]
}

export interface VolFitReferenceList {
  items: VolFitReference[]
}

export interface SurfaceCurrency {
  exchange: Exchange
  /**
   * The surface tables' own name for the book. Pass it back verbatim as the
   * `symbol` of an analytics request; anything re-derived will miss the books
   * whose vendor name is not their base currency.
   */
  currency: string
}

export interface SurfaceCurrencyList {
  items: SurfaceCurrency[]
}

/**
 * §10 — DVOL OHLC. One row per timestamp; OHLC over the configured
 * timeframe (default 60 seconds = minute). The API returns
 * `instrument = "DERIBIT_<CCY>_DVOL_INDEX"` which is derivable from
 * `currency` + the static "DVOL" index name; not carried in the proto.
 */
export interface VolatilityIndexPoint {
  /** = exchangeTimestamp from API */
  timestampMs: string
  exchange: Exchange
  currency: string
  /** 60 = 1m, 3600 = 1h, 86400 = 1d */
  timeframeSeconds: number
  open?: string | undefined
  high?: string | undefined
  low?: string | undefined
  close?: string | undefined
}

export interface VolatilityIndexList {
  items: VolatilityIndexPoint[]
}

export interface DataPayloadList {
  items: DataPayload[]
}

export interface UnifiedOrderList {
  items: UnifiedOrderItem[]
}

export interface UnifiedOrderItem {
  order?: Order | undefined
  algoState?: AlgoState | undefined
}

export interface CandleList {
  ticks: string[]
  open: number[]
  high: number[]
  low: number[]
  close: number[]
  /** Volume */
  volumeBase: number[]
  volumeQuote: number[]
  /** volume_quote / volume_base */
  vwap: number[]
  /** twap_price_avg from MV */
  twap: number[]
  /** Trade Pressure (CVD) */
  buyVolumeBase: number[]
  sellVolumeBase: number[]
  /** (buy - sell) */
  netBuyVolumeBase: number[]
  /** Trade Counts */
  totalTradeCount: string[]
  buyTradeCount: string[]
  sellTradeCount: string[]
  netBuyTradeCount: string[]
  /** Size Analytics */
  avgTradeSize: number[]
  /** Liquidations */
  totalLiqBase: number[]
  totalLiqQuote: number[]
  /** total_liq_quote / total_liq_base */
  liqwap: number[]
  totalLiqCount: string[]
  /** Liquidation Breakdown */
  buyLiqBase: number[]
  /** Longs liquidating */
  sellLiqBase: number[]
  liqTakerVolume: number[]
  liqMakerVolume: number[]
  /** Volatility */
  realizedVolatility: number[]
  /** Advanced Quant Analytics */
  avgBuyTradeSize: number[]
  avgSellTradeSize: number[]
  /** net_buy_vol / vol */
  deltaPercentage: number[]
  /** Quote CVD */
  netBuyVolumeQuote: number[]
  /** vwap - twap */
  vwapTwapSpread: number[]
  /** buy_liq - sell_liq */
  netLiquidations: number[]
  /** Block-trade-included analytics */
  volumeBaseBlockIncl: number[]
  volumeQuoteBlockIncl: number[]
  buyVolumeBaseBlockIncl: number[]
  sellVolumeBaseBlockIncl: number[]
  netBuyVolumeBaseBlockIncl: number[]
  netBuyVolumeQuoteBlockIncl: number[]
  openInterestBaseOpen: number[]
  openInterestBaseHigh: number[]
  openInterestBaseLow: number[]
  openInterestBaseClose: number[]
  openInterestQuoteOpen: number[]
  openInterestQuoteHigh: number[]
  openInterestQuoteLow: number[]
  openInterestQuoteClose: number[]
  fundingRateOpen: number[]
  fundingRateHigh: number[]
  fundingRateLow: number[]
  fundingRateClose: number[]
  fundingAprOpen: number[]
  fundingAprHigh: number[]
  fundingAprLow: number[]
  fundingAprClose: number[]
}

export interface Subscribed {
  channels: MessageSubject[]
}

export interface Unsubscribed {
  channels: MessageSubject[]
}

export interface Ping {
  timestamp: string
}

export interface Pong {
  timestamp: string
}

export interface AuthenticateRequest {
  token: string
}

export interface AuthenticateResponse {
  success: boolean
  userId: string
  errorMessage: string
}

export interface Error {
  message: string
}

export interface Success {
  message: string
}

export interface ServerMessage {
  subscribed?: Subscribed | undefined
  unsubscribed?: Unsubscribed | undefined
  ping?: Ping | undefined
  pong?: Pong | undefined
  /** Add more as needed, e.g. error, notification, etc. */
  data?: DataPayload | undefined
  error?: Error | undefined
  success?: Success | undefined
  authenticateResponse?: AuthenticateResponse | undefined
  /** Authentication responses */
  loginResponse?: LoginResponse | undefined
  signupResponse?: SignupResponse | undefined
  userAccountsResponse?: PublicAccountList | undefined
  requestPasswordResetResponse?: RequestPasswordResetResponse | undefined
  confirmPasswordResetResponse?: ConfirmPasswordResetResponse | undefined
  refreshTokenResponse?: RefreshTokenResponse | undefined
  verifyEmailResponse?: VerifyEmailResponse | undefined
  resendVerificationResponse?: ResendVerificationResponse | undefined
  /** 2FA responses */
  setup2faResponse?: Setup2faResponse | undefined
  confirm2faSetupResponse?: Confirm2faSetupResponse | undefined
  verify2faResponse?: Verify2faResponse | undefined
  verify2faLoginResponse?: Verify2faLoginResponse | undefined
  disable2faResponse?: Disable2faResponse | undefined
  get2faBackupCodesResponse?: Get2faBackupCodesResponse | undefined
  /** Passkey responses */
  setupPasskeyResponse?: SetupPasskeyResponse | undefined
  confirmPasskeySetupResponse?: ConfirmPasskeySetupResponse | undefined
  passkeyLoginResponse?: PasskeyLoginResponse | undefined
  confirmPasskeyLoginResponse?: ConfirmPasskeyLoginResponse | undefined
  deletePasskeyResponse?: DeletePasskeyResponse | undefined
  getUserPasskeysResponse?: GetUserPasskeysResponse | undefined
  /** Google OAuth response */
  googleLoginResponse?: GoogleLoginResponse | undefined
  verifyResponse?: VerifyTokenResponse | undefined
  /** Chart API responses */
  timeResponse?: TimeResponse | undefined
  createAccountResponse?: CreateAccountResponse | undefined
  compressedPayload?: CompressedPayload | undefined
  executionPlan?: DraftExecutionPlan | undefined
  getPagesResponse?: GetPagesResponse | undefined
  getPageLayoutResponse?: GetPageLayoutResponse | undefined
  pageMutationResponse?: PageMutationResponse | undefined
  componentPreferenceResponse?: ComponentPreferenceResponse | undefined
  positionGroupMutationResponse?: PositionGroupMutationResponse | undefined
  getPositionGroupsResponse?: GetPositionGroupsResponse | undefined
  getPositionsViewResponse?: GetPositionsViewResponse | undefined
  /** Order presets — see migrations/0009_order_presets.md */
  createPresetResponse?: CreatePresetResponse | undefined
  updatePresetResponse?: UpdatePresetResponse | undefined
  deletePresetResponse?: DeletePresetResponse | undefined
  listPresetsResponse?: ListPresetsResponse | undefined
  executePresetResponse?: ExecutePresetResponse | undefined
  getPresetResponse?: GetPresetResponse | undefined
  /** Personal watchlists */
  watchlistMutationResponse?: WatchlistMutationResponse | undefined
  getWatchlistsResponse?: GetWatchlistsResponse | undefined
  confirmExecutionPlanResponse?: ConfirmExecutionPlanResponse | undefined
  createRfqResponse?: CreateRfqResponse | undefined
  cancelRfqResponse?: CancelRfqResponse | undefined
  acceptRfqQuoteResponse?: AcceptRfqQuoteResponse | undefined
  getRfqMakersResponse?: GetRfqMakersResponse | undefined
  getRfqHistoryResponse?: GetRfqHistoryResponse | undefined
  /** Bybit OAuth broker onboarding */
  bybitOauthMintStateResponse?: BybitOauthMintStateResponse | undefined
  /** Deribit OAuth (Registered Partner Model) */
  deribitOauthMintStateResponse?: DeribitOauthMintStateResponse | undefined
  /** Hyperliquid agent-wallet onboarding (confirm uses the shared Success/Error) */
  hyperliquidPrepareAgentResponse?: HyperliquidPrepareAgentResponse | undefined
  /** Derive session-key onboarding (confirm/disconnect use the shared Success/Error) */
  derivePrepareSessionKeyResponse?: DerivePrepareSessionKeyResponse | undefined
  deriveListSubaccountsResponse?: DeriveListSubaccountsResponse | undefined
  deriveLinkSubaccountsResponse?: DeriveLinkSubaccountsResponse | undefined
  hyperliquidListSubaccountsResponse?: HyperliquidListSubaccountsResponse | undefined
  hyperliquidLinkSubaccountsResponse?: HyperliquidLinkSubaccountsResponse | undefined
  /** Lighter (lighter.xyz) sub-account onboarding */
  lighterListSubaccountsResponse?: LighterListSubaccountsResponse | undefined
  lighterPrepareSubaccountKeyResponse?: LighterPrepareSubaccountKeyResponse | undefined
  lighterConfirmSubaccountKeyResponse?: LighterConfirmSubaccountKeyResponse | undefined
  lighterLinkSubaccountsResponse?: LighterLinkSubaccountsResponse | undefined
  lighterPrepareIntegratorConsentResponse?: LighterPrepareIntegratorConsentResponse | undefined
  lighterConfirmIntegratorConsentResponse?: LighterConfirmIntegratorConsentResponse | undefined
  /** Stripe billing */
  createCheckoutSessionResponse?: CreateCheckoutSessionResponse | undefined
  getSubscriptionResponse?: GetSubscriptionResponse | undefined
  openBillingPortalResponse?: OpenBillingPortalResponse | undefined
  getPlansResponse?: GetPlansResponse | undefined
  /** Account access sharing */
  listAccountAccessResponse?: ListAccountAccessResponse | undefined
  listMyInvitesResponse?: ListMyInvitesResponse | undefined
  orderPreviewResponse?: OrderPreviewResponse | undefined
  /** Session security & device tracking */
  changePasswordResponse?: ChangePasswordResponse | undefined
  listSessionsResponse?: ListSessionsResponse | undefined
  revokeSessionResponse?: RevokeSessionResponse | undefined
  logoutResponse?: LogoutResponse | undefined
  revokeAllOtherSessionsResponse?: RevokeAllOtherSessionsResponse | undefined
  sendStepUpCodeResponse?: SendStepUpCodeResponse | undefined
  batchOrderPreviewResponse?: BatchOrderPreviewResponse | undefined
  /** Messaging-bot linking */
  mintMessagingLinkNonceResponse?: MintMessagingLinkNonceResponse | undefined
  /** Paradigm account binding wizard. Starts at 86: 85 is `reserved` below. */
  paradigmConnectDeskResponse?: ParadigmConnectDeskResponse | undefined
  paradigmListAccountsResponse?: ParadigmListAccountsResponse | undefined
  paradigmLinkAccountResponse?: ParadigmLinkAccountResponse | undefined
  /** Shareable layouts */
  createSharedLayoutResponse?: CreateSharedLayoutResponse | undefined
  getSharedLayoutResponse?: GetSharedLayoutResponse | undefined
  createApiKeyResponse?: CreateApiKeyResponse | undefined
  listApiKeysResponse?: ListApiKeysResponse | undefined
  revokeApiKeyResponse?: RevokeApiKeyResponse | undefined
  getApiBillingResponse?: GetApiBillingResponse | undefined
  updateApiBillingSettingsResponse?: UpdateApiBillingSettingsResponse | undefined
  createCreditCheckoutSessionResponse?: CreateCreditCheckoutSessionResponse | undefined
  listCreditLedgerResponse?: ListCreditLedgerResponse | undefined
  getCreditSpendStatsResponse?: GetCreditSpendStatsResponse | undefined
  sendRfqMakerQuoteResponse?: SendRfqMakerQuoteResponse | undefined
  cancelRfqMakerQuoteResponse?: CancelRfqMakerQuoteResponse | undefined
  setLeverageResponse?: SetLeverageResponse | undefined
  papertradePrepareSessionKeyResponse?: PapertradePrepareSessionKeyResponse | undefined
  accountSettings?: AccountSettings | undefined
}

export interface DraftExecutionPlan {
  accountId: string
  /**
   * Immediate-fire actions. Trigger-bound actions go in `triggered_items`
   * and never appear here.
   */
  executionBatch: ExecutionBatch | undefined
  warnings: ExecutionWarning[]
  /** One entry per input whose `trigger` was populated. */
  triggeredItems: TriggeredItem[]
  /** One entry per input the compiler refused, with structured reason. */
  refusals: Refusal[]
}

export interface ConfirmExecutionPlanRequest {
  executionPlan: DraftExecutionPlan | undefined
}

export interface ConfirmExecutionPlanResponse {
  success: boolean
  message: string
  immediateCommandCount: number
  triggerCount: number
  error?: string | undefined
}

/**
 * Invariant: `account_id` MUST equal the parent plan's `account_id` and the
 * `account_id` on every entry in `fire_payload`. Mismatches are a refusal.
 * The trigger is intentionally embedded here: draft generation does not
 * register alerts, so the confirmation path needs the full condition to start
 * triggered execution later.
 */
export interface TriggeredItem {
  accountId: string
  firePayload: ExecutionBatch | undefined
  trigger: Trigger | undefined
}

/**
 * Structured refusal — the compiler chose not to materialize an input
 * Action / AlgoSubscription / Management entry.
 */
export interface Refusal {
  reason: RefusalReason
  /** Human-readable explanation, safe to surface verbatim to the user. */
  message?: string | undefined
  /**
   * Internal debugging context (e.g. the offending option symbol). Never
   * surface verbatim to the user.
   */
  offendingValue?: string | undefined
  /**
   * Zero-based index within the originating track. Required for stable UI
   * mapping.
   */
  itemIndex?: number | undefined
  track: IntentItemTrack
  stage: IntentPipelineStage
  suggestedAlternative?: string | undefined
}

export interface VolSurfaceGenerationResult {
  success?: GenerateVolSurfaceResponse | undefined
  error?: Error | undefined
}

export interface RiskSimulationResult {
  success?: RiskSimulationResponse | undefined
  error?: Error | undefined
}

export interface OrderPreviewRequest {
  accountId: string
  symbol: string
  side: OrderSide
  /** Decimal as string */
  quantity: string
  orderType: OrderType
  /** required for limit; market uses live mark server-side */
  price?: string | undefined
  denomination: Denomination
}

export interface OrderPreviewResponse {
  orderValueBase: string
  orderValueQuote: string
  /** incremental margin for *this* order; absent only if truly uncomputable */
  marginRequired?: string | undefined
  /** Σ existing Position.initial_margin_usd — already known today */
  marginUsedCurrent: string
  marginUsedAfter?: string | undefined
  maxSize?: string | undefined
  grossLeverageCurrent: string
  grossLeverageAfter: string
  netLeverageCurrent: string
  netLeverageAfter: string
  feeBase?: string | undefined
  feeQuote?: string | undefined
  /** true whenever the margin figure isn't the venue's own precise math */
  approximate: boolean
  warningCode?: WarningCode | undefined
  timestamp: string
  /**
   * USD-normalized order value: quantity × price/premium converted through
   * the instrument's quote-currency USD rate (1.0 for USD-like, the
   * instrument's own underlying/index price for a coin-margined premium,
   * the KRW CME rate for Upbit). Absent when no USD rate resolves (unknown
   * quote currency, or a cold KRW price cache) — never defaulted to 0.
   */
  totalValueUsd?: string | undefined
  /** (margin_equity_usd − margin_used_current).max(0). */
  marginAvailableCurrent?: string | undefined
  /** (margin_equity_usd − margin_used_after).max(0). */
  marginAvailableAfter?: string | undefined
  /**
   * (margin_used_after − margin_used_current) / margin_equity_usd × 100.
   * Absent when margin_equity_usd <= 0 or the instrument has no margin
   * concept (e.g. Upbit spot).
   */
  marginImpactPct?: string | undefined
  /**
   * fee_quote converted through the same USD rate as total_value_usd.
   * Absent under the same conditions as total_value_usd.
   */
  feeUsd?: string | undefined
  /**
   * Margin utilisation LEVELS, mirroring MarginPoolPreview's fields of the
   * same name: margin_used_current / margin_equity_usd x 100 and
   * margin_used_after / margin_equity_usd x 100. Absent under the same
   * condition as margin_impact_pct.
   */
  marginUsedPctCurrent?: string | undefined
  marginUsedPctAfter?: string | undefined
  /**
   * Estimated liquidation price, decimal string in the instrument's quote
   * currency. _current is for the existing position, _after for the position
   * if this order fills (same current/after pairing as margin_used_*).
   * Venue's own figure where it publishes one (Deribit
   * estimated_liquidation_price, Hyperliquid liquidationPx, Bybit liqPrice);
   * otherwise computed from maintenance margin, with `approximate` set.
   * Absent - never 0 - when there is no liquidation concept (spot, fully
   * collateralised, no position) or the venue's maintenance-margin tier
   * can't be resolved. Batch rows carry these too, via RowPreviewResult.ok.
   */
  estimatedLiquidationPriceCurrent?: string | undefined
  estimatedLiquidationPriceAfter?: string | undefined
}

export interface RowPreviewError {
  message: string
  /**
   * Currently always absent in every emitted RowPreviewError — reserved for
   * future per-row warning classification (e.g. below-min-notional). Do not
   * build client logic that expects this to be populated yet.
   */
  code?: WarningCode | undefined
}

export interface RowPreviewResult {
  ok?: OrderPreviewResponse | undefined
  error?: RowPreviewError | undefined
}

export interface MarginPoolPreview {
  /**
   * Venue-specific margin-pool identifier (e.g. Hyperliquid's per-dex key:
   * "main" for the main clearinghouse, or the HIP-3 builder-dex name). For
   * venues with a single, undifferentiated margin pool (Deribit, Bybit,
   * Upbit), this is a fixed sentinel naming that pool — see
   * order_preview_shared.rs's dex_key() for the exact value each venue maps
   * to.
   */
  dexKey: string
  /**
   * Combined by sequentially applying each contributing row's (post-netting)
   * margin impact against this pool's evolving margin-used figure — NOT a
   * naive sum of each row's independently-computed margin_required — so
   * tiered/bracket margin models track more faithfully than summation would.
   * See compute_pool_preview in shared/order-preview/src/combined.rs.
   */
  marginRequired?: string | undefined
  marginAvailableCurrent?: string | undefined
  marginAvailableAfter?: string | undefined
  marginImpactPct?: string | undefined
  /**
   * Always true when 2+ rows contribute to this pool — combined margin is a
   * heuristic composition, never venue-exact. May also be true for a single
   * contributing row if that row's own margin estimate was approximate.
   */
  approximate: boolean
  warningCode?: WarningCode | undefined
  /**
   * Margin utilisation LEVELS, so a client can render "5% -> 80%" rather than
   * only the delta margin_impact_pct carries: margin_used_current /
   * margin_equity_usd x 100, and margin_used_after / margin_equity_usd x 100.
   * Not derivable client-side from the fields above — margin_available_* are
   * both .max(0)-clamped, and margin_impact_pct is 0 for a margin-neutral
   * order, so solving back for equity divides by zero. Absent under the same
   * condition as margin_impact_pct (margin_equity_usd <= 0).
   */
  marginUsedPctCurrent?: string | undefined
  marginUsedPctAfter?: string | undefined
}

export interface AccountGroupPreview {
  /**
   * Part of this group's identity alongside account_id, not just descriptive
   * metadata — account_id is not guaranteed globally unique across
   * exchanges, so BatchOrderPreviewResponse.groups must be correlated back
   * to request rows by matching BOTH exchange and account_id together, never
   * account_id alone.
   */
  exchange: Exchange
  accountId: string
  /** one entry per distinct margin pool present among this group's rows */
  pools: MarginPoolPreview[]
  /** sum across every row in the group, regardless of pool */
  totalValueUsd?: string | undefined
  /** sum across every row in the group, regardless of pool */
  feeUsd?: string | undefined
  /**
   * Whole-account combined leverage across every row in this group — exact,
   * not a heuristic (mathematically equivalent to recomputing gross/net
   * notional from scratch against every row's net delta), and never a copy
   * of any single row's own per-row leverage. See combine_leverage_after in
   * shared/order-preview/src/combined.rs.
   */
  grossLeverageCurrent: string
  grossLeverageAfter: string
  netLeverageCurrent: string
  netLeverageAfter: string
  /**
   * True if any row in this group errored (RowPreviewResult.error), OR if a
   * row succeeded but its own total_value_usd couldn't resolve a USD rate
   * (design spec §4.2 scopes the incompleteness signal to that sum
   * specifically). Does NOT cover a row's fee_usd failing to resolve — the
   * fee row already carries its own "≈" display convention rather than a
   * backend incomplete flag. In both covered cases, the combined subtotals
   * above exclude the affected row rather than silently under-reporting, so
   * the frontend must render them as unavailable, not as a complete number.
   */
  incomplete: boolean
}

export interface BatchOrderPreviewRequest {
  /** capped at 20 — see order_preview_batch.rs validation */
  orders: OrderPreviewRequest[]
}

export interface BatchOrderPreviewResponse {
  /**
   * Exactly one entry per request row, in the same order — index
   * correspondence is a hard invariant so the frontend can zip rows back to
   * their inputs.
   */
  rows: RowPreviewResult[]
  /**
   * One entry per distinct (exchange, account_id) pair present among the
   * request's rows — correlate back to a request row by matching its
   * resolved account's exchange AND account_id together (see
   * AccountGroupPreview's own comment), never account_id alone. A row that
   * errored during account resolution still produces a group (marked
   * incomplete) rather than being omitted.
   */
  groups: AccountGroupPreview[]
  timestamp: string
}

export interface ExecutionWarning {
  severity: WarningSeverity
  warningCode: WarningCode
  /** Context for the frontend */
  notionalUsdValue: string
  recommendation: RecommendedAction
  relatedSymbol: string
}

export interface CompressedPayload {
  /** Gzip compressed data */
  data: Uint8Array
  method: CompressedPayload_CompressionMethod
  payloadType: CompressedPayload_PayloadType
}

export enum CompressedPayload_CompressionMethod {
  COMPRESSION_METHOD_UNSPECIFIED = 0,
  COMPRESSION_METHOD_GZIP = 1,
  UNRECOGNIZED = -1,
}

export function compressedPayload_CompressionMethodFromJSON(
  object: any
): CompressedPayload_CompressionMethod {
  switch (object) {
    case 0:
    case 'COMPRESSION_METHOD_UNSPECIFIED':
      return CompressedPayload_CompressionMethod.COMPRESSION_METHOD_UNSPECIFIED
    case 1:
    case 'COMPRESSION_METHOD_GZIP':
      return CompressedPayload_CompressionMethod.COMPRESSION_METHOD_GZIP
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CompressedPayload_CompressionMethod.UNRECOGNIZED
  }
}

export function compressedPayload_CompressionMethodToJSON(
  object: CompressedPayload_CompressionMethod
): string {
  switch (object) {
    case CompressedPayload_CompressionMethod.COMPRESSION_METHOD_UNSPECIFIED:
      return 'COMPRESSION_METHOD_UNSPECIFIED'
    case CompressedPayload_CompressionMethod.COMPRESSION_METHOD_GZIP:
      return 'COMPRESSION_METHOD_GZIP'
    case CompressedPayload_CompressionMethod.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum CompressedPayload_PayloadType {
  PAYLOAD_TYPE_UNSPECIFIED = 0,
  PAYLOAD_TYPE_INSTRUMENT_LIST = 1,
  PAYLOAD_TYPE_MASTER_INSTRUMENT_LIST = 2,
  UNRECOGNIZED = -1,
}

export function compressedPayload_PayloadTypeFromJSON(object: any): CompressedPayload_PayloadType {
  switch (object) {
    case 0:
    case 'PAYLOAD_TYPE_UNSPECIFIED':
      return CompressedPayload_PayloadType.PAYLOAD_TYPE_UNSPECIFIED
    case 1:
    case 'PAYLOAD_TYPE_INSTRUMENT_LIST':
      return CompressedPayload_PayloadType.PAYLOAD_TYPE_INSTRUMENT_LIST
    case 2:
    case 'PAYLOAD_TYPE_MASTER_INSTRUMENT_LIST':
      return CompressedPayload_PayloadType.PAYLOAD_TYPE_MASTER_INSTRUMENT_LIST
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CompressedPayload_PayloadType.UNRECOGNIZED
  }
}

export function compressedPayload_PayloadTypeToJSON(object: CompressedPayload_PayloadType): string {
  switch (object) {
    case CompressedPayload_PayloadType.PAYLOAD_TYPE_UNSPECIFIED:
      return 'PAYLOAD_TYPE_UNSPECIFIED'
    case CompressedPayload_PayloadType.PAYLOAD_TYPE_INSTRUMENT_LIST:
      return 'PAYLOAD_TYPE_INSTRUMENT_LIST'
    case CompressedPayload_PayloadType.PAYLOAD_TYPE_MASTER_INSTRUMENT_LIST:
      return 'PAYLOAD_TYPE_MASTER_INSTRUMENT_LIST'
    case CompressedPayload_PayloadType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface TimeResponse {
  /** Unix timestamp in milliseconds */
  serverTime: string
}

export interface Subscribe {
  channels: MessageSubject[]
}

export interface Unsubscribe {
  channels: MessageSubject[]
}

export interface DataRequest {
  requests: MessageSubject[]
}

/**
 * Sets this connection's StreamInterval. May be sent at any time, including
 * before authenticate; it lasts until the socket closes, so a client re-sends
 * it after every reconnect. No reply.
 */
export interface SetStreamInterval {
  interval: StreamInterval
}

export interface ClientMessage {
  /** Authentication (must be first message) */
  authenticate?: AuthenticateRequest | undefined
  /** Subscription management */
  subscribe?: Subscribe | undefined
  unsubscribe?: Unsubscribe | undefined
  ping?: Ping | undefined
  pong?: Pong | undefined
  /** One time Data Requests */
  apiRequest?: ApiRequest | undefined
  /** Market-data cadence for this connection */
  setStreamInterval?: SetStreamInterval | undefined
}

export interface CreateRfqRequest {
  accountId: string
  legs: RfqLeg[]
  hedge?: RfqHedgeLeg | undefined
  makerIds: string[]
  disclosed: boolean
  autoApprove?: AutoApprove | undefined
  autoRetry?: AutoRetry | undefined
  correlationId?: string | undefined
}

export interface CreateRfqResponse {
  rfqId?: string | undefined
  correlationId?: string | undefined
}

export interface CancelRfqRequest {
  accountId: string
  rfqId: string
  correlationId?: string | undefined
}

export interface CancelRfqResponse {
  accepted: boolean
}

/**
 * Maker quote on an incoming RFQ (RfqMakerRfq.rfq_id). Upsert keyed by
 * quote_id: absent = new quote, the server mints quote_id and returns it;
 * present = re-price that quote. Full size only, one quote per side per RFQ.
 */
export interface SendRfqMakerQuoteRequest {
  accountId: string
  rfqId: string
  side: RfqQuoteSide
  price: string
  /** Absent = new quote (server mints quote_id). Present = upsert that quote. */
  quoteId?: string | undefined
  correlationId?: string | undefined
}

/** Routed, not yet live: the quote's state arrives on the RFQ_MAKER stream. */
export interface SendRfqMakerQuoteResponse {
  quoteId: string
}

export interface CancelRfqMakerQuoteRequest {
  accountId: string
  quoteId: string
  correlationId?: string | undefined
  /** maker rfq id; routes the cancel exactly like Send */
  rfqId: string
}

export interface CancelRfqMakerQuoteResponse {
  accepted: boolean
}

export interface AcceptRfqQuoteRequest {
  accountId: string
  rfqId: string
  quoteId: string
  price: string
  correlationId?: string | undefined
}

export interface AcceptRfqQuoteResponse {
  accepted: boolean
}

export interface GetRfqMakersRequest {
  accountId: string
}

export interface GetRfqMakersResponse {
  makerIds: string[]
}

export interface GetRfqHistoryRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  /** ms */
  from?: string | undefined
  /** ms */
  to?: string | undefined
  limit?: string | undefined
}

export interface GetRfqHistoryResponse {
  rfqs: RfqUpdate[]
}

export interface ApiRequest {
  executionBatch?: ExecutionBatch | undefined
  login?: LoginRequest | undefined
  signup?: SignupRequest | undefined
  createAccount?: CreateAccountRequest | undefined
  getUserAccounts?: GetUserAccountsRequest | undefined
  requestPasswordReset?: RequestPasswordResetRequest | undefined
  confirmPasswordReset?: ConfirmPasswordResetRequest | undefined
  refreshToken?: RefreshTokenRequest | undefined
  verifyEmail?: VerifyEmailRequest | undefined
  resendVerification?: ResendVerificationRequest | undefined
  verify?: VerifyTokenRequest | undefined
  /** 2FA Management */
  setup2fa?: Setup2faRequest | undefined
  confirm2faSetup?: Confirm2faSetupRequest | undefined
  verify2fa?: Verify2faRequest | undefined
  verify2faLogin?: Verify2faLoginRequest | undefined
  disable2fa?: Disable2faRequest | undefined
  get2faBackupCodes?: Get2faBackupCodesRequest | undefined
  /** Passkey Management */
  setupPasskey?: SetupPasskeyRequest | undefined
  confirmPasskeySetup?: ConfirmPasskeySetupRequest | undefined
  passkeyLogin?: PasskeyLoginRequest | undefined
  confirmPasskeyLogin?: ConfirmPasskeyLoginRequest | undefined
  deletePasskey?: DeletePasskeyRequest | undefined
  getUserPasskeys?: GetUserPasskeysRequest | undefined
  /** Google OAuth */
  googleLogin?: GoogleLoginRequest | undefined
  /** Chart API requests */
  chartData?: ChartDataRequest | undefined
  portfolioLineChart?: PortfolioLineChartRequest | undefined
  time?: Time | undefined
  updateAccount?: UpdateAccountRequest | undefined
  /** Instruments request */
  instrumentList?: InstrumentListRequest | undefined
  /** Order History Request, returns  DataPayload */
  orderHistory?: HistoryRequest | undefined
  /** Trade history request, returns DataPayload */
  tradeHistory?: HistoryRequest | undefined
  /** UI state management requests */
  createPage?: CreatePageRequest | undefined
  getPages?: GetPagesRequest | undefined
  getPageLayout?: GetPageLayoutRequest | undefined
  updatePageMeta?: UpdatePageMetaRequest | undefined
  deletePage?: DeletePageRequest | undefined
  addWidget?: AddWidgetRequest | undefined
  updateWidget?: UpdateWidgetRequest | undefined
  removeWidget?: RemoveWidgetRequest | undefined
  saveComponentPreference?: SaveComponentPreferenceRequest | undefined
  getComponentPreference?: GetComponentPreferenceRequest | undefined
  createPositionGroup?: CreatePositionGroupRequest | undefined
  updatePositionGroup?: UpdatePositionGroupRequest | undefined
  deletePositionGroup?: DeletePositionGroupRequest | undefined
  getPositionsView?: GetPositionsViewRequest | undefined
  getPositionGroups?: GetPositionGroupsRequest | undefined
  reorderPositionsView?: ReorderPositionsViewRequest | undefined
  setPositionGroupOrder?: SetPositionGroupOrderRequest | undefined
  generateVolSurface?: GenerateVolSurfaceRequest | undefined
  riskSimulation?: RiskSimulationRequest | undefined
  economicCalendarHistory?: EconomicCalendarHistoryRequest | undefined
  executionAnalytics?: ExecutionAnalyticsRequest | undefined
  getVenues?: GetVenuesRequest | undefined
  getExchanges?: GetExchangesRequest | undefined
  getOrdersForAlgo?: GetOrdersForAlgoRequest | undefined
  getTradesForOrder?: GetTradesForOrderRequest | undefined
  getOrderStateHistory?: GetOrderStateHistoryRequest | undefined
  getTradesForAlgo?: GetTradesForAlgoRequest | undefined
  /**
   * ENG-462 — options analytic pulls (snapshot from KV, range from
   * QuestDB). Generic per Aaron's Slack 2026-05-04 architecture:
   * single ApiRequest variant + dispatch by `analytics_type`.
   */
  getAnalyticSnapshot?: GetAnalyticSnapshotRequest | undefined
  getAnalyticRange?: GetAnalyticRangeRequest | undefined
  optionsVolumeLeaderboard?: GetOptionsVolumeLeaderboardRequest | undefined
  optionsVolumeSeries?: OptionsVolumeSeriesRequest | undefined
  optionsOiSeries?: OptionsOiSeriesRequest | undefined
  optionsOiLeaderboard?: GetOptionsOiLeaderboardRequest | undefined
  optionsOiByStrike?: GetOptionsOiByStrikeRequest | undefined
  fundingSeries?: GetFundingSeriesRequest | undefined
  fundingLeaderboard?: GetFundingLeaderboardRequest | undefined
  /** Order presets — see migrations/0009_order_presets.md */
  createPreset?: CreatePresetRequest | undefined
  updatePreset?: UpdatePresetRequest | undefined
  deletePreset?: DeletePresetRequest | undefined
  listPresets?: ListPresetsRequest | undefined
  executePreset?: ExecutePresetRequest | undefined
  getPreset?: GetPresetRequest | undefined
  /** Personal watchlists */
  createWatchlist?: CreateWatchlistRequest | undefined
  getWatchlists?: GetWatchlistsRequest | undefined
  setWatchlist?: SetWatchlistRequest | undefined
  renameWatchlist?: RenameWatchlistRequest | undefined
  deleteWatchlist?: DeleteWatchlistRequest | undefined
  reorderWatchlists?: ReorderWatchlistsRequest | undefined
  dbNewsHistory?: DbNewsHistoryRequest | undefined
  alpacaNewsHistory?: AlpacaNewsHistoryRequest | undefined
  /**
   * Natural-language trade intent submitted to the intent-compiler
   * service. Public-api forwards the encoded `TradeIntent` over the
   * `internal.intent_compiler.draft.request` NATS subject and surfaces
   * the resulting `DraftExecutionPlan` (or `Error`) back to the client.
   * Tag 30 is `reserved` for the retired `trade_intent` shape.
   */
  intentCompiler?: TradeIntent | undefined
  confirmExecutionPlan?: ConfirmExecutionPlanRequest | undefined
  /**
   * Discovery of DB News trigger-filter values (sources/event-types/coins/tags)
   * so the frontend can populate `triggers.DbNewsCondition` without hardcoding
   * dbws.io's undocumented, ever-growing vocabulary. Response: `DbNewsVocabulary`.
   */
  getDbNewsVocabulary?: GetDbNewsVocabularyRequest | undefined
  testIntentCompiler?: TestIntentCompilerRequest | undefined
  getVenueStatus?: GetVenueStatus | undefined
  getVenueSchedules?: GetVenueSchedules | undefined
  createRfq?: CreateRfqRequest | undefined
  cancelRfq?: CancelRfqRequest | undefined
  acceptRfqQuote?: AcceptRfqQuoteRequest | undefined
  getRfqMakers?: GetRfqMakersRequest | undefined
  getRfqHistory?: GetRfqHistoryRequest | undefined
  rfqAnalytics?: RfqAnalyticsRequest | undefined
  /** Bybit OAuth broker onboarding */
  bybitOauthMintState?: BybitOauthMintStateRequest | undefined
  bybitOauthExchangeCode?: BybitOauthExchangeCodeRequest | undefined
  /** Deribit OAuth (Registered Partner Model) */
  deribitOauthMintState?: DeribitOauthMintStateRequest | undefined
  deribitOauthExchangeCode?: DeribitOauthExchangeCodeRequest | undefined
  /** Hyperliquid agent-wallet onboarding */
  hyperliquidPrepareAgent?: HyperliquidPrepareAgentRequest | undefined
  hyperliquidConfirmAgent?: HyperliquidConfirmAgentRequest | undefined
  hyperliquidDisconnectAgent?: HyperliquidDisconnectAgentRequest | undefined
  /** Derive (derive.xyz) session-key onboarding */
  derivePrepareSessionKey?: DerivePrepareSessionKeyRequest | undefined
  deriveConfirmSessionKey?: DeriveConfirmSessionKeyRequest | undefined
  deriveDisconnect?: DeriveDisconnectRequest | undefined
  deriveListSubaccounts?: DeriveListSubaccountsRequest | undefined
  deriveLinkSubaccounts?: DeriveLinkSubaccountsRequest | undefined
  /** Lighter (lighter.xyz) sub-account onboarding */
  lighterListSubaccounts?: LighterListSubaccountsRequest | undefined
  lighterPrepareSubaccountKey?: LighterPrepareSubaccountKeyRequest | undefined
  lighterConfirmSubaccountKey?: LighterConfirmSubaccountKeyRequest | undefined
  lighterLinkSubaccounts?: LighterLinkSubaccountsRequest | undefined
  /** Stripe billing */
  createCheckoutSession?: CreateCheckoutSessionRequest | undefined
  getSubscription?: GetSubscriptionRequest | undefined
  openBillingPortal?: OpenBillingPortalRequest | undefined
  getPlans?: GetPlansRequest | undefined
  /** Account access sharing */
  inviteToAccount?: InviteToAccountRequest | undefined
  listAccountAccess?: ListAccountAccessRequest | undefined
  revokeInvite?: RevokeInviteRequest | undefined
  removeAccountAccess?: RemoveAccountAccessRequest | undefined
  changeAccountRole?: ChangeAccountRoleRequest | undefined
  leaveAccount?: LeaveAccountRequest | undefined
  listMyInvites?: ListMyInvitesRequest | undefined
  respondToInvite?: RespondToInviteRequest | undefined
  transferAccountOwnership?: TransferAccountOwnershipRequest | undefined
  cancelPendingAccount?: CancelPendingAccountRequest | undefined
  orderPreview?: OrderPreviewRequest | undefined
  /** Session security & device tracking */
  changePassword?: ChangePasswordRequest | undefined
  listSessions?: ListSessionsRequest | undefined
  revokeSession?: RevokeSessionRequest | undefined
  logout?: LogoutRequest | undefined
  revokeAllOtherSessions?: RevokeAllOtherSessionsRequest | undefined
  sendStepUpCode?: SendStepUpCodeRequest | undefined
  orderbookMetricsSeries?: OrderbookMetricsSeriesRequest | undefined
  optionsTradesHistory?: OptionsTradesHistoryRequest | undefined
  masterInstrumentList?: MasterInstrumentListRequest | undefined
  impliedMove?: GetImpliedMoveRequest | undefined
  ivPercentile?: GetIvPercentileRequest | undefined
  maxPain?: GetMaxPainRequest | undefined
  greeksByExpiry?: GetGreeksByExpiryRequest | undefined
  /** Spec D6 (2026-07-20): AI-generated watchlist */
  generateWatchlist?: GenerateWatchlistRequest | undefined
  hyperliquidListSubaccounts?: HyperliquidListSubaccountsRequest | undefined
  hyperliquidLinkSubaccounts?: HyperliquidLinkSubaccountsRequest | undefined
  batchOrderPreview?: BatchOrderPreviewRequest | undefined
  visibleRangeProfile?: VisibleRangeProfileRequest | undefined
  getTwitterPostHistory?: GetTwitterPostHistoryRequest | undefined
  lighterPrepareIntegratorConsent?: LighterPrepareIntegratorConsentRequest | undefined
  lighterConfirmIntegratorConsent?: LighterConfirmIntegratorConsentRequest | undefined
  etfFundFlows?: EtfFundFlowsRequest | undefined
  fedwatchProbabilities?: FedwatchProbabilitiesRequest | undefined
  getCoinmarketcalEvents?: GetCoinMarketCalEventsRequest | undefined
  optionsStrikeFlow?: OptionsStrikeFlowRequest | undefined
  gexAggregate?: GetGexAggregateRequest | undefined
  economicData?: EconomicDataRequest | undefined
  /** Messaging-bot linking */
  mintMessagingLinkNonce?: MintMessagingLinkNonceRequest | undefined
  getTokenUnlocks?: GetTokenUnlocksRequest | undefined
  getTokenEmission?: GetTokenEmissionRequest | undefined
  /** Paradigm account binding wizard. Starts at 157: 154 is `reserved` below. */
  paradigmConnectDesk?: ParadigmConnectDeskRequest | undefined
  paradigmListAccounts?: ParadigmListAccountsRequest | undefined
  paradigmLinkAccount?: ParadigmLinkAccountRequest | undefined
  paradigmDisconnect?: ParadigmDisconnectRequest | undefined
  /** Shareable layouts */
  createSharedLayout?: CreateSharedLayoutRequest | undefined
  getSharedLayout?: GetSharedLayoutRequest | undefined
  treeNewsHistory?: TreeNewsHistoryRequest | undefined
  surfaceCurrencies?: GetSurfaceCurrenciesRequest | undefined
  /**
   * Self-serve external data-API keys. Session-authenticated, never on the
   * `/v1` surface: that one authenticates with a data API key, so a user
   * holding none would have no way to create their first.
   */
  createApiKey?: CreateApiKeyRequest | undefined
  listApiKeys?: ListApiKeysRequest | undefined
  revokeApiKey?: RevokeApiKeyRequest | undefined
  /**
   * Data API billing: credits, spend limit, auto refill, spend history.
   * Session-only, like the key requests above: an API key reads its balance
   * and history on `/v1` but can never buy credits or change a limit.
   */
  getApiBilling?: GetApiBillingRequest | undefined
  updateApiBillingSettings?: UpdateApiBillingSettingsRequest | undefined
  createCreditCheckoutSession?: CreateCreditCheckoutSessionRequest | undefined
  listCreditLedger?: ListCreditLedgerRequest | undefined
  getCreditSpendStats?: GetCreditSpendStatsRequest | undefined
  getMarketScreener?: GetMarketScreenerRequest | undefined
  listVolFitReferences?: ListVolFitReferencesRequest | undefined
  orderbookHeatmap?: OrderbookHeatmapRequest | undefined
  sendRfqMakerQuote?: SendRfqMakerQuoteRequest | undefined
  cancelRfqMakerQuote?: CancelRfqMakerQuoteRequest | undefined
  setLeverage?: SetLeverageRequest | undefined
  papertradePrepareSessionKey?: PapertradePrepareSessionKeyRequest | undefined
  papertradeConfirmSessionKey?: PapertradeConfirmSessionKeyRequest | undefined
  papertradeDisconnect?: PapertradeDisconnectRequest | undefined
  getAccountSettings?: GetAccountSettingsRequest | undefined
}

/**
 * ENG-462 — one-shot KV pull. Response: `DataPayload` whose oneof variant
 * matches `analytics_type`. KV is keyed `{EXCHANGE}.{currency}.{kind}`
 * where `kind` is `analytics_type.as_str_name()`. `symbol` carries
 * `currency` for §2-9 and `DVOL_<currency>` for §10; the handler strips
 * the `DVOL_` prefix when computing the KV key.
 */
export interface GetAnalyticSnapshotRequest {
  exchange: Exchange
  symbol: string
  analyticsType: AnalyticsType
}

/**
 * ENG-462 — historical range query. Only the 6 "full history" analytic
 * types (PUT_CALL_RATIO, DELTA_SURFACE_CONSTANT, DELTA_SURFACE_FLOATING,
 * IMPLIED_VS_REALIZED, TERM_STRUCTURE_RICHNESS, VOLATILITY_INDEX) are
 * supported; KV-only types (VOL_METRICS_24HR, TERM_STRUCTURE_CONSTANT,
 * TERM_STRUCTURE_FLOATING) return an error.
 */
export interface GetAnalyticRangeRequest {
  exchange: Exchange
  symbol: string
  analyticsType: AnalyticsType
  /**
   * Unix timestamp ms — same shape as EconomicCalendarHistoryRequest /
   * ChartDataRequest so the frontend's date-picker plumbing reuses
   * existing helpers without per-endpoint adapters.
   */
  from?: string | undefined
  to?: string | undefined
  limit?: number | undefined
  /**
   * analytics_type SVI only: restrict rows to one fit source (book, marks,
   * analytics). Absent or UNSPECIFIED returns every source. Rejected on any
   * other analytics_type.
   */
  sviSourceKind?: SviSourceKind | undefined
}

/**
 * FedWatch target-rate probabilities. One snapshot is many rows (meeting x
 * target range), so this does not go through GetAnalyticRange, whose row-level
 * `limit` would slice a grid in half.
 *
 * Three shapes, by which fields are set:
 *   - nothing set        → the latest grid across every meeting
 *   - `as_of` set        → that same grid as it stood at each instant, for
 *                          comparing today against a day/week/month ago
 *   - `from`/`to` set    → the series, which needs `meeting_date` to stay
 *                          inside the row cap
 */
export interface FedwatchProbabilitiesRequest {
  exchange: Exchange
  /** Futures root the tree was built from; defaults to `ZQ` when empty. */
  symbol: string
  /** Restrict to one FOMC meeting, `YYYY-MM-DD`. Required alongside from/to. */
  meetingDate?: string | undefined
  /** Unix timestamp ms, same shape as GetAnalyticRangeRequest. */
  from?: string | undefined
  to?: string | undefined
  limit?: number | undefined
  /**
   * Each instant resolves to the newest grid at or before it. Mutually
   * exclusive with from/to.
   */
  asOf: string[]
}

/**
 * ENG-613 #2/#3 — 24h options volume leaderboard. Window is fixed at 24h
 * (ticket); option_type absent = All (response carries put/call split).
 */
export interface GetOptionsVolumeLeaderboardRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
  volumeMeasure: OptionsVolumeMeasure
  groupBy: OptionsVolumeGroupBy
  /** absent = All */
  optionType?: OptionType | undefined
  /** CONTRACT top-N; capped server-side */
  limit?: number | undefined
}

/** ENG-613 #1 — options volume time-series request (chart-parity timeframes). */
export interface OptionsVolumeSeriesRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
  timeframe: ChartTimeframe
  volumeMeasure: OptionsVolumeMeasure
  /** ms */
  from?: string | undefined
  /** ms */
  to?: string | undefined
  limit?: number | undefined
}

/**
 * ENG-613 #4 — options OI time-series request (chart-parity timeframes, 1m+).
 * option_type absent = All (response carries the put/call split per bucket).
 */
export interface OptionsOiSeriesRequest {
  exchange: Exchange
  /** "BTC", "BTC_USDC", "ETH" */
  underlying: string
  /** MIN_1 and up */
  timeframe: ChartTimeframe
  measure: OptionsVolumeMeasure
  /** absent = All */
  optionType?: OptionType | undefined
  /** ms */
  from?: string | undefined
  /** ms */
  to?: string | undefined
  limit?: number | undefined
  /** absent = aggregate all expiries */
  expiryMs?: string | undefined
}

/**
 * ENG-613 #5 — top contracts by open interest. `mode` selects ranking by
 * current OI or by 24h OI change; option_type absent = All.
 */
export interface GetOptionsOiLeaderboardRequest {
  exchange: Exchange
  /** "BTC", "BTC_USDC", "ETH" */
  underlying: string
  measure: OptionsVolumeMeasure
  mode: OptionsOiRankMode
  /** absent = All */
  optionType?: OptionType | undefined
  /** top-N; capped server-side */
  limit?: number | undefined
}

/**
 * Open interest per strike, summed over every live expiry, with each side's
 * 24h change. No option_type filter — both sides ship on every row. No limit:
 * the row count is the venue's live strike count, capped server-side well above
 * the widest chain.
 */
export interface GetOptionsOiByStrikeRequest {
  exchange: Exchange
  /** "BTC", "BTC_USDC", "ETH" */
  underlying: string
  measure: OptionsVolumeMeasure
}

/**
 * ENG-613 — one-shot recent options-trades seed for the Options Trades tape.
 * Mirrors the OptionsTradesStream server-side filters (minus option_type, which
 * is a client-side display filter) plus a range/limit. Response reuses
 * InstrumentTradeList (data.instrument_trades). Auth-only.
 */
export interface OptionsTradesHistoryRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
  /** ALL / ONLY / NONE (UNSPECIFIED = ALL) */
  blockMode: BlockTradeMode
  /** paired with min_size */
  sizeMeasure?: OptionsVolumeMeasure | undefined
  /** size floor; both absent = no filter */
  minSize?: number | undefined
  /** ms; absent → to − 24h */
  from?: string | undefined
  /** ms; absent → now */
  to?: string | undefined
  /** default 100, clamped to 500 */
  limit?: number | undefined
}

/**
 * Strike × time flow heatmap. Reads the raw options tape, so the effective
 * window is min(requested, 90d, (limit + 1) x timeframe) — the table has no TTL
 * and a coarse timeframe would otherwise scan years. Venues that report no
 * aggressor side (OPRA) are rejected: every cell would be a zeroed buy/sell
 * split indistinguishable from no trading. Auth-only.
 */
export interface OptionsStrikeFlowRequest {
  exchange: Exchange
  /** "BTC", "ETH" */
  underlying: string
  timeframe: ChartTimeframe
  volumeMeasure: OptionsVolumeMeasure
  /** absent = every expiry */
  expiryMs?: string | undefined
  /** ms */
  from?: string | undefined
  /** ms */
  to?: string | undefined
  /** time buckets; default 500, max 1000 */
  limit?: number | undefined
  /** top-N strikes; default 20, max 50 */
  strikeLimit?: number | undefined
}

/**
 * Public discovery endpoint — returns every TradeVenue the system
 * knows about together with its `enabled` and `new_account` flags so
 * the frontend can gate signup UI without round-tripping per-venue
 * feature flags.
 */
export interface GetVenuesRequest {}

/**
 * Public discovery endpoint — given a TradeVenue (typically derived
 * from the user's account on the frontend), returns the Exchanges
 * that venue can trade on. For full-stack venues like Deribit this is
 * a single Exchange; for broker-style venues like IBKR it spans every
 * Exchange the broker fronts (e.g. XNAS, XNYS, OPRA, GLBX via
 * Databento data backends).
 */
export interface GetExchangesRequest {
  venue: TradeVenue
}

/** Market status for one venue. */
export interface GetVenueStatus {
  exchange: Exchange
}

/** Static weekly schedules for every known venue. */
export interface GetVenueSchedules {}

/**
 * One position slot a group can hold: an instrument in a specific account.
 * Account-qualified so one group can mix venues (ETH-PERPETUAL on Deribit
 * beside ETHUSDT on Bybit) and the same symbol in two accounts can sit in
 * different groups.
 */
export interface PositionGroupMember {
  accountId: string
  instrumentId: string
}

/**
 * A user-level group of positions. Groups belong to the user, not to an
 * account; each member names its own account.
 */
export interface PositionGroup {
  groupId: string
  name: string
  parentGroupId?: string | undefined
  children: PositionGroup[]
  createdAt: string
  updatedAt: string
  members: PositionGroupMember[]
  /**
   * User-defined order of this group's legs. Members absent here fall
   * back to notional sort behind the ordered prefix. An ordering hint
   * only; membership is `members`.
   */
  orderedMembers: PositionGroupMember[]
}

export interface PositionGroupMutationResponse {
  success: boolean
  message: string
  group?: PositionGroup | undefined
}

/**
 * A member already in another group moves to this one: a position slot
 * belongs to at most one group. Member lists here and in
 * UpdatePositionGroupRequest are capped at 1000 per request.
 */
export interface CreatePositionGroupRequest {
  name: string
  parentGroupId?: string | undefined
  members: PositionGroupMember[]
}

export interface UpdatePositionGroupRequest {
  groupId: string
  name?: string | undefined
  parentGroupId?: string | undefined
  addMembers: PositionGroupMember[]
  removeMembers: PositionGroupMember[]
}

export interface DeletePositionGroupRequest {
  groupId: string
}

/**
 * Persist the user-defined order of a single group's legs. Absolute list
 * (not a delta); members absent here fall back to notional sort. Returns
 * PositionGroupMutationResponse.
 */
export interface SetPositionGroupOrderRequest {
  groupId: string
  orderedMembers: PositionGroupMember[]
}

/** Every group the caller owns. */
export interface GetPositionGroupsRequest {}

export interface GetPositionGroupsResponse {
  groups: PositionGroup[]
}

/**
 * Subtree-summed USD metrics for a position group. Per-coin fields are
 * omitted because BTC + ETH deltas don't add meaningfully.
 */
export interface GroupedPositionMetrics {
  deltaUsd?: string | undefined
  gammaUsd?: string | undefined
  vegaUsd?: string | undefined
  thetaUsd?: string | undefined
  unrealizedPnlUsd?: string | undefined
  realizedPnlUsd?: string | undefined
  dailyUnrealizedPnlUsd?: string | undefined
  initialMarginUsd?: string | undefined
  maintenanceMarginUsd?: string | undefined
}

export interface GroupedPositionNode {
  groupId: string
  name: string
  parentGroupId?: string | undefined
  positions: Position[]
  children: GroupedPositionNode[]
  metrics?: GroupedPositionMetrics | undefined
}

/**
 * Groups are per user; the account fields filter which positions the view
 * is built from, so group metrics sum only the positions in scope. With a
 * filter, groups left with no positions are omitted; without one, empty
 * groups are returned too.
 */
export interface GetPositionsViewRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  mode: PositionViewMode
}

/**
 * One node in the interleaved top-level positions view: either a group
 * (with its assembled legs) or a standalone ungrouped position.
 */
export interface PositionViewEntry {
  group?: GroupedPositionNode | undefined
  position?: Position | undefined
}

/**
 * A reference in the saved top-level order. `id` is a group_id when
 * kind=GROUP, an instrument_id (== position symbol) when kind=POSITION.
 * `account_id` is required for kind=POSITION and ignored for kind=GROUP.
 */
export interface PositionViewOrderEntry {
  kind: PositionViewEntryKind
  id: string
  accountId: string
}

/**
 * Persist the user-defined interleaved top-level order (groups + ungrouped
 * positions). Entries referencing stale ids are ignored by the view
 * assembly; unseen items append at the bottom (positions by notional, groups
 * by name). The order is per user, not per account. Returns
 * GetPositionsViewResponse rebuilt across every account the caller can read.
 */
export interface ReorderPositionsViewRequest {
  orderedEntries: PositionViewOrderEntry[]
}

/**
 * Interpretation of value_lower / value_upper depends on `price_range_kind`:
 *   ABSOLUTE (default) — exact price lower/upper bounds.
 *   PERCENT            — fractions of mark price (e.g. 0.30 → ±30% around mark).
 */
export interface SimulationGridParams {
  valueLower: number
  valueUpper: number
  /** Clamped server-side to 99 (at most 100 price columns, step = range/99). */
  priceSteps: number
  volBumpPct: number
  /** Map of "YYYY-MM-DD" -> bump_pct */
  volBumpsByExpiry: { [key: string]: number }
  startDate: string
  endDate: string
  timeStepSeconds: string
  priceRangeKind: SimulationPriceRangeKind
}

export interface SimulationGridParams_VolBumpsByExpiryEntry {
  key: string
  value: number
}

export interface GenerateVolSurfaceRequest {
  asset: string
  optionPriceSource: OptionPriceSource
}

export interface StoredTenorSurface {
  tenorYears: number
  strikes: number[]
  vols: number[]
  markPrices: number[]
  bids: number[]
  asks: number[]
  marketForward: number
}

export interface StoredVolSurface {
  asset: string
  spot: number
  rate: number
  generatedAt: string
  tenors: StoredTenorSurface[]
}

export interface GenerateVolSurfaceResponse {
  asset: string
  tenorCount: number
  surface: StoredVolSurface | undefined
}

export interface RiskSimulationPosition {
  asset: string
  /**
   * Fixed underlying metric (crypto amount OR USD contract value).
   * UI contract:
   * - Linear contracts: size is in crypto.
   * - Inverse options: size is in crypto.
   * - Inverse perps/futures: size is total USD contract value.
   */
  size: number
  /**
   * Native entry price.
   * UI contract:
   * - Linear contracts: entry_price is in USD.
   * - Inverse options: entry_price is in base asset units.
   * - Inverse perps/futures: entry_price is in USD.
   */
  entryPrice: number
  instrumentType: RiskSimulationInstrumentType | undefined
  /** Determines payout model for PnL math (linear vs inverse contract). */
  contractType: InstrumentType
  /**
   * Account holding (or that would hold) this position. Margin is computed
   * per account only when EVERY position carries one; otherwise the margin
   * fields stay empty and PnL/greeks still run for the whole book.
   */
  accountId?: string | undefined
}

export interface RiskSimulationInstrumentType {
  call?: RiskSimulationCall | undefined
  put?: RiskSimulationPut | undefined
  perpetual?: RiskSimulationPerpetual | undefined
  future?: RiskSimulationFuture | undefined
}

export interface RiskSimulationCall {
  strike: number
  expiry: string
}

export interface RiskSimulationPut {
  strike: number
  expiry: string
}

export interface RiskSimulationPerpetual {}

export interface RiskSimulationFuture {
  expiry: string
}

export interface RiskSimulationRequest {
  portfolio: RiskSimulationPosition[]
  asset: string
  optionPriceSource: OptionPriceSource
  simulationGrid: SimulationGridParams | undefined
  /**
   * Expiry filter, "YYYY-MM-DD", inclusive, either bound optional. Keeps only
   * options/futures whose expiry DATE falls inside; perpetuals are always
   * kept. A book left empty by the filter is a validation error.
   */
  expiryFrom?: string | undefined
  expiryTo?: string | undefined
  /**
   * SERVER-POPULATED: public-api discards whatever a client sends here and
   * refills it from the accounts named in portfolio[].account_id.
   */
  accountMargins: RiskSimulationAccountMargin[]
}

/**
 * One account's margin context. On the request it is filled by public-api;
 * the response echoes it so the UI can label the regime and flag estimates.
 */
export interface RiskSimulationAccountMargin {
  accountId: string
  /**
   * PORTFOLIO only: net inverse and linear legs as separate pools (the
   * account segregates margin per settlement currency).
   */
  poolBySettlement: boolean
  /** The venue's own model name, display-only (e.g. "cross_pm"). */
  marginLabel: string
  /**
   * Response only: true when either figure is a model level rather than
   * venue-anchored. The lambda sets it; a request value is ignored.
   */
  approximate: boolean
  /**
   * Regime of the inverse-settled (coin) and linear-settled (stablecoin)
   * pools: from the currencies the pool's live legs touch, else the account's
   * own margin model. Both are always set; UNSPECIFIED on either is an error.
   */
  inversePoolRegime: RiskSimulationMarginRegime
  linearPoolRegime: RiskSimulationMarginRegime
  /**
   * Venue's current IM / MM (USD) on live_book; absent when the venue does
   * not report it or the live book could not be fully modelled.
   */
  venueImUsd?: number | undefined
  venueMmUsd?: number | undefined
  /**
   * The account's live positions on the slide's asset, in the portfolio's
   * shape; the lambda anchors its model to the venue figures on this book.
   */
  liveBook: RiskSimulationPosition[]
  /**
   * venue_mm_usd split by settlement pool (inverse = coin-settled, linear =
   * stablecoin-settled), each the venue's MM on that pool's live legs; 0 for
   * a pool with none. Pools margined apart are anchored apart, a pool without
   * its figure staying unanchored; with both absent, venue_mm_usd anchors the
   * account as a whole.
   */
  venueMmInversePoolUsd?: number | undefined
  venueMmLinearPoolUsd?: number | undefined
}

/** Deprecated with results_usd / results_base; see RiskSimulationTable. */
export interface SimulationPoint {
  price: number
  timestamp: string
  pnl: number
  delta: number
  gamma: number
  vega: number
  rho: number
  theta: number
  vanna: number
  volga: number
  weightedVega: number
}

export interface RiskSimulationResponse {
  volSurfacesUpdated: boolean
  /**
   * Deprecated: no longer filled; read table_usd / table_base. During the
   * rollout read these only when the tables are absent. To be reserved.
   *
   * @deprecated
   */
  resultsUsd: SimulationPoint[]
  /** @deprecated */
  resultsBase: SimulationPoint[]
  /**
   * One entry per simulated timestamp, in the same order as the tables'
   * timestamps. Applies to both tables: base PnL is USD PnL / price, so both
   * cross zero at the same prices.
   */
  breakEvens: BreakEvenSlice[]
  /**
   * Margin context per account, in the order accounts first appear in the
   * portfolio. Empty when margin was not computed.
   */
  accounts: RiskSimulationAccountMargin[]
  /**
   * Set instead of every other field when the response is too large to
   * return inline: a short-lived HTTPS URL to this message, protobuf-encoded.
   * The body is gzip (Content-Encoding); browsers' fetch decompresses it,
   * non-browser clients must decompress.
   */
  resultUrl: string
  /**
   * The simulation grid in USD and in base (coin) units; replaces
   * results_usd / results_base. Same axes in both.
   */
  tableUsd: RiskSimulationTable | undefined
  tableBase: RiskSimulationTable | undefined
}

/**
 * The (timestamp x price) simulation grid as columns.
 * - Layout: every per-point column holds timestamps.len() * prices.len()
 *   values, row-major by timestamp: the cell for (t, p) is at index
 *   t * prices.len() + p, with t indexing timestamps and p indexing prices.
 * - Precision: per-point values are float (f32, about 7 significant digits),
 *   for display only. Anything that is a difference of large numbers
 *   (attribution terms, skew_delta) is computed server-side in f64 first.
 * - NaN marks a value that does not exist (see maintenance_margin); it is
 *   never a stand-in for 0.
 * - Units: table_usd is USD (delta-like columns in dollar delta; gamma is the
 *   delta change per 1% spot move). table_base is each table_usd cell divided
 *   by that cell's price, in base (coin) units, plus attribution_coin_revaluation.
 * - An empty column means the term does not apply to this table (read it as
 *   0); it is not missing data.
 */
export interface RiskSimulationTable {
  /** The axes, sent once. prices ascending; timestamps RFC 3339, ascending. */
  prices: number[]
  timestamps: string[]
  pnl: number[]
  delta: number[]
  gamma: number[]
  vega: number[]
  rho: number[]
  theta: number[]
  vanna: number[]
  volga: number[]
  weightedVega: number[]
  /**
   * Delta change per calendar day with spot unchanged (dDelta/dt), same unit
   * as delta.
   */
  charm: number[]
  /** delta + vega * dSigma/dSpot, the smile slope taken sticky-moneyness. */
  smileDelta: number[]
  /** smile_delta - delta. */
  skewDelta: number[]
  /**
   * PnL change from the base point (current spot, start_date, unbumped vol),
   * split by a per-position Taylor expansion, one column per term. At every
   * cell the terms sum to pnl minus pnl at the base point, in the table's unit.
   * Base-point PnL is not sent.
   */
  attributionDelta: number[]
  attributionGamma: number[]
  attributionVega: number[]
  attributionTheta: number[]
  attributionVanna: number[]
  attributionVolga: number[]
  attributionResidual: number[]
  /**
   * table_base only (empty in table_usd): base-point PnL revalued from base
   * spot to this cell's price, base_pnl_usd * (1/price - 1/base_spot).
   */
  attributionCoinRevaluation: number[]
  /**
   * One per RiskSimulationResponse.accounts, matched by index (accounts[i]
   * owns accounts[i] here). Empty when margin was not computed.
   */
  accounts: RiskSimulationAccountColumns[]
}

/**
 * One account's margin requirement at every grid cell, in the enclosing
 * table's unit and layout.
 */
export interface RiskSimulationAccountColumns {
  initialMargin: number[]
  /** NaN where no defensible figure exists (unanchored portfolio margin). */
  maintenanceMargin: number[]
}

/**
 * Underlying prices where the portfolio's simulated PnL is zero at one
 * timestamp. Solved against the exact PnL function (not interpolated between
 * grid points), so a crossing is placed correctly even when an expiry kink sits
 * between two grid prices.
 * - Only roots inside the requested price range are reported; a break-even
 *   beyond value_lower / value_upper is absent, not clamped to the edge.
 * - Zero, one or many per slice (a straddle has two, a condor up to four).
 *   Sorted ascending.
 * - PnL excludes fees, so these are pre-fee break-evens.
 * - A root is only found where PnL changes sign or is exactly zero on a grid
 *   price; a curve that dips below zero and back within one grid step is
 *   missed, so a finer price_steps finds more of them.
 * - Where PnL sits flat at zero across several grid prices (e.g. below a call
 *   spread's lower strike), only the price where it leaves zero is reported;
 *   a book that is zero everywhere (fully offset) has none.
 */
export interface BreakEvenSlice {
  /** RFC3339, matches RiskSimulationTable.timestamps */
  timestamp: string
  prices: number[]
}

export interface GetPositionsViewResponse {
  mode: PositionViewMode
  groups: GroupedPositionNode[]
  ungroupedPositions: Position[]
  /**
   * Interleaved top-level order (groups + standalone positions). Primary
   * field for rendering; `groups`/`ungrouped_positions` remain populated
   * for back-compat, each ordered to match this list.
   */
  entries: PositionViewEntry[]
}

export interface PageMeta {
  pageId: string
  name: string
  isActive: boolean
  gridCols: number
  gridMargin: number
  createdAt: string
  updatedAt: string
}

export interface WidgetInstance {
  pageId: string
  widgetId: string
  widgetType: string
  x: number
  y: number
  w: number
  h: number
  minW: number
  minH: number
  config: { [key: string]: string }
  updatedAt: string
}

export interface WidgetInstance_ConfigEntry {
  key: string
  value: string
}

export interface ComponentPreference {
  componentId: string
  searchTerm?: string | undefined
  tickerFilter?: string | undefined
  columnOrder: string[]
  config: { [key: string]: string }
  updatedAt: string
}

export interface ComponentPreference_ConfigEntry {
  key: string
  value: string
}

export interface CreatePageRequest {
  pageId: string
  name: string
  isActive?: boolean | undefined
  gridCols?: number | undefined
  gridMargin?: number | undefined
}

export interface GetPagesRequest {}

export interface GetPagesResponse {
  pages: PageMeta[]
}

export interface GetPageLayoutRequest {
  pageId: string
}

export interface GetPageLayoutResponse {
  page?: PageMeta | undefined
  widgets: WidgetInstance[]
}

export interface UpdatePageMetaRequest {
  pageId: string
  name?: string | undefined
  isActive?: boolean | undefined
  gridCols?: number | undefined
  gridMargin?: number | undefined
}

export interface DeletePageRequest {
  pageId: string
}

export interface AddWidgetRequest {
  pageId: string
  widgetId: string
  widgetType: string
  x: number
  y: number
  w: number
  h: number
  minW?: number | undefined
  minH?: number | undefined
  config: { [key: string]: string }
}

export interface AddWidgetRequest_ConfigEntry {
  key: string
  value: string
}

export interface UpdateWidgetRequest {
  pageId: string
  widgetId: string
  x?: number | undefined
  y?: number | undefined
  w?: number | undefined
  h?: number | undefined
  minW?: number | undefined
  minH?: number | undefined
  config: { [key: string]: string }
}

export interface UpdateWidgetRequest_ConfigEntry {
  key: string
  value: string
}

export interface RemoveWidgetRequest {
  pageId: string
  widgetId: string
}

export interface SaveComponentPreferenceRequest {
  componentId: string
  searchTerm?: string | undefined
  tickerFilter?: string | undefined
  columnOrder: string[]
  config: { [key: string]: string }
}

export interface SaveComponentPreferenceRequest_ConfigEntry {
  key: string
  value: string
}

export interface GetComponentPreferenceRequest {
  componentId: string
}

export interface ComponentPreferenceResponse {
  preference?: ComponentPreference | undefined
}

export interface PageMutationResponse {
  success: boolean
  message: string
  page?: PageMeta | undefined
  widget?: WidgetInstance | undefined
}

/**
 * ── Shareable layouts ─────────────────────────────────────────────────
 * A share is a frozen, ownerless copy of a page layout addressable by an
 * unguessable id. It is never mutated, never deleted, and readable
 * without authentication by anyone holding the id. The creating user is
 * recorded server-side for logging only and is never returned.
 *
 * Deliberately not `WidgetInstance`: `page_id`, `widget_id` and
 * `updated_at` identify a widget inside one user's live page and mean
 * nothing in a frozen copy.
 */
export interface SharedWidget {
  widgetType: string
  x: number
  y: number
  w: number
  h: number
  minW?: number | undefined
  minH?: number | undefined
  /**
   * Opaque to the backend, exactly as `WidgetInstance.config` is. The
   * client is responsible for stripping anything private before sharing;
   * the server drops a denylist of obviously-sensitive keys as a safety
   * net, not as a substitute.
   */
  config: { [key: string]: string }
}

export interface SharedWidget_ConfigEntry {
  key: string
  value: string
}

export interface CreateSharedLayoutRequest {
  name: string
  gridCols?: number | undefined
  gridMargin?: number | undefined
  widgets: SharedWidget[]
}

export interface CreateSharedLayoutResponse {
  shareId: string
  createdAt: string
}

/** Unauthenticated. The id is the only credential. */
export interface GetSharedLayoutRequest {
  shareId: string
}

export interface GetSharedLayoutResponse {
  shareId: string
  name: string
  gridCols: number
  gridMargin: number
  widgets: SharedWidget[]
  createdAt: string
}

/**
 * A symbol alone is ambiguous across venues; `(exchange, symbol)` is the
 * instrument key the rest of the system routes on.
 */
export interface WatchlistEntry {
  exchange: Exchange
  symbol: string
}

/**
 * Personal watchlists. Full-replace `SetWatchlist` covers
 * add/remove/reorder of instruments in one message.
 */
export interface Watchlist {
  watchlistId: string
  name: string
  createdAt: string
  updatedAt: string
  orderedEntries: WatchlistEntry[]
  /**
   * The natural-language prompt this list was generated from, when created
   * by the AI flow. Absent/empty = manually created. Enables the "AI" badge
   * and regenerate-in-place: re-running the prompt set_watchlist-replaces
   * the SAME watchlist_id, so widget references stay valid.
   */
  generatedFromPrompt?: string | undefined
  /**
   * Last time the prompt was re-run (create, manual regenerate, or
   * auto-refresh). Distinct from updated_at, which moves on any manual edit.
   */
  lastRefreshedAtMs?: string | undefined
  /**
   * Auto-refresh cadence; 0/absent = manual refresh only. Set by the AI at
   * generation time from the prompt's time-sensitivity ("next month's
   * expiries" → daily). Server enforces 0 or >= 60000 (1 min).
   */
  refreshIntervalMs?: string | undefined
}

/**
 * Always a manual, non-AI watchlist — AI provenance/cadence is only ever
 * set via GenerateWatchlistRequest (spec D6), which decides refresh cadence
 * itself rather than accepting one from the client.
 */
export interface CreateWatchlistRequest {
  name: string
}

/**
 * Spec D6: creates an AI-generated watchlist from a natural-language prompt.
 * The list is created immediately (empty entries, generated_from_prompt
 * stamped) and populated asynchronously via the WatchlistRefreshRequest/
 * Result round-trip below — the response returns before entries land.
 */
export interface GenerateWatchlistRequest {
  /**
   * Same length cap as Watchlist.generated_from_prompt (<= 500 chars,
   * server-enforced).
   */
  prompt: string
  /**
   * Optional display name. Empty = server derives one from the prompt
   * (first 30 chars).
   */
  name: string
}

export interface GetWatchlistsRequest {}

/**
 * Persist a user-defined order across watchlists. IDs not in
 * `ordered_watchlist_ids` fall back to created_at sort behind the ordered
 * prefix.
 */
export interface ReorderWatchlistsRequest {
  orderedWatchlistIds: string[]
}

export interface GetWatchlistsResponse {
  watchlists: Watchlist[]
}

export interface SetWatchlistRequest {
  watchlistId: string
  orderedEntries: WatchlistEntry[]
}

export interface RenameWatchlistRequest {
  watchlistId: string
  newName: string
}

export interface DeleteWatchlistRequest {
  watchlistId: string
}

export interface WatchlistMutationResponse {
  success: boolean
  message: string
  watchlist?: Watchlist | undefined
}

/**
 * Service-to-service watchlist auto-refresh AND generation (spec 2026-07-19
 * D4, extended 2026-07-20 D6). public-api publishes WatchlistRefreshRequest
 * fire-and-forget on `internal.watchlist.refresh.request` in two cases: (a)
 * a GetWatchlists read finds a prompt-generated list past its refresh
 * interval, or (b) a GenerateWatchlistRequest just created a new prompt list
 * and wants it populated immediately. `instrument-enrichment` (D6 — moved
 * in-house from the external chat/AI service) re-runs the prompt against its
 * own in-memory enriched catalog and publishes WatchlistRefreshResult on
 * `internal.watchlist.refresh.result`; public-api applies the entries,
 * stamps last_refreshed_at_ms, and overwrites refresh_interval_ms with the
 * sender's latest cadence assessment. Both directions are fire-and-forget
 * core NATS — a lost message just means the list stays stale (or, for a
 * fresh generate, empty) until the next request. NOT part of the
 * ApiRequest/ServerMessage oneofs.
 *
 * Apply contract (server-enforced; violations reject the WHOLE result, no
 * partial apply, and the list stays stale until a later valid result):
 * ordered_entries must be deduplicated on (exchange, symbol); exchange must
 * be a concrete Exchange value (EXCHANGE_UNSPECIFIED rejected); symbols are
 * capped at 32 chars. A result for a watchlist the user has deleted is
 * dropped — a refresh never resurrects a deleted list.
 */
export interface WatchlistRefreshRequest {
  userId: string
  watchlistId: string
  prompt: string
}

export interface WatchlistRefreshResult {
  userId: string
  watchlistId: string
  orderedEntries: WatchlistEntry[]
  /**
   * Spec D6: cadence the sender recommends after (re-)evaluating the
   * prompt. 0/absent = static list, no auto-refresh. public-api always
   * overwrites the stored value with this — the sender re-assesses cadence
   * on every refresh, not just the first.
   */
  refreshIntervalMs?: string | undefined
}

export interface ExecutionBatch {
  /** Implicitly empty if the user isn't doing standard orders */
  executionCommands: OrderExecutionCommandList | undefined
  /** Implicitly empty if the user isn't doing algos */
  algoCommands: AlgoServiceCommandList | undefined
  /** If set, will cancel all existing orders/algos. All other commands will be ignored. Use with caution. */
  cancelAllOrders: CancelAllOrdersCommand | undefined
}

export interface CancelAllOrdersCommand {
  accountId: string[]
}

export interface HistoryRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  /** e.g BTC-PERPETUAL Empty = all, might conflict with currency */
  symbols: string[]
  /** e.g BTC, Empty = all, might conflict with symbols */
  currency: string[]
  /** timestamp in milliseconds, empty = most recent */
  from?: string | undefined
  /** timestamp in milliseconds, empty = all until limit */
  to?: string | undefined
  /** default 100, */
  limit?: number | undefined
}

export interface InstrumentListRequest {
  exchange: Exchange
}

/**
 * Fetch the enriched master instrument list for one exchange (mirror of
 * InstrumentListRequest, but served from the enriched REF_DATA_MASTER_INSTRUMENTS store).
 */
export interface MasterInstrumentListRequest {
  exchange: Exchange
}

export interface Time {}

export interface OrderHistory {
  /** optional */
  accountSource?: AccountSource | undefined
  /** optional */
  symbols: string[]
  /** optional */
  instruments: string[]
  /** optional */
  instrumentKinds: InstrumentKind[]
  /** optional, timestamp in nanoseconds */
  expiries: string[]
  /** optional */
  strikeRange?: IntRange | undefined
  /** optional, timerange as unix timestamps in nanoseconds */
  fromTo?: IntRange | undefined
  /** optional, size as integer range */
  orderSize?: IntRange | undefined
  /** optional */
  orderType?: OrderType | undefined
  /** optional */
  orderStatus?: OrderStatus | undefined
  /** optional, for pagination */
  limit?: number | undefined
  /** optional, timestamp in ns cursor for pagination, returns orders where timestamp < cursor */
  cursor?: string | undefined
}

export interface OpenOrders {
  /** optional */
  accountSource?: AccountSource | undefined
  /** optional */
  symbols: string[]
  /** optional */
  instruments: string[]
  /** optional */
  instrumentKinds: InstrumentKind[]
  /** optional */
  expiries: string[]
  /** optional */
  strikeRange?: IntRange | undefined
  /** optional */
  orderSize?: IntRange | undefined
  /** optional */
  orderType?: OrderType | undefined
}

export interface Positions {
  /** optional */
  accountSource?: AccountSource | undefined
  /** optional */
  symbols: string[]
  /** optional */
  instruments: string[]
  /** optional */
  instrumentKinds: InstrumentKind[]
  /** optional, timestamp in nanoseconds */
  expiries: string[]
  /** optional */
  strikeRange?: IntRange | undefined
  /** optional */
  posDeltaRange?: IntRange | undefined
  /** optional */
  instrDeltaRange?: IntRange | undefined
  /** optional */
  quantityRange?: IntRange | undefined
  /** optional */
  unrealizedPnlRange?: IntRange | undefined
}

export interface IntRange {
  /** min value as decimal string */
  min: string
  /** max value as decimal string */
  max: string
}

export interface Balances {
  /** optional */
  accountSource?: AccountSource | undefined
  /** optional */
  currencies: string[]
}

export interface AccountSource {
  accountIds?: AccountIds | undefined
  tradeVenues?: TradeVenues | undefined
}

export interface AccountIds {
  ids: string[]
}

export interface TradeVenues {
  tradeVenues: TradeVenue[]
}

export interface CreateAccountRequest {
  name: string
  apiKey?: string | undefined
  apiSecret?: string | undefined
  tradeVenue: TradeVenue
}

export interface CreateAccountResponse {
  name: string
  accountId: string
  publicIp: string
  tradeVenue: TradeVenue
}

export interface UpdateAccountRequest {
  accountId: string
  name?: string | undefined
  apiKey?: string | undefined
  apiSecret?: string | undefined
  disabled?: boolean | undefined
}

export interface InviteToAccountRequest {
  accountId: string
  email: string
  role: AccountRole
}

export interface ListAccountAccessRequest {
  accountId: string
}

export interface AccountMemberEntry {
  userId: string
  email: string
  role: AccountRole
  createdAt: string
}

export interface PendingInviteEntry {
  email: string
  role: AccountRole
  inviterUserId: string
  createdAt: string
  expiresAt: string
  /** Resolved for display; inviter_user_id stays for programmatic joins. */
  inviterEmail: string
}

export interface ListAccountAccessResponse {
  accountId: string
  members: AccountMemberEntry[]
  pendingInvites: PendingInviteEntry[]
}

export interface RevokeInviteRequest {
  accountId: string
  email: string
}

export interface RemoveAccountAccessRequest {
  accountId: string
  userId: string
}

export interface ChangeAccountRoleRequest {
  accountId: string
  userId: string
  role: AccountRole
}

export interface LeaveAccountRequest {
  accountId: string
}

/**
 * Owner-only: hand the account's OWNER role to an existing member; the old
 * owner becomes READ_WRITE. Atomic. Response is the generic success ack.
 */
export interface TransferAccountOwnershipRequest {
  accountId: string
  targetUserId: string
}

export interface ListMyInvitesRequest {}

export interface MyInviteEntry {
  accountId: string
  accountName: string
  tradeVenue: TradeVenue
  role: AccountRole
  inviterEmail: string
  expiresAt: string
  createdAt: string
}

export interface ListMyInvitesResponse {
  invites: MyInviteEntry[]
}

export interface RespondToInviteRequest {
  accountId: string
  /** false = decline (both delete the invite row) */
  accept: boolean
}

/** User ID will be extracted from authentication */
export interface GetUserAccountsRequest {}

export interface RequestPasswordResetRequest {
  email: string
}

export interface RequestPasswordResetResponse {
  success: boolean
  message: string
}

export interface ConfirmPasswordResetRequest {
  email: string
  verificationCode: string
  newPassword: string
}

export interface ConfirmPasswordResetResponse {
  success: boolean
  message: string
}

export interface VerifyEmailRequest {
  email: string
  verificationCode: string
}

export interface VerifyEmailResponse {
  success: boolean
  message: string
}

export interface VerifyTokenRequest {}

export interface ParsedAuthenticatorToken {
  userId: string
  emailVerified: boolean
}

export interface VerifyTokenResponse {
  valid: boolean
  token?: ParsedAuthenticatorToken | undefined
  errorMessage?: string | undefined
}

export interface ResendVerificationRequest {
  email: string
}

export interface ResendVerificationResponse {
  success: boolean
  message: string
}

/**
 * Narrows which legs a cross-exchange aggregate folds. Both lists are
 * permissive by default so a client that only wants "everything" sends an
 * empty message.
 */
export interface CrossExchangeScope {
  /** empty = every venue carrying the asset */
  exchanges: Exchange[]
  /** empty = every type the requested families support */
  instrumentTypes: CrossExchangeInstrumentType[]
}

/**
 * One instrument that went into a cross-exchange aggregate. Returned so the
 * client can show what the number is made of without re-deriving the leg set.
 */
export interface CrossExchangeLeg {
  exchange: Exchange
  symbol: string
  instrumentType: CrossExchangeInstrumentType
}

export interface ChartDataRequest {
  symbol: string
  exchange: Exchange
  timeframe: ChartTimeframe
  /** timestamp in seconds */
  from?: string | undefined
  /** timestamp in seconds */
  to?: string | undefined
  limit?: number | undefined
  families: CandleFamily[]
  /**
   * Present = `symbol` is an asset (BTC) and the CANDLE_FAMILY_AGGREGATE_*
   * families fold every matching leg. Absent = the legacy per-instrument path.
   */
  crossExchange?: CrossExchangeScope | undefined
}

export interface ChartData {
  symbol: string
  exchange: Exchange
  timeframe: ChartTimeframe
  candles?: CandleList | undefined
  /**
   * The legs folded into the aggregate. Populated only when the request
   * carried `cross_exchange`; empty on the per-instrument path.
   */
  crossExchangeLegs: CrossExchangeLeg[]
}

/**
 * Volume-delta, liquidation and open-interest profiles for a chart's visible
 * time range: traded size and OI change bucketed by price rather than by time.
 * The indicators come from one request because they share a price grid.
 */
export interface VisibleRangeProfileRequest {
  exchange: Exchange
  symbol: string
  fromMs: string
  toMs: string
  buckets?: number | undefined
  /**
   * Absent = derive the grid from the window's own min/max traded price.
   * Set both to bucket over the chart's y-axis instead; trades outside the
   * given range fold into the end buckets. Rejected unless
   * 0 < price_min < price_max, so an axis reaching at or below zero has to
   * omit them and take the derived grid.
   */
  priceMin?: number | undefined
  priceMax?: number | undefined
}

/**
 * Parallel arrays of length `buckets`, low price to high. Bucket i spans
 * [price_min + i*bucket_width, price_min + (i+1)*bucket_width). Both
 * denominations ship together so the frontend can toggle without a refetch;
 * liquidation arrays are all-zero for venues that publish no liquidations.
 */
export interface VisibleRangeProfile {
  exchange: Exchange
  symbol: string
  fromMs: string
  toMs: string
  priceMin: number
  bucketWidth: number
  buyVolumeBase: number[]
  sellVolumeBase: number[]
  buyVolumeQuote: number[]
  sellVolumeQuote: number[]
  buyLiquidationBase: number[]
  sellLiquidationBase: number[]
  buyLiquidationQuote: number[]
  sellLiquidationQuote: number[]
  /**
   * Actual span of the rows behind the arrays; absent when the window held no
   * plottable rows — bucketing keys on a candle's average price and no bar can
   * sit at a non-positive one, so an instrument trading entirely negative
   * (Deribit multi-leg combos) reports these absent with every series zero.
   * price_min itself still spans the surviving candles' lows and can be
   * negative. Narrower than from_ms/to_ms when the window predates the
   * instrument or the source tier's retention.
   */
  coveredFromMs?: string | undefined
  coveredToMs?: string | undefined
  /**
   * Time resolution of the source rows. Prices are bucketed from per-interval
   * averages, so a bucket smaller than one interval's price move is smeared.
   */
  sourceIntervalSeconds: number
  /**
   * Open-interest change attributed to the price it happened at: per band, the
   * sum of positive and of negative deltas of the per-interval OI level.
   * Decrease is a positive magnitude, so net is increase - decrease. All-zero
   * for spot, and also for a perp whose instrument metadata has not reached the
   * backend yet, so all-zero is not proof the instrument carries no open
   * interest. Options never reach here.
   */
  openInterestIncreaseBase: number[]
  openInterestDecreaseBase: number[]
  openInterestIncreaseQuote: number[]
  openInterestDecreaseQuote: number[]
}

/**
 * Predicted liquidation prices of every currently-open perpetual position,
 * bucketed onto a producer-owned price grid. Same parallel-array encoding as
 * VisibleRangeProfile so all three profile datasets render in one overlay,
 * but the tense is opposite: these are levels positions WILL liquidate at,
 * where VisibleRangeProfile.buy/sell_liquidation_* are fills that already
 * happened. Live-only — nothing persists this, so there is no range query.
 */
export interface LiquidationLevelProfile {
  exchange: Exchange
  symbol: string
  timestamp: string
  /**
   * Grid centre the window was built around (the venue's mark price, which is
   * also what liquidations are triggered against).
   */
  mid: number
  priceMin: number
  bucketWidth: number
  /**
   * Split by position direction, not by the side of a future fill: longs
   * liquidate below mid, shorts above. USD notional of the positions whose
   * liquidation price falls in each bucket.
   */
  longLiquidationLevelNotional: number[]
  shortLiquidationLevelNotional: number[]
  longLiquidationLevelCount: string[]
  shortLiquidationLevelCount: string[]
}

/**
 * Resting TP/SL trigger prices bucketed onto the same grid encoding as
 * LiquidationLevelProfile. Take-profit and stop-loss ship as separate arrays
 * so the frontend can render them as one merged layer or two.
 */
export interface StopLevelProfile {
  exchange: Exchange
  symbol: string
  timestamp: string
  mid: number
  priceMin: number
  bucketWidth: number
  /**
   * A position-level TP/SL rests with size 0 (it closes whatever the position
   * holds at trigger time), so its notional is resolved from the position
   * snapshot. Orders whose position cannot be resolved contribute to the
   * count arrays only — count is always complete, notional can under-report.
   *
   * The two arrays are alternative outcomes, not addends: a position with both
   * a TP and an SL contributes its notional to each, and only one can fire.
   * Summing them double-counts every such position.
   */
  takeProfitNotional: number[]
  stopLossNotional: number[]
  takeProfitCount: string[]
  stopLossCount: string[]
}

/**
 * One row of the perp positions table. `account` is the venue's identifier
 * verbatim (Hyperliquid address, Lighter account index, Derive subaccount id).
 * `size` is signed in venue-native units (negative = short); `notional_usd`
 * is |size| × mark. Optional fields are absent when the venue does not
 * supply them for that row.
 */
export interface PerpPositionRow {
  account: string
  size: number
  notionalUsd: number
  entryPrice?: number | undefined
  markPrice?: number | undefined
  unrealizedPnl?: number | undefined
  liquidationPrice?: number | undefined
  leverage?: number | undefined
  isolated?: boolean | undefined
  accountValue?: number | undefined
  fundingPnl?: number | undefined
}

/**
 * Top-N perp positions for one instrument plus aggregates over EVERY
 * position the producer saw (not just the rows carried). Full replace per
 * publish. `coverage_pct` is set only where the producer cannot see the whole
 * market (Derive: Σ covered |size| / (2 · venue open interest) × 100, capped
 * at 100; OI is one-sided while Σ|size| counts longs and shorts).
 * `long_upnl_usd` / `short_upnl_usd` sum `unrealized_pnl` over every position
 * on that side that carries one; absent when none does.
 */
export interface PerpPositionsSnapshot {
  exchange: Exchange
  instrument: string
  asOfMs: string
  totalPositions: number
  longNotionalUsd: number
  shortNotionalUsd: number
  longAccounts: number
  shortAccounts: number
  coveragePct?: number | undefined
  rows: PerpPositionRow[]
  longUpnlUsd?: number | undefined
  shortUpnlUsd?: number | undefined
}

export interface PortfolioLineChartRequest {
  accountId: string
  /**
   * Multi-account scope; takes precedence over account_id. Empty with an
   * empty account_id means every account the caller can read.
   */
  accountIds: string[]
  /** in seconds (e.g. 300 or 3600) */
  timeframe: number
  from?: string | undefined
  to?: string | undefined
  limit?: number | undefined
  tradeVenue: TradeVenue
}

export interface PortfolioLineChart {
  accountId: string
  timeframe: number
  ticks: string[]
  values: number[]
  tradeVenue: TradeVenue
}

/**
 * Multi-account answer to a PortfolioLineChartRequest carrying `account_ids`.
 * One series per account, each keeping its own `account_id`; the DataPayload
 * envelope's is empty. Chosen by the request's shape, never by how many accounts
 * resolved: a request setting `account_ids` gets this variant even for one
 * element. Only a legacy `account_id`-only request gets the singular
 * `portfolio_line_chart`. Series are NOT summed — the client decides whether to
 * overlay or aggregate.
 */
export interface PortfolioLineChartList {
  charts: PortfolioLineChart[]
}

/**
 * Bind a bot chat to an OrderX account without a credential ever appearing in a
 * chat window: the signed-in web client mints a single-use nonce, the user
 * carries it to the bot through a deep link, and the bot redeems it.
 *
 * UNSPECIFIED is rejected rather than defaulted — a nonce minted for the wrong
 * surface would be redeemable from the wrong one.
 */
export interface MintMessagingLinkNonceRequest {
  channel: MessagingChannel
  /**
   * Which bot the nonce is for. UNSPECIFIED is rejected for the same reason
   * `channel` is: both are persisted in the link row's key, and defaulting
   * either one binds the chat to a bot the user did not choose.
   */
  surface: MessagingSurface
}

export interface MintMessagingLinkNonceResponse {
  success: boolean
  /**
   * base64url, unpadded, 22 chars — sized to fit Telegram's 64-char `start`
   * deep-link payload. 128 bits of entropy, because a bearer nonce is checked
   * against no second identifier and an attempt counter cannot bound an attack
   * that guesses a different nonce every time.
   */
  nonce?: string | undefined
  /** Unix timestamp ms */
  expiresAt?: string | undefined
  errorMessage?: string | undefined
  /**
   * The link the client opens, e.g. `https://t.me/<bot>?start=<nonce>`.
   *
   * Server-built rather than assembled client-side: the nonce alone is not
   * actionable, because the bot's username is deployment configuration the web
   * client has no other way to learn — and hardcoding it there puts a
   * per-environment value in the frontend bundle. Absent when the channel has
   * no configured bot, which is also how a caller learns the channel is not
   * usable yet rather than getting a nonce it can do nothing with.
   */
  deepLink?: string | undefined
}

/**
 * There is deliberately NO tier or bucket field. What a key may reach is the
 * lesser of the holder's live plan and the `[entitlements.api_*]` bucket its
 * `scopes` earn, resolved per request — so an upgrade reaches a key the holder
 * already has, and a lapsed plan downgrades it, without reissuing anything. A
 * field here would let a caller ask for a paid bucket, and would re-freeze the
 * plan class onto the key that this design exists to remove.
 */
export interface CreateApiKeyRequest {
  /**
   * Free-text, shown in the key list. The customer's own name for the
   * integration; the server caps its length.
   */
  label: string
  /**
   * `account:read` opens the caller's own accounts, positions, orders and
   * fills. `execute` places and cancels orders on accounts the caller OWNS,
   * and is the only scope that earns trade venues. Neither is implied by the
   * other, and an unrecognised scope is refused rather than stored: a stored
   * typo mints a key that authenticates and then 403s forever.
   */
  scopes: string[]
  /**
   * Optional expiry, **Unix SECONDS** — note the messaging nonce above uses
   * milliseconds, so a client reusing that handling is off by 1000x. Unset
   * means the key never expires, which is what every key minted before this
   * field existed carries. A time in the past is refused, since it would mint
   * a key that can never authenticate.
   */
  expiresAt?: string | undefined
  /**
   * Step-up, the same shape `ChangePasswordRequest` uses. A key outlives every
   * session-kill lever the account has and is revoked only from the key list,
   * so minting one re-proves the account rather than trusting the session.
   *
   * Send the password AND the factor the account has, both in the first
   * request. With TOTP enabled that is `totp_code` (or `backup_code`);
   * otherwise call `SendStepUpCode(SENSITIVE_ACTION_CREATE_API_KEY)` first and
   * send `email_code`.
   *
   * Do NOT probe with these empty to discover which factor is needed: an empty
   * `current_password` is answered before the factor is looked at, so the
   * reply is always about the password, and every attempt counts as a failed
   * step-up against the account's throttle.
   */
  currentPassword: string
  totpCode?: string | undefined
  emailCode?: string | undefined
  backupCode?: string | undefined
}

export interface CreateApiKeyResponse {
  success: boolean
  /**
   * The full key, `oxk_<key_id>_<secret>`. Present on success and **nowhere
   * else, ever**: the server stores only a hash of the secret half, so this is
   * not recoverable and a lost key is reissued rather than looked up. Surface
   * it as copy-once, with no re-read path in the UI.
   */
  apiKey?: string | undefined
  /**
   * The same key's non-secret metadata, so a client can render the new row
   * without a follow-up list call.
   */
  key?: ApiKeyInfo | undefined
  errorMessage?: string | undefined
}

/**
 * One key's non-secret facts. `key_id` is the half that is not a secret: it
 * appears in server logs and is the right thing to quote in a support request.
 */
export interface ApiKeyInfo {
  keyId: string
  label: string
  /**
   * What this key may do. Resolved from the key's own record, and the field to
   * branch on — NOT the account plan — when deciding whether a key can reach
   * account data or place an order.
   */
  scopes: string[]
  /** Unix seconds */
  createdAt: string
  /** Unix seconds; unset = never expires */
  expiresAt?: string | undefined
  /**
   * Set once revoked. `ListApiKeys` leaves revoked and expired keys out (ENG-1094),
   * so this is never set on a listed key; `oems-admin api-key list` shows it.
   */
  revokedAt?: string | undefined
  /**
   * The execution kill switch. Set, and this key places no orders while its
   * data access keeps working. Operator-set today.
   */
  executionHaltedAt?: string | undefined
}

/**
 * Empty — the caller's session identifies whose keys these are. A user_id
 * field would be a way to read another tenant's key list.
 */
export interface ListApiKeysRequest {}

export interface ListApiKeysResponse {
  success: boolean
  /**
   * Newest first. Only keys that still authenticate: revoked and expired keys
   * are left out, by the same test the live-key cap counts with.
   */
  keys: ApiKeyInfo[]
  errorMessage?: string | undefined
}

export interface RevokeApiKeyRequest {
  /**
   * The non-secret half, as returned by create or list. Ownership is enforced
   * server-side as a write condition, so this cannot revoke another tenant's
   * key even though `key_id` is not a secret.
   */
  keyId: string
}

export interface RevokeApiKeyResponse {
  success: boolean
  /**
   * A key_id that is not this caller's reports failure rather than success:
   * telling someone mid-incident that a key is dead when it is still
   * authenticating is the dangerous answer.
   */
  errorMessage?: string | undefined
}

/**
 * Credits are sold as one Stripe price per credit; the buyer picks how many.
 * The price is Stripe's, read live, so repricing is a Dashboard change with no
 * deploy.
 */
export interface CreditPrice {
  /** minor units of `currency` per credit, e.g. 10 = $0.10 */
  unitAmount: string
  /** ISO 4217, lowercase as Stripe sends it */
  currency: string
  /** A top-up or a refill buys between these, inclusive. */
  minCredits: string
  maxCredits: string
  /**
   * One-click top-up sizes in minor units of `currency` (5000 = $50), in the
   * order shown. Each buys `amount / unit_amount` credits, rounded down, so a
   * repricing keeps the buttons on round amounts.
   */
  presetAmounts: string[]
}

export interface ApiBillingSettings {
  /**
   * Most credits the account may spend in one calendar week, Monday 00:00 UTC
   * to Sunday 23:59 UTC; it resets every Monday 00:00 UTC. Unset = no limit. A
   * request that would cross it is refused with 402 `spending_limit_reached` on
   * `/v1`.
   */
  spendLimitWeekly?: string | undefined
  /**
   * "If the balance drops below `refill_threshold`, buy `refill_credits`",
   * charged to the card saved at a top-up. Requires `spend_limit_weekly`;
   * `refill_credits` is within `CreditPrice` min..max, and `refill_threshold`
   * may not exceed it.
   */
  refillEnabled: boolean
  refillThreshold: string
  refillCredits: string
}

export interface GetApiBillingRequest {}

export interface GetApiBillingResponse {
  success: boolean
  /**
   * Unset when the account has never held credits — different from 0, which
   * means it has spent everything. Same rule as `/v1/me`.
   */
  balance?: string | undefined
  grantedTotal: string
  spentTotal: string
  settings: ApiBillingSettings | undefined
  /** Spent since Monday 00:00 UTC, net of refunds, for "X of Y used". */
  spentThisWeek: string
  /**
   * The card auto refill charges, display only. Unset = no saved card, so
   * refill cannot be enabled until a top-up saves one.
   */
  cardBrand?: string | undefined
  cardLast4?: string | undefined
  errorMessage?: string | undefined
  /** Unset = credits are not on sale: top-up and auto refill are refused. */
  creditPrice?: CreditPrice | undefined
}

/**
 * Replaces the settings whole. Raising or removing the limit, enabling refill,
 * raising the refill amount, or raising the refill threshold is step-up gated,
 * with the same fields and the same "send both in the first request" rule as
 * `CreateApiKeyRequest`
 * (`SendStepUpCode(SENSITIVE_ACTION_UPDATE_API_BILLING)` for the email code).
 * Lowering the limit or disabling refill needs no step-up, and ignores these.
 */
export interface UpdateApiBillingSettingsRequest {
  settings: ApiBillingSettings | undefined
  currentPassword: string
  totpCode?: string | undefined
  emailCode?: string | undefined
  backupCode?: string | undefined
}

export interface UpdateApiBillingSettingsResponse {
  success: boolean
  /** What is now stored, on success. */
  settings: ApiBillingSettings | undefined
  errorMessage?: string | undefined
}

/**
 * Hosted Stripe Checkout for `credits` credits (the per-credit price times
 * that quantity). Credits land when Stripe confirms the payment, not when this
 * returns: poll `GetApiBilling` on the success page.
 */
export interface CreateCreditCheckoutSessionRequest {
  /** Within `CreditPrice` min..max. */
  credits: string
  /**
   * Save the card for auto refill. The Checkout page tells the customer it
   * will be charged later without them present.
   */
  saveCardForRefill: boolean
  /** Required, and must be on the billing redirect allowlist (origin + path). */
  successUrl: string
  cancelUrl: string
}

export interface CreateCreditCheckoutSessionResponse {
  success: boolean
  checkoutUrl?: string | undefined
  errorMessage?: string | undefined
}

export interface ListCreditLedgerRequest {
  /**
   * Only this key's refunds and its share of each day's spend. Grants carry no
   * key and are left out.
   */
  keyId?: string | undefined
  /** `next_cursor` from the previous page; unset for the newest page. */
  cursor?: string | undefined
  /** Rows per page; 0 = the server default. The server caps it. */
  limit: number
}

/**
 * One entry of the account's credit history. Debits are not itemised: each
 * day's debits are one `spend` entry. The entries of an account sum to its
 * balance.
 */
export interface CreditLedgerEntry {
  kind: CreditLedgerKind
  /** signed: spend and clawback are negative */
  credits: string
  createdAtMs: string
  /**
   * The purchase id for a refund; the Checkout Session id for a purchase; the
   * PaymentIntent id for an auto refill; the operator's grant id; the charge
   * id for a clawback; the day (`YYYY-MM-DD`, UTC) for spend. A spend entry is placed at 00:00 UTC of its
   * day; its breakdown is in `GetCreditSpendStats`.
   */
  reference: string
  keyId: string
  /** `file` or `live` on a refund; empty otherwise */
  source: string
  /** on a refund; empty otherwise */
  dataset: string
}

export interface ListCreditLedgerResponse {
  success: boolean
  /**
   * Newest first. Filtering by key can return a short or empty page while
   * `next_cursor` is still set; keep paging until it is unset.
   */
  entries: CreditLedgerEntry[]
  nextCursor?: string | undefined
  errorMessage?: string | undefined
}

export interface GetCreditSpendStatsRequest {
  /**
   * Inclusive UTC days, `YYYY-MM-DD`. Both unset = the current week, Monday
   * 00:00 UTC to today.
   */
  fromDay?: string | undefined
  toDay?: string | undefined
}

/**
 * Debits, gross: a refund for a failed request is a `REFUND` entry in
 * `ListCreditLedger` and is not subtracted here, so this week's total can exceed
 * `spent_this_week`. Clawbacks are not spend and are in neither.
 */
export interface CreditSpendDay {
  /** `YYYY-MM-DD`, UTC */
  day: string
  total: string
  byDataset: { [key: string]: string }
  bySource: { [key: string]: string }
  byKey: { [key: string]: string }
}

export interface CreditSpendDay_ByDatasetEntry {
  key: string
  value: string
}

export interface CreditSpendDay_BySourceEntry {
  key: string
  value: string
}

export interface CreditSpendDay_ByKeyEntry {
  key: string
  value: string
}

export interface GetCreditSpendStatsResponse {
  success: boolean
  /** Oldest first. A day with no spend is absent. */
  days: CreditSpendDay[]
  /** The same breakdowns summed over the range. */
  total: string
  byDataset: { [key: string]: string }
  bySource: { [key: string]: string }
  byKey: { [key: string]: string }
  errorMessage?: string | undefined
}

export interface GetCreditSpendStatsResponse_ByDatasetEntry {
  key: string
  value: string
}

export interface GetCreditSpendStatsResponse_BySourceEntry {
  key: string
  value: string
}

export interface GetCreditSpendStatsResponse_ByKeyEntry {
  key: string
  value: string
}

function createBaseMessageSubject(): MessageSubject {
  return {
    marketDataStream: undefined,
    exchangeData: undefined,
    account: undefined,
    accountStream: undefined,
    execution: undefined,
    chartDataStream: undefined,
    serviceNotifications: undefined,
    economicCalendarStream: undefined,
    executionAnalyticsStream: undefined,
    analyticsStream: undefined,
    dbNewsStream: undefined,
    triggerConditionStream: undefined,
    optionsVolumeStream: undefined,
    optionsTradesStream: undefined,
    exchangeStatusStream: undefined,
    polymarketSignalStream: undefined,
    venueHealthStream: undefined,
    alpacaNewsStream: undefined,
    twitterStream: undefined,
    coinmarketcalEventStream: undefined,
    tokenUnlockStream: undefined,
    treeNewsStream: undefined,
    marketScreenerStream: undefined,
    orderbookHeatmapStream: undefined,
  }
}

export const MessageSubject: MessageFns<MessageSubject> = {
  encode(message: MessageSubject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.marketDataStream !== undefined) {
      MarketDataStream.encode(message.marketDataStream, writer.uint32(10).fork()).join()
    }
    if (message.exchangeData !== undefined) {
      ExchangeData.encode(message.exchangeData, writer.uint32(18).fork()).join()
    }
    if (message.account !== undefined) {
      AccountData.encode(message.account, writer.uint32(26).fork()).join()
    }
    if (message.accountStream !== undefined) {
      AccountDataStream.encode(message.accountStream, writer.uint32(34).fork()).join()
    }
    if (message.execution !== undefined) {
      Execution.encode(message.execution, writer.uint32(42).fork()).join()
    }
    if (message.chartDataStream !== undefined) {
      ChartDataStream.encode(message.chartDataStream, writer.uint32(50).fork()).join()
    }
    if (message.serviceNotifications !== undefined) {
      Notifications.encode(message.serviceNotifications, writer.uint32(58).fork()).join()
    }
    if (message.economicCalendarStream !== undefined) {
      EconomicCalendarStream.encode(message.economicCalendarStream, writer.uint32(66).fork()).join()
    }
    if (message.executionAnalyticsStream !== undefined) {
      ExecutionAnalyticsStream.encode(
        message.executionAnalyticsStream,
        writer.uint32(82).fork()
      ).join()
    }
    if (message.analyticsStream !== undefined) {
      AnalyticsStream.encode(message.analyticsStream, writer.uint32(90).fork()).join()
    }
    if (message.dbNewsStream !== undefined) {
      DbNewsStream.encode(message.dbNewsStream, writer.uint32(98).fork()).join()
    }
    if (message.triggerConditionStream !== undefined) {
      TriggerConditionStream.encode(
        message.triggerConditionStream,
        writer.uint32(106).fork()
      ).join()
    }
    if (message.optionsVolumeStream !== undefined) {
      OptionsVolumeStream.encode(message.optionsVolumeStream, writer.uint32(114).fork()).join()
    }
    if (message.optionsTradesStream !== undefined) {
      OptionsTradesStream.encode(message.optionsTradesStream, writer.uint32(122).fork()).join()
    }
    if (message.exchangeStatusStream !== undefined) {
      ExchangeStatusStream.encode(message.exchangeStatusStream, writer.uint32(130).fork()).join()
    }
    if (message.polymarketSignalStream !== undefined) {
      PolymarketSignalStream.encode(
        message.polymarketSignalStream,
        writer.uint32(138).fork()
      ).join()
    }
    if (message.venueHealthStream !== undefined) {
      VenueHealthStream.encode(message.venueHealthStream, writer.uint32(146).fork()).join()
    }
    if (message.alpacaNewsStream !== undefined) {
      AlpacaNewsStream.encode(message.alpacaNewsStream, writer.uint32(162).fork()).join()
    }
    if (message.twitterStream !== undefined) {
      TwitterStream.encode(message.twitterStream, writer.uint32(170).fork()).join()
    }
    if (message.coinmarketcalEventStream !== undefined) {
      CoinMarketCalEventStream.encode(
        message.coinmarketcalEventStream,
        writer.uint32(178).fork()
      ).join()
    }
    if (message.tokenUnlockStream !== undefined) {
      TokenUnlockStream.encode(message.tokenUnlockStream, writer.uint32(186).fork()).join()
    }
    if (message.treeNewsStream !== undefined) {
      TreeNewsStream.encode(message.treeNewsStream, writer.uint32(194).fork()).join()
    }
    if (message.marketScreenerStream !== undefined) {
      MarketScreenerStream.encode(message.marketScreenerStream, writer.uint32(202).fork()).join()
    }
    if (message.orderbookHeatmapStream !== undefined) {
      OrderbookHeatmapStream.encode(
        message.orderbookHeatmapStream,
        writer.uint32(210).fork()
      ).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageSubject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMessageSubject()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.marketDataStream = MarketDataStream.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.exchangeData = ExchangeData.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.account = AccountData.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountStream = AccountDataStream.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.execution = Execution.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.chartDataStream = ChartDataStream.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.serviceNotifications = Notifications.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.economicCalendarStream = EconomicCalendarStream.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.executionAnalyticsStream = ExecutionAnalyticsStream.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.analyticsStream = AnalyticsStream.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.dbNewsStream = DbNewsStream.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.triggerConditionStream = TriggerConditionStream.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.optionsVolumeStream = OptionsVolumeStream.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.optionsTradesStream = OptionsTradesStream.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.exchangeStatusStream = ExchangeStatusStream.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.polymarketSignalStream = PolymarketSignalStream.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.venueHealthStream = VenueHealthStream.decode(reader, reader.uint32())
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.alpacaNewsStream = AlpacaNewsStream.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.twitterStream = TwitterStream.decode(reader, reader.uint32())
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.coinmarketcalEventStream = CoinMarketCalEventStream.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.tokenUnlockStream = TokenUnlockStream.decode(reader, reader.uint32())
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.treeNewsStream = TreeNewsStream.decode(reader, reader.uint32())
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.marketScreenerStream = MarketScreenerStream.decode(reader, reader.uint32())
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.orderbookHeatmapStream = OrderbookHeatmapStream.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MessageSubject {
    return {
      marketDataStream: isSet(object.marketDataStream)
        ? MarketDataStream.fromJSON(object.marketDataStream)
        : isSet(object.market_data_stream)
          ? MarketDataStream.fromJSON(object.market_data_stream)
          : undefined,
      exchangeData: isSet(object.exchangeData)
        ? ExchangeData.fromJSON(object.exchangeData)
        : isSet(object.exchange_data)
          ? ExchangeData.fromJSON(object.exchange_data)
          : undefined,
      account: isSet(object.account) ? AccountData.fromJSON(object.account) : undefined,
      accountStream: isSet(object.accountStream)
        ? AccountDataStream.fromJSON(object.accountStream)
        : isSet(object.account_stream)
          ? AccountDataStream.fromJSON(object.account_stream)
          : undefined,
      execution: isSet(object.execution) ? Execution.fromJSON(object.execution) : undefined,
      chartDataStream: isSet(object.chartDataStream)
        ? ChartDataStream.fromJSON(object.chartDataStream)
        : isSet(object.chart_data_stream)
          ? ChartDataStream.fromJSON(object.chart_data_stream)
          : undefined,
      serviceNotifications: isSet(object.serviceNotifications)
        ? Notifications.fromJSON(object.serviceNotifications)
        : isSet(object.service_notifications)
          ? Notifications.fromJSON(object.service_notifications)
          : undefined,
      economicCalendarStream: isSet(object.economicCalendarStream)
        ? EconomicCalendarStream.fromJSON(object.economicCalendarStream)
        : isSet(object.economic_calendar_stream)
          ? EconomicCalendarStream.fromJSON(object.economic_calendar_stream)
          : undefined,
      executionAnalyticsStream: isSet(object.executionAnalyticsStream)
        ? ExecutionAnalyticsStream.fromJSON(object.executionAnalyticsStream)
        : isSet(object.execution_analytics_stream)
          ? ExecutionAnalyticsStream.fromJSON(object.execution_analytics_stream)
          : undefined,
      analyticsStream: isSet(object.analyticsStream)
        ? AnalyticsStream.fromJSON(object.analyticsStream)
        : isSet(object.analytics_stream)
          ? AnalyticsStream.fromJSON(object.analytics_stream)
          : undefined,
      dbNewsStream: isSet(object.dbNewsStream)
        ? DbNewsStream.fromJSON(object.dbNewsStream)
        : isSet(object.db_news_stream)
          ? DbNewsStream.fromJSON(object.db_news_stream)
          : undefined,
      triggerConditionStream: isSet(object.triggerConditionStream)
        ? TriggerConditionStream.fromJSON(object.triggerConditionStream)
        : isSet(object.trigger_condition_stream)
          ? TriggerConditionStream.fromJSON(object.trigger_condition_stream)
          : undefined,
      optionsVolumeStream: isSet(object.optionsVolumeStream)
        ? OptionsVolumeStream.fromJSON(object.optionsVolumeStream)
        : isSet(object.options_volume_stream)
          ? OptionsVolumeStream.fromJSON(object.options_volume_stream)
          : undefined,
      optionsTradesStream: isSet(object.optionsTradesStream)
        ? OptionsTradesStream.fromJSON(object.optionsTradesStream)
        : isSet(object.options_trades_stream)
          ? OptionsTradesStream.fromJSON(object.options_trades_stream)
          : undefined,
      exchangeStatusStream: isSet(object.exchangeStatusStream)
        ? ExchangeStatusStream.fromJSON(object.exchangeStatusStream)
        : isSet(object.exchange_status_stream)
          ? ExchangeStatusStream.fromJSON(object.exchange_status_stream)
          : undefined,
      polymarketSignalStream: isSet(object.polymarketSignalStream)
        ? PolymarketSignalStream.fromJSON(object.polymarketSignalStream)
        : isSet(object.polymarket_signal_stream)
          ? PolymarketSignalStream.fromJSON(object.polymarket_signal_stream)
          : undefined,
      venueHealthStream: isSet(object.venueHealthStream)
        ? VenueHealthStream.fromJSON(object.venueHealthStream)
        : isSet(object.venue_health_stream)
          ? VenueHealthStream.fromJSON(object.venue_health_stream)
          : undefined,
      alpacaNewsStream: isSet(object.alpacaNewsStream)
        ? AlpacaNewsStream.fromJSON(object.alpacaNewsStream)
        : isSet(object.alpaca_news_stream)
          ? AlpacaNewsStream.fromJSON(object.alpaca_news_stream)
          : undefined,
      twitterStream: isSet(object.twitterStream)
        ? TwitterStream.fromJSON(object.twitterStream)
        : isSet(object.twitter_stream)
          ? TwitterStream.fromJSON(object.twitter_stream)
          : undefined,
      coinmarketcalEventStream: isSet(object.coinmarketcalEventStream)
        ? CoinMarketCalEventStream.fromJSON(object.coinmarketcalEventStream)
        : isSet(object.coinmarketcal_event_stream)
          ? CoinMarketCalEventStream.fromJSON(object.coinmarketcal_event_stream)
          : undefined,
      tokenUnlockStream: isSet(object.tokenUnlockStream)
        ? TokenUnlockStream.fromJSON(object.tokenUnlockStream)
        : isSet(object.token_unlock_stream)
          ? TokenUnlockStream.fromJSON(object.token_unlock_stream)
          : undefined,
      treeNewsStream: isSet(object.treeNewsStream)
        ? TreeNewsStream.fromJSON(object.treeNewsStream)
        : isSet(object.tree_news_stream)
          ? TreeNewsStream.fromJSON(object.tree_news_stream)
          : undefined,
      marketScreenerStream: isSet(object.marketScreenerStream)
        ? MarketScreenerStream.fromJSON(object.marketScreenerStream)
        : isSet(object.market_screener_stream)
          ? MarketScreenerStream.fromJSON(object.market_screener_stream)
          : undefined,
      orderbookHeatmapStream: isSet(object.orderbookHeatmapStream)
        ? OrderbookHeatmapStream.fromJSON(object.orderbookHeatmapStream)
        : isSet(object.orderbook_heatmap_stream)
          ? OrderbookHeatmapStream.fromJSON(object.orderbook_heatmap_stream)
          : undefined,
    }
  },

  toJSON(message: MessageSubject): unknown {
    const obj: any = {}
    if (message.marketDataStream !== undefined) {
      obj.marketDataStream = MarketDataStream.toJSON(message.marketDataStream)
    }
    if (message.exchangeData !== undefined) {
      obj.exchangeData = ExchangeData.toJSON(message.exchangeData)
    }
    if (message.account !== undefined) {
      obj.account = AccountData.toJSON(message.account)
    }
    if (message.accountStream !== undefined) {
      obj.accountStream = AccountDataStream.toJSON(message.accountStream)
    }
    if (message.execution !== undefined) {
      obj.execution = Execution.toJSON(message.execution)
    }
    if (message.chartDataStream !== undefined) {
      obj.chartDataStream = ChartDataStream.toJSON(message.chartDataStream)
    }
    if (message.serviceNotifications !== undefined) {
      obj.serviceNotifications = Notifications.toJSON(message.serviceNotifications)
    }
    if (message.economicCalendarStream !== undefined) {
      obj.economicCalendarStream = EconomicCalendarStream.toJSON(message.economicCalendarStream)
    }
    if (message.executionAnalyticsStream !== undefined) {
      obj.executionAnalyticsStream = ExecutionAnalyticsStream.toJSON(
        message.executionAnalyticsStream
      )
    }
    if (message.analyticsStream !== undefined) {
      obj.analyticsStream = AnalyticsStream.toJSON(message.analyticsStream)
    }
    if (message.dbNewsStream !== undefined) {
      obj.dbNewsStream = DbNewsStream.toJSON(message.dbNewsStream)
    }
    if (message.triggerConditionStream !== undefined) {
      obj.triggerConditionStream = TriggerConditionStream.toJSON(message.triggerConditionStream)
    }
    if (message.optionsVolumeStream !== undefined) {
      obj.optionsVolumeStream = OptionsVolumeStream.toJSON(message.optionsVolumeStream)
    }
    if (message.optionsTradesStream !== undefined) {
      obj.optionsTradesStream = OptionsTradesStream.toJSON(message.optionsTradesStream)
    }
    if (message.exchangeStatusStream !== undefined) {
      obj.exchangeStatusStream = ExchangeStatusStream.toJSON(message.exchangeStatusStream)
    }
    if (message.polymarketSignalStream !== undefined) {
      obj.polymarketSignalStream = PolymarketSignalStream.toJSON(message.polymarketSignalStream)
    }
    if (message.venueHealthStream !== undefined) {
      obj.venueHealthStream = VenueHealthStream.toJSON(message.venueHealthStream)
    }
    if (message.alpacaNewsStream !== undefined) {
      obj.alpacaNewsStream = AlpacaNewsStream.toJSON(message.alpacaNewsStream)
    }
    if (message.twitterStream !== undefined) {
      obj.twitterStream = TwitterStream.toJSON(message.twitterStream)
    }
    if (message.coinmarketcalEventStream !== undefined) {
      obj.coinmarketcalEventStream = CoinMarketCalEventStream.toJSON(
        message.coinmarketcalEventStream
      )
    }
    if (message.tokenUnlockStream !== undefined) {
      obj.tokenUnlockStream = TokenUnlockStream.toJSON(message.tokenUnlockStream)
    }
    if (message.treeNewsStream !== undefined) {
      obj.treeNewsStream = TreeNewsStream.toJSON(message.treeNewsStream)
    }
    if (message.marketScreenerStream !== undefined) {
      obj.marketScreenerStream = MarketScreenerStream.toJSON(message.marketScreenerStream)
    }
    if (message.orderbookHeatmapStream !== undefined) {
      obj.orderbookHeatmapStream = OrderbookHeatmapStream.toJSON(message.orderbookHeatmapStream)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MessageSubject>, I>>(base?: I): MessageSubject {
    return MessageSubject.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MessageSubject>, I>>(object: I): MessageSubject {
    const message = createBaseMessageSubject()
    message.marketDataStream =
      object.marketDataStream !== undefined && object.marketDataStream !== null
        ? MarketDataStream.fromPartial(object.marketDataStream)
        : undefined
    message.exchangeData =
      object.exchangeData !== undefined && object.exchangeData !== null
        ? ExchangeData.fromPartial(object.exchangeData)
        : undefined
    message.account =
      object.account !== undefined && object.account !== null
        ? AccountData.fromPartial(object.account)
        : undefined
    message.accountStream =
      object.accountStream !== undefined && object.accountStream !== null
        ? AccountDataStream.fromPartial(object.accountStream)
        : undefined
    message.execution =
      object.execution !== undefined && object.execution !== null
        ? Execution.fromPartial(object.execution)
        : undefined
    message.chartDataStream =
      object.chartDataStream !== undefined && object.chartDataStream !== null
        ? ChartDataStream.fromPartial(object.chartDataStream)
        : undefined
    message.serviceNotifications =
      object.serviceNotifications !== undefined && object.serviceNotifications !== null
        ? Notifications.fromPartial(object.serviceNotifications)
        : undefined
    message.economicCalendarStream =
      object.economicCalendarStream !== undefined && object.economicCalendarStream !== null
        ? EconomicCalendarStream.fromPartial(object.economicCalendarStream)
        : undefined
    message.executionAnalyticsStream =
      object.executionAnalyticsStream !== undefined && object.executionAnalyticsStream !== null
        ? ExecutionAnalyticsStream.fromPartial(object.executionAnalyticsStream)
        : undefined
    message.analyticsStream =
      object.analyticsStream !== undefined && object.analyticsStream !== null
        ? AnalyticsStream.fromPartial(object.analyticsStream)
        : undefined
    message.dbNewsStream =
      object.dbNewsStream !== undefined && object.dbNewsStream !== null
        ? DbNewsStream.fromPartial(object.dbNewsStream)
        : undefined
    message.triggerConditionStream =
      object.triggerConditionStream !== undefined && object.triggerConditionStream !== null
        ? TriggerConditionStream.fromPartial(object.triggerConditionStream)
        : undefined
    message.optionsVolumeStream =
      object.optionsVolumeStream !== undefined && object.optionsVolumeStream !== null
        ? OptionsVolumeStream.fromPartial(object.optionsVolumeStream)
        : undefined
    message.optionsTradesStream =
      object.optionsTradesStream !== undefined && object.optionsTradesStream !== null
        ? OptionsTradesStream.fromPartial(object.optionsTradesStream)
        : undefined
    message.exchangeStatusStream =
      object.exchangeStatusStream !== undefined && object.exchangeStatusStream !== null
        ? ExchangeStatusStream.fromPartial(object.exchangeStatusStream)
        : undefined
    message.polymarketSignalStream =
      object.polymarketSignalStream !== undefined && object.polymarketSignalStream !== null
        ? PolymarketSignalStream.fromPartial(object.polymarketSignalStream)
        : undefined
    message.venueHealthStream =
      object.venueHealthStream !== undefined && object.venueHealthStream !== null
        ? VenueHealthStream.fromPartial(object.venueHealthStream)
        : undefined
    message.alpacaNewsStream =
      object.alpacaNewsStream !== undefined && object.alpacaNewsStream !== null
        ? AlpacaNewsStream.fromPartial(object.alpacaNewsStream)
        : undefined
    message.twitterStream =
      object.twitterStream !== undefined && object.twitterStream !== null
        ? TwitterStream.fromPartial(object.twitterStream)
        : undefined
    message.coinmarketcalEventStream =
      object.coinmarketcalEventStream !== undefined && object.coinmarketcalEventStream !== null
        ? CoinMarketCalEventStream.fromPartial(object.coinmarketcalEventStream)
        : undefined
    message.tokenUnlockStream =
      object.tokenUnlockStream !== undefined && object.tokenUnlockStream !== null
        ? TokenUnlockStream.fromPartial(object.tokenUnlockStream)
        : undefined
    message.treeNewsStream =
      object.treeNewsStream !== undefined && object.treeNewsStream !== null
        ? TreeNewsStream.fromPartial(object.treeNewsStream)
        : undefined
    message.marketScreenerStream =
      object.marketScreenerStream !== undefined && object.marketScreenerStream !== null
        ? MarketScreenerStream.fromPartial(object.marketScreenerStream)
        : undefined
    message.orderbookHeatmapStream =
      object.orderbookHeatmapStream !== undefined && object.orderbookHeatmapStream !== null
        ? OrderbookHeatmapStream.fromPartial(object.orderbookHeatmapStream)
        : undefined
    return message
  },
}

function createBaseEconomicCalendarStream(): EconomicCalendarStream {
  return {}
}

export const EconomicCalendarStream: MessageFns<EconomicCalendarStream> = {
  encode(_: EconomicCalendarStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicCalendarStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicCalendarStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): EconomicCalendarStream {
    return {}
  },

  toJSON(_: EconomicCalendarStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicCalendarStream>, I>>(
    base?: I
  ): EconomicCalendarStream {
    return EconomicCalendarStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicCalendarStream>, I>>(
    _: I
  ): EconomicCalendarStream {
    const message = createBaseEconomicCalendarStream()
    return message
  },
}

function createBaseEconomicCalendarHistoryRequest(): EconomicCalendarHistoryRequest {
  return {
    from: undefined,
    to: undefined,
    limit: undefined,
    offset: undefined,
    eventId: undefined,
    eeType: undefined,
  }
}

export const EconomicCalendarHistoryRequest: MessageFns<EconomicCalendarHistoryRequest> = {
  encode(
    message: EconomicCalendarHistoryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.from !== undefined) {
      writer.uint32(8).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(16).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(24).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(32).int32(message.offset)
    }
    if (message.eventId !== undefined) {
      writer.uint32(42).string(message.eventId)
    }
    if (message.eeType !== undefined) {
      writer.uint32(50).string(message.eeType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicCalendarHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicCalendarHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.eventId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.eeType = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicCalendarHistoryRequest {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      eventId: isSet(object.eventId)
        ? globalThis.String(object.eventId)
        : isSet(object.event_id)
          ? globalThis.String(object.event_id)
          : undefined,
      eeType: isSet(object.eeType)
        ? globalThis.String(object.eeType)
        : isSet(object.ee_type)
          ? globalThis.String(object.ee_type)
          : undefined,
    }
  },

  toJSON(message: EconomicCalendarHistoryRequest): unknown {
    const obj: any = {}
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.eventId !== undefined) {
      obj.eventId = message.eventId
    }
    if (message.eeType !== undefined) {
      obj.eeType = message.eeType
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicCalendarHistoryRequest>, I>>(
    base?: I
  ): EconomicCalendarHistoryRequest {
    return EconomicCalendarHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicCalendarHistoryRequest>, I>>(
    object: I
  ): EconomicCalendarHistoryRequest {
    const message = createBaseEconomicCalendarHistoryRequest()
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.eventId = object.eventId ?? undefined
    message.eeType = object.eeType ?? undefined
    return message
  },
}

function createBaseEconomicCalendarEventList(): EconomicCalendarEventList {
  return { events: [] }
}

export const EconomicCalendarEventList: MessageFns<EconomicCalendarEventList> = {
  encode(
    message: EconomicCalendarEventList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.events) {
      EconomicCalendarEvent.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicCalendarEventList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicCalendarEventList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.events.push(EconomicCalendarEvent.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicCalendarEventList {
    return {
      events: globalThis.Array.isArray(object?.events)
        ? object.events.map((e: any) => EconomicCalendarEvent.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EconomicCalendarEventList): unknown {
    const obj: any = {}
    if (message.events?.length) {
      obj.events = message.events.map((e) => EconomicCalendarEvent.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicCalendarEventList>, I>>(
    base?: I
  ): EconomicCalendarEventList {
    return EconomicCalendarEventList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicCalendarEventList>, I>>(
    object: I
  ): EconomicCalendarEventList {
    const message = createBaseEconomicCalendarEventList()
    message.events = object.events?.map((e) => EconomicCalendarEvent.fromPartial(e)) || []
    return message
  },
}

function createBaseEconomicCalendarEvent(): EconomicCalendarEvent {
  return {
    eventId: '',
    eventDateId: '',
    name: '',
    countryCode: '',
    currencyCode: '',
    dateUtc: '0',
    volatility: undefined,
    potency: undefined,
    actual: undefined,
    revised: undefined,
    consensus: undefined,
    previous: undefined,
    ratioDeviation: undefined,
    isBetterThanExpected: undefined,
    isAllDay: false,
    isTentative: false,
    isPreliminary: false,
    isReport: undefined,
    isSpeech: undefined,
    unit: undefined,
    periodDateUtc: undefined,
    periodType: undefined,
    lastUpdated: undefined,
  }
}

export const EconomicCalendarEvent: MessageFns<EconomicCalendarEvent> = {
  encode(message: EconomicCalendarEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventId !== '') {
      writer.uint32(10).string(message.eventId)
    }
    if (message.eventDateId !== '') {
      writer.uint32(18).string(message.eventDateId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.countryCode !== '') {
      writer.uint32(34).string(message.countryCode)
    }
    if (message.currencyCode !== '') {
      writer.uint32(42).string(message.currencyCode)
    }
    if (message.dateUtc !== '0') {
      writer.uint32(48).int64(message.dateUtc)
    }
    if (message.volatility !== undefined) {
      writer.uint32(56).int32(message.volatility)
    }
    if (message.potency !== undefined) {
      writer.uint32(64).int32(message.potency)
    }
    if (message.actual !== undefined) {
      writer.uint32(73).double(message.actual)
    }
    if (message.revised !== undefined) {
      writer.uint32(81).double(message.revised)
    }
    if (message.consensus !== undefined) {
      writer.uint32(89).double(message.consensus)
    }
    if (message.previous !== undefined) {
      writer.uint32(97).double(message.previous)
    }
    if (message.ratioDeviation !== undefined) {
      writer.uint32(105).double(message.ratioDeviation)
    }
    if (message.isBetterThanExpected !== undefined) {
      writer.uint32(112).bool(message.isBetterThanExpected)
    }
    if (message.isAllDay !== false) {
      writer.uint32(120).bool(message.isAllDay)
    }
    if (message.isTentative !== false) {
      writer.uint32(128).bool(message.isTentative)
    }
    if (message.isPreliminary !== false) {
      writer.uint32(136).bool(message.isPreliminary)
    }
    if (message.isReport !== undefined) {
      writer.uint32(144).bool(message.isReport)
    }
    if (message.isSpeech !== undefined) {
      writer.uint32(152).bool(message.isSpeech)
    }
    if (message.unit !== undefined) {
      writer.uint32(162).string(message.unit)
    }
    if (message.periodDateUtc !== undefined) {
      writer.uint32(168).int64(message.periodDateUtc)
    }
    if (message.periodType !== undefined) {
      writer.uint32(176).int32(message.periodType)
    }
    if (message.lastUpdated !== undefined) {
      writer.uint32(184).int64(message.lastUpdated)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicCalendarEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicCalendarEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.eventId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.eventDateId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.countryCode = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.currencyCode = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.dateUtc = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.volatility = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.potency = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 73) {
            break
          }

          message.actual = reader.double()
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.revised = reader.double()
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.consensus = reader.double()
          continue
        }
        case 12: {
          if (tag !== 97) {
            break
          }

          message.previous = reader.double()
          continue
        }
        case 13: {
          if (tag !== 105) {
            break
          }

          message.ratioDeviation = reader.double()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.isBetterThanExpected = reader.bool()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.isAllDay = reader.bool()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.isTentative = reader.bool()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.isPreliminary = reader.bool()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.isReport = reader.bool()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.isSpeech = reader.bool()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.unit = reader.string()
          continue
        }
        case 21: {
          if (tag !== 168) {
            break
          }

          message.periodDateUtc = reader.int64().toString()
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.periodType = reader.int32() as any
          continue
        }
        case 23: {
          if (tag !== 184) {
            break
          }

          message.lastUpdated = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicCalendarEvent {
    return {
      eventId: isSet(object.eventId)
        ? globalThis.String(object.eventId)
        : isSet(object.event_id)
          ? globalThis.String(object.event_id)
          : '',
      eventDateId: isSet(object.eventDateId)
        ? globalThis.String(object.eventDateId)
        : isSet(object.event_date_id)
          ? globalThis.String(object.event_date_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      countryCode: isSet(object.countryCode)
        ? globalThis.String(object.countryCode)
        : isSet(object.country_code)
          ? globalThis.String(object.country_code)
          : '',
      currencyCode: isSet(object.currencyCode)
        ? globalThis.String(object.currencyCode)
        : isSet(object.currency_code)
          ? globalThis.String(object.currency_code)
          : '',
      dateUtc: isSet(object.dateUtc)
        ? globalThis.String(object.dateUtc)
        : isSet(object.date_utc)
          ? globalThis.String(object.date_utc)
          : '0',
      volatility: isSet(object.volatility) ? eventVolatilityFromJSON(object.volatility) : undefined,
      potency: isSet(object.potency) ? eventPotencyFromJSON(object.potency) : undefined,
      actual: isSet(object.actual) ? globalThis.Number(object.actual) : undefined,
      revised: isSet(object.revised) ? globalThis.Number(object.revised) : undefined,
      consensus: isSet(object.consensus) ? globalThis.Number(object.consensus) : undefined,
      previous: isSet(object.previous) ? globalThis.Number(object.previous) : undefined,
      ratioDeviation: isSet(object.ratioDeviation)
        ? globalThis.Number(object.ratioDeviation)
        : isSet(object.ratio_deviation)
          ? globalThis.Number(object.ratio_deviation)
          : undefined,
      isBetterThanExpected: isSet(object.isBetterThanExpected)
        ? globalThis.Boolean(object.isBetterThanExpected)
        : isSet(object.is_better_than_expected)
          ? globalThis.Boolean(object.is_better_than_expected)
          : undefined,
      isAllDay: isSet(object.isAllDay)
        ? globalThis.Boolean(object.isAllDay)
        : isSet(object.is_all_day)
          ? globalThis.Boolean(object.is_all_day)
          : false,
      isTentative: isSet(object.isTentative)
        ? globalThis.Boolean(object.isTentative)
        : isSet(object.is_tentative)
          ? globalThis.Boolean(object.is_tentative)
          : false,
      isPreliminary: isSet(object.isPreliminary)
        ? globalThis.Boolean(object.isPreliminary)
        : isSet(object.is_preliminary)
          ? globalThis.Boolean(object.is_preliminary)
          : false,
      isReport: isSet(object.isReport)
        ? globalThis.Boolean(object.isReport)
        : isSet(object.is_report)
          ? globalThis.Boolean(object.is_report)
          : undefined,
      isSpeech: isSet(object.isSpeech)
        ? globalThis.Boolean(object.isSpeech)
        : isSet(object.is_speech)
          ? globalThis.Boolean(object.is_speech)
          : undefined,
      unit: isSet(object.unit) ? globalThis.String(object.unit) : undefined,
      periodDateUtc: isSet(object.periodDateUtc)
        ? globalThis.String(object.periodDateUtc)
        : isSet(object.period_date_utc)
          ? globalThis.String(object.period_date_utc)
          : undefined,
      periodType: isSet(object.periodType)
        ? eventPeriodTypeFromJSON(object.periodType)
        : isSet(object.period_type)
          ? eventPeriodTypeFromJSON(object.period_type)
          : undefined,
      lastUpdated: isSet(object.lastUpdated)
        ? globalThis.String(object.lastUpdated)
        : isSet(object.last_updated)
          ? globalThis.String(object.last_updated)
          : undefined,
    }
  },

  toJSON(message: EconomicCalendarEvent): unknown {
    const obj: any = {}
    if (message.eventId !== '') {
      obj.eventId = message.eventId
    }
    if (message.eventDateId !== '') {
      obj.eventDateId = message.eventDateId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.countryCode !== '') {
      obj.countryCode = message.countryCode
    }
    if (message.currencyCode !== '') {
      obj.currencyCode = message.currencyCode
    }
    if (message.dateUtc !== '0') {
      obj.dateUtc = message.dateUtc
    }
    if (message.volatility !== undefined) {
      obj.volatility = eventVolatilityToJSON(message.volatility)
    }
    if (message.potency !== undefined) {
      obj.potency = eventPotencyToJSON(message.potency)
    }
    if (message.actual !== undefined) {
      obj.actual = message.actual
    }
    if (message.revised !== undefined) {
      obj.revised = message.revised
    }
    if (message.consensus !== undefined) {
      obj.consensus = message.consensus
    }
    if (message.previous !== undefined) {
      obj.previous = message.previous
    }
    if (message.ratioDeviation !== undefined) {
      obj.ratioDeviation = message.ratioDeviation
    }
    if (message.isBetterThanExpected !== undefined) {
      obj.isBetterThanExpected = message.isBetterThanExpected
    }
    if (message.isAllDay !== false) {
      obj.isAllDay = message.isAllDay
    }
    if (message.isTentative !== false) {
      obj.isTentative = message.isTentative
    }
    if (message.isPreliminary !== false) {
      obj.isPreliminary = message.isPreliminary
    }
    if (message.isReport !== undefined) {
      obj.isReport = message.isReport
    }
    if (message.isSpeech !== undefined) {
      obj.isSpeech = message.isSpeech
    }
    if (message.unit !== undefined) {
      obj.unit = message.unit
    }
    if (message.periodDateUtc !== undefined) {
      obj.periodDateUtc = message.periodDateUtc
    }
    if (message.periodType !== undefined) {
      obj.periodType = eventPeriodTypeToJSON(message.periodType)
    }
    if (message.lastUpdated !== undefined) {
      obj.lastUpdated = message.lastUpdated
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicCalendarEvent>, I>>(base?: I): EconomicCalendarEvent {
    return EconomicCalendarEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicCalendarEvent>, I>>(
    object: I
  ): EconomicCalendarEvent {
    const message = createBaseEconomicCalendarEvent()
    message.eventId = object.eventId ?? ''
    message.eventDateId = object.eventDateId ?? ''
    message.name = object.name ?? ''
    message.countryCode = object.countryCode ?? ''
    message.currencyCode = object.currencyCode ?? ''
    message.dateUtc = object.dateUtc ?? '0'
    message.volatility = object.volatility ?? undefined
    message.potency = object.potency ?? undefined
    message.actual = object.actual ?? undefined
    message.revised = object.revised ?? undefined
    message.consensus = object.consensus ?? undefined
    message.previous = object.previous ?? undefined
    message.ratioDeviation = object.ratioDeviation ?? undefined
    message.isBetterThanExpected = object.isBetterThanExpected ?? undefined
    message.isAllDay = object.isAllDay ?? false
    message.isTentative = object.isTentative ?? false
    message.isPreliminary = object.isPreliminary ?? false
    message.isReport = object.isReport ?? undefined
    message.isSpeech = object.isSpeech ?? undefined
    message.unit = object.unit ?? undefined
    message.periodDateUtc = object.periodDateUtc ?? undefined
    message.periodType = object.periodType ?? undefined
    message.lastUpdated = object.lastUpdated ?? undefined
    return message
  },
}

function createBaseDbNewsStream(): DbNewsStream {
  return {}
}

export const DbNewsStream: MessageFns<DbNewsStream> = {
  encode(_: DbNewsStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): DbNewsStream {
    return {}
  },

  toJSON(_: DbNewsStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsStream>, I>>(base?: I): DbNewsStream {
    return DbNewsStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsStream>, I>>(_: I): DbNewsStream {
    const message = createBaseDbNewsStream()
    return message
  },
}

function createBaseDbNewsCoinReason(): DbNewsCoinReason {
  return { reason: '', matches: [] }
}

export const DbNewsCoinReason: MessageFns<DbNewsCoinReason> = {
  encode(message: DbNewsCoinReason, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== '') {
      writer.uint32(10).string(message.reason)
    }
    for (const v of message.matches) {
      writer.uint32(18).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsCoinReason {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsCoinReason()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.reason = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.matches.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsCoinReason {
    return {
      reason: isSet(object.reason) ? globalThis.String(object.reason) : '',
      matches: globalThis.Array.isArray(object?.matches)
        ? object.matches.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: DbNewsCoinReason): unknown {
    const obj: any = {}
    if (message.reason !== '') {
      obj.reason = message.reason
    }
    if (message.matches?.length) {
      obj.matches = message.matches
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsCoinReason>, I>>(base?: I): DbNewsCoinReason {
    return DbNewsCoinReason.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsCoinReason>, I>>(object: I): DbNewsCoinReason {
    const message = createBaseDbNewsCoinReason()
    message.reason = object.reason ?? ''
    message.matches = object.matches?.map((e) => e) || []
    return message
  },
}

function createBaseDbNewsPost(): DbNewsPost {
  return {
    postId: '',
    newsType: '',
    text: '',
    link: '',
    description: '',
    coins: [],
    coinReasons: [],
    eeType: '',
    filterReasons: [],
    highlightedWords: [],
    tweeterHandle: '',
    telegramId: '',
    avatarLink: '',
    img: '',
    tags: [],
    ts: '',
  }
}

export const DbNewsPost: MessageFns<DbNewsPost> = {
  encode(message: DbNewsPost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.postId !== '') {
      writer.uint32(10).string(message.postId)
    }
    if (message.newsType !== '') {
      writer.uint32(18).string(message.newsType)
    }
    if (message.text !== '') {
      writer.uint32(26).string(message.text)
    }
    if (message.link !== '') {
      writer.uint32(34).string(message.link)
    }
    if (message.description !== '') {
      writer.uint32(42).string(message.description)
    }
    for (const v of message.coins) {
      writer.uint32(50).string(v!)
    }
    for (const v of message.coinReasons) {
      DbNewsCoinReason.encode(v!, writer.uint32(58).fork()).join()
    }
    if (message.eeType !== '') {
      writer.uint32(66).string(message.eeType)
    }
    for (const v of message.filterReasons) {
      writer.uint32(74).string(v!)
    }
    for (const v of message.highlightedWords) {
      writer.uint32(82).string(v!)
    }
    if (message.tweeterHandle !== '') {
      writer.uint32(90).string(message.tweeterHandle)
    }
    if (message.telegramId !== '') {
      writer.uint32(98).string(message.telegramId)
    }
    if (message.avatarLink !== '') {
      writer.uint32(106).string(message.avatarLink)
    }
    if (message.img !== '') {
      writer.uint32(114).string(message.img)
    }
    for (const v of message.tags) {
      writer.uint32(122).string(v!)
    }
    if (message.ts !== '') {
      writer.uint32(130).string(message.ts)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsPost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsPost()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.postId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.newsType = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.link = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.description = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.coins.push(reader.string())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.coinReasons.push(DbNewsCoinReason.decode(reader, reader.uint32()))
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.eeType = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.filterReasons.push(reader.string())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.highlightedWords.push(reader.string())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.tweeterHandle = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.telegramId = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.avatarLink = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.img = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.tags.push(reader.string())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.ts = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsPost {
    return {
      postId: isSet(object.postId)
        ? globalThis.String(object.postId)
        : isSet(object.post_id)
          ? globalThis.String(object.post_id)
          : '',
      newsType: isSet(object.newsType)
        ? globalThis.String(object.newsType)
        : isSet(object.news_type)
          ? globalThis.String(object.news_type)
          : '',
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      link: isSet(object.link) ? globalThis.String(object.link) : '',
      description: isSet(object.description) ? globalThis.String(object.description) : '',
      coins: globalThis.Array.isArray(object?.coins)
        ? object.coins.map((e: any) => globalThis.String(e))
        : [],
      coinReasons: globalThis.Array.isArray(object?.coinReasons)
        ? object.coinReasons.map((e: any) => DbNewsCoinReason.fromJSON(e))
        : globalThis.Array.isArray(object?.coin_reasons)
          ? object.coin_reasons.map((e: any) => DbNewsCoinReason.fromJSON(e))
          : [],
      eeType: isSet(object.eeType)
        ? globalThis.String(object.eeType)
        : isSet(object.ee_type)
          ? globalThis.String(object.ee_type)
          : '',
      filterReasons: globalThis.Array.isArray(object?.filterReasons)
        ? object.filterReasons.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.filter_reasons)
          ? object.filter_reasons.map((e: any) => globalThis.String(e))
          : [],
      highlightedWords: globalThis.Array.isArray(object?.highlightedWords)
        ? object.highlightedWords.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.highlighted_words)
          ? object.highlighted_words.map((e: any) => globalThis.String(e))
          : [],
      tweeterHandle: isSet(object.tweeterHandle)
        ? globalThis.String(object.tweeterHandle)
        : isSet(object.tweeter_handle)
          ? globalThis.String(object.tweeter_handle)
          : '',
      telegramId: isSet(object.telegramId)
        ? globalThis.String(object.telegramId)
        : isSet(object.telegram_id)
          ? globalThis.String(object.telegram_id)
          : '',
      avatarLink: isSet(object.avatarLink)
        ? globalThis.String(object.avatarLink)
        : isSet(object.avatar_link)
          ? globalThis.String(object.avatar_link)
          : '',
      img: isSet(object.img) ? globalThis.String(object.img) : '',
      tags: globalThis.Array.isArray(object?.tags)
        ? object.tags.map((e: any) => globalThis.String(e))
        : [],
      ts: isSet(object.ts) ? globalThis.String(object.ts) : '',
    }
  },

  toJSON(message: DbNewsPost): unknown {
    const obj: any = {}
    if (message.postId !== '') {
      obj.postId = message.postId
    }
    if (message.newsType !== '') {
      obj.newsType = message.newsType
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.link !== '') {
      obj.link = message.link
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    if (message.coins?.length) {
      obj.coins = message.coins
    }
    if (message.coinReasons?.length) {
      obj.coinReasons = message.coinReasons.map((e) => DbNewsCoinReason.toJSON(e))
    }
    if (message.eeType !== '') {
      obj.eeType = message.eeType
    }
    if (message.filterReasons?.length) {
      obj.filterReasons = message.filterReasons
    }
    if (message.highlightedWords?.length) {
      obj.highlightedWords = message.highlightedWords
    }
    if (message.tweeterHandle !== '') {
      obj.tweeterHandle = message.tweeterHandle
    }
    if (message.telegramId !== '') {
      obj.telegramId = message.telegramId
    }
    if (message.avatarLink !== '') {
      obj.avatarLink = message.avatarLink
    }
    if (message.img !== '') {
      obj.img = message.img
    }
    if (message.tags?.length) {
      obj.tags = message.tags
    }
    if (message.ts !== '') {
      obj.ts = message.ts
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsPost>, I>>(base?: I): DbNewsPost {
    return DbNewsPost.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsPost>, I>>(object: I): DbNewsPost {
    const message = createBaseDbNewsPost()
    message.postId = object.postId ?? ''
    message.newsType = object.newsType ?? ''
    message.text = object.text ?? ''
    message.link = object.link ?? ''
    message.description = object.description ?? ''
    message.coins = object.coins?.map((e) => e) || []
    message.coinReasons = object.coinReasons?.map((e) => DbNewsCoinReason.fromPartial(e)) || []
    message.eeType = object.eeType ?? ''
    message.filterReasons = object.filterReasons?.map((e) => e) || []
    message.highlightedWords = object.highlightedWords?.map((e) => e) || []
    message.tweeterHandle = object.tweeterHandle ?? ''
    message.telegramId = object.telegramId ?? ''
    message.avatarLink = object.avatarLink ?? ''
    message.img = object.img ?? ''
    message.tags = object.tags?.map((e) => e) || []
    message.ts = object.ts ?? ''
    return message
  },
}

function createBaseDbNewsHistoryRequest(): DbNewsHistoryRequest {
  return {
    limit: undefined,
    offset: undefined,
    from: undefined,
    to: undefined,
    newsType: undefined,
    coin: undefined,
  }
}

export const DbNewsHistoryRequest: MessageFns<DbNewsHistoryRequest> = {
  encode(message: DbNewsHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== undefined) {
      writer.uint32(8).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(16).int32(message.offset)
    }
    if (message.from !== undefined) {
      writer.uint32(24).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(32).int64(message.to)
    }
    if (message.newsType !== undefined) {
      writer.uint32(42).string(message.newsType)
    }
    if (message.coin !== undefined) {
      writer.uint32(50).string(message.coin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.newsType = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.coin = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsHistoryRequest {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      newsType: isSet(object.newsType)
        ? globalThis.String(object.newsType)
        : isSet(object.news_type)
          ? globalThis.String(object.news_type)
          : undefined,
      coin: isSet(object.coin) ? globalThis.String(object.coin) : undefined,
    }
  },

  toJSON(message: DbNewsHistoryRequest): unknown {
    const obj: any = {}
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.newsType !== undefined) {
      obj.newsType = message.newsType
    }
    if (message.coin !== undefined) {
      obj.coin = message.coin
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsHistoryRequest>, I>>(base?: I): DbNewsHistoryRequest {
    return DbNewsHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsHistoryRequest>, I>>(
    object: I
  ): DbNewsHistoryRequest {
    const message = createBaseDbNewsHistoryRequest()
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.newsType = object.newsType ?? undefined
    message.coin = object.coin ?? undefined
    return message
  },
}

function createBaseDbNewsPostList(): DbNewsPostList {
  return { posts: [] }
}

export const DbNewsPostList: MessageFns<DbNewsPostList> = {
  encode(message: DbNewsPostList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.posts) {
      DbNewsPost.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsPostList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsPostList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.posts.push(DbNewsPost.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsPostList {
    return {
      posts: globalThis.Array.isArray(object?.posts)
        ? object.posts.map((e: any) => DbNewsPost.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DbNewsPostList): unknown {
    const obj: any = {}
    if (message.posts?.length) {
      obj.posts = message.posts.map((e) => DbNewsPost.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsPostList>, I>>(base?: I): DbNewsPostList {
    return DbNewsPostList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsPostList>, I>>(object: I): DbNewsPostList {
    const message = createBaseDbNewsPostList()
    message.posts = object.posts?.map((e) => DbNewsPost.fromPartial(e)) || []
    return message
  },
}

function createBaseAlpacaNewsStream(): AlpacaNewsStream {
  return {}
}

export const AlpacaNewsStream: MessageFns<AlpacaNewsStream> = {
  encode(_: AlpacaNewsStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlpacaNewsStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlpacaNewsStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): AlpacaNewsStream {
    return {}
  },

  toJSON(_: AlpacaNewsStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<AlpacaNewsStream>, I>>(base?: I): AlpacaNewsStream {
    return AlpacaNewsStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlpacaNewsStream>, I>>(_: I): AlpacaNewsStream {
    const message = createBaseAlpacaNewsStream()
    return message
  },
}

function createBaseAlpacaNewsPost(): AlpacaNewsPost {
  return {
    id: '0',
    headline: '',
    author: '',
    summary: '',
    content: '',
    url: '',
    source: '',
    symbols: [],
    images: [],
    createdAt: '',
    updatedAt: '',
  }
}

export const AlpacaNewsPost: MessageFns<AlpacaNewsPost> = {
  encode(message: AlpacaNewsPost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '0') {
      writer.uint32(8).int64(message.id)
    }
    if (message.headline !== '') {
      writer.uint32(18).string(message.headline)
    }
    if (message.author !== '') {
      writer.uint32(26).string(message.author)
    }
    if (message.summary !== '') {
      writer.uint32(34).string(message.summary)
    }
    if (message.content !== '') {
      writer.uint32(42).string(message.content)
    }
    if (message.url !== '') {
      writer.uint32(50).string(message.url)
    }
    if (message.source !== '') {
      writer.uint32(58).string(message.source)
    }
    for (const v of message.symbols) {
      writer.uint32(66).string(v!)
    }
    for (const v of message.images) {
      writer.uint32(74).string(v!)
    }
    if (message.createdAt !== '') {
      writer.uint32(82).string(message.createdAt)
    }
    if (message.updatedAt !== '') {
      writer.uint32(90).string(message.updatedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlpacaNewsPost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlpacaNewsPost()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.id = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.headline = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.author = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.summary = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.content = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.url = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.source = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.images.push(reader.string())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.createdAt = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.updatedAt = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlpacaNewsPost {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '0',
      headline: isSet(object.headline) ? globalThis.String(object.headline) : '',
      author: isSet(object.author) ? globalThis.String(object.author) : '',
      summary: isSet(object.summary) ? globalThis.String(object.summary) : '',
      content: isSet(object.content) ? globalThis.String(object.content) : '',
      url: isSet(object.url) ? globalThis.String(object.url) : '',
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      images: globalThis.Array.isArray(object?.images)
        ? object.images.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '',
    }
  },

  toJSON(message: AlpacaNewsPost): unknown {
    const obj: any = {}
    if (message.id !== '0') {
      obj.id = message.id
    }
    if (message.headline !== '') {
      obj.headline = message.headline
    }
    if (message.author !== '') {
      obj.author = message.author
    }
    if (message.summary !== '') {
      obj.summary = message.summary
    }
    if (message.content !== '') {
      obj.content = message.content
    }
    if (message.url !== '') {
      obj.url = message.url
    }
    if (message.source !== '') {
      obj.source = message.source
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.images?.length) {
      obj.images = message.images
    }
    if (message.createdAt !== '') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '') {
      obj.updatedAt = message.updatedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlpacaNewsPost>, I>>(base?: I): AlpacaNewsPost {
    return AlpacaNewsPost.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlpacaNewsPost>, I>>(object: I): AlpacaNewsPost {
    const message = createBaseAlpacaNewsPost()
    message.id = object.id ?? '0'
    message.headline = object.headline ?? ''
    message.author = object.author ?? ''
    message.summary = object.summary ?? ''
    message.content = object.content ?? ''
    message.url = object.url ?? ''
    message.source = object.source ?? ''
    message.symbols = object.symbols?.map((e) => e) || []
    message.images = object.images?.map((e) => e) || []
    message.createdAt = object.createdAt ?? ''
    message.updatedAt = object.updatedAt ?? ''
    return message
  },
}

function createBaseAlpacaNewsHistoryRequest(): AlpacaNewsHistoryRequest {
  return {
    limit: undefined,
    offset: undefined,
    from: undefined,
    to: undefined,
    symbol: undefined,
    source: undefined,
  }
}

export const AlpacaNewsHistoryRequest: MessageFns<AlpacaNewsHistoryRequest> = {
  encode(
    message: AlpacaNewsHistoryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.limit !== undefined) {
      writer.uint32(8).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(16).int32(message.offset)
    }
    if (message.from !== undefined) {
      writer.uint32(24).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(32).int64(message.to)
    }
    if (message.symbol !== undefined) {
      writer.uint32(42).string(message.symbol)
    }
    if (message.source !== undefined) {
      writer.uint32(50).string(message.source)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlpacaNewsHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlpacaNewsHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.source = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlpacaNewsHistoryRequest {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      source: isSet(object.source) ? globalThis.String(object.source) : undefined,
    }
  },

  toJSON(message: AlpacaNewsHistoryRequest): unknown {
    const obj: any = {}
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.source !== undefined) {
      obj.source = message.source
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlpacaNewsHistoryRequest>, I>>(
    base?: I
  ): AlpacaNewsHistoryRequest {
    return AlpacaNewsHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlpacaNewsHistoryRequest>, I>>(
    object: I
  ): AlpacaNewsHistoryRequest {
    const message = createBaseAlpacaNewsHistoryRequest()
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.symbol = object.symbol ?? undefined
    message.source = object.source ?? undefined
    return message
  },
}

function createBaseAlpacaNewsPostList(): AlpacaNewsPostList {
  return { posts: [] }
}

export const AlpacaNewsPostList: MessageFns<AlpacaNewsPostList> = {
  encode(message: AlpacaNewsPostList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.posts) {
      AlpacaNewsPost.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlpacaNewsPostList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlpacaNewsPostList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.posts.push(AlpacaNewsPost.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlpacaNewsPostList {
    return {
      posts: globalThis.Array.isArray(object?.posts)
        ? object.posts.map((e: any) => AlpacaNewsPost.fromJSON(e))
        : [],
    }
  },

  toJSON(message: AlpacaNewsPostList): unknown {
    const obj: any = {}
    if (message.posts?.length) {
      obj.posts = message.posts.map((e) => AlpacaNewsPost.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlpacaNewsPostList>, I>>(base?: I): AlpacaNewsPostList {
    return AlpacaNewsPostList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlpacaNewsPostList>, I>>(object: I): AlpacaNewsPostList {
    const message = createBaseAlpacaNewsPostList()
    message.posts = object.posts?.map((e) => AlpacaNewsPost.fromPartial(e)) || []
    return message
  },
}

function createBaseTreeNewsStream(): TreeNewsStream {
  return {}
}

export const TreeNewsStream: MessageFns<TreeNewsStream> = {
  encode(_: TreeNewsStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): TreeNewsStream {
    return {}
  },

  toJSON(_: TreeNewsStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsStream>, I>>(base?: I): TreeNewsStream {
    return TreeNewsStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsStream>, I>>(_: I): TreeNewsStream {
    const message = createBaseTreeNewsStream()
    return message
  },
}

function createBaseMarketScreenerStream(): MarketScreenerStream {
  return { exchanges: [] }
}

export const MarketScreenerStream: MessageFns<MarketScreenerStream> = {
  encode(message: MarketScreenerStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.exchanges) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketScreenerStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarketScreenerStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.exchanges.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.exchanges.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarketScreenerStream {
    return {
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => exchangeFromJSON(e))
        : [],
    }
  },

  toJSON(message: MarketScreenerStream): unknown {
    const obj: any = {}
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges.map((e) => exchangeToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarketScreenerStream>, I>>(base?: I): MarketScreenerStream {
    return MarketScreenerStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarketScreenerStream>, I>>(
    object: I
  ): MarketScreenerStream {
    const message = createBaseMarketScreenerStream()
    message.exchanges = object.exchanges?.map((e) => e) || []
    return message
  },
}

function createBaseOrderbookHeatmapStream(): OrderbookHeatmapStream {
  return { exchange: 0, symbol: '' }
}

export const OrderbookHeatmapStream: MessageFns<OrderbookHeatmapStream> = {
  encode(message: OrderbookHeatmapStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookHeatmapStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookHeatmapStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookHeatmapStream {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
    }
  },

  toJSON(message: OrderbookHeatmapStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookHeatmapStream>, I>>(
    base?: I
  ): OrderbookHeatmapStream {
    return OrderbookHeatmapStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookHeatmapStream>, I>>(
    object: I
  ): OrderbookHeatmapStream {
    const message = createBaseOrderbookHeatmapStream()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    return message
  },
}

function createBaseGetMarketScreenerRequest(): GetMarketScreenerRequest {
  return { exchanges: [] }
}

export const GetMarketScreenerRequest: MessageFns<GetMarketScreenerRequest> = {
  encode(
    message: GetMarketScreenerRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.exchanges) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarketScreenerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetMarketScreenerRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.exchanges.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.exchanges.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetMarketScreenerRequest {
    return {
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => exchangeFromJSON(e))
        : [],
    }
  },

  toJSON(message: GetMarketScreenerRequest): unknown {
    const obj: any = {}
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges.map((e) => exchangeToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetMarketScreenerRequest>, I>>(
    base?: I
  ): GetMarketScreenerRequest {
    return GetMarketScreenerRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetMarketScreenerRequest>, I>>(
    object: I
  ): GetMarketScreenerRequest {
    const message = createBaseGetMarketScreenerRequest()
    message.exchanges = object.exchanges?.map((e) => e) || []
    return message
  },
}

function createBaseMarketScreenerFrame(): MarketScreenerFrame {
  return { filterToken: '', seq: '0', asOfMs: '0', snapshot: false, rows: [], removedAssets: [] }
}

export const MarketScreenerFrame: MessageFns<MarketScreenerFrame> = {
  encode(message: MarketScreenerFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filterToken !== '') {
      writer.uint32(10).string(message.filterToken)
    }
    if (message.seq !== '0') {
      writer.uint32(16).uint64(message.seq)
    }
    if (message.asOfMs !== '0') {
      writer.uint32(24).int64(message.asOfMs)
    }
    if (message.snapshot !== false) {
      writer.uint32(32).bool(message.snapshot)
    }
    for (const v of message.rows) {
      ScreenerRow.encode(v!, writer.uint32(42).fork()).join()
    }
    for (const v of message.removedAssets) {
      writer.uint32(50).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketScreenerFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarketScreenerFrame()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.filterToken = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.seq = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.snapshot = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.rows.push(ScreenerRow.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.removedAssets.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarketScreenerFrame {
    return {
      filterToken: isSet(object.filterToken)
        ? globalThis.String(object.filterToken)
        : isSet(object.filter_token)
          ? globalThis.String(object.filter_token)
          : '',
      seq: isSet(object.seq) ? globalThis.String(object.seq) : '0',
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
      snapshot: isSet(object.snapshot) ? globalThis.Boolean(object.snapshot) : false,
      rows: globalThis.Array.isArray(object?.rows)
        ? object.rows.map((e: any) => ScreenerRow.fromJSON(e))
        : [],
      removedAssets: globalThis.Array.isArray(object?.removedAssets)
        ? object.removedAssets.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.removed_assets)
          ? object.removed_assets.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: MarketScreenerFrame): unknown {
    const obj: any = {}
    if (message.filterToken !== '') {
      obj.filterToken = message.filterToken
    }
    if (message.seq !== '0') {
      obj.seq = message.seq
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    if (message.snapshot !== false) {
      obj.snapshot = message.snapshot
    }
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => ScreenerRow.toJSON(e))
    }
    if (message.removedAssets?.length) {
      obj.removedAssets = message.removedAssets
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarketScreenerFrame>, I>>(base?: I): MarketScreenerFrame {
    return MarketScreenerFrame.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarketScreenerFrame>, I>>(
    object: I
  ): MarketScreenerFrame {
    const message = createBaseMarketScreenerFrame()
    message.filterToken = object.filterToken ?? ''
    message.seq = object.seq ?? '0'
    message.asOfMs = object.asOfMs ?? '0'
    message.snapshot = object.snapshot ?? false
    message.rows = object.rows?.map((e) => ScreenerRow.fromPartial(e)) || []
    message.removedAssets = object.removedAssets?.map((e) => e) || []
    return message
  },
}

function createBaseScreenerRow(): ScreenerRow {
  return {
    asset: '',
    live: undefined,
    windows: undefined,
    derivs: undefined,
    book: undefined,
    meta: undefined,
    flags: undefined,
    venues: [],
  }
}

export const ScreenerRow: MessageFns<ScreenerRow> = {
  encode(message: ScreenerRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.live !== undefined) {
      ScreenerLive.encode(message.live, writer.uint32(18).fork()).join()
    }
    if (message.windows !== undefined) {
      ScreenerWindows.encode(message.windows, writer.uint32(26).fork()).join()
    }
    if (message.derivs !== undefined) {
      ScreenerDerivs.encode(message.derivs, writer.uint32(34).fork()).join()
    }
    if (message.book !== undefined) {
      ScreenerBook.encode(message.book, writer.uint32(42).fork()).join()
    }
    if (message.meta !== undefined) {
      ScreenerMeta.encode(message.meta, writer.uint32(50).fork()).join()
    }
    if (message.flags !== undefined) {
      ScreenerFlags.encode(message.flags, writer.uint32(58).fork()).join()
    }
    for (const v of message.venues) {
      ScreenerVenue.encode(v!, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerRow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.live = ScreenerLive.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.windows = ScreenerWindows.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.derivs = ScreenerDerivs.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.book = ScreenerBook.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.meta = ScreenerMeta.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.flags = ScreenerFlags.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.venues.push(ScreenerVenue.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerRow {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      live: isSet(object.live) ? ScreenerLive.fromJSON(object.live) : undefined,
      windows: isSet(object.windows) ? ScreenerWindows.fromJSON(object.windows) : undefined,
      derivs: isSet(object.derivs) ? ScreenerDerivs.fromJSON(object.derivs) : undefined,
      book: isSet(object.book) ? ScreenerBook.fromJSON(object.book) : undefined,
      meta: isSet(object.meta) ? ScreenerMeta.fromJSON(object.meta) : undefined,
      flags: isSet(object.flags) ? ScreenerFlags.fromJSON(object.flags) : undefined,
      venues: globalThis.Array.isArray(object?.venues)
        ? object.venues.map((e: any) => ScreenerVenue.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ScreenerRow): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.live !== undefined) {
      obj.live = ScreenerLive.toJSON(message.live)
    }
    if (message.windows !== undefined) {
      obj.windows = ScreenerWindows.toJSON(message.windows)
    }
    if (message.derivs !== undefined) {
      obj.derivs = ScreenerDerivs.toJSON(message.derivs)
    }
    if (message.book !== undefined) {
      obj.book = ScreenerBook.toJSON(message.book)
    }
    if (message.meta !== undefined) {
      obj.meta = ScreenerMeta.toJSON(message.meta)
    }
    if (message.flags !== undefined) {
      obj.flags = ScreenerFlags.toJSON(message.flags)
    }
    if (message.venues?.length) {
      obj.venues = message.venues.map((e) => ScreenerVenue.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerRow>, I>>(base?: I): ScreenerRow {
    return ScreenerRow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerRow>, I>>(object: I): ScreenerRow {
    const message = createBaseScreenerRow()
    message.asset = object.asset ?? ''
    message.live =
      object.live !== undefined && object.live !== null
        ? ScreenerLive.fromPartial(object.live)
        : undefined
    message.windows =
      object.windows !== undefined && object.windows !== null
        ? ScreenerWindows.fromPartial(object.windows)
        : undefined
    message.derivs =
      object.derivs !== undefined && object.derivs !== null
        ? ScreenerDerivs.fromPartial(object.derivs)
        : undefined
    message.book =
      object.book !== undefined && object.book !== null
        ? ScreenerBook.fromPartial(object.book)
        : undefined
    message.meta =
      object.meta !== undefined && object.meta !== null
        ? ScreenerMeta.fromPartial(object.meta)
        : undefined
    message.flags =
      object.flags !== undefined && object.flags !== null
        ? ScreenerFlags.fromPartial(object.flags)
        : undefined
    message.venues = object.venues?.map((e) => ScreenerVenue.fromPartial(e)) || []
    return message
  },
}

function createBaseScreenerLive(): ScreenerLive {
  return { price: 0, changePct24h: undefined }
}

export const ScreenerLive: MessageFns<ScreenerLive> = {
  encode(message: ScreenerLive, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.price !== 0) {
      writer.uint32(9).double(message.price)
    }
    if (message.changePct24h !== undefined) {
      writer.uint32(17).double(message.changePct24h)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerLive {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerLive()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.price = reader.double()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.changePct24h = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerLive {
    return {
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      changePct24h: isSet(object.changePct24h)
        ? globalThis.Number(object.changePct24h)
        : isSet(object.change_pct_24h)
          ? globalThis.Number(object.change_pct_24h)
          : undefined,
    }
  },

  toJSON(message: ScreenerLive): unknown {
    const obj: any = {}
    if (message.price !== 0) {
      obj.price = message.price
    }
    if (message.changePct24h !== undefined) {
      obj.changePct24h = message.changePct24h
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerLive>, I>>(base?: I): ScreenerLive {
    return ScreenerLive.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerLive>, I>>(object: I): ScreenerLive {
    const message = createBaseScreenerLive()
    message.price = object.price ?? 0
    message.changePct24h = object.changePct24h ?? undefined
    return message
  },
}

function createBaseScreenerWindow(): ScreenerWindow {
  return {
    tradeCount: '0',
    changePct: undefined,
    volumeUsd: 0,
    volumeDeltaUsd: 0,
    stdevPct: undefined,
    takerBuyPct: undefined,
    liqLongUsd: undefined,
    liqShortUsd: undefined,
  }
}

export const ScreenerWindow: MessageFns<ScreenerWindow> = {
  encode(message: ScreenerWindow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tradeCount !== '0') {
      writer.uint32(8).int64(message.tradeCount)
    }
    if (message.changePct !== undefined) {
      writer.uint32(17).double(message.changePct)
    }
    if (message.volumeUsd !== 0) {
      writer.uint32(25).double(message.volumeUsd)
    }
    if (message.volumeDeltaUsd !== 0) {
      writer.uint32(33).double(message.volumeDeltaUsd)
    }
    if (message.stdevPct !== undefined) {
      writer.uint32(41).double(message.stdevPct)
    }
    if (message.takerBuyPct !== undefined) {
      writer.uint32(49).double(message.takerBuyPct)
    }
    if (message.liqLongUsd !== undefined) {
      writer.uint32(57).double(message.liqLongUsd)
    }
    if (message.liqShortUsd !== undefined) {
      writer.uint32(65).double(message.liqShortUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerWindow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerWindow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tradeCount = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.changePct = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.volumeUsd = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.volumeDeltaUsd = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.stdevPct = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.takerBuyPct = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.liqLongUsd = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.liqShortUsd = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerWindow {
    return {
      tradeCount: isSet(object.tradeCount)
        ? globalThis.String(object.tradeCount)
        : isSet(object.trade_count)
          ? globalThis.String(object.trade_count)
          : '0',
      changePct: isSet(object.changePct)
        ? globalThis.Number(object.changePct)
        : isSet(object.change_pct)
          ? globalThis.Number(object.change_pct)
          : undefined,
      volumeUsd: isSet(object.volumeUsd)
        ? globalThis.Number(object.volumeUsd)
        : isSet(object.volume_usd)
          ? globalThis.Number(object.volume_usd)
          : 0,
      volumeDeltaUsd: isSet(object.volumeDeltaUsd)
        ? globalThis.Number(object.volumeDeltaUsd)
        : isSet(object.volume_delta_usd)
          ? globalThis.Number(object.volume_delta_usd)
          : 0,
      stdevPct: isSet(object.stdevPct)
        ? globalThis.Number(object.stdevPct)
        : isSet(object.stdev_pct)
          ? globalThis.Number(object.stdev_pct)
          : undefined,
      takerBuyPct: isSet(object.takerBuyPct)
        ? globalThis.Number(object.takerBuyPct)
        : isSet(object.taker_buy_pct)
          ? globalThis.Number(object.taker_buy_pct)
          : undefined,
      liqLongUsd: isSet(object.liqLongUsd)
        ? globalThis.Number(object.liqLongUsd)
        : isSet(object.liq_long_usd)
          ? globalThis.Number(object.liq_long_usd)
          : undefined,
      liqShortUsd: isSet(object.liqShortUsd)
        ? globalThis.Number(object.liqShortUsd)
        : isSet(object.liq_short_usd)
          ? globalThis.Number(object.liq_short_usd)
          : undefined,
    }
  },

  toJSON(message: ScreenerWindow): unknown {
    const obj: any = {}
    if (message.tradeCount !== '0') {
      obj.tradeCount = message.tradeCount
    }
    if (message.changePct !== undefined) {
      obj.changePct = message.changePct
    }
    if (message.volumeUsd !== 0) {
      obj.volumeUsd = message.volumeUsd
    }
    if (message.volumeDeltaUsd !== 0) {
      obj.volumeDeltaUsd = message.volumeDeltaUsd
    }
    if (message.stdevPct !== undefined) {
      obj.stdevPct = message.stdevPct
    }
    if (message.takerBuyPct !== undefined) {
      obj.takerBuyPct = message.takerBuyPct
    }
    if (message.liqLongUsd !== undefined) {
      obj.liqLongUsd = message.liqLongUsd
    }
    if (message.liqShortUsd !== undefined) {
      obj.liqShortUsd = message.liqShortUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerWindow>, I>>(base?: I): ScreenerWindow {
    return ScreenerWindow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerWindow>, I>>(object: I): ScreenerWindow {
    const message = createBaseScreenerWindow()
    message.tradeCount = object.tradeCount ?? '0'
    message.changePct = object.changePct ?? undefined
    message.volumeUsd = object.volumeUsd ?? 0
    message.volumeDeltaUsd = object.volumeDeltaUsd ?? 0
    message.stdevPct = object.stdevPct ?? undefined
    message.takerBuyPct = object.takerBuyPct ?? undefined
    message.liqLongUsd = object.liqLongUsd ?? undefined
    message.liqShortUsd = object.liqShortUsd ?? undefined
    return message
  },
}

function createBaseScreenerWindows(): ScreenerWindows {
  return { w5m: undefined, w15m: undefined, asOfMs: '0', stale: false }
}

export const ScreenerWindows: MessageFns<ScreenerWindows> = {
  encode(message: ScreenerWindows, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.w5m !== undefined) {
      ScreenerWindow.encode(message.w5m, writer.uint32(10).fork()).join()
    }
    if (message.w15m !== undefined) {
      ScreenerWindow.encode(message.w15m, writer.uint32(18).fork()).join()
    }
    if (message.asOfMs !== '0') {
      writer.uint32(24).int64(message.asOfMs)
    }
    if (message.stale !== false) {
      writer.uint32(32).bool(message.stale)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerWindows {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerWindows()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.w5m = ScreenerWindow.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.w15m = ScreenerWindow.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.stale = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerWindows {
    return {
      w5m: isSet(object.w5m) ? ScreenerWindow.fromJSON(object.w5m) : undefined,
      w15m: isSet(object.w15m) ? ScreenerWindow.fromJSON(object.w15m) : undefined,
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
    }
  },

  toJSON(message: ScreenerWindows): unknown {
    const obj: any = {}
    if (message.w5m !== undefined) {
      obj.w5m = ScreenerWindow.toJSON(message.w5m)
    }
    if (message.w15m !== undefined) {
      obj.w15m = ScreenerWindow.toJSON(message.w15m)
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    if (message.stale !== false) {
      obj.stale = message.stale
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerWindows>, I>>(base?: I): ScreenerWindows {
    return ScreenerWindows.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerWindows>, I>>(object: I): ScreenerWindows {
    const message = createBaseScreenerWindows()
    message.w5m =
      object.w5m !== undefined && object.w5m !== null
        ? ScreenerWindow.fromPartial(object.w5m)
        : undefined
    message.w15m =
      object.w15m !== undefined && object.w15m !== null
        ? ScreenerWindow.fromPartial(object.w15m)
        : undefined
    message.asOfMs = object.asOfMs ?? '0'
    message.stale = object.stale ?? false
    return message
  },
}

function createBaseScreenerDerivs(): ScreenerDerivs {
  return {
    fundingRateHourly: undefined,
    fundingApr: undefined,
    openInterestUsd: undefined,
    oiChangePct1h: undefined,
    oiChangePct24h: undefined,
    fundingSpreadHourly: undefined,
    asOfMs: '0',
    stale: false,
  }
}

export const ScreenerDerivs: MessageFns<ScreenerDerivs> = {
  encode(message: ScreenerDerivs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fundingRateHourly !== undefined) {
      writer.uint32(9).double(message.fundingRateHourly)
    }
    if (message.fundingApr !== undefined) {
      writer.uint32(17).double(message.fundingApr)
    }
    if (message.openInterestUsd !== undefined) {
      writer.uint32(25).double(message.openInterestUsd)
    }
    if (message.oiChangePct1h !== undefined) {
      writer.uint32(33).double(message.oiChangePct1h)
    }
    if (message.oiChangePct24h !== undefined) {
      writer.uint32(41).double(message.oiChangePct24h)
    }
    if (message.fundingSpreadHourly !== undefined) {
      writer.uint32(49).double(message.fundingSpreadHourly)
    }
    if (message.asOfMs !== '0') {
      writer.uint32(56).int64(message.asOfMs)
    }
    if (message.stale !== false) {
      writer.uint32(64).bool(message.stale)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerDerivs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerDerivs()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.fundingRateHourly = reader.double()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.fundingApr = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.openInterestUsd = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.oiChangePct1h = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.oiChangePct24h = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.fundingSpreadHourly = reader.double()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.stale = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerDerivs {
    return {
      fundingRateHourly: isSet(object.fundingRateHourly)
        ? globalThis.Number(object.fundingRateHourly)
        : isSet(object.funding_rate_hourly)
          ? globalThis.Number(object.funding_rate_hourly)
          : undefined,
      fundingApr: isSet(object.fundingApr)
        ? globalThis.Number(object.fundingApr)
        : isSet(object.funding_apr)
          ? globalThis.Number(object.funding_apr)
          : undefined,
      openInterestUsd: isSet(object.openInterestUsd)
        ? globalThis.Number(object.openInterestUsd)
        : isSet(object.open_interest_usd)
          ? globalThis.Number(object.open_interest_usd)
          : undefined,
      oiChangePct1h: isSet(object.oiChangePct1h)
        ? globalThis.Number(object.oiChangePct1h)
        : isSet(object.oi_change_pct_1h)
          ? globalThis.Number(object.oi_change_pct_1h)
          : undefined,
      oiChangePct24h: isSet(object.oiChangePct24h)
        ? globalThis.Number(object.oiChangePct24h)
        : isSet(object.oi_change_pct_24h)
          ? globalThis.Number(object.oi_change_pct_24h)
          : undefined,
      fundingSpreadHourly: isSet(object.fundingSpreadHourly)
        ? globalThis.Number(object.fundingSpreadHourly)
        : isSet(object.funding_spread_hourly)
          ? globalThis.Number(object.funding_spread_hourly)
          : undefined,
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
    }
  },

  toJSON(message: ScreenerDerivs): unknown {
    const obj: any = {}
    if (message.fundingRateHourly !== undefined) {
      obj.fundingRateHourly = message.fundingRateHourly
    }
    if (message.fundingApr !== undefined) {
      obj.fundingApr = message.fundingApr
    }
    if (message.openInterestUsd !== undefined) {
      obj.openInterestUsd = message.openInterestUsd
    }
    if (message.oiChangePct1h !== undefined) {
      obj.oiChangePct1h = message.oiChangePct1h
    }
    if (message.oiChangePct24h !== undefined) {
      obj.oiChangePct24h = message.oiChangePct24h
    }
    if (message.fundingSpreadHourly !== undefined) {
      obj.fundingSpreadHourly = message.fundingSpreadHourly
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    if (message.stale !== false) {
      obj.stale = message.stale
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerDerivs>, I>>(base?: I): ScreenerDerivs {
    return ScreenerDerivs.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerDerivs>, I>>(object: I): ScreenerDerivs {
    const message = createBaseScreenerDerivs()
    message.fundingRateHourly = object.fundingRateHourly ?? undefined
    message.fundingApr = object.fundingApr ?? undefined
    message.openInterestUsd = object.openInterestUsd ?? undefined
    message.oiChangePct1h = object.oiChangePct1h ?? undefined
    message.oiChangePct24h = object.oiChangePct24h ?? undefined
    message.fundingSpreadHourly = object.fundingSpreadHourly ?? undefined
    message.asOfMs = object.asOfMs ?? '0'
    message.stale = object.stale ?? false
    return message
  },
}

function createBaseScreenerBook(): ScreenerBook {
  return {
    spreadBps: undefined,
    depth50bpsUsd: undefined,
    imbalance: undefined,
    asOfMs: '0',
    stale: false,
  }
}

export const ScreenerBook: MessageFns<ScreenerBook> = {
  encode(message: ScreenerBook, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spreadBps !== undefined) {
      writer.uint32(9).double(message.spreadBps)
    }
    if (message.depth50bpsUsd !== undefined) {
      writer.uint32(17).double(message.depth50bpsUsd)
    }
    if (message.imbalance !== undefined) {
      writer.uint32(25).double(message.imbalance)
    }
    if (message.asOfMs !== '0') {
      writer.uint32(32).int64(message.asOfMs)
    }
    if (message.stale !== false) {
      writer.uint32(40).bool(message.stale)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerBook {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerBook()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.spreadBps = reader.double()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.depth50bpsUsd = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.imbalance = reader.double()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.stale = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerBook {
    return {
      spreadBps: isSet(object.spreadBps)
        ? globalThis.Number(object.spreadBps)
        : isSet(object.spread_bps)
          ? globalThis.Number(object.spread_bps)
          : undefined,
      depth50bpsUsd: isSet(object.depth50bpsUsd)
        ? globalThis.Number(object.depth50bpsUsd)
        : isSet(object.depth_50bps_usd)
          ? globalThis.Number(object.depth_50bps_usd)
          : undefined,
      imbalance: isSet(object.imbalance) ? globalThis.Number(object.imbalance) : undefined,
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
      stale: isSet(object.stale) ? globalThis.Boolean(object.stale) : false,
    }
  },

  toJSON(message: ScreenerBook): unknown {
    const obj: any = {}
    if (message.spreadBps !== undefined) {
      obj.spreadBps = message.spreadBps
    }
    if (message.depth50bpsUsd !== undefined) {
      obj.depth50bpsUsd = message.depth50bpsUsd
    }
    if (message.imbalance !== undefined) {
      obj.imbalance = message.imbalance
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    if (message.stale !== false) {
      obj.stale = message.stale
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerBook>, I>>(base?: I): ScreenerBook {
    return ScreenerBook.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerBook>, I>>(object: I): ScreenerBook {
    const message = createBaseScreenerBook()
    message.spreadBps = object.spreadBps ?? undefined
    message.depth50bpsUsd = object.depth50bpsUsd ?? undefined
    message.imbalance = object.imbalance ?? undefined
    message.asOfMs = object.asOfMs ?? '0'
    message.stale = object.stale ?? false
    return message
  },
}

function createBaseScreenerMeta(): ScreenerMeta {
  return {
    referenceSymbol: '',
    referenceExchange: 0,
    marketCapUsd: undefined,
    fdvUsd: undefined,
    venues: [],
  }
}

export const ScreenerMeta: MessageFns<ScreenerMeta> = {
  encode(message: ScreenerMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.referenceSymbol !== '') {
      writer.uint32(10).string(message.referenceSymbol)
    }
    if (message.referenceExchange !== 0) {
      writer.uint32(16).int32(message.referenceExchange)
    }
    if (message.marketCapUsd !== undefined) {
      writer.uint32(25).double(message.marketCapUsd)
    }
    if (message.fdvUsd !== undefined) {
      writer.uint32(33).double(message.fdvUsd)
    }
    writer.uint32(42).fork()
    for (const v of message.venues) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerMeta()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.referenceSymbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.referenceExchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.marketCapUsd = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.fdvUsd = reader.double()
          continue
        }
        case 5: {
          if (tag === 40) {
            message.venues.push(reader.int32() as any)

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.venues.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerMeta {
    return {
      referenceSymbol: isSet(object.referenceSymbol)
        ? globalThis.String(object.referenceSymbol)
        : isSet(object.reference_symbol)
          ? globalThis.String(object.reference_symbol)
          : '',
      referenceExchange: isSet(object.referenceExchange)
        ? exchangeFromJSON(object.referenceExchange)
        : isSet(object.reference_exchange)
          ? exchangeFromJSON(object.reference_exchange)
          : 0,
      marketCapUsd: isSet(object.marketCapUsd)
        ? globalThis.Number(object.marketCapUsd)
        : isSet(object.market_cap_usd)
          ? globalThis.Number(object.market_cap_usd)
          : undefined,
      fdvUsd: isSet(object.fdvUsd)
        ? globalThis.Number(object.fdvUsd)
        : isSet(object.fdv_usd)
          ? globalThis.Number(object.fdv_usd)
          : undefined,
      venues: globalThis.Array.isArray(object?.venues)
        ? object.venues.map((e: any) => exchangeFromJSON(e))
        : [],
    }
  },

  toJSON(message: ScreenerMeta): unknown {
    const obj: any = {}
    if (message.referenceSymbol !== '') {
      obj.referenceSymbol = message.referenceSymbol
    }
    if (message.referenceExchange !== 0) {
      obj.referenceExchange = exchangeToJSON(message.referenceExchange)
    }
    if (message.marketCapUsd !== undefined) {
      obj.marketCapUsd = message.marketCapUsd
    }
    if (message.fdvUsd !== undefined) {
      obj.fdvUsd = message.fdvUsd
    }
    if (message.venues?.length) {
      obj.venues = message.venues.map((e) => exchangeToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerMeta>, I>>(base?: I): ScreenerMeta {
    return ScreenerMeta.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerMeta>, I>>(object: I): ScreenerMeta {
    const message = createBaseScreenerMeta()
    message.referenceSymbol = object.referenceSymbol ?? ''
    message.referenceExchange = object.referenceExchange ?? 0
    message.marketCapUsd = object.marketCapUsd ?? undefined
    message.fdvUsd = object.fdvUsd ?? undefined
    message.venues = object.venues?.map((e) => e) || []
    return message
  },
}

function createBaseScreenerFlags(): ScreenerFlags {
  return { values: [] }
}

export const ScreenerFlags: MessageFns<ScreenerFlags> = {
  encode(message: ScreenerFlags, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.values) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerFlags {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerFlags()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.values.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.values.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerFlags {
    return {
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => screenerFlagFromJSON(e))
        : [],
    }
  },

  toJSON(message: ScreenerFlags): unknown {
    const obj: any = {}
    if (message.values?.length) {
      obj.values = message.values.map((e) => screenerFlagToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerFlags>, I>>(base?: I): ScreenerFlags {
    return ScreenerFlags.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerFlags>, I>>(object: I): ScreenerFlags {
    const message = createBaseScreenerFlags()
    message.values = object.values?.map((e) => e) || []
    return message
  },
}

function createBaseScreenerVenue(): ScreenerVenue {
  return { exchange: 0, symbol: '', windows: undefined, derivs: undefined, book: undefined }
}

export const ScreenerVenue: MessageFns<ScreenerVenue> = {
  encode(message: ScreenerVenue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.windows !== undefined) {
      ScreenerWindows.encode(message.windows, writer.uint32(26).fork()).join()
    }
    if (message.derivs !== undefined) {
      ScreenerDerivs.encode(message.derivs, writer.uint32(34).fork()).join()
    }
    if (message.book !== undefined) {
      ScreenerBook.encode(message.book, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScreenerVenue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScreenerVenue()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.windows = ScreenerWindows.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.derivs = ScreenerDerivs.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.book = ScreenerBook.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScreenerVenue {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      windows: isSet(object.windows) ? ScreenerWindows.fromJSON(object.windows) : undefined,
      derivs: isSet(object.derivs) ? ScreenerDerivs.fromJSON(object.derivs) : undefined,
      book: isSet(object.book) ? ScreenerBook.fromJSON(object.book) : undefined,
    }
  },

  toJSON(message: ScreenerVenue): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.windows !== undefined) {
      obj.windows = ScreenerWindows.toJSON(message.windows)
    }
    if (message.derivs !== undefined) {
      obj.derivs = ScreenerDerivs.toJSON(message.derivs)
    }
    if (message.book !== undefined) {
      obj.book = ScreenerBook.toJSON(message.book)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScreenerVenue>, I>>(base?: I): ScreenerVenue {
    return ScreenerVenue.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScreenerVenue>, I>>(object: I): ScreenerVenue {
    const message = createBaseScreenerVenue()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.windows =
      object.windows !== undefined && object.windows !== null
        ? ScreenerWindows.fromPartial(object.windows)
        : undefined
    message.derivs =
      object.derivs !== undefined && object.derivs !== null
        ? ScreenerDerivs.fromPartial(object.derivs)
        : undefined
    message.book =
      object.book !== undefined && object.book !== null
        ? ScreenerBook.fromPartial(object.book)
        : undefined
    return message
  },
}

function createBaseTreeNewsSymbol(): TreeNewsSymbol {
  return { exchange: '', symbol: '' }
}

export const TreeNewsSymbol: MessageFns<TreeNewsSymbol> = {
  encode(message: TreeNewsSymbol, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== '') {
      writer.uint32(10).string(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsSymbol {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsSymbol()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.exchange = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsSymbol {
    return {
      exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
    }
  },

  toJSON(message: TreeNewsSymbol): unknown {
    const obj: any = {}
    if (message.exchange !== '') {
      obj.exchange = message.exchange
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsSymbol>, I>>(base?: I): TreeNewsSymbol {
    return TreeNewsSymbol.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsSymbol>, I>>(object: I): TreeNewsSymbol {
    const message = createBaseTreeNewsSymbol()
    message.exchange = object.exchange ?? ''
    message.symbol = object.symbol ?? ''
    return message
  },
}

function createBaseTreeNewsSuggestion(): TreeNewsSuggestion {
  return {
    coin: '',
    found: [],
    symbols: [],
    supply: undefined,
    priceMove1h: undefined,
    maxMove1h: undefined,
    isAccountMapped: false,
  }
}

export const TreeNewsSuggestion: MessageFns<TreeNewsSuggestion> = {
  encode(message: TreeNewsSuggestion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.coin !== '') {
      writer.uint32(10).string(message.coin)
    }
    for (const v of message.found) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.symbols) {
      TreeNewsSymbol.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.supply !== undefined) {
      writer.uint32(33).double(message.supply)
    }
    if (message.priceMove1h !== undefined) {
      writer.uint32(41).double(message.priceMove1h)
    }
    if (message.maxMove1h !== undefined) {
      writer.uint32(49).double(message.maxMove1h)
    }
    if (message.isAccountMapped !== false) {
      writer.uint32(56).bool(message.isAccountMapped)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsSuggestion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsSuggestion()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.coin = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.found.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbols.push(TreeNewsSymbol.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.supply = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.priceMove1h = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.maxMove1h = reader.double()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.isAccountMapped = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsSuggestion {
    return {
      coin: isSet(object.coin) ? globalThis.String(object.coin) : '',
      found: globalThis.Array.isArray(object?.found)
        ? object.found.map((e: any) => globalThis.String(e))
        : [],
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => TreeNewsSymbol.fromJSON(e))
        : [],
      supply: isSet(object.supply) ? globalThis.Number(object.supply) : undefined,
      priceMove1h: isSet(object.priceMove1h)
        ? globalThis.Number(object.priceMove1h)
        : isSet(object.price_move_1h)
          ? globalThis.Number(object.price_move_1h)
          : undefined,
      maxMove1h: isSet(object.maxMove1h)
        ? globalThis.Number(object.maxMove1h)
        : isSet(object.max_move_1h)
          ? globalThis.Number(object.max_move_1h)
          : undefined,
      isAccountMapped: isSet(object.isAccountMapped)
        ? globalThis.Boolean(object.isAccountMapped)
        : isSet(object.is_account_mapped)
          ? globalThis.Boolean(object.is_account_mapped)
          : false,
    }
  },

  toJSON(message: TreeNewsSuggestion): unknown {
    const obj: any = {}
    if (message.coin !== '') {
      obj.coin = message.coin
    }
    if (message.found?.length) {
      obj.found = message.found
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols.map((e) => TreeNewsSymbol.toJSON(e))
    }
    if (message.supply !== undefined) {
      obj.supply = message.supply
    }
    if (message.priceMove1h !== undefined) {
      obj.priceMove1h = message.priceMove1h
    }
    if (message.maxMove1h !== undefined) {
      obj.maxMove1h = message.maxMove1h
    }
    if (message.isAccountMapped !== false) {
      obj.isAccountMapped = message.isAccountMapped
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsSuggestion>, I>>(base?: I): TreeNewsSuggestion {
    return TreeNewsSuggestion.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsSuggestion>, I>>(object: I): TreeNewsSuggestion {
    const message = createBaseTreeNewsSuggestion()
    message.coin = object.coin ?? ''
    message.found = object.found?.map((e) => e) || []
    message.symbols = object.symbols?.map((e) => TreeNewsSymbol.fromPartial(e)) || []
    message.supply = object.supply ?? undefined
    message.priceMove1h = object.priceMove1h ?? undefined
    message.maxMove1h = object.maxMove1h ?? undefined
    message.isAccountMapped = object.isAccountMapped ?? false
    return message
  },
}

function createBaseTreeNewsMention(): TreeNewsMention {
  return { handle: '', id: '', coin: '' }
}

export const TreeNewsMention: MessageFns<TreeNewsMention> = {
  encode(message: TreeNewsMention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.handle !== '') {
      writer.uint32(10).string(message.handle)
    }
    if (message.id !== '') {
      writer.uint32(18).string(message.id)
    }
    if (message.coin !== '') {
      writer.uint32(26).string(message.coin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsMention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsMention()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.handle = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.coin = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsMention {
    return {
      handle: isSet(object.handle) ? globalThis.String(object.handle) : '',
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      coin: isSet(object.coin) ? globalThis.String(object.coin) : '',
    }
  },

  toJSON(message: TreeNewsMention): unknown {
    const obj: any = {}
    if (message.handle !== '') {
      obj.handle = message.handle
    }
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.coin !== '') {
      obj.coin = message.coin
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsMention>, I>>(base?: I): TreeNewsMention {
    return TreeNewsMention.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsMention>, I>>(object: I): TreeNewsMention {
    const message = createBaseTreeNewsMention()
    message.handle = object.handle ?? ''
    message.id = object.id ?? ''
    message.coin = object.coin ?? ''
    return message
  },
}

function createBaseTreeNewsPost(): TreeNewsPost {
  return {
    id: '',
    source: '',
    sourceName: '',
    title: '',
    body: '',
    url: '',
    icon: '',
    image: '',
    video: '',
    coins: [],
    symbols: [],
    isReply: false,
    isRetweet: false,
    isQuote: false,
    isSelfReply: false,
    twitterId: '',
    truthId: '',
    time: '0',
    suggestions: [],
    mentions: [],
    urls: [],
    firstPrice: {},
  }
}

export const TreeNewsPost: MessageFns<TreeNewsPost> = {
  encode(message: TreeNewsPost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.source !== '') {
      writer.uint32(18).string(message.source)
    }
    if (message.sourceName !== '') {
      writer.uint32(26).string(message.sourceName)
    }
    if (message.title !== '') {
      writer.uint32(34).string(message.title)
    }
    if (message.body !== '') {
      writer.uint32(42).string(message.body)
    }
    if (message.url !== '') {
      writer.uint32(50).string(message.url)
    }
    if (message.icon !== '') {
      writer.uint32(58).string(message.icon)
    }
    if (message.image !== '') {
      writer.uint32(66).string(message.image)
    }
    if (message.video !== '') {
      writer.uint32(74).string(message.video)
    }
    for (const v of message.coins) {
      writer.uint32(82).string(v!)
    }
    for (const v of message.symbols) {
      writer.uint32(90).string(v!)
    }
    if (message.isReply !== false) {
      writer.uint32(96).bool(message.isReply)
    }
    if (message.isRetweet !== false) {
      writer.uint32(104).bool(message.isRetweet)
    }
    if (message.isQuote !== false) {
      writer.uint32(112).bool(message.isQuote)
    }
    if (message.isSelfReply !== false) {
      writer.uint32(120).bool(message.isSelfReply)
    }
    if (message.twitterId !== '') {
      writer.uint32(130).string(message.twitterId)
    }
    if (message.truthId !== '') {
      writer.uint32(138).string(message.truthId)
    }
    if (message.time !== '0') {
      writer.uint32(144).int64(message.time)
    }
    for (const v of message.suggestions) {
      TreeNewsSuggestion.encode(v!, writer.uint32(154).fork()).join()
    }
    for (const v of message.mentions) {
      TreeNewsMention.encode(v!, writer.uint32(162).fork()).join()
    }
    for (const v of message.urls) {
      writer.uint32(170).string(v!)
    }
    globalThis.Object.entries(message.firstPrice).forEach(([key, value]: [string, number]) => {
      TreeNewsPost_FirstPriceEntry.encode(
        { key: key as any, value },
        writer.uint32(178).fork()
      ).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsPost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsPost()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.source = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sourceName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.title = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.body = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.url = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.icon = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.image = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.video = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.coins.push(reader.string())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.isReply = reader.bool()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.isRetweet = reader.bool()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.isQuote = reader.bool()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.isSelfReply = reader.bool()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.twitterId = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.truthId = reader.string()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.time = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.suggestions.push(TreeNewsSuggestion.decode(reader, reader.uint32()))
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.mentions.push(TreeNewsMention.decode(reader, reader.uint32()))
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.urls.push(reader.string())
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          const entry22 = TreeNewsPost_FirstPriceEntry.decode(reader, reader.uint32())
          if (entry22.value !== undefined) {
            message.firstPrice[entry22.key] = entry22.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsPost {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      sourceName: isSet(object.sourceName)
        ? globalThis.String(object.sourceName)
        : isSet(object.source_name)
          ? globalThis.String(object.source_name)
          : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      body: isSet(object.body) ? globalThis.String(object.body) : '',
      url: isSet(object.url) ? globalThis.String(object.url) : '',
      icon: isSet(object.icon) ? globalThis.String(object.icon) : '',
      image: isSet(object.image) ? globalThis.String(object.image) : '',
      video: isSet(object.video) ? globalThis.String(object.video) : '',
      coins: globalThis.Array.isArray(object?.coins)
        ? object.coins.map((e: any) => globalThis.String(e))
        : [],
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      isReply: isSet(object.isReply)
        ? globalThis.Boolean(object.isReply)
        : isSet(object.is_reply)
          ? globalThis.Boolean(object.is_reply)
          : false,
      isRetweet: isSet(object.isRetweet)
        ? globalThis.Boolean(object.isRetweet)
        : isSet(object.is_retweet)
          ? globalThis.Boolean(object.is_retweet)
          : false,
      isQuote: isSet(object.isQuote)
        ? globalThis.Boolean(object.isQuote)
        : isSet(object.is_quote)
          ? globalThis.Boolean(object.is_quote)
          : false,
      isSelfReply: isSet(object.isSelfReply)
        ? globalThis.Boolean(object.isSelfReply)
        : isSet(object.is_self_reply)
          ? globalThis.Boolean(object.is_self_reply)
          : false,
      twitterId: isSet(object.twitterId)
        ? globalThis.String(object.twitterId)
        : isSet(object.twitter_id)
          ? globalThis.String(object.twitter_id)
          : '',
      truthId: isSet(object.truthId)
        ? globalThis.String(object.truthId)
        : isSet(object.truth_id)
          ? globalThis.String(object.truth_id)
          : '',
      time: isSet(object.time) ? globalThis.String(object.time) : '0',
      suggestions: globalThis.Array.isArray(object?.suggestions)
        ? object.suggestions.map((e: any) => TreeNewsSuggestion.fromJSON(e))
        : [],
      mentions: globalThis.Array.isArray(object?.mentions)
        ? object.mentions.map((e: any) => TreeNewsMention.fromJSON(e))
        : [],
      urls: globalThis.Array.isArray(object?.urls)
        ? object.urls.map((e: any) => globalThis.String(e))
        : [],
      firstPrice: isObject(object.firstPrice)
        ? (globalThis.Object.entries(object.firstPrice) as [string, any][]).reduce(
            (acc: { [key: string]: number }, [key, value]: [string, any]) => {
              acc[key] = globalThis.Number(value)
              return acc
            },
            {}
          )
        : isObject(object.first_price)
          ? (globalThis.Object.entries(object.first_price) as [string, any][]).reduce(
              (acc: { [key: string]: number }, [key, value]: [string, any]) => {
                acc[key] = globalThis.Number(value)
                return acc
              },
              {}
            )
          : {},
    }
  },

  toJSON(message: TreeNewsPost): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.source !== '') {
      obj.source = message.source
    }
    if (message.sourceName !== '') {
      obj.sourceName = message.sourceName
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.body !== '') {
      obj.body = message.body
    }
    if (message.url !== '') {
      obj.url = message.url
    }
    if (message.icon !== '') {
      obj.icon = message.icon
    }
    if (message.image !== '') {
      obj.image = message.image
    }
    if (message.video !== '') {
      obj.video = message.video
    }
    if (message.coins?.length) {
      obj.coins = message.coins
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.isReply !== false) {
      obj.isReply = message.isReply
    }
    if (message.isRetweet !== false) {
      obj.isRetweet = message.isRetweet
    }
    if (message.isQuote !== false) {
      obj.isQuote = message.isQuote
    }
    if (message.isSelfReply !== false) {
      obj.isSelfReply = message.isSelfReply
    }
    if (message.twitterId !== '') {
      obj.twitterId = message.twitterId
    }
    if (message.truthId !== '') {
      obj.truthId = message.truthId
    }
    if (message.time !== '0') {
      obj.time = message.time
    }
    if (message.suggestions?.length) {
      obj.suggestions = message.suggestions.map((e) => TreeNewsSuggestion.toJSON(e))
    }
    if (message.mentions?.length) {
      obj.mentions = message.mentions.map((e) => TreeNewsMention.toJSON(e))
    }
    if (message.urls?.length) {
      obj.urls = message.urls
    }
    if (message.firstPrice) {
      const entries = globalThis.Object.entries(message.firstPrice) as [string, number][]
      if (entries.length > 0) {
        obj.firstPrice = {}
        entries.forEach(([k, v]) => {
          obj.firstPrice[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsPost>, I>>(base?: I): TreeNewsPost {
    return TreeNewsPost.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsPost>, I>>(object: I): TreeNewsPost {
    const message = createBaseTreeNewsPost()
    message.id = object.id ?? ''
    message.source = object.source ?? ''
    message.sourceName = object.sourceName ?? ''
    message.title = object.title ?? ''
    message.body = object.body ?? ''
    message.url = object.url ?? ''
    message.icon = object.icon ?? ''
    message.image = object.image ?? ''
    message.video = object.video ?? ''
    message.coins = object.coins?.map((e) => e) || []
    message.symbols = object.symbols?.map((e) => e) || []
    message.isReply = object.isReply ?? false
    message.isRetweet = object.isRetweet ?? false
    message.isQuote = object.isQuote ?? false
    message.isSelfReply = object.isSelfReply ?? false
    message.twitterId = object.twitterId ?? ''
    message.truthId = object.truthId ?? ''
    message.time = object.time ?? '0'
    message.suggestions = object.suggestions?.map((e) => TreeNewsSuggestion.fromPartial(e)) || []
    message.mentions = object.mentions?.map((e) => TreeNewsMention.fromPartial(e)) || []
    message.urls = object.urls?.map((e) => e) || []
    message.firstPrice = (
      globalThis.Object.entries(object.firstPrice ?? {}) as [string, number][]
    ).reduce((acc: { [key: string]: number }, [key, value]: [string, number]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value)
      }
      return acc
    }, {})
    return message
  },
}

function createBaseTreeNewsPost_FirstPriceEntry(): TreeNewsPost_FirstPriceEntry {
  return { key: '', value: 0 }
}

export const TreeNewsPost_FirstPriceEntry: MessageFns<TreeNewsPost_FirstPriceEntry> = {
  encode(
    message: TreeNewsPost_FirstPriceEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsPost_FirstPriceEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsPost_FirstPriceEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.value = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsPost_FirstPriceEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    }
  },

  toJSON(message: TreeNewsPost_FirstPriceEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== 0) {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsPost_FirstPriceEntry>, I>>(
    base?: I
  ): TreeNewsPost_FirstPriceEntry {
    return TreeNewsPost_FirstPriceEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsPost_FirstPriceEntry>, I>>(
    object: I
  ): TreeNewsPost_FirstPriceEntry {
    const message = createBaseTreeNewsPost_FirstPriceEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? 0
    return message
  },
}

function createBaseTreeNewsHistoryRequest(): TreeNewsHistoryRequest {
  return {
    limit: undefined,
    offset: undefined,
    from: undefined,
    to: undefined,
    coin: undefined,
    source: undefined,
  }
}

export const TreeNewsHistoryRequest: MessageFns<TreeNewsHistoryRequest> = {
  encode(message: TreeNewsHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== undefined) {
      writer.uint32(8).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(16).int32(message.offset)
    }
    if (message.from !== undefined) {
      writer.uint32(24).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(32).int64(message.to)
    }
    if (message.coin !== undefined) {
      writer.uint32(42).string(message.coin)
    }
    if (message.source !== undefined) {
      writer.uint32(50).string(message.source)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.coin = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.source = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsHistoryRequest {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      coin: isSet(object.coin) ? globalThis.String(object.coin) : undefined,
      source: isSet(object.source) ? globalThis.String(object.source) : undefined,
    }
  },

  toJSON(message: TreeNewsHistoryRequest): unknown {
    const obj: any = {}
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.coin !== undefined) {
      obj.coin = message.coin
    }
    if (message.source !== undefined) {
      obj.source = message.source
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsHistoryRequest>, I>>(
    base?: I
  ): TreeNewsHistoryRequest {
    return TreeNewsHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsHistoryRequest>, I>>(
    object: I
  ): TreeNewsHistoryRequest {
    const message = createBaseTreeNewsHistoryRequest()
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.coin = object.coin ?? undefined
    message.source = object.source ?? undefined
    return message
  },
}

function createBaseTreeNewsPostList(): TreeNewsPostList {
  return { posts: [] }
}

export const TreeNewsPostList: MessageFns<TreeNewsPostList> = {
  encode(message: TreeNewsPostList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.posts) {
      TreeNewsPost.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNewsPostList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTreeNewsPostList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.posts.push(TreeNewsPost.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TreeNewsPostList {
    return {
      posts: globalThis.Array.isArray(object?.posts)
        ? object.posts.map((e: any) => TreeNewsPost.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TreeNewsPostList): unknown {
    const obj: any = {}
    if (message.posts?.length) {
      obj.posts = message.posts.map((e) => TreeNewsPost.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TreeNewsPostList>, I>>(base?: I): TreeNewsPostList {
    return TreeNewsPostList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TreeNewsPostList>, I>>(object: I): TreeNewsPostList {
    const message = createBaseTreeNewsPostList()
    message.posts = object.posts?.map((e) => TreeNewsPost.fromPartial(e)) || []
    return message
  },
}

function createBaseGetDbNewsVocabularyRequest(): GetDbNewsVocabularyRequest {
  return {}
}

export const GetDbNewsVocabularyRequest: MessageFns<GetDbNewsVocabularyRequest> = {
  encode(_: GetDbNewsVocabularyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDbNewsVocabularyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetDbNewsVocabularyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetDbNewsVocabularyRequest {
    return {}
  },

  toJSON(_: GetDbNewsVocabularyRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetDbNewsVocabularyRequest>, I>>(
    base?: I
  ): GetDbNewsVocabularyRequest {
    return GetDbNewsVocabularyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetDbNewsVocabularyRequest>, I>>(
    _: I
  ): GetDbNewsVocabularyRequest {
    const message = createBaseGetDbNewsVocabularyRequest()
    return message
  },
}

function createBaseDbNewsVocabulary(): DbNewsVocabulary {
  return { newsTypes: [], eeTypes: [], coins: [], tags: [] }
}

export const DbNewsVocabulary: MessageFns<DbNewsVocabulary> = {
  encode(message: DbNewsVocabulary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.newsTypes) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.eeTypes) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.coins) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.tags) {
      writer.uint32(34).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DbNewsVocabulary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDbNewsVocabulary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.newsTypes.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.eeTypes.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.coins.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tags.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DbNewsVocabulary {
    return {
      newsTypes: globalThis.Array.isArray(object?.newsTypes)
        ? object.newsTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.news_types)
          ? object.news_types.map((e: any) => globalThis.String(e))
          : [],
      eeTypes: globalThis.Array.isArray(object?.eeTypes)
        ? object.eeTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ee_types)
          ? object.ee_types.map((e: any) => globalThis.String(e))
          : [],
      coins: globalThis.Array.isArray(object?.coins)
        ? object.coins.map((e: any) => globalThis.String(e))
        : [],
      tags: globalThis.Array.isArray(object?.tags)
        ? object.tags.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: DbNewsVocabulary): unknown {
    const obj: any = {}
    if (message.newsTypes?.length) {
      obj.newsTypes = message.newsTypes
    }
    if (message.eeTypes?.length) {
      obj.eeTypes = message.eeTypes
    }
    if (message.coins?.length) {
      obj.coins = message.coins
    }
    if (message.tags?.length) {
      obj.tags = message.tags
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DbNewsVocabulary>, I>>(base?: I): DbNewsVocabulary {
    return DbNewsVocabulary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DbNewsVocabulary>, I>>(object: I): DbNewsVocabulary {
    const message = createBaseDbNewsVocabulary()
    message.newsTypes = object.newsTypes?.map((e) => e) || []
    message.eeTypes = object.eeTypes?.map((e) => e) || []
    message.coins = object.coins?.map((e) => e) || []
    message.tags = object.tags?.map((e) => e) || []
    return message
  },
}

function createBaseTwitterStream(): TwitterStream {
  return {}
}

export const TwitterStream: MessageFns<TwitterStream> = {
  encode(_: TwitterStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwitterStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwitterStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): TwitterStream {
    return {}
  },

  toJSON(_: TwitterStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<TwitterStream>, I>>(base?: I): TwitterStream {
    return TwitterStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwitterStream>, I>>(_: I): TwitterStream {
    const message = createBaseTwitterStream()
    return message
  },
}

function createBaseTwitterPost(): TwitterPost {
  return {
    postId: '',
    handle: '',
    text: '',
    lang: '',
    conversationId: '',
    referencedType: '',
    referencedPostId: '',
    cashtags: [],
    hashtags: [],
    mentions: [],
    urls: [],
    mediaUrls: [],
    createdAt: '',
  }
}

export const TwitterPost: MessageFns<TwitterPost> = {
  encode(message: TwitterPost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.postId !== '') {
      writer.uint32(10).string(message.postId)
    }
    if (message.handle !== '') {
      writer.uint32(18).string(message.handle)
    }
    if (message.text !== '') {
      writer.uint32(26).string(message.text)
    }
    if (message.lang !== '') {
      writer.uint32(34).string(message.lang)
    }
    if (message.conversationId !== '') {
      writer.uint32(42).string(message.conversationId)
    }
    if (message.referencedType !== '') {
      writer.uint32(50).string(message.referencedType)
    }
    if (message.referencedPostId !== '') {
      writer.uint32(58).string(message.referencedPostId)
    }
    for (const v of message.cashtags) {
      writer.uint32(66).string(v!)
    }
    for (const v of message.hashtags) {
      writer.uint32(74).string(v!)
    }
    for (const v of message.mentions) {
      writer.uint32(82).string(v!)
    }
    for (const v of message.urls) {
      writer.uint32(90).string(v!)
    }
    for (const v of message.mediaUrls) {
      writer.uint32(98).string(v!)
    }
    if (message.createdAt !== '') {
      writer.uint32(106).string(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwitterPost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwitterPost()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.postId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.handle = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.lang = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.conversationId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.referencedType = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.referencedPostId = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.cashtags.push(reader.string())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.hashtags.push(reader.string())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.mentions.push(reader.string())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.urls.push(reader.string())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.mediaUrls.push(reader.string())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.createdAt = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TwitterPost {
    return {
      postId: isSet(object.postId)
        ? globalThis.String(object.postId)
        : isSet(object.post_id)
          ? globalThis.String(object.post_id)
          : '',
      handle: isSet(object.handle) ? globalThis.String(object.handle) : '',
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      lang: isSet(object.lang) ? globalThis.String(object.lang) : '',
      conversationId: isSet(object.conversationId)
        ? globalThis.String(object.conversationId)
        : isSet(object.conversation_id)
          ? globalThis.String(object.conversation_id)
          : '',
      referencedType: isSet(object.referencedType)
        ? globalThis.String(object.referencedType)
        : isSet(object.referenced_type)
          ? globalThis.String(object.referenced_type)
          : '',
      referencedPostId: isSet(object.referencedPostId)
        ? globalThis.String(object.referencedPostId)
        : isSet(object.referenced_post_id)
          ? globalThis.String(object.referenced_post_id)
          : '',
      cashtags: globalThis.Array.isArray(object?.cashtags)
        ? object.cashtags.map((e: any) => globalThis.String(e))
        : [],
      hashtags: globalThis.Array.isArray(object?.hashtags)
        ? object.hashtags.map((e: any) => globalThis.String(e))
        : [],
      mentions: globalThis.Array.isArray(object?.mentions)
        ? object.mentions.map((e: any) => globalThis.String(e))
        : [],
      urls: globalThis.Array.isArray(object?.urls)
        ? object.urls.map((e: any) => globalThis.String(e))
        : [],
      mediaUrls: globalThis.Array.isArray(object?.mediaUrls)
        ? object.mediaUrls.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.media_urls)
          ? object.media_urls.map((e: any) => globalThis.String(e))
          : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '',
    }
  },

  toJSON(message: TwitterPost): unknown {
    const obj: any = {}
    if (message.postId !== '') {
      obj.postId = message.postId
    }
    if (message.handle !== '') {
      obj.handle = message.handle
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.lang !== '') {
      obj.lang = message.lang
    }
    if (message.conversationId !== '') {
      obj.conversationId = message.conversationId
    }
    if (message.referencedType !== '') {
      obj.referencedType = message.referencedType
    }
    if (message.referencedPostId !== '') {
      obj.referencedPostId = message.referencedPostId
    }
    if (message.cashtags?.length) {
      obj.cashtags = message.cashtags
    }
    if (message.hashtags?.length) {
      obj.hashtags = message.hashtags
    }
    if (message.mentions?.length) {
      obj.mentions = message.mentions
    }
    if (message.urls?.length) {
      obj.urls = message.urls
    }
    if (message.mediaUrls?.length) {
      obj.mediaUrls = message.mediaUrls
    }
    if (message.createdAt !== '') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TwitterPost>, I>>(base?: I): TwitterPost {
    return TwitterPost.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwitterPost>, I>>(object: I): TwitterPost {
    const message = createBaseTwitterPost()
    message.postId = object.postId ?? ''
    message.handle = object.handle ?? ''
    message.text = object.text ?? ''
    message.lang = object.lang ?? ''
    message.conversationId = object.conversationId ?? ''
    message.referencedType = object.referencedType ?? ''
    message.referencedPostId = object.referencedPostId ?? ''
    message.cashtags = object.cashtags?.map((e) => e) || []
    message.hashtags = object.hashtags?.map((e) => e) || []
    message.mentions = object.mentions?.map((e) => e) || []
    message.urls = object.urls?.map((e) => e) || []
    message.mediaUrls = object.mediaUrls?.map((e) => e) || []
    message.createdAt = object.createdAt ?? ''
    return message
  },
}

function createBaseTwitterPostList(): TwitterPostList {
  return { posts: [] }
}

export const TwitterPostList: MessageFns<TwitterPostList> = {
  encode(message: TwitterPostList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.posts) {
      TwitterPost.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwitterPostList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwitterPostList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.posts.push(TwitterPost.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TwitterPostList {
    return {
      posts: globalThis.Array.isArray(object?.posts)
        ? object.posts.map((e: any) => TwitterPost.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TwitterPostList): unknown {
    const obj: any = {}
    if (message.posts?.length) {
      obj.posts = message.posts.map((e) => TwitterPost.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TwitterPostList>, I>>(base?: I): TwitterPostList {
    return TwitterPostList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwitterPostList>, I>>(object: I): TwitterPostList {
    const message = createBaseTwitterPostList()
    message.posts = object.posts?.map((e) => TwitterPost.fromPartial(e)) || []
    return message
  },
}

function createBaseGetTwitterPostHistoryRequest(): GetTwitterPostHistoryRequest {
  return {
    handle: undefined,
    cashtag: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
    offset: undefined,
  }
}

export const GetTwitterPostHistoryRequest: MessageFns<GetTwitterPostHistoryRequest> = {
  encode(
    message: GetTwitterPostHistoryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.handle !== undefined) {
      writer.uint32(10).string(message.handle)
    }
    if (message.cashtag !== undefined) {
      writer.uint32(18).string(message.cashtag)
    }
    if (message.from !== undefined) {
      writer.uint32(24).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(32).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(40).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(48).int32(message.offset)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTwitterPostHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetTwitterPostHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.handle = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.cashtag = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.offset = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetTwitterPostHistoryRequest {
    return {
      handle: isSet(object.handle) ? globalThis.String(object.handle) : undefined,
      cashtag: isSet(object.cashtag) ? globalThis.String(object.cashtag) : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
    }
  },

  toJSON(message: GetTwitterPostHistoryRequest): unknown {
    const obj: any = {}
    if (message.handle !== undefined) {
      obj.handle = message.handle
    }
    if (message.cashtag !== undefined) {
      obj.cashtag = message.cashtag
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetTwitterPostHistoryRequest>, I>>(
    base?: I
  ): GetTwitterPostHistoryRequest {
    return GetTwitterPostHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetTwitterPostHistoryRequest>, I>>(
    object: I
  ): GetTwitterPostHistoryRequest {
    const message = createBaseGetTwitterPostHistoryRequest()
    message.handle = object.handle ?? undefined
    message.cashtag = object.cashtag ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    return message
  },
}

function createBaseEconomicDataRequest(): EconomicDataRequest {
  return { dataset: 0, from: undefined, to: undefined }
}

export const EconomicDataRequest: MessageFns<EconomicDataRequest> = {
  encode(message: EconomicDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataset !== 0) {
      writer.uint32(8).int32(message.dataset)
    }
    if (message.from !== undefined) {
      writer.uint32(16).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(24).int64(message.to)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicDataRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.dataset = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicDataRequest {
    return {
      dataset: isSet(object.dataset) ? economicDatasetFromJSON(object.dataset) : 0,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
    }
  },

  toJSON(message: EconomicDataRequest): unknown {
    const obj: any = {}
    if (message.dataset !== 0) {
      obj.dataset = economicDatasetToJSON(message.dataset)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicDataRequest>, I>>(base?: I): EconomicDataRequest {
    return EconomicDataRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicDataRequest>, I>>(
    object: I
  ): EconomicDataRequest {
    const message = createBaseEconomicDataRequest()
    message.dataset = object.dataset ?? 0
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    return message
  },
}

function createBaseEconomicInflationPoint(): EconomicInflationPoint {
  return {
    date: '0',
    cpi: undefined,
    cpiCore: undefined,
    cpiYearOverYear: undefined,
    pce: undefined,
    pceCore: undefined,
    pceSpending: undefined,
  }
}

export const EconomicInflationPoint: MessageFns<EconomicInflationPoint> = {
  encode(message: EconomicInflationPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== '0') {
      writer.uint32(8).int64(message.date)
    }
    if (message.cpi !== undefined) {
      writer.uint32(17).double(message.cpi)
    }
    if (message.cpiCore !== undefined) {
      writer.uint32(25).double(message.cpiCore)
    }
    if (message.cpiYearOverYear !== undefined) {
      writer.uint32(33).double(message.cpiYearOverYear)
    }
    if (message.pce !== undefined) {
      writer.uint32(41).double(message.pce)
    }
    if (message.pceCore !== undefined) {
      writer.uint32(49).double(message.pceCore)
    }
    if (message.pceSpending !== undefined) {
      writer.uint32(57).double(message.pceSpending)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicInflationPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicInflationPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.date = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.cpi = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.cpiCore = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.cpiYearOverYear = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.pce = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.pceCore = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.pceSpending = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicInflationPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '0',
      cpi: isSet(object.cpi) ? globalThis.Number(object.cpi) : undefined,
      cpiCore: isSet(object.cpiCore)
        ? globalThis.Number(object.cpiCore)
        : isSet(object.cpi_core)
          ? globalThis.Number(object.cpi_core)
          : undefined,
      cpiYearOverYear: isSet(object.cpiYearOverYear)
        ? globalThis.Number(object.cpiYearOverYear)
        : isSet(object.cpi_year_over_year)
          ? globalThis.Number(object.cpi_year_over_year)
          : undefined,
      pce: isSet(object.pce) ? globalThis.Number(object.pce) : undefined,
      pceCore: isSet(object.pceCore)
        ? globalThis.Number(object.pceCore)
        : isSet(object.pce_core)
          ? globalThis.Number(object.pce_core)
          : undefined,
      pceSpending: isSet(object.pceSpending)
        ? globalThis.Number(object.pceSpending)
        : isSet(object.pce_spending)
          ? globalThis.Number(object.pce_spending)
          : undefined,
    }
  },

  toJSON(message: EconomicInflationPoint): unknown {
    const obj: any = {}
    if (message.date !== '0') {
      obj.date = message.date
    }
    if (message.cpi !== undefined) {
      obj.cpi = message.cpi
    }
    if (message.cpiCore !== undefined) {
      obj.cpiCore = message.cpiCore
    }
    if (message.cpiYearOverYear !== undefined) {
      obj.cpiYearOverYear = message.cpiYearOverYear
    }
    if (message.pce !== undefined) {
      obj.pce = message.pce
    }
    if (message.pceCore !== undefined) {
      obj.pceCore = message.pceCore
    }
    if (message.pceSpending !== undefined) {
      obj.pceSpending = message.pceSpending
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicInflationPoint>, I>>(
    base?: I
  ): EconomicInflationPoint {
    return EconomicInflationPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicInflationPoint>, I>>(
    object: I
  ): EconomicInflationPoint {
    const message = createBaseEconomicInflationPoint()
    message.date = object.date ?? '0'
    message.cpi = object.cpi ?? undefined
    message.cpiCore = object.cpiCore ?? undefined
    message.cpiYearOverYear = object.cpiYearOverYear ?? undefined
    message.pce = object.pce ?? undefined
    message.pceCore = object.pceCore ?? undefined
    message.pceSpending = object.pceSpending ?? undefined
    return message
  },
}

function createBaseEconomicInflationList(): EconomicInflationList {
  return { points: [] }
}

export const EconomicInflationList: MessageFns<EconomicInflationList> = {
  encode(message: EconomicInflationList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      EconomicInflationPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicInflationList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicInflationList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(EconomicInflationPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicInflationList {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => EconomicInflationPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EconomicInflationList): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => EconomicInflationPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicInflationList>, I>>(base?: I): EconomicInflationList {
    return EconomicInflationList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicInflationList>, I>>(
    object: I
  ): EconomicInflationList {
    const message = createBaseEconomicInflationList()
    message.points = object.points?.map((e) => EconomicInflationPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseEconomicInflationExpectationsPoint(): EconomicInflationExpectationsPoint {
  return {
    date: '0',
    forwardYears5To10: undefined,
    market5Year: undefined,
    market10Year: undefined,
    model1Year: undefined,
    model5Year: undefined,
    model10Year: undefined,
    model30Year: undefined,
  }
}

export const EconomicInflationExpectationsPoint: MessageFns<EconomicInflationExpectationsPoint> = {
  encode(
    message: EconomicInflationExpectationsPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.date !== '0') {
      writer.uint32(8).int64(message.date)
    }
    if (message.forwardYears5To10 !== undefined) {
      writer.uint32(17).double(message.forwardYears5To10)
    }
    if (message.market5Year !== undefined) {
      writer.uint32(25).double(message.market5Year)
    }
    if (message.market10Year !== undefined) {
      writer.uint32(33).double(message.market10Year)
    }
    if (message.model1Year !== undefined) {
      writer.uint32(41).double(message.model1Year)
    }
    if (message.model5Year !== undefined) {
      writer.uint32(49).double(message.model5Year)
    }
    if (message.model10Year !== undefined) {
      writer.uint32(57).double(message.model10Year)
    }
    if (message.model30Year !== undefined) {
      writer.uint32(65).double(message.model30Year)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicInflationExpectationsPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicInflationExpectationsPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.date = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.forwardYears5To10 = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.market5Year = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.market10Year = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.model1Year = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.model5Year = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.model10Year = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.model30Year = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicInflationExpectationsPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '0',
      forwardYears5To10: isSet(object.forwardYears5To10)
        ? globalThis.Number(object.forwardYears5To10)
        : isSet(object.forward_years_5_to_10)
          ? globalThis.Number(object.forward_years_5_to_10)
          : undefined,
      market5Year: isSet(object.market5Year)
        ? globalThis.Number(object.market5Year)
        : isSet(object.market_5_year)
          ? globalThis.Number(object.market_5_year)
          : undefined,
      market10Year: isSet(object.market10Year)
        ? globalThis.Number(object.market10Year)
        : isSet(object.market_10_year)
          ? globalThis.Number(object.market_10_year)
          : undefined,
      model1Year: isSet(object.model1Year)
        ? globalThis.Number(object.model1Year)
        : isSet(object.model_1_year)
          ? globalThis.Number(object.model_1_year)
          : undefined,
      model5Year: isSet(object.model5Year)
        ? globalThis.Number(object.model5Year)
        : isSet(object.model_5_year)
          ? globalThis.Number(object.model_5_year)
          : undefined,
      model10Year: isSet(object.model10Year)
        ? globalThis.Number(object.model10Year)
        : isSet(object.model_10_year)
          ? globalThis.Number(object.model_10_year)
          : undefined,
      model30Year: isSet(object.model30Year)
        ? globalThis.Number(object.model30Year)
        : isSet(object.model_30_year)
          ? globalThis.Number(object.model_30_year)
          : undefined,
    }
  },

  toJSON(message: EconomicInflationExpectationsPoint): unknown {
    const obj: any = {}
    if (message.date !== '0') {
      obj.date = message.date
    }
    if (message.forwardYears5To10 !== undefined) {
      obj.forwardYears5To10 = message.forwardYears5To10
    }
    if (message.market5Year !== undefined) {
      obj.market5Year = message.market5Year
    }
    if (message.market10Year !== undefined) {
      obj.market10Year = message.market10Year
    }
    if (message.model1Year !== undefined) {
      obj.model1Year = message.model1Year
    }
    if (message.model5Year !== undefined) {
      obj.model5Year = message.model5Year
    }
    if (message.model10Year !== undefined) {
      obj.model10Year = message.model10Year
    }
    if (message.model30Year !== undefined) {
      obj.model30Year = message.model30Year
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicInflationExpectationsPoint>, I>>(
    base?: I
  ): EconomicInflationExpectationsPoint {
    return EconomicInflationExpectationsPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicInflationExpectationsPoint>, I>>(
    object: I
  ): EconomicInflationExpectationsPoint {
    const message = createBaseEconomicInflationExpectationsPoint()
    message.date = object.date ?? '0'
    message.forwardYears5To10 = object.forwardYears5To10 ?? undefined
    message.market5Year = object.market5Year ?? undefined
    message.market10Year = object.market10Year ?? undefined
    message.model1Year = object.model1Year ?? undefined
    message.model5Year = object.model5Year ?? undefined
    message.model10Year = object.model10Year ?? undefined
    message.model30Year = object.model30Year ?? undefined
    return message
  },
}

function createBaseEconomicInflationExpectationsList(): EconomicInflationExpectationsList {
  return { points: [] }
}

export const EconomicInflationExpectationsList: MessageFns<EconomicInflationExpectationsList> = {
  encode(
    message: EconomicInflationExpectationsList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.points) {
      EconomicInflationExpectationsPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicInflationExpectationsList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicInflationExpectationsList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(EconomicInflationExpectationsPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicInflationExpectationsList {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => EconomicInflationExpectationsPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EconomicInflationExpectationsList): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => EconomicInflationExpectationsPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicInflationExpectationsList>, I>>(
    base?: I
  ): EconomicInflationExpectationsList {
    return EconomicInflationExpectationsList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicInflationExpectationsList>, I>>(
    object: I
  ): EconomicInflationExpectationsList {
    const message = createBaseEconomicInflationExpectationsList()
    message.points =
      object.points?.map((e) => EconomicInflationExpectationsPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseEconomicLaborMarketPoint(): EconomicLaborMarketPoint {
  return {
    date: '0',
    unemploymentRate: undefined,
    laborForceParticipationRate: undefined,
    avgHourlyEarnings: undefined,
    jobOpenings: undefined,
  }
}

export const EconomicLaborMarketPoint: MessageFns<EconomicLaborMarketPoint> = {
  encode(
    message: EconomicLaborMarketPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.date !== '0') {
      writer.uint32(8).int64(message.date)
    }
    if (message.unemploymentRate !== undefined) {
      writer.uint32(17).double(message.unemploymentRate)
    }
    if (message.laborForceParticipationRate !== undefined) {
      writer.uint32(25).double(message.laborForceParticipationRate)
    }
    if (message.avgHourlyEarnings !== undefined) {
      writer.uint32(33).double(message.avgHourlyEarnings)
    }
    if (message.jobOpenings !== undefined) {
      writer.uint32(41).double(message.jobOpenings)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicLaborMarketPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicLaborMarketPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.date = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.unemploymentRate = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.laborForceParticipationRate = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.avgHourlyEarnings = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.jobOpenings = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicLaborMarketPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '0',
      unemploymentRate: isSet(object.unemploymentRate)
        ? globalThis.Number(object.unemploymentRate)
        : isSet(object.unemployment_rate)
          ? globalThis.Number(object.unemployment_rate)
          : undefined,
      laborForceParticipationRate: isSet(object.laborForceParticipationRate)
        ? globalThis.Number(object.laborForceParticipationRate)
        : isSet(object.labor_force_participation_rate)
          ? globalThis.Number(object.labor_force_participation_rate)
          : undefined,
      avgHourlyEarnings: isSet(object.avgHourlyEarnings)
        ? globalThis.Number(object.avgHourlyEarnings)
        : isSet(object.avg_hourly_earnings)
          ? globalThis.Number(object.avg_hourly_earnings)
          : undefined,
      jobOpenings: isSet(object.jobOpenings)
        ? globalThis.Number(object.jobOpenings)
        : isSet(object.job_openings)
          ? globalThis.Number(object.job_openings)
          : undefined,
    }
  },

  toJSON(message: EconomicLaborMarketPoint): unknown {
    const obj: any = {}
    if (message.date !== '0') {
      obj.date = message.date
    }
    if (message.unemploymentRate !== undefined) {
      obj.unemploymentRate = message.unemploymentRate
    }
    if (message.laborForceParticipationRate !== undefined) {
      obj.laborForceParticipationRate = message.laborForceParticipationRate
    }
    if (message.avgHourlyEarnings !== undefined) {
      obj.avgHourlyEarnings = message.avgHourlyEarnings
    }
    if (message.jobOpenings !== undefined) {
      obj.jobOpenings = message.jobOpenings
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicLaborMarketPoint>, I>>(
    base?: I
  ): EconomicLaborMarketPoint {
    return EconomicLaborMarketPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicLaborMarketPoint>, I>>(
    object: I
  ): EconomicLaborMarketPoint {
    const message = createBaseEconomicLaborMarketPoint()
    message.date = object.date ?? '0'
    message.unemploymentRate = object.unemploymentRate ?? undefined
    message.laborForceParticipationRate = object.laborForceParticipationRate ?? undefined
    message.avgHourlyEarnings = object.avgHourlyEarnings ?? undefined
    message.jobOpenings = object.jobOpenings ?? undefined
    return message
  },
}

function createBaseEconomicLaborMarketList(): EconomicLaborMarketList {
  return { points: [] }
}

export const EconomicLaborMarketList: MessageFns<EconomicLaborMarketList> = {
  encode(
    message: EconomicLaborMarketList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.points) {
      EconomicLaborMarketPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicLaborMarketList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicLaborMarketList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(EconomicLaborMarketPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicLaborMarketList {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => EconomicLaborMarketPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EconomicLaborMarketList): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => EconomicLaborMarketPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicLaborMarketList>, I>>(
    base?: I
  ): EconomicLaborMarketList {
    return EconomicLaborMarketList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicLaborMarketList>, I>>(
    object: I
  ): EconomicLaborMarketList {
    const message = createBaseEconomicLaborMarketList()
    message.points = object.points?.map((e) => EconomicLaborMarketPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseEconomicTreasuryYieldPoint(): EconomicTreasuryYieldPoint {
  return {
    date: '0',
    yield1Month: undefined,
    yield3Month: undefined,
    yield6Month: undefined,
    yield1Year: undefined,
    yield2Year: undefined,
    yield3Year: undefined,
    yield5Year: undefined,
    yield7Year: undefined,
    yield10Year: undefined,
    yield20Year: undefined,
    yield30Year: undefined,
  }
}

export const EconomicTreasuryYieldPoint: MessageFns<EconomicTreasuryYieldPoint> = {
  encode(
    message: EconomicTreasuryYieldPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.date !== '0') {
      writer.uint32(8).int64(message.date)
    }
    if (message.yield1Month !== undefined) {
      writer.uint32(17).double(message.yield1Month)
    }
    if (message.yield3Month !== undefined) {
      writer.uint32(25).double(message.yield3Month)
    }
    if (message.yield6Month !== undefined) {
      writer.uint32(33).double(message.yield6Month)
    }
    if (message.yield1Year !== undefined) {
      writer.uint32(41).double(message.yield1Year)
    }
    if (message.yield2Year !== undefined) {
      writer.uint32(49).double(message.yield2Year)
    }
    if (message.yield3Year !== undefined) {
      writer.uint32(57).double(message.yield3Year)
    }
    if (message.yield5Year !== undefined) {
      writer.uint32(65).double(message.yield5Year)
    }
    if (message.yield7Year !== undefined) {
      writer.uint32(73).double(message.yield7Year)
    }
    if (message.yield10Year !== undefined) {
      writer.uint32(81).double(message.yield10Year)
    }
    if (message.yield20Year !== undefined) {
      writer.uint32(89).double(message.yield20Year)
    }
    if (message.yield30Year !== undefined) {
      writer.uint32(97).double(message.yield30Year)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicTreasuryYieldPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicTreasuryYieldPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.date = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.yield1Month = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.yield3Month = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.yield6Month = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.yield1Year = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.yield2Year = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.yield3Year = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.yield5Year = reader.double()
          continue
        }
        case 9: {
          if (tag !== 73) {
            break
          }

          message.yield7Year = reader.double()
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.yield10Year = reader.double()
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.yield20Year = reader.double()
          continue
        }
        case 12: {
          if (tag !== 97) {
            break
          }

          message.yield30Year = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicTreasuryYieldPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '0',
      yield1Month: isSet(object.yield1Month)
        ? globalThis.Number(object.yield1Month)
        : isSet(object.yield_1_month)
          ? globalThis.Number(object.yield_1_month)
          : undefined,
      yield3Month: isSet(object.yield3Month)
        ? globalThis.Number(object.yield3Month)
        : isSet(object.yield_3_month)
          ? globalThis.Number(object.yield_3_month)
          : undefined,
      yield6Month: isSet(object.yield6Month)
        ? globalThis.Number(object.yield6Month)
        : isSet(object.yield_6_month)
          ? globalThis.Number(object.yield_6_month)
          : undefined,
      yield1Year: isSet(object.yield1Year)
        ? globalThis.Number(object.yield1Year)
        : isSet(object.yield_1_year)
          ? globalThis.Number(object.yield_1_year)
          : undefined,
      yield2Year: isSet(object.yield2Year)
        ? globalThis.Number(object.yield2Year)
        : isSet(object.yield_2_year)
          ? globalThis.Number(object.yield_2_year)
          : undefined,
      yield3Year: isSet(object.yield3Year)
        ? globalThis.Number(object.yield3Year)
        : isSet(object.yield_3_year)
          ? globalThis.Number(object.yield_3_year)
          : undefined,
      yield5Year: isSet(object.yield5Year)
        ? globalThis.Number(object.yield5Year)
        : isSet(object.yield_5_year)
          ? globalThis.Number(object.yield_5_year)
          : undefined,
      yield7Year: isSet(object.yield7Year)
        ? globalThis.Number(object.yield7Year)
        : isSet(object.yield_7_year)
          ? globalThis.Number(object.yield_7_year)
          : undefined,
      yield10Year: isSet(object.yield10Year)
        ? globalThis.Number(object.yield10Year)
        : isSet(object.yield_10_year)
          ? globalThis.Number(object.yield_10_year)
          : undefined,
      yield20Year: isSet(object.yield20Year)
        ? globalThis.Number(object.yield20Year)
        : isSet(object.yield_20_year)
          ? globalThis.Number(object.yield_20_year)
          : undefined,
      yield30Year: isSet(object.yield30Year)
        ? globalThis.Number(object.yield30Year)
        : isSet(object.yield_30_year)
          ? globalThis.Number(object.yield_30_year)
          : undefined,
    }
  },

  toJSON(message: EconomicTreasuryYieldPoint): unknown {
    const obj: any = {}
    if (message.date !== '0') {
      obj.date = message.date
    }
    if (message.yield1Month !== undefined) {
      obj.yield1Month = message.yield1Month
    }
    if (message.yield3Month !== undefined) {
      obj.yield3Month = message.yield3Month
    }
    if (message.yield6Month !== undefined) {
      obj.yield6Month = message.yield6Month
    }
    if (message.yield1Year !== undefined) {
      obj.yield1Year = message.yield1Year
    }
    if (message.yield2Year !== undefined) {
      obj.yield2Year = message.yield2Year
    }
    if (message.yield3Year !== undefined) {
      obj.yield3Year = message.yield3Year
    }
    if (message.yield5Year !== undefined) {
      obj.yield5Year = message.yield5Year
    }
    if (message.yield7Year !== undefined) {
      obj.yield7Year = message.yield7Year
    }
    if (message.yield10Year !== undefined) {
      obj.yield10Year = message.yield10Year
    }
    if (message.yield20Year !== undefined) {
      obj.yield20Year = message.yield20Year
    }
    if (message.yield30Year !== undefined) {
      obj.yield30Year = message.yield30Year
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicTreasuryYieldPoint>, I>>(
    base?: I
  ): EconomicTreasuryYieldPoint {
    return EconomicTreasuryYieldPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicTreasuryYieldPoint>, I>>(
    object: I
  ): EconomicTreasuryYieldPoint {
    const message = createBaseEconomicTreasuryYieldPoint()
    message.date = object.date ?? '0'
    message.yield1Month = object.yield1Month ?? undefined
    message.yield3Month = object.yield3Month ?? undefined
    message.yield6Month = object.yield6Month ?? undefined
    message.yield1Year = object.yield1Year ?? undefined
    message.yield2Year = object.yield2Year ?? undefined
    message.yield3Year = object.yield3Year ?? undefined
    message.yield5Year = object.yield5Year ?? undefined
    message.yield7Year = object.yield7Year ?? undefined
    message.yield10Year = object.yield10Year ?? undefined
    message.yield20Year = object.yield20Year ?? undefined
    message.yield30Year = object.yield30Year ?? undefined
    return message
  },
}

function createBaseEconomicTreasuryYieldList(): EconomicTreasuryYieldList {
  return { points: [] }
}

export const EconomicTreasuryYieldList: MessageFns<EconomicTreasuryYieldList> = {
  encode(
    message: EconomicTreasuryYieldList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.points) {
      EconomicTreasuryYieldPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EconomicTreasuryYieldList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEconomicTreasuryYieldList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(EconomicTreasuryYieldPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EconomicTreasuryYieldList {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => EconomicTreasuryYieldPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EconomicTreasuryYieldList): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => EconomicTreasuryYieldPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EconomicTreasuryYieldList>, I>>(
    base?: I
  ): EconomicTreasuryYieldList {
    return EconomicTreasuryYieldList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EconomicTreasuryYieldList>, I>>(
    object: I
  ): EconomicTreasuryYieldList {
    const message = createBaseEconomicTreasuryYieldList()
    message.points = object.points?.map((e) => EconomicTreasuryYieldPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseEtfFundFlowsRequest(): EtfFundFlowsRequest {
  return { asset: '', from: '0', to: '0', byFund: false }
}

export const EtfFundFlowsRequest: MessageFns<EtfFundFlowsRequest> = {
  encode(message: EtfFundFlowsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.from !== '0') {
      writer.uint32(16).int64(message.from)
    }
    if (message.to !== '0') {
      writer.uint32(24).int64(message.to)
    }
    if (message.byFund !== false) {
      writer.uint32(32).bool(message.byFund)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EtfFundFlowsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEtfFundFlowsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.byFund = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EtfFundFlowsRequest {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      from: isSet(object.from) ? globalThis.String(object.from) : '0',
      to: isSet(object.to) ? globalThis.String(object.to) : '0',
      byFund: isSet(object.byFund)
        ? globalThis.Boolean(object.byFund)
        : isSet(object.by_fund)
          ? globalThis.Boolean(object.by_fund)
          : false,
    }
  },

  toJSON(message: EtfFundFlowsRequest): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.from !== '0') {
      obj.from = message.from
    }
    if (message.to !== '0') {
      obj.to = message.to
    }
    if (message.byFund !== false) {
      obj.byFund = message.byFund
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EtfFundFlowsRequest>, I>>(base?: I): EtfFundFlowsRequest {
    return EtfFundFlowsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EtfFundFlowsRequest>, I>>(
    object: I
  ): EtfFundFlowsRequest {
    const message = createBaseEtfFundFlowsRequest()
    message.asset = object.asset ?? ''
    message.from = object.from ?? '0'
    message.to = object.to ?? '0'
    message.byFund = object.byFund ?? false
    return message
  },
}

function createBaseEtfFlowPoint(): EtfFlowPoint {
  return { date: '0', fundFlow: 0, aum: 0, price: undefined, compositeTicker: undefined }
}

export const EtfFlowPoint: MessageFns<EtfFlowPoint> = {
  encode(message: EtfFlowPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== '0') {
      writer.uint32(8).int64(message.date)
    }
    if (message.fundFlow !== 0) {
      writer.uint32(17).double(message.fundFlow)
    }
    if (message.aum !== 0) {
      writer.uint32(25).double(message.aum)
    }
    if (message.price !== undefined) {
      writer.uint32(33).double(message.price)
    }
    if (message.compositeTicker !== undefined) {
      writer.uint32(42).string(message.compositeTicker)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EtfFlowPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEtfFlowPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.date = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.fundFlow = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.aum = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.price = reader.double()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.compositeTicker = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EtfFlowPoint {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '0',
      fundFlow: isSet(object.fundFlow)
        ? globalThis.Number(object.fundFlow)
        : isSet(object.fund_flow)
          ? globalThis.Number(object.fund_flow)
          : 0,
      aum: isSet(object.aum) ? globalThis.Number(object.aum) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : undefined,
      compositeTicker: isSet(object.compositeTicker)
        ? globalThis.String(object.compositeTicker)
        : isSet(object.composite_ticker)
          ? globalThis.String(object.composite_ticker)
          : undefined,
    }
  },

  toJSON(message: EtfFlowPoint): unknown {
    const obj: any = {}
    if (message.date !== '0') {
      obj.date = message.date
    }
    if (message.fundFlow !== 0) {
      obj.fundFlow = message.fundFlow
    }
    if (message.aum !== 0) {
      obj.aum = message.aum
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.compositeTicker !== undefined) {
      obj.compositeTicker = message.compositeTicker
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EtfFlowPoint>, I>>(base?: I): EtfFlowPoint {
    return EtfFlowPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EtfFlowPoint>, I>>(object: I): EtfFlowPoint {
    const message = createBaseEtfFlowPoint()
    message.date = object.date ?? '0'
    message.fundFlow = object.fundFlow ?? 0
    message.aum = object.aum ?? 0
    message.price = object.price ?? undefined
    message.compositeTicker = object.compositeTicker ?? undefined
    return message
  },
}

function createBaseEtfFlowSeries(): EtfFlowSeries {
  return { points: [] }
}

export const EtfFlowSeries: MessageFns<EtfFlowSeries> = {
  encode(message: EtfFlowSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      EtfFlowPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EtfFlowSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEtfFlowSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(EtfFlowPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EtfFlowSeries {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => EtfFlowPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: EtfFlowSeries): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => EtfFlowPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EtfFlowSeries>, I>>(base?: I): EtfFlowSeries {
    return EtfFlowSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EtfFlowSeries>, I>>(object: I): EtfFlowSeries {
    const message = createBaseEtfFlowSeries()
    message.points = object.points?.map((e) => EtfFlowPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseCoinMarketCalEventStream(): CoinMarketCalEventStream {
  return {}
}

export const CoinMarketCalEventStream: MessageFns<CoinMarketCalEventStream> = {
  encode(_: CoinMarketCalEventStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoinMarketCalEventStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCoinMarketCalEventStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): CoinMarketCalEventStream {
    return {}
  },

  toJSON(_: CoinMarketCalEventStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<CoinMarketCalEventStream>, I>>(
    base?: I
  ): CoinMarketCalEventStream {
    return CoinMarketCalEventStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CoinMarketCalEventStream>, I>>(
    _: I
  ): CoinMarketCalEventStream {
    const message = createBaseCoinMarketCalEventStream()
    return message
  },
}

function createBaseCoinMarketCalEvent(): CoinMarketCalEvent {
  return {
    eventId: '',
    slug: '',
    title: '',
    description: '',
    eventDate: '0',
    dateEnd: undefined,
    dateType: 0,
    isEstimated: false,
    displayedDate: '',
    categories: [],
    coinSlugs: [],
    coinSymbols: [],
    impact: undefined,
    impactSummary: '',
    sourceUrl: '',
    snapshotUrl: '',
    lastVerifiedAt: undefined,
    createdAt: '0',
    updatedAt: undefined,
    cancelledAt: undefined,
  }
}

export const CoinMarketCalEvent: MessageFns<CoinMarketCalEvent> = {
  encode(message: CoinMarketCalEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventId !== '') {
      writer.uint32(10).string(message.eventId)
    }
    if (message.slug !== '') {
      writer.uint32(18).string(message.slug)
    }
    if (message.title !== '') {
      writer.uint32(26).string(message.title)
    }
    if (message.description !== '') {
      writer.uint32(34).string(message.description)
    }
    if (message.eventDate !== '0') {
      writer.uint32(40).int64(message.eventDate)
    }
    if (message.dateEnd !== undefined) {
      writer.uint32(48).int64(message.dateEnd)
    }
    if (message.dateType !== 0) {
      writer.uint32(56).int32(message.dateType)
    }
    if (message.isEstimated !== false) {
      writer.uint32(64).bool(message.isEstimated)
    }
    if (message.displayedDate !== '') {
      writer.uint32(74).string(message.displayedDate)
    }
    for (const v of message.categories) {
      writer.uint32(82).string(v!)
    }
    for (const v of message.coinSlugs) {
      writer.uint32(90).string(v!)
    }
    for (const v of message.coinSymbols) {
      writer.uint32(98).string(v!)
    }
    if (message.impact !== undefined) {
      writer.uint32(105).double(message.impact)
    }
    if (message.impactSummary !== '') {
      writer.uint32(114).string(message.impactSummary)
    }
    if (message.sourceUrl !== '') {
      writer.uint32(122).string(message.sourceUrl)
    }
    if (message.snapshotUrl !== '') {
      writer.uint32(130).string(message.snapshotUrl)
    }
    if (message.lastVerifiedAt !== undefined) {
      writer.uint32(136).int64(message.lastVerifiedAt)
    }
    if (message.createdAt !== '0') {
      writer.uint32(144).int64(message.createdAt)
    }
    if (message.updatedAt !== undefined) {
      writer.uint32(152).int64(message.updatedAt)
    }
    if (message.cancelledAt !== undefined) {
      writer.uint32(160).int64(message.cancelledAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoinMarketCalEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCoinMarketCalEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.eventId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.slug = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.title = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.description = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.eventDate = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.dateEnd = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.dateType = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.isEstimated = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.displayedDate = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.categories.push(reader.string())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.coinSlugs.push(reader.string())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.coinSymbols.push(reader.string())
          continue
        }
        case 13: {
          if (tag !== 105) {
            break
          }

          message.impact = reader.double()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.impactSummary = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.sourceUrl = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.snapshotUrl = reader.string()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.lastVerifiedAt = reader.int64().toString()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 20: {
          if (tag !== 160) {
            break
          }

          message.cancelledAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CoinMarketCalEvent {
    return {
      eventId: isSet(object.eventId)
        ? globalThis.String(object.eventId)
        : isSet(object.event_id)
          ? globalThis.String(object.event_id)
          : '',
      slug: isSet(object.slug) ? globalThis.String(object.slug) : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      description: isSet(object.description) ? globalThis.String(object.description) : '',
      eventDate: isSet(object.eventDate)
        ? globalThis.String(object.eventDate)
        : isSet(object.event_date)
          ? globalThis.String(object.event_date)
          : '0',
      dateEnd: isSet(object.dateEnd)
        ? globalThis.String(object.dateEnd)
        : isSet(object.date_end)
          ? globalThis.String(object.date_end)
          : undefined,
      dateType: isSet(object.dateType)
        ? coinMarketCalDateTypeFromJSON(object.dateType)
        : isSet(object.date_type)
          ? coinMarketCalDateTypeFromJSON(object.date_type)
          : 0,
      isEstimated: isSet(object.isEstimated)
        ? globalThis.Boolean(object.isEstimated)
        : isSet(object.is_estimated)
          ? globalThis.Boolean(object.is_estimated)
          : false,
      displayedDate: isSet(object.displayedDate)
        ? globalThis.String(object.displayedDate)
        : isSet(object.displayed_date)
          ? globalThis.String(object.displayed_date)
          : '',
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => globalThis.String(e))
        : [],
      coinSlugs: globalThis.Array.isArray(object?.coinSlugs)
        ? object.coinSlugs.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.coin_slugs)
          ? object.coin_slugs.map((e: any) => globalThis.String(e))
          : [],
      coinSymbols: globalThis.Array.isArray(object?.coinSymbols)
        ? object.coinSymbols.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.coin_symbols)
          ? object.coin_symbols.map((e: any) => globalThis.String(e))
          : [],
      impact: isSet(object.impact) ? globalThis.Number(object.impact) : undefined,
      impactSummary: isSet(object.impactSummary)
        ? globalThis.String(object.impactSummary)
        : isSet(object.impact_summary)
          ? globalThis.String(object.impact_summary)
          : '',
      sourceUrl: isSet(object.sourceUrl)
        ? globalThis.String(object.sourceUrl)
        : isSet(object.source_url)
          ? globalThis.String(object.source_url)
          : '',
      snapshotUrl: isSet(object.snapshotUrl)
        ? globalThis.String(object.snapshotUrl)
        : isSet(object.snapshot_url)
          ? globalThis.String(object.snapshot_url)
          : '',
      lastVerifiedAt: isSet(object.lastVerifiedAt)
        ? globalThis.String(object.lastVerifiedAt)
        : isSet(object.last_verified_at)
          ? globalThis.String(object.last_verified_at)
          : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : undefined,
      cancelledAt: isSet(object.cancelledAt)
        ? globalThis.String(object.cancelledAt)
        : isSet(object.cancelled_at)
          ? globalThis.String(object.cancelled_at)
          : undefined,
    }
  },

  toJSON(message: CoinMarketCalEvent): unknown {
    const obj: any = {}
    if (message.eventId !== '') {
      obj.eventId = message.eventId
    }
    if (message.slug !== '') {
      obj.slug = message.slug
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    if (message.eventDate !== '0') {
      obj.eventDate = message.eventDate
    }
    if (message.dateEnd !== undefined) {
      obj.dateEnd = message.dateEnd
    }
    if (message.dateType !== 0) {
      obj.dateType = coinMarketCalDateTypeToJSON(message.dateType)
    }
    if (message.isEstimated !== false) {
      obj.isEstimated = message.isEstimated
    }
    if (message.displayedDate !== '') {
      obj.displayedDate = message.displayedDate
    }
    if (message.categories?.length) {
      obj.categories = message.categories
    }
    if (message.coinSlugs?.length) {
      obj.coinSlugs = message.coinSlugs
    }
    if (message.coinSymbols?.length) {
      obj.coinSymbols = message.coinSymbols
    }
    if (message.impact !== undefined) {
      obj.impact = message.impact
    }
    if (message.impactSummary !== '') {
      obj.impactSummary = message.impactSummary
    }
    if (message.sourceUrl !== '') {
      obj.sourceUrl = message.sourceUrl
    }
    if (message.snapshotUrl !== '') {
      obj.snapshotUrl = message.snapshotUrl
    }
    if (message.lastVerifiedAt !== undefined) {
      obj.lastVerifiedAt = message.lastVerifiedAt
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt
    }
    if (message.cancelledAt !== undefined) {
      obj.cancelledAt = message.cancelledAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CoinMarketCalEvent>, I>>(base?: I): CoinMarketCalEvent {
    return CoinMarketCalEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CoinMarketCalEvent>, I>>(object: I): CoinMarketCalEvent {
    const message = createBaseCoinMarketCalEvent()
    message.eventId = object.eventId ?? ''
    message.slug = object.slug ?? ''
    message.title = object.title ?? ''
    message.description = object.description ?? ''
    message.eventDate = object.eventDate ?? '0'
    message.dateEnd = object.dateEnd ?? undefined
    message.dateType = object.dateType ?? 0
    message.isEstimated = object.isEstimated ?? false
    message.displayedDate = object.displayedDate ?? ''
    message.categories = object.categories?.map((e) => e) || []
    message.coinSlugs = object.coinSlugs?.map((e) => e) || []
    message.coinSymbols = object.coinSymbols?.map((e) => e) || []
    message.impact = object.impact ?? undefined
    message.impactSummary = object.impactSummary ?? ''
    message.sourceUrl = object.sourceUrl ?? ''
    message.snapshotUrl = object.snapshotUrl ?? ''
    message.lastVerifiedAt = object.lastVerifiedAt ?? undefined
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? undefined
    message.cancelledAt = object.cancelledAt ?? undefined
    return message
  },
}

function createBaseCoinMarketCalEventList(): CoinMarketCalEventList {
  return { events: [] }
}

export const CoinMarketCalEventList: MessageFns<CoinMarketCalEventList> = {
  encode(message: CoinMarketCalEventList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      CoinMarketCalEvent.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoinMarketCalEventList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCoinMarketCalEventList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.events.push(CoinMarketCalEvent.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CoinMarketCalEventList {
    return {
      events: globalThis.Array.isArray(object?.events)
        ? object.events.map((e: any) => CoinMarketCalEvent.fromJSON(e))
        : [],
    }
  },

  toJSON(message: CoinMarketCalEventList): unknown {
    const obj: any = {}
    if (message.events?.length) {
      obj.events = message.events.map((e) => CoinMarketCalEvent.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CoinMarketCalEventList>, I>>(
    base?: I
  ): CoinMarketCalEventList {
    return CoinMarketCalEventList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CoinMarketCalEventList>, I>>(
    object: I
  ): CoinMarketCalEventList {
    const message = createBaseCoinMarketCalEventList()
    message.events = object.events?.map((e) => CoinMarketCalEvent.fromPartial(e)) || []
    return message
  },
}

function createBaseGetCoinMarketCalEventsRequest(): GetCoinMarketCalEventsRequest {
  return {
    from: undefined,
    to: undefined,
    limit: undefined,
    offset: undefined,
    coin: undefined,
    category: undefined,
  }
}

export const GetCoinMarketCalEventsRequest: MessageFns<GetCoinMarketCalEventsRequest> = {
  encode(
    message: GetCoinMarketCalEventsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.from !== undefined) {
      writer.uint32(8).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(16).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(24).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(32).int32(message.offset)
    }
    if (message.coin !== undefined) {
      writer.uint32(42).string(message.coin)
    }
    if (message.category !== undefined) {
      writer.uint32(50).string(message.category)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCoinMarketCalEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetCoinMarketCalEventsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.coin = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.category = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetCoinMarketCalEventsRequest {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      coin: isSet(object.coin) ? globalThis.String(object.coin) : undefined,
      category: isSet(object.category) ? globalThis.String(object.category) : undefined,
    }
  },

  toJSON(message: GetCoinMarketCalEventsRequest): unknown {
    const obj: any = {}
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.coin !== undefined) {
      obj.coin = message.coin
    }
    if (message.category !== undefined) {
      obj.category = message.category
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetCoinMarketCalEventsRequest>, I>>(
    base?: I
  ): GetCoinMarketCalEventsRequest {
    return GetCoinMarketCalEventsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetCoinMarketCalEventsRequest>, I>>(
    object: I
  ): GetCoinMarketCalEventsRequest {
    const message = createBaseGetCoinMarketCalEventsRequest()
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.coin = object.coin ?? undefined
    message.category = object.category ?? undefined
    return message
  },
}

function createBaseTokenUnlockStream(): TokenUnlockStream {
  return {}
}

export const TokenUnlockStream: MessageFns<TokenUnlockStream> = {
  encode(_: TokenUnlockStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenUnlockStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenUnlockStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): TokenUnlockStream {
    return {}
  },

  toJSON(_: TokenUnlockStream): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<TokenUnlockStream>, I>>(base?: I): TokenUnlockStream {
    return TokenUnlockStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenUnlockStream>, I>>(_: I): TokenUnlockStream {
    const message = createBaseTokenUnlockStream()
    return message
  },
}

function createBaseTokenUnlockAllocation(): TokenUnlockAllocation {
  return {
    allocationName: '',
    standardAllocationName: '',
    cliffAmount: 0,
    cliffValue: 0,
    unlockPrecision: '',
    unlockDate: undefined,
    referencePrice: undefined,
    referencePriceUpdatedAt: undefined,
  }
}

export const TokenUnlockAllocation: MessageFns<TokenUnlockAllocation> = {
  encode(message: TokenUnlockAllocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.allocationName !== '') {
      writer.uint32(10).string(message.allocationName)
    }
    if (message.standardAllocationName !== '') {
      writer.uint32(18).string(message.standardAllocationName)
    }
    if (message.cliffAmount !== 0) {
      writer.uint32(25).double(message.cliffAmount)
    }
    if (message.cliffValue !== 0) {
      writer.uint32(33).double(message.cliffValue)
    }
    if (message.unlockPrecision !== '') {
      writer.uint32(42).string(message.unlockPrecision)
    }
    if (message.unlockDate !== undefined) {
      writer.uint32(48).int64(message.unlockDate)
    }
    if (message.referencePrice !== undefined) {
      writer.uint32(57).double(message.referencePrice)
    }
    if (message.referencePriceUpdatedAt !== undefined) {
      writer.uint32(64).int64(message.referencePriceUpdatedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenUnlockAllocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenUnlockAllocation()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.allocationName = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.standardAllocationName = reader.string()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.cliffAmount = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.cliffValue = reader.double()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.unlockPrecision = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.unlockDate = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.referencePrice = reader.double()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.referencePriceUpdatedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TokenUnlockAllocation {
    return {
      allocationName: isSet(object.allocationName)
        ? globalThis.String(object.allocationName)
        : isSet(object.allocation_name)
          ? globalThis.String(object.allocation_name)
          : '',
      standardAllocationName: isSet(object.standardAllocationName)
        ? globalThis.String(object.standardAllocationName)
        : isSet(object.standard_allocation_name)
          ? globalThis.String(object.standard_allocation_name)
          : '',
      cliffAmount: isSet(object.cliffAmount)
        ? globalThis.Number(object.cliffAmount)
        : isSet(object.cliff_amount)
          ? globalThis.Number(object.cliff_amount)
          : 0,
      cliffValue: isSet(object.cliffValue)
        ? globalThis.Number(object.cliffValue)
        : isSet(object.cliff_value)
          ? globalThis.Number(object.cliff_value)
          : 0,
      unlockPrecision: isSet(object.unlockPrecision)
        ? globalThis.String(object.unlockPrecision)
        : isSet(object.unlock_precision)
          ? globalThis.String(object.unlock_precision)
          : '',
      unlockDate: isSet(object.unlockDate)
        ? globalThis.String(object.unlockDate)
        : isSet(object.unlock_date)
          ? globalThis.String(object.unlock_date)
          : undefined,
      referencePrice: isSet(object.referencePrice)
        ? globalThis.Number(object.referencePrice)
        : isSet(object.reference_price)
          ? globalThis.Number(object.reference_price)
          : undefined,
      referencePriceUpdatedAt: isSet(object.referencePriceUpdatedAt)
        ? globalThis.String(object.referencePriceUpdatedAt)
        : isSet(object.reference_price_updated_at)
          ? globalThis.String(object.reference_price_updated_at)
          : undefined,
    }
  },

  toJSON(message: TokenUnlockAllocation): unknown {
    const obj: any = {}
    if (message.allocationName !== '') {
      obj.allocationName = message.allocationName
    }
    if (message.standardAllocationName !== '') {
      obj.standardAllocationName = message.standardAllocationName
    }
    if (message.cliffAmount !== 0) {
      obj.cliffAmount = message.cliffAmount
    }
    if (message.cliffValue !== 0) {
      obj.cliffValue = message.cliffValue
    }
    if (message.unlockPrecision !== '') {
      obj.unlockPrecision = message.unlockPrecision
    }
    if (message.unlockDate !== undefined) {
      obj.unlockDate = message.unlockDate
    }
    if (message.referencePrice !== undefined) {
      obj.referencePrice = message.referencePrice
    }
    if (message.referencePriceUpdatedAt !== undefined) {
      obj.referencePriceUpdatedAt = message.referencePriceUpdatedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TokenUnlockAllocation>, I>>(base?: I): TokenUnlockAllocation {
    return TokenUnlockAllocation.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenUnlockAllocation>, I>>(
    object: I
  ): TokenUnlockAllocation {
    const message = createBaseTokenUnlockAllocation()
    message.allocationName = object.allocationName ?? ''
    message.standardAllocationName = object.standardAllocationName ?? ''
    message.cliffAmount = object.cliffAmount ?? 0
    message.cliffValue = object.cliffValue ?? 0
    message.unlockPrecision = object.unlockPrecision ?? ''
    message.unlockDate = object.unlockDate ?? undefined
    message.referencePrice = object.referencePrice ?? undefined
    message.referencePriceUpdatedAt = object.referencePriceUpdatedAt ?? undefined
    return message
  },
}

function createBaseTokenUnlockEvent(): TokenUnlockEvent {
  return {
    tokenId: '',
    tokenSymbol: '',
    tokenName: '',
    unlockDate: '0',
    totalCliffAmount: 0,
    totalCliffValue: 0,
    valueToMarketCap: undefined,
    marketCap: undefined,
    releasedPercentage: undefined,
    referencePrice: undefined,
    referencePriceUpdatedAt: undefined,
    listedMethod: '',
    dataSource: '',
    allocationBreakdown: [],
    latestUpdateDate: '0',
    lastSeenAt: undefined,
    valuationObservedAt: undefined,
  }
}

export const TokenUnlockEvent: MessageFns<TokenUnlockEvent> = {
  encode(message: TokenUnlockEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.tokenSymbol !== '') {
      writer.uint32(18).string(message.tokenSymbol)
    }
    if (message.tokenName !== '') {
      writer.uint32(26).string(message.tokenName)
    }
    if (message.unlockDate !== '0') {
      writer.uint32(32).int64(message.unlockDate)
    }
    if (message.totalCliffAmount !== 0) {
      writer.uint32(41).double(message.totalCliffAmount)
    }
    if (message.totalCliffValue !== 0) {
      writer.uint32(49).double(message.totalCliffValue)
    }
    if (message.valueToMarketCap !== undefined) {
      writer.uint32(57).double(message.valueToMarketCap)
    }
    if (message.marketCap !== undefined) {
      writer.uint32(65).double(message.marketCap)
    }
    if (message.releasedPercentage !== undefined) {
      writer.uint32(73).double(message.releasedPercentage)
    }
    if (message.referencePrice !== undefined) {
      writer.uint32(81).double(message.referencePrice)
    }
    if (message.referencePriceUpdatedAt !== undefined) {
      writer.uint32(88).int64(message.referencePriceUpdatedAt)
    }
    if (message.listedMethod !== '') {
      writer.uint32(98).string(message.listedMethod)
    }
    if (message.dataSource !== '') {
      writer.uint32(106).string(message.dataSource)
    }
    for (const v of message.allocationBreakdown) {
      TokenUnlockAllocation.encode(v!, writer.uint32(114).fork()).join()
    }
    if (message.latestUpdateDate !== '0') {
      writer.uint32(120).int64(message.latestUpdateDate)
    }
    if (message.lastSeenAt !== undefined) {
      writer.uint32(128).int64(message.lastSeenAt)
    }
    if (message.valuationObservedAt !== undefined) {
      writer.uint32(136).int64(message.valuationObservedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenUnlockEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenUnlockEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tokenSymbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tokenName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.unlockDate = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.totalCliffAmount = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.totalCliffValue = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.valueToMarketCap = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.marketCap = reader.double()
          continue
        }
        case 9: {
          if (tag !== 73) {
            break
          }

          message.releasedPercentage = reader.double()
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.referencePrice = reader.double()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.referencePriceUpdatedAt = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.listedMethod = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.dataSource = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.allocationBreakdown.push(TokenUnlockAllocation.decode(reader, reader.uint32()))
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.latestUpdateDate = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.lastSeenAt = reader.int64().toString()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.valuationObservedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TokenUnlockEvent {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      tokenSymbol: isSet(object.tokenSymbol)
        ? globalThis.String(object.tokenSymbol)
        : isSet(object.token_symbol)
          ? globalThis.String(object.token_symbol)
          : '',
      tokenName: isSet(object.tokenName)
        ? globalThis.String(object.tokenName)
        : isSet(object.token_name)
          ? globalThis.String(object.token_name)
          : '',
      unlockDate: isSet(object.unlockDate)
        ? globalThis.String(object.unlockDate)
        : isSet(object.unlock_date)
          ? globalThis.String(object.unlock_date)
          : '0',
      totalCliffAmount: isSet(object.totalCliffAmount)
        ? globalThis.Number(object.totalCliffAmount)
        : isSet(object.total_cliff_amount)
          ? globalThis.Number(object.total_cliff_amount)
          : 0,
      totalCliffValue: isSet(object.totalCliffValue)
        ? globalThis.Number(object.totalCliffValue)
        : isSet(object.total_cliff_value)
          ? globalThis.Number(object.total_cliff_value)
          : 0,
      valueToMarketCap: isSet(object.valueToMarketCap)
        ? globalThis.Number(object.valueToMarketCap)
        : isSet(object.value_to_market_cap)
          ? globalThis.Number(object.value_to_market_cap)
          : undefined,
      marketCap: isSet(object.marketCap)
        ? globalThis.Number(object.marketCap)
        : isSet(object.market_cap)
          ? globalThis.Number(object.market_cap)
          : undefined,
      releasedPercentage: isSet(object.releasedPercentage)
        ? globalThis.Number(object.releasedPercentage)
        : isSet(object.released_percentage)
          ? globalThis.Number(object.released_percentage)
          : undefined,
      referencePrice: isSet(object.referencePrice)
        ? globalThis.Number(object.referencePrice)
        : isSet(object.reference_price)
          ? globalThis.Number(object.reference_price)
          : undefined,
      referencePriceUpdatedAt: isSet(object.referencePriceUpdatedAt)
        ? globalThis.String(object.referencePriceUpdatedAt)
        : isSet(object.reference_price_updated_at)
          ? globalThis.String(object.reference_price_updated_at)
          : undefined,
      listedMethod: isSet(object.listedMethod)
        ? globalThis.String(object.listedMethod)
        : isSet(object.listed_method)
          ? globalThis.String(object.listed_method)
          : '',
      dataSource: isSet(object.dataSource)
        ? globalThis.String(object.dataSource)
        : isSet(object.data_source)
          ? globalThis.String(object.data_source)
          : '',
      allocationBreakdown: globalThis.Array.isArray(object?.allocationBreakdown)
        ? object.allocationBreakdown.map((e: any) => TokenUnlockAllocation.fromJSON(e))
        : globalThis.Array.isArray(object?.allocation_breakdown)
          ? object.allocation_breakdown.map((e: any) => TokenUnlockAllocation.fromJSON(e))
          : [],
      latestUpdateDate: isSet(object.latestUpdateDate)
        ? globalThis.String(object.latestUpdateDate)
        : isSet(object.latest_update_date)
          ? globalThis.String(object.latest_update_date)
          : '0',
      lastSeenAt: isSet(object.lastSeenAt)
        ? globalThis.String(object.lastSeenAt)
        : isSet(object.last_seen_at)
          ? globalThis.String(object.last_seen_at)
          : undefined,
      valuationObservedAt: isSet(object.valuationObservedAt)
        ? globalThis.String(object.valuationObservedAt)
        : isSet(object.valuation_observed_at)
          ? globalThis.String(object.valuation_observed_at)
          : undefined,
    }
  },

  toJSON(message: TokenUnlockEvent): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.tokenSymbol !== '') {
      obj.tokenSymbol = message.tokenSymbol
    }
    if (message.tokenName !== '') {
      obj.tokenName = message.tokenName
    }
    if (message.unlockDate !== '0') {
      obj.unlockDate = message.unlockDate
    }
    if (message.totalCliffAmount !== 0) {
      obj.totalCliffAmount = message.totalCliffAmount
    }
    if (message.totalCliffValue !== 0) {
      obj.totalCliffValue = message.totalCliffValue
    }
    if (message.valueToMarketCap !== undefined) {
      obj.valueToMarketCap = message.valueToMarketCap
    }
    if (message.marketCap !== undefined) {
      obj.marketCap = message.marketCap
    }
    if (message.releasedPercentage !== undefined) {
      obj.releasedPercentage = message.releasedPercentage
    }
    if (message.referencePrice !== undefined) {
      obj.referencePrice = message.referencePrice
    }
    if (message.referencePriceUpdatedAt !== undefined) {
      obj.referencePriceUpdatedAt = message.referencePriceUpdatedAt
    }
    if (message.listedMethod !== '') {
      obj.listedMethod = message.listedMethod
    }
    if (message.dataSource !== '') {
      obj.dataSource = message.dataSource
    }
    if (message.allocationBreakdown?.length) {
      obj.allocationBreakdown = message.allocationBreakdown.map((e) =>
        TokenUnlockAllocation.toJSON(e)
      )
    }
    if (message.latestUpdateDate !== '0') {
      obj.latestUpdateDate = message.latestUpdateDate
    }
    if (message.lastSeenAt !== undefined) {
      obj.lastSeenAt = message.lastSeenAt
    }
    if (message.valuationObservedAt !== undefined) {
      obj.valuationObservedAt = message.valuationObservedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TokenUnlockEvent>, I>>(base?: I): TokenUnlockEvent {
    return TokenUnlockEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenUnlockEvent>, I>>(object: I): TokenUnlockEvent {
    const message = createBaseTokenUnlockEvent()
    message.tokenId = object.tokenId ?? ''
    message.tokenSymbol = object.tokenSymbol ?? ''
    message.tokenName = object.tokenName ?? ''
    message.unlockDate = object.unlockDate ?? '0'
    message.totalCliffAmount = object.totalCliffAmount ?? 0
    message.totalCliffValue = object.totalCliffValue ?? 0
    message.valueToMarketCap = object.valueToMarketCap ?? undefined
    message.marketCap = object.marketCap ?? undefined
    message.releasedPercentage = object.releasedPercentage ?? undefined
    message.referencePrice = object.referencePrice ?? undefined
    message.referencePriceUpdatedAt = object.referencePriceUpdatedAt ?? undefined
    message.listedMethod = object.listedMethod ?? ''
    message.dataSource = object.dataSource ?? ''
    message.allocationBreakdown =
      object.allocationBreakdown?.map((e) => TokenUnlockAllocation.fromPartial(e)) || []
    message.latestUpdateDate = object.latestUpdateDate ?? '0'
    message.lastSeenAt = object.lastSeenAt ?? undefined
    message.valuationObservedAt = object.valuationObservedAt ?? undefined
    return message
  },
}

function createBaseTokenUnlockEventList(): TokenUnlockEventList {
  return { events: [] }
}

export const TokenUnlockEventList: MessageFns<TokenUnlockEventList> = {
  encode(message: TokenUnlockEventList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      TokenUnlockEvent.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenUnlockEventList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenUnlockEventList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.events.push(TokenUnlockEvent.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TokenUnlockEventList {
    return {
      events: globalThis.Array.isArray(object?.events)
        ? object.events.map((e: any) => TokenUnlockEvent.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TokenUnlockEventList): unknown {
    const obj: any = {}
    if (message.events?.length) {
      obj.events = message.events.map((e) => TokenUnlockEvent.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TokenUnlockEventList>, I>>(base?: I): TokenUnlockEventList {
    return TokenUnlockEventList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenUnlockEventList>, I>>(
    object: I
  ): TokenUnlockEventList {
    const message = createBaseTokenUnlockEventList()
    message.events = object.events?.map((e) => TokenUnlockEvent.fromPartial(e)) || []
    return message
  },
}

function createBaseTokenEmissionPoint(): TokenEmissionPoint {
  return {
    emissionDate: '0',
    periodEnd: '0',
    unlockAmount: 0,
    unlockValue: 0,
    referencePrice: 0,
    totalCumulativeUnlockedAmount: 0,
    allocations: [],
  }
}

export const TokenEmissionPoint: MessageFns<TokenEmissionPoint> = {
  encode(message: TokenEmissionPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.emissionDate !== '0') {
      writer.uint32(8).int64(message.emissionDate)
    }
    if (message.periodEnd !== '0') {
      writer.uint32(16).int64(message.periodEnd)
    }
    if (message.unlockAmount !== 0) {
      writer.uint32(25).double(message.unlockAmount)
    }
    if (message.unlockValue !== 0) {
      writer.uint32(33).double(message.unlockValue)
    }
    if (message.referencePrice !== 0) {
      writer.uint32(41).double(message.referencePrice)
    }
    if (message.totalCumulativeUnlockedAmount !== 0) {
      writer.uint32(49).double(message.totalCumulativeUnlockedAmount)
    }
    for (const v of message.allocations) {
      TokenUnlockAllocation.encode(v!, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenEmissionPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenEmissionPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.emissionDate = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.periodEnd = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.unlockAmount = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.unlockValue = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.referencePrice = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.totalCumulativeUnlockedAmount = reader.double()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.allocations.push(TokenUnlockAllocation.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TokenEmissionPoint {
    return {
      emissionDate: isSet(object.emissionDate)
        ? globalThis.String(object.emissionDate)
        : isSet(object.emission_date)
          ? globalThis.String(object.emission_date)
          : '0',
      periodEnd: isSet(object.periodEnd)
        ? globalThis.String(object.periodEnd)
        : isSet(object.period_end)
          ? globalThis.String(object.period_end)
          : '0',
      unlockAmount: isSet(object.unlockAmount)
        ? globalThis.Number(object.unlockAmount)
        : isSet(object.unlock_amount)
          ? globalThis.Number(object.unlock_amount)
          : 0,
      unlockValue: isSet(object.unlockValue)
        ? globalThis.Number(object.unlockValue)
        : isSet(object.unlock_value)
          ? globalThis.Number(object.unlock_value)
          : 0,
      referencePrice: isSet(object.referencePrice)
        ? globalThis.Number(object.referencePrice)
        : isSet(object.reference_price)
          ? globalThis.Number(object.reference_price)
          : 0,
      totalCumulativeUnlockedAmount: isSet(object.totalCumulativeUnlockedAmount)
        ? globalThis.Number(object.totalCumulativeUnlockedAmount)
        : isSet(object.total_cumulative_unlocked_amount)
          ? globalThis.Number(object.total_cumulative_unlocked_amount)
          : 0,
      allocations: globalThis.Array.isArray(object?.allocations)
        ? object.allocations.map((e: any) => TokenUnlockAllocation.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TokenEmissionPoint): unknown {
    const obj: any = {}
    if (message.emissionDate !== '0') {
      obj.emissionDate = message.emissionDate
    }
    if (message.periodEnd !== '0') {
      obj.periodEnd = message.periodEnd
    }
    if (message.unlockAmount !== 0) {
      obj.unlockAmount = message.unlockAmount
    }
    if (message.unlockValue !== 0) {
      obj.unlockValue = message.unlockValue
    }
    if (message.referencePrice !== 0) {
      obj.referencePrice = message.referencePrice
    }
    if (message.totalCumulativeUnlockedAmount !== 0) {
      obj.totalCumulativeUnlockedAmount = message.totalCumulativeUnlockedAmount
    }
    if (message.allocations?.length) {
      obj.allocations = message.allocations.map((e) => TokenUnlockAllocation.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TokenEmissionPoint>, I>>(base?: I): TokenEmissionPoint {
    return TokenEmissionPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenEmissionPoint>, I>>(object: I): TokenEmissionPoint {
    const message = createBaseTokenEmissionPoint()
    message.emissionDate = object.emissionDate ?? '0'
    message.periodEnd = object.periodEnd ?? '0'
    message.unlockAmount = object.unlockAmount ?? 0
    message.unlockValue = object.unlockValue ?? 0
    message.referencePrice = object.referencePrice ?? 0
    message.totalCumulativeUnlockedAmount = object.totalCumulativeUnlockedAmount ?? 0
    message.allocations = object.allocations?.map((e) => TokenUnlockAllocation.fromPartial(e)) || []
    return message
  },
}

function createBaseTokenEmissionSeries(): TokenEmissionSeries {
  return { tokenId: '', tokenSymbol: '', points: [] }
}

export const TokenEmissionSeries: MessageFns<TokenEmissionSeries> = {
  encode(message: TokenEmissionSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.tokenSymbol !== '') {
      writer.uint32(18).string(message.tokenSymbol)
    }
    for (const v of message.points) {
      TokenEmissionPoint.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenEmissionSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTokenEmissionSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tokenSymbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.points.push(TokenEmissionPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TokenEmissionSeries {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      tokenSymbol: isSet(object.tokenSymbol)
        ? globalThis.String(object.tokenSymbol)
        : isSet(object.token_symbol)
          ? globalThis.String(object.token_symbol)
          : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => TokenEmissionPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TokenEmissionSeries): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.tokenSymbol !== '') {
      obj.tokenSymbol = message.tokenSymbol
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => TokenEmissionPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TokenEmissionSeries>, I>>(base?: I): TokenEmissionSeries {
    return TokenEmissionSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TokenEmissionSeries>, I>>(
    object: I
  ): TokenEmissionSeries {
    const message = createBaseTokenEmissionSeries()
    message.tokenId = object.tokenId ?? ''
    message.tokenSymbol = object.tokenSymbol ?? ''
    message.points = object.points?.map((e) => TokenEmissionPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetTokenUnlocksRequest(): GetTokenUnlocksRequest {
  return {
    from: undefined,
    to: undefined,
    limit: undefined,
    offset: undefined,
    token: undefined,
    minValueToMarketCap: undefined,
    minMarketCap: undefined,
  }
}

export const GetTokenUnlocksRequest: MessageFns<GetTokenUnlocksRequest> = {
  encode(message: GetTokenUnlocksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== undefined) {
      writer.uint32(8).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(16).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(24).int32(message.limit)
    }
    if (message.offset !== undefined) {
      writer.uint32(32).int32(message.offset)
    }
    if (message.token !== undefined) {
      writer.uint32(42).string(message.token)
    }
    if (message.minValueToMarketCap !== undefined) {
      writer.uint32(49).double(message.minValueToMarketCap)
    }
    if (message.minMarketCap !== undefined) {
      writer.uint32(57).double(message.minMarketCap)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTokenUnlocksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetTokenUnlocksRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.offset = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.token = reader.string()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.minValueToMarketCap = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.minMarketCap = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetTokenUnlocksRequest {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      token: isSet(object.token) ? globalThis.String(object.token) : undefined,
      minValueToMarketCap: isSet(object.minValueToMarketCap)
        ? globalThis.Number(object.minValueToMarketCap)
        : isSet(object.min_value_to_market_cap)
          ? globalThis.Number(object.min_value_to_market_cap)
          : undefined,
      minMarketCap: isSet(object.minMarketCap)
        ? globalThis.Number(object.minMarketCap)
        : isSet(object.min_market_cap)
          ? globalThis.Number(object.min_market_cap)
          : undefined,
    }
  },

  toJSON(message: GetTokenUnlocksRequest): unknown {
    const obj: any = {}
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset)
    }
    if (message.token !== undefined) {
      obj.token = message.token
    }
    if (message.minValueToMarketCap !== undefined) {
      obj.minValueToMarketCap = message.minValueToMarketCap
    }
    if (message.minMarketCap !== undefined) {
      obj.minMarketCap = message.minMarketCap
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetTokenUnlocksRequest>, I>>(
    base?: I
  ): GetTokenUnlocksRequest {
    return GetTokenUnlocksRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetTokenUnlocksRequest>, I>>(
    object: I
  ): GetTokenUnlocksRequest {
    const message = createBaseGetTokenUnlocksRequest()
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.offset = object.offset ?? undefined
    message.token = object.token ?? undefined
    message.minValueToMarketCap = object.minValueToMarketCap ?? undefined
    message.minMarketCap = object.minMarketCap ?? undefined
    return message
  },
}

function createBaseGetTokenEmissionRequest(): GetTokenEmissionRequest {
  return { token: '', from: undefined, to: undefined }
}

export const GetTokenEmissionRequest: MessageFns<GetTokenEmissionRequest> = {
  encode(
    message: GetTokenEmissionRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.token !== '') {
      writer.uint32(10).string(message.token)
    }
    if (message.from !== undefined) {
      writer.uint32(16).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(24).int64(message.to)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTokenEmissionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetTokenEmissionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.token = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetTokenEmissionRequest {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : '',
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
    }
  },

  toJSON(message: GetTokenEmissionRequest): unknown {
    const obj: any = {}
    if (message.token !== '') {
      obj.token = message.token
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetTokenEmissionRequest>, I>>(
    base?: I
  ): GetTokenEmissionRequest {
    return GetTokenEmissionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetTokenEmissionRequest>, I>>(
    object: I
  ): GetTokenEmissionRequest {
    const message = createBaseGetTokenEmissionRequest()
    message.token = object.token ?? ''
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    return message
  },
}

function createBaseNotifications(): Notifications {
  return { accountId: '', accountIds: [] }
}

export const Notifications: MessageFns<Notifications> = {
  encode(message: Notifications, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(18).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Notifications {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseNotifications()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Notifications {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: Notifications): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Notifications>, I>>(base?: I): Notifications {
    return Notifications.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Notifications>, I>>(object: I): Notifications {
    const message = createBaseNotifications()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    return message
  },
}

function createBaseMarketDataStream(): MarketDataStream {
  return { exchange: 0, symbol: '', dataType: 0, depth: 0 }
}

export const MarketDataStream: MessageFns<MarketDataStream> = {
  encode(message: MarketDataStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.dataType !== 0) {
      writer.uint32(24).int32(message.dataType)
    }
    if (message.depth !== 0) {
      writer.uint32(32).int32(message.depth)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketDataStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarketDataStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.dataType = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.depth = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarketDataStream {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      dataType: isSet(object.dataType)
        ? marketDataTypeFromJSON(object.dataType)
        : isSet(object.data_type)
          ? marketDataTypeFromJSON(object.data_type)
          : 0,
      depth: isSet(object.depth) ? globalThis.Number(object.depth) : 0,
    }
  },

  toJSON(message: MarketDataStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.dataType !== 0) {
      obj.dataType = marketDataTypeToJSON(message.dataType)
    }
    if (message.depth !== 0) {
      obj.depth = Math.round(message.depth)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarketDataStream>, I>>(base?: I): MarketDataStream {
    return MarketDataStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarketDataStream>, I>>(object: I): MarketDataStream {
    const message = createBaseMarketDataStream()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.dataType = object.dataType ?? 0
    message.depth = object.depth ?? 0
    return message
  },
}

function createBaseExchangeData(): ExchangeData {
  return { exchange: 0, dataType: 0 }
}

export const ExchangeData: MessageFns<ExchangeData> = {
  encode(message: ExchangeData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExchangeData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExchangeData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.dataType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExchangeData {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      dataType: isSet(object.dataType)
        ? exchangeDataTypeFromJSON(object.dataType)
        : isSet(object.data_type)
          ? exchangeDataTypeFromJSON(object.data_type)
          : 0,
    }
  },

  toJSON(message: ExchangeData): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.dataType !== 0) {
      obj.dataType = exchangeDataTypeToJSON(message.dataType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExchangeData>, I>>(base?: I): ExchangeData {
    return ExchangeData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeData>, I>>(object: I): ExchangeData {
    const message = createBaseExchangeData()
    message.exchange = object.exchange ?? 0
    message.dataType = object.dataType ?? 0
    return message
  },
}

function createBaseExchangeStatusStream(): ExchangeStatusStream {
  return { exchange: 0 }
}

export const ExchangeStatusStream: MessageFns<ExchangeStatusStream> = {
  encode(message: ExchangeStatusStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExchangeStatusStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExchangeStatusStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExchangeStatusStream {
    return { exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0 }
  },

  toJSON(message: ExchangeStatusStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExchangeStatusStream>, I>>(base?: I): ExchangeStatusStream {
    return ExchangeStatusStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeStatusStream>, I>>(
    object: I
  ): ExchangeStatusStream {
    const message = createBaseExchangeStatusStream()
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseVenueHealthStream(): VenueHealthStream {
  return { exchange: 0 }
}

export const VenueHealthStream: MessageFns<VenueHealthStream> = {
  encode(message: VenueHealthStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueHealthStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueHealthStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueHealthStream {
    return { exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0 }
  },

  toJSON(message: VenueHealthStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueHealthStream>, I>>(base?: I): VenueHealthStream {
    return VenueHealthStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueHealthStream>, I>>(object: I): VenueHealthStream {
    const message = createBaseVenueHealthStream()
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseAccountData(): AccountData {
  return { accountId: '', accountIds: [], dataType: 0 }
}

export const AccountData: MessageFns<AccountData> = {
  encode(message: AccountData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.dataType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountData {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      dataType: isSet(object.dataType)
        ? accountDataTypeFromJSON(object.dataType)
        : isSet(object.data_type)
          ? accountDataTypeFromJSON(object.data_type)
          : 0,
    }
  },

  toJSON(message: AccountData): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.dataType !== 0) {
      obj.dataType = accountDataTypeToJSON(message.dataType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountData>, I>>(base?: I): AccountData {
    return AccountData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountData>, I>>(object: I): AccountData {
    const message = createBaseAccountData()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.dataType = object.dataType ?? 0
    return message
  },
}

function createBaseAccountDataStream(): AccountDataStream {
  return { accountId: '', accountIds: [], dataType: 0 }
}

export const AccountDataStream: MessageFns<AccountDataStream> = {
  encode(message: AccountDataStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountDataStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountDataStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.dataType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountDataStream {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      dataType: isSet(object.dataType)
        ? accountDataStreamTypeFromJSON(object.dataType)
        : isSet(object.data_type)
          ? accountDataStreamTypeFromJSON(object.data_type)
          : 0,
    }
  },

  toJSON(message: AccountDataStream): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.dataType !== 0) {
      obj.dataType = accountDataStreamTypeToJSON(message.dataType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountDataStream>, I>>(base?: I): AccountDataStream {
    return AccountDataStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountDataStream>, I>>(object: I): AccountDataStream {
    const message = createBaseAccountDataStream()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.dataType = object.dataType ?? 0
    return message
  },
}

function createBaseChartDataStream(): ChartDataStream {
  return { symbol: '', exchange: 0, timeframe: 0 }
}

export const ChartDataStream: MessageFns<ChartDataStream> = {
  encode(message: ChartDataStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartDataStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartDataStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartDataStream {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
    }
  },

  toJSON(message: ChartDataStream): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartDataStream>, I>>(base?: I): ChartDataStream {
    return ChartDataStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartDataStream>, I>>(object: I): ChartDataStream {
    const message = createBaseChartDataStream()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.timeframe = object.timeframe ?? 0
    return message
  },
}

function createBaseAnalyticsStream(): AnalyticsStream {
  return { exchange: 0, symbol: '', analyticsType: 0 }
}

export const AnalyticsStream: MessageFns<AnalyticsStream> = {
  encode(message: AnalyticsStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.analyticsType !== 0) {
      writer.uint32(24).int32(message.analyticsType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalyticsStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAnalyticsStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.analyticsType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AnalyticsStream {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      analyticsType: isSet(object.analyticsType)
        ? analyticsTypeFromJSON(object.analyticsType)
        : isSet(object.analytics_type)
          ? analyticsTypeFromJSON(object.analytics_type)
          : 0,
    }
  },

  toJSON(message: AnalyticsStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.analyticsType !== 0) {
      obj.analyticsType = analyticsTypeToJSON(message.analyticsType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AnalyticsStream>, I>>(base?: I): AnalyticsStream {
    return AnalyticsStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AnalyticsStream>, I>>(object: I): AnalyticsStream {
    const message = createBaseAnalyticsStream()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.analyticsType = object.analyticsType ?? 0
    return message
  },
}

function createBasePolymarketSignalStream(): PolymarketSignalStream {
  return { tokenId: '' }
}

export const PolymarketSignalStream: MessageFns<PolymarketSignalStream> = {
  encode(message: PolymarketSignalStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketSignalStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketSignalStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketSignalStream {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
    }
  },

  toJSON(message: PolymarketSignalStream): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketSignalStream>, I>>(
    base?: I
  ): PolymarketSignalStream {
    return PolymarketSignalStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketSignalStream>, I>>(
    object: I
  ): PolymarketSignalStream {
    const message = createBasePolymarketSignalStream()
    message.tokenId = object.tokenId ?? ''
    return message
  },
}

function createBasePolymarketSignal(): PolymarketSignal {
  return { tokenId: '', yesMid: '', tsMs: '0' }
}

export const PolymarketSignal: MessageFns<PolymarketSignal> = {
  encode(message: PolymarketSignal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.yesMid !== '') {
      writer.uint32(18).string(message.yesMid)
    }
    if (message.tsMs !== '0') {
      writer.uint32(24).int64(message.tsMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketSignal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketSignal()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.yesMid = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tsMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketSignal {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      yesMid: isSet(object.yesMid)
        ? globalThis.String(object.yesMid)
        : isSet(object.yes_mid)
          ? globalThis.String(object.yes_mid)
          : '',
      tsMs: isSet(object.tsMs)
        ? globalThis.String(object.tsMs)
        : isSet(object.ts_ms)
          ? globalThis.String(object.ts_ms)
          : '0',
    }
  },

  toJSON(message: PolymarketSignal): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.yesMid !== '') {
      obj.yesMid = message.yesMid
    }
    if (message.tsMs !== '0') {
      obj.tsMs = message.tsMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketSignal>, I>>(base?: I): PolymarketSignal {
    return PolymarketSignal.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketSignal>, I>>(object: I): PolymarketSignal {
    const message = createBasePolymarketSignal()
    message.tokenId = object.tokenId ?? ''
    message.yesMid = object.yesMid ?? ''
    message.tsMs = object.tsMs ?? '0'
    return message
  },
}

function createBasePolymarketResolveRequest(): PolymarketResolveRequest {
  return { text: undefined, slug: undefined, conditionId: undefined, tokenId: undefined }
}

export const PolymarketResolveRequest: MessageFns<PolymarketResolveRequest> = {
  encode(
    message: PolymarketResolveRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.text !== undefined) {
      writer.uint32(10).string(message.text)
    }
    if (message.slug !== undefined) {
      writer.uint32(18).string(message.slug)
    }
    if (message.conditionId !== undefined) {
      writer.uint32(26).string(message.conditionId)
    }
    if (message.tokenId !== undefined) {
      writer.uint32(34).string(message.tokenId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketResolveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketResolveRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.slug = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.conditionId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketResolveRequest {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
          ? globalThis.String(object.condition_id)
          : undefined,
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : undefined,
    }
  },

  toJSON(message: PolymarketResolveRequest): unknown {
    const obj: any = {}
    if (message.text !== undefined) {
      obj.text = message.text
    }
    if (message.slug !== undefined) {
      obj.slug = message.slug
    }
    if (message.conditionId !== undefined) {
      obj.conditionId = message.conditionId
    }
    if (message.tokenId !== undefined) {
      obj.tokenId = message.tokenId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketResolveRequest>, I>>(
    base?: I
  ): PolymarketResolveRequest {
    return PolymarketResolveRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketResolveRequest>, I>>(
    object: I
  ): PolymarketResolveRequest {
    const message = createBasePolymarketResolveRequest()
    message.text = object.text ?? undefined
    message.slug = object.slug ?? undefined
    message.conditionId = object.conditionId ?? undefined
    message.tokenId = object.tokenId ?? undefined
    return message
  },
}

function createBasePolymarketResolvedToken(): PolymarketResolvedToken {
  return { tokenId: '', outcome: '', pairedTokenId: '' }
}

export const PolymarketResolvedToken: MessageFns<PolymarketResolvedToken> = {
  encode(
    message: PolymarketResolvedToken,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.outcome !== '') {
      writer.uint32(18).string(message.outcome)
    }
    if (message.pairedTokenId !== '') {
      writer.uint32(26).string(message.pairedTokenId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketResolvedToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketResolvedToken()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.outcome = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.pairedTokenId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketResolvedToken {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      outcome: isSet(object.outcome) ? globalThis.String(object.outcome) : '',
      pairedTokenId: isSet(object.pairedTokenId)
        ? globalThis.String(object.pairedTokenId)
        : isSet(object.paired_token_id)
          ? globalThis.String(object.paired_token_id)
          : '',
    }
  },

  toJSON(message: PolymarketResolvedToken): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.outcome !== '') {
      obj.outcome = message.outcome
    }
    if (message.pairedTokenId !== '') {
      obj.pairedTokenId = message.pairedTokenId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketResolvedToken>, I>>(
    base?: I
  ): PolymarketResolvedToken {
    return PolymarketResolvedToken.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketResolvedToken>, I>>(
    object: I
  ): PolymarketResolvedToken {
    const message = createBasePolymarketResolvedToken()
    message.tokenId = object.tokenId ?? ''
    message.outcome = object.outcome ?? ''
    message.pairedTokenId = object.pairedTokenId ?? ''
    return message
  },
}

function createBasePolymarketResolvedMarket(): PolymarketResolvedMarket {
  return { conditionId: '', question: '', slug: '', endDateMs: '0', tokens: [] }
}

export const PolymarketResolvedMarket: MessageFns<PolymarketResolvedMarket> = {
  encode(
    message: PolymarketResolvedMarket,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.conditionId !== '') {
      writer.uint32(10).string(message.conditionId)
    }
    if (message.question !== '') {
      writer.uint32(18).string(message.question)
    }
    if (message.slug !== '') {
      writer.uint32(26).string(message.slug)
    }
    if (message.endDateMs !== '0') {
      writer.uint32(32).int64(message.endDateMs)
    }
    for (const v of message.tokens) {
      PolymarketResolvedToken.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketResolvedMarket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketResolvedMarket()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.conditionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.question = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.slug = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.endDateMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.tokens.push(PolymarketResolvedToken.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketResolvedMarket {
    return {
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
          ? globalThis.String(object.condition_id)
          : '',
      question: isSet(object.question) ? globalThis.String(object.question) : '',
      slug: isSet(object.slug) ? globalThis.String(object.slug) : '',
      endDateMs: isSet(object.endDateMs)
        ? globalThis.String(object.endDateMs)
        : isSet(object.end_date_ms)
          ? globalThis.String(object.end_date_ms)
          : '0',
      tokens: globalThis.Array.isArray(object?.tokens)
        ? object.tokens.map((e: any) => PolymarketResolvedToken.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PolymarketResolvedMarket): unknown {
    const obj: any = {}
    if (message.conditionId !== '') {
      obj.conditionId = message.conditionId
    }
    if (message.question !== '') {
      obj.question = message.question
    }
    if (message.slug !== '') {
      obj.slug = message.slug
    }
    if (message.endDateMs !== '0') {
      obj.endDateMs = message.endDateMs
    }
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => PolymarketResolvedToken.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketResolvedMarket>, I>>(
    base?: I
  ): PolymarketResolvedMarket {
    return PolymarketResolvedMarket.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketResolvedMarket>, I>>(
    object: I
  ): PolymarketResolvedMarket {
    const message = createBasePolymarketResolvedMarket()
    message.conditionId = object.conditionId ?? ''
    message.question = object.question ?? ''
    message.slug = object.slug ?? ''
    message.endDateMs = object.endDateMs ?? '0'
    message.tokens = object.tokens?.map((e) => PolymarketResolvedToken.fromPartial(e)) || []
    return message
  },
}

function createBasePolymarketResolveResponse(): PolymarketResolveResponse {
  return { markets: [] }
}

export const PolymarketResolveResponse: MessageFns<PolymarketResolveResponse> = {
  encode(
    message: PolymarketResolveResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.markets) {
      PolymarketResolvedMarket.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketResolveResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketResolveResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.markets.push(PolymarketResolvedMarket.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketResolveResponse {
    return {
      markets: globalThis.Array.isArray(object?.markets)
        ? object.markets.map((e: any) => PolymarketResolvedMarket.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PolymarketResolveResponse): unknown {
    const obj: any = {}
    if (message.markets?.length) {
      obj.markets = message.markets.map((e) => PolymarketResolvedMarket.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketResolveResponse>, I>>(
    base?: I
  ): PolymarketResolveResponse {
    return PolymarketResolveResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketResolveResponse>, I>>(
    object: I
  ): PolymarketResolveResponse {
    const message = createBasePolymarketResolveResponse()
    message.markets = object.markets?.map((e) => PolymarketResolvedMarket.fromPartial(e)) || []
    return message
  },
}

function createBasePolymarketSubscriptionRequest(): PolymarketSubscriptionRequest {
  return { tokenId: '', action: 0 }
}

export const PolymarketSubscriptionRequest: MessageFns<PolymarketSubscriptionRequest> = {
  encode(
    message: PolymarketSubscriptionRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tokenId !== '') {
      writer.uint32(10).string(message.tokenId)
    }
    if (message.action !== 0) {
      writer.uint32(16).int32(message.action)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PolymarketSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePolymarketSubscriptionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tokenId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.action = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PolymarketSubscriptionRequest {
    return {
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
          ? globalThis.String(object.token_id)
          : '',
      action: isSet(object.action) ? polymarketSubscriptionActionFromJSON(object.action) : 0,
    }
  },

  toJSON(message: PolymarketSubscriptionRequest): unknown {
    const obj: any = {}
    if (message.tokenId !== '') {
      obj.tokenId = message.tokenId
    }
    if (message.action !== 0) {
      obj.action = polymarketSubscriptionActionToJSON(message.action)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PolymarketSubscriptionRequest>, I>>(
    base?: I
  ): PolymarketSubscriptionRequest {
    return PolymarketSubscriptionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PolymarketSubscriptionRequest>, I>>(
    object: I
  ): PolymarketSubscriptionRequest {
    const message = createBasePolymarketSubscriptionRequest()
    message.tokenId = object.tokenId ?? ''
    message.action = object.action ?? 0
    return message
  },
}

function createBaseExecution(): Execution {
  return { accountId: '', tradeVenue: 0 }
}

export const Execution: MessageFns<Execution> = {
  encode(message: Execution, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(16).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Execution {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecution()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Execution {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: Execution): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Execution>, I>>(base?: I): Execution {
    return Execution.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Execution>, I>>(object: I): Execution {
    const message = createBaseExecution()
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseExecutionAnalyticsStream(): ExecutionAnalyticsStream {
  return { accountId: '', accountIds: [], targetType: 0, targetId: '' }
}

export const ExecutionAnalyticsStream: MessageFns<ExecutionAnalyticsStream> = {
  encode(
    message: ExecutionAnalyticsStream,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(34).string(v!)
    }
    if (message.targetType !== 0) {
      writer.uint32(16).int32(message.targetType)
    }
    if (message.targetId !== '') {
      writer.uint32(26).string(message.targetId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAnalyticsStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAnalyticsStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.targetType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.targetId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAnalyticsStream {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      targetType: isSet(object.targetType)
        ? executionAnalyticsTargetTypeFromJSON(object.targetType)
        : isSet(object.target_type)
          ? executionAnalyticsTargetTypeFromJSON(object.target_type)
          : 0,
      targetId: isSet(object.targetId)
        ? globalThis.String(object.targetId)
        : isSet(object.target_id)
          ? globalThis.String(object.target_id)
          : '',
    }
  },

  toJSON(message: ExecutionAnalyticsStream): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.targetType !== 0) {
      obj.targetType = executionAnalyticsTargetTypeToJSON(message.targetType)
    }
    if (message.targetId !== '') {
      obj.targetId = message.targetId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAnalyticsStream>, I>>(
    base?: I
  ): ExecutionAnalyticsStream {
    return ExecutionAnalyticsStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAnalyticsStream>, I>>(
    object: I
  ): ExecutionAnalyticsStream {
    const message = createBaseExecutionAnalyticsStream()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.targetType = object.targetType ?? 0
    message.targetId = object.targetId ?? ''
    return message
  },
}

function createBaseTriggerConditionStream(): TriggerConditionStream {
  return { accountId: '', accountIds: [], registrationId: '', triggerId: '' }
}

export const TriggerConditionStream: MessageFns<TriggerConditionStream> = {
  encode(message: TriggerConditionStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(34).string(v!)
    }
    if (message.registrationId !== '') {
      writer.uint32(18).string(message.registrationId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerConditionStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerConditionStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerConditionStream {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
    }
  },

  toJSON(message: TriggerConditionStream): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerConditionStream>, I>>(
    base?: I
  ): TriggerConditionStream {
    return TriggerConditionStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerConditionStream>, I>>(
    object: I
  ): TriggerConditionStream {
    const message = createBaseTriggerConditionStream()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.registrationId = object.registrationId ?? ''
    message.triggerId = object.triggerId ?? ''
    return message
  },
}

function createBaseExecutionAnalyticsRequest(): ExecutionAnalyticsRequest {
  return {
    accountId: '',
    accountIds: [],
    targetType: 0,
    targetId: '',
    from: undefined,
    to: undefined,
    includeOrders: 0,
    includeTrades: undefined,
    includeBenchmarks: undefined,
  }
}

export const ExecutionAnalyticsRequest: MessageFns<ExecutionAnalyticsRequest> = {
  encode(
    message: ExecutionAnalyticsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(82).string(v!)
    }
    if (message.targetType !== 0) {
      writer.uint32(16).int32(message.targetType)
    }
    if (message.targetId !== '') {
      writer.uint32(26).string(message.targetId)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.includeOrders !== 0) {
      writer.uint32(48).int32(message.includeOrders)
    }
    if (message.includeTrades !== undefined) {
      writer.uint32(56).bool(message.includeTrades)
    }
    if (message.includeBenchmarks !== undefined) {
      writer.uint32(72).bool(message.includeBenchmarks)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAnalyticsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAnalyticsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.targetType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.targetId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.includeOrders = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.includeTrades = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.includeBenchmarks = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAnalyticsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      targetType: isSet(object.targetType)
        ? executionAnalyticsTargetTypeFromJSON(object.targetType)
        : isSet(object.target_type)
          ? executionAnalyticsTargetTypeFromJSON(object.target_type)
          : 0,
      targetId: isSet(object.targetId)
        ? globalThis.String(object.targetId)
        : isSet(object.target_id)
          ? globalThis.String(object.target_id)
          : '',
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      includeOrders: isSet(object.includeOrders)
        ? orderInclusionFromJSON(object.includeOrders)
        : isSet(object.include_orders)
          ? orderInclusionFromJSON(object.include_orders)
          : 0,
      includeTrades: isSet(object.includeTrades)
        ? globalThis.Boolean(object.includeTrades)
        : isSet(object.include_trades)
          ? globalThis.Boolean(object.include_trades)
          : undefined,
      includeBenchmarks: isSet(object.includeBenchmarks)
        ? globalThis.Boolean(object.includeBenchmarks)
        : isSet(object.include_benchmarks)
          ? globalThis.Boolean(object.include_benchmarks)
          : undefined,
    }
  },

  toJSON(message: ExecutionAnalyticsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.targetType !== 0) {
      obj.targetType = executionAnalyticsTargetTypeToJSON(message.targetType)
    }
    if (message.targetId !== '') {
      obj.targetId = message.targetId
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.includeOrders !== 0) {
      obj.includeOrders = orderInclusionToJSON(message.includeOrders)
    }
    if (message.includeTrades !== undefined) {
      obj.includeTrades = message.includeTrades
    }
    if (message.includeBenchmarks !== undefined) {
      obj.includeBenchmarks = message.includeBenchmarks
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAnalyticsRequest>, I>>(
    base?: I
  ): ExecutionAnalyticsRequest {
    return ExecutionAnalyticsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAnalyticsRequest>, I>>(
    object: I
  ): ExecutionAnalyticsRequest {
    const message = createBaseExecutionAnalyticsRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.targetType = object.targetType ?? 0
    message.targetId = object.targetId ?? ''
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.includeOrders = object.includeOrders ?? 0
    message.includeTrades = object.includeTrades ?? undefined
    message.includeBenchmarks = object.includeBenchmarks ?? undefined
    return message
  },
}

function createBaseExecutionAlgorithmStats(): ExecutionAlgorithmStats {
  return {
    currentAvgFillPrice: undefined,
    currentAvgFillPriceInclFees: undefined,
    amountFilledQuote: '',
    amountFilledBase: '',
    timeRunningMs: '0',
    timeRemainingMs: undefined,
    feesPaidQuote: '',
    feesPaidBase: '',
    makerVolumeQuote: '',
    makerVolumeBase: '',
    takerVolumeQuote: '',
    takerVolumeBase: '',
    participationRate: undefined,
    currentAvgFillPriceIv: undefined,
    currentAvgFillPriceInclFeesIv: undefined,
  }
}

export const ExecutionAlgorithmStats: MessageFns<ExecutionAlgorithmStats> = {
  encode(
    message: ExecutionAlgorithmStats,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.currentAvgFillPrice !== undefined) {
      writer.uint32(10).string(message.currentAvgFillPrice)
    }
    if (message.currentAvgFillPriceInclFees !== undefined) {
      writer.uint32(18).string(message.currentAvgFillPriceInclFees)
    }
    if (message.amountFilledQuote !== '') {
      writer.uint32(26).string(message.amountFilledQuote)
    }
    if (message.amountFilledBase !== '') {
      writer.uint32(34).string(message.amountFilledBase)
    }
    if (message.timeRunningMs !== '0') {
      writer.uint32(40).int64(message.timeRunningMs)
    }
    if (message.timeRemainingMs !== undefined) {
      writer.uint32(48).int64(message.timeRemainingMs)
    }
    if (message.feesPaidQuote !== '') {
      writer.uint32(58).string(message.feesPaidQuote)
    }
    if (message.feesPaidBase !== '') {
      writer.uint32(66).string(message.feesPaidBase)
    }
    if (message.makerVolumeQuote !== '') {
      writer.uint32(74).string(message.makerVolumeQuote)
    }
    if (message.makerVolumeBase !== '') {
      writer.uint32(82).string(message.makerVolumeBase)
    }
    if (message.takerVolumeQuote !== '') {
      writer.uint32(90).string(message.takerVolumeQuote)
    }
    if (message.takerVolumeBase !== '') {
      writer.uint32(98).string(message.takerVolumeBase)
    }
    if (message.participationRate !== undefined) {
      writer.uint32(106).string(message.participationRate)
    }
    if (message.currentAvgFillPriceIv !== undefined) {
      writer.uint32(114).string(message.currentAvgFillPriceIv)
    }
    if (message.currentAvgFillPriceInclFeesIv !== undefined) {
      writer.uint32(122).string(message.currentAvgFillPriceInclFeesIv)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAlgorithmStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAlgorithmStats()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.currentAvgFillPrice = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currentAvgFillPriceInclFees = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.amountFilledQuote = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.amountFilledBase = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.timeRunningMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.timeRemainingMs = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.feesPaidQuote = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.feesPaidBase = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.makerVolumeQuote = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.makerVolumeBase = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.takerVolumeQuote = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.takerVolumeBase = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.participationRate = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.currentAvgFillPriceIv = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.currentAvgFillPriceInclFeesIv = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAlgorithmStats {
    return {
      currentAvgFillPrice: isSet(object.currentAvgFillPrice)
        ? globalThis.String(object.currentAvgFillPrice)
        : isSet(object.current_avg_fill_price)
          ? globalThis.String(object.current_avg_fill_price)
          : undefined,
      currentAvgFillPriceInclFees: isSet(object.currentAvgFillPriceInclFees)
        ? globalThis.String(object.currentAvgFillPriceInclFees)
        : isSet(object.current_avg_fill_price_incl_fees)
          ? globalThis.String(object.current_avg_fill_price_incl_fees)
          : undefined,
      amountFilledQuote: isSet(object.amountFilledQuote)
        ? globalThis.String(object.amountFilledQuote)
        : isSet(object.amount_filled_quote)
          ? globalThis.String(object.amount_filled_quote)
          : '',
      amountFilledBase: isSet(object.amountFilledBase)
        ? globalThis.String(object.amountFilledBase)
        : isSet(object.amount_filled_base)
          ? globalThis.String(object.amount_filled_base)
          : '',
      timeRunningMs: isSet(object.timeRunningMs)
        ? globalThis.String(object.timeRunningMs)
        : isSet(object.time_running_ms)
          ? globalThis.String(object.time_running_ms)
          : '0',
      timeRemainingMs: isSet(object.timeRemainingMs)
        ? globalThis.String(object.timeRemainingMs)
        : isSet(object.time_remaining_ms)
          ? globalThis.String(object.time_remaining_ms)
          : undefined,
      feesPaidQuote: isSet(object.feesPaidQuote)
        ? globalThis.String(object.feesPaidQuote)
        : isSet(object.fees_paid_quote)
          ? globalThis.String(object.fees_paid_quote)
          : '',
      feesPaidBase: isSet(object.feesPaidBase)
        ? globalThis.String(object.feesPaidBase)
        : isSet(object.fees_paid_base)
          ? globalThis.String(object.fees_paid_base)
          : '',
      makerVolumeQuote: isSet(object.makerVolumeQuote)
        ? globalThis.String(object.makerVolumeQuote)
        : isSet(object.maker_volume_quote)
          ? globalThis.String(object.maker_volume_quote)
          : '',
      makerVolumeBase: isSet(object.makerVolumeBase)
        ? globalThis.String(object.makerVolumeBase)
        : isSet(object.maker_volume_base)
          ? globalThis.String(object.maker_volume_base)
          : '',
      takerVolumeQuote: isSet(object.takerVolumeQuote)
        ? globalThis.String(object.takerVolumeQuote)
        : isSet(object.taker_volume_quote)
          ? globalThis.String(object.taker_volume_quote)
          : '',
      takerVolumeBase: isSet(object.takerVolumeBase)
        ? globalThis.String(object.takerVolumeBase)
        : isSet(object.taker_volume_base)
          ? globalThis.String(object.taker_volume_base)
          : '',
      participationRate: isSet(object.participationRate)
        ? globalThis.String(object.participationRate)
        : isSet(object.participation_rate)
          ? globalThis.String(object.participation_rate)
          : undefined,
      currentAvgFillPriceIv: isSet(object.currentAvgFillPriceIv)
        ? globalThis.String(object.currentAvgFillPriceIv)
        : isSet(object.current_avg_fill_price_iv)
          ? globalThis.String(object.current_avg_fill_price_iv)
          : undefined,
      currentAvgFillPriceInclFeesIv: isSet(object.currentAvgFillPriceInclFeesIv)
        ? globalThis.String(object.currentAvgFillPriceInclFeesIv)
        : isSet(object.current_avg_fill_price_incl_fees_iv)
          ? globalThis.String(object.current_avg_fill_price_incl_fees_iv)
          : undefined,
    }
  },

  toJSON(message: ExecutionAlgorithmStats): unknown {
    const obj: any = {}
    if (message.currentAvgFillPrice !== undefined) {
      obj.currentAvgFillPrice = message.currentAvgFillPrice
    }
    if (message.currentAvgFillPriceInclFees !== undefined) {
      obj.currentAvgFillPriceInclFees = message.currentAvgFillPriceInclFees
    }
    if (message.amountFilledQuote !== '') {
      obj.amountFilledQuote = message.amountFilledQuote
    }
    if (message.amountFilledBase !== '') {
      obj.amountFilledBase = message.amountFilledBase
    }
    if (message.timeRunningMs !== '0') {
      obj.timeRunningMs = message.timeRunningMs
    }
    if (message.timeRemainingMs !== undefined) {
      obj.timeRemainingMs = message.timeRemainingMs
    }
    if (message.feesPaidQuote !== '') {
      obj.feesPaidQuote = message.feesPaidQuote
    }
    if (message.feesPaidBase !== '') {
      obj.feesPaidBase = message.feesPaidBase
    }
    if (message.makerVolumeQuote !== '') {
      obj.makerVolumeQuote = message.makerVolumeQuote
    }
    if (message.makerVolumeBase !== '') {
      obj.makerVolumeBase = message.makerVolumeBase
    }
    if (message.takerVolumeQuote !== '') {
      obj.takerVolumeQuote = message.takerVolumeQuote
    }
    if (message.takerVolumeBase !== '') {
      obj.takerVolumeBase = message.takerVolumeBase
    }
    if (message.participationRate !== undefined) {
      obj.participationRate = message.participationRate
    }
    if (message.currentAvgFillPriceIv !== undefined) {
      obj.currentAvgFillPriceIv = message.currentAvgFillPriceIv
    }
    if (message.currentAvgFillPriceInclFeesIv !== undefined) {
      obj.currentAvgFillPriceInclFeesIv = message.currentAvgFillPriceInclFeesIv
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAlgorithmStats>, I>>(
    base?: I
  ): ExecutionAlgorithmStats {
    return ExecutionAlgorithmStats.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAlgorithmStats>, I>>(
    object: I
  ): ExecutionAlgorithmStats {
    const message = createBaseExecutionAlgorithmStats()
    message.currentAvgFillPrice = object.currentAvgFillPrice ?? undefined
    message.currentAvgFillPriceInclFees = object.currentAvgFillPriceInclFees ?? undefined
    message.amountFilledQuote = object.amountFilledQuote ?? ''
    message.amountFilledBase = object.amountFilledBase ?? ''
    message.timeRunningMs = object.timeRunningMs ?? '0'
    message.timeRemainingMs = object.timeRemainingMs ?? undefined
    message.feesPaidQuote = object.feesPaidQuote ?? ''
    message.feesPaidBase = object.feesPaidBase ?? ''
    message.makerVolumeQuote = object.makerVolumeQuote ?? ''
    message.makerVolumeBase = object.makerVolumeBase ?? ''
    message.takerVolumeQuote = object.takerVolumeQuote ?? ''
    message.takerVolumeBase = object.takerVolumeBase ?? ''
    message.participationRate = object.participationRate ?? undefined
    message.currentAvgFillPriceIv = object.currentAvgFillPriceIv ?? undefined
    message.currentAvgFillPriceInclFeesIv = object.currentAvgFillPriceInclFeesIv ?? undefined
    return message
  },
}

function createBaseExecutionPerformanceBenchmarks(): ExecutionPerformanceBenchmarks {
  return {
    arrivalPrice: undefined,
    arrivalPriceInclSlippage: undefined,
    arrivalPriceInclSlippageFees: undefined,
    departurePrice: undefined,
    departurePriceInclSlippage: undefined,
    departurePriceInclSlippageFees: undefined,
    vwap: undefined,
    vwapInclFees: undefined,
    twap: undefined,
    twapInclFees: undefined,
    currentMarketMidPrice: undefined,
    currentMarketMarkPrice: undefined,
    arrivalPriceIv: undefined,
    arrivalPriceInclSlippageIv: undefined,
    arrivalPriceInclSlippageFeesIv: undefined,
    departurePriceIv: undefined,
    departurePriceInclSlippageIv: undefined,
    departurePriceInclSlippageFeesIv: undefined,
    vwapIv: undefined,
    vwapInclFeesIv: undefined,
    twapIv: undefined,
    twapInclFeesIv: undefined,
    currentMarketMidPriceIv: undefined,
    currentMarketMarkPriceIv: undefined,
  }
}

export const ExecutionPerformanceBenchmarks: MessageFns<ExecutionPerformanceBenchmarks> = {
  encode(
    message: ExecutionPerformanceBenchmarks,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.arrivalPrice !== undefined) {
      writer.uint32(10).string(message.arrivalPrice)
    }
    if (message.arrivalPriceInclSlippage !== undefined) {
      writer.uint32(18).string(message.arrivalPriceInclSlippage)
    }
    if (message.arrivalPriceInclSlippageFees !== undefined) {
      writer.uint32(26).string(message.arrivalPriceInclSlippageFees)
    }
    if (message.departurePrice !== undefined) {
      writer.uint32(34).string(message.departurePrice)
    }
    if (message.departurePriceInclSlippage !== undefined) {
      writer.uint32(42).string(message.departurePriceInclSlippage)
    }
    if (message.departurePriceInclSlippageFees !== undefined) {
      writer.uint32(50).string(message.departurePriceInclSlippageFees)
    }
    if (message.vwap !== undefined) {
      writer.uint32(58).string(message.vwap)
    }
    if (message.vwapInclFees !== undefined) {
      writer.uint32(66).string(message.vwapInclFees)
    }
    if (message.twap !== undefined) {
      writer.uint32(74).string(message.twap)
    }
    if (message.twapInclFees !== undefined) {
      writer.uint32(82).string(message.twapInclFees)
    }
    if (message.currentMarketMidPrice !== undefined) {
      writer.uint32(90).string(message.currentMarketMidPrice)
    }
    if (message.currentMarketMarkPrice !== undefined) {
      writer.uint32(98).string(message.currentMarketMarkPrice)
    }
    if (message.arrivalPriceIv !== undefined) {
      writer.uint32(106).string(message.arrivalPriceIv)
    }
    if (message.arrivalPriceInclSlippageIv !== undefined) {
      writer.uint32(114).string(message.arrivalPriceInclSlippageIv)
    }
    if (message.arrivalPriceInclSlippageFeesIv !== undefined) {
      writer.uint32(122).string(message.arrivalPriceInclSlippageFeesIv)
    }
    if (message.departurePriceIv !== undefined) {
      writer.uint32(130).string(message.departurePriceIv)
    }
    if (message.departurePriceInclSlippageIv !== undefined) {
      writer.uint32(138).string(message.departurePriceInclSlippageIv)
    }
    if (message.departurePriceInclSlippageFeesIv !== undefined) {
      writer.uint32(146).string(message.departurePriceInclSlippageFeesIv)
    }
    if (message.vwapIv !== undefined) {
      writer.uint32(154).string(message.vwapIv)
    }
    if (message.vwapInclFeesIv !== undefined) {
      writer.uint32(162).string(message.vwapInclFeesIv)
    }
    if (message.twapIv !== undefined) {
      writer.uint32(170).string(message.twapIv)
    }
    if (message.twapInclFeesIv !== undefined) {
      writer.uint32(178).string(message.twapInclFeesIv)
    }
    if (message.currentMarketMidPriceIv !== undefined) {
      writer.uint32(186).string(message.currentMarketMidPriceIv)
    }
    if (message.currentMarketMarkPriceIv !== undefined) {
      writer.uint32(194).string(message.currentMarketMarkPriceIv)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionPerformanceBenchmarks {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionPerformanceBenchmarks()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.arrivalPrice = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.arrivalPriceInclSlippage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.arrivalPriceInclSlippageFees = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.departurePrice = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.departurePriceInclSlippage = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.departurePriceInclSlippageFees = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.vwap = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.vwapInclFees = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.twap = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.twapInclFees = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.currentMarketMidPrice = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.currentMarketMarkPrice = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.arrivalPriceIv = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.arrivalPriceInclSlippageIv = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.arrivalPriceInclSlippageFeesIv = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.departurePriceIv = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.departurePriceInclSlippageIv = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.departurePriceInclSlippageFeesIv = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.vwapIv = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.vwapInclFeesIv = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.twapIv = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.twapInclFeesIv = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.currentMarketMidPriceIv = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.currentMarketMarkPriceIv = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionPerformanceBenchmarks {
    return {
      arrivalPrice: isSet(object.arrivalPrice)
        ? globalThis.String(object.arrivalPrice)
        : isSet(object.arrival_price)
          ? globalThis.String(object.arrival_price)
          : undefined,
      arrivalPriceInclSlippage: isSet(object.arrivalPriceInclSlippage)
        ? globalThis.String(object.arrivalPriceInclSlippage)
        : isSet(object.arrival_price_incl_slippage)
          ? globalThis.String(object.arrival_price_incl_slippage)
          : undefined,
      arrivalPriceInclSlippageFees: isSet(object.arrivalPriceInclSlippageFees)
        ? globalThis.String(object.arrivalPriceInclSlippageFees)
        : isSet(object.arrival_price_incl_slippage_fees)
          ? globalThis.String(object.arrival_price_incl_slippage_fees)
          : undefined,
      departurePrice: isSet(object.departurePrice)
        ? globalThis.String(object.departurePrice)
        : isSet(object.departure_price)
          ? globalThis.String(object.departure_price)
          : undefined,
      departurePriceInclSlippage: isSet(object.departurePriceInclSlippage)
        ? globalThis.String(object.departurePriceInclSlippage)
        : isSet(object.departure_price_incl_slippage)
          ? globalThis.String(object.departure_price_incl_slippage)
          : undefined,
      departurePriceInclSlippageFees: isSet(object.departurePriceInclSlippageFees)
        ? globalThis.String(object.departurePriceInclSlippageFees)
        : isSet(object.departure_price_incl_slippage_fees)
          ? globalThis.String(object.departure_price_incl_slippage_fees)
          : undefined,
      vwap: isSet(object.vwap) ? globalThis.String(object.vwap) : undefined,
      vwapInclFees: isSet(object.vwapInclFees)
        ? globalThis.String(object.vwapInclFees)
        : isSet(object.vwap_incl_fees)
          ? globalThis.String(object.vwap_incl_fees)
          : undefined,
      twap: isSet(object.twap) ? globalThis.String(object.twap) : undefined,
      twapInclFees: isSet(object.twapInclFees)
        ? globalThis.String(object.twapInclFees)
        : isSet(object.twap_incl_fees)
          ? globalThis.String(object.twap_incl_fees)
          : undefined,
      currentMarketMidPrice: isSet(object.currentMarketMidPrice)
        ? globalThis.String(object.currentMarketMidPrice)
        : isSet(object.current_market_mid_price)
          ? globalThis.String(object.current_market_mid_price)
          : undefined,
      currentMarketMarkPrice: isSet(object.currentMarketMarkPrice)
        ? globalThis.String(object.currentMarketMarkPrice)
        : isSet(object.current_market_mark_price)
          ? globalThis.String(object.current_market_mark_price)
          : undefined,
      arrivalPriceIv: isSet(object.arrivalPriceIv)
        ? globalThis.String(object.arrivalPriceIv)
        : isSet(object.arrival_price_iv)
          ? globalThis.String(object.arrival_price_iv)
          : undefined,
      arrivalPriceInclSlippageIv: isSet(object.arrivalPriceInclSlippageIv)
        ? globalThis.String(object.arrivalPriceInclSlippageIv)
        : isSet(object.arrival_price_incl_slippage_iv)
          ? globalThis.String(object.arrival_price_incl_slippage_iv)
          : undefined,
      arrivalPriceInclSlippageFeesIv: isSet(object.arrivalPriceInclSlippageFeesIv)
        ? globalThis.String(object.arrivalPriceInclSlippageFeesIv)
        : isSet(object.arrival_price_incl_slippage_fees_iv)
          ? globalThis.String(object.arrival_price_incl_slippage_fees_iv)
          : undefined,
      departurePriceIv: isSet(object.departurePriceIv)
        ? globalThis.String(object.departurePriceIv)
        : isSet(object.departure_price_iv)
          ? globalThis.String(object.departure_price_iv)
          : undefined,
      departurePriceInclSlippageIv: isSet(object.departurePriceInclSlippageIv)
        ? globalThis.String(object.departurePriceInclSlippageIv)
        : isSet(object.departure_price_incl_slippage_iv)
          ? globalThis.String(object.departure_price_incl_slippage_iv)
          : undefined,
      departurePriceInclSlippageFeesIv: isSet(object.departurePriceInclSlippageFeesIv)
        ? globalThis.String(object.departurePriceInclSlippageFeesIv)
        : isSet(object.departure_price_incl_slippage_fees_iv)
          ? globalThis.String(object.departure_price_incl_slippage_fees_iv)
          : undefined,
      vwapIv: isSet(object.vwapIv)
        ? globalThis.String(object.vwapIv)
        : isSet(object.vwap_iv)
          ? globalThis.String(object.vwap_iv)
          : undefined,
      vwapInclFeesIv: isSet(object.vwapInclFeesIv)
        ? globalThis.String(object.vwapInclFeesIv)
        : isSet(object.vwap_incl_fees_iv)
          ? globalThis.String(object.vwap_incl_fees_iv)
          : undefined,
      twapIv: isSet(object.twapIv)
        ? globalThis.String(object.twapIv)
        : isSet(object.twap_iv)
          ? globalThis.String(object.twap_iv)
          : undefined,
      twapInclFeesIv: isSet(object.twapInclFeesIv)
        ? globalThis.String(object.twapInclFeesIv)
        : isSet(object.twap_incl_fees_iv)
          ? globalThis.String(object.twap_incl_fees_iv)
          : undefined,
      currentMarketMidPriceIv: isSet(object.currentMarketMidPriceIv)
        ? globalThis.String(object.currentMarketMidPriceIv)
        : isSet(object.current_market_mid_price_iv)
          ? globalThis.String(object.current_market_mid_price_iv)
          : undefined,
      currentMarketMarkPriceIv: isSet(object.currentMarketMarkPriceIv)
        ? globalThis.String(object.currentMarketMarkPriceIv)
        : isSet(object.current_market_mark_price_iv)
          ? globalThis.String(object.current_market_mark_price_iv)
          : undefined,
    }
  },

  toJSON(message: ExecutionPerformanceBenchmarks): unknown {
    const obj: any = {}
    if (message.arrivalPrice !== undefined) {
      obj.arrivalPrice = message.arrivalPrice
    }
    if (message.arrivalPriceInclSlippage !== undefined) {
      obj.arrivalPriceInclSlippage = message.arrivalPriceInclSlippage
    }
    if (message.arrivalPriceInclSlippageFees !== undefined) {
      obj.arrivalPriceInclSlippageFees = message.arrivalPriceInclSlippageFees
    }
    if (message.departurePrice !== undefined) {
      obj.departurePrice = message.departurePrice
    }
    if (message.departurePriceInclSlippage !== undefined) {
      obj.departurePriceInclSlippage = message.departurePriceInclSlippage
    }
    if (message.departurePriceInclSlippageFees !== undefined) {
      obj.departurePriceInclSlippageFees = message.departurePriceInclSlippageFees
    }
    if (message.vwap !== undefined) {
      obj.vwap = message.vwap
    }
    if (message.vwapInclFees !== undefined) {
      obj.vwapInclFees = message.vwapInclFees
    }
    if (message.twap !== undefined) {
      obj.twap = message.twap
    }
    if (message.twapInclFees !== undefined) {
      obj.twapInclFees = message.twapInclFees
    }
    if (message.currentMarketMidPrice !== undefined) {
      obj.currentMarketMidPrice = message.currentMarketMidPrice
    }
    if (message.currentMarketMarkPrice !== undefined) {
      obj.currentMarketMarkPrice = message.currentMarketMarkPrice
    }
    if (message.arrivalPriceIv !== undefined) {
      obj.arrivalPriceIv = message.arrivalPriceIv
    }
    if (message.arrivalPriceInclSlippageIv !== undefined) {
      obj.arrivalPriceInclSlippageIv = message.arrivalPriceInclSlippageIv
    }
    if (message.arrivalPriceInclSlippageFeesIv !== undefined) {
      obj.arrivalPriceInclSlippageFeesIv = message.arrivalPriceInclSlippageFeesIv
    }
    if (message.departurePriceIv !== undefined) {
      obj.departurePriceIv = message.departurePriceIv
    }
    if (message.departurePriceInclSlippageIv !== undefined) {
      obj.departurePriceInclSlippageIv = message.departurePriceInclSlippageIv
    }
    if (message.departurePriceInclSlippageFeesIv !== undefined) {
      obj.departurePriceInclSlippageFeesIv = message.departurePriceInclSlippageFeesIv
    }
    if (message.vwapIv !== undefined) {
      obj.vwapIv = message.vwapIv
    }
    if (message.vwapInclFeesIv !== undefined) {
      obj.vwapInclFeesIv = message.vwapInclFeesIv
    }
    if (message.twapIv !== undefined) {
      obj.twapIv = message.twapIv
    }
    if (message.twapInclFeesIv !== undefined) {
      obj.twapInclFeesIv = message.twapInclFeesIv
    }
    if (message.currentMarketMidPriceIv !== undefined) {
      obj.currentMarketMidPriceIv = message.currentMarketMidPriceIv
    }
    if (message.currentMarketMarkPriceIv !== undefined) {
      obj.currentMarketMarkPriceIv = message.currentMarketMarkPriceIv
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionPerformanceBenchmarks>, I>>(
    base?: I
  ): ExecutionPerformanceBenchmarks {
    return ExecutionPerformanceBenchmarks.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionPerformanceBenchmarks>, I>>(
    object: I
  ): ExecutionPerformanceBenchmarks {
    const message = createBaseExecutionPerformanceBenchmarks()
    message.arrivalPrice = object.arrivalPrice ?? undefined
    message.arrivalPriceInclSlippage = object.arrivalPriceInclSlippage ?? undefined
    message.arrivalPriceInclSlippageFees = object.arrivalPriceInclSlippageFees ?? undefined
    message.departurePrice = object.departurePrice ?? undefined
    message.departurePriceInclSlippage = object.departurePriceInclSlippage ?? undefined
    message.departurePriceInclSlippageFees = object.departurePriceInclSlippageFees ?? undefined
    message.vwap = object.vwap ?? undefined
    message.vwapInclFees = object.vwapInclFees ?? undefined
    message.twap = object.twap ?? undefined
    message.twapInclFees = object.twapInclFees ?? undefined
    message.currentMarketMidPrice = object.currentMarketMidPrice ?? undefined
    message.currentMarketMarkPrice = object.currentMarketMarkPrice ?? undefined
    message.arrivalPriceIv = object.arrivalPriceIv ?? undefined
    message.arrivalPriceInclSlippageIv = object.arrivalPriceInclSlippageIv ?? undefined
    message.arrivalPriceInclSlippageFeesIv = object.arrivalPriceInclSlippageFeesIv ?? undefined
    message.departurePriceIv = object.departurePriceIv ?? undefined
    message.departurePriceInclSlippageIv = object.departurePriceInclSlippageIv ?? undefined
    message.departurePriceInclSlippageFeesIv = object.departurePriceInclSlippageFeesIv ?? undefined
    message.vwapIv = object.vwapIv ?? undefined
    message.vwapInclFeesIv = object.vwapInclFeesIv ?? undefined
    message.twapIv = object.twapIv ?? undefined
    message.twapInclFeesIv = object.twapInclFeesIv ?? undefined
    message.currentMarketMidPriceIv = object.currentMarketMidPriceIv ?? undefined
    message.currentMarketMarkPriceIv = object.currentMarketMarkPriceIv ?? undefined
    return message
  },
}

function createBaseExecutionAnalyticsOverlay(): ExecutionAnalyticsOverlay {
  return { name: '', value: '' }
}

export const ExecutionAnalyticsOverlay: MessageFns<ExecutionAnalyticsOverlay> = {
  encode(
    message: ExecutionAnalyticsOverlay,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAnalyticsOverlay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAnalyticsOverlay()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAnalyticsOverlay {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: ExecutionAnalyticsOverlay): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAnalyticsOverlay>, I>>(
    base?: I
  ): ExecutionAnalyticsOverlay {
    return ExecutionAnalyticsOverlay.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAnalyticsOverlay>, I>>(
    object: I
  ): ExecutionAnalyticsOverlay {
    const message = createBaseExecutionAnalyticsOverlay()
    message.name = object.name ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseGetOrdersForAlgoRequest(): GetOrdersForAlgoRequest {
  return {
    accountId: '',
    accountIds: [],
    algoId: '',
    includeHistory: false,
    includeDescendants: undefined,
  }
}

export const GetOrdersForAlgoRequest: MessageFns<GetOrdersForAlgoRequest> = {
  encode(
    message: GetOrdersForAlgoRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(42).string(v!)
    }
    if (message.algoId !== '') {
      writer.uint32(18).string(message.algoId)
    }
    if (message.includeHistory !== false) {
      writer.uint32(24).bool(message.includeHistory)
    }
    if (message.includeDescendants !== undefined) {
      writer.uint32(32).bool(message.includeDescendants)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrdersForAlgoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetOrdersForAlgoRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.includeHistory = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.includeDescendants = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetOrdersForAlgoRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      includeHistory: isSet(object.includeHistory)
        ? globalThis.Boolean(object.includeHistory)
        : isSet(object.include_history)
          ? globalThis.Boolean(object.include_history)
          : false,
      includeDescendants: isSet(object.includeDescendants)
        ? globalThis.Boolean(object.includeDescendants)
        : isSet(object.include_descendants)
          ? globalThis.Boolean(object.include_descendants)
          : undefined,
    }
  },

  toJSON(message: GetOrdersForAlgoRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.includeHistory !== false) {
      obj.includeHistory = message.includeHistory
    }
    if (message.includeDescendants !== undefined) {
      obj.includeDescendants = message.includeDescendants
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetOrdersForAlgoRequest>, I>>(
    base?: I
  ): GetOrdersForAlgoRequest {
    return GetOrdersForAlgoRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetOrdersForAlgoRequest>, I>>(
    object: I
  ): GetOrdersForAlgoRequest {
    const message = createBaseGetOrdersForAlgoRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.algoId = object.algoId ?? ''
    message.includeHistory = object.includeHistory ?? false
    message.includeDescendants = object.includeDescendants ?? undefined
    return message
  },
}

function createBaseGetTradesForOrderRequest(): GetTradesForOrderRequest {
  return { accountId: '', accountIds: [], orderId: '' }
}

export const GetTradesForOrderRequest: MessageFns<GetTradesForOrderRequest> = {
  encode(
    message: GetTradesForOrderRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTradesForOrderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetTradesForOrderRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetTradesForOrderRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
    }
  },

  toJSON(message: GetTradesForOrderRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetTradesForOrderRequest>, I>>(
    base?: I
  ): GetTradesForOrderRequest {
    return GetTradesForOrderRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetTradesForOrderRequest>, I>>(
    object: I
  ): GetTradesForOrderRequest {
    const message = createBaseGetTradesForOrderRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.orderId = object.orderId ?? ''
    return message
  },
}

function createBaseGetTradesForAlgoRequest(): GetTradesForAlgoRequest {
  return {
    accountId: '',
    accountIds: [],
    algoId: '',
    includeDescendants: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
  }
}

export const GetTradesForAlgoRequest: MessageFns<GetTradesForAlgoRequest> = {
  encode(
    message: GetTradesForAlgoRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(58).string(v!)
    }
    if (message.algoId !== '') {
      writer.uint32(18).string(message.algoId)
    }
    if (message.includeDescendants !== undefined) {
      writer.uint32(24).bool(message.includeDescendants)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTradesForAlgoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetTradesForAlgoRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.includeDescendants = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetTradesForAlgoRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      includeDescendants: isSet(object.includeDescendants)
        ? globalThis.Boolean(object.includeDescendants)
        : isSet(object.include_descendants)
          ? globalThis.Boolean(object.include_descendants)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: GetTradesForAlgoRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.includeDescendants !== undefined) {
      obj.includeDescendants = message.includeDescendants
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetTradesForAlgoRequest>, I>>(
    base?: I
  ): GetTradesForAlgoRequest {
    return GetTradesForAlgoRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetTradesForAlgoRequest>, I>>(
    object: I
  ): GetTradesForAlgoRequest {
    const message = createBaseGetTradesForAlgoRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.algoId = object.algoId ?? ''
    message.includeDescendants = object.includeDescendants ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseGetOrderStateHistoryRequest(): GetOrderStateHistoryRequest {
  return { accountId: '', accountIds: [], orderId: '' }
}

export const GetOrderStateHistoryRequest: MessageFns<GetOrderStateHistoryRequest> = {
  encode(
    message: GetOrderStateHistoryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrderStateHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetOrderStateHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetOrderStateHistoryRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
    }
  },

  toJSON(message: GetOrderStateHistoryRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetOrderStateHistoryRequest>, I>>(
    base?: I
  ): GetOrderStateHistoryRequest {
    return GetOrderStateHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderStateHistoryRequest>, I>>(
    object: I
  ): GetOrderStateHistoryRequest {
    const message = createBaseGetOrderStateHistoryRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.orderId = object.orderId ?? ''
    return message
  },
}

function createBaseRfqAnalyticsRequest(): RfqAnalyticsRequest {
  return {
    accountId: '',
    accountIds: [],
    rfqId: undefined,
    from: undefined,
    to: undefined,
    makerFilter: [],
  }
}

export const RfqAnalyticsRequest: MessageFns<RfqAnalyticsRequest> = {
  encode(message: RfqAnalyticsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(50).string(v!)
    }
    if (message.rfqId !== undefined) {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.from !== undefined) {
      writer.uint32(24).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(32).int64(message.to)
    }
    for (const v of message.makerFilter) {
      writer.uint32(42).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAnalyticsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAnalyticsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.makerFilter.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAnalyticsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      makerFilter: globalThis.Array.isArray(object?.makerFilter)
        ? object.makerFilter.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_filter)
          ? object.maker_filter.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: RfqAnalyticsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.rfqId !== undefined) {
      obj.rfqId = message.rfqId
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.makerFilter?.length) {
      obj.makerFilter = message.makerFilter
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAnalyticsRequest>, I>>(base?: I): RfqAnalyticsRequest {
    return RfqAnalyticsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAnalyticsRequest>, I>>(
    object: I
  ): RfqAnalyticsRequest {
    const message = createBaseRfqAnalyticsRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.rfqId = object.rfqId ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.makerFilter = object.makerFilter?.map((e) => e) || []
    return message
  },
}

function createBaseRfqMakerStat(): RfqMakerStat {
  return {
    alias: '',
    rfqsQuoted: 0,
    quotesProvided: 0,
    wins: 0,
    winRate: '',
    avgSpreadToMark: '',
    avgQuoteAmount: '',
    rfqNetwork: 0,
  }
}

export const RfqMakerStat: MessageFns<RfqMakerStat> = {
  encode(message: RfqMakerStat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alias !== '') {
      writer.uint32(10).string(message.alias)
    }
    if (message.rfqsQuoted !== 0) {
      writer.uint32(16).int32(message.rfqsQuoted)
    }
    if (message.quotesProvided !== 0) {
      writer.uint32(24).int32(message.quotesProvided)
    }
    if (message.wins !== 0) {
      writer.uint32(32).int32(message.wins)
    }
    if (message.winRate !== '') {
      writer.uint32(42).string(message.winRate)
    }
    if (message.avgSpreadToMark !== '') {
      writer.uint32(50).string(message.avgSpreadToMark)
    }
    if (message.avgQuoteAmount !== '') {
      writer.uint32(58).string(message.avgQuoteAmount)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(64).int32(message.rfqNetwork)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqMakerStat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqMakerStat()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.alias = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.rfqsQuoted = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.quotesProvided = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.wins = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.winRate = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.avgSpreadToMark = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.avgQuoteAmount = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqMakerStat {
    return {
      alias: isSet(object.alias) ? globalThis.String(object.alias) : '',
      rfqsQuoted: isSet(object.rfqsQuoted)
        ? globalThis.Number(object.rfqsQuoted)
        : isSet(object.rfqs_quoted)
          ? globalThis.Number(object.rfqs_quoted)
          : 0,
      quotesProvided: isSet(object.quotesProvided)
        ? globalThis.Number(object.quotesProvided)
        : isSet(object.quotes_provided)
          ? globalThis.Number(object.quotes_provided)
          : 0,
      wins: isSet(object.wins) ? globalThis.Number(object.wins) : 0,
      winRate: isSet(object.winRate)
        ? globalThis.String(object.winRate)
        : isSet(object.win_rate)
          ? globalThis.String(object.win_rate)
          : '',
      avgSpreadToMark: isSet(object.avgSpreadToMark)
        ? globalThis.String(object.avgSpreadToMark)
        : isSet(object.avg_spread_to_mark)
          ? globalThis.String(object.avg_spread_to_mark)
          : '',
      avgQuoteAmount: isSet(object.avgQuoteAmount)
        ? globalThis.String(object.avgQuoteAmount)
        : isSet(object.avg_quote_amount)
          ? globalThis.String(object.avg_quote_amount)
          : '',
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
    }
  },

  toJSON(message: RfqMakerStat): unknown {
    const obj: any = {}
    if (message.alias !== '') {
      obj.alias = message.alias
    }
    if (message.rfqsQuoted !== 0) {
      obj.rfqsQuoted = Math.round(message.rfqsQuoted)
    }
    if (message.quotesProvided !== 0) {
      obj.quotesProvided = Math.round(message.quotesProvided)
    }
    if (message.wins !== 0) {
      obj.wins = Math.round(message.wins)
    }
    if (message.winRate !== '') {
      obj.winRate = message.winRate
    }
    if (message.avgSpreadToMark !== '') {
      obj.avgSpreadToMark = message.avgSpreadToMark
    }
    if (message.avgQuoteAmount !== '') {
      obj.avgQuoteAmount = message.avgQuoteAmount
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqMakerStat>, I>>(base?: I): RfqMakerStat {
    return RfqMakerStat.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqMakerStat>, I>>(object: I): RfqMakerStat {
    const message = createBaseRfqMakerStat()
    message.alias = object.alias ?? ''
    message.rfqsQuoted = object.rfqsQuoted ?? 0
    message.quotesProvided = object.quotesProvided ?? 0
    message.wins = object.wins ?? 0
    message.winRate = object.winRate ?? ''
    message.avgSpreadToMark = object.avgSpreadToMark ?? ''
    message.avgQuoteAmount = object.avgQuoteAmount ?? ''
    message.rfqNetwork = object.rfqNetwork ?? 0
    return message
  },
}

function createBaseRfqWorkflowStats(): RfqWorkflowStats {
  return {
    total: 0,
    filled: 0,
    expired: 0,
    cancelled: 0,
    open: 0,
    fillRate: '',
    avgTimeToFirstQuoteMs: undefined,
    avgTimeToFillMs: undefined,
    avgMakersResponding: '',
    filledNotional: '',
  }
}

export const RfqWorkflowStats: MessageFns<RfqWorkflowStats> = {
  encode(message: RfqWorkflowStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total !== 0) {
      writer.uint32(8).int32(message.total)
    }
    if (message.filled !== 0) {
      writer.uint32(16).int32(message.filled)
    }
    if (message.expired !== 0) {
      writer.uint32(24).int32(message.expired)
    }
    if (message.cancelled !== 0) {
      writer.uint32(32).int32(message.cancelled)
    }
    if (message.open !== 0) {
      writer.uint32(40).int32(message.open)
    }
    if (message.fillRate !== '') {
      writer.uint32(50).string(message.fillRate)
    }
    if (message.avgTimeToFirstQuoteMs !== undefined) {
      writer.uint32(56).int64(message.avgTimeToFirstQuoteMs)
    }
    if (message.avgTimeToFillMs !== undefined) {
      writer.uint32(64).int64(message.avgTimeToFillMs)
    }
    if (message.avgMakersResponding !== '') {
      writer.uint32(74).string(message.avgMakersResponding)
    }
    if (message.filledNotional !== '') {
      writer.uint32(82).string(message.filledNotional)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqWorkflowStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqWorkflowStats()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.total = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.filled = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.expired = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.cancelled = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.open = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.fillRate = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.avgTimeToFirstQuoteMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.avgTimeToFillMs = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.avgMakersResponding = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.filledNotional = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqWorkflowStats {
    return {
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      filled: isSet(object.filled) ? globalThis.Number(object.filled) : 0,
      expired: isSet(object.expired) ? globalThis.Number(object.expired) : 0,
      cancelled: isSet(object.cancelled) ? globalThis.Number(object.cancelled) : 0,
      open: isSet(object.open) ? globalThis.Number(object.open) : 0,
      fillRate: isSet(object.fillRate)
        ? globalThis.String(object.fillRate)
        : isSet(object.fill_rate)
          ? globalThis.String(object.fill_rate)
          : '',
      avgTimeToFirstQuoteMs: isSet(object.avgTimeToFirstQuoteMs)
        ? globalThis.String(object.avgTimeToFirstQuoteMs)
        : isSet(object.avg_time_to_first_quote_ms)
          ? globalThis.String(object.avg_time_to_first_quote_ms)
          : undefined,
      avgTimeToFillMs: isSet(object.avgTimeToFillMs)
        ? globalThis.String(object.avgTimeToFillMs)
        : isSet(object.avg_time_to_fill_ms)
          ? globalThis.String(object.avg_time_to_fill_ms)
          : undefined,
      avgMakersResponding: isSet(object.avgMakersResponding)
        ? globalThis.String(object.avgMakersResponding)
        : isSet(object.avg_makers_responding)
          ? globalThis.String(object.avg_makers_responding)
          : '',
      filledNotional: isSet(object.filledNotional)
        ? globalThis.String(object.filledNotional)
        : isSet(object.filled_notional)
          ? globalThis.String(object.filled_notional)
          : '',
    }
  },

  toJSON(message: RfqWorkflowStats): unknown {
    const obj: any = {}
    if (message.total !== 0) {
      obj.total = Math.round(message.total)
    }
    if (message.filled !== 0) {
      obj.filled = Math.round(message.filled)
    }
    if (message.expired !== 0) {
      obj.expired = Math.round(message.expired)
    }
    if (message.cancelled !== 0) {
      obj.cancelled = Math.round(message.cancelled)
    }
    if (message.open !== 0) {
      obj.open = Math.round(message.open)
    }
    if (message.fillRate !== '') {
      obj.fillRate = message.fillRate
    }
    if (message.avgTimeToFirstQuoteMs !== undefined) {
      obj.avgTimeToFirstQuoteMs = message.avgTimeToFirstQuoteMs
    }
    if (message.avgTimeToFillMs !== undefined) {
      obj.avgTimeToFillMs = message.avgTimeToFillMs
    }
    if (message.avgMakersResponding !== '') {
      obj.avgMakersResponding = message.avgMakersResponding
    }
    if (message.filledNotional !== '') {
      obj.filledNotional = message.filledNotional
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqWorkflowStats>, I>>(base?: I): RfqWorkflowStats {
    return RfqWorkflowStats.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqWorkflowStats>, I>>(object: I): RfqWorkflowStats {
    const message = createBaseRfqWorkflowStats()
    message.total = object.total ?? 0
    message.filled = object.filled ?? 0
    message.expired = object.expired ?? 0
    message.cancelled = object.cancelled ?? 0
    message.open = object.open ?? 0
    message.fillRate = object.fillRate ?? ''
    message.avgTimeToFirstQuoteMs = object.avgTimeToFirstQuoteMs ?? undefined
    message.avgTimeToFillMs = object.avgTimeToFillMs ?? undefined
    message.avgMakersResponding = object.avgMakersResponding ?? ''
    message.filledNotional = object.filledNotional ?? ''
    return message
  },
}

function createBaseRfqExecutionQualityStats(): RfqExecutionQualityStats {
  return { sampleSize: 0, avgEdgeVsMark: '', avgAcceptedVsBestQuote: '' }
}

export const RfqExecutionQualityStats: MessageFns<RfqExecutionQualityStats> = {
  encode(
    message: RfqExecutionQualityStats,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.sampleSize !== 0) {
      writer.uint32(8).int32(message.sampleSize)
    }
    if (message.avgEdgeVsMark !== '') {
      writer.uint32(18).string(message.avgEdgeVsMark)
    }
    if (message.avgAcceptedVsBestQuote !== '') {
      writer.uint32(26).string(message.avgAcceptedVsBestQuote)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqExecutionQualityStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqExecutionQualityStats()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.sampleSize = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.avgEdgeVsMark = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.avgAcceptedVsBestQuote = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqExecutionQualityStats {
    return {
      sampleSize: isSet(object.sampleSize)
        ? globalThis.Number(object.sampleSize)
        : isSet(object.sample_size)
          ? globalThis.Number(object.sample_size)
          : 0,
      avgEdgeVsMark: isSet(object.avgEdgeVsMark)
        ? globalThis.String(object.avgEdgeVsMark)
        : isSet(object.avg_edge_vs_mark)
          ? globalThis.String(object.avg_edge_vs_mark)
          : '',
      avgAcceptedVsBestQuote: isSet(object.avgAcceptedVsBestQuote)
        ? globalThis.String(object.avgAcceptedVsBestQuote)
        : isSet(object.avg_accepted_vs_best_quote)
          ? globalThis.String(object.avg_accepted_vs_best_quote)
          : '',
    }
  },

  toJSON(message: RfqExecutionQualityStats): unknown {
    const obj: any = {}
    if (message.sampleSize !== 0) {
      obj.sampleSize = Math.round(message.sampleSize)
    }
    if (message.avgEdgeVsMark !== '') {
      obj.avgEdgeVsMark = message.avgEdgeVsMark
    }
    if (message.avgAcceptedVsBestQuote !== '') {
      obj.avgAcceptedVsBestQuote = message.avgAcceptedVsBestQuote
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqExecutionQualityStats>, I>>(
    base?: I
  ): RfqExecutionQualityStats {
    return RfqExecutionQualityStats.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqExecutionQualityStats>, I>>(
    object: I
  ): RfqExecutionQualityStats {
    const message = createBaseRfqExecutionQualityStats()
    message.sampleSize = object.sampleSize ?? 0
    message.avgEdgeVsMark = object.avgEdgeVsMark ?? ''
    message.avgAcceptedVsBestQuote = object.avgAcceptedVsBestQuote ?? ''
    return message
  },
}

function createBaseRfqAlgoStats(): RfqAlgoStats {
  return {
    total: 0,
    filled: 0,
    gaveUp: 0,
    avgRetriesToFill: '',
    pctFilledWithinThreshold: '',
    pctExpiredWithoutMeeting: '',
    avgTimeToFillMs: undefined,
    avgRealizedOffsetVsThreshold: '',
  }
}

export const RfqAlgoStats: MessageFns<RfqAlgoStats> = {
  encode(message: RfqAlgoStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total !== 0) {
      writer.uint32(8).int32(message.total)
    }
    if (message.filled !== 0) {
      writer.uint32(16).int32(message.filled)
    }
    if (message.gaveUp !== 0) {
      writer.uint32(24).int32(message.gaveUp)
    }
    if (message.avgRetriesToFill !== '') {
      writer.uint32(34).string(message.avgRetriesToFill)
    }
    if (message.pctFilledWithinThreshold !== '') {
      writer.uint32(42).string(message.pctFilledWithinThreshold)
    }
    if (message.pctExpiredWithoutMeeting !== '') {
      writer.uint32(50).string(message.pctExpiredWithoutMeeting)
    }
    if (message.avgTimeToFillMs !== undefined) {
      writer.uint32(56).int64(message.avgTimeToFillMs)
    }
    if (message.avgRealizedOffsetVsThreshold !== '') {
      writer.uint32(66).string(message.avgRealizedOffsetVsThreshold)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAlgoStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAlgoStats()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.total = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.filled = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.gaveUp = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.avgRetriesToFill = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.pctFilledWithinThreshold = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.pctExpiredWithoutMeeting = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.avgTimeToFillMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.avgRealizedOffsetVsThreshold = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAlgoStats {
    return {
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      filled: isSet(object.filled) ? globalThis.Number(object.filled) : 0,
      gaveUp: isSet(object.gaveUp)
        ? globalThis.Number(object.gaveUp)
        : isSet(object.gave_up)
          ? globalThis.Number(object.gave_up)
          : 0,
      avgRetriesToFill: isSet(object.avgRetriesToFill)
        ? globalThis.String(object.avgRetriesToFill)
        : isSet(object.avg_retries_to_fill)
          ? globalThis.String(object.avg_retries_to_fill)
          : '',
      pctFilledWithinThreshold: isSet(object.pctFilledWithinThreshold)
        ? globalThis.String(object.pctFilledWithinThreshold)
        : isSet(object.pct_filled_within_threshold)
          ? globalThis.String(object.pct_filled_within_threshold)
          : '',
      pctExpiredWithoutMeeting: isSet(object.pctExpiredWithoutMeeting)
        ? globalThis.String(object.pctExpiredWithoutMeeting)
        : isSet(object.pct_expired_without_meeting)
          ? globalThis.String(object.pct_expired_without_meeting)
          : '',
      avgTimeToFillMs: isSet(object.avgTimeToFillMs)
        ? globalThis.String(object.avgTimeToFillMs)
        : isSet(object.avg_time_to_fill_ms)
          ? globalThis.String(object.avg_time_to_fill_ms)
          : undefined,
      avgRealizedOffsetVsThreshold: isSet(object.avgRealizedOffsetVsThreshold)
        ? globalThis.String(object.avgRealizedOffsetVsThreshold)
        : isSet(object.avg_realized_offset_vs_threshold)
          ? globalThis.String(object.avg_realized_offset_vs_threshold)
          : '',
    }
  },

  toJSON(message: RfqAlgoStats): unknown {
    const obj: any = {}
    if (message.total !== 0) {
      obj.total = Math.round(message.total)
    }
    if (message.filled !== 0) {
      obj.filled = Math.round(message.filled)
    }
    if (message.gaveUp !== 0) {
      obj.gaveUp = Math.round(message.gaveUp)
    }
    if (message.avgRetriesToFill !== '') {
      obj.avgRetriesToFill = message.avgRetriesToFill
    }
    if (message.pctFilledWithinThreshold !== '') {
      obj.pctFilledWithinThreshold = message.pctFilledWithinThreshold
    }
    if (message.pctExpiredWithoutMeeting !== '') {
      obj.pctExpiredWithoutMeeting = message.pctExpiredWithoutMeeting
    }
    if (message.avgTimeToFillMs !== undefined) {
      obj.avgTimeToFillMs = message.avgTimeToFillMs
    }
    if (message.avgRealizedOffsetVsThreshold !== '') {
      obj.avgRealizedOffsetVsThreshold = message.avgRealizedOffsetVsThreshold
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAlgoStats>, I>>(base?: I): RfqAlgoStats {
    return RfqAlgoStats.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAlgoStats>, I>>(object: I): RfqAlgoStats {
    const message = createBaseRfqAlgoStats()
    message.total = object.total ?? 0
    message.filled = object.filled ?? 0
    message.gaveUp = object.gaveUp ?? 0
    message.avgRetriesToFill = object.avgRetriesToFill ?? ''
    message.pctFilledWithinThreshold = object.pctFilledWithinThreshold ?? ''
    message.pctExpiredWithoutMeeting = object.pctExpiredWithoutMeeting ?? ''
    message.avgTimeToFillMs = object.avgTimeToFillMs ?? undefined
    message.avgRealizedOffsetVsThreshold = object.avgRealizedOffsetVsThreshold ?? ''
    return message
  },
}

function createBaseRfqStateTransition(): RfqStateTransition {
  return { state: 0, atMs: '0', rfqNetwork: 0 }
}

export const RfqStateTransition: MessageFns<RfqStateTransition> = {
  encode(message: RfqStateTransition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state)
    }
    if (message.atMs !== '0') {
      writer.uint32(16).int64(message.atMs)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(24).int32(message.rfqNetwork)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqStateTransition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqStateTransition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.atMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqStateTransition {
    return {
      state: isSet(object.state) ? rfqStateFromJSON(object.state) : 0,
      atMs: isSet(object.atMs)
        ? globalThis.String(object.atMs)
        : isSet(object.at_ms)
          ? globalThis.String(object.at_ms)
          : '0',
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
    }
  },

  toJSON(message: RfqStateTransition): unknown {
    const obj: any = {}
    if (message.state !== 0) {
      obj.state = rfqStateToJSON(message.state)
    }
    if (message.atMs !== '0') {
      obj.atMs = message.atMs
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqStateTransition>, I>>(base?: I): RfqStateTransition {
    return RfqStateTransition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqStateTransition>, I>>(object: I): RfqStateTransition {
    const message = createBaseRfqStateTransition()
    message.state = object.state ?? 0
    message.atMs = object.atMs ?? '0'
    message.rfqNetwork = object.rfqNetwork ?? 0
    return message
  },
}

function createBaseRfqQuoteTimelinePoint(): RfqQuoteTimelinePoint {
  return {
    observedAtMs: '0',
    bestBid: undefined,
    bestAsk: undefined,
    packageMark: undefined,
    askSpreadToMark: undefined,
    makersResponding: 0,
    rfqNetwork: 0,
  }
}

export const RfqQuoteTimelinePoint: MessageFns<RfqQuoteTimelinePoint> = {
  encode(message: RfqQuoteTimelinePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.observedAtMs !== '0') {
      writer.uint32(8).int64(message.observedAtMs)
    }
    if (message.bestBid !== undefined) {
      writer.uint32(18).string(message.bestBid)
    }
    if (message.bestAsk !== undefined) {
      writer.uint32(26).string(message.bestAsk)
    }
    if (message.packageMark !== undefined) {
      writer.uint32(34).string(message.packageMark)
    }
    if (message.askSpreadToMark !== undefined) {
      writer.uint32(42).string(message.askSpreadToMark)
    }
    if (message.makersResponding !== 0) {
      writer.uint32(48).int32(message.makersResponding)
    }
    if (message.rfqNetwork !== 0) {
      writer.uint32(56).int32(message.rfqNetwork)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqQuoteTimelinePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqQuoteTimelinePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.observedAtMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.bestBid = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.bestAsk = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.packageMark = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.askSpreadToMark = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.makersResponding = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.rfqNetwork = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqQuoteTimelinePoint {
    return {
      observedAtMs: isSet(object.observedAtMs)
        ? globalThis.String(object.observedAtMs)
        : isSet(object.observed_at_ms)
          ? globalThis.String(object.observed_at_ms)
          : '0',
      bestBid: isSet(object.bestBid)
        ? globalThis.String(object.bestBid)
        : isSet(object.best_bid)
          ? globalThis.String(object.best_bid)
          : undefined,
      bestAsk: isSet(object.bestAsk)
        ? globalThis.String(object.bestAsk)
        : isSet(object.best_ask)
          ? globalThis.String(object.best_ask)
          : undefined,
      packageMark: isSet(object.packageMark)
        ? globalThis.String(object.packageMark)
        : isSet(object.package_mark)
          ? globalThis.String(object.package_mark)
          : undefined,
      askSpreadToMark: isSet(object.askSpreadToMark)
        ? globalThis.String(object.askSpreadToMark)
        : isSet(object.ask_spread_to_mark)
          ? globalThis.String(object.ask_spread_to_mark)
          : undefined,
      makersResponding: isSet(object.makersResponding)
        ? globalThis.Number(object.makersResponding)
        : isSet(object.makers_responding)
          ? globalThis.Number(object.makers_responding)
          : 0,
      rfqNetwork: isSet(object.rfqNetwork)
        ? rfqNetworkFromJSON(object.rfqNetwork)
        : isSet(object.rfq_network)
          ? rfqNetworkFromJSON(object.rfq_network)
          : 0,
    }
  },

  toJSON(message: RfqQuoteTimelinePoint): unknown {
    const obj: any = {}
    if (message.observedAtMs !== '0') {
      obj.observedAtMs = message.observedAtMs
    }
    if (message.bestBid !== undefined) {
      obj.bestBid = message.bestBid
    }
    if (message.bestAsk !== undefined) {
      obj.bestAsk = message.bestAsk
    }
    if (message.packageMark !== undefined) {
      obj.packageMark = message.packageMark
    }
    if (message.askSpreadToMark !== undefined) {
      obj.askSpreadToMark = message.askSpreadToMark
    }
    if (message.makersResponding !== 0) {
      obj.makersResponding = Math.round(message.makersResponding)
    }
    if (message.rfqNetwork !== 0) {
      obj.rfqNetwork = rfqNetworkToJSON(message.rfqNetwork)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqQuoteTimelinePoint>, I>>(base?: I): RfqQuoteTimelinePoint {
    return RfqQuoteTimelinePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqQuoteTimelinePoint>, I>>(
    object: I
  ): RfqQuoteTimelinePoint {
    const message = createBaseRfqQuoteTimelinePoint()
    message.observedAtMs = object.observedAtMs ?? '0'
    message.bestBid = object.bestBid ?? undefined
    message.bestAsk = object.bestAsk ?? undefined
    message.packageMark = object.packageMark ?? undefined
    message.askSpreadToMark = object.askSpreadToMark ?? undefined
    message.makersResponding = object.makersResponding ?? 0
    message.rfqNetwork = object.rfqNetwork ?? 0
    return message
  },
}

function createBaseRfqDetail(): RfqDetail {
  return {
    rfqId: '',
    finalState: 0,
    transitions: [],
    quoteTimeline: [],
    makers: [],
    acceptedPrice: undefined,
    acceptedEdgeVsMark: undefined,
    timeToFirstQuoteMs: undefined,
    timeToFillMs: undefined,
  }
}

export const RfqDetail: MessageFns<RfqDetail> = {
  encode(message: RfqDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rfqId !== '') {
      writer.uint32(10).string(message.rfqId)
    }
    if (message.finalState !== 0) {
      writer.uint32(16).int32(message.finalState)
    }
    for (const v of message.transitions) {
      RfqStateTransition.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.quoteTimeline) {
      RfqQuoteTimelinePoint.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.makers) {
      RfqMakerStat.encode(v!, writer.uint32(42).fork()).join()
    }
    if (message.acceptedPrice !== undefined) {
      writer.uint32(50).string(message.acceptedPrice)
    }
    if (message.acceptedEdgeVsMark !== undefined) {
      writer.uint32(58).string(message.acceptedEdgeVsMark)
    }
    if (message.timeToFirstQuoteMs !== undefined) {
      writer.uint32(64).int64(message.timeToFirstQuoteMs)
    }
    if (message.timeToFillMs !== undefined) {
      writer.uint32(72).int64(message.timeToFillMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.finalState = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.transitions.push(RfqStateTransition.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quoteTimeline.push(RfqQuoteTimelinePoint.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.makers.push(RfqMakerStat.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.acceptedPrice = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.acceptedEdgeVsMark = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.timeToFirstQuoteMs = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.timeToFillMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqDetail {
    return {
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      finalState: isSet(object.finalState)
        ? rfqStateFromJSON(object.finalState)
        : isSet(object.final_state)
          ? rfqStateFromJSON(object.final_state)
          : 0,
      transitions: globalThis.Array.isArray(object?.transitions)
        ? object.transitions.map((e: any) => RfqStateTransition.fromJSON(e))
        : [],
      quoteTimeline: globalThis.Array.isArray(object?.quoteTimeline)
        ? object.quoteTimeline.map((e: any) => RfqQuoteTimelinePoint.fromJSON(e))
        : globalThis.Array.isArray(object?.quote_timeline)
          ? object.quote_timeline.map((e: any) => RfqQuoteTimelinePoint.fromJSON(e))
          : [],
      makers: globalThis.Array.isArray(object?.makers)
        ? object.makers.map((e: any) => RfqMakerStat.fromJSON(e))
        : [],
      acceptedPrice: isSet(object.acceptedPrice)
        ? globalThis.String(object.acceptedPrice)
        : isSet(object.accepted_price)
          ? globalThis.String(object.accepted_price)
          : undefined,
      acceptedEdgeVsMark: isSet(object.acceptedEdgeVsMark)
        ? globalThis.String(object.acceptedEdgeVsMark)
        : isSet(object.accepted_edge_vs_mark)
          ? globalThis.String(object.accepted_edge_vs_mark)
          : undefined,
      timeToFirstQuoteMs: isSet(object.timeToFirstQuoteMs)
        ? globalThis.String(object.timeToFirstQuoteMs)
        : isSet(object.time_to_first_quote_ms)
          ? globalThis.String(object.time_to_first_quote_ms)
          : undefined,
      timeToFillMs: isSet(object.timeToFillMs)
        ? globalThis.String(object.timeToFillMs)
        : isSet(object.time_to_fill_ms)
          ? globalThis.String(object.time_to_fill_ms)
          : undefined,
    }
  },

  toJSON(message: RfqDetail): unknown {
    const obj: any = {}
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.finalState !== 0) {
      obj.finalState = rfqStateToJSON(message.finalState)
    }
    if (message.transitions?.length) {
      obj.transitions = message.transitions.map((e) => RfqStateTransition.toJSON(e))
    }
    if (message.quoteTimeline?.length) {
      obj.quoteTimeline = message.quoteTimeline.map((e) => RfqQuoteTimelinePoint.toJSON(e))
    }
    if (message.makers?.length) {
      obj.makers = message.makers.map((e) => RfqMakerStat.toJSON(e))
    }
    if (message.acceptedPrice !== undefined) {
      obj.acceptedPrice = message.acceptedPrice
    }
    if (message.acceptedEdgeVsMark !== undefined) {
      obj.acceptedEdgeVsMark = message.acceptedEdgeVsMark
    }
    if (message.timeToFirstQuoteMs !== undefined) {
      obj.timeToFirstQuoteMs = message.timeToFirstQuoteMs
    }
    if (message.timeToFillMs !== undefined) {
      obj.timeToFillMs = message.timeToFillMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqDetail>, I>>(base?: I): RfqDetail {
    return RfqDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqDetail>, I>>(object: I): RfqDetail {
    const message = createBaseRfqDetail()
    message.rfqId = object.rfqId ?? ''
    message.finalState = object.finalState ?? 0
    message.transitions = object.transitions?.map((e) => RfqStateTransition.fromPartial(e)) || []
    message.quoteTimeline =
      object.quoteTimeline?.map((e) => RfqQuoteTimelinePoint.fromPartial(e)) || []
    message.makers = object.makers?.map((e) => RfqMakerStat.fromPartial(e)) || []
    message.acceptedPrice = object.acceptedPrice ?? undefined
    message.acceptedEdgeVsMark = object.acceptedEdgeVsMark ?? undefined
    message.timeToFirstQuoteMs = object.timeToFirstQuoteMs ?? undefined
    message.timeToFillMs = object.timeToFillMs ?? undefined
    return message
  },
}

function createBaseRfqAnalytics(): RfqAnalytics {
  return {
    accountId: '',
    from: undefined,
    to: undefined,
    workflow: undefined,
    executionQuality: undefined,
    makers: [],
    algo: undefined,
    detail: undefined,
  }
}

export const RfqAnalytics: MessageFns<RfqAnalytics> = {
  encode(message: RfqAnalytics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.from !== undefined) {
      writer.uint32(16).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(24).int64(message.to)
    }
    if (message.workflow !== undefined) {
      RfqWorkflowStats.encode(message.workflow, writer.uint32(34).fork()).join()
    }
    if (message.executionQuality !== undefined) {
      RfqExecutionQualityStats.encode(message.executionQuality, writer.uint32(42).fork()).join()
    }
    for (const v of message.makers) {
      RfqMakerStat.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.algo !== undefined) {
      RfqAlgoStats.encode(message.algo, writer.uint32(58).fork()).join()
    }
    if (message.detail !== undefined) {
      RfqDetail.encode(message.detail, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAnalytics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAnalytics()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.workflow = RfqWorkflowStats.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.executionQuality = RfqExecutionQualityStats.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.makers.push(RfqMakerStat.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.algo = RfqAlgoStats.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.detail = RfqDetail.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAnalytics {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      workflow: isSet(object.workflow) ? RfqWorkflowStats.fromJSON(object.workflow) : undefined,
      executionQuality: isSet(object.executionQuality)
        ? RfqExecutionQualityStats.fromJSON(object.executionQuality)
        : isSet(object.execution_quality)
          ? RfqExecutionQualityStats.fromJSON(object.execution_quality)
          : undefined,
      makers: globalThis.Array.isArray(object?.makers)
        ? object.makers.map((e: any) => RfqMakerStat.fromJSON(e))
        : [],
      algo: isSet(object.algo) ? RfqAlgoStats.fromJSON(object.algo) : undefined,
      detail: isSet(object.detail) ? RfqDetail.fromJSON(object.detail) : undefined,
    }
  },

  toJSON(message: RfqAnalytics): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.workflow !== undefined) {
      obj.workflow = RfqWorkflowStats.toJSON(message.workflow)
    }
    if (message.executionQuality !== undefined) {
      obj.executionQuality = RfqExecutionQualityStats.toJSON(message.executionQuality)
    }
    if (message.makers?.length) {
      obj.makers = message.makers.map((e) => RfqMakerStat.toJSON(e))
    }
    if (message.algo !== undefined) {
      obj.algo = RfqAlgoStats.toJSON(message.algo)
    }
    if (message.detail !== undefined) {
      obj.detail = RfqDetail.toJSON(message.detail)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAnalytics>, I>>(base?: I): RfqAnalytics {
    return RfqAnalytics.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAnalytics>, I>>(object: I): RfqAnalytics {
    const message = createBaseRfqAnalytics()
    message.accountId = object.accountId ?? ''
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.workflow =
      object.workflow !== undefined && object.workflow !== null
        ? RfqWorkflowStats.fromPartial(object.workflow)
        : undefined
    message.executionQuality =
      object.executionQuality !== undefined && object.executionQuality !== null
        ? RfqExecutionQualityStats.fromPartial(object.executionQuality)
        : undefined
    message.makers = object.makers?.map((e) => RfqMakerStat.fromPartial(e)) || []
    message.algo =
      object.algo !== undefined && object.algo !== null
        ? RfqAlgoStats.fromPartial(object.algo)
        : undefined
    message.detail =
      object.detail !== undefined && object.detail !== null
        ? RfqDetail.fromPartial(object.detail)
        : undefined
    return message
  },
}

function createBaseRfqAnalyticsList(): RfqAnalyticsList {
  return { analytics: [] }
}

export const RfqAnalyticsList: MessageFns<RfqAnalyticsList> = {
  encode(message: RfqAnalyticsList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.analytics) {
      RfqAnalytics.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAnalyticsList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAnalyticsList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.analytics.push(RfqAnalytics.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAnalyticsList {
    return {
      analytics: globalThis.Array.isArray(object?.analytics)
        ? object.analytics.map((e: any) => RfqAnalytics.fromJSON(e))
        : [],
    }
  },

  toJSON(message: RfqAnalyticsList): unknown {
    const obj: any = {}
    if (message.analytics?.length) {
      obj.analytics = message.analytics.map((e) => RfqAnalytics.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAnalyticsList>, I>>(base?: I): RfqAnalyticsList {
    return RfqAnalyticsList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAnalyticsList>, I>>(object: I): RfqAnalyticsList {
    const message = createBaseRfqAnalyticsList()
    message.analytics = object.analytics?.map((e) => RfqAnalytics.fromPartial(e)) || []
    return message
  },
}

function createBaseExecutionAnalytics(): ExecutionAnalytics {
  return {
    accountId: '',
    targetType: 0,
    targetId: '',
    exchange: 0,
    symbol: '',
    side: 0,
    algoType: undefined,
    algoStatus: undefined,
    submittedAt: '0',
    completedAt: undefined,
    isActive: false,
    stats: undefined,
    benchmarks: undefined,
    orders: [],
    trades: [],
    overlays: [],
    generatedAt: '0',
    childAlgos: [],
  }
}

export const ExecutionAnalytics: MessageFns<ExecutionAnalytics> = {
  encode(message: ExecutionAnalytics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.targetType !== 0) {
      writer.uint32(16).int32(message.targetType)
    }
    if (message.targetId !== '') {
      writer.uint32(26).string(message.targetId)
    }
    if (message.exchange !== 0) {
      writer.uint32(32).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(42).string(message.symbol)
    }
    if (message.side !== 0) {
      writer.uint32(48).int32(message.side)
    }
    if (message.algoType !== undefined) {
      writer.uint32(56).int32(message.algoType)
    }
    if (message.algoStatus !== undefined) {
      writer.uint32(64).int32(message.algoStatus)
    }
    if (message.submittedAt !== '0') {
      writer.uint32(72).int64(message.submittedAt)
    }
    if (message.completedAt !== undefined) {
      writer.uint32(80).int64(message.completedAt)
    }
    if (message.isActive !== false) {
      writer.uint32(88).bool(message.isActive)
    }
    if (message.stats !== undefined) {
      ExecutionAlgorithmStats.encode(message.stats, writer.uint32(98).fork()).join()
    }
    if (message.benchmarks !== undefined) {
      ExecutionPerformanceBenchmarks.encode(message.benchmarks, writer.uint32(106).fork()).join()
    }
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(114).fork()).join()
    }
    for (const v of message.trades) {
      Trade.encode(v!, writer.uint32(122).fork()).join()
    }
    for (const v of message.overlays) {
      ExecutionAnalyticsOverlay.encode(v!, writer.uint32(130).fork()).join()
    }
    if (message.generatedAt !== '0') {
      writer.uint32(136).int64(message.generatedAt)
    }
    for (const v of message.childAlgos) {
      AlgoState.encode(v!, writer.uint32(146).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAnalytics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAnalytics()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.targetType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.targetId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.algoType = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.algoStatus = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.submittedAt = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.completedAt = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.stats = ExecutionAlgorithmStats.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.benchmarks = ExecutionPerformanceBenchmarks.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.orders.push(Order.decode(reader, reader.uint32()))
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.trades.push(Trade.decode(reader, reader.uint32()))
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.overlays.push(ExecutionAnalyticsOverlay.decode(reader, reader.uint32()))
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.generatedAt = reader.int64().toString()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.childAlgos.push(AlgoState.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAnalytics {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      targetType: isSet(object.targetType)
        ? executionAnalyticsTargetTypeFromJSON(object.targetType)
        : isSet(object.target_type)
          ? executionAnalyticsTargetTypeFromJSON(object.target_type)
          : 0,
      targetId: isSet(object.targetId)
        ? globalThis.String(object.targetId)
        : isSet(object.target_id)
          ? globalThis.String(object.target_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      algoType: isSet(object.algoType)
        ? algoTypeFromJSON(object.algoType)
        : isSet(object.algo_type)
          ? algoTypeFromJSON(object.algo_type)
          : undefined,
      algoStatus: isSet(object.algoStatus)
        ? algoStatusFromJSON(object.algoStatus)
        : isSet(object.algo_status)
          ? algoStatusFromJSON(object.algo_status)
          : undefined,
      submittedAt: isSet(object.submittedAt)
        ? globalThis.String(object.submittedAt)
        : isSet(object.submitted_at)
          ? globalThis.String(object.submitted_at)
          : '0',
      completedAt: isSet(object.completedAt)
        ? globalThis.String(object.completedAt)
        : isSet(object.completed_at)
          ? globalThis.String(object.completed_at)
          : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : false,
      stats: isSet(object.stats) ? ExecutionAlgorithmStats.fromJSON(object.stats) : undefined,
      benchmarks: isSet(object.benchmarks)
        ? ExecutionPerformanceBenchmarks.fromJSON(object.benchmarks)
        : undefined,
      orders: globalThis.Array.isArray(object?.orders)
        ? object.orders.map((e: any) => Order.fromJSON(e))
        : [],
      trades: globalThis.Array.isArray(object?.trades)
        ? object.trades.map((e: any) => Trade.fromJSON(e))
        : [],
      overlays: globalThis.Array.isArray(object?.overlays)
        ? object.overlays.map((e: any) => ExecutionAnalyticsOverlay.fromJSON(e))
        : [],
      generatedAt: isSet(object.generatedAt)
        ? globalThis.String(object.generatedAt)
        : isSet(object.generated_at)
          ? globalThis.String(object.generated_at)
          : '0',
      childAlgos: globalThis.Array.isArray(object?.childAlgos)
        ? object.childAlgos.map((e: any) => AlgoState.fromJSON(e))
        : globalThis.Array.isArray(object?.child_algos)
          ? object.child_algos.map((e: any) => AlgoState.fromJSON(e))
          : [],
    }
  },

  toJSON(message: ExecutionAnalytics): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.targetType !== 0) {
      obj.targetType = executionAnalyticsTargetTypeToJSON(message.targetType)
    }
    if (message.targetId !== '') {
      obj.targetId = message.targetId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.algoType !== undefined) {
      obj.algoType = algoTypeToJSON(message.algoType)
    }
    if (message.algoStatus !== undefined) {
      obj.algoStatus = algoStatusToJSON(message.algoStatus)
    }
    if (message.submittedAt !== '0') {
      obj.submittedAt = message.submittedAt
    }
    if (message.completedAt !== undefined) {
      obj.completedAt = message.completedAt
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive
    }
    if (message.stats !== undefined) {
      obj.stats = ExecutionAlgorithmStats.toJSON(message.stats)
    }
    if (message.benchmarks !== undefined) {
      obj.benchmarks = ExecutionPerformanceBenchmarks.toJSON(message.benchmarks)
    }
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e))
    }
    if (message.trades?.length) {
      obj.trades = message.trades.map((e) => Trade.toJSON(e))
    }
    if (message.overlays?.length) {
      obj.overlays = message.overlays.map((e) => ExecutionAnalyticsOverlay.toJSON(e))
    }
    if (message.generatedAt !== '0') {
      obj.generatedAt = message.generatedAt
    }
    if (message.childAlgos?.length) {
      obj.childAlgos = message.childAlgos.map((e) => AlgoState.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAnalytics>, I>>(base?: I): ExecutionAnalytics {
    return ExecutionAnalytics.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAnalytics>, I>>(object: I): ExecutionAnalytics {
    const message = createBaseExecutionAnalytics()
    message.accountId = object.accountId ?? ''
    message.targetType = object.targetType ?? 0
    message.targetId = object.targetId ?? ''
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? 0
    message.algoType = object.algoType ?? undefined
    message.algoStatus = object.algoStatus ?? undefined
    message.submittedAt = object.submittedAt ?? '0'
    message.completedAt = object.completedAt ?? undefined
    message.isActive = object.isActive ?? false
    message.stats =
      object.stats !== undefined && object.stats !== null
        ? ExecutionAlgorithmStats.fromPartial(object.stats)
        : undefined
    message.benchmarks =
      object.benchmarks !== undefined && object.benchmarks !== null
        ? ExecutionPerformanceBenchmarks.fromPartial(object.benchmarks)
        : undefined
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || []
    message.trades = object.trades?.map((e) => Trade.fromPartial(e)) || []
    message.overlays = object.overlays?.map((e) => ExecutionAnalyticsOverlay.fromPartial(e)) || []
    message.generatedAt = object.generatedAt ?? '0'
    message.childAlgos = object.childAlgos?.map((e) => AlgoState.fromPartial(e)) || []
    return message
  },
}

function createBaseExecutionAnalyticsList(): ExecutionAnalyticsList {
  return { analytics: [] }
}

export const ExecutionAnalyticsList: MessageFns<ExecutionAnalyticsList> = {
  encode(message: ExecutionAnalyticsList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.analytics) {
      ExecutionAnalytics.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionAnalyticsList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionAnalyticsList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.analytics.push(ExecutionAnalytics.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionAnalyticsList {
    return {
      analytics: globalThis.Array.isArray(object?.analytics)
        ? object.analytics.map((e: any) => ExecutionAnalytics.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ExecutionAnalyticsList): unknown {
    const obj: any = {}
    if (message.analytics?.length) {
      obj.analytics = message.analytics.map((e) => ExecutionAnalytics.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionAnalyticsList>, I>>(
    base?: I
  ): ExecutionAnalyticsList {
    return ExecutionAnalyticsList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionAnalyticsList>, I>>(
    object: I
  ): ExecutionAnalyticsList {
    const message = createBaseExecutionAnalyticsList()
    message.analytics = object.analytics?.map((e) => ExecutionAnalytics.fromPartial(e)) || []
    return message
  },
}

function createBaseDataPayload(): DataPayload {
  return {
    accountId: '',
    trades: undefined,
    positions: undefined,
    instruments: undefined,
    tickers: undefined,
    orderBooks: undefined,
    portfolioData: undefined,
    instrumentTrades: undefined,
    unifiedOrders: undefined,
    chartData: undefined,
    incrementalTickers: undefined,
    notification: undefined,
    portfolioLineChart: undefined,
    volSurfaceGenerationResult: undefined,
    riskSimulationResult: undefined,
    economicCalendarEvent: undefined,
    economicCalendarEventList: undefined,
    instrumentStates: undefined,
    executionAnalytics: undefined,
    venues: undefined,
    exchanges: undefined,
    orders: undefined,
    algoStates: undefined,
    volMetrics24h: undefined,
    putCallRatio: undefined,
    deltaSurfaceConstant: undefined,
    deltaSurfaceFloating: undefined,
    impliedVsRealized: undefined,
    termStructureConstant: undefined,
    termStructureFloating: undefined,
    termStructureRichness: undefined,
    volatilityIndex: undefined,
    dbNewsPost: undefined,
    dbNewsPostList: undefined,
    triggerEvaluationSnapshot: undefined,
    dbNewsVocabulary: undefined,
    exchangeStatus: undefined,
    venueSchedules: undefined,
    rfqUpdates: undefined,
    rfqAnalytics: undefined,
    rfqAccept: undefined,
    skewConstant: undefined,
    skewFloating: undefined,
    optionsVolumeLeaderboard: undefined,
    optionsVolumeSeries: undefined,
    optionsVolumeStreamUpdate: undefined,
    optionsOiSeries: undefined,
    optionsOiLeaderboard: undefined,
    fundingSeries: undefined,
    fundingLeaderboard: undefined,
    accountFees: undefined,
    accountSummary: undefined,
    transfers: undefined,
    polymarketSignal: undefined,
    orderbookMetricsSeries: undefined,
    impliedMove: undefined,
    ivPercentile: undefined,
    maxPain: undefined,
    usdGamma: undefined,
    gex: undefined,
    volCones: undefined,
    rvSeasonalityDow: undefined,
    rvSeasonalityMoy: undefined,
    greeksByExpiry: undefined,
    venueHealth: undefined,
    alpacaNewsPost: undefined,
    alpacaNewsPostList: undefined,
    visibleRangeProfile: undefined,
    twitterPost: undefined,
    twitterPostList: undefined,
    portfolioLineChartList: undefined,
    executionAnalyticsList: undefined,
    rfqAnalyticsList: undefined,
    fedwatchProbabilities: undefined,
    etfFlowSeries: undefined,
    coinmarketcalEvent: undefined,
    coinmarketcalEventList: undefined,
    optionsStrikeFlow: undefined,
    gexAggregate: undefined,
    economicInflation: undefined,
    economicInflationExpectations: undefined,
    economicLaborMarket: undefined,
    economicTreasuryYields: undefined,
    bucketedReturns: undefined,
    sessionCumulativeReturns: undefined,
    liquidationLevelProfile: undefined,
    stopLevelProfile: undefined,
    tokenUnlockEvent: undefined,
    tokenUnlockEventList: undefined,
    tokenEmissionSeries: undefined,
    svi: undefined,
    optionsOiByStrike: undefined,
    treeNewsPost: undefined,
    treeNewsPostList: undefined,
    rvSeasonalityHour: undefined,
    surfaceCurrencies: undefined,
    marketScreenerFrame: undefined,
    volFitReferences: undefined,
    orderbookHeatmap: undefined,
    rfqMakerRfqs: undefined,
    rfqMakerQuotes: undefined,
    perpPositions: undefined,
    oiPressure: undefined,
  }
}

export const DataPayload: MessageFns<DataPayload> = {
  encode(message: DataPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(538).string(message.accountId)
    }
    if (message.trades !== undefined) {
      TradeList.encode(message.trades, writer.uint32(10).fork()).join()
    }
    if (message.positions !== undefined) {
      PositionList.encode(message.positions, writer.uint32(18).fork()).join()
    }
    if (message.instruments !== undefined) {
      InstrumentList1.encode(message.instruments, writer.uint32(26).fork()).join()
    }
    if (message.tickers !== undefined) {
      TickerList.encode(message.tickers, writer.uint32(34).fork()).join()
    }
    if (message.orderBooks !== undefined) {
      OrderBookList.encode(message.orderBooks, writer.uint32(42).fork()).join()
    }
    if (message.portfolioData !== undefined) {
      PortfolioDataList.encode(message.portfolioData, writer.uint32(50).fork()).join()
    }
    if (message.instrumentTrades !== undefined) {
      InstrumentTradeList.encode(message.instrumentTrades, writer.uint32(58).fork()).join()
    }
    if (message.unifiedOrders !== undefined) {
      UnifiedOrderList.encode(message.unifiedOrders, writer.uint32(66).fork()).join()
    }
    if (message.chartData !== undefined) {
      ChartData.encode(message.chartData, writer.uint32(74).fork()).join()
    }
    if (message.incrementalTickers !== undefined) {
      IncrementalTickerList.encode(message.incrementalTickers, writer.uint32(82).fork()).join()
    }
    if (message.notification !== undefined) {
      ServiceNotification.encode(message.notification, writer.uint32(90).fork()).join()
    }
    if (message.portfolioLineChart !== undefined) {
      PortfolioLineChart.encode(message.portfolioLineChart, writer.uint32(98).fork()).join()
    }
    if (message.volSurfaceGenerationResult !== undefined) {
      VolSurfaceGenerationResult.encode(
        message.volSurfaceGenerationResult,
        writer.uint32(106).fork()
      ).join()
    }
    if (message.riskSimulationResult !== undefined) {
      RiskSimulationResult.encode(message.riskSimulationResult, writer.uint32(114).fork()).join()
    }
    if (message.economicCalendarEvent !== undefined) {
      EconomicCalendarEvent.encode(message.economicCalendarEvent, writer.uint32(122).fork()).join()
    }
    if (message.economicCalendarEventList !== undefined) {
      EconomicCalendarEventList.encode(
        message.economicCalendarEventList,
        writer.uint32(130).fork()
      ).join()
    }
    if (message.instrumentStates !== undefined) {
      InstrumentStateList.encode(message.instrumentStates, writer.uint32(154).fork()).join()
    }
    if (message.executionAnalytics !== undefined) {
      ExecutionAnalytics.encode(message.executionAnalytics, writer.uint32(162).fork()).join()
    }
    if (message.venues !== undefined) {
      VenueList.encode(message.venues, writer.uint32(170).fork()).join()
    }
    if (message.exchanges !== undefined) {
      ExchangeList.encode(message.exchanges, writer.uint32(178).fork()).join()
    }
    if (message.orders !== undefined) {
      OrderList.encode(message.orders, writer.uint32(186).fork()).join()
    }
    if (message.algoStates !== undefined) {
      AlgoStateList.encode(message.algoStates, writer.uint32(194).fork()).join()
    }
    if (message.volMetrics24h !== undefined) {
      VolMetrics24hList.encode(message.volMetrics24h, writer.uint32(202).fork()).join()
    }
    if (message.putCallRatio !== undefined) {
      PutCallRatioList.encode(message.putCallRatio, writer.uint32(210).fork()).join()
    }
    if (message.deltaSurfaceConstant !== undefined) {
      DeltaSurfaceConstantList.encode(
        message.deltaSurfaceConstant,
        writer.uint32(218).fork()
      ).join()
    }
    if (message.deltaSurfaceFloating !== undefined) {
      DeltaSurfaceFloatingList.encode(
        message.deltaSurfaceFloating,
        writer.uint32(226).fork()
      ).join()
    }
    if (message.impliedVsRealized !== undefined) {
      ImpliedVsRealizedList.encode(message.impliedVsRealized, writer.uint32(234).fork()).join()
    }
    if (message.termStructureConstant !== undefined) {
      TermStructureConstantList.encode(
        message.termStructureConstant,
        writer.uint32(242).fork()
      ).join()
    }
    if (message.termStructureFloating !== undefined) {
      TermStructureFloatingList.encode(
        message.termStructureFloating,
        writer.uint32(250).fork()
      ).join()
    }
    if (message.termStructureRichness !== undefined) {
      TermStructureRichnessList.encode(
        message.termStructureRichness,
        writer.uint32(258).fork()
      ).join()
    }
    if (message.volatilityIndex !== undefined) {
      VolatilityIndexList.encode(message.volatilityIndex, writer.uint32(266).fork()).join()
    }
    if (message.dbNewsPost !== undefined) {
      DbNewsPost.encode(message.dbNewsPost, writer.uint32(274).fork()).join()
    }
    if (message.dbNewsPostList !== undefined) {
      DbNewsPostList.encode(message.dbNewsPostList, writer.uint32(282).fork()).join()
    }
    if (message.triggerEvaluationSnapshot !== undefined) {
      TriggerEvaluationSnapshot.encode(
        message.triggerEvaluationSnapshot,
        writer.uint32(290).fork()
      ).join()
    }
    if (message.dbNewsVocabulary !== undefined) {
      DbNewsVocabulary.encode(message.dbNewsVocabulary, writer.uint32(298).fork()).join()
    }
    if (message.exchangeStatus !== undefined) {
      ExchangeStatus.encode(message.exchangeStatus, writer.uint32(306).fork()).join()
    }
    if (message.venueSchedules !== undefined) {
      VenueScheduleList.encode(message.venueSchedules, writer.uint32(314).fork()).join()
    }
    if (message.rfqUpdates !== undefined) {
      RfqUpdateList.encode(message.rfqUpdates, writer.uint32(322).fork()).join()
    }
    if (message.rfqAnalytics !== undefined) {
      RfqAnalytics.encode(message.rfqAnalytics, writer.uint32(330).fork()).join()
    }
    if (message.rfqAccept !== undefined) {
      RfqAccept.encode(message.rfqAccept, writer.uint32(338).fork()).join()
    }
    if (message.skewConstant !== undefined) {
      SkewConstantList.encode(message.skewConstant, writer.uint32(346).fork()).join()
    }
    if (message.skewFloating !== undefined) {
      SkewFloatingList.encode(message.skewFloating, writer.uint32(354).fork()).join()
    }
    if (message.optionsVolumeLeaderboard !== undefined) {
      OptionsVolumeLeaderboard.encode(
        message.optionsVolumeLeaderboard,
        writer.uint32(362).fork()
      ).join()
    }
    if (message.optionsVolumeSeries !== undefined) {
      OptionsVolumeSeries.encode(message.optionsVolumeSeries, writer.uint32(370).fork()).join()
    }
    if (message.optionsVolumeStreamUpdate !== undefined) {
      OptionsVolumeStreamUpdate.encode(
        message.optionsVolumeStreamUpdate,
        writer.uint32(378).fork()
      ).join()
    }
    if (message.optionsOiSeries !== undefined) {
      OptionsOiSeries.encode(message.optionsOiSeries, writer.uint32(386).fork()).join()
    }
    if (message.optionsOiLeaderboard !== undefined) {
      OptionsOiLeaderboard.encode(message.optionsOiLeaderboard, writer.uint32(394).fork()).join()
    }
    if (message.fundingSeries !== undefined) {
      FundingSeries.encode(message.fundingSeries, writer.uint32(402).fork()).join()
    }
    if (message.fundingLeaderboard !== undefined) {
      FundingLeaderboard.encode(message.fundingLeaderboard, writer.uint32(410).fork()).join()
    }
    if (message.accountFees !== undefined) {
      AccountFeesList.encode(message.accountFees, writer.uint32(418).fork()).join()
    }
    if (message.accountSummary !== undefined) {
      AccountSummaryList.encode(message.accountSummary, writer.uint32(426).fork()).join()
    }
    if (message.transfers !== undefined) {
      TransferList.encode(message.transfers, writer.uint32(434).fork()).join()
    }
    if (message.polymarketSignal !== undefined) {
      PolymarketSignal.encode(message.polymarketSignal, writer.uint32(442).fork()).join()
    }
    if (message.orderbookMetricsSeries !== undefined) {
      OrderbookMetricsSeries.encode(
        message.orderbookMetricsSeries,
        writer.uint32(450).fork()
      ).join()
    }
    if (message.impliedMove !== undefined) {
      ImpliedMove.encode(message.impliedMove, writer.uint32(458).fork()).join()
    }
    if (message.ivPercentile !== undefined) {
      IvPercentile.encode(message.ivPercentile, writer.uint32(466).fork()).join()
    }
    if (message.maxPain !== undefined) {
      MaxPain.encode(message.maxPain, writer.uint32(474).fork()).join()
    }
    if (message.usdGamma !== undefined) {
      UsdGammaList.encode(message.usdGamma, writer.uint32(482).fork()).join()
    }
    if (message.gex !== undefined) {
      GexList.encode(message.gex, writer.uint32(490).fork()).join()
    }
    if (message.volCones !== undefined) {
      VolConeList.encode(message.volCones, writer.uint32(498).fork()).join()
    }
    if (message.rvSeasonalityDow !== undefined) {
      RvSeasonalityList.encode(message.rvSeasonalityDow, writer.uint32(506).fork()).join()
    }
    if (message.rvSeasonalityMoy !== undefined) {
      RvSeasonalityList.encode(message.rvSeasonalityMoy, writer.uint32(514).fork()).join()
    }
    if (message.greeksByExpiry !== undefined) {
      GreeksByExpiry.encode(message.greeksByExpiry, writer.uint32(522).fork()).join()
    }
    if (message.venueHealth !== undefined) {
      VenueHealth.encode(message.venueHealth, writer.uint32(530).fork()).join()
    }
    if (message.alpacaNewsPost !== undefined) {
      AlpacaNewsPost.encode(message.alpacaNewsPost, writer.uint32(554).fork()).join()
    }
    if (message.alpacaNewsPostList !== undefined) {
      AlpacaNewsPostList.encode(message.alpacaNewsPostList, writer.uint32(562).fork()).join()
    }
    if (message.visibleRangeProfile !== undefined) {
      VisibleRangeProfile.encode(message.visibleRangeProfile, writer.uint32(570).fork()).join()
    }
    if (message.twitterPost !== undefined) {
      TwitterPost.encode(message.twitterPost, writer.uint32(578).fork()).join()
    }
    if (message.twitterPostList !== undefined) {
      TwitterPostList.encode(message.twitterPostList, writer.uint32(586).fork()).join()
    }
    if (message.portfolioLineChartList !== undefined) {
      PortfolioLineChartList.encode(
        message.portfolioLineChartList,
        writer.uint32(594).fork()
      ).join()
    }
    if (message.executionAnalyticsList !== undefined) {
      ExecutionAnalyticsList.encode(
        message.executionAnalyticsList,
        writer.uint32(602).fork()
      ).join()
    }
    if (message.rfqAnalyticsList !== undefined) {
      RfqAnalyticsList.encode(message.rfqAnalyticsList, writer.uint32(610).fork()).join()
    }
    if (message.fedwatchProbabilities !== undefined) {
      FedwatchProbabilityList.encode(
        message.fedwatchProbabilities,
        writer.uint32(618).fork()
      ).join()
    }
    if (message.etfFlowSeries !== undefined) {
      EtfFlowSeries.encode(message.etfFlowSeries, writer.uint32(626).fork()).join()
    }
    if (message.coinmarketcalEvent !== undefined) {
      CoinMarketCalEvent.encode(message.coinmarketcalEvent, writer.uint32(634).fork()).join()
    }
    if (message.coinmarketcalEventList !== undefined) {
      CoinMarketCalEventList.encode(
        message.coinmarketcalEventList,
        writer.uint32(642).fork()
      ).join()
    }
    if (message.optionsStrikeFlow !== undefined) {
      OptionsStrikeFlow.encode(message.optionsStrikeFlow, writer.uint32(650).fork()).join()
    }
    if (message.gexAggregate !== undefined) {
      GexAggregate.encode(message.gexAggregate, writer.uint32(658).fork()).join()
    }
    if (message.economicInflation !== undefined) {
      EconomicInflationList.encode(message.economicInflation, writer.uint32(666).fork()).join()
    }
    if (message.economicInflationExpectations !== undefined) {
      EconomicInflationExpectationsList.encode(
        message.economicInflationExpectations,
        writer.uint32(674).fork()
      ).join()
    }
    if (message.economicLaborMarket !== undefined) {
      EconomicLaborMarketList.encode(message.economicLaborMarket, writer.uint32(682).fork()).join()
    }
    if (message.economicTreasuryYields !== undefined) {
      EconomicTreasuryYieldList.encode(
        message.economicTreasuryYields,
        writer.uint32(690).fork()
      ).join()
    }
    if (message.bucketedReturns !== undefined) {
      BucketedReturnList.encode(message.bucketedReturns, writer.uint32(698).fork()).join()
    }
    if (message.sessionCumulativeReturns !== undefined) {
      SessionCumulativeReturnList.encode(
        message.sessionCumulativeReturns,
        writer.uint32(706).fork()
      ).join()
    }
    if (message.liquidationLevelProfile !== undefined) {
      LiquidationLevelProfile.encode(
        message.liquidationLevelProfile,
        writer.uint32(714).fork()
      ).join()
    }
    if (message.stopLevelProfile !== undefined) {
      StopLevelProfile.encode(message.stopLevelProfile, writer.uint32(722).fork()).join()
    }
    if (message.tokenUnlockEvent !== undefined) {
      TokenUnlockEvent.encode(message.tokenUnlockEvent, writer.uint32(730).fork()).join()
    }
    if (message.tokenUnlockEventList !== undefined) {
      TokenUnlockEventList.encode(message.tokenUnlockEventList, writer.uint32(738).fork()).join()
    }
    if (message.tokenEmissionSeries !== undefined) {
      TokenEmissionSeries.encode(message.tokenEmissionSeries, writer.uint32(746).fork()).join()
    }
    if (message.svi !== undefined) {
      SviList.encode(message.svi, writer.uint32(754).fork()).join()
    }
    if (message.optionsOiByStrike !== undefined) {
      OptionsOiByStrike.encode(message.optionsOiByStrike, writer.uint32(762).fork()).join()
    }
    if (message.treeNewsPost !== undefined) {
      TreeNewsPost.encode(message.treeNewsPost, writer.uint32(770).fork()).join()
    }
    if (message.treeNewsPostList !== undefined) {
      TreeNewsPostList.encode(message.treeNewsPostList, writer.uint32(778).fork()).join()
    }
    if (message.rvSeasonalityHour !== undefined) {
      RvSeasonalityList.encode(message.rvSeasonalityHour, writer.uint32(786).fork()).join()
    }
    if (message.surfaceCurrencies !== undefined) {
      SurfaceCurrencyList.encode(message.surfaceCurrencies, writer.uint32(794).fork()).join()
    }
    if (message.marketScreenerFrame !== undefined) {
      MarketScreenerFrame.encode(message.marketScreenerFrame, writer.uint32(802).fork()).join()
    }
    if (message.volFitReferences !== undefined) {
      VolFitReferenceList.encode(message.volFitReferences, writer.uint32(810).fork()).join()
    }
    if (message.orderbookHeatmap !== undefined) {
      OrderbookHeatmap.encode(message.orderbookHeatmap, writer.uint32(818).fork()).join()
    }
    if (message.rfqMakerRfqs !== undefined) {
      RfqMakerRfqList.encode(message.rfqMakerRfqs, writer.uint32(826).fork()).join()
    }
    if (message.rfqMakerQuotes !== undefined) {
      RfqMakerQuoteList.encode(message.rfqMakerQuotes, writer.uint32(834).fork()).join()
    }
    if (message.perpPositions !== undefined) {
      PerpPositionsSnapshot.encode(message.perpPositions, writer.uint32(842).fork()).join()
    }
    if (message.oiPressure !== undefined) {
      OpenInterestPressureList.encode(message.oiPressure, writer.uint32(850).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDataPayload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 67: {
          if (tag !== 538) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 1: {
          if (tag !== 10) {
            break
          }

          message.trades = TradeList.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.positions = PositionList.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.instruments = InstrumentList1.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tickers = TickerList.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.orderBooks = OrderBookList.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.portfolioData = PortfolioDataList.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.instrumentTrades = InstrumentTradeList.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.unifiedOrders = UnifiedOrderList.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.chartData = ChartData.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.incrementalTickers = IncrementalTickerList.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.notification = ServiceNotification.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.portfolioLineChart = PortfolioLineChart.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.volSurfaceGenerationResult = VolSurfaceGenerationResult.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.riskSimulationResult = RiskSimulationResult.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.economicCalendarEvent = EconomicCalendarEvent.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.economicCalendarEventList = EconomicCalendarEventList.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.instrumentStates = InstrumentStateList.decode(reader, reader.uint32())
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.executionAnalytics = ExecutionAnalytics.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.venues = VenueList.decode(reader, reader.uint32())
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.exchanges = ExchangeList.decode(reader, reader.uint32())
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.orders = OrderList.decode(reader, reader.uint32())
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.algoStates = AlgoStateList.decode(reader, reader.uint32())
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.volMetrics24h = VolMetrics24hList.decode(reader, reader.uint32())
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.putCallRatio = PutCallRatioList.decode(reader, reader.uint32())
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.deltaSurfaceConstant = DeltaSurfaceConstantList.decode(reader, reader.uint32())
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.deltaSurfaceFloating = DeltaSurfaceFloatingList.decode(reader, reader.uint32())
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.impliedVsRealized = ImpliedVsRealizedList.decode(reader, reader.uint32())
          continue
        }
        case 30: {
          if (tag !== 242) {
            break
          }

          message.termStructureConstant = TermStructureConstantList.decode(reader, reader.uint32())
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.termStructureFloating = TermStructureFloatingList.decode(reader, reader.uint32())
          continue
        }
        case 32: {
          if (tag !== 258) {
            break
          }

          message.termStructureRichness = TermStructureRichnessList.decode(reader, reader.uint32())
          continue
        }
        case 33: {
          if (tag !== 266) {
            break
          }

          message.volatilityIndex = VolatilityIndexList.decode(reader, reader.uint32())
          continue
        }
        case 34: {
          if (tag !== 274) {
            break
          }

          message.dbNewsPost = DbNewsPost.decode(reader, reader.uint32())
          continue
        }
        case 35: {
          if (tag !== 282) {
            break
          }

          message.dbNewsPostList = DbNewsPostList.decode(reader, reader.uint32())
          continue
        }
        case 36: {
          if (tag !== 290) {
            break
          }

          message.triggerEvaluationSnapshot = TriggerEvaluationSnapshot.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 37: {
          if (tag !== 298) {
            break
          }

          message.dbNewsVocabulary = DbNewsVocabulary.decode(reader, reader.uint32())
          continue
        }
        case 38: {
          if (tag !== 306) {
            break
          }

          message.exchangeStatus = ExchangeStatus.decode(reader, reader.uint32())
          continue
        }
        case 39: {
          if (tag !== 314) {
            break
          }

          message.venueSchedules = VenueScheduleList.decode(reader, reader.uint32())
          continue
        }
        case 40: {
          if (tag !== 322) {
            break
          }

          message.rfqUpdates = RfqUpdateList.decode(reader, reader.uint32())
          continue
        }
        case 41: {
          if (tag !== 330) {
            break
          }

          message.rfqAnalytics = RfqAnalytics.decode(reader, reader.uint32())
          continue
        }
        case 42: {
          if (tag !== 338) {
            break
          }

          message.rfqAccept = RfqAccept.decode(reader, reader.uint32())
          continue
        }
        case 43: {
          if (tag !== 346) {
            break
          }

          message.skewConstant = SkewConstantList.decode(reader, reader.uint32())
          continue
        }
        case 44: {
          if (tag !== 354) {
            break
          }

          message.skewFloating = SkewFloatingList.decode(reader, reader.uint32())
          continue
        }
        case 45: {
          if (tag !== 362) {
            break
          }

          message.optionsVolumeLeaderboard = OptionsVolumeLeaderboard.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 46: {
          if (tag !== 370) {
            break
          }

          message.optionsVolumeSeries = OptionsVolumeSeries.decode(reader, reader.uint32())
          continue
        }
        case 47: {
          if (tag !== 378) {
            break
          }

          message.optionsVolumeStreamUpdate = OptionsVolumeStreamUpdate.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 48: {
          if (tag !== 386) {
            break
          }

          message.optionsOiSeries = OptionsOiSeries.decode(reader, reader.uint32())
          continue
        }
        case 49: {
          if (tag !== 394) {
            break
          }

          message.optionsOiLeaderboard = OptionsOiLeaderboard.decode(reader, reader.uint32())
          continue
        }
        case 50: {
          if (tag !== 402) {
            break
          }

          message.fundingSeries = FundingSeries.decode(reader, reader.uint32())
          continue
        }
        case 51: {
          if (tag !== 410) {
            break
          }

          message.fundingLeaderboard = FundingLeaderboard.decode(reader, reader.uint32())
          continue
        }
        case 52: {
          if (tag !== 418) {
            break
          }

          message.accountFees = AccountFeesList.decode(reader, reader.uint32())
          continue
        }
        case 53: {
          if (tag !== 426) {
            break
          }

          message.accountSummary = AccountSummaryList.decode(reader, reader.uint32())
          continue
        }
        case 54: {
          if (tag !== 434) {
            break
          }

          message.transfers = TransferList.decode(reader, reader.uint32())
          continue
        }
        case 55: {
          if (tag !== 442) {
            break
          }

          message.polymarketSignal = PolymarketSignal.decode(reader, reader.uint32())
          continue
        }
        case 56: {
          if (tag !== 450) {
            break
          }

          message.orderbookMetricsSeries = OrderbookMetricsSeries.decode(reader, reader.uint32())
          continue
        }
        case 57: {
          if (tag !== 458) {
            break
          }

          message.impliedMove = ImpliedMove.decode(reader, reader.uint32())
          continue
        }
        case 58: {
          if (tag !== 466) {
            break
          }

          message.ivPercentile = IvPercentile.decode(reader, reader.uint32())
          continue
        }
        case 59: {
          if (tag !== 474) {
            break
          }

          message.maxPain = MaxPain.decode(reader, reader.uint32())
          continue
        }
        case 60: {
          if (tag !== 482) {
            break
          }

          message.usdGamma = UsdGammaList.decode(reader, reader.uint32())
          continue
        }
        case 61: {
          if (tag !== 490) {
            break
          }

          message.gex = GexList.decode(reader, reader.uint32())
          continue
        }
        case 62: {
          if (tag !== 498) {
            break
          }

          message.volCones = VolConeList.decode(reader, reader.uint32())
          continue
        }
        case 63: {
          if (tag !== 506) {
            break
          }

          message.rvSeasonalityDow = RvSeasonalityList.decode(reader, reader.uint32())
          continue
        }
        case 64: {
          if (tag !== 514) {
            break
          }

          message.rvSeasonalityMoy = RvSeasonalityList.decode(reader, reader.uint32())
          continue
        }
        case 65: {
          if (tag !== 522) {
            break
          }

          message.greeksByExpiry = GreeksByExpiry.decode(reader, reader.uint32())
          continue
        }
        case 66: {
          if (tag !== 530) {
            break
          }

          message.venueHealth = VenueHealth.decode(reader, reader.uint32())
          continue
        }
        case 69: {
          if (tag !== 554) {
            break
          }

          message.alpacaNewsPost = AlpacaNewsPost.decode(reader, reader.uint32())
          continue
        }
        case 70: {
          if (tag !== 562) {
            break
          }

          message.alpacaNewsPostList = AlpacaNewsPostList.decode(reader, reader.uint32())
          continue
        }
        case 71: {
          if (tag !== 570) {
            break
          }

          message.visibleRangeProfile = VisibleRangeProfile.decode(reader, reader.uint32())
          continue
        }
        case 72: {
          if (tag !== 578) {
            break
          }

          message.twitterPost = TwitterPost.decode(reader, reader.uint32())
          continue
        }
        case 73: {
          if (tag !== 586) {
            break
          }

          message.twitterPostList = TwitterPostList.decode(reader, reader.uint32())
          continue
        }
        case 74: {
          if (tag !== 594) {
            break
          }

          message.portfolioLineChartList = PortfolioLineChartList.decode(reader, reader.uint32())
          continue
        }
        case 75: {
          if (tag !== 602) {
            break
          }

          message.executionAnalyticsList = ExecutionAnalyticsList.decode(reader, reader.uint32())
          continue
        }
        case 76: {
          if (tag !== 610) {
            break
          }

          message.rfqAnalyticsList = RfqAnalyticsList.decode(reader, reader.uint32())
          continue
        }
        case 77: {
          if (tag !== 618) {
            break
          }

          message.fedwatchProbabilities = FedwatchProbabilityList.decode(reader, reader.uint32())
          continue
        }
        case 78: {
          if (tag !== 626) {
            break
          }

          message.etfFlowSeries = EtfFlowSeries.decode(reader, reader.uint32())
          continue
        }
        case 79: {
          if (tag !== 634) {
            break
          }

          message.coinmarketcalEvent = CoinMarketCalEvent.decode(reader, reader.uint32())
          continue
        }
        case 80: {
          if (tag !== 642) {
            break
          }

          message.coinmarketcalEventList = CoinMarketCalEventList.decode(reader, reader.uint32())
          continue
        }
        case 81: {
          if (tag !== 650) {
            break
          }

          message.optionsStrikeFlow = OptionsStrikeFlow.decode(reader, reader.uint32())
          continue
        }
        case 82: {
          if (tag !== 658) {
            break
          }

          message.gexAggregate = GexAggregate.decode(reader, reader.uint32())
          continue
        }
        case 83: {
          if (tag !== 666) {
            break
          }

          message.economicInflation = EconomicInflationList.decode(reader, reader.uint32())
          continue
        }
        case 84: {
          if (tag !== 674) {
            break
          }

          message.economicInflationExpectations = EconomicInflationExpectationsList.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 85: {
          if (tag !== 682) {
            break
          }

          message.economicLaborMarket = EconomicLaborMarketList.decode(reader, reader.uint32())
          continue
        }
        case 86: {
          if (tag !== 690) {
            break
          }

          message.economicTreasuryYields = EconomicTreasuryYieldList.decode(reader, reader.uint32())
          continue
        }
        case 87: {
          if (tag !== 698) {
            break
          }

          message.bucketedReturns = BucketedReturnList.decode(reader, reader.uint32())
          continue
        }
        case 88: {
          if (tag !== 706) {
            break
          }

          message.sessionCumulativeReturns = SessionCumulativeReturnList.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 89: {
          if (tag !== 714) {
            break
          }

          message.liquidationLevelProfile = LiquidationLevelProfile.decode(reader, reader.uint32())
          continue
        }
        case 90: {
          if (tag !== 722) {
            break
          }

          message.stopLevelProfile = StopLevelProfile.decode(reader, reader.uint32())
          continue
        }
        case 91: {
          if (tag !== 730) {
            break
          }

          message.tokenUnlockEvent = TokenUnlockEvent.decode(reader, reader.uint32())
          continue
        }
        case 92: {
          if (tag !== 738) {
            break
          }

          message.tokenUnlockEventList = TokenUnlockEventList.decode(reader, reader.uint32())
          continue
        }
        case 93: {
          if (tag !== 746) {
            break
          }

          message.tokenEmissionSeries = TokenEmissionSeries.decode(reader, reader.uint32())
          continue
        }
        case 94: {
          if (tag !== 754) {
            break
          }

          message.svi = SviList.decode(reader, reader.uint32())
          continue
        }
        case 95: {
          if (tag !== 762) {
            break
          }

          message.optionsOiByStrike = OptionsOiByStrike.decode(reader, reader.uint32())
          continue
        }
        case 96: {
          if (tag !== 770) {
            break
          }

          message.treeNewsPost = TreeNewsPost.decode(reader, reader.uint32())
          continue
        }
        case 97: {
          if (tag !== 778) {
            break
          }

          message.treeNewsPostList = TreeNewsPostList.decode(reader, reader.uint32())
          continue
        }
        case 98: {
          if (tag !== 786) {
            break
          }

          message.rvSeasonalityHour = RvSeasonalityList.decode(reader, reader.uint32())
          continue
        }
        case 99: {
          if (tag !== 794) {
            break
          }

          message.surfaceCurrencies = SurfaceCurrencyList.decode(reader, reader.uint32())
          continue
        }
        case 100: {
          if (tag !== 802) {
            break
          }

          message.marketScreenerFrame = MarketScreenerFrame.decode(reader, reader.uint32())
          continue
        }
        case 101: {
          if (tag !== 810) {
            break
          }

          message.volFitReferences = VolFitReferenceList.decode(reader, reader.uint32())
          continue
        }
        case 102: {
          if (tag !== 818) {
            break
          }

          message.orderbookHeatmap = OrderbookHeatmap.decode(reader, reader.uint32())
          continue
        }
        case 103: {
          if (tag !== 826) {
            break
          }

          message.rfqMakerRfqs = RfqMakerRfqList.decode(reader, reader.uint32())
          continue
        }
        case 104: {
          if (tag !== 834) {
            break
          }

          message.rfqMakerQuotes = RfqMakerQuoteList.decode(reader, reader.uint32())
          continue
        }
        case 105: {
          if (tag !== 842) {
            break
          }

          message.perpPositions = PerpPositionsSnapshot.decode(reader, reader.uint32())
          continue
        }
        case 106: {
          if (tag !== 850) {
            break
          }

          message.oiPressure = OpenInterestPressureList.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DataPayload {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      trades: isSet(object.trades) ? TradeList.fromJSON(object.trades) : undefined,
      positions: isSet(object.positions) ? PositionList.fromJSON(object.positions) : undefined,
      instruments: isSet(object.instruments)
        ? InstrumentList1.fromJSON(object.instruments)
        : undefined,
      tickers: isSet(object.tickers) ? TickerList.fromJSON(object.tickers) : undefined,
      orderBooks: isSet(object.orderBooks)
        ? OrderBookList.fromJSON(object.orderBooks)
        : isSet(object.order_books)
          ? OrderBookList.fromJSON(object.order_books)
          : undefined,
      portfolioData: isSet(object.portfolioData)
        ? PortfolioDataList.fromJSON(object.portfolioData)
        : isSet(object.portfolio_data)
          ? PortfolioDataList.fromJSON(object.portfolio_data)
          : undefined,
      instrumentTrades: isSet(object.instrumentTrades)
        ? InstrumentTradeList.fromJSON(object.instrumentTrades)
        : isSet(object.instrument_trades)
          ? InstrumentTradeList.fromJSON(object.instrument_trades)
          : undefined,
      unifiedOrders: isSet(object.unifiedOrders)
        ? UnifiedOrderList.fromJSON(object.unifiedOrders)
        : isSet(object.unified_orders)
          ? UnifiedOrderList.fromJSON(object.unified_orders)
          : undefined,
      chartData: isSet(object.chartData)
        ? ChartData.fromJSON(object.chartData)
        : isSet(object.chart_data)
          ? ChartData.fromJSON(object.chart_data)
          : undefined,
      incrementalTickers: isSet(object.incrementalTickers)
        ? IncrementalTickerList.fromJSON(object.incrementalTickers)
        : isSet(object.incremental_tickers)
          ? IncrementalTickerList.fromJSON(object.incremental_tickers)
          : undefined,
      notification: isSet(object.notification)
        ? ServiceNotification.fromJSON(object.notification)
        : undefined,
      portfolioLineChart: isSet(object.portfolioLineChart)
        ? PortfolioLineChart.fromJSON(object.portfolioLineChart)
        : isSet(object.portfolio_line_chart)
          ? PortfolioLineChart.fromJSON(object.portfolio_line_chart)
          : undefined,
      volSurfaceGenerationResult: isSet(object.volSurfaceGenerationResult)
        ? VolSurfaceGenerationResult.fromJSON(object.volSurfaceGenerationResult)
        : isSet(object.vol_surface_generation_result)
          ? VolSurfaceGenerationResult.fromJSON(object.vol_surface_generation_result)
          : undefined,
      riskSimulationResult: isSet(object.riskSimulationResult)
        ? RiskSimulationResult.fromJSON(object.riskSimulationResult)
        : isSet(object.risk_simulation_result)
          ? RiskSimulationResult.fromJSON(object.risk_simulation_result)
          : undefined,
      economicCalendarEvent: isSet(object.economicCalendarEvent)
        ? EconomicCalendarEvent.fromJSON(object.economicCalendarEvent)
        : isSet(object.economic_calendar_event)
          ? EconomicCalendarEvent.fromJSON(object.economic_calendar_event)
          : undefined,
      economicCalendarEventList: isSet(object.economicCalendarEventList)
        ? EconomicCalendarEventList.fromJSON(object.economicCalendarEventList)
        : isSet(object.economic_calendar_event_list)
          ? EconomicCalendarEventList.fromJSON(object.economic_calendar_event_list)
          : undefined,
      instrumentStates: isSet(object.instrumentStates)
        ? InstrumentStateList.fromJSON(object.instrumentStates)
        : isSet(object.instrument_states)
          ? InstrumentStateList.fromJSON(object.instrument_states)
          : undefined,
      executionAnalytics: isSet(object.executionAnalytics)
        ? ExecutionAnalytics.fromJSON(object.executionAnalytics)
        : isSet(object.execution_analytics)
          ? ExecutionAnalytics.fromJSON(object.execution_analytics)
          : undefined,
      venues: isSet(object.venues) ? VenueList.fromJSON(object.venues) : undefined,
      exchanges: isSet(object.exchanges) ? ExchangeList.fromJSON(object.exchanges) : undefined,
      orders: isSet(object.orders) ? OrderList.fromJSON(object.orders) : undefined,
      algoStates: isSet(object.algoStates)
        ? AlgoStateList.fromJSON(object.algoStates)
        : isSet(object.algo_states)
          ? AlgoStateList.fromJSON(object.algo_states)
          : undefined,
      volMetrics24h: isSet(object.volMetrics24h)
        ? VolMetrics24hList.fromJSON(object.volMetrics24h)
        : isSet(object.vol_metrics_24h)
          ? VolMetrics24hList.fromJSON(object.vol_metrics_24h)
          : undefined,
      putCallRatio: isSet(object.putCallRatio)
        ? PutCallRatioList.fromJSON(object.putCallRatio)
        : isSet(object.put_call_ratio)
          ? PutCallRatioList.fromJSON(object.put_call_ratio)
          : undefined,
      deltaSurfaceConstant: isSet(object.deltaSurfaceConstant)
        ? DeltaSurfaceConstantList.fromJSON(object.deltaSurfaceConstant)
        : isSet(object.delta_surface_constant)
          ? DeltaSurfaceConstantList.fromJSON(object.delta_surface_constant)
          : undefined,
      deltaSurfaceFloating: isSet(object.deltaSurfaceFloating)
        ? DeltaSurfaceFloatingList.fromJSON(object.deltaSurfaceFloating)
        : isSet(object.delta_surface_floating)
          ? DeltaSurfaceFloatingList.fromJSON(object.delta_surface_floating)
          : undefined,
      impliedVsRealized: isSet(object.impliedVsRealized)
        ? ImpliedVsRealizedList.fromJSON(object.impliedVsRealized)
        : isSet(object.implied_vs_realized)
          ? ImpliedVsRealizedList.fromJSON(object.implied_vs_realized)
          : undefined,
      termStructureConstant: isSet(object.termStructureConstant)
        ? TermStructureConstantList.fromJSON(object.termStructureConstant)
        : isSet(object.term_structure_constant)
          ? TermStructureConstantList.fromJSON(object.term_structure_constant)
          : undefined,
      termStructureFloating: isSet(object.termStructureFloating)
        ? TermStructureFloatingList.fromJSON(object.termStructureFloating)
        : isSet(object.term_structure_floating)
          ? TermStructureFloatingList.fromJSON(object.term_structure_floating)
          : undefined,
      termStructureRichness: isSet(object.termStructureRichness)
        ? TermStructureRichnessList.fromJSON(object.termStructureRichness)
        : isSet(object.term_structure_richness)
          ? TermStructureRichnessList.fromJSON(object.term_structure_richness)
          : undefined,
      volatilityIndex: isSet(object.volatilityIndex)
        ? VolatilityIndexList.fromJSON(object.volatilityIndex)
        : isSet(object.volatility_index)
          ? VolatilityIndexList.fromJSON(object.volatility_index)
          : undefined,
      dbNewsPost: isSet(object.dbNewsPost)
        ? DbNewsPost.fromJSON(object.dbNewsPost)
        : isSet(object.db_news_post)
          ? DbNewsPost.fromJSON(object.db_news_post)
          : undefined,
      dbNewsPostList: isSet(object.dbNewsPostList)
        ? DbNewsPostList.fromJSON(object.dbNewsPostList)
        : isSet(object.db_news_post_list)
          ? DbNewsPostList.fromJSON(object.db_news_post_list)
          : undefined,
      triggerEvaluationSnapshot: isSet(object.triggerEvaluationSnapshot)
        ? TriggerEvaluationSnapshot.fromJSON(object.triggerEvaluationSnapshot)
        : isSet(object.trigger_evaluation_snapshot)
          ? TriggerEvaluationSnapshot.fromJSON(object.trigger_evaluation_snapshot)
          : undefined,
      dbNewsVocabulary: isSet(object.dbNewsVocabulary)
        ? DbNewsVocabulary.fromJSON(object.dbNewsVocabulary)
        : isSet(object.db_news_vocabulary)
          ? DbNewsVocabulary.fromJSON(object.db_news_vocabulary)
          : undefined,
      exchangeStatus: isSet(object.exchangeStatus)
        ? ExchangeStatus.fromJSON(object.exchangeStatus)
        : isSet(object.exchange_status)
          ? ExchangeStatus.fromJSON(object.exchange_status)
          : undefined,
      venueSchedules: isSet(object.venueSchedules)
        ? VenueScheduleList.fromJSON(object.venueSchedules)
        : isSet(object.venue_schedules)
          ? VenueScheduleList.fromJSON(object.venue_schedules)
          : undefined,
      rfqUpdates: isSet(object.rfqUpdates)
        ? RfqUpdateList.fromJSON(object.rfqUpdates)
        : isSet(object.rfq_updates)
          ? RfqUpdateList.fromJSON(object.rfq_updates)
          : undefined,
      rfqAnalytics: isSet(object.rfqAnalytics)
        ? RfqAnalytics.fromJSON(object.rfqAnalytics)
        : isSet(object.rfq_analytics)
          ? RfqAnalytics.fromJSON(object.rfq_analytics)
          : undefined,
      rfqAccept: isSet(object.rfqAccept)
        ? RfqAccept.fromJSON(object.rfqAccept)
        : isSet(object.rfq_accept)
          ? RfqAccept.fromJSON(object.rfq_accept)
          : undefined,
      skewConstant: isSet(object.skewConstant)
        ? SkewConstantList.fromJSON(object.skewConstant)
        : isSet(object.skew_constant)
          ? SkewConstantList.fromJSON(object.skew_constant)
          : undefined,
      skewFloating: isSet(object.skewFloating)
        ? SkewFloatingList.fromJSON(object.skewFloating)
        : isSet(object.skew_floating)
          ? SkewFloatingList.fromJSON(object.skew_floating)
          : undefined,
      optionsVolumeLeaderboard: isSet(object.optionsVolumeLeaderboard)
        ? OptionsVolumeLeaderboard.fromJSON(object.optionsVolumeLeaderboard)
        : isSet(object.options_volume_leaderboard)
          ? OptionsVolumeLeaderboard.fromJSON(object.options_volume_leaderboard)
          : undefined,
      optionsVolumeSeries: isSet(object.optionsVolumeSeries)
        ? OptionsVolumeSeries.fromJSON(object.optionsVolumeSeries)
        : isSet(object.options_volume_series)
          ? OptionsVolumeSeries.fromJSON(object.options_volume_series)
          : undefined,
      optionsVolumeStreamUpdate: isSet(object.optionsVolumeStreamUpdate)
        ? OptionsVolumeStreamUpdate.fromJSON(object.optionsVolumeStreamUpdate)
        : isSet(object.options_volume_stream_update)
          ? OptionsVolumeStreamUpdate.fromJSON(object.options_volume_stream_update)
          : undefined,
      optionsOiSeries: isSet(object.optionsOiSeries)
        ? OptionsOiSeries.fromJSON(object.optionsOiSeries)
        : isSet(object.options_oi_series)
          ? OptionsOiSeries.fromJSON(object.options_oi_series)
          : undefined,
      optionsOiLeaderboard: isSet(object.optionsOiLeaderboard)
        ? OptionsOiLeaderboard.fromJSON(object.optionsOiLeaderboard)
        : isSet(object.options_oi_leaderboard)
          ? OptionsOiLeaderboard.fromJSON(object.options_oi_leaderboard)
          : undefined,
      fundingSeries: isSet(object.fundingSeries)
        ? FundingSeries.fromJSON(object.fundingSeries)
        : isSet(object.funding_series)
          ? FundingSeries.fromJSON(object.funding_series)
          : undefined,
      fundingLeaderboard: isSet(object.fundingLeaderboard)
        ? FundingLeaderboard.fromJSON(object.fundingLeaderboard)
        : isSet(object.funding_leaderboard)
          ? FundingLeaderboard.fromJSON(object.funding_leaderboard)
          : undefined,
      accountFees: isSet(object.accountFees)
        ? AccountFeesList.fromJSON(object.accountFees)
        : isSet(object.account_fees)
          ? AccountFeesList.fromJSON(object.account_fees)
          : undefined,
      accountSummary: isSet(object.accountSummary)
        ? AccountSummaryList.fromJSON(object.accountSummary)
        : isSet(object.account_summary)
          ? AccountSummaryList.fromJSON(object.account_summary)
          : undefined,
      transfers: isSet(object.transfers) ? TransferList.fromJSON(object.transfers) : undefined,
      polymarketSignal: isSet(object.polymarketSignal)
        ? PolymarketSignal.fromJSON(object.polymarketSignal)
        : isSet(object.polymarket_signal)
          ? PolymarketSignal.fromJSON(object.polymarket_signal)
          : undefined,
      orderbookMetricsSeries: isSet(object.orderbookMetricsSeries)
        ? OrderbookMetricsSeries.fromJSON(object.orderbookMetricsSeries)
        : isSet(object.orderbook_metrics_series)
          ? OrderbookMetricsSeries.fromJSON(object.orderbook_metrics_series)
          : undefined,
      impliedMove: isSet(object.impliedMove)
        ? ImpliedMove.fromJSON(object.impliedMove)
        : isSet(object.implied_move)
          ? ImpliedMove.fromJSON(object.implied_move)
          : undefined,
      ivPercentile: isSet(object.ivPercentile)
        ? IvPercentile.fromJSON(object.ivPercentile)
        : isSet(object.iv_percentile)
          ? IvPercentile.fromJSON(object.iv_percentile)
          : undefined,
      maxPain: isSet(object.maxPain)
        ? MaxPain.fromJSON(object.maxPain)
        : isSet(object.max_pain)
          ? MaxPain.fromJSON(object.max_pain)
          : undefined,
      usdGamma: isSet(object.usdGamma)
        ? UsdGammaList.fromJSON(object.usdGamma)
        : isSet(object.usd_gamma)
          ? UsdGammaList.fromJSON(object.usd_gamma)
          : undefined,
      gex: isSet(object.gex) ? GexList.fromJSON(object.gex) : undefined,
      volCones: isSet(object.volCones)
        ? VolConeList.fromJSON(object.volCones)
        : isSet(object.vol_cones)
          ? VolConeList.fromJSON(object.vol_cones)
          : undefined,
      rvSeasonalityDow: isSet(object.rvSeasonalityDow)
        ? RvSeasonalityList.fromJSON(object.rvSeasonalityDow)
        : isSet(object.rv_seasonality_dow)
          ? RvSeasonalityList.fromJSON(object.rv_seasonality_dow)
          : undefined,
      rvSeasonalityMoy: isSet(object.rvSeasonalityMoy)
        ? RvSeasonalityList.fromJSON(object.rvSeasonalityMoy)
        : isSet(object.rv_seasonality_moy)
          ? RvSeasonalityList.fromJSON(object.rv_seasonality_moy)
          : undefined,
      greeksByExpiry: isSet(object.greeksByExpiry)
        ? GreeksByExpiry.fromJSON(object.greeksByExpiry)
        : isSet(object.greeks_by_expiry)
          ? GreeksByExpiry.fromJSON(object.greeks_by_expiry)
          : undefined,
      venueHealth: isSet(object.venueHealth)
        ? VenueHealth.fromJSON(object.venueHealth)
        : isSet(object.venue_health)
          ? VenueHealth.fromJSON(object.venue_health)
          : undefined,
      alpacaNewsPost: isSet(object.alpacaNewsPost)
        ? AlpacaNewsPost.fromJSON(object.alpacaNewsPost)
        : isSet(object.alpaca_news_post)
          ? AlpacaNewsPost.fromJSON(object.alpaca_news_post)
          : undefined,
      alpacaNewsPostList: isSet(object.alpacaNewsPostList)
        ? AlpacaNewsPostList.fromJSON(object.alpacaNewsPostList)
        : isSet(object.alpaca_news_post_list)
          ? AlpacaNewsPostList.fromJSON(object.alpaca_news_post_list)
          : undefined,
      visibleRangeProfile: isSet(object.visibleRangeProfile)
        ? VisibleRangeProfile.fromJSON(object.visibleRangeProfile)
        : isSet(object.visible_range_profile)
          ? VisibleRangeProfile.fromJSON(object.visible_range_profile)
          : undefined,
      twitterPost: isSet(object.twitterPost)
        ? TwitterPost.fromJSON(object.twitterPost)
        : isSet(object.twitter_post)
          ? TwitterPost.fromJSON(object.twitter_post)
          : undefined,
      twitterPostList: isSet(object.twitterPostList)
        ? TwitterPostList.fromJSON(object.twitterPostList)
        : isSet(object.twitter_post_list)
          ? TwitterPostList.fromJSON(object.twitter_post_list)
          : undefined,
      portfolioLineChartList: isSet(object.portfolioLineChartList)
        ? PortfolioLineChartList.fromJSON(object.portfolioLineChartList)
        : isSet(object.portfolio_line_chart_list)
          ? PortfolioLineChartList.fromJSON(object.portfolio_line_chart_list)
          : undefined,
      executionAnalyticsList: isSet(object.executionAnalyticsList)
        ? ExecutionAnalyticsList.fromJSON(object.executionAnalyticsList)
        : isSet(object.execution_analytics_list)
          ? ExecutionAnalyticsList.fromJSON(object.execution_analytics_list)
          : undefined,
      rfqAnalyticsList: isSet(object.rfqAnalyticsList)
        ? RfqAnalyticsList.fromJSON(object.rfqAnalyticsList)
        : isSet(object.rfq_analytics_list)
          ? RfqAnalyticsList.fromJSON(object.rfq_analytics_list)
          : undefined,
      fedwatchProbabilities: isSet(object.fedwatchProbabilities)
        ? FedwatchProbabilityList.fromJSON(object.fedwatchProbabilities)
        : isSet(object.fedwatch_probabilities)
          ? FedwatchProbabilityList.fromJSON(object.fedwatch_probabilities)
          : undefined,
      etfFlowSeries: isSet(object.etfFlowSeries)
        ? EtfFlowSeries.fromJSON(object.etfFlowSeries)
        : isSet(object.etf_flow_series)
          ? EtfFlowSeries.fromJSON(object.etf_flow_series)
          : undefined,
      coinmarketcalEvent: isSet(object.coinmarketcalEvent)
        ? CoinMarketCalEvent.fromJSON(object.coinmarketcalEvent)
        : isSet(object.coinmarketcal_event)
          ? CoinMarketCalEvent.fromJSON(object.coinmarketcal_event)
          : undefined,
      coinmarketcalEventList: isSet(object.coinmarketcalEventList)
        ? CoinMarketCalEventList.fromJSON(object.coinmarketcalEventList)
        : isSet(object.coinmarketcal_event_list)
          ? CoinMarketCalEventList.fromJSON(object.coinmarketcal_event_list)
          : undefined,
      optionsStrikeFlow: isSet(object.optionsStrikeFlow)
        ? OptionsStrikeFlow.fromJSON(object.optionsStrikeFlow)
        : isSet(object.options_strike_flow)
          ? OptionsStrikeFlow.fromJSON(object.options_strike_flow)
          : undefined,
      gexAggregate: isSet(object.gexAggregate)
        ? GexAggregate.fromJSON(object.gexAggregate)
        : isSet(object.gex_aggregate)
          ? GexAggregate.fromJSON(object.gex_aggregate)
          : undefined,
      economicInflation: isSet(object.economicInflation)
        ? EconomicInflationList.fromJSON(object.economicInflation)
        : isSet(object.economic_inflation)
          ? EconomicInflationList.fromJSON(object.economic_inflation)
          : undefined,
      economicInflationExpectations: isSet(object.economicInflationExpectations)
        ? EconomicInflationExpectationsList.fromJSON(object.economicInflationExpectations)
        : isSet(object.economic_inflation_expectations)
          ? EconomicInflationExpectationsList.fromJSON(object.economic_inflation_expectations)
          : undefined,
      economicLaborMarket: isSet(object.economicLaborMarket)
        ? EconomicLaborMarketList.fromJSON(object.economicLaborMarket)
        : isSet(object.economic_labor_market)
          ? EconomicLaborMarketList.fromJSON(object.economic_labor_market)
          : undefined,
      economicTreasuryYields: isSet(object.economicTreasuryYields)
        ? EconomicTreasuryYieldList.fromJSON(object.economicTreasuryYields)
        : isSet(object.economic_treasury_yields)
          ? EconomicTreasuryYieldList.fromJSON(object.economic_treasury_yields)
          : undefined,
      bucketedReturns: isSet(object.bucketedReturns)
        ? BucketedReturnList.fromJSON(object.bucketedReturns)
        : isSet(object.bucketed_returns)
          ? BucketedReturnList.fromJSON(object.bucketed_returns)
          : undefined,
      sessionCumulativeReturns: isSet(object.sessionCumulativeReturns)
        ? SessionCumulativeReturnList.fromJSON(object.sessionCumulativeReturns)
        : isSet(object.session_cumulative_returns)
          ? SessionCumulativeReturnList.fromJSON(object.session_cumulative_returns)
          : undefined,
      liquidationLevelProfile: isSet(object.liquidationLevelProfile)
        ? LiquidationLevelProfile.fromJSON(object.liquidationLevelProfile)
        : isSet(object.liquidation_level_profile)
          ? LiquidationLevelProfile.fromJSON(object.liquidation_level_profile)
          : undefined,
      stopLevelProfile: isSet(object.stopLevelProfile)
        ? StopLevelProfile.fromJSON(object.stopLevelProfile)
        : isSet(object.stop_level_profile)
          ? StopLevelProfile.fromJSON(object.stop_level_profile)
          : undefined,
      tokenUnlockEvent: isSet(object.tokenUnlockEvent)
        ? TokenUnlockEvent.fromJSON(object.tokenUnlockEvent)
        : isSet(object.token_unlock_event)
          ? TokenUnlockEvent.fromJSON(object.token_unlock_event)
          : undefined,
      tokenUnlockEventList: isSet(object.tokenUnlockEventList)
        ? TokenUnlockEventList.fromJSON(object.tokenUnlockEventList)
        : isSet(object.token_unlock_event_list)
          ? TokenUnlockEventList.fromJSON(object.token_unlock_event_list)
          : undefined,
      tokenEmissionSeries: isSet(object.tokenEmissionSeries)
        ? TokenEmissionSeries.fromJSON(object.tokenEmissionSeries)
        : isSet(object.token_emission_series)
          ? TokenEmissionSeries.fromJSON(object.token_emission_series)
          : undefined,
      svi: isSet(object.svi) ? SviList.fromJSON(object.svi) : undefined,
      optionsOiByStrike: isSet(object.optionsOiByStrike)
        ? OptionsOiByStrike.fromJSON(object.optionsOiByStrike)
        : isSet(object.options_oi_by_strike)
          ? OptionsOiByStrike.fromJSON(object.options_oi_by_strike)
          : undefined,
      treeNewsPost: isSet(object.treeNewsPost)
        ? TreeNewsPost.fromJSON(object.treeNewsPost)
        : isSet(object.tree_news_post)
          ? TreeNewsPost.fromJSON(object.tree_news_post)
          : undefined,
      treeNewsPostList: isSet(object.treeNewsPostList)
        ? TreeNewsPostList.fromJSON(object.treeNewsPostList)
        : isSet(object.tree_news_post_list)
          ? TreeNewsPostList.fromJSON(object.tree_news_post_list)
          : undefined,
      rvSeasonalityHour: isSet(object.rvSeasonalityHour)
        ? RvSeasonalityList.fromJSON(object.rvSeasonalityHour)
        : isSet(object.rv_seasonality_hour)
          ? RvSeasonalityList.fromJSON(object.rv_seasonality_hour)
          : undefined,
      surfaceCurrencies: isSet(object.surfaceCurrencies)
        ? SurfaceCurrencyList.fromJSON(object.surfaceCurrencies)
        : isSet(object.surface_currencies)
          ? SurfaceCurrencyList.fromJSON(object.surface_currencies)
          : undefined,
      marketScreenerFrame: isSet(object.marketScreenerFrame)
        ? MarketScreenerFrame.fromJSON(object.marketScreenerFrame)
        : isSet(object.market_screener_frame)
          ? MarketScreenerFrame.fromJSON(object.market_screener_frame)
          : undefined,
      volFitReferences: isSet(object.volFitReferences)
        ? VolFitReferenceList.fromJSON(object.volFitReferences)
        : isSet(object.vol_fit_references)
          ? VolFitReferenceList.fromJSON(object.vol_fit_references)
          : undefined,
      orderbookHeatmap: isSet(object.orderbookHeatmap)
        ? OrderbookHeatmap.fromJSON(object.orderbookHeatmap)
        : isSet(object.orderbook_heatmap)
          ? OrderbookHeatmap.fromJSON(object.orderbook_heatmap)
          : undefined,
      rfqMakerRfqs: isSet(object.rfqMakerRfqs)
        ? RfqMakerRfqList.fromJSON(object.rfqMakerRfqs)
        : isSet(object.rfq_maker_rfqs)
          ? RfqMakerRfqList.fromJSON(object.rfq_maker_rfqs)
          : undefined,
      rfqMakerQuotes: isSet(object.rfqMakerQuotes)
        ? RfqMakerQuoteList.fromJSON(object.rfqMakerQuotes)
        : isSet(object.rfq_maker_quotes)
          ? RfqMakerQuoteList.fromJSON(object.rfq_maker_quotes)
          : undefined,
      perpPositions: isSet(object.perpPositions)
        ? PerpPositionsSnapshot.fromJSON(object.perpPositions)
        : isSet(object.perp_positions)
          ? PerpPositionsSnapshot.fromJSON(object.perp_positions)
          : undefined,
      oiPressure: isSet(object.oiPressure)
        ? OpenInterestPressureList.fromJSON(object.oiPressure)
        : isSet(object.oi_pressure)
          ? OpenInterestPressureList.fromJSON(object.oi_pressure)
          : undefined,
    }
  },

  toJSON(message: DataPayload): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.trades !== undefined) {
      obj.trades = TradeList.toJSON(message.trades)
    }
    if (message.positions !== undefined) {
      obj.positions = PositionList.toJSON(message.positions)
    }
    if (message.instruments !== undefined) {
      obj.instruments = InstrumentList1.toJSON(message.instruments)
    }
    if (message.tickers !== undefined) {
      obj.tickers = TickerList.toJSON(message.tickers)
    }
    if (message.orderBooks !== undefined) {
      obj.orderBooks = OrderBookList.toJSON(message.orderBooks)
    }
    if (message.portfolioData !== undefined) {
      obj.portfolioData = PortfolioDataList.toJSON(message.portfolioData)
    }
    if (message.instrumentTrades !== undefined) {
      obj.instrumentTrades = InstrumentTradeList.toJSON(message.instrumentTrades)
    }
    if (message.unifiedOrders !== undefined) {
      obj.unifiedOrders = UnifiedOrderList.toJSON(message.unifiedOrders)
    }
    if (message.chartData !== undefined) {
      obj.chartData = ChartData.toJSON(message.chartData)
    }
    if (message.incrementalTickers !== undefined) {
      obj.incrementalTickers = IncrementalTickerList.toJSON(message.incrementalTickers)
    }
    if (message.notification !== undefined) {
      obj.notification = ServiceNotification.toJSON(message.notification)
    }
    if (message.portfolioLineChart !== undefined) {
      obj.portfolioLineChart = PortfolioLineChart.toJSON(message.portfolioLineChart)
    }
    if (message.volSurfaceGenerationResult !== undefined) {
      obj.volSurfaceGenerationResult = VolSurfaceGenerationResult.toJSON(
        message.volSurfaceGenerationResult
      )
    }
    if (message.riskSimulationResult !== undefined) {
      obj.riskSimulationResult = RiskSimulationResult.toJSON(message.riskSimulationResult)
    }
    if (message.economicCalendarEvent !== undefined) {
      obj.economicCalendarEvent = EconomicCalendarEvent.toJSON(message.economicCalendarEvent)
    }
    if (message.economicCalendarEventList !== undefined) {
      obj.economicCalendarEventList = EconomicCalendarEventList.toJSON(
        message.economicCalendarEventList
      )
    }
    if (message.instrumentStates !== undefined) {
      obj.instrumentStates = InstrumentStateList.toJSON(message.instrumentStates)
    }
    if (message.executionAnalytics !== undefined) {
      obj.executionAnalytics = ExecutionAnalytics.toJSON(message.executionAnalytics)
    }
    if (message.venues !== undefined) {
      obj.venues = VenueList.toJSON(message.venues)
    }
    if (message.exchanges !== undefined) {
      obj.exchanges = ExchangeList.toJSON(message.exchanges)
    }
    if (message.orders !== undefined) {
      obj.orders = OrderList.toJSON(message.orders)
    }
    if (message.algoStates !== undefined) {
      obj.algoStates = AlgoStateList.toJSON(message.algoStates)
    }
    if (message.volMetrics24h !== undefined) {
      obj.volMetrics24h = VolMetrics24hList.toJSON(message.volMetrics24h)
    }
    if (message.putCallRatio !== undefined) {
      obj.putCallRatio = PutCallRatioList.toJSON(message.putCallRatio)
    }
    if (message.deltaSurfaceConstant !== undefined) {
      obj.deltaSurfaceConstant = DeltaSurfaceConstantList.toJSON(message.deltaSurfaceConstant)
    }
    if (message.deltaSurfaceFloating !== undefined) {
      obj.deltaSurfaceFloating = DeltaSurfaceFloatingList.toJSON(message.deltaSurfaceFloating)
    }
    if (message.impliedVsRealized !== undefined) {
      obj.impliedVsRealized = ImpliedVsRealizedList.toJSON(message.impliedVsRealized)
    }
    if (message.termStructureConstant !== undefined) {
      obj.termStructureConstant = TermStructureConstantList.toJSON(message.termStructureConstant)
    }
    if (message.termStructureFloating !== undefined) {
      obj.termStructureFloating = TermStructureFloatingList.toJSON(message.termStructureFloating)
    }
    if (message.termStructureRichness !== undefined) {
      obj.termStructureRichness = TermStructureRichnessList.toJSON(message.termStructureRichness)
    }
    if (message.volatilityIndex !== undefined) {
      obj.volatilityIndex = VolatilityIndexList.toJSON(message.volatilityIndex)
    }
    if (message.dbNewsPost !== undefined) {
      obj.dbNewsPost = DbNewsPost.toJSON(message.dbNewsPost)
    }
    if (message.dbNewsPostList !== undefined) {
      obj.dbNewsPostList = DbNewsPostList.toJSON(message.dbNewsPostList)
    }
    if (message.triggerEvaluationSnapshot !== undefined) {
      obj.triggerEvaluationSnapshot = TriggerEvaluationSnapshot.toJSON(
        message.triggerEvaluationSnapshot
      )
    }
    if (message.dbNewsVocabulary !== undefined) {
      obj.dbNewsVocabulary = DbNewsVocabulary.toJSON(message.dbNewsVocabulary)
    }
    if (message.exchangeStatus !== undefined) {
      obj.exchangeStatus = ExchangeStatus.toJSON(message.exchangeStatus)
    }
    if (message.venueSchedules !== undefined) {
      obj.venueSchedules = VenueScheduleList.toJSON(message.venueSchedules)
    }
    if (message.rfqUpdates !== undefined) {
      obj.rfqUpdates = RfqUpdateList.toJSON(message.rfqUpdates)
    }
    if (message.rfqAnalytics !== undefined) {
      obj.rfqAnalytics = RfqAnalytics.toJSON(message.rfqAnalytics)
    }
    if (message.rfqAccept !== undefined) {
      obj.rfqAccept = RfqAccept.toJSON(message.rfqAccept)
    }
    if (message.skewConstant !== undefined) {
      obj.skewConstant = SkewConstantList.toJSON(message.skewConstant)
    }
    if (message.skewFloating !== undefined) {
      obj.skewFloating = SkewFloatingList.toJSON(message.skewFloating)
    }
    if (message.optionsVolumeLeaderboard !== undefined) {
      obj.optionsVolumeLeaderboard = OptionsVolumeLeaderboard.toJSON(
        message.optionsVolumeLeaderboard
      )
    }
    if (message.optionsVolumeSeries !== undefined) {
      obj.optionsVolumeSeries = OptionsVolumeSeries.toJSON(message.optionsVolumeSeries)
    }
    if (message.optionsVolumeStreamUpdate !== undefined) {
      obj.optionsVolumeStreamUpdate = OptionsVolumeStreamUpdate.toJSON(
        message.optionsVolumeStreamUpdate
      )
    }
    if (message.optionsOiSeries !== undefined) {
      obj.optionsOiSeries = OptionsOiSeries.toJSON(message.optionsOiSeries)
    }
    if (message.optionsOiLeaderboard !== undefined) {
      obj.optionsOiLeaderboard = OptionsOiLeaderboard.toJSON(message.optionsOiLeaderboard)
    }
    if (message.fundingSeries !== undefined) {
      obj.fundingSeries = FundingSeries.toJSON(message.fundingSeries)
    }
    if (message.fundingLeaderboard !== undefined) {
      obj.fundingLeaderboard = FundingLeaderboard.toJSON(message.fundingLeaderboard)
    }
    if (message.accountFees !== undefined) {
      obj.accountFees = AccountFeesList.toJSON(message.accountFees)
    }
    if (message.accountSummary !== undefined) {
      obj.accountSummary = AccountSummaryList.toJSON(message.accountSummary)
    }
    if (message.transfers !== undefined) {
      obj.transfers = TransferList.toJSON(message.transfers)
    }
    if (message.polymarketSignal !== undefined) {
      obj.polymarketSignal = PolymarketSignal.toJSON(message.polymarketSignal)
    }
    if (message.orderbookMetricsSeries !== undefined) {
      obj.orderbookMetricsSeries = OrderbookMetricsSeries.toJSON(message.orderbookMetricsSeries)
    }
    if (message.impliedMove !== undefined) {
      obj.impliedMove = ImpliedMove.toJSON(message.impliedMove)
    }
    if (message.ivPercentile !== undefined) {
      obj.ivPercentile = IvPercentile.toJSON(message.ivPercentile)
    }
    if (message.maxPain !== undefined) {
      obj.maxPain = MaxPain.toJSON(message.maxPain)
    }
    if (message.usdGamma !== undefined) {
      obj.usdGamma = UsdGammaList.toJSON(message.usdGamma)
    }
    if (message.gex !== undefined) {
      obj.gex = GexList.toJSON(message.gex)
    }
    if (message.volCones !== undefined) {
      obj.volCones = VolConeList.toJSON(message.volCones)
    }
    if (message.rvSeasonalityDow !== undefined) {
      obj.rvSeasonalityDow = RvSeasonalityList.toJSON(message.rvSeasonalityDow)
    }
    if (message.rvSeasonalityMoy !== undefined) {
      obj.rvSeasonalityMoy = RvSeasonalityList.toJSON(message.rvSeasonalityMoy)
    }
    if (message.greeksByExpiry !== undefined) {
      obj.greeksByExpiry = GreeksByExpiry.toJSON(message.greeksByExpiry)
    }
    if (message.venueHealth !== undefined) {
      obj.venueHealth = VenueHealth.toJSON(message.venueHealth)
    }
    if (message.alpacaNewsPost !== undefined) {
      obj.alpacaNewsPost = AlpacaNewsPost.toJSON(message.alpacaNewsPost)
    }
    if (message.alpacaNewsPostList !== undefined) {
      obj.alpacaNewsPostList = AlpacaNewsPostList.toJSON(message.alpacaNewsPostList)
    }
    if (message.visibleRangeProfile !== undefined) {
      obj.visibleRangeProfile = VisibleRangeProfile.toJSON(message.visibleRangeProfile)
    }
    if (message.twitterPost !== undefined) {
      obj.twitterPost = TwitterPost.toJSON(message.twitterPost)
    }
    if (message.twitterPostList !== undefined) {
      obj.twitterPostList = TwitterPostList.toJSON(message.twitterPostList)
    }
    if (message.portfolioLineChartList !== undefined) {
      obj.portfolioLineChartList = PortfolioLineChartList.toJSON(message.portfolioLineChartList)
    }
    if (message.executionAnalyticsList !== undefined) {
      obj.executionAnalyticsList = ExecutionAnalyticsList.toJSON(message.executionAnalyticsList)
    }
    if (message.rfqAnalyticsList !== undefined) {
      obj.rfqAnalyticsList = RfqAnalyticsList.toJSON(message.rfqAnalyticsList)
    }
    if (message.fedwatchProbabilities !== undefined) {
      obj.fedwatchProbabilities = FedwatchProbabilityList.toJSON(message.fedwatchProbabilities)
    }
    if (message.etfFlowSeries !== undefined) {
      obj.etfFlowSeries = EtfFlowSeries.toJSON(message.etfFlowSeries)
    }
    if (message.coinmarketcalEvent !== undefined) {
      obj.coinmarketcalEvent = CoinMarketCalEvent.toJSON(message.coinmarketcalEvent)
    }
    if (message.coinmarketcalEventList !== undefined) {
      obj.coinmarketcalEventList = CoinMarketCalEventList.toJSON(message.coinmarketcalEventList)
    }
    if (message.optionsStrikeFlow !== undefined) {
      obj.optionsStrikeFlow = OptionsStrikeFlow.toJSON(message.optionsStrikeFlow)
    }
    if (message.gexAggregate !== undefined) {
      obj.gexAggregate = GexAggregate.toJSON(message.gexAggregate)
    }
    if (message.economicInflation !== undefined) {
      obj.economicInflation = EconomicInflationList.toJSON(message.economicInflation)
    }
    if (message.economicInflationExpectations !== undefined) {
      obj.economicInflationExpectations = EconomicInflationExpectationsList.toJSON(
        message.economicInflationExpectations
      )
    }
    if (message.economicLaborMarket !== undefined) {
      obj.economicLaborMarket = EconomicLaborMarketList.toJSON(message.economicLaborMarket)
    }
    if (message.economicTreasuryYields !== undefined) {
      obj.economicTreasuryYields = EconomicTreasuryYieldList.toJSON(message.economicTreasuryYields)
    }
    if (message.bucketedReturns !== undefined) {
      obj.bucketedReturns = BucketedReturnList.toJSON(message.bucketedReturns)
    }
    if (message.sessionCumulativeReturns !== undefined) {
      obj.sessionCumulativeReturns = SessionCumulativeReturnList.toJSON(
        message.sessionCumulativeReturns
      )
    }
    if (message.liquidationLevelProfile !== undefined) {
      obj.liquidationLevelProfile = LiquidationLevelProfile.toJSON(message.liquidationLevelProfile)
    }
    if (message.stopLevelProfile !== undefined) {
      obj.stopLevelProfile = StopLevelProfile.toJSON(message.stopLevelProfile)
    }
    if (message.tokenUnlockEvent !== undefined) {
      obj.tokenUnlockEvent = TokenUnlockEvent.toJSON(message.tokenUnlockEvent)
    }
    if (message.tokenUnlockEventList !== undefined) {
      obj.tokenUnlockEventList = TokenUnlockEventList.toJSON(message.tokenUnlockEventList)
    }
    if (message.tokenEmissionSeries !== undefined) {
      obj.tokenEmissionSeries = TokenEmissionSeries.toJSON(message.tokenEmissionSeries)
    }
    if (message.svi !== undefined) {
      obj.svi = SviList.toJSON(message.svi)
    }
    if (message.optionsOiByStrike !== undefined) {
      obj.optionsOiByStrike = OptionsOiByStrike.toJSON(message.optionsOiByStrike)
    }
    if (message.treeNewsPost !== undefined) {
      obj.treeNewsPost = TreeNewsPost.toJSON(message.treeNewsPost)
    }
    if (message.treeNewsPostList !== undefined) {
      obj.treeNewsPostList = TreeNewsPostList.toJSON(message.treeNewsPostList)
    }
    if (message.rvSeasonalityHour !== undefined) {
      obj.rvSeasonalityHour = RvSeasonalityList.toJSON(message.rvSeasonalityHour)
    }
    if (message.surfaceCurrencies !== undefined) {
      obj.surfaceCurrencies = SurfaceCurrencyList.toJSON(message.surfaceCurrencies)
    }
    if (message.marketScreenerFrame !== undefined) {
      obj.marketScreenerFrame = MarketScreenerFrame.toJSON(message.marketScreenerFrame)
    }
    if (message.volFitReferences !== undefined) {
      obj.volFitReferences = VolFitReferenceList.toJSON(message.volFitReferences)
    }
    if (message.orderbookHeatmap !== undefined) {
      obj.orderbookHeatmap = OrderbookHeatmap.toJSON(message.orderbookHeatmap)
    }
    if (message.rfqMakerRfqs !== undefined) {
      obj.rfqMakerRfqs = RfqMakerRfqList.toJSON(message.rfqMakerRfqs)
    }
    if (message.rfqMakerQuotes !== undefined) {
      obj.rfqMakerQuotes = RfqMakerQuoteList.toJSON(message.rfqMakerQuotes)
    }
    if (message.perpPositions !== undefined) {
      obj.perpPositions = PerpPositionsSnapshot.toJSON(message.perpPositions)
    }
    if (message.oiPressure !== undefined) {
      obj.oiPressure = OpenInterestPressureList.toJSON(message.oiPressure)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DataPayload>, I>>(base?: I): DataPayload {
    return DataPayload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DataPayload>, I>>(object: I): DataPayload {
    const message = createBaseDataPayload()
    message.accountId = object.accountId ?? ''
    message.trades =
      object.trades !== undefined && object.trades !== null
        ? TradeList.fromPartial(object.trades)
        : undefined
    message.positions =
      object.positions !== undefined && object.positions !== null
        ? PositionList.fromPartial(object.positions)
        : undefined
    message.instruments =
      object.instruments !== undefined && object.instruments !== null
        ? InstrumentList1.fromPartial(object.instruments)
        : undefined
    message.tickers =
      object.tickers !== undefined && object.tickers !== null
        ? TickerList.fromPartial(object.tickers)
        : undefined
    message.orderBooks =
      object.orderBooks !== undefined && object.orderBooks !== null
        ? OrderBookList.fromPartial(object.orderBooks)
        : undefined
    message.portfolioData =
      object.portfolioData !== undefined && object.portfolioData !== null
        ? PortfolioDataList.fromPartial(object.portfolioData)
        : undefined
    message.instrumentTrades =
      object.instrumentTrades !== undefined && object.instrumentTrades !== null
        ? InstrumentTradeList.fromPartial(object.instrumentTrades)
        : undefined
    message.unifiedOrders =
      object.unifiedOrders !== undefined && object.unifiedOrders !== null
        ? UnifiedOrderList.fromPartial(object.unifiedOrders)
        : undefined
    message.chartData =
      object.chartData !== undefined && object.chartData !== null
        ? ChartData.fromPartial(object.chartData)
        : undefined
    message.incrementalTickers =
      object.incrementalTickers !== undefined && object.incrementalTickers !== null
        ? IncrementalTickerList.fromPartial(object.incrementalTickers)
        : undefined
    message.notification =
      object.notification !== undefined && object.notification !== null
        ? ServiceNotification.fromPartial(object.notification)
        : undefined
    message.portfolioLineChart =
      object.portfolioLineChart !== undefined && object.portfolioLineChart !== null
        ? PortfolioLineChart.fromPartial(object.portfolioLineChart)
        : undefined
    message.volSurfaceGenerationResult =
      object.volSurfaceGenerationResult !== undefined && object.volSurfaceGenerationResult !== null
        ? VolSurfaceGenerationResult.fromPartial(object.volSurfaceGenerationResult)
        : undefined
    message.riskSimulationResult =
      object.riskSimulationResult !== undefined && object.riskSimulationResult !== null
        ? RiskSimulationResult.fromPartial(object.riskSimulationResult)
        : undefined
    message.economicCalendarEvent =
      object.economicCalendarEvent !== undefined && object.economicCalendarEvent !== null
        ? EconomicCalendarEvent.fromPartial(object.economicCalendarEvent)
        : undefined
    message.economicCalendarEventList =
      object.economicCalendarEventList !== undefined && object.economicCalendarEventList !== null
        ? EconomicCalendarEventList.fromPartial(object.economicCalendarEventList)
        : undefined
    message.instrumentStates =
      object.instrumentStates !== undefined && object.instrumentStates !== null
        ? InstrumentStateList.fromPartial(object.instrumentStates)
        : undefined
    message.executionAnalytics =
      object.executionAnalytics !== undefined && object.executionAnalytics !== null
        ? ExecutionAnalytics.fromPartial(object.executionAnalytics)
        : undefined
    message.venues =
      object.venues !== undefined && object.venues !== null
        ? VenueList.fromPartial(object.venues)
        : undefined
    message.exchanges =
      object.exchanges !== undefined && object.exchanges !== null
        ? ExchangeList.fromPartial(object.exchanges)
        : undefined
    message.orders =
      object.orders !== undefined && object.orders !== null
        ? OrderList.fromPartial(object.orders)
        : undefined
    message.algoStates =
      object.algoStates !== undefined && object.algoStates !== null
        ? AlgoStateList.fromPartial(object.algoStates)
        : undefined
    message.volMetrics24h =
      object.volMetrics24h !== undefined && object.volMetrics24h !== null
        ? VolMetrics24hList.fromPartial(object.volMetrics24h)
        : undefined
    message.putCallRatio =
      object.putCallRatio !== undefined && object.putCallRatio !== null
        ? PutCallRatioList.fromPartial(object.putCallRatio)
        : undefined
    message.deltaSurfaceConstant =
      object.deltaSurfaceConstant !== undefined && object.deltaSurfaceConstant !== null
        ? DeltaSurfaceConstantList.fromPartial(object.deltaSurfaceConstant)
        : undefined
    message.deltaSurfaceFloating =
      object.deltaSurfaceFloating !== undefined && object.deltaSurfaceFloating !== null
        ? DeltaSurfaceFloatingList.fromPartial(object.deltaSurfaceFloating)
        : undefined
    message.impliedVsRealized =
      object.impliedVsRealized !== undefined && object.impliedVsRealized !== null
        ? ImpliedVsRealizedList.fromPartial(object.impliedVsRealized)
        : undefined
    message.termStructureConstant =
      object.termStructureConstant !== undefined && object.termStructureConstant !== null
        ? TermStructureConstantList.fromPartial(object.termStructureConstant)
        : undefined
    message.termStructureFloating =
      object.termStructureFloating !== undefined && object.termStructureFloating !== null
        ? TermStructureFloatingList.fromPartial(object.termStructureFloating)
        : undefined
    message.termStructureRichness =
      object.termStructureRichness !== undefined && object.termStructureRichness !== null
        ? TermStructureRichnessList.fromPartial(object.termStructureRichness)
        : undefined
    message.volatilityIndex =
      object.volatilityIndex !== undefined && object.volatilityIndex !== null
        ? VolatilityIndexList.fromPartial(object.volatilityIndex)
        : undefined
    message.dbNewsPost =
      object.dbNewsPost !== undefined && object.dbNewsPost !== null
        ? DbNewsPost.fromPartial(object.dbNewsPost)
        : undefined
    message.dbNewsPostList =
      object.dbNewsPostList !== undefined && object.dbNewsPostList !== null
        ? DbNewsPostList.fromPartial(object.dbNewsPostList)
        : undefined
    message.triggerEvaluationSnapshot =
      object.triggerEvaluationSnapshot !== undefined && object.triggerEvaluationSnapshot !== null
        ? TriggerEvaluationSnapshot.fromPartial(object.triggerEvaluationSnapshot)
        : undefined
    message.dbNewsVocabulary =
      object.dbNewsVocabulary !== undefined && object.dbNewsVocabulary !== null
        ? DbNewsVocabulary.fromPartial(object.dbNewsVocabulary)
        : undefined
    message.exchangeStatus =
      object.exchangeStatus !== undefined && object.exchangeStatus !== null
        ? ExchangeStatus.fromPartial(object.exchangeStatus)
        : undefined
    message.venueSchedules =
      object.venueSchedules !== undefined && object.venueSchedules !== null
        ? VenueScheduleList.fromPartial(object.venueSchedules)
        : undefined
    message.rfqUpdates =
      object.rfqUpdates !== undefined && object.rfqUpdates !== null
        ? RfqUpdateList.fromPartial(object.rfqUpdates)
        : undefined
    message.rfqAnalytics =
      object.rfqAnalytics !== undefined && object.rfqAnalytics !== null
        ? RfqAnalytics.fromPartial(object.rfqAnalytics)
        : undefined
    message.rfqAccept =
      object.rfqAccept !== undefined && object.rfqAccept !== null
        ? RfqAccept.fromPartial(object.rfqAccept)
        : undefined
    message.skewConstant =
      object.skewConstant !== undefined && object.skewConstant !== null
        ? SkewConstantList.fromPartial(object.skewConstant)
        : undefined
    message.skewFloating =
      object.skewFloating !== undefined && object.skewFloating !== null
        ? SkewFloatingList.fromPartial(object.skewFloating)
        : undefined
    message.optionsVolumeLeaderboard =
      object.optionsVolumeLeaderboard !== undefined && object.optionsVolumeLeaderboard !== null
        ? OptionsVolumeLeaderboard.fromPartial(object.optionsVolumeLeaderboard)
        : undefined
    message.optionsVolumeSeries =
      object.optionsVolumeSeries !== undefined && object.optionsVolumeSeries !== null
        ? OptionsVolumeSeries.fromPartial(object.optionsVolumeSeries)
        : undefined
    message.optionsVolumeStreamUpdate =
      object.optionsVolumeStreamUpdate !== undefined && object.optionsVolumeStreamUpdate !== null
        ? OptionsVolumeStreamUpdate.fromPartial(object.optionsVolumeStreamUpdate)
        : undefined
    message.optionsOiSeries =
      object.optionsOiSeries !== undefined && object.optionsOiSeries !== null
        ? OptionsOiSeries.fromPartial(object.optionsOiSeries)
        : undefined
    message.optionsOiLeaderboard =
      object.optionsOiLeaderboard !== undefined && object.optionsOiLeaderboard !== null
        ? OptionsOiLeaderboard.fromPartial(object.optionsOiLeaderboard)
        : undefined
    message.fundingSeries =
      object.fundingSeries !== undefined && object.fundingSeries !== null
        ? FundingSeries.fromPartial(object.fundingSeries)
        : undefined
    message.fundingLeaderboard =
      object.fundingLeaderboard !== undefined && object.fundingLeaderboard !== null
        ? FundingLeaderboard.fromPartial(object.fundingLeaderboard)
        : undefined
    message.accountFees =
      object.accountFees !== undefined && object.accountFees !== null
        ? AccountFeesList.fromPartial(object.accountFees)
        : undefined
    message.accountSummary =
      object.accountSummary !== undefined && object.accountSummary !== null
        ? AccountSummaryList.fromPartial(object.accountSummary)
        : undefined
    message.transfers =
      object.transfers !== undefined && object.transfers !== null
        ? TransferList.fromPartial(object.transfers)
        : undefined
    message.polymarketSignal =
      object.polymarketSignal !== undefined && object.polymarketSignal !== null
        ? PolymarketSignal.fromPartial(object.polymarketSignal)
        : undefined
    message.orderbookMetricsSeries =
      object.orderbookMetricsSeries !== undefined && object.orderbookMetricsSeries !== null
        ? OrderbookMetricsSeries.fromPartial(object.orderbookMetricsSeries)
        : undefined
    message.impliedMove =
      object.impliedMove !== undefined && object.impliedMove !== null
        ? ImpliedMove.fromPartial(object.impliedMove)
        : undefined
    message.ivPercentile =
      object.ivPercentile !== undefined && object.ivPercentile !== null
        ? IvPercentile.fromPartial(object.ivPercentile)
        : undefined
    message.maxPain =
      object.maxPain !== undefined && object.maxPain !== null
        ? MaxPain.fromPartial(object.maxPain)
        : undefined
    message.usdGamma =
      object.usdGamma !== undefined && object.usdGamma !== null
        ? UsdGammaList.fromPartial(object.usdGamma)
        : undefined
    message.gex =
      object.gex !== undefined && object.gex !== null ? GexList.fromPartial(object.gex) : undefined
    message.volCones =
      object.volCones !== undefined && object.volCones !== null
        ? VolConeList.fromPartial(object.volCones)
        : undefined
    message.rvSeasonalityDow =
      object.rvSeasonalityDow !== undefined && object.rvSeasonalityDow !== null
        ? RvSeasonalityList.fromPartial(object.rvSeasonalityDow)
        : undefined
    message.rvSeasonalityMoy =
      object.rvSeasonalityMoy !== undefined && object.rvSeasonalityMoy !== null
        ? RvSeasonalityList.fromPartial(object.rvSeasonalityMoy)
        : undefined
    message.greeksByExpiry =
      object.greeksByExpiry !== undefined && object.greeksByExpiry !== null
        ? GreeksByExpiry.fromPartial(object.greeksByExpiry)
        : undefined
    message.venueHealth =
      object.venueHealth !== undefined && object.venueHealth !== null
        ? VenueHealth.fromPartial(object.venueHealth)
        : undefined
    message.alpacaNewsPost =
      object.alpacaNewsPost !== undefined && object.alpacaNewsPost !== null
        ? AlpacaNewsPost.fromPartial(object.alpacaNewsPost)
        : undefined
    message.alpacaNewsPostList =
      object.alpacaNewsPostList !== undefined && object.alpacaNewsPostList !== null
        ? AlpacaNewsPostList.fromPartial(object.alpacaNewsPostList)
        : undefined
    message.visibleRangeProfile =
      object.visibleRangeProfile !== undefined && object.visibleRangeProfile !== null
        ? VisibleRangeProfile.fromPartial(object.visibleRangeProfile)
        : undefined
    message.twitterPost =
      object.twitterPost !== undefined && object.twitterPost !== null
        ? TwitterPost.fromPartial(object.twitterPost)
        : undefined
    message.twitterPostList =
      object.twitterPostList !== undefined && object.twitterPostList !== null
        ? TwitterPostList.fromPartial(object.twitterPostList)
        : undefined
    message.portfolioLineChartList =
      object.portfolioLineChartList !== undefined && object.portfolioLineChartList !== null
        ? PortfolioLineChartList.fromPartial(object.portfolioLineChartList)
        : undefined
    message.executionAnalyticsList =
      object.executionAnalyticsList !== undefined && object.executionAnalyticsList !== null
        ? ExecutionAnalyticsList.fromPartial(object.executionAnalyticsList)
        : undefined
    message.rfqAnalyticsList =
      object.rfqAnalyticsList !== undefined && object.rfqAnalyticsList !== null
        ? RfqAnalyticsList.fromPartial(object.rfqAnalyticsList)
        : undefined
    message.fedwatchProbabilities =
      object.fedwatchProbabilities !== undefined && object.fedwatchProbabilities !== null
        ? FedwatchProbabilityList.fromPartial(object.fedwatchProbabilities)
        : undefined
    message.etfFlowSeries =
      object.etfFlowSeries !== undefined && object.etfFlowSeries !== null
        ? EtfFlowSeries.fromPartial(object.etfFlowSeries)
        : undefined
    message.coinmarketcalEvent =
      object.coinmarketcalEvent !== undefined && object.coinmarketcalEvent !== null
        ? CoinMarketCalEvent.fromPartial(object.coinmarketcalEvent)
        : undefined
    message.coinmarketcalEventList =
      object.coinmarketcalEventList !== undefined && object.coinmarketcalEventList !== null
        ? CoinMarketCalEventList.fromPartial(object.coinmarketcalEventList)
        : undefined
    message.optionsStrikeFlow =
      object.optionsStrikeFlow !== undefined && object.optionsStrikeFlow !== null
        ? OptionsStrikeFlow.fromPartial(object.optionsStrikeFlow)
        : undefined
    message.gexAggregate =
      object.gexAggregate !== undefined && object.gexAggregate !== null
        ? GexAggregate.fromPartial(object.gexAggregate)
        : undefined
    message.economicInflation =
      object.economicInflation !== undefined && object.economicInflation !== null
        ? EconomicInflationList.fromPartial(object.economicInflation)
        : undefined
    message.economicInflationExpectations =
      object.economicInflationExpectations !== undefined &&
      object.economicInflationExpectations !== null
        ? EconomicInflationExpectationsList.fromPartial(object.economicInflationExpectations)
        : undefined
    message.economicLaborMarket =
      object.economicLaborMarket !== undefined && object.economicLaborMarket !== null
        ? EconomicLaborMarketList.fromPartial(object.economicLaborMarket)
        : undefined
    message.economicTreasuryYields =
      object.economicTreasuryYields !== undefined && object.economicTreasuryYields !== null
        ? EconomicTreasuryYieldList.fromPartial(object.economicTreasuryYields)
        : undefined
    message.bucketedReturns =
      object.bucketedReturns !== undefined && object.bucketedReturns !== null
        ? BucketedReturnList.fromPartial(object.bucketedReturns)
        : undefined
    message.sessionCumulativeReturns =
      object.sessionCumulativeReturns !== undefined && object.sessionCumulativeReturns !== null
        ? SessionCumulativeReturnList.fromPartial(object.sessionCumulativeReturns)
        : undefined
    message.liquidationLevelProfile =
      object.liquidationLevelProfile !== undefined && object.liquidationLevelProfile !== null
        ? LiquidationLevelProfile.fromPartial(object.liquidationLevelProfile)
        : undefined
    message.stopLevelProfile =
      object.stopLevelProfile !== undefined && object.stopLevelProfile !== null
        ? StopLevelProfile.fromPartial(object.stopLevelProfile)
        : undefined
    message.tokenUnlockEvent =
      object.tokenUnlockEvent !== undefined && object.tokenUnlockEvent !== null
        ? TokenUnlockEvent.fromPartial(object.tokenUnlockEvent)
        : undefined
    message.tokenUnlockEventList =
      object.tokenUnlockEventList !== undefined && object.tokenUnlockEventList !== null
        ? TokenUnlockEventList.fromPartial(object.tokenUnlockEventList)
        : undefined
    message.tokenEmissionSeries =
      object.tokenEmissionSeries !== undefined && object.tokenEmissionSeries !== null
        ? TokenEmissionSeries.fromPartial(object.tokenEmissionSeries)
        : undefined
    message.svi =
      object.svi !== undefined && object.svi !== null ? SviList.fromPartial(object.svi) : undefined
    message.optionsOiByStrike =
      object.optionsOiByStrike !== undefined && object.optionsOiByStrike !== null
        ? OptionsOiByStrike.fromPartial(object.optionsOiByStrike)
        : undefined
    message.treeNewsPost =
      object.treeNewsPost !== undefined && object.treeNewsPost !== null
        ? TreeNewsPost.fromPartial(object.treeNewsPost)
        : undefined
    message.treeNewsPostList =
      object.treeNewsPostList !== undefined && object.treeNewsPostList !== null
        ? TreeNewsPostList.fromPartial(object.treeNewsPostList)
        : undefined
    message.rvSeasonalityHour =
      object.rvSeasonalityHour !== undefined && object.rvSeasonalityHour !== null
        ? RvSeasonalityList.fromPartial(object.rvSeasonalityHour)
        : undefined
    message.surfaceCurrencies =
      object.surfaceCurrencies !== undefined && object.surfaceCurrencies !== null
        ? SurfaceCurrencyList.fromPartial(object.surfaceCurrencies)
        : undefined
    message.marketScreenerFrame =
      object.marketScreenerFrame !== undefined && object.marketScreenerFrame !== null
        ? MarketScreenerFrame.fromPartial(object.marketScreenerFrame)
        : undefined
    message.volFitReferences =
      object.volFitReferences !== undefined && object.volFitReferences !== null
        ? VolFitReferenceList.fromPartial(object.volFitReferences)
        : undefined
    message.orderbookHeatmap =
      object.orderbookHeatmap !== undefined && object.orderbookHeatmap !== null
        ? OrderbookHeatmap.fromPartial(object.orderbookHeatmap)
        : undefined
    message.rfqMakerRfqs =
      object.rfqMakerRfqs !== undefined && object.rfqMakerRfqs !== null
        ? RfqMakerRfqList.fromPartial(object.rfqMakerRfqs)
        : undefined
    message.rfqMakerQuotes =
      object.rfqMakerQuotes !== undefined && object.rfqMakerQuotes !== null
        ? RfqMakerQuoteList.fromPartial(object.rfqMakerQuotes)
        : undefined
    message.perpPositions =
      object.perpPositions !== undefined && object.perpPositions !== null
        ? PerpPositionsSnapshot.fromPartial(object.perpPositions)
        : undefined
    message.oiPressure =
      object.oiPressure !== undefined && object.oiPressure !== null
        ? OpenInterestPressureList.fromPartial(object.oiPressure)
        : undefined
    return message
  },
}

function createBaseVenueCapabilities(): VenueCapabilities {
  return {
    orderTypes: [],
    timeInForce: [],
    postOnly: false,
    reduceOnly: false,
    amend: false,
    venueTriggers: false,
    partialClose: false,
    supportedAlgos: [],
    rfq: false,
  }
}

export const VenueCapabilities: MessageFns<VenueCapabilities> = {
  encode(message: VenueCapabilities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.orderTypes) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(18).fork()
    for (const v of message.timeInForce) {
      writer.int32(v)
    }
    writer.join()
    if (message.postOnly !== false) {
      writer.uint32(24).bool(message.postOnly)
    }
    if (message.reduceOnly !== false) {
      writer.uint32(32).bool(message.reduceOnly)
    }
    if (message.amend !== false) {
      writer.uint32(40).bool(message.amend)
    }
    if (message.venueTriggers !== false) {
      writer.uint32(48).bool(message.venueTriggers)
    }
    if (message.partialClose !== false) {
      writer.uint32(56).bool(message.partialClose)
    }
    writer.uint32(66).fork()
    for (const v of message.supportedAlgos) {
      writer.int32(v)
    }
    writer.join()
    if (message.rfq !== false) {
      writer.uint32(72).bool(message.rfq)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueCapabilities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueCapabilities()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.orderTypes.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.orderTypes.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 2: {
          if (tag === 16) {
            message.timeInForce.push(reader.int32() as any)

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.timeInForce.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.amend = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.venueTriggers = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.partialClose = reader.bool()
          continue
        }
        case 8: {
          if (tag === 64) {
            message.supportedAlgos.push(reader.int32() as any)

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.supportedAlgos.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.rfq = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueCapabilities {
    return {
      orderTypes: globalThis.Array.isArray(object?.orderTypes)
        ? object.orderTypes.map((e: any) => orderTypeFromJSON(e))
        : globalThis.Array.isArray(object?.order_types)
          ? object.order_types.map((e: any) => orderTypeFromJSON(e))
          : [],
      timeInForce: globalThis.Array.isArray(object?.timeInForce)
        ? object.timeInForce.map((e: any) => timeInForceFromJSON(e))
        : globalThis.Array.isArray(object?.time_in_force)
          ? object.time_in_force.map((e: any) => timeInForceFromJSON(e))
          : [],
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : false,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : false,
      amend: isSet(object.amend) ? globalThis.Boolean(object.amend) : false,
      venueTriggers: isSet(object.venueTriggers)
        ? globalThis.Boolean(object.venueTriggers)
        : isSet(object.venue_triggers)
          ? globalThis.Boolean(object.venue_triggers)
          : false,
      partialClose: isSet(object.partialClose)
        ? globalThis.Boolean(object.partialClose)
        : isSet(object.partial_close)
          ? globalThis.Boolean(object.partial_close)
          : false,
      supportedAlgos: globalThis.Array.isArray(object?.supportedAlgos)
        ? object.supportedAlgos.map((e: any) => algoTypeFromJSON(e))
        : globalThis.Array.isArray(object?.supported_algos)
          ? object.supported_algos.map((e: any) => algoTypeFromJSON(e))
          : [],
      rfq: isSet(object.rfq) ? globalThis.Boolean(object.rfq) : false,
    }
  },

  toJSON(message: VenueCapabilities): unknown {
    const obj: any = {}
    if (message.orderTypes?.length) {
      obj.orderTypes = message.orderTypes.map((e) => orderTypeToJSON(e))
    }
    if (message.timeInForce?.length) {
      obj.timeInForce = message.timeInForce.map((e) => timeInForceToJSON(e))
    }
    if (message.postOnly !== false) {
      obj.postOnly = message.postOnly
    }
    if (message.reduceOnly !== false) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.amend !== false) {
      obj.amend = message.amend
    }
    if (message.venueTriggers !== false) {
      obj.venueTriggers = message.venueTriggers
    }
    if (message.partialClose !== false) {
      obj.partialClose = message.partialClose
    }
    if (message.supportedAlgos?.length) {
      obj.supportedAlgos = message.supportedAlgos.map((e) => algoTypeToJSON(e))
    }
    if (message.rfq !== false) {
      obj.rfq = message.rfq
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueCapabilities>, I>>(base?: I): VenueCapabilities {
    return VenueCapabilities.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueCapabilities>, I>>(object: I): VenueCapabilities {
    const message = createBaseVenueCapabilities()
    message.orderTypes = object.orderTypes?.map((e) => e) || []
    message.timeInForce = object.timeInForce?.map((e) => e) || []
    message.postOnly = object.postOnly ?? false
    message.reduceOnly = object.reduceOnly ?? false
    message.amend = object.amend ?? false
    message.venueTriggers = object.venueTriggers ?? false
    message.partialClose = object.partialClose ?? false
    message.supportedAlgos = object.supportedAlgos?.map((e) => e) || []
    message.rfq = object.rfq ?? false
    return message
  },
}

function createBaseVenueInfo(): VenueInfo {
  return {
    tradeVenue: 0,
    enabled: false,
    newAccount: false,
    oauth: undefined,
    apiKeyGuide: undefined,
    capabilities: undefined,
  }
}

export const VenueInfo: MessageFns<VenueInfo> = {
  encode(message: VenueInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tradeVenue !== 0) {
      writer.uint32(8).int32(message.tradeVenue)
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled)
    }
    if (message.newAccount !== false) {
      writer.uint32(24).bool(message.newAccount)
    }
    if (message.oauth !== undefined) {
      OauthConfig.encode(message.oauth, writer.uint32(34).fork()).join()
    }
    if (message.apiKeyGuide !== undefined) {
      ApiKeyGuide.encode(message.apiKeyGuide, writer.uint32(42).fork()).join()
    }
    if (message.capabilities !== undefined) {
      VenueCapabilities.encode(message.capabilities, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.enabled = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.newAccount = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.oauth = OauthConfig.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.apiKeyGuide = ApiKeyGuide.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.capabilities = VenueCapabilities.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueInfo {
    return {
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      newAccount: isSet(object.newAccount)
        ? globalThis.Boolean(object.newAccount)
        : isSet(object.new_account)
          ? globalThis.Boolean(object.new_account)
          : false,
      oauth: isSet(object.oauth) ? OauthConfig.fromJSON(object.oauth) : undefined,
      apiKeyGuide: isSet(object.apiKeyGuide)
        ? ApiKeyGuide.fromJSON(object.apiKeyGuide)
        : isSet(object.api_key_guide)
          ? ApiKeyGuide.fromJSON(object.api_key_guide)
          : undefined,
      capabilities: isSet(object.capabilities)
        ? VenueCapabilities.fromJSON(object.capabilities)
        : undefined,
    }
  },

  toJSON(message: VenueInfo): unknown {
    const obj: any = {}
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled
    }
    if (message.newAccount !== false) {
      obj.newAccount = message.newAccount
    }
    if (message.oauth !== undefined) {
      obj.oauth = OauthConfig.toJSON(message.oauth)
    }
    if (message.apiKeyGuide !== undefined) {
      obj.apiKeyGuide = ApiKeyGuide.toJSON(message.apiKeyGuide)
    }
    if (message.capabilities !== undefined) {
      obj.capabilities = VenueCapabilities.toJSON(message.capabilities)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueInfo>, I>>(base?: I): VenueInfo {
    return VenueInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueInfo>, I>>(object: I): VenueInfo {
    const message = createBaseVenueInfo()
    message.tradeVenue = object.tradeVenue ?? 0
    message.enabled = object.enabled ?? false
    message.newAccount = object.newAccount ?? false
    message.oauth =
      object.oauth !== undefined && object.oauth !== null
        ? OauthConfig.fromPartial(object.oauth)
        : undefined
    message.apiKeyGuide =
      object.apiKeyGuide !== undefined && object.apiKeyGuide !== null
        ? ApiKeyGuide.fromPartial(object.apiKeyGuide)
        : undefined
    message.capabilities =
      object.capabilities !== undefined && object.capabilities !== null
        ? VenueCapabilities.fromPartial(object.capabilities)
        : undefined
    return message
  },
}

function createBaseVenueList(): VenueList {
  return { venues: [] }
}

export const VenueList: MessageFns<VenueList> = {
  encode(message: VenueList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.venues) {
      VenueInfo.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.venues.push(VenueInfo.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueList {
    return {
      venues: globalThis.Array.isArray(object?.venues)
        ? object.venues.map((e: any) => VenueInfo.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VenueList): unknown {
    const obj: any = {}
    if (message.venues?.length) {
      obj.venues = message.venues.map((e) => VenueInfo.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueList>, I>>(base?: I): VenueList {
    return VenueList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueList>, I>>(object: I): VenueList {
    const message = createBaseVenueList()
    message.venues = object.venues?.map((e) => VenueInfo.fromPartial(e)) || []
    return message
  },
}

function createBaseApiKeyGuide(): ApiKeyGuide {
  return { createKeyUrl: '', guideUrl: undefined, permissions: [], note: undefined }
}

export const ApiKeyGuide: MessageFns<ApiKeyGuide> = {
  encode(message: ApiKeyGuide, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createKeyUrl !== '') {
      writer.uint32(10).string(message.createKeyUrl)
    }
    if (message.guideUrl !== undefined) {
      writer.uint32(18).string(message.guideUrl)
    }
    for (const v of message.permissions) {
      VenuePermission.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.note !== undefined) {
      writer.uint32(34).string(message.note)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiKeyGuide {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseApiKeyGuide()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.createKeyUrl = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.guideUrl = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.permissions.push(VenuePermission.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.note = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ApiKeyGuide {
    return {
      createKeyUrl: isSet(object.createKeyUrl)
        ? globalThis.String(object.createKeyUrl)
        : isSet(object.create_key_url)
          ? globalThis.String(object.create_key_url)
          : '',
      guideUrl: isSet(object.guideUrl)
        ? globalThis.String(object.guideUrl)
        : isSet(object.guide_url)
          ? globalThis.String(object.guide_url)
          : undefined,
      permissions: globalThis.Array.isArray(object?.permissions)
        ? object.permissions.map((e: any) => VenuePermission.fromJSON(e))
        : [],
      note: isSet(object.note) ? globalThis.String(object.note) : undefined,
    }
  },

  toJSON(message: ApiKeyGuide): unknown {
    const obj: any = {}
    if (message.createKeyUrl !== '') {
      obj.createKeyUrl = message.createKeyUrl
    }
    if (message.guideUrl !== undefined) {
      obj.guideUrl = message.guideUrl
    }
    if (message.permissions?.length) {
      obj.permissions = message.permissions.map((e) => VenuePermission.toJSON(e))
    }
    if (message.note !== undefined) {
      obj.note = message.note
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ApiKeyGuide>, I>>(base?: I): ApiKeyGuide {
    return ApiKeyGuide.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ApiKeyGuide>, I>>(object: I): ApiKeyGuide {
    const message = createBaseApiKeyGuide()
    message.createKeyUrl = object.createKeyUrl ?? ''
    message.guideUrl = object.guideUrl ?? undefined
    message.permissions = object.permissions?.map((e) => VenuePermission.fromPartial(e)) || []
    message.note = object.note ?? undefined
    return message
  },
}

function createBaseVenuePermission(): VenuePermission {
  return { label: '', scope: undefined }
}

export const VenuePermission: MessageFns<VenuePermission> = {
  encode(message: VenuePermission, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.scope !== undefined) {
      writer.uint32(18).string(message.scope)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenuePermission {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenuePermission()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scope = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenuePermission {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
    }
  },

  toJSON(message: VenuePermission): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenuePermission>, I>>(base?: I): VenuePermission {
    return VenuePermission.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenuePermission>, I>>(object: I): VenuePermission {
    const message = createBaseVenuePermission()
    message.label = object.label ?? ''
    message.scope = object.scope ?? undefined
    return message
  },
}

function createBaseOauthConfig(): OauthConfig {
  return { authorizeUrl: '', clientId: '', scope: undefined, responseType: undefined }
}

export const OauthConfig: MessageFns<OauthConfig> = {
  encode(message: OauthConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.authorizeUrl !== '') {
      writer.uint32(10).string(message.authorizeUrl)
    }
    if (message.clientId !== '') {
      writer.uint32(18).string(message.clientId)
    }
    if (message.scope !== undefined) {
      writer.uint32(34).string(message.scope)
    }
    if (message.responseType !== undefined) {
      writer.uint32(42).string(message.responseType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OauthConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOauthConfig()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.authorizeUrl = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.clientId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.scope = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.responseType = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OauthConfig {
    return {
      authorizeUrl: isSet(object.authorizeUrl)
        ? globalThis.String(object.authorizeUrl)
        : isSet(object.authorize_url)
          ? globalThis.String(object.authorize_url)
          : '',
      clientId: isSet(object.clientId)
        ? globalThis.String(object.clientId)
        : isSet(object.client_id)
          ? globalThis.String(object.client_id)
          : '',
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
      responseType: isSet(object.responseType)
        ? globalThis.String(object.responseType)
        : isSet(object.response_type)
          ? globalThis.String(object.response_type)
          : undefined,
    }
  },

  toJSON(message: OauthConfig): unknown {
    const obj: any = {}
    if (message.authorizeUrl !== '') {
      obj.authorizeUrl = message.authorizeUrl
    }
    if (message.clientId !== '') {
      obj.clientId = message.clientId
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope
    }
    if (message.responseType !== undefined) {
      obj.responseType = message.responseType
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OauthConfig>, I>>(base?: I): OauthConfig {
    return OauthConfig.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OauthConfig>, I>>(object: I): OauthConfig {
    const message = createBaseOauthConfig()
    message.authorizeUrl = object.authorizeUrl ?? ''
    message.clientId = object.clientId ?? ''
    message.scope = object.scope ?? undefined
    message.responseType = object.responseType ?? undefined
    return message
  },
}

function createBaseBybitOauthMintStateRequest(): BybitOauthMintStateRequest {
  return { accountId: '' }
}

export const BybitOauthMintStateRequest: MessageFns<BybitOauthMintStateRequest> = {
  encode(
    message: BybitOauthMintStateRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BybitOauthMintStateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBybitOauthMintStateRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BybitOauthMintStateRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: BybitOauthMintStateRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BybitOauthMintStateRequest>, I>>(
    base?: I
  ): BybitOauthMintStateRequest {
    return BybitOauthMintStateRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BybitOauthMintStateRequest>, I>>(
    object: I
  ): BybitOauthMintStateRequest {
    const message = createBaseBybitOauthMintStateRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseBybitOauthMintStateResponse(): BybitOauthMintStateResponse {
  return { state: '' }
}

export const BybitOauthMintStateResponse: MessageFns<BybitOauthMintStateResponse> = {
  encode(
    message: BybitOauthMintStateResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.state !== '') {
      writer.uint32(10).string(message.state)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BybitOauthMintStateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBybitOauthMintStateResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.state = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BybitOauthMintStateResponse {
    return { state: isSet(object.state) ? globalThis.String(object.state) : '' }
  },

  toJSON(message: BybitOauthMintStateResponse): unknown {
    const obj: any = {}
    if (message.state !== '') {
      obj.state = message.state
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BybitOauthMintStateResponse>, I>>(
    base?: I
  ): BybitOauthMintStateResponse {
    return BybitOauthMintStateResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BybitOauthMintStateResponse>, I>>(
    object: I
  ): BybitOauthMintStateResponse {
    const message = createBaseBybitOauthMintStateResponse()
    message.state = object.state ?? ''
    return message
  },
}

function createBaseBybitOauthExchangeCodeRequest(): BybitOauthExchangeCodeRequest {
  return { accountId: '', code: '', state: '', redirectUri: '' }
}

export const BybitOauthExchangeCodeRequest: MessageFns<BybitOauthExchangeCodeRequest> = {
  encode(
    message: BybitOauthExchangeCodeRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.code !== '') {
      writer.uint32(18).string(message.code)
    }
    if (message.state !== '') {
      writer.uint32(26).string(message.state)
    }
    if (message.redirectUri !== '') {
      writer.uint32(34).string(message.redirectUri)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BybitOauthExchangeCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBybitOauthExchangeCodeRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.code = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.state = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.redirectUri = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BybitOauthExchangeCodeRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      code: isSet(object.code) ? globalThis.String(object.code) : '',
      state: isSet(object.state) ? globalThis.String(object.state) : '',
      redirectUri: isSet(object.redirectUri)
        ? globalThis.String(object.redirectUri)
        : isSet(object.redirect_uri)
          ? globalThis.String(object.redirect_uri)
          : '',
    }
  },

  toJSON(message: BybitOauthExchangeCodeRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.code !== '') {
      obj.code = message.code
    }
    if (message.state !== '') {
      obj.state = message.state
    }
    if (message.redirectUri !== '') {
      obj.redirectUri = message.redirectUri
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BybitOauthExchangeCodeRequest>, I>>(
    base?: I
  ): BybitOauthExchangeCodeRequest {
    return BybitOauthExchangeCodeRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BybitOauthExchangeCodeRequest>, I>>(
    object: I
  ): BybitOauthExchangeCodeRequest {
    const message = createBaseBybitOauthExchangeCodeRequest()
    message.accountId = object.accountId ?? ''
    message.code = object.code ?? ''
    message.state = object.state ?? ''
    message.redirectUri = object.redirectUri ?? ''
    return message
  },
}

function createBaseDeribitOauthMintStateRequest(): DeribitOauthMintStateRequest {
  return { accountId: '' }
}

export const DeribitOauthMintStateRequest: MessageFns<DeribitOauthMintStateRequest> = {
  encode(
    message: DeribitOauthMintStateRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeribitOauthMintStateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeribitOauthMintStateRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeribitOauthMintStateRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: DeribitOauthMintStateRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeribitOauthMintStateRequest>, I>>(
    base?: I
  ): DeribitOauthMintStateRequest {
    return DeribitOauthMintStateRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeribitOauthMintStateRequest>, I>>(
    object: I
  ): DeribitOauthMintStateRequest {
    const message = createBaseDeribitOauthMintStateRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseDeribitOauthMintStateResponse(): DeribitOauthMintStateResponse {
  return { state: '' }
}

export const DeribitOauthMintStateResponse: MessageFns<DeribitOauthMintStateResponse> = {
  encode(
    message: DeribitOauthMintStateResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.state !== '') {
      writer.uint32(10).string(message.state)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeribitOauthMintStateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeribitOauthMintStateResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.state = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeribitOauthMintStateResponse {
    return { state: isSet(object.state) ? globalThis.String(object.state) : '' }
  },

  toJSON(message: DeribitOauthMintStateResponse): unknown {
    const obj: any = {}
    if (message.state !== '') {
      obj.state = message.state
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeribitOauthMintStateResponse>, I>>(
    base?: I
  ): DeribitOauthMintStateResponse {
    return DeribitOauthMintStateResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeribitOauthMintStateResponse>, I>>(
    object: I
  ): DeribitOauthMintStateResponse {
    const message = createBaseDeribitOauthMintStateResponse()
    message.state = object.state ?? ''
    return message
  },
}

function createBaseDeribitOauthExchangeCodeRequest(): DeribitOauthExchangeCodeRequest {
  return { accountId: '', code: '', state: '', redirectUri: '' }
}

export const DeribitOauthExchangeCodeRequest: MessageFns<DeribitOauthExchangeCodeRequest> = {
  encode(
    message: DeribitOauthExchangeCodeRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.code !== '') {
      writer.uint32(18).string(message.code)
    }
    if (message.state !== '') {
      writer.uint32(26).string(message.state)
    }
    if (message.redirectUri !== '') {
      writer.uint32(34).string(message.redirectUri)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeribitOauthExchangeCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeribitOauthExchangeCodeRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.code = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.state = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.redirectUri = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeribitOauthExchangeCodeRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      code: isSet(object.code) ? globalThis.String(object.code) : '',
      state: isSet(object.state) ? globalThis.String(object.state) : '',
      redirectUri: isSet(object.redirectUri)
        ? globalThis.String(object.redirectUri)
        : isSet(object.redirect_uri)
          ? globalThis.String(object.redirect_uri)
          : '',
    }
  },

  toJSON(message: DeribitOauthExchangeCodeRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.code !== '') {
      obj.code = message.code
    }
    if (message.state !== '') {
      obj.state = message.state
    }
    if (message.redirectUri !== '') {
      obj.redirectUri = message.redirectUri
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeribitOauthExchangeCodeRequest>, I>>(
    base?: I
  ): DeribitOauthExchangeCodeRequest {
    return DeribitOauthExchangeCodeRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeribitOauthExchangeCodeRequest>, I>>(
    object: I
  ): DeribitOauthExchangeCodeRequest {
    const message = createBaseDeribitOauthExchangeCodeRequest()
    message.accountId = object.accountId ?? ''
    message.code = object.code ?? ''
    message.state = object.state ?? ''
    message.redirectUri = object.redirectUri ?? ''
    return message
  },
}

function createBaseHyperliquidPrepareAgentRequest(): HyperliquidPrepareAgentRequest {
  return { accountId: '', signatureChainId: 0, masterAddress: undefined }
}

export const HyperliquidPrepareAgentRequest: MessageFns<HyperliquidPrepareAgentRequest> = {
  encode(
    message: HyperliquidPrepareAgentRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.signatureChainId !== 0) {
      writer.uint32(16).uint32(message.signatureChainId)
    }
    if (message.masterAddress !== undefined) {
      writer.uint32(26).string(message.masterAddress)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidPrepareAgentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidPrepareAgentRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.signatureChainId = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.masterAddress = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidPrepareAgentRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      signatureChainId: isSet(object.signatureChainId)
        ? globalThis.Number(object.signatureChainId)
        : isSet(object.signature_chain_id)
          ? globalThis.Number(object.signature_chain_id)
          : 0,
      masterAddress: isSet(object.masterAddress)
        ? globalThis.String(object.masterAddress)
        : isSet(object.master_address)
          ? globalThis.String(object.master_address)
          : undefined,
    }
  },

  toJSON(message: HyperliquidPrepareAgentRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.signatureChainId !== 0) {
      obj.signatureChainId = Math.round(message.signatureChainId)
    }
    if (message.masterAddress !== undefined) {
      obj.masterAddress = message.masterAddress
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidPrepareAgentRequest>, I>>(
    base?: I
  ): HyperliquidPrepareAgentRequest {
    return HyperliquidPrepareAgentRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidPrepareAgentRequest>, I>>(
    object: I
  ): HyperliquidPrepareAgentRequest {
    const message = createBaseHyperliquidPrepareAgentRequest()
    message.accountId = object.accountId ?? ''
    message.signatureChainId = object.signatureChainId ?? 0
    message.masterAddress = object.masterAddress ?? undefined
    return message
  },
}

function createBaseHyperliquidPrepareAgentResponse(): HyperliquidPrepareAgentResponse {
  return { agentAddress: '', approveAgentPayload: '', approveBuilderFeePayload: undefined }
}

export const HyperliquidPrepareAgentResponse: MessageFns<HyperliquidPrepareAgentResponse> = {
  encode(
    message: HyperliquidPrepareAgentResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.agentAddress !== '') {
      writer.uint32(10).string(message.agentAddress)
    }
    if (message.approveAgentPayload !== '') {
      writer.uint32(18).string(message.approveAgentPayload)
    }
    if (message.approveBuilderFeePayload !== undefined) {
      writer.uint32(26).string(message.approveBuilderFeePayload)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidPrepareAgentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidPrepareAgentResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.agentAddress = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.approveAgentPayload = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.approveBuilderFeePayload = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidPrepareAgentResponse {
    return {
      agentAddress: isSet(object.agentAddress)
        ? globalThis.String(object.agentAddress)
        : isSet(object.agent_address)
          ? globalThis.String(object.agent_address)
          : '',
      approveAgentPayload: isSet(object.approveAgentPayload)
        ? globalThis.String(object.approveAgentPayload)
        : isSet(object.approve_agent_payload)
          ? globalThis.String(object.approve_agent_payload)
          : '',
      approveBuilderFeePayload: isSet(object.approveBuilderFeePayload)
        ? globalThis.String(object.approveBuilderFeePayload)
        : isSet(object.approve_builder_fee_payload)
          ? globalThis.String(object.approve_builder_fee_payload)
          : undefined,
    }
  },

  toJSON(message: HyperliquidPrepareAgentResponse): unknown {
    const obj: any = {}
    if (message.agentAddress !== '') {
      obj.agentAddress = message.agentAddress
    }
    if (message.approveAgentPayload !== '') {
      obj.approveAgentPayload = message.approveAgentPayload
    }
    if (message.approveBuilderFeePayload !== undefined) {
      obj.approveBuilderFeePayload = message.approveBuilderFeePayload
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidPrepareAgentResponse>, I>>(
    base?: I
  ): HyperliquidPrepareAgentResponse {
    return HyperliquidPrepareAgentResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidPrepareAgentResponse>, I>>(
    object: I
  ): HyperliquidPrepareAgentResponse {
    const message = createBaseHyperliquidPrepareAgentResponse()
    message.agentAddress = object.agentAddress ?? ''
    message.approveAgentPayload = object.approveAgentPayload ?? ''
    message.approveBuilderFeePayload = object.approveBuilderFeePayload ?? undefined
    return message
  },
}

function createBaseHyperliquidConfirmAgentRequest(): HyperliquidConfirmAgentRequest {
  return {
    accountId: '',
    masterAddress: '',
    approveAgentSignature: '',
    approveBuilderFeeSignature: undefined,
  }
}

export const HyperliquidConfirmAgentRequest: MessageFns<HyperliquidConfirmAgentRequest> = {
  encode(
    message: HyperliquidConfirmAgentRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.masterAddress !== '') {
      writer.uint32(18).string(message.masterAddress)
    }
    if (message.approveAgentSignature !== '') {
      writer.uint32(26).string(message.approveAgentSignature)
    }
    if (message.approveBuilderFeeSignature !== undefined) {
      writer.uint32(34).string(message.approveBuilderFeeSignature)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidConfirmAgentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidConfirmAgentRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.masterAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.approveAgentSignature = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.approveBuilderFeeSignature = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidConfirmAgentRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      masterAddress: isSet(object.masterAddress)
        ? globalThis.String(object.masterAddress)
        : isSet(object.master_address)
          ? globalThis.String(object.master_address)
          : '',
      approveAgentSignature: isSet(object.approveAgentSignature)
        ? globalThis.String(object.approveAgentSignature)
        : isSet(object.approve_agent_signature)
          ? globalThis.String(object.approve_agent_signature)
          : '',
      approveBuilderFeeSignature: isSet(object.approveBuilderFeeSignature)
        ? globalThis.String(object.approveBuilderFeeSignature)
        : isSet(object.approve_builder_fee_signature)
          ? globalThis.String(object.approve_builder_fee_signature)
          : undefined,
    }
  },

  toJSON(message: HyperliquidConfirmAgentRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.masterAddress !== '') {
      obj.masterAddress = message.masterAddress
    }
    if (message.approveAgentSignature !== '') {
      obj.approveAgentSignature = message.approveAgentSignature
    }
    if (message.approveBuilderFeeSignature !== undefined) {
      obj.approveBuilderFeeSignature = message.approveBuilderFeeSignature
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidConfirmAgentRequest>, I>>(
    base?: I
  ): HyperliquidConfirmAgentRequest {
    return HyperliquidConfirmAgentRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidConfirmAgentRequest>, I>>(
    object: I
  ): HyperliquidConfirmAgentRequest {
    const message = createBaseHyperliquidConfirmAgentRequest()
    message.accountId = object.accountId ?? ''
    message.masterAddress = object.masterAddress ?? ''
    message.approveAgentSignature = object.approveAgentSignature ?? ''
    message.approveBuilderFeeSignature = object.approveBuilderFeeSignature ?? undefined
    return message
  },
}

function createBaseHyperliquidDisconnectAgentRequest(): HyperliquidDisconnectAgentRequest {
  return { accountId: '' }
}

export const HyperliquidDisconnectAgentRequest: MessageFns<HyperliquidDisconnectAgentRequest> = {
  encode(
    message: HyperliquidDisconnectAgentRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidDisconnectAgentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidDisconnectAgentRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidDisconnectAgentRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: HyperliquidDisconnectAgentRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidDisconnectAgentRequest>, I>>(
    base?: I
  ): HyperliquidDisconnectAgentRequest {
    return HyperliquidDisconnectAgentRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidDisconnectAgentRequest>, I>>(
    object: I
  ): HyperliquidDisconnectAgentRequest {
    const message = createBaseHyperliquidDisconnectAgentRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseHyperliquidListSubaccountsRequest(): HyperliquidListSubaccountsRequest {
  return { accountId: '', masterAddress: '' }
}

export const HyperliquidListSubaccountsRequest: MessageFns<HyperliquidListSubaccountsRequest> = {
  encode(
    message: HyperliquidListSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.masterAddress !== '') {
      writer.uint32(18).string(message.masterAddress)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidListSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidListSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.masterAddress = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidListSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      masterAddress: isSet(object.masterAddress)
        ? globalThis.String(object.masterAddress)
        : isSet(object.master_address)
          ? globalThis.String(object.master_address)
          : '',
    }
  },

  toJSON(message: HyperliquidListSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.masterAddress !== '') {
      obj.masterAddress = message.masterAddress
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidListSubaccountsRequest>, I>>(
    base?: I
  ): HyperliquidListSubaccountsRequest {
    return HyperliquidListSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidListSubaccountsRequest>, I>>(
    object: I
  ): HyperliquidListSubaccountsRequest {
    const message = createBaseHyperliquidListSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.masterAddress = object.masterAddress ?? ''
    return message
  },
}

function createBaseHyperliquidSubaccountInfo(): HyperliquidSubaccountInfo {
  return { address: '', name: '', alreadyLinked: false, linkedAccountId: '' }
}

export const HyperliquidSubaccountInfo: MessageFns<HyperliquidSubaccountInfo> = {
  encode(
    message: HyperliquidSubaccountInfo,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.address !== '') {
      writer.uint32(10).string(message.address)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.alreadyLinked !== false) {
      writer.uint32(24).bool(message.alreadyLinked)
    }
    if (message.linkedAccountId !== '') {
      writer.uint32(34).string(message.linkedAccountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidSubaccountInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidSubaccountInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.address = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.alreadyLinked = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.linkedAccountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidSubaccountInfo {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      alreadyLinked: isSet(object.alreadyLinked)
        ? globalThis.Boolean(object.alreadyLinked)
        : isSet(object.already_linked)
          ? globalThis.Boolean(object.already_linked)
          : false,
      linkedAccountId: isSet(object.linkedAccountId)
        ? globalThis.String(object.linkedAccountId)
        : isSet(object.linked_account_id)
          ? globalThis.String(object.linked_account_id)
          : '',
    }
  },

  toJSON(message: HyperliquidSubaccountInfo): unknown {
    const obj: any = {}
    if (message.address !== '') {
      obj.address = message.address
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.alreadyLinked !== false) {
      obj.alreadyLinked = message.alreadyLinked
    }
    if (message.linkedAccountId !== '') {
      obj.linkedAccountId = message.linkedAccountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidSubaccountInfo>, I>>(
    base?: I
  ): HyperliquidSubaccountInfo {
    return HyperliquidSubaccountInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidSubaccountInfo>, I>>(
    object: I
  ): HyperliquidSubaccountInfo {
    const message = createBaseHyperliquidSubaccountInfo()
    message.address = object.address ?? ''
    message.name = object.name ?? ''
    message.alreadyLinked = object.alreadyLinked ?? false
    message.linkedAccountId = object.linkedAccountId ?? ''
    return message
  },
}

function createBaseHyperliquidListSubaccountsResponse(): HyperliquidListSubaccountsResponse {
  return { walletConnected: false, subaccounts: [], remainingAccountSlots: 0 }
}

export const HyperliquidListSubaccountsResponse: MessageFns<HyperliquidListSubaccountsResponse> = {
  encode(
    message: HyperliquidListSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.walletConnected !== false) {
      writer.uint32(8).bool(message.walletConnected)
    }
    for (const v of message.subaccounts) {
      HyperliquidSubaccountInfo.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.remainingAccountSlots !== 0) {
      writer.uint32(24).int32(message.remainingAccountSlots)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidListSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidListSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.walletConnected = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.subaccounts.push(HyperliquidSubaccountInfo.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.remainingAccountSlots = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidListSubaccountsResponse {
    return {
      walletConnected: isSet(object.walletConnected)
        ? globalThis.Boolean(object.walletConnected)
        : isSet(object.wallet_connected)
          ? globalThis.Boolean(object.wallet_connected)
          : false,
      subaccounts: globalThis.Array.isArray(object?.subaccounts)
        ? object.subaccounts.map((e: any) => HyperliquidSubaccountInfo.fromJSON(e))
        : [],
      remainingAccountSlots: isSet(object.remainingAccountSlots)
        ? globalThis.Number(object.remainingAccountSlots)
        : isSet(object.remaining_account_slots)
          ? globalThis.Number(object.remaining_account_slots)
          : 0,
    }
  },

  toJSON(message: HyperliquidListSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.walletConnected !== false) {
      obj.walletConnected = message.walletConnected
    }
    if (message.subaccounts?.length) {
      obj.subaccounts = message.subaccounts.map((e) => HyperliquidSubaccountInfo.toJSON(e))
    }
    if (message.remainingAccountSlots !== 0) {
      obj.remainingAccountSlots = Math.round(message.remainingAccountSlots)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidListSubaccountsResponse>, I>>(
    base?: I
  ): HyperliquidListSubaccountsResponse {
    return HyperliquidListSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidListSubaccountsResponse>, I>>(
    object: I
  ): HyperliquidListSubaccountsResponse {
    const message = createBaseHyperliquidListSubaccountsResponse()
    message.walletConnected = object.walletConnected ?? false
    message.subaccounts =
      object.subaccounts?.map((e) => HyperliquidSubaccountInfo.fromPartial(e)) || []
    message.remainingAccountSlots = object.remainingAccountSlots ?? 0
    return message
  },
}

function createBaseHyperliquidLinkSubaccountsRequest(): HyperliquidLinkSubaccountsRequest {
  return { accountId: '', masterAddress: '', subaccountAddresses: [] }
}

export const HyperliquidLinkSubaccountsRequest: MessageFns<HyperliquidLinkSubaccountsRequest> = {
  encode(
    message: HyperliquidLinkSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.masterAddress !== '') {
      writer.uint32(18).string(message.masterAddress)
    }
    for (const v of message.subaccountAddresses) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidLinkSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidLinkSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.masterAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.subaccountAddresses.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidLinkSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      masterAddress: isSet(object.masterAddress)
        ? globalThis.String(object.masterAddress)
        : isSet(object.master_address)
          ? globalThis.String(object.master_address)
          : '',
      subaccountAddresses: globalThis.Array.isArray(object?.subaccountAddresses)
        ? object.subaccountAddresses.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.subaccount_addresses)
          ? object.subaccount_addresses.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: HyperliquidLinkSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.masterAddress !== '') {
      obj.masterAddress = message.masterAddress
    }
    if (message.subaccountAddresses?.length) {
      obj.subaccountAddresses = message.subaccountAddresses
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidLinkSubaccountsRequest>, I>>(
    base?: I
  ): HyperliquidLinkSubaccountsRequest {
    return HyperliquidLinkSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidLinkSubaccountsRequest>, I>>(
    object: I
  ): HyperliquidLinkSubaccountsRequest {
    const message = createBaseHyperliquidLinkSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.masterAddress = object.masterAddress ?? ''
    message.subaccountAddresses = object.subaccountAddresses?.map((e) => e) || []
    return message
  },
}

function createBaseHyperliquidLinkedSlot(): HyperliquidLinkedSlot {
  return { subaccountAddress: '', accountId: '', error: '' }
}

export const HyperliquidLinkedSlot: MessageFns<HyperliquidLinkedSlot> = {
  encode(message: HyperliquidLinkedSlot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subaccountAddress !== '') {
      writer.uint32(10).string(message.subaccountAddress)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.error !== '') {
      writer.uint32(26).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidLinkedSlot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidLinkedSlot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.subaccountAddress = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidLinkedSlot {
    return {
      subaccountAddress: isSet(object.subaccountAddress)
        ? globalThis.String(object.subaccountAddress)
        : isSet(object.subaccount_address)
          ? globalThis.String(object.subaccount_address)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      error: isSet(object.error) ? globalThis.String(object.error) : '',
    }
  },

  toJSON(message: HyperliquidLinkedSlot): unknown {
    const obj: any = {}
    if (message.subaccountAddress !== '') {
      obj.subaccountAddress = message.subaccountAddress
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.error !== '') {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidLinkedSlot>, I>>(base?: I): HyperliquidLinkedSlot {
    return HyperliquidLinkedSlot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidLinkedSlot>, I>>(
    object: I
  ): HyperliquidLinkedSlot {
    const message = createBaseHyperliquidLinkedSlot()
    message.subaccountAddress = object.subaccountAddress ?? ''
    message.accountId = object.accountId ?? ''
    message.error = object.error ?? ''
    return message
  },
}

function createBaseHyperliquidLinkSubaccountsResponse(): HyperliquidLinkSubaccountsResponse {
  return { slots: [] }
}

export const HyperliquidLinkSubaccountsResponse: MessageFns<HyperliquidLinkSubaccountsResponse> = {
  encode(
    message: HyperliquidLinkSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.slots) {
      HyperliquidLinkedSlot.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HyperliquidLinkSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHyperliquidLinkSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.slots.push(HyperliquidLinkedSlot.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HyperliquidLinkSubaccountsResponse {
    return {
      slots: globalThis.Array.isArray(object?.slots)
        ? object.slots.map((e: any) => HyperliquidLinkedSlot.fromJSON(e))
        : [],
    }
  },

  toJSON(message: HyperliquidLinkSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.slots?.length) {
      obj.slots = message.slots.map((e) => HyperliquidLinkedSlot.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HyperliquidLinkSubaccountsResponse>, I>>(
    base?: I
  ): HyperliquidLinkSubaccountsResponse {
    return HyperliquidLinkSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HyperliquidLinkSubaccountsResponse>, I>>(
    object: I
  ): HyperliquidLinkSubaccountsResponse {
    const message = createBaseHyperliquidLinkSubaccountsResponse()
    message.slots = object.slots?.map((e) => HyperliquidLinkedSlot.fromPartial(e)) || []
    return message
  },
}

function createBaseDerivePrepareSessionKeyRequest(): DerivePrepareSessionKeyRequest {
  return { accountId: '', walletAddress: '', subaccountIds: [] }
}

export const DerivePrepareSessionKeyRequest: MessageFns<DerivePrepareSessionKeyRequest> = {
  encode(
    message: DerivePrepareSessionKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    writer.uint32(26).fork()
    for (const v of message.subaccountIds) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DerivePrepareSessionKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDerivePrepareSessionKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
        case 3: {
          if (tag === 24) {
            message.subaccountIds.push(reader.int64().toString())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.subaccountIds.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DerivePrepareSessionKeyRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
      subaccountIds: globalThis.Array.isArray(object?.subaccountIds)
        ? object.subaccountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.subaccount_ids)
          ? object.subaccount_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: DerivePrepareSessionKeyRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    if (message.subaccountIds?.length) {
      obj.subaccountIds = message.subaccountIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DerivePrepareSessionKeyRequest>, I>>(
    base?: I
  ): DerivePrepareSessionKeyRequest {
    return DerivePrepareSessionKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DerivePrepareSessionKeyRequest>, I>>(
    object: I
  ): DerivePrepareSessionKeyRequest {
    const message = createBaseDerivePrepareSessionKeyRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    message.subaccountIds = object.subaccountIds?.map((e) => e) || []
    return message
  },
}

function createBaseDerivePrepareSessionKeyResponse(): DerivePrepareSessionKeyResponse {
  return {
    sessionKeyAddress: '',
    matchingContractAddress: '',
    needsSubaccount: false,
    registrationExpiryUnixSeconds: '0',
    userOpHash: '',
    typedDataJson: '',
    chainId: '0',
  }
}

export const DerivePrepareSessionKeyResponse: MessageFns<DerivePrepareSessionKeyResponse> = {
  encode(
    message: DerivePrepareSessionKeyResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.sessionKeyAddress !== '') {
      writer.uint32(10).string(message.sessionKeyAddress)
    }
    if (message.matchingContractAddress !== '') {
      writer.uint32(18).string(message.matchingContractAddress)
    }
    if (message.needsSubaccount !== false) {
      writer.uint32(24).bool(message.needsSubaccount)
    }
    if (message.registrationExpiryUnixSeconds !== '0') {
      writer.uint32(32).int64(message.registrationExpiryUnixSeconds)
    }
    if (message.userOpHash !== '') {
      writer.uint32(42).string(message.userOpHash)
    }
    if (message.typedDataJson !== '') {
      writer.uint32(50).string(message.typedDataJson)
    }
    if (message.chainId !== '0') {
      writer.uint32(56).int64(message.chainId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DerivePrepareSessionKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDerivePrepareSessionKeyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionKeyAddress = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.matchingContractAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.needsSubaccount = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.registrationExpiryUnixSeconds = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.userOpHash = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.typedDataJson = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.chainId = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DerivePrepareSessionKeyResponse {
    return {
      sessionKeyAddress: isSet(object.sessionKeyAddress)
        ? globalThis.String(object.sessionKeyAddress)
        : isSet(object.session_key_address)
          ? globalThis.String(object.session_key_address)
          : '',
      matchingContractAddress: isSet(object.matchingContractAddress)
        ? globalThis.String(object.matchingContractAddress)
        : isSet(object.matching_contract_address)
          ? globalThis.String(object.matching_contract_address)
          : '',
      needsSubaccount: isSet(object.needsSubaccount)
        ? globalThis.Boolean(object.needsSubaccount)
        : isSet(object.needs_subaccount)
          ? globalThis.Boolean(object.needs_subaccount)
          : false,
      registrationExpiryUnixSeconds: isSet(object.registrationExpiryUnixSeconds)
        ? globalThis.String(object.registrationExpiryUnixSeconds)
        : isSet(object.registration_expiry_unix_seconds)
          ? globalThis.String(object.registration_expiry_unix_seconds)
          : '0',
      userOpHash: isSet(object.userOpHash)
        ? globalThis.String(object.userOpHash)
        : isSet(object.user_op_hash)
          ? globalThis.String(object.user_op_hash)
          : '',
      typedDataJson: isSet(object.typedDataJson)
        ? globalThis.String(object.typedDataJson)
        : isSet(object.typed_data_json)
          ? globalThis.String(object.typed_data_json)
          : '',
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
          ? globalThis.String(object.chain_id)
          : '0',
    }
  },

  toJSON(message: DerivePrepareSessionKeyResponse): unknown {
    const obj: any = {}
    if (message.sessionKeyAddress !== '') {
      obj.sessionKeyAddress = message.sessionKeyAddress
    }
    if (message.matchingContractAddress !== '') {
      obj.matchingContractAddress = message.matchingContractAddress
    }
    if (message.needsSubaccount !== false) {
      obj.needsSubaccount = message.needsSubaccount
    }
    if (message.registrationExpiryUnixSeconds !== '0') {
      obj.registrationExpiryUnixSeconds = message.registrationExpiryUnixSeconds
    }
    if (message.userOpHash !== '') {
      obj.userOpHash = message.userOpHash
    }
    if (message.typedDataJson !== '') {
      obj.typedDataJson = message.typedDataJson
    }
    if (message.chainId !== '0') {
      obj.chainId = message.chainId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DerivePrepareSessionKeyResponse>, I>>(
    base?: I
  ): DerivePrepareSessionKeyResponse {
    return DerivePrepareSessionKeyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DerivePrepareSessionKeyResponse>, I>>(
    object: I
  ): DerivePrepareSessionKeyResponse {
    const message = createBaseDerivePrepareSessionKeyResponse()
    message.sessionKeyAddress = object.sessionKeyAddress ?? ''
    message.matchingContractAddress = object.matchingContractAddress ?? ''
    message.needsSubaccount = object.needsSubaccount ?? false
    message.registrationExpiryUnixSeconds = object.registrationExpiryUnixSeconds ?? '0'
    message.userOpHash = object.userOpHash ?? ''
    message.typedDataJson = object.typedDataJson ?? ''
    message.chainId = object.chainId ?? '0'
    return message
  },
}

function createBaseDeriveConfirmSessionKeyRequest(): DeriveConfirmSessionKeyRequest {
  return {
    accountId: '',
    walletAddress: '',
    registrationTxHash: '',
    subaccountId: 0,
    userOpSignature: '',
    actionSignature: '',
    loginTimestampMs: '0',
    loginSignature: '',
  }
}

export const DeriveConfirmSessionKeyRequest: MessageFns<DeriveConfirmSessionKeyRequest> = {
  encode(
    message: DeriveConfirmSessionKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    if (message.registrationTxHash !== '') {
      writer.uint32(26).string(message.registrationTxHash)
    }
    if (message.subaccountId !== 0) {
      writer.uint32(32).int32(message.subaccountId)
    }
    if (message.userOpSignature !== '') {
      writer.uint32(42).string(message.userOpSignature)
    }
    if (message.actionSignature !== '') {
      writer.uint32(50).string(message.actionSignature)
    }
    if (message.loginTimestampMs !== '0') {
      writer.uint32(56).int64(message.loginTimestampMs)
    }
    if (message.loginSignature !== '') {
      writer.uint32(66).string(message.loginSignature)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveConfirmSessionKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveConfirmSessionKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.registrationTxHash = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.subaccountId = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.userOpSignature = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.actionSignature = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.loginTimestampMs = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.loginSignature = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveConfirmSessionKeyRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
      registrationTxHash: isSet(object.registrationTxHash)
        ? globalThis.String(object.registrationTxHash)
        : isSet(object.registration_tx_hash)
          ? globalThis.String(object.registration_tx_hash)
          : '',
      subaccountId: isSet(object.subaccountId)
        ? globalThis.Number(object.subaccountId)
        : isSet(object.subaccount_id)
          ? globalThis.Number(object.subaccount_id)
          : 0,
      userOpSignature: isSet(object.userOpSignature)
        ? globalThis.String(object.userOpSignature)
        : isSet(object.user_op_signature)
          ? globalThis.String(object.user_op_signature)
          : '',
      actionSignature: isSet(object.actionSignature)
        ? globalThis.String(object.actionSignature)
        : isSet(object.action_signature)
          ? globalThis.String(object.action_signature)
          : '',
      loginTimestampMs: isSet(object.loginTimestampMs)
        ? globalThis.String(object.loginTimestampMs)
        : isSet(object.login_timestamp_ms)
          ? globalThis.String(object.login_timestamp_ms)
          : '0',
      loginSignature: isSet(object.loginSignature)
        ? globalThis.String(object.loginSignature)
        : isSet(object.login_signature)
          ? globalThis.String(object.login_signature)
          : '',
    }
  },

  toJSON(message: DeriveConfirmSessionKeyRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    if (message.registrationTxHash !== '') {
      obj.registrationTxHash = message.registrationTxHash
    }
    if (message.subaccountId !== 0) {
      obj.subaccountId = Math.round(message.subaccountId)
    }
    if (message.userOpSignature !== '') {
      obj.userOpSignature = message.userOpSignature
    }
    if (message.actionSignature !== '') {
      obj.actionSignature = message.actionSignature
    }
    if (message.loginTimestampMs !== '0') {
      obj.loginTimestampMs = message.loginTimestampMs
    }
    if (message.loginSignature !== '') {
      obj.loginSignature = message.loginSignature
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveConfirmSessionKeyRequest>, I>>(
    base?: I
  ): DeriveConfirmSessionKeyRequest {
    return DeriveConfirmSessionKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveConfirmSessionKeyRequest>, I>>(
    object: I
  ): DeriveConfirmSessionKeyRequest {
    const message = createBaseDeriveConfirmSessionKeyRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    message.registrationTxHash = object.registrationTxHash ?? ''
    message.subaccountId = object.subaccountId ?? 0
    message.userOpSignature = object.userOpSignature ?? ''
    message.actionSignature = object.actionSignature ?? ''
    message.loginTimestampMs = object.loginTimestampMs ?? '0'
    message.loginSignature = object.loginSignature ?? ''
    return message
  },
}

function createBaseDeriveDisconnectRequest(): DeriveDisconnectRequest {
  return { accountId: '' }
}

export const DeriveDisconnectRequest: MessageFns<DeriveDisconnectRequest> = {
  encode(
    message: DeriveDisconnectRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveDisconnectRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveDisconnectRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveDisconnectRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: DeriveDisconnectRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveDisconnectRequest>, I>>(
    base?: I
  ): DeriveDisconnectRequest {
    return DeriveDisconnectRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveDisconnectRequest>, I>>(
    object: I
  ): DeriveDisconnectRequest {
    const message = createBaseDeriveDisconnectRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseDeriveListSubaccountsRequest(): DeriveListSubaccountsRequest {
  return { accountId: '', walletAddress: '', loginTimestampMs: '0', loginSignature: '' }
}

export const DeriveListSubaccountsRequest: MessageFns<DeriveListSubaccountsRequest> = {
  encode(
    message: DeriveListSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    if (message.loginTimestampMs !== '0') {
      writer.uint32(24).int64(message.loginTimestampMs)
    }
    if (message.loginSignature !== '') {
      writer.uint32(34).string(message.loginSignature)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveListSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveListSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.loginTimestampMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.loginSignature = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveListSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
      loginTimestampMs: isSet(object.loginTimestampMs)
        ? globalThis.String(object.loginTimestampMs)
        : isSet(object.login_timestamp_ms)
          ? globalThis.String(object.login_timestamp_ms)
          : '0',
      loginSignature: isSet(object.loginSignature)
        ? globalThis.String(object.loginSignature)
        : isSet(object.login_signature)
          ? globalThis.String(object.login_signature)
          : '',
    }
  },

  toJSON(message: DeriveListSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    if (message.loginTimestampMs !== '0') {
      obj.loginTimestampMs = message.loginTimestampMs
    }
    if (message.loginSignature !== '') {
      obj.loginSignature = message.loginSignature
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveListSubaccountsRequest>, I>>(
    base?: I
  ): DeriveListSubaccountsRequest {
    return DeriveListSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveListSubaccountsRequest>, I>>(
    object: I
  ): DeriveListSubaccountsRequest {
    const message = createBaseDeriveListSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    message.loginTimestampMs = object.loginTimestampMs ?? '0'
    message.loginSignature = object.loginSignature ?? ''
    return message
  },
}

function createBaseDeriveSubaccountInfo(): DeriveSubaccountInfo {
  return {
    subaccountId: '0',
    alreadyLinked: false,
    linkedAccountId: '',
    currency: '',
    marginType: '',
    balanceUsd: '',
    usdcBalance: '',
  }
}

export const DeriveSubaccountInfo: MessageFns<DeriveSubaccountInfo> = {
  encode(message: DeriveSubaccountInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subaccountId !== '0') {
      writer.uint32(8).int64(message.subaccountId)
    }
    if (message.alreadyLinked !== false) {
      writer.uint32(16).bool(message.alreadyLinked)
    }
    if (message.linkedAccountId !== '') {
      writer.uint32(26).string(message.linkedAccountId)
    }
    if (message.currency !== '') {
      writer.uint32(34).string(message.currency)
    }
    if (message.marginType !== '') {
      writer.uint32(42).string(message.marginType)
    }
    if (message.balanceUsd !== '') {
      writer.uint32(50).string(message.balanceUsd)
    }
    if (message.usdcBalance !== '') {
      writer.uint32(58).string(message.usdcBalance)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveSubaccountInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveSubaccountInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.subaccountId = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.alreadyLinked = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.linkedAccountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.marginType = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.balanceUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.usdcBalance = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveSubaccountInfo {
    return {
      subaccountId: isSet(object.subaccountId)
        ? globalThis.String(object.subaccountId)
        : isSet(object.subaccount_id)
          ? globalThis.String(object.subaccount_id)
          : '0',
      alreadyLinked: isSet(object.alreadyLinked)
        ? globalThis.Boolean(object.alreadyLinked)
        : isSet(object.already_linked)
          ? globalThis.Boolean(object.already_linked)
          : false,
      linkedAccountId: isSet(object.linkedAccountId)
        ? globalThis.String(object.linkedAccountId)
        : isSet(object.linked_account_id)
          ? globalThis.String(object.linked_account_id)
          : '',
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      marginType: isSet(object.marginType)
        ? globalThis.String(object.marginType)
        : isSet(object.margin_type)
          ? globalThis.String(object.margin_type)
          : '',
      balanceUsd: isSet(object.balanceUsd)
        ? globalThis.String(object.balanceUsd)
        : isSet(object.balance_usd)
          ? globalThis.String(object.balance_usd)
          : '',
      usdcBalance: isSet(object.usdcBalance)
        ? globalThis.String(object.usdcBalance)
        : isSet(object.usdc_balance)
          ? globalThis.String(object.usdc_balance)
          : '',
    }
  },

  toJSON(message: DeriveSubaccountInfo): unknown {
    const obj: any = {}
    if (message.subaccountId !== '0') {
      obj.subaccountId = message.subaccountId
    }
    if (message.alreadyLinked !== false) {
      obj.alreadyLinked = message.alreadyLinked
    }
    if (message.linkedAccountId !== '') {
      obj.linkedAccountId = message.linkedAccountId
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.marginType !== '') {
      obj.marginType = message.marginType
    }
    if (message.balanceUsd !== '') {
      obj.balanceUsd = message.balanceUsd
    }
    if (message.usdcBalance !== '') {
      obj.usdcBalance = message.usdcBalance
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveSubaccountInfo>, I>>(base?: I): DeriveSubaccountInfo {
    return DeriveSubaccountInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveSubaccountInfo>, I>>(
    object: I
  ): DeriveSubaccountInfo {
    const message = createBaseDeriveSubaccountInfo()
    message.subaccountId = object.subaccountId ?? '0'
    message.alreadyLinked = object.alreadyLinked ?? false
    message.linkedAccountId = object.linkedAccountId ?? ''
    message.currency = object.currency ?? ''
    message.marginType = object.marginType ?? ''
    message.balanceUsd = object.balanceUsd ?? ''
    message.usdcBalance = object.usdcBalance ?? ''
    return message
  },
}

function createBaseDeriveListSubaccountsResponse(): DeriveListSubaccountsResponse {
  return {
    walletConnected: false,
    scwAddress: '',
    subaccounts: [],
    remainingAccountSlots: 0,
    initiatingSubaccountId: '0',
    maxSlotsPerLink: 0,
    subaccountCreateAmountUsd: '',
  }
}

export const DeriveListSubaccountsResponse: MessageFns<DeriveListSubaccountsResponse> = {
  encode(
    message: DeriveListSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.walletConnected !== false) {
      writer.uint32(8).bool(message.walletConnected)
    }
    if (message.scwAddress !== '') {
      writer.uint32(18).string(message.scwAddress)
    }
    for (const v of message.subaccounts) {
      DeriveSubaccountInfo.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.remainingAccountSlots !== 0) {
      writer.uint32(32).int32(message.remainingAccountSlots)
    }
    if (message.initiatingSubaccountId !== '0') {
      writer.uint32(40).int64(message.initiatingSubaccountId)
    }
    if (message.maxSlotsPerLink !== 0) {
      writer.uint32(48).uint32(message.maxSlotsPerLink)
    }
    if (message.subaccountCreateAmountUsd !== '') {
      writer.uint32(58).string(message.subaccountCreateAmountUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveListSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveListSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.walletConnected = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scwAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.subaccounts.push(DeriveSubaccountInfo.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.remainingAccountSlots = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.initiatingSubaccountId = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.maxSlotsPerLink = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.subaccountCreateAmountUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveListSubaccountsResponse {
    return {
      walletConnected: isSet(object.walletConnected)
        ? globalThis.Boolean(object.walletConnected)
        : isSet(object.wallet_connected)
          ? globalThis.Boolean(object.wallet_connected)
          : false,
      scwAddress: isSet(object.scwAddress)
        ? globalThis.String(object.scwAddress)
        : isSet(object.scw_address)
          ? globalThis.String(object.scw_address)
          : '',
      subaccounts: globalThis.Array.isArray(object?.subaccounts)
        ? object.subaccounts.map((e: any) => DeriveSubaccountInfo.fromJSON(e))
        : [],
      remainingAccountSlots: isSet(object.remainingAccountSlots)
        ? globalThis.Number(object.remainingAccountSlots)
        : isSet(object.remaining_account_slots)
          ? globalThis.Number(object.remaining_account_slots)
          : 0,
      initiatingSubaccountId: isSet(object.initiatingSubaccountId)
        ? globalThis.String(object.initiatingSubaccountId)
        : isSet(object.initiating_subaccount_id)
          ? globalThis.String(object.initiating_subaccount_id)
          : '0',
      maxSlotsPerLink: isSet(object.maxSlotsPerLink)
        ? globalThis.Number(object.maxSlotsPerLink)
        : isSet(object.max_slots_per_link)
          ? globalThis.Number(object.max_slots_per_link)
          : 0,
      subaccountCreateAmountUsd: isSet(object.subaccountCreateAmountUsd)
        ? globalThis.String(object.subaccountCreateAmountUsd)
        : isSet(object.subaccount_create_amount_usd)
          ? globalThis.String(object.subaccount_create_amount_usd)
          : '',
    }
  },

  toJSON(message: DeriveListSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.walletConnected !== false) {
      obj.walletConnected = message.walletConnected
    }
    if (message.scwAddress !== '') {
      obj.scwAddress = message.scwAddress
    }
    if (message.subaccounts?.length) {
      obj.subaccounts = message.subaccounts.map((e) => DeriveSubaccountInfo.toJSON(e))
    }
    if (message.remainingAccountSlots !== 0) {
      obj.remainingAccountSlots = Math.round(message.remainingAccountSlots)
    }
    if (message.initiatingSubaccountId !== '0') {
      obj.initiatingSubaccountId = message.initiatingSubaccountId
    }
    if (message.maxSlotsPerLink !== 0) {
      obj.maxSlotsPerLink = Math.round(message.maxSlotsPerLink)
    }
    if (message.subaccountCreateAmountUsd !== '') {
      obj.subaccountCreateAmountUsd = message.subaccountCreateAmountUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveListSubaccountsResponse>, I>>(
    base?: I
  ): DeriveListSubaccountsResponse {
    return DeriveListSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveListSubaccountsResponse>, I>>(
    object: I
  ): DeriveListSubaccountsResponse {
    const message = createBaseDeriveListSubaccountsResponse()
    message.walletConnected = object.walletConnected ?? false
    message.scwAddress = object.scwAddress ?? ''
    message.subaccounts = object.subaccounts?.map((e) => DeriveSubaccountInfo.fromPartial(e)) || []
    message.remainingAccountSlots = object.remainingAccountSlots ?? 0
    message.initiatingSubaccountId = object.initiatingSubaccountId ?? '0'
    message.maxSlotsPerLink = object.maxSlotsPerLink ?? 0
    message.subaccountCreateAmountUsd = object.subaccountCreateAmountUsd ?? ''
    return message
  },
}

function createBaseDeriveLinkSubaccountsRequest(): DeriveLinkSubaccountsRequest {
  return {
    accountId: '',
    walletAddress: '',
    subaccountIds: [],
    createCount: 0,
    fundingSubaccountId: '0',
  }
}

export const DeriveLinkSubaccountsRequest: MessageFns<DeriveLinkSubaccountsRequest> = {
  encode(
    message: DeriveLinkSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    writer.uint32(26).fork()
    for (const v of message.subaccountIds) {
      writer.int64(v)
    }
    writer.join()
    if (message.createCount !== 0) {
      writer.uint32(32).uint32(message.createCount)
    }
    if (message.fundingSubaccountId !== '0') {
      writer.uint32(40).int64(message.fundingSubaccountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveLinkSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveLinkSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
        case 3: {
          if (tag === 24) {
            message.subaccountIds.push(reader.int64().toString())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.subaccountIds.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createCount = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.fundingSubaccountId = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveLinkSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
      subaccountIds: globalThis.Array.isArray(object?.subaccountIds)
        ? object.subaccountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.subaccount_ids)
          ? object.subaccount_ids.map((e: any) => globalThis.String(e))
          : [],
      createCount: isSet(object.createCount)
        ? globalThis.Number(object.createCount)
        : isSet(object.create_count)
          ? globalThis.Number(object.create_count)
          : 0,
      fundingSubaccountId: isSet(object.fundingSubaccountId)
        ? globalThis.String(object.fundingSubaccountId)
        : isSet(object.funding_subaccount_id)
          ? globalThis.String(object.funding_subaccount_id)
          : '0',
    }
  },

  toJSON(message: DeriveLinkSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    if (message.subaccountIds?.length) {
      obj.subaccountIds = message.subaccountIds
    }
    if (message.createCount !== 0) {
      obj.createCount = Math.round(message.createCount)
    }
    if (message.fundingSubaccountId !== '0') {
      obj.fundingSubaccountId = message.fundingSubaccountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveLinkSubaccountsRequest>, I>>(
    base?: I
  ): DeriveLinkSubaccountsRequest {
    return DeriveLinkSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveLinkSubaccountsRequest>, I>>(
    object: I
  ): DeriveLinkSubaccountsRequest {
    const message = createBaseDeriveLinkSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    message.subaccountIds = object.subaccountIds?.map((e) => e) || []
    message.createCount = object.createCount ?? 0
    message.fundingSubaccountId = object.fundingSubaccountId ?? '0'
    return message
  },
}

function createBaseDeriveLinkedSlot(): DeriveLinkedSlot {
  return { subaccountId: '0', accountId: '', accountName: '', ok: false, error: '' }
}

export const DeriveLinkedSlot: MessageFns<DeriveLinkedSlot> = {
  encode(message: DeriveLinkedSlot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subaccountId !== '0') {
      writer.uint32(8).int64(message.subaccountId)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.accountName !== '') {
      writer.uint32(26).string(message.accountName)
    }
    if (message.ok !== false) {
      writer.uint32(32).bool(message.ok)
    }
    if (message.error !== '') {
      writer.uint32(42).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveLinkedSlot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveLinkedSlot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.subaccountId = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.ok = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveLinkedSlot {
    return {
      subaccountId: isSet(object.subaccountId)
        ? globalThis.String(object.subaccountId)
        : isSet(object.subaccount_id)
          ? globalThis.String(object.subaccount_id)
          : '0',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
      ok: isSet(object.ok) ? globalThis.Boolean(object.ok) : false,
      error: isSet(object.error) ? globalThis.String(object.error) : '',
    }
  },

  toJSON(message: DeriveLinkedSlot): unknown {
    const obj: any = {}
    if (message.subaccountId !== '0') {
      obj.subaccountId = message.subaccountId
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    if (message.ok !== false) {
      obj.ok = message.ok
    }
    if (message.error !== '') {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveLinkedSlot>, I>>(base?: I): DeriveLinkedSlot {
    return DeriveLinkedSlot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveLinkedSlot>, I>>(object: I): DeriveLinkedSlot {
    const message = createBaseDeriveLinkedSlot()
    message.subaccountId = object.subaccountId ?? '0'
    message.accountId = object.accountId ?? ''
    message.accountName = object.accountName ?? ''
    message.ok = object.ok ?? false
    message.error = object.error ?? ''
    return message
  },
}

function createBaseDeriveLinkSubaccountsResponse(): DeriveLinkSubaccountsResponse {
  return { slots: [] }
}

export const DeriveLinkSubaccountsResponse: MessageFns<DeriveLinkSubaccountsResponse> = {
  encode(
    message: DeriveLinkSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.slots) {
      DeriveLinkedSlot.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeriveLinkSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeriveLinkSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.slots.push(DeriveLinkedSlot.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeriveLinkSubaccountsResponse {
    return {
      slots: globalThis.Array.isArray(object?.slots)
        ? object.slots.map((e: any) => DeriveLinkedSlot.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DeriveLinkSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.slots?.length) {
      obj.slots = message.slots.map((e) => DeriveLinkedSlot.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeriveLinkSubaccountsResponse>, I>>(
    base?: I
  ): DeriveLinkSubaccountsResponse {
    return DeriveLinkSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeriveLinkSubaccountsResponse>, I>>(
    object: I
  ): DeriveLinkSubaccountsResponse {
    const message = createBaseDeriveLinkSubaccountsResponse()
    message.slots = object.slots?.map((e) => DeriveLinkedSlot.fromPartial(e)) || []
    return message
  },
}

function createBaseLighterListSubaccountsRequest(): LighterListSubaccountsRequest {
  return { accountId: '', l1Address: '' }
}

export const LighterListSubaccountsRequest: MessageFns<LighterListSubaccountsRequest> = {
  encode(
    message: LighterListSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.l1Address !== '') {
      writer.uint32(18).string(message.l1Address)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterListSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterListSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.l1Address = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterListSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      l1Address: isSet(object.l1Address)
        ? globalThis.String(object.l1Address)
        : isSet(object.l1_address)
          ? globalThis.String(object.l1_address)
          : '',
    }
  },

  toJSON(message: LighterListSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.l1Address !== '') {
      obj.l1Address = message.l1Address
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterListSubaccountsRequest>, I>>(
    base?: I
  ): LighterListSubaccountsRequest {
    return LighterListSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterListSubaccountsRequest>, I>>(
    object: I
  ): LighterListSubaccountsRequest {
    const message = createBaseLighterListSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.l1Address = object.l1Address ?? ''
    return message
  },
}

function createBaseLighterSubaccountInfo(): LighterSubaccountInfo {
  return { accountIndex: '0', alreadyLinked: false, linkedAccountId: '', accountType: '' }
}

export const LighterSubaccountInfo: MessageFns<LighterSubaccountInfo> = {
  encode(message: LighterSubaccountInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountIndex !== '0') {
      writer.uint32(8).int64(message.accountIndex)
    }
    if (message.alreadyLinked !== false) {
      writer.uint32(16).bool(message.alreadyLinked)
    }
    if (message.linkedAccountId !== '') {
      writer.uint32(26).string(message.linkedAccountId)
    }
    if (message.accountType !== '') {
      writer.uint32(34).string(message.accountType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterSubaccountInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterSubaccountInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accountIndex = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.alreadyLinked = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.linkedAccountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountType = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterSubaccountInfo {
    return {
      accountIndex: isSet(object.accountIndex)
        ? globalThis.String(object.accountIndex)
        : isSet(object.account_index)
          ? globalThis.String(object.account_index)
          : '0',
      alreadyLinked: isSet(object.alreadyLinked)
        ? globalThis.Boolean(object.alreadyLinked)
        : isSet(object.already_linked)
          ? globalThis.Boolean(object.already_linked)
          : false,
      linkedAccountId: isSet(object.linkedAccountId)
        ? globalThis.String(object.linkedAccountId)
        : isSet(object.linked_account_id)
          ? globalThis.String(object.linked_account_id)
          : '',
      accountType: isSet(object.accountType)
        ? globalThis.String(object.accountType)
        : isSet(object.account_type)
          ? globalThis.String(object.account_type)
          : '',
    }
  },

  toJSON(message: LighterSubaccountInfo): unknown {
    const obj: any = {}
    if (message.accountIndex !== '0') {
      obj.accountIndex = message.accountIndex
    }
    if (message.alreadyLinked !== false) {
      obj.alreadyLinked = message.alreadyLinked
    }
    if (message.linkedAccountId !== '') {
      obj.linkedAccountId = message.linkedAccountId
    }
    if (message.accountType !== '') {
      obj.accountType = message.accountType
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterSubaccountInfo>, I>>(base?: I): LighterSubaccountInfo {
    return LighterSubaccountInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterSubaccountInfo>, I>>(
    object: I
  ): LighterSubaccountInfo {
    const message = createBaseLighterSubaccountInfo()
    message.accountIndex = object.accountIndex ?? '0'
    message.alreadyLinked = object.alreadyLinked ?? false
    message.linkedAccountId = object.linkedAccountId ?? ''
    message.accountType = object.accountType ?? ''
    return message
  },
}

function createBaseLighterListSubaccountsResponse(): LighterListSubaccountsResponse {
  return { subaccounts: [], remainingAccountSlots: 0 }
}

export const LighterListSubaccountsResponse: MessageFns<LighterListSubaccountsResponse> = {
  encode(
    message: LighterListSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.subaccounts) {
      LighterSubaccountInfo.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.remainingAccountSlots !== 0) {
      writer.uint32(16).int32(message.remainingAccountSlots)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterListSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterListSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.subaccounts.push(LighterSubaccountInfo.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.remainingAccountSlots = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterListSubaccountsResponse {
    return {
      subaccounts: globalThis.Array.isArray(object?.subaccounts)
        ? object.subaccounts.map((e: any) => LighterSubaccountInfo.fromJSON(e))
        : [],
      remainingAccountSlots: isSet(object.remainingAccountSlots)
        ? globalThis.Number(object.remainingAccountSlots)
        : isSet(object.remaining_account_slots)
          ? globalThis.Number(object.remaining_account_slots)
          : 0,
    }
  },

  toJSON(message: LighterListSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.subaccounts?.length) {
      obj.subaccounts = message.subaccounts.map((e) => LighterSubaccountInfo.toJSON(e))
    }
    if (message.remainingAccountSlots !== 0) {
      obj.remainingAccountSlots = Math.round(message.remainingAccountSlots)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterListSubaccountsResponse>, I>>(
    base?: I
  ): LighterListSubaccountsResponse {
    return LighterListSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterListSubaccountsResponse>, I>>(
    object: I
  ): LighterListSubaccountsResponse {
    const message = createBaseLighterListSubaccountsResponse()
    message.subaccounts = object.subaccounts?.map((e) => LighterSubaccountInfo.fromPartial(e)) || []
    message.remainingAccountSlots = object.remainingAccountSlots ?? 0
    return message
  },
}

function createBaseLighterPrepareSubaccountKeyRequest(): LighterPrepareSubaccountKeyRequest {
  return { accountId: '', l1Address: '', accountIndex: '0', apiKeyIndex: 0 }
}

export const LighterPrepareSubaccountKeyRequest: MessageFns<LighterPrepareSubaccountKeyRequest> = {
  encode(
    message: LighterPrepareSubaccountKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.l1Address !== '') {
      writer.uint32(18).string(message.l1Address)
    }
    if (message.accountIndex !== '0') {
      writer.uint32(24).int64(message.accountIndex)
    }
    if (message.apiKeyIndex !== 0) {
      writer.uint32(32).uint32(message.apiKeyIndex)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterPrepareSubaccountKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterPrepareSubaccountKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.l1Address = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.accountIndex = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.apiKeyIndex = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterPrepareSubaccountKeyRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      l1Address: isSet(object.l1Address)
        ? globalThis.String(object.l1Address)
        : isSet(object.l1_address)
          ? globalThis.String(object.l1_address)
          : '',
      accountIndex: isSet(object.accountIndex)
        ? globalThis.String(object.accountIndex)
        : isSet(object.account_index)
          ? globalThis.String(object.account_index)
          : '0',
      apiKeyIndex: isSet(object.apiKeyIndex)
        ? globalThis.Number(object.apiKeyIndex)
        : isSet(object.api_key_index)
          ? globalThis.Number(object.api_key_index)
          : 0,
    }
  },

  toJSON(message: LighterPrepareSubaccountKeyRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.l1Address !== '') {
      obj.l1Address = message.l1Address
    }
    if (message.accountIndex !== '0') {
      obj.accountIndex = message.accountIndex
    }
    if (message.apiKeyIndex !== 0) {
      obj.apiKeyIndex = Math.round(message.apiKeyIndex)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterPrepareSubaccountKeyRequest>, I>>(
    base?: I
  ): LighterPrepareSubaccountKeyRequest {
    return LighterPrepareSubaccountKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterPrepareSubaccountKeyRequest>, I>>(
    object: I
  ): LighterPrepareSubaccountKeyRequest {
    const message = createBaseLighterPrepareSubaccountKeyRequest()
    message.accountId = object.accountId ?? ''
    message.l1Address = object.l1Address ?? ''
    message.accountIndex = object.accountIndex ?? '0'
    message.apiKeyIndex = object.apiKeyIndex ?? 0
    return message
  },
}

function createBaseLighterPrepareSubaccountKeyResponse(): LighterPrepareSubaccountKeyResponse {
  return { preparedKeyId: '', personalSignText: '' }
}

export const LighterPrepareSubaccountKeyResponse: MessageFns<LighterPrepareSubaccountKeyResponse> =
  {
    encode(
      message: LighterPrepareSubaccountKeyResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.preparedKeyId !== '') {
        writer.uint32(10).string(message.preparedKeyId)
      }
      if (message.personalSignText !== '') {
        writer.uint32(18).string(message.personalSignText)
      }
      return writer
    },

    decode(input: BinaryReader | Uint8Array, length?: number): LighterPrepareSubaccountKeyResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterPrepareSubaccountKeyResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.preparedKeyId = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.personalSignText = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterPrepareSubaccountKeyResponse {
      return {
        preparedKeyId: isSet(object.preparedKeyId)
          ? globalThis.String(object.preparedKeyId)
          : isSet(object.prepared_key_id)
            ? globalThis.String(object.prepared_key_id)
            : '',
        personalSignText: isSet(object.personalSignText)
          ? globalThis.String(object.personalSignText)
          : isSet(object.personal_sign_text)
            ? globalThis.String(object.personal_sign_text)
            : '',
      }
    },

    toJSON(message: LighterPrepareSubaccountKeyResponse): unknown {
      const obj: any = {}
      if (message.preparedKeyId !== '') {
        obj.preparedKeyId = message.preparedKeyId
      }
      if (message.personalSignText !== '') {
        obj.personalSignText = message.personalSignText
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterPrepareSubaccountKeyResponse>, I>>(
      base?: I
    ): LighterPrepareSubaccountKeyResponse {
      return LighterPrepareSubaccountKeyResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterPrepareSubaccountKeyResponse>, I>>(
      object: I
    ): LighterPrepareSubaccountKeyResponse {
      const message = createBaseLighterPrepareSubaccountKeyResponse()
      message.preparedKeyId = object.preparedKeyId ?? ''
      message.personalSignText = object.personalSignText ?? ''
      return message
    },
  }

function createBaseLighterConfirmSubaccountKeyRequest(): LighterConfirmSubaccountKeyRequest {
  return { preparedKeyId: '', personalSignSignature: '' }
}

export const LighterConfirmSubaccountKeyRequest: MessageFns<LighterConfirmSubaccountKeyRequest> = {
  encode(
    message: LighterConfirmSubaccountKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.preparedKeyId !== '') {
      writer.uint32(10).string(message.preparedKeyId)
    }
    if (message.personalSignSignature !== '') {
      writer.uint32(18).string(message.personalSignSignature)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterConfirmSubaccountKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterConfirmSubaccountKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.preparedKeyId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.personalSignSignature = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterConfirmSubaccountKeyRequest {
    return {
      preparedKeyId: isSet(object.preparedKeyId)
        ? globalThis.String(object.preparedKeyId)
        : isSet(object.prepared_key_id)
          ? globalThis.String(object.prepared_key_id)
          : '',
      personalSignSignature: isSet(object.personalSignSignature)
        ? globalThis.String(object.personalSignSignature)
        : isSet(object.personal_sign_signature)
          ? globalThis.String(object.personal_sign_signature)
          : '',
    }
  },

  toJSON(message: LighterConfirmSubaccountKeyRequest): unknown {
    const obj: any = {}
    if (message.preparedKeyId !== '') {
      obj.preparedKeyId = message.preparedKeyId
    }
    if (message.personalSignSignature !== '') {
      obj.personalSignSignature = message.personalSignSignature
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterConfirmSubaccountKeyRequest>, I>>(
    base?: I
  ): LighterConfirmSubaccountKeyRequest {
    return LighterConfirmSubaccountKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterConfirmSubaccountKeyRequest>, I>>(
    object: I
  ): LighterConfirmSubaccountKeyRequest {
    const message = createBaseLighterConfirmSubaccountKeyRequest()
    message.preparedKeyId = object.preparedKeyId ?? ''
    message.personalSignSignature = object.personalSignSignature ?? ''
    return message
  },
}

function createBaseLighterConfirmSubaccountKeyResponse(): LighterConfirmSubaccountKeyResponse {
  return { ok: false, error: '' }
}

export const LighterConfirmSubaccountKeyResponse: MessageFns<LighterConfirmSubaccountKeyResponse> =
  {
    encode(
      message: LighterConfirmSubaccountKeyResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.ok !== false) {
        writer.uint32(8).bool(message.ok)
      }
      if (message.error !== '') {
        writer.uint32(18).string(message.error)
      }
      return writer
    },

    decode(input: BinaryReader | Uint8Array, length?: number): LighterConfirmSubaccountKeyResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterConfirmSubaccountKeyResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break
            }

            message.ok = reader.bool()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.error = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterConfirmSubaccountKeyResponse {
      return {
        ok: isSet(object.ok) ? globalThis.Boolean(object.ok) : false,
        error: isSet(object.error) ? globalThis.String(object.error) : '',
      }
    },

    toJSON(message: LighterConfirmSubaccountKeyResponse): unknown {
      const obj: any = {}
      if (message.ok !== false) {
        obj.ok = message.ok
      }
      if (message.error !== '') {
        obj.error = message.error
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterConfirmSubaccountKeyResponse>, I>>(
      base?: I
    ): LighterConfirmSubaccountKeyResponse {
      return LighterConfirmSubaccountKeyResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterConfirmSubaccountKeyResponse>, I>>(
      object: I
    ): LighterConfirmSubaccountKeyResponse {
      const message = createBaseLighterConfirmSubaccountKeyResponse()
      message.ok = object.ok ?? false
      message.error = object.error ?? ''
      return message
    },
  }

function createBaseLighterLinkSubaccountsRequest(): LighterLinkSubaccountsRequest {
  return { accountId: '', l1Address: '', links: [] }
}

export const LighterLinkSubaccountsRequest: MessageFns<LighterLinkSubaccountsRequest> = {
  encode(
    message: LighterLinkSubaccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.l1Address !== '') {
      writer.uint32(18).string(message.l1Address)
    }
    for (const v of message.links) {
      LighterSubaccountLink.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterLinkSubaccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterLinkSubaccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.l1Address = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.links.push(LighterSubaccountLink.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterLinkSubaccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      l1Address: isSet(object.l1Address)
        ? globalThis.String(object.l1Address)
        : isSet(object.l1_address)
          ? globalThis.String(object.l1_address)
          : '',
      links: globalThis.Array.isArray(object?.links)
        ? object.links.map((e: any) => LighterSubaccountLink.fromJSON(e))
        : [],
    }
  },

  toJSON(message: LighterLinkSubaccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.l1Address !== '') {
      obj.l1Address = message.l1Address
    }
    if (message.links?.length) {
      obj.links = message.links.map((e) => LighterSubaccountLink.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterLinkSubaccountsRequest>, I>>(
    base?: I
  ): LighterLinkSubaccountsRequest {
    return LighterLinkSubaccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterLinkSubaccountsRequest>, I>>(
    object: I
  ): LighterLinkSubaccountsRequest {
    const message = createBaseLighterLinkSubaccountsRequest()
    message.accountId = object.accountId ?? ''
    message.l1Address = object.l1Address ?? ''
    message.links = object.links?.map((e) => LighterSubaccountLink.fromPartial(e)) || []
    return message
  },
}

function createBaseLighterSubaccountLink(): LighterSubaccountLink {
  return {
    accountIndex: '0',
    apiKeyIndex: 0,
    pastedApiKeySecret: undefined,
    preparedKeyId: undefined,
  }
}

export const LighterSubaccountLink: MessageFns<LighterSubaccountLink> = {
  encode(message: LighterSubaccountLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountIndex !== '0') {
      writer.uint32(8).int64(message.accountIndex)
    }
    if (message.apiKeyIndex !== 0) {
      writer.uint32(16).uint32(message.apiKeyIndex)
    }
    if (message.pastedApiKeySecret !== undefined) {
      writer.uint32(26).string(message.pastedApiKeySecret)
    }
    if (message.preparedKeyId !== undefined) {
      writer.uint32(34).string(message.preparedKeyId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterSubaccountLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterSubaccountLink()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accountIndex = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.apiKeyIndex = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.pastedApiKeySecret = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.preparedKeyId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterSubaccountLink {
    return {
      accountIndex: isSet(object.accountIndex)
        ? globalThis.String(object.accountIndex)
        : isSet(object.account_index)
          ? globalThis.String(object.account_index)
          : '0',
      apiKeyIndex: isSet(object.apiKeyIndex)
        ? globalThis.Number(object.apiKeyIndex)
        : isSet(object.api_key_index)
          ? globalThis.Number(object.api_key_index)
          : 0,
      pastedApiKeySecret: isSet(object.pastedApiKeySecret)
        ? globalThis.String(object.pastedApiKeySecret)
        : isSet(object.pasted_api_key_secret)
          ? globalThis.String(object.pasted_api_key_secret)
          : undefined,
      preparedKeyId: isSet(object.preparedKeyId)
        ? globalThis.String(object.preparedKeyId)
        : isSet(object.prepared_key_id)
          ? globalThis.String(object.prepared_key_id)
          : undefined,
    }
  },

  toJSON(message: LighterSubaccountLink): unknown {
    const obj: any = {}
    if (message.accountIndex !== '0') {
      obj.accountIndex = message.accountIndex
    }
    if (message.apiKeyIndex !== 0) {
      obj.apiKeyIndex = Math.round(message.apiKeyIndex)
    }
    if (message.pastedApiKeySecret !== undefined) {
      obj.pastedApiKeySecret = message.pastedApiKeySecret
    }
    if (message.preparedKeyId !== undefined) {
      obj.preparedKeyId = message.preparedKeyId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterSubaccountLink>, I>>(base?: I): LighterSubaccountLink {
    return LighterSubaccountLink.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterSubaccountLink>, I>>(
    object: I
  ): LighterSubaccountLink {
    const message = createBaseLighterSubaccountLink()
    message.accountIndex = object.accountIndex ?? '0'
    message.apiKeyIndex = object.apiKeyIndex ?? 0
    message.pastedApiKeySecret = object.pastedApiKeySecret ?? undefined
    message.preparedKeyId = object.preparedKeyId ?? undefined
    return message
  },
}

function createBaseLighterLinkedSlot(): LighterLinkedSlot {
  return { accountIndex: '0', accountId: '', accountName: '', ok: false, error: '' }
}

export const LighterLinkedSlot: MessageFns<LighterLinkedSlot> = {
  encode(message: LighterLinkedSlot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountIndex !== '0') {
      writer.uint32(8).int64(message.accountIndex)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.accountName !== '') {
      writer.uint32(26).string(message.accountName)
    }
    if (message.ok !== false) {
      writer.uint32(32).bool(message.ok)
    }
    if (message.error !== '') {
      writer.uint32(42).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterLinkedSlot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterLinkedSlot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accountIndex = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.ok = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterLinkedSlot {
    return {
      accountIndex: isSet(object.accountIndex)
        ? globalThis.String(object.accountIndex)
        : isSet(object.account_index)
          ? globalThis.String(object.account_index)
          : '0',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
      ok: isSet(object.ok) ? globalThis.Boolean(object.ok) : false,
      error: isSet(object.error) ? globalThis.String(object.error) : '',
    }
  },

  toJSON(message: LighterLinkedSlot): unknown {
    const obj: any = {}
    if (message.accountIndex !== '0') {
      obj.accountIndex = message.accountIndex
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    if (message.ok !== false) {
      obj.ok = message.ok
    }
    if (message.error !== '') {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterLinkedSlot>, I>>(base?: I): LighterLinkedSlot {
    return LighterLinkedSlot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterLinkedSlot>, I>>(object: I): LighterLinkedSlot {
    const message = createBaseLighterLinkedSlot()
    message.accountIndex = object.accountIndex ?? '0'
    message.accountId = object.accountId ?? ''
    message.accountName = object.accountName ?? ''
    message.ok = object.ok ?? false
    message.error = object.error ?? ''
    return message
  },
}

function createBaseLighterLinkSubaccountsResponse(): LighterLinkSubaccountsResponse {
  return { slots: [] }
}

export const LighterLinkSubaccountsResponse: MessageFns<LighterLinkSubaccountsResponse> = {
  encode(
    message: LighterLinkSubaccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.slots) {
      LighterLinkedSlot.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LighterLinkSubaccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLighterLinkSubaccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.slots.push(LighterLinkedSlot.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LighterLinkSubaccountsResponse {
    return {
      slots: globalThis.Array.isArray(object?.slots)
        ? object.slots.map((e: any) => LighterLinkedSlot.fromJSON(e))
        : [],
    }
  },

  toJSON(message: LighterLinkSubaccountsResponse): unknown {
    const obj: any = {}
    if (message.slots?.length) {
      obj.slots = message.slots.map((e) => LighterLinkedSlot.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LighterLinkSubaccountsResponse>, I>>(
    base?: I
  ): LighterLinkSubaccountsResponse {
    return LighterLinkSubaccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LighterLinkSubaccountsResponse>, I>>(
    object: I
  ): LighterLinkSubaccountsResponse {
    const message = createBaseLighterLinkSubaccountsResponse()
    message.slots = object.slots?.map((e) => LighterLinkedSlot.fromPartial(e)) || []
    return message
  },
}

function createBaseLighterPrepareIntegratorConsentRequest(): LighterPrepareIntegratorConsentRequest {
  return { accountId: '' }
}

export const LighterPrepareIntegratorConsentRequest: MessageFns<LighterPrepareIntegratorConsentRequest> =
  {
    encode(
      message: LighterPrepareIntegratorConsentRequest,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.accountId !== '') {
        writer.uint32(10).string(message.accountId)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): LighterPrepareIntegratorConsentRequest {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterPrepareIntegratorConsentRequest()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.accountId = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterPrepareIntegratorConsentRequest {
      return {
        accountId: isSet(object.accountId)
          ? globalThis.String(object.accountId)
          : isSet(object.account_id)
            ? globalThis.String(object.account_id)
            : '',
      }
    },

    toJSON(message: LighterPrepareIntegratorConsentRequest): unknown {
      const obj: any = {}
      if (message.accountId !== '') {
        obj.accountId = message.accountId
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterPrepareIntegratorConsentRequest>, I>>(
      base?: I
    ): LighterPrepareIntegratorConsentRequest {
      return LighterPrepareIntegratorConsentRequest.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterPrepareIntegratorConsentRequest>, I>>(
      object: I
    ): LighterPrepareIntegratorConsentRequest {
      const message = createBaseLighterPrepareIntegratorConsentRequest()
      message.accountId = object.accountId ?? ''
      return message
    },
  }

function createBaseLighterPrepareIntegratorConsentResponse(): LighterPrepareIntegratorConsentResponse {
  return {
    preparedConsentId: '',
    personalSignText: '',
    integratorAccountIndex: '0',
    maxFeeUnits: 0,
    alreadyApproved: false,
  }
}

export const LighterPrepareIntegratorConsentResponse: MessageFns<LighterPrepareIntegratorConsentResponse> =
  {
    encode(
      message: LighterPrepareIntegratorConsentResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.preparedConsentId !== '') {
        writer.uint32(10).string(message.preparedConsentId)
      }
      if (message.personalSignText !== '') {
        writer.uint32(18).string(message.personalSignText)
      }
      if (message.integratorAccountIndex !== '0') {
        writer.uint32(24).uint64(message.integratorAccountIndex)
      }
      if (message.maxFeeUnits !== 0) {
        writer.uint32(32).uint32(message.maxFeeUnits)
      }
      if (message.alreadyApproved !== false) {
        writer.uint32(40).bool(message.alreadyApproved)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): LighterPrepareIntegratorConsentResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterPrepareIntegratorConsentResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.preparedConsentId = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.personalSignText = reader.string()
            continue
          }
          case 3: {
            if (tag !== 24) {
              break
            }

            message.integratorAccountIndex = reader.uint64().toString()
            continue
          }
          case 4: {
            if (tag !== 32) {
              break
            }

            message.maxFeeUnits = reader.uint32()
            continue
          }
          case 5: {
            if (tag !== 40) {
              break
            }

            message.alreadyApproved = reader.bool()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterPrepareIntegratorConsentResponse {
      return {
        preparedConsentId: isSet(object.preparedConsentId)
          ? globalThis.String(object.preparedConsentId)
          : isSet(object.prepared_consent_id)
            ? globalThis.String(object.prepared_consent_id)
            : '',
        personalSignText: isSet(object.personalSignText)
          ? globalThis.String(object.personalSignText)
          : isSet(object.personal_sign_text)
            ? globalThis.String(object.personal_sign_text)
            : '',
        integratorAccountIndex: isSet(object.integratorAccountIndex)
          ? globalThis.String(object.integratorAccountIndex)
          : isSet(object.integrator_account_index)
            ? globalThis.String(object.integrator_account_index)
            : '0',
        maxFeeUnits: isSet(object.maxFeeUnits)
          ? globalThis.Number(object.maxFeeUnits)
          : isSet(object.max_fee_units)
            ? globalThis.Number(object.max_fee_units)
            : 0,
        alreadyApproved: isSet(object.alreadyApproved)
          ? globalThis.Boolean(object.alreadyApproved)
          : isSet(object.already_approved)
            ? globalThis.Boolean(object.already_approved)
            : false,
      }
    },

    toJSON(message: LighterPrepareIntegratorConsentResponse): unknown {
      const obj: any = {}
      if (message.preparedConsentId !== '') {
        obj.preparedConsentId = message.preparedConsentId
      }
      if (message.personalSignText !== '') {
        obj.personalSignText = message.personalSignText
      }
      if (message.integratorAccountIndex !== '0') {
        obj.integratorAccountIndex = message.integratorAccountIndex
      }
      if (message.maxFeeUnits !== 0) {
        obj.maxFeeUnits = Math.round(message.maxFeeUnits)
      }
      if (message.alreadyApproved !== false) {
        obj.alreadyApproved = message.alreadyApproved
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterPrepareIntegratorConsentResponse>, I>>(
      base?: I
    ): LighterPrepareIntegratorConsentResponse {
      return LighterPrepareIntegratorConsentResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterPrepareIntegratorConsentResponse>, I>>(
      object: I
    ): LighterPrepareIntegratorConsentResponse {
      const message = createBaseLighterPrepareIntegratorConsentResponse()
      message.preparedConsentId = object.preparedConsentId ?? ''
      message.personalSignText = object.personalSignText ?? ''
      message.integratorAccountIndex = object.integratorAccountIndex ?? '0'
      message.maxFeeUnits = object.maxFeeUnits ?? 0
      message.alreadyApproved = object.alreadyApproved ?? false
      return message
    },
  }

function createBaseLighterConfirmIntegratorConsentRequest(): LighterConfirmIntegratorConsentRequest {
  return { preparedConsentId: '', personalSignSignature: '' }
}

export const LighterConfirmIntegratorConsentRequest: MessageFns<LighterConfirmIntegratorConsentRequest> =
  {
    encode(
      message: LighterConfirmIntegratorConsentRequest,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.preparedConsentId !== '') {
        writer.uint32(10).string(message.preparedConsentId)
      }
      if (message.personalSignSignature !== '') {
        writer.uint32(18).string(message.personalSignSignature)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): LighterConfirmIntegratorConsentRequest {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterConfirmIntegratorConsentRequest()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.preparedConsentId = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.personalSignSignature = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterConfirmIntegratorConsentRequest {
      return {
        preparedConsentId: isSet(object.preparedConsentId)
          ? globalThis.String(object.preparedConsentId)
          : isSet(object.prepared_consent_id)
            ? globalThis.String(object.prepared_consent_id)
            : '',
        personalSignSignature: isSet(object.personalSignSignature)
          ? globalThis.String(object.personalSignSignature)
          : isSet(object.personal_sign_signature)
            ? globalThis.String(object.personal_sign_signature)
            : '',
      }
    },

    toJSON(message: LighterConfirmIntegratorConsentRequest): unknown {
      const obj: any = {}
      if (message.preparedConsentId !== '') {
        obj.preparedConsentId = message.preparedConsentId
      }
      if (message.personalSignSignature !== '') {
        obj.personalSignSignature = message.personalSignSignature
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterConfirmIntegratorConsentRequest>, I>>(
      base?: I
    ): LighterConfirmIntegratorConsentRequest {
      return LighterConfirmIntegratorConsentRequest.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterConfirmIntegratorConsentRequest>, I>>(
      object: I
    ): LighterConfirmIntegratorConsentRequest {
      const message = createBaseLighterConfirmIntegratorConsentRequest()
      message.preparedConsentId = object.preparedConsentId ?? ''
      message.personalSignSignature = object.personalSignSignature ?? ''
      return message
    },
  }

function createBaseLighterConfirmIntegratorConsentResponse(): LighterConfirmIntegratorConsentResponse {
  return { ok: false, error: '' }
}

export const LighterConfirmIntegratorConsentResponse: MessageFns<LighterConfirmIntegratorConsentResponse> =
  {
    encode(
      message: LighterConfirmIntegratorConsentResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.ok !== false) {
        writer.uint32(8).bool(message.ok)
      }
      if (message.error !== '') {
        writer.uint32(18).string(message.error)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): LighterConfirmIntegratorConsentResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseLighterConfirmIntegratorConsentResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break
            }

            message.ok = reader.bool()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.error = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): LighterConfirmIntegratorConsentResponse {
      return {
        ok: isSet(object.ok) ? globalThis.Boolean(object.ok) : false,
        error: isSet(object.error) ? globalThis.String(object.error) : '',
      }
    },

    toJSON(message: LighterConfirmIntegratorConsentResponse): unknown {
      const obj: any = {}
      if (message.ok !== false) {
        obj.ok = message.ok
      }
      if (message.error !== '') {
        obj.error = message.error
      }
      return obj
    },

    create<I extends Exact<DeepPartial<LighterConfirmIntegratorConsentResponse>, I>>(
      base?: I
    ): LighterConfirmIntegratorConsentResponse {
      return LighterConfirmIntegratorConsentResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<LighterConfirmIntegratorConsentResponse>, I>>(
      object: I
    ): LighterConfirmIntegratorConsentResponse {
      const message = createBaseLighterConfirmIntegratorConsentResponse()
      message.ok = object.ok ?? false
      message.error = object.error ?? ''
      return message
    },
  }

function createBaseSetLeverageRequest(): SetLeverageRequest {
  return { accountId: '', instrument: '', leverage: 0 }
}

export const SetLeverageRequest: MessageFns<SetLeverageRequest> = {
  encode(message: SetLeverageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.instrument !== '') {
      writer.uint32(18).string(message.instrument)
    }
    if (message.leverage !== 0) {
      writer.uint32(24).uint32(message.leverage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetLeverageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetLeverageRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.leverage = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetLeverageRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : '',
      leverage: isSet(object.leverage) ? globalThis.Number(object.leverage) : 0,
    }
  },

  toJSON(message: SetLeverageRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.instrument !== '') {
      obj.instrument = message.instrument
    }
    if (message.leverage !== 0) {
      obj.leverage = Math.round(message.leverage)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetLeverageRequest>, I>>(base?: I): SetLeverageRequest {
    return SetLeverageRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetLeverageRequest>, I>>(object: I): SetLeverageRequest {
    const message = createBaseSetLeverageRequest()
    message.accountId = object.accountId ?? ''
    message.instrument = object.instrument ?? ''
    message.leverage = object.leverage ?? 0
    return message
  },
}

function createBaseSetLeverageResponse(): SetLeverageResponse {
  return { accountId: '', instrument: '', leverage: 0 }
}

export const SetLeverageResponse: MessageFns<SetLeverageResponse> = {
  encode(message: SetLeverageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.instrument !== '') {
      writer.uint32(18).string(message.instrument)
    }
    if (message.leverage !== 0) {
      writer.uint32(24).uint32(message.leverage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetLeverageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetLeverageResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.leverage = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetLeverageResponse {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : '',
      leverage: isSet(object.leverage) ? globalThis.Number(object.leverage) : 0,
    }
  },

  toJSON(message: SetLeverageResponse): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.instrument !== '') {
      obj.instrument = message.instrument
    }
    if (message.leverage !== 0) {
      obj.leverage = Math.round(message.leverage)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetLeverageResponse>, I>>(base?: I): SetLeverageResponse {
    return SetLeverageResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetLeverageResponse>, I>>(
    object: I
  ): SetLeverageResponse {
    const message = createBaseSetLeverageResponse()
    message.accountId = object.accountId ?? ''
    message.instrument = object.instrument ?? ''
    message.leverage = object.leverage ?? 0
    return message
  },
}

function createBaseGetAccountSettingsRequest(): GetAccountSettingsRequest {
  return { accountId: '' }
}

export const GetAccountSettingsRequest: MessageFns<GetAccountSettingsRequest> = {
  encode(
    message: GetAccountSettingsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAccountSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetAccountSettingsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetAccountSettingsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: GetAccountSettingsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetAccountSettingsRequest>, I>>(
    base?: I
  ): GetAccountSettingsRequest {
    return GetAccountSettingsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountSettingsRequest>, I>>(
    object: I
  ): GetAccountSettingsRequest {
    const message = createBaseGetAccountSettingsRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseAccountSettings(): AccountSettings {
  return { accountId: '', leverage: {}, defaultLeverage: undefined }
}

export const AccountSettings: MessageFns<AccountSettings> = {
  encode(message: AccountSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    globalThis.Object.entries(message.leverage).forEach(([key, value]: [string, number]) => {
      AccountSettings_LeverageEntry.encode(
        { key: key as any, value },
        writer.uint32(18).fork()
      ).join()
    })
    if (message.defaultLeverage !== undefined) {
      writer.uint32(24).uint32(message.defaultLeverage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountSettings()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          const entry2 = AccountSettings_LeverageEntry.decode(reader, reader.uint32())
          if (entry2.value !== undefined) {
            message.leverage[entry2.key] = entry2.value
          }
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.defaultLeverage = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountSettings {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      leverage: isObject(object.leverage)
        ? (globalThis.Object.entries(object.leverage) as [string, any][]).reduce(
            (acc: { [key: string]: number }, [key, value]: [string, any]) => {
              acc[key] = globalThis.Number(value)
              return acc
            },
            {}
          )
        : {},
      defaultLeverage: isSet(object.defaultLeverage)
        ? globalThis.Number(object.defaultLeverage)
        : isSet(object.default_leverage)
          ? globalThis.Number(object.default_leverage)
          : undefined,
    }
  },

  toJSON(message: AccountSettings): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.leverage) {
      const entries = globalThis.Object.entries(message.leverage) as [string, number][]
      if (entries.length > 0) {
        obj.leverage = {}
        entries.forEach(([k, v]) => {
          obj.leverage[k] = Math.round(v)
        })
      }
    }
    if (message.defaultLeverage !== undefined) {
      obj.defaultLeverage = Math.round(message.defaultLeverage)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountSettings>, I>>(base?: I): AccountSettings {
    return AccountSettings.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountSettings>, I>>(object: I): AccountSettings {
    const message = createBaseAccountSettings()
    message.accountId = object.accountId ?? ''
    message.leverage = (
      globalThis.Object.entries(object.leverage ?? {}) as [string, number][]
    ).reduce((acc: { [key: string]: number }, [key, value]: [string, number]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value)
      }
      return acc
    }, {})
    message.defaultLeverage = object.defaultLeverage ?? undefined
    return message
  },
}

function createBaseAccountSettings_LeverageEntry(): AccountSettings_LeverageEntry {
  return { key: '', value: 0 }
}

export const AccountSettings_LeverageEntry: MessageFns<AccountSettings_LeverageEntry> = {
  encode(
    message: AccountSettings_LeverageEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== 0) {
      writer.uint32(16).uint32(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountSettings_LeverageEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountSettings_LeverageEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.value = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountSettings_LeverageEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    }
  },

  toJSON(message: AccountSettings_LeverageEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountSettings_LeverageEntry>, I>>(
    base?: I
  ): AccountSettings_LeverageEntry {
    return AccountSettings_LeverageEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountSettings_LeverageEntry>, I>>(
    object: I
  ): AccountSettings_LeverageEntry {
    const message = createBaseAccountSettings_LeverageEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? 0
    return message
  },
}

function createBasePapertradePrepareSessionKeyRequest(): PapertradePrepareSessionKeyRequest {
  return { accountId: '', walletAddress: '' }
}

export const PapertradePrepareSessionKeyRequest: MessageFns<PapertradePrepareSessionKeyRequest> = {
  encode(
    message: PapertradePrepareSessionKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PapertradePrepareSessionKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePapertradePrepareSessionKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PapertradePrepareSessionKeyRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
    }
  },

  toJSON(message: PapertradePrepareSessionKeyRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PapertradePrepareSessionKeyRequest>, I>>(
    base?: I
  ): PapertradePrepareSessionKeyRequest {
    return PapertradePrepareSessionKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PapertradePrepareSessionKeyRequest>, I>>(
    object: I
  ): PapertradePrepareSessionKeyRequest {
    const message = createBasePapertradePrepareSessionKeyRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    return message
  },
}

function createBasePapertradePrepareSessionKeyResponse(): PapertradePrepareSessionKeyResponse {
  return {
    sessionKeyAddress: '',
    typedDataJson: '',
    chainId: 0,
    registrationExpiryUnixSeconds: '0',
  }
}

export const PapertradePrepareSessionKeyResponse: MessageFns<PapertradePrepareSessionKeyResponse> =
  {
    encode(
      message: PapertradePrepareSessionKeyResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.sessionKeyAddress !== '') {
        writer.uint32(10).string(message.sessionKeyAddress)
      }
      if (message.typedDataJson !== '') {
        writer.uint32(18).string(message.typedDataJson)
      }
      if (message.chainId !== 0) {
        writer.uint32(24).uint32(message.chainId)
      }
      if (message.registrationExpiryUnixSeconds !== '0') {
        writer.uint32(32).uint64(message.registrationExpiryUnixSeconds)
      }
      return writer
    },

    decode(input: BinaryReader | Uint8Array, length?: number): PapertradePrepareSessionKeyResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBasePapertradePrepareSessionKeyResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.sessionKeyAddress = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.typedDataJson = reader.string()
            continue
          }
          case 3: {
            if (tag !== 24) {
              break
            }

            message.chainId = reader.uint32()
            continue
          }
          case 4: {
            if (tag !== 32) {
              break
            }

            message.registrationExpiryUnixSeconds = reader.uint64().toString()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): PapertradePrepareSessionKeyResponse {
      return {
        sessionKeyAddress: isSet(object.sessionKeyAddress)
          ? globalThis.String(object.sessionKeyAddress)
          : isSet(object.session_key_address)
            ? globalThis.String(object.session_key_address)
            : '',
        typedDataJson: isSet(object.typedDataJson)
          ? globalThis.String(object.typedDataJson)
          : isSet(object.typed_data_json)
            ? globalThis.String(object.typed_data_json)
            : '',
        chainId: isSet(object.chainId)
          ? globalThis.Number(object.chainId)
          : isSet(object.chain_id)
            ? globalThis.Number(object.chain_id)
            : 0,
        registrationExpiryUnixSeconds: isSet(object.registrationExpiryUnixSeconds)
          ? globalThis.String(object.registrationExpiryUnixSeconds)
          : isSet(object.registration_expiry_unix_seconds)
            ? globalThis.String(object.registration_expiry_unix_seconds)
            : '0',
      }
    },

    toJSON(message: PapertradePrepareSessionKeyResponse): unknown {
      const obj: any = {}
      if (message.sessionKeyAddress !== '') {
        obj.sessionKeyAddress = message.sessionKeyAddress
      }
      if (message.typedDataJson !== '') {
        obj.typedDataJson = message.typedDataJson
      }
      if (message.chainId !== 0) {
        obj.chainId = Math.round(message.chainId)
      }
      if (message.registrationExpiryUnixSeconds !== '0') {
        obj.registrationExpiryUnixSeconds = message.registrationExpiryUnixSeconds
      }
      return obj
    },

    create<I extends Exact<DeepPartial<PapertradePrepareSessionKeyResponse>, I>>(
      base?: I
    ): PapertradePrepareSessionKeyResponse {
      return PapertradePrepareSessionKeyResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<PapertradePrepareSessionKeyResponse>, I>>(
      object: I
    ): PapertradePrepareSessionKeyResponse {
      const message = createBasePapertradePrepareSessionKeyResponse()
      message.sessionKeyAddress = object.sessionKeyAddress ?? ''
      message.typedDataJson = object.typedDataJson ?? ''
      message.chainId = object.chainId ?? 0
      message.registrationExpiryUnixSeconds = object.registrationExpiryUnixSeconds ?? '0'
      return message
    },
  }

function createBasePapertradeConfirmSessionKeyRequest(): PapertradeConfirmSessionKeyRequest {
  return { accountId: '', walletAddress: '', signature: '' }
}

export const PapertradeConfirmSessionKeyRequest: MessageFns<PapertradeConfirmSessionKeyRequest> = {
  encode(
    message: PapertradeConfirmSessionKeyRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.walletAddress !== '') {
      writer.uint32(18).string(message.walletAddress)
    }
    if (message.signature !== '') {
      writer.uint32(26).string(message.signature)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PapertradeConfirmSessionKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePapertradeConfirmSessionKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.walletAddress = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.signature = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PapertradeConfirmSessionKeyRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      walletAddress: isSet(object.walletAddress)
        ? globalThis.String(object.walletAddress)
        : isSet(object.wallet_address)
          ? globalThis.String(object.wallet_address)
          : '',
      signature: isSet(object.signature) ? globalThis.String(object.signature) : '',
    }
  },

  toJSON(message: PapertradeConfirmSessionKeyRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.walletAddress !== '') {
      obj.walletAddress = message.walletAddress
    }
    if (message.signature !== '') {
      obj.signature = message.signature
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PapertradeConfirmSessionKeyRequest>, I>>(
    base?: I
  ): PapertradeConfirmSessionKeyRequest {
    return PapertradeConfirmSessionKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PapertradeConfirmSessionKeyRequest>, I>>(
    object: I
  ): PapertradeConfirmSessionKeyRequest {
    const message = createBasePapertradeConfirmSessionKeyRequest()
    message.accountId = object.accountId ?? ''
    message.walletAddress = object.walletAddress ?? ''
    message.signature = object.signature ?? ''
    return message
  },
}

function createBasePapertradeDisconnectRequest(): PapertradeDisconnectRequest {
  return { accountId: '' }
}

export const PapertradeDisconnectRequest: MessageFns<PapertradeDisconnectRequest> = {
  encode(
    message: PapertradeDisconnectRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PapertradeDisconnectRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePapertradeDisconnectRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PapertradeDisconnectRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: PapertradeDisconnectRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PapertradeDisconnectRequest>, I>>(
    base?: I
  ): PapertradeDisconnectRequest {
    return PapertradeDisconnectRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PapertradeDisconnectRequest>, I>>(
    object: I
  ): PapertradeDisconnectRequest {
    const message = createBasePapertradeDisconnectRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseParadigmAccountInfo(): ParadigmAccountInfo {
  return {
    accountName: '',
    paradigmTradeCount: 0,
    matchedTradeCount: 0,
    lastTradedAtMs: undefined,
    evidence: 0,
    matchedAccountIds: [],
  }
}

export const ParadigmAccountInfo: MessageFns<ParadigmAccountInfo> = {
  encode(message: ParadigmAccountInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountName !== '') {
      writer.uint32(10).string(message.accountName)
    }
    if (message.paradigmTradeCount !== 0) {
      writer.uint32(16).int32(message.paradigmTradeCount)
    }
    if (message.matchedTradeCount !== 0) {
      writer.uint32(24).int32(message.matchedTradeCount)
    }
    if (message.lastTradedAtMs !== undefined) {
      writer.uint32(32).int64(message.lastTradedAtMs)
    }
    if (message.evidence !== 0) {
      writer.uint32(40).int32(message.evidence)
    }
    for (const v of message.matchedAccountIds) {
      writer.uint32(50).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmAccountInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmAccountInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountName = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.paradigmTradeCount = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.matchedTradeCount = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.lastTradedAtMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.evidence = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.matchedAccountIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmAccountInfo {
    return {
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
      paradigmTradeCount: isSet(object.paradigmTradeCount)
        ? globalThis.Number(object.paradigmTradeCount)
        : isSet(object.paradigm_trade_count)
          ? globalThis.Number(object.paradigm_trade_count)
          : 0,
      matchedTradeCount: isSet(object.matchedTradeCount)
        ? globalThis.Number(object.matchedTradeCount)
        : isSet(object.matched_trade_count)
          ? globalThis.Number(object.matched_trade_count)
          : 0,
      lastTradedAtMs: isSet(object.lastTradedAtMs)
        ? globalThis.String(object.lastTradedAtMs)
        : isSet(object.last_traded_at_ms)
          ? globalThis.String(object.last_traded_at_ms)
          : undefined,
      evidence: isSet(object.evidence) ? paradigmBindingEvidenceFromJSON(object.evidence) : 0,
      matchedAccountIds: globalThis.Array.isArray(object?.matchedAccountIds)
        ? object.matchedAccountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.matched_account_ids)
          ? object.matched_account_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: ParadigmAccountInfo): unknown {
    const obj: any = {}
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    if (message.paradigmTradeCount !== 0) {
      obj.paradigmTradeCount = Math.round(message.paradigmTradeCount)
    }
    if (message.matchedTradeCount !== 0) {
      obj.matchedTradeCount = Math.round(message.matchedTradeCount)
    }
    if (message.lastTradedAtMs !== undefined) {
      obj.lastTradedAtMs = message.lastTradedAtMs
    }
    if (message.evidence !== 0) {
      obj.evidence = paradigmBindingEvidenceToJSON(message.evidence)
    }
    if (message.matchedAccountIds?.length) {
      obj.matchedAccountIds = message.matchedAccountIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmAccountInfo>, I>>(base?: I): ParadigmAccountInfo {
    return ParadigmAccountInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmAccountInfo>, I>>(
    object: I
  ): ParadigmAccountInfo {
    const message = createBaseParadigmAccountInfo()
    message.accountName = object.accountName ?? ''
    message.paradigmTradeCount = object.paradigmTradeCount ?? 0
    message.matchedTradeCount = object.matchedTradeCount ?? 0
    message.lastTradedAtMs = object.lastTradedAtMs ?? undefined
    message.evidence = object.evidence ?? 0
    message.matchedAccountIds = object.matchedAccountIds?.map((e) => e) || []
    return message
  },
}

function createBaseParadigmConnectDeskRequest(): ParadigmConnectDeskRequest {
  return { accountId: '', accessKey: '', secretKey: '' }
}

export const ParadigmConnectDeskRequest: MessageFns<ParadigmConnectDeskRequest> = {
  encode(
    message: ParadigmConnectDeskRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.accessKey !== '') {
      writer.uint32(18).string(message.accessKey)
    }
    if (message.secretKey !== '') {
      writer.uint32(26).string(message.secretKey)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmConnectDeskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmConnectDeskRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessKey = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.secretKey = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmConnectDeskRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accessKey: isSet(object.accessKey)
        ? globalThis.String(object.accessKey)
        : isSet(object.access_key)
          ? globalThis.String(object.access_key)
          : '',
      secretKey: isSet(object.secretKey)
        ? globalThis.String(object.secretKey)
        : isSet(object.secret_key)
          ? globalThis.String(object.secret_key)
          : '',
    }
  },

  toJSON(message: ParadigmConnectDeskRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accessKey !== '') {
      obj.accessKey = message.accessKey
    }
    if (message.secretKey !== '') {
      obj.secretKey = message.secretKey
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmConnectDeskRequest>, I>>(
    base?: I
  ): ParadigmConnectDeskRequest {
    return ParadigmConnectDeskRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmConnectDeskRequest>, I>>(
    object: I
  ): ParadigmConnectDeskRequest {
    const message = createBaseParadigmConnectDeskRequest()
    message.accountId = object.accountId ?? ''
    message.accessKey = object.accessKey ?? ''
    message.secretKey = object.secretKey ?? ''
    return message
  },
}

function createBaseParadigmConnectDeskResponse(): ParadigmConnectDeskResponse {
  return { deskId: '', deskName: undefined }
}

export const ParadigmConnectDeskResponse: MessageFns<ParadigmConnectDeskResponse> = {
  encode(
    message: ParadigmConnectDeskResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.deskId !== '') {
      writer.uint32(10).string(message.deskId)
    }
    if (message.deskName !== undefined) {
      writer.uint32(18).string(message.deskName)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmConnectDeskResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmConnectDeskResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.deskId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deskName = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmConnectDeskResponse {
    return {
      deskId: isSet(object.deskId)
        ? globalThis.String(object.deskId)
        : isSet(object.desk_id)
          ? globalThis.String(object.desk_id)
          : '',
      deskName: isSet(object.deskName)
        ? globalThis.String(object.deskName)
        : isSet(object.desk_name)
          ? globalThis.String(object.desk_name)
          : undefined,
    }
  },

  toJSON(message: ParadigmConnectDeskResponse): unknown {
    const obj: any = {}
    if (message.deskId !== '') {
      obj.deskId = message.deskId
    }
    if (message.deskName !== undefined) {
      obj.deskName = message.deskName
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmConnectDeskResponse>, I>>(
    base?: I
  ): ParadigmConnectDeskResponse {
    return ParadigmConnectDeskResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmConnectDeskResponse>, I>>(
    object: I
  ): ParadigmConnectDeskResponse {
    const message = createBaseParadigmConnectDeskResponse()
    message.deskId = object.deskId ?? ''
    message.deskName = object.deskName ?? undefined
    return message
  },
}

function createBaseParadigmListAccountsRequest(): ParadigmListAccountsRequest {
  return { accountId: '' }
}

export const ParadigmListAccountsRequest: MessageFns<ParadigmListAccountsRequest> = {
  encode(
    message: ParadigmListAccountsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmListAccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmListAccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmListAccountsRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: ParadigmListAccountsRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmListAccountsRequest>, I>>(
    base?: I
  ): ParadigmListAccountsRequest {
    return ParadigmListAccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmListAccountsRequest>, I>>(
    object: I
  ): ParadigmListAccountsRequest {
    const message = createBaseParadigmListAccountsRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseParadigmListAccountsResponse(): ParadigmListAccountsResponse {
  return { accounts: [] }
}

export const ParadigmListAccountsResponse: MessageFns<ParadigmListAccountsResponse> = {
  encode(
    message: ParadigmListAccountsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.accounts) {
      ParadigmAccountInfo.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmListAccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmListAccountsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accounts.push(ParadigmAccountInfo.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmListAccountsResponse {
    return {
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => ParadigmAccountInfo.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ParadigmListAccountsResponse): unknown {
    const obj: any = {}
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => ParadigmAccountInfo.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmListAccountsResponse>, I>>(
    base?: I
  ): ParadigmListAccountsResponse {
    return ParadigmListAccountsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmListAccountsResponse>, I>>(
    object: I
  ): ParadigmListAccountsResponse {
    const message = createBaseParadigmListAccountsResponse()
    message.accounts = object.accounts?.map((e) => ParadigmAccountInfo.fromPartial(e)) || []
    return message
  },
}

function createBaseParadigmLinkAccountRequest(): ParadigmLinkAccountRequest {
  return { accountId: '', accountName: '' }
}

export const ParadigmLinkAccountRequest: MessageFns<ParadigmLinkAccountRequest> = {
  encode(
    message: ParadigmLinkAccountRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.accountName !== '') {
      writer.uint32(18).string(message.accountName)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmLinkAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmLinkAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountName = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmLinkAccountRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
    }
  },

  toJSON(message: ParadigmLinkAccountRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmLinkAccountRequest>, I>>(
    base?: I
  ): ParadigmLinkAccountRequest {
    return ParadigmLinkAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmLinkAccountRequest>, I>>(
    object: I
  ): ParadigmLinkAccountRequest {
    const message = createBaseParadigmLinkAccountRequest()
    message.accountId = object.accountId ?? ''
    message.accountName = object.accountName ?? ''
    return message
  },
}

function createBaseParadigmLinkAccountResponse(): ParadigmLinkAccountResponse {
  return { state: 0 }
}

export const ParadigmLinkAccountResponse: MessageFns<ParadigmLinkAccountResponse> = {
  encode(
    message: ParadigmLinkAccountResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmLinkAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmLinkAccountResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmLinkAccountResponse {
    return { state: isSet(object.state) ? paradigmBindingStateFromJSON(object.state) : 0 }
  },

  toJSON(message: ParadigmLinkAccountResponse): unknown {
    const obj: any = {}
    if (message.state !== 0) {
      obj.state = paradigmBindingStateToJSON(message.state)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmLinkAccountResponse>, I>>(
    base?: I
  ): ParadigmLinkAccountResponse {
    return ParadigmLinkAccountResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmLinkAccountResponse>, I>>(
    object: I
  ): ParadigmLinkAccountResponse {
    const message = createBaseParadigmLinkAccountResponse()
    message.state = object.state ?? 0
    return message
  },
}

function createBaseParadigmDisconnectRequest(): ParadigmDisconnectRequest {
  return { accountId: '' }
}

export const ParadigmDisconnectRequest: MessageFns<ParadigmDisconnectRequest> = {
  encode(
    message: ParadigmDisconnectRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmDisconnectRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmDisconnectRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmDisconnectRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: ParadigmDisconnectRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmDisconnectRequest>, I>>(
    base?: I
  ): ParadigmDisconnectRequest {
    return ParadigmDisconnectRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmDisconnectRequest>, I>>(
    object: I
  ): ParadigmDisconnectRequest {
    const message = createBaseParadigmDisconnectRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseCancelPendingAccountRequest(): CancelPendingAccountRequest {
  return { accountId: '' }
}

export const CancelPendingAccountRequest: MessageFns<CancelPendingAccountRequest> = {
  encode(
    message: CancelPendingAccountRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelPendingAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelPendingAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelPendingAccountRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: CancelPendingAccountRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelPendingAccountRequest>, I>>(
    base?: I
  ): CancelPendingAccountRequest {
    return CancelPendingAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelPendingAccountRequest>, I>>(
    object: I
  ): CancelPendingAccountRequest {
    const message = createBaseCancelPendingAccountRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseCreateCheckoutSessionRequest(): CreateCheckoutSessionRequest {
  return { successUrl: '', cancelUrl: '', priceId: '' }
}

export const CreateCheckoutSessionRequest: MessageFns<CreateCheckoutSessionRequest> = {
  encode(
    message: CreateCheckoutSessionRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.successUrl !== '') {
      writer.uint32(18).string(message.successUrl)
    }
    if (message.cancelUrl !== '') {
      writer.uint32(26).string(message.cancelUrl)
    }
    if (message.priceId !== '') {
      writer.uint32(34).string(message.priceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCheckoutSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateCheckoutSessionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.successUrl = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.cancelUrl = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.priceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateCheckoutSessionRequest {
    return {
      successUrl: isSet(object.successUrl)
        ? globalThis.String(object.successUrl)
        : isSet(object.success_url)
          ? globalThis.String(object.success_url)
          : '',
      cancelUrl: isSet(object.cancelUrl)
        ? globalThis.String(object.cancelUrl)
        : isSet(object.cancel_url)
          ? globalThis.String(object.cancel_url)
          : '',
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
          ? globalThis.String(object.price_id)
          : '',
    }
  },

  toJSON(message: CreateCheckoutSessionRequest): unknown {
    const obj: any = {}
    if (message.successUrl !== '') {
      obj.successUrl = message.successUrl
    }
    if (message.cancelUrl !== '') {
      obj.cancelUrl = message.cancelUrl
    }
    if (message.priceId !== '') {
      obj.priceId = message.priceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateCheckoutSessionRequest>, I>>(
    base?: I
  ): CreateCheckoutSessionRequest {
    return CreateCheckoutSessionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateCheckoutSessionRequest>, I>>(
    object: I
  ): CreateCheckoutSessionRequest {
    const message = createBaseCreateCheckoutSessionRequest()
    message.successUrl = object.successUrl ?? ''
    message.cancelUrl = object.cancelUrl ?? ''
    message.priceId = object.priceId ?? ''
    return message
  },
}

function createBaseCreateCheckoutSessionResponse(): CreateCheckoutSessionResponse {
  return { checkoutUrl: '' }
}

export const CreateCheckoutSessionResponse: MessageFns<CreateCheckoutSessionResponse> = {
  encode(
    message: CreateCheckoutSessionResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.checkoutUrl !== '') {
      writer.uint32(10).string(message.checkoutUrl)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCheckoutSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateCheckoutSessionResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.checkoutUrl = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateCheckoutSessionResponse {
    return {
      checkoutUrl: isSet(object.checkoutUrl)
        ? globalThis.String(object.checkoutUrl)
        : isSet(object.checkout_url)
          ? globalThis.String(object.checkout_url)
          : '',
    }
  },

  toJSON(message: CreateCheckoutSessionResponse): unknown {
    const obj: any = {}
    if (message.checkoutUrl !== '') {
      obj.checkoutUrl = message.checkoutUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateCheckoutSessionResponse>, I>>(
    base?: I
  ): CreateCheckoutSessionResponse {
    return CreateCheckoutSessionResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateCheckoutSessionResponse>, I>>(
    object: I
  ): CreateCheckoutSessionResponse {
    const message = createBaseCreateCheckoutSessionResponse()
    message.checkoutUrl = object.checkoutUrl ?? ''
    return message
  },
}

function createBaseGetSubscriptionRequest(): GetSubscriptionRequest {
  return {}
}

export const GetSubscriptionRequest: MessageFns<GetSubscriptionRequest> = {
  encode(_: GetSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSubscriptionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetSubscriptionRequest {
    return {}
  },

  toJSON(_: GetSubscriptionRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetSubscriptionRequest>, I>>(
    base?: I
  ): GetSubscriptionRequest {
    return GetSubscriptionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSubscriptionRequest>, I>>(
    _: I
  ): GetSubscriptionRequest {
    const message = createBaseGetSubscriptionRequest()
    return message
  },
}

function createBaseGetSubscriptionResponse(): GetSubscriptionResponse {
  return {
    status: '',
    planLevel: 0,
    currentPeriodEnd: '0',
    cancelAtPeriodEnd: false,
    capabilities: undefined,
    planLabel: '',
    trialEligible: false,
    subscriptionActive: false,
  }
}

export const GetSubscriptionResponse: MessageFns<GetSubscriptionResponse> = {
  encode(
    message: GetSubscriptionResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.status !== '') {
      writer.uint32(10).string(message.status)
    }
    if (message.planLevel !== 0) {
      writer.uint32(16).int32(message.planLevel)
    }
    if (message.currentPeriodEnd !== '0') {
      writer.uint32(24).int64(message.currentPeriodEnd)
    }
    if (message.cancelAtPeriodEnd !== false) {
      writer.uint32(32).bool(message.cancelAtPeriodEnd)
    }
    if (message.capabilities !== undefined) {
      Capabilities.encode(message.capabilities, writer.uint32(42).fork()).join()
    }
    if (message.planLabel !== '') {
      writer.uint32(50).string(message.planLabel)
    }
    if (message.trialEligible !== false) {
      writer.uint32(56).bool(message.trialEligible)
    }
    if (message.subscriptionActive !== false) {
      writer.uint32(64).bool(message.subscriptionActive)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSubscriptionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSubscriptionResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.status = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.planLevel = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.currentPeriodEnd = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.cancelAtPeriodEnd = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.capabilities = Capabilities.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.planLabel = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.trialEligible = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.subscriptionActive = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetSubscriptionResponse {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : '',
      planLevel: isSet(object.planLevel)
        ? planLevelFromJSON(object.planLevel)
        : isSet(object.plan_level)
          ? planLevelFromJSON(object.plan_level)
          : 0,
      currentPeriodEnd: isSet(object.currentPeriodEnd)
        ? globalThis.String(object.currentPeriodEnd)
        : isSet(object.current_period_end)
          ? globalThis.String(object.current_period_end)
          : '0',
      cancelAtPeriodEnd: isSet(object.cancelAtPeriodEnd)
        ? globalThis.Boolean(object.cancelAtPeriodEnd)
        : isSet(object.cancel_at_period_end)
          ? globalThis.Boolean(object.cancel_at_period_end)
          : false,
      capabilities: isSet(object.capabilities)
        ? Capabilities.fromJSON(object.capabilities)
        : undefined,
      planLabel: isSet(object.planLabel)
        ? globalThis.String(object.planLabel)
        : isSet(object.plan_label)
          ? globalThis.String(object.plan_label)
          : '',
      trialEligible: isSet(object.trialEligible)
        ? globalThis.Boolean(object.trialEligible)
        : isSet(object.trial_eligible)
          ? globalThis.Boolean(object.trial_eligible)
          : false,
      subscriptionActive: isSet(object.subscriptionActive)
        ? globalThis.Boolean(object.subscriptionActive)
        : isSet(object.subscription_active)
          ? globalThis.Boolean(object.subscription_active)
          : false,
    }
  },

  toJSON(message: GetSubscriptionResponse): unknown {
    const obj: any = {}
    if (message.status !== '') {
      obj.status = message.status
    }
    if (message.planLevel !== 0) {
      obj.planLevel = planLevelToJSON(message.planLevel)
    }
    if (message.currentPeriodEnd !== '0') {
      obj.currentPeriodEnd = message.currentPeriodEnd
    }
    if (message.cancelAtPeriodEnd !== false) {
      obj.cancelAtPeriodEnd = message.cancelAtPeriodEnd
    }
    if (message.capabilities !== undefined) {
      obj.capabilities = Capabilities.toJSON(message.capabilities)
    }
    if (message.planLabel !== '') {
      obj.planLabel = message.planLabel
    }
    if (message.trialEligible !== false) {
      obj.trialEligible = message.trialEligible
    }
    if (message.subscriptionActive !== false) {
      obj.subscriptionActive = message.subscriptionActive
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetSubscriptionResponse>, I>>(
    base?: I
  ): GetSubscriptionResponse {
    return GetSubscriptionResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSubscriptionResponse>, I>>(
    object: I
  ): GetSubscriptionResponse {
    const message = createBaseGetSubscriptionResponse()
    message.status = object.status ?? ''
    message.planLevel = object.planLevel ?? 0
    message.currentPeriodEnd = object.currentPeriodEnd ?? '0'
    message.cancelAtPeriodEnd = object.cancelAtPeriodEnd ?? false
    message.capabilities =
      object.capabilities !== undefined && object.capabilities !== null
        ? Capabilities.fromPartial(object.capabilities)
        : undefined
    message.planLabel = object.planLabel ?? ''
    message.trialEligible = object.trialEligible ?? false
    message.subscriptionActive = object.subscriptionActive ?? false
    return message
  },
}

function createBaseCapabilities(): Capabilities {
  return {
    allowedAlgos: [],
    allowedVenues: [],
    allowedStreamKinds: [],
    maxAccounts: 0,
    maxSharedMembers: 0,
    allowedTriggerConditions: [],
    allowedHedgeMechanisms: [],
    allowedAnalyticsTypes: [],
    allowedFeatures: [],
  }
}

export const Capabilities: MessageFns<Capabilities> = {
  encode(message: Capabilities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.allowedAlgos) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(18).fork()
    for (const v of message.allowedVenues) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(26).fork()
    for (const v of message.allowedStreamKinds) {
      writer.int32(v)
    }
    writer.join()
    if (message.maxAccounts !== 0) {
      writer.uint32(32).uint32(message.maxAccounts)
    }
    if (message.maxSharedMembers !== 0) {
      writer.uint32(40).uint32(message.maxSharedMembers)
    }
    writer.uint32(58).fork()
    for (const v of message.allowedTriggerConditions) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.allowedHedgeMechanisms) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.allowedAnalyticsTypes) {
      writer.int32(v)
    }
    writer.join()
    for (const v of message.allowedFeatures) {
      writer.uint32(82).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Capabilities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCapabilities()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.allowedAlgos.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedAlgos.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 2: {
          if (tag === 16) {
            message.allowedVenues.push(reader.int32() as any)

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedVenues.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 3: {
          if (tag === 24) {
            message.allowedStreamKinds.push(reader.int32() as any)

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedStreamKinds.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.maxAccounts = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.maxSharedMembers = reader.uint32()
          continue
        }
        case 7: {
          if (tag === 56) {
            message.allowedTriggerConditions.push(reader.int32() as any)

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedTriggerConditions.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 64) {
            message.allowedHedgeMechanisms.push(reader.int32() as any)

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedHedgeMechanisms.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 72) {
            message.allowedAnalyticsTypes.push(reader.int32() as any)

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.allowedAnalyticsTypes.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.allowedFeatures.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Capabilities {
    return {
      allowedAlgos: globalThis.Array.isArray(object?.allowedAlgos)
        ? object.allowedAlgos.map((e: any) => algoTypeFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_algos)
          ? object.allowed_algos.map((e: any) => algoTypeFromJSON(e))
          : [],
      allowedVenues: globalThis.Array.isArray(object?.allowedVenues)
        ? object.allowedVenues.map((e: any) => tradeVenueFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_venues)
          ? object.allowed_venues.map((e: any) => tradeVenueFromJSON(e))
          : [],
      allowedStreamKinds: globalThis.Array.isArray(object?.allowedStreamKinds)
        ? object.allowedStreamKinds.map((e: any) => streamKindFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_stream_kinds)
          ? object.allowed_stream_kinds.map((e: any) => streamKindFromJSON(e))
          : [],
      maxAccounts: isSet(object.maxAccounts)
        ? globalThis.Number(object.maxAccounts)
        : isSet(object.max_accounts)
          ? globalThis.Number(object.max_accounts)
          : 0,
      maxSharedMembers: isSet(object.maxSharedMembers)
        ? globalThis.Number(object.maxSharedMembers)
        : isSet(object.max_shared_members)
          ? globalThis.Number(object.max_shared_members)
          : 0,
      allowedTriggerConditions: globalThis.Array.isArray(object?.allowedTriggerConditions)
        ? object.allowedTriggerConditions.map((e: any) => triggerConditionTypeFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_trigger_conditions)
          ? object.allowed_trigger_conditions.map((e: any) => triggerConditionTypeFromJSON(e))
          : [],
      allowedHedgeMechanisms: globalThis.Array.isArray(object?.allowedHedgeMechanisms)
        ? object.allowedHedgeMechanisms.map((e: any) => hedgeMechanismFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_hedge_mechanisms)
          ? object.allowed_hedge_mechanisms.map((e: any) => hedgeMechanismFromJSON(e))
          : [],
      allowedAnalyticsTypes: globalThis.Array.isArray(object?.allowedAnalyticsTypes)
        ? object.allowedAnalyticsTypes.map((e: any) => analyticsTypeFromJSON(e))
        : globalThis.Array.isArray(object?.allowed_analytics_types)
          ? object.allowed_analytics_types.map((e: any) => analyticsTypeFromJSON(e))
          : [],
      allowedFeatures: globalThis.Array.isArray(object?.allowedFeatures)
        ? object.allowedFeatures.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.allowed_features)
          ? object.allowed_features.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: Capabilities): unknown {
    const obj: any = {}
    if (message.allowedAlgos?.length) {
      obj.allowedAlgos = message.allowedAlgos.map((e) => algoTypeToJSON(e))
    }
    if (message.allowedVenues?.length) {
      obj.allowedVenues = message.allowedVenues.map((e) => tradeVenueToJSON(e))
    }
    if (message.allowedStreamKinds?.length) {
      obj.allowedStreamKinds = message.allowedStreamKinds.map((e) => streamKindToJSON(e))
    }
    if (message.maxAccounts !== 0) {
      obj.maxAccounts = Math.round(message.maxAccounts)
    }
    if (message.maxSharedMembers !== 0) {
      obj.maxSharedMembers = Math.round(message.maxSharedMembers)
    }
    if (message.allowedTriggerConditions?.length) {
      obj.allowedTriggerConditions = message.allowedTriggerConditions.map((e) =>
        triggerConditionTypeToJSON(e)
      )
    }
    if (message.allowedHedgeMechanisms?.length) {
      obj.allowedHedgeMechanisms = message.allowedHedgeMechanisms.map((e) =>
        hedgeMechanismToJSON(e)
      )
    }
    if (message.allowedAnalyticsTypes?.length) {
      obj.allowedAnalyticsTypes = message.allowedAnalyticsTypes.map((e) => analyticsTypeToJSON(e))
    }
    if (message.allowedFeatures?.length) {
      obj.allowedFeatures = message.allowedFeatures
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Capabilities>, I>>(base?: I): Capabilities {
    return Capabilities.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Capabilities>, I>>(object: I): Capabilities {
    const message = createBaseCapabilities()
    message.allowedAlgos = object.allowedAlgos?.map((e) => e) || []
    message.allowedVenues = object.allowedVenues?.map((e) => e) || []
    message.allowedStreamKinds = object.allowedStreamKinds?.map((e) => e) || []
    message.maxAccounts = object.maxAccounts ?? 0
    message.maxSharedMembers = object.maxSharedMembers ?? 0
    message.allowedTriggerConditions = object.allowedTriggerConditions?.map((e) => e) || []
    message.allowedHedgeMechanisms = object.allowedHedgeMechanisms?.map((e) => e) || []
    message.allowedAnalyticsTypes = object.allowedAnalyticsTypes?.map((e) => e) || []
    message.allowedFeatures = object.allowedFeatures?.map((e) => e) || []
    return message
  },
}

function createBaseOpenBillingPortalRequest(): OpenBillingPortalRequest {
  return { returnUrl: '' }
}

export const OpenBillingPortalRequest: MessageFns<OpenBillingPortalRequest> = {
  encode(
    message: OpenBillingPortalRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.returnUrl !== '') {
      writer.uint32(10).string(message.returnUrl)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBillingPortalRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOpenBillingPortalRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.returnUrl = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OpenBillingPortalRequest {
    return {
      returnUrl: isSet(object.returnUrl)
        ? globalThis.String(object.returnUrl)
        : isSet(object.return_url)
          ? globalThis.String(object.return_url)
          : '',
    }
  },

  toJSON(message: OpenBillingPortalRequest): unknown {
    const obj: any = {}
    if (message.returnUrl !== '') {
      obj.returnUrl = message.returnUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OpenBillingPortalRequest>, I>>(
    base?: I
  ): OpenBillingPortalRequest {
    return OpenBillingPortalRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OpenBillingPortalRequest>, I>>(
    object: I
  ): OpenBillingPortalRequest {
    const message = createBaseOpenBillingPortalRequest()
    message.returnUrl = object.returnUrl ?? ''
    return message
  },
}

function createBaseOpenBillingPortalResponse(): OpenBillingPortalResponse {
  return { portalUrl: '' }
}

export const OpenBillingPortalResponse: MessageFns<OpenBillingPortalResponse> = {
  encode(
    message: OpenBillingPortalResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.portalUrl !== '') {
      writer.uint32(10).string(message.portalUrl)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenBillingPortalResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOpenBillingPortalResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.portalUrl = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OpenBillingPortalResponse {
    return {
      portalUrl: isSet(object.portalUrl)
        ? globalThis.String(object.portalUrl)
        : isSet(object.portal_url)
          ? globalThis.String(object.portal_url)
          : '',
    }
  },

  toJSON(message: OpenBillingPortalResponse): unknown {
    const obj: any = {}
    if (message.portalUrl !== '') {
      obj.portalUrl = message.portalUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OpenBillingPortalResponse>, I>>(
    base?: I
  ): OpenBillingPortalResponse {
    return OpenBillingPortalResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OpenBillingPortalResponse>, I>>(
    object: I
  ): OpenBillingPortalResponse {
    const message = createBaseOpenBillingPortalResponse()
    message.portalUrl = object.portalUrl ?? ''
    return message
  },
}

function createBaseGetPlansRequest(): GetPlansRequest {
  return {}
}

export const GetPlansRequest: MessageFns<GetPlansRequest> = {
  encode(_: GetPlansRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlansRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPlansRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetPlansRequest {
    return {}
  },

  toJSON(_: GetPlansRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetPlansRequest>, I>>(base?: I): GetPlansRequest {
    return GetPlansRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPlansRequest>, I>>(_: I): GetPlansRequest {
    const message = createBaseGetPlansRequest()
    return message
  },
}

function createBaseGetPlansResponse(): GetPlansResponse {
  return { plans: [], publishableKey: '' }
}

export const GetPlansResponse: MessageFns<GetPlansResponse> = {
  encode(message: GetPlansResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.plans) {
      Plan.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.publishableKey !== '') {
      writer.uint32(18).string(message.publishableKey)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlansResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPlansResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.plans.push(Plan.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.publishableKey = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPlansResponse {
    return {
      plans: globalThis.Array.isArray(object?.plans)
        ? object.plans.map((e: any) => Plan.fromJSON(e))
        : [],
      publishableKey: isSet(object.publishableKey)
        ? globalThis.String(object.publishableKey)
        : isSet(object.publishable_key)
          ? globalThis.String(object.publishable_key)
          : '',
    }
  },

  toJSON(message: GetPlansResponse): unknown {
    const obj: any = {}
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => Plan.toJSON(e))
    }
    if (message.publishableKey !== '') {
      obj.publishableKey = message.publishableKey
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPlansResponse>, I>>(base?: I): GetPlansResponse {
    return GetPlansResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPlansResponse>, I>>(object: I): GetPlansResponse {
    const message = createBaseGetPlansResponse()
    message.plans = object.plans?.map((e) => Plan.fromPartial(e)) || []
    message.publishableKey = object.publishableKey ?? ''
    return message
  },
}

function createBasePlan(): Plan {
  return { level: 0, label: '', prices: [], capabilities: undefined, trialPeriodDays: 0 }
}

export const Plan: MessageFns<Plan> = {
  encode(message: Plan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).int32(message.level)
    }
    if (message.label !== '') {
      writer.uint32(18).string(message.label)
    }
    for (const v of message.prices) {
      Price.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.capabilities !== undefined) {
      Capabilities.encode(message.capabilities, writer.uint32(34).fork()).join()
    }
    if (message.trialPeriodDays !== 0) {
      writer.uint32(40).uint32(message.trialPeriodDays)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Plan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePlan()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.level = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.prices.push(Price.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.capabilities = Capabilities.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.trialPeriodDays = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Plan {
    return {
      level: isSet(object.level) ? planLevelFromJSON(object.level) : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      prices: globalThis.Array.isArray(object?.prices)
        ? object.prices.map((e: any) => Price.fromJSON(e))
        : [],
      capabilities: isSet(object.capabilities)
        ? Capabilities.fromJSON(object.capabilities)
        : undefined,
      trialPeriodDays: isSet(object.trialPeriodDays)
        ? globalThis.Number(object.trialPeriodDays)
        : isSet(object.trial_period_days)
          ? globalThis.Number(object.trial_period_days)
          : 0,
    }
  },

  toJSON(message: Plan): unknown {
    const obj: any = {}
    if (message.level !== 0) {
      obj.level = planLevelToJSON(message.level)
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.prices?.length) {
      obj.prices = message.prices.map((e) => Price.toJSON(e))
    }
    if (message.capabilities !== undefined) {
      obj.capabilities = Capabilities.toJSON(message.capabilities)
    }
    if (message.trialPeriodDays !== 0) {
      obj.trialPeriodDays = Math.round(message.trialPeriodDays)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Plan>, I>>(base?: I): Plan {
    return Plan.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Plan>, I>>(object: I): Plan {
    const message = createBasePlan()
    message.level = object.level ?? 0
    message.label = object.label ?? ''
    message.prices = object.prices?.map((e) => Price.fromPartial(e)) || []
    message.capabilities =
      object.capabilities !== undefined && object.capabilities !== null
        ? Capabilities.fromPartial(object.capabilities)
        : undefined
    message.trialPeriodDays = object.trialPeriodDays ?? 0
    return message
  },
}

function createBasePrice(): Price {
  return {
    priceId: '',
    unitAmount: '0',
    currency: '',
    interval: '',
    intervalCount: 0,
    compareAtAmount: undefined,
  }
}

export const Price: MessageFns<Price> = {
  encode(message: Price, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceId !== '') {
      writer.uint32(10).string(message.priceId)
    }
    if (message.unitAmount !== '0') {
      writer.uint32(16).int64(message.unitAmount)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.interval !== '') {
      writer.uint32(34).string(message.interval)
    }
    if (message.intervalCount !== 0) {
      writer.uint32(40).uint32(message.intervalCount)
    }
    if (message.compareAtAmount !== undefined) {
      writer.uint32(48).int64(message.compareAtAmount)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Price {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePrice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.priceId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.unitAmount = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.interval = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.intervalCount = reader.uint32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.compareAtAmount = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Price {
    return {
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
          ? globalThis.String(object.price_id)
          : '',
      unitAmount: isSet(object.unitAmount)
        ? globalThis.String(object.unitAmount)
        : isSet(object.unit_amount)
          ? globalThis.String(object.unit_amount)
          : '0',
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      interval: isSet(object.interval) ? globalThis.String(object.interval) : '',
      intervalCount: isSet(object.intervalCount)
        ? globalThis.Number(object.intervalCount)
        : isSet(object.interval_count)
          ? globalThis.Number(object.interval_count)
          : 0,
      compareAtAmount: isSet(object.compareAtAmount)
        ? globalThis.String(object.compareAtAmount)
        : isSet(object.compare_at_amount)
          ? globalThis.String(object.compare_at_amount)
          : undefined,
    }
  },

  toJSON(message: Price): unknown {
    const obj: any = {}
    if (message.priceId !== '') {
      obj.priceId = message.priceId
    }
    if (message.unitAmount !== '0') {
      obj.unitAmount = message.unitAmount
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.interval !== '') {
      obj.interval = message.interval
    }
    if (message.intervalCount !== 0) {
      obj.intervalCount = Math.round(message.intervalCount)
    }
    if (message.compareAtAmount !== undefined) {
      obj.compareAtAmount = message.compareAtAmount
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Price>, I>>(base?: I): Price {
    return Price.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Price>, I>>(object: I): Price {
    const message = createBasePrice()
    message.priceId = object.priceId ?? ''
    message.unitAmount = object.unitAmount ?? '0'
    message.currency = object.currency ?? ''
    message.interval = object.interval ?? ''
    message.intervalCount = object.intervalCount ?? 0
    message.compareAtAmount = object.compareAtAmount ?? undefined
    return message
  },
}

function createBaseExchangeList(): ExchangeList {
  return { exchanges: [] }
}

export const ExchangeList: MessageFns<ExchangeList> = {
  encode(message: ExchangeList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.exchanges) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExchangeList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExchangeList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.exchanges.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.exchanges.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExchangeList {
    return {
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => exchangeFromJSON(e))
        : [],
    }
  },

  toJSON(message: ExchangeList): unknown {
    const obj: any = {}
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges.map((e) => exchangeToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExchangeList>, I>>(base?: I): ExchangeList {
    return ExchangeList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeList>, I>>(object: I): ExchangeList {
    const message = createBaseExchangeList()
    message.exchanges = object.exchanges?.map((e) => e) || []
    return message
  },
}

function createBaseInstrumentList(): InstrumentList {
  return { instruments: [] }
}

export const InstrumentList: MessageFns<InstrumentList> = {
  encode(message: InstrumentList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.instruments) {
      Instrument.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instruments.push(Instrument.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentList {
    return {
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => Instrument.fromJSON(e))
        : [],
    }
  },

  toJSON(message: InstrumentList): unknown {
    const obj: any = {}
    if (message.instruments?.length) {
      obj.instruments = message.instruments.map((e) => Instrument.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentList>, I>>(base?: I): InstrumentList {
    return InstrumentList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentList>, I>>(object: I): InstrumentList {
    const message = createBaseInstrumentList()
    message.instruments = object.instruments?.map((e) => Instrument.fromPartial(e)) || []
    return message
  },
}

function createBaseExchangeStatus(): ExchangeStatus {
  return { exchange: 0, status: 0, sinceMs: '0', nextChangeMs: undefined, latencyMs: undefined }
}

export const ExchangeStatus: MessageFns<ExchangeStatus> = {
  encode(message: ExchangeStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status)
    }
    if (message.sinceMs !== '0') {
      writer.uint32(24).int64(message.sinceMs)
    }
    if (message.nextChangeMs !== undefined) {
      writer.uint32(32).int64(message.nextChangeMs)
    }
    if (message.latencyMs !== undefined) {
      writer.uint32(40).uint32(message.latencyMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExchangeStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExchangeStatus()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.sinceMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.nextChangeMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.latencyMs = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExchangeStatus {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      status: isSet(object.status) ? exchangeStatusTypeFromJSON(object.status) : 0,
      sinceMs: isSet(object.sinceMs)
        ? globalThis.String(object.sinceMs)
        : isSet(object.since_ms)
          ? globalThis.String(object.since_ms)
          : '0',
      nextChangeMs: isSet(object.nextChangeMs)
        ? globalThis.String(object.nextChangeMs)
        : isSet(object.next_change_ms)
          ? globalThis.String(object.next_change_ms)
          : undefined,
      latencyMs: isSet(object.latencyMs)
        ? globalThis.Number(object.latencyMs)
        : isSet(object.latency_ms)
          ? globalThis.Number(object.latency_ms)
          : undefined,
    }
  },

  toJSON(message: ExchangeStatus): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.status !== 0) {
      obj.status = exchangeStatusTypeToJSON(message.status)
    }
    if (message.sinceMs !== '0') {
      obj.sinceMs = message.sinceMs
    }
    if (message.nextChangeMs !== undefined) {
      obj.nextChangeMs = message.nextChangeMs
    }
    if (message.latencyMs !== undefined) {
      obj.latencyMs = Math.round(message.latencyMs)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExchangeStatus>, I>>(base?: I): ExchangeStatus {
    return ExchangeStatus.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeStatus>, I>>(object: I): ExchangeStatus {
    const message = createBaseExchangeStatus()
    message.exchange = object.exchange ?? 0
    message.status = object.status ?? 0
    message.sinceMs = object.sinceMs ?? '0'
    message.nextChangeMs = object.nextChangeMs ?? undefined
    message.latencyMs = object.latencyMs ?? undefined
    return message
  },
}

function createBaseVenueHealth(): VenueHealth {
  return { exchange: 0, data: 0, trading: undefined, whatChanged: 0, sinceMs: '0' }
}

export const VenueHealth: MessageFns<VenueHealth> = {
  encode(message: VenueHealth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.data !== 0) {
      writer.uint32(16).int32(message.data)
    }
    if (message.trading !== undefined) {
      writer.uint32(24).bool(message.trading)
    }
    if (message.whatChanged !== 0) {
      writer.uint32(32).int32(message.whatChanged)
    }
    if (message.sinceMs !== '0') {
      writer.uint32(40).int64(message.sinceMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueHealth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueHealth()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.data = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.trading = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.whatChanged = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.sinceMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueHealth {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      data: isSet(object.data) ? exchangeStatusTypeFromJSON(object.data) : 0,
      trading: isSet(object.trading) ? globalThis.Boolean(object.trading) : undefined,
      whatChanged: isSet(object.whatChanged)
        ? venueHealthChangeFromJSON(object.whatChanged)
        : isSet(object.what_changed)
          ? venueHealthChangeFromJSON(object.what_changed)
          : 0,
      sinceMs: isSet(object.sinceMs)
        ? globalThis.String(object.sinceMs)
        : isSet(object.since_ms)
          ? globalThis.String(object.since_ms)
          : '0',
    }
  },

  toJSON(message: VenueHealth): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.data !== 0) {
      obj.data = exchangeStatusTypeToJSON(message.data)
    }
    if (message.trading !== undefined) {
      obj.trading = message.trading
    }
    if (message.whatChanged !== 0) {
      obj.whatChanged = venueHealthChangeToJSON(message.whatChanged)
    }
    if (message.sinceMs !== '0') {
      obj.sinceMs = message.sinceMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueHealth>, I>>(base?: I): VenueHealth {
    return VenueHealth.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueHealth>, I>>(object: I): VenueHealth {
    const message = createBaseVenueHealth()
    message.exchange = object.exchange ?? 0
    message.data = object.data ?? 0
    message.trading = object.trading ?? undefined
    message.whatChanged = object.whatChanged ?? 0
    message.sinceMs = object.sinceMs ?? '0'
    return message
  },
}

function createBaseVenueSchedule(): VenueSchedule {
  return {
    exchange: 0,
    timezone: '',
    alwaysOpen: false,
    weeklySessions: [],
    holidays: [],
    sessionOverrides: [],
  }
}

export const VenueSchedule: MessageFns<VenueSchedule> = {
  encode(message: VenueSchedule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.timezone !== '') {
      writer.uint32(18).string(message.timezone)
    }
    if (message.alwaysOpen !== false) {
      writer.uint32(24).bool(message.alwaysOpen)
    }
    for (const v of message.weeklySessions) {
      WeeklySession.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.holidays) {
      writer.uint32(42).string(v!)
    }
    for (const v of message.sessionOverrides) {
      VenueSchedule_SessionOverride.encode(v!, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueSchedule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueSchedule()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.timezone = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.alwaysOpen = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.weeklySessions.push(WeeklySession.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.holidays.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.sessionOverrides.push(
            VenueSchedule_SessionOverride.decode(reader, reader.uint32())
          )
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueSchedule {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : '',
      alwaysOpen: isSet(object.alwaysOpen)
        ? globalThis.Boolean(object.alwaysOpen)
        : isSet(object.always_open)
          ? globalThis.Boolean(object.always_open)
          : false,
      weeklySessions: globalThis.Array.isArray(object?.weeklySessions)
        ? object.weeklySessions.map((e: any) => WeeklySession.fromJSON(e))
        : globalThis.Array.isArray(object?.weekly_sessions)
          ? object.weekly_sessions.map((e: any) => WeeklySession.fromJSON(e))
          : [],
      holidays: globalThis.Array.isArray(object?.holidays)
        ? object.holidays.map((e: any) => globalThis.String(e))
        : [],
      sessionOverrides: globalThis.Array.isArray(object?.sessionOverrides)
        ? object.sessionOverrides.map((e: any) => VenueSchedule_SessionOverride.fromJSON(e))
        : globalThis.Array.isArray(object?.session_overrides)
          ? object.session_overrides.map((e: any) => VenueSchedule_SessionOverride.fromJSON(e))
          : [],
    }
  },

  toJSON(message: VenueSchedule): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.timezone !== '') {
      obj.timezone = message.timezone
    }
    if (message.alwaysOpen !== false) {
      obj.alwaysOpen = message.alwaysOpen
    }
    if (message.weeklySessions?.length) {
      obj.weeklySessions = message.weeklySessions.map((e) => WeeklySession.toJSON(e))
    }
    if (message.holidays?.length) {
      obj.holidays = message.holidays
    }
    if (message.sessionOverrides?.length) {
      obj.sessionOverrides = message.sessionOverrides.map((e) =>
        VenueSchedule_SessionOverride.toJSON(e)
      )
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueSchedule>, I>>(base?: I): VenueSchedule {
    return VenueSchedule.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueSchedule>, I>>(object: I): VenueSchedule {
    const message = createBaseVenueSchedule()
    message.exchange = object.exchange ?? 0
    message.timezone = object.timezone ?? ''
    message.alwaysOpen = object.alwaysOpen ?? false
    message.weeklySessions = object.weeklySessions?.map((e) => WeeklySession.fromPartial(e)) || []
    message.holidays = object.holidays?.map((e) => e) || []
    message.sessionOverrides =
      object.sessionOverrides?.map((e) => VenueSchedule_SessionOverride.fromPartial(e)) || []
    return message
  },
}

function createBaseVenueSchedule_SessionOverride(): VenueSchedule_SessionOverride {
  return { date: '', open: '', close: '' }
}

export const VenueSchedule_SessionOverride: MessageFns<VenueSchedule_SessionOverride> = {
  encode(
    message: VenueSchedule_SessionOverride,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.date !== '') {
      writer.uint32(10).string(message.date)
    }
    if (message.open !== '') {
      writer.uint32(18).string(message.open)
    }
    if (message.close !== '') {
      writer.uint32(26).string(message.close)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueSchedule_SessionOverride {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueSchedule_SessionOverride()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.date = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.open = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.close = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueSchedule_SessionOverride {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : '',
      open: isSet(object.open) ? globalThis.String(object.open) : '',
      close: isSet(object.close) ? globalThis.String(object.close) : '',
    }
  },

  toJSON(message: VenueSchedule_SessionOverride): unknown {
    const obj: any = {}
    if (message.date !== '') {
      obj.date = message.date
    }
    if (message.open !== '') {
      obj.open = message.open
    }
    if (message.close !== '') {
      obj.close = message.close
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueSchedule_SessionOverride>, I>>(
    base?: I
  ): VenueSchedule_SessionOverride {
    return VenueSchedule_SessionOverride.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueSchedule_SessionOverride>, I>>(
    object: I
  ): VenueSchedule_SessionOverride {
    const message = createBaseVenueSchedule_SessionOverride()
    message.date = object.date ?? ''
    message.open = object.open ?? ''
    message.close = object.close ?? ''
    return message
  },
}

function createBaseWeeklySession(): WeeklySession {
  return { weekday: 0, open: '', close: '' }
}

export const WeeklySession: MessageFns<WeeklySession> = {
  encode(message: WeeklySession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.weekday !== 0) {
      writer.uint32(8).uint32(message.weekday)
    }
    if (message.open !== '') {
      writer.uint32(18).string(message.open)
    }
    if (message.close !== '') {
      writer.uint32(26).string(message.close)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WeeklySession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWeeklySession()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.weekday = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.open = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.close = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WeeklySession {
    return {
      weekday: isSet(object.weekday) ? globalThis.Number(object.weekday) : 0,
      open: isSet(object.open) ? globalThis.String(object.open) : '',
      close: isSet(object.close) ? globalThis.String(object.close) : '',
    }
  },

  toJSON(message: WeeklySession): unknown {
    const obj: any = {}
    if (message.weekday !== 0) {
      obj.weekday = Math.round(message.weekday)
    }
    if (message.open !== '') {
      obj.open = message.open
    }
    if (message.close !== '') {
      obj.close = message.close
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WeeklySession>, I>>(base?: I): WeeklySession {
    return WeeklySession.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WeeklySession>, I>>(object: I): WeeklySession {
    const message = createBaseWeeklySession()
    message.weekday = object.weekday ?? 0
    message.open = object.open ?? ''
    message.close = object.close ?? ''
    return message
  },
}

function createBaseVenueScheduleList(): VenueScheduleList {
  return { schedules: [] }
}

export const VenueScheduleList: MessageFns<VenueScheduleList> = {
  encode(message: VenueScheduleList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.schedules) {
      VenueSchedule.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VenueScheduleList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVenueScheduleList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.schedules.push(VenueSchedule.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VenueScheduleList {
    return {
      schedules: globalThis.Array.isArray(object?.schedules)
        ? object.schedules.map((e: any) => VenueSchedule.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VenueScheduleList): unknown {
    const obj: any = {}
    if (message.schedules?.length) {
      obj.schedules = message.schedules.map((e) => VenueSchedule.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VenueScheduleList>, I>>(base?: I): VenueScheduleList {
    return VenueScheduleList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VenueScheduleList>, I>>(object: I): VenueScheduleList {
    const message = createBaseVenueScheduleList()
    message.schedules = object.schedules?.map((e) => VenueSchedule.fromPartial(e)) || []
    return message
  },
}

function createBaseVolMetrics24hPoint(): VolMetrics24hPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    daysToExpiration: '',
    atm: undefined,
    atmChange: undefined,
    butterfly15: undefined,
    butterfly15Change: undefined,
    butterfly25: undefined,
    butterfly25Change: undefined,
    riskReversal15: undefined,
    riskReversal15Change: undefined,
    riskReversal25: undefined,
    riskReversal25Change: undefined,
    underlyingPrice: undefined,
    underlyingPriceChange: undefined,
  }
}

export const VolMetrics24hPoint: MessageFns<VolMetrics24hPoint> = {
  encode(message: VolMetrics24hPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(42).string(message.daysToExpiration)
    }
    if (message.atm !== undefined) {
      writer.uint32(50).string(message.atm)
    }
    if (message.atmChange !== undefined) {
      writer.uint32(58).string(message.atmChange)
    }
    if (message.butterfly15 !== undefined) {
      writer.uint32(66).string(message.butterfly15)
    }
    if (message.butterfly15Change !== undefined) {
      writer.uint32(74).string(message.butterfly15Change)
    }
    if (message.butterfly25 !== undefined) {
      writer.uint32(82).string(message.butterfly25)
    }
    if (message.butterfly25Change !== undefined) {
      writer.uint32(90).string(message.butterfly25Change)
    }
    if (message.riskReversal15 !== undefined) {
      writer.uint32(98).string(message.riskReversal15)
    }
    if (message.riskReversal15Change !== undefined) {
      writer.uint32(106).string(message.riskReversal15Change)
    }
    if (message.riskReversal25 !== undefined) {
      writer.uint32(114).string(message.riskReversal25)
    }
    if (message.riskReversal25Change !== undefined) {
      writer.uint32(122).string(message.riskReversal25Change)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(130).string(message.underlyingPrice)
    }
    if (message.underlyingPriceChange !== undefined) {
      writer.uint32(138).string(message.underlyingPriceChange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolMetrics24hPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolMetrics24hPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.atm = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.atmChange = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.butterfly15 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.butterfly15Change = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.butterfly25 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.butterfly25Change = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.riskReversal15 = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.riskReversal15Change = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.riskReversal25 = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.riskReversal25Change = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.underlyingPriceChange = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolMetrics24hPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      atm: isSet(object.atm) ? globalThis.String(object.atm) : undefined,
      atmChange: isSet(object.atmChange)
        ? globalThis.String(object.atmChange)
        : isSet(object.atm_change)
          ? globalThis.String(object.atm_change)
          : undefined,
      butterfly15: isSet(object.butterfly15)
        ? globalThis.String(object.butterfly15)
        : isSet(object.butterfly_15)
          ? globalThis.String(object.butterfly_15)
          : undefined,
      butterfly15Change: isSet(object.butterfly15Change)
        ? globalThis.String(object.butterfly15Change)
        : isSet(object.butterfly_15_change)
          ? globalThis.String(object.butterfly_15_change)
          : undefined,
      butterfly25: isSet(object.butterfly25)
        ? globalThis.String(object.butterfly25)
        : isSet(object.butterfly_25)
          ? globalThis.String(object.butterfly_25)
          : undefined,
      butterfly25Change: isSet(object.butterfly25Change)
        ? globalThis.String(object.butterfly25Change)
        : isSet(object.butterfly_25_change)
          ? globalThis.String(object.butterfly_25_change)
          : undefined,
      riskReversal15: isSet(object.riskReversal15)
        ? globalThis.String(object.riskReversal15)
        : isSet(object.risk_reversal_15)
          ? globalThis.String(object.risk_reversal_15)
          : undefined,
      riskReversal15Change: isSet(object.riskReversal15Change)
        ? globalThis.String(object.riskReversal15Change)
        : isSet(object.risk_reversal_15_change)
          ? globalThis.String(object.risk_reversal_15_change)
          : undefined,
      riskReversal25: isSet(object.riskReversal25)
        ? globalThis.String(object.riskReversal25)
        : isSet(object.risk_reversal_25)
          ? globalThis.String(object.risk_reversal_25)
          : undefined,
      riskReversal25Change: isSet(object.riskReversal25Change)
        ? globalThis.String(object.riskReversal25Change)
        : isSet(object.risk_reversal_25_change)
          ? globalThis.String(object.risk_reversal_25_change)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      underlyingPriceChange: isSet(object.underlyingPriceChange)
        ? globalThis.String(object.underlyingPriceChange)
        : isSet(object.underlying_price_change)
          ? globalThis.String(object.underlying_price_change)
          : undefined,
    }
  },

  toJSON(message: VolMetrics24hPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.atm !== undefined) {
      obj.atm = message.atm
    }
    if (message.atmChange !== undefined) {
      obj.atmChange = message.atmChange
    }
    if (message.butterfly15 !== undefined) {
      obj.butterfly15 = message.butterfly15
    }
    if (message.butterfly15Change !== undefined) {
      obj.butterfly15Change = message.butterfly15Change
    }
    if (message.butterfly25 !== undefined) {
      obj.butterfly25 = message.butterfly25
    }
    if (message.butterfly25Change !== undefined) {
      obj.butterfly25Change = message.butterfly25Change
    }
    if (message.riskReversal15 !== undefined) {
      obj.riskReversal15 = message.riskReversal15
    }
    if (message.riskReversal15Change !== undefined) {
      obj.riskReversal15Change = message.riskReversal15Change
    }
    if (message.riskReversal25 !== undefined) {
      obj.riskReversal25 = message.riskReversal25
    }
    if (message.riskReversal25Change !== undefined) {
      obj.riskReversal25Change = message.riskReversal25Change
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.underlyingPriceChange !== undefined) {
      obj.underlyingPriceChange = message.underlyingPriceChange
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolMetrics24hPoint>, I>>(base?: I): VolMetrics24hPoint {
    return VolMetrics24hPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolMetrics24hPoint>, I>>(object: I): VolMetrics24hPoint {
    const message = createBaseVolMetrics24hPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.atm = object.atm ?? undefined
    message.atmChange = object.atmChange ?? undefined
    message.butterfly15 = object.butterfly15 ?? undefined
    message.butterfly15Change = object.butterfly15Change ?? undefined
    message.butterfly25 = object.butterfly25 ?? undefined
    message.butterfly25Change = object.butterfly25Change ?? undefined
    message.riskReversal15 = object.riskReversal15 ?? undefined
    message.riskReversal15Change = object.riskReversal15Change ?? undefined
    message.riskReversal25 = object.riskReversal25 ?? undefined
    message.riskReversal25Change = object.riskReversal25Change ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.underlyingPriceChange = object.underlyingPriceChange ?? undefined
    return message
  },
}

function createBaseVolMetrics24hList(): VolMetrics24hList {
  return { items: [] }
}

export const VolMetrics24hList: MessageFns<VolMetrics24hList> = {
  encode(message: VolMetrics24hList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      VolMetrics24hPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolMetrics24hList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolMetrics24hList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(VolMetrics24hPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolMetrics24hList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => VolMetrics24hPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VolMetrics24hList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => VolMetrics24hPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolMetrics24hList>, I>>(base?: I): VolMetrics24hList {
    return VolMetrics24hList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolMetrics24hList>, I>>(object: I): VolMetrics24hList {
    const message = createBaseVolMetrics24hList()
    message.items = object.items?.map((e) => VolMetrics24hPoint.fromPartial(e)) || []
    return message
  },
}

function createBasePutCallRatioPoint(): PutCallRatioPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    putCallRatioOpenInterest: undefined,
    putCallRatioVolume24h: undefined,
    indexPrice: undefined,
  }
}

export const PutCallRatioPoint: MessageFns<PutCallRatioPoint> = {
  encode(message: PutCallRatioPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.putCallRatioOpenInterest !== undefined) {
      writer.uint32(34).string(message.putCallRatioOpenInterest)
    }
    if (message.putCallRatioVolume24h !== undefined) {
      writer.uint32(42).string(message.putCallRatioVolume24h)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(50).string(message.indexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PutCallRatioPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePutCallRatioPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.putCallRatioOpenInterest = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.putCallRatioVolume24h = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PutCallRatioPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      putCallRatioOpenInterest: isSet(object.putCallRatioOpenInterest)
        ? globalThis.String(object.putCallRatioOpenInterest)
        : isSet(object.put_call_ratio_open_interest)
          ? globalThis.String(object.put_call_ratio_open_interest)
          : undefined,
      putCallRatioVolume24h: isSet(object.putCallRatioVolume24h)
        ? globalThis.String(object.putCallRatioVolume24h)
        : isSet(object.put_call_ratio_volume_24h)
          ? globalThis.String(object.put_call_ratio_volume_24h)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
    }
  },

  toJSON(message: PutCallRatioPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.putCallRatioOpenInterest !== undefined) {
      obj.putCallRatioOpenInterest = message.putCallRatioOpenInterest
    }
    if (message.putCallRatioVolume24h !== undefined) {
      obj.putCallRatioVolume24h = message.putCallRatioVolume24h
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PutCallRatioPoint>, I>>(base?: I): PutCallRatioPoint {
    return PutCallRatioPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PutCallRatioPoint>, I>>(object: I): PutCallRatioPoint {
    const message = createBasePutCallRatioPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.putCallRatioOpenInterest = object.putCallRatioOpenInterest ?? undefined
    message.putCallRatioVolume24h = object.putCallRatioVolume24h ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    return message
  },
}

function createBasePutCallRatioList(): PutCallRatioList {
  return { items: [] }
}

export const PutCallRatioList: MessageFns<PutCallRatioList> = {
  encode(message: PutCallRatioList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      PutCallRatioPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PutCallRatioList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePutCallRatioList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(PutCallRatioPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PutCallRatioList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => PutCallRatioPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PutCallRatioList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => PutCallRatioPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PutCallRatioList>, I>>(base?: I): PutCallRatioList {
    return PutCallRatioList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PutCallRatioList>, I>>(object: I): PutCallRatioList {
    const message = createBasePutCallRatioList()
    message.items = object.items?.map((e) => PutCallRatioPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseDeltaSurfaceConstantPoint(): DeltaSurfaceConstantPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    daysToExpiration: '',
    multiplier: undefined,
    openInterest: undefined,
    indexPrice: undefined,
    underlyingPrice: undefined,
    atm: undefined,
    delta50: undefined,
    deltaCall05: undefined,
    deltaCall10: undefined,
    deltaCall15: undefined,
    deltaCall20: undefined,
    deltaCall25: undefined,
    deltaCall30: undefined,
    deltaCall35: undefined,
    deltaCall40: undefined,
    deltaCall45: undefined,
    deltaPut05: undefined,
    deltaPut10: undefined,
    deltaPut15: undefined,
    deltaPut20: undefined,
    deltaPut25: undefined,
    deltaPut30: undefined,
    deltaPut35: undefined,
    deltaPut40: undefined,
    deltaPut45: undefined,
    bookIndexPrice: undefined,
  }
}

export const DeltaSurfaceConstantPoint: MessageFns<DeltaSurfaceConstantPoint> = {
  encode(
    message: DeltaSurfaceConstantPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(34).string(message.daysToExpiration)
    }
    if (message.multiplier !== undefined) {
      writer.uint32(42).string(message.multiplier)
    }
    if (message.openInterest !== undefined) {
      writer.uint32(50).string(message.openInterest)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(58).string(message.indexPrice)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(66).string(message.underlyingPrice)
    }
    if (message.atm !== undefined) {
      writer.uint32(74).string(message.atm)
    }
    if (message.delta50 !== undefined) {
      writer.uint32(82).string(message.delta50)
    }
    if (message.deltaCall05 !== undefined) {
      writer.uint32(90).string(message.deltaCall05)
    }
    if (message.deltaCall10 !== undefined) {
      writer.uint32(98).string(message.deltaCall10)
    }
    if (message.deltaCall15 !== undefined) {
      writer.uint32(106).string(message.deltaCall15)
    }
    if (message.deltaCall20 !== undefined) {
      writer.uint32(114).string(message.deltaCall20)
    }
    if (message.deltaCall25 !== undefined) {
      writer.uint32(122).string(message.deltaCall25)
    }
    if (message.deltaCall30 !== undefined) {
      writer.uint32(130).string(message.deltaCall30)
    }
    if (message.deltaCall35 !== undefined) {
      writer.uint32(138).string(message.deltaCall35)
    }
    if (message.deltaCall40 !== undefined) {
      writer.uint32(146).string(message.deltaCall40)
    }
    if (message.deltaCall45 !== undefined) {
      writer.uint32(154).string(message.deltaCall45)
    }
    if (message.deltaPut05 !== undefined) {
      writer.uint32(162).string(message.deltaPut05)
    }
    if (message.deltaPut10 !== undefined) {
      writer.uint32(170).string(message.deltaPut10)
    }
    if (message.deltaPut15 !== undefined) {
      writer.uint32(178).string(message.deltaPut15)
    }
    if (message.deltaPut20 !== undefined) {
      writer.uint32(186).string(message.deltaPut20)
    }
    if (message.deltaPut25 !== undefined) {
      writer.uint32(194).string(message.deltaPut25)
    }
    if (message.deltaPut30 !== undefined) {
      writer.uint32(202).string(message.deltaPut30)
    }
    if (message.deltaPut35 !== undefined) {
      writer.uint32(210).string(message.deltaPut35)
    }
    if (message.deltaPut40 !== undefined) {
      writer.uint32(218).string(message.deltaPut40)
    }
    if (message.deltaPut45 !== undefined) {
      writer.uint32(226).string(message.deltaPut45)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(234).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaSurfaceConstantPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaSurfaceConstantPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.multiplier = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.openInterest = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.atm = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.delta50 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.deltaCall05 = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.deltaCall10 = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.deltaCall15 = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.deltaCall20 = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.deltaCall25 = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.deltaCall30 = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.deltaCall35 = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.deltaCall40 = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.deltaCall45 = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.deltaPut05 = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.deltaPut10 = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.deltaPut15 = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.deltaPut20 = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.deltaPut25 = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.deltaPut30 = reader.string()
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.deltaPut35 = reader.string()
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.deltaPut40 = reader.string()
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.deltaPut45 = reader.string()
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaSurfaceConstantPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      multiplier: isSet(object.multiplier) ? globalThis.String(object.multiplier) : undefined,
      openInterest: isSet(object.openInterest)
        ? globalThis.String(object.openInterest)
        : isSet(object.open_interest)
          ? globalThis.String(object.open_interest)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      atm: isSet(object.atm) ? globalThis.String(object.atm) : undefined,
      delta50: isSet(object.delta50)
        ? globalThis.String(object.delta50)
        : isSet(object.delta_50)
          ? globalThis.String(object.delta_50)
          : undefined,
      deltaCall05: isSet(object.deltaCall05)
        ? globalThis.String(object.deltaCall05)
        : isSet(object.delta_call_05)
          ? globalThis.String(object.delta_call_05)
          : undefined,
      deltaCall10: isSet(object.deltaCall10)
        ? globalThis.String(object.deltaCall10)
        : isSet(object.delta_call_10)
          ? globalThis.String(object.delta_call_10)
          : undefined,
      deltaCall15: isSet(object.deltaCall15)
        ? globalThis.String(object.deltaCall15)
        : isSet(object.delta_call_15)
          ? globalThis.String(object.delta_call_15)
          : undefined,
      deltaCall20: isSet(object.deltaCall20)
        ? globalThis.String(object.deltaCall20)
        : isSet(object.delta_call_20)
          ? globalThis.String(object.delta_call_20)
          : undefined,
      deltaCall25: isSet(object.deltaCall25)
        ? globalThis.String(object.deltaCall25)
        : isSet(object.delta_call_25)
          ? globalThis.String(object.delta_call_25)
          : undefined,
      deltaCall30: isSet(object.deltaCall30)
        ? globalThis.String(object.deltaCall30)
        : isSet(object.delta_call_30)
          ? globalThis.String(object.delta_call_30)
          : undefined,
      deltaCall35: isSet(object.deltaCall35)
        ? globalThis.String(object.deltaCall35)
        : isSet(object.delta_call_35)
          ? globalThis.String(object.delta_call_35)
          : undefined,
      deltaCall40: isSet(object.deltaCall40)
        ? globalThis.String(object.deltaCall40)
        : isSet(object.delta_call_40)
          ? globalThis.String(object.delta_call_40)
          : undefined,
      deltaCall45: isSet(object.deltaCall45)
        ? globalThis.String(object.deltaCall45)
        : isSet(object.delta_call_45)
          ? globalThis.String(object.delta_call_45)
          : undefined,
      deltaPut05: isSet(object.deltaPut05)
        ? globalThis.String(object.deltaPut05)
        : isSet(object.delta_put_05)
          ? globalThis.String(object.delta_put_05)
          : undefined,
      deltaPut10: isSet(object.deltaPut10)
        ? globalThis.String(object.deltaPut10)
        : isSet(object.delta_put_10)
          ? globalThis.String(object.delta_put_10)
          : undefined,
      deltaPut15: isSet(object.deltaPut15)
        ? globalThis.String(object.deltaPut15)
        : isSet(object.delta_put_15)
          ? globalThis.String(object.delta_put_15)
          : undefined,
      deltaPut20: isSet(object.deltaPut20)
        ? globalThis.String(object.deltaPut20)
        : isSet(object.delta_put_20)
          ? globalThis.String(object.delta_put_20)
          : undefined,
      deltaPut25: isSet(object.deltaPut25)
        ? globalThis.String(object.deltaPut25)
        : isSet(object.delta_put_25)
          ? globalThis.String(object.delta_put_25)
          : undefined,
      deltaPut30: isSet(object.deltaPut30)
        ? globalThis.String(object.deltaPut30)
        : isSet(object.delta_put_30)
          ? globalThis.String(object.delta_put_30)
          : undefined,
      deltaPut35: isSet(object.deltaPut35)
        ? globalThis.String(object.deltaPut35)
        : isSet(object.delta_put_35)
          ? globalThis.String(object.delta_put_35)
          : undefined,
      deltaPut40: isSet(object.deltaPut40)
        ? globalThis.String(object.deltaPut40)
        : isSet(object.delta_put_40)
          ? globalThis.String(object.delta_put_40)
          : undefined,
      deltaPut45: isSet(object.deltaPut45)
        ? globalThis.String(object.deltaPut45)
        : isSet(object.delta_put_45)
          ? globalThis.String(object.delta_put_45)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: DeltaSurfaceConstantPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = message.multiplier
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = message.openInterest
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.atm !== undefined) {
      obj.atm = message.atm
    }
    if (message.delta50 !== undefined) {
      obj.delta50 = message.delta50
    }
    if (message.deltaCall05 !== undefined) {
      obj.deltaCall05 = message.deltaCall05
    }
    if (message.deltaCall10 !== undefined) {
      obj.deltaCall10 = message.deltaCall10
    }
    if (message.deltaCall15 !== undefined) {
      obj.deltaCall15 = message.deltaCall15
    }
    if (message.deltaCall20 !== undefined) {
      obj.deltaCall20 = message.deltaCall20
    }
    if (message.deltaCall25 !== undefined) {
      obj.deltaCall25 = message.deltaCall25
    }
    if (message.deltaCall30 !== undefined) {
      obj.deltaCall30 = message.deltaCall30
    }
    if (message.deltaCall35 !== undefined) {
      obj.deltaCall35 = message.deltaCall35
    }
    if (message.deltaCall40 !== undefined) {
      obj.deltaCall40 = message.deltaCall40
    }
    if (message.deltaCall45 !== undefined) {
      obj.deltaCall45 = message.deltaCall45
    }
    if (message.deltaPut05 !== undefined) {
      obj.deltaPut05 = message.deltaPut05
    }
    if (message.deltaPut10 !== undefined) {
      obj.deltaPut10 = message.deltaPut10
    }
    if (message.deltaPut15 !== undefined) {
      obj.deltaPut15 = message.deltaPut15
    }
    if (message.deltaPut20 !== undefined) {
      obj.deltaPut20 = message.deltaPut20
    }
    if (message.deltaPut25 !== undefined) {
      obj.deltaPut25 = message.deltaPut25
    }
    if (message.deltaPut30 !== undefined) {
      obj.deltaPut30 = message.deltaPut30
    }
    if (message.deltaPut35 !== undefined) {
      obj.deltaPut35 = message.deltaPut35
    }
    if (message.deltaPut40 !== undefined) {
      obj.deltaPut40 = message.deltaPut40
    }
    if (message.deltaPut45 !== undefined) {
      obj.deltaPut45 = message.deltaPut45
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaSurfaceConstantPoint>, I>>(
    base?: I
  ): DeltaSurfaceConstantPoint {
    return DeltaSurfaceConstantPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaSurfaceConstantPoint>, I>>(
    object: I
  ): DeltaSurfaceConstantPoint {
    const message = createBaseDeltaSurfaceConstantPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.multiplier = object.multiplier ?? undefined
    message.openInterest = object.openInterest ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.atm = object.atm ?? undefined
    message.delta50 = object.delta50 ?? undefined
    message.deltaCall05 = object.deltaCall05 ?? undefined
    message.deltaCall10 = object.deltaCall10 ?? undefined
    message.deltaCall15 = object.deltaCall15 ?? undefined
    message.deltaCall20 = object.deltaCall20 ?? undefined
    message.deltaCall25 = object.deltaCall25 ?? undefined
    message.deltaCall30 = object.deltaCall30 ?? undefined
    message.deltaCall35 = object.deltaCall35 ?? undefined
    message.deltaCall40 = object.deltaCall40 ?? undefined
    message.deltaCall45 = object.deltaCall45 ?? undefined
    message.deltaPut05 = object.deltaPut05 ?? undefined
    message.deltaPut10 = object.deltaPut10 ?? undefined
    message.deltaPut15 = object.deltaPut15 ?? undefined
    message.deltaPut20 = object.deltaPut20 ?? undefined
    message.deltaPut25 = object.deltaPut25 ?? undefined
    message.deltaPut30 = object.deltaPut30 ?? undefined
    message.deltaPut35 = object.deltaPut35 ?? undefined
    message.deltaPut40 = object.deltaPut40 ?? undefined
    message.deltaPut45 = object.deltaPut45 ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseDeltaSurfaceConstantList(): DeltaSurfaceConstantList {
  return { items: [] }
}

export const DeltaSurfaceConstantList: MessageFns<DeltaSurfaceConstantList> = {
  encode(
    message: DeltaSurfaceConstantList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      DeltaSurfaceConstantPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaSurfaceConstantList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaSurfaceConstantList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(DeltaSurfaceConstantPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaSurfaceConstantList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => DeltaSurfaceConstantPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DeltaSurfaceConstantList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => DeltaSurfaceConstantPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaSurfaceConstantList>, I>>(
    base?: I
  ): DeltaSurfaceConstantList {
    return DeltaSurfaceConstantList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaSurfaceConstantList>, I>>(
    object: I
  ): DeltaSurfaceConstantList {
    const message = createBaseDeltaSurfaceConstantList()
    message.items = object.items?.map((e) => DeltaSurfaceConstantPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseDeltaSurfaceFloatingPoint(): DeltaSurfaceFloatingPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    daysToExpiration: '',
    multiplier: undefined,
    openInterest: undefined,
    indexPrice: undefined,
    underlyingPrice: undefined,
    atm: undefined,
    delta50: undefined,
    deltaCall05: undefined,
    deltaCall10: undefined,
    deltaCall15: undefined,
    deltaCall20: undefined,
    deltaCall25: undefined,
    deltaCall30: undefined,
    deltaCall35: undefined,
    deltaCall40: undefined,
    deltaCall45: undefined,
    deltaPut05: undefined,
    deltaPut10: undefined,
    deltaPut15: undefined,
    deltaPut20: undefined,
    deltaPut25: undefined,
    deltaPut30: undefined,
    deltaPut35: undefined,
    deltaPut40: undefined,
    deltaPut45: undefined,
    bookIndexPrice: undefined,
  }
}

export const DeltaSurfaceFloatingPoint: MessageFns<DeltaSurfaceFloatingPoint> = {
  encode(
    message: DeltaSurfaceFloatingPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(42).string(message.daysToExpiration)
    }
    if (message.multiplier !== undefined) {
      writer.uint32(50).string(message.multiplier)
    }
    if (message.openInterest !== undefined) {
      writer.uint32(58).string(message.openInterest)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(66).string(message.indexPrice)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(74).string(message.underlyingPrice)
    }
    if (message.atm !== undefined) {
      writer.uint32(82).string(message.atm)
    }
    if (message.delta50 !== undefined) {
      writer.uint32(90).string(message.delta50)
    }
    if (message.deltaCall05 !== undefined) {
      writer.uint32(98).string(message.deltaCall05)
    }
    if (message.deltaCall10 !== undefined) {
      writer.uint32(106).string(message.deltaCall10)
    }
    if (message.deltaCall15 !== undefined) {
      writer.uint32(114).string(message.deltaCall15)
    }
    if (message.deltaCall20 !== undefined) {
      writer.uint32(122).string(message.deltaCall20)
    }
    if (message.deltaCall25 !== undefined) {
      writer.uint32(130).string(message.deltaCall25)
    }
    if (message.deltaCall30 !== undefined) {
      writer.uint32(138).string(message.deltaCall30)
    }
    if (message.deltaCall35 !== undefined) {
      writer.uint32(146).string(message.deltaCall35)
    }
    if (message.deltaCall40 !== undefined) {
      writer.uint32(154).string(message.deltaCall40)
    }
    if (message.deltaCall45 !== undefined) {
      writer.uint32(162).string(message.deltaCall45)
    }
    if (message.deltaPut05 !== undefined) {
      writer.uint32(170).string(message.deltaPut05)
    }
    if (message.deltaPut10 !== undefined) {
      writer.uint32(178).string(message.deltaPut10)
    }
    if (message.deltaPut15 !== undefined) {
      writer.uint32(186).string(message.deltaPut15)
    }
    if (message.deltaPut20 !== undefined) {
      writer.uint32(194).string(message.deltaPut20)
    }
    if (message.deltaPut25 !== undefined) {
      writer.uint32(202).string(message.deltaPut25)
    }
    if (message.deltaPut30 !== undefined) {
      writer.uint32(210).string(message.deltaPut30)
    }
    if (message.deltaPut35 !== undefined) {
      writer.uint32(218).string(message.deltaPut35)
    }
    if (message.deltaPut40 !== undefined) {
      writer.uint32(226).string(message.deltaPut40)
    }
    if (message.deltaPut45 !== undefined) {
      writer.uint32(234).string(message.deltaPut45)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(242).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaSurfaceFloatingPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaSurfaceFloatingPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.multiplier = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.openInterest = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.atm = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.delta50 = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.deltaCall05 = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.deltaCall10 = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.deltaCall15 = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.deltaCall20 = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.deltaCall25 = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.deltaCall30 = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.deltaCall35 = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.deltaCall40 = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.deltaCall45 = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.deltaPut05 = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.deltaPut10 = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.deltaPut15 = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.deltaPut20 = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.deltaPut25 = reader.string()
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.deltaPut30 = reader.string()
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.deltaPut35 = reader.string()
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.deltaPut40 = reader.string()
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.deltaPut45 = reader.string()
          continue
        }
        case 30: {
          if (tag !== 242) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaSurfaceFloatingPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      multiplier: isSet(object.multiplier) ? globalThis.String(object.multiplier) : undefined,
      openInterest: isSet(object.openInterest)
        ? globalThis.String(object.openInterest)
        : isSet(object.open_interest)
          ? globalThis.String(object.open_interest)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      atm: isSet(object.atm) ? globalThis.String(object.atm) : undefined,
      delta50: isSet(object.delta50)
        ? globalThis.String(object.delta50)
        : isSet(object.delta_50)
          ? globalThis.String(object.delta_50)
          : undefined,
      deltaCall05: isSet(object.deltaCall05)
        ? globalThis.String(object.deltaCall05)
        : isSet(object.delta_call_05)
          ? globalThis.String(object.delta_call_05)
          : undefined,
      deltaCall10: isSet(object.deltaCall10)
        ? globalThis.String(object.deltaCall10)
        : isSet(object.delta_call_10)
          ? globalThis.String(object.delta_call_10)
          : undefined,
      deltaCall15: isSet(object.deltaCall15)
        ? globalThis.String(object.deltaCall15)
        : isSet(object.delta_call_15)
          ? globalThis.String(object.delta_call_15)
          : undefined,
      deltaCall20: isSet(object.deltaCall20)
        ? globalThis.String(object.deltaCall20)
        : isSet(object.delta_call_20)
          ? globalThis.String(object.delta_call_20)
          : undefined,
      deltaCall25: isSet(object.deltaCall25)
        ? globalThis.String(object.deltaCall25)
        : isSet(object.delta_call_25)
          ? globalThis.String(object.delta_call_25)
          : undefined,
      deltaCall30: isSet(object.deltaCall30)
        ? globalThis.String(object.deltaCall30)
        : isSet(object.delta_call_30)
          ? globalThis.String(object.delta_call_30)
          : undefined,
      deltaCall35: isSet(object.deltaCall35)
        ? globalThis.String(object.deltaCall35)
        : isSet(object.delta_call_35)
          ? globalThis.String(object.delta_call_35)
          : undefined,
      deltaCall40: isSet(object.deltaCall40)
        ? globalThis.String(object.deltaCall40)
        : isSet(object.delta_call_40)
          ? globalThis.String(object.delta_call_40)
          : undefined,
      deltaCall45: isSet(object.deltaCall45)
        ? globalThis.String(object.deltaCall45)
        : isSet(object.delta_call_45)
          ? globalThis.String(object.delta_call_45)
          : undefined,
      deltaPut05: isSet(object.deltaPut05)
        ? globalThis.String(object.deltaPut05)
        : isSet(object.delta_put_05)
          ? globalThis.String(object.delta_put_05)
          : undefined,
      deltaPut10: isSet(object.deltaPut10)
        ? globalThis.String(object.deltaPut10)
        : isSet(object.delta_put_10)
          ? globalThis.String(object.delta_put_10)
          : undefined,
      deltaPut15: isSet(object.deltaPut15)
        ? globalThis.String(object.deltaPut15)
        : isSet(object.delta_put_15)
          ? globalThis.String(object.delta_put_15)
          : undefined,
      deltaPut20: isSet(object.deltaPut20)
        ? globalThis.String(object.deltaPut20)
        : isSet(object.delta_put_20)
          ? globalThis.String(object.delta_put_20)
          : undefined,
      deltaPut25: isSet(object.deltaPut25)
        ? globalThis.String(object.deltaPut25)
        : isSet(object.delta_put_25)
          ? globalThis.String(object.delta_put_25)
          : undefined,
      deltaPut30: isSet(object.deltaPut30)
        ? globalThis.String(object.deltaPut30)
        : isSet(object.delta_put_30)
          ? globalThis.String(object.delta_put_30)
          : undefined,
      deltaPut35: isSet(object.deltaPut35)
        ? globalThis.String(object.deltaPut35)
        : isSet(object.delta_put_35)
          ? globalThis.String(object.delta_put_35)
          : undefined,
      deltaPut40: isSet(object.deltaPut40)
        ? globalThis.String(object.deltaPut40)
        : isSet(object.delta_put_40)
          ? globalThis.String(object.delta_put_40)
          : undefined,
      deltaPut45: isSet(object.deltaPut45)
        ? globalThis.String(object.deltaPut45)
        : isSet(object.delta_put_45)
          ? globalThis.String(object.delta_put_45)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: DeltaSurfaceFloatingPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = message.multiplier
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = message.openInterest
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.atm !== undefined) {
      obj.atm = message.atm
    }
    if (message.delta50 !== undefined) {
      obj.delta50 = message.delta50
    }
    if (message.deltaCall05 !== undefined) {
      obj.deltaCall05 = message.deltaCall05
    }
    if (message.deltaCall10 !== undefined) {
      obj.deltaCall10 = message.deltaCall10
    }
    if (message.deltaCall15 !== undefined) {
      obj.deltaCall15 = message.deltaCall15
    }
    if (message.deltaCall20 !== undefined) {
      obj.deltaCall20 = message.deltaCall20
    }
    if (message.deltaCall25 !== undefined) {
      obj.deltaCall25 = message.deltaCall25
    }
    if (message.deltaCall30 !== undefined) {
      obj.deltaCall30 = message.deltaCall30
    }
    if (message.deltaCall35 !== undefined) {
      obj.deltaCall35 = message.deltaCall35
    }
    if (message.deltaCall40 !== undefined) {
      obj.deltaCall40 = message.deltaCall40
    }
    if (message.deltaCall45 !== undefined) {
      obj.deltaCall45 = message.deltaCall45
    }
    if (message.deltaPut05 !== undefined) {
      obj.deltaPut05 = message.deltaPut05
    }
    if (message.deltaPut10 !== undefined) {
      obj.deltaPut10 = message.deltaPut10
    }
    if (message.deltaPut15 !== undefined) {
      obj.deltaPut15 = message.deltaPut15
    }
    if (message.deltaPut20 !== undefined) {
      obj.deltaPut20 = message.deltaPut20
    }
    if (message.deltaPut25 !== undefined) {
      obj.deltaPut25 = message.deltaPut25
    }
    if (message.deltaPut30 !== undefined) {
      obj.deltaPut30 = message.deltaPut30
    }
    if (message.deltaPut35 !== undefined) {
      obj.deltaPut35 = message.deltaPut35
    }
    if (message.deltaPut40 !== undefined) {
      obj.deltaPut40 = message.deltaPut40
    }
    if (message.deltaPut45 !== undefined) {
      obj.deltaPut45 = message.deltaPut45
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaSurfaceFloatingPoint>, I>>(
    base?: I
  ): DeltaSurfaceFloatingPoint {
    return DeltaSurfaceFloatingPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaSurfaceFloatingPoint>, I>>(
    object: I
  ): DeltaSurfaceFloatingPoint {
    const message = createBaseDeltaSurfaceFloatingPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.multiplier = object.multiplier ?? undefined
    message.openInterest = object.openInterest ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.atm = object.atm ?? undefined
    message.delta50 = object.delta50 ?? undefined
    message.deltaCall05 = object.deltaCall05 ?? undefined
    message.deltaCall10 = object.deltaCall10 ?? undefined
    message.deltaCall15 = object.deltaCall15 ?? undefined
    message.deltaCall20 = object.deltaCall20 ?? undefined
    message.deltaCall25 = object.deltaCall25 ?? undefined
    message.deltaCall30 = object.deltaCall30 ?? undefined
    message.deltaCall35 = object.deltaCall35 ?? undefined
    message.deltaCall40 = object.deltaCall40 ?? undefined
    message.deltaCall45 = object.deltaCall45 ?? undefined
    message.deltaPut05 = object.deltaPut05 ?? undefined
    message.deltaPut10 = object.deltaPut10 ?? undefined
    message.deltaPut15 = object.deltaPut15 ?? undefined
    message.deltaPut20 = object.deltaPut20 ?? undefined
    message.deltaPut25 = object.deltaPut25 ?? undefined
    message.deltaPut30 = object.deltaPut30 ?? undefined
    message.deltaPut35 = object.deltaPut35 ?? undefined
    message.deltaPut40 = object.deltaPut40 ?? undefined
    message.deltaPut45 = object.deltaPut45 ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseDeltaSurfaceFloatingList(): DeltaSurfaceFloatingList {
  return { items: [] }
}

export const DeltaSurfaceFloatingList: MessageFns<DeltaSurfaceFloatingList> = {
  encode(
    message: DeltaSurfaceFloatingList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      DeltaSurfaceFloatingPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaSurfaceFloatingList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaSurfaceFloatingList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(DeltaSurfaceFloatingPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaSurfaceFloatingList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => DeltaSurfaceFloatingPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DeltaSurfaceFloatingList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => DeltaSurfaceFloatingPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaSurfaceFloatingList>, I>>(
    base?: I
  ): DeltaSurfaceFloatingList {
    return DeltaSurfaceFloatingList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaSurfaceFloatingList>, I>>(
    object: I
  ): DeltaSurfaceFloatingList {
    const message = createBaseDeltaSurfaceFloatingList()
    message.items = object.items?.map((e) => DeltaSurfaceFloatingPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseSkewConstantPoint(): SkewConstantPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    daysToExpiration: '',
    skew05: undefined,
    skew10: undefined,
    skew15: undefined,
    skew20: undefined,
    skew25: undefined,
    skew30: undefined,
    skew35: undefined,
    skew40: undefined,
    skew45: undefined,
    indexPrice: undefined,
    bookIndexPrice: undefined,
  }
}

export const SkewConstantPoint: MessageFns<SkewConstantPoint> = {
  encode(message: SkewConstantPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(34).string(message.daysToExpiration)
    }
    if (message.skew05 !== undefined) {
      writer.uint32(42).string(message.skew05)
    }
    if (message.skew10 !== undefined) {
      writer.uint32(50).string(message.skew10)
    }
    if (message.skew15 !== undefined) {
      writer.uint32(58).string(message.skew15)
    }
    if (message.skew20 !== undefined) {
      writer.uint32(66).string(message.skew20)
    }
    if (message.skew25 !== undefined) {
      writer.uint32(74).string(message.skew25)
    }
    if (message.skew30 !== undefined) {
      writer.uint32(82).string(message.skew30)
    }
    if (message.skew35 !== undefined) {
      writer.uint32(90).string(message.skew35)
    }
    if (message.skew40 !== undefined) {
      writer.uint32(98).string(message.skew40)
    }
    if (message.skew45 !== undefined) {
      writer.uint32(106).string(message.skew45)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(114).string(message.indexPrice)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(122).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkewConstantPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSkewConstantPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.skew05 = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.skew10 = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.skew15 = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.skew20 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.skew25 = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.skew30 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.skew35 = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.skew40 = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.skew45 = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SkewConstantPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      skew05: isSet(object.skew05)
        ? globalThis.String(object.skew05)
        : isSet(object.skew_05)
          ? globalThis.String(object.skew_05)
          : undefined,
      skew10: isSet(object.skew10)
        ? globalThis.String(object.skew10)
        : isSet(object.skew_10)
          ? globalThis.String(object.skew_10)
          : undefined,
      skew15: isSet(object.skew15)
        ? globalThis.String(object.skew15)
        : isSet(object.skew_15)
          ? globalThis.String(object.skew_15)
          : undefined,
      skew20: isSet(object.skew20)
        ? globalThis.String(object.skew20)
        : isSet(object.skew_20)
          ? globalThis.String(object.skew_20)
          : undefined,
      skew25: isSet(object.skew25)
        ? globalThis.String(object.skew25)
        : isSet(object.skew_25)
          ? globalThis.String(object.skew_25)
          : undefined,
      skew30: isSet(object.skew30)
        ? globalThis.String(object.skew30)
        : isSet(object.skew_30)
          ? globalThis.String(object.skew_30)
          : undefined,
      skew35: isSet(object.skew35)
        ? globalThis.String(object.skew35)
        : isSet(object.skew_35)
          ? globalThis.String(object.skew_35)
          : undefined,
      skew40: isSet(object.skew40)
        ? globalThis.String(object.skew40)
        : isSet(object.skew_40)
          ? globalThis.String(object.skew_40)
          : undefined,
      skew45: isSet(object.skew45)
        ? globalThis.String(object.skew45)
        : isSet(object.skew_45)
          ? globalThis.String(object.skew_45)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: SkewConstantPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.skew05 !== undefined) {
      obj.skew05 = message.skew05
    }
    if (message.skew10 !== undefined) {
      obj.skew10 = message.skew10
    }
    if (message.skew15 !== undefined) {
      obj.skew15 = message.skew15
    }
    if (message.skew20 !== undefined) {
      obj.skew20 = message.skew20
    }
    if (message.skew25 !== undefined) {
      obj.skew25 = message.skew25
    }
    if (message.skew30 !== undefined) {
      obj.skew30 = message.skew30
    }
    if (message.skew35 !== undefined) {
      obj.skew35 = message.skew35
    }
    if (message.skew40 !== undefined) {
      obj.skew40 = message.skew40
    }
    if (message.skew45 !== undefined) {
      obj.skew45 = message.skew45
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SkewConstantPoint>, I>>(base?: I): SkewConstantPoint {
    return SkewConstantPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SkewConstantPoint>, I>>(object: I): SkewConstantPoint {
    const message = createBaseSkewConstantPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.skew05 = object.skew05 ?? undefined
    message.skew10 = object.skew10 ?? undefined
    message.skew15 = object.skew15 ?? undefined
    message.skew20 = object.skew20 ?? undefined
    message.skew25 = object.skew25 ?? undefined
    message.skew30 = object.skew30 ?? undefined
    message.skew35 = object.skew35 ?? undefined
    message.skew40 = object.skew40 ?? undefined
    message.skew45 = object.skew45 ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseSkewConstantList(): SkewConstantList {
  return { items: [] }
}

export const SkewConstantList: MessageFns<SkewConstantList> = {
  encode(message: SkewConstantList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      SkewConstantPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkewConstantList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSkewConstantList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(SkewConstantPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SkewConstantList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => SkewConstantPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SkewConstantList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => SkewConstantPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SkewConstantList>, I>>(base?: I): SkewConstantList {
    return SkewConstantList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SkewConstantList>, I>>(object: I): SkewConstantList {
    const message = createBaseSkewConstantList()
    message.items = object.items?.map((e) => SkewConstantPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseSkewFloatingPoint(): SkewFloatingPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    daysToExpiration: '',
    skew05: undefined,
    skew10: undefined,
    skew15: undefined,
    skew20: undefined,
    skew25: undefined,
    skew30: undefined,
    skew35: undefined,
    skew40: undefined,
    skew45: undefined,
    indexPrice: undefined,
    bookIndexPrice: undefined,
  }
}

export const SkewFloatingPoint: MessageFns<SkewFloatingPoint> = {
  encode(message: SkewFloatingPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(42).string(message.daysToExpiration)
    }
    if (message.skew05 !== undefined) {
      writer.uint32(50).string(message.skew05)
    }
    if (message.skew10 !== undefined) {
      writer.uint32(58).string(message.skew10)
    }
    if (message.skew15 !== undefined) {
      writer.uint32(66).string(message.skew15)
    }
    if (message.skew20 !== undefined) {
      writer.uint32(74).string(message.skew20)
    }
    if (message.skew25 !== undefined) {
      writer.uint32(82).string(message.skew25)
    }
    if (message.skew30 !== undefined) {
      writer.uint32(90).string(message.skew30)
    }
    if (message.skew35 !== undefined) {
      writer.uint32(98).string(message.skew35)
    }
    if (message.skew40 !== undefined) {
      writer.uint32(106).string(message.skew40)
    }
    if (message.skew45 !== undefined) {
      writer.uint32(114).string(message.skew45)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(122).string(message.indexPrice)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(130).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkewFloatingPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSkewFloatingPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.skew05 = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.skew10 = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.skew15 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.skew20 = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.skew25 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.skew30 = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.skew35 = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.skew40 = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.skew45 = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SkewFloatingPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      skew05: isSet(object.skew05)
        ? globalThis.String(object.skew05)
        : isSet(object.skew_05)
          ? globalThis.String(object.skew_05)
          : undefined,
      skew10: isSet(object.skew10)
        ? globalThis.String(object.skew10)
        : isSet(object.skew_10)
          ? globalThis.String(object.skew_10)
          : undefined,
      skew15: isSet(object.skew15)
        ? globalThis.String(object.skew15)
        : isSet(object.skew_15)
          ? globalThis.String(object.skew_15)
          : undefined,
      skew20: isSet(object.skew20)
        ? globalThis.String(object.skew20)
        : isSet(object.skew_20)
          ? globalThis.String(object.skew_20)
          : undefined,
      skew25: isSet(object.skew25)
        ? globalThis.String(object.skew25)
        : isSet(object.skew_25)
          ? globalThis.String(object.skew_25)
          : undefined,
      skew30: isSet(object.skew30)
        ? globalThis.String(object.skew30)
        : isSet(object.skew_30)
          ? globalThis.String(object.skew_30)
          : undefined,
      skew35: isSet(object.skew35)
        ? globalThis.String(object.skew35)
        : isSet(object.skew_35)
          ? globalThis.String(object.skew_35)
          : undefined,
      skew40: isSet(object.skew40)
        ? globalThis.String(object.skew40)
        : isSet(object.skew_40)
          ? globalThis.String(object.skew_40)
          : undefined,
      skew45: isSet(object.skew45)
        ? globalThis.String(object.skew45)
        : isSet(object.skew_45)
          ? globalThis.String(object.skew_45)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: SkewFloatingPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.skew05 !== undefined) {
      obj.skew05 = message.skew05
    }
    if (message.skew10 !== undefined) {
      obj.skew10 = message.skew10
    }
    if (message.skew15 !== undefined) {
      obj.skew15 = message.skew15
    }
    if (message.skew20 !== undefined) {
      obj.skew20 = message.skew20
    }
    if (message.skew25 !== undefined) {
      obj.skew25 = message.skew25
    }
    if (message.skew30 !== undefined) {
      obj.skew30 = message.skew30
    }
    if (message.skew35 !== undefined) {
      obj.skew35 = message.skew35
    }
    if (message.skew40 !== undefined) {
      obj.skew40 = message.skew40
    }
    if (message.skew45 !== undefined) {
      obj.skew45 = message.skew45
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SkewFloatingPoint>, I>>(base?: I): SkewFloatingPoint {
    return SkewFloatingPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SkewFloatingPoint>, I>>(object: I): SkewFloatingPoint {
    const message = createBaseSkewFloatingPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.skew05 = object.skew05 ?? undefined
    message.skew10 = object.skew10 ?? undefined
    message.skew15 = object.skew15 ?? undefined
    message.skew20 = object.skew20 ?? undefined
    message.skew25 = object.skew25 ?? undefined
    message.skew30 = object.skew30 ?? undefined
    message.skew35 = object.skew35 ?? undefined
    message.skew40 = object.skew40 ?? undefined
    message.skew45 = object.skew45 ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseSkewFloatingList(): SkewFloatingList {
  return { items: [] }
}

export const SkewFloatingList: MessageFns<SkewFloatingList> = {
  encode(message: SkewFloatingList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      SkewFloatingPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkewFloatingList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSkewFloatingList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(SkewFloatingPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SkewFloatingList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => SkewFloatingPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SkewFloatingList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => SkewFloatingPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SkewFloatingList>, I>>(base?: I): SkewFloatingList {
    return SkewFloatingList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SkewFloatingList>, I>>(object: I): SkewFloatingList {
    const message = createBaseSkewFloatingList()
    message.items = object.items?.map((e) => SkewFloatingPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseFedwatchProbabilityPoint(): FedwatchProbabilityPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    meetingDate: '',
    targetLowerBp: 0,
    cumulativeMoveBp: 0,
    probability: '',
  }
}

export const FedwatchProbabilityPoint: MessageFns<FedwatchProbabilityPoint> = {
  encode(
    message: FedwatchProbabilityPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.meetingDate !== '') {
      writer.uint32(34).string(message.meetingDate)
    }
    if (message.targetLowerBp !== 0) {
      writer.uint32(40).int32(message.targetLowerBp)
    }
    if (message.cumulativeMoveBp !== 0) {
      writer.uint32(48).int32(message.cumulativeMoveBp)
    }
    if (message.probability !== '') {
      writer.uint32(58).string(message.probability)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FedwatchProbabilityPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFedwatchProbabilityPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.meetingDate = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.targetLowerBp = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.cumulativeMoveBp = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.probability = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FedwatchProbabilityPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      meetingDate: isSet(object.meetingDate)
        ? globalThis.String(object.meetingDate)
        : isSet(object.meeting_date)
          ? globalThis.String(object.meeting_date)
          : '',
      targetLowerBp: isSet(object.targetLowerBp)
        ? globalThis.Number(object.targetLowerBp)
        : isSet(object.target_lower_bp)
          ? globalThis.Number(object.target_lower_bp)
          : 0,
      cumulativeMoveBp: isSet(object.cumulativeMoveBp)
        ? globalThis.Number(object.cumulativeMoveBp)
        : isSet(object.cumulative_move_bp)
          ? globalThis.Number(object.cumulative_move_bp)
          : 0,
      probability: isSet(object.probability) ? globalThis.String(object.probability) : '',
    }
  },

  toJSON(message: FedwatchProbabilityPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.meetingDate !== '') {
      obj.meetingDate = message.meetingDate
    }
    if (message.targetLowerBp !== 0) {
      obj.targetLowerBp = Math.round(message.targetLowerBp)
    }
    if (message.cumulativeMoveBp !== 0) {
      obj.cumulativeMoveBp = Math.round(message.cumulativeMoveBp)
    }
    if (message.probability !== '') {
      obj.probability = message.probability
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FedwatchProbabilityPoint>, I>>(
    base?: I
  ): FedwatchProbabilityPoint {
    return FedwatchProbabilityPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FedwatchProbabilityPoint>, I>>(
    object: I
  ): FedwatchProbabilityPoint {
    const message = createBaseFedwatchProbabilityPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.meetingDate = object.meetingDate ?? ''
    message.targetLowerBp = object.targetLowerBp ?? 0
    message.cumulativeMoveBp = object.cumulativeMoveBp ?? 0
    message.probability = object.probability ?? ''
    return message
  },
}

function createBaseFedwatchProbabilityList(): FedwatchProbabilityList {
  return { items: [] }
}

export const FedwatchProbabilityList: MessageFns<FedwatchProbabilityList> = {
  encode(
    message: FedwatchProbabilityList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      FedwatchProbabilityPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FedwatchProbabilityList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFedwatchProbabilityList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(FedwatchProbabilityPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FedwatchProbabilityList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => FedwatchProbabilityPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: FedwatchProbabilityList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => FedwatchProbabilityPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FedwatchProbabilityList>, I>>(
    base?: I
  ): FedwatchProbabilityList {
    return FedwatchProbabilityList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FedwatchProbabilityList>, I>>(
    object: I
  ): FedwatchProbabilityList {
    const message = createBaseFedwatchProbabilityList()
    message.items = object.items?.map((e) => FedwatchProbabilityPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsVolumeLeaderboardEntry(): OptionsVolumeLeaderboardEntry {
  return {
    symbol: undefined,
    expiryMs: undefined,
    volume: '',
    callVolume: undefined,
    putVolume: undefined,
  }
}

export const OptionsVolumeLeaderboardEntry: MessageFns<OptionsVolumeLeaderboardEntry> = {
  encode(
    message: OptionsVolumeLeaderboardEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.symbol !== undefined) {
      writer.uint32(10).string(message.symbol)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(16).int64(message.expiryMs)
    }
    if (message.volume !== '') {
      writer.uint32(26).string(message.volume)
    }
    if (message.callVolume !== undefined) {
      writer.uint32(34).string(message.callVolume)
    }
    if (message.putVolume !== undefined) {
      writer.uint32(42).string(message.putVolume)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeLeaderboardEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeLeaderboardEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.volume = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.callVolume = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.putVolume = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeLeaderboardEntry {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
      volume: isSet(object.volume) ? globalThis.String(object.volume) : '',
      callVolume: isSet(object.callVolume)
        ? globalThis.String(object.callVolume)
        : isSet(object.call_volume)
          ? globalThis.String(object.call_volume)
          : undefined,
      putVolume: isSet(object.putVolume)
        ? globalThis.String(object.putVolume)
        : isSet(object.put_volume)
          ? globalThis.String(object.put_volume)
          : undefined,
    }
  },

  toJSON(message: OptionsVolumeLeaderboardEntry): unknown {
    const obj: any = {}
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    if (message.volume !== '') {
      obj.volume = message.volume
    }
    if (message.callVolume !== undefined) {
      obj.callVolume = message.callVolume
    }
    if (message.putVolume !== undefined) {
      obj.putVolume = message.putVolume
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeLeaderboardEntry>, I>>(
    base?: I
  ): OptionsVolumeLeaderboardEntry {
    return OptionsVolumeLeaderboardEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeLeaderboardEntry>, I>>(
    object: I
  ): OptionsVolumeLeaderboardEntry {
    const message = createBaseOptionsVolumeLeaderboardEntry()
    message.symbol = object.symbol ?? undefined
    message.expiryMs = object.expiryMs ?? undefined
    message.volume = object.volume ?? ''
    message.callVolume = object.callVolume ?? undefined
    message.putVolume = object.putVolume ?? undefined
    return message
  },
}

function createBaseOptionsVolumeLeaderboard(): OptionsVolumeLeaderboard {
  return { exchange: 0, underlying: '', volumeMeasure: 0, groupBy: 0, entries: [] }
}

export const OptionsVolumeLeaderboard: MessageFns<OptionsVolumeLeaderboard> = {
  encode(
    message: OptionsVolumeLeaderboard,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(24).int32(message.volumeMeasure)
    }
    if (message.groupBy !== 0) {
      writer.uint32(32).int32(message.groupBy)
    }
    for (const v of message.entries) {
      OptionsVolumeLeaderboardEntry.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeLeaderboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeLeaderboard()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.groupBy = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.entries.push(OptionsVolumeLeaderboardEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeLeaderboard {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      groupBy: isSet(object.groupBy)
        ? optionsVolumeGroupByFromJSON(object.groupBy)
        : isSet(object.group_by)
          ? optionsVolumeGroupByFromJSON(object.group_by)
          : 0,
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => OptionsVolumeLeaderboardEntry.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsVolumeLeaderboard): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.groupBy !== 0) {
      obj.groupBy = optionsVolumeGroupByToJSON(message.groupBy)
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => OptionsVolumeLeaderboardEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeLeaderboard>, I>>(
    base?: I
  ): OptionsVolumeLeaderboard {
    return OptionsVolumeLeaderboard.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeLeaderboard>, I>>(
    object: I
  ): OptionsVolumeLeaderboard {
    const message = createBaseOptionsVolumeLeaderboard()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.groupBy = object.groupBy ?? 0
    message.entries = object.entries?.map((e) => OptionsVolumeLeaderboardEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsVolumeBucket(): OptionsVolumeBucket {
  return { timestampMs: '0', volume: '', callVolume: '', putVolume: '' }
}

export const OptionsVolumeBucket: MessageFns<OptionsVolumeBucket> = {
  encode(message: OptionsVolumeBucket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.volume !== '') {
      writer.uint32(18).string(message.volume)
    }
    if (message.callVolume !== '') {
      writer.uint32(26).string(message.callVolume)
    }
    if (message.putVolume !== '') {
      writer.uint32(34).string(message.putVolume)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeBucket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeBucket()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.volume = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.callVolume = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.putVolume = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeBucket {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      volume: isSet(object.volume) ? globalThis.String(object.volume) : '',
      callVolume: isSet(object.callVolume)
        ? globalThis.String(object.callVolume)
        : isSet(object.call_volume)
          ? globalThis.String(object.call_volume)
          : '',
      putVolume: isSet(object.putVolume)
        ? globalThis.String(object.putVolume)
        : isSet(object.put_volume)
          ? globalThis.String(object.put_volume)
          : '',
    }
  },

  toJSON(message: OptionsVolumeBucket): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.volume !== '') {
      obj.volume = message.volume
    }
    if (message.callVolume !== '') {
      obj.callVolume = message.callVolume
    }
    if (message.putVolume !== '') {
      obj.putVolume = message.putVolume
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeBucket>, I>>(base?: I): OptionsVolumeBucket {
    return OptionsVolumeBucket.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeBucket>, I>>(
    object: I
  ): OptionsVolumeBucket {
    const message = createBaseOptionsVolumeBucket()
    message.timestampMs = object.timestampMs ?? '0'
    message.volume = object.volume ?? ''
    message.callVolume = object.callVolume ?? ''
    message.putVolume = object.putVolume ?? ''
    return message
  },
}

function createBaseOptionsVolumeSeries(): OptionsVolumeSeries {
  return { exchange: 0, underlying: '', timeframe: 0, volumeMeasure: 0, buckets: [] }
}

export const OptionsVolumeSeries: MessageFns<OptionsVolumeSeries> = {
  encode(message: OptionsVolumeSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(32).int32(message.volumeMeasure)
    }
    for (const v of message.buckets) {
      OptionsVolumeBucket.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.buckets.push(OptionsVolumeBucket.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeSeries {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      buckets: globalThis.Array.isArray(object?.buckets)
        ? object.buckets.map((e: any) => OptionsVolumeBucket.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsVolumeSeries): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.buckets?.length) {
      obj.buckets = message.buckets.map((e) => OptionsVolumeBucket.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeSeries>, I>>(base?: I): OptionsVolumeSeries {
    return OptionsVolumeSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeSeries>, I>>(
    object: I
  ): OptionsVolumeSeries {
    const message = createBaseOptionsVolumeSeries()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.buckets = object.buckets?.map((e) => OptionsVolumeBucket.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsStrikeFlowCell(): OptionsStrikeFlowCell {
  return { strike: '', buyVolume: '', sellVolume: '' }
}

export const OptionsStrikeFlowCell: MessageFns<OptionsStrikeFlowCell> = {
  encode(message: OptionsStrikeFlowCell, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strike !== '') {
      writer.uint32(10).string(message.strike)
    }
    if (message.buyVolume !== '') {
      writer.uint32(18).string(message.buyVolume)
    }
    if (message.sellVolume !== '') {
      writer.uint32(26).string(message.sellVolume)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsStrikeFlowCell {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsStrikeFlowCell()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.buyVolume = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sellVolume = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsStrikeFlowCell {
    return {
      strike: isSet(object.strike) ? globalThis.String(object.strike) : '',
      buyVolume: isSet(object.buyVolume)
        ? globalThis.String(object.buyVolume)
        : isSet(object.buy_volume)
          ? globalThis.String(object.buy_volume)
          : '',
      sellVolume: isSet(object.sellVolume)
        ? globalThis.String(object.sellVolume)
        : isSet(object.sell_volume)
          ? globalThis.String(object.sell_volume)
          : '',
    }
  },

  toJSON(message: OptionsStrikeFlowCell): unknown {
    const obj: any = {}
    if (message.strike !== '') {
      obj.strike = message.strike
    }
    if (message.buyVolume !== '') {
      obj.buyVolume = message.buyVolume
    }
    if (message.sellVolume !== '') {
      obj.sellVolume = message.sellVolume
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsStrikeFlowCell>, I>>(base?: I): OptionsStrikeFlowCell {
    return OptionsStrikeFlowCell.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsStrikeFlowCell>, I>>(
    object: I
  ): OptionsStrikeFlowCell {
    const message = createBaseOptionsStrikeFlowCell()
    message.strike = object.strike ?? ''
    message.buyVolume = object.buyVolume ?? ''
    message.sellVolume = object.sellVolume ?? ''
    return message
  },
}

function createBaseOptionsStrikeFlowBucket(): OptionsStrikeFlowBucket {
  return { timestampMs: '0', avgIndexPrice: undefined, cells: [] }
}

export const OptionsStrikeFlowBucket: MessageFns<OptionsStrikeFlowBucket> = {
  encode(
    message: OptionsStrikeFlowBucket,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.avgIndexPrice !== undefined) {
      writer.uint32(18).string(message.avgIndexPrice)
    }
    for (const v of message.cells) {
      OptionsStrikeFlowCell.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsStrikeFlowBucket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsStrikeFlowBucket()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.avgIndexPrice = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.cells.push(OptionsStrikeFlowCell.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsStrikeFlowBucket {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      avgIndexPrice: isSet(object.avgIndexPrice)
        ? globalThis.String(object.avgIndexPrice)
        : isSet(object.avg_index_price)
          ? globalThis.String(object.avg_index_price)
          : undefined,
      cells: globalThis.Array.isArray(object?.cells)
        ? object.cells.map((e: any) => OptionsStrikeFlowCell.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsStrikeFlowBucket): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.avgIndexPrice !== undefined) {
      obj.avgIndexPrice = message.avgIndexPrice
    }
    if (message.cells?.length) {
      obj.cells = message.cells.map((e) => OptionsStrikeFlowCell.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsStrikeFlowBucket>, I>>(
    base?: I
  ): OptionsStrikeFlowBucket {
    return OptionsStrikeFlowBucket.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsStrikeFlowBucket>, I>>(
    object: I
  ): OptionsStrikeFlowBucket {
    const message = createBaseOptionsStrikeFlowBucket()
    message.timestampMs = object.timestampMs ?? '0'
    message.avgIndexPrice = object.avgIndexPrice ?? undefined
    message.cells = object.cells?.map((e) => OptionsStrikeFlowCell.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsStrikeFlow(): OptionsStrikeFlow {
  return {
    exchange: 0,
    underlying: '',
    timeframe: 0,
    volumeMeasure: 0,
    expiryMs: undefined,
    strikes: [],
    buckets: [],
  }
}

export const OptionsStrikeFlow: MessageFns<OptionsStrikeFlow> = {
  encode(message: OptionsStrikeFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(32).int32(message.volumeMeasure)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(40).int64(message.expiryMs)
    }
    for (const v of message.strikes) {
      writer.uint32(50).string(v!)
    }
    for (const v of message.buckets) {
      OptionsStrikeFlowBucket.encode(v!, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsStrikeFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsStrikeFlow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.strikes.push(reader.string())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.buckets.push(OptionsStrikeFlowBucket.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsStrikeFlow {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
      strikes: globalThis.Array.isArray(object?.strikes)
        ? object.strikes.map((e: any) => globalThis.String(e))
        : [],
      buckets: globalThis.Array.isArray(object?.buckets)
        ? object.buckets.map((e: any) => OptionsStrikeFlowBucket.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsStrikeFlow): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    if (message.strikes?.length) {
      obj.strikes = message.strikes
    }
    if (message.buckets?.length) {
      obj.buckets = message.buckets.map((e) => OptionsStrikeFlowBucket.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsStrikeFlow>, I>>(base?: I): OptionsStrikeFlow {
    return OptionsStrikeFlow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsStrikeFlow>, I>>(object: I): OptionsStrikeFlow {
    const message = createBaseOptionsStrikeFlow()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.expiryMs = object.expiryMs ?? undefined
    message.strikes = object.strikes?.map((e) => e) || []
    message.buckets = object.buckets?.map((e) => OptionsStrikeFlowBucket.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsVolumeStream(): OptionsVolumeStream {
  return { exchange: 0, underlying: '', timeframe: 0 }
}

export const OptionsVolumeStream: MessageFns<OptionsVolumeStream> = {
  encode(message: OptionsVolumeStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeStream {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
    }
  },

  toJSON(message: OptionsVolumeStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeStream>, I>>(base?: I): OptionsVolumeStream {
    return OptionsVolumeStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeStream>, I>>(
    object: I
  ): OptionsVolumeStream {
    const message = createBaseOptionsVolumeStream()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    return message
  },
}

function createBaseOptionsVolumeStreamUpdate(): OptionsVolumeStreamUpdate {
  return {
    exchange: 0,
    underlying: '',
    timeframe: 0,
    timestampMs: '0',
    callNotionalBase: '',
    callNotionalQuote: '',
    callPremiumBase: '',
    callPremiumQuote: '',
    putNotionalBase: '',
    putNotionalQuote: '',
    putPremiumBase: '',
    putPremiumQuote: '',
  }
}

export const OptionsVolumeStreamUpdate: MessageFns<OptionsVolumeStreamUpdate> = {
  encode(
    message: OptionsVolumeStreamUpdate,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.timestampMs !== '0') {
      writer.uint32(32).int64(message.timestampMs)
    }
    if (message.callNotionalBase !== '') {
      writer.uint32(42).string(message.callNotionalBase)
    }
    if (message.callNotionalQuote !== '') {
      writer.uint32(50).string(message.callNotionalQuote)
    }
    if (message.callPremiumBase !== '') {
      writer.uint32(58).string(message.callPremiumBase)
    }
    if (message.callPremiumQuote !== '') {
      writer.uint32(66).string(message.callPremiumQuote)
    }
    if (message.putNotionalBase !== '') {
      writer.uint32(74).string(message.putNotionalBase)
    }
    if (message.putNotionalQuote !== '') {
      writer.uint32(82).string(message.putNotionalQuote)
    }
    if (message.putPremiumBase !== '') {
      writer.uint32(90).string(message.putPremiumBase)
    }
    if (message.putPremiumQuote !== '') {
      writer.uint32(98).string(message.putPremiumQuote)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeStreamUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeStreamUpdate()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.callNotionalBase = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.callNotionalQuote = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.callPremiumBase = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.callPremiumQuote = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.putNotionalBase = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.putNotionalQuote = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.putPremiumBase = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.putPremiumQuote = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeStreamUpdate {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      callNotionalBase: isSet(object.callNotionalBase)
        ? globalThis.String(object.callNotionalBase)
        : isSet(object.call_notional_base)
          ? globalThis.String(object.call_notional_base)
          : '',
      callNotionalQuote: isSet(object.callNotionalQuote)
        ? globalThis.String(object.callNotionalQuote)
        : isSet(object.call_notional_quote)
          ? globalThis.String(object.call_notional_quote)
          : '',
      callPremiumBase: isSet(object.callPremiumBase)
        ? globalThis.String(object.callPremiumBase)
        : isSet(object.call_premium_base)
          ? globalThis.String(object.call_premium_base)
          : '',
      callPremiumQuote: isSet(object.callPremiumQuote)
        ? globalThis.String(object.callPremiumQuote)
        : isSet(object.call_premium_quote)
          ? globalThis.String(object.call_premium_quote)
          : '',
      putNotionalBase: isSet(object.putNotionalBase)
        ? globalThis.String(object.putNotionalBase)
        : isSet(object.put_notional_base)
          ? globalThis.String(object.put_notional_base)
          : '',
      putNotionalQuote: isSet(object.putNotionalQuote)
        ? globalThis.String(object.putNotionalQuote)
        : isSet(object.put_notional_quote)
          ? globalThis.String(object.put_notional_quote)
          : '',
      putPremiumBase: isSet(object.putPremiumBase)
        ? globalThis.String(object.putPremiumBase)
        : isSet(object.put_premium_base)
          ? globalThis.String(object.put_premium_base)
          : '',
      putPremiumQuote: isSet(object.putPremiumQuote)
        ? globalThis.String(object.putPremiumQuote)
        : isSet(object.put_premium_quote)
          ? globalThis.String(object.put_premium_quote)
          : '',
    }
  },

  toJSON(message: OptionsVolumeStreamUpdate): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.callNotionalBase !== '') {
      obj.callNotionalBase = message.callNotionalBase
    }
    if (message.callNotionalQuote !== '') {
      obj.callNotionalQuote = message.callNotionalQuote
    }
    if (message.callPremiumBase !== '') {
      obj.callPremiumBase = message.callPremiumBase
    }
    if (message.callPremiumQuote !== '') {
      obj.callPremiumQuote = message.callPremiumQuote
    }
    if (message.putNotionalBase !== '') {
      obj.putNotionalBase = message.putNotionalBase
    }
    if (message.putNotionalQuote !== '') {
      obj.putNotionalQuote = message.putNotionalQuote
    }
    if (message.putPremiumBase !== '') {
      obj.putPremiumBase = message.putPremiumBase
    }
    if (message.putPremiumQuote !== '') {
      obj.putPremiumQuote = message.putPremiumQuote
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeStreamUpdate>, I>>(
    base?: I
  ): OptionsVolumeStreamUpdate {
    return OptionsVolumeStreamUpdate.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeStreamUpdate>, I>>(
    object: I
  ): OptionsVolumeStreamUpdate {
    const message = createBaseOptionsVolumeStreamUpdate()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.timestampMs = object.timestampMs ?? '0'
    message.callNotionalBase = object.callNotionalBase ?? ''
    message.callNotionalQuote = object.callNotionalQuote ?? ''
    message.callPremiumBase = object.callPremiumBase ?? ''
    message.callPremiumQuote = object.callPremiumQuote ?? ''
    message.putNotionalBase = object.putNotionalBase ?? ''
    message.putNotionalQuote = object.putNotionalQuote ?? ''
    message.putPremiumBase = object.putPremiumBase ?? ''
    message.putPremiumQuote = object.putPremiumQuote ?? ''
    return message
  },
}

function createBaseOptionsTradesStream(): OptionsTradesStream {
  return {
    exchange: 0,
    underlying: '',
    optionType: undefined,
    blockMode: 0,
    sizeMeasure: undefined,
    minSize: undefined,
  }
}

export const OptionsTradesStream: MessageFns<OptionsTradesStream> = {
  encode(message: OptionsTradesStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.optionType !== undefined) {
      writer.uint32(24).int32(message.optionType)
    }
    if (message.blockMode !== 0) {
      writer.uint32(32).int32(message.blockMode)
    }
    if (message.sizeMeasure !== undefined) {
      writer.uint32(40).int32(message.sizeMeasure)
    }
    if (message.minSize !== undefined) {
      writer.uint32(49).double(message.minSize)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsTradesStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsTradesStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.blockMode = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.sizeMeasure = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.minSize = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsTradesStream {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      blockMode: isSet(object.blockMode)
        ? blockTradeModeFromJSON(object.blockMode)
        : isSet(object.block_mode)
          ? blockTradeModeFromJSON(object.block_mode)
          : 0,
      sizeMeasure: isSet(object.sizeMeasure)
        ? optionsVolumeMeasureFromJSON(object.sizeMeasure)
        : isSet(object.size_measure)
          ? optionsVolumeMeasureFromJSON(object.size_measure)
          : undefined,
      minSize: isSet(object.minSize)
        ? globalThis.Number(object.minSize)
        : isSet(object.min_size)
          ? globalThis.Number(object.min_size)
          : undefined,
    }
  },

  toJSON(message: OptionsTradesStream): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.blockMode !== 0) {
      obj.blockMode = blockTradeModeToJSON(message.blockMode)
    }
    if (message.sizeMeasure !== undefined) {
      obj.sizeMeasure = optionsVolumeMeasureToJSON(message.sizeMeasure)
    }
    if (message.minSize !== undefined) {
      obj.minSize = message.minSize
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsTradesStream>, I>>(base?: I): OptionsTradesStream {
    return OptionsTradesStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsTradesStream>, I>>(
    object: I
  ): OptionsTradesStream {
    const message = createBaseOptionsTradesStream()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.optionType = object.optionType ?? undefined
    message.blockMode = object.blockMode ?? 0
    message.sizeMeasure = object.sizeMeasure ?? undefined
    message.minSize = object.minSize ?? undefined
    return message
  },
}

function createBaseOptionsOiBucket(): OptionsOiBucket {
  return { timestampMs: '0', oi: '', callOi: '', putOi: '' }
}

export const OptionsOiBucket: MessageFns<OptionsOiBucket> = {
  encode(message: OptionsOiBucket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.oi !== '') {
      writer.uint32(18).string(message.oi)
    }
    if (message.callOi !== '') {
      writer.uint32(26).string(message.callOi)
    }
    if (message.putOi !== '') {
      writer.uint32(34).string(message.putOi)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiBucket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiBucket()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.oi = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.callOi = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.putOi = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiBucket {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      oi: isSet(object.oi) ? globalThis.String(object.oi) : '',
      callOi: isSet(object.callOi)
        ? globalThis.String(object.callOi)
        : isSet(object.call_oi)
          ? globalThis.String(object.call_oi)
          : '',
      putOi: isSet(object.putOi)
        ? globalThis.String(object.putOi)
        : isSet(object.put_oi)
          ? globalThis.String(object.put_oi)
          : '',
    }
  },

  toJSON(message: OptionsOiBucket): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.oi !== '') {
      obj.oi = message.oi
    }
    if (message.callOi !== '') {
      obj.callOi = message.callOi
    }
    if (message.putOi !== '') {
      obj.putOi = message.putOi
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiBucket>, I>>(base?: I): OptionsOiBucket {
    return OptionsOiBucket.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiBucket>, I>>(object: I): OptionsOiBucket {
    const message = createBaseOptionsOiBucket()
    message.timestampMs = object.timestampMs ?? '0'
    message.oi = object.oi ?? ''
    message.callOi = object.callOi ?? ''
    message.putOi = object.putOi ?? ''
    return message
  },
}

function createBaseOptionsOiSeries(): OptionsOiSeries {
  return { exchange: 0, underlying: '', timeframe: 0, measure: 0, buckets: [] }
}

export const OptionsOiSeries: MessageFns<OptionsOiSeries> = {
  encode(message: OptionsOiSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.measure !== 0) {
      writer.uint32(32).int32(message.measure)
    }
    for (const v of message.buckets) {
      OptionsOiBucket.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.buckets.push(OptionsOiBucket.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiSeries {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
      buckets: globalThis.Array.isArray(object?.buckets)
        ? object.buckets.map((e: any) => OptionsOiBucket.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsOiSeries): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    if (message.buckets?.length) {
      obj.buckets = message.buckets.map((e) => OptionsOiBucket.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiSeries>, I>>(base?: I): OptionsOiSeries {
    return OptionsOiSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiSeries>, I>>(object: I): OptionsOiSeries {
    const message = createBaseOptionsOiSeries()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.measure = object.measure ?? 0
    message.buckets = object.buckets?.map((e) => OptionsOiBucket.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsOiLeaderboardEntry(): OptionsOiLeaderboardEntry {
  return { symbol: '', expiryMs: undefined, oi: '', oiChange24h: '' }
}

export const OptionsOiLeaderboardEntry: MessageFns<OptionsOiLeaderboardEntry> = {
  encode(
    message: OptionsOiLeaderboardEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(16).int64(message.expiryMs)
    }
    if (message.oi !== '') {
      writer.uint32(26).string(message.oi)
    }
    if (message.oiChange24h !== '') {
      writer.uint32(34).string(message.oiChange24h)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiLeaderboardEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiLeaderboardEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.oi = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.oiChange24h = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiLeaderboardEntry {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
      oi: isSet(object.oi) ? globalThis.String(object.oi) : '',
      oiChange24h: isSet(object.oiChange24h)
        ? globalThis.String(object.oiChange24h)
        : isSet(object.oi_change_24h)
          ? globalThis.String(object.oi_change_24h)
          : '',
    }
  },

  toJSON(message: OptionsOiLeaderboardEntry): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    if (message.oi !== '') {
      obj.oi = message.oi
    }
    if (message.oiChange24h !== '') {
      obj.oiChange24h = message.oiChange24h
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiLeaderboardEntry>, I>>(
    base?: I
  ): OptionsOiLeaderboardEntry {
    return OptionsOiLeaderboardEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiLeaderboardEntry>, I>>(
    object: I
  ): OptionsOiLeaderboardEntry {
    const message = createBaseOptionsOiLeaderboardEntry()
    message.symbol = object.symbol ?? ''
    message.expiryMs = object.expiryMs ?? undefined
    message.oi = object.oi ?? ''
    message.oiChange24h = object.oiChange24h ?? ''
    return message
  },
}

function createBaseOptionsOiLeaderboard(): OptionsOiLeaderboard {
  return { exchange: 0, underlying: '', measure: 0, mode: 0, entries: [] }
}

export const OptionsOiLeaderboard: MessageFns<OptionsOiLeaderboard> = {
  encode(message: OptionsOiLeaderboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.measure !== 0) {
      writer.uint32(24).int32(message.measure)
    }
    if (message.mode !== 0) {
      writer.uint32(32).int32(message.mode)
    }
    for (const v of message.entries) {
      OptionsOiLeaderboardEntry.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiLeaderboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiLeaderboard()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.entries.push(OptionsOiLeaderboardEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiLeaderboard {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
      mode: isSet(object.mode) ? optionsOiRankModeFromJSON(object.mode) : 0,
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => OptionsOiLeaderboardEntry.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsOiLeaderboard): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    if (message.mode !== 0) {
      obj.mode = optionsOiRankModeToJSON(message.mode)
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => OptionsOiLeaderboardEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiLeaderboard>, I>>(base?: I): OptionsOiLeaderboard {
    return OptionsOiLeaderboard.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiLeaderboard>, I>>(
    object: I
  ): OptionsOiLeaderboard {
    const message = createBaseOptionsOiLeaderboard()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.measure = object.measure ?? 0
    message.mode = object.mode ?? 0
    message.entries = object.entries?.map((e) => OptionsOiLeaderboardEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsOiStrikePoint(): OptionsOiStrikePoint {
  return { strike: '', callOi: '', putOi: '', callOiChange24h: '', putOiChange24h: '' }
}

export const OptionsOiStrikePoint: MessageFns<OptionsOiStrikePoint> = {
  encode(message: OptionsOiStrikePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strike !== '') {
      writer.uint32(10).string(message.strike)
    }
    if (message.callOi !== '') {
      writer.uint32(18).string(message.callOi)
    }
    if (message.putOi !== '') {
      writer.uint32(26).string(message.putOi)
    }
    if (message.callOiChange24h !== '') {
      writer.uint32(34).string(message.callOiChange24h)
    }
    if (message.putOiChange24h !== '') {
      writer.uint32(42).string(message.putOiChange24h)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiStrikePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiStrikePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.callOi = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.putOi = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.callOiChange24h = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.putOiChange24h = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiStrikePoint {
    return {
      strike: isSet(object.strike) ? globalThis.String(object.strike) : '',
      callOi: isSet(object.callOi)
        ? globalThis.String(object.callOi)
        : isSet(object.call_oi)
          ? globalThis.String(object.call_oi)
          : '',
      putOi: isSet(object.putOi)
        ? globalThis.String(object.putOi)
        : isSet(object.put_oi)
          ? globalThis.String(object.put_oi)
          : '',
      callOiChange24h: isSet(object.callOiChange24h)
        ? globalThis.String(object.callOiChange24h)
        : isSet(object.call_oi_change_24h)
          ? globalThis.String(object.call_oi_change_24h)
          : '',
      putOiChange24h: isSet(object.putOiChange24h)
        ? globalThis.String(object.putOiChange24h)
        : isSet(object.put_oi_change_24h)
          ? globalThis.String(object.put_oi_change_24h)
          : '',
    }
  },

  toJSON(message: OptionsOiStrikePoint): unknown {
    const obj: any = {}
    if (message.strike !== '') {
      obj.strike = message.strike
    }
    if (message.callOi !== '') {
      obj.callOi = message.callOi
    }
    if (message.putOi !== '') {
      obj.putOi = message.putOi
    }
    if (message.callOiChange24h !== '') {
      obj.callOiChange24h = message.callOiChange24h
    }
    if (message.putOiChange24h !== '') {
      obj.putOiChange24h = message.putOiChange24h
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiStrikePoint>, I>>(base?: I): OptionsOiStrikePoint {
    return OptionsOiStrikePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiStrikePoint>, I>>(
    object: I
  ): OptionsOiStrikePoint {
    const message = createBaseOptionsOiStrikePoint()
    message.strike = object.strike ?? ''
    message.callOi = object.callOi ?? ''
    message.putOi = object.putOi ?? ''
    message.callOiChange24h = object.callOiChange24h ?? ''
    message.putOiChange24h = object.putOiChange24h ?? ''
    return message
  },
}

function createBaseOptionsOiByStrike(): OptionsOiByStrike {
  return { exchange: 0, underlying: '', measure: 0, points: [] }
}

export const OptionsOiByStrike: MessageFns<OptionsOiByStrike> = {
  encode(message: OptionsOiByStrike, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.measure !== 0) {
      writer.uint32(24).int32(message.measure)
    }
    for (const v of message.points) {
      OptionsOiStrikePoint.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiByStrike {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiByStrike()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.points.push(OptionsOiStrikePoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiByStrike {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => OptionsOiStrikePoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsOiByStrike): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => OptionsOiStrikePoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiByStrike>, I>>(base?: I): OptionsOiByStrike {
    return OptionsOiByStrike.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiByStrike>, I>>(object: I): OptionsOiByStrike {
    const message = createBaseOptionsOiByStrike()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.measure = object.measure ?? 0
    message.points = object.points?.map((e) => OptionsOiStrikePoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetImpliedMoveRequest(): GetImpliedMoveRequest {
  return { exchange: 0, underlying: '' }
}

export const GetImpliedMoveRequest: MessageFns<GetImpliedMoveRequest> = {
  encode(message: GetImpliedMoveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetImpliedMoveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetImpliedMoveRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetImpliedMoveRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: GetImpliedMoveRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetImpliedMoveRequest>, I>>(base?: I): GetImpliedMoveRequest {
    return GetImpliedMoveRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetImpliedMoveRequest>, I>>(
    object: I
  ): GetImpliedMoveRequest {
    const message = createBaseGetImpliedMoveRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseImpliedMovePoint(): ImpliedMovePoint {
  return { expiryMs: '0', daysToExpiration: 0, oneSigma: '', oneSigmaUsd: undefined }
}

export const ImpliedMovePoint: MessageFns<ImpliedMovePoint> = {
  encode(message: ImpliedMovePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiryMs !== '0') {
      writer.uint32(8).int64(message.expiryMs)
    }
    if (message.daysToExpiration !== 0) {
      writer.uint32(17).double(message.daysToExpiration)
    }
    if (message.oneSigma !== '') {
      writer.uint32(26).string(message.oneSigma)
    }
    if (message.oneSigmaUsd !== undefined) {
      writer.uint32(34).string(message.oneSigmaUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpliedMovePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseImpliedMovePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.daysToExpiration = reader.double()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.oneSigma = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.oneSigmaUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ImpliedMovePoint {
    return {
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.Number(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.Number(object.days_to_expiration)
          : 0,
      oneSigma: isSet(object.oneSigma)
        ? globalThis.String(object.oneSigma)
        : isSet(object.one_sigma)
          ? globalThis.String(object.one_sigma)
          : '',
      oneSigmaUsd: isSet(object.oneSigmaUsd)
        ? globalThis.String(object.oneSigmaUsd)
        : isSet(object.one_sigma_usd)
          ? globalThis.String(object.one_sigma_usd)
          : undefined,
    }
  },

  toJSON(message: ImpliedMovePoint): unknown {
    const obj: any = {}
    if (message.expiryMs !== '0') {
      obj.expiryMs = message.expiryMs
    }
    if (message.daysToExpiration !== 0) {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.oneSigma !== '') {
      obj.oneSigma = message.oneSigma
    }
    if (message.oneSigmaUsd !== undefined) {
      obj.oneSigmaUsd = message.oneSigmaUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ImpliedMovePoint>, I>>(base?: I): ImpliedMovePoint {
    return ImpliedMovePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ImpliedMovePoint>, I>>(object: I): ImpliedMovePoint {
    const message = createBaseImpliedMovePoint()
    message.expiryMs = object.expiryMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? 0
    message.oneSigma = object.oneSigma ?? ''
    message.oneSigmaUsd = object.oneSigmaUsd ?? undefined
    return message
  },
}

function createBaseImpliedMove(): ImpliedMove {
  return { exchange: 0, underlying: '', points: [] }
}

export const ImpliedMove: MessageFns<ImpliedMove> = {
  encode(message: ImpliedMove, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    for (const v of message.points) {
      ImpliedMovePoint.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpliedMove {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseImpliedMove()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.points.push(ImpliedMovePoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ImpliedMove {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => ImpliedMovePoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ImpliedMove): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => ImpliedMovePoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ImpliedMove>, I>>(base?: I): ImpliedMove {
    return ImpliedMove.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ImpliedMove>, I>>(object: I): ImpliedMove {
    const message = createBaseImpliedMove()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.points = object.points?.map((e) => ImpliedMovePoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetIvPercentileRequest(): GetIvPercentileRequest {
  return { exchange: 0, underlying: '' }
}

export const GetIvPercentileRequest: MessageFns<GetIvPercentileRequest> = {
  encode(message: GetIvPercentileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIvPercentileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetIvPercentileRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetIvPercentileRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: GetIvPercentileRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetIvPercentileRequest>, I>>(
    base?: I
  ): GetIvPercentileRequest {
    return GetIvPercentileRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetIvPercentileRequest>, I>>(
    object: I
  ): GetIvPercentileRequest {
    const message = createBaseGetIvPercentileRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseIvPercentilePoint(): IvPercentilePoint {
  return {
    daysToExpiration: 0,
    current: '',
    percentileRank: '',
    p5: '',
    p25: '',
    p50: '',
    p75: '',
    p95: '',
    sampleCount: '0',
  }
}

export const IvPercentilePoint: MessageFns<IvPercentilePoint> = {
  encode(message: IvPercentilePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.daysToExpiration !== 0) {
      writer.uint32(9).double(message.daysToExpiration)
    }
    if (message.current !== '') {
      writer.uint32(18).string(message.current)
    }
    if (message.percentileRank !== '') {
      writer.uint32(26).string(message.percentileRank)
    }
    if (message.p5 !== '') {
      writer.uint32(34).string(message.p5)
    }
    if (message.p25 !== '') {
      writer.uint32(42).string(message.p25)
    }
    if (message.p50 !== '') {
      writer.uint32(50).string(message.p50)
    }
    if (message.p75 !== '') {
      writer.uint32(58).string(message.p75)
    }
    if (message.p95 !== '') {
      writer.uint32(66).string(message.p95)
    }
    if (message.sampleCount !== '0') {
      writer.uint32(72).int64(message.sampleCount)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IvPercentilePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIvPercentilePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.daysToExpiration = reader.double()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.current = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.percentileRank = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.p5 = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.p25 = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.p50 = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.p75 = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.p95 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.sampleCount = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IvPercentilePoint {
    return {
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.Number(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.Number(object.days_to_expiration)
          : 0,
      current: isSet(object.current) ? globalThis.String(object.current) : '',
      percentileRank: isSet(object.percentileRank)
        ? globalThis.String(object.percentileRank)
        : isSet(object.percentile_rank)
          ? globalThis.String(object.percentile_rank)
          : '',
      p5: isSet(object.p5) ? globalThis.String(object.p5) : '',
      p25: isSet(object.p25) ? globalThis.String(object.p25) : '',
      p50: isSet(object.p50) ? globalThis.String(object.p50) : '',
      p75: isSet(object.p75) ? globalThis.String(object.p75) : '',
      p95: isSet(object.p95) ? globalThis.String(object.p95) : '',
      sampleCount: isSet(object.sampleCount)
        ? globalThis.String(object.sampleCount)
        : isSet(object.sample_count)
          ? globalThis.String(object.sample_count)
          : '0',
    }
  },

  toJSON(message: IvPercentilePoint): unknown {
    const obj: any = {}
    if (message.daysToExpiration !== 0) {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.current !== '') {
      obj.current = message.current
    }
    if (message.percentileRank !== '') {
      obj.percentileRank = message.percentileRank
    }
    if (message.p5 !== '') {
      obj.p5 = message.p5
    }
    if (message.p25 !== '') {
      obj.p25 = message.p25
    }
    if (message.p50 !== '') {
      obj.p50 = message.p50
    }
    if (message.p75 !== '') {
      obj.p75 = message.p75
    }
    if (message.p95 !== '') {
      obj.p95 = message.p95
    }
    if (message.sampleCount !== '0') {
      obj.sampleCount = message.sampleCount
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IvPercentilePoint>, I>>(base?: I): IvPercentilePoint {
    return IvPercentilePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IvPercentilePoint>, I>>(object: I): IvPercentilePoint {
    const message = createBaseIvPercentilePoint()
    message.daysToExpiration = object.daysToExpiration ?? 0
    message.current = object.current ?? ''
    message.percentileRank = object.percentileRank ?? ''
    message.p5 = object.p5 ?? ''
    message.p25 = object.p25 ?? ''
    message.p50 = object.p50 ?? ''
    message.p75 = object.p75 ?? ''
    message.p95 = object.p95 ?? ''
    message.sampleCount = object.sampleCount ?? '0'
    return message
  },
}

function createBaseIvPercentile(): IvPercentile {
  return { exchange: 0, underlying: '', points: [] }
}

export const IvPercentile: MessageFns<IvPercentile> = {
  encode(message: IvPercentile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    for (const v of message.points) {
      IvPercentilePoint.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IvPercentile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIvPercentile()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.points.push(IvPercentilePoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IvPercentile {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => IvPercentilePoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: IvPercentile): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => IvPercentilePoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IvPercentile>, I>>(base?: I): IvPercentile {
    return IvPercentile.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IvPercentile>, I>>(object: I): IvPercentile {
    const message = createBaseIvPercentile()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.points = object.points?.map((e) => IvPercentilePoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetMaxPainRequest(): GetMaxPainRequest {
  return { exchange: 0, underlying: '' }
}

export const GetMaxPainRequest: MessageFns<GetMaxPainRequest> = {
  encode(message: GetMaxPainRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMaxPainRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetMaxPainRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetMaxPainRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: GetMaxPainRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetMaxPainRequest>, I>>(base?: I): GetMaxPainRequest {
    return GetMaxPainRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetMaxPainRequest>, I>>(object: I): GetMaxPainRequest {
    const message = createBaseGetMaxPainRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseMaxPainPoint(): MaxPainPoint {
  return { expiryMs: '0', maxPainStrike: '', totalOi: '' }
}

export const MaxPainPoint: MessageFns<MaxPainPoint> = {
  encode(message: MaxPainPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiryMs !== '0') {
      writer.uint32(8).int64(message.expiryMs)
    }
    if (message.maxPainStrike !== '') {
      writer.uint32(18).string(message.maxPainStrike)
    }
    if (message.totalOi !== '') {
      writer.uint32(26).string(message.totalOi)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MaxPainPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMaxPainPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.maxPainStrike = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.totalOi = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MaxPainPoint {
    return {
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : '0',
      maxPainStrike: isSet(object.maxPainStrike)
        ? globalThis.String(object.maxPainStrike)
        : isSet(object.max_pain_strike)
          ? globalThis.String(object.max_pain_strike)
          : '',
      totalOi: isSet(object.totalOi)
        ? globalThis.String(object.totalOi)
        : isSet(object.total_oi)
          ? globalThis.String(object.total_oi)
          : '',
    }
  },

  toJSON(message: MaxPainPoint): unknown {
    const obj: any = {}
    if (message.expiryMs !== '0') {
      obj.expiryMs = message.expiryMs
    }
    if (message.maxPainStrike !== '') {
      obj.maxPainStrike = message.maxPainStrike
    }
    if (message.totalOi !== '') {
      obj.totalOi = message.totalOi
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MaxPainPoint>, I>>(base?: I): MaxPainPoint {
    return MaxPainPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MaxPainPoint>, I>>(object: I): MaxPainPoint {
    const message = createBaseMaxPainPoint()
    message.expiryMs = object.expiryMs ?? '0'
    message.maxPainStrike = object.maxPainStrike ?? ''
    message.totalOi = object.totalOi ?? ''
    return message
  },
}

function createBaseMaxPain(): MaxPain {
  return { exchange: 0, underlying: '', underlyingPrice: undefined, points: [] }
}

export const MaxPain: MessageFns<MaxPain> = {
  encode(message: MaxPain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(26).string(message.underlyingPrice)
    }
    for (const v of message.points) {
      MaxPainPoint.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MaxPain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMaxPain()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.points.push(MaxPainPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MaxPain {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => MaxPainPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: MaxPain): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => MaxPainPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MaxPain>, I>>(base?: I): MaxPain {
    return MaxPain.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MaxPain>, I>>(object: I): MaxPain {
    const message = createBaseMaxPain()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.points = object.points?.map((e) => MaxPainPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseFundingPoint(): FundingPoint {
  return { timestampMs: '0', fundingRate: '', fundingApr: undefined }
}

export const FundingPoint: MessageFns<FundingPoint> = {
  encode(message: FundingPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.fundingRate !== '') {
      writer.uint32(18).string(message.fundingRate)
    }
    if (message.fundingApr !== undefined) {
      writer.uint32(26).string(message.fundingApr)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FundingPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFundingPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.fundingRate = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.fundingApr = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FundingPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      fundingRate: isSet(object.fundingRate)
        ? globalThis.String(object.fundingRate)
        : isSet(object.funding_rate)
          ? globalThis.String(object.funding_rate)
          : '',
      fundingApr: isSet(object.fundingApr)
        ? globalThis.String(object.fundingApr)
        : isSet(object.funding_apr)
          ? globalThis.String(object.funding_apr)
          : undefined,
    }
  },

  toJSON(message: FundingPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.fundingRate !== '') {
      obj.fundingRate = message.fundingRate
    }
    if (message.fundingApr !== undefined) {
      obj.fundingApr = message.fundingApr
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FundingPoint>, I>>(base?: I): FundingPoint {
    return FundingPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FundingPoint>, I>>(object: I): FundingPoint {
    const message = createBaseFundingPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.fundingRate = object.fundingRate ?? ''
    message.fundingApr = object.fundingApr ?? undefined
    return message
  },
}

function createBaseFundingSeries(): FundingSeries {
  return { exchange: 0, symbol: '', points: [] }
}

export const FundingSeries: MessageFns<FundingSeries> = {
  encode(message: FundingSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    for (const v of message.points) {
      FundingPoint.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FundingSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFundingSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.points.push(FundingPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FundingSeries {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => FundingPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: FundingSeries): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => FundingPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FundingSeries>, I>>(base?: I): FundingSeries {
    return FundingSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FundingSeries>, I>>(object: I): FundingSeries {
    const message = createBaseFundingSeries()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.points = object.points?.map((e) => FundingPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseFundingLeaderboardEntry(): FundingLeaderboardEntry {
  return { symbol: '', fundingRate: '', fundingApr: undefined, openInterest: undefined }
}

export const FundingLeaderboardEntry: MessageFns<FundingLeaderboardEntry> = {
  encode(
    message: FundingLeaderboardEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.fundingRate !== '') {
      writer.uint32(18).string(message.fundingRate)
    }
    if (message.fundingApr !== undefined) {
      writer.uint32(26).string(message.fundingApr)
    }
    if (message.openInterest !== undefined) {
      writer.uint32(34).string(message.openInterest)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FundingLeaderboardEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFundingLeaderboardEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.fundingRate = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.fundingApr = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.openInterest = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FundingLeaderboardEntry {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      fundingRate: isSet(object.fundingRate)
        ? globalThis.String(object.fundingRate)
        : isSet(object.funding_rate)
          ? globalThis.String(object.funding_rate)
          : '',
      fundingApr: isSet(object.fundingApr)
        ? globalThis.String(object.fundingApr)
        : isSet(object.funding_apr)
          ? globalThis.String(object.funding_apr)
          : undefined,
      openInterest: isSet(object.openInterest)
        ? globalThis.String(object.openInterest)
        : isSet(object.open_interest)
          ? globalThis.String(object.open_interest)
          : undefined,
    }
  },

  toJSON(message: FundingLeaderboardEntry): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.fundingRate !== '') {
      obj.fundingRate = message.fundingRate
    }
    if (message.fundingApr !== undefined) {
      obj.fundingApr = message.fundingApr
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = message.openInterest
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FundingLeaderboardEntry>, I>>(
    base?: I
  ): FundingLeaderboardEntry {
    return FundingLeaderboardEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FundingLeaderboardEntry>, I>>(
    object: I
  ): FundingLeaderboardEntry {
    const message = createBaseFundingLeaderboardEntry()
    message.symbol = object.symbol ?? ''
    message.fundingRate = object.fundingRate ?? ''
    message.fundingApr = object.fundingApr ?? undefined
    message.openInterest = object.openInterest ?? undefined
    return message
  },
}

function createBaseFundingLeaderboard(): FundingLeaderboard {
  return { exchange: 0, mode: 0, entries: [] }
}

export const FundingLeaderboard: MessageFns<FundingLeaderboard> = {
  encode(message: FundingLeaderboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode)
    }
    for (const v of message.entries) {
      FundingLeaderboardEntry.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FundingLeaderboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFundingLeaderboard()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.entries.push(FundingLeaderboardEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FundingLeaderboard {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      mode: isSet(object.mode) ? fundingRankModeFromJSON(object.mode) : 0,
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => FundingLeaderboardEntry.fromJSON(e))
        : [],
    }
  },

  toJSON(message: FundingLeaderboard): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.mode !== 0) {
      obj.mode = fundingRankModeToJSON(message.mode)
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => FundingLeaderboardEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FundingLeaderboard>, I>>(base?: I): FundingLeaderboard {
    return FundingLeaderboard.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FundingLeaderboard>, I>>(object: I): FundingLeaderboard {
    const message = createBaseFundingLeaderboard()
    message.exchange = object.exchange ?? 0
    message.mode = object.mode ?? 0
    message.entries = object.entries?.map((e) => FundingLeaderboardEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseGetFundingSeriesRequest(): GetFundingSeriesRequest {
  return { exchange: 0, symbol: '', fromMs: undefined, toMs: undefined, limit: undefined }
}

export const GetFundingSeriesRequest: MessageFns<GetFundingSeriesRequest> = {
  encode(
    message: GetFundingSeriesRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.fromMs !== undefined) {
      writer.uint32(24).int64(message.fromMs)
    }
    if (message.toMs !== undefined) {
      writer.uint32(32).int64(message.toMs)
    }
    if (message.limit !== undefined) {
      writer.uint32(40).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFundingSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetFundingSeriesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.fromMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.toMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetFundingSeriesRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      fromMs: isSet(object.fromMs)
        ? globalThis.String(object.fromMs)
        : isSet(object.from_ms)
          ? globalThis.String(object.from_ms)
          : undefined,
      toMs: isSet(object.toMs)
        ? globalThis.String(object.toMs)
        : isSet(object.to_ms)
          ? globalThis.String(object.to_ms)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: GetFundingSeriesRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.fromMs !== undefined) {
      obj.fromMs = message.fromMs
    }
    if (message.toMs !== undefined) {
      obj.toMs = message.toMs
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetFundingSeriesRequest>, I>>(
    base?: I
  ): GetFundingSeriesRequest {
    return GetFundingSeriesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetFundingSeriesRequest>, I>>(
    object: I
  ): GetFundingSeriesRequest {
    const message = createBaseGetFundingSeriesRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.fromMs = object.fromMs ?? undefined
    message.toMs = object.toMs ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseGetFundingLeaderboardRequest(): GetFundingLeaderboardRequest {
  return { exchange: 0, mode: 0, limit: undefined }
}

export const GetFundingLeaderboardRequest: MessageFns<GetFundingLeaderboardRequest> = {
  encode(
    message: GetFundingLeaderboardRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode)
    }
    if (message.limit !== undefined) {
      writer.uint32(24).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFundingLeaderboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetFundingLeaderboardRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetFundingLeaderboardRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      mode: isSet(object.mode) ? fundingRankModeFromJSON(object.mode) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: GetFundingLeaderboardRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.mode !== 0) {
      obj.mode = fundingRankModeToJSON(message.mode)
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetFundingLeaderboardRequest>, I>>(
    base?: I
  ): GetFundingLeaderboardRequest {
    return GetFundingLeaderboardRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetFundingLeaderboardRequest>, I>>(
    object: I
  ): GetFundingLeaderboardRequest {
    const message = createBaseGetFundingLeaderboardRequest()
    message.exchange = object.exchange ?? 0
    message.mode = object.mode ?? 0
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseOrderbookMetricsSeriesRequest(): OrderbookMetricsSeriesRequest {
  return {
    exchange: 0,
    symbol: '',
    timeframe: 0,
    fromMs: undefined,
    toMs: undefined,
    limit: undefined,
    depthTiersBps: [],
  }
}

export const OrderbookMetricsSeriesRequest: MessageFns<OrderbookMetricsSeriesRequest> = {
  encode(
    message: OrderbookMetricsSeriesRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.fromMs !== undefined) {
      writer.uint32(32).int64(message.fromMs)
    }
    if (message.toMs !== undefined) {
      writer.uint32(40).int64(message.toMs)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    writer.uint32(58).fork()
    for (const v of message.depthTiersBps) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookMetricsSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookMetricsSeriesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.fromMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.toMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 7: {
          if (tag === 56) {
            message.depthTiersBps.push(reader.int32())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.depthTiersBps.push(reader.int32())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookMetricsSeriesRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      fromMs: isSet(object.fromMs)
        ? globalThis.String(object.fromMs)
        : isSet(object.from_ms)
          ? globalThis.String(object.from_ms)
          : undefined,
      toMs: isSet(object.toMs)
        ? globalThis.String(object.toMs)
        : isSet(object.to_ms)
          ? globalThis.String(object.to_ms)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      depthTiersBps: globalThis.Array.isArray(object?.depthTiersBps)
        ? object.depthTiersBps.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.depth_tiers_bps)
          ? object.depth_tiers_bps.map((e: any) => globalThis.Number(e))
          : [],
    }
  },

  toJSON(message: OrderbookMetricsSeriesRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.fromMs !== undefined) {
      obj.fromMs = message.fromMs
    }
    if (message.toMs !== undefined) {
      obj.toMs = message.toMs
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.depthTiersBps?.length) {
      obj.depthTiersBps = message.depthTiersBps.map((e) => Math.round(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookMetricsSeriesRequest>, I>>(
    base?: I
  ): OrderbookMetricsSeriesRequest {
    return OrderbookMetricsSeriesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookMetricsSeriesRequest>, I>>(
    object: I
  ): OrderbookMetricsSeriesRequest {
    const message = createBaseOrderbookMetricsSeriesRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timeframe = object.timeframe ?? 0
    message.fromMs = object.fromMs ?? undefined
    message.toMs = object.toMs ?? undefined
    message.limit = object.limit ?? undefined
    message.depthTiersBps = object.depthTiersBps?.map((e) => e) || []
    return message
  },
}

function createBaseOrderbookDepthTierSeries(): OrderbookDepthTierSeries {
  return { bps: 0, bidVal: [], askVal: [], bidCnt: [], askCnt: [] }
}

export const OrderbookDepthTierSeries: MessageFns<OrderbookDepthTierSeries> = {
  encode(
    message: OrderbookDepthTierSeries,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.bps !== 0) {
      writer.uint32(8).int32(message.bps)
    }
    writer.uint32(18).fork()
    for (const v of message.bidVal) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(26).fork()
    for (const v of message.askVal) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(34).fork()
    for (const v of message.bidCnt) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.askCnt) {
      writer.double(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookDepthTierSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookDepthTierSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.bps = reader.int32()
          continue
        }
        case 2: {
          if (tag === 17) {
            message.bidVal.push(reader.double())

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.bidVal.push(reader.double())
            }

            continue
          }

          break
        }
        case 3: {
          if (tag === 25) {
            message.askVal.push(reader.double())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.askVal.push(reader.double())
            }

            continue
          }

          break
        }
        case 4: {
          if (tag === 33) {
            message.bidCnt.push(reader.double())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.bidCnt.push(reader.double())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 41) {
            message.askCnt.push(reader.double())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.askCnt.push(reader.double())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookDepthTierSeries {
    return {
      bps: isSet(object.bps) ? globalThis.Number(object.bps) : 0,
      bidVal: globalThis.Array.isArray(object?.bidVal)
        ? object.bidVal.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.bid_val)
          ? object.bid_val.map((e: any) => globalThis.Number(e))
          : [],
      askVal: globalThis.Array.isArray(object?.askVal)
        ? object.askVal.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.ask_val)
          ? object.ask_val.map((e: any) => globalThis.Number(e))
          : [],
      bidCnt: globalThis.Array.isArray(object?.bidCnt)
        ? object.bidCnt.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.bid_cnt)
          ? object.bid_cnt.map((e: any) => globalThis.Number(e))
          : [],
      askCnt: globalThis.Array.isArray(object?.askCnt)
        ? object.askCnt.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.ask_cnt)
          ? object.ask_cnt.map((e: any) => globalThis.Number(e))
          : [],
    }
  },

  toJSON(message: OrderbookDepthTierSeries): unknown {
    const obj: any = {}
    if (message.bps !== 0) {
      obj.bps = Math.round(message.bps)
    }
    if (message.bidVal?.length) {
      obj.bidVal = message.bidVal
    }
    if (message.askVal?.length) {
      obj.askVal = message.askVal
    }
    if (message.bidCnt?.length) {
      obj.bidCnt = message.bidCnt
    }
    if (message.askCnt?.length) {
      obj.askCnt = message.askCnt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookDepthTierSeries>, I>>(
    base?: I
  ): OrderbookDepthTierSeries {
    return OrderbookDepthTierSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookDepthTierSeries>, I>>(
    object: I
  ): OrderbookDepthTierSeries {
    const message = createBaseOrderbookDepthTierSeries()
    message.bps = object.bps ?? 0
    message.bidVal = object.bidVal?.map((e) => e) || []
    message.askVal = object.askVal?.map((e) => e) || []
    message.bidCnt = object.bidCnt?.map((e) => e) || []
    message.askCnt = object.askCnt?.map((e) => e) || []
    return message
  },
}

function createBaseOrderbookMetricsSeries(): OrderbookMetricsSeries {
  return {
    exchange: 0,
    symbol: '',
    timeframe: 0,
    ticksMs: [],
    spreadBps: [],
    spreadBpsMax: [],
    pressureRatio: [],
    bidLiquidityTotal: [],
    askLiquidityTotal: [],
    midPrice: [],
    depthTiers: [],
  }
}

export const OrderbookMetricsSeries: MessageFns<OrderbookMetricsSeries> = {
  encode(message: OrderbookMetricsSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    writer.uint32(34).fork()
    for (const v of message.ticksMs) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.spreadBps) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(50).fork()
    for (const v of message.spreadBpsMax) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(58).fork()
    for (const v of message.pressureRatio) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.bidLiquidityTotal) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.askLiquidityTotal) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.midPrice) {
      writer.double(v)
    }
    writer.join()
    for (const v of message.depthTiers) {
      OrderbookDepthTierSeries.encode(v!, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookMetricsSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookMetricsSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag === 32) {
            message.ticksMs.push(reader.int64().toString())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.ticksMs.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 41) {
            message.spreadBps.push(reader.double())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.spreadBps.push(reader.double())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag === 49) {
            message.spreadBpsMax.push(reader.double())

            continue
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.spreadBpsMax.push(reader.double())
            }

            continue
          }

          break
        }
        case 7: {
          if (tag === 57) {
            message.pressureRatio.push(reader.double())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.pressureRatio.push(reader.double())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 65) {
            message.bidLiquidityTotal.push(reader.double())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.bidLiquidityTotal.push(reader.double())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 73) {
            message.askLiquidityTotal.push(reader.double())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.askLiquidityTotal.push(reader.double())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 81) {
            message.midPrice.push(reader.double())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.midPrice.push(reader.double())
            }

            continue
          }

          break
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.depthTiers.push(OrderbookDepthTierSeries.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookMetricsSeries {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      ticksMs: globalThis.Array.isArray(object?.ticksMs)
        ? object.ticksMs.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ticks_ms)
          ? object.ticks_ms.map((e: any) => globalThis.String(e))
          : [],
      spreadBps: globalThis.Array.isArray(object?.spreadBps)
        ? object.spreadBps.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.spread_bps)
          ? object.spread_bps.map((e: any) => globalThis.Number(e))
          : [],
      spreadBpsMax: globalThis.Array.isArray(object?.spreadBpsMax)
        ? object.spreadBpsMax.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.spread_bps_max)
          ? object.spread_bps_max.map((e: any) => globalThis.Number(e))
          : [],
      pressureRatio: globalThis.Array.isArray(object?.pressureRatio)
        ? object.pressureRatio.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.pressure_ratio)
          ? object.pressure_ratio.map((e: any) => globalThis.Number(e))
          : [],
      bidLiquidityTotal: globalThis.Array.isArray(object?.bidLiquidityTotal)
        ? object.bidLiquidityTotal.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.bid_liquidity_total)
          ? object.bid_liquidity_total.map((e: any) => globalThis.Number(e))
          : [],
      askLiquidityTotal: globalThis.Array.isArray(object?.askLiquidityTotal)
        ? object.askLiquidityTotal.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.ask_liquidity_total)
          ? object.ask_liquidity_total.map((e: any) => globalThis.Number(e))
          : [],
      midPrice: globalThis.Array.isArray(object?.midPrice)
        ? object.midPrice.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.mid_price)
          ? object.mid_price.map((e: any) => globalThis.Number(e))
          : [],
      depthTiers: globalThis.Array.isArray(object?.depthTiers)
        ? object.depthTiers.map((e: any) => OrderbookDepthTierSeries.fromJSON(e))
        : globalThis.Array.isArray(object?.depth_tiers)
          ? object.depth_tiers.map((e: any) => OrderbookDepthTierSeries.fromJSON(e))
          : [],
    }
  },

  toJSON(message: OrderbookMetricsSeries): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.ticksMs?.length) {
      obj.ticksMs = message.ticksMs
    }
    if (message.spreadBps?.length) {
      obj.spreadBps = message.spreadBps
    }
    if (message.spreadBpsMax?.length) {
      obj.spreadBpsMax = message.spreadBpsMax
    }
    if (message.pressureRatio?.length) {
      obj.pressureRatio = message.pressureRatio
    }
    if (message.bidLiquidityTotal?.length) {
      obj.bidLiquidityTotal = message.bidLiquidityTotal
    }
    if (message.askLiquidityTotal?.length) {
      obj.askLiquidityTotal = message.askLiquidityTotal
    }
    if (message.midPrice?.length) {
      obj.midPrice = message.midPrice
    }
    if (message.depthTiers?.length) {
      obj.depthTiers = message.depthTiers.map((e) => OrderbookDepthTierSeries.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookMetricsSeries>, I>>(
    base?: I
  ): OrderbookMetricsSeries {
    return OrderbookMetricsSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookMetricsSeries>, I>>(
    object: I
  ): OrderbookMetricsSeries {
    const message = createBaseOrderbookMetricsSeries()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timeframe = object.timeframe ?? 0
    message.ticksMs = object.ticksMs?.map((e) => e) || []
    message.spreadBps = object.spreadBps?.map((e) => e) || []
    message.spreadBpsMax = object.spreadBpsMax?.map((e) => e) || []
    message.pressureRatio = object.pressureRatio?.map((e) => e) || []
    message.bidLiquidityTotal = object.bidLiquidityTotal?.map((e) => e) || []
    message.askLiquidityTotal = object.askLiquidityTotal?.map((e) => e) || []
    message.midPrice = object.midPrice?.map((e) => e) || []
    message.depthTiers =
      object.depthTiers?.map((e) => OrderbookDepthTierSeries.fromPartial(e)) || []
    return message
  },
}

function createBaseOrderbookHeatmapRequest(): OrderbookHeatmapRequest {
  return {
    exchange: 0,
    symbol: '',
    timeframe: 0,
    fromMs: undefined,
    toMs: undefined,
    limit: undefined,
  }
}

export const OrderbookHeatmapRequest: MessageFns<OrderbookHeatmapRequest> = {
  encode(
    message: OrderbookHeatmapRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.fromMs !== undefined) {
      writer.uint32(32).int64(message.fromMs)
    }
    if (message.toMs !== undefined) {
      writer.uint32(40).int64(message.toMs)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookHeatmapRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookHeatmapRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.fromMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.toMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookHeatmapRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      fromMs: isSet(object.fromMs)
        ? globalThis.String(object.fromMs)
        : isSet(object.from_ms)
          ? globalThis.String(object.from_ms)
          : undefined,
      toMs: isSet(object.toMs)
        ? globalThis.String(object.toMs)
        : isSet(object.to_ms)
          ? globalThis.String(object.to_ms)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: OrderbookHeatmapRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.fromMs !== undefined) {
      obj.fromMs = message.fromMs
    }
    if (message.toMs !== undefined) {
      obj.toMs = message.toMs
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookHeatmapRequest>, I>>(
    base?: I
  ): OrderbookHeatmapRequest {
    return OrderbookHeatmapRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookHeatmapRequest>, I>>(
    object: I
  ): OrderbookHeatmapRequest {
    const message = createBaseOrderbookHeatmapRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timeframe = object.timeframe ?? 0
    message.fromMs = object.fromMs ?? undefined
    message.toMs = object.toMs ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseOrderbookHeatmapColumn(): OrderbookHeatmapColumn {
  return { tsMs: '0', midPrice: 0, bucketWidth: 0, bidStart: 0, askStart: 0, bids: [], asks: [] }
}

export const OrderbookHeatmapColumn: MessageFns<OrderbookHeatmapColumn> = {
  encode(message: OrderbookHeatmapColumn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tsMs !== '0') {
      writer.uint32(8).int64(message.tsMs)
    }
    if (message.midPrice !== 0) {
      writer.uint32(17).double(message.midPrice)
    }
    if (message.bucketWidth !== 0) {
      writer.uint32(25).double(message.bucketWidth)
    }
    if (message.bidStart !== 0) {
      writer.uint32(33).double(message.bidStart)
    }
    if (message.askStart !== 0) {
      writer.uint32(41).double(message.askStart)
    }
    writer.uint32(50).fork()
    for (const v of message.bids) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(58).fork()
    for (const v of message.asks) {
      writer.double(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookHeatmapColumn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookHeatmapColumn()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.midPrice = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.bucketWidth = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.bidStart = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.askStart = reader.double()
          continue
        }
        case 6: {
          if (tag === 49) {
            message.bids.push(reader.double())

            continue
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.bids.push(reader.double())
            }

            continue
          }

          break
        }
        case 7: {
          if (tag === 57) {
            message.asks.push(reader.double())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.asks.push(reader.double())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookHeatmapColumn {
    return {
      tsMs: isSet(object.tsMs)
        ? globalThis.String(object.tsMs)
        : isSet(object.ts_ms)
          ? globalThis.String(object.ts_ms)
          : '0',
      midPrice: isSet(object.midPrice)
        ? globalThis.Number(object.midPrice)
        : isSet(object.mid_price)
          ? globalThis.Number(object.mid_price)
          : 0,
      bucketWidth: isSet(object.bucketWidth)
        ? globalThis.Number(object.bucketWidth)
        : isSet(object.bucket_width)
          ? globalThis.Number(object.bucket_width)
          : 0,
      bidStart: isSet(object.bidStart)
        ? globalThis.Number(object.bidStart)
        : isSet(object.bid_start)
          ? globalThis.Number(object.bid_start)
          : 0,
      askStart: isSet(object.askStart)
        ? globalThis.Number(object.askStart)
        : isSet(object.ask_start)
          ? globalThis.Number(object.ask_start)
          : 0,
      bids: globalThis.Array.isArray(object?.bids)
        ? object.bids.map((e: any) => globalThis.Number(e))
        : [],
      asks: globalThis.Array.isArray(object?.asks)
        ? object.asks.map((e: any) => globalThis.Number(e))
        : [],
    }
  },

  toJSON(message: OrderbookHeatmapColumn): unknown {
    const obj: any = {}
    if (message.tsMs !== '0') {
      obj.tsMs = message.tsMs
    }
    if (message.midPrice !== 0) {
      obj.midPrice = message.midPrice
    }
    if (message.bucketWidth !== 0) {
      obj.bucketWidth = message.bucketWidth
    }
    if (message.bidStart !== 0) {
      obj.bidStart = message.bidStart
    }
    if (message.askStart !== 0) {
      obj.askStart = message.askStart
    }
    if (message.bids?.length) {
      obj.bids = message.bids
    }
    if (message.asks?.length) {
      obj.asks = message.asks
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookHeatmapColumn>, I>>(
    base?: I
  ): OrderbookHeatmapColumn {
    return OrderbookHeatmapColumn.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookHeatmapColumn>, I>>(
    object: I
  ): OrderbookHeatmapColumn {
    const message = createBaseOrderbookHeatmapColumn()
    message.tsMs = object.tsMs ?? '0'
    message.midPrice = object.midPrice ?? 0
    message.bucketWidth = object.bucketWidth ?? 0
    message.bidStart = object.bidStart ?? 0
    message.askStart = object.askStart ?? 0
    message.bids = object.bids?.map((e) => e) || []
    message.asks = object.asks?.map((e) => e) || []
    return message
  },
}

function createBaseOrderbookHeatmap(): OrderbookHeatmap {
  return { exchange: 0, symbol: '', timeframe: 0, columns: [] }
}

export const OrderbookHeatmap: MessageFns<OrderbookHeatmap> = {
  encode(message: OrderbookHeatmap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    for (const v of message.columns) {
      OrderbookHeatmapColumn.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderbookHeatmap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderbookHeatmap()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.columns.push(OrderbookHeatmapColumn.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderbookHeatmap {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => OrderbookHeatmapColumn.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OrderbookHeatmap): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => OrderbookHeatmapColumn.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderbookHeatmap>, I>>(base?: I): OrderbookHeatmap {
    return OrderbookHeatmap.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderbookHeatmap>, I>>(object: I): OrderbookHeatmap {
    const message = createBaseOrderbookHeatmap()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timeframe = object.timeframe ?? 0
    message.columns = object.columns?.map((e) => OrderbookHeatmapColumn.fromPartial(e)) || []
    return message
  },
}

function createBaseOpenInterestPressure(): OpenInterestPressure {
  return { symbol: '', exchange: 0, longNotional: '', shortNotional: '', timestamp: '0' }
}

export const OpenInterestPressure: MessageFns<OpenInterestPressure> = {
  encode(message: OpenInterestPressure, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.longNotional !== '') {
      writer.uint32(26).string(message.longNotional)
    }
    if (message.shortNotional !== '') {
      writer.uint32(34).string(message.shortNotional)
    }
    if (message.timestamp !== '0') {
      writer.uint32(40).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenInterestPressure {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOpenInterestPressure()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.longNotional = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.shortNotional = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OpenInterestPressure {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      longNotional: isSet(object.longNotional)
        ? globalThis.String(object.longNotional)
        : isSet(object.long_notional)
          ? globalThis.String(object.long_notional)
          : '',
      shortNotional: isSet(object.shortNotional)
        ? globalThis.String(object.shortNotional)
        : isSet(object.short_notional)
          ? globalThis.String(object.short_notional)
          : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
    }
  },

  toJSON(message: OpenInterestPressure): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.longNotional !== '') {
      obj.longNotional = message.longNotional
    }
    if (message.shortNotional !== '') {
      obj.shortNotional = message.shortNotional
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OpenInterestPressure>, I>>(base?: I): OpenInterestPressure {
    return OpenInterestPressure.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestPressure>, I>>(
    object: I
  ): OpenInterestPressure {
    const message = createBaseOpenInterestPressure()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.longNotional = object.longNotional ?? ''
    message.shortNotional = object.shortNotional ?? ''
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBaseOpenInterestPressureList(): OpenInterestPressureList {
  return { items: [] }
}

export const OpenInterestPressureList: MessageFns<OpenInterestPressureList> = {
  encode(
    message: OpenInterestPressureList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      OpenInterestPressure.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenInterestPressureList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOpenInterestPressureList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(OpenInterestPressure.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OpenInterestPressureList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => OpenInterestPressure.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OpenInterestPressureList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => OpenInterestPressure.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OpenInterestPressureList>, I>>(
    base?: I
  ): OpenInterestPressureList {
    return OpenInterestPressureList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OpenInterestPressureList>, I>>(
    object: I
  ): OpenInterestPressureList {
    const message = createBaseOpenInterestPressureList()
    message.items = object.items?.map((e) => OpenInterestPressure.fromPartial(e)) || []
    return message
  },
}

function createBaseImpliedVsRealizedPoint(): ImpliedVsRealizedPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    indexPrice: undefined,
    lnReturn: undefined,
    atm7: undefined,
    atm30: undefined,
    atm60: undefined,
    atm90: undefined,
    atm180: undefined,
    realizedVolatility7: undefined,
    realizedVolatility30: undefined,
  }
}

export const ImpliedVsRealizedPoint: MessageFns<ImpliedVsRealizedPoint> = {
  encode(message: ImpliedVsRealizedPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(34).string(message.indexPrice)
    }
    if (message.lnReturn !== undefined) {
      writer.uint32(42).string(message.lnReturn)
    }
    if (message.atm7 !== undefined) {
      writer.uint32(50).string(message.atm7)
    }
    if (message.atm30 !== undefined) {
      writer.uint32(58).string(message.atm30)
    }
    if (message.atm60 !== undefined) {
      writer.uint32(66).string(message.atm60)
    }
    if (message.atm90 !== undefined) {
      writer.uint32(74).string(message.atm90)
    }
    if (message.atm180 !== undefined) {
      writer.uint32(82).string(message.atm180)
    }
    if (message.realizedVolatility7 !== undefined) {
      writer.uint32(90).string(message.realizedVolatility7)
    }
    if (message.realizedVolatility30 !== undefined) {
      writer.uint32(98).string(message.realizedVolatility30)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpliedVsRealizedPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseImpliedVsRealizedPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.lnReturn = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.atm7 = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.atm30 = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.atm60 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.atm90 = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.atm180 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.realizedVolatility7 = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.realizedVolatility30 = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ImpliedVsRealizedPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      lnReturn: isSet(object.lnReturn)
        ? globalThis.String(object.lnReturn)
        : isSet(object.ln_return)
          ? globalThis.String(object.ln_return)
          : undefined,
      atm7: isSet(object.atm7)
        ? globalThis.String(object.atm7)
        : isSet(object.atm_7)
          ? globalThis.String(object.atm_7)
          : undefined,
      atm30: isSet(object.atm30)
        ? globalThis.String(object.atm30)
        : isSet(object.atm_30)
          ? globalThis.String(object.atm_30)
          : undefined,
      atm60: isSet(object.atm60)
        ? globalThis.String(object.atm60)
        : isSet(object.atm_60)
          ? globalThis.String(object.atm_60)
          : undefined,
      atm90: isSet(object.atm90)
        ? globalThis.String(object.atm90)
        : isSet(object.atm_90)
          ? globalThis.String(object.atm_90)
          : undefined,
      atm180: isSet(object.atm180)
        ? globalThis.String(object.atm180)
        : isSet(object.atm_180)
          ? globalThis.String(object.atm_180)
          : undefined,
      realizedVolatility7: isSet(object.realizedVolatility7)
        ? globalThis.String(object.realizedVolatility7)
        : isSet(object.realized_volatility_7)
          ? globalThis.String(object.realized_volatility_7)
          : undefined,
      realizedVolatility30: isSet(object.realizedVolatility30)
        ? globalThis.String(object.realizedVolatility30)
        : isSet(object.realized_volatility_30)
          ? globalThis.String(object.realized_volatility_30)
          : undefined,
    }
  },

  toJSON(message: ImpliedVsRealizedPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.lnReturn !== undefined) {
      obj.lnReturn = message.lnReturn
    }
    if (message.atm7 !== undefined) {
      obj.atm7 = message.atm7
    }
    if (message.atm30 !== undefined) {
      obj.atm30 = message.atm30
    }
    if (message.atm60 !== undefined) {
      obj.atm60 = message.atm60
    }
    if (message.atm90 !== undefined) {
      obj.atm90 = message.atm90
    }
    if (message.atm180 !== undefined) {
      obj.atm180 = message.atm180
    }
    if (message.realizedVolatility7 !== undefined) {
      obj.realizedVolatility7 = message.realizedVolatility7
    }
    if (message.realizedVolatility30 !== undefined) {
      obj.realizedVolatility30 = message.realizedVolatility30
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ImpliedVsRealizedPoint>, I>>(
    base?: I
  ): ImpliedVsRealizedPoint {
    return ImpliedVsRealizedPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ImpliedVsRealizedPoint>, I>>(
    object: I
  ): ImpliedVsRealizedPoint {
    const message = createBaseImpliedVsRealizedPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.indexPrice = object.indexPrice ?? undefined
    message.lnReturn = object.lnReturn ?? undefined
    message.atm7 = object.atm7 ?? undefined
    message.atm30 = object.atm30 ?? undefined
    message.atm60 = object.atm60 ?? undefined
    message.atm90 = object.atm90 ?? undefined
    message.atm180 = object.atm180 ?? undefined
    message.realizedVolatility7 = object.realizedVolatility7 ?? undefined
    message.realizedVolatility30 = object.realizedVolatility30 ?? undefined
    return message
  },
}

function createBaseImpliedVsRealizedList(): ImpliedVsRealizedList {
  return { items: [] }
}

export const ImpliedVsRealizedList: MessageFns<ImpliedVsRealizedList> = {
  encode(message: ImpliedVsRealizedList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      ImpliedVsRealizedPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpliedVsRealizedList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseImpliedVsRealizedList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(ImpliedVsRealizedPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ImpliedVsRealizedList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ImpliedVsRealizedPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ImpliedVsRealizedList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => ImpliedVsRealizedPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ImpliedVsRealizedList>, I>>(base?: I): ImpliedVsRealizedList {
    return ImpliedVsRealizedList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ImpliedVsRealizedList>, I>>(
    object: I
  ): ImpliedVsRealizedList {
    const message = createBaseImpliedVsRealizedList()
    message.items = object.items?.map((e) => ImpliedVsRealizedPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseUsdGammaPoint(): UsdGammaPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    normalizedGammaNative: undefined,
    normalizedGammaUsd: undefined,
    bookIndexPrice: undefined,
  }
}

export const UsdGammaPoint: MessageFns<UsdGammaPoint> = {
  encode(message: UsdGammaPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.normalizedGammaNative !== undefined) {
      writer.uint32(34).string(message.normalizedGammaNative)
    }
    if (message.normalizedGammaUsd !== undefined) {
      writer.uint32(42).string(message.normalizedGammaUsd)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(50).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsdGammaPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUsdGammaPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.normalizedGammaNative = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.normalizedGammaUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UsdGammaPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      normalizedGammaNative: isSet(object.normalizedGammaNative)
        ? globalThis.String(object.normalizedGammaNative)
        : isSet(object.normalized_gamma_native)
          ? globalThis.String(object.normalized_gamma_native)
          : undefined,
      normalizedGammaUsd: isSet(object.normalizedGammaUsd)
        ? globalThis.String(object.normalizedGammaUsd)
        : isSet(object.normalized_gamma_usd)
          ? globalThis.String(object.normalized_gamma_usd)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: UsdGammaPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.normalizedGammaNative !== undefined) {
      obj.normalizedGammaNative = message.normalizedGammaNative
    }
    if (message.normalizedGammaUsd !== undefined) {
      obj.normalizedGammaUsd = message.normalizedGammaUsd
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UsdGammaPoint>, I>>(base?: I): UsdGammaPoint {
    return UsdGammaPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UsdGammaPoint>, I>>(object: I): UsdGammaPoint {
    const message = createBaseUsdGammaPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.normalizedGammaNative = object.normalizedGammaNative ?? undefined
    message.normalizedGammaUsd = object.normalizedGammaUsd ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseUsdGammaList(): UsdGammaList {
  return { items: [] }
}

export const UsdGammaList: MessageFns<UsdGammaList> = {
  encode(message: UsdGammaList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      UsdGammaPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsdGammaList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUsdGammaList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(UsdGammaPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UsdGammaList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => UsdGammaPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: UsdGammaList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => UsdGammaPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UsdGammaList>, I>>(base?: I): UsdGammaList {
    return UsdGammaList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UsdGammaList>, I>>(object: I): UsdGammaList {
    const message = createBaseUsdGammaList()
    message.items = object.items?.map((e) => UsdGammaPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGexPoint(): GexPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    instrument: '',
    putCall: '',
    strike: undefined,
    dealerNetInventory: undefined,
    dealerTotalInventory: undefined,
    gammaLevel: undefined,
    indexPrice: undefined,
    bookIndexPrice: undefined,
  }
}

export const GexPoint: MessageFns<GexPoint> = {
  encode(message: GexPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.instrument !== '') {
      writer.uint32(42).string(message.instrument)
    }
    if (message.putCall !== '') {
      writer.uint32(50).string(message.putCall)
    }
    if (message.strike !== undefined) {
      writer.uint32(58).string(message.strike)
    }
    if (message.dealerNetInventory !== undefined) {
      writer.uint32(66).string(message.dealerNetInventory)
    }
    if (message.dealerTotalInventory !== undefined) {
      writer.uint32(74).string(message.dealerTotalInventory)
    }
    if (message.gammaLevel !== undefined) {
      writer.uint32(82).string(message.gammaLevel)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(90).string(message.indexPrice)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(98).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.putCall = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.dealerNetInventory = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.dealerTotalInventory = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.gammaLevel = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : '',
      putCall: isSet(object.putCall)
        ? globalThis.String(object.putCall)
        : isSet(object.put_call)
          ? globalThis.String(object.put_call)
          : '',
      strike: isSet(object.strike) ? globalThis.String(object.strike) : undefined,
      dealerNetInventory: isSet(object.dealerNetInventory)
        ? globalThis.String(object.dealerNetInventory)
        : isSet(object.dealer_net_inventory)
          ? globalThis.String(object.dealer_net_inventory)
          : undefined,
      dealerTotalInventory: isSet(object.dealerTotalInventory)
        ? globalThis.String(object.dealerTotalInventory)
        : isSet(object.dealer_total_inventory)
          ? globalThis.String(object.dealer_total_inventory)
          : undefined,
      gammaLevel: isSet(object.gammaLevel)
        ? globalThis.String(object.gammaLevel)
        : isSet(object.gamma_level)
          ? globalThis.String(object.gamma_level)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: GexPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.instrument !== '') {
      obj.instrument = message.instrument
    }
    if (message.putCall !== '') {
      obj.putCall = message.putCall
    }
    if (message.strike !== undefined) {
      obj.strike = message.strike
    }
    if (message.dealerNetInventory !== undefined) {
      obj.dealerNetInventory = message.dealerNetInventory
    }
    if (message.dealerTotalInventory !== undefined) {
      obj.dealerTotalInventory = message.dealerTotalInventory
    }
    if (message.gammaLevel !== undefined) {
      obj.gammaLevel = message.gammaLevel
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexPoint>, I>>(base?: I): GexPoint {
    return GexPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexPoint>, I>>(object: I): GexPoint {
    const message = createBaseGexPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.instrument = object.instrument ?? ''
    message.putCall = object.putCall ?? ''
    message.strike = object.strike ?? undefined
    message.dealerNetInventory = object.dealerNetInventory ?? undefined
    message.dealerTotalInventory = object.dealerTotalInventory ?? undefined
    message.gammaLevel = object.gammaLevel ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseGexList(): GexList {
  return { items: [] }
}

export const GexList: MessageFns<GexList> = {
  encode(message: GexList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      GexPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(GexPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => GexPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GexList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => GexPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexList>, I>>(base?: I): GexList {
    return GexList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexList>, I>>(object: I): GexList {
    const message = createBaseGexList()
    message.items = object.items?.map((e) => GexPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseVolConePoint(): VolConePoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    windowDays: '0',
    current: undefined,
    min: undefined,
    max: undefined,
    p25: undefined,
    p50: undefined,
    p75: undefined,
    observations: undefined,
  }
}

export const VolConePoint: MessageFns<VolConePoint> = {
  encode(message: VolConePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.windowDays !== '0') {
      writer.uint32(32).int64(message.windowDays)
    }
    if (message.current !== undefined) {
      writer.uint32(42).string(message.current)
    }
    if (message.min !== undefined) {
      writer.uint32(50).string(message.min)
    }
    if (message.max !== undefined) {
      writer.uint32(58).string(message.max)
    }
    if (message.p25 !== undefined) {
      writer.uint32(66).string(message.p25)
    }
    if (message.p50 !== undefined) {
      writer.uint32(74).string(message.p50)
    }
    if (message.p75 !== undefined) {
      writer.uint32(82).string(message.p75)
    }
    if (message.observations !== undefined) {
      writer.uint32(88).int64(message.observations)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolConePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolConePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.windowDays = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.current = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.min = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.max = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.p25 = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.p50 = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.p75 = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.observations = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolConePoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      windowDays: isSet(object.windowDays)
        ? globalThis.String(object.windowDays)
        : isSet(object.window_days)
          ? globalThis.String(object.window_days)
          : '0',
      current: isSet(object.current) ? globalThis.String(object.current) : undefined,
      min: isSet(object.min) ? globalThis.String(object.min) : undefined,
      max: isSet(object.max) ? globalThis.String(object.max) : undefined,
      p25: isSet(object.p25) ? globalThis.String(object.p25) : undefined,
      p50: isSet(object.p50) ? globalThis.String(object.p50) : undefined,
      p75: isSet(object.p75) ? globalThis.String(object.p75) : undefined,
      observations: isSet(object.observations) ? globalThis.String(object.observations) : undefined,
    }
  },

  toJSON(message: VolConePoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.windowDays !== '0') {
      obj.windowDays = message.windowDays
    }
    if (message.current !== undefined) {
      obj.current = message.current
    }
    if (message.min !== undefined) {
      obj.min = message.min
    }
    if (message.max !== undefined) {
      obj.max = message.max
    }
    if (message.p25 !== undefined) {
      obj.p25 = message.p25
    }
    if (message.p50 !== undefined) {
      obj.p50 = message.p50
    }
    if (message.p75 !== undefined) {
      obj.p75 = message.p75
    }
    if (message.observations !== undefined) {
      obj.observations = message.observations
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolConePoint>, I>>(base?: I): VolConePoint {
    return VolConePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolConePoint>, I>>(object: I): VolConePoint {
    const message = createBaseVolConePoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.windowDays = object.windowDays ?? '0'
    message.current = object.current ?? undefined
    message.min = object.min ?? undefined
    message.max = object.max ?? undefined
    message.p25 = object.p25 ?? undefined
    message.p50 = object.p50 ?? undefined
    message.p75 = object.p75 ?? undefined
    message.observations = object.observations ?? undefined
    return message
  },
}

function createBaseVolConeList(): VolConeList {
  return { items: [] }
}

export const VolConeList: MessageFns<VolConeList> = {
  encode(message: VolConeList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      VolConePoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolConeList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolConeList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(VolConePoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolConeList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => VolConePoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VolConeList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => VolConePoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolConeList>, I>>(base?: I): VolConeList {
    return VolConeList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolConeList>, I>>(object: I): VolConeList {
    const message = createBaseVolConeList()
    message.items = object.items?.map((e) => VolConePoint.fromPartial(e)) || []
    return message
  },
}

function createBaseSviPoint(): SviPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    daysToExpiration: '',
    forward: undefined,
    sviA: undefined,
    sviB: undefined,
    sviRho: undefined,
    sviM: undefined,
    sviSigma: undefined,
    fitRmseVolpts: undefined,
    quoteCount: undefined,
    maxAbsErrVolpts: undefined,
    fittedAtMs: undefined,
    model: undefined,
    deAmericanized: undefined,
    inputsNewestTsMs: undefined,
    inputsOldestTsMs: undefined,
    sourceKind: undefined,
    rvGuardVolpts: undefined,
    indexPrice: undefined,
  }
}

export const SviPoint: MessageFns<SviPoint> = {
  encode(message: SviPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(42).string(message.daysToExpiration)
    }
    if (message.forward !== undefined) {
      writer.uint32(50).string(message.forward)
    }
    if (message.sviA !== undefined) {
      writer.uint32(58).string(message.sviA)
    }
    if (message.sviB !== undefined) {
      writer.uint32(66).string(message.sviB)
    }
    if (message.sviRho !== undefined) {
      writer.uint32(74).string(message.sviRho)
    }
    if (message.sviM !== undefined) {
      writer.uint32(82).string(message.sviM)
    }
    if (message.sviSigma !== undefined) {
      writer.uint32(90).string(message.sviSigma)
    }
    if (message.fitRmseVolpts !== undefined) {
      writer.uint32(98).string(message.fitRmseVolpts)
    }
    if (message.quoteCount !== undefined) {
      writer.uint32(104).uint32(message.quoteCount)
    }
    if (message.maxAbsErrVolpts !== undefined) {
      writer.uint32(114).string(message.maxAbsErrVolpts)
    }
    if (message.fittedAtMs !== undefined) {
      writer.uint32(120).int64(message.fittedAtMs)
    }
    if (message.model !== undefined) {
      writer.uint32(130).string(message.model)
    }
    if (message.deAmericanized !== undefined) {
      writer.uint32(136).bool(message.deAmericanized)
    }
    if (message.inputsNewestTsMs !== undefined) {
      writer.uint32(144).int64(message.inputsNewestTsMs)
    }
    if (message.inputsOldestTsMs !== undefined) {
      writer.uint32(152).int64(message.inputsOldestTsMs)
    }
    if (message.sourceKind !== undefined) {
      writer.uint32(160).int32(message.sourceKind)
    }
    if (message.rvGuardVolpts !== undefined) {
      writer.uint32(170).string(message.rvGuardVolpts)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(178).string(message.indexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SviPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSviPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.forward = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.sviA = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.sviB = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.sviRho = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.sviM = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.sviSigma = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.fitRmseVolpts = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.quoteCount = reader.uint32()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.maxAbsErrVolpts = reader.string()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.fittedAtMs = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.model = reader.string()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.deAmericanized = reader.bool()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.inputsNewestTsMs = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.inputsOldestTsMs = reader.int64().toString()
          continue
        }
        case 20: {
          if (tag !== 160) {
            break
          }

          message.sourceKind = reader.int32() as any
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.rvGuardVolpts = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SviPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      forward: isSet(object.forward) ? globalThis.String(object.forward) : undefined,
      sviA: isSet(object.sviA)
        ? globalThis.String(object.sviA)
        : isSet(object.svi_a)
          ? globalThis.String(object.svi_a)
          : undefined,
      sviB: isSet(object.sviB)
        ? globalThis.String(object.sviB)
        : isSet(object.svi_b)
          ? globalThis.String(object.svi_b)
          : undefined,
      sviRho: isSet(object.sviRho)
        ? globalThis.String(object.sviRho)
        : isSet(object.svi_rho)
          ? globalThis.String(object.svi_rho)
          : undefined,
      sviM: isSet(object.sviM)
        ? globalThis.String(object.sviM)
        : isSet(object.svi_m)
          ? globalThis.String(object.svi_m)
          : undefined,
      sviSigma: isSet(object.sviSigma)
        ? globalThis.String(object.sviSigma)
        : isSet(object.svi_sigma)
          ? globalThis.String(object.svi_sigma)
          : undefined,
      fitRmseVolpts: isSet(object.fitRmseVolpts)
        ? globalThis.String(object.fitRmseVolpts)
        : isSet(object.fit_rmse_volpts)
          ? globalThis.String(object.fit_rmse_volpts)
          : undefined,
      quoteCount: isSet(object.quoteCount)
        ? globalThis.Number(object.quoteCount)
        : isSet(object.quote_count)
          ? globalThis.Number(object.quote_count)
          : undefined,
      maxAbsErrVolpts: isSet(object.maxAbsErrVolpts)
        ? globalThis.String(object.maxAbsErrVolpts)
        : isSet(object.max_abs_err_volpts)
          ? globalThis.String(object.max_abs_err_volpts)
          : undefined,
      fittedAtMs: isSet(object.fittedAtMs)
        ? globalThis.String(object.fittedAtMs)
        : isSet(object.fitted_at_ms)
          ? globalThis.String(object.fitted_at_ms)
          : undefined,
      model: isSet(object.model) ? globalThis.String(object.model) : undefined,
      deAmericanized: isSet(object.deAmericanized)
        ? globalThis.Boolean(object.deAmericanized)
        : isSet(object.de_americanized)
          ? globalThis.Boolean(object.de_americanized)
          : undefined,
      inputsNewestTsMs: isSet(object.inputsNewestTsMs)
        ? globalThis.String(object.inputsNewestTsMs)
        : isSet(object.inputs_newest_ts_ms)
          ? globalThis.String(object.inputs_newest_ts_ms)
          : undefined,
      inputsOldestTsMs: isSet(object.inputsOldestTsMs)
        ? globalThis.String(object.inputsOldestTsMs)
        : isSet(object.inputs_oldest_ts_ms)
          ? globalThis.String(object.inputs_oldest_ts_ms)
          : undefined,
      sourceKind: isSet(object.sourceKind)
        ? sviSourceKindFromJSON(object.sourceKind)
        : isSet(object.source_kind)
          ? sviSourceKindFromJSON(object.source_kind)
          : undefined,
      rvGuardVolpts: isSet(object.rvGuardVolpts)
        ? globalThis.String(object.rvGuardVolpts)
        : isSet(object.rv_guard_volpts)
          ? globalThis.String(object.rv_guard_volpts)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
    }
  },

  toJSON(message: SviPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.forward !== undefined) {
      obj.forward = message.forward
    }
    if (message.sviA !== undefined) {
      obj.sviA = message.sviA
    }
    if (message.sviB !== undefined) {
      obj.sviB = message.sviB
    }
    if (message.sviRho !== undefined) {
      obj.sviRho = message.sviRho
    }
    if (message.sviM !== undefined) {
      obj.sviM = message.sviM
    }
    if (message.sviSigma !== undefined) {
      obj.sviSigma = message.sviSigma
    }
    if (message.fitRmseVolpts !== undefined) {
      obj.fitRmseVolpts = message.fitRmseVolpts
    }
    if (message.quoteCount !== undefined) {
      obj.quoteCount = Math.round(message.quoteCount)
    }
    if (message.maxAbsErrVolpts !== undefined) {
      obj.maxAbsErrVolpts = message.maxAbsErrVolpts
    }
    if (message.fittedAtMs !== undefined) {
      obj.fittedAtMs = message.fittedAtMs
    }
    if (message.model !== undefined) {
      obj.model = message.model
    }
    if (message.deAmericanized !== undefined) {
      obj.deAmericanized = message.deAmericanized
    }
    if (message.inputsNewestTsMs !== undefined) {
      obj.inputsNewestTsMs = message.inputsNewestTsMs
    }
    if (message.inputsOldestTsMs !== undefined) {
      obj.inputsOldestTsMs = message.inputsOldestTsMs
    }
    if (message.sourceKind !== undefined) {
      obj.sourceKind = sviSourceKindToJSON(message.sourceKind)
    }
    if (message.rvGuardVolpts !== undefined) {
      obj.rvGuardVolpts = message.rvGuardVolpts
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SviPoint>, I>>(base?: I): SviPoint {
    return SviPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SviPoint>, I>>(object: I): SviPoint {
    const message = createBaseSviPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.forward = object.forward ?? undefined
    message.sviA = object.sviA ?? undefined
    message.sviB = object.sviB ?? undefined
    message.sviRho = object.sviRho ?? undefined
    message.sviM = object.sviM ?? undefined
    message.sviSigma = object.sviSigma ?? undefined
    message.fitRmseVolpts = object.fitRmseVolpts ?? undefined
    message.quoteCount = object.quoteCount ?? undefined
    message.maxAbsErrVolpts = object.maxAbsErrVolpts ?? undefined
    message.fittedAtMs = object.fittedAtMs ?? undefined
    message.model = object.model ?? undefined
    message.deAmericanized = object.deAmericanized ?? undefined
    message.inputsNewestTsMs = object.inputsNewestTsMs ?? undefined
    message.inputsOldestTsMs = object.inputsOldestTsMs ?? undefined
    message.sourceKind = object.sourceKind ?? undefined
    message.rvGuardVolpts = object.rvGuardVolpts ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    return message
  },
}

function createBaseSviList(): SviList {
  return { items: [], calendar: undefined }
}

export const SviList: MessageFns<SviList> = {
  encode(message: SviList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      SviPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.calendar !== undefined) {
      writer.uint32(16).int32(message.calendar)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SviList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSviList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(SviPoint.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.calendar = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SviList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => SviPoint.fromJSON(e))
        : [],
      calendar: isSet(object.calendar) ? exchangeFromJSON(object.calendar) : undefined,
    }
  },

  toJSON(message: SviList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => SviPoint.toJSON(e))
    }
    if (message.calendar !== undefined) {
      obj.calendar = exchangeToJSON(message.calendar)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SviList>, I>>(base?: I): SviList {
    return SviList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SviList>, I>>(object: I): SviList {
    const message = createBaseSviList()
    message.items = object.items?.map((e) => SviPoint.fromPartial(e)) || []
    message.calendar = object.calendar ?? undefined
    return message
  },
}

function createBaseRvSeasonalityPoint(): RvSeasonalityPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    bucket: '',
    historicalVolatility: undefined,
  }
}

export const RvSeasonalityPoint: MessageFns<RvSeasonalityPoint> = {
  encode(message: RvSeasonalityPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.bucket !== '') {
      writer.uint32(34).string(message.bucket)
    }
    if (message.historicalVolatility !== undefined) {
      writer.uint32(42).string(message.historicalVolatility)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RvSeasonalityPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRvSeasonalityPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.bucket = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.historicalVolatility = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RvSeasonalityPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      bucket: isSet(object.bucket) ? globalThis.String(object.bucket) : '',
      historicalVolatility: isSet(object.historicalVolatility)
        ? globalThis.String(object.historicalVolatility)
        : isSet(object.historical_volatility)
          ? globalThis.String(object.historical_volatility)
          : undefined,
    }
  },

  toJSON(message: RvSeasonalityPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.bucket !== '') {
      obj.bucket = message.bucket
    }
    if (message.historicalVolatility !== undefined) {
      obj.historicalVolatility = message.historicalVolatility
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RvSeasonalityPoint>, I>>(base?: I): RvSeasonalityPoint {
    return RvSeasonalityPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RvSeasonalityPoint>, I>>(object: I): RvSeasonalityPoint {
    const message = createBaseRvSeasonalityPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.bucket = object.bucket ?? ''
    message.historicalVolatility = object.historicalVolatility ?? undefined
    return message
  },
}

function createBaseRvSeasonalityList(): RvSeasonalityList {
  return { items: [] }
}

export const RvSeasonalityList: MessageFns<RvSeasonalityList> = {
  encode(message: RvSeasonalityList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      RvSeasonalityPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RvSeasonalityList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRvSeasonalityList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(RvSeasonalityPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RvSeasonalityList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => RvSeasonalityPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: RvSeasonalityList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => RvSeasonalityPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RvSeasonalityList>, I>>(base?: I): RvSeasonalityList {
    return RvSeasonalityList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RvSeasonalityList>, I>>(object: I): RvSeasonalityList {
    const message = createBaseRvSeasonalityList()
    message.items = object.items?.map((e) => RvSeasonalityPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseBucketedReturnPoint(): BucketedReturnPoint {
  return { exchange: 0, symbol: '', bucket: '', avgReturnPct: undefined, samples: '0' }
}

export const BucketedReturnPoint: MessageFns<BucketedReturnPoint> = {
  encode(message: BucketedReturnPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.bucket !== '') {
      writer.uint32(34).string(message.bucket)
    }
    if (message.avgReturnPct !== undefined) {
      writer.uint32(42).string(message.avgReturnPct)
    }
    if (message.samples !== '0') {
      writer.uint32(48).int64(message.samples)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BucketedReturnPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBucketedReturnPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.bucket = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.avgReturnPct = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.samples = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BucketedReturnPoint {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      bucket: isSet(object.bucket) ? globalThis.String(object.bucket) : '',
      avgReturnPct: isSet(object.avgReturnPct)
        ? globalThis.String(object.avgReturnPct)
        : isSet(object.avg_return_pct)
          ? globalThis.String(object.avg_return_pct)
          : undefined,
      samples: isSet(object.samples) ? globalThis.String(object.samples) : '0',
    }
  },

  toJSON(message: BucketedReturnPoint): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.bucket !== '') {
      obj.bucket = message.bucket
    }
    if (message.avgReturnPct !== undefined) {
      obj.avgReturnPct = message.avgReturnPct
    }
    if (message.samples !== '0') {
      obj.samples = message.samples
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BucketedReturnPoint>, I>>(base?: I): BucketedReturnPoint {
    return BucketedReturnPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BucketedReturnPoint>, I>>(
    object: I
  ): BucketedReturnPoint {
    const message = createBaseBucketedReturnPoint()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.bucket = object.bucket ?? ''
    message.avgReturnPct = object.avgReturnPct ?? undefined
    message.samples = object.samples ?? '0'
    return message
  },
}

function createBaseBucketedReturnList(): BucketedReturnList {
  return { items: [], coveredFromMs: undefined, coveredToMs: undefined, basis: 0 }
}

export const BucketedReturnList: MessageFns<BucketedReturnList> = {
  encode(message: BucketedReturnList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      BucketedReturnPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.coveredFromMs !== undefined) {
      writer.uint32(16).int64(message.coveredFromMs)
    }
    if (message.coveredToMs !== undefined) {
      writer.uint32(24).int64(message.coveredToMs)
    }
    if (message.basis !== 0) {
      writer.uint32(32).int32(message.basis)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BucketedReturnList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBucketedReturnList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(BucketedReturnPoint.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.coveredFromMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.coveredToMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.basis = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BucketedReturnList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => BucketedReturnPoint.fromJSON(e))
        : [],
      coveredFromMs: isSet(object.coveredFromMs)
        ? globalThis.String(object.coveredFromMs)
        : isSet(object.covered_from_ms)
          ? globalThis.String(object.covered_from_ms)
          : undefined,
      coveredToMs: isSet(object.coveredToMs)
        ? globalThis.String(object.coveredToMs)
        : isSet(object.covered_to_ms)
          ? globalThis.String(object.covered_to_ms)
          : undefined,
      basis: isSet(object.basis) ? returnBasisFromJSON(object.basis) : 0,
    }
  },

  toJSON(message: BucketedReturnList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => BucketedReturnPoint.toJSON(e))
    }
    if (message.coveredFromMs !== undefined) {
      obj.coveredFromMs = message.coveredFromMs
    }
    if (message.coveredToMs !== undefined) {
      obj.coveredToMs = message.coveredToMs
    }
    if (message.basis !== 0) {
      obj.basis = returnBasisToJSON(message.basis)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BucketedReturnList>, I>>(base?: I): BucketedReturnList {
    return BucketedReturnList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BucketedReturnList>, I>>(object: I): BucketedReturnList {
    const message = createBaseBucketedReturnList()
    message.items = object.items?.map((e) => BucketedReturnPoint.fromPartial(e)) || []
    message.coveredFromMs = object.coveredFromMs ?? undefined
    message.coveredToMs = object.coveredToMs ?? undefined
    message.basis = object.basis ?? 0
    return message
  },
}

function createBaseSessionCumulativeReturnPoint(): SessionCumulativeReturnPoint {
  return { timestampMs: '0', exchange: 0, symbol: '', bucket: '', cumulativeReturnPct: undefined }
}

export const SessionCumulativeReturnPoint: MessageFns<SessionCumulativeReturnPoint> = {
  encode(
    message: SessionCumulativeReturnPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.bucket !== '') {
      writer.uint32(34).string(message.bucket)
    }
    if (message.cumulativeReturnPct !== undefined) {
      writer.uint32(42).string(message.cumulativeReturnPct)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionCumulativeReturnPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionCumulativeReturnPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.bucket = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.cumulativeReturnPct = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionCumulativeReturnPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      bucket: isSet(object.bucket) ? globalThis.String(object.bucket) : '',
      cumulativeReturnPct: isSet(object.cumulativeReturnPct)
        ? globalThis.String(object.cumulativeReturnPct)
        : isSet(object.cumulative_return_pct)
          ? globalThis.String(object.cumulative_return_pct)
          : undefined,
    }
  },

  toJSON(message: SessionCumulativeReturnPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.bucket !== '') {
      obj.bucket = message.bucket
    }
    if (message.cumulativeReturnPct !== undefined) {
      obj.cumulativeReturnPct = message.cumulativeReturnPct
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionCumulativeReturnPoint>, I>>(
    base?: I
  ): SessionCumulativeReturnPoint {
    return SessionCumulativeReturnPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionCumulativeReturnPoint>, I>>(
    object: I
  ): SessionCumulativeReturnPoint {
    const message = createBaseSessionCumulativeReturnPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.bucket = object.bucket ?? ''
    message.cumulativeReturnPct = object.cumulativeReturnPct ?? undefined
    return message
  },
}

function createBaseSessionCumulativeReturnList(): SessionCumulativeReturnList {
  return { items: [], coveredFromMs: undefined, coveredToMs: undefined }
}

export const SessionCumulativeReturnList: MessageFns<SessionCumulativeReturnList> = {
  encode(
    message: SessionCumulativeReturnList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      SessionCumulativeReturnPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.coveredFromMs !== undefined) {
      writer.uint32(16).int64(message.coveredFromMs)
    }
    if (message.coveredToMs !== undefined) {
      writer.uint32(24).int64(message.coveredToMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionCumulativeReturnList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionCumulativeReturnList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(SessionCumulativeReturnPoint.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.coveredFromMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.coveredToMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionCumulativeReturnList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => SessionCumulativeReturnPoint.fromJSON(e))
        : [],
      coveredFromMs: isSet(object.coveredFromMs)
        ? globalThis.String(object.coveredFromMs)
        : isSet(object.covered_from_ms)
          ? globalThis.String(object.covered_from_ms)
          : undefined,
      coveredToMs: isSet(object.coveredToMs)
        ? globalThis.String(object.coveredToMs)
        : isSet(object.covered_to_ms)
          ? globalThis.String(object.covered_to_ms)
          : undefined,
    }
  },

  toJSON(message: SessionCumulativeReturnList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => SessionCumulativeReturnPoint.toJSON(e))
    }
    if (message.coveredFromMs !== undefined) {
      obj.coveredFromMs = message.coveredFromMs
    }
    if (message.coveredToMs !== undefined) {
      obj.coveredToMs = message.coveredToMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionCumulativeReturnList>, I>>(
    base?: I
  ): SessionCumulativeReturnList {
    return SessionCumulativeReturnList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionCumulativeReturnList>, I>>(
    object: I
  ): SessionCumulativeReturnList {
    const message = createBaseSessionCumulativeReturnList()
    message.items = object.items?.map((e) => SessionCumulativeReturnPoint.fromPartial(e)) || []
    message.coveredFromMs = object.coveredFromMs ?? undefined
    message.coveredToMs = object.coveredToMs ?? undefined
    return message
  },
}

function createBaseGetGreeksByExpiryRequest(): GetGreeksByExpiryRequest {
  return { exchange: 0, underlying: '' }
}

export const GetGreeksByExpiryRequest: MessageFns<GetGreeksByExpiryRequest> = {
  encode(
    message: GetGreeksByExpiryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetGreeksByExpiryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetGreeksByExpiryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetGreeksByExpiryRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: GetGreeksByExpiryRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetGreeksByExpiryRequest>, I>>(
    base?: I
  ): GetGreeksByExpiryRequest {
    return GetGreeksByExpiryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetGreeksByExpiryRequest>, I>>(
    object: I
  ): GetGreeksByExpiryRequest {
    const message = createBaseGetGreeksByExpiryRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseGreeksByExpiryPoint(): GreeksByExpiryPoint {
  return {
    expiryMs: '0',
    callDelta: '',
    putDelta: '',
    netDelta: '',
    callGamma: '',
    putGamma: '',
    netGamma: '',
    callVega: '',
    putVega: '',
    netVega: '',
    callTheta: '',
    putTheta: '',
    netTheta: '',
    callRho: '',
    putRho: '',
    netRho: '',
  }
}

export const GreeksByExpiryPoint: MessageFns<GreeksByExpiryPoint> = {
  encode(message: GreeksByExpiryPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiryMs !== '0') {
      writer.uint32(8).int64(message.expiryMs)
    }
    if (message.callDelta !== '') {
      writer.uint32(18).string(message.callDelta)
    }
    if (message.putDelta !== '') {
      writer.uint32(26).string(message.putDelta)
    }
    if (message.netDelta !== '') {
      writer.uint32(34).string(message.netDelta)
    }
    if (message.callGamma !== '') {
      writer.uint32(42).string(message.callGamma)
    }
    if (message.putGamma !== '') {
      writer.uint32(50).string(message.putGamma)
    }
    if (message.netGamma !== '') {
      writer.uint32(58).string(message.netGamma)
    }
    if (message.callVega !== '') {
      writer.uint32(66).string(message.callVega)
    }
    if (message.putVega !== '') {
      writer.uint32(74).string(message.putVega)
    }
    if (message.netVega !== '') {
      writer.uint32(82).string(message.netVega)
    }
    if (message.callTheta !== '') {
      writer.uint32(90).string(message.callTheta)
    }
    if (message.putTheta !== '') {
      writer.uint32(98).string(message.putTheta)
    }
    if (message.netTheta !== '') {
      writer.uint32(106).string(message.netTheta)
    }
    if (message.callRho !== '') {
      writer.uint32(114).string(message.callRho)
    }
    if (message.putRho !== '') {
      writer.uint32(122).string(message.putRho)
    }
    if (message.netRho !== '') {
      writer.uint32(130).string(message.netRho)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreeksByExpiryPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGreeksByExpiryPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.callDelta = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.putDelta = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.netDelta = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.callGamma = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.putGamma = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.netGamma = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.callVega = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.putVega = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.netVega = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.callTheta = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.putTheta = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.netTheta = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.callRho = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.putRho = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.netRho = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GreeksByExpiryPoint {
    return {
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : '0',
      callDelta: isSet(object.callDelta)
        ? globalThis.String(object.callDelta)
        : isSet(object.call_delta)
          ? globalThis.String(object.call_delta)
          : '',
      putDelta: isSet(object.putDelta)
        ? globalThis.String(object.putDelta)
        : isSet(object.put_delta)
          ? globalThis.String(object.put_delta)
          : '',
      netDelta: isSet(object.netDelta)
        ? globalThis.String(object.netDelta)
        : isSet(object.net_delta)
          ? globalThis.String(object.net_delta)
          : '',
      callGamma: isSet(object.callGamma)
        ? globalThis.String(object.callGamma)
        : isSet(object.call_gamma)
          ? globalThis.String(object.call_gamma)
          : '',
      putGamma: isSet(object.putGamma)
        ? globalThis.String(object.putGamma)
        : isSet(object.put_gamma)
          ? globalThis.String(object.put_gamma)
          : '',
      netGamma: isSet(object.netGamma)
        ? globalThis.String(object.netGamma)
        : isSet(object.net_gamma)
          ? globalThis.String(object.net_gamma)
          : '',
      callVega: isSet(object.callVega)
        ? globalThis.String(object.callVega)
        : isSet(object.call_vega)
          ? globalThis.String(object.call_vega)
          : '',
      putVega: isSet(object.putVega)
        ? globalThis.String(object.putVega)
        : isSet(object.put_vega)
          ? globalThis.String(object.put_vega)
          : '',
      netVega: isSet(object.netVega)
        ? globalThis.String(object.netVega)
        : isSet(object.net_vega)
          ? globalThis.String(object.net_vega)
          : '',
      callTheta: isSet(object.callTheta)
        ? globalThis.String(object.callTheta)
        : isSet(object.call_theta)
          ? globalThis.String(object.call_theta)
          : '',
      putTheta: isSet(object.putTheta)
        ? globalThis.String(object.putTheta)
        : isSet(object.put_theta)
          ? globalThis.String(object.put_theta)
          : '',
      netTheta: isSet(object.netTheta)
        ? globalThis.String(object.netTheta)
        : isSet(object.net_theta)
          ? globalThis.String(object.net_theta)
          : '',
      callRho: isSet(object.callRho)
        ? globalThis.String(object.callRho)
        : isSet(object.call_rho)
          ? globalThis.String(object.call_rho)
          : '',
      putRho: isSet(object.putRho)
        ? globalThis.String(object.putRho)
        : isSet(object.put_rho)
          ? globalThis.String(object.put_rho)
          : '',
      netRho: isSet(object.netRho)
        ? globalThis.String(object.netRho)
        : isSet(object.net_rho)
          ? globalThis.String(object.net_rho)
          : '',
    }
  },

  toJSON(message: GreeksByExpiryPoint): unknown {
    const obj: any = {}
    if (message.expiryMs !== '0') {
      obj.expiryMs = message.expiryMs
    }
    if (message.callDelta !== '') {
      obj.callDelta = message.callDelta
    }
    if (message.putDelta !== '') {
      obj.putDelta = message.putDelta
    }
    if (message.netDelta !== '') {
      obj.netDelta = message.netDelta
    }
    if (message.callGamma !== '') {
      obj.callGamma = message.callGamma
    }
    if (message.putGamma !== '') {
      obj.putGamma = message.putGamma
    }
    if (message.netGamma !== '') {
      obj.netGamma = message.netGamma
    }
    if (message.callVega !== '') {
      obj.callVega = message.callVega
    }
    if (message.putVega !== '') {
      obj.putVega = message.putVega
    }
    if (message.netVega !== '') {
      obj.netVega = message.netVega
    }
    if (message.callTheta !== '') {
      obj.callTheta = message.callTheta
    }
    if (message.putTheta !== '') {
      obj.putTheta = message.putTheta
    }
    if (message.netTheta !== '') {
      obj.netTheta = message.netTheta
    }
    if (message.callRho !== '') {
      obj.callRho = message.callRho
    }
    if (message.putRho !== '') {
      obj.putRho = message.putRho
    }
    if (message.netRho !== '') {
      obj.netRho = message.netRho
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GreeksByExpiryPoint>, I>>(base?: I): GreeksByExpiryPoint {
    return GreeksByExpiryPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GreeksByExpiryPoint>, I>>(
    object: I
  ): GreeksByExpiryPoint {
    const message = createBaseGreeksByExpiryPoint()
    message.expiryMs = object.expiryMs ?? '0'
    message.callDelta = object.callDelta ?? ''
    message.putDelta = object.putDelta ?? ''
    message.netDelta = object.netDelta ?? ''
    message.callGamma = object.callGamma ?? ''
    message.putGamma = object.putGamma ?? ''
    message.netGamma = object.netGamma ?? ''
    message.callVega = object.callVega ?? ''
    message.putVega = object.putVega ?? ''
    message.netVega = object.netVega ?? ''
    message.callTheta = object.callTheta ?? ''
    message.putTheta = object.putTheta ?? ''
    message.netTheta = object.netTheta ?? ''
    message.callRho = object.callRho ?? ''
    message.putRho = object.putRho ?? ''
    message.netRho = object.netRho ?? ''
    return message
  },
}

function createBaseGreeksByExpiry(): GreeksByExpiry {
  return { exchange: 0, underlying: '', points: [] }
}

export const GreeksByExpiry: MessageFns<GreeksByExpiry> = {
  encode(message: GreeksByExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    for (const v of message.points) {
      GreeksByExpiryPoint.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreeksByExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGreeksByExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.points.push(GreeksByExpiryPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GreeksByExpiry {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => GreeksByExpiryPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GreeksByExpiry): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => GreeksByExpiryPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GreeksByExpiry>, I>>(base?: I): GreeksByExpiry {
    return GreeksByExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GreeksByExpiry>, I>>(object: I): GreeksByExpiry {
    const message = createBaseGreeksByExpiry()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.points = object.points?.map((e) => GreeksByExpiryPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetGexAggregateRequest(): GetGexAggregateRequest {
  return { exchange: 0, currency: '' }
}

export const GetGexAggregateRequest: MessageFns<GetGexAggregateRequest> = {
  encode(message: GetGexAggregateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(18).string(message.currency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetGexAggregateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetGexAggregateRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetGexAggregateRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
    }
  },

  toJSON(message: GetGexAggregateRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetGexAggregateRequest>, I>>(
    base?: I
  ): GetGexAggregateRequest {
    return GetGexAggregateRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetGexAggregateRequest>, I>>(
    object: I
  ): GetGexAggregateRequest {
    const message = createBaseGetGexAggregateRequest()
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    return message
  },
}

function createBaseGexByStrikePoint(): GexByStrikePoint {
  return { strike: undefined, gammaUsd: undefined }
}

export const GexByStrikePoint: MessageFns<GexByStrikePoint> = {
  encode(message: GexByStrikePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strike !== undefined) {
      writer.uint32(10).string(message.strike)
    }
    if (message.gammaUsd !== undefined) {
      writer.uint32(18).string(message.gammaUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexByStrikePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexByStrikePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexByStrikePoint {
    return {
      strike: isSet(object.strike) ? globalThis.String(object.strike) : undefined,
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : undefined,
    }
  },

  toJSON(message: GexByStrikePoint): unknown {
    const obj: any = {}
    if (message.strike !== undefined) {
      obj.strike = message.strike
    }
    if (message.gammaUsd !== undefined) {
      obj.gammaUsd = message.gammaUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexByStrikePoint>, I>>(base?: I): GexByStrikePoint {
    return GexByStrikePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexByStrikePoint>, I>>(object: I): GexByStrikePoint {
    const message = createBaseGexByStrikePoint()
    message.strike = object.strike ?? undefined
    message.gammaUsd = object.gammaUsd ?? undefined
    return message
  },
}

function createBaseGexByExpiryStrikePoint(): GexByExpiryStrikePoint {
  return { expirationTsMs: '0', strike: undefined, gammaUsd: undefined }
}

export const GexByExpiryStrikePoint: MessageFns<GexByExpiryStrikePoint> = {
  encode(message: GexByExpiryStrikePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.strike !== undefined) {
      writer.uint32(18).string(message.strike)
    }
    if (message.gammaUsd !== undefined) {
      writer.uint32(26).string(message.gammaUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexByExpiryStrikePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexByExpiryStrikePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexByExpiryStrikePoint {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      strike: isSet(object.strike) ? globalThis.String(object.strike) : undefined,
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : undefined,
    }
  },

  toJSON(message: GexByExpiryStrikePoint): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.strike !== undefined) {
      obj.strike = message.strike
    }
    if (message.gammaUsd !== undefined) {
      obj.gammaUsd = message.gammaUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexByExpiryStrikePoint>, I>>(
    base?: I
  ): GexByExpiryStrikePoint {
    return GexByExpiryStrikePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexByExpiryStrikePoint>, I>>(
    object: I
  ): GexByExpiryStrikePoint {
    const message = createBaseGexByExpiryStrikePoint()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.strike = object.strike ?? undefined
    message.gammaUsd = object.gammaUsd ?? undefined
    return message
  },
}

function createBaseGexByExpiryTypePoint(): GexByExpiryTypePoint {
  return { expirationTsMs: '0', putCall: '', gammaUsd: undefined }
}

export const GexByExpiryTypePoint: MessageFns<GexByExpiryTypePoint> = {
  encode(message: GexByExpiryTypePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.putCall !== '') {
      writer.uint32(18).string(message.putCall)
    }
    if (message.gammaUsd !== undefined) {
      writer.uint32(26).string(message.gammaUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexByExpiryTypePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexByExpiryTypePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.putCall = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexByExpiryTypePoint {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      putCall: isSet(object.putCall)
        ? globalThis.String(object.putCall)
        : isSet(object.put_call)
          ? globalThis.String(object.put_call)
          : '',
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : undefined,
    }
  },

  toJSON(message: GexByExpiryTypePoint): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.putCall !== '') {
      obj.putCall = message.putCall
    }
    if (message.gammaUsd !== undefined) {
      obj.gammaUsd = message.gammaUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexByExpiryTypePoint>, I>>(base?: I): GexByExpiryTypePoint {
    return GexByExpiryTypePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexByExpiryTypePoint>, I>>(
    object: I
  ): GexByExpiryTypePoint {
    const message = createBaseGexByExpiryTypePoint()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.putCall = object.putCall ?? ''
    message.gammaUsd = object.gammaUsd ?? undefined
    return message
  },
}

function createBaseGexSpotVolPoint(): GexSpotVolPoint {
  return { expirationTsMs: '0', upsideGammaUsd: undefined, downsideGammaUsd: undefined }
}

export const GexSpotVolPoint: MessageFns<GexSpotVolPoint> = {
  encode(message: GexSpotVolPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.upsideGammaUsd !== undefined) {
      writer.uint32(18).string(message.upsideGammaUsd)
    }
    if (message.downsideGammaUsd !== undefined) {
      writer.uint32(26).string(message.downsideGammaUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexSpotVolPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexSpotVolPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.upsideGammaUsd = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.downsideGammaUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexSpotVolPoint {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      upsideGammaUsd: isSet(object.upsideGammaUsd)
        ? globalThis.String(object.upsideGammaUsd)
        : isSet(object.upside_gamma_usd)
          ? globalThis.String(object.upside_gamma_usd)
          : undefined,
      downsideGammaUsd: isSet(object.downsideGammaUsd)
        ? globalThis.String(object.downsideGammaUsd)
        : isSet(object.downside_gamma_usd)
          ? globalThis.String(object.downside_gamma_usd)
          : undefined,
    }
  },

  toJSON(message: GexSpotVolPoint): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.upsideGammaUsd !== undefined) {
      obj.upsideGammaUsd = message.upsideGammaUsd
    }
    if (message.downsideGammaUsd !== undefined) {
      obj.downsideGammaUsd = message.downsideGammaUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexSpotVolPoint>, I>>(base?: I): GexSpotVolPoint {
    return GexSpotVolPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexSpotVolPoint>, I>>(object: I): GexSpotVolPoint {
    const message = createBaseGexSpotVolPoint()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.upsideGammaUsd = object.upsideGammaUsd ?? undefined
    message.downsideGammaUsd = object.downsideGammaUsd ?? undefined
    return message
  },
}

function createBaseGexAggregate(): GexAggregate {
  return {
    exchange: 0,
    currency: '',
    timestampMs: undefined,
    indexPrice: undefined,
    byStrike: [],
    byExpiryStrike: [],
    byExpiryType: [],
    spotVol: [],
  }
}

export const GexAggregate: MessageFns<GexAggregate> = {
  encode(message: GexAggregate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(18).string(message.currency)
    }
    if (message.timestampMs !== undefined) {
      writer.uint32(24).int64(message.timestampMs)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(34).string(message.indexPrice)
    }
    for (const v of message.byStrike) {
      GexByStrikePoint.encode(v!, writer.uint32(42).fork()).join()
    }
    for (const v of message.byExpiryStrike) {
      GexByExpiryStrikePoint.encode(v!, writer.uint32(50).fork()).join()
    }
    for (const v of message.byExpiryType) {
      GexByExpiryTypePoint.encode(v!, writer.uint32(58).fork()).join()
    }
    for (const v of message.spotVol) {
      GexSpotVolPoint.encode(v!, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GexAggregate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGexAggregate()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.byStrike.push(GexByStrikePoint.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.byExpiryStrike.push(GexByExpiryStrikePoint.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.byExpiryType.push(GexByExpiryTypePoint.decode(reader, reader.uint32()))
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.spotVol.push(GexSpotVolPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GexAggregate {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      byStrike: globalThis.Array.isArray(object?.byStrike)
        ? object.byStrike.map((e: any) => GexByStrikePoint.fromJSON(e))
        : globalThis.Array.isArray(object?.by_strike)
          ? object.by_strike.map((e: any) => GexByStrikePoint.fromJSON(e))
          : [],
      byExpiryStrike: globalThis.Array.isArray(object?.byExpiryStrike)
        ? object.byExpiryStrike.map((e: any) => GexByExpiryStrikePoint.fromJSON(e))
        : globalThis.Array.isArray(object?.by_expiry_strike)
          ? object.by_expiry_strike.map((e: any) => GexByExpiryStrikePoint.fromJSON(e))
          : [],
      byExpiryType: globalThis.Array.isArray(object?.byExpiryType)
        ? object.byExpiryType.map((e: any) => GexByExpiryTypePoint.fromJSON(e))
        : globalThis.Array.isArray(object?.by_expiry_type)
          ? object.by_expiry_type.map((e: any) => GexByExpiryTypePoint.fromJSON(e))
          : [],
      spotVol: globalThis.Array.isArray(object?.spotVol)
        ? object.spotVol.map((e: any) => GexSpotVolPoint.fromJSON(e))
        : globalThis.Array.isArray(object?.spot_vol)
          ? object.spot_vol.map((e: any) => GexSpotVolPoint.fromJSON(e))
          : [],
    }
  },

  toJSON(message: GexAggregate): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.timestampMs !== undefined) {
      obj.timestampMs = message.timestampMs
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.byStrike?.length) {
      obj.byStrike = message.byStrike.map((e) => GexByStrikePoint.toJSON(e))
    }
    if (message.byExpiryStrike?.length) {
      obj.byExpiryStrike = message.byExpiryStrike.map((e) => GexByExpiryStrikePoint.toJSON(e))
    }
    if (message.byExpiryType?.length) {
      obj.byExpiryType = message.byExpiryType.map((e) => GexByExpiryTypePoint.toJSON(e))
    }
    if (message.spotVol?.length) {
      obj.spotVol = message.spotVol.map((e) => GexSpotVolPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GexAggregate>, I>>(base?: I): GexAggregate {
    return GexAggregate.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GexAggregate>, I>>(object: I): GexAggregate {
    const message = createBaseGexAggregate()
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.timestampMs = object.timestampMs ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.byStrike = object.byStrike?.map((e) => GexByStrikePoint.fromPartial(e)) || []
    message.byExpiryStrike =
      object.byExpiryStrike?.map((e) => GexByExpiryStrikePoint.fromPartial(e)) || []
    message.byExpiryType =
      object.byExpiryType?.map((e) => GexByExpiryTypePoint.fromPartial(e)) || []
    message.spotVol = object.spotVol?.map((e) => GexSpotVolPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseTermStructureConstantPoint(): TermStructureConstantPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    daysToExpiration: 0,
    atm: undefined,
    fwdAtm: undefined,
  }
}

export const TermStructureConstantPoint: MessageFns<TermStructureConstantPoint> = {
  encode(
    message: TermStructureConstantPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.daysToExpiration !== 0) {
      writer.uint32(32).int32(message.daysToExpiration)
    }
    if (message.atm !== undefined) {
      writer.uint32(42).string(message.atm)
    }
    if (message.fwdAtm !== undefined) {
      writer.uint32(50).string(message.fwdAtm)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureConstantPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureConstantPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.daysToExpiration = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.atm = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.fwdAtm = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureConstantPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.Number(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.Number(object.days_to_expiration)
          : 0,
      atm: isSet(object.atm) ? globalThis.String(object.atm) : undefined,
      fwdAtm: isSet(object.fwdAtm)
        ? globalThis.String(object.fwdAtm)
        : isSet(object.fwd_atm)
          ? globalThis.String(object.fwd_atm)
          : undefined,
    }
  },

  toJSON(message: TermStructureConstantPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.daysToExpiration !== 0) {
      obj.daysToExpiration = Math.round(message.daysToExpiration)
    }
    if (message.atm !== undefined) {
      obj.atm = message.atm
    }
    if (message.fwdAtm !== undefined) {
      obj.fwdAtm = message.fwdAtm
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureConstantPoint>, I>>(
    base?: I
  ): TermStructureConstantPoint {
    return TermStructureConstantPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureConstantPoint>, I>>(
    object: I
  ): TermStructureConstantPoint {
    const message = createBaseTermStructureConstantPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.daysToExpiration = object.daysToExpiration ?? 0
    message.atm = object.atm ?? undefined
    message.fwdAtm = object.fwdAtm ?? undefined
    return message
  },
}

function createBaseTermStructureConstantList(): TermStructureConstantList {
  return { items: [] }
}

export const TermStructureConstantList: MessageFns<TermStructureConstantList> = {
  encode(
    message: TermStructureConstantList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      TermStructureConstantPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureConstantList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureConstantList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(TermStructureConstantPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureConstantList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => TermStructureConstantPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TermStructureConstantList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => TermStructureConstantPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureConstantList>, I>>(
    base?: I
  ): TermStructureConstantList {
    return TermStructureConstantList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureConstantList>, I>>(
    object: I
  ): TermStructureConstantList {
    const message = createBaseTermStructureConstantList()
    message.items = object.items?.map((e) => TermStructureConstantPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseTermStructureFloatingPoint(): TermStructureFloatingPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    expirationTsMs: '0',
    daysToExpiration: '',
    atm: undefined,
    fwdAtm: undefined,
  }
}

export const TermStructureFloatingPoint: MessageFns<TermStructureFloatingPoint> = {
  encode(
    message: TermStructureFloatingPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.expirationTsMs !== '0') {
      writer.uint32(32).int64(message.expirationTsMs)
    }
    if (message.daysToExpiration !== '') {
      writer.uint32(42).string(message.daysToExpiration)
    }
    if (message.atm !== undefined) {
      writer.uint32(50).string(message.atm)
    }
    if (message.fwdAtm !== undefined) {
      writer.uint32(58).string(message.fwdAtm)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureFloatingPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureFloatingPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.daysToExpiration = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.atm = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.fwdAtm = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureFloatingPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      daysToExpiration: isSet(object.daysToExpiration)
        ? globalThis.String(object.daysToExpiration)
        : isSet(object.days_to_expiration)
          ? globalThis.String(object.days_to_expiration)
          : '',
      atm: isSet(object.atm) ? globalThis.String(object.atm) : undefined,
      fwdAtm: isSet(object.fwdAtm)
        ? globalThis.String(object.fwdAtm)
        : isSet(object.fwd_atm)
          ? globalThis.String(object.fwd_atm)
          : undefined,
    }
  },

  toJSON(message: TermStructureFloatingPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.daysToExpiration !== '') {
      obj.daysToExpiration = message.daysToExpiration
    }
    if (message.atm !== undefined) {
      obj.atm = message.atm
    }
    if (message.fwdAtm !== undefined) {
      obj.fwdAtm = message.fwdAtm
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureFloatingPoint>, I>>(
    base?: I
  ): TermStructureFloatingPoint {
    return TermStructureFloatingPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureFloatingPoint>, I>>(
    object: I
  ): TermStructureFloatingPoint {
    const message = createBaseTermStructureFloatingPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.daysToExpiration = object.daysToExpiration ?? ''
    message.atm = object.atm ?? undefined
    message.fwdAtm = object.fwdAtm ?? undefined
    return message
  },
}

function createBaseTermStructureFloatingList(): TermStructureFloatingList {
  return { items: [] }
}

export const TermStructureFloatingList: MessageFns<TermStructureFloatingList> = {
  encode(
    message: TermStructureFloatingList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      TermStructureFloatingPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureFloatingList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureFloatingList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(TermStructureFloatingPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureFloatingList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => TermStructureFloatingPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TermStructureFloatingList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => TermStructureFloatingPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureFloatingList>, I>>(
    base?: I
  ): TermStructureFloatingList {
    return TermStructureFloatingList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureFloatingList>, I>>(
    object: I
  ): TermStructureFloatingList {
    const message = createBaseTermStructureFloatingList()
    message.items = object.items?.map((e) => TermStructureFloatingPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseTermStructureRichnessPoint(): TermStructureRichnessPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    atm7days: undefined,
    atm30days: undefined,
    atm60days: undefined,
    atm90days: undefined,
    atm180days: undefined,
    counter: 0,
    ratio: undefined,
    richness: undefined,
    bookIndexPrice: undefined,
  }
}

export const TermStructureRichnessPoint: MessageFns<TermStructureRichnessPoint> = {
  encode(
    message: TermStructureRichnessPoint,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.atm7days !== undefined) {
      writer.uint32(34).string(message.atm7days)
    }
    if (message.atm30days !== undefined) {
      writer.uint32(42).string(message.atm30days)
    }
    if (message.atm60days !== undefined) {
      writer.uint32(50).string(message.atm60days)
    }
    if (message.atm90days !== undefined) {
      writer.uint32(58).string(message.atm90days)
    }
    if (message.atm180days !== undefined) {
      writer.uint32(66).string(message.atm180days)
    }
    if (message.counter !== 0) {
      writer.uint32(72).int32(message.counter)
    }
    if (message.ratio !== undefined) {
      writer.uint32(82).string(message.ratio)
    }
    if (message.richness !== undefined) {
      writer.uint32(90).string(message.richness)
    }
    if (message.bookIndexPrice !== undefined) {
      writer.uint32(98).string(message.bookIndexPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureRichnessPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureRichnessPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.atm7days = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.atm30days = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.atm60days = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.atm90days = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.atm180days = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.counter = reader.int32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.ratio = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.richness = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.bookIndexPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureRichnessPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      atm7days: isSet(object.atm7days)
        ? globalThis.String(object.atm7days)
        : isSet(object.atm_7days)
          ? globalThis.String(object.atm_7days)
          : undefined,
      atm30days: isSet(object.atm30days)
        ? globalThis.String(object.atm30days)
        : isSet(object.atm_30days)
          ? globalThis.String(object.atm_30days)
          : undefined,
      atm60days: isSet(object.atm60days)
        ? globalThis.String(object.atm60days)
        : isSet(object.atm_60days)
          ? globalThis.String(object.atm_60days)
          : undefined,
      atm90days: isSet(object.atm90days)
        ? globalThis.String(object.atm90days)
        : isSet(object.atm_90days)
          ? globalThis.String(object.atm_90days)
          : undefined,
      atm180days: isSet(object.atm180days)
        ? globalThis.String(object.atm180days)
        : isSet(object.atm_180days)
          ? globalThis.String(object.atm_180days)
          : undefined,
      counter: isSet(object.counter) ? globalThis.Number(object.counter) : 0,
      ratio: isSet(object.ratio) ? globalThis.String(object.ratio) : undefined,
      richness: isSet(object.richness) ? globalThis.String(object.richness) : undefined,
      bookIndexPrice: isSet(object.bookIndexPrice)
        ? globalThis.String(object.bookIndexPrice)
        : isSet(object.book_index_price)
          ? globalThis.String(object.book_index_price)
          : undefined,
    }
  },

  toJSON(message: TermStructureRichnessPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.atm7days !== undefined) {
      obj.atm7days = message.atm7days
    }
    if (message.atm30days !== undefined) {
      obj.atm30days = message.atm30days
    }
    if (message.atm60days !== undefined) {
      obj.atm60days = message.atm60days
    }
    if (message.atm90days !== undefined) {
      obj.atm90days = message.atm90days
    }
    if (message.atm180days !== undefined) {
      obj.atm180days = message.atm180days
    }
    if (message.counter !== 0) {
      obj.counter = Math.round(message.counter)
    }
    if (message.ratio !== undefined) {
      obj.ratio = message.ratio
    }
    if (message.richness !== undefined) {
      obj.richness = message.richness
    }
    if (message.bookIndexPrice !== undefined) {
      obj.bookIndexPrice = message.bookIndexPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureRichnessPoint>, I>>(
    base?: I
  ): TermStructureRichnessPoint {
    return TermStructureRichnessPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureRichnessPoint>, I>>(
    object: I
  ): TermStructureRichnessPoint {
    const message = createBaseTermStructureRichnessPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.atm7days = object.atm7days ?? undefined
    message.atm30days = object.atm30days ?? undefined
    message.atm60days = object.atm60days ?? undefined
    message.atm90days = object.atm90days ?? undefined
    message.atm180days = object.atm180days ?? undefined
    message.counter = object.counter ?? 0
    message.ratio = object.ratio ?? undefined
    message.richness = object.richness ?? undefined
    message.bookIndexPrice = object.bookIndexPrice ?? undefined
    return message
  },
}

function createBaseTermStructureRichnessList(): TermStructureRichnessList {
  return { items: [] }
}

export const TermStructureRichnessList: MessageFns<TermStructureRichnessList> = {
  encode(
    message: TermStructureRichnessList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.items) {
      TermStructureRichnessPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermStructureRichnessList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTermStructureRichnessList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(TermStructureRichnessPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TermStructureRichnessList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => TermStructureRichnessPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TermStructureRichnessList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => TermStructureRichnessPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TermStructureRichnessList>, I>>(
    base?: I
  ): TermStructureRichnessList {
    return TermStructureRichnessList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TermStructureRichnessList>, I>>(
    object: I
  ): TermStructureRichnessList {
    const message = createBaseTermStructureRichnessList()
    message.items = object.items?.map((e) => TermStructureRichnessPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseGetSurfaceCurrenciesRequest(): GetSurfaceCurrenciesRequest {
  return {}
}

export const GetSurfaceCurrenciesRequest: MessageFns<GetSurfaceCurrenciesRequest> = {
  encode(_: GetSurfaceCurrenciesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSurfaceCurrenciesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSurfaceCurrenciesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetSurfaceCurrenciesRequest {
    return {}
  },

  toJSON(_: GetSurfaceCurrenciesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetSurfaceCurrenciesRequest>, I>>(
    base?: I
  ): GetSurfaceCurrenciesRequest {
    return GetSurfaceCurrenciesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSurfaceCurrenciesRequest>, I>>(
    _: I
  ): GetSurfaceCurrenciesRequest {
    const message = createBaseGetSurfaceCurrenciesRequest()
    return message
  },
}

function createBaseListVolFitReferencesRequest(): ListVolFitReferencesRequest {
  return {}
}

export const ListVolFitReferencesRequest: MessageFns<ListVolFitReferencesRequest> = {
  encode(_: ListVolFitReferencesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListVolFitReferencesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListVolFitReferencesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ListVolFitReferencesRequest {
    return {}
  },

  toJSON(_: ListVolFitReferencesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ListVolFitReferencesRequest>, I>>(
    base?: I
  ): ListVolFitReferencesRequest {
    return ListVolFitReferencesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListVolFitReferencesRequest>, I>>(
    _: I
  ): ListVolFitReferencesRequest {
    const message = createBaseListVolFitReferencesRequest()
    return message
  },
}

function createBaseVolFitReference(): VolFitReference {
  return { exchange: 0, chain: '', sourceKind: 0, newestFitTsMs: '0', expirationTsMs: [] }
}

export const VolFitReference: MessageFns<VolFitReference> = {
  encode(message: VolFitReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.chain !== '') {
      writer.uint32(18).string(message.chain)
    }
    if (message.sourceKind !== 0) {
      writer.uint32(24).int32(message.sourceKind)
    }
    if (message.newestFitTsMs !== '0') {
      writer.uint32(32).int64(message.newestFitTsMs)
    }
    writer.uint32(42).fork()
    for (const v of message.expirationTsMs) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolFitReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolFitReference()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.chain = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.sourceKind = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.newestFitTsMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag === 40) {
            message.expirationTsMs.push(reader.int64().toString())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.expirationTsMs.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolFitReference {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      chain: isSet(object.chain) ? globalThis.String(object.chain) : '',
      sourceKind: isSet(object.sourceKind)
        ? sviSourceKindFromJSON(object.sourceKind)
        : isSet(object.source_kind)
          ? sviSourceKindFromJSON(object.source_kind)
          : 0,
      newestFitTsMs: isSet(object.newestFitTsMs)
        ? globalThis.String(object.newestFitTsMs)
        : isSet(object.newest_fit_ts_ms)
          ? globalThis.String(object.newest_fit_ts_ms)
          : '0',
      expirationTsMs: globalThis.Array.isArray(object?.expirationTsMs)
        ? object.expirationTsMs.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.expiration_ts_ms)
          ? object.expiration_ts_ms.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: VolFitReference): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.chain !== '') {
      obj.chain = message.chain
    }
    if (message.sourceKind !== 0) {
      obj.sourceKind = sviSourceKindToJSON(message.sourceKind)
    }
    if (message.newestFitTsMs !== '0') {
      obj.newestFitTsMs = message.newestFitTsMs
    }
    if (message.expirationTsMs?.length) {
      obj.expirationTsMs = message.expirationTsMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolFitReference>, I>>(base?: I): VolFitReference {
    return VolFitReference.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolFitReference>, I>>(object: I): VolFitReference {
    const message = createBaseVolFitReference()
    message.exchange = object.exchange ?? 0
    message.chain = object.chain ?? ''
    message.sourceKind = object.sourceKind ?? 0
    message.newestFitTsMs = object.newestFitTsMs ?? '0'
    message.expirationTsMs = object.expirationTsMs?.map((e) => e) || []
    return message
  },
}

function createBaseVolFitReferenceList(): VolFitReferenceList {
  return { items: [] }
}

export const VolFitReferenceList: MessageFns<VolFitReferenceList> = {
  encode(message: VolFitReferenceList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      VolFitReference.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolFitReferenceList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolFitReferenceList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(VolFitReference.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolFitReferenceList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => VolFitReference.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VolFitReferenceList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => VolFitReference.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolFitReferenceList>, I>>(base?: I): VolFitReferenceList {
    return VolFitReferenceList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolFitReferenceList>, I>>(
    object: I
  ): VolFitReferenceList {
    const message = createBaseVolFitReferenceList()
    message.items = object.items?.map((e) => VolFitReference.fromPartial(e)) || []
    return message
  },
}

function createBaseSurfaceCurrency(): SurfaceCurrency {
  return { exchange: 0, currency: '' }
}

export const SurfaceCurrency: MessageFns<SurfaceCurrency> = {
  encode(message: SurfaceCurrency, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(18).string(message.currency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SurfaceCurrency {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSurfaceCurrency()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SurfaceCurrency {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
    }
  },

  toJSON(message: SurfaceCurrency): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SurfaceCurrency>, I>>(base?: I): SurfaceCurrency {
    return SurfaceCurrency.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SurfaceCurrency>, I>>(object: I): SurfaceCurrency {
    const message = createBaseSurfaceCurrency()
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    return message
  },
}

function createBaseSurfaceCurrencyList(): SurfaceCurrencyList {
  return { items: [] }
}

export const SurfaceCurrencyList: MessageFns<SurfaceCurrencyList> = {
  encode(message: SurfaceCurrencyList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      SurfaceCurrency.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SurfaceCurrencyList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSurfaceCurrencyList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(SurfaceCurrency.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SurfaceCurrencyList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => SurfaceCurrency.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SurfaceCurrencyList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => SurfaceCurrency.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SurfaceCurrencyList>, I>>(base?: I): SurfaceCurrencyList {
    return SurfaceCurrencyList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SurfaceCurrencyList>, I>>(
    object: I
  ): SurfaceCurrencyList {
    const message = createBaseSurfaceCurrencyList()
    message.items = object.items?.map((e) => SurfaceCurrency.fromPartial(e)) || []
    return message
  },
}

function createBaseVolatilityIndexPoint(): VolatilityIndexPoint {
  return {
    timestampMs: '0',
    exchange: 0,
    currency: '',
    timeframeSeconds: 0,
    open: undefined,
    high: undefined,
    low: undefined,
    close: undefined,
  }
}

export const VolatilityIndexPoint: MessageFns<VolatilityIndexPoint> = {
  encode(message: VolatilityIndexPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== '0') {
      writer.uint32(8).int64(message.timestampMs)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.timeframeSeconds !== 0) {
      writer.uint32(32).int32(message.timeframeSeconds)
    }
    if (message.open !== undefined) {
      writer.uint32(42).string(message.open)
    }
    if (message.high !== undefined) {
      writer.uint32(50).string(message.high)
    }
    if (message.low !== undefined) {
      writer.uint32(58).string(message.low)
    }
    if (message.close !== undefined) {
      writer.uint32(66).string(message.close)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolatilityIndexPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolatilityIndexPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestampMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.timeframeSeconds = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.open = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.high = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.low = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.close = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolatilityIndexPoint {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.String(object.timestampMs)
        : isSet(object.timestamp_ms)
          ? globalThis.String(object.timestamp_ms)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      timeframeSeconds: isSet(object.timeframeSeconds)
        ? globalThis.Number(object.timeframeSeconds)
        : isSet(object.timeframe_seconds)
          ? globalThis.Number(object.timeframe_seconds)
          : 0,
      open: isSet(object.open) ? globalThis.String(object.open) : undefined,
      high: isSet(object.high) ? globalThis.String(object.high) : undefined,
      low: isSet(object.low) ? globalThis.String(object.low) : undefined,
      close: isSet(object.close) ? globalThis.String(object.close) : undefined,
    }
  },

  toJSON(message: VolatilityIndexPoint): unknown {
    const obj: any = {}
    if (message.timestampMs !== '0') {
      obj.timestampMs = message.timestampMs
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.timeframeSeconds !== 0) {
      obj.timeframeSeconds = Math.round(message.timeframeSeconds)
    }
    if (message.open !== undefined) {
      obj.open = message.open
    }
    if (message.high !== undefined) {
      obj.high = message.high
    }
    if (message.low !== undefined) {
      obj.low = message.low
    }
    if (message.close !== undefined) {
      obj.close = message.close
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolatilityIndexPoint>, I>>(base?: I): VolatilityIndexPoint {
    return VolatilityIndexPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolatilityIndexPoint>, I>>(
    object: I
  ): VolatilityIndexPoint {
    const message = createBaseVolatilityIndexPoint()
    message.timestampMs = object.timestampMs ?? '0'
    message.exchange = object.exchange ?? 0
    message.currency = object.currency ?? ''
    message.timeframeSeconds = object.timeframeSeconds ?? 0
    message.open = object.open ?? undefined
    message.high = object.high ?? undefined
    message.low = object.low ?? undefined
    message.close = object.close ?? undefined
    return message
  },
}

function createBaseVolatilityIndexList(): VolatilityIndexList {
  return { items: [] }
}

export const VolatilityIndexList: MessageFns<VolatilityIndexList> = {
  encode(message: VolatilityIndexList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      VolatilityIndexPoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolatilityIndexList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolatilityIndexList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(VolatilityIndexPoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolatilityIndexList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => VolatilityIndexPoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: VolatilityIndexList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => VolatilityIndexPoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolatilityIndexList>, I>>(base?: I): VolatilityIndexList {
    return VolatilityIndexList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolatilityIndexList>, I>>(
    object: I
  ): VolatilityIndexList {
    const message = createBaseVolatilityIndexList()
    message.items = object.items?.map((e) => VolatilityIndexPoint.fromPartial(e)) || []
    return message
  },
}

function createBaseDataPayloadList(): DataPayloadList {
  return { items: [] }
}

export const DataPayloadList: MessageFns<DataPayloadList> = {
  encode(message: DataPayloadList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      DataPayload.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataPayloadList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDataPayloadList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(DataPayload.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DataPayloadList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => DataPayload.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DataPayloadList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => DataPayload.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DataPayloadList>, I>>(base?: I): DataPayloadList {
    return DataPayloadList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DataPayloadList>, I>>(object: I): DataPayloadList {
    const message = createBaseDataPayloadList()
    message.items = object.items?.map((e) => DataPayload.fromPartial(e)) || []
    return message
  },
}

function createBaseUnifiedOrderList(): UnifiedOrderList {
  return { items: [] }
}

export const UnifiedOrderList: MessageFns<UnifiedOrderList> = {
  encode(message: UnifiedOrderList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      UnifiedOrderItem.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnifiedOrderList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUnifiedOrderList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.items.push(UnifiedOrderItem.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UnifiedOrderList {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => UnifiedOrderItem.fromJSON(e))
        : [],
    }
  },

  toJSON(message: UnifiedOrderList): unknown {
    const obj: any = {}
    if (message.items?.length) {
      obj.items = message.items.map((e) => UnifiedOrderItem.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UnifiedOrderList>, I>>(base?: I): UnifiedOrderList {
    return UnifiedOrderList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedOrderList>, I>>(object: I): UnifiedOrderList {
    const message = createBaseUnifiedOrderList()
    message.items = object.items?.map((e) => UnifiedOrderItem.fromPartial(e)) || []
    return message
  },
}

function createBaseUnifiedOrderItem(): UnifiedOrderItem {
  return { order: undefined, algoState: undefined }
}

export const UnifiedOrderItem: MessageFns<UnifiedOrderItem> = {
  encode(message: UnifiedOrderItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.order !== undefined) {
      Order.encode(message.order, writer.uint32(10).fork()).join()
    }
    if (message.algoState !== undefined) {
      AlgoState.encode(message.algoState, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnifiedOrderItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUnifiedOrderItem()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.order = Order.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoState = AlgoState.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UnifiedOrderItem {
    return {
      order: isSet(object.order) ? Order.fromJSON(object.order) : undefined,
      algoState: isSet(object.algoState)
        ? AlgoState.fromJSON(object.algoState)
        : isSet(object.algo_state)
          ? AlgoState.fromJSON(object.algo_state)
          : undefined,
    }
  },

  toJSON(message: UnifiedOrderItem): unknown {
    const obj: any = {}
    if (message.order !== undefined) {
      obj.order = Order.toJSON(message.order)
    }
    if (message.algoState !== undefined) {
      obj.algoState = AlgoState.toJSON(message.algoState)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UnifiedOrderItem>, I>>(base?: I): UnifiedOrderItem {
    return UnifiedOrderItem.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedOrderItem>, I>>(object: I): UnifiedOrderItem {
    const message = createBaseUnifiedOrderItem()
    message.order =
      object.order !== undefined && object.order !== null
        ? Order.fromPartial(object.order)
        : undefined
    message.algoState =
      object.algoState !== undefined && object.algoState !== null
        ? AlgoState.fromPartial(object.algoState)
        : undefined
    return message
  },
}

function createBaseCandleList(): CandleList {
  return {
    ticks: [],
    open: [],
    high: [],
    low: [],
    close: [],
    volumeBase: [],
    volumeQuote: [],
    vwap: [],
    twap: [],
    buyVolumeBase: [],
    sellVolumeBase: [],
    netBuyVolumeBase: [],
    totalTradeCount: [],
    buyTradeCount: [],
    sellTradeCount: [],
    netBuyTradeCount: [],
    avgTradeSize: [],
    totalLiqBase: [],
    totalLiqQuote: [],
    liqwap: [],
    totalLiqCount: [],
    buyLiqBase: [],
    sellLiqBase: [],
    liqTakerVolume: [],
    liqMakerVolume: [],
    realizedVolatility: [],
    avgBuyTradeSize: [],
    avgSellTradeSize: [],
    deltaPercentage: [],
    netBuyVolumeQuote: [],
    vwapTwapSpread: [],
    netLiquidations: [],
    volumeBaseBlockIncl: [],
    volumeQuoteBlockIncl: [],
    buyVolumeBaseBlockIncl: [],
    sellVolumeBaseBlockIncl: [],
    netBuyVolumeBaseBlockIncl: [],
    netBuyVolumeQuoteBlockIncl: [],
    openInterestBaseOpen: [],
    openInterestBaseHigh: [],
    openInterestBaseLow: [],
    openInterestBaseClose: [],
    openInterestQuoteOpen: [],
    openInterestQuoteHigh: [],
    openInterestQuoteLow: [],
    openInterestQuoteClose: [],
    fundingRateOpen: [],
    fundingRateHigh: [],
    fundingRateLow: [],
    fundingRateClose: [],
    fundingAprOpen: [],
    fundingAprHigh: [],
    fundingAprLow: [],
    fundingAprClose: [],
  }
}

export const CandleList: MessageFns<CandleList> = {
  encode(message: CandleList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.ticks) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(18).fork()
    for (const v of message.open) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(26).fork()
    for (const v of message.high) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(34).fork()
    for (const v of message.low) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.close) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(50).fork()
    for (const v of message.volumeBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(58).fork()
    for (const v of message.volumeQuote) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.vwap) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.twap) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.buyVolumeBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(90).fork()
    for (const v of message.sellVolumeBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(98).fork()
    for (const v of message.netBuyVolumeBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(106).fork()
    for (const v of message.totalTradeCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(114).fork()
    for (const v of message.buyTradeCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(122).fork()
    for (const v of message.sellTradeCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(130).fork()
    for (const v of message.netBuyTradeCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(138).fork()
    for (const v of message.avgTradeSize) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(146).fork()
    for (const v of message.totalLiqBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(154).fork()
    for (const v of message.totalLiqQuote) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(162).fork()
    for (const v of message.liqwap) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(170).fork()
    for (const v of message.totalLiqCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(178).fork()
    for (const v of message.buyLiqBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(186).fork()
    for (const v of message.sellLiqBase) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(194).fork()
    for (const v of message.liqTakerVolume) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(202).fork()
    for (const v of message.liqMakerVolume) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(210).fork()
    for (const v of message.realizedVolatility) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(218).fork()
    for (const v of message.avgBuyTradeSize) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(226).fork()
    for (const v of message.avgSellTradeSize) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(234).fork()
    for (const v of message.deltaPercentage) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(242).fork()
    for (const v of message.netBuyVolumeQuote) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(250).fork()
    for (const v of message.vwapTwapSpread) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(258).fork()
    for (const v of message.netLiquidations) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(266).fork()
    for (const v of message.volumeBaseBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(274).fork()
    for (const v of message.volumeQuoteBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(282).fork()
    for (const v of message.buyVolumeBaseBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(290).fork()
    for (const v of message.sellVolumeBaseBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(298).fork()
    for (const v of message.netBuyVolumeBaseBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(306).fork()
    for (const v of message.netBuyVolumeQuoteBlockIncl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(346).fork()
    for (const v of message.openInterestBaseOpen) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(354).fork()
    for (const v of message.openInterestBaseHigh) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(362).fork()
    for (const v of message.openInterestBaseLow) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(370).fork()
    for (const v of message.openInterestBaseClose) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(378).fork()
    for (const v of message.openInterestQuoteOpen) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(386).fork()
    for (const v of message.openInterestQuoteHigh) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(394).fork()
    for (const v of message.openInterestQuoteLow) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(402).fork()
    for (const v of message.openInterestQuoteClose) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(410).fork()
    for (const v of message.fundingRateOpen) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(418).fork()
    for (const v of message.fundingRateHigh) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(426).fork()
    for (const v of message.fundingRateLow) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(434).fork()
    for (const v of message.fundingRateClose) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(442).fork()
    for (const v of message.fundingAprOpen) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(450).fork()
    for (const v of message.fundingAprHigh) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(458).fork()
    for (const v of message.fundingAprLow) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(466).fork()
    for (const v of message.fundingAprClose) {
      writer.float(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CandleList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCandleList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.ticks.push(reader.int64().toString())

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.ticks.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 2: {
          if (tag === 21) {
            message.open.push(reader.float())

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.open.push(reader.float())
            }

            continue
          }

          break
        }
        case 3: {
          if (tag === 29) {
            message.high.push(reader.float())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.high.push(reader.float())
            }

            continue
          }

          break
        }
        case 4: {
          if (tag === 37) {
            message.low.push(reader.float())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.low.push(reader.float())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 45) {
            message.close.push(reader.float())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.close.push(reader.float())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag === 53) {
            message.volumeBase.push(reader.float())

            continue
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.volumeBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 7: {
          if (tag === 61) {
            message.volumeQuote.push(reader.float())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.volumeQuote.push(reader.float())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 69) {
            message.vwap.push(reader.float())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.vwap.push(reader.float())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 77) {
            message.twap.push(reader.float())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.twap.push(reader.float())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 85) {
            message.buyVolumeBase.push(reader.float())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyVolumeBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 11: {
          if (tag === 93) {
            message.sellVolumeBase.push(reader.float())

            continue
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellVolumeBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 12: {
          if (tag === 101) {
            message.netBuyVolumeBase.push(reader.float())

            continue
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netBuyVolumeBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 13: {
          if (tag === 104) {
            message.totalTradeCount.push(reader.int64().toString())

            continue
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.totalTradeCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 14: {
          if (tag === 112) {
            message.buyTradeCount.push(reader.int64().toString())

            continue
          }

          if (tag === 114) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyTradeCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 15: {
          if (tag === 120) {
            message.sellTradeCount.push(reader.int64().toString())

            continue
          }

          if (tag === 122) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellTradeCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 16: {
          if (tag === 128) {
            message.netBuyTradeCount.push(reader.int64().toString())

            continue
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netBuyTradeCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 17: {
          if (tag === 141) {
            message.avgTradeSize.push(reader.float())

            continue
          }

          if (tag === 138) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.avgTradeSize.push(reader.float())
            }

            continue
          }

          break
        }
        case 18: {
          if (tag === 149) {
            message.totalLiqBase.push(reader.float())

            continue
          }

          if (tag === 146) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.totalLiqBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 19: {
          if (tag === 157) {
            message.totalLiqQuote.push(reader.float())

            continue
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.totalLiqQuote.push(reader.float())
            }

            continue
          }

          break
        }
        case 20: {
          if (tag === 165) {
            message.liqwap.push(reader.float())

            continue
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.liqwap.push(reader.float())
            }

            continue
          }

          break
        }
        case 21: {
          if (tag === 168) {
            message.totalLiqCount.push(reader.int64().toString())

            continue
          }

          if (tag === 170) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.totalLiqCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 22: {
          if (tag === 181) {
            message.buyLiqBase.push(reader.float())

            continue
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyLiqBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 23: {
          if (tag === 189) {
            message.sellLiqBase.push(reader.float())

            continue
          }

          if (tag === 186) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellLiqBase.push(reader.float())
            }

            continue
          }

          break
        }
        case 24: {
          if (tag === 197) {
            message.liqTakerVolume.push(reader.float())

            continue
          }

          if (tag === 194) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.liqTakerVolume.push(reader.float())
            }

            continue
          }

          break
        }
        case 25: {
          if (tag === 205) {
            message.liqMakerVolume.push(reader.float())

            continue
          }

          if (tag === 202) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.liqMakerVolume.push(reader.float())
            }

            continue
          }

          break
        }
        case 26: {
          if (tag === 213) {
            message.realizedVolatility.push(reader.float())

            continue
          }

          if (tag === 210) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.realizedVolatility.push(reader.float())
            }

            continue
          }

          break
        }
        case 27: {
          if (tag === 221) {
            message.avgBuyTradeSize.push(reader.float())

            continue
          }

          if (tag === 218) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.avgBuyTradeSize.push(reader.float())
            }

            continue
          }

          break
        }
        case 28: {
          if (tag === 229) {
            message.avgSellTradeSize.push(reader.float())

            continue
          }

          if (tag === 226) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.avgSellTradeSize.push(reader.float())
            }

            continue
          }

          break
        }
        case 29: {
          if (tag === 237) {
            message.deltaPercentage.push(reader.float())

            continue
          }

          if (tag === 234) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.deltaPercentage.push(reader.float())
            }

            continue
          }

          break
        }
        case 30: {
          if (tag === 245) {
            message.netBuyVolumeQuote.push(reader.float())

            continue
          }

          if (tag === 242) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netBuyVolumeQuote.push(reader.float())
            }

            continue
          }

          break
        }
        case 31: {
          if (tag === 253) {
            message.vwapTwapSpread.push(reader.float())

            continue
          }

          if (tag === 250) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.vwapTwapSpread.push(reader.float())
            }

            continue
          }

          break
        }
        case 32: {
          if (tag === 261) {
            message.netLiquidations.push(reader.float())

            continue
          }

          if (tag === 258) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netLiquidations.push(reader.float())
            }

            continue
          }

          break
        }
        case 33: {
          if (tag === 269) {
            message.volumeBaseBlockIncl.push(reader.float())

            continue
          }

          if (tag === 266) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.volumeBaseBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 34: {
          if (tag === 277) {
            message.volumeQuoteBlockIncl.push(reader.float())

            continue
          }

          if (tag === 274) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.volumeQuoteBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 35: {
          if (tag === 285) {
            message.buyVolumeBaseBlockIncl.push(reader.float())

            continue
          }

          if (tag === 282) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyVolumeBaseBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 36: {
          if (tag === 293) {
            message.sellVolumeBaseBlockIncl.push(reader.float())

            continue
          }

          if (tag === 290) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellVolumeBaseBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 37: {
          if (tag === 301) {
            message.netBuyVolumeBaseBlockIncl.push(reader.float())

            continue
          }

          if (tag === 298) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netBuyVolumeBaseBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 38: {
          if (tag === 309) {
            message.netBuyVolumeQuoteBlockIncl.push(reader.float())

            continue
          }

          if (tag === 306) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.netBuyVolumeQuoteBlockIncl.push(reader.float())
            }

            continue
          }

          break
        }
        case 43: {
          if (tag === 345) {
            message.openInterestBaseOpen.push(reader.double())

            continue
          }

          if (tag === 346) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestBaseOpen.push(reader.double())
            }

            continue
          }

          break
        }
        case 44: {
          if (tag === 353) {
            message.openInterestBaseHigh.push(reader.double())

            continue
          }

          if (tag === 354) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestBaseHigh.push(reader.double())
            }

            continue
          }

          break
        }
        case 45: {
          if (tag === 361) {
            message.openInterestBaseLow.push(reader.double())

            continue
          }

          if (tag === 362) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestBaseLow.push(reader.double())
            }

            continue
          }

          break
        }
        case 46: {
          if (tag === 369) {
            message.openInterestBaseClose.push(reader.double())

            continue
          }

          if (tag === 370) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestBaseClose.push(reader.double())
            }

            continue
          }

          break
        }
        case 47: {
          if (tag === 377) {
            message.openInterestQuoteOpen.push(reader.double())

            continue
          }

          if (tag === 378) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestQuoteOpen.push(reader.double())
            }

            continue
          }

          break
        }
        case 48: {
          if (tag === 385) {
            message.openInterestQuoteHigh.push(reader.double())

            continue
          }

          if (tag === 386) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestQuoteHigh.push(reader.double())
            }

            continue
          }

          break
        }
        case 49: {
          if (tag === 393) {
            message.openInterestQuoteLow.push(reader.double())

            continue
          }

          if (tag === 394) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestQuoteLow.push(reader.double())
            }

            continue
          }

          break
        }
        case 50: {
          if (tag === 401) {
            message.openInterestQuoteClose.push(reader.double())

            continue
          }

          if (tag === 402) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestQuoteClose.push(reader.double())
            }

            continue
          }

          break
        }
        case 51: {
          if (tag === 413) {
            message.fundingRateOpen.push(reader.float())

            continue
          }

          if (tag === 410) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingRateOpen.push(reader.float())
            }

            continue
          }

          break
        }
        case 52: {
          if (tag === 421) {
            message.fundingRateHigh.push(reader.float())

            continue
          }

          if (tag === 418) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingRateHigh.push(reader.float())
            }

            continue
          }

          break
        }
        case 53: {
          if (tag === 429) {
            message.fundingRateLow.push(reader.float())

            continue
          }

          if (tag === 426) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingRateLow.push(reader.float())
            }

            continue
          }

          break
        }
        case 54: {
          if (tag === 437) {
            message.fundingRateClose.push(reader.float())

            continue
          }

          if (tag === 434) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingRateClose.push(reader.float())
            }

            continue
          }

          break
        }
        case 55: {
          if (tag === 445) {
            message.fundingAprOpen.push(reader.float())

            continue
          }

          if (tag === 442) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingAprOpen.push(reader.float())
            }

            continue
          }

          break
        }
        case 56: {
          if (tag === 453) {
            message.fundingAprHigh.push(reader.float())

            continue
          }

          if (tag === 450) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingAprHigh.push(reader.float())
            }

            continue
          }

          break
        }
        case 57: {
          if (tag === 461) {
            message.fundingAprLow.push(reader.float())

            continue
          }

          if (tag === 458) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingAprLow.push(reader.float())
            }

            continue
          }

          break
        }
        case 58: {
          if (tag === 469) {
            message.fundingAprClose.push(reader.float())

            continue
          }

          if (tag === 466) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.fundingAprClose.push(reader.float())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CandleList {
    return {
      ticks: globalThis.Array.isArray(object?.ticks)
        ? object.ticks.map((e: any) => globalThis.String(e))
        : [],
      open: globalThis.Array.isArray(object?.open)
        ? object.open.map((e: any) => globalThis.Number(e))
        : [],
      high: globalThis.Array.isArray(object?.high)
        ? object.high.map((e: any) => globalThis.Number(e))
        : [],
      low: globalThis.Array.isArray(object?.low)
        ? object.low.map((e: any) => globalThis.Number(e))
        : [],
      close: globalThis.Array.isArray(object?.close)
        ? object.close.map((e: any) => globalThis.Number(e))
        : [],
      volumeBase: globalThis.Array.isArray(object?.volumeBase)
        ? object.volumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.volume_base)
          ? object.volume_base.map((e: any) => globalThis.Number(e))
          : [],
      volumeQuote: globalThis.Array.isArray(object?.volumeQuote)
        ? object.volumeQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.volume_quote)
          ? object.volume_quote.map((e: any) => globalThis.Number(e))
          : [],
      vwap: globalThis.Array.isArray(object?.vwap)
        ? object.vwap.map((e: any) => globalThis.Number(e))
        : [],
      twap: globalThis.Array.isArray(object?.twap)
        ? object.twap.map((e: any) => globalThis.Number(e))
        : [],
      buyVolumeBase: globalThis.Array.isArray(object?.buyVolumeBase)
        ? object.buyVolumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_volume_base)
          ? object.buy_volume_base.map((e: any) => globalThis.Number(e))
          : [],
      sellVolumeBase: globalThis.Array.isArray(object?.sellVolumeBase)
        ? object.sellVolumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_volume_base)
          ? object.sell_volume_base.map((e: any) => globalThis.Number(e))
          : [],
      netBuyVolumeBase: globalThis.Array.isArray(object?.netBuyVolumeBase)
        ? object.netBuyVolumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.net_buy_volume_base)
          ? object.net_buy_volume_base.map((e: any) => globalThis.Number(e))
          : [],
      totalTradeCount: globalThis.Array.isArray(object?.totalTradeCount)
        ? object.totalTradeCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.total_trade_count)
          ? object.total_trade_count.map((e: any) => globalThis.String(e))
          : [],
      buyTradeCount: globalThis.Array.isArray(object?.buyTradeCount)
        ? object.buyTradeCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.buy_trade_count)
          ? object.buy_trade_count.map((e: any) => globalThis.String(e))
          : [],
      sellTradeCount: globalThis.Array.isArray(object?.sellTradeCount)
        ? object.sellTradeCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.sell_trade_count)
          ? object.sell_trade_count.map((e: any) => globalThis.String(e))
          : [],
      netBuyTradeCount: globalThis.Array.isArray(object?.netBuyTradeCount)
        ? object.netBuyTradeCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.net_buy_trade_count)
          ? object.net_buy_trade_count.map((e: any) => globalThis.String(e))
          : [],
      avgTradeSize: globalThis.Array.isArray(object?.avgTradeSize)
        ? object.avgTradeSize.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.avg_trade_size)
          ? object.avg_trade_size.map((e: any) => globalThis.Number(e))
          : [],
      totalLiqBase: globalThis.Array.isArray(object?.totalLiqBase)
        ? object.totalLiqBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.total_liq_base)
          ? object.total_liq_base.map((e: any) => globalThis.Number(e))
          : [],
      totalLiqQuote: globalThis.Array.isArray(object?.totalLiqQuote)
        ? object.totalLiqQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.total_liq_quote)
          ? object.total_liq_quote.map((e: any) => globalThis.Number(e))
          : [],
      liqwap: globalThis.Array.isArray(object?.liqwap)
        ? object.liqwap.map((e: any) => globalThis.Number(e))
        : [],
      totalLiqCount: globalThis.Array.isArray(object?.totalLiqCount)
        ? object.totalLiqCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.total_liq_count)
          ? object.total_liq_count.map((e: any) => globalThis.String(e))
          : [],
      buyLiqBase: globalThis.Array.isArray(object?.buyLiqBase)
        ? object.buyLiqBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_liq_base)
          ? object.buy_liq_base.map((e: any) => globalThis.Number(e))
          : [],
      sellLiqBase: globalThis.Array.isArray(object?.sellLiqBase)
        ? object.sellLiqBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_liq_base)
          ? object.sell_liq_base.map((e: any) => globalThis.Number(e))
          : [],
      liqTakerVolume: globalThis.Array.isArray(object?.liqTakerVolume)
        ? object.liqTakerVolume.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.liq_taker_volume)
          ? object.liq_taker_volume.map((e: any) => globalThis.Number(e))
          : [],
      liqMakerVolume: globalThis.Array.isArray(object?.liqMakerVolume)
        ? object.liqMakerVolume.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.liq_maker_volume)
          ? object.liq_maker_volume.map((e: any) => globalThis.Number(e))
          : [],
      realizedVolatility: globalThis.Array.isArray(object?.realizedVolatility)
        ? object.realizedVolatility.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.realized_volatility)
          ? object.realized_volatility.map((e: any) => globalThis.Number(e))
          : [],
      avgBuyTradeSize: globalThis.Array.isArray(object?.avgBuyTradeSize)
        ? object.avgBuyTradeSize.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.avg_buy_trade_size)
          ? object.avg_buy_trade_size.map((e: any) => globalThis.Number(e))
          : [],
      avgSellTradeSize: globalThis.Array.isArray(object?.avgSellTradeSize)
        ? object.avgSellTradeSize.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.avg_sell_trade_size)
          ? object.avg_sell_trade_size.map((e: any) => globalThis.Number(e))
          : [],
      deltaPercentage: globalThis.Array.isArray(object?.deltaPercentage)
        ? object.deltaPercentage.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.delta_percentage)
          ? object.delta_percentage.map((e: any) => globalThis.Number(e))
          : [],
      netBuyVolumeQuote: globalThis.Array.isArray(object?.netBuyVolumeQuote)
        ? object.netBuyVolumeQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.net_buy_volume_quote)
          ? object.net_buy_volume_quote.map((e: any) => globalThis.Number(e))
          : [],
      vwapTwapSpread: globalThis.Array.isArray(object?.vwapTwapSpread)
        ? object.vwapTwapSpread.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.vwap_twap_spread)
          ? object.vwap_twap_spread.map((e: any) => globalThis.Number(e))
          : [],
      netLiquidations: globalThis.Array.isArray(object?.netLiquidations)
        ? object.netLiquidations.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.net_liquidations)
          ? object.net_liquidations.map((e: any) => globalThis.Number(e))
          : [],
      volumeBaseBlockIncl: globalThis.Array.isArray(object?.volumeBaseBlockIncl)
        ? object.volumeBaseBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.volume_base_block_incl)
          ? object.volume_base_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      volumeQuoteBlockIncl: globalThis.Array.isArray(object?.volumeQuoteBlockIncl)
        ? object.volumeQuoteBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.volume_quote_block_incl)
          ? object.volume_quote_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      buyVolumeBaseBlockIncl: globalThis.Array.isArray(object?.buyVolumeBaseBlockIncl)
        ? object.buyVolumeBaseBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_volume_base_block_incl)
          ? object.buy_volume_base_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      sellVolumeBaseBlockIncl: globalThis.Array.isArray(object?.sellVolumeBaseBlockIncl)
        ? object.sellVolumeBaseBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_volume_base_block_incl)
          ? object.sell_volume_base_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      netBuyVolumeBaseBlockIncl: globalThis.Array.isArray(object?.netBuyVolumeBaseBlockIncl)
        ? object.netBuyVolumeBaseBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.net_buy_volume_base_block_incl)
          ? object.net_buy_volume_base_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      netBuyVolumeQuoteBlockIncl: globalThis.Array.isArray(object?.netBuyVolumeQuoteBlockIncl)
        ? object.netBuyVolumeQuoteBlockIncl.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.net_buy_volume_quote_block_incl)
          ? object.net_buy_volume_quote_block_incl.map((e: any) => globalThis.Number(e))
          : [],
      openInterestBaseOpen: globalThis.Array.isArray(object?.openInterestBaseOpen)
        ? object.openInterestBaseOpen.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_base_open)
          ? object.open_interest_base_open.map((e: any) => globalThis.Number(e))
          : [],
      openInterestBaseHigh: globalThis.Array.isArray(object?.openInterestBaseHigh)
        ? object.openInterestBaseHigh.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_base_high)
          ? object.open_interest_base_high.map((e: any) => globalThis.Number(e))
          : [],
      openInterestBaseLow: globalThis.Array.isArray(object?.openInterestBaseLow)
        ? object.openInterestBaseLow.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_base_low)
          ? object.open_interest_base_low.map((e: any) => globalThis.Number(e))
          : [],
      openInterestBaseClose: globalThis.Array.isArray(object?.openInterestBaseClose)
        ? object.openInterestBaseClose.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_base_close)
          ? object.open_interest_base_close.map((e: any) => globalThis.Number(e))
          : [],
      openInterestQuoteOpen: globalThis.Array.isArray(object?.openInterestQuoteOpen)
        ? object.openInterestQuoteOpen.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_quote_open)
          ? object.open_interest_quote_open.map((e: any) => globalThis.Number(e))
          : [],
      openInterestQuoteHigh: globalThis.Array.isArray(object?.openInterestQuoteHigh)
        ? object.openInterestQuoteHigh.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_quote_high)
          ? object.open_interest_quote_high.map((e: any) => globalThis.Number(e))
          : [],
      openInterestQuoteLow: globalThis.Array.isArray(object?.openInterestQuoteLow)
        ? object.openInterestQuoteLow.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_quote_low)
          ? object.open_interest_quote_low.map((e: any) => globalThis.Number(e))
          : [],
      openInterestQuoteClose: globalThis.Array.isArray(object?.openInterestQuoteClose)
        ? object.openInterestQuoteClose.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_quote_close)
          ? object.open_interest_quote_close.map((e: any) => globalThis.Number(e))
          : [],
      fundingRateOpen: globalThis.Array.isArray(object?.fundingRateOpen)
        ? object.fundingRateOpen.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_rate_open)
          ? object.funding_rate_open.map((e: any) => globalThis.Number(e))
          : [],
      fundingRateHigh: globalThis.Array.isArray(object?.fundingRateHigh)
        ? object.fundingRateHigh.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_rate_high)
          ? object.funding_rate_high.map((e: any) => globalThis.Number(e))
          : [],
      fundingRateLow: globalThis.Array.isArray(object?.fundingRateLow)
        ? object.fundingRateLow.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_rate_low)
          ? object.funding_rate_low.map((e: any) => globalThis.Number(e))
          : [],
      fundingRateClose: globalThis.Array.isArray(object?.fundingRateClose)
        ? object.fundingRateClose.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_rate_close)
          ? object.funding_rate_close.map((e: any) => globalThis.Number(e))
          : [],
      fundingAprOpen: globalThis.Array.isArray(object?.fundingAprOpen)
        ? object.fundingAprOpen.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_apr_open)
          ? object.funding_apr_open.map((e: any) => globalThis.Number(e))
          : [],
      fundingAprHigh: globalThis.Array.isArray(object?.fundingAprHigh)
        ? object.fundingAprHigh.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_apr_high)
          ? object.funding_apr_high.map((e: any) => globalThis.Number(e))
          : [],
      fundingAprLow: globalThis.Array.isArray(object?.fundingAprLow)
        ? object.fundingAprLow.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_apr_low)
          ? object.funding_apr_low.map((e: any) => globalThis.Number(e))
          : [],
      fundingAprClose: globalThis.Array.isArray(object?.fundingAprClose)
        ? object.fundingAprClose.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.funding_apr_close)
          ? object.funding_apr_close.map((e: any) => globalThis.Number(e))
          : [],
    }
  },

  toJSON(message: CandleList): unknown {
    const obj: any = {}
    if (message.ticks?.length) {
      obj.ticks = message.ticks
    }
    if (message.open?.length) {
      obj.open = message.open
    }
    if (message.high?.length) {
      obj.high = message.high
    }
    if (message.low?.length) {
      obj.low = message.low
    }
    if (message.close?.length) {
      obj.close = message.close
    }
    if (message.volumeBase?.length) {
      obj.volumeBase = message.volumeBase
    }
    if (message.volumeQuote?.length) {
      obj.volumeQuote = message.volumeQuote
    }
    if (message.vwap?.length) {
      obj.vwap = message.vwap
    }
    if (message.twap?.length) {
      obj.twap = message.twap
    }
    if (message.buyVolumeBase?.length) {
      obj.buyVolumeBase = message.buyVolumeBase
    }
    if (message.sellVolumeBase?.length) {
      obj.sellVolumeBase = message.sellVolumeBase
    }
    if (message.netBuyVolumeBase?.length) {
      obj.netBuyVolumeBase = message.netBuyVolumeBase
    }
    if (message.totalTradeCount?.length) {
      obj.totalTradeCount = message.totalTradeCount
    }
    if (message.buyTradeCount?.length) {
      obj.buyTradeCount = message.buyTradeCount
    }
    if (message.sellTradeCount?.length) {
      obj.sellTradeCount = message.sellTradeCount
    }
    if (message.netBuyTradeCount?.length) {
      obj.netBuyTradeCount = message.netBuyTradeCount
    }
    if (message.avgTradeSize?.length) {
      obj.avgTradeSize = message.avgTradeSize
    }
    if (message.totalLiqBase?.length) {
      obj.totalLiqBase = message.totalLiqBase
    }
    if (message.totalLiqQuote?.length) {
      obj.totalLiqQuote = message.totalLiqQuote
    }
    if (message.liqwap?.length) {
      obj.liqwap = message.liqwap
    }
    if (message.totalLiqCount?.length) {
      obj.totalLiqCount = message.totalLiqCount
    }
    if (message.buyLiqBase?.length) {
      obj.buyLiqBase = message.buyLiqBase
    }
    if (message.sellLiqBase?.length) {
      obj.sellLiqBase = message.sellLiqBase
    }
    if (message.liqTakerVolume?.length) {
      obj.liqTakerVolume = message.liqTakerVolume
    }
    if (message.liqMakerVolume?.length) {
      obj.liqMakerVolume = message.liqMakerVolume
    }
    if (message.realizedVolatility?.length) {
      obj.realizedVolatility = message.realizedVolatility
    }
    if (message.avgBuyTradeSize?.length) {
      obj.avgBuyTradeSize = message.avgBuyTradeSize
    }
    if (message.avgSellTradeSize?.length) {
      obj.avgSellTradeSize = message.avgSellTradeSize
    }
    if (message.deltaPercentage?.length) {
      obj.deltaPercentage = message.deltaPercentage
    }
    if (message.netBuyVolumeQuote?.length) {
      obj.netBuyVolumeQuote = message.netBuyVolumeQuote
    }
    if (message.vwapTwapSpread?.length) {
      obj.vwapTwapSpread = message.vwapTwapSpread
    }
    if (message.netLiquidations?.length) {
      obj.netLiquidations = message.netLiquidations
    }
    if (message.volumeBaseBlockIncl?.length) {
      obj.volumeBaseBlockIncl = message.volumeBaseBlockIncl
    }
    if (message.volumeQuoteBlockIncl?.length) {
      obj.volumeQuoteBlockIncl = message.volumeQuoteBlockIncl
    }
    if (message.buyVolumeBaseBlockIncl?.length) {
      obj.buyVolumeBaseBlockIncl = message.buyVolumeBaseBlockIncl
    }
    if (message.sellVolumeBaseBlockIncl?.length) {
      obj.sellVolumeBaseBlockIncl = message.sellVolumeBaseBlockIncl
    }
    if (message.netBuyVolumeBaseBlockIncl?.length) {
      obj.netBuyVolumeBaseBlockIncl = message.netBuyVolumeBaseBlockIncl
    }
    if (message.netBuyVolumeQuoteBlockIncl?.length) {
      obj.netBuyVolumeQuoteBlockIncl = message.netBuyVolumeQuoteBlockIncl
    }
    if (message.openInterestBaseOpen?.length) {
      obj.openInterestBaseOpen = message.openInterestBaseOpen
    }
    if (message.openInterestBaseHigh?.length) {
      obj.openInterestBaseHigh = message.openInterestBaseHigh
    }
    if (message.openInterestBaseLow?.length) {
      obj.openInterestBaseLow = message.openInterestBaseLow
    }
    if (message.openInterestBaseClose?.length) {
      obj.openInterestBaseClose = message.openInterestBaseClose
    }
    if (message.openInterestQuoteOpen?.length) {
      obj.openInterestQuoteOpen = message.openInterestQuoteOpen
    }
    if (message.openInterestQuoteHigh?.length) {
      obj.openInterestQuoteHigh = message.openInterestQuoteHigh
    }
    if (message.openInterestQuoteLow?.length) {
      obj.openInterestQuoteLow = message.openInterestQuoteLow
    }
    if (message.openInterestQuoteClose?.length) {
      obj.openInterestQuoteClose = message.openInterestQuoteClose
    }
    if (message.fundingRateOpen?.length) {
      obj.fundingRateOpen = message.fundingRateOpen
    }
    if (message.fundingRateHigh?.length) {
      obj.fundingRateHigh = message.fundingRateHigh
    }
    if (message.fundingRateLow?.length) {
      obj.fundingRateLow = message.fundingRateLow
    }
    if (message.fundingRateClose?.length) {
      obj.fundingRateClose = message.fundingRateClose
    }
    if (message.fundingAprOpen?.length) {
      obj.fundingAprOpen = message.fundingAprOpen
    }
    if (message.fundingAprHigh?.length) {
      obj.fundingAprHigh = message.fundingAprHigh
    }
    if (message.fundingAprLow?.length) {
      obj.fundingAprLow = message.fundingAprLow
    }
    if (message.fundingAprClose?.length) {
      obj.fundingAprClose = message.fundingAprClose
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CandleList>, I>>(base?: I): CandleList {
    return CandleList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CandleList>, I>>(object: I): CandleList {
    const message = createBaseCandleList()
    message.ticks = object.ticks?.map((e) => e) || []
    message.open = object.open?.map((e) => e) || []
    message.high = object.high?.map((e) => e) || []
    message.low = object.low?.map((e) => e) || []
    message.close = object.close?.map((e) => e) || []
    message.volumeBase = object.volumeBase?.map((e) => e) || []
    message.volumeQuote = object.volumeQuote?.map((e) => e) || []
    message.vwap = object.vwap?.map((e) => e) || []
    message.twap = object.twap?.map((e) => e) || []
    message.buyVolumeBase = object.buyVolumeBase?.map((e) => e) || []
    message.sellVolumeBase = object.sellVolumeBase?.map((e) => e) || []
    message.netBuyVolumeBase = object.netBuyVolumeBase?.map((e) => e) || []
    message.totalTradeCount = object.totalTradeCount?.map((e) => e) || []
    message.buyTradeCount = object.buyTradeCount?.map((e) => e) || []
    message.sellTradeCount = object.sellTradeCount?.map((e) => e) || []
    message.netBuyTradeCount = object.netBuyTradeCount?.map((e) => e) || []
    message.avgTradeSize = object.avgTradeSize?.map((e) => e) || []
    message.totalLiqBase = object.totalLiqBase?.map((e) => e) || []
    message.totalLiqQuote = object.totalLiqQuote?.map((e) => e) || []
    message.liqwap = object.liqwap?.map((e) => e) || []
    message.totalLiqCount = object.totalLiqCount?.map((e) => e) || []
    message.buyLiqBase = object.buyLiqBase?.map((e) => e) || []
    message.sellLiqBase = object.sellLiqBase?.map((e) => e) || []
    message.liqTakerVolume = object.liqTakerVolume?.map((e) => e) || []
    message.liqMakerVolume = object.liqMakerVolume?.map((e) => e) || []
    message.realizedVolatility = object.realizedVolatility?.map((e) => e) || []
    message.avgBuyTradeSize = object.avgBuyTradeSize?.map((e) => e) || []
    message.avgSellTradeSize = object.avgSellTradeSize?.map((e) => e) || []
    message.deltaPercentage = object.deltaPercentage?.map((e) => e) || []
    message.netBuyVolumeQuote = object.netBuyVolumeQuote?.map((e) => e) || []
    message.vwapTwapSpread = object.vwapTwapSpread?.map((e) => e) || []
    message.netLiquidations = object.netLiquidations?.map((e) => e) || []
    message.volumeBaseBlockIncl = object.volumeBaseBlockIncl?.map((e) => e) || []
    message.volumeQuoteBlockIncl = object.volumeQuoteBlockIncl?.map((e) => e) || []
    message.buyVolumeBaseBlockIncl = object.buyVolumeBaseBlockIncl?.map((e) => e) || []
    message.sellVolumeBaseBlockIncl = object.sellVolumeBaseBlockIncl?.map((e) => e) || []
    message.netBuyVolumeBaseBlockIncl = object.netBuyVolumeBaseBlockIncl?.map((e) => e) || []
    message.netBuyVolumeQuoteBlockIncl = object.netBuyVolumeQuoteBlockIncl?.map((e) => e) || []
    message.openInterestBaseOpen = object.openInterestBaseOpen?.map((e) => e) || []
    message.openInterestBaseHigh = object.openInterestBaseHigh?.map((e) => e) || []
    message.openInterestBaseLow = object.openInterestBaseLow?.map((e) => e) || []
    message.openInterestBaseClose = object.openInterestBaseClose?.map((e) => e) || []
    message.openInterestQuoteOpen = object.openInterestQuoteOpen?.map((e) => e) || []
    message.openInterestQuoteHigh = object.openInterestQuoteHigh?.map((e) => e) || []
    message.openInterestQuoteLow = object.openInterestQuoteLow?.map((e) => e) || []
    message.openInterestQuoteClose = object.openInterestQuoteClose?.map((e) => e) || []
    message.fundingRateOpen = object.fundingRateOpen?.map((e) => e) || []
    message.fundingRateHigh = object.fundingRateHigh?.map((e) => e) || []
    message.fundingRateLow = object.fundingRateLow?.map((e) => e) || []
    message.fundingRateClose = object.fundingRateClose?.map((e) => e) || []
    message.fundingAprOpen = object.fundingAprOpen?.map((e) => e) || []
    message.fundingAprHigh = object.fundingAprHigh?.map((e) => e) || []
    message.fundingAprLow = object.fundingAprLow?.map((e) => e) || []
    message.fundingAprClose = object.fundingAprClose?.map((e) => e) || []
    return message
  },
}

function createBaseSubscribed(): Subscribed {
  return { channels: [] }
}

export const Subscribed: MessageFns<Subscribed> = {
  encode(message: Subscribed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channels) {
      MessageSubject.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Subscribed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSubscribed()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.channels.push(MessageSubject.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Subscribed {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => MessageSubject.fromJSON(e))
        : [],
    }
  },

  toJSON(message: Subscribed): unknown {
    const obj: any = {}
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => MessageSubject.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Subscribed>, I>>(base?: I): Subscribed {
    return Subscribed.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Subscribed>, I>>(object: I): Subscribed {
    const message = createBaseSubscribed()
    message.channels = object.channels?.map((e) => MessageSubject.fromPartial(e)) || []
    return message
  },
}

function createBaseUnsubscribed(): Unsubscribed {
  return { channels: [] }
}

export const Unsubscribed: MessageFns<Unsubscribed> = {
  encode(message: Unsubscribed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channels) {
      MessageSubject.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Unsubscribed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUnsubscribed()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.channels.push(MessageSubject.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Unsubscribed {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => MessageSubject.fromJSON(e))
        : [],
    }
  },

  toJSON(message: Unsubscribed): unknown {
    const obj: any = {}
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => MessageSubject.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Unsubscribed>, I>>(base?: I): Unsubscribed {
    return Unsubscribed.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Unsubscribed>, I>>(object: I): Unsubscribed {
    const message = createBaseUnsubscribed()
    message.channels = object.channels?.map((e) => MessageSubject.fromPartial(e)) || []
    return message
  },
}

function createBasePing(): Ping {
  return { timestamp: '0' }
}

export const Ping: MessageFns<Ping> = {
  encode(message: Ping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== '0') {
      writer.uint32(8).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePing()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Ping {
    return { timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0' }
  },

  toJSON(message: Ping): unknown {
    const obj: any = {}
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Ping>, I>>(base?: I): Ping {
    return Ping.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Ping>, I>>(object: I): Ping {
    const message = createBasePing()
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBasePong(): Pong {
  return { timestamp: '0' }
}

export const Pong: MessageFns<Pong> = {
  encode(message: Pong, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== '0') {
      writer.uint32(8).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pong {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePong()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Pong {
    return { timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0' }
  },

  toJSON(message: Pong): unknown {
    const obj: any = {}
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Pong>, I>>(base?: I): Pong {
    return Pong.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Pong>, I>>(object: I): Pong {
    const message = createBasePong()
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBaseAuthenticateRequest(): AuthenticateRequest {
  return { token: '' }
}

export const AuthenticateRequest: MessageFns<AuthenticateRequest> = {
  encode(message: AuthenticateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== '') {
      writer.uint32(10).string(message.token)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AuthenticateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAuthenticateRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.token = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AuthenticateRequest {
    return { token: isSet(object.token) ? globalThis.String(object.token) : '' }
  },

  toJSON(message: AuthenticateRequest): unknown {
    const obj: any = {}
    if (message.token !== '') {
      obj.token = message.token
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AuthenticateRequest>, I>>(base?: I): AuthenticateRequest {
    return AuthenticateRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AuthenticateRequest>, I>>(
    object: I
  ): AuthenticateRequest {
    const message = createBaseAuthenticateRequest()
    message.token = object.token ?? ''
    return message
  },
}

function createBaseAuthenticateResponse(): AuthenticateResponse {
  return { success: false, userId: '', errorMessage: '' }
}

export const AuthenticateResponse: MessageFns<AuthenticateResponse> = {
  encode(message: AuthenticateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.userId !== '') {
      writer.uint32(18).string(message.userId)
    }
    if (message.errorMessage !== '') {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AuthenticateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAuthenticateResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AuthenticateResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : '',
    }
  },

  toJSON(message: AuthenticateResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AuthenticateResponse>, I>>(base?: I): AuthenticateResponse {
    return AuthenticateResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AuthenticateResponse>, I>>(
    object: I
  ): AuthenticateResponse {
    const message = createBaseAuthenticateResponse()
    message.success = object.success ?? false
    message.userId = object.userId ?? ''
    message.errorMessage = object.errorMessage ?? ''
    return message
  },
}

function createBaseError(): Error {
  return { message: '' }
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseError()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Error {
    return { message: isSet(object.message) ? globalThis.String(object.message) : '' }
  },

  toJSON(message: Error): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError()
    message.message = object.message ?? ''
    return message
  },
}

function createBaseSuccess(): Success {
  return { message: '' }
}

export const Success: MessageFns<Success> = {
  encode(message: Success, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Success {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSuccess()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Success {
    return { message: isSet(object.message) ? globalThis.String(object.message) : '' }
  },

  toJSON(message: Success): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Success>, I>>(base?: I): Success {
    return Success.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Success>, I>>(object: I): Success {
    const message = createBaseSuccess()
    message.message = object.message ?? ''
    return message
  },
}

function createBaseServerMessage(): ServerMessage {
  return {
    subscribed: undefined,
    unsubscribed: undefined,
    ping: undefined,
    pong: undefined,
    data: undefined,
    error: undefined,
    success: undefined,
    authenticateResponse: undefined,
    loginResponse: undefined,
    signupResponse: undefined,
    userAccountsResponse: undefined,
    requestPasswordResetResponse: undefined,
    confirmPasswordResetResponse: undefined,
    refreshTokenResponse: undefined,
    verifyEmailResponse: undefined,
    resendVerificationResponse: undefined,
    setup2faResponse: undefined,
    confirm2faSetupResponse: undefined,
    verify2faResponse: undefined,
    verify2faLoginResponse: undefined,
    disable2faResponse: undefined,
    get2faBackupCodesResponse: undefined,
    setupPasskeyResponse: undefined,
    confirmPasskeySetupResponse: undefined,
    passkeyLoginResponse: undefined,
    confirmPasskeyLoginResponse: undefined,
    deletePasskeyResponse: undefined,
    getUserPasskeysResponse: undefined,
    googleLoginResponse: undefined,
    verifyResponse: undefined,
    timeResponse: undefined,
    createAccountResponse: undefined,
    compressedPayload: undefined,
    executionPlan: undefined,
    getPagesResponse: undefined,
    getPageLayoutResponse: undefined,
    pageMutationResponse: undefined,
    componentPreferenceResponse: undefined,
    positionGroupMutationResponse: undefined,
    getPositionGroupsResponse: undefined,
    getPositionsViewResponse: undefined,
    createPresetResponse: undefined,
    updatePresetResponse: undefined,
    deletePresetResponse: undefined,
    listPresetsResponse: undefined,
    executePresetResponse: undefined,
    getPresetResponse: undefined,
    watchlistMutationResponse: undefined,
    getWatchlistsResponse: undefined,
    confirmExecutionPlanResponse: undefined,
    createRfqResponse: undefined,
    cancelRfqResponse: undefined,
    acceptRfqQuoteResponse: undefined,
    getRfqMakersResponse: undefined,
    getRfqHistoryResponse: undefined,
    bybitOauthMintStateResponse: undefined,
    deribitOauthMintStateResponse: undefined,
    hyperliquidPrepareAgentResponse: undefined,
    derivePrepareSessionKeyResponse: undefined,
    deriveListSubaccountsResponse: undefined,
    deriveLinkSubaccountsResponse: undefined,
    hyperliquidListSubaccountsResponse: undefined,
    hyperliquidLinkSubaccountsResponse: undefined,
    lighterListSubaccountsResponse: undefined,
    lighterPrepareSubaccountKeyResponse: undefined,
    lighterConfirmSubaccountKeyResponse: undefined,
    lighterLinkSubaccountsResponse: undefined,
    lighterPrepareIntegratorConsentResponse: undefined,
    lighterConfirmIntegratorConsentResponse: undefined,
    createCheckoutSessionResponse: undefined,
    getSubscriptionResponse: undefined,
    openBillingPortalResponse: undefined,
    getPlansResponse: undefined,
    listAccountAccessResponse: undefined,
    listMyInvitesResponse: undefined,
    orderPreviewResponse: undefined,
    changePasswordResponse: undefined,
    listSessionsResponse: undefined,
    revokeSessionResponse: undefined,
    logoutResponse: undefined,
    revokeAllOtherSessionsResponse: undefined,
    sendStepUpCodeResponse: undefined,
    batchOrderPreviewResponse: undefined,
    mintMessagingLinkNonceResponse: undefined,
    paradigmConnectDeskResponse: undefined,
    paradigmListAccountsResponse: undefined,
    paradigmLinkAccountResponse: undefined,
    createSharedLayoutResponse: undefined,
    getSharedLayoutResponse: undefined,
    createApiKeyResponse: undefined,
    listApiKeysResponse: undefined,
    revokeApiKeyResponse: undefined,
    getApiBillingResponse: undefined,
    updateApiBillingSettingsResponse: undefined,
    createCreditCheckoutSessionResponse: undefined,
    listCreditLedgerResponse: undefined,
    getCreditSpendStatsResponse: undefined,
    sendRfqMakerQuoteResponse: undefined,
    cancelRfqMakerQuoteResponse: undefined,
    setLeverageResponse: undefined,
    papertradePrepareSessionKeyResponse: undefined,
    accountSettings: undefined,
  }
}

export const ServerMessage: MessageFns<ServerMessage> = {
  encode(message: ServerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subscribed !== undefined) {
      Subscribed.encode(message.subscribed, writer.uint32(10).fork()).join()
    }
    if (message.unsubscribed !== undefined) {
      Unsubscribed.encode(message.unsubscribed, writer.uint32(18).fork()).join()
    }
    if (message.ping !== undefined) {
      Ping.encode(message.ping, writer.uint32(26).fork()).join()
    }
    if (message.pong !== undefined) {
      Pong.encode(message.pong, writer.uint32(34).fork()).join()
    }
    if (message.data !== undefined) {
      DataPayload.encode(message.data, writer.uint32(42).fork()).join()
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(50).fork()).join()
    }
    if (message.success !== undefined) {
      Success.encode(message.success, writer.uint32(58).fork()).join()
    }
    if (message.authenticateResponse !== undefined) {
      AuthenticateResponse.encode(message.authenticateResponse, writer.uint32(354).fork()).join()
    }
    if (message.loginResponse !== undefined) {
      LoginResponse.encode(message.loginResponse, writer.uint32(66).fork()).join()
    }
    if (message.signupResponse !== undefined) {
      SignupResponse.encode(message.signupResponse, writer.uint32(74).fork()).join()
    }
    if (message.userAccountsResponse !== undefined) {
      PublicAccountList.encode(message.userAccountsResponse, writer.uint32(82).fork()).join()
    }
    if (message.requestPasswordResetResponse !== undefined) {
      RequestPasswordResetResponse.encode(
        message.requestPasswordResetResponse,
        writer.uint32(90).fork()
      ).join()
    }
    if (message.confirmPasswordResetResponse !== undefined) {
      ConfirmPasswordResetResponse.encode(
        message.confirmPasswordResetResponse,
        writer.uint32(98).fork()
      ).join()
    }
    if (message.refreshTokenResponse !== undefined) {
      RefreshTokenResponse.encode(message.refreshTokenResponse, writer.uint32(106).fork()).join()
    }
    if (message.verifyEmailResponse !== undefined) {
      VerifyEmailResponse.encode(message.verifyEmailResponse, writer.uint32(114).fork()).join()
    }
    if (message.resendVerificationResponse !== undefined) {
      ResendVerificationResponse.encode(
        message.resendVerificationResponse,
        writer.uint32(122).fork()
      ).join()
    }
    if (message.setup2faResponse !== undefined) {
      Setup2faResponse.encode(message.setup2faResponse, writer.uint32(130).fork()).join()
    }
    if (message.confirm2faSetupResponse !== undefined) {
      Confirm2faSetupResponse.encode(
        message.confirm2faSetupResponse,
        writer.uint32(138).fork()
      ).join()
    }
    if (message.verify2faResponse !== undefined) {
      Verify2faResponse.encode(message.verify2faResponse, writer.uint32(146).fork()).join()
    }
    if (message.verify2faLoginResponse !== undefined) {
      Verify2faLoginResponse.encode(
        message.verify2faLoginResponse,
        writer.uint32(154).fork()
      ).join()
    }
    if (message.disable2faResponse !== undefined) {
      Disable2faResponse.encode(message.disable2faResponse, writer.uint32(162).fork()).join()
    }
    if (message.get2faBackupCodesResponse !== undefined) {
      Get2faBackupCodesResponse.encode(
        message.get2faBackupCodesResponse,
        writer.uint32(170).fork()
      ).join()
    }
    if (message.setupPasskeyResponse !== undefined) {
      SetupPasskeyResponse.encode(message.setupPasskeyResponse, writer.uint32(178).fork()).join()
    }
    if (message.confirmPasskeySetupResponse !== undefined) {
      ConfirmPasskeySetupResponse.encode(
        message.confirmPasskeySetupResponse,
        writer.uint32(186).fork()
      ).join()
    }
    if (message.passkeyLoginResponse !== undefined) {
      PasskeyLoginResponse.encode(message.passkeyLoginResponse, writer.uint32(194).fork()).join()
    }
    if (message.confirmPasskeyLoginResponse !== undefined) {
      ConfirmPasskeyLoginResponse.encode(
        message.confirmPasskeyLoginResponse,
        writer.uint32(202).fork()
      ).join()
    }
    if (message.deletePasskeyResponse !== undefined) {
      DeletePasskeyResponse.encode(message.deletePasskeyResponse, writer.uint32(210).fork()).join()
    }
    if (message.getUserPasskeysResponse !== undefined) {
      GetUserPasskeysResponse.encode(
        message.getUserPasskeysResponse,
        writer.uint32(218).fork()
      ).join()
    }
    if (message.googleLoginResponse !== undefined) {
      GoogleLoginResponse.encode(message.googleLoginResponse, writer.uint32(226).fork()).join()
    }
    if (message.verifyResponse !== undefined) {
      VerifyTokenResponse.encode(message.verifyResponse, writer.uint32(322).fork()).join()
    }
    if (message.timeResponse !== undefined) {
      TimeResponse.encode(message.timeResponse, writer.uint32(234).fork()).join()
    }
    if (message.createAccountResponse !== undefined) {
      CreateAccountResponse.encode(message.createAccountResponse, writer.uint32(242).fork()).join()
    }
    if (message.compressedPayload !== undefined) {
      CompressedPayload.encode(message.compressedPayload, writer.uint32(250).fork()).join()
    }
    if (message.executionPlan !== undefined) {
      DraftExecutionPlan.encode(message.executionPlan, writer.uint32(258).fork()).join()
    }
    if (message.getPagesResponse !== undefined) {
      GetPagesResponse.encode(message.getPagesResponse, writer.uint32(266).fork()).join()
    }
    if (message.getPageLayoutResponse !== undefined) {
      GetPageLayoutResponse.encode(message.getPageLayoutResponse, writer.uint32(274).fork()).join()
    }
    if (message.pageMutationResponse !== undefined) {
      PageMutationResponse.encode(message.pageMutationResponse, writer.uint32(282).fork()).join()
    }
    if (message.componentPreferenceResponse !== undefined) {
      ComponentPreferenceResponse.encode(
        message.componentPreferenceResponse,
        writer.uint32(290).fork()
      ).join()
    }
    if (message.positionGroupMutationResponse !== undefined) {
      PositionGroupMutationResponse.encode(
        message.positionGroupMutationResponse,
        writer.uint32(298).fork()
      ).join()
    }
    if (message.getPositionGroupsResponse !== undefined) {
      GetPositionGroupsResponse.encode(
        message.getPositionGroupsResponse,
        writer.uint32(306).fork()
      ).join()
    }
    if (message.getPositionsViewResponse !== undefined) {
      GetPositionsViewResponse.encode(
        message.getPositionsViewResponse,
        writer.uint32(314).fork()
      ).join()
    }
    if (message.createPresetResponse !== undefined) {
      CreatePresetResponse.encode(message.createPresetResponse, writer.uint32(330).fork()).join()
    }
    if (message.updatePresetResponse !== undefined) {
      UpdatePresetResponse.encode(message.updatePresetResponse, writer.uint32(338).fork()).join()
    }
    if (message.deletePresetResponse !== undefined) {
      DeletePresetResponse.encode(message.deletePresetResponse, writer.uint32(346).fork()).join()
    }
    if (message.listPresetsResponse !== undefined) {
      ListPresetsResponse.encode(message.listPresetsResponse, writer.uint32(362).fork()).join()
    }
    if (message.executePresetResponse !== undefined) {
      ExecutePresetResponse.encode(message.executePresetResponse, writer.uint32(370).fork()).join()
    }
    if (message.getPresetResponse !== undefined) {
      GetPresetResponse.encode(message.getPresetResponse, writer.uint32(714).fork()).join()
    }
    if (message.watchlistMutationResponse !== undefined) {
      WatchlistMutationResponse.encode(
        message.watchlistMutationResponse,
        writer.uint32(378).fork()
      ).join()
    }
    if (message.getWatchlistsResponse !== undefined) {
      GetWatchlistsResponse.encode(message.getWatchlistsResponse, writer.uint32(386).fork()).join()
    }
    if (message.confirmExecutionPlanResponse !== undefined) {
      ConfirmExecutionPlanResponse.encode(
        message.confirmExecutionPlanResponse,
        writer.uint32(394).fork()
      ).join()
    }
    if (message.createRfqResponse !== undefined) {
      CreateRfqResponse.encode(message.createRfqResponse, writer.uint32(402).fork()).join()
    }
    if (message.cancelRfqResponse !== undefined) {
      CancelRfqResponse.encode(message.cancelRfqResponse, writer.uint32(410).fork()).join()
    }
    if (message.acceptRfqQuoteResponse !== undefined) {
      AcceptRfqQuoteResponse.encode(
        message.acceptRfqQuoteResponse,
        writer.uint32(418).fork()
      ).join()
    }
    if (message.getRfqMakersResponse !== undefined) {
      GetRfqMakersResponse.encode(message.getRfqMakersResponse, writer.uint32(426).fork()).join()
    }
    if (message.getRfqHistoryResponse !== undefined) {
      GetRfqHistoryResponse.encode(message.getRfqHistoryResponse, writer.uint32(434).fork()).join()
    }
    if (message.bybitOauthMintStateResponse !== undefined) {
      BybitOauthMintStateResponse.encode(
        message.bybitOauthMintStateResponse,
        writer.uint32(442).fork()
      ).join()
    }
    if (message.deribitOauthMintStateResponse !== undefined) {
      DeribitOauthMintStateResponse.encode(
        message.deribitOauthMintStateResponse,
        writer.uint32(466).fork()
      ).join()
    }
    if (message.hyperliquidPrepareAgentResponse !== undefined) {
      HyperliquidPrepareAgentResponse.encode(
        message.hyperliquidPrepareAgentResponse,
        writer.uint32(474).fork()
      ).join()
    }
    if (message.derivePrepareSessionKeyResponse !== undefined) {
      DerivePrepareSessionKeyResponse.encode(
        message.derivePrepareSessionKeyResponse,
        writer.uint32(570).fork()
      ).join()
    }
    if (message.deriveListSubaccountsResponse !== undefined) {
      DeriveListSubaccountsResponse.encode(
        message.deriveListSubaccountsResponse,
        writer.uint32(578).fork()
      ).join()
    }
    if (message.deriveLinkSubaccountsResponse !== undefined) {
      DeriveLinkSubaccountsResponse.encode(
        message.deriveLinkSubaccountsResponse,
        writer.uint32(586).fork()
      ).join()
    }
    if (message.hyperliquidListSubaccountsResponse !== undefined) {
      HyperliquidListSubaccountsResponse.encode(
        message.hyperliquidListSubaccountsResponse,
        writer.uint32(594).fork()
      ).join()
    }
    if (message.hyperliquidLinkSubaccountsResponse !== undefined) {
      HyperliquidLinkSubaccountsResponse.encode(
        message.hyperliquidLinkSubaccountsResponse,
        writer.uint32(602).fork()
      ).join()
    }
    if (message.lighterListSubaccountsResponse !== undefined) {
      LighterListSubaccountsResponse.encode(
        message.lighterListSubaccountsResponse,
        writer.uint32(626).fork()
      ).join()
    }
    if (message.lighterPrepareSubaccountKeyResponse !== undefined) {
      LighterPrepareSubaccountKeyResponse.encode(
        message.lighterPrepareSubaccountKeyResponse,
        writer.uint32(634).fork()
      ).join()
    }
    if (message.lighterConfirmSubaccountKeyResponse !== undefined) {
      LighterConfirmSubaccountKeyResponse.encode(
        message.lighterConfirmSubaccountKeyResponse,
        writer.uint32(642).fork()
      ).join()
    }
    if (message.lighterLinkSubaccountsResponse !== undefined) {
      LighterLinkSubaccountsResponse.encode(
        message.lighterLinkSubaccountsResponse,
        writer.uint32(650).fork()
      ).join()
    }
    if (message.lighterPrepareIntegratorConsentResponse !== undefined) {
      LighterPrepareIntegratorConsentResponse.encode(
        message.lighterPrepareIntegratorConsentResponse,
        writer.uint32(658).fork()
      ).join()
    }
    if (message.lighterConfirmIntegratorConsentResponse !== undefined) {
      LighterConfirmIntegratorConsentResponse.encode(
        message.lighterConfirmIntegratorConsentResponse,
        writer.uint32(666).fork()
      ).join()
    }
    if (message.createCheckoutSessionResponse !== undefined) {
      CreateCheckoutSessionResponse.encode(
        message.createCheckoutSessionResponse,
        writer.uint32(482).fork()
      ).join()
    }
    if (message.getSubscriptionResponse !== undefined) {
      GetSubscriptionResponse.encode(
        message.getSubscriptionResponse,
        writer.uint32(490).fork()
      ).join()
    }
    if (message.openBillingPortalResponse !== undefined) {
      OpenBillingPortalResponse.encode(
        message.openBillingPortalResponse,
        writer.uint32(498).fork()
      ).join()
    }
    if (message.getPlansResponse !== undefined) {
      GetPlansResponse.encode(message.getPlansResponse, writer.uint32(506).fork()).join()
    }
    if (message.listAccountAccessResponse !== undefined) {
      ListAccountAccessResponse.encode(
        message.listAccountAccessResponse,
        writer.uint32(450).fork()
      ).join()
    }
    if (message.listMyInvitesResponse !== undefined) {
      ListMyInvitesResponse.encode(message.listMyInvitesResponse, writer.uint32(458).fork()).join()
    }
    if (message.orderPreviewResponse !== undefined) {
      OrderPreviewResponse.encode(message.orderPreviewResponse, writer.uint32(514).fork()).join()
    }
    if (message.changePasswordResponse !== undefined) {
      ChangePasswordResponse.encode(
        message.changePasswordResponse,
        writer.uint32(522).fork()
      ).join()
    }
    if (message.listSessionsResponse !== undefined) {
      ListSessionsResponse.encode(message.listSessionsResponse, writer.uint32(530).fork()).join()
    }
    if (message.revokeSessionResponse !== undefined) {
      RevokeSessionResponse.encode(message.revokeSessionResponse, writer.uint32(538).fork()).join()
    }
    if (message.logoutResponse !== undefined) {
      LogoutResponse.encode(message.logoutResponse, writer.uint32(546).fork()).join()
    }
    if (message.revokeAllOtherSessionsResponse !== undefined) {
      RevokeAllOtherSessionsResponse.encode(
        message.revokeAllOtherSessionsResponse,
        writer.uint32(554).fork()
      ).join()
    }
    if (message.sendStepUpCodeResponse !== undefined) {
      SendStepUpCodeResponse.encode(
        message.sendStepUpCodeResponse,
        writer.uint32(562).fork()
      ).join()
    }
    if (message.batchOrderPreviewResponse !== undefined) {
      BatchOrderPreviewResponse.encode(
        message.batchOrderPreviewResponse,
        writer.uint32(610).fork()
      ).join()
    }
    if (message.mintMessagingLinkNonceResponse !== undefined) {
      MintMessagingLinkNonceResponse.encode(
        message.mintMessagingLinkNonceResponse,
        writer.uint32(674).fork()
      ).join()
    }
    if (message.paradigmConnectDeskResponse !== undefined) {
      ParadigmConnectDeskResponse.encode(
        message.paradigmConnectDeskResponse,
        writer.uint32(690).fork()
      ).join()
    }
    if (message.paradigmListAccountsResponse !== undefined) {
      ParadigmListAccountsResponse.encode(
        message.paradigmListAccountsResponse,
        writer.uint32(698).fork()
      ).join()
    }
    if (message.paradigmLinkAccountResponse !== undefined) {
      ParadigmLinkAccountResponse.encode(
        message.paradigmLinkAccountResponse,
        writer.uint32(706).fork()
      ).join()
    }
    if (message.createSharedLayoutResponse !== undefined) {
      CreateSharedLayoutResponse.encode(
        message.createSharedLayoutResponse,
        writer.uint32(722).fork()
      ).join()
    }
    if (message.getSharedLayoutResponse !== undefined) {
      GetSharedLayoutResponse.encode(
        message.getSharedLayoutResponse,
        writer.uint32(730).fork()
      ).join()
    }
    if (message.createApiKeyResponse !== undefined) {
      CreateApiKeyResponse.encode(message.createApiKeyResponse, writer.uint32(738).fork()).join()
    }
    if (message.listApiKeysResponse !== undefined) {
      ListApiKeysResponse.encode(message.listApiKeysResponse, writer.uint32(746).fork()).join()
    }
    if (message.revokeApiKeyResponse !== undefined) {
      RevokeApiKeyResponse.encode(message.revokeApiKeyResponse, writer.uint32(754).fork()).join()
    }
    if (message.getApiBillingResponse !== undefined) {
      GetApiBillingResponse.encode(message.getApiBillingResponse, writer.uint32(762).fork()).join()
    }
    if (message.updateApiBillingSettingsResponse !== undefined) {
      UpdateApiBillingSettingsResponse.encode(
        message.updateApiBillingSettingsResponse,
        writer.uint32(770).fork()
      ).join()
    }
    if (message.createCreditCheckoutSessionResponse !== undefined) {
      CreateCreditCheckoutSessionResponse.encode(
        message.createCreditCheckoutSessionResponse,
        writer.uint32(778).fork()
      ).join()
    }
    if (message.listCreditLedgerResponse !== undefined) {
      ListCreditLedgerResponse.encode(
        message.listCreditLedgerResponse,
        writer.uint32(786).fork()
      ).join()
    }
    if (message.getCreditSpendStatsResponse !== undefined) {
      GetCreditSpendStatsResponse.encode(
        message.getCreditSpendStatsResponse,
        writer.uint32(794).fork()
      ).join()
    }
    if (message.sendRfqMakerQuoteResponse !== undefined) {
      SendRfqMakerQuoteResponse.encode(
        message.sendRfqMakerQuoteResponse,
        writer.uint32(802).fork()
      ).join()
    }
    if (message.cancelRfqMakerQuoteResponse !== undefined) {
      CancelRfqMakerQuoteResponse.encode(
        message.cancelRfqMakerQuoteResponse,
        writer.uint32(810).fork()
      ).join()
    }
    if (message.setLeverageResponse !== undefined) {
      SetLeverageResponse.encode(message.setLeverageResponse, writer.uint32(818).fork()).join()
    }
    if (message.papertradePrepareSessionKeyResponse !== undefined) {
      PapertradePrepareSessionKeyResponse.encode(
        message.papertradePrepareSessionKeyResponse,
        writer.uint32(826).fork()
      ).join()
    }
    if (message.accountSettings !== undefined) {
      AccountSettings.encode(message.accountSettings, writer.uint32(834).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseServerMessage()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.subscribed = Subscribed.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.unsubscribed = Unsubscribed.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.ping = Ping.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.pong = Pong.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.data = DataPayload.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.error = Error.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.success = Success.decode(reader, reader.uint32())
          continue
        }
        case 44: {
          if (tag !== 354) {
            break
          }

          message.authenticateResponse = AuthenticateResponse.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.loginResponse = LoginResponse.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.signupResponse = SignupResponse.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.userAccountsResponse = PublicAccountList.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.requestPasswordResetResponse = RequestPasswordResetResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.confirmPasswordResetResponse = ConfirmPasswordResetResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.refreshTokenResponse = RefreshTokenResponse.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.verifyEmailResponse = VerifyEmailResponse.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.resendVerificationResponse = ResendVerificationResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.setup2faResponse = Setup2faResponse.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.confirm2faSetupResponse = Confirm2faSetupResponse.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.verify2faResponse = Verify2faResponse.decode(reader, reader.uint32())
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.verify2faLoginResponse = Verify2faLoginResponse.decode(reader, reader.uint32())
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.disable2faResponse = Disable2faResponse.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.get2faBackupCodesResponse = Get2faBackupCodesResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.setupPasskeyResponse = SetupPasskeyResponse.decode(reader, reader.uint32())
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.confirmPasskeySetupResponse = ConfirmPasskeySetupResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.passkeyLoginResponse = PasskeyLoginResponse.decode(reader, reader.uint32())
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.confirmPasskeyLoginResponse = ConfirmPasskeyLoginResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.deletePasskeyResponse = DeletePasskeyResponse.decode(reader, reader.uint32())
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.getUserPasskeysResponse = GetUserPasskeysResponse.decode(reader, reader.uint32())
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.googleLoginResponse = GoogleLoginResponse.decode(reader, reader.uint32())
          continue
        }
        case 40: {
          if (tag !== 322) {
            break
          }

          message.verifyResponse = VerifyTokenResponse.decode(reader, reader.uint32())
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.timeResponse = TimeResponse.decode(reader, reader.uint32())
          continue
        }
        case 30: {
          if (tag !== 242) {
            break
          }

          message.createAccountResponse = CreateAccountResponse.decode(reader, reader.uint32())
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.compressedPayload = CompressedPayload.decode(reader, reader.uint32())
          continue
        }
        case 32: {
          if (tag !== 258) {
            break
          }

          message.executionPlan = DraftExecutionPlan.decode(reader, reader.uint32())
          continue
        }
        case 33: {
          if (tag !== 266) {
            break
          }

          message.getPagesResponse = GetPagesResponse.decode(reader, reader.uint32())
          continue
        }
        case 34: {
          if (tag !== 274) {
            break
          }

          message.getPageLayoutResponse = GetPageLayoutResponse.decode(reader, reader.uint32())
          continue
        }
        case 35: {
          if (tag !== 282) {
            break
          }

          message.pageMutationResponse = PageMutationResponse.decode(reader, reader.uint32())
          continue
        }
        case 36: {
          if (tag !== 290) {
            break
          }

          message.componentPreferenceResponse = ComponentPreferenceResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 37: {
          if (tag !== 298) {
            break
          }

          message.positionGroupMutationResponse = PositionGroupMutationResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 38: {
          if (tag !== 306) {
            break
          }

          message.getPositionGroupsResponse = GetPositionGroupsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 39: {
          if (tag !== 314) {
            break
          }

          message.getPositionsViewResponse = GetPositionsViewResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 41: {
          if (tag !== 330) {
            break
          }

          message.createPresetResponse = CreatePresetResponse.decode(reader, reader.uint32())
          continue
        }
        case 42: {
          if (tag !== 338) {
            break
          }

          message.updatePresetResponse = UpdatePresetResponse.decode(reader, reader.uint32())
          continue
        }
        case 43: {
          if (tag !== 346) {
            break
          }

          message.deletePresetResponse = DeletePresetResponse.decode(reader, reader.uint32())
          continue
        }
        case 45: {
          if (tag !== 362) {
            break
          }

          message.listPresetsResponse = ListPresetsResponse.decode(reader, reader.uint32())
          continue
        }
        case 46: {
          if (tag !== 370) {
            break
          }

          message.executePresetResponse = ExecutePresetResponse.decode(reader, reader.uint32())
          continue
        }
        case 89: {
          if (tag !== 714) {
            break
          }

          message.getPresetResponse = GetPresetResponse.decode(reader, reader.uint32())
          continue
        }
        case 47: {
          if (tag !== 378) {
            break
          }

          message.watchlistMutationResponse = WatchlistMutationResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 48: {
          if (tag !== 386) {
            break
          }

          message.getWatchlistsResponse = GetWatchlistsResponse.decode(reader, reader.uint32())
          continue
        }
        case 49: {
          if (tag !== 394) {
            break
          }

          message.confirmExecutionPlanResponse = ConfirmExecutionPlanResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 50: {
          if (tag !== 402) {
            break
          }

          message.createRfqResponse = CreateRfqResponse.decode(reader, reader.uint32())
          continue
        }
        case 51: {
          if (tag !== 410) {
            break
          }

          message.cancelRfqResponse = CancelRfqResponse.decode(reader, reader.uint32())
          continue
        }
        case 52: {
          if (tag !== 418) {
            break
          }

          message.acceptRfqQuoteResponse = AcceptRfqQuoteResponse.decode(reader, reader.uint32())
          continue
        }
        case 53: {
          if (tag !== 426) {
            break
          }

          message.getRfqMakersResponse = GetRfqMakersResponse.decode(reader, reader.uint32())
          continue
        }
        case 54: {
          if (tag !== 434) {
            break
          }

          message.getRfqHistoryResponse = GetRfqHistoryResponse.decode(reader, reader.uint32())
          continue
        }
        case 55: {
          if (tag !== 442) {
            break
          }

          message.bybitOauthMintStateResponse = BybitOauthMintStateResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 58: {
          if (tag !== 466) {
            break
          }

          message.deribitOauthMintStateResponse = DeribitOauthMintStateResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 59: {
          if (tag !== 474) {
            break
          }

          message.hyperliquidPrepareAgentResponse = HyperliquidPrepareAgentResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 71: {
          if (tag !== 570) {
            break
          }

          message.derivePrepareSessionKeyResponse = DerivePrepareSessionKeyResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 72: {
          if (tag !== 578) {
            break
          }

          message.deriveListSubaccountsResponse = DeriveListSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 73: {
          if (tag !== 586) {
            break
          }

          message.deriveLinkSubaccountsResponse = DeriveLinkSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 74: {
          if (tag !== 594) {
            break
          }

          message.hyperliquidListSubaccountsResponse = HyperliquidListSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 75: {
          if (tag !== 602) {
            break
          }

          message.hyperliquidLinkSubaccountsResponse = HyperliquidLinkSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 78: {
          if (tag !== 626) {
            break
          }

          message.lighterListSubaccountsResponse = LighterListSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 79: {
          if (tag !== 634) {
            break
          }

          message.lighterPrepareSubaccountKeyResponse = LighterPrepareSubaccountKeyResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 80: {
          if (tag !== 642) {
            break
          }

          message.lighterConfirmSubaccountKeyResponse = LighterConfirmSubaccountKeyResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 81: {
          if (tag !== 650) {
            break
          }

          message.lighterLinkSubaccountsResponse = LighterLinkSubaccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 82: {
          if (tag !== 658) {
            break
          }

          message.lighterPrepareIntegratorConsentResponse =
            LighterPrepareIntegratorConsentResponse.decode(reader, reader.uint32())
          continue
        }
        case 83: {
          if (tag !== 666) {
            break
          }

          message.lighterConfirmIntegratorConsentResponse =
            LighterConfirmIntegratorConsentResponse.decode(reader, reader.uint32())
          continue
        }
        case 60: {
          if (tag !== 482) {
            break
          }

          message.createCheckoutSessionResponse = CreateCheckoutSessionResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 61: {
          if (tag !== 490) {
            break
          }

          message.getSubscriptionResponse = GetSubscriptionResponse.decode(reader, reader.uint32())
          continue
        }
        case 62: {
          if (tag !== 498) {
            break
          }

          message.openBillingPortalResponse = OpenBillingPortalResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 63: {
          if (tag !== 506) {
            break
          }

          message.getPlansResponse = GetPlansResponse.decode(reader, reader.uint32())
          continue
        }
        case 56: {
          if (tag !== 450) {
            break
          }

          message.listAccountAccessResponse = ListAccountAccessResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 57: {
          if (tag !== 458) {
            break
          }

          message.listMyInvitesResponse = ListMyInvitesResponse.decode(reader, reader.uint32())
          continue
        }
        case 64: {
          if (tag !== 514) {
            break
          }

          message.orderPreviewResponse = OrderPreviewResponse.decode(reader, reader.uint32())
          continue
        }
        case 65: {
          if (tag !== 522) {
            break
          }

          message.changePasswordResponse = ChangePasswordResponse.decode(reader, reader.uint32())
          continue
        }
        case 66: {
          if (tag !== 530) {
            break
          }

          message.listSessionsResponse = ListSessionsResponse.decode(reader, reader.uint32())
          continue
        }
        case 67: {
          if (tag !== 538) {
            break
          }

          message.revokeSessionResponse = RevokeSessionResponse.decode(reader, reader.uint32())
          continue
        }
        case 68: {
          if (tag !== 546) {
            break
          }

          message.logoutResponse = LogoutResponse.decode(reader, reader.uint32())
          continue
        }
        case 69: {
          if (tag !== 554) {
            break
          }

          message.revokeAllOtherSessionsResponse = RevokeAllOtherSessionsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 70: {
          if (tag !== 562) {
            break
          }

          message.sendStepUpCodeResponse = SendStepUpCodeResponse.decode(reader, reader.uint32())
          continue
        }
        case 76: {
          if (tag !== 610) {
            break
          }

          message.batchOrderPreviewResponse = BatchOrderPreviewResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 84: {
          if (tag !== 674) {
            break
          }

          message.mintMessagingLinkNonceResponse = MintMessagingLinkNonceResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 86: {
          if (tag !== 690) {
            break
          }

          message.paradigmConnectDeskResponse = ParadigmConnectDeskResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 87: {
          if (tag !== 698) {
            break
          }

          message.paradigmListAccountsResponse = ParadigmListAccountsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 88: {
          if (tag !== 706) {
            break
          }

          message.paradigmLinkAccountResponse = ParadigmLinkAccountResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 90: {
          if (tag !== 722) {
            break
          }

          message.createSharedLayoutResponse = CreateSharedLayoutResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 91: {
          if (tag !== 730) {
            break
          }

          message.getSharedLayoutResponse = GetSharedLayoutResponse.decode(reader, reader.uint32())
          continue
        }
        case 92: {
          if (tag !== 738) {
            break
          }

          message.createApiKeyResponse = CreateApiKeyResponse.decode(reader, reader.uint32())
          continue
        }
        case 93: {
          if (tag !== 746) {
            break
          }

          message.listApiKeysResponse = ListApiKeysResponse.decode(reader, reader.uint32())
          continue
        }
        case 94: {
          if (tag !== 754) {
            break
          }

          message.revokeApiKeyResponse = RevokeApiKeyResponse.decode(reader, reader.uint32())
          continue
        }
        case 95: {
          if (tag !== 762) {
            break
          }

          message.getApiBillingResponse = GetApiBillingResponse.decode(reader, reader.uint32())
          continue
        }
        case 96: {
          if (tag !== 770) {
            break
          }

          message.updateApiBillingSettingsResponse = UpdateApiBillingSettingsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 97: {
          if (tag !== 778) {
            break
          }

          message.createCreditCheckoutSessionResponse = CreateCreditCheckoutSessionResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 98: {
          if (tag !== 786) {
            break
          }

          message.listCreditLedgerResponse = ListCreditLedgerResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 99: {
          if (tag !== 794) {
            break
          }

          message.getCreditSpendStatsResponse = GetCreditSpendStatsResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 100: {
          if (tag !== 802) {
            break
          }

          message.sendRfqMakerQuoteResponse = SendRfqMakerQuoteResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 101: {
          if (tag !== 810) {
            break
          }

          message.cancelRfqMakerQuoteResponse = CancelRfqMakerQuoteResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 102: {
          if (tag !== 818) {
            break
          }

          message.setLeverageResponse = SetLeverageResponse.decode(reader, reader.uint32())
          continue
        }
        case 103: {
          if (tag !== 826) {
            break
          }

          message.papertradePrepareSessionKeyResponse = PapertradePrepareSessionKeyResponse.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 104: {
          if (tag !== 834) {
            break
          }

          message.accountSettings = AccountSettings.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ServerMessage {
    return {
      subscribed: isSet(object.subscribed) ? Subscribed.fromJSON(object.subscribed) : undefined,
      unsubscribed: isSet(object.unsubscribed)
        ? Unsubscribed.fromJSON(object.unsubscribed)
        : undefined,
      ping: isSet(object.ping) ? Ping.fromJSON(object.ping) : undefined,
      pong: isSet(object.pong) ? Pong.fromJSON(object.pong) : undefined,
      data: isSet(object.data) ? DataPayload.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
      success: isSet(object.success) ? Success.fromJSON(object.success) : undefined,
      authenticateResponse: isSet(object.authenticateResponse)
        ? AuthenticateResponse.fromJSON(object.authenticateResponse)
        : isSet(object.authenticate_response)
          ? AuthenticateResponse.fromJSON(object.authenticate_response)
          : undefined,
      loginResponse: isSet(object.loginResponse)
        ? LoginResponse.fromJSON(object.loginResponse)
        : isSet(object.login_response)
          ? LoginResponse.fromJSON(object.login_response)
          : undefined,
      signupResponse: isSet(object.signupResponse)
        ? SignupResponse.fromJSON(object.signupResponse)
        : isSet(object.signup_response)
          ? SignupResponse.fromJSON(object.signup_response)
          : undefined,
      userAccountsResponse: isSet(object.userAccountsResponse)
        ? PublicAccountList.fromJSON(object.userAccountsResponse)
        : isSet(object.user_accounts_response)
          ? PublicAccountList.fromJSON(object.user_accounts_response)
          : undefined,
      requestPasswordResetResponse: isSet(object.requestPasswordResetResponse)
        ? RequestPasswordResetResponse.fromJSON(object.requestPasswordResetResponse)
        : isSet(object.request_password_reset_response)
          ? RequestPasswordResetResponse.fromJSON(object.request_password_reset_response)
          : undefined,
      confirmPasswordResetResponse: isSet(object.confirmPasswordResetResponse)
        ? ConfirmPasswordResetResponse.fromJSON(object.confirmPasswordResetResponse)
        : isSet(object.confirm_password_reset_response)
          ? ConfirmPasswordResetResponse.fromJSON(object.confirm_password_reset_response)
          : undefined,
      refreshTokenResponse: isSet(object.refreshTokenResponse)
        ? RefreshTokenResponse.fromJSON(object.refreshTokenResponse)
        : isSet(object.refresh_token_response)
          ? RefreshTokenResponse.fromJSON(object.refresh_token_response)
          : undefined,
      verifyEmailResponse: isSet(object.verifyEmailResponse)
        ? VerifyEmailResponse.fromJSON(object.verifyEmailResponse)
        : isSet(object.verify_email_response)
          ? VerifyEmailResponse.fromJSON(object.verify_email_response)
          : undefined,
      resendVerificationResponse: isSet(object.resendVerificationResponse)
        ? ResendVerificationResponse.fromJSON(object.resendVerificationResponse)
        : isSet(object.resend_verification_response)
          ? ResendVerificationResponse.fromJSON(object.resend_verification_response)
          : undefined,
      setup2faResponse: isSet(object.setup2faResponse)
        ? Setup2faResponse.fromJSON(object.setup2faResponse)
        : isSet(object.setup_2fa_response)
          ? Setup2faResponse.fromJSON(object.setup_2fa_response)
          : undefined,
      confirm2faSetupResponse: isSet(object.confirm2faSetupResponse)
        ? Confirm2faSetupResponse.fromJSON(object.confirm2faSetupResponse)
        : isSet(object.confirm_2fa_setup_response)
          ? Confirm2faSetupResponse.fromJSON(object.confirm_2fa_setup_response)
          : undefined,
      verify2faResponse: isSet(object.verify2faResponse)
        ? Verify2faResponse.fromJSON(object.verify2faResponse)
        : isSet(object.verify_2fa_response)
          ? Verify2faResponse.fromJSON(object.verify_2fa_response)
          : undefined,
      verify2faLoginResponse: isSet(object.verify2faLoginResponse)
        ? Verify2faLoginResponse.fromJSON(object.verify2faLoginResponse)
        : isSet(object.verify_2fa_login_response)
          ? Verify2faLoginResponse.fromJSON(object.verify_2fa_login_response)
          : undefined,
      disable2faResponse: isSet(object.disable2faResponse)
        ? Disable2faResponse.fromJSON(object.disable2faResponse)
        : isSet(object.disable_2fa_response)
          ? Disable2faResponse.fromJSON(object.disable_2fa_response)
          : undefined,
      get2faBackupCodesResponse: isSet(object.get2faBackupCodesResponse)
        ? Get2faBackupCodesResponse.fromJSON(object.get2faBackupCodesResponse)
        : isSet(object.get_2fa_backup_codes_response)
          ? Get2faBackupCodesResponse.fromJSON(object.get_2fa_backup_codes_response)
          : undefined,
      setupPasskeyResponse: isSet(object.setupPasskeyResponse)
        ? SetupPasskeyResponse.fromJSON(object.setupPasskeyResponse)
        : isSet(object.setup_passkey_response)
          ? SetupPasskeyResponse.fromJSON(object.setup_passkey_response)
          : undefined,
      confirmPasskeySetupResponse: isSet(object.confirmPasskeySetupResponse)
        ? ConfirmPasskeySetupResponse.fromJSON(object.confirmPasskeySetupResponse)
        : isSet(object.confirm_passkey_setup_response)
          ? ConfirmPasskeySetupResponse.fromJSON(object.confirm_passkey_setup_response)
          : undefined,
      passkeyLoginResponse: isSet(object.passkeyLoginResponse)
        ? PasskeyLoginResponse.fromJSON(object.passkeyLoginResponse)
        : isSet(object.passkey_login_response)
          ? PasskeyLoginResponse.fromJSON(object.passkey_login_response)
          : undefined,
      confirmPasskeyLoginResponse: isSet(object.confirmPasskeyLoginResponse)
        ? ConfirmPasskeyLoginResponse.fromJSON(object.confirmPasskeyLoginResponse)
        : isSet(object.confirm_passkey_login_response)
          ? ConfirmPasskeyLoginResponse.fromJSON(object.confirm_passkey_login_response)
          : undefined,
      deletePasskeyResponse: isSet(object.deletePasskeyResponse)
        ? DeletePasskeyResponse.fromJSON(object.deletePasskeyResponse)
        : isSet(object.delete_passkey_response)
          ? DeletePasskeyResponse.fromJSON(object.delete_passkey_response)
          : undefined,
      getUserPasskeysResponse: isSet(object.getUserPasskeysResponse)
        ? GetUserPasskeysResponse.fromJSON(object.getUserPasskeysResponse)
        : isSet(object.get_user_passkeys_response)
          ? GetUserPasskeysResponse.fromJSON(object.get_user_passkeys_response)
          : undefined,
      googleLoginResponse: isSet(object.googleLoginResponse)
        ? GoogleLoginResponse.fromJSON(object.googleLoginResponse)
        : isSet(object.google_login_response)
          ? GoogleLoginResponse.fromJSON(object.google_login_response)
          : undefined,
      verifyResponse: isSet(object.verifyResponse)
        ? VerifyTokenResponse.fromJSON(object.verifyResponse)
        : isSet(object.verify_response)
          ? VerifyTokenResponse.fromJSON(object.verify_response)
          : undefined,
      timeResponse: isSet(object.timeResponse)
        ? TimeResponse.fromJSON(object.timeResponse)
        : isSet(object.time_response)
          ? TimeResponse.fromJSON(object.time_response)
          : undefined,
      createAccountResponse: isSet(object.createAccountResponse)
        ? CreateAccountResponse.fromJSON(object.createAccountResponse)
        : isSet(object.create_account_response)
          ? CreateAccountResponse.fromJSON(object.create_account_response)
          : undefined,
      compressedPayload: isSet(object.compressedPayload)
        ? CompressedPayload.fromJSON(object.compressedPayload)
        : isSet(object.compressed_payload)
          ? CompressedPayload.fromJSON(object.compressed_payload)
          : undefined,
      executionPlan: isSet(object.executionPlan)
        ? DraftExecutionPlan.fromJSON(object.executionPlan)
        : isSet(object.execution_plan)
          ? DraftExecutionPlan.fromJSON(object.execution_plan)
          : undefined,
      getPagesResponse: isSet(object.getPagesResponse)
        ? GetPagesResponse.fromJSON(object.getPagesResponse)
        : isSet(object.get_pages_response)
          ? GetPagesResponse.fromJSON(object.get_pages_response)
          : undefined,
      getPageLayoutResponse: isSet(object.getPageLayoutResponse)
        ? GetPageLayoutResponse.fromJSON(object.getPageLayoutResponse)
        : isSet(object.get_page_layout_response)
          ? GetPageLayoutResponse.fromJSON(object.get_page_layout_response)
          : undefined,
      pageMutationResponse: isSet(object.pageMutationResponse)
        ? PageMutationResponse.fromJSON(object.pageMutationResponse)
        : isSet(object.page_mutation_response)
          ? PageMutationResponse.fromJSON(object.page_mutation_response)
          : undefined,
      componentPreferenceResponse: isSet(object.componentPreferenceResponse)
        ? ComponentPreferenceResponse.fromJSON(object.componentPreferenceResponse)
        : isSet(object.component_preference_response)
          ? ComponentPreferenceResponse.fromJSON(object.component_preference_response)
          : undefined,
      positionGroupMutationResponse: isSet(object.positionGroupMutationResponse)
        ? PositionGroupMutationResponse.fromJSON(object.positionGroupMutationResponse)
        : isSet(object.position_group_mutation_response)
          ? PositionGroupMutationResponse.fromJSON(object.position_group_mutation_response)
          : undefined,
      getPositionGroupsResponse: isSet(object.getPositionGroupsResponse)
        ? GetPositionGroupsResponse.fromJSON(object.getPositionGroupsResponse)
        : isSet(object.get_position_groups_response)
          ? GetPositionGroupsResponse.fromJSON(object.get_position_groups_response)
          : undefined,
      getPositionsViewResponse: isSet(object.getPositionsViewResponse)
        ? GetPositionsViewResponse.fromJSON(object.getPositionsViewResponse)
        : isSet(object.get_positions_view_response)
          ? GetPositionsViewResponse.fromJSON(object.get_positions_view_response)
          : undefined,
      createPresetResponse: isSet(object.createPresetResponse)
        ? CreatePresetResponse.fromJSON(object.createPresetResponse)
        : isSet(object.create_preset_response)
          ? CreatePresetResponse.fromJSON(object.create_preset_response)
          : undefined,
      updatePresetResponse: isSet(object.updatePresetResponse)
        ? UpdatePresetResponse.fromJSON(object.updatePresetResponse)
        : isSet(object.update_preset_response)
          ? UpdatePresetResponse.fromJSON(object.update_preset_response)
          : undefined,
      deletePresetResponse: isSet(object.deletePresetResponse)
        ? DeletePresetResponse.fromJSON(object.deletePresetResponse)
        : isSet(object.delete_preset_response)
          ? DeletePresetResponse.fromJSON(object.delete_preset_response)
          : undefined,
      listPresetsResponse: isSet(object.listPresetsResponse)
        ? ListPresetsResponse.fromJSON(object.listPresetsResponse)
        : isSet(object.list_presets_response)
          ? ListPresetsResponse.fromJSON(object.list_presets_response)
          : undefined,
      executePresetResponse: isSet(object.executePresetResponse)
        ? ExecutePresetResponse.fromJSON(object.executePresetResponse)
        : isSet(object.execute_preset_response)
          ? ExecutePresetResponse.fromJSON(object.execute_preset_response)
          : undefined,
      getPresetResponse: isSet(object.getPresetResponse)
        ? GetPresetResponse.fromJSON(object.getPresetResponse)
        : isSet(object.get_preset_response)
          ? GetPresetResponse.fromJSON(object.get_preset_response)
          : undefined,
      watchlistMutationResponse: isSet(object.watchlistMutationResponse)
        ? WatchlistMutationResponse.fromJSON(object.watchlistMutationResponse)
        : isSet(object.watchlist_mutation_response)
          ? WatchlistMutationResponse.fromJSON(object.watchlist_mutation_response)
          : undefined,
      getWatchlistsResponse: isSet(object.getWatchlistsResponse)
        ? GetWatchlistsResponse.fromJSON(object.getWatchlistsResponse)
        : isSet(object.get_watchlists_response)
          ? GetWatchlistsResponse.fromJSON(object.get_watchlists_response)
          : undefined,
      confirmExecutionPlanResponse: isSet(object.confirmExecutionPlanResponse)
        ? ConfirmExecutionPlanResponse.fromJSON(object.confirmExecutionPlanResponse)
        : isSet(object.confirm_execution_plan_response)
          ? ConfirmExecutionPlanResponse.fromJSON(object.confirm_execution_plan_response)
          : undefined,
      createRfqResponse: isSet(object.createRfqResponse)
        ? CreateRfqResponse.fromJSON(object.createRfqResponse)
        : isSet(object.create_rfq_response)
          ? CreateRfqResponse.fromJSON(object.create_rfq_response)
          : undefined,
      cancelRfqResponse: isSet(object.cancelRfqResponse)
        ? CancelRfqResponse.fromJSON(object.cancelRfqResponse)
        : isSet(object.cancel_rfq_response)
          ? CancelRfqResponse.fromJSON(object.cancel_rfq_response)
          : undefined,
      acceptRfqQuoteResponse: isSet(object.acceptRfqQuoteResponse)
        ? AcceptRfqQuoteResponse.fromJSON(object.acceptRfqQuoteResponse)
        : isSet(object.accept_rfq_quote_response)
          ? AcceptRfqQuoteResponse.fromJSON(object.accept_rfq_quote_response)
          : undefined,
      getRfqMakersResponse: isSet(object.getRfqMakersResponse)
        ? GetRfqMakersResponse.fromJSON(object.getRfqMakersResponse)
        : isSet(object.get_rfq_makers_response)
          ? GetRfqMakersResponse.fromJSON(object.get_rfq_makers_response)
          : undefined,
      getRfqHistoryResponse: isSet(object.getRfqHistoryResponse)
        ? GetRfqHistoryResponse.fromJSON(object.getRfqHistoryResponse)
        : isSet(object.get_rfq_history_response)
          ? GetRfqHistoryResponse.fromJSON(object.get_rfq_history_response)
          : undefined,
      bybitOauthMintStateResponse: isSet(object.bybitOauthMintStateResponse)
        ? BybitOauthMintStateResponse.fromJSON(object.bybitOauthMintStateResponse)
        : isSet(object.bybit_oauth_mint_state_response)
          ? BybitOauthMintStateResponse.fromJSON(object.bybit_oauth_mint_state_response)
          : undefined,
      deribitOauthMintStateResponse: isSet(object.deribitOauthMintStateResponse)
        ? DeribitOauthMintStateResponse.fromJSON(object.deribitOauthMintStateResponse)
        : isSet(object.deribit_oauth_mint_state_response)
          ? DeribitOauthMintStateResponse.fromJSON(object.deribit_oauth_mint_state_response)
          : undefined,
      hyperliquidPrepareAgentResponse: isSet(object.hyperliquidPrepareAgentResponse)
        ? HyperliquidPrepareAgentResponse.fromJSON(object.hyperliquidPrepareAgentResponse)
        : isSet(object.hyperliquid_prepare_agent_response)
          ? HyperliquidPrepareAgentResponse.fromJSON(object.hyperliquid_prepare_agent_response)
          : undefined,
      derivePrepareSessionKeyResponse: isSet(object.derivePrepareSessionKeyResponse)
        ? DerivePrepareSessionKeyResponse.fromJSON(object.derivePrepareSessionKeyResponse)
        : isSet(object.derive_prepare_session_key_response)
          ? DerivePrepareSessionKeyResponse.fromJSON(object.derive_prepare_session_key_response)
          : undefined,
      deriveListSubaccountsResponse: isSet(object.deriveListSubaccountsResponse)
        ? DeriveListSubaccountsResponse.fromJSON(object.deriveListSubaccountsResponse)
        : isSet(object.derive_list_subaccounts_response)
          ? DeriveListSubaccountsResponse.fromJSON(object.derive_list_subaccounts_response)
          : undefined,
      deriveLinkSubaccountsResponse: isSet(object.deriveLinkSubaccountsResponse)
        ? DeriveLinkSubaccountsResponse.fromJSON(object.deriveLinkSubaccountsResponse)
        : isSet(object.derive_link_subaccounts_response)
          ? DeriveLinkSubaccountsResponse.fromJSON(object.derive_link_subaccounts_response)
          : undefined,
      hyperliquidListSubaccountsResponse: isSet(object.hyperliquidListSubaccountsResponse)
        ? HyperliquidListSubaccountsResponse.fromJSON(object.hyperliquidListSubaccountsResponse)
        : isSet(object.hyperliquid_list_subaccounts_response)
          ? HyperliquidListSubaccountsResponse.fromJSON(
              object.hyperliquid_list_subaccounts_response
            )
          : undefined,
      hyperliquidLinkSubaccountsResponse: isSet(object.hyperliquidLinkSubaccountsResponse)
        ? HyperliquidLinkSubaccountsResponse.fromJSON(object.hyperliquidLinkSubaccountsResponse)
        : isSet(object.hyperliquid_link_subaccounts_response)
          ? HyperliquidLinkSubaccountsResponse.fromJSON(
              object.hyperliquid_link_subaccounts_response
            )
          : undefined,
      lighterListSubaccountsResponse: isSet(object.lighterListSubaccountsResponse)
        ? LighterListSubaccountsResponse.fromJSON(object.lighterListSubaccountsResponse)
        : isSet(object.lighter_list_subaccounts_response)
          ? LighterListSubaccountsResponse.fromJSON(object.lighter_list_subaccounts_response)
          : undefined,
      lighterPrepareSubaccountKeyResponse: isSet(object.lighterPrepareSubaccountKeyResponse)
        ? LighterPrepareSubaccountKeyResponse.fromJSON(object.lighterPrepareSubaccountKeyResponse)
        : isSet(object.lighter_prepare_subaccount_key_response)
          ? LighterPrepareSubaccountKeyResponse.fromJSON(
              object.lighter_prepare_subaccount_key_response
            )
          : undefined,
      lighterConfirmSubaccountKeyResponse: isSet(object.lighterConfirmSubaccountKeyResponse)
        ? LighterConfirmSubaccountKeyResponse.fromJSON(object.lighterConfirmSubaccountKeyResponse)
        : isSet(object.lighter_confirm_subaccount_key_response)
          ? LighterConfirmSubaccountKeyResponse.fromJSON(
              object.lighter_confirm_subaccount_key_response
            )
          : undefined,
      lighterLinkSubaccountsResponse: isSet(object.lighterLinkSubaccountsResponse)
        ? LighterLinkSubaccountsResponse.fromJSON(object.lighterLinkSubaccountsResponse)
        : isSet(object.lighter_link_subaccounts_response)
          ? LighterLinkSubaccountsResponse.fromJSON(object.lighter_link_subaccounts_response)
          : undefined,
      lighterPrepareIntegratorConsentResponse: isSet(object.lighterPrepareIntegratorConsentResponse)
        ? LighterPrepareIntegratorConsentResponse.fromJSON(
            object.lighterPrepareIntegratorConsentResponse
          )
        : isSet(object.lighter_prepare_integrator_consent_response)
          ? LighterPrepareIntegratorConsentResponse.fromJSON(
              object.lighter_prepare_integrator_consent_response
            )
          : undefined,
      lighterConfirmIntegratorConsentResponse: isSet(object.lighterConfirmIntegratorConsentResponse)
        ? LighterConfirmIntegratorConsentResponse.fromJSON(
            object.lighterConfirmIntegratorConsentResponse
          )
        : isSet(object.lighter_confirm_integrator_consent_response)
          ? LighterConfirmIntegratorConsentResponse.fromJSON(
              object.lighter_confirm_integrator_consent_response
            )
          : undefined,
      createCheckoutSessionResponse: isSet(object.createCheckoutSessionResponse)
        ? CreateCheckoutSessionResponse.fromJSON(object.createCheckoutSessionResponse)
        : isSet(object.create_checkout_session_response)
          ? CreateCheckoutSessionResponse.fromJSON(object.create_checkout_session_response)
          : undefined,
      getSubscriptionResponse: isSet(object.getSubscriptionResponse)
        ? GetSubscriptionResponse.fromJSON(object.getSubscriptionResponse)
        : isSet(object.get_subscription_response)
          ? GetSubscriptionResponse.fromJSON(object.get_subscription_response)
          : undefined,
      openBillingPortalResponse: isSet(object.openBillingPortalResponse)
        ? OpenBillingPortalResponse.fromJSON(object.openBillingPortalResponse)
        : isSet(object.open_billing_portal_response)
          ? OpenBillingPortalResponse.fromJSON(object.open_billing_portal_response)
          : undefined,
      getPlansResponse: isSet(object.getPlansResponse)
        ? GetPlansResponse.fromJSON(object.getPlansResponse)
        : isSet(object.get_plans_response)
          ? GetPlansResponse.fromJSON(object.get_plans_response)
          : undefined,
      listAccountAccessResponse: isSet(object.listAccountAccessResponse)
        ? ListAccountAccessResponse.fromJSON(object.listAccountAccessResponse)
        : isSet(object.list_account_access_response)
          ? ListAccountAccessResponse.fromJSON(object.list_account_access_response)
          : undefined,
      listMyInvitesResponse: isSet(object.listMyInvitesResponse)
        ? ListMyInvitesResponse.fromJSON(object.listMyInvitesResponse)
        : isSet(object.list_my_invites_response)
          ? ListMyInvitesResponse.fromJSON(object.list_my_invites_response)
          : undefined,
      orderPreviewResponse: isSet(object.orderPreviewResponse)
        ? OrderPreviewResponse.fromJSON(object.orderPreviewResponse)
        : isSet(object.order_preview_response)
          ? OrderPreviewResponse.fromJSON(object.order_preview_response)
          : undefined,
      changePasswordResponse: isSet(object.changePasswordResponse)
        ? ChangePasswordResponse.fromJSON(object.changePasswordResponse)
        : isSet(object.change_password_response)
          ? ChangePasswordResponse.fromJSON(object.change_password_response)
          : undefined,
      listSessionsResponse: isSet(object.listSessionsResponse)
        ? ListSessionsResponse.fromJSON(object.listSessionsResponse)
        : isSet(object.list_sessions_response)
          ? ListSessionsResponse.fromJSON(object.list_sessions_response)
          : undefined,
      revokeSessionResponse: isSet(object.revokeSessionResponse)
        ? RevokeSessionResponse.fromJSON(object.revokeSessionResponse)
        : isSet(object.revoke_session_response)
          ? RevokeSessionResponse.fromJSON(object.revoke_session_response)
          : undefined,
      logoutResponse: isSet(object.logoutResponse)
        ? LogoutResponse.fromJSON(object.logoutResponse)
        : isSet(object.logout_response)
          ? LogoutResponse.fromJSON(object.logout_response)
          : undefined,
      revokeAllOtherSessionsResponse: isSet(object.revokeAllOtherSessionsResponse)
        ? RevokeAllOtherSessionsResponse.fromJSON(object.revokeAllOtherSessionsResponse)
        : isSet(object.revoke_all_other_sessions_response)
          ? RevokeAllOtherSessionsResponse.fromJSON(object.revoke_all_other_sessions_response)
          : undefined,
      sendStepUpCodeResponse: isSet(object.sendStepUpCodeResponse)
        ? SendStepUpCodeResponse.fromJSON(object.sendStepUpCodeResponse)
        : isSet(object.send_step_up_code_response)
          ? SendStepUpCodeResponse.fromJSON(object.send_step_up_code_response)
          : undefined,
      batchOrderPreviewResponse: isSet(object.batchOrderPreviewResponse)
        ? BatchOrderPreviewResponse.fromJSON(object.batchOrderPreviewResponse)
        : isSet(object.batch_order_preview_response)
          ? BatchOrderPreviewResponse.fromJSON(object.batch_order_preview_response)
          : undefined,
      mintMessagingLinkNonceResponse: isSet(object.mintMessagingLinkNonceResponse)
        ? MintMessagingLinkNonceResponse.fromJSON(object.mintMessagingLinkNonceResponse)
        : isSet(object.mint_messaging_link_nonce_response)
          ? MintMessagingLinkNonceResponse.fromJSON(object.mint_messaging_link_nonce_response)
          : undefined,
      paradigmConnectDeskResponse: isSet(object.paradigmConnectDeskResponse)
        ? ParadigmConnectDeskResponse.fromJSON(object.paradigmConnectDeskResponse)
        : isSet(object.paradigm_connect_desk_response)
          ? ParadigmConnectDeskResponse.fromJSON(object.paradigm_connect_desk_response)
          : undefined,
      paradigmListAccountsResponse: isSet(object.paradigmListAccountsResponse)
        ? ParadigmListAccountsResponse.fromJSON(object.paradigmListAccountsResponse)
        : isSet(object.paradigm_list_accounts_response)
          ? ParadigmListAccountsResponse.fromJSON(object.paradigm_list_accounts_response)
          : undefined,
      paradigmLinkAccountResponse: isSet(object.paradigmLinkAccountResponse)
        ? ParadigmLinkAccountResponse.fromJSON(object.paradigmLinkAccountResponse)
        : isSet(object.paradigm_link_account_response)
          ? ParadigmLinkAccountResponse.fromJSON(object.paradigm_link_account_response)
          : undefined,
      createSharedLayoutResponse: isSet(object.createSharedLayoutResponse)
        ? CreateSharedLayoutResponse.fromJSON(object.createSharedLayoutResponse)
        : isSet(object.create_shared_layout_response)
          ? CreateSharedLayoutResponse.fromJSON(object.create_shared_layout_response)
          : undefined,
      getSharedLayoutResponse: isSet(object.getSharedLayoutResponse)
        ? GetSharedLayoutResponse.fromJSON(object.getSharedLayoutResponse)
        : isSet(object.get_shared_layout_response)
          ? GetSharedLayoutResponse.fromJSON(object.get_shared_layout_response)
          : undefined,
      createApiKeyResponse: isSet(object.createApiKeyResponse)
        ? CreateApiKeyResponse.fromJSON(object.createApiKeyResponse)
        : isSet(object.create_api_key_response)
          ? CreateApiKeyResponse.fromJSON(object.create_api_key_response)
          : undefined,
      listApiKeysResponse: isSet(object.listApiKeysResponse)
        ? ListApiKeysResponse.fromJSON(object.listApiKeysResponse)
        : isSet(object.list_api_keys_response)
          ? ListApiKeysResponse.fromJSON(object.list_api_keys_response)
          : undefined,
      revokeApiKeyResponse: isSet(object.revokeApiKeyResponse)
        ? RevokeApiKeyResponse.fromJSON(object.revokeApiKeyResponse)
        : isSet(object.revoke_api_key_response)
          ? RevokeApiKeyResponse.fromJSON(object.revoke_api_key_response)
          : undefined,
      getApiBillingResponse: isSet(object.getApiBillingResponse)
        ? GetApiBillingResponse.fromJSON(object.getApiBillingResponse)
        : isSet(object.get_api_billing_response)
          ? GetApiBillingResponse.fromJSON(object.get_api_billing_response)
          : undefined,
      updateApiBillingSettingsResponse: isSet(object.updateApiBillingSettingsResponse)
        ? UpdateApiBillingSettingsResponse.fromJSON(object.updateApiBillingSettingsResponse)
        : isSet(object.update_api_billing_settings_response)
          ? UpdateApiBillingSettingsResponse.fromJSON(object.update_api_billing_settings_response)
          : undefined,
      createCreditCheckoutSessionResponse: isSet(object.createCreditCheckoutSessionResponse)
        ? CreateCreditCheckoutSessionResponse.fromJSON(object.createCreditCheckoutSessionResponse)
        : isSet(object.create_credit_checkout_session_response)
          ? CreateCreditCheckoutSessionResponse.fromJSON(
              object.create_credit_checkout_session_response
            )
          : undefined,
      listCreditLedgerResponse: isSet(object.listCreditLedgerResponse)
        ? ListCreditLedgerResponse.fromJSON(object.listCreditLedgerResponse)
        : isSet(object.list_credit_ledger_response)
          ? ListCreditLedgerResponse.fromJSON(object.list_credit_ledger_response)
          : undefined,
      getCreditSpendStatsResponse: isSet(object.getCreditSpendStatsResponse)
        ? GetCreditSpendStatsResponse.fromJSON(object.getCreditSpendStatsResponse)
        : isSet(object.get_credit_spend_stats_response)
          ? GetCreditSpendStatsResponse.fromJSON(object.get_credit_spend_stats_response)
          : undefined,
      sendRfqMakerQuoteResponse: isSet(object.sendRfqMakerQuoteResponse)
        ? SendRfqMakerQuoteResponse.fromJSON(object.sendRfqMakerQuoteResponse)
        : isSet(object.send_rfq_maker_quote_response)
          ? SendRfqMakerQuoteResponse.fromJSON(object.send_rfq_maker_quote_response)
          : undefined,
      cancelRfqMakerQuoteResponse: isSet(object.cancelRfqMakerQuoteResponse)
        ? CancelRfqMakerQuoteResponse.fromJSON(object.cancelRfqMakerQuoteResponse)
        : isSet(object.cancel_rfq_maker_quote_response)
          ? CancelRfqMakerQuoteResponse.fromJSON(object.cancel_rfq_maker_quote_response)
          : undefined,
      setLeverageResponse: isSet(object.setLeverageResponse)
        ? SetLeverageResponse.fromJSON(object.setLeverageResponse)
        : isSet(object.set_leverage_response)
          ? SetLeverageResponse.fromJSON(object.set_leverage_response)
          : undefined,
      papertradePrepareSessionKeyResponse: isSet(object.papertradePrepareSessionKeyResponse)
        ? PapertradePrepareSessionKeyResponse.fromJSON(object.papertradePrepareSessionKeyResponse)
        : isSet(object.papertrade_prepare_session_key_response)
          ? PapertradePrepareSessionKeyResponse.fromJSON(
              object.papertrade_prepare_session_key_response
            )
          : undefined,
      accountSettings: isSet(object.accountSettings)
        ? AccountSettings.fromJSON(object.accountSettings)
        : isSet(object.account_settings)
          ? AccountSettings.fromJSON(object.account_settings)
          : undefined,
    }
  },

  toJSON(message: ServerMessage): unknown {
    const obj: any = {}
    if (message.subscribed !== undefined) {
      obj.subscribed = Subscribed.toJSON(message.subscribed)
    }
    if (message.unsubscribed !== undefined) {
      obj.unsubscribed = Unsubscribed.toJSON(message.unsubscribed)
    }
    if (message.ping !== undefined) {
      obj.ping = Ping.toJSON(message.ping)
    }
    if (message.pong !== undefined) {
      obj.pong = Pong.toJSON(message.pong)
    }
    if (message.data !== undefined) {
      obj.data = DataPayload.toJSON(message.data)
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error)
    }
    if (message.success !== undefined) {
      obj.success = Success.toJSON(message.success)
    }
    if (message.authenticateResponse !== undefined) {
      obj.authenticateResponse = AuthenticateResponse.toJSON(message.authenticateResponse)
    }
    if (message.loginResponse !== undefined) {
      obj.loginResponse = LoginResponse.toJSON(message.loginResponse)
    }
    if (message.signupResponse !== undefined) {
      obj.signupResponse = SignupResponse.toJSON(message.signupResponse)
    }
    if (message.userAccountsResponse !== undefined) {
      obj.userAccountsResponse = PublicAccountList.toJSON(message.userAccountsResponse)
    }
    if (message.requestPasswordResetResponse !== undefined) {
      obj.requestPasswordResetResponse = RequestPasswordResetResponse.toJSON(
        message.requestPasswordResetResponse
      )
    }
    if (message.confirmPasswordResetResponse !== undefined) {
      obj.confirmPasswordResetResponse = ConfirmPasswordResetResponse.toJSON(
        message.confirmPasswordResetResponse
      )
    }
    if (message.refreshTokenResponse !== undefined) {
      obj.refreshTokenResponse = RefreshTokenResponse.toJSON(message.refreshTokenResponse)
    }
    if (message.verifyEmailResponse !== undefined) {
      obj.verifyEmailResponse = VerifyEmailResponse.toJSON(message.verifyEmailResponse)
    }
    if (message.resendVerificationResponse !== undefined) {
      obj.resendVerificationResponse = ResendVerificationResponse.toJSON(
        message.resendVerificationResponse
      )
    }
    if (message.setup2faResponse !== undefined) {
      obj.setup2faResponse = Setup2faResponse.toJSON(message.setup2faResponse)
    }
    if (message.confirm2faSetupResponse !== undefined) {
      obj.confirm2faSetupResponse = Confirm2faSetupResponse.toJSON(message.confirm2faSetupResponse)
    }
    if (message.verify2faResponse !== undefined) {
      obj.verify2faResponse = Verify2faResponse.toJSON(message.verify2faResponse)
    }
    if (message.verify2faLoginResponse !== undefined) {
      obj.verify2faLoginResponse = Verify2faLoginResponse.toJSON(message.verify2faLoginResponse)
    }
    if (message.disable2faResponse !== undefined) {
      obj.disable2faResponse = Disable2faResponse.toJSON(message.disable2faResponse)
    }
    if (message.get2faBackupCodesResponse !== undefined) {
      obj.get2faBackupCodesResponse = Get2faBackupCodesResponse.toJSON(
        message.get2faBackupCodesResponse
      )
    }
    if (message.setupPasskeyResponse !== undefined) {
      obj.setupPasskeyResponse = SetupPasskeyResponse.toJSON(message.setupPasskeyResponse)
    }
    if (message.confirmPasskeySetupResponse !== undefined) {
      obj.confirmPasskeySetupResponse = ConfirmPasskeySetupResponse.toJSON(
        message.confirmPasskeySetupResponse
      )
    }
    if (message.passkeyLoginResponse !== undefined) {
      obj.passkeyLoginResponse = PasskeyLoginResponse.toJSON(message.passkeyLoginResponse)
    }
    if (message.confirmPasskeyLoginResponse !== undefined) {
      obj.confirmPasskeyLoginResponse = ConfirmPasskeyLoginResponse.toJSON(
        message.confirmPasskeyLoginResponse
      )
    }
    if (message.deletePasskeyResponse !== undefined) {
      obj.deletePasskeyResponse = DeletePasskeyResponse.toJSON(message.deletePasskeyResponse)
    }
    if (message.getUserPasskeysResponse !== undefined) {
      obj.getUserPasskeysResponse = GetUserPasskeysResponse.toJSON(message.getUserPasskeysResponse)
    }
    if (message.googleLoginResponse !== undefined) {
      obj.googleLoginResponse = GoogleLoginResponse.toJSON(message.googleLoginResponse)
    }
    if (message.verifyResponse !== undefined) {
      obj.verifyResponse = VerifyTokenResponse.toJSON(message.verifyResponse)
    }
    if (message.timeResponse !== undefined) {
      obj.timeResponse = TimeResponse.toJSON(message.timeResponse)
    }
    if (message.createAccountResponse !== undefined) {
      obj.createAccountResponse = CreateAccountResponse.toJSON(message.createAccountResponse)
    }
    if (message.compressedPayload !== undefined) {
      obj.compressedPayload = CompressedPayload.toJSON(message.compressedPayload)
    }
    if (message.executionPlan !== undefined) {
      obj.executionPlan = DraftExecutionPlan.toJSON(message.executionPlan)
    }
    if (message.getPagesResponse !== undefined) {
      obj.getPagesResponse = GetPagesResponse.toJSON(message.getPagesResponse)
    }
    if (message.getPageLayoutResponse !== undefined) {
      obj.getPageLayoutResponse = GetPageLayoutResponse.toJSON(message.getPageLayoutResponse)
    }
    if (message.pageMutationResponse !== undefined) {
      obj.pageMutationResponse = PageMutationResponse.toJSON(message.pageMutationResponse)
    }
    if (message.componentPreferenceResponse !== undefined) {
      obj.componentPreferenceResponse = ComponentPreferenceResponse.toJSON(
        message.componentPreferenceResponse
      )
    }
    if (message.positionGroupMutationResponse !== undefined) {
      obj.positionGroupMutationResponse = PositionGroupMutationResponse.toJSON(
        message.positionGroupMutationResponse
      )
    }
    if (message.getPositionGroupsResponse !== undefined) {
      obj.getPositionGroupsResponse = GetPositionGroupsResponse.toJSON(
        message.getPositionGroupsResponse
      )
    }
    if (message.getPositionsViewResponse !== undefined) {
      obj.getPositionsViewResponse = GetPositionsViewResponse.toJSON(
        message.getPositionsViewResponse
      )
    }
    if (message.createPresetResponse !== undefined) {
      obj.createPresetResponse = CreatePresetResponse.toJSON(message.createPresetResponse)
    }
    if (message.updatePresetResponse !== undefined) {
      obj.updatePresetResponse = UpdatePresetResponse.toJSON(message.updatePresetResponse)
    }
    if (message.deletePresetResponse !== undefined) {
      obj.deletePresetResponse = DeletePresetResponse.toJSON(message.deletePresetResponse)
    }
    if (message.listPresetsResponse !== undefined) {
      obj.listPresetsResponse = ListPresetsResponse.toJSON(message.listPresetsResponse)
    }
    if (message.executePresetResponse !== undefined) {
      obj.executePresetResponse = ExecutePresetResponse.toJSON(message.executePresetResponse)
    }
    if (message.getPresetResponse !== undefined) {
      obj.getPresetResponse = GetPresetResponse.toJSON(message.getPresetResponse)
    }
    if (message.watchlistMutationResponse !== undefined) {
      obj.watchlistMutationResponse = WatchlistMutationResponse.toJSON(
        message.watchlistMutationResponse
      )
    }
    if (message.getWatchlistsResponse !== undefined) {
      obj.getWatchlistsResponse = GetWatchlistsResponse.toJSON(message.getWatchlistsResponse)
    }
    if (message.confirmExecutionPlanResponse !== undefined) {
      obj.confirmExecutionPlanResponse = ConfirmExecutionPlanResponse.toJSON(
        message.confirmExecutionPlanResponse
      )
    }
    if (message.createRfqResponse !== undefined) {
      obj.createRfqResponse = CreateRfqResponse.toJSON(message.createRfqResponse)
    }
    if (message.cancelRfqResponse !== undefined) {
      obj.cancelRfqResponse = CancelRfqResponse.toJSON(message.cancelRfqResponse)
    }
    if (message.acceptRfqQuoteResponse !== undefined) {
      obj.acceptRfqQuoteResponse = AcceptRfqQuoteResponse.toJSON(message.acceptRfqQuoteResponse)
    }
    if (message.getRfqMakersResponse !== undefined) {
      obj.getRfqMakersResponse = GetRfqMakersResponse.toJSON(message.getRfqMakersResponse)
    }
    if (message.getRfqHistoryResponse !== undefined) {
      obj.getRfqHistoryResponse = GetRfqHistoryResponse.toJSON(message.getRfqHistoryResponse)
    }
    if (message.bybitOauthMintStateResponse !== undefined) {
      obj.bybitOauthMintStateResponse = BybitOauthMintStateResponse.toJSON(
        message.bybitOauthMintStateResponse
      )
    }
    if (message.deribitOauthMintStateResponse !== undefined) {
      obj.deribitOauthMintStateResponse = DeribitOauthMintStateResponse.toJSON(
        message.deribitOauthMintStateResponse
      )
    }
    if (message.hyperliquidPrepareAgentResponse !== undefined) {
      obj.hyperliquidPrepareAgentResponse = HyperliquidPrepareAgentResponse.toJSON(
        message.hyperliquidPrepareAgentResponse
      )
    }
    if (message.derivePrepareSessionKeyResponse !== undefined) {
      obj.derivePrepareSessionKeyResponse = DerivePrepareSessionKeyResponse.toJSON(
        message.derivePrepareSessionKeyResponse
      )
    }
    if (message.deriveListSubaccountsResponse !== undefined) {
      obj.deriveListSubaccountsResponse = DeriveListSubaccountsResponse.toJSON(
        message.deriveListSubaccountsResponse
      )
    }
    if (message.deriveLinkSubaccountsResponse !== undefined) {
      obj.deriveLinkSubaccountsResponse = DeriveLinkSubaccountsResponse.toJSON(
        message.deriveLinkSubaccountsResponse
      )
    }
    if (message.hyperliquidListSubaccountsResponse !== undefined) {
      obj.hyperliquidListSubaccountsResponse = HyperliquidListSubaccountsResponse.toJSON(
        message.hyperliquidListSubaccountsResponse
      )
    }
    if (message.hyperliquidLinkSubaccountsResponse !== undefined) {
      obj.hyperliquidLinkSubaccountsResponse = HyperliquidLinkSubaccountsResponse.toJSON(
        message.hyperliquidLinkSubaccountsResponse
      )
    }
    if (message.lighterListSubaccountsResponse !== undefined) {
      obj.lighterListSubaccountsResponse = LighterListSubaccountsResponse.toJSON(
        message.lighterListSubaccountsResponse
      )
    }
    if (message.lighterPrepareSubaccountKeyResponse !== undefined) {
      obj.lighterPrepareSubaccountKeyResponse = LighterPrepareSubaccountKeyResponse.toJSON(
        message.lighterPrepareSubaccountKeyResponse
      )
    }
    if (message.lighterConfirmSubaccountKeyResponse !== undefined) {
      obj.lighterConfirmSubaccountKeyResponse = LighterConfirmSubaccountKeyResponse.toJSON(
        message.lighterConfirmSubaccountKeyResponse
      )
    }
    if (message.lighterLinkSubaccountsResponse !== undefined) {
      obj.lighterLinkSubaccountsResponse = LighterLinkSubaccountsResponse.toJSON(
        message.lighterLinkSubaccountsResponse
      )
    }
    if (message.lighterPrepareIntegratorConsentResponse !== undefined) {
      obj.lighterPrepareIntegratorConsentResponse = LighterPrepareIntegratorConsentResponse.toJSON(
        message.lighterPrepareIntegratorConsentResponse
      )
    }
    if (message.lighterConfirmIntegratorConsentResponse !== undefined) {
      obj.lighterConfirmIntegratorConsentResponse = LighterConfirmIntegratorConsentResponse.toJSON(
        message.lighterConfirmIntegratorConsentResponse
      )
    }
    if (message.createCheckoutSessionResponse !== undefined) {
      obj.createCheckoutSessionResponse = CreateCheckoutSessionResponse.toJSON(
        message.createCheckoutSessionResponse
      )
    }
    if (message.getSubscriptionResponse !== undefined) {
      obj.getSubscriptionResponse = GetSubscriptionResponse.toJSON(message.getSubscriptionResponse)
    }
    if (message.openBillingPortalResponse !== undefined) {
      obj.openBillingPortalResponse = OpenBillingPortalResponse.toJSON(
        message.openBillingPortalResponse
      )
    }
    if (message.getPlansResponse !== undefined) {
      obj.getPlansResponse = GetPlansResponse.toJSON(message.getPlansResponse)
    }
    if (message.listAccountAccessResponse !== undefined) {
      obj.listAccountAccessResponse = ListAccountAccessResponse.toJSON(
        message.listAccountAccessResponse
      )
    }
    if (message.listMyInvitesResponse !== undefined) {
      obj.listMyInvitesResponse = ListMyInvitesResponse.toJSON(message.listMyInvitesResponse)
    }
    if (message.orderPreviewResponse !== undefined) {
      obj.orderPreviewResponse = OrderPreviewResponse.toJSON(message.orderPreviewResponse)
    }
    if (message.changePasswordResponse !== undefined) {
      obj.changePasswordResponse = ChangePasswordResponse.toJSON(message.changePasswordResponse)
    }
    if (message.listSessionsResponse !== undefined) {
      obj.listSessionsResponse = ListSessionsResponse.toJSON(message.listSessionsResponse)
    }
    if (message.revokeSessionResponse !== undefined) {
      obj.revokeSessionResponse = RevokeSessionResponse.toJSON(message.revokeSessionResponse)
    }
    if (message.logoutResponse !== undefined) {
      obj.logoutResponse = LogoutResponse.toJSON(message.logoutResponse)
    }
    if (message.revokeAllOtherSessionsResponse !== undefined) {
      obj.revokeAllOtherSessionsResponse = RevokeAllOtherSessionsResponse.toJSON(
        message.revokeAllOtherSessionsResponse
      )
    }
    if (message.sendStepUpCodeResponse !== undefined) {
      obj.sendStepUpCodeResponse = SendStepUpCodeResponse.toJSON(message.sendStepUpCodeResponse)
    }
    if (message.batchOrderPreviewResponse !== undefined) {
      obj.batchOrderPreviewResponse = BatchOrderPreviewResponse.toJSON(
        message.batchOrderPreviewResponse
      )
    }
    if (message.mintMessagingLinkNonceResponse !== undefined) {
      obj.mintMessagingLinkNonceResponse = MintMessagingLinkNonceResponse.toJSON(
        message.mintMessagingLinkNonceResponse
      )
    }
    if (message.paradigmConnectDeskResponse !== undefined) {
      obj.paradigmConnectDeskResponse = ParadigmConnectDeskResponse.toJSON(
        message.paradigmConnectDeskResponse
      )
    }
    if (message.paradigmListAccountsResponse !== undefined) {
      obj.paradigmListAccountsResponse = ParadigmListAccountsResponse.toJSON(
        message.paradigmListAccountsResponse
      )
    }
    if (message.paradigmLinkAccountResponse !== undefined) {
      obj.paradigmLinkAccountResponse = ParadigmLinkAccountResponse.toJSON(
        message.paradigmLinkAccountResponse
      )
    }
    if (message.createSharedLayoutResponse !== undefined) {
      obj.createSharedLayoutResponse = CreateSharedLayoutResponse.toJSON(
        message.createSharedLayoutResponse
      )
    }
    if (message.getSharedLayoutResponse !== undefined) {
      obj.getSharedLayoutResponse = GetSharedLayoutResponse.toJSON(message.getSharedLayoutResponse)
    }
    if (message.createApiKeyResponse !== undefined) {
      obj.createApiKeyResponse = CreateApiKeyResponse.toJSON(message.createApiKeyResponse)
    }
    if (message.listApiKeysResponse !== undefined) {
      obj.listApiKeysResponse = ListApiKeysResponse.toJSON(message.listApiKeysResponse)
    }
    if (message.revokeApiKeyResponse !== undefined) {
      obj.revokeApiKeyResponse = RevokeApiKeyResponse.toJSON(message.revokeApiKeyResponse)
    }
    if (message.getApiBillingResponse !== undefined) {
      obj.getApiBillingResponse = GetApiBillingResponse.toJSON(message.getApiBillingResponse)
    }
    if (message.updateApiBillingSettingsResponse !== undefined) {
      obj.updateApiBillingSettingsResponse = UpdateApiBillingSettingsResponse.toJSON(
        message.updateApiBillingSettingsResponse
      )
    }
    if (message.createCreditCheckoutSessionResponse !== undefined) {
      obj.createCreditCheckoutSessionResponse = CreateCreditCheckoutSessionResponse.toJSON(
        message.createCreditCheckoutSessionResponse
      )
    }
    if (message.listCreditLedgerResponse !== undefined) {
      obj.listCreditLedgerResponse = ListCreditLedgerResponse.toJSON(
        message.listCreditLedgerResponse
      )
    }
    if (message.getCreditSpendStatsResponse !== undefined) {
      obj.getCreditSpendStatsResponse = GetCreditSpendStatsResponse.toJSON(
        message.getCreditSpendStatsResponse
      )
    }
    if (message.sendRfqMakerQuoteResponse !== undefined) {
      obj.sendRfqMakerQuoteResponse = SendRfqMakerQuoteResponse.toJSON(
        message.sendRfqMakerQuoteResponse
      )
    }
    if (message.cancelRfqMakerQuoteResponse !== undefined) {
      obj.cancelRfqMakerQuoteResponse = CancelRfqMakerQuoteResponse.toJSON(
        message.cancelRfqMakerQuoteResponse
      )
    }
    if (message.setLeverageResponse !== undefined) {
      obj.setLeverageResponse = SetLeverageResponse.toJSON(message.setLeverageResponse)
    }
    if (message.papertradePrepareSessionKeyResponse !== undefined) {
      obj.papertradePrepareSessionKeyResponse = PapertradePrepareSessionKeyResponse.toJSON(
        message.papertradePrepareSessionKeyResponse
      )
    }
    if (message.accountSettings !== undefined) {
      obj.accountSettings = AccountSettings.toJSON(message.accountSettings)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ServerMessage>, I>>(base?: I): ServerMessage {
    return ServerMessage.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ServerMessage>, I>>(object: I): ServerMessage {
    const message = createBaseServerMessage()
    message.subscribed =
      object.subscribed !== undefined && object.subscribed !== null
        ? Subscribed.fromPartial(object.subscribed)
        : undefined
    message.unsubscribed =
      object.unsubscribed !== undefined && object.unsubscribed !== null
        ? Unsubscribed.fromPartial(object.unsubscribed)
        : undefined
    message.ping =
      object.ping !== undefined && object.ping !== null ? Ping.fromPartial(object.ping) : undefined
    message.pong =
      object.pong !== undefined && object.pong !== null ? Pong.fromPartial(object.pong) : undefined
    message.data =
      object.data !== undefined && object.data !== null
        ? DataPayload.fromPartial(object.data)
        : undefined
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined
    message.success =
      object.success !== undefined && object.success !== null
        ? Success.fromPartial(object.success)
        : undefined
    message.authenticateResponse =
      object.authenticateResponse !== undefined && object.authenticateResponse !== null
        ? AuthenticateResponse.fromPartial(object.authenticateResponse)
        : undefined
    message.loginResponse =
      object.loginResponse !== undefined && object.loginResponse !== null
        ? LoginResponse.fromPartial(object.loginResponse)
        : undefined
    message.signupResponse =
      object.signupResponse !== undefined && object.signupResponse !== null
        ? SignupResponse.fromPartial(object.signupResponse)
        : undefined
    message.userAccountsResponse =
      object.userAccountsResponse !== undefined && object.userAccountsResponse !== null
        ? PublicAccountList.fromPartial(object.userAccountsResponse)
        : undefined
    message.requestPasswordResetResponse =
      object.requestPasswordResetResponse !== undefined &&
      object.requestPasswordResetResponse !== null
        ? RequestPasswordResetResponse.fromPartial(object.requestPasswordResetResponse)
        : undefined
    message.confirmPasswordResetResponse =
      object.confirmPasswordResetResponse !== undefined &&
      object.confirmPasswordResetResponse !== null
        ? ConfirmPasswordResetResponse.fromPartial(object.confirmPasswordResetResponse)
        : undefined
    message.refreshTokenResponse =
      object.refreshTokenResponse !== undefined && object.refreshTokenResponse !== null
        ? RefreshTokenResponse.fromPartial(object.refreshTokenResponse)
        : undefined
    message.verifyEmailResponse =
      object.verifyEmailResponse !== undefined && object.verifyEmailResponse !== null
        ? VerifyEmailResponse.fromPartial(object.verifyEmailResponse)
        : undefined
    message.resendVerificationResponse =
      object.resendVerificationResponse !== undefined && object.resendVerificationResponse !== null
        ? ResendVerificationResponse.fromPartial(object.resendVerificationResponse)
        : undefined
    message.setup2faResponse =
      object.setup2faResponse !== undefined && object.setup2faResponse !== null
        ? Setup2faResponse.fromPartial(object.setup2faResponse)
        : undefined
    message.confirm2faSetupResponse =
      object.confirm2faSetupResponse !== undefined && object.confirm2faSetupResponse !== null
        ? Confirm2faSetupResponse.fromPartial(object.confirm2faSetupResponse)
        : undefined
    message.verify2faResponse =
      object.verify2faResponse !== undefined && object.verify2faResponse !== null
        ? Verify2faResponse.fromPartial(object.verify2faResponse)
        : undefined
    message.verify2faLoginResponse =
      object.verify2faLoginResponse !== undefined && object.verify2faLoginResponse !== null
        ? Verify2faLoginResponse.fromPartial(object.verify2faLoginResponse)
        : undefined
    message.disable2faResponse =
      object.disable2faResponse !== undefined && object.disable2faResponse !== null
        ? Disable2faResponse.fromPartial(object.disable2faResponse)
        : undefined
    message.get2faBackupCodesResponse =
      object.get2faBackupCodesResponse !== undefined && object.get2faBackupCodesResponse !== null
        ? Get2faBackupCodesResponse.fromPartial(object.get2faBackupCodesResponse)
        : undefined
    message.setupPasskeyResponse =
      object.setupPasskeyResponse !== undefined && object.setupPasskeyResponse !== null
        ? SetupPasskeyResponse.fromPartial(object.setupPasskeyResponse)
        : undefined
    message.confirmPasskeySetupResponse =
      object.confirmPasskeySetupResponse !== undefined &&
      object.confirmPasskeySetupResponse !== null
        ? ConfirmPasskeySetupResponse.fromPartial(object.confirmPasskeySetupResponse)
        : undefined
    message.passkeyLoginResponse =
      object.passkeyLoginResponse !== undefined && object.passkeyLoginResponse !== null
        ? PasskeyLoginResponse.fromPartial(object.passkeyLoginResponse)
        : undefined
    message.confirmPasskeyLoginResponse =
      object.confirmPasskeyLoginResponse !== undefined &&
      object.confirmPasskeyLoginResponse !== null
        ? ConfirmPasskeyLoginResponse.fromPartial(object.confirmPasskeyLoginResponse)
        : undefined
    message.deletePasskeyResponse =
      object.deletePasskeyResponse !== undefined && object.deletePasskeyResponse !== null
        ? DeletePasskeyResponse.fromPartial(object.deletePasskeyResponse)
        : undefined
    message.getUserPasskeysResponse =
      object.getUserPasskeysResponse !== undefined && object.getUserPasskeysResponse !== null
        ? GetUserPasskeysResponse.fromPartial(object.getUserPasskeysResponse)
        : undefined
    message.googleLoginResponse =
      object.googleLoginResponse !== undefined && object.googleLoginResponse !== null
        ? GoogleLoginResponse.fromPartial(object.googleLoginResponse)
        : undefined
    message.verifyResponse =
      object.verifyResponse !== undefined && object.verifyResponse !== null
        ? VerifyTokenResponse.fromPartial(object.verifyResponse)
        : undefined
    message.timeResponse =
      object.timeResponse !== undefined && object.timeResponse !== null
        ? TimeResponse.fromPartial(object.timeResponse)
        : undefined
    message.createAccountResponse =
      object.createAccountResponse !== undefined && object.createAccountResponse !== null
        ? CreateAccountResponse.fromPartial(object.createAccountResponse)
        : undefined
    message.compressedPayload =
      object.compressedPayload !== undefined && object.compressedPayload !== null
        ? CompressedPayload.fromPartial(object.compressedPayload)
        : undefined
    message.executionPlan =
      object.executionPlan !== undefined && object.executionPlan !== null
        ? DraftExecutionPlan.fromPartial(object.executionPlan)
        : undefined
    message.getPagesResponse =
      object.getPagesResponse !== undefined && object.getPagesResponse !== null
        ? GetPagesResponse.fromPartial(object.getPagesResponse)
        : undefined
    message.getPageLayoutResponse =
      object.getPageLayoutResponse !== undefined && object.getPageLayoutResponse !== null
        ? GetPageLayoutResponse.fromPartial(object.getPageLayoutResponse)
        : undefined
    message.pageMutationResponse =
      object.pageMutationResponse !== undefined && object.pageMutationResponse !== null
        ? PageMutationResponse.fromPartial(object.pageMutationResponse)
        : undefined
    message.componentPreferenceResponse =
      object.componentPreferenceResponse !== undefined &&
      object.componentPreferenceResponse !== null
        ? ComponentPreferenceResponse.fromPartial(object.componentPreferenceResponse)
        : undefined
    message.positionGroupMutationResponse =
      object.positionGroupMutationResponse !== undefined &&
      object.positionGroupMutationResponse !== null
        ? PositionGroupMutationResponse.fromPartial(object.positionGroupMutationResponse)
        : undefined
    message.getPositionGroupsResponse =
      object.getPositionGroupsResponse !== undefined && object.getPositionGroupsResponse !== null
        ? GetPositionGroupsResponse.fromPartial(object.getPositionGroupsResponse)
        : undefined
    message.getPositionsViewResponse =
      object.getPositionsViewResponse !== undefined && object.getPositionsViewResponse !== null
        ? GetPositionsViewResponse.fromPartial(object.getPositionsViewResponse)
        : undefined
    message.createPresetResponse =
      object.createPresetResponse !== undefined && object.createPresetResponse !== null
        ? CreatePresetResponse.fromPartial(object.createPresetResponse)
        : undefined
    message.updatePresetResponse =
      object.updatePresetResponse !== undefined && object.updatePresetResponse !== null
        ? UpdatePresetResponse.fromPartial(object.updatePresetResponse)
        : undefined
    message.deletePresetResponse =
      object.deletePresetResponse !== undefined && object.deletePresetResponse !== null
        ? DeletePresetResponse.fromPartial(object.deletePresetResponse)
        : undefined
    message.listPresetsResponse =
      object.listPresetsResponse !== undefined && object.listPresetsResponse !== null
        ? ListPresetsResponse.fromPartial(object.listPresetsResponse)
        : undefined
    message.executePresetResponse =
      object.executePresetResponse !== undefined && object.executePresetResponse !== null
        ? ExecutePresetResponse.fromPartial(object.executePresetResponse)
        : undefined
    message.getPresetResponse =
      object.getPresetResponse !== undefined && object.getPresetResponse !== null
        ? GetPresetResponse.fromPartial(object.getPresetResponse)
        : undefined
    message.watchlistMutationResponse =
      object.watchlistMutationResponse !== undefined && object.watchlistMutationResponse !== null
        ? WatchlistMutationResponse.fromPartial(object.watchlistMutationResponse)
        : undefined
    message.getWatchlistsResponse =
      object.getWatchlistsResponse !== undefined && object.getWatchlistsResponse !== null
        ? GetWatchlistsResponse.fromPartial(object.getWatchlistsResponse)
        : undefined
    message.confirmExecutionPlanResponse =
      object.confirmExecutionPlanResponse !== undefined &&
      object.confirmExecutionPlanResponse !== null
        ? ConfirmExecutionPlanResponse.fromPartial(object.confirmExecutionPlanResponse)
        : undefined
    message.createRfqResponse =
      object.createRfqResponse !== undefined && object.createRfqResponse !== null
        ? CreateRfqResponse.fromPartial(object.createRfqResponse)
        : undefined
    message.cancelRfqResponse =
      object.cancelRfqResponse !== undefined && object.cancelRfqResponse !== null
        ? CancelRfqResponse.fromPartial(object.cancelRfqResponse)
        : undefined
    message.acceptRfqQuoteResponse =
      object.acceptRfqQuoteResponse !== undefined && object.acceptRfqQuoteResponse !== null
        ? AcceptRfqQuoteResponse.fromPartial(object.acceptRfqQuoteResponse)
        : undefined
    message.getRfqMakersResponse =
      object.getRfqMakersResponse !== undefined && object.getRfqMakersResponse !== null
        ? GetRfqMakersResponse.fromPartial(object.getRfqMakersResponse)
        : undefined
    message.getRfqHistoryResponse =
      object.getRfqHistoryResponse !== undefined && object.getRfqHistoryResponse !== null
        ? GetRfqHistoryResponse.fromPartial(object.getRfqHistoryResponse)
        : undefined
    message.bybitOauthMintStateResponse =
      object.bybitOauthMintStateResponse !== undefined &&
      object.bybitOauthMintStateResponse !== null
        ? BybitOauthMintStateResponse.fromPartial(object.bybitOauthMintStateResponse)
        : undefined
    message.deribitOauthMintStateResponse =
      object.deribitOauthMintStateResponse !== undefined &&
      object.deribitOauthMintStateResponse !== null
        ? DeribitOauthMintStateResponse.fromPartial(object.deribitOauthMintStateResponse)
        : undefined
    message.hyperliquidPrepareAgentResponse =
      object.hyperliquidPrepareAgentResponse !== undefined &&
      object.hyperliquidPrepareAgentResponse !== null
        ? HyperliquidPrepareAgentResponse.fromPartial(object.hyperliquidPrepareAgentResponse)
        : undefined
    message.derivePrepareSessionKeyResponse =
      object.derivePrepareSessionKeyResponse !== undefined &&
      object.derivePrepareSessionKeyResponse !== null
        ? DerivePrepareSessionKeyResponse.fromPartial(object.derivePrepareSessionKeyResponse)
        : undefined
    message.deriveListSubaccountsResponse =
      object.deriveListSubaccountsResponse !== undefined &&
      object.deriveListSubaccountsResponse !== null
        ? DeriveListSubaccountsResponse.fromPartial(object.deriveListSubaccountsResponse)
        : undefined
    message.deriveLinkSubaccountsResponse =
      object.deriveLinkSubaccountsResponse !== undefined &&
      object.deriveLinkSubaccountsResponse !== null
        ? DeriveLinkSubaccountsResponse.fromPartial(object.deriveLinkSubaccountsResponse)
        : undefined
    message.hyperliquidListSubaccountsResponse =
      object.hyperliquidListSubaccountsResponse !== undefined &&
      object.hyperliquidListSubaccountsResponse !== null
        ? HyperliquidListSubaccountsResponse.fromPartial(object.hyperliquidListSubaccountsResponse)
        : undefined
    message.hyperliquidLinkSubaccountsResponse =
      object.hyperliquidLinkSubaccountsResponse !== undefined &&
      object.hyperliquidLinkSubaccountsResponse !== null
        ? HyperliquidLinkSubaccountsResponse.fromPartial(object.hyperliquidLinkSubaccountsResponse)
        : undefined
    message.lighterListSubaccountsResponse =
      object.lighterListSubaccountsResponse !== undefined &&
      object.lighterListSubaccountsResponse !== null
        ? LighterListSubaccountsResponse.fromPartial(object.lighterListSubaccountsResponse)
        : undefined
    message.lighterPrepareSubaccountKeyResponse =
      object.lighterPrepareSubaccountKeyResponse !== undefined &&
      object.lighterPrepareSubaccountKeyResponse !== null
        ? LighterPrepareSubaccountKeyResponse.fromPartial(
            object.lighterPrepareSubaccountKeyResponse
          )
        : undefined
    message.lighterConfirmSubaccountKeyResponse =
      object.lighterConfirmSubaccountKeyResponse !== undefined &&
      object.lighterConfirmSubaccountKeyResponse !== null
        ? LighterConfirmSubaccountKeyResponse.fromPartial(
            object.lighterConfirmSubaccountKeyResponse
          )
        : undefined
    message.lighterLinkSubaccountsResponse =
      object.lighterLinkSubaccountsResponse !== undefined &&
      object.lighterLinkSubaccountsResponse !== null
        ? LighterLinkSubaccountsResponse.fromPartial(object.lighterLinkSubaccountsResponse)
        : undefined
    message.lighterPrepareIntegratorConsentResponse =
      object.lighterPrepareIntegratorConsentResponse !== undefined &&
      object.lighterPrepareIntegratorConsentResponse !== null
        ? LighterPrepareIntegratorConsentResponse.fromPartial(
            object.lighterPrepareIntegratorConsentResponse
          )
        : undefined
    message.lighterConfirmIntegratorConsentResponse =
      object.lighterConfirmIntegratorConsentResponse !== undefined &&
      object.lighterConfirmIntegratorConsentResponse !== null
        ? LighterConfirmIntegratorConsentResponse.fromPartial(
            object.lighterConfirmIntegratorConsentResponse
          )
        : undefined
    message.createCheckoutSessionResponse =
      object.createCheckoutSessionResponse !== undefined &&
      object.createCheckoutSessionResponse !== null
        ? CreateCheckoutSessionResponse.fromPartial(object.createCheckoutSessionResponse)
        : undefined
    message.getSubscriptionResponse =
      object.getSubscriptionResponse !== undefined && object.getSubscriptionResponse !== null
        ? GetSubscriptionResponse.fromPartial(object.getSubscriptionResponse)
        : undefined
    message.openBillingPortalResponse =
      object.openBillingPortalResponse !== undefined && object.openBillingPortalResponse !== null
        ? OpenBillingPortalResponse.fromPartial(object.openBillingPortalResponse)
        : undefined
    message.getPlansResponse =
      object.getPlansResponse !== undefined && object.getPlansResponse !== null
        ? GetPlansResponse.fromPartial(object.getPlansResponse)
        : undefined
    message.listAccountAccessResponse =
      object.listAccountAccessResponse !== undefined && object.listAccountAccessResponse !== null
        ? ListAccountAccessResponse.fromPartial(object.listAccountAccessResponse)
        : undefined
    message.listMyInvitesResponse =
      object.listMyInvitesResponse !== undefined && object.listMyInvitesResponse !== null
        ? ListMyInvitesResponse.fromPartial(object.listMyInvitesResponse)
        : undefined
    message.orderPreviewResponse =
      object.orderPreviewResponse !== undefined && object.orderPreviewResponse !== null
        ? OrderPreviewResponse.fromPartial(object.orderPreviewResponse)
        : undefined
    message.changePasswordResponse =
      object.changePasswordResponse !== undefined && object.changePasswordResponse !== null
        ? ChangePasswordResponse.fromPartial(object.changePasswordResponse)
        : undefined
    message.listSessionsResponse =
      object.listSessionsResponse !== undefined && object.listSessionsResponse !== null
        ? ListSessionsResponse.fromPartial(object.listSessionsResponse)
        : undefined
    message.revokeSessionResponse =
      object.revokeSessionResponse !== undefined && object.revokeSessionResponse !== null
        ? RevokeSessionResponse.fromPartial(object.revokeSessionResponse)
        : undefined
    message.logoutResponse =
      object.logoutResponse !== undefined && object.logoutResponse !== null
        ? LogoutResponse.fromPartial(object.logoutResponse)
        : undefined
    message.revokeAllOtherSessionsResponse =
      object.revokeAllOtherSessionsResponse !== undefined &&
      object.revokeAllOtherSessionsResponse !== null
        ? RevokeAllOtherSessionsResponse.fromPartial(object.revokeAllOtherSessionsResponse)
        : undefined
    message.sendStepUpCodeResponse =
      object.sendStepUpCodeResponse !== undefined && object.sendStepUpCodeResponse !== null
        ? SendStepUpCodeResponse.fromPartial(object.sendStepUpCodeResponse)
        : undefined
    message.batchOrderPreviewResponse =
      object.batchOrderPreviewResponse !== undefined && object.batchOrderPreviewResponse !== null
        ? BatchOrderPreviewResponse.fromPartial(object.batchOrderPreviewResponse)
        : undefined
    message.mintMessagingLinkNonceResponse =
      object.mintMessagingLinkNonceResponse !== undefined &&
      object.mintMessagingLinkNonceResponse !== null
        ? MintMessagingLinkNonceResponse.fromPartial(object.mintMessagingLinkNonceResponse)
        : undefined
    message.paradigmConnectDeskResponse =
      object.paradigmConnectDeskResponse !== undefined &&
      object.paradigmConnectDeskResponse !== null
        ? ParadigmConnectDeskResponse.fromPartial(object.paradigmConnectDeskResponse)
        : undefined
    message.paradigmListAccountsResponse =
      object.paradigmListAccountsResponse !== undefined &&
      object.paradigmListAccountsResponse !== null
        ? ParadigmListAccountsResponse.fromPartial(object.paradigmListAccountsResponse)
        : undefined
    message.paradigmLinkAccountResponse =
      object.paradigmLinkAccountResponse !== undefined &&
      object.paradigmLinkAccountResponse !== null
        ? ParadigmLinkAccountResponse.fromPartial(object.paradigmLinkAccountResponse)
        : undefined
    message.createSharedLayoutResponse =
      object.createSharedLayoutResponse !== undefined && object.createSharedLayoutResponse !== null
        ? CreateSharedLayoutResponse.fromPartial(object.createSharedLayoutResponse)
        : undefined
    message.getSharedLayoutResponse =
      object.getSharedLayoutResponse !== undefined && object.getSharedLayoutResponse !== null
        ? GetSharedLayoutResponse.fromPartial(object.getSharedLayoutResponse)
        : undefined
    message.createApiKeyResponse =
      object.createApiKeyResponse !== undefined && object.createApiKeyResponse !== null
        ? CreateApiKeyResponse.fromPartial(object.createApiKeyResponse)
        : undefined
    message.listApiKeysResponse =
      object.listApiKeysResponse !== undefined && object.listApiKeysResponse !== null
        ? ListApiKeysResponse.fromPartial(object.listApiKeysResponse)
        : undefined
    message.revokeApiKeyResponse =
      object.revokeApiKeyResponse !== undefined && object.revokeApiKeyResponse !== null
        ? RevokeApiKeyResponse.fromPartial(object.revokeApiKeyResponse)
        : undefined
    message.getApiBillingResponse =
      object.getApiBillingResponse !== undefined && object.getApiBillingResponse !== null
        ? GetApiBillingResponse.fromPartial(object.getApiBillingResponse)
        : undefined
    message.updateApiBillingSettingsResponse =
      object.updateApiBillingSettingsResponse !== undefined &&
      object.updateApiBillingSettingsResponse !== null
        ? UpdateApiBillingSettingsResponse.fromPartial(object.updateApiBillingSettingsResponse)
        : undefined
    message.createCreditCheckoutSessionResponse =
      object.createCreditCheckoutSessionResponse !== undefined &&
      object.createCreditCheckoutSessionResponse !== null
        ? CreateCreditCheckoutSessionResponse.fromPartial(
            object.createCreditCheckoutSessionResponse
          )
        : undefined
    message.listCreditLedgerResponse =
      object.listCreditLedgerResponse !== undefined && object.listCreditLedgerResponse !== null
        ? ListCreditLedgerResponse.fromPartial(object.listCreditLedgerResponse)
        : undefined
    message.getCreditSpendStatsResponse =
      object.getCreditSpendStatsResponse !== undefined &&
      object.getCreditSpendStatsResponse !== null
        ? GetCreditSpendStatsResponse.fromPartial(object.getCreditSpendStatsResponse)
        : undefined
    message.sendRfqMakerQuoteResponse =
      object.sendRfqMakerQuoteResponse !== undefined && object.sendRfqMakerQuoteResponse !== null
        ? SendRfqMakerQuoteResponse.fromPartial(object.sendRfqMakerQuoteResponse)
        : undefined
    message.cancelRfqMakerQuoteResponse =
      object.cancelRfqMakerQuoteResponse !== undefined &&
      object.cancelRfqMakerQuoteResponse !== null
        ? CancelRfqMakerQuoteResponse.fromPartial(object.cancelRfqMakerQuoteResponse)
        : undefined
    message.setLeverageResponse =
      object.setLeverageResponse !== undefined && object.setLeverageResponse !== null
        ? SetLeverageResponse.fromPartial(object.setLeverageResponse)
        : undefined
    message.papertradePrepareSessionKeyResponse =
      object.papertradePrepareSessionKeyResponse !== undefined &&
      object.papertradePrepareSessionKeyResponse !== null
        ? PapertradePrepareSessionKeyResponse.fromPartial(
            object.papertradePrepareSessionKeyResponse
          )
        : undefined
    message.accountSettings =
      object.accountSettings !== undefined && object.accountSettings !== null
        ? AccountSettings.fromPartial(object.accountSettings)
        : undefined
    return message
  },
}

function createBaseDraftExecutionPlan(): DraftExecutionPlan {
  return {
    accountId: '',
    executionBatch: undefined,
    warnings: [],
    triggeredItems: [],
    refusals: [],
  }
}

export const DraftExecutionPlan: MessageFns<DraftExecutionPlan> = {
  encode(message: DraftExecutionPlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.executionBatch !== undefined) {
      ExecutionBatch.encode(message.executionBatch, writer.uint32(18).fork()).join()
    }
    for (const v of message.warnings) {
      ExecutionWarning.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.triggeredItems) {
      TriggeredItem.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.refusals) {
      Refusal.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DraftExecutionPlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDraftExecutionPlan()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.executionBatch = ExecutionBatch.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.warnings.push(ExecutionWarning.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.triggeredItems.push(TriggeredItem.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.refusals.push(Refusal.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DraftExecutionPlan {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      executionBatch: isSet(object.executionBatch)
        ? ExecutionBatch.fromJSON(object.executionBatch)
        : isSet(object.execution_batch)
          ? ExecutionBatch.fromJSON(object.execution_batch)
          : undefined,
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => ExecutionWarning.fromJSON(e))
        : [],
      triggeredItems: globalThis.Array.isArray(object?.triggeredItems)
        ? object.triggeredItems.map((e: any) => TriggeredItem.fromJSON(e))
        : globalThis.Array.isArray(object?.triggered_items)
          ? object.triggered_items.map((e: any) => TriggeredItem.fromJSON(e))
          : [],
      refusals: globalThis.Array.isArray(object?.refusals)
        ? object.refusals.map((e: any) => Refusal.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DraftExecutionPlan): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.executionBatch !== undefined) {
      obj.executionBatch = ExecutionBatch.toJSON(message.executionBatch)
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings.map((e) => ExecutionWarning.toJSON(e))
    }
    if (message.triggeredItems?.length) {
      obj.triggeredItems = message.triggeredItems.map((e) => TriggeredItem.toJSON(e))
    }
    if (message.refusals?.length) {
      obj.refusals = message.refusals.map((e) => Refusal.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DraftExecutionPlan>, I>>(base?: I): DraftExecutionPlan {
    return DraftExecutionPlan.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DraftExecutionPlan>, I>>(object: I): DraftExecutionPlan {
    const message = createBaseDraftExecutionPlan()
    message.accountId = object.accountId ?? ''
    message.executionBatch =
      object.executionBatch !== undefined && object.executionBatch !== null
        ? ExecutionBatch.fromPartial(object.executionBatch)
        : undefined
    message.warnings = object.warnings?.map((e) => ExecutionWarning.fromPartial(e)) || []
    message.triggeredItems = object.triggeredItems?.map((e) => TriggeredItem.fromPartial(e)) || []
    message.refusals = object.refusals?.map((e) => Refusal.fromPartial(e)) || []
    return message
  },
}

function createBaseConfirmExecutionPlanRequest(): ConfirmExecutionPlanRequest {
  return { executionPlan: undefined }
}

export const ConfirmExecutionPlanRequest: MessageFns<ConfirmExecutionPlanRequest> = {
  encode(
    message: ConfirmExecutionPlanRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.executionPlan !== undefined) {
      DraftExecutionPlan.encode(message.executionPlan, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmExecutionPlanRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmExecutionPlanRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.executionPlan = DraftExecutionPlan.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmExecutionPlanRequest {
    return {
      executionPlan: isSet(object.executionPlan)
        ? DraftExecutionPlan.fromJSON(object.executionPlan)
        : isSet(object.execution_plan)
          ? DraftExecutionPlan.fromJSON(object.execution_plan)
          : undefined,
    }
  },

  toJSON(message: ConfirmExecutionPlanRequest): unknown {
    const obj: any = {}
    if (message.executionPlan !== undefined) {
      obj.executionPlan = DraftExecutionPlan.toJSON(message.executionPlan)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmExecutionPlanRequest>, I>>(
    base?: I
  ): ConfirmExecutionPlanRequest {
    return ConfirmExecutionPlanRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmExecutionPlanRequest>, I>>(
    object: I
  ): ConfirmExecutionPlanRequest {
    const message = createBaseConfirmExecutionPlanRequest()
    message.executionPlan =
      object.executionPlan !== undefined && object.executionPlan !== null
        ? DraftExecutionPlan.fromPartial(object.executionPlan)
        : undefined
    return message
  },
}

function createBaseConfirmExecutionPlanResponse(): ConfirmExecutionPlanResponse {
  return {
    success: false,
    message: '',
    immediateCommandCount: 0,
    triggerCount: 0,
    error: undefined,
  }
}

export const ConfirmExecutionPlanResponse: MessageFns<ConfirmExecutionPlanResponse> = {
  encode(
    message: ConfirmExecutionPlanResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.immediateCommandCount !== 0) {
      writer.uint32(24).uint32(message.immediateCommandCount)
    }
    if (message.triggerCount !== 0) {
      writer.uint32(32).uint32(message.triggerCount)
    }
    if (message.error !== undefined) {
      writer.uint32(42).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmExecutionPlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmExecutionPlanResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.immediateCommandCount = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.triggerCount = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmExecutionPlanResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      immediateCommandCount: isSet(object.immediateCommandCount)
        ? globalThis.Number(object.immediateCommandCount)
        : isSet(object.immediate_command_count)
          ? globalThis.Number(object.immediate_command_count)
          : 0,
      triggerCount: isSet(object.triggerCount)
        ? globalThis.Number(object.triggerCount)
        : isSet(object.trigger_count)
          ? globalThis.Number(object.trigger_count)
          : 0,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: ConfirmExecutionPlanResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.immediateCommandCount !== 0) {
      obj.immediateCommandCount = Math.round(message.immediateCommandCount)
    }
    if (message.triggerCount !== 0) {
      obj.triggerCount = Math.round(message.triggerCount)
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmExecutionPlanResponse>, I>>(
    base?: I
  ): ConfirmExecutionPlanResponse {
    return ConfirmExecutionPlanResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmExecutionPlanResponse>, I>>(
    object: I
  ): ConfirmExecutionPlanResponse {
    const message = createBaseConfirmExecutionPlanResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    message.immediateCommandCount = object.immediateCommandCount ?? 0
    message.triggerCount = object.triggerCount ?? 0
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseTriggeredItem(): TriggeredItem {
  return { accountId: '', firePayload: undefined, trigger: undefined }
}

export const TriggeredItem: MessageFns<TriggeredItem> = {
  encode(message: TriggeredItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.firePayload !== undefined) {
      ExecutionBatch.encode(message.firePayload, writer.uint32(18).fork()).join()
    }
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggeredItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggeredItem()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.firePayload = ExecutionBatch.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggeredItem {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      firePayload: isSet(object.firePayload)
        ? ExecutionBatch.fromJSON(object.firePayload)
        : isSet(object.fire_payload)
          ? ExecutionBatch.fromJSON(object.fire_payload)
          : undefined,
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
    }
  },

  toJSON(message: TriggeredItem): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.firePayload !== undefined) {
      obj.firePayload = ExecutionBatch.toJSON(message.firePayload)
    }
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggeredItem>, I>>(base?: I): TriggeredItem {
    return TriggeredItem.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggeredItem>, I>>(object: I): TriggeredItem {
    const message = createBaseTriggeredItem()
    message.accountId = object.accountId ?? ''
    message.firePayload =
      object.firePayload !== undefined && object.firePayload !== null
        ? ExecutionBatch.fromPartial(object.firePayload)
        : undefined
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    return message
  },
}

function createBaseRefusal(): Refusal {
  return {
    reason: 0,
    message: undefined,
    offendingValue: undefined,
    itemIndex: undefined,
    track: 0,
    stage: 0,
    suggestedAlternative: undefined,
  }
}

export const Refusal: MessageFns<Refusal> = {
  encode(message: Refusal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== 0) {
      writer.uint32(8).int32(message.reason)
    }
    if (message.message !== undefined) {
      writer.uint32(18).string(message.message)
    }
    if (message.offendingValue !== undefined) {
      writer.uint32(26).string(message.offendingValue)
    }
    if (message.itemIndex !== undefined) {
      writer.uint32(32).uint32(message.itemIndex)
    }
    if (message.track !== 0) {
      writer.uint32(40).int32(message.track)
    }
    if (message.stage !== 0) {
      writer.uint32(48).int32(message.stage)
    }
    if (message.suggestedAlternative !== undefined) {
      writer.uint32(58).string(message.suggestedAlternative)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Refusal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRefusal()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.reason = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.offendingValue = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.itemIndex = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.track = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.stage = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.suggestedAlternative = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Refusal {
    return {
      reason: isSet(object.reason) ? refusalReasonFromJSON(object.reason) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      offendingValue: isSet(object.offendingValue)
        ? globalThis.String(object.offendingValue)
        : isSet(object.offending_value)
          ? globalThis.String(object.offending_value)
          : undefined,
      itemIndex: isSet(object.itemIndex)
        ? globalThis.Number(object.itemIndex)
        : isSet(object.item_index)
          ? globalThis.Number(object.item_index)
          : undefined,
      track: isSet(object.track) ? intentItemTrackFromJSON(object.track) : 0,
      stage: isSet(object.stage) ? intentPipelineStageFromJSON(object.stage) : 0,
      suggestedAlternative: isSet(object.suggestedAlternative)
        ? globalThis.String(object.suggestedAlternative)
        : isSet(object.suggested_alternative)
          ? globalThis.String(object.suggested_alternative)
          : undefined,
    }
  },

  toJSON(message: Refusal): unknown {
    const obj: any = {}
    if (message.reason !== 0) {
      obj.reason = refusalReasonToJSON(message.reason)
    }
    if (message.message !== undefined) {
      obj.message = message.message
    }
    if (message.offendingValue !== undefined) {
      obj.offendingValue = message.offendingValue
    }
    if (message.itemIndex !== undefined) {
      obj.itemIndex = Math.round(message.itemIndex)
    }
    if (message.track !== 0) {
      obj.track = intentItemTrackToJSON(message.track)
    }
    if (message.stage !== 0) {
      obj.stage = intentPipelineStageToJSON(message.stage)
    }
    if (message.suggestedAlternative !== undefined) {
      obj.suggestedAlternative = message.suggestedAlternative
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Refusal>, I>>(base?: I): Refusal {
    return Refusal.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Refusal>, I>>(object: I): Refusal {
    const message = createBaseRefusal()
    message.reason = object.reason ?? 0
    message.message = object.message ?? undefined
    message.offendingValue = object.offendingValue ?? undefined
    message.itemIndex = object.itemIndex ?? undefined
    message.track = object.track ?? 0
    message.stage = object.stage ?? 0
    message.suggestedAlternative = object.suggestedAlternative ?? undefined
    return message
  },
}

function createBaseVolSurfaceGenerationResult(): VolSurfaceGenerationResult {
  return { success: undefined, error: undefined }
}

export const VolSurfaceGenerationResult: MessageFns<VolSurfaceGenerationResult> = {
  encode(
    message: VolSurfaceGenerationResult,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== undefined) {
      GenerateVolSurfaceResponse.encode(message.success, writer.uint32(10).fork()).join()
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolSurfaceGenerationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolSurfaceGenerationResult()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.success = GenerateVolSurfaceResponse.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.error = Error.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolSurfaceGenerationResult {
    return {
      success: isSet(object.success)
        ? GenerateVolSurfaceResponse.fromJSON(object.success)
        : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    }
  },

  toJSON(message: VolSurfaceGenerationResult): unknown {
    const obj: any = {}
    if (message.success !== undefined) {
      obj.success = GenerateVolSurfaceResponse.toJSON(message.success)
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolSurfaceGenerationResult>, I>>(
    base?: I
  ): VolSurfaceGenerationResult {
    return VolSurfaceGenerationResult.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolSurfaceGenerationResult>, I>>(
    object: I
  ): VolSurfaceGenerationResult {
    const message = createBaseVolSurfaceGenerationResult()
    message.success =
      object.success !== undefined && object.success !== null
        ? GenerateVolSurfaceResponse.fromPartial(object.success)
        : undefined
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined
    return message
  },
}

function createBaseRiskSimulationResult(): RiskSimulationResult {
  return { success: undefined, error: undefined }
}

export const RiskSimulationResult: MessageFns<RiskSimulationResult> = {
  encode(message: RiskSimulationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== undefined) {
      RiskSimulationResponse.encode(message.success, writer.uint32(10).fork()).join()
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationResult()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.success = RiskSimulationResponse.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.error = Error.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationResult {
    return {
      success: isSet(object.success) ? RiskSimulationResponse.fromJSON(object.success) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    }
  },

  toJSON(message: RiskSimulationResult): unknown {
    const obj: any = {}
    if (message.success !== undefined) {
      obj.success = RiskSimulationResponse.toJSON(message.success)
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationResult>, I>>(base?: I): RiskSimulationResult {
    return RiskSimulationResult.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationResult>, I>>(
    object: I
  ): RiskSimulationResult {
    const message = createBaseRiskSimulationResult()
    message.success =
      object.success !== undefined && object.success !== null
        ? RiskSimulationResponse.fromPartial(object.success)
        : undefined
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined
    return message
  },
}

function createBaseOrderPreviewRequest(): OrderPreviewRequest {
  return {
    accountId: '',
    symbol: '',
    side: 0,
    quantity: '',
    orderType: 0,
    price: undefined,
    denomination: 0,
  }
}

export const OrderPreviewRequest: MessageFns<OrderPreviewRequest> = {
  encode(message: OrderPreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(34).string(message.quantity)
    }
    if (message.orderType !== 0) {
      writer.uint32(40).int32(message.orderType)
    }
    if (message.price !== undefined) {
      writer.uint32(50).string(message.price)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderPreviewRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderPreviewRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : undefined,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
    }
  },

  toJSON(message: OrderPreviewRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.orderType !== 0) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderPreviewRequest>, I>>(base?: I): OrderPreviewRequest {
    return OrderPreviewRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderPreviewRequest>, I>>(
    object: I
  ): OrderPreviewRequest {
    const message = createBaseOrderPreviewRequest()
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.orderType = object.orderType ?? 0
    message.price = object.price ?? undefined
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBaseOrderPreviewResponse(): OrderPreviewResponse {
  return {
    orderValueBase: '',
    orderValueQuote: '',
    marginRequired: undefined,
    marginUsedCurrent: '',
    marginUsedAfter: undefined,
    maxSize: undefined,
    grossLeverageCurrent: '',
    grossLeverageAfter: '',
    netLeverageCurrent: '',
    netLeverageAfter: '',
    feeBase: undefined,
    feeQuote: undefined,
    approximate: false,
    warningCode: undefined,
    timestamp: '0',
    totalValueUsd: undefined,
    marginAvailableCurrent: undefined,
    marginAvailableAfter: undefined,
    marginImpactPct: undefined,
    feeUsd: undefined,
    marginUsedPctCurrent: undefined,
    marginUsedPctAfter: undefined,
    estimatedLiquidationPriceCurrent: undefined,
    estimatedLiquidationPriceAfter: undefined,
  }
}

export const OrderPreviewResponse: MessageFns<OrderPreviewResponse> = {
  encode(message: OrderPreviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderValueBase !== '') {
      writer.uint32(10).string(message.orderValueBase)
    }
    if (message.orderValueQuote !== '') {
      writer.uint32(18).string(message.orderValueQuote)
    }
    if (message.marginRequired !== undefined) {
      writer.uint32(26).string(message.marginRequired)
    }
    if (message.marginUsedCurrent !== '') {
      writer.uint32(34).string(message.marginUsedCurrent)
    }
    if (message.marginUsedAfter !== undefined) {
      writer.uint32(42).string(message.marginUsedAfter)
    }
    if (message.maxSize !== undefined) {
      writer.uint32(50).string(message.maxSize)
    }
    if (message.grossLeverageCurrent !== '') {
      writer.uint32(58).string(message.grossLeverageCurrent)
    }
    if (message.grossLeverageAfter !== '') {
      writer.uint32(66).string(message.grossLeverageAfter)
    }
    if (message.netLeverageCurrent !== '') {
      writer.uint32(74).string(message.netLeverageCurrent)
    }
    if (message.netLeverageAfter !== '') {
      writer.uint32(82).string(message.netLeverageAfter)
    }
    if (message.feeBase !== undefined) {
      writer.uint32(90).string(message.feeBase)
    }
    if (message.feeQuote !== undefined) {
      writer.uint32(98).string(message.feeQuote)
    }
    if (message.approximate !== false) {
      writer.uint32(104).bool(message.approximate)
    }
    if (message.warningCode !== undefined) {
      writer.uint32(112).int32(message.warningCode)
    }
    if (message.timestamp !== '0') {
      writer.uint32(120).int64(message.timestamp)
    }
    if (message.totalValueUsd !== undefined) {
      writer.uint32(130).string(message.totalValueUsd)
    }
    if (message.marginAvailableCurrent !== undefined) {
      writer.uint32(138).string(message.marginAvailableCurrent)
    }
    if (message.marginAvailableAfter !== undefined) {
      writer.uint32(146).string(message.marginAvailableAfter)
    }
    if (message.marginImpactPct !== undefined) {
      writer.uint32(154).string(message.marginImpactPct)
    }
    if (message.feeUsd !== undefined) {
      writer.uint32(162).string(message.feeUsd)
    }
    if (message.marginUsedPctCurrent !== undefined) {
      writer.uint32(170).string(message.marginUsedPctCurrent)
    }
    if (message.marginUsedPctAfter !== undefined) {
      writer.uint32(178).string(message.marginUsedPctAfter)
    }
    if (message.estimatedLiquidationPriceCurrent !== undefined) {
      writer.uint32(186).string(message.estimatedLiquidationPriceCurrent)
    }
    if (message.estimatedLiquidationPriceAfter !== undefined) {
      writer.uint32(194).string(message.estimatedLiquidationPriceAfter)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderPreviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderPreviewResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderValueBase = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderValueQuote = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.marginRequired = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.marginUsedCurrent = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.marginUsedAfter = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.maxSize = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.grossLeverageCurrent = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.grossLeverageAfter = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.netLeverageCurrent = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.netLeverageAfter = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.feeBase = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.feeQuote = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.approximate = reader.bool()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.warningCode = reader.int32() as any
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.totalValueUsd = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.marginAvailableCurrent = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.marginAvailableAfter = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.marginImpactPct = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.feeUsd = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.marginUsedPctCurrent = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.marginUsedPctAfter = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.estimatedLiquidationPriceCurrent = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.estimatedLiquidationPriceAfter = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderPreviewResponse {
    return {
      orderValueBase: isSet(object.orderValueBase)
        ? globalThis.String(object.orderValueBase)
        : isSet(object.order_value_base)
          ? globalThis.String(object.order_value_base)
          : '',
      orderValueQuote: isSet(object.orderValueQuote)
        ? globalThis.String(object.orderValueQuote)
        : isSet(object.order_value_quote)
          ? globalThis.String(object.order_value_quote)
          : '',
      marginRequired: isSet(object.marginRequired)
        ? globalThis.String(object.marginRequired)
        : isSet(object.margin_required)
          ? globalThis.String(object.margin_required)
          : undefined,
      marginUsedCurrent: isSet(object.marginUsedCurrent)
        ? globalThis.String(object.marginUsedCurrent)
        : isSet(object.margin_used_current)
          ? globalThis.String(object.margin_used_current)
          : '',
      marginUsedAfter: isSet(object.marginUsedAfter)
        ? globalThis.String(object.marginUsedAfter)
        : isSet(object.margin_used_after)
          ? globalThis.String(object.margin_used_after)
          : undefined,
      maxSize: isSet(object.maxSize)
        ? globalThis.String(object.maxSize)
        : isSet(object.max_size)
          ? globalThis.String(object.max_size)
          : undefined,
      grossLeverageCurrent: isSet(object.grossLeverageCurrent)
        ? globalThis.String(object.grossLeverageCurrent)
        : isSet(object.gross_leverage_current)
          ? globalThis.String(object.gross_leverage_current)
          : '',
      grossLeverageAfter: isSet(object.grossLeverageAfter)
        ? globalThis.String(object.grossLeverageAfter)
        : isSet(object.gross_leverage_after)
          ? globalThis.String(object.gross_leverage_after)
          : '',
      netLeverageCurrent: isSet(object.netLeverageCurrent)
        ? globalThis.String(object.netLeverageCurrent)
        : isSet(object.net_leverage_current)
          ? globalThis.String(object.net_leverage_current)
          : '',
      netLeverageAfter: isSet(object.netLeverageAfter)
        ? globalThis.String(object.netLeverageAfter)
        : isSet(object.net_leverage_after)
          ? globalThis.String(object.net_leverage_after)
          : '',
      feeBase: isSet(object.feeBase)
        ? globalThis.String(object.feeBase)
        : isSet(object.fee_base)
          ? globalThis.String(object.fee_base)
          : undefined,
      feeQuote: isSet(object.feeQuote)
        ? globalThis.String(object.feeQuote)
        : isSet(object.fee_quote)
          ? globalThis.String(object.fee_quote)
          : undefined,
      approximate: isSet(object.approximate) ? globalThis.Boolean(object.approximate) : false,
      warningCode: isSet(object.warningCode)
        ? warningCodeFromJSON(object.warningCode)
        : isSet(object.warning_code)
          ? warningCodeFromJSON(object.warning_code)
          : undefined,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      totalValueUsd: isSet(object.totalValueUsd)
        ? globalThis.String(object.totalValueUsd)
        : isSet(object.total_value_usd)
          ? globalThis.String(object.total_value_usd)
          : undefined,
      marginAvailableCurrent: isSet(object.marginAvailableCurrent)
        ? globalThis.String(object.marginAvailableCurrent)
        : isSet(object.margin_available_current)
          ? globalThis.String(object.margin_available_current)
          : undefined,
      marginAvailableAfter: isSet(object.marginAvailableAfter)
        ? globalThis.String(object.marginAvailableAfter)
        : isSet(object.margin_available_after)
          ? globalThis.String(object.margin_available_after)
          : undefined,
      marginImpactPct: isSet(object.marginImpactPct)
        ? globalThis.String(object.marginImpactPct)
        : isSet(object.margin_impact_pct)
          ? globalThis.String(object.margin_impact_pct)
          : undefined,
      feeUsd: isSet(object.feeUsd)
        ? globalThis.String(object.feeUsd)
        : isSet(object.fee_usd)
          ? globalThis.String(object.fee_usd)
          : undefined,
      marginUsedPctCurrent: isSet(object.marginUsedPctCurrent)
        ? globalThis.String(object.marginUsedPctCurrent)
        : isSet(object.margin_used_pct_current)
          ? globalThis.String(object.margin_used_pct_current)
          : undefined,
      marginUsedPctAfter: isSet(object.marginUsedPctAfter)
        ? globalThis.String(object.marginUsedPctAfter)
        : isSet(object.margin_used_pct_after)
          ? globalThis.String(object.margin_used_pct_after)
          : undefined,
      estimatedLiquidationPriceCurrent: isSet(object.estimatedLiquidationPriceCurrent)
        ? globalThis.String(object.estimatedLiquidationPriceCurrent)
        : isSet(object.estimated_liquidation_price_current)
          ? globalThis.String(object.estimated_liquidation_price_current)
          : undefined,
      estimatedLiquidationPriceAfter: isSet(object.estimatedLiquidationPriceAfter)
        ? globalThis.String(object.estimatedLiquidationPriceAfter)
        : isSet(object.estimated_liquidation_price_after)
          ? globalThis.String(object.estimated_liquidation_price_after)
          : undefined,
    }
  },

  toJSON(message: OrderPreviewResponse): unknown {
    const obj: any = {}
    if (message.orderValueBase !== '') {
      obj.orderValueBase = message.orderValueBase
    }
    if (message.orderValueQuote !== '') {
      obj.orderValueQuote = message.orderValueQuote
    }
    if (message.marginRequired !== undefined) {
      obj.marginRequired = message.marginRequired
    }
    if (message.marginUsedCurrent !== '') {
      obj.marginUsedCurrent = message.marginUsedCurrent
    }
    if (message.marginUsedAfter !== undefined) {
      obj.marginUsedAfter = message.marginUsedAfter
    }
    if (message.maxSize !== undefined) {
      obj.maxSize = message.maxSize
    }
    if (message.grossLeverageCurrent !== '') {
      obj.grossLeverageCurrent = message.grossLeverageCurrent
    }
    if (message.grossLeverageAfter !== '') {
      obj.grossLeverageAfter = message.grossLeverageAfter
    }
    if (message.netLeverageCurrent !== '') {
      obj.netLeverageCurrent = message.netLeverageCurrent
    }
    if (message.netLeverageAfter !== '') {
      obj.netLeverageAfter = message.netLeverageAfter
    }
    if (message.feeBase !== undefined) {
      obj.feeBase = message.feeBase
    }
    if (message.feeQuote !== undefined) {
      obj.feeQuote = message.feeQuote
    }
    if (message.approximate !== false) {
      obj.approximate = message.approximate
    }
    if (message.warningCode !== undefined) {
      obj.warningCode = warningCodeToJSON(message.warningCode)
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.totalValueUsd !== undefined) {
      obj.totalValueUsd = message.totalValueUsd
    }
    if (message.marginAvailableCurrent !== undefined) {
      obj.marginAvailableCurrent = message.marginAvailableCurrent
    }
    if (message.marginAvailableAfter !== undefined) {
      obj.marginAvailableAfter = message.marginAvailableAfter
    }
    if (message.marginImpactPct !== undefined) {
      obj.marginImpactPct = message.marginImpactPct
    }
    if (message.feeUsd !== undefined) {
      obj.feeUsd = message.feeUsd
    }
    if (message.marginUsedPctCurrent !== undefined) {
      obj.marginUsedPctCurrent = message.marginUsedPctCurrent
    }
    if (message.marginUsedPctAfter !== undefined) {
      obj.marginUsedPctAfter = message.marginUsedPctAfter
    }
    if (message.estimatedLiquidationPriceCurrent !== undefined) {
      obj.estimatedLiquidationPriceCurrent = message.estimatedLiquidationPriceCurrent
    }
    if (message.estimatedLiquidationPriceAfter !== undefined) {
      obj.estimatedLiquidationPriceAfter = message.estimatedLiquidationPriceAfter
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderPreviewResponse>, I>>(base?: I): OrderPreviewResponse {
    return OrderPreviewResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderPreviewResponse>, I>>(
    object: I
  ): OrderPreviewResponse {
    const message = createBaseOrderPreviewResponse()
    message.orderValueBase = object.orderValueBase ?? ''
    message.orderValueQuote = object.orderValueQuote ?? ''
    message.marginRequired = object.marginRequired ?? undefined
    message.marginUsedCurrent = object.marginUsedCurrent ?? ''
    message.marginUsedAfter = object.marginUsedAfter ?? undefined
    message.maxSize = object.maxSize ?? undefined
    message.grossLeverageCurrent = object.grossLeverageCurrent ?? ''
    message.grossLeverageAfter = object.grossLeverageAfter ?? ''
    message.netLeverageCurrent = object.netLeverageCurrent ?? ''
    message.netLeverageAfter = object.netLeverageAfter ?? ''
    message.feeBase = object.feeBase ?? undefined
    message.feeQuote = object.feeQuote ?? undefined
    message.approximate = object.approximate ?? false
    message.warningCode = object.warningCode ?? undefined
    message.timestamp = object.timestamp ?? '0'
    message.totalValueUsd = object.totalValueUsd ?? undefined
    message.marginAvailableCurrent = object.marginAvailableCurrent ?? undefined
    message.marginAvailableAfter = object.marginAvailableAfter ?? undefined
    message.marginImpactPct = object.marginImpactPct ?? undefined
    message.feeUsd = object.feeUsd ?? undefined
    message.marginUsedPctCurrent = object.marginUsedPctCurrent ?? undefined
    message.marginUsedPctAfter = object.marginUsedPctAfter ?? undefined
    message.estimatedLiquidationPriceCurrent = object.estimatedLiquidationPriceCurrent ?? undefined
    message.estimatedLiquidationPriceAfter = object.estimatedLiquidationPriceAfter ?? undefined
    return message
  },
}

function createBaseRowPreviewError(): RowPreviewError {
  return { message: '', code: undefined }
}

export const RowPreviewError: MessageFns<RowPreviewError> = {
  encode(message: RowPreviewError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    if (message.code !== undefined) {
      writer.uint32(16).int32(message.code)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RowPreviewError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRowPreviewError()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.code = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RowPreviewError {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      code: isSet(object.code) ? warningCodeFromJSON(object.code) : undefined,
    }
  },

  toJSON(message: RowPreviewError): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.code !== undefined) {
      obj.code = warningCodeToJSON(message.code)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RowPreviewError>, I>>(base?: I): RowPreviewError {
    return RowPreviewError.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RowPreviewError>, I>>(object: I): RowPreviewError {
    const message = createBaseRowPreviewError()
    message.message = object.message ?? ''
    message.code = object.code ?? undefined
    return message
  },
}

function createBaseRowPreviewResult(): RowPreviewResult {
  return { ok: undefined, error: undefined }
}

export const RowPreviewResult: MessageFns<RowPreviewResult> = {
  encode(message: RowPreviewResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ok !== undefined) {
      OrderPreviewResponse.encode(message.ok, writer.uint32(10).fork()).join()
    }
    if (message.error !== undefined) {
      RowPreviewError.encode(message.error, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RowPreviewResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRowPreviewResult()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.ok = OrderPreviewResponse.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.error = RowPreviewError.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RowPreviewResult {
    return {
      ok: isSet(object.ok) ? OrderPreviewResponse.fromJSON(object.ok) : undefined,
      error: isSet(object.error) ? RowPreviewError.fromJSON(object.error) : undefined,
    }
  },

  toJSON(message: RowPreviewResult): unknown {
    const obj: any = {}
    if (message.ok !== undefined) {
      obj.ok = OrderPreviewResponse.toJSON(message.ok)
    }
    if (message.error !== undefined) {
      obj.error = RowPreviewError.toJSON(message.error)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RowPreviewResult>, I>>(base?: I): RowPreviewResult {
    return RowPreviewResult.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RowPreviewResult>, I>>(object: I): RowPreviewResult {
    const message = createBaseRowPreviewResult()
    message.ok =
      object.ok !== undefined && object.ok !== null
        ? OrderPreviewResponse.fromPartial(object.ok)
        : undefined
    message.error =
      object.error !== undefined && object.error !== null
        ? RowPreviewError.fromPartial(object.error)
        : undefined
    return message
  },
}

function createBaseMarginPoolPreview(): MarginPoolPreview {
  return {
    dexKey: '',
    marginRequired: undefined,
    marginAvailableCurrent: undefined,
    marginAvailableAfter: undefined,
    marginImpactPct: undefined,
    approximate: false,
    warningCode: undefined,
    marginUsedPctCurrent: undefined,
    marginUsedPctAfter: undefined,
  }
}

export const MarginPoolPreview: MessageFns<MarginPoolPreview> = {
  encode(message: MarginPoolPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dexKey !== '') {
      writer.uint32(10).string(message.dexKey)
    }
    if (message.marginRequired !== undefined) {
      writer.uint32(18).string(message.marginRequired)
    }
    if (message.marginAvailableCurrent !== undefined) {
      writer.uint32(26).string(message.marginAvailableCurrent)
    }
    if (message.marginAvailableAfter !== undefined) {
      writer.uint32(34).string(message.marginAvailableAfter)
    }
    if (message.marginImpactPct !== undefined) {
      writer.uint32(42).string(message.marginImpactPct)
    }
    if (message.approximate !== false) {
      writer.uint32(48).bool(message.approximate)
    }
    if (message.warningCode !== undefined) {
      writer.uint32(56).int32(message.warningCode)
    }
    if (message.marginUsedPctCurrent !== undefined) {
      writer.uint32(66).string(message.marginUsedPctCurrent)
    }
    if (message.marginUsedPctAfter !== undefined) {
      writer.uint32(74).string(message.marginUsedPctAfter)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarginPoolPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarginPoolPreview()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.dexKey = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.marginRequired = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.marginAvailableCurrent = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.marginAvailableAfter = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.marginImpactPct = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.approximate = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.warningCode = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.marginUsedPctCurrent = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.marginUsedPctAfter = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarginPoolPreview {
    return {
      dexKey: isSet(object.dexKey)
        ? globalThis.String(object.dexKey)
        : isSet(object.dex_key)
          ? globalThis.String(object.dex_key)
          : '',
      marginRequired: isSet(object.marginRequired)
        ? globalThis.String(object.marginRequired)
        : isSet(object.margin_required)
          ? globalThis.String(object.margin_required)
          : undefined,
      marginAvailableCurrent: isSet(object.marginAvailableCurrent)
        ? globalThis.String(object.marginAvailableCurrent)
        : isSet(object.margin_available_current)
          ? globalThis.String(object.margin_available_current)
          : undefined,
      marginAvailableAfter: isSet(object.marginAvailableAfter)
        ? globalThis.String(object.marginAvailableAfter)
        : isSet(object.margin_available_after)
          ? globalThis.String(object.margin_available_after)
          : undefined,
      marginImpactPct: isSet(object.marginImpactPct)
        ? globalThis.String(object.marginImpactPct)
        : isSet(object.margin_impact_pct)
          ? globalThis.String(object.margin_impact_pct)
          : undefined,
      approximate: isSet(object.approximate) ? globalThis.Boolean(object.approximate) : false,
      warningCode: isSet(object.warningCode)
        ? warningCodeFromJSON(object.warningCode)
        : isSet(object.warning_code)
          ? warningCodeFromJSON(object.warning_code)
          : undefined,
      marginUsedPctCurrent: isSet(object.marginUsedPctCurrent)
        ? globalThis.String(object.marginUsedPctCurrent)
        : isSet(object.margin_used_pct_current)
          ? globalThis.String(object.margin_used_pct_current)
          : undefined,
      marginUsedPctAfter: isSet(object.marginUsedPctAfter)
        ? globalThis.String(object.marginUsedPctAfter)
        : isSet(object.margin_used_pct_after)
          ? globalThis.String(object.margin_used_pct_after)
          : undefined,
    }
  },

  toJSON(message: MarginPoolPreview): unknown {
    const obj: any = {}
    if (message.dexKey !== '') {
      obj.dexKey = message.dexKey
    }
    if (message.marginRequired !== undefined) {
      obj.marginRequired = message.marginRequired
    }
    if (message.marginAvailableCurrent !== undefined) {
      obj.marginAvailableCurrent = message.marginAvailableCurrent
    }
    if (message.marginAvailableAfter !== undefined) {
      obj.marginAvailableAfter = message.marginAvailableAfter
    }
    if (message.marginImpactPct !== undefined) {
      obj.marginImpactPct = message.marginImpactPct
    }
    if (message.approximate !== false) {
      obj.approximate = message.approximate
    }
    if (message.warningCode !== undefined) {
      obj.warningCode = warningCodeToJSON(message.warningCode)
    }
    if (message.marginUsedPctCurrent !== undefined) {
      obj.marginUsedPctCurrent = message.marginUsedPctCurrent
    }
    if (message.marginUsedPctAfter !== undefined) {
      obj.marginUsedPctAfter = message.marginUsedPctAfter
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarginPoolPreview>, I>>(base?: I): MarginPoolPreview {
    return MarginPoolPreview.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarginPoolPreview>, I>>(object: I): MarginPoolPreview {
    const message = createBaseMarginPoolPreview()
    message.dexKey = object.dexKey ?? ''
    message.marginRequired = object.marginRequired ?? undefined
    message.marginAvailableCurrent = object.marginAvailableCurrent ?? undefined
    message.marginAvailableAfter = object.marginAvailableAfter ?? undefined
    message.marginImpactPct = object.marginImpactPct ?? undefined
    message.approximate = object.approximate ?? false
    message.warningCode = object.warningCode ?? undefined
    message.marginUsedPctCurrent = object.marginUsedPctCurrent ?? undefined
    message.marginUsedPctAfter = object.marginUsedPctAfter ?? undefined
    return message
  },
}

function createBaseAccountGroupPreview(): AccountGroupPreview {
  return {
    exchange: 0,
    accountId: '',
    pools: [],
    totalValueUsd: undefined,
    feeUsd: undefined,
    grossLeverageCurrent: '',
    grossLeverageAfter: '',
    netLeverageCurrent: '',
    netLeverageAfter: '',
    incomplete: false,
  }
}

export const AccountGroupPreview: MessageFns<AccountGroupPreview> = {
  encode(message: AccountGroupPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    for (const v of message.pools) {
      MarginPoolPreview.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.totalValueUsd !== undefined) {
      writer.uint32(34).string(message.totalValueUsd)
    }
    if (message.feeUsd !== undefined) {
      writer.uint32(42).string(message.feeUsd)
    }
    if (message.grossLeverageCurrent !== '') {
      writer.uint32(50).string(message.grossLeverageCurrent)
    }
    if (message.grossLeverageAfter !== '') {
      writer.uint32(58).string(message.grossLeverageAfter)
    }
    if (message.netLeverageCurrent !== '') {
      writer.uint32(66).string(message.netLeverageCurrent)
    }
    if (message.netLeverageAfter !== '') {
      writer.uint32(74).string(message.netLeverageAfter)
    }
    if (message.incomplete !== false) {
      writer.uint32(80).bool(message.incomplete)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountGroupPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountGroupPreview()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.pools.push(MarginPoolPreview.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.totalValueUsd = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.feeUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.grossLeverageCurrent = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.grossLeverageAfter = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.netLeverageCurrent = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.netLeverageAfter = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.incomplete = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountGroupPreview {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      pools: globalThis.Array.isArray(object?.pools)
        ? object.pools.map((e: any) => MarginPoolPreview.fromJSON(e))
        : [],
      totalValueUsd: isSet(object.totalValueUsd)
        ? globalThis.String(object.totalValueUsd)
        : isSet(object.total_value_usd)
          ? globalThis.String(object.total_value_usd)
          : undefined,
      feeUsd: isSet(object.feeUsd)
        ? globalThis.String(object.feeUsd)
        : isSet(object.fee_usd)
          ? globalThis.String(object.fee_usd)
          : undefined,
      grossLeverageCurrent: isSet(object.grossLeverageCurrent)
        ? globalThis.String(object.grossLeverageCurrent)
        : isSet(object.gross_leverage_current)
          ? globalThis.String(object.gross_leverage_current)
          : '',
      grossLeverageAfter: isSet(object.grossLeverageAfter)
        ? globalThis.String(object.grossLeverageAfter)
        : isSet(object.gross_leverage_after)
          ? globalThis.String(object.gross_leverage_after)
          : '',
      netLeverageCurrent: isSet(object.netLeverageCurrent)
        ? globalThis.String(object.netLeverageCurrent)
        : isSet(object.net_leverage_current)
          ? globalThis.String(object.net_leverage_current)
          : '',
      netLeverageAfter: isSet(object.netLeverageAfter)
        ? globalThis.String(object.netLeverageAfter)
        : isSet(object.net_leverage_after)
          ? globalThis.String(object.net_leverage_after)
          : '',
      incomplete: isSet(object.incomplete) ? globalThis.Boolean(object.incomplete) : false,
    }
  },

  toJSON(message: AccountGroupPreview): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.pools?.length) {
      obj.pools = message.pools.map((e) => MarginPoolPreview.toJSON(e))
    }
    if (message.totalValueUsd !== undefined) {
      obj.totalValueUsd = message.totalValueUsd
    }
    if (message.feeUsd !== undefined) {
      obj.feeUsd = message.feeUsd
    }
    if (message.grossLeverageCurrent !== '') {
      obj.grossLeverageCurrent = message.grossLeverageCurrent
    }
    if (message.grossLeverageAfter !== '') {
      obj.grossLeverageAfter = message.grossLeverageAfter
    }
    if (message.netLeverageCurrent !== '') {
      obj.netLeverageCurrent = message.netLeverageCurrent
    }
    if (message.netLeverageAfter !== '') {
      obj.netLeverageAfter = message.netLeverageAfter
    }
    if (message.incomplete !== false) {
      obj.incomplete = message.incomplete
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountGroupPreview>, I>>(base?: I): AccountGroupPreview {
    return AccountGroupPreview.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountGroupPreview>, I>>(
    object: I
  ): AccountGroupPreview {
    const message = createBaseAccountGroupPreview()
    message.exchange = object.exchange ?? 0
    message.accountId = object.accountId ?? ''
    message.pools = object.pools?.map((e) => MarginPoolPreview.fromPartial(e)) || []
    message.totalValueUsd = object.totalValueUsd ?? undefined
    message.feeUsd = object.feeUsd ?? undefined
    message.grossLeverageCurrent = object.grossLeverageCurrent ?? ''
    message.grossLeverageAfter = object.grossLeverageAfter ?? ''
    message.netLeverageCurrent = object.netLeverageCurrent ?? ''
    message.netLeverageAfter = object.netLeverageAfter ?? ''
    message.incomplete = object.incomplete ?? false
    return message
  },
}

function createBaseBatchOrderPreviewRequest(): BatchOrderPreviewRequest {
  return { orders: [] }
}

export const BatchOrderPreviewRequest: MessageFns<BatchOrderPreviewRequest> = {
  encode(
    message: BatchOrderPreviewRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.orders) {
      OrderPreviewRequest.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchOrderPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBatchOrderPreviewRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orders.push(OrderPreviewRequest.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BatchOrderPreviewRequest {
    return {
      orders: globalThis.Array.isArray(object?.orders)
        ? object.orders.map((e: any) => OrderPreviewRequest.fromJSON(e))
        : [],
    }
  },

  toJSON(message: BatchOrderPreviewRequest): unknown {
    const obj: any = {}
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => OrderPreviewRequest.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BatchOrderPreviewRequest>, I>>(
    base?: I
  ): BatchOrderPreviewRequest {
    return BatchOrderPreviewRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BatchOrderPreviewRequest>, I>>(
    object: I
  ): BatchOrderPreviewRequest {
    const message = createBaseBatchOrderPreviewRequest()
    message.orders = object.orders?.map((e) => OrderPreviewRequest.fromPartial(e)) || []
    return message
  },
}

function createBaseBatchOrderPreviewResponse(): BatchOrderPreviewResponse {
  return { rows: [], groups: [], timestamp: '0' }
}

export const BatchOrderPreviewResponse: MessageFns<BatchOrderPreviewResponse> = {
  encode(
    message: BatchOrderPreviewResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.rows) {
      RowPreviewResult.encode(v!, writer.uint32(10).fork()).join()
    }
    for (const v of message.groups) {
      AccountGroupPreview.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.timestamp !== '0') {
      writer.uint32(24).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchOrderPreviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBatchOrderPreviewResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rows.push(RowPreviewResult.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.groups.push(AccountGroupPreview.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BatchOrderPreviewResponse {
    return {
      rows: globalThis.Array.isArray(object?.rows)
        ? object.rows.map((e: any) => RowPreviewResult.fromJSON(e))
        : [],
      groups: globalThis.Array.isArray(object?.groups)
        ? object.groups.map((e: any) => AccountGroupPreview.fromJSON(e))
        : [],
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
    }
  },

  toJSON(message: BatchOrderPreviewResponse): unknown {
    const obj: any = {}
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => RowPreviewResult.toJSON(e))
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => AccountGroupPreview.toJSON(e))
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BatchOrderPreviewResponse>, I>>(
    base?: I
  ): BatchOrderPreviewResponse {
    return BatchOrderPreviewResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BatchOrderPreviewResponse>, I>>(
    object: I
  ): BatchOrderPreviewResponse {
    const message = createBaseBatchOrderPreviewResponse()
    message.rows = object.rows?.map((e) => RowPreviewResult.fromPartial(e)) || []
    message.groups = object.groups?.map((e) => AccountGroupPreview.fromPartial(e)) || []
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBaseExecutionWarning(): ExecutionWarning {
  return { severity: 0, warningCode: 0, notionalUsdValue: '', recommendation: 0, relatedSymbol: '' }
}

export const ExecutionWarning: MessageFns<ExecutionWarning> = {
  encode(message: ExecutionWarning, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.severity !== 0) {
      writer.uint32(8).int32(message.severity)
    }
    if (message.warningCode !== 0) {
      writer.uint32(16).int32(message.warningCode)
    }
    if (message.notionalUsdValue !== '') {
      writer.uint32(26).string(message.notionalUsdValue)
    }
    if (message.recommendation !== 0) {
      writer.uint32(32).int32(message.recommendation)
    }
    if (message.relatedSymbol !== '') {
      writer.uint32(42).string(message.relatedSymbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionWarning {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionWarning()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.severity = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.warningCode = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.notionalUsdValue = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.recommendation = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.relatedSymbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionWarning {
    return {
      severity: isSet(object.severity) ? warningSeverityFromJSON(object.severity) : 0,
      warningCode: isSet(object.warningCode)
        ? warningCodeFromJSON(object.warningCode)
        : isSet(object.warning_code)
          ? warningCodeFromJSON(object.warning_code)
          : 0,
      notionalUsdValue: isSet(object.notionalUsdValue)
        ? globalThis.String(object.notionalUsdValue)
        : isSet(object.notional_usd_value)
          ? globalThis.String(object.notional_usd_value)
          : '',
      recommendation: isSet(object.recommendation)
        ? recommendedActionFromJSON(object.recommendation)
        : 0,
      relatedSymbol: isSet(object.relatedSymbol)
        ? globalThis.String(object.relatedSymbol)
        : isSet(object.related_symbol)
          ? globalThis.String(object.related_symbol)
          : '',
    }
  },

  toJSON(message: ExecutionWarning): unknown {
    const obj: any = {}
    if (message.severity !== 0) {
      obj.severity = warningSeverityToJSON(message.severity)
    }
    if (message.warningCode !== 0) {
      obj.warningCode = warningCodeToJSON(message.warningCode)
    }
    if (message.notionalUsdValue !== '') {
      obj.notionalUsdValue = message.notionalUsdValue
    }
    if (message.recommendation !== 0) {
      obj.recommendation = recommendedActionToJSON(message.recommendation)
    }
    if (message.relatedSymbol !== '') {
      obj.relatedSymbol = message.relatedSymbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionWarning>, I>>(base?: I): ExecutionWarning {
    return ExecutionWarning.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionWarning>, I>>(object: I): ExecutionWarning {
    const message = createBaseExecutionWarning()
    message.severity = object.severity ?? 0
    message.warningCode = object.warningCode ?? 0
    message.notionalUsdValue = object.notionalUsdValue ?? ''
    message.recommendation = object.recommendation ?? 0
    message.relatedSymbol = object.relatedSymbol ?? ''
    return message
  },
}

function createBaseCompressedPayload(): CompressedPayload {
  return { data: new Uint8Array(0), method: 0, payloadType: 0 }
}

export const CompressedPayload: MessageFns<CompressedPayload> = {
  encode(message: CompressedPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data)
    }
    if (message.method !== 0) {
      writer.uint32(16).int32(message.method)
    }
    if (message.payloadType !== 0) {
      writer.uint32(24).int32(message.payloadType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompressedPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCompressedPayload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.data = reader.bytes()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.method = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.payloadType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CompressedPayload {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      method: isSet(object.method) ? compressedPayload_CompressionMethodFromJSON(object.method) : 0,
      payloadType: isSet(object.payloadType)
        ? compressedPayload_PayloadTypeFromJSON(object.payloadType)
        : isSet(object.payload_type)
          ? compressedPayload_PayloadTypeFromJSON(object.payload_type)
          : 0,
    }
  },

  toJSON(message: CompressedPayload): unknown {
    const obj: any = {}
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data)
    }
    if (message.method !== 0) {
      obj.method = compressedPayload_CompressionMethodToJSON(message.method)
    }
    if (message.payloadType !== 0) {
      obj.payloadType = compressedPayload_PayloadTypeToJSON(message.payloadType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CompressedPayload>, I>>(base?: I): CompressedPayload {
    return CompressedPayload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CompressedPayload>, I>>(object: I): CompressedPayload {
    const message = createBaseCompressedPayload()
    message.data = object.data ?? new Uint8Array(0)
    message.method = object.method ?? 0
    message.payloadType = object.payloadType ?? 0
    return message
  },
}

function createBaseTimeResponse(): TimeResponse {
  return { serverTime: '0' }
}

export const TimeResponse: MessageFns<TimeResponse> = {
  encode(message: TimeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serverTime !== '0') {
      writer.uint32(8).int64(message.serverTime)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTimeResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.serverTime = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TimeResponse {
    return {
      serverTime: isSet(object.serverTime)
        ? globalThis.String(object.serverTime)
        : isSet(object.server_time)
          ? globalThis.String(object.server_time)
          : '0',
    }
  },

  toJSON(message: TimeResponse): unknown {
    const obj: any = {}
    if (message.serverTime !== '0') {
      obj.serverTime = message.serverTime
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TimeResponse>, I>>(base?: I): TimeResponse {
    return TimeResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TimeResponse>, I>>(object: I): TimeResponse {
    const message = createBaseTimeResponse()
    message.serverTime = object.serverTime ?? '0'
    return message
  },
}

function createBaseSubscribe(): Subscribe {
  return { channels: [] }
}

export const Subscribe: MessageFns<Subscribe> = {
  encode(message: Subscribe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channels) {
      MessageSubject.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Subscribe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSubscribe()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.channels.push(MessageSubject.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Subscribe {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => MessageSubject.fromJSON(e))
        : [],
    }
  },

  toJSON(message: Subscribe): unknown {
    const obj: any = {}
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => MessageSubject.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Subscribe>, I>>(base?: I): Subscribe {
    return Subscribe.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Subscribe>, I>>(object: I): Subscribe {
    const message = createBaseSubscribe()
    message.channels = object.channels?.map((e) => MessageSubject.fromPartial(e)) || []
    return message
  },
}

function createBaseUnsubscribe(): Unsubscribe {
  return { channels: [] }
}

export const Unsubscribe: MessageFns<Unsubscribe> = {
  encode(message: Unsubscribe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channels) {
      MessageSubject.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Unsubscribe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUnsubscribe()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.channels.push(MessageSubject.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Unsubscribe {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => MessageSubject.fromJSON(e))
        : [],
    }
  },

  toJSON(message: Unsubscribe): unknown {
    const obj: any = {}
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => MessageSubject.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Unsubscribe>, I>>(base?: I): Unsubscribe {
    return Unsubscribe.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Unsubscribe>, I>>(object: I): Unsubscribe {
    const message = createBaseUnsubscribe()
    message.channels = object.channels?.map((e) => MessageSubject.fromPartial(e)) || []
    return message
  },
}

function createBaseDataRequest(): DataRequest {
  return { requests: [] }
}

export const DataRequest: MessageFns<DataRequest> = {
  encode(message: DataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.requests) {
      MessageSubject.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDataRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.requests.push(MessageSubject.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DataRequest {
    return {
      requests: globalThis.Array.isArray(object?.requests)
        ? object.requests.map((e: any) => MessageSubject.fromJSON(e))
        : [],
    }
  },

  toJSON(message: DataRequest): unknown {
    const obj: any = {}
    if (message.requests?.length) {
      obj.requests = message.requests.map((e) => MessageSubject.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DataRequest>, I>>(base?: I): DataRequest {
    return DataRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DataRequest>, I>>(object: I): DataRequest {
    const message = createBaseDataRequest()
    message.requests = object.requests?.map((e) => MessageSubject.fromPartial(e)) || []
    return message
  },
}

function createBaseSetStreamInterval(): SetStreamInterval {
  return { interval: 0 }
}

export const SetStreamInterval: MessageFns<SetStreamInterval> = {
  encode(message: SetStreamInterval, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.interval !== 0) {
      writer.uint32(8).int32(message.interval)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetStreamInterval {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetStreamInterval()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.interval = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetStreamInterval {
    return { interval: isSet(object.interval) ? streamIntervalFromJSON(object.interval) : 0 }
  },

  toJSON(message: SetStreamInterval): unknown {
    const obj: any = {}
    if (message.interval !== 0) {
      obj.interval = streamIntervalToJSON(message.interval)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetStreamInterval>, I>>(base?: I): SetStreamInterval {
    return SetStreamInterval.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetStreamInterval>, I>>(object: I): SetStreamInterval {
    const message = createBaseSetStreamInterval()
    message.interval = object.interval ?? 0
    return message
  },
}

function createBaseClientMessage(): ClientMessage {
  return {
    authenticate: undefined,
    subscribe: undefined,
    unsubscribe: undefined,
    ping: undefined,
    pong: undefined,
    apiRequest: undefined,
    setStreamInterval: undefined,
  }
}

export const ClientMessage: MessageFns<ClientMessage> = {
  encode(message: ClientMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.authenticate !== undefined) {
      AuthenticateRequest.encode(message.authenticate, writer.uint32(50).fork()).join()
    }
    if (message.subscribe !== undefined) {
      Subscribe.encode(message.subscribe, writer.uint32(10).fork()).join()
    }
    if (message.unsubscribe !== undefined) {
      Unsubscribe.encode(message.unsubscribe, writer.uint32(18).fork()).join()
    }
    if (message.ping !== undefined) {
      Ping.encode(message.ping, writer.uint32(26).fork()).join()
    }
    if (message.pong !== undefined) {
      Pong.encode(message.pong, writer.uint32(34).fork()).join()
    }
    if (message.apiRequest !== undefined) {
      ApiRequest.encode(message.apiRequest, writer.uint32(42).fork()).join()
    }
    if (message.setStreamInterval !== undefined) {
      SetStreamInterval.encode(message.setStreamInterval, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClientMessage()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 6: {
          if (tag !== 50) {
            break
          }

          message.authenticate = AuthenticateRequest.decode(reader, reader.uint32())
          continue
        }
        case 1: {
          if (tag !== 10) {
            break
          }

          message.subscribe = Subscribe.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.unsubscribe = Unsubscribe.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.ping = Ping.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.pong = Pong.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.apiRequest = ApiRequest.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.setStreamInterval = SetStreamInterval.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClientMessage {
    return {
      authenticate: isSet(object.authenticate)
        ? AuthenticateRequest.fromJSON(object.authenticate)
        : undefined,
      subscribe: isSet(object.subscribe) ? Subscribe.fromJSON(object.subscribe) : undefined,
      unsubscribe: isSet(object.unsubscribe) ? Unsubscribe.fromJSON(object.unsubscribe) : undefined,
      ping: isSet(object.ping) ? Ping.fromJSON(object.ping) : undefined,
      pong: isSet(object.pong) ? Pong.fromJSON(object.pong) : undefined,
      apiRequest: isSet(object.apiRequest)
        ? ApiRequest.fromJSON(object.apiRequest)
        : isSet(object.api_request)
          ? ApiRequest.fromJSON(object.api_request)
          : undefined,
      setStreamInterval: isSet(object.setStreamInterval)
        ? SetStreamInterval.fromJSON(object.setStreamInterval)
        : isSet(object.set_stream_interval)
          ? SetStreamInterval.fromJSON(object.set_stream_interval)
          : undefined,
    }
  },

  toJSON(message: ClientMessage): unknown {
    const obj: any = {}
    if (message.authenticate !== undefined) {
      obj.authenticate = AuthenticateRequest.toJSON(message.authenticate)
    }
    if (message.subscribe !== undefined) {
      obj.subscribe = Subscribe.toJSON(message.subscribe)
    }
    if (message.unsubscribe !== undefined) {
      obj.unsubscribe = Unsubscribe.toJSON(message.unsubscribe)
    }
    if (message.ping !== undefined) {
      obj.ping = Ping.toJSON(message.ping)
    }
    if (message.pong !== undefined) {
      obj.pong = Pong.toJSON(message.pong)
    }
    if (message.apiRequest !== undefined) {
      obj.apiRequest = ApiRequest.toJSON(message.apiRequest)
    }
    if (message.setStreamInterval !== undefined) {
      obj.setStreamInterval = SetStreamInterval.toJSON(message.setStreamInterval)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClientMessage>, I>>(base?: I): ClientMessage {
    return ClientMessage.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClientMessage>, I>>(object: I): ClientMessage {
    const message = createBaseClientMessage()
    message.authenticate =
      object.authenticate !== undefined && object.authenticate !== null
        ? AuthenticateRequest.fromPartial(object.authenticate)
        : undefined
    message.subscribe =
      object.subscribe !== undefined && object.subscribe !== null
        ? Subscribe.fromPartial(object.subscribe)
        : undefined
    message.unsubscribe =
      object.unsubscribe !== undefined && object.unsubscribe !== null
        ? Unsubscribe.fromPartial(object.unsubscribe)
        : undefined
    message.ping =
      object.ping !== undefined && object.ping !== null ? Ping.fromPartial(object.ping) : undefined
    message.pong =
      object.pong !== undefined && object.pong !== null ? Pong.fromPartial(object.pong) : undefined
    message.apiRequest =
      object.apiRequest !== undefined && object.apiRequest !== null
        ? ApiRequest.fromPartial(object.apiRequest)
        : undefined
    message.setStreamInterval =
      object.setStreamInterval !== undefined && object.setStreamInterval !== null
        ? SetStreamInterval.fromPartial(object.setStreamInterval)
        : undefined
    return message
  },
}

function createBaseCreateRfqRequest(): CreateRfqRequest {
  return {
    accountId: '',
    legs: [],
    hedge: undefined,
    makerIds: [],
    disclosed: false,
    autoApprove: undefined,
    autoRetry: undefined,
    correlationId: undefined,
  }
}

export const CreateRfqRequest: MessageFns<CreateRfqRequest> = {
  encode(message: CreateRfqRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.legs) {
      RfqLeg.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.hedge !== undefined) {
      RfqHedgeLeg.encode(message.hedge, writer.uint32(26).fork()).join()
    }
    for (const v of message.makerIds) {
      writer.uint32(34).string(v!)
    }
    if (message.disclosed !== false) {
      writer.uint32(40).bool(message.disclosed)
    }
    if (message.autoApprove !== undefined) {
      AutoApprove.encode(message.autoApprove, writer.uint32(50).fork()).join()
    }
    if (message.autoRetry !== undefined) {
      AutoRetry.encode(message.autoRetry, writer.uint32(58).fork()).join()
    }
    if (message.correlationId !== undefined) {
      writer.uint32(66).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRfqRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateRfqRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.legs.push(RfqLeg.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.hedge = RfqHedgeLeg.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.makerIds.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.disclosed = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.autoApprove = AutoApprove.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.autoRetry = AutoRetry.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateRfqRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqLeg.fromJSON(e))
        : [],
      hedge: isSet(object.hedge) ? RfqHedgeLeg.fromJSON(object.hedge) : undefined,
      makerIds: globalThis.Array.isArray(object?.makerIds)
        ? object.makerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_ids)
          ? object.maker_ids.map((e: any) => globalThis.String(e))
          : [],
      disclosed: isSet(object.disclosed) ? globalThis.Boolean(object.disclosed) : false,
      autoApprove: isSet(object.autoApprove)
        ? AutoApprove.fromJSON(object.autoApprove)
        : isSet(object.auto_approve)
          ? AutoApprove.fromJSON(object.auto_approve)
          : undefined,
      autoRetry: isSet(object.autoRetry)
        ? AutoRetry.fromJSON(object.autoRetry)
        : isSet(object.auto_retry)
          ? AutoRetry.fromJSON(object.auto_retry)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: CreateRfqRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqLeg.toJSON(e))
    }
    if (message.hedge !== undefined) {
      obj.hedge = RfqHedgeLeg.toJSON(message.hedge)
    }
    if (message.makerIds?.length) {
      obj.makerIds = message.makerIds
    }
    if (message.disclosed !== false) {
      obj.disclosed = message.disclosed
    }
    if (message.autoApprove !== undefined) {
      obj.autoApprove = AutoApprove.toJSON(message.autoApprove)
    }
    if (message.autoRetry !== undefined) {
      obj.autoRetry = AutoRetry.toJSON(message.autoRetry)
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateRfqRequest>, I>>(base?: I): CreateRfqRequest {
    return CreateRfqRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateRfqRequest>, I>>(object: I): CreateRfqRequest {
    const message = createBaseCreateRfqRequest()
    message.accountId = object.accountId ?? ''
    message.legs = object.legs?.map((e) => RfqLeg.fromPartial(e)) || []
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? RfqHedgeLeg.fromPartial(object.hedge)
        : undefined
    message.makerIds = object.makerIds?.map((e) => e) || []
    message.disclosed = object.disclosed ?? false
    message.autoApprove =
      object.autoApprove !== undefined && object.autoApprove !== null
        ? AutoApprove.fromPartial(object.autoApprove)
        : undefined
    message.autoRetry =
      object.autoRetry !== undefined && object.autoRetry !== null
        ? AutoRetry.fromPartial(object.autoRetry)
        : undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCreateRfqResponse(): CreateRfqResponse {
  return { rfqId: undefined, correlationId: undefined }
}

export const CreateRfqResponse: MessageFns<CreateRfqResponse> = {
  encode(message: CreateRfqResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rfqId !== undefined) {
      writer.uint32(10).string(message.rfqId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(18).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRfqResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateRfqResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateRfqResponse {
    return {
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: CreateRfqResponse): unknown {
    const obj: any = {}
    if (message.rfqId !== undefined) {
      obj.rfqId = message.rfqId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateRfqResponse>, I>>(base?: I): CreateRfqResponse {
    return CreateRfqResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateRfqResponse>, I>>(object: I): CreateRfqResponse {
    const message = createBaseCreateRfqResponse()
    message.rfqId = object.rfqId ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCancelRfqRequest(): CancelRfqRequest {
  return { accountId: '', rfqId: '', correlationId: undefined }
}

export const CancelRfqRequest: MessageFns<CancelRfqRequest> = {
  encode(message: CancelRfqRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: CancelRfqRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqRequest>, I>>(base?: I): CancelRfqRequest {
    return CancelRfqRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqRequest>, I>>(object: I): CancelRfqRequest {
    const message = createBaseCancelRfqRequest()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCancelRfqResponse(): CancelRfqResponse {
  return { accepted: false }
}

export const CancelRfqResponse: MessageFns<CancelRfqResponse> = {
  encode(message: CancelRfqResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accepted = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqResponse {
    return { accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false }
  },

  toJSON(message: CancelRfqResponse): unknown {
    const obj: any = {}
    if (message.accepted !== false) {
      obj.accepted = message.accepted
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqResponse>, I>>(base?: I): CancelRfqResponse {
    return CancelRfqResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqResponse>, I>>(object: I): CancelRfqResponse {
    const message = createBaseCancelRfqResponse()
    message.accepted = object.accepted ?? false
    return message
  },
}

function createBaseSendRfqMakerQuoteRequest(): SendRfqMakerQuoteRequest {
  return {
    accountId: '',
    rfqId: '',
    side: 0,
    price: '',
    quoteId: undefined,
    correlationId: undefined,
  }
}

export const SendRfqMakerQuoteRequest: MessageFns<SendRfqMakerQuoteRequest> = {
  encode(
    message: SendRfqMakerQuoteRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    if (message.quoteId !== undefined) {
      writer.uint32(42).string(message.quoteId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(50).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendRfqMakerQuoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSendRfqMakerQuoteRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SendRfqMakerQuoteRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      side: isSet(object.side) ? rfqQuoteSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: SendRfqMakerQuoteRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.side !== 0) {
      obj.side = rfqQuoteSideToJSON(message.side)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.quoteId !== undefined) {
      obj.quoteId = message.quoteId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SendRfqMakerQuoteRequest>, I>>(
    base?: I
  ): SendRfqMakerQuoteRequest {
    return SendRfqMakerQuoteRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SendRfqMakerQuoteRequest>, I>>(
    object: I
  ): SendRfqMakerQuoteRequest {
    const message = createBaseSendRfqMakerQuoteRequest()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.side = object.side ?? 0
    message.price = object.price ?? ''
    message.quoteId = object.quoteId ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseSendRfqMakerQuoteResponse(): SendRfqMakerQuoteResponse {
  return { quoteId: '' }
}

export const SendRfqMakerQuoteResponse: MessageFns<SendRfqMakerQuoteResponse> = {
  encode(
    message: SendRfqMakerQuoteResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.quoteId !== '') {
      writer.uint32(10).string(message.quoteId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendRfqMakerQuoteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSendRfqMakerQuoteResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SendRfqMakerQuoteResponse {
    return {
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
    }
  },

  toJSON(message: SendRfqMakerQuoteResponse): unknown {
    const obj: any = {}
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SendRfqMakerQuoteResponse>, I>>(
    base?: I
  ): SendRfqMakerQuoteResponse {
    return SendRfqMakerQuoteResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SendRfqMakerQuoteResponse>, I>>(
    object: I
  ): SendRfqMakerQuoteResponse {
    const message = createBaseSendRfqMakerQuoteResponse()
    message.quoteId = object.quoteId ?? ''
    return message
  },
}

function createBaseCancelRfqMakerQuoteRequest(): CancelRfqMakerQuoteRequest {
  return { accountId: '', quoteId: '', correlationId: undefined, rfqId: '' }
}

export const CancelRfqMakerQuoteRequest: MessageFns<CancelRfqMakerQuoteRequest> = {
  encode(
    message: CancelRfqMakerQuoteRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.quoteId !== '') {
      writer.uint32(18).string(message.quoteId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    if (message.rfqId !== '') {
      writer.uint32(34).string(message.rfqId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqMakerQuoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqMakerQuoteRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqMakerQuoteRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
    }
  },

  toJSON(message: CancelRfqMakerQuoteRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqMakerQuoteRequest>, I>>(
    base?: I
  ): CancelRfqMakerQuoteRequest {
    return CancelRfqMakerQuoteRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqMakerQuoteRequest>, I>>(
    object: I
  ): CancelRfqMakerQuoteRequest {
    const message = createBaseCancelRfqMakerQuoteRequest()
    message.accountId = object.accountId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.correlationId = object.correlationId ?? undefined
    message.rfqId = object.rfqId ?? ''
    return message
  },
}

function createBaseCancelRfqMakerQuoteResponse(): CancelRfqMakerQuoteResponse {
  return { accepted: false }
}

export const CancelRfqMakerQuoteResponse: MessageFns<CancelRfqMakerQuoteResponse> = {
  encode(
    message: CancelRfqMakerQuoteResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfqMakerQuoteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfqMakerQuoteResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accepted = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfqMakerQuoteResponse {
    return { accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false }
  },

  toJSON(message: CancelRfqMakerQuoteResponse): unknown {
    const obj: any = {}
    if (message.accepted !== false) {
      obj.accepted = message.accepted
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfqMakerQuoteResponse>, I>>(
    base?: I
  ): CancelRfqMakerQuoteResponse {
    return CancelRfqMakerQuoteResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfqMakerQuoteResponse>, I>>(
    object: I
  ): CancelRfqMakerQuoteResponse {
    const message = createBaseCancelRfqMakerQuoteResponse()
    message.accepted = object.accepted ?? false
    return message
  },
}

function createBaseAcceptRfqQuoteRequest(): AcceptRfqQuoteRequest {
  return { accountId: '', rfqId: '', quoteId: '', price: '', correlationId: undefined }
}

export const AcceptRfqQuoteRequest: MessageFns<AcceptRfqQuoteRequest> = {
  encode(message: AcceptRfqQuoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.quoteId !== '') {
      writer.uint32(26).string(message.quoteId)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(42).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcceptRfqQuoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAcceptRfqQuoteRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AcceptRfqQuoteRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: AcceptRfqQuoteRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AcceptRfqQuoteRequest>, I>>(base?: I): AcceptRfqQuoteRequest {
    return AcceptRfqQuoteRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AcceptRfqQuoteRequest>, I>>(
    object: I
  ): AcceptRfqQuoteRequest {
    const message = createBaseAcceptRfqQuoteRequest()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.price = object.price ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseAcceptRfqQuoteResponse(): AcceptRfqQuoteResponse {
  return { accepted: false }
}

export const AcceptRfqQuoteResponse: MessageFns<AcceptRfqQuoteResponse> = {
  encode(message: AcceptRfqQuoteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcceptRfqQuoteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAcceptRfqQuoteResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.accepted = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AcceptRfqQuoteResponse {
    return { accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false }
  },

  toJSON(message: AcceptRfqQuoteResponse): unknown {
    const obj: any = {}
    if (message.accepted !== false) {
      obj.accepted = message.accepted
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AcceptRfqQuoteResponse>, I>>(
    base?: I
  ): AcceptRfqQuoteResponse {
    return AcceptRfqQuoteResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AcceptRfqQuoteResponse>, I>>(
    object: I
  ): AcceptRfqQuoteResponse {
    const message = createBaseAcceptRfqQuoteResponse()
    message.accepted = object.accepted ?? false
    return message
  },
}

function createBaseGetRfqMakersRequest(): GetRfqMakersRequest {
  return { accountId: '' }
}

export const GetRfqMakersRequest: MessageFns<GetRfqMakersRequest> = {
  encode(message: GetRfqMakersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRfqMakersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetRfqMakersRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetRfqMakersRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: GetRfqMakersRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetRfqMakersRequest>, I>>(base?: I): GetRfqMakersRequest {
    return GetRfqMakersRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetRfqMakersRequest>, I>>(
    object: I
  ): GetRfqMakersRequest {
    const message = createBaseGetRfqMakersRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseGetRfqMakersResponse(): GetRfqMakersResponse {
  return { makerIds: [] }
}

export const GetRfqMakersResponse: MessageFns<GetRfqMakersResponse> = {
  encode(message: GetRfqMakersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.makerIds) {
      writer.uint32(10).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRfqMakersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetRfqMakersResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.makerIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetRfqMakersResponse {
    return {
      makerIds: globalThis.Array.isArray(object?.makerIds)
        ? object.makerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_ids)
          ? object.maker_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: GetRfqMakersResponse): unknown {
    const obj: any = {}
    if (message.makerIds?.length) {
      obj.makerIds = message.makerIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetRfqMakersResponse>, I>>(base?: I): GetRfqMakersResponse {
    return GetRfqMakersResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetRfqMakersResponse>, I>>(
    object: I
  ): GetRfqMakersResponse {
    const message = createBaseGetRfqMakersResponse()
    message.makerIds = object.makerIds?.map((e) => e) || []
    return message
  },
}

function createBaseGetRfqHistoryRequest(): GetRfqHistoryRequest {
  return { accountId: '', accountIds: [], from: undefined, to: undefined, limit: undefined }
}

export const GetRfqHistoryRequest: MessageFns<GetRfqHistoryRequest> = {
  encode(message: GetRfqHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(42).string(v!)
    }
    if (message.from !== undefined) {
      writer.uint32(16).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(24).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(32).int64(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRfqHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetRfqHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.limit = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetRfqHistoryRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.String(object.limit) : undefined,
    }
  },

  toJSON(message: GetRfqHistoryRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = message.limit
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetRfqHistoryRequest>, I>>(base?: I): GetRfqHistoryRequest {
    return GetRfqHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetRfqHistoryRequest>, I>>(
    object: I
  ): GetRfqHistoryRequest {
    const message = createBaseGetRfqHistoryRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseGetRfqHistoryResponse(): GetRfqHistoryResponse {
  return { rfqs: [] }
}

export const GetRfqHistoryResponse: MessageFns<GetRfqHistoryResponse> = {
  encode(message: GetRfqHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rfqs) {
      RfqUpdate.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRfqHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetRfqHistoryResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rfqs.push(RfqUpdate.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetRfqHistoryResponse {
    return {
      rfqs: globalThis.Array.isArray(object?.rfqs)
        ? object.rfqs.map((e: any) => RfqUpdate.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetRfqHistoryResponse): unknown {
    const obj: any = {}
    if (message.rfqs?.length) {
      obj.rfqs = message.rfqs.map((e) => RfqUpdate.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetRfqHistoryResponse>, I>>(base?: I): GetRfqHistoryResponse {
    return GetRfqHistoryResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetRfqHistoryResponse>, I>>(
    object: I
  ): GetRfqHistoryResponse {
    const message = createBaseGetRfqHistoryResponse()
    message.rfqs = object.rfqs?.map((e) => RfqUpdate.fromPartial(e)) || []
    return message
  },
}

function createBaseApiRequest(): ApiRequest {
  return {
    executionBatch: undefined,
    login: undefined,
    signup: undefined,
    createAccount: undefined,
    getUserAccounts: undefined,
    requestPasswordReset: undefined,
    confirmPasswordReset: undefined,
    refreshToken: undefined,
    verifyEmail: undefined,
    resendVerification: undefined,
    verify: undefined,
    setup2fa: undefined,
    confirm2faSetup: undefined,
    verify2fa: undefined,
    verify2faLogin: undefined,
    disable2fa: undefined,
    get2faBackupCodes: undefined,
    setupPasskey: undefined,
    confirmPasskeySetup: undefined,
    passkeyLogin: undefined,
    confirmPasskeyLogin: undefined,
    deletePasskey: undefined,
    getUserPasskeys: undefined,
    googleLogin: undefined,
    chartData: undefined,
    portfolioLineChart: undefined,
    time: undefined,
    updateAccount: undefined,
    instrumentList: undefined,
    orderHistory: undefined,
    tradeHistory: undefined,
    createPage: undefined,
    getPages: undefined,
    getPageLayout: undefined,
    updatePageMeta: undefined,
    deletePage: undefined,
    addWidget: undefined,
    updateWidget: undefined,
    removeWidget: undefined,
    saveComponentPreference: undefined,
    getComponentPreference: undefined,
    createPositionGroup: undefined,
    updatePositionGroup: undefined,
    deletePositionGroup: undefined,
    getPositionsView: undefined,
    getPositionGroups: undefined,
    reorderPositionsView: undefined,
    setPositionGroupOrder: undefined,
    generateVolSurface: undefined,
    riskSimulation: undefined,
    economicCalendarHistory: undefined,
    executionAnalytics: undefined,
    getVenues: undefined,
    getExchanges: undefined,
    getOrdersForAlgo: undefined,
    getTradesForOrder: undefined,
    getOrderStateHistory: undefined,
    getTradesForAlgo: undefined,
    getAnalyticSnapshot: undefined,
    getAnalyticRange: undefined,
    optionsVolumeLeaderboard: undefined,
    optionsVolumeSeries: undefined,
    optionsOiSeries: undefined,
    optionsOiLeaderboard: undefined,
    optionsOiByStrike: undefined,
    fundingSeries: undefined,
    fundingLeaderboard: undefined,
    createPreset: undefined,
    updatePreset: undefined,
    deletePreset: undefined,
    listPresets: undefined,
    executePreset: undefined,
    getPreset: undefined,
    createWatchlist: undefined,
    getWatchlists: undefined,
    setWatchlist: undefined,
    renameWatchlist: undefined,
    deleteWatchlist: undefined,
    reorderWatchlists: undefined,
    dbNewsHistory: undefined,
    alpacaNewsHistory: undefined,
    intentCompiler: undefined,
    confirmExecutionPlan: undefined,
    getDbNewsVocabulary: undefined,
    testIntentCompiler: undefined,
    getVenueStatus: undefined,
    getVenueSchedules: undefined,
    createRfq: undefined,
    cancelRfq: undefined,
    acceptRfqQuote: undefined,
    getRfqMakers: undefined,
    getRfqHistory: undefined,
    rfqAnalytics: undefined,
    bybitOauthMintState: undefined,
    bybitOauthExchangeCode: undefined,
    deribitOauthMintState: undefined,
    deribitOauthExchangeCode: undefined,
    hyperliquidPrepareAgent: undefined,
    hyperliquidConfirmAgent: undefined,
    hyperliquidDisconnectAgent: undefined,
    derivePrepareSessionKey: undefined,
    deriveConfirmSessionKey: undefined,
    deriveDisconnect: undefined,
    deriveListSubaccounts: undefined,
    deriveLinkSubaccounts: undefined,
    lighterListSubaccounts: undefined,
    lighterPrepareSubaccountKey: undefined,
    lighterConfirmSubaccountKey: undefined,
    lighterLinkSubaccounts: undefined,
    createCheckoutSession: undefined,
    getSubscription: undefined,
    openBillingPortal: undefined,
    getPlans: undefined,
    inviteToAccount: undefined,
    listAccountAccess: undefined,
    revokeInvite: undefined,
    removeAccountAccess: undefined,
    changeAccountRole: undefined,
    leaveAccount: undefined,
    listMyInvites: undefined,
    respondToInvite: undefined,
    transferAccountOwnership: undefined,
    cancelPendingAccount: undefined,
    orderPreview: undefined,
    changePassword: undefined,
    listSessions: undefined,
    revokeSession: undefined,
    logout: undefined,
    revokeAllOtherSessions: undefined,
    sendStepUpCode: undefined,
    orderbookMetricsSeries: undefined,
    optionsTradesHistory: undefined,
    masterInstrumentList: undefined,
    impliedMove: undefined,
    ivPercentile: undefined,
    maxPain: undefined,
    greeksByExpiry: undefined,
    generateWatchlist: undefined,
    hyperliquidListSubaccounts: undefined,
    hyperliquidLinkSubaccounts: undefined,
    batchOrderPreview: undefined,
    visibleRangeProfile: undefined,
    getTwitterPostHistory: undefined,
    lighterPrepareIntegratorConsent: undefined,
    lighterConfirmIntegratorConsent: undefined,
    etfFundFlows: undefined,
    fedwatchProbabilities: undefined,
    getCoinmarketcalEvents: undefined,
    optionsStrikeFlow: undefined,
    gexAggregate: undefined,
    economicData: undefined,
    mintMessagingLinkNonce: undefined,
    getTokenUnlocks: undefined,
    getTokenEmission: undefined,
    paradigmConnectDesk: undefined,
    paradigmListAccounts: undefined,
    paradigmLinkAccount: undefined,
    paradigmDisconnect: undefined,
    createSharedLayout: undefined,
    getSharedLayout: undefined,
    treeNewsHistory: undefined,
    surfaceCurrencies: undefined,
    createApiKey: undefined,
    listApiKeys: undefined,
    revokeApiKey: undefined,
    getApiBilling: undefined,
    updateApiBillingSettings: undefined,
    createCreditCheckoutSession: undefined,
    listCreditLedger: undefined,
    getCreditSpendStats: undefined,
    getMarketScreener: undefined,
    listVolFitReferences: undefined,
    orderbookHeatmap: undefined,
    sendRfqMakerQuote: undefined,
    cancelRfqMakerQuote: undefined,
    setLeverage: undefined,
    papertradePrepareSessionKey: undefined,
    papertradeConfirmSessionKey: undefined,
    papertradeDisconnect: undefined,
    getAccountSettings: undefined,
  }
}

export const ApiRequest: MessageFns<ApiRequest> = {
  encode(message: ApiRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.executionBatch !== undefined) {
      ExecutionBatch.encode(message.executionBatch, writer.uint32(10).fork()).join()
    }
    if (message.login !== undefined) {
      LoginRequest.encode(message.login, writer.uint32(18).fork()).join()
    }
    if (message.signup !== undefined) {
      SignupRequest.encode(message.signup, writer.uint32(26).fork()).join()
    }
    if (message.createAccount !== undefined) {
      CreateAccountRequest.encode(message.createAccount, writer.uint32(34).fork()).join()
    }
    if (message.getUserAccounts !== undefined) {
      GetUserAccountsRequest.encode(message.getUserAccounts, writer.uint32(42).fork()).join()
    }
    if (message.requestPasswordReset !== undefined) {
      RequestPasswordResetRequest.encode(
        message.requestPasswordReset,
        writer.uint32(50).fork()
      ).join()
    }
    if (message.confirmPasswordReset !== undefined) {
      ConfirmPasswordResetRequest.encode(
        message.confirmPasswordReset,
        writer.uint32(58).fork()
      ).join()
    }
    if (message.refreshToken !== undefined) {
      RefreshTokenRequest.encode(message.refreshToken, writer.uint32(66).fork()).join()
    }
    if (message.verifyEmail !== undefined) {
      VerifyEmailRequest.encode(message.verifyEmail, writer.uint32(74).fork()).join()
    }
    if (message.resendVerification !== undefined) {
      ResendVerificationRequest.encode(message.resendVerification, writer.uint32(82).fork()).join()
    }
    if (message.verify !== undefined) {
      VerifyTokenRequest.encode(message.verify, writer.uint32(378).fork()).join()
    }
    if (message.setup2fa !== undefined) {
      Setup2faRequest.encode(message.setup2fa, writer.uint32(90).fork()).join()
    }
    if (message.confirm2faSetup !== undefined) {
      Confirm2faSetupRequest.encode(message.confirm2faSetup, writer.uint32(98).fork()).join()
    }
    if (message.verify2fa !== undefined) {
      Verify2faRequest.encode(message.verify2fa, writer.uint32(106).fork()).join()
    }
    if (message.verify2faLogin !== undefined) {
      Verify2faLoginRequest.encode(message.verify2faLogin, writer.uint32(114).fork()).join()
    }
    if (message.disable2fa !== undefined) {
      Disable2faRequest.encode(message.disable2fa, writer.uint32(122).fork()).join()
    }
    if (message.get2faBackupCodes !== undefined) {
      Get2faBackupCodesRequest.encode(message.get2faBackupCodes, writer.uint32(130).fork()).join()
    }
    if (message.setupPasskey !== undefined) {
      SetupPasskeyRequest.encode(message.setupPasskey, writer.uint32(138).fork()).join()
    }
    if (message.confirmPasskeySetup !== undefined) {
      ConfirmPasskeySetupRequest.encode(
        message.confirmPasskeySetup,
        writer.uint32(146).fork()
      ).join()
    }
    if (message.passkeyLogin !== undefined) {
      PasskeyLoginRequest.encode(message.passkeyLogin, writer.uint32(154).fork()).join()
    }
    if (message.confirmPasskeyLogin !== undefined) {
      ConfirmPasskeyLoginRequest.encode(
        message.confirmPasskeyLogin,
        writer.uint32(162).fork()
      ).join()
    }
    if (message.deletePasskey !== undefined) {
      DeletePasskeyRequest.encode(message.deletePasskey, writer.uint32(170).fork()).join()
    }
    if (message.getUserPasskeys !== undefined) {
      GetUserPasskeysRequest.encode(message.getUserPasskeys, writer.uint32(178).fork()).join()
    }
    if (message.googleLogin !== undefined) {
      GoogleLoginRequest.encode(message.googleLogin, writer.uint32(186).fork()).join()
    }
    if (message.chartData !== undefined) {
      ChartDataRequest.encode(message.chartData, writer.uint32(194).fork()).join()
    }
    if (message.portfolioLineChart !== undefined) {
      PortfolioLineChartRequest.encode(message.portfolioLineChart, writer.uint32(370).fork()).join()
    }
    if (message.time !== undefined) {
      Time.encode(message.time, writer.uint32(202).fork()).join()
    }
    if (message.updateAccount !== undefined) {
      UpdateAccountRequest.encode(message.updateAccount, writer.uint32(210).fork()).join()
    }
    if (message.instrumentList !== undefined) {
      InstrumentListRequest.encode(message.instrumentList, writer.uint32(218).fork()).join()
    }
    if (message.orderHistory !== undefined) {
      HistoryRequest.encode(message.orderHistory, writer.uint32(226).fork()).join()
    }
    if (message.tradeHistory !== undefined) {
      HistoryRequest.encode(message.tradeHistory, writer.uint32(234).fork()).join()
    }
    if (message.createPage !== undefined) {
      CreatePageRequest.encode(message.createPage, writer.uint32(250).fork()).join()
    }
    if (message.getPages !== undefined) {
      GetPagesRequest.encode(message.getPages, writer.uint32(258).fork()).join()
    }
    if (message.getPageLayout !== undefined) {
      GetPageLayoutRequest.encode(message.getPageLayout, writer.uint32(266).fork()).join()
    }
    if (message.updatePageMeta !== undefined) {
      UpdatePageMetaRequest.encode(message.updatePageMeta, writer.uint32(274).fork()).join()
    }
    if (message.deletePage !== undefined) {
      DeletePageRequest.encode(message.deletePage, writer.uint32(282).fork()).join()
    }
    if (message.addWidget !== undefined) {
      AddWidgetRequest.encode(message.addWidget, writer.uint32(290).fork()).join()
    }
    if (message.updateWidget !== undefined) {
      UpdateWidgetRequest.encode(message.updateWidget, writer.uint32(298).fork()).join()
    }
    if (message.removeWidget !== undefined) {
      RemoveWidgetRequest.encode(message.removeWidget, writer.uint32(306).fork()).join()
    }
    if (message.saveComponentPreference !== undefined) {
      SaveComponentPreferenceRequest.encode(
        message.saveComponentPreference,
        writer.uint32(314).fork()
      ).join()
    }
    if (message.getComponentPreference !== undefined) {
      GetComponentPreferenceRequest.encode(
        message.getComponentPreference,
        writer.uint32(322).fork()
      ).join()
    }
    if (message.createPositionGroup !== undefined) {
      CreatePositionGroupRequest.encode(
        message.createPositionGroup,
        writer.uint32(330).fork()
      ).join()
    }
    if (message.updatePositionGroup !== undefined) {
      UpdatePositionGroupRequest.encode(
        message.updatePositionGroup,
        writer.uint32(338).fork()
      ).join()
    }
    if (message.deletePositionGroup !== undefined) {
      DeletePositionGroupRequest.encode(
        message.deletePositionGroup,
        writer.uint32(346).fork()
      ).join()
    }
    if (message.getPositionsView !== undefined) {
      GetPositionsViewRequest.encode(message.getPositionsView, writer.uint32(354).fork()).join()
    }
    if (message.getPositionGroups !== undefined) {
      GetPositionGroupsRequest.encode(message.getPositionGroups, writer.uint32(362).fork()).join()
    }
    if (message.reorderPositionsView !== undefined) {
      ReorderPositionsViewRequest.encode(
        message.reorderPositionsView,
        writer.uint32(794).fork()
      ).join()
    }
    if (message.setPositionGroupOrder !== undefined) {
      SetPositionGroupOrderRequest.encode(
        message.setPositionGroupOrder,
        writer.uint32(802).fork()
      ).join()
    }
    if (message.generateVolSurface !== undefined) {
      GenerateVolSurfaceRequest.encode(message.generateVolSurface, writer.uint32(386).fork()).join()
    }
    if (message.riskSimulation !== undefined) {
      RiskSimulationRequest.encode(message.riskSimulation, writer.uint32(394).fork()).join()
    }
    if (message.economicCalendarHistory !== undefined) {
      EconomicCalendarHistoryRequest.encode(
        message.economicCalendarHistory,
        writer.uint32(402).fork()
      ).join()
    }
    if (message.executionAnalytics !== undefined) {
      ExecutionAnalyticsRequest.encode(message.executionAnalytics, writer.uint32(418).fork()).join()
    }
    if (message.getVenues !== undefined) {
      GetVenuesRequest.encode(message.getVenues, writer.uint32(426).fork()).join()
    }
    if (message.getExchanges !== undefined) {
      GetExchangesRequest.encode(message.getExchanges, writer.uint32(434).fork()).join()
    }
    if (message.getOrdersForAlgo !== undefined) {
      GetOrdersForAlgoRequest.encode(message.getOrdersForAlgo, writer.uint32(442).fork()).join()
    }
    if (message.getTradesForOrder !== undefined) {
      GetTradesForOrderRequest.encode(message.getTradesForOrder, writer.uint32(450).fork()).join()
    }
    if (message.getOrderStateHistory !== undefined) {
      GetOrderStateHistoryRequest.encode(
        message.getOrderStateHistory,
        writer.uint32(458).fork()
      ).join()
    }
    if (message.getTradesForAlgo !== undefined) {
      GetTradesForAlgoRequest.encode(message.getTradesForAlgo, writer.uint32(858).fork()).join()
    }
    if (message.getAnalyticSnapshot !== undefined) {
      GetAnalyticSnapshotRequest.encode(
        message.getAnalyticSnapshot,
        writer.uint32(474).fork()
      ).join()
    }
    if (message.getAnalyticRange !== undefined) {
      GetAnalyticRangeRequest.encode(message.getAnalyticRange, writer.uint32(482).fork()).join()
    }
    if (message.optionsVolumeLeaderboard !== undefined) {
      GetOptionsVolumeLeaderboardRequest.encode(
        message.optionsVolumeLeaderboard,
        writer.uint32(762).fork()
      ).join()
    }
    if (message.optionsVolumeSeries !== undefined) {
      OptionsVolumeSeriesRequest.encode(
        message.optionsVolumeSeries,
        writer.uint32(770).fork()
      ).join()
    }
    if (message.optionsOiSeries !== undefined) {
      OptionsOiSeriesRequest.encode(message.optionsOiSeries, writer.uint32(778).fork()).join()
    }
    if (message.optionsOiLeaderboard !== undefined) {
      GetOptionsOiLeaderboardRequest.encode(
        message.optionsOiLeaderboard,
        writer.uint32(786).fork()
      ).join()
    }
    if (message.optionsOiByStrike !== undefined) {
      GetOptionsOiByStrikeRequest.encode(
        message.optionsOiByStrike,
        writer.uint32(1298).fork()
      ).join()
    }
    if (message.fundingSeries !== undefined) {
      GetFundingSeriesRequest.encode(message.fundingSeries, writer.uint32(810).fork()).join()
    }
    if (message.fundingLeaderboard !== undefined) {
      GetFundingLeaderboardRequest.encode(
        message.fundingLeaderboard,
        writer.uint32(818).fork()
      ).join()
    }
    if (message.createPreset !== undefined) {
      CreatePresetRequest.encode(message.createPreset, writer.uint32(490).fork()).join()
    }
    if (message.updatePreset !== undefined) {
      UpdatePresetRequest.encode(message.updatePreset, writer.uint32(498).fork()).join()
    }
    if (message.deletePreset !== undefined) {
      DeletePresetRequest.encode(message.deletePreset, writer.uint32(506).fork()).join()
    }
    if (message.listPresets !== undefined) {
      ListPresetsRequest.encode(message.listPresets, writer.uint32(514).fork()).join()
    }
    if (message.executePreset !== undefined) {
      ExecutePresetRequest.encode(message.executePreset, writer.uint32(522).fork()).join()
    }
    if (message.getPreset !== undefined) {
      GetPresetRequest.encode(message.getPreset, writer.uint32(1290).fork()).join()
    }
    if (message.createWatchlist !== undefined) {
      CreateWatchlistRequest.encode(message.createWatchlist, writer.uint32(530).fork()).join()
    }
    if (message.getWatchlists !== undefined) {
      GetWatchlistsRequest.encode(message.getWatchlists, writer.uint32(538).fork()).join()
    }
    if (message.setWatchlist !== undefined) {
      SetWatchlistRequest.encode(message.setWatchlist, writer.uint32(546).fork()).join()
    }
    if (message.renameWatchlist !== undefined) {
      RenameWatchlistRequest.encode(message.renameWatchlist, writer.uint32(554).fork()).join()
    }
    if (message.deleteWatchlist !== undefined) {
      DeleteWatchlistRequest.encode(message.deleteWatchlist, writer.uint32(562).fork()).join()
    }
    if (message.reorderWatchlists !== undefined) {
      ReorderWatchlistsRequest.encode(message.reorderWatchlists, writer.uint32(570).fork()).join()
    }
    if (message.dbNewsHistory !== undefined) {
      DbNewsHistoryRequest.encode(message.dbNewsHistory, writer.uint32(578).fork()).join()
    }
    if (message.alpacaNewsHistory !== undefined) {
      AlpacaNewsHistoryRequest.encode(message.alpacaNewsHistory, writer.uint32(1106).fork()).join()
    }
    if (message.intentCompiler !== undefined) {
      TradeIntent.encode(message.intentCompiler, writer.uint32(586).fork()).join()
    }
    if (message.confirmExecutionPlan !== undefined) {
      ConfirmExecutionPlanRequest.encode(
        message.confirmExecutionPlan,
        writer.uint32(594).fork()
      ).join()
    }
    if (message.getDbNewsVocabulary !== undefined) {
      GetDbNewsVocabularyRequest.encode(
        message.getDbNewsVocabulary,
        writer.uint32(602).fork()
      ).join()
    }
    if (message.testIntentCompiler !== undefined) {
      TestIntentCompilerRequest.encode(message.testIntentCompiler, writer.uint32(610).fork()).join()
    }
    if (message.getVenueStatus !== undefined) {
      GetVenueStatus.encode(message.getVenueStatus, writer.uint32(618).fork()).join()
    }
    if (message.getVenueSchedules !== undefined) {
      GetVenueSchedules.encode(message.getVenueSchedules, writer.uint32(626).fork()).join()
    }
    if (message.createRfq !== undefined) {
      CreateRfqRequest.encode(message.createRfq, writer.uint32(634).fork()).join()
    }
    if (message.cancelRfq !== undefined) {
      CancelRfqRequest.encode(message.cancelRfq, writer.uint32(642).fork()).join()
    }
    if (message.acceptRfqQuote !== undefined) {
      AcceptRfqQuoteRequest.encode(message.acceptRfqQuote, writer.uint32(650).fork()).join()
    }
    if (message.getRfqMakers !== undefined) {
      GetRfqMakersRequest.encode(message.getRfqMakers, writer.uint32(658).fork()).join()
    }
    if (message.getRfqHistory !== undefined) {
      GetRfqHistoryRequest.encode(message.getRfqHistory, writer.uint32(666).fork()).join()
    }
    if (message.rfqAnalytics !== undefined) {
      RfqAnalyticsRequest.encode(message.rfqAnalytics, writer.uint32(674).fork()).join()
    }
    if (message.bybitOauthMintState !== undefined) {
      BybitOauthMintStateRequest.encode(
        message.bybitOauthMintState,
        writer.uint32(682).fork()
      ).join()
    }
    if (message.bybitOauthExchangeCode !== undefined) {
      BybitOauthExchangeCodeRequest.encode(
        message.bybitOauthExchangeCode,
        writer.uint32(690).fork()
      ).join()
    }
    if (message.deribitOauthMintState !== undefined) {
      DeribitOauthMintStateRequest.encode(
        message.deribitOauthMintState,
        writer.uint32(826).fork()
      ).join()
    }
    if (message.deribitOauthExchangeCode !== undefined) {
      DeribitOauthExchangeCodeRequest.encode(
        message.deribitOauthExchangeCode,
        writer.uint32(834).fork()
      ).join()
    }
    if (message.hyperliquidPrepareAgent !== undefined) {
      HyperliquidPrepareAgentRequest.encode(
        message.hyperliquidPrepareAgent,
        writer.uint32(842).fork()
      ).join()
    }
    if (message.hyperliquidConfirmAgent !== undefined) {
      HyperliquidConfirmAgentRequest.encode(
        message.hyperliquidConfirmAgent,
        writer.uint32(850).fork()
      ).join()
    }
    if (message.hyperliquidDisconnectAgent !== undefined) {
      HyperliquidDisconnectAgentRequest.encode(
        message.hyperliquidDisconnectAgent,
        writer.uint32(906).fork()
      ).join()
    }
    if (message.derivePrepareSessionKey !== undefined) {
      DerivePrepareSessionKeyRequest.encode(
        message.derivePrepareSessionKey,
        writer.uint32(1034).fork()
      ).join()
    }
    if (message.deriveConfirmSessionKey !== undefined) {
      DeriveConfirmSessionKeyRequest.encode(
        message.deriveConfirmSessionKey,
        writer.uint32(1042).fork()
      ).join()
    }
    if (message.deriveDisconnect !== undefined) {
      DeriveDisconnectRequest.encode(message.deriveDisconnect, writer.uint32(1050).fork()).join()
    }
    if (message.deriveListSubaccounts !== undefined) {
      DeriveListSubaccountsRequest.encode(
        message.deriveListSubaccounts,
        writer.uint32(1058).fork()
      ).join()
    }
    if (message.deriveLinkSubaccounts !== undefined) {
      DeriveLinkSubaccountsRequest.encode(
        message.deriveLinkSubaccounts,
        writer.uint32(1066).fork()
      ).join()
    }
    if (message.lighterListSubaccounts !== undefined) {
      LighterListSubaccountsRequest.encode(
        message.lighterListSubaccounts,
        writer.uint32(1114).fork()
      ).join()
    }
    if (message.lighterPrepareSubaccountKey !== undefined) {
      LighterPrepareSubaccountKeyRequest.encode(
        message.lighterPrepareSubaccountKey,
        writer.uint32(1122).fork()
      ).join()
    }
    if (message.lighterConfirmSubaccountKey !== undefined) {
      LighterConfirmSubaccountKeyRequest.encode(
        message.lighterConfirmSubaccountKey,
        writer.uint32(1130).fork()
      ).join()
    }
    if (message.lighterLinkSubaccounts !== undefined) {
      LighterLinkSubaccountsRequest.encode(
        message.lighterLinkSubaccounts,
        writer.uint32(1138).fork()
      ).join()
    }
    if (message.createCheckoutSession !== undefined) {
      CreateCheckoutSessionRequest.encode(
        message.createCheckoutSession,
        writer.uint32(866).fork()
      ).join()
    }
    if (message.getSubscription !== undefined) {
      GetSubscriptionRequest.encode(message.getSubscription, writer.uint32(874).fork()).join()
    }
    if (message.openBillingPortal !== undefined) {
      OpenBillingPortalRequest.encode(message.openBillingPortal, writer.uint32(882).fork()).join()
    }
    if (message.getPlans !== undefined) {
      GetPlansRequest.encode(message.getPlans, writer.uint32(890).fork()).join()
    }
    if (message.inviteToAccount !== undefined) {
      InviteToAccountRequest.encode(message.inviteToAccount, writer.uint32(698).fork()).join()
    }
    if (message.listAccountAccess !== undefined) {
      ListAccountAccessRequest.encode(message.listAccountAccess, writer.uint32(706).fork()).join()
    }
    if (message.revokeInvite !== undefined) {
      RevokeInviteRequest.encode(message.revokeInvite, writer.uint32(714).fork()).join()
    }
    if (message.removeAccountAccess !== undefined) {
      RemoveAccountAccessRequest.encode(
        message.removeAccountAccess,
        writer.uint32(722).fork()
      ).join()
    }
    if (message.changeAccountRole !== undefined) {
      ChangeAccountRoleRequest.encode(message.changeAccountRole, writer.uint32(730).fork()).join()
    }
    if (message.leaveAccount !== undefined) {
      LeaveAccountRequest.encode(message.leaveAccount, writer.uint32(738).fork()).join()
    }
    if (message.listMyInvites !== undefined) {
      ListMyInvitesRequest.encode(message.listMyInvites, writer.uint32(746).fork()).join()
    }
    if (message.respondToInvite !== undefined) {
      RespondToInviteRequest.encode(message.respondToInvite, writer.uint32(754).fork()).join()
    }
    if (message.transferAccountOwnership !== undefined) {
      TransferAccountOwnershipRequest.encode(
        message.transferAccountOwnership,
        writer.uint32(898).fork()
      ).join()
    }
    if (message.cancelPendingAccount !== undefined) {
      CancelPendingAccountRequest.encode(
        message.cancelPendingAccount,
        writer.uint32(914).fork()
      ).join()
    }
    if (message.orderPreview !== undefined) {
      OrderPreviewRequest.encode(message.orderPreview, writer.uint32(922).fork()).join()
    }
    if (message.changePassword !== undefined) {
      ChangePasswordRequest.encode(message.changePassword, writer.uint32(930).fork()).join()
    }
    if (message.listSessions !== undefined) {
      ListSessionsRequest.encode(message.listSessions, writer.uint32(938).fork()).join()
    }
    if (message.revokeSession !== undefined) {
      RevokeSessionRequest.encode(message.revokeSession, writer.uint32(946).fork()).join()
    }
    if (message.logout !== undefined) {
      LogoutRequest.encode(message.logout, writer.uint32(954).fork()).join()
    }
    if (message.revokeAllOtherSessions !== undefined) {
      RevokeAllOtherSessionsRequest.encode(
        message.revokeAllOtherSessions,
        writer.uint32(962).fork()
      ).join()
    }
    if (message.sendStepUpCode !== undefined) {
      SendStepUpCodeRequest.encode(message.sendStepUpCode, writer.uint32(970).fork()).join()
    }
    if (message.orderbookMetricsSeries !== undefined) {
      OrderbookMetricsSeriesRequest.encode(
        message.orderbookMetricsSeries,
        writer.uint32(978).fork()
      ).join()
    }
    if (message.optionsTradesHistory !== undefined) {
      OptionsTradesHistoryRequest.encode(
        message.optionsTradesHistory,
        writer.uint32(986).fork()
      ).join()
    }
    if (message.masterInstrumentList !== undefined) {
      MasterInstrumentListRequest.encode(
        message.masterInstrumentList,
        writer.uint32(994).fork()
      ).join()
    }
    if (message.impliedMove !== undefined) {
      GetImpliedMoveRequest.encode(message.impliedMove, writer.uint32(1002).fork()).join()
    }
    if (message.ivPercentile !== undefined) {
      GetIvPercentileRequest.encode(message.ivPercentile, writer.uint32(1010).fork()).join()
    }
    if (message.maxPain !== undefined) {
      GetMaxPainRequest.encode(message.maxPain, writer.uint32(1018).fork()).join()
    }
    if (message.greeksByExpiry !== undefined) {
      GetGreeksByExpiryRequest.encode(message.greeksByExpiry, writer.uint32(1026).fork()).join()
    }
    if (message.generateWatchlist !== undefined) {
      GenerateWatchlistRequest.encode(message.generateWatchlist, writer.uint32(1074).fork()).join()
    }
    if (message.hyperliquidListSubaccounts !== undefined) {
      HyperliquidListSubaccountsRequest.encode(
        message.hyperliquidListSubaccounts,
        writer.uint32(1082).fork()
      ).join()
    }
    if (message.hyperliquidLinkSubaccounts !== undefined) {
      HyperliquidLinkSubaccountsRequest.encode(
        message.hyperliquidLinkSubaccounts,
        writer.uint32(1090).fork()
      ).join()
    }
    if (message.batchOrderPreview !== undefined) {
      BatchOrderPreviewRequest.encode(message.batchOrderPreview, writer.uint32(1098).fork()).join()
    }
    if (message.visibleRangeProfile !== undefined) {
      VisibleRangeProfileRequest.encode(
        message.visibleRangeProfile,
        writer.uint32(1146).fork()
      ).join()
    }
    if (message.getTwitterPostHistory !== undefined) {
      GetTwitterPostHistoryRequest.encode(
        message.getTwitterPostHistory,
        writer.uint32(1154).fork()
      ).join()
    }
    if (message.lighterPrepareIntegratorConsent !== undefined) {
      LighterPrepareIntegratorConsentRequest.encode(
        message.lighterPrepareIntegratorConsent,
        writer.uint32(1162).fork()
      ).join()
    }
    if (message.lighterConfirmIntegratorConsent !== undefined) {
      LighterConfirmIntegratorConsentRequest.encode(
        message.lighterConfirmIntegratorConsent,
        writer.uint32(1170).fork()
      ).join()
    }
    if (message.etfFundFlows !== undefined) {
      EtfFundFlowsRequest.encode(message.etfFundFlows, writer.uint32(1178).fork()).join()
    }
    if (message.fedwatchProbabilities !== undefined) {
      FedwatchProbabilitiesRequest.encode(
        message.fedwatchProbabilities,
        writer.uint32(1186).fork()
      ).join()
    }
    if (message.getCoinmarketcalEvents !== undefined) {
      GetCoinMarketCalEventsRequest.encode(
        message.getCoinmarketcalEvents,
        writer.uint32(1194).fork()
      ).join()
    }
    if (message.optionsStrikeFlow !== undefined) {
      OptionsStrikeFlowRequest.encode(message.optionsStrikeFlow, writer.uint32(1202).fork()).join()
    }
    if (message.gexAggregate !== undefined) {
      GetGexAggregateRequest.encode(message.gexAggregate, writer.uint32(1210).fork()).join()
    }
    if (message.economicData !== undefined) {
      EconomicDataRequest.encode(message.economicData, writer.uint32(1218).fork()).join()
    }
    if (message.mintMessagingLinkNonce !== undefined) {
      MintMessagingLinkNonceRequest.encode(
        message.mintMessagingLinkNonce,
        writer.uint32(1226).fork()
      ).join()
    }
    if (message.getTokenUnlocks !== undefined) {
      GetTokenUnlocksRequest.encode(message.getTokenUnlocks, writer.uint32(1242).fork()).join()
    }
    if (message.getTokenEmission !== undefined) {
      GetTokenEmissionRequest.encode(message.getTokenEmission, writer.uint32(1250).fork()).join()
    }
    if (message.paradigmConnectDesk !== undefined) {
      ParadigmConnectDeskRequest.encode(
        message.paradigmConnectDesk,
        writer.uint32(1258).fork()
      ).join()
    }
    if (message.paradigmListAccounts !== undefined) {
      ParadigmListAccountsRequest.encode(
        message.paradigmListAccounts,
        writer.uint32(1266).fork()
      ).join()
    }
    if (message.paradigmLinkAccount !== undefined) {
      ParadigmLinkAccountRequest.encode(
        message.paradigmLinkAccount,
        writer.uint32(1274).fork()
      ).join()
    }
    if (message.paradigmDisconnect !== undefined) {
      ParadigmDisconnectRequest.encode(
        message.paradigmDisconnect,
        writer.uint32(1282).fork()
      ).join()
    }
    if (message.createSharedLayout !== undefined) {
      CreateSharedLayoutRequest.encode(
        message.createSharedLayout,
        writer.uint32(1306).fork()
      ).join()
    }
    if (message.getSharedLayout !== undefined) {
      GetSharedLayoutRequest.encode(message.getSharedLayout, writer.uint32(1314).fork()).join()
    }
    if (message.treeNewsHistory !== undefined) {
      TreeNewsHistoryRequest.encode(message.treeNewsHistory, writer.uint32(1322).fork()).join()
    }
    if (message.surfaceCurrencies !== undefined) {
      GetSurfaceCurrenciesRequest.encode(
        message.surfaceCurrencies,
        writer.uint32(1330).fork()
      ).join()
    }
    if (message.createApiKey !== undefined) {
      CreateApiKeyRequest.encode(message.createApiKey, writer.uint32(1338).fork()).join()
    }
    if (message.listApiKeys !== undefined) {
      ListApiKeysRequest.encode(message.listApiKeys, writer.uint32(1346).fork()).join()
    }
    if (message.revokeApiKey !== undefined) {
      RevokeApiKeyRequest.encode(message.revokeApiKey, writer.uint32(1354).fork()).join()
    }
    if (message.getApiBilling !== undefined) {
      GetApiBillingRequest.encode(message.getApiBilling, writer.uint32(1362).fork()).join()
    }
    if (message.updateApiBillingSettings !== undefined) {
      UpdateApiBillingSettingsRequest.encode(
        message.updateApiBillingSettings,
        writer.uint32(1370).fork()
      ).join()
    }
    if (message.createCreditCheckoutSession !== undefined) {
      CreateCreditCheckoutSessionRequest.encode(
        message.createCreditCheckoutSession,
        writer.uint32(1378).fork()
      ).join()
    }
    if (message.listCreditLedger !== undefined) {
      ListCreditLedgerRequest.encode(message.listCreditLedger, writer.uint32(1386).fork()).join()
    }
    if (message.getCreditSpendStats !== undefined) {
      GetCreditSpendStatsRequest.encode(
        message.getCreditSpendStats,
        writer.uint32(1394).fork()
      ).join()
    }
    if (message.getMarketScreener !== undefined) {
      GetMarketScreenerRequest.encode(message.getMarketScreener, writer.uint32(1402).fork()).join()
    }
    if (message.listVolFitReferences !== undefined) {
      ListVolFitReferencesRequest.encode(
        message.listVolFitReferences,
        writer.uint32(1410).fork()
      ).join()
    }
    if (message.orderbookHeatmap !== undefined) {
      OrderbookHeatmapRequest.encode(message.orderbookHeatmap, writer.uint32(1418).fork()).join()
    }
    if (message.sendRfqMakerQuote !== undefined) {
      SendRfqMakerQuoteRequest.encode(message.sendRfqMakerQuote, writer.uint32(1426).fork()).join()
    }
    if (message.cancelRfqMakerQuote !== undefined) {
      CancelRfqMakerQuoteRequest.encode(
        message.cancelRfqMakerQuote,
        writer.uint32(1434).fork()
      ).join()
    }
    if (message.setLeverage !== undefined) {
      SetLeverageRequest.encode(message.setLeverage, writer.uint32(1442).fork()).join()
    }
    if (message.papertradePrepareSessionKey !== undefined) {
      PapertradePrepareSessionKeyRequest.encode(
        message.papertradePrepareSessionKey,
        writer.uint32(1450).fork()
      ).join()
    }
    if (message.papertradeConfirmSessionKey !== undefined) {
      PapertradeConfirmSessionKeyRequest.encode(
        message.papertradeConfirmSessionKey,
        writer.uint32(1458).fork()
      ).join()
    }
    if (message.papertradeDisconnect !== undefined) {
      PapertradeDisconnectRequest.encode(
        message.papertradeDisconnect,
        writer.uint32(1466).fork()
      ).join()
    }
    if (message.getAccountSettings !== undefined) {
      GetAccountSettingsRequest.encode(
        message.getAccountSettings,
        writer.uint32(1474).fork()
      ).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseApiRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.executionBatch = ExecutionBatch.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.login = LoginRequest.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.signup = SignupRequest.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.createAccount = CreateAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.getUserAccounts = GetUserAccountsRequest.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.requestPasswordReset = RequestPasswordResetRequest.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.confirmPasswordReset = ConfirmPasswordResetRequest.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.refreshToken = RefreshTokenRequest.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.verifyEmail = VerifyEmailRequest.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.resendVerification = ResendVerificationRequest.decode(reader, reader.uint32())
          continue
        }
        case 47: {
          if (tag !== 378) {
            break
          }

          message.verify = VerifyTokenRequest.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.setup2fa = Setup2faRequest.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.confirm2faSetup = Confirm2faSetupRequest.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.verify2fa = Verify2faRequest.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.verify2faLogin = Verify2faLoginRequest.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.disable2fa = Disable2faRequest.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.get2faBackupCodes = Get2faBackupCodesRequest.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.setupPasskey = SetupPasskeyRequest.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.confirmPasskeySetup = ConfirmPasskeySetupRequest.decode(reader, reader.uint32())
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.passkeyLogin = PasskeyLoginRequest.decode(reader, reader.uint32())
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.confirmPasskeyLogin = ConfirmPasskeyLoginRequest.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.deletePasskey = DeletePasskeyRequest.decode(reader, reader.uint32())
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.getUserPasskeys = GetUserPasskeysRequest.decode(reader, reader.uint32())
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.googleLogin = GoogleLoginRequest.decode(reader, reader.uint32())
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.chartData = ChartDataRequest.decode(reader, reader.uint32())
          continue
        }
        case 46: {
          if (tag !== 370) {
            break
          }

          message.portfolioLineChart = PortfolioLineChartRequest.decode(reader, reader.uint32())
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.time = Time.decode(reader, reader.uint32())
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.updateAccount = UpdateAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.instrumentList = InstrumentListRequest.decode(reader, reader.uint32())
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.orderHistory = HistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.tradeHistory = HistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.createPage = CreatePageRequest.decode(reader, reader.uint32())
          continue
        }
        case 32: {
          if (tag !== 258) {
            break
          }

          message.getPages = GetPagesRequest.decode(reader, reader.uint32())
          continue
        }
        case 33: {
          if (tag !== 266) {
            break
          }

          message.getPageLayout = GetPageLayoutRequest.decode(reader, reader.uint32())
          continue
        }
        case 34: {
          if (tag !== 274) {
            break
          }

          message.updatePageMeta = UpdatePageMetaRequest.decode(reader, reader.uint32())
          continue
        }
        case 35: {
          if (tag !== 282) {
            break
          }

          message.deletePage = DeletePageRequest.decode(reader, reader.uint32())
          continue
        }
        case 36: {
          if (tag !== 290) {
            break
          }

          message.addWidget = AddWidgetRequest.decode(reader, reader.uint32())
          continue
        }
        case 37: {
          if (tag !== 298) {
            break
          }

          message.updateWidget = UpdateWidgetRequest.decode(reader, reader.uint32())
          continue
        }
        case 38: {
          if (tag !== 306) {
            break
          }

          message.removeWidget = RemoveWidgetRequest.decode(reader, reader.uint32())
          continue
        }
        case 39: {
          if (tag !== 314) {
            break
          }

          message.saveComponentPreference = SaveComponentPreferenceRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 40: {
          if (tag !== 322) {
            break
          }

          message.getComponentPreference = GetComponentPreferenceRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 41: {
          if (tag !== 330) {
            break
          }

          message.createPositionGroup = CreatePositionGroupRequest.decode(reader, reader.uint32())
          continue
        }
        case 42: {
          if (tag !== 338) {
            break
          }

          message.updatePositionGroup = UpdatePositionGroupRequest.decode(reader, reader.uint32())
          continue
        }
        case 43: {
          if (tag !== 346) {
            break
          }

          message.deletePositionGroup = DeletePositionGroupRequest.decode(reader, reader.uint32())
          continue
        }
        case 44: {
          if (tag !== 354) {
            break
          }

          message.getPositionsView = GetPositionsViewRequest.decode(reader, reader.uint32())
          continue
        }
        case 45: {
          if (tag !== 362) {
            break
          }

          message.getPositionGroups = GetPositionGroupsRequest.decode(reader, reader.uint32())
          continue
        }
        case 99: {
          if (tag !== 794) {
            break
          }

          message.reorderPositionsView = ReorderPositionsViewRequest.decode(reader, reader.uint32())
          continue
        }
        case 100: {
          if (tag !== 802) {
            break
          }

          message.setPositionGroupOrder = SetPositionGroupOrderRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 48: {
          if (tag !== 386) {
            break
          }

          message.generateVolSurface = GenerateVolSurfaceRequest.decode(reader, reader.uint32())
          continue
        }
        case 49: {
          if (tag !== 394) {
            break
          }

          message.riskSimulation = RiskSimulationRequest.decode(reader, reader.uint32())
          continue
        }
        case 50: {
          if (tag !== 402) {
            break
          }

          message.economicCalendarHistory = EconomicCalendarHistoryRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 52: {
          if (tag !== 418) {
            break
          }

          message.executionAnalytics = ExecutionAnalyticsRequest.decode(reader, reader.uint32())
          continue
        }
        case 53: {
          if (tag !== 426) {
            break
          }

          message.getVenues = GetVenuesRequest.decode(reader, reader.uint32())
          continue
        }
        case 54: {
          if (tag !== 434) {
            break
          }

          message.getExchanges = GetExchangesRequest.decode(reader, reader.uint32())
          continue
        }
        case 55: {
          if (tag !== 442) {
            break
          }

          message.getOrdersForAlgo = GetOrdersForAlgoRequest.decode(reader, reader.uint32())
          continue
        }
        case 56: {
          if (tag !== 450) {
            break
          }

          message.getTradesForOrder = GetTradesForOrderRequest.decode(reader, reader.uint32())
          continue
        }
        case 57: {
          if (tag !== 458) {
            break
          }

          message.getOrderStateHistory = GetOrderStateHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 107: {
          if (tag !== 858) {
            break
          }

          message.getTradesForAlgo = GetTradesForAlgoRequest.decode(reader, reader.uint32())
          continue
        }
        case 59: {
          if (tag !== 474) {
            break
          }

          message.getAnalyticSnapshot = GetAnalyticSnapshotRequest.decode(reader, reader.uint32())
          continue
        }
        case 60: {
          if (tag !== 482) {
            break
          }

          message.getAnalyticRange = GetAnalyticRangeRequest.decode(reader, reader.uint32())
          continue
        }
        case 95: {
          if (tag !== 762) {
            break
          }

          message.optionsVolumeLeaderboard = GetOptionsVolumeLeaderboardRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 96: {
          if (tag !== 770) {
            break
          }

          message.optionsVolumeSeries = OptionsVolumeSeriesRequest.decode(reader, reader.uint32())
          continue
        }
        case 97: {
          if (tag !== 778) {
            break
          }

          message.optionsOiSeries = OptionsOiSeriesRequest.decode(reader, reader.uint32())
          continue
        }
        case 98: {
          if (tag !== 786) {
            break
          }

          message.optionsOiLeaderboard = GetOptionsOiLeaderboardRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 162: {
          if (tag !== 1298) {
            break
          }

          message.optionsOiByStrike = GetOptionsOiByStrikeRequest.decode(reader, reader.uint32())
          continue
        }
        case 101: {
          if (tag !== 810) {
            break
          }

          message.fundingSeries = GetFundingSeriesRequest.decode(reader, reader.uint32())
          continue
        }
        case 102: {
          if (tag !== 818) {
            break
          }

          message.fundingLeaderboard = GetFundingLeaderboardRequest.decode(reader, reader.uint32())
          continue
        }
        case 61: {
          if (tag !== 490) {
            break
          }

          message.createPreset = CreatePresetRequest.decode(reader, reader.uint32())
          continue
        }
        case 62: {
          if (tag !== 498) {
            break
          }

          message.updatePreset = UpdatePresetRequest.decode(reader, reader.uint32())
          continue
        }
        case 63: {
          if (tag !== 506) {
            break
          }

          message.deletePreset = DeletePresetRequest.decode(reader, reader.uint32())
          continue
        }
        case 64: {
          if (tag !== 514) {
            break
          }

          message.listPresets = ListPresetsRequest.decode(reader, reader.uint32())
          continue
        }
        case 65: {
          if (tag !== 522) {
            break
          }

          message.executePreset = ExecutePresetRequest.decode(reader, reader.uint32())
          continue
        }
        case 161: {
          if (tag !== 1290) {
            break
          }

          message.getPreset = GetPresetRequest.decode(reader, reader.uint32())
          continue
        }
        case 66: {
          if (tag !== 530) {
            break
          }

          message.createWatchlist = CreateWatchlistRequest.decode(reader, reader.uint32())
          continue
        }
        case 67: {
          if (tag !== 538) {
            break
          }

          message.getWatchlists = GetWatchlistsRequest.decode(reader, reader.uint32())
          continue
        }
        case 68: {
          if (tag !== 546) {
            break
          }

          message.setWatchlist = SetWatchlistRequest.decode(reader, reader.uint32())
          continue
        }
        case 69: {
          if (tag !== 554) {
            break
          }

          message.renameWatchlist = RenameWatchlistRequest.decode(reader, reader.uint32())
          continue
        }
        case 70: {
          if (tag !== 562) {
            break
          }

          message.deleteWatchlist = DeleteWatchlistRequest.decode(reader, reader.uint32())
          continue
        }
        case 71: {
          if (tag !== 570) {
            break
          }

          message.reorderWatchlists = ReorderWatchlistsRequest.decode(reader, reader.uint32())
          continue
        }
        case 72: {
          if (tag !== 578) {
            break
          }

          message.dbNewsHistory = DbNewsHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 138: {
          if (tag !== 1106) {
            break
          }

          message.alpacaNewsHistory = AlpacaNewsHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 73: {
          if (tag !== 586) {
            break
          }

          message.intentCompiler = TradeIntent.decode(reader, reader.uint32())
          continue
        }
        case 74: {
          if (tag !== 594) {
            break
          }

          message.confirmExecutionPlan = ConfirmExecutionPlanRequest.decode(reader, reader.uint32())
          continue
        }
        case 75: {
          if (tag !== 602) {
            break
          }

          message.getDbNewsVocabulary = GetDbNewsVocabularyRequest.decode(reader, reader.uint32())
          continue
        }
        case 76: {
          if (tag !== 610) {
            break
          }

          message.testIntentCompiler = TestIntentCompilerRequest.decode(reader, reader.uint32())
          continue
        }
        case 77: {
          if (tag !== 618) {
            break
          }

          message.getVenueStatus = GetVenueStatus.decode(reader, reader.uint32())
          continue
        }
        case 78: {
          if (tag !== 626) {
            break
          }

          message.getVenueSchedules = GetVenueSchedules.decode(reader, reader.uint32())
          continue
        }
        case 79: {
          if (tag !== 634) {
            break
          }

          message.createRfq = CreateRfqRequest.decode(reader, reader.uint32())
          continue
        }
        case 80: {
          if (tag !== 642) {
            break
          }

          message.cancelRfq = CancelRfqRequest.decode(reader, reader.uint32())
          continue
        }
        case 81: {
          if (tag !== 650) {
            break
          }

          message.acceptRfqQuote = AcceptRfqQuoteRequest.decode(reader, reader.uint32())
          continue
        }
        case 82: {
          if (tag !== 658) {
            break
          }

          message.getRfqMakers = GetRfqMakersRequest.decode(reader, reader.uint32())
          continue
        }
        case 83: {
          if (tag !== 666) {
            break
          }

          message.getRfqHistory = GetRfqHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 84: {
          if (tag !== 674) {
            break
          }

          message.rfqAnalytics = RfqAnalyticsRequest.decode(reader, reader.uint32())
          continue
        }
        case 85: {
          if (tag !== 682) {
            break
          }

          message.bybitOauthMintState = BybitOauthMintStateRequest.decode(reader, reader.uint32())
          continue
        }
        case 86: {
          if (tag !== 690) {
            break
          }

          message.bybitOauthExchangeCode = BybitOauthExchangeCodeRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 103: {
          if (tag !== 826) {
            break
          }

          message.deribitOauthMintState = DeribitOauthMintStateRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 104: {
          if (tag !== 834) {
            break
          }

          message.deribitOauthExchangeCode = DeribitOauthExchangeCodeRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 105: {
          if (tag !== 842) {
            break
          }

          message.hyperliquidPrepareAgent = HyperliquidPrepareAgentRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 106: {
          if (tag !== 850) {
            break
          }

          message.hyperliquidConfirmAgent = HyperliquidConfirmAgentRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 113: {
          if (tag !== 906) {
            break
          }

          message.hyperliquidDisconnectAgent = HyperliquidDisconnectAgentRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 129: {
          if (tag !== 1034) {
            break
          }

          message.derivePrepareSessionKey = DerivePrepareSessionKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 130: {
          if (tag !== 1042) {
            break
          }

          message.deriveConfirmSessionKey = DeriveConfirmSessionKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 131: {
          if (tag !== 1050) {
            break
          }

          message.deriveDisconnect = DeriveDisconnectRequest.decode(reader, reader.uint32())
          continue
        }
        case 132: {
          if (tag !== 1058) {
            break
          }

          message.deriveListSubaccounts = DeriveListSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 133: {
          if (tag !== 1066) {
            break
          }

          message.deriveLinkSubaccounts = DeriveLinkSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 139: {
          if (tag !== 1114) {
            break
          }

          message.lighterListSubaccounts = LighterListSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 140: {
          if (tag !== 1122) {
            break
          }

          message.lighterPrepareSubaccountKey = LighterPrepareSubaccountKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 141: {
          if (tag !== 1130) {
            break
          }

          message.lighterConfirmSubaccountKey = LighterConfirmSubaccountKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 142: {
          if (tag !== 1138) {
            break
          }

          message.lighterLinkSubaccounts = LighterLinkSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 108: {
          if (tag !== 866) {
            break
          }

          message.createCheckoutSession = CreateCheckoutSessionRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 109: {
          if (tag !== 874) {
            break
          }

          message.getSubscription = GetSubscriptionRequest.decode(reader, reader.uint32())
          continue
        }
        case 110: {
          if (tag !== 882) {
            break
          }

          message.openBillingPortal = OpenBillingPortalRequest.decode(reader, reader.uint32())
          continue
        }
        case 111: {
          if (tag !== 890) {
            break
          }

          message.getPlans = GetPlansRequest.decode(reader, reader.uint32())
          continue
        }
        case 87: {
          if (tag !== 698) {
            break
          }

          message.inviteToAccount = InviteToAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 88: {
          if (tag !== 706) {
            break
          }

          message.listAccountAccess = ListAccountAccessRequest.decode(reader, reader.uint32())
          continue
        }
        case 89: {
          if (tag !== 714) {
            break
          }

          message.revokeInvite = RevokeInviteRequest.decode(reader, reader.uint32())
          continue
        }
        case 90: {
          if (tag !== 722) {
            break
          }

          message.removeAccountAccess = RemoveAccountAccessRequest.decode(reader, reader.uint32())
          continue
        }
        case 91: {
          if (tag !== 730) {
            break
          }

          message.changeAccountRole = ChangeAccountRoleRequest.decode(reader, reader.uint32())
          continue
        }
        case 92: {
          if (tag !== 738) {
            break
          }

          message.leaveAccount = LeaveAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 93: {
          if (tag !== 746) {
            break
          }

          message.listMyInvites = ListMyInvitesRequest.decode(reader, reader.uint32())
          continue
        }
        case 94: {
          if (tag !== 754) {
            break
          }

          message.respondToInvite = RespondToInviteRequest.decode(reader, reader.uint32())
          continue
        }
        case 112: {
          if (tag !== 898) {
            break
          }

          message.transferAccountOwnership = TransferAccountOwnershipRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 114: {
          if (tag !== 914) {
            break
          }

          message.cancelPendingAccount = CancelPendingAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 115: {
          if (tag !== 922) {
            break
          }

          message.orderPreview = OrderPreviewRequest.decode(reader, reader.uint32())
          continue
        }
        case 116: {
          if (tag !== 930) {
            break
          }

          message.changePassword = ChangePasswordRequest.decode(reader, reader.uint32())
          continue
        }
        case 117: {
          if (tag !== 938) {
            break
          }

          message.listSessions = ListSessionsRequest.decode(reader, reader.uint32())
          continue
        }
        case 118: {
          if (tag !== 946) {
            break
          }

          message.revokeSession = RevokeSessionRequest.decode(reader, reader.uint32())
          continue
        }
        case 119: {
          if (tag !== 954) {
            break
          }

          message.logout = LogoutRequest.decode(reader, reader.uint32())
          continue
        }
        case 120: {
          if (tag !== 962) {
            break
          }

          message.revokeAllOtherSessions = RevokeAllOtherSessionsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 121: {
          if (tag !== 970) {
            break
          }

          message.sendStepUpCode = SendStepUpCodeRequest.decode(reader, reader.uint32())
          continue
        }
        case 122: {
          if (tag !== 978) {
            break
          }

          message.orderbookMetricsSeries = OrderbookMetricsSeriesRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 123: {
          if (tag !== 986) {
            break
          }

          message.optionsTradesHistory = OptionsTradesHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 124: {
          if (tag !== 994) {
            break
          }

          message.masterInstrumentList = MasterInstrumentListRequest.decode(reader, reader.uint32())
          continue
        }
        case 125: {
          if (tag !== 1002) {
            break
          }

          message.impliedMove = GetImpliedMoveRequest.decode(reader, reader.uint32())
          continue
        }
        case 126: {
          if (tag !== 1010) {
            break
          }

          message.ivPercentile = GetIvPercentileRequest.decode(reader, reader.uint32())
          continue
        }
        case 127: {
          if (tag !== 1018) {
            break
          }

          message.maxPain = GetMaxPainRequest.decode(reader, reader.uint32())
          continue
        }
        case 128: {
          if (tag !== 1026) {
            break
          }

          message.greeksByExpiry = GetGreeksByExpiryRequest.decode(reader, reader.uint32())
          continue
        }
        case 134: {
          if (tag !== 1074) {
            break
          }

          message.generateWatchlist = GenerateWatchlistRequest.decode(reader, reader.uint32())
          continue
        }
        case 135: {
          if (tag !== 1082) {
            break
          }

          message.hyperliquidListSubaccounts = HyperliquidListSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 136: {
          if (tag !== 1090) {
            break
          }

          message.hyperliquidLinkSubaccounts = HyperliquidLinkSubaccountsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 137: {
          if (tag !== 1098) {
            break
          }

          message.batchOrderPreview = BatchOrderPreviewRequest.decode(reader, reader.uint32())
          continue
        }
        case 143: {
          if (tag !== 1146) {
            break
          }

          message.visibleRangeProfile = VisibleRangeProfileRequest.decode(reader, reader.uint32())
          continue
        }
        case 144: {
          if (tag !== 1154) {
            break
          }

          message.getTwitterPostHistory = GetTwitterPostHistoryRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 145: {
          if (tag !== 1162) {
            break
          }

          message.lighterPrepareIntegratorConsent = LighterPrepareIntegratorConsentRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 146: {
          if (tag !== 1170) {
            break
          }

          message.lighterConfirmIntegratorConsent = LighterConfirmIntegratorConsentRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 147: {
          if (tag !== 1178) {
            break
          }

          message.etfFundFlows = EtfFundFlowsRequest.decode(reader, reader.uint32())
          continue
        }
        case 148: {
          if (tag !== 1186) {
            break
          }

          message.fedwatchProbabilities = FedwatchProbabilitiesRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 149: {
          if (tag !== 1194) {
            break
          }

          message.getCoinmarketcalEvents = GetCoinMarketCalEventsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 150: {
          if (tag !== 1202) {
            break
          }

          message.optionsStrikeFlow = OptionsStrikeFlowRequest.decode(reader, reader.uint32())
          continue
        }
        case 151: {
          if (tag !== 1210) {
            break
          }

          message.gexAggregate = GetGexAggregateRequest.decode(reader, reader.uint32())
          continue
        }
        case 152: {
          if (tag !== 1218) {
            break
          }

          message.economicData = EconomicDataRequest.decode(reader, reader.uint32())
          continue
        }
        case 153: {
          if (tag !== 1226) {
            break
          }

          message.mintMessagingLinkNonce = MintMessagingLinkNonceRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 155: {
          if (tag !== 1242) {
            break
          }

          message.getTokenUnlocks = GetTokenUnlocksRequest.decode(reader, reader.uint32())
          continue
        }
        case 156: {
          if (tag !== 1250) {
            break
          }

          message.getTokenEmission = GetTokenEmissionRequest.decode(reader, reader.uint32())
          continue
        }
        case 157: {
          if (tag !== 1258) {
            break
          }

          message.paradigmConnectDesk = ParadigmConnectDeskRequest.decode(reader, reader.uint32())
          continue
        }
        case 158: {
          if (tag !== 1266) {
            break
          }

          message.paradigmListAccounts = ParadigmListAccountsRequest.decode(reader, reader.uint32())
          continue
        }
        case 159: {
          if (tag !== 1274) {
            break
          }

          message.paradigmLinkAccount = ParadigmLinkAccountRequest.decode(reader, reader.uint32())
          continue
        }
        case 160: {
          if (tag !== 1282) {
            break
          }

          message.paradigmDisconnect = ParadigmDisconnectRequest.decode(reader, reader.uint32())
          continue
        }
        case 163: {
          if (tag !== 1306) {
            break
          }

          message.createSharedLayout = CreateSharedLayoutRequest.decode(reader, reader.uint32())
          continue
        }
        case 164: {
          if (tag !== 1314) {
            break
          }

          message.getSharedLayout = GetSharedLayoutRequest.decode(reader, reader.uint32())
          continue
        }
        case 165: {
          if (tag !== 1322) {
            break
          }

          message.treeNewsHistory = TreeNewsHistoryRequest.decode(reader, reader.uint32())
          continue
        }
        case 166: {
          if (tag !== 1330) {
            break
          }

          message.surfaceCurrencies = GetSurfaceCurrenciesRequest.decode(reader, reader.uint32())
          continue
        }
        case 167: {
          if (tag !== 1338) {
            break
          }

          message.createApiKey = CreateApiKeyRequest.decode(reader, reader.uint32())
          continue
        }
        case 168: {
          if (tag !== 1346) {
            break
          }

          message.listApiKeys = ListApiKeysRequest.decode(reader, reader.uint32())
          continue
        }
        case 169: {
          if (tag !== 1354) {
            break
          }

          message.revokeApiKey = RevokeApiKeyRequest.decode(reader, reader.uint32())
          continue
        }
        case 170: {
          if (tag !== 1362) {
            break
          }

          message.getApiBilling = GetApiBillingRequest.decode(reader, reader.uint32())
          continue
        }
        case 171: {
          if (tag !== 1370) {
            break
          }

          message.updateApiBillingSettings = UpdateApiBillingSettingsRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 172: {
          if (tag !== 1378) {
            break
          }

          message.createCreditCheckoutSession = CreateCreditCheckoutSessionRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 173: {
          if (tag !== 1386) {
            break
          }

          message.listCreditLedger = ListCreditLedgerRequest.decode(reader, reader.uint32())
          continue
        }
        case 174: {
          if (tag !== 1394) {
            break
          }

          message.getCreditSpendStats = GetCreditSpendStatsRequest.decode(reader, reader.uint32())
          continue
        }
        case 175: {
          if (tag !== 1402) {
            break
          }

          message.getMarketScreener = GetMarketScreenerRequest.decode(reader, reader.uint32())
          continue
        }
        case 176: {
          if (tag !== 1410) {
            break
          }

          message.listVolFitReferences = ListVolFitReferencesRequest.decode(reader, reader.uint32())
          continue
        }
        case 177: {
          if (tag !== 1418) {
            break
          }

          message.orderbookHeatmap = OrderbookHeatmapRequest.decode(reader, reader.uint32())
          continue
        }
        case 178: {
          if (tag !== 1426) {
            break
          }

          message.sendRfqMakerQuote = SendRfqMakerQuoteRequest.decode(reader, reader.uint32())
          continue
        }
        case 179: {
          if (tag !== 1434) {
            break
          }

          message.cancelRfqMakerQuote = CancelRfqMakerQuoteRequest.decode(reader, reader.uint32())
          continue
        }
        case 180: {
          if (tag !== 1442) {
            break
          }

          message.setLeverage = SetLeverageRequest.decode(reader, reader.uint32())
          continue
        }
        case 181: {
          if (tag !== 1450) {
            break
          }

          message.papertradePrepareSessionKey = PapertradePrepareSessionKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 182: {
          if (tag !== 1458) {
            break
          }

          message.papertradeConfirmSessionKey = PapertradeConfirmSessionKeyRequest.decode(
            reader,
            reader.uint32()
          )
          continue
        }
        case 183: {
          if (tag !== 1466) {
            break
          }

          message.papertradeDisconnect = PapertradeDisconnectRequest.decode(reader, reader.uint32())
          continue
        }
        case 184: {
          if (tag !== 1474) {
            break
          }

          message.getAccountSettings = GetAccountSettingsRequest.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ApiRequest {
    return {
      executionBatch: isSet(object.executionBatch)
        ? ExecutionBatch.fromJSON(object.executionBatch)
        : isSet(object.execution_batch)
          ? ExecutionBatch.fromJSON(object.execution_batch)
          : undefined,
      login: isSet(object.login) ? LoginRequest.fromJSON(object.login) : undefined,
      signup: isSet(object.signup) ? SignupRequest.fromJSON(object.signup) : undefined,
      createAccount: isSet(object.createAccount)
        ? CreateAccountRequest.fromJSON(object.createAccount)
        : isSet(object.create_account)
          ? CreateAccountRequest.fromJSON(object.create_account)
          : undefined,
      getUserAccounts: isSet(object.getUserAccounts)
        ? GetUserAccountsRequest.fromJSON(object.getUserAccounts)
        : isSet(object.get_user_accounts)
          ? GetUserAccountsRequest.fromJSON(object.get_user_accounts)
          : undefined,
      requestPasswordReset: isSet(object.requestPasswordReset)
        ? RequestPasswordResetRequest.fromJSON(object.requestPasswordReset)
        : isSet(object.request_password_reset)
          ? RequestPasswordResetRequest.fromJSON(object.request_password_reset)
          : undefined,
      confirmPasswordReset: isSet(object.confirmPasswordReset)
        ? ConfirmPasswordResetRequest.fromJSON(object.confirmPasswordReset)
        : isSet(object.confirm_password_reset)
          ? ConfirmPasswordResetRequest.fromJSON(object.confirm_password_reset)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? RefreshTokenRequest.fromJSON(object.refreshToken)
        : isSet(object.refresh_token)
          ? RefreshTokenRequest.fromJSON(object.refresh_token)
          : undefined,
      verifyEmail: isSet(object.verifyEmail)
        ? VerifyEmailRequest.fromJSON(object.verifyEmail)
        : isSet(object.verify_email)
          ? VerifyEmailRequest.fromJSON(object.verify_email)
          : undefined,
      resendVerification: isSet(object.resendVerification)
        ? ResendVerificationRequest.fromJSON(object.resendVerification)
        : isSet(object.resend_verification)
          ? ResendVerificationRequest.fromJSON(object.resend_verification)
          : undefined,
      verify: isSet(object.verify) ? VerifyTokenRequest.fromJSON(object.verify) : undefined,
      setup2fa: isSet(object.setup2fa)
        ? Setup2faRequest.fromJSON(object.setup2fa)
        : isSet(object.setup_2fa)
          ? Setup2faRequest.fromJSON(object.setup_2fa)
          : undefined,
      confirm2faSetup: isSet(object.confirm2faSetup)
        ? Confirm2faSetupRequest.fromJSON(object.confirm2faSetup)
        : isSet(object.confirm_2fa_setup)
          ? Confirm2faSetupRequest.fromJSON(object.confirm_2fa_setup)
          : undefined,
      verify2fa: isSet(object.verify2fa)
        ? Verify2faRequest.fromJSON(object.verify2fa)
        : isSet(object.verify_2fa)
          ? Verify2faRequest.fromJSON(object.verify_2fa)
          : undefined,
      verify2faLogin: isSet(object.verify2faLogin)
        ? Verify2faLoginRequest.fromJSON(object.verify2faLogin)
        : isSet(object.verify_2fa_login)
          ? Verify2faLoginRequest.fromJSON(object.verify_2fa_login)
          : undefined,
      disable2fa: isSet(object.disable2fa)
        ? Disable2faRequest.fromJSON(object.disable2fa)
        : isSet(object.disable_2fa)
          ? Disable2faRequest.fromJSON(object.disable_2fa)
          : undefined,
      get2faBackupCodes: isSet(object.get2faBackupCodes)
        ? Get2faBackupCodesRequest.fromJSON(object.get2faBackupCodes)
        : isSet(object.get_2fa_backup_codes)
          ? Get2faBackupCodesRequest.fromJSON(object.get_2fa_backup_codes)
          : undefined,
      setupPasskey: isSet(object.setupPasskey)
        ? SetupPasskeyRequest.fromJSON(object.setupPasskey)
        : isSet(object.setup_passkey)
          ? SetupPasskeyRequest.fromJSON(object.setup_passkey)
          : undefined,
      confirmPasskeySetup: isSet(object.confirmPasskeySetup)
        ? ConfirmPasskeySetupRequest.fromJSON(object.confirmPasskeySetup)
        : isSet(object.confirm_passkey_setup)
          ? ConfirmPasskeySetupRequest.fromJSON(object.confirm_passkey_setup)
          : undefined,
      passkeyLogin: isSet(object.passkeyLogin)
        ? PasskeyLoginRequest.fromJSON(object.passkeyLogin)
        : isSet(object.passkey_login)
          ? PasskeyLoginRequest.fromJSON(object.passkey_login)
          : undefined,
      confirmPasskeyLogin: isSet(object.confirmPasskeyLogin)
        ? ConfirmPasskeyLoginRequest.fromJSON(object.confirmPasskeyLogin)
        : isSet(object.confirm_passkey_login)
          ? ConfirmPasskeyLoginRequest.fromJSON(object.confirm_passkey_login)
          : undefined,
      deletePasskey: isSet(object.deletePasskey)
        ? DeletePasskeyRequest.fromJSON(object.deletePasskey)
        : isSet(object.delete_passkey)
          ? DeletePasskeyRequest.fromJSON(object.delete_passkey)
          : undefined,
      getUserPasskeys: isSet(object.getUserPasskeys)
        ? GetUserPasskeysRequest.fromJSON(object.getUserPasskeys)
        : isSet(object.get_user_passkeys)
          ? GetUserPasskeysRequest.fromJSON(object.get_user_passkeys)
          : undefined,
      googleLogin: isSet(object.googleLogin)
        ? GoogleLoginRequest.fromJSON(object.googleLogin)
        : isSet(object.google_login)
          ? GoogleLoginRequest.fromJSON(object.google_login)
          : undefined,
      chartData: isSet(object.chartData)
        ? ChartDataRequest.fromJSON(object.chartData)
        : isSet(object.chart_data)
          ? ChartDataRequest.fromJSON(object.chart_data)
          : undefined,
      portfolioLineChart: isSet(object.portfolioLineChart)
        ? PortfolioLineChartRequest.fromJSON(object.portfolioLineChart)
        : isSet(object.portfolio_line_chart)
          ? PortfolioLineChartRequest.fromJSON(object.portfolio_line_chart)
          : undefined,
      time: isSet(object.time) ? Time.fromJSON(object.time) : undefined,
      updateAccount: isSet(object.updateAccount)
        ? UpdateAccountRequest.fromJSON(object.updateAccount)
        : isSet(object.update_account)
          ? UpdateAccountRequest.fromJSON(object.update_account)
          : undefined,
      instrumentList: isSet(object.instrumentList)
        ? InstrumentListRequest.fromJSON(object.instrumentList)
        : isSet(object.instrument_list)
          ? InstrumentListRequest.fromJSON(object.instrument_list)
          : undefined,
      orderHistory: isSet(object.orderHistory)
        ? HistoryRequest.fromJSON(object.orderHistory)
        : isSet(object.order_history)
          ? HistoryRequest.fromJSON(object.order_history)
          : undefined,
      tradeHistory: isSet(object.tradeHistory)
        ? HistoryRequest.fromJSON(object.tradeHistory)
        : isSet(object.trade_history)
          ? HistoryRequest.fromJSON(object.trade_history)
          : undefined,
      createPage: isSet(object.createPage)
        ? CreatePageRequest.fromJSON(object.createPage)
        : isSet(object.create_page)
          ? CreatePageRequest.fromJSON(object.create_page)
          : undefined,
      getPages: isSet(object.getPages)
        ? GetPagesRequest.fromJSON(object.getPages)
        : isSet(object.get_pages)
          ? GetPagesRequest.fromJSON(object.get_pages)
          : undefined,
      getPageLayout: isSet(object.getPageLayout)
        ? GetPageLayoutRequest.fromJSON(object.getPageLayout)
        : isSet(object.get_page_layout)
          ? GetPageLayoutRequest.fromJSON(object.get_page_layout)
          : undefined,
      updatePageMeta: isSet(object.updatePageMeta)
        ? UpdatePageMetaRequest.fromJSON(object.updatePageMeta)
        : isSet(object.update_page_meta)
          ? UpdatePageMetaRequest.fromJSON(object.update_page_meta)
          : undefined,
      deletePage: isSet(object.deletePage)
        ? DeletePageRequest.fromJSON(object.deletePage)
        : isSet(object.delete_page)
          ? DeletePageRequest.fromJSON(object.delete_page)
          : undefined,
      addWidget: isSet(object.addWidget)
        ? AddWidgetRequest.fromJSON(object.addWidget)
        : isSet(object.add_widget)
          ? AddWidgetRequest.fromJSON(object.add_widget)
          : undefined,
      updateWidget: isSet(object.updateWidget)
        ? UpdateWidgetRequest.fromJSON(object.updateWidget)
        : isSet(object.update_widget)
          ? UpdateWidgetRequest.fromJSON(object.update_widget)
          : undefined,
      removeWidget: isSet(object.removeWidget)
        ? RemoveWidgetRequest.fromJSON(object.removeWidget)
        : isSet(object.remove_widget)
          ? RemoveWidgetRequest.fromJSON(object.remove_widget)
          : undefined,
      saveComponentPreference: isSet(object.saveComponentPreference)
        ? SaveComponentPreferenceRequest.fromJSON(object.saveComponentPreference)
        : isSet(object.save_component_preference)
          ? SaveComponentPreferenceRequest.fromJSON(object.save_component_preference)
          : undefined,
      getComponentPreference: isSet(object.getComponentPreference)
        ? GetComponentPreferenceRequest.fromJSON(object.getComponentPreference)
        : isSet(object.get_component_preference)
          ? GetComponentPreferenceRequest.fromJSON(object.get_component_preference)
          : undefined,
      createPositionGroup: isSet(object.createPositionGroup)
        ? CreatePositionGroupRequest.fromJSON(object.createPositionGroup)
        : isSet(object.create_position_group)
          ? CreatePositionGroupRequest.fromJSON(object.create_position_group)
          : undefined,
      updatePositionGroup: isSet(object.updatePositionGroup)
        ? UpdatePositionGroupRequest.fromJSON(object.updatePositionGroup)
        : isSet(object.update_position_group)
          ? UpdatePositionGroupRequest.fromJSON(object.update_position_group)
          : undefined,
      deletePositionGroup: isSet(object.deletePositionGroup)
        ? DeletePositionGroupRequest.fromJSON(object.deletePositionGroup)
        : isSet(object.delete_position_group)
          ? DeletePositionGroupRequest.fromJSON(object.delete_position_group)
          : undefined,
      getPositionsView: isSet(object.getPositionsView)
        ? GetPositionsViewRequest.fromJSON(object.getPositionsView)
        : isSet(object.get_positions_view)
          ? GetPositionsViewRequest.fromJSON(object.get_positions_view)
          : undefined,
      getPositionGroups: isSet(object.getPositionGroups)
        ? GetPositionGroupsRequest.fromJSON(object.getPositionGroups)
        : isSet(object.get_position_groups)
          ? GetPositionGroupsRequest.fromJSON(object.get_position_groups)
          : undefined,
      reorderPositionsView: isSet(object.reorderPositionsView)
        ? ReorderPositionsViewRequest.fromJSON(object.reorderPositionsView)
        : isSet(object.reorder_positions_view)
          ? ReorderPositionsViewRequest.fromJSON(object.reorder_positions_view)
          : undefined,
      setPositionGroupOrder: isSet(object.setPositionGroupOrder)
        ? SetPositionGroupOrderRequest.fromJSON(object.setPositionGroupOrder)
        : isSet(object.set_position_group_order)
          ? SetPositionGroupOrderRequest.fromJSON(object.set_position_group_order)
          : undefined,
      generateVolSurface: isSet(object.generateVolSurface)
        ? GenerateVolSurfaceRequest.fromJSON(object.generateVolSurface)
        : isSet(object.generate_vol_surface)
          ? GenerateVolSurfaceRequest.fromJSON(object.generate_vol_surface)
          : undefined,
      riskSimulation: isSet(object.riskSimulation)
        ? RiskSimulationRequest.fromJSON(object.riskSimulation)
        : isSet(object.risk_simulation)
          ? RiskSimulationRequest.fromJSON(object.risk_simulation)
          : undefined,
      economicCalendarHistory: isSet(object.economicCalendarHistory)
        ? EconomicCalendarHistoryRequest.fromJSON(object.economicCalendarHistory)
        : isSet(object.economic_calendar_history)
          ? EconomicCalendarHistoryRequest.fromJSON(object.economic_calendar_history)
          : undefined,
      executionAnalytics: isSet(object.executionAnalytics)
        ? ExecutionAnalyticsRequest.fromJSON(object.executionAnalytics)
        : isSet(object.execution_analytics)
          ? ExecutionAnalyticsRequest.fromJSON(object.execution_analytics)
          : undefined,
      getVenues: isSet(object.getVenues)
        ? GetVenuesRequest.fromJSON(object.getVenues)
        : isSet(object.get_venues)
          ? GetVenuesRequest.fromJSON(object.get_venues)
          : undefined,
      getExchanges: isSet(object.getExchanges)
        ? GetExchangesRequest.fromJSON(object.getExchanges)
        : isSet(object.get_exchanges)
          ? GetExchangesRequest.fromJSON(object.get_exchanges)
          : undefined,
      getOrdersForAlgo: isSet(object.getOrdersForAlgo)
        ? GetOrdersForAlgoRequest.fromJSON(object.getOrdersForAlgo)
        : isSet(object.get_orders_for_algo)
          ? GetOrdersForAlgoRequest.fromJSON(object.get_orders_for_algo)
          : undefined,
      getTradesForOrder: isSet(object.getTradesForOrder)
        ? GetTradesForOrderRequest.fromJSON(object.getTradesForOrder)
        : isSet(object.get_trades_for_order)
          ? GetTradesForOrderRequest.fromJSON(object.get_trades_for_order)
          : undefined,
      getOrderStateHistory: isSet(object.getOrderStateHistory)
        ? GetOrderStateHistoryRequest.fromJSON(object.getOrderStateHistory)
        : isSet(object.get_order_state_history)
          ? GetOrderStateHistoryRequest.fromJSON(object.get_order_state_history)
          : undefined,
      getTradesForAlgo: isSet(object.getTradesForAlgo)
        ? GetTradesForAlgoRequest.fromJSON(object.getTradesForAlgo)
        : isSet(object.get_trades_for_algo)
          ? GetTradesForAlgoRequest.fromJSON(object.get_trades_for_algo)
          : undefined,
      getAnalyticSnapshot: isSet(object.getAnalyticSnapshot)
        ? GetAnalyticSnapshotRequest.fromJSON(object.getAnalyticSnapshot)
        : isSet(object.get_analytic_snapshot)
          ? GetAnalyticSnapshotRequest.fromJSON(object.get_analytic_snapshot)
          : undefined,
      getAnalyticRange: isSet(object.getAnalyticRange)
        ? GetAnalyticRangeRequest.fromJSON(object.getAnalyticRange)
        : isSet(object.get_analytic_range)
          ? GetAnalyticRangeRequest.fromJSON(object.get_analytic_range)
          : undefined,
      optionsVolumeLeaderboard: isSet(object.optionsVolumeLeaderboard)
        ? GetOptionsVolumeLeaderboardRequest.fromJSON(object.optionsVolumeLeaderboard)
        : isSet(object.options_volume_leaderboard)
          ? GetOptionsVolumeLeaderboardRequest.fromJSON(object.options_volume_leaderboard)
          : undefined,
      optionsVolumeSeries: isSet(object.optionsVolumeSeries)
        ? OptionsVolumeSeriesRequest.fromJSON(object.optionsVolumeSeries)
        : isSet(object.options_volume_series)
          ? OptionsVolumeSeriesRequest.fromJSON(object.options_volume_series)
          : undefined,
      optionsOiSeries: isSet(object.optionsOiSeries)
        ? OptionsOiSeriesRequest.fromJSON(object.optionsOiSeries)
        : isSet(object.options_oi_series)
          ? OptionsOiSeriesRequest.fromJSON(object.options_oi_series)
          : undefined,
      optionsOiLeaderboard: isSet(object.optionsOiLeaderboard)
        ? GetOptionsOiLeaderboardRequest.fromJSON(object.optionsOiLeaderboard)
        : isSet(object.options_oi_leaderboard)
          ? GetOptionsOiLeaderboardRequest.fromJSON(object.options_oi_leaderboard)
          : undefined,
      optionsOiByStrike: isSet(object.optionsOiByStrike)
        ? GetOptionsOiByStrikeRequest.fromJSON(object.optionsOiByStrike)
        : isSet(object.options_oi_by_strike)
          ? GetOptionsOiByStrikeRequest.fromJSON(object.options_oi_by_strike)
          : undefined,
      fundingSeries: isSet(object.fundingSeries)
        ? GetFundingSeriesRequest.fromJSON(object.fundingSeries)
        : isSet(object.funding_series)
          ? GetFundingSeriesRequest.fromJSON(object.funding_series)
          : undefined,
      fundingLeaderboard: isSet(object.fundingLeaderboard)
        ? GetFundingLeaderboardRequest.fromJSON(object.fundingLeaderboard)
        : isSet(object.funding_leaderboard)
          ? GetFundingLeaderboardRequest.fromJSON(object.funding_leaderboard)
          : undefined,
      createPreset: isSet(object.createPreset)
        ? CreatePresetRequest.fromJSON(object.createPreset)
        : isSet(object.create_preset)
          ? CreatePresetRequest.fromJSON(object.create_preset)
          : undefined,
      updatePreset: isSet(object.updatePreset)
        ? UpdatePresetRequest.fromJSON(object.updatePreset)
        : isSet(object.update_preset)
          ? UpdatePresetRequest.fromJSON(object.update_preset)
          : undefined,
      deletePreset: isSet(object.deletePreset)
        ? DeletePresetRequest.fromJSON(object.deletePreset)
        : isSet(object.delete_preset)
          ? DeletePresetRequest.fromJSON(object.delete_preset)
          : undefined,
      listPresets: isSet(object.listPresets)
        ? ListPresetsRequest.fromJSON(object.listPresets)
        : isSet(object.list_presets)
          ? ListPresetsRequest.fromJSON(object.list_presets)
          : undefined,
      executePreset: isSet(object.executePreset)
        ? ExecutePresetRequest.fromJSON(object.executePreset)
        : isSet(object.execute_preset)
          ? ExecutePresetRequest.fromJSON(object.execute_preset)
          : undefined,
      getPreset: isSet(object.getPreset)
        ? GetPresetRequest.fromJSON(object.getPreset)
        : isSet(object.get_preset)
          ? GetPresetRequest.fromJSON(object.get_preset)
          : undefined,
      createWatchlist: isSet(object.createWatchlist)
        ? CreateWatchlistRequest.fromJSON(object.createWatchlist)
        : isSet(object.create_watchlist)
          ? CreateWatchlistRequest.fromJSON(object.create_watchlist)
          : undefined,
      getWatchlists: isSet(object.getWatchlists)
        ? GetWatchlistsRequest.fromJSON(object.getWatchlists)
        : isSet(object.get_watchlists)
          ? GetWatchlistsRequest.fromJSON(object.get_watchlists)
          : undefined,
      setWatchlist: isSet(object.setWatchlist)
        ? SetWatchlistRequest.fromJSON(object.setWatchlist)
        : isSet(object.set_watchlist)
          ? SetWatchlistRequest.fromJSON(object.set_watchlist)
          : undefined,
      renameWatchlist: isSet(object.renameWatchlist)
        ? RenameWatchlistRequest.fromJSON(object.renameWatchlist)
        : isSet(object.rename_watchlist)
          ? RenameWatchlistRequest.fromJSON(object.rename_watchlist)
          : undefined,
      deleteWatchlist: isSet(object.deleteWatchlist)
        ? DeleteWatchlistRequest.fromJSON(object.deleteWatchlist)
        : isSet(object.delete_watchlist)
          ? DeleteWatchlistRequest.fromJSON(object.delete_watchlist)
          : undefined,
      reorderWatchlists: isSet(object.reorderWatchlists)
        ? ReorderWatchlistsRequest.fromJSON(object.reorderWatchlists)
        : isSet(object.reorder_watchlists)
          ? ReorderWatchlistsRequest.fromJSON(object.reorder_watchlists)
          : undefined,
      dbNewsHistory: isSet(object.dbNewsHistory)
        ? DbNewsHistoryRequest.fromJSON(object.dbNewsHistory)
        : isSet(object.db_news_history)
          ? DbNewsHistoryRequest.fromJSON(object.db_news_history)
          : undefined,
      alpacaNewsHistory: isSet(object.alpacaNewsHistory)
        ? AlpacaNewsHistoryRequest.fromJSON(object.alpacaNewsHistory)
        : isSet(object.alpaca_news_history)
          ? AlpacaNewsHistoryRequest.fromJSON(object.alpaca_news_history)
          : undefined,
      intentCompiler: isSet(object.intentCompiler)
        ? TradeIntent.fromJSON(object.intentCompiler)
        : isSet(object.intent_compiler)
          ? TradeIntent.fromJSON(object.intent_compiler)
          : undefined,
      confirmExecutionPlan: isSet(object.confirmExecutionPlan)
        ? ConfirmExecutionPlanRequest.fromJSON(object.confirmExecutionPlan)
        : isSet(object.confirm_execution_plan)
          ? ConfirmExecutionPlanRequest.fromJSON(object.confirm_execution_plan)
          : undefined,
      getDbNewsVocabulary: isSet(object.getDbNewsVocabulary)
        ? GetDbNewsVocabularyRequest.fromJSON(object.getDbNewsVocabulary)
        : isSet(object.get_db_news_vocabulary)
          ? GetDbNewsVocabularyRequest.fromJSON(object.get_db_news_vocabulary)
          : undefined,
      testIntentCompiler: isSet(object.testIntentCompiler)
        ? TestIntentCompilerRequest.fromJSON(object.testIntentCompiler)
        : isSet(object.test_intent_compiler)
          ? TestIntentCompilerRequest.fromJSON(object.test_intent_compiler)
          : undefined,
      getVenueStatus: isSet(object.getVenueStatus)
        ? GetVenueStatus.fromJSON(object.getVenueStatus)
        : isSet(object.get_venue_status)
          ? GetVenueStatus.fromJSON(object.get_venue_status)
          : undefined,
      getVenueSchedules: isSet(object.getVenueSchedules)
        ? GetVenueSchedules.fromJSON(object.getVenueSchedules)
        : isSet(object.get_venue_schedules)
          ? GetVenueSchedules.fromJSON(object.get_venue_schedules)
          : undefined,
      createRfq: isSet(object.createRfq)
        ? CreateRfqRequest.fromJSON(object.createRfq)
        : isSet(object.create_rfq)
          ? CreateRfqRequest.fromJSON(object.create_rfq)
          : undefined,
      cancelRfq: isSet(object.cancelRfq)
        ? CancelRfqRequest.fromJSON(object.cancelRfq)
        : isSet(object.cancel_rfq)
          ? CancelRfqRequest.fromJSON(object.cancel_rfq)
          : undefined,
      acceptRfqQuote: isSet(object.acceptRfqQuote)
        ? AcceptRfqQuoteRequest.fromJSON(object.acceptRfqQuote)
        : isSet(object.accept_rfq_quote)
          ? AcceptRfqQuoteRequest.fromJSON(object.accept_rfq_quote)
          : undefined,
      getRfqMakers: isSet(object.getRfqMakers)
        ? GetRfqMakersRequest.fromJSON(object.getRfqMakers)
        : isSet(object.get_rfq_makers)
          ? GetRfqMakersRequest.fromJSON(object.get_rfq_makers)
          : undefined,
      getRfqHistory: isSet(object.getRfqHistory)
        ? GetRfqHistoryRequest.fromJSON(object.getRfqHistory)
        : isSet(object.get_rfq_history)
          ? GetRfqHistoryRequest.fromJSON(object.get_rfq_history)
          : undefined,
      rfqAnalytics: isSet(object.rfqAnalytics)
        ? RfqAnalyticsRequest.fromJSON(object.rfqAnalytics)
        : isSet(object.rfq_analytics)
          ? RfqAnalyticsRequest.fromJSON(object.rfq_analytics)
          : undefined,
      bybitOauthMintState: isSet(object.bybitOauthMintState)
        ? BybitOauthMintStateRequest.fromJSON(object.bybitOauthMintState)
        : isSet(object.bybit_oauth_mint_state)
          ? BybitOauthMintStateRequest.fromJSON(object.bybit_oauth_mint_state)
          : undefined,
      bybitOauthExchangeCode: isSet(object.bybitOauthExchangeCode)
        ? BybitOauthExchangeCodeRequest.fromJSON(object.bybitOauthExchangeCode)
        : isSet(object.bybit_oauth_exchange_code)
          ? BybitOauthExchangeCodeRequest.fromJSON(object.bybit_oauth_exchange_code)
          : undefined,
      deribitOauthMintState: isSet(object.deribitOauthMintState)
        ? DeribitOauthMintStateRequest.fromJSON(object.deribitOauthMintState)
        : isSet(object.deribit_oauth_mint_state)
          ? DeribitOauthMintStateRequest.fromJSON(object.deribit_oauth_mint_state)
          : undefined,
      deribitOauthExchangeCode: isSet(object.deribitOauthExchangeCode)
        ? DeribitOauthExchangeCodeRequest.fromJSON(object.deribitOauthExchangeCode)
        : isSet(object.deribit_oauth_exchange_code)
          ? DeribitOauthExchangeCodeRequest.fromJSON(object.deribit_oauth_exchange_code)
          : undefined,
      hyperliquidPrepareAgent: isSet(object.hyperliquidPrepareAgent)
        ? HyperliquidPrepareAgentRequest.fromJSON(object.hyperliquidPrepareAgent)
        : isSet(object.hyperliquid_prepare_agent)
          ? HyperliquidPrepareAgentRequest.fromJSON(object.hyperliquid_prepare_agent)
          : undefined,
      hyperliquidConfirmAgent: isSet(object.hyperliquidConfirmAgent)
        ? HyperliquidConfirmAgentRequest.fromJSON(object.hyperliquidConfirmAgent)
        : isSet(object.hyperliquid_confirm_agent)
          ? HyperliquidConfirmAgentRequest.fromJSON(object.hyperliquid_confirm_agent)
          : undefined,
      hyperliquidDisconnectAgent: isSet(object.hyperliquidDisconnectAgent)
        ? HyperliquidDisconnectAgentRequest.fromJSON(object.hyperliquidDisconnectAgent)
        : isSet(object.hyperliquid_disconnect_agent)
          ? HyperliquidDisconnectAgentRequest.fromJSON(object.hyperliquid_disconnect_agent)
          : undefined,
      derivePrepareSessionKey: isSet(object.derivePrepareSessionKey)
        ? DerivePrepareSessionKeyRequest.fromJSON(object.derivePrepareSessionKey)
        : isSet(object.derive_prepare_session_key)
          ? DerivePrepareSessionKeyRequest.fromJSON(object.derive_prepare_session_key)
          : undefined,
      deriveConfirmSessionKey: isSet(object.deriveConfirmSessionKey)
        ? DeriveConfirmSessionKeyRequest.fromJSON(object.deriveConfirmSessionKey)
        : isSet(object.derive_confirm_session_key)
          ? DeriveConfirmSessionKeyRequest.fromJSON(object.derive_confirm_session_key)
          : undefined,
      deriveDisconnect: isSet(object.deriveDisconnect)
        ? DeriveDisconnectRequest.fromJSON(object.deriveDisconnect)
        : isSet(object.derive_disconnect)
          ? DeriveDisconnectRequest.fromJSON(object.derive_disconnect)
          : undefined,
      deriveListSubaccounts: isSet(object.deriveListSubaccounts)
        ? DeriveListSubaccountsRequest.fromJSON(object.deriveListSubaccounts)
        : isSet(object.derive_list_subaccounts)
          ? DeriveListSubaccountsRequest.fromJSON(object.derive_list_subaccounts)
          : undefined,
      deriveLinkSubaccounts: isSet(object.deriveLinkSubaccounts)
        ? DeriveLinkSubaccountsRequest.fromJSON(object.deriveLinkSubaccounts)
        : isSet(object.derive_link_subaccounts)
          ? DeriveLinkSubaccountsRequest.fromJSON(object.derive_link_subaccounts)
          : undefined,
      lighterListSubaccounts: isSet(object.lighterListSubaccounts)
        ? LighterListSubaccountsRequest.fromJSON(object.lighterListSubaccounts)
        : isSet(object.lighter_list_subaccounts)
          ? LighterListSubaccountsRequest.fromJSON(object.lighter_list_subaccounts)
          : undefined,
      lighterPrepareSubaccountKey: isSet(object.lighterPrepareSubaccountKey)
        ? LighterPrepareSubaccountKeyRequest.fromJSON(object.lighterPrepareSubaccountKey)
        : isSet(object.lighter_prepare_subaccount_key)
          ? LighterPrepareSubaccountKeyRequest.fromJSON(object.lighter_prepare_subaccount_key)
          : undefined,
      lighterConfirmSubaccountKey: isSet(object.lighterConfirmSubaccountKey)
        ? LighterConfirmSubaccountKeyRequest.fromJSON(object.lighterConfirmSubaccountKey)
        : isSet(object.lighter_confirm_subaccount_key)
          ? LighterConfirmSubaccountKeyRequest.fromJSON(object.lighter_confirm_subaccount_key)
          : undefined,
      lighterLinkSubaccounts: isSet(object.lighterLinkSubaccounts)
        ? LighterLinkSubaccountsRequest.fromJSON(object.lighterLinkSubaccounts)
        : isSet(object.lighter_link_subaccounts)
          ? LighterLinkSubaccountsRequest.fromJSON(object.lighter_link_subaccounts)
          : undefined,
      createCheckoutSession: isSet(object.createCheckoutSession)
        ? CreateCheckoutSessionRequest.fromJSON(object.createCheckoutSession)
        : isSet(object.create_checkout_session)
          ? CreateCheckoutSessionRequest.fromJSON(object.create_checkout_session)
          : undefined,
      getSubscription: isSet(object.getSubscription)
        ? GetSubscriptionRequest.fromJSON(object.getSubscription)
        : isSet(object.get_subscription)
          ? GetSubscriptionRequest.fromJSON(object.get_subscription)
          : undefined,
      openBillingPortal: isSet(object.openBillingPortal)
        ? OpenBillingPortalRequest.fromJSON(object.openBillingPortal)
        : isSet(object.open_billing_portal)
          ? OpenBillingPortalRequest.fromJSON(object.open_billing_portal)
          : undefined,
      getPlans: isSet(object.getPlans)
        ? GetPlansRequest.fromJSON(object.getPlans)
        : isSet(object.get_plans)
          ? GetPlansRequest.fromJSON(object.get_plans)
          : undefined,
      inviteToAccount: isSet(object.inviteToAccount)
        ? InviteToAccountRequest.fromJSON(object.inviteToAccount)
        : isSet(object.invite_to_account)
          ? InviteToAccountRequest.fromJSON(object.invite_to_account)
          : undefined,
      listAccountAccess: isSet(object.listAccountAccess)
        ? ListAccountAccessRequest.fromJSON(object.listAccountAccess)
        : isSet(object.list_account_access)
          ? ListAccountAccessRequest.fromJSON(object.list_account_access)
          : undefined,
      revokeInvite: isSet(object.revokeInvite)
        ? RevokeInviteRequest.fromJSON(object.revokeInvite)
        : isSet(object.revoke_invite)
          ? RevokeInviteRequest.fromJSON(object.revoke_invite)
          : undefined,
      removeAccountAccess: isSet(object.removeAccountAccess)
        ? RemoveAccountAccessRequest.fromJSON(object.removeAccountAccess)
        : isSet(object.remove_account_access)
          ? RemoveAccountAccessRequest.fromJSON(object.remove_account_access)
          : undefined,
      changeAccountRole: isSet(object.changeAccountRole)
        ? ChangeAccountRoleRequest.fromJSON(object.changeAccountRole)
        : isSet(object.change_account_role)
          ? ChangeAccountRoleRequest.fromJSON(object.change_account_role)
          : undefined,
      leaveAccount: isSet(object.leaveAccount)
        ? LeaveAccountRequest.fromJSON(object.leaveAccount)
        : isSet(object.leave_account)
          ? LeaveAccountRequest.fromJSON(object.leave_account)
          : undefined,
      listMyInvites: isSet(object.listMyInvites)
        ? ListMyInvitesRequest.fromJSON(object.listMyInvites)
        : isSet(object.list_my_invites)
          ? ListMyInvitesRequest.fromJSON(object.list_my_invites)
          : undefined,
      respondToInvite: isSet(object.respondToInvite)
        ? RespondToInviteRequest.fromJSON(object.respondToInvite)
        : isSet(object.respond_to_invite)
          ? RespondToInviteRequest.fromJSON(object.respond_to_invite)
          : undefined,
      transferAccountOwnership: isSet(object.transferAccountOwnership)
        ? TransferAccountOwnershipRequest.fromJSON(object.transferAccountOwnership)
        : isSet(object.transfer_account_ownership)
          ? TransferAccountOwnershipRequest.fromJSON(object.transfer_account_ownership)
          : undefined,
      cancelPendingAccount: isSet(object.cancelPendingAccount)
        ? CancelPendingAccountRequest.fromJSON(object.cancelPendingAccount)
        : isSet(object.cancel_pending_account)
          ? CancelPendingAccountRequest.fromJSON(object.cancel_pending_account)
          : undefined,
      orderPreview: isSet(object.orderPreview)
        ? OrderPreviewRequest.fromJSON(object.orderPreview)
        : isSet(object.order_preview)
          ? OrderPreviewRequest.fromJSON(object.order_preview)
          : undefined,
      changePassword: isSet(object.changePassword)
        ? ChangePasswordRequest.fromJSON(object.changePassword)
        : isSet(object.change_password)
          ? ChangePasswordRequest.fromJSON(object.change_password)
          : undefined,
      listSessions: isSet(object.listSessions)
        ? ListSessionsRequest.fromJSON(object.listSessions)
        : isSet(object.list_sessions)
          ? ListSessionsRequest.fromJSON(object.list_sessions)
          : undefined,
      revokeSession: isSet(object.revokeSession)
        ? RevokeSessionRequest.fromJSON(object.revokeSession)
        : isSet(object.revoke_session)
          ? RevokeSessionRequest.fromJSON(object.revoke_session)
          : undefined,
      logout: isSet(object.logout) ? LogoutRequest.fromJSON(object.logout) : undefined,
      revokeAllOtherSessions: isSet(object.revokeAllOtherSessions)
        ? RevokeAllOtherSessionsRequest.fromJSON(object.revokeAllOtherSessions)
        : isSet(object.revoke_all_other_sessions)
          ? RevokeAllOtherSessionsRequest.fromJSON(object.revoke_all_other_sessions)
          : undefined,
      sendStepUpCode: isSet(object.sendStepUpCode)
        ? SendStepUpCodeRequest.fromJSON(object.sendStepUpCode)
        : isSet(object.send_step_up_code)
          ? SendStepUpCodeRequest.fromJSON(object.send_step_up_code)
          : undefined,
      orderbookMetricsSeries: isSet(object.orderbookMetricsSeries)
        ? OrderbookMetricsSeriesRequest.fromJSON(object.orderbookMetricsSeries)
        : isSet(object.orderbook_metrics_series)
          ? OrderbookMetricsSeriesRequest.fromJSON(object.orderbook_metrics_series)
          : undefined,
      optionsTradesHistory: isSet(object.optionsTradesHistory)
        ? OptionsTradesHistoryRequest.fromJSON(object.optionsTradesHistory)
        : isSet(object.options_trades_history)
          ? OptionsTradesHistoryRequest.fromJSON(object.options_trades_history)
          : undefined,
      masterInstrumentList: isSet(object.masterInstrumentList)
        ? MasterInstrumentListRequest.fromJSON(object.masterInstrumentList)
        : isSet(object.master_instrument_list)
          ? MasterInstrumentListRequest.fromJSON(object.master_instrument_list)
          : undefined,
      impliedMove: isSet(object.impliedMove)
        ? GetImpliedMoveRequest.fromJSON(object.impliedMove)
        : isSet(object.implied_move)
          ? GetImpliedMoveRequest.fromJSON(object.implied_move)
          : undefined,
      ivPercentile: isSet(object.ivPercentile)
        ? GetIvPercentileRequest.fromJSON(object.ivPercentile)
        : isSet(object.iv_percentile)
          ? GetIvPercentileRequest.fromJSON(object.iv_percentile)
          : undefined,
      maxPain: isSet(object.maxPain)
        ? GetMaxPainRequest.fromJSON(object.maxPain)
        : isSet(object.max_pain)
          ? GetMaxPainRequest.fromJSON(object.max_pain)
          : undefined,
      greeksByExpiry: isSet(object.greeksByExpiry)
        ? GetGreeksByExpiryRequest.fromJSON(object.greeksByExpiry)
        : isSet(object.greeks_by_expiry)
          ? GetGreeksByExpiryRequest.fromJSON(object.greeks_by_expiry)
          : undefined,
      generateWatchlist: isSet(object.generateWatchlist)
        ? GenerateWatchlistRequest.fromJSON(object.generateWatchlist)
        : isSet(object.generate_watchlist)
          ? GenerateWatchlistRequest.fromJSON(object.generate_watchlist)
          : undefined,
      hyperliquidListSubaccounts: isSet(object.hyperliquidListSubaccounts)
        ? HyperliquidListSubaccountsRequest.fromJSON(object.hyperliquidListSubaccounts)
        : isSet(object.hyperliquid_list_subaccounts)
          ? HyperliquidListSubaccountsRequest.fromJSON(object.hyperliquid_list_subaccounts)
          : undefined,
      hyperliquidLinkSubaccounts: isSet(object.hyperliquidLinkSubaccounts)
        ? HyperliquidLinkSubaccountsRequest.fromJSON(object.hyperliquidLinkSubaccounts)
        : isSet(object.hyperliquid_link_subaccounts)
          ? HyperliquidLinkSubaccountsRequest.fromJSON(object.hyperliquid_link_subaccounts)
          : undefined,
      batchOrderPreview: isSet(object.batchOrderPreview)
        ? BatchOrderPreviewRequest.fromJSON(object.batchOrderPreview)
        : isSet(object.batch_order_preview)
          ? BatchOrderPreviewRequest.fromJSON(object.batch_order_preview)
          : undefined,
      visibleRangeProfile: isSet(object.visibleRangeProfile)
        ? VisibleRangeProfileRequest.fromJSON(object.visibleRangeProfile)
        : isSet(object.visible_range_profile)
          ? VisibleRangeProfileRequest.fromJSON(object.visible_range_profile)
          : undefined,
      getTwitterPostHistory: isSet(object.getTwitterPostHistory)
        ? GetTwitterPostHistoryRequest.fromJSON(object.getTwitterPostHistory)
        : isSet(object.get_twitter_post_history)
          ? GetTwitterPostHistoryRequest.fromJSON(object.get_twitter_post_history)
          : undefined,
      lighterPrepareIntegratorConsent: isSet(object.lighterPrepareIntegratorConsent)
        ? LighterPrepareIntegratorConsentRequest.fromJSON(object.lighterPrepareIntegratorConsent)
        : isSet(object.lighter_prepare_integrator_consent)
          ? LighterPrepareIntegratorConsentRequest.fromJSON(
              object.lighter_prepare_integrator_consent
            )
          : undefined,
      lighterConfirmIntegratorConsent: isSet(object.lighterConfirmIntegratorConsent)
        ? LighterConfirmIntegratorConsentRequest.fromJSON(object.lighterConfirmIntegratorConsent)
        : isSet(object.lighter_confirm_integrator_consent)
          ? LighterConfirmIntegratorConsentRequest.fromJSON(
              object.lighter_confirm_integrator_consent
            )
          : undefined,
      etfFundFlows: isSet(object.etfFundFlows)
        ? EtfFundFlowsRequest.fromJSON(object.etfFundFlows)
        : isSet(object.etf_fund_flows)
          ? EtfFundFlowsRequest.fromJSON(object.etf_fund_flows)
          : undefined,
      fedwatchProbabilities: isSet(object.fedwatchProbabilities)
        ? FedwatchProbabilitiesRequest.fromJSON(object.fedwatchProbabilities)
        : isSet(object.fedwatch_probabilities)
          ? FedwatchProbabilitiesRequest.fromJSON(object.fedwatch_probabilities)
          : undefined,
      getCoinmarketcalEvents: isSet(object.getCoinmarketcalEvents)
        ? GetCoinMarketCalEventsRequest.fromJSON(object.getCoinmarketcalEvents)
        : isSet(object.get_coinmarketcal_events)
          ? GetCoinMarketCalEventsRequest.fromJSON(object.get_coinmarketcal_events)
          : undefined,
      optionsStrikeFlow: isSet(object.optionsStrikeFlow)
        ? OptionsStrikeFlowRequest.fromJSON(object.optionsStrikeFlow)
        : isSet(object.options_strike_flow)
          ? OptionsStrikeFlowRequest.fromJSON(object.options_strike_flow)
          : undefined,
      gexAggregate: isSet(object.gexAggregate)
        ? GetGexAggregateRequest.fromJSON(object.gexAggregate)
        : isSet(object.gex_aggregate)
          ? GetGexAggregateRequest.fromJSON(object.gex_aggregate)
          : undefined,
      economicData: isSet(object.economicData)
        ? EconomicDataRequest.fromJSON(object.economicData)
        : isSet(object.economic_data)
          ? EconomicDataRequest.fromJSON(object.economic_data)
          : undefined,
      mintMessagingLinkNonce: isSet(object.mintMessagingLinkNonce)
        ? MintMessagingLinkNonceRequest.fromJSON(object.mintMessagingLinkNonce)
        : isSet(object.mint_messaging_link_nonce)
          ? MintMessagingLinkNonceRequest.fromJSON(object.mint_messaging_link_nonce)
          : undefined,
      getTokenUnlocks: isSet(object.getTokenUnlocks)
        ? GetTokenUnlocksRequest.fromJSON(object.getTokenUnlocks)
        : isSet(object.get_token_unlocks)
          ? GetTokenUnlocksRequest.fromJSON(object.get_token_unlocks)
          : undefined,
      getTokenEmission: isSet(object.getTokenEmission)
        ? GetTokenEmissionRequest.fromJSON(object.getTokenEmission)
        : isSet(object.get_token_emission)
          ? GetTokenEmissionRequest.fromJSON(object.get_token_emission)
          : undefined,
      paradigmConnectDesk: isSet(object.paradigmConnectDesk)
        ? ParadigmConnectDeskRequest.fromJSON(object.paradigmConnectDesk)
        : isSet(object.paradigm_connect_desk)
          ? ParadigmConnectDeskRequest.fromJSON(object.paradigm_connect_desk)
          : undefined,
      paradigmListAccounts: isSet(object.paradigmListAccounts)
        ? ParadigmListAccountsRequest.fromJSON(object.paradigmListAccounts)
        : isSet(object.paradigm_list_accounts)
          ? ParadigmListAccountsRequest.fromJSON(object.paradigm_list_accounts)
          : undefined,
      paradigmLinkAccount: isSet(object.paradigmLinkAccount)
        ? ParadigmLinkAccountRequest.fromJSON(object.paradigmLinkAccount)
        : isSet(object.paradigm_link_account)
          ? ParadigmLinkAccountRequest.fromJSON(object.paradigm_link_account)
          : undefined,
      paradigmDisconnect: isSet(object.paradigmDisconnect)
        ? ParadigmDisconnectRequest.fromJSON(object.paradigmDisconnect)
        : isSet(object.paradigm_disconnect)
          ? ParadigmDisconnectRequest.fromJSON(object.paradigm_disconnect)
          : undefined,
      createSharedLayout: isSet(object.createSharedLayout)
        ? CreateSharedLayoutRequest.fromJSON(object.createSharedLayout)
        : isSet(object.create_shared_layout)
          ? CreateSharedLayoutRequest.fromJSON(object.create_shared_layout)
          : undefined,
      getSharedLayout: isSet(object.getSharedLayout)
        ? GetSharedLayoutRequest.fromJSON(object.getSharedLayout)
        : isSet(object.get_shared_layout)
          ? GetSharedLayoutRequest.fromJSON(object.get_shared_layout)
          : undefined,
      treeNewsHistory: isSet(object.treeNewsHistory)
        ? TreeNewsHistoryRequest.fromJSON(object.treeNewsHistory)
        : isSet(object.tree_news_history)
          ? TreeNewsHistoryRequest.fromJSON(object.tree_news_history)
          : undefined,
      surfaceCurrencies: isSet(object.surfaceCurrencies)
        ? GetSurfaceCurrenciesRequest.fromJSON(object.surfaceCurrencies)
        : isSet(object.surface_currencies)
          ? GetSurfaceCurrenciesRequest.fromJSON(object.surface_currencies)
          : undefined,
      createApiKey: isSet(object.createApiKey)
        ? CreateApiKeyRequest.fromJSON(object.createApiKey)
        : isSet(object.create_api_key)
          ? CreateApiKeyRequest.fromJSON(object.create_api_key)
          : undefined,
      listApiKeys: isSet(object.listApiKeys)
        ? ListApiKeysRequest.fromJSON(object.listApiKeys)
        : isSet(object.list_api_keys)
          ? ListApiKeysRequest.fromJSON(object.list_api_keys)
          : undefined,
      revokeApiKey: isSet(object.revokeApiKey)
        ? RevokeApiKeyRequest.fromJSON(object.revokeApiKey)
        : isSet(object.revoke_api_key)
          ? RevokeApiKeyRequest.fromJSON(object.revoke_api_key)
          : undefined,
      getApiBilling: isSet(object.getApiBilling)
        ? GetApiBillingRequest.fromJSON(object.getApiBilling)
        : isSet(object.get_api_billing)
          ? GetApiBillingRequest.fromJSON(object.get_api_billing)
          : undefined,
      updateApiBillingSettings: isSet(object.updateApiBillingSettings)
        ? UpdateApiBillingSettingsRequest.fromJSON(object.updateApiBillingSettings)
        : isSet(object.update_api_billing_settings)
          ? UpdateApiBillingSettingsRequest.fromJSON(object.update_api_billing_settings)
          : undefined,
      createCreditCheckoutSession: isSet(object.createCreditCheckoutSession)
        ? CreateCreditCheckoutSessionRequest.fromJSON(object.createCreditCheckoutSession)
        : isSet(object.create_credit_checkout_session)
          ? CreateCreditCheckoutSessionRequest.fromJSON(object.create_credit_checkout_session)
          : undefined,
      listCreditLedger: isSet(object.listCreditLedger)
        ? ListCreditLedgerRequest.fromJSON(object.listCreditLedger)
        : isSet(object.list_credit_ledger)
          ? ListCreditLedgerRequest.fromJSON(object.list_credit_ledger)
          : undefined,
      getCreditSpendStats: isSet(object.getCreditSpendStats)
        ? GetCreditSpendStatsRequest.fromJSON(object.getCreditSpendStats)
        : isSet(object.get_credit_spend_stats)
          ? GetCreditSpendStatsRequest.fromJSON(object.get_credit_spend_stats)
          : undefined,
      getMarketScreener: isSet(object.getMarketScreener)
        ? GetMarketScreenerRequest.fromJSON(object.getMarketScreener)
        : isSet(object.get_market_screener)
          ? GetMarketScreenerRequest.fromJSON(object.get_market_screener)
          : undefined,
      listVolFitReferences: isSet(object.listVolFitReferences)
        ? ListVolFitReferencesRequest.fromJSON(object.listVolFitReferences)
        : isSet(object.list_vol_fit_references)
          ? ListVolFitReferencesRequest.fromJSON(object.list_vol_fit_references)
          : undefined,
      orderbookHeatmap: isSet(object.orderbookHeatmap)
        ? OrderbookHeatmapRequest.fromJSON(object.orderbookHeatmap)
        : isSet(object.orderbook_heatmap)
          ? OrderbookHeatmapRequest.fromJSON(object.orderbook_heatmap)
          : undefined,
      sendRfqMakerQuote: isSet(object.sendRfqMakerQuote)
        ? SendRfqMakerQuoteRequest.fromJSON(object.sendRfqMakerQuote)
        : isSet(object.send_rfq_maker_quote)
          ? SendRfqMakerQuoteRequest.fromJSON(object.send_rfq_maker_quote)
          : undefined,
      cancelRfqMakerQuote: isSet(object.cancelRfqMakerQuote)
        ? CancelRfqMakerQuoteRequest.fromJSON(object.cancelRfqMakerQuote)
        : isSet(object.cancel_rfq_maker_quote)
          ? CancelRfqMakerQuoteRequest.fromJSON(object.cancel_rfq_maker_quote)
          : undefined,
      setLeverage: isSet(object.setLeverage)
        ? SetLeverageRequest.fromJSON(object.setLeverage)
        : isSet(object.set_leverage)
          ? SetLeverageRequest.fromJSON(object.set_leverage)
          : undefined,
      papertradePrepareSessionKey: isSet(object.papertradePrepareSessionKey)
        ? PapertradePrepareSessionKeyRequest.fromJSON(object.papertradePrepareSessionKey)
        : isSet(object.papertrade_prepare_session_key)
          ? PapertradePrepareSessionKeyRequest.fromJSON(object.papertrade_prepare_session_key)
          : undefined,
      papertradeConfirmSessionKey: isSet(object.papertradeConfirmSessionKey)
        ? PapertradeConfirmSessionKeyRequest.fromJSON(object.papertradeConfirmSessionKey)
        : isSet(object.papertrade_confirm_session_key)
          ? PapertradeConfirmSessionKeyRequest.fromJSON(object.papertrade_confirm_session_key)
          : undefined,
      papertradeDisconnect: isSet(object.papertradeDisconnect)
        ? PapertradeDisconnectRequest.fromJSON(object.papertradeDisconnect)
        : isSet(object.papertrade_disconnect)
          ? PapertradeDisconnectRequest.fromJSON(object.papertrade_disconnect)
          : undefined,
      getAccountSettings: isSet(object.getAccountSettings)
        ? GetAccountSettingsRequest.fromJSON(object.getAccountSettings)
        : isSet(object.get_account_settings)
          ? GetAccountSettingsRequest.fromJSON(object.get_account_settings)
          : undefined,
    }
  },

  toJSON(message: ApiRequest): unknown {
    const obj: any = {}
    if (message.executionBatch !== undefined) {
      obj.executionBatch = ExecutionBatch.toJSON(message.executionBatch)
    }
    if (message.login !== undefined) {
      obj.login = LoginRequest.toJSON(message.login)
    }
    if (message.signup !== undefined) {
      obj.signup = SignupRequest.toJSON(message.signup)
    }
    if (message.createAccount !== undefined) {
      obj.createAccount = CreateAccountRequest.toJSON(message.createAccount)
    }
    if (message.getUserAccounts !== undefined) {
      obj.getUserAccounts = GetUserAccountsRequest.toJSON(message.getUserAccounts)
    }
    if (message.requestPasswordReset !== undefined) {
      obj.requestPasswordReset = RequestPasswordResetRequest.toJSON(message.requestPasswordReset)
    }
    if (message.confirmPasswordReset !== undefined) {
      obj.confirmPasswordReset = ConfirmPasswordResetRequest.toJSON(message.confirmPasswordReset)
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = RefreshTokenRequest.toJSON(message.refreshToken)
    }
    if (message.verifyEmail !== undefined) {
      obj.verifyEmail = VerifyEmailRequest.toJSON(message.verifyEmail)
    }
    if (message.resendVerification !== undefined) {
      obj.resendVerification = ResendVerificationRequest.toJSON(message.resendVerification)
    }
    if (message.verify !== undefined) {
      obj.verify = VerifyTokenRequest.toJSON(message.verify)
    }
    if (message.setup2fa !== undefined) {
      obj.setup2fa = Setup2faRequest.toJSON(message.setup2fa)
    }
    if (message.confirm2faSetup !== undefined) {
      obj.confirm2faSetup = Confirm2faSetupRequest.toJSON(message.confirm2faSetup)
    }
    if (message.verify2fa !== undefined) {
      obj.verify2fa = Verify2faRequest.toJSON(message.verify2fa)
    }
    if (message.verify2faLogin !== undefined) {
      obj.verify2faLogin = Verify2faLoginRequest.toJSON(message.verify2faLogin)
    }
    if (message.disable2fa !== undefined) {
      obj.disable2fa = Disable2faRequest.toJSON(message.disable2fa)
    }
    if (message.get2faBackupCodes !== undefined) {
      obj.get2faBackupCodes = Get2faBackupCodesRequest.toJSON(message.get2faBackupCodes)
    }
    if (message.setupPasskey !== undefined) {
      obj.setupPasskey = SetupPasskeyRequest.toJSON(message.setupPasskey)
    }
    if (message.confirmPasskeySetup !== undefined) {
      obj.confirmPasskeySetup = ConfirmPasskeySetupRequest.toJSON(message.confirmPasskeySetup)
    }
    if (message.passkeyLogin !== undefined) {
      obj.passkeyLogin = PasskeyLoginRequest.toJSON(message.passkeyLogin)
    }
    if (message.confirmPasskeyLogin !== undefined) {
      obj.confirmPasskeyLogin = ConfirmPasskeyLoginRequest.toJSON(message.confirmPasskeyLogin)
    }
    if (message.deletePasskey !== undefined) {
      obj.deletePasskey = DeletePasskeyRequest.toJSON(message.deletePasskey)
    }
    if (message.getUserPasskeys !== undefined) {
      obj.getUserPasskeys = GetUserPasskeysRequest.toJSON(message.getUserPasskeys)
    }
    if (message.googleLogin !== undefined) {
      obj.googleLogin = GoogleLoginRequest.toJSON(message.googleLogin)
    }
    if (message.chartData !== undefined) {
      obj.chartData = ChartDataRequest.toJSON(message.chartData)
    }
    if (message.portfolioLineChart !== undefined) {
      obj.portfolioLineChart = PortfolioLineChartRequest.toJSON(message.portfolioLineChart)
    }
    if (message.time !== undefined) {
      obj.time = Time.toJSON(message.time)
    }
    if (message.updateAccount !== undefined) {
      obj.updateAccount = UpdateAccountRequest.toJSON(message.updateAccount)
    }
    if (message.instrumentList !== undefined) {
      obj.instrumentList = InstrumentListRequest.toJSON(message.instrumentList)
    }
    if (message.orderHistory !== undefined) {
      obj.orderHistory = HistoryRequest.toJSON(message.orderHistory)
    }
    if (message.tradeHistory !== undefined) {
      obj.tradeHistory = HistoryRequest.toJSON(message.tradeHistory)
    }
    if (message.createPage !== undefined) {
      obj.createPage = CreatePageRequest.toJSON(message.createPage)
    }
    if (message.getPages !== undefined) {
      obj.getPages = GetPagesRequest.toJSON(message.getPages)
    }
    if (message.getPageLayout !== undefined) {
      obj.getPageLayout = GetPageLayoutRequest.toJSON(message.getPageLayout)
    }
    if (message.updatePageMeta !== undefined) {
      obj.updatePageMeta = UpdatePageMetaRequest.toJSON(message.updatePageMeta)
    }
    if (message.deletePage !== undefined) {
      obj.deletePage = DeletePageRequest.toJSON(message.deletePage)
    }
    if (message.addWidget !== undefined) {
      obj.addWidget = AddWidgetRequest.toJSON(message.addWidget)
    }
    if (message.updateWidget !== undefined) {
      obj.updateWidget = UpdateWidgetRequest.toJSON(message.updateWidget)
    }
    if (message.removeWidget !== undefined) {
      obj.removeWidget = RemoveWidgetRequest.toJSON(message.removeWidget)
    }
    if (message.saveComponentPreference !== undefined) {
      obj.saveComponentPreference = SaveComponentPreferenceRequest.toJSON(
        message.saveComponentPreference
      )
    }
    if (message.getComponentPreference !== undefined) {
      obj.getComponentPreference = GetComponentPreferenceRequest.toJSON(
        message.getComponentPreference
      )
    }
    if (message.createPositionGroup !== undefined) {
      obj.createPositionGroup = CreatePositionGroupRequest.toJSON(message.createPositionGroup)
    }
    if (message.updatePositionGroup !== undefined) {
      obj.updatePositionGroup = UpdatePositionGroupRequest.toJSON(message.updatePositionGroup)
    }
    if (message.deletePositionGroup !== undefined) {
      obj.deletePositionGroup = DeletePositionGroupRequest.toJSON(message.deletePositionGroup)
    }
    if (message.getPositionsView !== undefined) {
      obj.getPositionsView = GetPositionsViewRequest.toJSON(message.getPositionsView)
    }
    if (message.getPositionGroups !== undefined) {
      obj.getPositionGroups = GetPositionGroupsRequest.toJSON(message.getPositionGroups)
    }
    if (message.reorderPositionsView !== undefined) {
      obj.reorderPositionsView = ReorderPositionsViewRequest.toJSON(message.reorderPositionsView)
    }
    if (message.setPositionGroupOrder !== undefined) {
      obj.setPositionGroupOrder = SetPositionGroupOrderRequest.toJSON(message.setPositionGroupOrder)
    }
    if (message.generateVolSurface !== undefined) {
      obj.generateVolSurface = GenerateVolSurfaceRequest.toJSON(message.generateVolSurface)
    }
    if (message.riskSimulation !== undefined) {
      obj.riskSimulation = RiskSimulationRequest.toJSON(message.riskSimulation)
    }
    if (message.economicCalendarHistory !== undefined) {
      obj.economicCalendarHistory = EconomicCalendarHistoryRequest.toJSON(
        message.economicCalendarHistory
      )
    }
    if (message.executionAnalytics !== undefined) {
      obj.executionAnalytics = ExecutionAnalyticsRequest.toJSON(message.executionAnalytics)
    }
    if (message.getVenues !== undefined) {
      obj.getVenues = GetVenuesRequest.toJSON(message.getVenues)
    }
    if (message.getExchanges !== undefined) {
      obj.getExchanges = GetExchangesRequest.toJSON(message.getExchanges)
    }
    if (message.getOrdersForAlgo !== undefined) {
      obj.getOrdersForAlgo = GetOrdersForAlgoRequest.toJSON(message.getOrdersForAlgo)
    }
    if (message.getTradesForOrder !== undefined) {
      obj.getTradesForOrder = GetTradesForOrderRequest.toJSON(message.getTradesForOrder)
    }
    if (message.getOrderStateHistory !== undefined) {
      obj.getOrderStateHistory = GetOrderStateHistoryRequest.toJSON(message.getOrderStateHistory)
    }
    if (message.getTradesForAlgo !== undefined) {
      obj.getTradesForAlgo = GetTradesForAlgoRequest.toJSON(message.getTradesForAlgo)
    }
    if (message.getAnalyticSnapshot !== undefined) {
      obj.getAnalyticSnapshot = GetAnalyticSnapshotRequest.toJSON(message.getAnalyticSnapshot)
    }
    if (message.getAnalyticRange !== undefined) {
      obj.getAnalyticRange = GetAnalyticRangeRequest.toJSON(message.getAnalyticRange)
    }
    if (message.optionsVolumeLeaderboard !== undefined) {
      obj.optionsVolumeLeaderboard = GetOptionsVolumeLeaderboardRequest.toJSON(
        message.optionsVolumeLeaderboard
      )
    }
    if (message.optionsVolumeSeries !== undefined) {
      obj.optionsVolumeSeries = OptionsVolumeSeriesRequest.toJSON(message.optionsVolumeSeries)
    }
    if (message.optionsOiSeries !== undefined) {
      obj.optionsOiSeries = OptionsOiSeriesRequest.toJSON(message.optionsOiSeries)
    }
    if (message.optionsOiLeaderboard !== undefined) {
      obj.optionsOiLeaderboard = GetOptionsOiLeaderboardRequest.toJSON(message.optionsOiLeaderboard)
    }
    if (message.optionsOiByStrike !== undefined) {
      obj.optionsOiByStrike = GetOptionsOiByStrikeRequest.toJSON(message.optionsOiByStrike)
    }
    if (message.fundingSeries !== undefined) {
      obj.fundingSeries = GetFundingSeriesRequest.toJSON(message.fundingSeries)
    }
    if (message.fundingLeaderboard !== undefined) {
      obj.fundingLeaderboard = GetFundingLeaderboardRequest.toJSON(message.fundingLeaderboard)
    }
    if (message.createPreset !== undefined) {
      obj.createPreset = CreatePresetRequest.toJSON(message.createPreset)
    }
    if (message.updatePreset !== undefined) {
      obj.updatePreset = UpdatePresetRequest.toJSON(message.updatePreset)
    }
    if (message.deletePreset !== undefined) {
      obj.deletePreset = DeletePresetRequest.toJSON(message.deletePreset)
    }
    if (message.listPresets !== undefined) {
      obj.listPresets = ListPresetsRequest.toJSON(message.listPresets)
    }
    if (message.executePreset !== undefined) {
      obj.executePreset = ExecutePresetRequest.toJSON(message.executePreset)
    }
    if (message.getPreset !== undefined) {
      obj.getPreset = GetPresetRequest.toJSON(message.getPreset)
    }
    if (message.createWatchlist !== undefined) {
      obj.createWatchlist = CreateWatchlistRequest.toJSON(message.createWatchlist)
    }
    if (message.getWatchlists !== undefined) {
      obj.getWatchlists = GetWatchlistsRequest.toJSON(message.getWatchlists)
    }
    if (message.setWatchlist !== undefined) {
      obj.setWatchlist = SetWatchlistRequest.toJSON(message.setWatchlist)
    }
    if (message.renameWatchlist !== undefined) {
      obj.renameWatchlist = RenameWatchlistRequest.toJSON(message.renameWatchlist)
    }
    if (message.deleteWatchlist !== undefined) {
      obj.deleteWatchlist = DeleteWatchlistRequest.toJSON(message.deleteWatchlist)
    }
    if (message.reorderWatchlists !== undefined) {
      obj.reorderWatchlists = ReorderWatchlistsRequest.toJSON(message.reorderWatchlists)
    }
    if (message.dbNewsHistory !== undefined) {
      obj.dbNewsHistory = DbNewsHistoryRequest.toJSON(message.dbNewsHistory)
    }
    if (message.alpacaNewsHistory !== undefined) {
      obj.alpacaNewsHistory = AlpacaNewsHistoryRequest.toJSON(message.alpacaNewsHistory)
    }
    if (message.intentCompiler !== undefined) {
      obj.intentCompiler = TradeIntent.toJSON(message.intentCompiler)
    }
    if (message.confirmExecutionPlan !== undefined) {
      obj.confirmExecutionPlan = ConfirmExecutionPlanRequest.toJSON(message.confirmExecutionPlan)
    }
    if (message.getDbNewsVocabulary !== undefined) {
      obj.getDbNewsVocabulary = GetDbNewsVocabularyRequest.toJSON(message.getDbNewsVocabulary)
    }
    if (message.testIntentCompiler !== undefined) {
      obj.testIntentCompiler = TestIntentCompilerRequest.toJSON(message.testIntentCompiler)
    }
    if (message.getVenueStatus !== undefined) {
      obj.getVenueStatus = GetVenueStatus.toJSON(message.getVenueStatus)
    }
    if (message.getVenueSchedules !== undefined) {
      obj.getVenueSchedules = GetVenueSchedules.toJSON(message.getVenueSchedules)
    }
    if (message.createRfq !== undefined) {
      obj.createRfq = CreateRfqRequest.toJSON(message.createRfq)
    }
    if (message.cancelRfq !== undefined) {
      obj.cancelRfq = CancelRfqRequest.toJSON(message.cancelRfq)
    }
    if (message.acceptRfqQuote !== undefined) {
      obj.acceptRfqQuote = AcceptRfqQuoteRequest.toJSON(message.acceptRfqQuote)
    }
    if (message.getRfqMakers !== undefined) {
      obj.getRfqMakers = GetRfqMakersRequest.toJSON(message.getRfqMakers)
    }
    if (message.getRfqHistory !== undefined) {
      obj.getRfqHistory = GetRfqHistoryRequest.toJSON(message.getRfqHistory)
    }
    if (message.rfqAnalytics !== undefined) {
      obj.rfqAnalytics = RfqAnalyticsRequest.toJSON(message.rfqAnalytics)
    }
    if (message.bybitOauthMintState !== undefined) {
      obj.bybitOauthMintState = BybitOauthMintStateRequest.toJSON(message.bybitOauthMintState)
    }
    if (message.bybitOauthExchangeCode !== undefined) {
      obj.bybitOauthExchangeCode = BybitOauthExchangeCodeRequest.toJSON(
        message.bybitOauthExchangeCode
      )
    }
    if (message.deribitOauthMintState !== undefined) {
      obj.deribitOauthMintState = DeribitOauthMintStateRequest.toJSON(message.deribitOauthMintState)
    }
    if (message.deribitOauthExchangeCode !== undefined) {
      obj.deribitOauthExchangeCode = DeribitOauthExchangeCodeRequest.toJSON(
        message.deribitOauthExchangeCode
      )
    }
    if (message.hyperliquidPrepareAgent !== undefined) {
      obj.hyperliquidPrepareAgent = HyperliquidPrepareAgentRequest.toJSON(
        message.hyperliquidPrepareAgent
      )
    }
    if (message.hyperliquidConfirmAgent !== undefined) {
      obj.hyperliquidConfirmAgent = HyperliquidConfirmAgentRequest.toJSON(
        message.hyperliquidConfirmAgent
      )
    }
    if (message.hyperliquidDisconnectAgent !== undefined) {
      obj.hyperliquidDisconnectAgent = HyperliquidDisconnectAgentRequest.toJSON(
        message.hyperliquidDisconnectAgent
      )
    }
    if (message.derivePrepareSessionKey !== undefined) {
      obj.derivePrepareSessionKey = DerivePrepareSessionKeyRequest.toJSON(
        message.derivePrepareSessionKey
      )
    }
    if (message.deriveConfirmSessionKey !== undefined) {
      obj.deriveConfirmSessionKey = DeriveConfirmSessionKeyRequest.toJSON(
        message.deriveConfirmSessionKey
      )
    }
    if (message.deriveDisconnect !== undefined) {
      obj.deriveDisconnect = DeriveDisconnectRequest.toJSON(message.deriveDisconnect)
    }
    if (message.deriveListSubaccounts !== undefined) {
      obj.deriveListSubaccounts = DeriveListSubaccountsRequest.toJSON(message.deriveListSubaccounts)
    }
    if (message.deriveLinkSubaccounts !== undefined) {
      obj.deriveLinkSubaccounts = DeriveLinkSubaccountsRequest.toJSON(message.deriveLinkSubaccounts)
    }
    if (message.lighterListSubaccounts !== undefined) {
      obj.lighterListSubaccounts = LighterListSubaccountsRequest.toJSON(
        message.lighterListSubaccounts
      )
    }
    if (message.lighterPrepareSubaccountKey !== undefined) {
      obj.lighterPrepareSubaccountKey = LighterPrepareSubaccountKeyRequest.toJSON(
        message.lighterPrepareSubaccountKey
      )
    }
    if (message.lighterConfirmSubaccountKey !== undefined) {
      obj.lighterConfirmSubaccountKey = LighterConfirmSubaccountKeyRequest.toJSON(
        message.lighterConfirmSubaccountKey
      )
    }
    if (message.lighterLinkSubaccounts !== undefined) {
      obj.lighterLinkSubaccounts = LighterLinkSubaccountsRequest.toJSON(
        message.lighterLinkSubaccounts
      )
    }
    if (message.createCheckoutSession !== undefined) {
      obj.createCheckoutSession = CreateCheckoutSessionRequest.toJSON(message.createCheckoutSession)
    }
    if (message.getSubscription !== undefined) {
      obj.getSubscription = GetSubscriptionRequest.toJSON(message.getSubscription)
    }
    if (message.openBillingPortal !== undefined) {
      obj.openBillingPortal = OpenBillingPortalRequest.toJSON(message.openBillingPortal)
    }
    if (message.getPlans !== undefined) {
      obj.getPlans = GetPlansRequest.toJSON(message.getPlans)
    }
    if (message.inviteToAccount !== undefined) {
      obj.inviteToAccount = InviteToAccountRequest.toJSON(message.inviteToAccount)
    }
    if (message.listAccountAccess !== undefined) {
      obj.listAccountAccess = ListAccountAccessRequest.toJSON(message.listAccountAccess)
    }
    if (message.revokeInvite !== undefined) {
      obj.revokeInvite = RevokeInviteRequest.toJSON(message.revokeInvite)
    }
    if (message.removeAccountAccess !== undefined) {
      obj.removeAccountAccess = RemoveAccountAccessRequest.toJSON(message.removeAccountAccess)
    }
    if (message.changeAccountRole !== undefined) {
      obj.changeAccountRole = ChangeAccountRoleRequest.toJSON(message.changeAccountRole)
    }
    if (message.leaveAccount !== undefined) {
      obj.leaveAccount = LeaveAccountRequest.toJSON(message.leaveAccount)
    }
    if (message.listMyInvites !== undefined) {
      obj.listMyInvites = ListMyInvitesRequest.toJSON(message.listMyInvites)
    }
    if (message.respondToInvite !== undefined) {
      obj.respondToInvite = RespondToInviteRequest.toJSON(message.respondToInvite)
    }
    if (message.transferAccountOwnership !== undefined) {
      obj.transferAccountOwnership = TransferAccountOwnershipRequest.toJSON(
        message.transferAccountOwnership
      )
    }
    if (message.cancelPendingAccount !== undefined) {
      obj.cancelPendingAccount = CancelPendingAccountRequest.toJSON(message.cancelPendingAccount)
    }
    if (message.orderPreview !== undefined) {
      obj.orderPreview = OrderPreviewRequest.toJSON(message.orderPreview)
    }
    if (message.changePassword !== undefined) {
      obj.changePassword = ChangePasswordRequest.toJSON(message.changePassword)
    }
    if (message.listSessions !== undefined) {
      obj.listSessions = ListSessionsRequest.toJSON(message.listSessions)
    }
    if (message.revokeSession !== undefined) {
      obj.revokeSession = RevokeSessionRequest.toJSON(message.revokeSession)
    }
    if (message.logout !== undefined) {
      obj.logout = LogoutRequest.toJSON(message.logout)
    }
    if (message.revokeAllOtherSessions !== undefined) {
      obj.revokeAllOtherSessions = RevokeAllOtherSessionsRequest.toJSON(
        message.revokeAllOtherSessions
      )
    }
    if (message.sendStepUpCode !== undefined) {
      obj.sendStepUpCode = SendStepUpCodeRequest.toJSON(message.sendStepUpCode)
    }
    if (message.orderbookMetricsSeries !== undefined) {
      obj.orderbookMetricsSeries = OrderbookMetricsSeriesRequest.toJSON(
        message.orderbookMetricsSeries
      )
    }
    if (message.optionsTradesHistory !== undefined) {
      obj.optionsTradesHistory = OptionsTradesHistoryRequest.toJSON(message.optionsTradesHistory)
    }
    if (message.masterInstrumentList !== undefined) {
      obj.masterInstrumentList = MasterInstrumentListRequest.toJSON(message.masterInstrumentList)
    }
    if (message.impliedMove !== undefined) {
      obj.impliedMove = GetImpliedMoveRequest.toJSON(message.impliedMove)
    }
    if (message.ivPercentile !== undefined) {
      obj.ivPercentile = GetIvPercentileRequest.toJSON(message.ivPercentile)
    }
    if (message.maxPain !== undefined) {
      obj.maxPain = GetMaxPainRequest.toJSON(message.maxPain)
    }
    if (message.greeksByExpiry !== undefined) {
      obj.greeksByExpiry = GetGreeksByExpiryRequest.toJSON(message.greeksByExpiry)
    }
    if (message.generateWatchlist !== undefined) {
      obj.generateWatchlist = GenerateWatchlistRequest.toJSON(message.generateWatchlist)
    }
    if (message.hyperliquidListSubaccounts !== undefined) {
      obj.hyperliquidListSubaccounts = HyperliquidListSubaccountsRequest.toJSON(
        message.hyperliquidListSubaccounts
      )
    }
    if (message.hyperliquidLinkSubaccounts !== undefined) {
      obj.hyperliquidLinkSubaccounts = HyperliquidLinkSubaccountsRequest.toJSON(
        message.hyperliquidLinkSubaccounts
      )
    }
    if (message.batchOrderPreview !== undefined) {
      obj.batchOrderPreview = BatchOrderPreviewRequest.toJSON(message.batchOrderPreview)
    }
    if (message.visibleRangeProfile !== undefined) {
      obj.visibleRangeProfile = VisibleRangeProfileRequest.toJSON(message.visibleRangeProfile)
    }
    if (message.getTwitterPostHistory !== undefined) {
      obj.getTwitterPostHistory = GetTwitterPostHistoryRequest.toJSON(message.getTwitterPostHistory)
    }
    if (message.lighterPrepareIntegratorConsent !== undefined) {
      obj.lighterPrepareIntegratorConsent = LighterPrepareIntegratorConsentRequest.toJSON(
        message.lighterPrepareIntegratorConsent
      )
    }
    if (message.lighterConfirmIntegratorConsent !== undefined) {
      obj.lighterConfirmIntegratorConsent = LighterConfirmIntegratorConsentRequest.toJSON(
        message.lighterConfirmIntegratorConsent
      )
    }
    if (message.etfFundFlows !== undefined) {
      obj.etfFundFlows = EtfFundFlowsRequest.toJSON(message.etfFundFlows)
    }
    if (message.fedwatchProbabilities !== undefined) {
      obj.fedwatchProbabilities = FedwatchProbabilitiesRequest.toJSON(message.fedwatchProbabilities)
    }
    if (message.getCoinmarketcalEvents !== undefined) {
      obj.getCoinmarketcalEvents = GetCoinMarketCalEventsRequest.toJSON(
        message.getCoinmarketcalEvents
      )
    }
    if (message.optionsStrikeFlow !== undefined) {
      obj.optionsStrikeFlow = OptionsStrikeFlowRequest.toJSON(message.optionsStrikeFlow)
    }
    if (message.gexAggregate !== undefined) {
      obj.gexAggregate = GetGexAggregateRequest.toJSON(message.gexAggregate)
    }
    if (message.economicData !== undefined) {
      obj.economicData = EconomicDataRequest.toJSON(message.economicData)
    }
    if (message.mintMessagingLinkNonce !== undefined) {
      obj.mintMessagingLinkNonce = MintMessagingLinkNonceRequest.toJSON(
        message.mintMessagingLinkNonce
      )
    }
    if (message.getTokenUnlocks !== undefined) {
      obj.getTokenUnlocks = GetTokenUnlocksRequest.toJSON(message.getTokenUnlocks)
    }
    if (message.getTokenEmission !== undefined) {
      obj.getTokenEmission = GetTokenEmissionRequest.toJSON(message.getTokenEmission)
    }
    if (message.paradigmConnectDesk !== undefined) {
      obj.paradigmConnectDesk = ParadigmConnectDeskRequest.toJSON(message.paradigmConnectDesk)
    }
    if (message.paradigmListAccounts !== undefined) {
      obj.paradigmListAccounts = ParadigmListAccountsRequest.toJSON(message.paradigmListAccounts)
    }
    if (message.paradigmLinkAccount !== undefined) {
      obj.paradigmLinkAccount = ParadigmLinkAccountRequest.toJSON(message.paradigmLinkAccount)
    }
    if (message.paradigmDisconnect !== undefined) {
      obj.paradigmDisconnect = ParadigmDisconnectRequest.toJSON(message.paradigmDisconnect)
    }
    if (message.createSharedLayout !== undefined) {
      obj.createSharedLayout = CreateSharedLayoutRequest.toJSON(message.createSharedLayout)
    }
    if (message.getSharedLayout !== undefined) {
      obj.getSharedLayout = GetSharedLayoutRequest.toJSON(message.getSharedLayout)
    }
    if (message.treeNewsHistory !== undefined) {
      obj.treeNewsHistory = TreeNewsHistoryRequest.toJSON(message.treeNewsHistory)
    }
    if (message.surfaceCurrencies !== undefined) {
      obj.surfaceCurrencies = GetSurfaceCurrenciesRequest.toJSON(message.surfaceCurrencies)
    }
    if (message.createApiKey !== undefined) {
      obj.createApiKey = CreateApiKeyRequest.toJSON(message.createApiKey)
    }
    if (message.listApiKeys !== undefined) {
      obj.listApiKeys = ListApiKeysRequest.toJSON(message.listApiKeys)
    }
    if (message.revokeApiKey !== undefined) {
      obj.revokeApiKey = RevokeApiKeyRequest.toJSON(message.revokeApiKey)
    }
    if (message.getApiBilling !== undefined) {
      obj.getApiBilling = GetApiBillingRequest.toJSON(message.getApiBilling)
    }
    if (message.updateApiBillingSettings !== undefined) {
      obj.updateApiBillingSettings = UpdateApiBillingSettingsRequest.toJSON(
        message.updateApiBillingSettings
      )
    }
    if (message.createCreditCheckoutSession !== undefined) {
      obj.createCreditCheckoutSession = CreateCreditCheckoutSessionRequest.toJSON(
        message.createCreditCheckoutSession
      )
    }
    if (message.listCreditLedger !== undefined) {
      obj.listCreditLedger = ListCreditLedgerRequest.toJSON(message.listCreditLedger)
    }
    if (message.getCreditSpendStats !== undefined) {
      obj.getCreditSpendStats = GetCreditSpendStatsRequest.toJSON(message.getCreditSpendStats)
    }
    if (message.getMarketScreener !== undefined) {
      obj.getMarketScreener = GetMarketScreenerRequest.toJSON(message.getMarketScreener)
    }
    if (message.listVolFitReferences !== undefined) {
      obj.listVolFitReferences = ListVolFitReferencesRequest.toJSON(message.listVolFitReferences)
    }
    if (message.orderbookHeatmap !== undefined) {
      obj.orderbookHeatmap = OrderbookHeatmapRequest.toJSON(message.orderbookHeatmap)
    }
    if (message.sendRfqMakerQuote !== undefined) {
      obj.sendRfqMakerQuote = SendRfqMakerQuoteRequest.toJSON(message.sendRfqMakerQuote)
    }
    if (message.cancelRfqMakerQuote !== undefined) {
      obj.cancelRfqMakerQuote = CancelRfqMakerQuoteRequest.toJSON(message.cancelRfqMakerQuote)
    }
    if (message.setLeverage !== undefined) {
      obj.setLeverage = SetLeverageRequest.toJSON(message.setLeverage)
    }
    if (message.papertradePrepareSessionKey !== undefined) {
      obj.papertradePrepareSessionKey = PapertradePrepareSessionKeyRequest.toJSON(
        message.papertradePrepareSessionKey
      )
    }
    if (message.papertradeConfirmSessionKey !== undefined) {
      obj.papertradeConfirmSessionKey = PapertradeConfirmSessionKeyRequest.toJSON(
        message.papertradeConfirmSessionKey
      )
    }
    if (message.papertradeDisconnect !== undefined) {
      obj.papertradeDisconnect = PapertradeDisconnectRequest.toJSON(message.papertradeDisconnect)
    }
    if (message.getAccountSettings !== undefined) {
      obj.getAccountSettings = GetAccountSettingsRequest.toJSON(message.getAccountSettings)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ApiRequest>, I>>(base?: I): ApiRequest {
    return ApiRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ApiRequest>, I>>(object: I): ApiRequest {
    const message = createBaseApiRequest()
    message.executionBatch =
      object.executionBatch !== undefined && object.executionBatch !== null
        ? ExecutionBatch.fromPartial(object.executionBatch)
        : undefined
    message.login =
      object.login !== undefined && object.login !== null
        ? LoginRequest.fromPartial(object.login)
        : undefined
    message.signup =
      object.signup !== undefined && object.signup !== null
        ? SignupRequest.fromPartial(object.signup)
        : undefined
    message.createAccount =
      object.createAccount !== undefined && object.createAccount !== null
        ? CreateAccountRequest.fromPartial(object.createAccount)
        : undefined
    message.getUserAccounts =
      object.getUserAccounts !== undefined && object.getUserAccounts !== null
        ? GetUserAccountsRequest.fromPartial(object.getUserAccounts)
        : undefined
    message.requestPasswordReset =
      object.requestPasswordReset !== undefined && object.requestPasswordReset !== null
        ? RequestPasswordResetRequest.fromPartial(object.requestPasswordReset)
        : undefined
    message.confirmPasswordReset =
      object.confirmPasswordReset !== undefined && object.confirmPasswordReset !== null
        ? ConfirmPasswordResetRequest.fromPartial(object.confirmPasswordReset)
        : undefined
    message.refreshToken =
      object.refreshToken !== undefined && object.refreshToken !== null
        ? RefreshTokenRequest.fromPartial(object.refreshToken)
        : undefined
    message.verifyEmail =
      object.verifyEmail !== undefined && object.verifyEmail !== null
        ? VerifyEmailRequest.fromPartial(object.verifyEmail)
        : undefined
    message.resendVerification =
      object.resendVerification !== undefined && object.resendVerification !== null
        ? ResendVerificationRequest.fromPartial(object.resendVerification)
        : undefined
    message.verify =
      object.verify !== undefined && object.verify !== null
        ? VerifyTokenRequest.fromPartial(object.verify)
        : undefined
    message.setup2fa =
      object.setup2fa !== undefined && object.setup2fa !== null
        ? Setup2faRequest.fromPartial(object.setup2fa)
        : undefined
    message.confirm2faSetup =
      object.confirm2faSetup !== undefined && object.confirm2faSetup !== null
        ? Confirm2faSetupRequest.fromPartial(object.confirm2faSetup)
        : undefined
    message.verify2fa =
      object.verify2fa !== undefined && object.verify2fa !== null
        ? Verify2faRequest.fromPartial(object.verify2fa)
        : undefined
    message.verify2faLogin =
      object.verify2faLogin !== undefined && object.verify2faLogin !== null
        ? Verify2faLoginRequest.fromPartial(object.verify2faLogin)
        : undefined
    message.disable2fa =
      object.disable2fa !== undefined && object.disable2fa !== null
        ? Disable2faRequest.fromPartial(object.disable2fa)
        : undefined
    message.get2faBackupCodes =
      object.get2faBackupCodes !== undefined && object.get2faBackupCodes !== null
        ? Get2faBackupCodesRequest.fromPartial(object.get2faBackupCodes)
        : undefined
    message.setupPasskey =
      object.setupPasskey !== undefined && object.setupPasskey !== null
        ? SetupPasskeyRequest.fromPartial(object.setupPasskey)
        : undefined
    message.confirmPasskeySetup =
      object.confirmPasskeySetup !== undefined && object.confirmPasskeySetup !== null
        ? ConfirmPasskeySetupRequest.fromPartial(object.confirmPasskeySetup)
        : undefined
    message.passkeyLogin =
      object.passkeyLogin !== undefined && object.passkeyLogin !== null
        ? PasskeyLoginRequest.fromPartial(object.passkeyLogin)
        : undefined
    message.confirmPasskeyLogin =
      object.confirmPasskeyLogin !== undefined && object.confirmPasskeyLogin !== null
        ? ConfirmPasskeyLoginRequest.fromPartial(object.confirmPasskeyLogin)
        : undefined
    message.deletePasskey =
      object.deletePasskey !== undefined && object.deletePasskey !== null
        ? DeletePasskeyRequest.fromPartial(object.deletePasskey)
        : undefined
    message.getUserPasskeys =
      object.getUserPasskeys !== undefined && object.getUserPasskeys !== null
        ? GetUserPasskeysRequest.fromPartial(object.getUserPasskeys)
        : undefined
    message.googleLogin =
      object.googleLogin !== undefined && object.googleLogin !== null
        ? GoogleLoginRequest.fromPartial(object.googleLogin)
        : undefined
    message.chartData =
      object.chartData !== undefined && object.chartData !== null
        ? ChartDataRequest.fromPartial(object.chartData)
        : undefined
    message.portfolioLineChart =
      object.portfolioLineChart !== undefined && object.portfolioLineChart !== null
        ? PortfolioLineChartRequest.fromPartial(object.portfolioLineChart)
        : undefined
    message.time =
      object.time !== undefined && object.time !== null ? Time.fromPartial(object.time) : undefined
    message.updateAccount =
      object.updateAccount !== undefined && object.updateAccount !== null
        ? UpdateAccountRequest.fromPartial(object.updateAccount)
        : undefined
    message.instrumentList =
      object.instrumentList !== undefined && object.instrumentList !== null
        ? InstrumentListRequest.fromPartial(object.instrumentList)
        : undefined
    message.orderHistory =
      object.orderHistory !== undefined && object.orderHistory !== null
        ? HistoryRequest.fromPartial(object.orderHistory)
        : undefined
    message.tradeHistory =
      object.tradeHistory !== undefined && object.tradeHistory !== null
        ? HistoryRequest.fromPartial(object.tradeHistory)
        : undefined
    message.createPage =
      object.createPage !== undefined && object.createPage !== null
        ? CreatePageRequest.fromPartial(object.createPage)
        : undefined
    message.getPages =
      object.getPages !== undefined && object.getPages !== null
        ? GetPagesRequest.fromPartial(object.getPages)
        : undefined
    message.getPageLayout =
      object.getPageLayout !== undefined && object.getPageLayout !== null
        ? GetPageLayoutRequest.fromPartial(object.getPageLayout)
        : undefined
    message.updatePageMeta =
      object.updatePageMeta !== undefined && object.updatePageMeta !== null
        ? UpdatePageMetaRequest.fromPartial(object.updatePageMeta)
        : undefined
    message.deletePage =
      object.deletePage !== undefined && object.deletePage !== null
        ? DeletePageRequest.fromPartial(object.deletePage)
        : undefined
    message.addWidget =
      object.addWidget !== undefined && object.addWidget !== null
        ? AddWidgetRequest.fromPartial(object.addWidget)
        : undefined
    message.updateWidget =
      object.updateWidget !== undefined && object.updateWidget !== null
        ? UpdateWidgetRequest.fromPartial(object.updateWidget)
        : undefined
    message.removeWidget =
      object.removeWidget !== undefined && object.removeWidget !== null
        ? RemoveWidgetRequest.fromPartial(object.removeWidget)
        : undefined
    message.saveComponentPreference =
      object.saveComponentPreference !== undefined && object.saveComponentPreference !== null
        ? SaveComponentPreferenceRequest.fromPartial(object.saveComponentPreference)
        : undefined
    message.getComponentPreference =
      object.getComponentPreference !== undefined && object.getComponentPreference !== null
        ? GetComponentPreferenceRequest.fromPartial(object.getComponentPreference)
        : undefined
    message.createPositionGroup =
      object.createPositionGroup !== undefined && object.createPositionGroup !== null
        ? CreatePositionGroupRequest.fromPartial(object.createPositionGroup)
        : undefined
    message.updatePositionGroup =
      object.updatePositionGroup !== undefined && object.updatePositionGroup !== null
        ? UpdatePositionGroupRequest.fromPartial(object.updatePositionGroup)
        : undefined
    message.deletePositionGroup =
      object.deletePositionGroup !== undefined && object.deletePositionGroup !== null
        ? DeletePositionGroupRequest.fromPartial(object.deletePositionGroup)
        : undefined
    message.getPositionsView =
      object.getPositionsView !== undefined && object.getPositionsView !== null
        ? GetPositionsViewRequest.fromPartial(object.getPositionsView)
        : undefined
    message.getPositionGroups =
      object.getPositionGroups !== undefined && object.getPositionGroups !== null
        ? GetPositionGroupsRequest.fromPartial(object.getPositionGroups)
        : undefined
    message.reorderPositionsView =
      object.reorderPositionsView !== undefined && object.reorderPositionsView !== null
        ? ReorderPositionsViewRequest.fromPartial(object.reorderPositionsView)
        : undefined
    message.setPositionGroupOrder =
      object.setPositionGroupOrder !== undefined && object.setPositionGroupOrder !== null
        ? SetPositionGroupOrderRequest.fromPartial(object.setPositionGroupOrder)
        : undefined
    message.generateVolSurface =
      object.generateVolSurface !== undefined && object.generateVolSurface !== null
        ? GenerateVolSurfaceRequest.fromPartial(object.generateVolSurface)
        : undefined
    message.riskSimulation =
      object.riskSimulation !== undefined && object.riskSimulation !== null
        ? RiskSimulationRequest.fromPartial(object.riskSimulation)
        : undefined
    message.economicCalendarHistory =
      object.economicCalendarHistory !== undefined && object.economicCalendarHistory !== null
        ? EconomicCalendarHistoryRequest.fromPartial(object.economicCalendarHistory)
        : undefined
    message.executionAnalytics =
      object.executionAnalytics !== undefined && object.executionAnalytics !== null
        ? ExecutionAnalyticsRequest.fromPartial(object.executionAnalytics)
        : undefined
    message.getVenues =
      object.getVenues !== undefined && object.getVenues !== null
        ? GetVenuesRequest.fromPartial(object.getVenues)
        : undefined
    message.getExchanges =
      object.getExchanges !== undefined && object.getExchanges !== null
        ? GetExchangesRequest.fromPartial(object.getExchanges)
        : undefined
    message.getOrdersForAlgo =
      object.getOrdersForAlgo !== undefined && object.getOrdersForAlgo !== null
        ? GetOrdersForAlgoRequest.fromPartial(object.getOrdersForAlgo)
        : undefined
    message.getTradesForOrder =
      object.getTradesForOrder !== undefined && object.getTradesForOrder !== null
        ? GetTradesForOrderRequest.fromPartial(object.getTradesForOrder)
        : undefined
    message.getOrderStateHistory =
      object.getOrderStateHistory !== undefined && object.getOrderStateHistory !== null
        ? GetOrderStateHistoryRequest.fromPartial(object.getOrderStateHistory)
        : undefined
    message.getTradesForAlgo =
      object.getTradesForAlgo !== undefined && object.getTradesForAlgo !== null
        ? GetTradesForAlgoRequest.fromPartial(object.getTradesForAlgo)
        : undefined
    message.getAnalyticSnapshot =
      object.getAnalyticSnapshot !== undefined && object.getAnalyticSnapshot !== null
        ? GetAnalyticSnapshotRequest.fromPartial(object.getAnalyticSnapshot)
        : undefined
    message.getAnalyticRange =
      object.getAnalyticRange !== undefined && object.getAnalyticRange !== null
        ? GetAnalyticRangeRequest.fromPartial(object.getAnalyticRange)
        : undefined
    message.optionsVolumeLeaderboard =
      object.optionsVolumeLeaderboard !== undefined && object.optionsVolumeLeaderboard !== null
        ? GetOptionsVolumeLeaderboardRequest.fromPartial(object.optionsVolumeLeaderboard)
        : undefined
    message.optionsVolumeSeries =
      object.optionsVolumeSeries !== undefined && object.optionsVolumeSeries !== null
        ? OptionsVolumeSeriesRequest.fromPartial(object.optionsVolumeSeries)
        : undefined
    message.optionsOiSeries =
      object.optionsOiSeries !== undefined && object.optionsOiSeries !== null
        ? OptionsOiSeriesRequest.fromPartial(object.optionsOiSeries)
        : undefined
    message.optionsOiLeaderboard =
      object.optionsOiLeaderboard !== undefined && object.optionsOiLeaderboard !== null
        ? GetOptionsOiLeaderboardRequest.fromPartial(object.optionsOiLeaderboard)
        : undefined
    message.optionsOiByStrike =
      object.optionsOiByStrike !== undefined && object.optionsOiByStrike !== null
        ? GetOptionsOiByStrikeRequest.fromPartial(object.optionsOiByStrike)
        : undefined
    message.fundingSeries =
      object.fundingSeries !== undefined && object.fundingSeries !== null
        ? GetFundingSeriesRequest.fromPartial(object.fundingSeries)
        : undefined
    message.fundingLeaderboard =
      object.fundingLeaderboard !== undefined && object.fundingLeaderboard !== null
        ? GetFundingLeaderboardRequest.fromPartial(object.fundingLeaderboard)
        : undefined
    message.createPreset =
      object.createPreset !== undefined && object.createPreset !== null
        ? CreatePresetRequest.fromPartial(object.createPreset)
        : undefined
    message.updatePreset =
      object.updatePreset !== undefined && object.updatePreset !== null
        ? UpdatePresetRequest.fromPartial(object.updatePreset)
        : undefined
    message.deletePreset =
      object.deletePreset !== undefined && object.deletePreset !== null
        ? DeletePresetRequest.fromPartial(object.deletePreset)
        : undefined
    message.listPresets =
      object.listPresets !== undefined && object.listPresets !== null
        ? ListPresetsRequest.fromPartial(object.listPresets)
        : undefined
    message.executePreset =
      object.executePreset !== undefined && object.executePreset !== null
        ? ExecutePresetRequest.fromPartial(object.executePreset)
        : undefined
    message.getPreset =
      object.getPreset !== undefined && object.getPreset !== null
        ? GetPresetRequest.fromPartial(object.getPreset)
        : undefined
    message.createWatchlist =
      object.createWatchlist !== undefined && object.createWatchlist !== null
        ? CreateWatchlistRequest.fromPartial(object.createWatchlist)
        : undefined
    message.getWatchlists =
      object.getWatchlists !== undefined && object.getWatchlists !== null
        ? GetWatchlistsRequest.fromPartial(object.getWatchlists)
        : undefined
    message.setWatchlist =
      object.setWatchlist !== undefined && object.setWatchlist !== null
        ? SetWatchlistRequest.fromPartial(object.setWatchlist)
        : undefined
    message.renameWatchlist =
      object.renameWatchlist !== undefined && object.renameWatchlist !== null
        ? RenameWatchlistRequest.fromPartial(object.renameWatchlist)
        : undefined
    message.deleteWatchlist =
      object.deleteWatchlist !== undefined && object.deleteWatchlist !== null
        ? DeleteWatchlistRequest.fromPartial(object.deleteWatchlist)
        : undefined
    message.reorderWatchlists =
      object.reorderWatchlists !== undefined && object.reorderWatchlists !== null
        ? ReorderWatchlistsRequest.fromPartial(object.reorderWatchlists)
        : undefined
    message.dbNewsHistory =
      object.dbNewsHistory !== undefined && object.dbNewsHistory !== null
        ? DbNewsHistoryRequest.fromPartial(object.dbNewsHistory)
        : undefined
    message.alpacaNewsHistory =
      object.alpacaNewsHistory !== undefined && object.alpacaNewsHistory !== null
        ? AlpacaNewsHistoryRequest.fromPartial(object.alpacaNewsHistory)
        : undefined
    message.intentCompiler =
      object.intentCompiler !== undefined && object.intentCompiler !== null
        ? TradeIntent.fromPartial(object.intentCompiler)
        : undefined
    message.confirmExecutionPlan =
      object.confirmExecutionPlan !== undefined && object.confirmExecutionPlan !== null
        ? ConfirmExecutionPlanRequest.fromPartial(object.confirmExecutionPlan)
        : undefined
    message.getDbNewsVocabulary =
      object.getDbNewsVocabulary !== undefined && object.getDbNewsVocabulary !== null
        ? GetDbNewsVocabularyRequest.fromPartial(object.getDbNewsVocabulary)
        : undefined
    message.testIntentCompiler =
      object.testIntentCompiler !== undefined && object.testIntentCompiler !== null
        ? TestIntentCompilerRequest.fromPartial(object.testIntentCompiler)
        : undefined
    message.getVenueStatus =
      object.getVenueStatus !== undefined && object.getVenueStatus !== null
        ? GetVenueStatus.fromPartial(object.getVenueStatus)
        : undefined
    message.getVenueSchedules =
      object.getVenueSchedules !== undefined && object.getVenueSchedules !== null
        ? GetVenueSchedules.fromPartial(object.getVenueSchedules)
        : undefined
    message.createRfq =
      object.createRfq !== undefined && object.createRfq !== null
        ? CreateRfqRequest.fromPartial(object.createRfq)
        : undefined
    message.cancelRfq =
      object.cancelRfq !== undefined && object.cancelRfq !== null
        ? CancelRfqRequest.fromPartial(object.cancelRfq)
        : undefined
    message.acceptRfqQuote =
      object.acceptRfqQuote !== undefined && object.acceptRfqQuote !== null
        ? AcceptRfqQuoteRequest.fromPartial(object.acceptRfqQuote)
        : undefined
    message.getRfqMakers =
      object.getRfqMakers !== undefined && object.getRfqMakers !== null
        ? GetRfqMakersRequest.fromPartial(object.getRfqMakers)
        : undefined
    message.getRfqHistory =
      object.getRfqHistory !== undefined && object.getRfqHistory !== null
        ? GetRfqHistoryRequest.fromPartial(object.getRfqHistory)
        : undefined
    message.rfqAnalytics =
      object.rfqAnalytics !== undefined && object.rfqAnalytics !== null
        ? RfqAnalyticsRequest.fromPartial(object.rfqAnalytics)
        : undefined
    message.bybitOauthMintState =
      object.bybitOauthMintState !== undefined && object.bybitOauthMintState !== null
        ? BybitOauthMintStateRequest.fromPartial(object.bybitOauthMintState)
        : undefined
    message.bybitOauthExchangeCode =
      object.bybitOauthExchangeCode !== undefined && object.bybitOauthExchangeCode !== null
        ? BybitOauthExchangeCodeRequest.fromPartial(object.bybitOauthExchangeCode)
        : undefined
    message.deribitOauthMintState =
      object.deribitOauthMintState !== undefined && object.deribitOauthMintState !== null
        ? DeribitOauthMintStateRequest.fromPartial(object.deribitOauthMintState)
        : undefined
    message.deribitOauthExchangeCode =
      object.deribitOauthExchangeCode !== undefined && object.deribitOauthExchangeCode !== null
        ? DeribitOauthExchangeCodeRequest.fromPartial(object.deribitOauthExchangeCode)
        : undefined
    message.hyperliquidPrepareAgent =
      object.hyperliquidPrepareAgent !== undefined && object.hyperliquidPrepareAgent !== null
        ? HyperliquidPrepareAgentRequest.fromPartial(object.hyperliquidPrepareAgent)
        : undefined
    message.hyperliquidConfirmAgent =
      object.hyperliquidConfirmAgent !== undefined && object.hyperliquidConfirmAgent !== null
        ? HyperliquidConfirmAgentRequest.fromPartial(object.hyperliquidConfirmAgent)
        : undefined
    message.hyperliquidDisconnectAgent =
      object.hyperliquidDisconnectAgent !== undefined && object.hyperliquidDisconnectAgent !== null
        ? HyperliquidDisconnectAgentRequest.fromPartial(object.hyperliquidDisconnectAgent)
        : undefined
    message.derivePrepareSessionKey =
      object.derivePrepareSessionKey !== undefined && object.derivePrepareSessionKey !== null
        ? DerivePrepareSessionKeyRequest.fromPartial(object.derivePrepareSessionKey)
        : undefined
    message.deriveConfirmSessionKey =
      object.deriveConfirmSessionKey !== undefined && object.deriveConfirmSessionKey !== null
        ? DeriveConfirmSessionKeyRequest.fromPartial(object.deriveConfirmSessionKey)
        : undefined
    message.deriveDisconnect =
      object.deriveDisconnect !== undefined && object.deriveDisconnect !== null
        ? DeriveDisconnectRequest.fromPartial(object.deriveDisconnect)
        : undefined
    message.deriveListSubaccounts =
      object.deriveListSubaccounts !== undefined && object.deriveListSubaccounts !== null
        ? DeriveListSubaccountsRequest.fromPartial(object.deriveListSubaccounts)
        : undefined
    message.deriveLinkSubaccounts =
      object.deriveLinkSubaccounts !== undefined && object.deriveLinkSubaccounts !== null
        ? DeriveLinkSubaccountsRequest.fromPartial(object.deriveLinkSubaccounts)
        : undefined
    message.lighterListSubaccounts =
      object.lighterListSubaccounts !== undefined && object.lighterListSubaccounts !== null
        ? LighterListSubaccountsRequest.fromPartial(object.lighterListSubaccounts)
        : undefined
    message.lighterPrepareSubaccountKey =
      object.lighterPrepareSubaccountKey !== undefined &&
      object.lighterPrepareSubaccountKey !== null
        ? LighterPrepareSubaccountKeyRequest.fromPartial(object.lighterPrepareSubaccountKey)
        : undefined
    message.lighterConfirmSubaccountKey =
      object.lighterConfirmSubaccountKey !== undefined &&
      object.lighterConfirmSubaccountKey !== null
        ? LighterConfirmSubaccountKeyRequest.fromPartial(object.lighterConfirmSubaccountKey)
        : undefined
    message.lighterLinkSubaccounts =
      object.lighterLinkSubaccounts !== undefined && object.lighterLinkSubaccounts !== null
        ? LighterLinkSubaccountsRequest.fromPartial(object.lighterLinkSubaccounts)
        : undefined
    message.createCheckoutSession =
      object.createCheckoutSession !== undefined && object.createCheckoutSession !== null
        ? CreateCheckoutSessionRequest.fromPartial(object.createCheckoutSession)
        : undefined
    message.getSubscription =
      object.getSubscription !== undefined && object.getSubscription !== null
        ? GetSubscriptionRequest.fromPartial(object.getSubscription)
        : undefined
    message.openBillingPortal =
      object.openBillingPortal !== undefined && object.openBillingPortal !== null
        ? OpenBillingPortalRequest.fromPartial(object.openBillingPortal)
        : undefined
    message.getPlans =
      object.getPlans !== undefined && object.getPlans !== null
        ? GetPlansRequest.fromPartial(object.getPlans)
        : undefined
    message.inviteToAccount =
      object.inviteToAccount !== undefined && object.inviteToAccount !== null
        ? InviteToAccountRequest.fromPartial(object.inviteToAccount)
        : undefined
    message.listAccountAccess =
      object.listAccountAccess !== undefined && object.listAccountAccess !== null
        ? ListAccountAccessRequest.fromPartial(object.listAccountAccess)
        : undefined
    message.revokeInvite =
      object.revokeInvite !== undefined && object.revokeInvite !== null
        ? RevokeInviteRequest.fromPartial(object.revokeInvite)
        : undefined
    message.removeAccountAccess =
      object.removeAccountAccess !== undefined && object.removeAccountAccess !== null
        ? RemoveAccountAccessRequest.fromPartial(object.removeAccountAccess)
        : undefined
    message.changeAccountRole =
      object.changeAccountRole !== undefined && object.changeAccountRole !== null
        ? ChangeAccountRoleRequest.fromPartial(object.changeAccountRole)
        : undefined
    message.leaveAccount =
      object.leaveAccount !== undefined && object.leaveAccount !== null
        ? LeaveAccountRequest.fromPartial(object.leaveAccount)
        : undefined
    message.listMyInvites =
      object.listMyInvites !== undefined && object.listMyInvites !== null
        ? ListMyInvitesRequest.fromPartial(object.listMyInvites)
        : undefined
    message.respondToInvite =
      object.respondToInvite !== undefined && object.respondToInvite !== null
        ? RespondToInviteRequest.fromPartial(object.respondToInvite)
        : undefined
    message.transferAccountOwnership =
      object.transferAccountOwnership !== undefined && object.transferAccountOwnership !== null
        ? TransferAccountOwnershipRequest.fromPartial(object.transferAccountOwnership)
        : undefined
    message.cancelPendingAccount =
      object.cancelPendingAccount !== undefined && object.cancelPendingAccount !== null
        ? CancelPendingAccountRequest.fromPartial(object.cancelPendingAccount)
        : undefined
    message.orderPreview =
      object.orderPreview !== undefined && object.orderPreview !== null
        ? OrderPreviewRequest.fromPartial(object.orderPreview)
        : undefined
    message.changePassword =
      object.changePassword !== undefined && object.changePassword !== null
        ? ChangePasswordRequest.fromPartial(object.changePassword)
        : undefined
    message.listSessions =
      object.listSessions !== undefined && object.listSessions !== null
        ? ListSessionsRequest.fromPartial(object.listSessions)
        : undefined
    message.revokeSession =
      object.revokeSession !== undefined && object.revokeSession !== null
        ? RevokeSessionRequest.fromPartial(object.revokeSession)
        : undefined
    message.logout =
      object.logout !== undefined && object.logout !== null
        ? LogoutRequest.fromPartial(object.logout)
        : undefined
    message.revokeAllOtherSessions =
      object.revokeAllOtherSessions !== undefined && object.revokeAllOtherSessions !== null
        ? RevokeAllOtherSessionsRequest.fromPartial(object.revokeAllOtherSessions)
        : undefined
    message.sendStepUpCode =
      object.sendStepUpCode !== undefined && object.sendStepUpCode !== null
        ? SendStepUpCodeRequest.fromPartial(object.sendStepUpCode)
        : undefined
    message.orderbookMetricsSeries =
      object.orderbookMetricsSeries !== undefined && object.orderbookMetricsSeries !== null
        ? OrderbookMetricsSeriesRequest.fromPartial(object.orderbookMetricsSeries)
        : undefined
    message.optionsTradesHistory =
      object.optionsTradesHistory !== undefined && object.optionsTradesHistory !== null
        ? OptionsTradesHistoryRequest.fromPartial(object.optionsTradesHistory)
        : undefined
    message.masterInstrumentList =
      object.masterInstrumentList !== undefined && object.masterInstrumentList !== null
        ? MasterInstrumentListRequest.fromPartial(object.masterInstrumentList)
        : undefined
    message.impliedMove =
      object.impliedMove !== undefined && object.impliedMove !== null
        ? GetImpliedMoveRequest.fromPartial(object.impliedMove)
        : undefined
    message.ivPercentile =
      object.ivPercentile !== undefined && object.ivPercentile !== null
        ? GetIvPercentileRequest.fromPartial(object.ivPercentile)
        : undefined
    message.maxPain =
      object.maxPain !== undefined && object.maxPain !== null
        ? GetMaxPainRequest.fromPartial(object.maxPain)
        : undefined
    message.greeksByExpiry =
      object.greeksByExpiry !== undefined && object.greeksByExpiry !== null
        ? GetGreeksByExpiryRequest.fromPartial(object.greeksByExpiry)
        : undefined
    message.generateWatchlist =
      object.generateWatchlist !== undefined && object.generateWatchlist !== null
        ? GenerateWatchlistRequest.fromPartial(object.generateWatchlist)
        : undefined
    message.hyperliquidListSubaccounts =
      object.hyperliquidListSubaccounts !== undefined && object.hyperliquidListSubaccounts !== null
        ? HyperliquidListSubaccountsRequest.fromPartial(object.hyperliquidListSubaccounts)
        : undefined
    message.hyperliquidLinkSubaccounts =
      object.hyperliquidLinkSubaccounts !== undefined && object.hyperliquidLinkSubaccounts !== null
        ? HyperliquidLinkSubaccountsRequest.fromPartial(object.hyperliquidLinkSubaccounts)
        : undefined
    message.batchOrderPreview =
      object.batchOrderPreview !== undefined && object.batchOrderPreview !== null
        ? BatchOrderPreviewRequest.fromPartial(object.batchOrderPreview)
        : undefined
    message.visibleRangeProfile =
      object.visibleRangeProfile !== undefined && object.visibleRangeProfile !== null
        ? VisibleRangeProfileRequest.fromPartial(object.visibleRangeProfile)
        : undefined
    message.getTwitterPostHistory =
      object.getTwitterPostHistory !== undefined && object.getTwitterPostHistory !== null
        ? GetTwitterPostHistoryRequest.fromPartial(object.getTwitterPostHistory)
        : undefined
    message.lighterPrepareIntegratorConsent =
      object.lighterPrepareIntegratorConsent !== undefined &&
      object.lighterPrepareIntegratorConsent !== null
        ? LighterPrepareIntegratorConsentRequest.fromPartial(object.lighterPrepareIntegratorConsent)
        : undefined
    message.lighterConfirmIntegratorConsent =
      object.lighterConfirmIntegratorConsent !== undefined &&
      object.lighterConfirmIntegratorConsent !== null
        ? LighterConfirmIntegratorConsentRequest.fromPartial(object.lighterConfirmIntegratorConsent)
        : undefined
    message.etfFundFlows =
      object.etfFundFlows !== undefined && object.etfFundFlows !== null
        ? EtfFundFlowsRequest.fromPartial(object.etfFundFlows)
        : undefined
    message.fedwatchProbabilities =
      object.fedwatchProbabilities !== undefined && object.fedwatchProbabilities !== null
        ? FedwatchProbabilitiesRequest.fromPartial(object.fedwatchProbabilities)
        : undefined
    message.getCoinmarketcalEvents =
      object.getCoinmarketcalEvents !== undefined && object.getCoinmarketcalEvents !== null
        ? GetCoinMarketCalEventsRequest.fromPartial(object.getCoinmarketcalEvents)
        : undefined
    message.optionsStrikeFlow =
      object.optionsStrikeFlow !== undefined && object.optionsStrikeFlow !== null
        ? OptionsStrikeFlowRequest.fromPartial(object.optionsStrikeFlow)
        : undefined
    message.gexAggregate =
      object.gexAggregate !== undefined && object.gexAggregate !== null
        ? GetGexAggregateRequest.fromPartial(object.gexAggregate)
        : undefined
    message.economicData =
      object.economicData !== undefined && object.economicData !== null
        ? EconomicDataRequest.fromPartial(object.economicData)
        : undefined
    message.mintMessagingLinkNonce =
      object.mintMessagingLinkNonce !== undefined && object.mintMessagingLinkNonce !== null
        ? MintMessagingLinkNonceRequest.fromPartial(object.mintMessagingLinkNonce)
        : undefined
    message.getTokenUnlocks =
      object.getTokenUnlocks !== undefined && object.getTokenUnlocks !== null
        ? GetTokenUnlocksRequest.fromPartial(object.getTokenUnlocks)
        : undefined
    message.getTokenEmission =
      object.getTokenEmission !== undefined && object.getTokenEmission !== null
        ? GetTokenEmissionRequest.fromPartial(object.getTokenEmission)
        : undefined
    message.paradigmConnectDesk =
      object.paradigmConnectDesk !== undefined && object.paradigmConnectDesk !== null
        ? ParadigmConnectDeskRequest.fromPartial(object.paradigmConnectDesk)
        : undefined
    message.paradigmListAccounts =
      object.paradigmListAccounts !== undefined && object.paradigmListAccounts !== null
        ? ParadigmListAccountsRequest.fromPartial(object.paradigmListAccounts)
        : undefined
    message.paradigmLinkAccount =
      object.paradigmLinkAccount !== undefined && object.paradigmLinkAccount !== null
        ? ParadigmLinkAccountRequest.fromPartial(object.paradigmLinkAccount)
        : undefined
    message.paradigmDisconnect =
      object.paradigmDisconnect !== undefined && object.paradigmDisconnect !== null
        ? ParadigmDisconnectRequest.fromPartial(object.paradigmDisconnect)
        : undefined
    message.createSharedLayout =
      object.createSharedLayout !== undefined && object.createSharedLayout !== null
        ? CreateSharedLayoutRequest.fromPartial(object.createSharedLayout)
        : undefined
    message.getSharedLayout =
      object.getSharedLayout !== undefined && object.getSharedLayout !== null
        ? GetSharedLayoutRequest.fromPartial(object.getSharedLayout)
        : undefined
    message.treeNewsHistory =
      object.treeNewsHistory !== undefined && object.treeNewsHistory !== null
        ? TreeNewsHistoryRequest.fromPartial(object.treeNewsHistory)
        : undefined
    message.surfaceCurrencies =
      object.surfaceCurrencies !== undefined && object.surfaceCurrencies !== null
        ? GetSurfaceCurrenciesRequest.fromPartial(object.surfaceCurrencies)
        : undefined
    message.createApiKey =
      object.createApiKey !== undefined && object.createApiKey !== null
        ? CreateApiKeyRequest.fromPartial(object.createApiKey)
        : undefined
    message.listApiKeys =
      object.listApiKeys !== undefined && object.listApiKeys !== null
        ? ListApiKeysRequest.fromPartial(object.listApiKeys)
        : undefined
    message.revokeApiKey =
      object.revokeApiKey !== undefined && object.revokeApiKey !== null
        ? RevokeApiKeyRequest.fromPartial(object.revokeApiKey)
        : undefined
    message.getApiBilling =
      object.getApiBilling !== undefined && object.getApiBilling !== null
        ? GetApiBillingRequest.fromPartial(object.getApiBilling)
        : undefined
    message.updateApiBillingSettings =
      object.updateApiBillingSettings !== undefined && object.updateApiBillingSettings !== null
        ? UpdateApiBillingSettingsRequest.fromPartial(object.updateApiBillingSettings)
        : undefined
    message.createCreditCheckoutSession =
      object.createCreditCheckoutSession !== undefined &&
      object.createCreditCheckoutSession !== null
        ? CreateCreditCheckoutSessionRequest.fromPartial(object.createCreditCheckoutSession)
        : undefined
    message.listCreditLedger =
      object.listCreditLedger !== undefined && object.listCreditLedger !== null
        ? ListCreditLedgerRequest.fromPartial(object.listCreditLedger)
        : undefined
    message.getCreditSpendStats =
      object.getCreditSpendStats !== undefined && object.getCreditSpendStats !== null
        ? GetCreditSpendStatsRequest.fromPartial(object.getCreditSpendStats)
        : undefined
    message.getMarketScreener =
      object.getMarketScreener !== undefined && object.getMarketScreener !== null
        ? GetMarketScreenerRequest.fromPartial(object.getMarketScreener)
        : undefined
    message.listVolFitReferences =
      object.listVolFitReferences !== undefined && object.listVolFitReferences !== null
        ? ListVolFitReferencesRequest.fromPartial(object.listVolFitReferences)
        : undefined
    message.orderbookHeatmap =
      object.orderbookHeatmap !== undefined && object.orderbookHeatmap !== null
        ? OrderbookHeatmapRequest.fromPartial(object.orderbookHeatmap)
        : undefined
    message.sendRfqMakerQuote =
      object.sendRfqMakerQuote !== undefined && object.sendRfqMakerQuote !== null
        ? SendRfqMakerQuoteRequest.fromPartial(object.sendRfqMakerQuote)
        : undefined
    message.cancelRfqMakerQuote =
      object.cancelRfqMakerQuote !== undefined && object.cancelRfqMakerQuote !== null
        ? CancelRfqMakerQuoteRequest.fromPartial(object.cancelRfqMakerQuote)
        : undefined
    message.setLeverage =
      object.setLeverage !== undefined && object.setLeverage !== null
        ? SetLeverageRequest.fromPartial(object.setLeverage)
        : undefined
    message.papertradePrepareSessionKey =
      object.papertradePrepareSessionKey !== undefined &&
      object.papertradePrepareSessionKey !== null
        ? PapertradePrepareSessionKeyRequest.fromPartial(object.papertradePrepareSessionKey)
        : undefined
    message.papertradeConfirmSessionKey =
      object.papertradeConfirmSessionKey !== undefined &&
      object.papertradeConfirmSessionKey !== null
        ? PapertradeConfirmSessionKeyRequest.fromPartial(object.papertradeConfirmSessionKey)
        : undefined
    message.papertradeDisconnect =
      object.papertradeDisconnect !== undefined && object.papertradeDisconnect !== null
        ? PapertradeDisconnectRequest.fromPartial(object.papertradeDisconnect)
        : undefined
    message.getAccountSettings =
      object.getAccountSettings !== undefined && object.getAccountSettings !== null
        ? GetAccountSettingsRequest.fromPartial(object.getAccountSettings)
        : undefined
    return message
  },
}

function createBaseGetAnalyticSnapshotRequest(): GetAnalyticSnapshotRequest {
  return { exchange: 0, symbol: '', analyticsType: 0 }
}

export const GetAnalyticSnapshotRequest: MessageFns<GetAnalyticSnapshotRequest> = {
  encode(
    message: GetAnalyticSnapshotRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.analyticsType !== 0) {
      writer.uint32(24).int32(message.analyticsType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAnalyticSnapshotRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetAnalyticSnapshotRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.analyticsType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetAnalyticSnapshotRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      analyticsType: isSet(object.analyticsType)
        ? analyticsTypeFromJSON(object.analyticsType)
        : isSet(object.analytics_type)
          ? analyticsTypeFromJSON(object.analytics_type)
          : 0,
    }
  },

  toJSON(message: GetAnalyticSnapshotRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.analyticsType !== 0) {
      obj.analyticsType = analyticsTypeToJSON(message.analyticsType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetAnalyticSnapshotRequest>, I>>(
    base?: I
  ): GetAnalyticSnapshotRequest {
    return GetAnalyticSnapshotRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetAnalyticSnapshotRequest>, I>>(
    object: I
  ): GetAnalyticSnapshotRequest {
    const message = createBaseGetAnalyticSnapshotRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.analyticsType = object.analyticsType ?? 0
    return message
  },
}

function createBaseGetAnalyticRangeRequest(): GetAnalyticRangeRequest {
  return {
    exchange: 0,
    symbol: '',
    analyticsType: 0,
    from: undefined,
    to: undefined,
    limit: undefined,
    sviSourceKind: undefined,
  }
}

export const GetAnalyticRangeRequest: MessageFns<GetAnalyticRangeRequest> = {
  encode(
    message: GetAnalyticRangeRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.analyticsType !== 0) {
      writer.uint32(24).int32(message.analyticsType)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    if (message.sviSourceKind !== undefined) {
      writer.uint32(56).int32(message.sviSourceKind)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAnalyticRangeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetAnalyticRangeRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.analyticsType = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.sviSourceKind = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetAnalyticRangeRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      analyticsType: isSet(object.analyticsType)
        ? analyticsTypeFromJSON(object.analyticsType)
        : isSet(object.analytics_type)
          ? analyticsTypeFromJSON(object.analytics_type)
          : 0,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      sviSourceKind: isSet(object.sviSourceKind)
        ? sviSourceKindFromJSON(object.sviSourceKind)
        : isSet(object.svi_source_kind)
          ? sviSourceKindFromJSON(object.svi_source_kind)
          : undefined,
    }
  },

  toJSON(message: GetAnalyticRangeRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.analyticsType !== 0) {
      obj.analyticsType = analyticsTypeToJSON(message.analyticsType)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.sviSourceKind !== undefined) {
      obj.sviSourceKind = sviSourceKindToJSON(message.sviSourceKind)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetAnalyticRangeRequest>, I>>(
    base?: I
  ): GetAnalyticRangeRequest {
    return GetAnalyticRangeRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetAnalyticRangeRequest>, I>>(
    object: I
  ): GetAnalyticRangeRequest {
    const message = createBaseGetAnalyticRangeRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.analyticsType = object.analyticsType ?? 0
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.sviSourceKind = object.sviSourceKind ?? undefined
    return message
  },
}

function createBaseFedwatchProbabilitiesRequest(): FedwatchProbabilitiesRequest {
  return {
    exchange: 0,
    symbol: '',
    meetingDate: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
    asOf: [],
  }
}

export const FedwatchProbabilitiesRequest: MessageFns<FedwatchProbabilitiesRequest> = {
  encode(
    message: FedwatchProbabilitiesRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.meetingDate !== undefined) {
      writer.uint32(26).string(message.meetingDate)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    writer.uint32(58).fork()
    for (const v of message.asOf) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FedwatchProbabilitiesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFedwatchProbabilitiesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.meetingDate = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 7: {
          if (tag === 56) {
            message.asOf.push(reader.int64().toString())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.asOf.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FedwatchProbabilitiesRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      meetingDate: isSet(object.meetingDate)
        ? globalThis.String(object.meetingDate)
        : isSet(object.meeting_date)
          ? globalThis.String(object.meeting_date)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      asOf: globalThis.Array.isArray(object?.asOf)
        ? object.asOf.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.as_of)
          ? object.as_of.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: FedwatchProbabilitiesRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.meetingDate !== undefined) {
      obj.meetingDate = message.meetingDate
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.asOf?.length) {
      obj.asOf = message.asOf
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FedwatchProbabilitiesRequest>, I>>(
    base?: I
  ): FedwatchProbabilitiesRequest {
    return FedwatchProbabilitiesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FedwatchProbabilitiesRequest>, I>>(
    object: I
  ): FedwatchProbabilitiesRequest {
    const message = createBaseFedwatchProbabilitiesRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.meetingDate = object.meetingDate ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.asOf = object.asOf?.map((e) => e) || []
    return message
  },
}

function createBaseGetOptionsVolumeLeaderboardRequest(): GetOptionsVolumeLeaderboardRequest {
  return {
    exchange: 0,
    underlying: '',
    volumeMeasure: 0,
    groupBy: 0,
    optionType: undefined,
    limit: undefined,
  }
}

export const GetOptionsVolumeLeaderboardRequest: MessageFns<GetOptionsVolumeLeaderboardRequest> = {
  encode(
    message: GetOptionsVolumeLeaderboardRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(24).int32(message.volumeMeasure)
    }
    if (message.groupBy !== 0) {
      writer.uint32(32).int32(message.groupBy)
    }
    if (message.optionType !== undefined) {
      writer.uint32(40).int32(message.optionType)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOptionsVolumeLeaderboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetOptionsVolumeLeaderboardRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.groupBy = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetOptionsVolumeLeaderboardRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      groupBy: isSet(object.groupBy)
        ? optionsVolumeGroupByFromJSON(object.groupBy)
        : isSet(object.group_by)
          ? optionsVolumeGroupByFromJSON(object.group_by)
          : 0,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: GetOptionsVolumeLeaderboardRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.groupBy !== 0) {
      obj.groupBy = optionsVolumeGroupByToJSON(message.groupBy)
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetOptionsVolumeLeaderboardRequest>, I>>(
    base?: I
  ): GetOptionsVolumeLeaderboardRequest {
    return GetOptionsVolumeLeaderboardRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetOptionsVolumeLeaderboardRequest>, I>>(
    object: I
  ): GetOptionsVolumeLeaderboardRequest {
    const message = createBaseGetOptionsVolumeLeaderboardRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.groupBy = object.groupBy ?? 0
    message.optionType = object.optionType ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseOptionsVolumeSeriesRequest(): OptionsVolumeSeriesRequest {
  return {
    exchange: 0,
    underlying: '',
    timeframe: 0,
    volumeMeasure: 0,
    from: undefined,
    to: undefined,
    limit: undefined,
  }
}

export const OptionsVolumeSeriesRequest: MessageFns<OptionsVolumeSeriesRequest> = {
  encode(
    message: OptionsVolumeSeriesRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(32).int32(message.volumeMeasure)
    }
    if (message.from !== undefined) {
      writer.uint32(40).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(48).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(56).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsVolumeSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsVolumeSeriesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsVolumeSeriesRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: OptionsVolumeSeriesRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsVolumeSeriesRequest>, I>>(
    base?: I
  ): OptionsVolumeSeriesRequest {
    return OptionsVolumeSeriesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsVolumeSeriesRequest>, I>>(
    object: I
  ): OptionsVolumeSeriesRequest {
    const message = createBaseOptionsVolumeSeriesRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseOptionsOiSeriesRequest(): OptionsOiSeriesRequest {
  return {
    exchange: 0,
    underlying: '',
    timeframe: 0,
    measure: 0,
    optionType: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
    expiryMs: undefined,
  }
}

export const OptionsOiSeriesRequest: MessageFns<OptionsOiSeriesRequest> = {
  encode(message: OptionsOiSeriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.measure !== 0) {
      writer.uint32(32).int32(message.measure)
    }
    if (message.optionType !== undefined) {
      writer.uint32(40).int32(message.optionType)
    }
    if (message.from !== undefined) {
      writer.uint32(48).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(56).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(64).int32(message.limit)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(72).int64(message.expiryMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsOiSeriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsOiSeriesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsOiSeriesRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
    }
  },

  toJSON(message: OptionsOiSeriesRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsOiSeriesRequest>, I>>(
    base?: I
  ): OptionsOiSeriesRequest {
    return OptionsOiSeriesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsOiSeriesRequest>, I>>(
    object: I
  ): OptionsOiSeriesRequest {
    const message = createBaseOptionsOiSeriesRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.measure = object.measure ?? 0
    message.optionType = object.optionType ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.expiryMs = object.expiryMs ?? undefined
    return message
  },
}

function createBaseGetOptionsOiLeaderboardRequest(): GetOptionsOiLeaderboardRequest {
  return {
    exchange: 0,
    underlying: '',
    measure: 0,
    mode: 0,
    optionType: undefined,
    limit: undefined,
  }
}

export const GetOptionsOiLeaderboardRequest: MessageFns<GetOptionsOiLeaderboardRequest> = {
  encode(
    message: GetOptionsOiLeaderboardRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.measure !== 0) {
      writer.uint32(24).int32(message.measure)
    }
    if (message.mode !== 0) {
      writer.uint32(32).int32(message.mode)
    }
    if (message.optionType !== undefined) {
      writer.uint32(40).int32(message.optionType)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOptionsOiLeaderboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetOptionsOiLeaderboardRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetOptionsOiLeaderboardRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
      mode: isSet(object.mode) ? optionsOiRankModeFromJSON(object.mode) : 0,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: GetOptionsOiLeaderboardRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    if (message.mode !== 0) {
      obj.mode = optionsOiRankModeToJSON(message.mode)
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetOptionsOiLeaderboardRequest>, I>>(
    base?: I
  ): GetOptionsOiLeaderboardRequest {
    return GetOptionsOiLeaderboardRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetOptionsOiLeaderboardRequest>, I>>(
    object: I
  ): GetOptionsOiLeaderboardRequest {
    const message = createBaseGetOptionsOiLeaderboardRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.measure = object.measure ?? 0
    message.mode = object.mode ?? 0
    message.optionType = object.optionType ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseGetOptionsOiByStrikeRequest(): GetOptionsOiByStrikeRequest {
  return { exchange: 0, underlying: '', measure: 0 }
}

export const GetOptionsOiByStrikeRequest: MessageFns<GetOptionsOiByStrikeRequest> = {
  encode(
    message: GetOptionsOiByStrikeRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.measure !== 0) {
      writer.uint32(24).int32(message.measure)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOptionsOiByStrikeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetOptionsOiByStrikeRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.measure = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetOptionsOiByStrikeRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      measure: isSet(object.measure) ? optionsVolumeMeasureFromJSON(object.measure) : 0,
    }
  },

  toJSON(message: GetOptionsOiByStrikeRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.measure !== 0) {
      obj.measure = optionsVolumeMeasureToJSON(message.measure)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetOptionsOiByStrikeRequest>, I>>(
    base?: I
  ): GetOptionsOiByStrikeRequest {
    return GetOptionsOiByStrikeRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetOptionsOiByStrikeRequest>, I>>(
    object: I
  ): GetOptionsOiByStrikeRequest {
    const message = createBaseGetOptionsOiByStrikeRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.measure = object.measure ?? 0
    return message
  },
}

function createBaseOptionsTradesHistoryRequest(): OptionsTradesHistoryRequest {
  return {
    exchange: 0,
    underlying: '',
    blockMode: 0,
    sizeMeasure: undefined,
    minSize: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
  }
}

export const OptionsTradesHistoryRequest: MessageFns<OptionsTradesHistoryRequest> = {
  encode(
    message: OptionsTradesHistoryRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.blockMode !== 0) {
      writer.uint32(24).int32(message.blockMode)
    }
    if (message.sizeMeasure !== undefined) {
      writer.uint32(32).int32(message.sizeMeasure)
    }
    if (message.minSize !== undefined) {
      writer.uint32(41).double(message.minSize)
    }
    if (message.from !== undefined) {
      writer.uint32(48).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(56).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(64).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsTradesHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsTradesHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.blockMode = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.sizeMeasure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.minSize = reader.double()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsTradesHistoryRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      blockMode: isSet(object.blockMode)
        ? blockTradeModeFromJSON(object.blockMode)
        : isSet(object.block_mode)
          ? blockTradeModeFromJSON(object.block_mode)
          : 0,
      sizeMeasure: isSet(object.sizeMeasure)
        ? optionsVolumeMeasureFromJSON(object.sizeMeasure)
        : isSet(object.size_measure)
          ? optionsVolumeMeasureFromJSON(object.size_measure)
          : undefined,
      minSize: isSet(object.minSize)
        ? globalThis.Number(object.minSize)
        : isSet(object.min_size)
          ? globalThis.Number(object.min_size)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: OptionsTradesHistoryRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.blockMode !== 0) {
      obj.blockMode = blockTradeModeToJSON(message.blockMode)
    }
    if (message.sizeMeasure !== undefined) {
      obj.sizeMeasure = optionsVolumeMeasureToJSON(message.sizeMeasure)
    }
    if (message.minSize !== undefined) {
      obj.minSize = message.minSize
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsTradesHistoryRequest>, I>>(
    base?: I
  ): OptionsTradesHistoryRequest {
    return OptionsTradesHistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsTradesHistoryRequest>, I>>(
    object: I
  ): OptionsTradesHistoryRequest {
    const message = createBaseOptionsTradesHistoryRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.blockMode = object.blockMode ?? 0
    message.sizeMeasure = object.sizeMeasure ?? undefined
    message.minSize = object.minSize ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseOptionsStrikeFlowRequest(): OptionsStrikeFlowRequest {
  return {
    exchange: 0,
    underlying: '',
    timeframe: 0,
    volumeMeasure: 0,
    expiryMs: undefined,
    from: undefined,
    to: undefined,
    limit: undefined,
    strikeLimit: undefined,
  }
}

export const OptionsStrikeFlowRequest: MessageFns<OptionsStrikeFlowRequest> = {
  encode(
    message: OptionsStrikeFlowRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.underlying !== '') {
      writer.uint32(18).string(message.underlying)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      writer.uint32(32).int32(message.volumeMeasure)
    }
    if (message.expiryMs !== undefined) {
      writer.uint32(40).int64(message.expiryMs)
    }
    if (message.from !== undefined) {
      writer.uint32(48).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(56).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(64).int32(message.limit)
    }
    if (message.strikeLimit !== undefined) {
      writer.uint32(72).int32(message.strikeLimit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsStrikeFlowRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsStrikeFlowRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.volumeMeasure = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.expiryMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.strikeLimit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsStrikeFlowRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      volumeMeasure: isSet(object.volumeMeasure)
        ? optionsVolumeMeasureFromJSON(object.volumeMeasure)
        : isSet(object.volume_measure)
          ? optionsVolumeMeasureFromJSON(object.volume_measure)
          : 0,
      expiryMs: isSet(object.expiryMs)
        ? globalThis.String(object.expiryMs)
        : isSet(object.expiry_ms)
          ? globalThis.String(object.expiry_ms)
          : undefined,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      strikeLimit: isSet(object.strikeLimit)
        ? globalThis.Number(object.strikeLimit)
        : isSet(object.strike_limit)
          ? globalThis.Number(object.strike_limit)
          : undefined,
    }
  },

  toJSON(message: OptionsStrikeFlowRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.volumeMeasure !== 0) {
      obj.volumeMeasure = optionsVolumeMeasureToJSON(message.volumeMeasure)
    }
    if (message.expiryMs !== undefined) {
      obj.expiryMs = message.expiryMs
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.strikeLimit !== undefined) {
      obj.strikeLimit = Math.round(message.strikeLimit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsStrikeFlowRequest>, I>>(
    base?: I
  ): OptionsStrikeFlowRequest {
    return OptionsStrikeFlowRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsStrikeFlowRequest>, I>>(
    object: I
  ): OptionsStrikeFlowRequest {
    const message = createBaseOptionsStrikeFlowRequest()
    message.exchange = object.exchange ?? 0
    message.underlying = object.underlying ?? ''
    message.timeframe = object.timeframe ?? 0
    message.volumeMeasure = object.volumeMeasure ?? 0
    message.expiryMs = object.expiryMs ?? undefined
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.strikeLimit = object.strikeLimit ?? undefined
    return message
  },
}

function createBaseGetVenuesRequest(): GetVenuesRequest {
  return {}
}

export const GetVenuesRequest: MessageFns<GetVenuesRequest> = {
  encode(_: GetVenuesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVenuesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetVenuesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetVenuesRequest {
    return {}
  },

  toJSON(_: GetVenuesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetVenuesRequest>, I>>(base?: I): GetVenuesRequest {
    return GetVenuesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetVenuesRequest>, I>>(_: I): GetVenuesRequest {
    const message = createBaseGetVenuesRequest()
    return message
  },
}

function createBaseGetExchangesRequest(): GetExchangesRequest {
  return { venue: 0 }
}

export const GetExchangesRequest: MessageFns<GetExchangesRequest> = {
  encode(message: GetExchangesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.venue !== 0) {
      writer.uint32(8).int32(message.venue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetExchangesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetExchangesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.venue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetExchangesRequest {
    return { venue: isSet(object.venue) ? tradeVenueFromJSON(object.venue) : 0 }
  },

  toJSON(message: GetExchangesRequest): unknown {
    const obj: any = {}
    if (message.venue !== 0) {
      obj.venue = tradeVenueToJSON(message.venue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetExchangesRequest>, I>>(base?: I): GetExchangesRequest {
    return GetExchangesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetExchangesRequest>, I>>(
    object: I
  ): GetExchangesRequest {
    const message = createBaseGetExchangesRequest()
    message.venue = object.venue ?? 0
    return message
  },
}

function createBaseGetVenueStatus(): GetVenueStatus {
  return { exchange: 0 }
}

export const GetVenueStatus: MessageFns<GetVenueStatus> = {
  encode(message: GetVenueStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVenueStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetVenueStatus()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetVenueStatus {
    return { exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0 }
  },

  toJSON(message: GetVenueStatus): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetVenueStatus>, I>>(base?: I): GetVenueStatus {
    return GetVenueStatus.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetVenueStatus>, I>>(object: I): GetVenueStatus {
    const message = createBaseGetVenueStatus()
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseGetVenueSchedules(): GetVenueSchedules {
  return {}
}

export const GetVenueSchedules: MessageFns<GetVenueSchedules> = {
  encode(_: GetVenueSchedules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVenueSchedules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetVenueSchedules()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetVenueSchedules {
    return {}
  },

  toJSON(_: GetVenueSchedules): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetVenueSchedules>, I>>(base?: I): GetVenueSchedules {
    return GetVenueSchedules.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetVenueSchedules>, I>>(_: I): GetVenueSchedules {
    const message = createBaseGetVenueSchedules()
    return message
  },
}

function createBasePositionGroupMember(): PositionGroupMember {
  return { accountId: '', instrumentId: '' }
}

export const PositionGroupMember: MessageFns<PositionGroupMember> = {
  encode(message: PositionGroupMember, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.instrumentId !== '') {
      writer.uint32(18).string(message.instrumentId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionGroupMember {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionGroupMember()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrumentId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionGroupMember {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      instrumentId: isSet(object.instrumentId)
        ? globalThis.String(object.instrumentId)
        : isSet(object.instrument_id)
          ? globalThis.String(object.instrument_id)
          : '',
    }
  },

  toJSON(message: PositionGroupMember): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.instrumentId !== '') {
      obj.instrumentId = message.instrumentId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionGroupMember>, I>>(base?: I): PositionGroupMember {
    return PositionGroupMember.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionGroupMember>, I>>(
    object: I
  ): PositionGroupMember {
    const message = createBasePositionGroupMember()
    message.accountId = object.accountId ?? ''
    message.instrumentId = object.instrumentId ?? ''
    return message
  },
}

function createBasePositionGroup(): PositionGroup {
  return {
    groupId: '',
    name: '',
    parentGroupId: undefined,
    children: [],
    createdAt: '0',
    updatedAt: '0',
    members: [],
    orderedMembers: [],
  }
}

export const PositionGroup: MessageFns<PositionGroup> = {
  encode(message: PositionGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== '') {
      writer.uint32(10).string(message.groupId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.parentGroupId !== undefined) {
      writer.uint32(34).string(message.parentGroupId)
    }
    for (const v of message.children) {
      PositionGroup.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.createdAt !== '0') {
      writer.uint32(56).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(64).int64(message.updatedAt)
    }
    for (const v of message.members) {
      PositionGroupMember.encode(v!, writer.uint32(82).fork()).join()
    }
    for (const v of message.orderedMembers) {
      PositionGroupMember.encode(v!, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionGroup()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.groupId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.parentGroupId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.children.push(PositionGroup.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.members.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.orderedMembers.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionGroup {
    return {
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
          ? globalThis.String(object.group_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      parentGroupId: isSet(object.parentGroupId)
        ? globalThis.String(object.parentGroupId)
        : isSet(object.parent_group_id)
          ? globalThis.String(object.parent_group_id)
          : undefined,
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => PositionGroup.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      members: globalThis.Array.isArray(object?.members)
        ? object.members.map((e: any) => PositionGroupMember.fromJSON(e))
        : [],
      orderedMembers: globalThis.Array.isArray(object?.orderedMembers)
        ? object.orderedMembers.map((e: any) => PositionGroupMember.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_members)
          ? object.ordered_members.map((e: any) => PositionGroupMember.fromJSON(e))
          : [],
    }
  },

  toJSON(message: PositionGroup): unknown {
    const obj: any = {}
    if (message.groupId !== '') {
      obj.groupId = message.groupId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.parentGroupId !== undefined) {
      obj.parentGroupId = message.parentGroupId
    }
    if (message.children?.length) {
      obj.children = message.children.map((e) => PositionGroup.toJSON(e))
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => PositionGroupMember.toJSON(e))
    }
    if (message.orderedMembers?.length) {
      obj.orderedMembers = message.orderedMembers.map((e) => PositionGroupMember.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionGroup>, I>>(base?: I): PositionGroup {
    return PositionGroup.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionGroup>, I>>(object: I): PositionGroup {
    const message = createBasePositionGroup()
    message.groupId = object.groupId ?? ''
    message.name = object.name ?? ''
    message.parentGroupId = object.parentGroupId ?? undefined
    message.children = object.children?.map((e) => PositionGroup.fromPartial(e)) || []
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.members = object.members?.map((e) => PositionGroupMember.fromPartial(e)) || []
    message.orderedMembers =
      object.orderedMembers?.map((e) => PositionGroupMember.fromPartial(e)) || []
    return message
  },
}

function createBasePositionGroupMutationResponse(): PositionGroupMutationResponse {
  return { success: false, message: '', group: undefined }
}

export const PositionGroupMutationResponse: MessageFns<PositionGroupMutationResponse> = {
  encode(
    message: PositionGroupMutationResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.group !== undefined) {
      PositionGroup.encode(message.group, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionGroupMutationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionGroupMutationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.group = PositionGroup.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionGroupMutationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      group: isSet(object.group) ? PositionGroup.fromJSON(object.group) : undefined,
    }
  },

  toJSON(message: PositionGroupMutationResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.group !== undefined) {
      obj.group = PositionGroup.toJSON(message.group)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionGroupMutationResponse>, I>>(
    base?: I
  ): PositionGroupMutationResponse {
    return PositionGroupMutationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionGroupMutationResponse>, I>>(
    object: I
  ): PositionGroupMutationResponse {
    const message = createBasePositionGroupMutationResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    message.group =
      object.group !== undefined && object.group !== null
        ? PositionGroup.fromPartial(object.group)
        : undefined
    return message
  },
}

function createBaseCreatePositionGroupRequest(): CreatePositionGroupRequest {
  return { name: '', parentGroupId: undefined, members: [] }
}

export const CreatePositionGroupRequest: MessageFns<CreatePositionGroupRequest> = {
  encode(
    message: CreatePositionGroupRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.parentGroupId !== undefined) {
      writer.uint32(26).string(message.parentGroupId)
    }
    for (const v of message.members) {
      PositionGroupMember.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePositionGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreatePositionGroupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.parentGroupId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.members.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreatePositionGroupRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      parentGroupId: isSet(object.parentGroupId)
        ? globalThis.String(object.parentGroupId)
        : isSet(object.parent_group_id)
          ? globalThis.String(object.parent_group_id)
          : undefined,
      members: globalThis.Array.isArray(object?.members)
        ? object.members.map((e: any) => PositionGroupMember.fromJSON(e))
        : [],
    }
  },

  toJSON(message: CreatePositionGroupRequest): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.parentGroupId !== undefined) {
      obj.parentGroupId = message.parentGroupId
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => PositionGroupMember.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreatePositionGroupRequest>, I>>(
    base?: I
  ): CreatePositionGroupRequest {
    return CreatePositionGroupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreatePositionGroupRequest>, I>>(
    object: I
  ): CreatePositionGroupRequest {
    const message = createBaseCreatePositionGroupRequest()
    message.name = object.name ?? ''
    message.parentGroupId = object.parentGroupId ?? undefined
    message.members = object.members?.map((e) => PositionGroupMember.fromPartial(e)) || []
    return message
  },
}

function createBaseUpdatePositionGroupRequest(): UpdatePositionGroupRequest {
  return {
    groupId: '',
    name: undefined,
    parentGroupId: undefined,
    addMembers: [],
    removeMembers: [],
  }
}

export const UpdatePositionGroupRequest: MessageFns<UpdatePositionGroupRequest> = {
  encode(
    message: UpdatePositionGroupRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.groupId !== '') {
      writer.uint32(18).string(message.groupId)
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name)
    }
    if (message.parentGroupId !== undefined) {
      writer.uint32(34).string(message.parentGroupId)
    }
    for (const v of message.addMembers) {
      PositionGroupMember.encode(v!, writer.uint32(58).fork()).join()
    }
    for (const v of message.removeMembers) {
      PositionGroupMember.encode(v!, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePositionGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdatePositionGroupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.groupId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.parentGroupId = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.addMembers.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.removeMembers.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdatePositionGroupRequest {
    return {
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
          ? globalThis.String(object.group_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      parentGroupId: isSet(object.parentGroupId)
        ? globalThis.String(object.parentGroupId)
        : isSet(object.parent_group_id)
          ? globalThis.String(object.parent_group_id)
          : undefined,
      addMembers: globalThis.Array.isArray(object?.addMembers)
        ? object.addMembers.map((e: any) => PositionGroupMember.fromJSON(e))
        : globalThis.Array.isArray(object?.add_members)
          ? object.add_members.map((e: any) => PositionGroupMember.fromJSON(e))
          : [],
      removeMembers: globalThis.Array.isArray(object?.removeMembers)
        ? object.removeMembers.map((e: any) => PositionGroupMember.fromJSON(e))
        : globalThis.Array.isArray(object?.remove_members)
          ? object.remove_members.map((e: any) => PositionGroupMember.fromJSON(e))
          : [],
    }
  },

  toJSON(message: UpdatePositionGroupRequest): unknown {
    const obj: any = {}
    if (message.groupId !== '') {
      obj.groupId = message.groupId
    }
    if (message.name !== undefined) {
      obj.name = message.name
    }
    if (message.parentGroupId !== undefined) {
      obj.parentGroupId = message.parentGroupId
    }
    if (message.addMembers?.length) {
      obj.addMembers = message.addMembers.map((e) => PositionGroupMember.toJSON(e))
    }
    if (message.removeMembers?.length) {
      obj.removeMembers = message.removeMembers.map((e) => PositionGroupMember.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdatePositionGroupRequest>, I>>(
    base?: I
  ): UpdatePositionGroupRequest {
    return UpdatePositionGroupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePositionGroupRequest>, I>>(
    object: I
  ): UpdatePositionGroupRequest {
    const message = createBaseUpdatePositionGroupRequest()
    message.groupId = object.groupId ?? ''
    message.name = object.name ?? undefined
    message.parentGroupId = object.parentGroupId ?? undefined
    message.addMembers = object.addMembers?.map((e) => PositionGroupMember.fromPartial(e)) || []
    message.removeMembers =
      object.removeMembers?.map((e) => PositionGroupMember.fromPartial(e)) || []
    return message
  },
}

function createBaseDeletePositionGroupRequest(): DeletePositionGroupRequest {
  return { groupId: '' }
}

export const DeletePositionGroupRequest: MessageFns<DeletePositionGroupRequest> = {
  encode(
    message: DeletePositionGroupRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.groupId !== '') {
      writer.uint32(18).string(message.groupId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePositionGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePositionGroupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.groupId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeletePositionGroupRequest {
    return {
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
          ? globalThis.String(object.group_id)
          : '',
    }
  },

  toJSON(message: DeletePositionGroupRequest): unknown {
    const obj: any = {}
    if (message.groupId !== '') {
      obj.groupId = message.groupId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePositionGroupRequest>, I>>(
    base?: I
  ): DeletePositionGroupRequest {
    return DeletePositionGroupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePositionGroupRequest>, I>>(
    object: I
  ): DeletePositionGroupRequest {
    const message = createBaseDeletePositionGroupRequest()
    message.groupId = object.groupId ?? ''
    return message
  },
}

function createBaseSetPositionGroupOrderRequest(): SetPositionGroupOrderRequest {
  return { groupId: '', orderedMembers: [] }
}

export const SetPositionGroupOrderRequest: MessageFns<SetPositionGroupOrderRequest> = {
  encode(
    message: SetPositionGroupOrderRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.groupId !== '') {
      writer.uint32(18).string(message.groupId)
    }
    for (const v of message.orderedMembers) {
      PositionGroupMember.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetPositionGroupOrderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetPositionGroupOrderRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.groupId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.orderedMembers.push(PositionGroupMember.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetPositionGroupOrderRequest {
    return {
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
          ? globalThis.String(object.group_id)
          : '',
      orderedMembers: globalThis.Array.isArray(object?.orderedMembers)
        ? object.orderedMembers.map((e: any) => PositionGroupMember.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_members)
          ? object.ordered_members.map((e: any) => PositionGroupMember.fromJSON(e))
          : [],
    }
  },

  toJSON(message: SetPositionGroupOrderRequest): unknown {
    const obj: any = {}
    if (message.groupId !== '') {
      obj.groupId = message.groupId
    }
    if (message.orderedMembers?.length) {
      obj.orderedMembers = message.orderedMembers.map((e) => PositionGroupMember.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetPositionGroupOrderRequest>, I>>(
    base?: I
  ): SetPositionGroupOrderRequest {
    return SetPositionGroupOrderRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetPositionGroupOrderRequest>, I>>(
    object: I
  ): SetPositionGroupOrderRequest {
    const message = createBaseSetPositionGroupOrderRequest()
    message.groupId = object.groupId ?? ''
    message.orderedMembers =
      object.orderedMembers?.map((e) => PositionGroupMember.fromPartial(e)) || []
    return message
  },
}

function createBaseGetPositionGroupsRequest(): GetPositionGroupsRequest {
  return {}
}

export const GetPositionGroupsRequest: MessageFns<GetPositionGroupsRequest> = {
  encode(_: GetPositionGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPositionGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPositionGroupsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetPositionGroupsRequest {
    return {}
  },

  toJSON(_: GetPositionGroupsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetPositionGroupsRequest>, I>>(
    base?: I
  ): GetPositionGroupsRequest {
    return GetPositionGroupsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPositionGroupsRequest>, I>>(
    _: I
  ): GetPositionGroupsRequest {
    const message = createBaseGetPositionGroupsRequest()
    return message
  },
}

function createBaseGetPositionGroupsResponse(): GetPositionGroupsResponse {
  return { groups: [] }
}

export const GetPositionGroupsResponse: MessageFns<GetPositionGroupsResponse> = {
  encode(
    message: GetPositionGroupsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.groups) {
      PositionGroup.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPositionGroupsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPositionGroupsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.groups.push(PositionGroup.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPositionGroupsResponse {
    return {
      groups: globalThis.Array.isArray(object?.groups)
        ? object.groups.map((e: any) => PositionGroup.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetPositionGroupsResponse): unknown {
    const obj: any = {}
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => PositionGroup.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPositionGroupsResponse>, I>>(
    base?: I
  ): GetPositionGroupsResponse {
    return GetPositionGroupsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPositionGroupsResponse>, I>>(
    object: I
  ): GetPositionGroupsResponse {
    const message = createBaseGetPositionGroupsResponse()
    message.groups = object.groups?.map((e) => PositionGroup.fromPartial(e)) || []
    return message
  },
}

function createBaseGroupedPositionMetrics(): GroupedPositionMetrics {
  return {
    deltaUsd: undefined,
    gammaUsd: undefined,
    vegaUsd: undefined,
    thetaUsd: undefined,
    unrealizedPnlUsd: undefined,
    realizedPnlUsd: undefined,
    dailyUnrealizedPnlUsd: undefined,
    initialMarginUsd: undefined,
    maintenanceMarginUsd: undefined,
  }
}

export const GroupedPositionMetrics: MessageFns<GroupedPositionMetrics> = {
  encode(message: GroupedPositionMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deltaUsd !== undefined) {
      writer.uint32(10).string(message.deltaUsd)
    }
    if (message.gammaUsd !== undefined) {
      writer.uint32(18).string(message.gammaUsd)
    }
    if (message.vegaUsd !== undefined) {
      writer.uint32(26).string(message.vegaUsd)
    }
    if (message.thetaUsd !== undefined) {
      writer.uint32(34).string(message.thetaUsd)
    }
    if (message.unrealizedPnlUsd !== undefined) {
      writer.uint32(42).string(message.unrealizedPnlUsd)
    }
    if (message.realizedPnlUsd !== undefined) {
      writer.uint32(50).string(message.realizedPnlUsd)
    }
    if (message.dailyUnrealizedPnlUsd !== undefined) {
      writer.uint32(58).string(message.dailyUnrealizedPnlUsd)
    }
    if (message.initialMarginUsd !== undefined) {
      writer.uint32(66).string(message.initialMarginUsd)
    }
    if (message.maintenanceMarginUsd !== undefined) {
      writer.uint32(74).string(message.maintenanceMarginUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupedPositionMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGroupedPositionMetrics()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.deltaUsd = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.vegaUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.thetaUsd = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.unrealizedPnlUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.realizedPnlUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.dailyUnrealizedPnlUsd = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.initialMarginUsd = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.maintenanceMarginUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GroupedPositionMetrics {
    return {
      deltaUsd: isSet(object.deltaUsd)
        ? globalThis.String(object.deltaUsd)
        : isSet(object.delta_usd)
          ? globalThis.String(object.delta_usd)
          : undefined,
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : undefined,
      vegaUsd: isSet(object.vegaUsd)
        ? globalThis.String(object.vegaUsd)
        : isSet(object.vega_usd)
          ? globalThis.String(object.vega_usd)
          : undefined,
      thetaUsd: isSet(object.thetaUsd)
        ? globalThis.String(object.thetaUsd)
        : isSet(object.theta_usd)
          ? globalThis.String(object.theta_usd)
          : undefined,
      unrealizedPnlUsd: isSet(object.unrealizedPnlUsd)
        ? globalThis.String(object.unrealizedPnlUsd)
        : isSet(object.unrealized_pnl_usd)
          ? globalThis.String(object.unrealized_pnl_usd)
          : undefined,
      realizedPnlUsd: isSet(object.realizedPnlUsd)
        ? globalThis.String(object.realizedPnlUsd)
        : isSet(object.realized_pnl_usd)
          ? globalThis.String(object.realized_pnl_usd)
          : undefined,
      dailyUnrealizedPnlUsd: isSet(object.dailyUnrealizedPnlUsd)
        ? globalThis.String(object.dailyUnrealizedPnlUsd)
        : isSet(object.daily_unrealized_pnl_usd)
          ? globalThis.String(object.daily_unrealized_pnl_usd)
          : undefined,
      initialMarginUsd: isSet(object.initialMarginUsd)
        ? globalThis.String(object.initialMarginUsd)
        : isSet(object.initial_margin_usd)
          ? globalThis.String(object.initial_margin_usd)
          : undefined,
      maintenanceMarginUsd: isSet(object.maintenanceMarginUsd)
        ? globalThis.String(object.maintenanceMarginUsd)
        : isSet(object.maintenance_margin_usd)
          ? globalThis.String(object.maintenance_margin_usd)
          : undefined,
    }
  },

  toJSON(message: GroupedPositionMetrics): unknown {
    const obj: any = {}
    if (message.deltaUsd !== undefined) {
      obj.deltaUsd = message.deltaUsd
    }
    if (message.gammaUsd !== undefined) {
      obj.gammaUsd = message.gammaUsd
    }
    if (message.vegaUsd !== undefined) {
      obj.vegaUsd = message.vegaUsd
    }
    if (message.thetaUsd !== undefined) {
      obj.thetaUsd = message.thetaUsd
    }
    if (message.unrealizedPnlUsd !== undefined) {
      obj.unrealizedPnlUsd = message.unrealizedPnlUsd
    }
    if (message.realizedPnlUsd !== undefined) {
      obj.realizedPnlUsd = message.realizedPnlUsd
    }
    if (message.dailyUnrealizedPnlUsd !== undefined) {
      obj.dailyUnrealizedPnlUsd = message.dailyUnrealizedPnlUsd
    }
    if (message.initialMarginUsd !== undefined) {
      obj.initialMarginUsd = message.initialMarginUsd
    }
    if (message.maintenanceMarginUsd !== undefined) {
      obj.maintenanceMarginUsd = message.maintenanceMarginUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GroupedPositionMetrics>, I>>(
    base?: I
  ): GroupedPositionMetrics {
    return GroupedPositionMetrics.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GroupedPositionMetrics>, I>>(
    object: I
  ): GroupedPositionMetrics {
    const message = createBaseGroupedPositionMetrics()
    message.deltaUsd = object.deltaUsd ?? undefined
    message.gammaUsd = object.gammaUsd ?? undefined
    message.vegaUsd = object.vegaUsd ?? undefined
    message.thetaUsd = object.thetaUsd ?? undefined
    message.unrealizedPnlUsd = object.unrealizedPnlUsd ?? undefined
    message.realizedPnlUsd = object.realizedPnlUsd ?? undefined
    message.dailyUnrealizedPnlUsd = object.dailyUnrealizedPnlUsd ?? undefined
    message.initialMarginUsd = object.initialMarginUsd ?? undefined
    message.maintenanceMarginUsd = object.maintenanceMarginUsd ?? undefined
    return message
  },
}

function createBaseGroupedPositionNode(): GroupedPositionNode {
  return {
    groupId: '',
    name: '',
    parentGroupId: undefined,
    positions: [],
    children: [],
    metrics: undefined,
  }
}

export const GroupedPositionNode: MessageFns<GroupedPositionNode> = {
  encode(message: GroupedPositionNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== '') {
      writer.uint32(10).string(message.groupId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.parentGroupId !== undefined) {
      writer.uint32(34).string(message.parentGroupId)
    }
    for (const v of message.positions) {
      Position.encode(v!, writer.uint32(42).fork()).join()
    }
    for (const v of message.children) {
      GroupedPositionNode.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.metrics !== undefined) {
      GroupedPositionMetrics.encode(message.metrics, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupedPositionNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGroupedPositionNode()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.groupId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.parentGroupId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.positions.push(Position.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.children.push(GroupedPositionNode.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.metrics = GroupedPositionMetrics.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GroupedPositionNode {
    return {
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
          ? globalThis.String(object.group_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      parentGroupId: isSet(object.parentGroupId)
        ? globalThis.String(object.parentGroupId)
        : isSet(object.parent_group_id)
          ? globalThis.String(object.parent_group_id)
          : undefined,
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => Position.fromJSON(e))
        : [],
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => GroupedPositionNode.fromJSON(e))
        : [],
      metrics: isSet(object.metrics) ? GroupedPositionMetrics.fromJSON(object.metrics) : undefined,
    }
  },

  toJSON(message: GroupedPositionNode): unknown {
    const obj: any = {}
    if (message.groupId !== '') {
      obj.groupId = message.groupId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.parentGroupId !== undefined) {
      obj.parentGroupId = message.parentGroupId
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => Position.toJSON(e))
    }
    if (message.children?.length) {
      obj.children = message.children.map((e) => GroupedPositionNode.toJSON(e))
    }
    if (message.metrics !== undefined) {
      obj.metrics = GroupedPositionMetrics.toJSON(message.metrics)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GroupedPositionNode>, I>>(base?: I): GroupedPositionNode {
    return GroupedPositionNode.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GroupedPositionNode>, I>>(
    object: I
  ): GroupedPositionNode {
    const message = createBaseGroupedPositionNode()
    message.groupId = object.groupId ?? ''
    message.name = object.name ?? ''
    message.parentGroupId = object.parentGroupId ?? undefined
    message.positions = object.positions?.map((e) => Position.fromPartial(e)) || []
    message.children = object.children?.map((e) => GroupedPositionNode.fromPartial(e)) || []
    message.metrics =
      object.metrics !== undefined && object.metrics !== null
        ? GroupedPositionMetrics.fromPartial(object.metrics)
        : undefined
    return message
  },
}

function createBaseGetPositionsViewRequest(): GetPositionsViewRequest {
  return { accountId: '', accountIds: [], mode: 0 }
}

export const GetPositionsViewRequest: MessageFns<GetPositionsViewRequest> = {
  encode(
    message: GetPositionsViewRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPositionsViewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPositionsViewRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPositionsViewRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      mode: isSet(object.mode) ? positionViewModeFromJSON(object.mode) : 0,
    }
  },

  toJSON(message: GetPositionsViewRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.mode !== 0) {
      obj.mode = positionViewModeToJSON(message.mode)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPositionsViewRequest>, I>>(
    base?: I
  ): GetPositionsViewRequest {
    return GetPositionsViewRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPositionsViewRequest>, I>>(
    object: I
  ): GetPositionsViewRequest {
    const message = createBaseGetPositionsViewRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.mode = object.mode ?? 0
    return message
  },
}

function createBasePositionViewEntry(): PositionViewEntry {
  return { group: undefined, position: undefined }
}

export const PositionViewEntry: MessageFns<PositionViewEntry> = {
  encode(message: PositionViewEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group !== undefined) {
      GroupedPositionNode.encode(message.group, writer.uint32(10).fork()).join()
    }
    if (message.position !== undefined) {
      Position.encode(message.position, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionViewEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionViewEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.group = GroupedPositionNode.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.position = Position.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionViewEntry {
    return {
      group: isSet(object.group) ? GroupedPositionNode.fromJSON(object.group) : undefined,
      position: isSet(object.position) ? Position.fromJSON(object.position) : undefined,
    }
  },

  toJSON(message: PositionViewEntry): unknown {
    const obj: any = {}
    if (message.group !== undefined) {
      obj.group = GroupedPositionNode.toJSON(message.group)
    }
    if (message.position !== undefined) {
      obj.position = Position.toJSON(message.position)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionViewEntry>, I>>(base?: I): PositionViewEntry {
    return PositionViewEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionViewEntry>, I>>(object: I): PositionViewEntry {
    const message = createBasePositionViewEntry()
    message.group =
      object.group !== undefined && object.group !== null
        ? GroupedPositionNode.fromPartial(object.group)
        : undefined
    message.position =
      object.position !== undefined && object.position !== null
        ? Position.fromPartial(object.position)
        : undefined
    return message
  },
}

function createBasePositionViewOrderEntry(): PositionViewOrderEntry {
  return { kind: 0, id: '', accountId: '' }
}

export const PositionViewOrderEntry: MessageFns<PositionViewOrderEntry> = {
  encode(message: PositionViewOrderEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.id !== '') {
      writer.uint32(18).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(26).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionViewOrderEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionViewOrderEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionViewOrderEntry {
    return {
      kind: isSet(object.kind) ? positionViewEntryKindFromJSON(object.kind) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: PositionViewOrderEntry): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = positionViewEntryKindToJSON(message.kind)
    }
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionViewOrderEntry>, I>>(
    base?: I
  ): PositionViewOrderEntry {
    return PositionViewOrderEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionViewOrderEntry>, I>>(
    object: I
  ): PositionViewOrderEntry {
    const message = createBasePositionViewOrderEntry()
    message.kind = object.kind ?? 0
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseReorderPositionsViewRequest(): ReorderPositionsViewRequest {
  return { orderedEntries: [] }
}

export const ReorderPositionsViewRequest: MessageFns<ReorderPositionsViewRequest> = {
  encode(
    message: ReorderPositionsViewRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.orderedEntries) {
      PositionViewOrderEntry.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReorderPositionsViewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReorderPositionsViewRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderedEntries.push(PositionViewOrderEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ReorderPositionsViewRequest {
    return {
      orderedEntries: globalThis.Array.isArray(object?.orderedEntries)
        ? object.orderedEntries.map((e: any) => PositionViewOrderEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_entries)
          ? object.ordered_entries.map((e: any) => PositionViewOrderEntry.fromJSON(e))
          : [],
    }
  },

  toJSON(message: ReorderPositionsViewRequest): unknown {
    const obj: any = {}
    if (message.orderedEntries?.length) {
      obj.orderedEntries = message.orderedEntries.map((e) => PositionViewOrderEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ReorderPositionsViewRequest>, I>>(
    base?: I
  ): ReorderPositionsViewRequest {
    return ReorderPositionsViewRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ReorderPositionsViewRequest>, I>>(
    object: I
  ): ReorderPositionsViewRequest {
    const message = createBaseReorderPositionsViewRequest()
    message.orderedEntries =
      object.orderedEntries?.map((e) => PositionViewOrderEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseSimulationGridParams(): SimulationGridParams {
  return {
    valueLower: 0,
    valueUpper: 0,
    priceSteps: 0,
    volBumpPct: 0,
    volBumpsByExpiry: {},
    startDate: '',
    endDate: '',
    timeStepSeconds: '0',
    priceRangeKind: 0,
  }
}

export const SimulationGridParams: MessageFns<SimulationGridParams> = {
  encode(message: SimulationGridParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.valueLower !== 0) {
      writer.uint32(9).double(message.valueLower)
    }
    if (message.valueUpper !== 0) {
      writer.uint32(17).double(message.valueUpper)
    }
    if (message.priceSteps !== 0) {
      writer.uint32(24).uint32(message.priceSteps)
    }
    if (message.volBumpPct !== 0) {
      writer.uint32(33).double(message.volBumpPct)
    }
    globalThis.Object.entries(message.volBumpsByExpiry).forEach(
      ([key, value]: [string, number]) => {
        SimulationGridParams_VolBumpsByExpiryEntry.encode(
          { key: key as any, value },
          writer.uint32(74).fork()
        ).join()
      }
    )
    if (message.startDate !== '') {
      writer.uint32(42).string(message.startDate)
    }
    if (message.endDate !== '') {
      writer.uint32(50).string(message.endDate)
    }
    if (message.timeStepSeconds !== '0') {
      writer.uint32(56).int64(message.timeStepSeconds)
    }
    if (message.priceRangeKind !== 0) {
      writer.uint32(64).int32(message.priceRangeKind)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimulationGridParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSimulationGridParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.valueLower = reader.double()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.valueUpper = reader.double()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.priceSteps = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.volBumpPct = reader.double()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          const entry9 = SimulationGridParams_VolBumpsByExpiryEntry.decode(reader, reader.uint32())
          if (entry9.value !== undefined) {
            message.volBumpsByExpiry[entry9.key] = entry9.value
          }
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.startDate = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.endDate = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.timeStepSeconds = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.priceRangeKind = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SimulationGridParams {
    return {
      valueLower: isSet(object.valueLower)
        ? globalThis.Number(object.valueLower)
        : isSet(object.value_lower)
          ? globalThis.Number(object.value_lower)
          : 0,
      valueUpper: isSet(object.valueUpper)
        ? globalThis.Number(object.valueUpper)
        : isSet(object.value_upper)
          ? globalThis.Number(object.value_upper)
          : 0,
      priceSteps: isSet(object.priceSteps)
        ? globalThis.Number(object.priceSteps)
        : isSet(object.price_steps)
          ? globalThis.Number(object.price_steps)
          : 0,
      volBumpPct: isSet(object.volBumpPct)
        ? globalThis.Number(object.volBumpPct)
        : isSet(object.vol_bump_pct)
          ? globalThis.Number(object.vol_bump_pct)
          : 0,
      volBumpsByExpiry: isObject(object.volBumpsByExpiry)
        ? (globalThis.Object.entries(object.volBumpsByExpiry) as [string, any][]).reduce(
            (acc: { [key: string]: number }, [key, value]: [string, any]) => {
              acc[key] = globalThis.Number(value)
              return acc
            },
            {}
          )
        : isObject(object.vol_bumps_by_expiry)
          ? (globalThis.Object.entries(object.vol_bumps_by_expiry) as [string, any][]).reduce(
              (acc: { [key: string]: number }, [key, value]: [string, any]) => {
                acc[key] = globalThis.Number(value)
                return acc
              },
              {}
            )
          : {},
      startDate: isSet(object.startDate)
        ? globalThis.String(object.startDate)
        : isSet(object.start_date)
          ? globalThis.String(object.start_date)
          : '',
      endDate: isSet(object.endDate)
        ? globalThis.String(object.endDate)
        : isSet(object.end_date)
          ? globalThis.String(object.end_date)
          : '',
      timeStepSeconds: isSet(object.timeStepSeconds)
        ? globalThis.String(object.timeStepSeconds)
        : isSet(object.time_step_seconds)
          ? globalThis.String(object.time_step_seconds)
          : '0',
      priceRangeKind: isSet(object.priceRangeKind)
        ? simulationPriceRangeKindFromJSON(object.priceRangeKind)
        : isSet(object.price_range_kind)
          ? simulationPriceRangeKindFromJSON(object.price_range_kind)
          : 0,
    }
  },

  toJSON(message: SimulationGridParams): unknown {
    const obj: any = {}
    if (message.valueLower !== 0) {
      obj.valueLower = message.valueLower
    }
    if (message.valueUpper !== 0) {
      obj.valueUpper = message.valueUpper
    }
    if (message.priceSteps !== 0) {
      obj.priceSteps = Math.round(message.priceSteps)
    }
    if (message.volBumpPct !== 0) {
      obj.volBumpPct = message.volBumpPct
    }
    if (message.volBumpsByExpiry) {
      const entries = globalThis.Object.entries(message.volBumpsByExpiry) as [string, number][]
      if (entries.length > 0) {
        obj.volBumpsByExpiry = {}
        entries.forEach(([k, v]) => {
          obj.volBumpsByExpiry[k] = v
        })
      }
    }
    if (message.startDate !== '') {
      obj.startDate = message.startDate
    }
    if (message.endDate !== '') {
      obj.endDate = message.endDate
    }
    if (message.timeStepSeconds !== '0') {
      obj.timeStepSeconds = message.timeStepSeconds
    }
    if (message.priceRangeKind !== 0) {
      obj.priceRangeKind = simulationPriceRangeKindToJSON(message.priceRangeKind)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SimulationGridParams>, I>>(base?: I): SimulationGridParams {
    return SimulationGridParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SimulationGridParams>, I>>(
    object: I
  ): SimulationGridParams {
    const message = createBaseSimulationGridParams()
    message.valueLower = object.valueLower ?? 0
    message.valueUpper = object.valueUpper ?? 0
    message.priceSteps = object.priceSteps ?? 0
    message.volBumpPct = object.volBumpPct ?? 0
    message.volBumpsByExpiry = (
      globalThis.Object.entries(object.volBumpsByExpiry ?? {}) as [string, number][]
    ).reduce((acc: { [key: string]: number }, [key, value]: [string, number]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value)
      }
      return acc
    }, {})
    message.startDate = object.startDate ?? ''
    message.endDate = object.endDate ?? ''
    message.timeStepSeconds = object.timeStepSeconds ?? '0'
    message.priceRangeKind = object.priceRangeKind ?? 0
    return message
  },
}

function createBaseSimulationGridParams_VolBumpsByExpiryEntry(): SimulationGridParams_VolBumpsByExpiryEntry {
  return { key: '', value: 0 }
}

export const SimulationGridParams_VolBumpsByExpiryEntry: MessageFns<SimulationGridParams_VolBumpsByExpiryEntry> =
  {
    encode(
      message: SimulationGridParams_VolBumpsByExpiryEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== 0) {
        writer.uint32(17).double(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): SimulationGridParams_VolBumpsByExpiryEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseSimulationGridParams_VolBumpsByExpiryEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 17) {
              break
            }

            message.value = reader.double()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): SimulationGridParams_VolBumpsByExpiryEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      }
    },

    toJSON(message: SimulationGridParams_VolBumpsByExpiryEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== 0) {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<SimulationGridParams_VolBumpsByExpiryEntry>, I>>(
      base?: I
    ): SimulationGridParams_VolBumpsByExpiryEntry {
      return SimulationGridParams_VolBumpsByExpiryEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<SimulationGridParams_VolBumpsByExpiryEntry>, I>>(
      object: I
    ): SimulationGridParams_VolBumpsByExpiryEntry {
      const message = createBaseSimulationGridParams_VolBumpsByExpiryEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? 0
      return message
    },
  }

function createBaseGenerateVolSurfaceRequest(): GenerateVolSurfaceRequest {
  return { asset: '', optionPriceSource: 0 }
}

export const GenerateVolSurfaceRequest: MessageFns<GenerateVolSurfaceRequest> = {
  encode(
    message: GenerateVolSurfaceRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.optionPriceSource !== 0) {
      writer.uint32(16).int32(message.optionPriceSource)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateVolSurfaceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGenerateVolSurfaceRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.optionPriceSource = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GenerateVolSurfaceRequest {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      optionPriceSource: isSet(object.optionPriceSource)
        ? optionPriceSourceFromJSON(object.optionPriceSource)
        : isSet(object.option_price_source)
          ? optionPriceSourceFromJSON(object.option_price_source)
          : 0,
    }
  },

  toJSON(message: GenerateVolSurfaceRequest): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.optionPriceSource !== 0) {
      obj.optionPriceSource = optionPriceSourceToJSON(message.optionPriceSource)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GenerateVolSurfaceRequest>, I>>(
    base?: I
  ): GenerateVolSurfaceRequest {
    return GenerateVolSurfaceRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GenerateVolSurfaceRequest>, I>>(
    object: I
  ): GenerateVolSurfaceRequest {
    const message = createBaseGenerateVolSurfaceRequest()
    message.asset = object.asset ?? ''
    message.optionPriceSource = object.optionPriceSource ?? 0
    return message
  },
}

function createBaseStoredTenorSurface(): StoredTenorSurface {
  return {
    tenorYears: 0,
    strikes: [],
    vols: [],
    markPrices: [],
    bids: [],
    asks: [],
    marketForward: 0,
  }
}

export const StoredTenorSurface: MessageFns<StoredTenorSurface> = {
  encode(message: StoredTenorSurface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenorYears !== 0) {
      writer.uint32(9).double(message.tenorYears)
    }
    writer.uint32(18).fork()
    for (const v of message.strikes) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(26).fork()
    for (const v of message.vols) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(34).fork()
    for (const v of message.markPrices) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.bids) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(50).fork()
    for (const v of message.asks) {
      writer.double(v)
    }
    writer.join()
    if (message.marketForward !== 0) {
      writer.uint32(57).double(message.marketForward)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoredTenorSurface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStoredTenorSurface()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.tenorYears = reader.double()
          continue
        }
        case 2: {
          if (tag === 17) {
            message.strikes.push(reader.double())

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.strikes.push(reader.double())
            }

            continue
          }

          break
        }
        case 3: {
          if (tag === 25) {
            message.vols.push(reader.double())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.vols.push(reader.double())
            }

            continue
          }

          break
        }
        case 4: {
          if (tag === 33) {
            message.markPrices.push(reader.double())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.markPrices.push(reader.double())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 41) {
            message.bids.push(reader.double())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.bids.push(reader.double())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag === 49) {
            message.asks.push(reader.double())

            continue
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.asks.push(reader.double())
            }

            continue
          }

          break
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.marketForward = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StoredTenorSurface {
    return {
      tenorYears: isSet(object.tenorYears)
        ? globalThis.Number(object.tenorYears)
        : isSet(object.tenor_years)
          ? globalThis.Number(object.tenor_years)
          : 0,
      strikes: globalThis.Array.isArray(object?.strikes)
        ? object.strikes.map((e: any) => globalThis.Number(e))
        : [],
      vols: globalThis.Array.isArray(object?.vols)
        ? object.vols.map((e: any) => globalThis.Number(e))
        : [],
      markPrices: globalThis.Array.isArray(object?.markPrices)
        ? object.markPrices.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.mark_prices)
          ? object.mark_prices.map((e: any) => globalThis.Number(e))
          : [],
      bids: globalThis.Array.isArray(object?.bids)
        ? object.bids.map((e: any) => globalThis.Number(e))
        : [],
      asks: globalThis.Array.isArray(object?.asks)
        ? object.asks.map((e: any) => globalThis.Number(e))
        : [],
      marketForward: isSet(object.marketForward)
        ? globalThis.Number(object.marketForward)
        : isSet(object.market_forward)
          ? globalThis.Number(object.market_forward)
          : 0,
    }
  },

  toJSON(message: StoredTenorSurface): unknown {
    const obj: any = {}
    if (message.tenorYears !== 0) {
      obj.tenorYears = message.tenorYears
    }
    if (message.strikes?.length) {
      obj.strikes = message.strikes
    }
    if (message.vols?.length) {
      obj.vols = message.vols
    }
    if (message.markPrices?.length) {
      obj.markPrices = message.markPrices
    }
    if (message.bids?.length) {
      obj.bids = message.bids
    }
    if (message.asks?.length) {
      obj.asks = message.asks
    }
    if (message.marketForward !== 0) {
      obj.marketForward = message.marketForward
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StoredTenorSurface>, I>>(base?: I): StoredTenorSurface {
    return StoredTenorSurface.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StoredTenorSurface>, I>>(object: I): StoredTenorSurface {
    const message = createBaseStoredTenorSurface()
    message.tenorYears = object.tenorYears ?? 0
    message.strikes = object.strikes?.map((e) => e) || []
    message.vols = object.vols?.map((e) => e) || []
    message.markPrices = object.markPrices?.map((e) => e) || []
    message.bids = object.bids?.map((e) => e) || []
    message.asks = object.asks?.map((e) => e) || []
    message.marketForward = object.marketForward ?? 0
    return message
  },
}

function createBaseStoredVolSurface(): StoredVolSurface {
  return { asset: '', spot: 0, rate: 0, generatedAt: '', tenors: [] }
}

export const StoredVolSurface: MessageFns<StoredVolSurface> = {
  encode(message: StoredVolSurface, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.spot !== 0) {
      writer.uint32(17).double(message.spot)
    }
    if (message.rate !== 0) {
      writer.uint32(25).double(message.rate)
    }
    if (message.generatedAt !== '') {
      writer.uint32(34).string(message.generatedAt)
    }
    for (const v of message.tenors) {
      StoredTenorSurface.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoredVolSurface {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStoredVolSurface()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.spot = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.rate = reader.double()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.generatedAt = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.tenors.push(StoredTenorSurface.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StoredVolSurface {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      spot: isSet(object.spot) ? globalThis.Number(object.spot) : 0,
      rate: isSet(object.rate) ? globalThis.Number(object.rate) : 0,
      generatedAt: isSet(object.generatedAt)
        ? globalThis.String(object.generatedAt)
        : isSet(object.generated_at)
          ? globalThis.String(object.generated_at)
          : '',
      tenors: globalThis.Array.isArray(object?.tenors)
        ? object.tenors.map((e: any) => StoredTenorSurface.fromJSON(e))
        : [],
    }
  },

  toJSON(message: StoredVolSurface): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.spot !== 0) {
      obj.spot = message.spot
    }
    if (message.rate !== 0) {
      obj.rate = message.rate
    }
    if (message.generatedAt !== '') {
      obj.generatedAt = message.generatedAt
    }
    if (message.tenors?.length) {
      obj.tenors = message.tenors.map((e) => StoredTenorSurface.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StoredVolSurface>, I>>(base?: I): StoredVolSurface {
    return StoredVolSurface.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StoredVolSurface>, I>>(object: I): StoredVolSurface {
    const message = createBaseStoredVolSurface()
    message.asset = object.asset ?? ''
    message.spot = object.spot ?? 0
    message.rate = object.rate ?? 0
    message.generatedAt = object.generatedAt ?? ''
    message.tenors = object.tenors?.map((e) => StoredTenorSurface.fromPartial(e)) || []
    return message
  },
}

function createBaseGenerateVolSurfaceResponse(): GenerateVolSurfaceResponse {
  return { asset: '', tenorCount: 0, surface: undefined }
}

export const GenerateVolSurfaceResponse: MessageFns<GenerateVolSurfaceResponse> = {
  encode(
    message: GenerateVolSurfaceResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.tenorCount !== 0) {
      writer.uint32(16).uint32(message.tenorCount)
    }
    if (message.surface !== undefined) {
      StoredVolSurface.encode(message.surface, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateVolSurfaceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGenerateVolSurfaceResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tenorCount = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.surface = StoredVolSurface.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GenerateVolSurfaceResponse {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      tenorCount: isSet(object.tenorCount)
        ? globalThis.Number(object.tenorCount)
        : isSet(object.tenor_count)
          ? globalThis.Number(object.tenor_count)
          : 0,
      surface: isSet(object.surface) ? StoredVolSurface.fromJSON(object.surface) : undefined,
    }
  },

  toJSON(message: GenerateVolSurfaceResponse): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.tenorCount !== 0) {
      obj.tenorCount = Math.round(message.tenorCount)
    }
    if (message.surface !== undefined) {
      obj.surface = StoredVolSurface.toJSON(message.surface)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GenerateVolSurfaceResponse>, I>>(
    base?: I
  ): GenerateVolSurfaceResponse {
    return GenerateVolSurfaceResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GenerateVolSurfaceResponse>, I>>(
    object: I
  ): GenerateVolSurfaceResponse {
    const message = createBaseGenerateVolSurfaceResponse()
    message.asset = object.asset ?? ''
    message.tenorCount = object.tenorCount ?? 0
    message.surface =
      object.surface !== undefined && object.surface !== null
        ? StoredVolSurface.fromPartial(object.surface)
        : undefined
    return message
  },
}

function createBaseRiskSimulationPosition(): RiskSimulationPosition {
  return {
    asset: '',
    size: 0,
    entryPrice: 0,
    instrumentType: undefined,
    contractType: 0,
    accountId: undefined,
  }
}

export const RiskSimulationPosition: MessageFns<RiskSimulationPosition> = {
  encode(message: RiskSimulationPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.size !== 0) {
      writer.uint32(17).double(message.size)
    }
    if (message.entryPrice !== 0) {
      writer.uint32(25).double(message.entryPrice)
    }
    if (message.instrumentType !== undefined) {
      RiskSimulationInstrumentType.encode(message.instrumentType, writer.uint32(34).fork()).join()
    }
    if (message.contractType !== 0) {
      writer.uint32(40).int32(message.contractType)
    }
    if (message.accountId !== undefined) {
      writer.uint32(50).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationPosition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.size = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.entryPrice = reader.double()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.instrumentType = RiskSimulationInstrumentType.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.contractType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationPosition {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      entryPrice: isSet(object.entryPrice)
        ? globalThis.Number(object.entryPrice)
        : isSet(object.entry_price)
          ? globalThis.Number(object.entry_price)
          : 0,
      instrumentType: isSet(object.instrumentType)
        ? RiskSimulationInstrumentType.fromJSON(object.instrumentType)
        : isSet(object.instrument_type)
          ? RiskSimulationInstrumentType.fromJSON(object.instrument_type)
          : undefined,
      contractType: isSet(object.contractType)
        ? instrumentTypeFromJSON(object.contractType)
        : isSet(object.contract_type)
          ? instrumentTypeFromJSON(object.contract_type)
          : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : undefined,
    }
  },

  toJSON(message: RiskSimulationPosition): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.size !== 0) {
      obj.size = message.size
    }
    if (message.entryPrice !== 0) {
      obj.entryPrice = message.entryPrice
    }
    if (message.instrumentType !== undefined) {
      obj.instrumentType = RiskSimulationInstrumentType.toJSON(message.instrumentType)
    }
    if (message.contractType !== 0) {
      obj.contractType = instrumentTypeToJSON(message.contractType)
    }
    if (message.accountId !== undefined) {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationPosition>, I>>(
    base?: I
  ): RiskSimulationPosition {
    return RiskSimulationPosition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationPosition>, I>>(
    object: I
  ): RiskSimulationPosition {
    const message = createBaseRiskSimulationPosition()
    message.asset = object.asset ?? ''
    message.size = object.size ?? 0
    message.entryPrice = object.entryPrice ?? 0
    message.instrumentType =
      object.instrumentType !== undefined && object.instrumentType !== null
        ? RiskSimulationInstrumentType.fromPartial(object.instrumentType)
        : undefined
    message.contractType = object.contractType ?? 0
    message.accountId = object.accountId ?? undefined
    return message
  },
}

function createBaseRiskSimulationInstrumentType(): RiskSimulationInstrumentType {
  return { call: undefined, put: undefined, perpetual: undefined, future: undefined }
}

export const RiskSimulationInstrumentType: MessageFns<RiskSimulationInstrumentType> = {
  encode(
    message: RiskSimulationInstrumentType,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.call !== undefined) {
      RiskSimulationCall.encode(message.call, writer.uint32(10).fork()).join()
    }
    if (message.put !== undefined) {
      RiskSimulationPut.encode(message.put, writer.uint32(18).fork()).join()
    }
    if (message.perpetual !== undefined) {
      RiskSimulationPerpetual.encode(message.perpetual, writer.uint32(26).fork()).join()
    }
    if (message.future !== undefined) {
      RiskSimulationFuture.encode(message.future, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationInstrumentType {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationInstrumentType()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.call = RiskSimulationCall.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.put = RiskSimulationPut.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.perpetual = RiskSimulationPerpetual.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.future = RiskSimulationFuture.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationInstrumentType {
    return {
      call: isSet(object.call) ? RiskSimulationCall.fromJSON(object.call) : undefined,
      put: isSet(object.put) ? RiskSimulationPut.fromJSON(object.put) : undefined,
      perpetual: isSet(object.perpetual)
        ? RiskSimulationPerpetual.fromJSON(object.perpetual)
        : undefined,
      future: isSet(object.future) ? RiskSimulationFuture.fromJSON(object.future) : undefined,
    }
  },

  toJSON(message: RiskSimulationInstrumentType): unknown {
    const obj: any = {}
    if (message.call !== undefined) {
      obj.call = RiskSimulationCall.toJSON(message.call)
    }
    if (message.put !== undefined) {
      obj.put = RiskSimulationPut.toJSON(message.put)
    }
    if (message.perpetual !== undefined) {
      obj.perpetual = RiskSimulationPerpetual.toJSON(message.perpetual)
    }
    if (message.future !== undefined) {
      obj.future = RiskSimulationFuture.toJSON(message.future)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationInstrumentType>, I>>(
    base?: I
  ): RiskSimulationInstrumentType {
    return RiskSimulationInstrumentType.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationInstrumentType>, I>>(
    object: I
  ): RiskSimulationInstrumentType {
    const message = createBaseRiskSimulationInstrumentType()
    message.call =
      object.call !== undefined && object.call !== null
        ? RiskSimulationCall.fromPartial(object.call)
        : undefined
    message.put =
      object.put !== undefined && object.put !== null
        ? RiskSimulationPut.fromPartial(object.put)
        : undefined
    message.perpetual =
      object.perpetual !== undefined && object.perpetual !== null
        ? RiskSimulationPerpetual.fromPartial(object.perpetual)
        : undefined
    message.future =
      object.future !== undefined && object.future !== null
        ? RiskSimulationFuture.fromPartial(object.future)
        : undefined
    return message
  },
}

function createBaseRiskSimulationCall(): RiskSimulationCall {
  return { strike: 0, expiry: '' }
}

export const RiskSimulationCall: MessageFns<RiskSimulationCall> = {
  encode(message: RiskSimulationCall, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strike !== 0) {
      writer.uint32(9).double(message.strike)
    }
    if (message.expiry !== '') {
      writer.uint32(18).string(message.expiry)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationCall {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationCall()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.strike = reader.double()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.expiry = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationCall {
    return {
      strike: isSet(object.strike) ? globalThis.Number(object.strike) : 0,
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : '',
    }
  },

  toJSON(message: RiskSimulationCall): unknown {
    const obj: any = {}
    if (message.strike !== 0) {
      obj.strike = message.strike
    }
    if (message.expiry !== '') {
      obj.expiry = message.expiry
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationCall>, I>>(base?: I): RiskSimulationCall {
    return RiskSimulationCall.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationCall>, I>>(object: I): RiskSimulationCall {
    const message = createBaseRiskSimulationCall()
    message.strike = object.strike ?? 0
    message.expiry = object.expiry ?? ''
    return message
  },
}

function createBaseRiskSimulationPut(): RiskSimulationPut {
  return { strike: 0, expiry: '' }
}

export const RiskSimulationPut: MessageFns<RiskSimulationPut> = {
  encode(message: RiskSimulationPut, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strike !== 0) {
      writer.uint32(9).double(message.strike)
    }
    if (message.expiry !== '') {
      writer.uint32(18).string(message.expiry)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationPut {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationPut()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.strike = reader.double()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.expiry = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationPut {
    return {
      strike: isSet(object.strike) ? globalThis.Number(object.strike) : 0,
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : '',
    }
  },

  toJSON(message: RiskSimulationPut): unknown {
    const obj: any = {}
    if (message.strike !== 0) {
      obj.strike = message.strike
    }
    if (message.expiry !== '') {
      obj.expiry = message.expiry
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationPut>, I>>(base?: I): RiskSimulationPut {
    return RiskSimulationPut.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationPut>, I>>(object: I): RiskSimulationPut {
    const message = createBaseRiskSimulationPut()
    message.strike = object.strike ?? 0
    message.expiry = object.expiry ?? ''
    return message
  },
}

function createBaseRiskSimulationPerpetual(): RiskSimulationPerpetual {
  return {}
}

export const RiskSimulationPerpetual: MessageFns<RiskSimulationPerpetual> = {
  encode(_: RiskSimulationPerpetual, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationPerpetual {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationPerpetual()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): RiskSimulationPerpetual {
    return {}
  },

  toJSON(_: RiskSimulationPerpetual): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationPerpetual>, I>>(
    base?: I
  ): RiskSimulationPerpetual {
    return RiskSimulationPerpetual.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationPerpetual>, I>>(
    _: I
  ): RiskSimulationPerpetual {
    const message = createBaseRiskSimulationPerpetual()
    return message
  },
}

function createBaseRiskSimulationFuture(): RiskSimulationFuture {
  return { expiry: '' }
}

export const RiskSimulationFuture: MessageFns<RiskSimulationFuture> = {
  encode(message: RiskSimulationFuture, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiry !== '') {
      writer.uint32(10).string(message.expiry)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationFuture {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationFuture()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.expiry = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationFuture {
    return { expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : '' }
  },

  toJSON(message: RiskSimulationFuture): unknown {
    const obj: any = {}
    if (message.expiry !== '') {
      obj.expiry = message.expiry
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationFuture>, I>>(base?: I): RiskSimulationFuture {
    return RiskSimulationFuture.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationFuture>, I>>(
    object: I
  ): RiskSimulationFuture {
    const message = createBaseRiskSimulationFuture()
    message.expiry = object.expiry ?? ''
    return message
  },
}

function createBaseRiskSimulationRequest(): RiskSimulationRequest {
  return {
    portfolio: [],
    asset: '',
    optionPriceSource: 0,
    simulationGrid: undefined,
    expiryFrom: undefined,
    expiryTo: undefined,
    accountMargins: [],
  }
}

export const RiskSimulationRequest: MessageFns<RiskSimulationRequest> = {
  encode(message: RiskSimulationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.portfolio) {
      RiskSimulationPosition.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.asset !== '') {
      writer.uint32(18).string(message.asset)
    }
    if (message.optionPriceSource !== 0) {
      writer.uint32(24).int32(message.optionPriceSource)
    }
    if (message.simulationGrid !== undefined) {
      SimulationGridParams.encode(message.simulationGrid, writer.uint32(34).fork()).join()
    }
    if (message.expiryFrom !== undefined) {
      writer.uint32(42).string(message.expiryFrom)
    }
    if (message.expiryTo !== undefined) {
      writer.uint32(50).string(message.expiryTo)
    }
    for (const v of message.accountMargins) {
      RiskSimulationAccountMargin.encode(v!, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.portfolio.push(RiskSimulationPosition.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.optionPriceSource = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.simulationGrid = SimulationGridParams.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.expiryFrom = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.expiryTo = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.accountMargins.push(RiskSimulationAccountMargin.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationRequest {
    return {
      portfolio: globalThis.Array.isArray(object?.portfolio)
        ? object.portfolio.map((e: any) => RiskSimulationPosition.fromJSON(e))
        : [],
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      optionPriceSource: isSet(object.optionPriceSource)
        ? optionPriceSourceFromJSON(object.optionPriceSource)
        : isSet(object.option_price_source)
          ? optionPriceSourceFromJSON(object.option_price_source)
          : 0,
      simulationGrid: isSet(object.simulationGrid)
        ? SimulationGridParams.fromJSON(object.simulationGrid)
        : isSet(object.simulation_grid)
          ? SimulationGridParams.fromJSON(object.simulation_grid)
          : undefined,
      expiryFrom: isSet(object.expiryFrom)
        ? globalThis.String(object.expiryFrom)
        : isSet(object.expiry_from)
          ? globalThis.String(object.expiry_from)
          : undefined,
      expiryTo: isSet(object.expiryTo)
        ? globalThis.String(object.expiryTo)
        : isSet(object.expiry_to)
          ? globalThis.String(object.expiry_to)
          : undefined,
      accountMargins: globalThis.Array.isArray(object?.accountMargins)
        ? object.accountMargins.map((e: any) => RiskSimulationAccountMargin.fromJSON(e))
        : globalThis.Array.isArray(object?.account_margins)
          ? object.account_margins.map((e: any) => RiskSimulationAccountMargin.fromJSON(e))
          : [],
    }
  },

  toJSON(message: RiskSimulationRequest): unknown {
    const obj: any = {}
    if (message.portfolio?.length) {
      obj.portfolio = message.portfolio.map((e) => RiskSimulationPosition.toJSON(e))
    }
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.optionPriceSource !== 0) {
      obj.optionPriceSource = optionPriceSourceToJSON(message.optionPriceSource)
    }
    if (message.simulationGrid !== undefined) {
      obj.simulationGrid = SimulationGridParams.toJSON(message.simulationGrid)
    }
    if (message.expiryFrom !== undefined) {
      obj.expiryFrom = message.expiryFrom
    }
    if (message.expiryTo !== undefined) {
      obj.expiryTo = message.expiryTo
    }
    if (message.accountMargins?.length) {
      obj.accountMargins = message.accountMargins.map((e) => RiskSimulationAccountMargin.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationRequest>, I>>(base?: I): RiskSimulationRequest {
    return RiskSimulationRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationRequest>, I>>(
    object: I
  ): RiskSimulationRequest {
    const message = createBaseRiskSimulationRequest()
    message.portfolio = object.portfolio?.map((e) => RiskSimulationPosition.fromPartial(e)) || []
    message.asset = object.asset ?? ''
    message.optionPriceSource = object.optionPriceSource ?? 0
    message.simulationGrid =
      object.simulationGrid !== undefined && object.simulationGrid !== null
        ? SimulationGridParams.fromPartial(object.simulationGrid)
        : undefined
    message.expiryFrom = object.expiryFrom ?? undefined
    message.expiryTo = object.expiryTo ?? undefined
    message.accountMargins =
      object.accountMargins?.map((e) => RiskSimulationAccountMargin.fromPartial(e)) || []
    return message
  },
}

function createBaseRiskSimulationAccountMargin(): RiskSimulationAccountMargin {
  return {
    accountId: '',
    poolBySettlement: false,
    marginLabel: '',
    approximate: false,
    inversePoolRegime: 0,
    linearPoolRegime: 0,
    venueImUsd: undefined,
    venueMmUsd: undefined,
    liveBook: [],
    venueMmInversePoolUsd: undefined,
    venueMmLinearPoolUsd: undefined,
  }
}

export const RiskSimulationAccountMargin: MessageFns<RiskSimulationAccountMargin> = {
  encode(
    message: RiskSimulationAccountMargin,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.poolBySettlement !== false) {
      writer.uint32(24).bool(message.poolBySettlement)
    }
    if (message.marginLabel !== '') {
      writer.uint32(50).string(message.marginLabel)
    }
    if (message.approximate !== false) {
      writer.uint32(56).bool(message.approximate)
    }
    if (message.inversePoolRegime !== 0) {
      writer.uint32(64).int32(message.inversePoolRegime)
    }
    if (message.linearPoolRegime !== 0) {
      writer.uint32(72).int32(message.linearPoolRegime)
    }
    if (message.venueImUsd !== undefined) {
      writer.uint32(81).double(message.venueImUsd)
    }
    if (message.venueMmUsd !== undefined) {
      writer.uint32(89).double(message.venueMmUsd)
    }
    for (const v of message.liveBook) {
      RiskSimulationPosition.encode(v!, writer.uint32(98).fork()).join()
    }
    if (message.venueMmInversePoolUsd !== undefined) {
      writer.uint32(105).double(message.venueMmInversePoolUsd)
    }
    if (message.venueMmLinearPoolUsd !== undefined) {
      writer.uint32(113).double(message.venueMmLinearPoolUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationAccountMargin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationAccountMargin()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.poolBySettlement = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.marginLabel = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.approximate = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.inversePoolRegime = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.linearPoolRegime = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.venueImUsd = reader.double()
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.venueMmUsd = reader.double()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.liveBook.push(RiskSimulationPosition.decode(reader, reader.uint32()))
          continue
        }
        case 13: {
          if (tag !== 105) {
            break
          }

          message.venueMmInversePoolUsd = reader.double()
          continue
        }
        case 14: {
          if (tag !== 113) {
            break
          }

          message.venueMmLinearPoolUsd = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationAccountMargin {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      poolBySettlement: isSet(object.poolBySettlement)
        ? globalThis.Boolean(object.poolBySettlement)
        : isSet(object.pool_by_settlement)
          ? globalThis.Boolean(object.pool_by_settlement)
          : false,
      marginLabel: isSet(object.marginLabel)
        ? globalThis.String(object.marginLabel)
        : isSet(object.margin_label)
          ? globalThis.String(object.margin_label)
          : '',
      approximate: isSet(object.approximate) ? globalThis.Boolean(object.approximate) : false,
      inversePoolRegime: isSet(object.inversePoolRegime)
        ? riskSimulationMarginRegimeFromJSON(object.inversePoolRegime)
        : isSet(object.inverse_pool_regime)
          ? riskSimulationMarginRegimeFromJSON(object.inverse_pool_regime)
          : 0,
      linearPoolRegime: isSet(object.linearPoolRegime)
        ? riskSimulationMarginRegimeFromJSON(object.linearPoolRegime)
        : isSet(object.linear_pool_regime)
          ? riskSimulationMarginRegimeFromJSON(object.linear_pool_regime)
          : 0,
      venueImUsd: isSet(object.venueImUsd)
        ? globalThis.Number(object.venueImUsd)
        : isSet(object.venue_im_usd)
          ? globalThis.Number(object.venue_im_usd)
          : undefined,
      venueMmUsd: isSet(object.venueMmUsd)
        ? globalThis.Number(object.venueMmUsd)
        : isSet(object.venue_mm_usd)
          ? globalThis.Number(object.venue_mm_usd)
          : undefined,
      liveBook: globalThis.Array.isArray(object?.liveBook)
        ? object.liveBook.map((e: any) => RiskSimulationPosition.fromJSON(e))
        : globalThis.Array.isArray(object?.live_book)
          ? object.live_book.map((e: any) => RiskSimulationPosition.fromJSON(e))
          : [],
      venueMmInversePoolUsd: isSet(object.venueMmInversePoolUsd)
        ? globalThis.Number(object.venueMmInversePoolUsd)
        : isSet(object.venue_mm_inverse_pool_usd)
          ? globalThis.Number(object.venue_mm_inverse_pool_usd)
          : undefined,
      venueMmLinearPoolUsd: isSet(object.venueMmLinearPoolUsd)
        ? globalThis.Number(object.venueMmLinearPoolUsd)
        : isSet(object.venue_mm_linear_pool_usd)
          ? globalThis.Number(object.venue_mm_linear_pool_usd)
          : undefined,
    }
  },

  toJSON(message: RiskSimulationAccountMargin): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.poolBySettlement !== false) {
      obj.poolBySettlement = message.poolBySettlement
    }
    if (message.marginLabel !== '') {
      obj.marginLabel = message.marginLabel
    }
    if (message.approximate !== false) {
      obj.approximate = message.approximate
    }
    if (message.inversePoolRegime !== 0) {
      obj.inversePoolRegime = riskSimulationMarginRegimeToJSON(message.inversePoolRegime)
    }
    if (message.linearPoolRegime !== 0) {
      obj.linearPoolRegime = riskSimulationMarginRegimeToJSON(message.linearPoolRegime)
    }
    if (message.venueImUsd !== undefined) {
      obj.venueImUsd = message.venueImUsd
    }
    if (message.venueMmUsd !== undefined) {
      obj.venueMmUsd = message.venueMmUsd
    }
    if (message.liveBook?.length) {
      obj.liveBook = message.liveBook.map((e) => RiskSimulationPosition.toJSON(e))
    }
    if (message.venueMmInversePoolUsd !== undefined) {
      obj.venueMmInversePoolUsd = message.venueMmInversePoolUsd
    }
    if (message.venueMmLinearPoolUsd !== undefined) {
      obj.venueMmLinearPoolUsd = message.venueMmLinearPoolUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationAccountMargin>, I>>(
    base?: I
  ): RiskSimulationAccountMargin {
    return RiskSimulationAccountMargin.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationAccountMargin>, I>>(
    object: I
  ): RiskSimulationAccountMargin {
    const message = createBaseRiskSimulationAccountMargin()
    message.accountId = object.accountId ?? ''
    message.poolBySettlement = object.poolBySettlement ?? false
    message.marginLabel = object.marginLabel ?? ''
    message.approximate = object.approximate ?? false
    message.inversePoolRegime = object.inversePoolRegime ?? 0
    message.linearPoolRegime = object.linearPoolRegime ?? 0
    message.venueImUsd = object.venueImUsd ?? undefined
    message.venueMmUsd = object.venueMmUsd ?? undefined
    message.liveBook = object.liveBook?.map((e) => RiskSimulationPosition.fromPartial(e)) || []
    message.venueMmInversePoolUsd = object.venueMmInversePoolUsd ?? undefined
    message.venueMmLinearPoolUsd = object.venueMmLinearPoolUsd ?? undefined
    return message
  },
}

function createBaseSimulationPoint(): SimulationPoint {
  return {
    price: 0,
    timestamp: '',
    pnl: 0,
    delta: 0,
    gamma: 0,
    vega: 0,
    rho: 0,
    theta: 0,
    vanna: 0,
    volga: 0,
    weightedVega: 0,
  }
}

export const SimulationPoint: MessageFns<SimulationPoint> = {
  encode(message: SimulationPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.price !== 0) {
      writer.uint32(9).double(message.price)
    }
    if (message.timestamp !== '') {
      writer.uint32(18).string(message.timestamp)
    }
    if (message.pnl !== 0) {
      writer.uint32(25).double(message.pnl)
    }
    if (message.delta !== 0) {
      writer.uint32(33).double(message.delta)
    }
    if (message.gamma !== 0) {
      writer.uint32(41).double(message.gamma)
    }
    if (message.vega !== 0) {
      writer.uint32(49).double(message.vega)
    }
    if (message.rho !== 0) {
      writer.uint32(57).double(message.rho)
    }
    if (message.theta !== 0) {
      writer.uint32(65).double(message.theta)
    }
    if (message.vanna !== 0) {
      writer.uint32(73).double(message.vanna)
    }
    if (message.volga !== 0) {
      writer.uint32(81).double(message.volga)
    }
    if (message.weightedVega !== 0) {
      writer.uint32(89).double(message.weightedVega)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimulationPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSimulationPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break
          }

          message.price = reader.double()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.timestamp = reader.string()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.pnl = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.delta = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.gamma = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.vega = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.rho = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.theta = reader.double()
          continue
        }
        case 9: {
          if (tag !== 73) {
            break
          }

          message.vanna = reader.double()
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.volga = reader.double()
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.weightedVega = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SimulationPoint {
    return {
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '',
      pnl: isSet(object.pnl) ? globalThis.Number(object.pnl) : 0,
      delta: isSet(object.delta) ? globalThis.Number(object.delta) : 0,
      gamma: isSet(object.gamma) ? globalThis.Number(object.gamma) : 0,
      vega: isSet(object.vega) ? globalThis.Number(object.vega) : 0,
      rho: isSet(object.rho) ? globalThis.Number(object.rho) : 0,
      theta: isSet(object.theta) ? globalThis.Number(object.theta) : 0,
      vanna: isSet(object.vanna) ? globalThis.Number(object.vanna) : 0,
      volga: isSet(object.volga) ? globalThis.Number(object.volga) : 0,
      weightedVega: isSet(object.weightedVega)
        ? globalThis.Number(object.weightedVega)
        : isSet(object.weighted_vega)
          ? globalThis.Number(object.weighted_vega)
          : 0,
    }
  },

  toJSON(message: SimulationPoint): unknown {
    const obj: any = {}
    if (message.price !== 0) {
      obj.price = message.price
    }
    if (message.timestamp !== '') {
      obj.timestamp = message.timestamp
    }
    if (message.pnl !== 0) {
      obj.pnl = message.pnl
    }
    if (message.delta !== 0) {
      obj.delta = message.delta
    }
    if (message.gamma !== 0) {
      obj.gamma = message.gamma
    }
    if (message.vega !== 0) {
      obj.vega = message.vega
    }
    if (message.rho !== 0) {
      obj.rho = message.rho
    }
    if (message.theta !== 0) {
      obj.theta = message.theta
    }
    if (message.vanna !== 0) {
      obj.vanna = message.vanna
    }
    if (message.volga !== 0) {
      obj.volga = message.volga
    }
    if (message.weightedVega !== 0) {
      obj.weightedVega = message.weightedVega
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SimulationPoint>, I>>(base?: I): SimulationPoint {
    return SimulationPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SimulationPoint>, I>>(object: I): SimulationPoint {
    const message = createBaseSimulationPoint()
    message.price = object.price ?? 0
    message.timestamp = object.timestamp ?? ''
    message.pnl = object.pnl ?? 0
    message.delta = object.delta ?? 0
    message.gamma = object.gamma ?? 0
    message.vega = object.vega ?? 0
    message.rho = object.rho ?? 0
    message.theta = object.theta ?? 0
    message.vanna = object.vanna ?? 0
    message.volga = object.volga ?? 0
    message.weightedVega = object.weightedVega ?? 0
    return message
  },
}

function createBaseRiskSimulationResponse(): RiskSimulationResponse {
  return {
    volSurfacesUpdated: false,
    resultsUsd: [],
    resultsBase: [],
    breakEvens: [],
    accounts: [],
    resultUrl: '',
    tableUsd: undefined,
    tableBase: undefined,
  }
}

export const RiskSimulationResponse: MessageFns<RiskSimulationResponse> = {
  encode(message: RiskSimulationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.volSurfacesUpdated !== false) {
      writer.uint32(8).bool(message.volSurfacesUpdated)
    }
    for (const v of message.resultsUsd) {
      SimulationPoint.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.resultsBase) {
      SimulationPoint.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.breakEvens) {
      BreakEvenSlice.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.accounts) {
      RiskSimulationAccountMargin.encode(v!, writer.uint32(42).fork()).join()
    }
    if (message.resultUrl !== '') {
      writer.uint32(50).string(message.resultUrl)
    }
    if (message.tableUsd !== undefined) {
      RiskSimulationTable.encode(message.tableUsd, writer.uint32(58).fork()).join()
    }
    if (message.tableBase !== undefined) {
      RiskSimulationTable.encode(message.tableBase, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.volSurfacesUpdated = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.resultsUsd.push(SimulationPoint.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.resultsBase.push(SimulationPoint.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.breakEvens.push(BreakEvenSlice.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.accounts.push(RiskSimulationAccountMargin.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.resultUrl = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.tableUsd = RiskSimulationTable.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.tableBase = RiskSimulationTable.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationResponse {
    return {
      volSurfacesUpdated: isSet(object.volSurfacesUpdated)
        ? globalThis.Boolean(object.volSurfacesUpdated)
        : isSet(object.vol_surfaces_updated)
          ? globalThis.Boolean(object.vol_surfaces_updated)
          : false,
      resultsUsd: globalThis.Array.isArray(object?.resultsUsd)
        ? object.resultsUsd.map((e: any) => SimulationPoint.fromJSON(e))
        : globalThis.Array.isArray(object?.results_usd)
          ? object.results_usd.map((e: any) => SimulationPoint.fromJSON(e))
          : [],
      resultsBase: globalThis.Array.isArray(object?.resultsBase)
        ? object.resultsBase.map((e: any) => SimulationPoint.fromJSON(e))
        : globalThis.Array.isArray(object?.results_base)
          ? object.results_base.map((e: any) => SimulationPoint.fromJSON(e))
          : [],
      breakEvens: globalThis.Array.isArray(object?.breakEvens)
        ? object.breakEvens.map((e: any) => BreakEvenSlice.fromJSON(e))
        : globalThis.Array.isArray(object?.break_evens)
          ? object.break_evens.map((e: any) => BreakEvenSlice.fromJSON(e))
          : [],
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => RiskSimulationAccountMargin.fromJSON(e))
        : [],
      resultUrl: isSet(object.resultUrl)
        ? globalThis.String(object.resultUrl)
        : isSet(object.result_url)
          ? globalThis.String(object.result_url)
          : '',
      tableUsd: isSet(object.tableUsd)
        ? RiskSimulationTable.fromJSON(object.tableUsd)
        : isSet(object.table_usd)
          ? RiskSimulationTable.fromJSON(object.table_usd)
          : undefined,
      tableBase: isSet(object.tableBase)
        ? RiskSimulationTable.fromJSON(object.tableBase)
        : isSet(object.table_base)
          ? RiskSimulationTable.fromJSON(object.table_base)
          : undefined,
    }
  },

  toJSON(message: RiskSimulationResponse): unknown {
    const obj: any = {}
    if (message.volSurfacesUpdated !== false) {
      obj.volSurfacesUpdated = message.volSurfacesUpdated
    }
    if (message.resultsUsd?.length) {
      obj.resultsUsd = message.resultsUsd.map((e) => SimulationPoint.toJSON(e))
    }
    if (message.resultsBase?.length) {
      obj.resultsBase = message.resultsBase.map((e) => SimulationPoint.toJSON(e))
    }
    if (message.breakEvens?.length) {
      obj.breakEvens = message.breakEvens.map((e) => BreakEvenSlice.toJSON(e))
    }
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => RiskSimulationAccountMargin.toJSON(e))
    }
    if (message.resultUrl !== '') {
      obj.resultUrl = message.resultUrl
    }
    if (message.tableUsd !== undefined) {
      obj.tableUsd = RiskSimulationTable.toJSON(message.tableUsd)
    }
    if (message.tableBase !== undefined) {
      obj.tableBase = RiskSimulationTable.toJSON(message.tableBase)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationResponse>, I>>(
    base?: I
  ): RiskSimulationResponse {
    return RiskSimulationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationResponse>, I>>(
    object: I
  ): RiskSimulationResponse {
    const message = createBaseRiskSimulationResponse()
    message.volSurfacesUpdated = object.volSurfacesUpdated ?? false
    message.resultsUsd = object.resultsUsd?.map((e) => SimulationPoint.fromPartial(e)) || []
    message.resultsBase = object.resultsBase?.map((e) => SimulationPoint.fromPartial(e)) || []
    message.breakEvens = object.breakEvens?.map((e) => BreakEvenSlice.fromPartial(e)) || []
    message.accounts = object.accounts?.map((e) => RiskSimulationAccountMargin.fromPartial(e)) || []
    message.resultUrl = object.resultUrl ?? ''
    message.tableUsd =
      object.tableUsd !== undefined && object.tableUsd !== null
        ? RiskSimulationTable.fromPartial(object.tableUsd)
        : undefined
    message.tableBase =
      object.tableBase !== undefined && object.tableBase !== null
        ? RiskSimulationTable.fromPartial(object.tableBase)
        : undefined
    return message
  },
}

function createBaseRiskSimulationTable(): RiskSimulationTable {
  return {
    prices: [],
    timestamps: [],
    pnl: [],
    delta: [],
    gamma: [],
    vega: [],
    rho: [],
    theta: [],
    vanna: [],
    volga: [],
    weightedVega: [],
    charm: [],
    smileDelta: [],
    skewDelta: [],
    attributionDelta: [],
    attributionGamma: [],
    attributionVega: [],
    attributionTheta: [],
    attributionVanna: [],
    attributionVolga: [],
    attributionResidual: [],
    attributionCoinRevaluation: [],
    accounts: [],
  }
}

export const RiskSimulationTable: MessageFns<RiskSimulationTable> = {
  encode(message: RiskSimulationTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.prices) {
      writer.double(v)
    }
    writer.join()
    for (const v of message.timestamps) {
      writer.uint32(18).string(v!)
    }
    writer.uint32(26).fork()
    for (const v of message.pnl) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(34).fork()
    for (const v of message.delta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.gamma) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(50).fork()
    for (const v of message.vega) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(58).fork()
    for (const v of message.rho) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.theta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.vanna) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.volga) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(90).fork()
    for (const v of message.weightedVega) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(98).fork()
    for (const v of message.charm) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(106).fork()
    for (const v of message.smileDelta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(114).fork()
    for (const v of message.skewDelta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(122).fork()
    for (const v of message.attributionDelta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(130).fork()
    for (const v of message.attributionGamma) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(138).fork()
    for (const v of message.attributionVega) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(146).fork()
    for (const v of message.attributionTheta) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(154).fork()
    for (const v of message.attributionVanna) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(162).fork()
    for (const v of message.attributionVolga) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(170).fork()
    for (const v of message.attributionResidual) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(178).fork()
    for (const v of message.attributionCoinRevaluation) {
      writer.float(v)
    }
    writer.join()
    for (const v of message.accounts) {
      RiskSimulationAccountColumns.encode(v!, writer.uint32(186).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationTable()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.prices.push(reader.double())

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.prices.push(reader.double())
            }

            continue
          }

          break
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.timestamps.push(reader.string())
          continue
        }
        case 3: {
          if (tag === 29) {
            message.pnl.push(reader.float())

            continue
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.pnl.push(reader.float())
            }

            continue
          }

          break
        }
        case 4: {
          if (tag === 37) {
            message.delta.push(reader.float())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.delta.push(reader.float())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 45) {
            message.gamma.push(reader.float())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.gamma.push(reader.float())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag === 53) {
            message.vega.push(reader.float())

            continue
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.vega.push(reader.float())
            }

            continue
          }

          break
        }
        case 7: {
          if (tag === 61) {
            message.rho.push(reader.float())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.rho.push(reader.float())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 69) {
            message.theta.push(reader.float())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.theta.push(reader.float())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 77) {
            message.vanna.push(reader.float())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.vanna.push(reader.float())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 85) {
            message.volga.push(reader.float())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.volga.push(reader.float())
            }

            continue
          }

          break
        }
        case 11: {
          if (tag === 93) {
            message.weightedVega.push(reader.float())

            continue
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.weightedVega.push(reader.float())
            }

            continue
          }

          break
        }
        case 12: {
          if (tag === 101) {
            message.charm.push(reader.float())

            continue
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.charm.push(reader.float())
            }

            continue
          }

          break
        }
        case 13: {
          if (tag === 109) {
            message.smileDelta.push(reader.float())

            continue
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.smileDelta.push(reader.float())
            }

            continue
          }

          break
        }
        case 14: {
          if (tag === 117) {
            message.skewDelta.push(reader.float())

            continue
          }

          if (tag === 114) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.skewDelta.push(reader.float())
            }

            continue
          }

          break
        }
        case 15: {
          if (tag === 125) {
            message.attributionDelta.push(reader.float())

            continue
          }

          if (tag === 122) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionDelta.push(reader.float())
            }

            continue
          }

          break
        }
        case 16: {
          if (tag === 133) {
            message.attributionGamma.push(reader.float())

            continue
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionGamma.push(reader.float())
            }

            continue
          }

          break
        }
        case 17: {
          if (tag === 141) {
            message.attributionVega.push(reader.float())

            continue
          }

          if (tag === 138) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionVega.push(reader.float())
            }

            continue
          }

          break
        }
        case 18: {
          if (tag === 149) {
            message.attributionTheta.push(reader.float())

            continue
          }

          if (tag === 146) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionTheta.push(reader.float())
            }

            continue
          }

          break
        }
        case 19: {
          if (tag === 157) {
            message.attributionVanna.push(reader.float())

            continue
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionVanna.push(reader.float())
            }

            continue
          }

          break
        }
        case 20: {
          if (tag === 165) {
            message.attributionVolga.push(reader.float())

            continue
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionVolga.push(reader.float())
            }

            continue
          }

          break
        }
        case 21: {
          if (tag === 173) {
            message.attributionResidual.push(reader.float())

            continue
          }

          if (tag === 170) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionResidual.push(reader.float())
            }

            continue
          }

          break
        }
        case 22: {
          if (tag === 181) {
            message.attributionCoinRevaluation.push(reader.float())

            continue
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.attributionCoinRevaluation.push(reader.float())
            }

            continue
          }

          break
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.accounts.push(RiskSimulationAccountColumns.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationTable {
    return {
      prices: globalThis.Array.isArray(object?.prices)
        ? object.prices.map((e: any) => globalThis.Number(e))
        : [],
      timestamps: globalThis.Array.isArray(object?.timestamps)
        ? object.timestamps.map((e: any) => globalThis.String(e))
        : [],
      pnl: globalThis.Array.isArray(object?.pnl)
        ? object.pnl.map((e: any) => globalThis.Number(e))
        : [],
      delta: globalThis.Array.isArray(object?.delta)
        ? object.delta.map((e: any) => globalThis.Number(e))
        : [],
      gamma: globalThis.Array.isArray(object?.gamma)
        ? object.gamma.map((e: any) => globalThis.Number(e))
        : [],
      vega: globalThis.Array.isArray(object?.vega)
        ? object.vega.map((e: any) => globalThis.Number(e))
        : [],
      rho: globalThis.Array.isArray(object?.rho)
        ? object.rho.map((e: any) => globalThis.Number(e))
        : [],
      theta: globalThis.Array.isArray(object?.theta)
        ? object.theta.map((e: any) => globalThis.Number(e))
        : [],
      vanna: globalThis.Array.isArray(object?.vanna)
        ? object.vanna.map((e: any) => globalThis.Number(e))
        : [],
      volga: globalThis.Array.isArray(object?.volga)
        ? object.volga.map((e: any) => globalThis.Number(e))
        : [],
      weightedVega: globalThis.Array.isArray(object?.weightedVega)
        ? object.weightedVega.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.weighted_vega)
          ? object.weighted_vega.map((e: any) => globalThis.Number(e))
          : [],
      charm: globalThis.Array.isArray(object?.charm)
        ? object.charm.map((e: any) => globalThis.Number(e))
        : [],
      smileDelta: globalThis.Array.isArray(object?.smileDelta)
        ? object.smileDelta.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.smile_delta)
          ? object.smile_delta.map((e: any) => globalThis.Number(e))
          : [],
      skewDelta: globalThis.Array.isArray(object?.skewDelta)
        ? object.skewDelta.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.skew_delta)
          ? object.skew_delta.map((e: any) => globalThis.Number(e))
          : [],
      attributionDelta: globalThis.Array.isArray(object?.attributionDelta)
        ? object.attributionDelta.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_delta)
          ? object.attribution_delta.map((e: any) => globalThis.Number(e))
          : [],
      attributionGamma: globalThis.Array.isArray(object?.attributionGamma)
        ? object.attributionGamma.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_gamma)
          ? object.attribution_gamma.map((e: any) => globalThis.Number(e))
          : [],
      attributionVega: globalThis.Array.isArray(object?.attributionVega)
        ? object.attributionVega.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_vega)
          ? object.attribution_vega.map((e: any) => globalThis.Number(e))
          : [],
      attributionTheta: globalThis.Array.isArray(object?.attributionTheta)
        ? object.attributionTheta.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_theta)
          ? object.attribution_theta.map((e: any) => globalThis.Number(e))
          : [],
      attributionVanna: globalThis.Array.isArray(object?.attributionVanna)
        ? object.attributionVanna.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_vanna)
          ? object.attribution_vanna.map((e: any) => globalThis.Number(e))
          : [],
      attributionVolga: globalThis.Array.isArray(object?.attributionVolga)
        ? object.attributionVolga.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_volga)
          ? object.attribution_volga.map((e: any) => globalThis.Number(e))
          : [],
      attributionResidual: globalThis.Array.isArray(object?.attributionResidual)
        ? object.attributionResidual.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_residual)
          ? object.attribution_residual.map((e: any) => globalThis.Number(e))
          : [],
      attributionCoinRevaluation: globalThis.Array.isArray(object?.attributionCoinRevaluation)
        ? object.attributionCoinRevaluation.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.attribution_coin_revaluation)
          ? object.attribution_coin_revaluation.map((e: any) => globalThis.Number(e))
          : [],
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => RiskSimulationAccountColumns.fromJSON(e))
        : [],
    }
  },

  toJSON(message: RiskSimulationTable): unknown {
    const obj: any = {}
    if (message.prices?.length) {
      obj.prices = message.prices
    }
    if (message.timestamps?.length) {
      obj.timestamps = message.timestamps
    }
    if (message.pnl?.length) {
      obj.pnl = message.pnl
    }
    if (message.delta?.length) {
      obj.delta = message.delta
    }
    if (message.gamma?.length) {
      obj.gamma = message.gamma
    }
    if (message.vega?.length) {
      obj.vega = message.vega
    }
    if (message.rho?.length) {
      obj.rho = message.rho
    }
    if (message.theta?.length) {
      obj.theta = message.theta
    }
    if (message.vanna?.length) {
      obj.vanna = message.vanna
    }
    if (message.volga?.length) {
      obj.volga = message.volga
    }
    if (message.weightedVega?.length) {
      obj.weightedVega = message.weightedVega
    }
    if (message.charm?.length) {
      obj.charm = message.charm
    }
    if (message.smileDelta?.length) {
      obj.smileDelta = message.smileDelta
    }
    if (message.skewDelta?.length) {
      obj.skewDelta = message.skewDelta
    }
    if (message.attributionDelta?.length) {
      obj.attributionDelta = message.attributionDelta
    }
    if (message.attributionGamma?.length) {
      obj.attributionGamma = message.attributionGamma
    }
    if (message.attributionVega?.length) {
      obj.attributionVega = message.attributionVega
    }
    if (message.attributionTheta?.length) {
      obj.attributionTheta = message.attributionTheta
    }
    if (message.attributionVanna?.length) {
      obj.attributionVanna = message.attributionVanna
    }
    if (message.attributionVolga?.length) {
      obj.attributionVolga = message.attributionVolga
    }
    if (message.attributionResidual?.length) {
      obj.attributionResidual = message.attributionResidual
    }
    if (message.attributionCoinRevaluation?.length) {
      obj.attributionCoinRevaluation = message.attributionCoinRevaluation
    }
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => RiskSimulationAccountColumns.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationTable>, I>>(base?: I): RiskSimulationTable {
    return RiskSimulationTable.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationTable>, I>>(
    object: I
  ): RiskSimulationTable {
    const message = createBaseRiskSimulationTable()
    message.prices = object.prices?.map((e) => e) || []
    message.timestamps = object.timestamps?.map((e) => e) || []
    message.pnl = object.pnl?.map((e) => e) || []
    message.delta = object.delta?.map((e) => e) || []
    message.gamma = object.gamma?.map((e) => e) || []
    message.vega = object.vega?.map((e) => e) || []
    message.rho = object.rho?.map((e) => e) || []
    message.theta = object.theta?.map((e) => e) || []
    message.vanna = object.vanna?.map((e) => e) || []
    message.volga = object.volga?.map((e) => e) || []
    message.weightedVega = object.weightedVega?.map((e) => e) || []
    message.charm = object.charm?.map((e) => e) || []
    message.smileDelta = object.smileDelta?.map((e) => e) || []
    message.skewDelta = object.skewDelta?.map((e) => e) || []
    message.attributionDelta = object.attributionDelta?.map((e) => e) || []
    message.attributionGamma = object.attributionGamma?.map((e) => e) || []
    message.attributionVega = object.attributionVega?.map((e) => e) || []
    message.attributionTheta = object.attributionTheta?.map((e) => e) || []
    message.attributionVanna = object.attributionVanna?.map((e) => e) || []
    message.attributionVolga = object.attributionVolga?.map((e) => e) || []
    message.attributionResidual = object.attributionResidual?.map((e) => e) || []
    message.attributionCoinRevaluation = object.attributionCoinRevaluation?.map((e) => e) || []
    message.accounts =
      object.accounts?.map((e) => RiskSimulationAccountColumns.fromPartial(e)) || []
    return message
  },
}

function createBaseRiskSimulationAccountColumns(): RiskSimulationAccountColumns {
  return { initialMargin: [], maintenanceMargin: [] }
}

export const RiskSimulationAccountColumns: MessageFns<RiskSimulationAccountColumns> = {
  encode(
    message: RiskSimulationAccountColumns,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.initialMargin) {
      writer.float(v)
    }
    writer.join()
    writer.uint32(18).fork()
    for (const v of message.maintenanceMargin) {
      writer.float(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiskSimulationAccountColumns {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRiskSimulationAccountColumns()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 13) {
            message.initialMargin.push(reader.float())

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.initialMargin.push(reader.float())
            }

            continue
          }

          break
        }
        case 2: {
          if (tag === 21) {
            message.maintenanceMargin.push(reader.float())

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.maintenanceMargin.push(reader.float())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RiskSimulationAccountColumns {
    return {
      initialMargin: globalThis.Array.isArray(object?.initialMargin)
        ? object.initialMargin.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.initial_margin)
          ? object.initial_margin.map((e: any) => globalThis.Number(e))
          : [],
      maintenanceMargin: globalThis.Array.isArray(object?.maintenanceMargin)
        ? object.maintenanceMargin.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.maintenance_margin)
          ? object.maintenance_margin.map((e: any) => globalThis.Number(e))
          : [],
    }
  },

  toJSON(message: RiskSimulationAccountColumns): unknown {
    const obj: any = {}
    if (message.initialMargin?.length) {
      obj.initialMargin = message.initialMargin
    }
    if (message.maintenanceMargin?.length) {
      obj.maintenanceMargin = message.maintenanceMargin
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RiskSimulationAccountColumns>, I>>(
    base?: I
  ): RiskSimulationAccountColumns {
    return RiskSimulationAccountColumns.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RiskSimulationAccountColumns>, I>>(
    object: I
  ): RiskSimulationAccountColumns {
    const message = createBaseRiskSimulationAccountColumns()
    message.initialMargin = object.initialMargin?.map((e) => e) || []
    message.maintenanceMargin = object.maintenanceMargin?.map((e) => e) || []
    return message
  },
}

function createBaseBreakEvenSlice(): BreakEvenSlice {
  return { timestamp: '', prices: [] }
}

export const BreakEvenSlice: MessageFns<BreakEvenSlice> = {
  encode(message: BreakEvenSlice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== '') {
      writer.uint32(10).string(message.timestamp)
    }
    writer.uint32(18).fork()
    for (const v of message.prices) {
      writer.double(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BreakEvenSlice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBreakEvenSlice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.timestamp = reader.string()
          continue
        }
        case 2: {
          if (tag === 17) {
            message.prices.push(reader.double())

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.prices.push(reader.double())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BreakEvenSlice {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '',
      prices: globalThis.Array.isArray(object?.prices)
        ? object.prices.map((e: any) => globalThis.Number(e))
        : [],
    }
  },

  toJSON(message: BreakEvenSlice): unknown {
    const obj: any = {}
    if (message.timestamp !== '') {
      obj.timestamp = message.timestamp
    }
    if (message.prices?.length) {
      obj.prices = message.prices
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BreakEvenSlice>, I>>(base?: I): BreakEvenSlice {
    return BreakEvenSlice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BreakEvenSlice>, I>>(object: I): BreakEvenSlice {
    const message = createBaseBreakEvenSlice()
    message.timestamp = object.timestamp ?? ''
    message.prices = object.prices?.map((e) => e) || []
    return message
  },
}

function createBaseGetPositionsViewResponse(): GetPositionsViewResponse {
  return { mode: 0, groups: [], ungroupedPositions: [], entries: [] }
}

export const GetPositionsViewResponse: MessageFns<GetPositionsViewResponse> = {
  encode(
    message: GetPositionsViewResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode)
    }
    for (const v of message.groups) {
      GroupedPositionNode.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.ungroupedPositions) {
      Position.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.entries) {
      PositionViewEntry.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPositionsViewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPositionsViewResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.groups.push(GroupedPositionNode.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.ungroupedPositions.push(Position.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.entries.push(PositionViewEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPositionsViewResponse {
    return {
      mode: isSet(object.mode) ? positionViewModeFromJSON(object.mode) : 0,
      groups: globalThis.Array.isArray(object?.groups)
        ? object.groups.map((e: any) => GroupedPositionNode.fromJSON(e))
        : [],
      ungroupedPositions: globalThis.Array.isArray(object?.ungroupedPositions)
        ? object.ungroupedPositions.map((e: any) => Position.fromJSON(e))
        : globalThis.Array.isArray(object?.ungrouped_positions)
          ? object.ungrouped_positions.map((e: any) => Position.fromJSON(e))
          : [],
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => PositionViewEntry.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetPositionsViewResponse): unknown {
    const obj: any = {}
    if (message.mode !== 0) {
      obj.mode = positionViewModeToJSON(message.mode)
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => GroupedPositionNode.toJSON(e))
    }
    if (message.ungroupedPositions?.length) {
      obj.ungroupedPositions = message.ungroupedPositions.map((e) => Position.toJSON(e))
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => PositionViewEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPositionsViewResponse>, I>>(
    base?: I
  ): GetPositionsViewResponse {
    return GetPositionsViewResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPositionsViewResponse>, I>>(
    object: I
  ): GetPositionsViewResponse {
    const message = createBaseGetPositionsViewResponse()
    message.mode = object.mode ?? 0
    message.groups = object.groups?.map((e) => GroupedPositionNode.fromPartial(e)) || []
    message.ungroupedPositions =
      object.ungroupedPositions?.map((e) => Position.fromPartial(e)) || []
    message.entries = object.entries?.map((e) => PositionViewEntry.fromPartial(e)) || []
    return message
  },
}

function createBasePageMeta(): PageMeta {
  return {
    pageId: '',
    name: '',
    isActive: false,
    gridCols: 0,
    gridMargin: 0,
    createdAt: '0',
    updatedAt: '0',
  }
}

export const PageMeta: MessageFns<PageMeta> = {
  encode(message: PageMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.isActive !== false) {
      writer.uint32(24).bool(message.isActive)
    }
    if (message.gridCols !== 0) {
      writer.uint32(32).int32(message.gridCols)
    }
    if (message.gridMargin !== 0) {
      writer.uint32(40).int32(message.gridMargin)
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(56).int64(message.updatedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PageMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePageMeta()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.gridCols = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.gridMargin = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PageMeta {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : false,
      gridCols: isSet(object.gridCols)
        ? globalThis.Number(object.gridCols)
        : isSet(object.grid_cols)
          ? globalThis.Number(object.grid_cols)
          : 0,
      gridMargin: isSet(object.gridMargin)
        ? globalThis.Number(object.gridMargin)
        : isSet(object.grid_margin)
          ? globalThis.Number(object.grid_margin)
          : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
    }
  },

  toJSON(message: PageMeta): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive
    }
    if (message.gridCols !== 0) {
      obj.gridCols = Math.round(message.gridCols)
    }
    if (message.gridMargin !== 0) {
      obj.gridMargin = Math.round(message.gridMargin)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PageMeta>, I>>(base?: I): PageMeta {
    return PageMeta.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PageMeta>, I>>(object: I): PageMeta {
    const message = createBasePageMeta()
    message.pageId = object.pageId ?? ''
    message.name = object.name ?? ''
    message.isActive = object.isActive ?? false
    message.gridCols = object.gridCols ?? 0
    message.gridMargin = object.gridMargin ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    return message
  },
}

function createBaseWidgetInstance(): WidgetInstance {
  return {
    pageId: '',
    widgetId: '',
    widgetType: '',
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    minW: 0,
    minH: 0,
    config: {},
    updatedAt: '0',
  }
}

export const WidgetInstance: MessageFns<WidgetInstance> = {
  encode(message: WidgetInstance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.widgetId !== '') {
      writer.uint32(18).string(message.widgetId)
    }
    if (message.widgetType !== '') {
      writer.uint32(26).string(message.widgetType)
    }
    if (message.x !== 0) {
      writer.uint32(32).int32(message.x)
    }
    if (message.y !== 0) {
      writer.uint32(40).int32(message.y)
    }
    if (message.w !== 0) {
      writer.uint32(48).int32(message.w)
    }
    if (message.h !== 0) {
      writer.uint32(56).int32(message.h)
    }
    if (message.minW !== 0) {
      writer.uint32(64).int32(message.minW)
    }
    if (message.minH !== 0) {
      writer.uint32(72).int32(message.minH)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      WidgetInstance_ConfigEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).join()
    })
    if (message.updatedAt !== '0') {
      writer.uint32(88).int64(message.updatedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WidgetInstance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWidgetInstance()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.widgetId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.widgetType = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.x = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.y = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.w = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.h = reader.int32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.minW = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.minH = reader.int32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          const entry10 = WidgetInstance_ConfigEntry.decode(reader, reader.uint32())
          if (entry10.value !== undefined) {
            message.config[entry10.key] = entry10.value
          }
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WidgetInstance {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      widgetId: isSet(object.widgetId)
        ? globalThis.String(object.widgetId)
        : isSet(object.widget_id)
          ? globalThis.String(object.widget_id)
          : '',
      widgetType: isSet(object.widgetType)
        ? globalThis.String(object.widgetType)
        : isSet(object.widget_type)
          ? globalThis.String(object.widget_type)
          : '',
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
      h: isSet(object.h) ? globalThis.Number(object.h) : 0,
      minW: isSet(object.minW)
        ? globalThis.Number(object.minW)
        : isSet(object.min_w)
          ? globalThis.Number(object.min_w)
          : 0,
      minH: isSet(object.minH)
        ? globalThis.Number(object.minH)
        : isSet(object.min_h)
          ? globalThis.Number(object.min_h)
          : 0,
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
    }
  },

  toJSON(message: WidgetInstance): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.widgetId !== '') {
      obj.widgetId = message.widgetId
    }
    if (message.widgetType !== '') {
      obj.widgetType = message.widgetType
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x)
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y)
    }
    if (message.w !== 0) {
      obj.w = Math.round(message.w)
    }
    if (message.h !== 0) {
      obj.h = Math.round(message.h)
    }
    if (message.minW !== 0) {
      obj.minW = Math.round(message.minW)
    }
    if (message.minH !== 0) {
      obj.minH = Math.round(message.minH)
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WidgetInstance>, I>>(base?: I): WidgetInstance {
    return WidgetInstance.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WidgetInstance>, I>>(object: I): WidgetInstance {
    const message = createBaseWidgetInstance()
    message.pageId = object.pageId ?? ''
    message.widgetId = object.widgetId ?? ''
    message.widgetType = object.widgetType ?? ''
    message.x = object.x ?? 0
    message.y = object.y ?? 0
    message.w = object.w ?? 0
    message.h = object.h ?? 0
    message.minW = object.minW ?? 0
    message.minH = object.minH ?? 0
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    message.updatedAt = object.updatedAt ?? '0'
    return message
  },
}

function createBaseWidgetInstance_ConfigEntry(): WidgetInstance_ConfigEntry {
  return { key: '', value: '' }
}

export const WidgetInstance_ConfigEntry: MessageFns<WidgetInstance_ConfigEntry> = {
  encode(
    message: WidgetInstance_ConfigEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WidgetInstance_ConfigEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWidgetInstance_ConfigEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WidgetInstance_ConfigEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: WidgetInstance_ConfigEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WidgetInstance_ConfigEntry>, I>>(
    base?: I
  ): WidgetInstance_ConfigEntry {
    return WidgetInstance_ConfigEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WidgetInstance_ConfigEntry>, I>>(
    object: I
  ): WidgetInstance_ConfigEntry {
    const message = createBaseWidgetInstance_ConfigEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseComponentPreference(): ComponentPreference {
  return {
    componentId: '',
    searchTerm: undefined,
    tickerFilter: undefined,
    columnOrder: [],
    config: {},
    updatedAt: '0',
  }
}

export const ComponentPreference: MessageFns<ComponentPreference> = {
  encode(message: ComponentPreference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.componentId !== '') {
      writer.uint32(10).string(message.componentId)
    }
    if (message.searchTerm !== undefined) {
      writer.uint32(18).string(message.searchTerm)
    }
    if (message.tickerFilter !== undefined) {
      writer.uint32(26).string(message.tickerFilter)
    }
    for (const v of message.columnOrder) {
      writer.uint32(34).string(v!)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      ComponentPreference_ConfigEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork()
      ).join()
    })
    if (message.updatedAt !== '0') {
      writer.uint32(48).int64(message.updatedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentPreference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseComponentPreference()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.componentId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.searchTerm = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tickerFilter = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.columnOrder.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          const entry5 = ComponentPreference_ConfigEntry.decode(reader, reader.uint32())
          if (entry5.value !== undefined) {
            message.config[entry5.key] = entry5.value
          }
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ComponentPreference {
    return {
      componentId: isSet(object.componentId)
        ? globalThis.String(object.componentId)
        : isSet(object.component_id)
          ? globalThis.String(object.component_id)
          : '',
      searchTerm: isSet(object.searchTerm)
        ? globalThis.String(object.searchTerm)
        : isSet(object.search_term)
          ? globalThis.String(object.search_term)
          : undefined,
      tickerFilter: isSet(object.tickerFilter)
        ? globalThis.String(object.tickerFilter)
        : isSet(object.ticker_filter)
          ? globalThis.String(object.ticker_filter)
          : undefined,
      columnOrder: globalThis.Array.isArray(object?.columnOrder)
        ? object.columnOrder.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.column_order)
          ? object.column_order.map((e: any) => globalThis.String(e))
          : [],
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
    }
  },

  toJSON(message: ComponentPreference): unknown {
    const obj: any = {}
    if (message.componentId !== '') {
      obj.componentId = message.componentId
    }
    if (message.searchTerm !== undefined) {
      obj.searchTerm = message.searchTerm
    }
    if (message.tickerFilter !== undefined) {
      obj.tickerFilter = message.tickerFilter
    }
    if (message.columnOrder?.length) {
      obj.columnOrder = message.columnOrder
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ComponentPreference>, I>>(base?: I): ComponentPreference {
    return ComponentPreference.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ComponentPreference>, I>>(
    object: I
  ): ComponentPreference {
    const message = createBaseComponentPreference()
    message.componentId = object.componentId ?? ''
    message.searchTerm = object.searchTerm ?? undefined
    message.tickerFilter = object.tickerFilter ?? undefined
    message.columnOrder = object.columnOrder?.map((e) => e) || []
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    message.updatedAt = object.updatedAt ?? '0'
    return message
  },
}

function createBaseComponentPreference_ConfigEntry(): ComponentPreference_ConfigEntry {
  return { key: '', value: '' }
}

export const ComponentPreference_ConfigEntry: MessageFns<ComponentPreference_ConfigEntry> = {
  encode(
    message: ComponentPreference_ConfigEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentPreference_ConfigEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseComponentPreference_ConfigEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ComponentPreference_ConfigEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: ComponentPreference_ConfigEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ComponentPreference_ConfigEntry>, I>>(
    base?: I
  ): ComponentPreference_ConfigEntry {
    return ComponentPreference_ConfigEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ComponentPreference_ConfigEntry>, I>>(
    object: I
  ): ComponentPreference_ConfigEntry {
    const message = createBaseComponentPreference_ConfigEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseCreatePageRequest(): CreatePageRequest {
  return { pageId: '', name: '', isActive: undefined, gridCols: undefined, gridMargin: undefined }
}

export const CreatePageRequest: MessageFns<CreatePageRequest> = {
  encode(message: CreatePageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.isActive !== undefined) {
      writer.uint32(24).bool(message.isActive)
    }
    if (message.gridCols !== undefined) {
      writer.uint32(32).int32(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      writer.uint32(40).int32(message.gridMargin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreatePageRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.gridCols = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.gridMargin = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreatePageRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : undefined,
      gridCols: isSet(object.gridCols)
        ? globalThis.Number(object.gridCols)
        : isSet(object.grid_cols)
          ? globalThis.Number(object.grid_cols)
          : undefined,
      gridMargin: isSet(object.gridMargin)
        ? globalThis.Number(object.gridMargin)
        : isSet(object.grid_margin)
          ? globalThis.Number(object.grid_margin)
          : undefined,
    }
  },

  toJSON(message: CreatePageRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.isActive !== undefined) {
      obj.isActive = message.isActive
    }
    if (message.gridCols !== undefined) {
      obj.gridCols = Math.round(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      obj.gridMargin = Math.round(message.gridMargin)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreatePageRequest>, I>>(base?: I): CreatePageRequest {
    return CreatePageRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreatePageRequest>, I>>(object: I): CreatePageRequest {
    const message = createBaseCreatePageRequest()
    message.pageId = object.pageId ?? ''
    message.name = object.name ?? ''
    message.isActive = object.isActive ?? undefined
    message.gridCols = object.gridCols ?? undefined
    message.gridMargin = object.gridMargin ?? undefined
    return message
  },
}

function createBaseGetPagesRequest(): GetPagesRequest {
  return {}
}

export const GetPagesRequest: MessageFns<GetPagesRequest> = {
  encode(_: GetPagesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPagesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPagesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetPagesRequest {
    return {}
  },

  toJSON(_: GetPagesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetPagesRequest>, I>>(base?: I): GetPagesRequest {
    return GetPagesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPagesRequest>, I>>(_: I): GetPagesRequest {
    const message = createBaseGetPagesRequest()
    return message
  },
}

function createBaseGetPagesResponse(): GetPagesResponse {
  return { pages: [] }
}

export const GetPagesResponse: MessageFns<GetPagesResponse> = {
  encode(message: GetPagesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.pages) {
      PageMeta.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPagesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPagesResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pages.push(PageMeta.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPagesResponse {
    return {
      pages: globalThis.Array.isArray(object?.pages)
        ? object.pages.map((e: any) => PageMeta.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetPagesResponse): unknown {
    const obj: any = {}
    if (message.pages?.length) {
      obj.pages = message.pages.map((e) => PageMeta.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPagesResponse>, I>>(base?: I): GetPagesResponse {
    return GetPagesResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPagesResponse>, I>>(object: I): GetPagesResponse {
    const message = createBaseGetPagesResponse()
    message.pages = object.pages?.map((e) => PageMeta.fromPartial(e)) || []
    return message
  },
}

function createBaseGetPageLayoutRequest(): GetPageLayoutRequest {
  return { pageId: '' }
}

export const GetPageLayoutRequest: MessageFns<GetPageLayoutRequest> = {
  encode(message: GetPageLayoutRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPageLayoutRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPageLayoutRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPageLayoutRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
    }
  },

  toJSON(message: GetPageLayoutRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPageLayoutRequest>, I>>(base?: I): GetPageLayoutRequest {
    return GetPageLayoutRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPageLayoutRequest>, I>>(
    object: I
  ): GetPageLayoutRequest {
    const message = createBaseGetPageLayoutRequest()
    message.pageId = object.pageId ?? ''
    return message
  },
}

function createBaseGetPageLayoutResponse(): GetPageLayoutResponse {
  return { page: undefined, widgets: [] }
}

export const GetPageLayoutResponse: MessageFns<GetPageLayoutResponse> = {
  encode(message: GetPageLayoutResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page !== undefined) {
      PageMeta.encode(message.page, writer.uint32(10).fork()).join()
    }
    for (const v of message.widgets) {
      WidgetInstance.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPageLayoutResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPageLayoutResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.page = PageMeta.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.widgets.push(WidgetInstance.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPageLayoutResponse {
    return {
      page: isSet(object.page) ? PageMeta.fromJSON(object.page) : undefined,
      widgets: globalThis.Array.isArray(object?.widgets)
        ? object.widgets.map((e: any) => WidgetInstance.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetPageLayoutResponse): unknown {
    const obj: any = {}
    if (message.page !== undefined) {
      obj.page = PageMeta.toJSON(message.page)
    }
    if (message.widgets?.length) {
      obj.widgets = message.widgets.map((e) => WidgetInstance.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPageLayoutResponse>, I>>(base?: I): GetPageLayoutResponse {
    return GetPageLayoutResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPageLayoutResponse>, I>>(
    object: I
  ): GetPageLayoutResponse {
    const message = createBaseGetPageLayoutResponse()
    message.page =
      object.page !== undefined && object.page !== null
        ? PageMeta.fromPartial(object.page)
        : undefined
    message.widgets = object.widgets?.map((e) => WidgetInstance.fromPartial(e)) || []
    return message
  },
}

function createBaseUpdatePageMetaRequest(): UpdatePageMetaRequest {
  return {
    pageId: '',
    name: undefined,
    isActive: undefined,
    gridCols: undefined,
    gridMargin: undefined,
  }
}

export const UpdatePageMetaRequest: MessageFns<UpdatePageMetaRequest> = {
  encode(message: UpdatePageMetaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name)
    }
    if (message.isActive !== undefined) {
      writer.uint32(24).bool(message.isActive)
    }
    if (message.gridCols !== undefined) {
      writer.uint32(32).int32(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      writer.uint32(40).int32(message.gridMargin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePageMetaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdatePageMetaRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.gridCols = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.gridMargin = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdatePageMetaRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : undefined,
      gridCols: isSet(object.gridCols)
        ? globalThis.Number(object.gridCols)
        : isSet(object.grid_cols)
          ? globalThis.Number(object.grid_cols)
          : undefined,
      gridMargin: isSet(object.gridMargin)
        ? globalThis.Number(object.gridMargin)
        : isSet(object.grid_margin)
          ? globalThis.Number(object.grid_margin)
          : undefined,
    }
  },

  toJSON(message: UpdatePageMetaRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.name !== undefined) {
      obj.name = message.name
    }
    if (message.isActive !== undefined) {
      obj.isActive = message.isActive
    }
    if (message.gridCols !== undefined) {
      obj.gridCols = Math.round(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      obj.gridMargin = Math.round(message.gridMargin)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdatePageMetaRequest>, I>>(base?: I): UpdatePageMetaRequest {
    return UpdatePageMetaRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePageMetaRequest>, I>>(
    object: I
  ): UpdatePageMetaRequest {
    const message = createBaseUpdatePageMetaRequest()
    message.pageId = object.pageId ?? ''
    message.name = object.name ?? undefined
    message.isActive = object.isActive ?? undefined
    message.gridCols = object.gridCols ?? undefined
    message.gridMargin = object.gridMargin ?? undefined
    return message
  },
}

function createBaseDeletePageRequest(): DeletePageRequest {
  return { pageId: '' }
}

export const DeletePageRequest: MessageFns<DeletePageRequest> = {
  encode(message: DeletePageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePageRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeletePageRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
    }
  },

  toJSON(message: DeletePageRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePageRequest>, I>>(base?: I): DeletePageRequest {
    return DeletePageRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePageRequest>, I>>(object: I): DeletePageRequest {
    const message = createBaseDeletePageRequest()
    message.pageId = object.pageId ?? ''
    return message
  },
}

function createBaseAddWidgetRequest(): AddWidgetRequest {
  return {
    pageId: '',
    widgetId: '',
    widgetType: '',
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    minW: undefined,
    minH: undefined,
    config: {},
  }
}

export const AddWidgetRequest: MessageFns<AddWidgetRequest> = {
  encode(message: AddWidgetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.widgetId !== '') {
      writer.uint32(18).string(message.widgetId)
    }
    if (message.widgetType !== '') {
      writer.uint32(26).string(message.widgetType)
    }
    if (message.x !== 0) {
      writer.uint32(32).int32(message.x)
    }
    if (message.y !== 0) {
      writer.uint32(40).int32(message.y)
    }
    if (message.w !== 0) {
      writer.uint32(48).int32(message.w)
    }
    if (message.h !== 0) {
      writer.uint32(56).int32(message.h)
    }
    if (message.minW !== undefined) {
      writer.uint32(64).int32(message.minW)
    }
    if (message.minH !== undefined) {
      writer.uint32(72).int32(message.minH)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      AddWidgetRequest_ConfigEntry.encode(
        { key: key as any, value },
        writer.uint32(82).fork()
      ).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddWidgetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAddWidgetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.widgetId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.widgetType = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.x = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.y = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.w = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.h = reader.int32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.minW = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.minH = reader.int32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          const entry10 = AddWidgetRequest_ConfigEntry.decode(reader, reader.uint32())
          if (entry10.value !== undefined) {
            message.config[entry10.key] = entry10.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AddWidgetRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      widgetId: isSet(object.widgetId)
        ? globalThis.String(object.widgetId)
        : isSet(object.widget_id)
          ? globalThis.String(object.widget_id)
          : '',
      widgetType: isSet(object.widgetType)
        ? globalThis.String(object.widgetType)
        : isSet(object.widget_type)
          ? globalThis.String(object.widget_type)
          : '',
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
      h: isSet(object.h) ? globalThis.Number(object.h) : 0,
      minW: isSet(object.minW)
        ? globalThis.Number(object.minW)
        : isSet(object.min_w)
          ? globalThis.Number(object.min_w)
          : undefined,
      minH: isSet(object.minH)
        ? globalThis.Number(object.minH)
        : isSet(object.min_h)
          ? globalThis.Number(object.min_h)
          : undefined,
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
    }
  },

  toJSON(message: AddWidgetRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.widgetId !== '') {
      obj.widgetId = message.widgetId
    }
    if (message.widgetType !== '') {
      obj.widgetType = message.widgetType
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x)
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y)
    }
    if (message.w !== 0) {
      obj.w = Math.round(message.w)
    }
    if (message.h !== 0) {
      obj.h = Math.round(message.h)
    }
    if (message.minW !== undefined) {
      obj.minW = Math.round(message.minW)
    }
    if (message.minH !== undefined) {
      obj.minH = Math.round(message.minH)
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AddWidgetRequest>, I>>(base?: I): AddWidgetRequest {
    return AddWidgetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AddWidgetRequest>, I>>(object: I): AddWidgetRequest {
    const message = createBaseAddWidgetRequest()
    message.pageId = object.pageId ?? ''
    message.widgetId = object.widgetId ?? ''
    message.widgetType = object.widgetType ?? ''
    message.x = object.x ?? 0
    message.y = object.y ?? 0
    message.w = object.w ?? 0
    message.h = object.h ?? 0
    message.minW = object.minW ?? undefined
    message.minH = object.minH ?? undefined
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    return message
  },
}

function createBaseAddWidgetRequest_ConfigEntry(): AddWidgetRequest_ConfigEntry {
  return { key: '', value: '' }
}

export const AddWidgetRequest_ConfigEntry: MessageFns<AddWidgetRequest_ConfigEntry> = {
  encode(
    message: AddWidgetRequest_ConfigEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddWidgetRequest_ConfigEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAddWidgetRequest_ConfigEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AddWidgetRequest_ConfigEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: AddWidgetRequest_ConfigEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AddWidgetRequest_ConfigEntry>, I>>(
    base?: I
  ): AddWidgetRequest_ConfigEntry {
    return AddWidgetRequest_ConfigEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AddWidgetRequest_ConfigEntry>, I>>(
    object: I
  ): AddWidgetRequest_ConfigEntry {
    const message = createBaseAddWidgetRequest_ConfigEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseUpdateWidgetRequest(): UpdateWidgetRequest {
  return {
    pageId: '',
    widgetId: '',
    x: undefined,
    y: undefined,
    w: undefined,
    h: undefined,
    minW: undefined,
    minH: undefined,
    config: {},
  }
}

export const UpdateWidgetRequest: MessageFns<UpdateWidgetRequest> = {
  encode(message: UpdateWidgetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.widgetId !== '') {
      writer.uint32(18).string(message.widgetId)
    }
    if (message.x !== undefined) {
      writer.uint32(24).int32(message.x)
    }
    if (message.y !== undefined) {
      writer.uint32(32).int32(message.y)
    }
    if (message.w !== undefined) {
      writer.uint32(40).int32(message.w)
    }
    if (message.h !== undefined) {
      writer.uint32(48).int32(message.h)
    }
    if (message.minW !== undefined) {
      writer.uint32(56).int32(message.minW)
    }
    if (message.minH !== undefined) {
      writer.uint32(64).int32(message.minH)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      UpdateWidgetRequest_ConfigEntry.encode(
        { key: key as any, value },
        writer.uint32(74).fork()
      ).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateWidgetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateWidgetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.widgetId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.x = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.y = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.w = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.h = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.minW = reader.int32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.minH = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          const entry9 = UpdateWidgetRequest_ConfigEntry.decode(reader, reader.uint32())
          if (entry9.value !== undefined) {
            message.config[entry9.key] = entry9.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateWidgetRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      widgetId: isSet(object.widgetId)
        ? globalThis.String(object.widgetId)
        : isSet(object.widget_id)
          ? globalThis.String(object.widget_id)
          : '',
      x: isSet(object.x) ? globalThis.Number(object.x) : undefined,
      y: isSet(object.y) ? globalThis.Number(object.y) : undefined,
      w: isSet(object.w) ? globalThis.Number(object.w) : undefined,
      h: isSet(object.h) ? globalThis.Number(object.h) : undefined,
      minW: isSet(object.minW)
        ? globalThis.Number(object.minW)
        : isSet(object.min_w)
          ? globalThis.Number(object.min_w)
          : undefined,
      minH: isSet(object.minH)
        ? globalThis.Number(object.minH)
        : isSet(object.min_h)
          ? globalThis.Number(object.min_h)
          : undefined,
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
    }
  },

  toJSON(message: UpdateWidgetRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.widgetId !== '') {
      obj.widgetId = message.widgetId
    }
    if (message.x !== undefined) {
      obj.x = Math.round(message.x)
    }
    if (message.y !== undefined) {
      obj.y = Math.round(message.y)
    }
    if (message.w !== undefined) {
      obj.w = Math.round(message.w)
    }
    if (message.h !== undefined) {
      obj.h = Math.round(message.h)
    }
    if (message.minW !== undefined) {
      obj.minW = Math.round(message.minW)
    }
    if (message.minH !== undefined) {
      obj.minH = Math.round(message.minH)
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateWidgetRequest>, I>>(base?: I): UpdateWidgetRequest {
    return UpdateWidgetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateWidgetRequest>, I>>(
    object: I
  ): UpdateWidgetRequest {
    const message = createBaseUpdateWidgetRequest()
    message.pageId = object.pageId ?? ''
    message.widgetId = object.widgetId ?? ''
    message.x = object.x ?? undefined
    message.y = object.y ?? undefined
    message.w = object.w ?? undefined
    message.h = object.h ?? undefined
    message.minW = object.minW ?? undefined
    message.minH = object.minH ?? undefined
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    return message
  },
}

function createBaseUpdateWidgetRequest_ConfigEntry(): UpdateWidgetRequest_ConfigEntry {
  return { key: '', value: '' }
}

export const UpdateWidgetRequest_ConfigEntry: MessageFns<UpdateWidgetRequest_ConfigEntry> = {
  encode(
    message: UpdateWidgetRequest_ConfigEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateWidgetRequest_ConfigEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateWidgetRequest_ConfigEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateWidgetRequest_ConfigEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: UpdateWidgetRequest_ConfigEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateWidgetRequest_ConfigEntry>, I>>(
    base?: I
  ): UpdateWidgetRequest_ConfigEntry {
    return UpdateWidgetRequest_ConfigEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateWidgetRequest_ConfigEntry>, I>>(
    object: I
  ): UpdateWidgetRequest_ConfigEntry {
    const message = createBaseUpdateWidgetRequest_ConfigEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseRemoveWidgetRequest(): RemoveWidgetRequest {
  return { pageId: '', widgetId: '' }
}

export const RemoveWidgetRequest: MessageFns<RemoveWidgetRequest> = {
  encode(message: RemoveWidgetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageId !== '') {
      writer.uint32(10).string(message.pageId)
    }
    if (message.widgetId !== '') {
      writer.uint32(18).string(message.widgetId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveWidgetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRemoveWidgetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.pageId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.widgetId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RemoveWidgetRequest {
    return {
      pageId: isSet(object.pageId)
        ? globalThis.String(object.pageId)
        : isSet(object.page_id)
          ? globalThis.String(object.page_id)
          : '',
      widgetId: isSet(object.widgetId)
        ? globalThis.String(object.widgetId)
        : isSet(object.widget_id)
          ? globalThis.String(object.widget_id)
          : '',
    }
  },

  toJSON(message: RemoveWidgetRequest): unknown {
    const obj: any = {}
    if (message.pageId !== '') {
      obj.pageId = message.pageId
    }
    if (message.widgetId !== '') {
      obj.widgetId = message.widgetId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RemoveWidgetRequest>, I>>(base?: I): RemoveWidgetRequest {
    return RemoveWidgetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RemoveWidgetRequest>, I>>(
    object: I
  ): RemoveWidgetRequest {
    const message = createBaseRemoveWidgetRequest()
    message.pageId = object.pageId ?? ''
    message.widgetId = object.widgetId ?? ''
    return message
  },
}

function createBaseSaveComponentPreferenceRequest(): SaveComponentPreferenceRequest {
  return {
    componentId: '',
    searchTerm: undefined,
    tickerFilter: undefined,
    columnOrder: [],
    config: {},
  }
}

export const SaveComponentPreferenceRequest: MessageFns<SaveComponentPreferenceRequest> = {
  encode(
    message: SaveComponentPreferenceRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.componentId !== '') {
      writer.uint32(10).string(message.componentId)
    }
    if (message.searchTerm !== undefined) {
      writer.uint32(18).string(message.searchTerm)
    }
    if (message.tickerFilter !== undefined) {
      writer.uint32(26).string(message.tickerFilter)
    }
    for (const v of message.columnOrder) {
      writer.uint32(34).string(v!)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      SaveComponentPreferenceRequest_ConfigEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork()
      ).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveComponentPreferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSaveComponentPreferenceRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.componentId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.searchTerm = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tickerFilter = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.columnOrder.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          const entry5 = SaveComponentPreferenceRequest_ConfigEntry.decode(reader, reader.uint32())
          if (entry5.value !== undefined) {
            message.config[entry5.key] = entry5.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SaveComponentPreferenceRequest {
    return {
      componentId: isSet(object.componentId)
        ? globalThis.String(object.componentId)
        : isSet(object.component_id)
          ? globalThis.String(object.component_id)
          : '',
      searchTerm: isSet(object.searchTerm)
        ? globalThis.String(object.searchTerm)
        : isSet(object.search_term)
          ? globalThis.String(object.search_term)
          : undefined,
      tickerFilter: isSet(object.tickerFilter)
        ? globalThis.String(object.tickerFilter)
        : isSet(object.ticker_filter)
          ? globalThis.String(object.ticker_filter)
          : undefined,
      columnOrder: globalThis.Array.isArray(object?.columnOrder)
        ? object.columnOrder.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.column_order)
          ? object.column_order.map((e: any) => globalThis.String(e))
          : [],
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
    }
  },

  toJSON(message: SaveComponentPreferenceRequest): unknown {
    const obj: any = {}
    if (message.componentId !== '') {
      obj.componentId = message.componentId
    }
    if (message.searchTerm !== undefined) {
      obj.searchTerm = message.searchTerm
    }
    if (message.tickerFilter !== undefined) {
      obj.tickerFilter = message.tickerFilter
    }
    if (message.columnOrder?.length) {
      obj.columnOrder = message.columnOrder
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SaveComponentPreferenceRequest>, I>>(
    base?: I
  ): SaveComponentPreferenceRequest {
    return SaveComponentPreferenceRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SaveComponentPreferenceRequest>, I>>(
    object: I
  ): SaveComponentPreferenceRequest {
    const message = createBaseSaveComponentPreferenceRequest()
    message.componentId = object.componentId ?? ''
    message.searchTerm = object.searchTerm ?? undefined
    message.tickerFilter = object.tickerFilter ?? undefined
    message.columnOrder = object.columnOrder?.map((e) => e) || []
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    return message
  },
}

function createBaseSaveComponentPreferenceRequest_ConfigEntry(): SaveComponentPreferenceRequest_ConfigEntry {
  return { key: '', value: '' }
}

export const SaveComponentPreferenceRequest_ConfigEntry: MessageFns<SaveComponentPreferenceRequest_ConfigEntry> =
  {
    encode(
      message: SaveComponentPreferenceRequest_ConfigEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '') {
        writer.uint32(18).string(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): SaveComponentPreferenceRequest_ConfigEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseSaveComponentPreferenceRequest_ConfigEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.value = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): SaveComponentPreferenceRequest_ConfigEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      }
    },

    toJSON(message: SaveComponentPreferenceRequest_ConfigEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<SaveComponentPreferenceRequest_ConfigEntry>, I>>(
      base?: I
    ): SaveComponentPreferenceRequest_ConfigEntry {
      return SaveComponentPreferenceRequest_ConfigEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<SaveComponentPreferenceRequest_ConfigEntry>, I>>(
      object: I
    ): SaveComponentPreferenceRequest_ConfigEntry {
      const message = createBaseSaveComponentPreferenceRequest_ConfigEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? ''
      return message
    },
  }

function createBaseGetComponentPreferenceRequest(): GetComponentPreferenceRequest {
  return { componentId: '' }
}

export const GetComponentPreferenceRequest: MessageFns<GetComponentPreferenceRequest> = {
  encode(
    message: GetComponentPreferenceRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.componentId !== '') {
      writer.uint32(10).string(message.componentId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetComponentPreferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetComponentPreferenceRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.componentId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetComponentPreferenceRequest {
    return {
      componentId: isSet(object.componentId)
        ? globalThis.String(object.componentId)
        : isSet(object.component_id)
          ? globalThis.String(object.component_id)
          : '',
    }
  },

  toJSON(message: GetComponentPreferenceRequest): unknown {
    const obj: any = {}
    if (message.componentId !== '') {
      obj.componentId = message.componentId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetComponentPreferenceRequest>, I>>(
    base?: I
  ): GetComponentPreferenceRequest {
    return GetComponentPreferenceRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetComponentPreferenceRequest>, I>>(
    object: I
  ): GetComponentPreferenceRequest {
    const message = createBaseGetComponentPreferenceRequest()
    message.componentId = object.componentId ?? ''
    return message
  },
}

function createBaseComponentPreferenceResponse(): ComponentPreferenceResponse {
  return { preference: undefined }
}

export const ComponentPreferenceResponse: MessageFns<ComponentPreferenceResponse> = {
  encode(
    message: ComponentPreferenceResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.preference !== undefined) {
      ComponentPreference.encode(message.preference, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentPreferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseComponentPreferenceResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.preference = ComponentPreference.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ComponentPreferenceResponse {
    return {
      preference: isSet(object.preference)
        ? ComponentPreference.fromJSON(object.preference)
        : undefined,
    }
  },

  toJSON(message: ComponentPreferenceResponse): unknown {
    const obj: any = {}
    if (message.preference !== undefined) {
      obj.preference = ComponentPreference.toJSON(message.preference)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ComponentPreferenceResponse>, I>>(
    base?: I
  ): ComponentPreferenceResponse {
    return ComponentPreferenceResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ComponentPreferenceResponse>, I>>(
    object: I
  ): ComponentPreferenceResponse {
    const message = createBaseComponentPreferenceResponse()
    message.preference =
      object.preference !== undefined && object.preference !== null
        ? ComponentPreference.fromPartial(object.preference)
        : undefined
    return message
  },
}

function createBasePageMutationResponse(): PageMutationResponse {
  return { success: false, message: '', page: undefined, widget: undefined }
}

export const PageMutationResponse: MessageFns<PageMutationResponse> = {
  encode(message: PageMutationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.page !== undefined) {
      PageMeta.encode(message.page, writer.uint32(26).fork()).join()
    }
    if (message.widget !== undefined) {
      WidgetInstance.encode(message.widget, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PageMutationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePageMutationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.page = PageMeta.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.widget = WidgetInstance.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PageMutationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      page: isSet(object.page) ? PageMeta.fromJSON(object.page) : undefined,
      widget: isSet(object.widget) ? WidgetInstance.fromJSON(object.widget) : undefined,
    }
  },

  toJSON(message: PageMutationResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.page !== undefined) {
      obj.page = PageMeta.toJSON(message.page)
    }
    if (message.widget !== undefined) {
      obj.widget = WidgetInstance.toJSON(message.widget)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PageMutationResponse>, I>>(base?: I): PageMutationResponse {
    return PageMutationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PageMutationResponse>, I>>(
    object: I
  ): PageMutationResponse {
    const message = createBasePageMutationResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    message.page =
      object.page !== undefined && object.page !== null
        ? PageMeta.fromPartial(object.page)
        : undefined
    message.widget =
      object.widget !== undefined && object.widget !== null
        ? WidgetInstance.fromPartial(object.widget)
        : undefined
    return message
  },
}

function createBaseSharedWidget(): SharedWidget {
  return { widgetType: '', x: 0, y: 0, w: 0, h: 0, minW: undefined, minH: undefined, config: {} }
}

export const SharedWidget: MessageFns<SharedWidget> = {
  encode(message: SharedWidget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.widgetType !== '') {
      writer.uint32(10).string(message.widgetType)
    }
    if (message.x !== 0) {
      writer.uint32(16).int32(message.x)
    }
    if (message.y !== 0) {
      writer.uint32(24).int32(message.y)
    }
    if (message.w !== 0) {
      writer.uint32(32).int32(message.w)
    }
    if (message.h !== 0) {
      writer.uint32(40).int32(message.h)
    }
    if (message.minW !== undefined) {
      writer.uint32(48).int32(message.minW)
    }
    if (message.minH !== undefined) {
      writer.uint32(56).int32(message.minH)
    }
    globalThis.Object.entries(message.config).forEach(([key, value]: [string, string]) => {
      SharedWidget_ConfigEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SharedWidget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSharedWidget()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.widgetType = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.x = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.y = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.w = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.h = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.minW = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.minH = reader.int32()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          const entry8 = SharedWidget_ConfigEntry.decode(reader, reader.uint32())
          if (entry8.value !== undefined) {
            message.config[entry8.key] = entry8.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SharedWidget {
    return {
      widgetType: isSet(object.widgetType)
        ? globalThis.String(object.widgetType)
        : isSet(object.widget_type)
          ? globalThis.String(object.widget_type)
          : '',
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
      h: isSet(object.h) ? globalThis.Number(object.h) : 0,
      minW: isSet(object.minW)
        ? globalThis.Number(object.minW)
        : isSet(object.min_w)
          ? globalThis.Number(object.min_w)
          : undefined,
      minH: isSet(object.minH)
        ? globalThis.Number(object.minH)
        : isSet(object.min_h)
          ? globalThis.Number(object.min_h)
          : undefined,
      config: isObject(object.config)
        ? (globalThis.Object.entries(object.config) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
    }
  },

  toJSON(message: SharedWidget): unknown {
    const obj: any = {}
    if (message.widgetType !== '') {
      obj.widgetType = message.widgetType
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x)
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y)
    }
    if (message.w !== 0) {
      obj.w = Math.round(message.w)
    }
    if (message.h !== 0) {
      obj.h = Math.round(message.h)
    }
    if (message.minW !== undefined) {
      obj.minW = Math.round(message.minW)
    }
    if (message.minH !== undefined) {
      obj.minH = Math.round(message.minH)
    }
    if (message.config) {
      const entries = globalThis.Object.entries(message.config) as [string, string][]
      if (entries.length > 0) {
        obj.config = {}
        entries.forEach(([k, v]) => {
          obj.config[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SharedWidget>, I>>(base?: I): SharedWidget {
    return SharedWidget.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SharedWidget>, I>>(object: I): SharedWidget {
    const message = createBaseSharedWidget()
    message.widgetType = object.widgetType ?? ''
    message.x = object.x ?? 0
    message.y = object.y ?? 0
    message.w = object.w ?? 0
    message.h = object.h ?? 0
    message.minW = object.minW ?? undefined
    message.minH = object.minH ?? undefined
    message.config = (globalThis.Object.entries(object.config ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    return message
  },
}

function createBaseSharedWidget_ConfigEntry(): SharedWidget_ConfigEntry {
  return { key: '', value: '' }
}

export const SharedWidget_ConfigEntry: MessageFns<SharedWidget_ConfigEntry> = {
  encode(
    message: SharedWidget_ConfigEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SharedWidget_ConfigEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSharedWidget_ConfigEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SharedWidget_ConfigEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: SharedWidget_ConfigEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SharedWidget_ConfigEntry>, I>>(
    base?: I
  ): SharedWidget_ConfigEntry {
    return SharedWidget_ConfigEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SharedWidget_ConfigEntry>, I>>(
    object: I
  ): SharedWidget_ConfigEntry {
    const message = createBaseSharedWidget_ConfigEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseCreateSharedLayoutRequest(): CreateSharedLayoutRequest {
  return { name: '', gridCols: undefined, gridMargin: undefined, widgets: [] }
}

export const CreateSharedLayoutRequest: MessageFns<CreateSharedLayoutRequest> = {
  encode(
    message: CreateSharedLayoutRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.gridCols !== undefined) {
      writer.uint32(16).int32(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      writer.uint32(24).int32(message.gridMargin)
    }
    for (const v of message.widgets) {
      SharedWidget.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSharedLayoutRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateSharedLayoutRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.gridCols = reader.int32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.gridMargin = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.widgets.push(SharedWidget.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateSharedLayoutRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      gridCols: isSet(object.gridCols)
        ? globalThis.Number(object.gridCols)
        : isSet(object.grid_cols)
          ? globalThis.Number(object.grid_cols)
          : undefined,
      gridMargin: isSet(object.gridMargin)
        ? globalThis.Number(object.gridMargin)
        : isSet(object.grid_margin)
          ? globalThis.Number(object.grid_margin)
          : undefined,
      widgets: globalThis.Array.isArray(object?.widgets)
        ? object.widgets.map((e: any) => SharedWidget.fromJSON(e))
        : [],
    }
  },

  toJSON(message: CreateSharedLayoutRequest): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.gridCols !== undefined) {
      obj.gridCols = Math.round(message.gridCols)
    }
    if (message.gridMargin !== undefined) {
      obj.gridMargin = Math.round(message.gridMargin)
    }
    if (message.widgets?.length) {
      obj.widgets = message.widgets.map((e) => SharedWidget.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateSharedLayoutRequest>, I>>(
    base?: I
  ): CreateSharedLayoutRequest {
    return CreateSharedLayoutRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateSharedLayoutRequest>, I>>(
    object: I
  ): CreateSharedLayoutRequest {
    const message = createBaseCreateSharedLayoutRequest()
    message.name = object.name ?? ''
    message.gridCols = object.gridCols ?? undefined
    message.gridMargin = object.gridMargin ?? undefined
    message.widgets = object.widgets?.map((e) => SharedWidget.fromPartial(e)) || []
    return message
  },
}

function createBaseCreateSharedLayoutResponse(): CreateSharedLayoutResponse {
  return { shareId: '', createdAt: '0' }
}

export const CreateSharedLayoutResponse: MessageFns<CreateSharedLayoutResponse> = {
  encode(
    message: CreateSharedLayoutResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.shareId !== '') {
      writer.uint32(10).string(message.shareId)
    }
    if (message.createdAt !== '0') {
      writer.uint32(16).int64(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSharedLayoutResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateSharedLayoutResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.shareId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateSharedLayoutResponse {
    return {
      shareId: isSet(object.shareId)
        ? globalThis.String(object.shareId)
        : isSet(object.share_id)
          ? globalThis.String(object.share_id)
          : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
    }
  },

  toJSON(message: CreateSharedLayoutResponse): unknown {
    const obj: any = {}
    if (message.shareId !== '') {
      obj.shareId = message.shareId
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateSharedLayoutResponse>, I>>(
    base?: I
  ): CreateSharedLayoutResponse {
    return CreateSharedLayoutResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateSharedLayoutResponse>, I>>(
    object: I
  ): CreateSharedLayoutResponse {
    const message = createBaseCreateSharedLayoutResponse()
    message.shareId = object.shareId ?? ''
    message.createdAt = object.createdAt ?? '0'
    return message
  },
}

function createBaseGetSharedLayoutRequest(): GetSharedLayoutRequest {
  return { shareId: '' }
}

export const GetSharedLayoutRequest: MessageFns<GetSharedLayoutRequest> = {
  encode(message: GetSharedLayoutRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shareId !== '') {
      writer.uint32(10).string(message.shareId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSharedLayoutRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSharedLayoutRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.shareId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetSharedLayoutRequest {
    return {
      shareId: isSet(object.shareId)
        ? globalThis.String(object.shareId)
        : isSet(object.share_id)
          ? globalThis.String(object.share_id)
          : '',
    }
  },

  toJSON(message: GetSharedLayoutRequest): unknown {
    const obj: any = {}
    if (message.shareId !== '') {
      obj.shareId = message.shareId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetSharedLayoutRequest>, I>>(
    base?: I
  ): GetSharedLayoutRequest {
    return GetSharedLayoutRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSharedLayoutRequest>, I>>(
    object: I
  ): GetSharedLayoutRequest {
    const message = createBaseGetSharedLayoutRequest()
    message.shareId = object.shareId ?? ''
    return message
  },
}

function createBaseGetSharedLayoutResponse(): GetSharedLayoutResponse {
  return { shareId: '', name: '', gridCols: 0, gridMargin: 0, widgets: [], createdAt: '0' }
}

export const GetSharedLayoutResponse: MessageFns<GetSharedLayoutResponse> = {
  encode(
    message: GetSharedLayoutResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.shareId !== '') {
      writer.uint32(10).string(message.shareId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.gridCols !== 0) {
      writer.uint32(24).int32(message.gridCols)
    }
    if (message.gridMargin !== 0) {
      writer.uint32(32).int32(message.gridMargin)
    }
    for (const v of message.widgets) {
      SharedWidget.encode(v!, writer.uint32(42).fork()).join()
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSharedLayoutResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetSharedLayoutResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.shareId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.gridCols = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.gridMargin = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.widgets.push(SharedWidget.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetSharedLayoutResponse {
    return {
      shareId: isSet(object.shareId)
        ? globalThis.String(object.shareId)
        : isSet(object.share_id)
          ? globalThis.String(object.share_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      gridCols: isSet(object.gridCols)
        ? globalThis.Number(object.gridCols)
        : isSet(object.grid_cols)
          ? globalThis.Number(object.grid_cols)
          : 0,
      gridMargin: isSet(object.gridMargin)
        ? globalThis.Number(object.gridMargin)
        : isSet(object.grid_margin)
          ? globalThis.Number(object.grid_margin)
          : 0,
      widgets: globalThis.Array.isArray(object?.widgets)
        ? object.widgets.map((e: any) => SharedWidget.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
    }
  },

  toJSON(message: GetSharedLayoutResponse): unknown {
    const obj: any = {}
    if (message.shareId !== '') {
      obj.shareId = message.shareId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.gridCols !== 0) {
      obj.gridCols = Math.round(message.gridCols)
    }
    if (message.gridMargin !== 0) {
      obj.gridMargin = Math.round(message.gridMargin)
    }
    if (message.widgets?.length) {
      obj.widgets = message.widgets.map((e) => SharedWidget.toJSON(e))
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetSharedLayoutResponse>, I>>(
    base?: I
  ): GetSharedLayoutResponse {
    return GetSharedLayoutResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetSharedLayoutResponse>, I>>(
    object: I
  ): GetSharedLayoutResponse {
    const message = createBaseGetSharedLayoutResponse()
    message.shareId = object.shareId ?? ''
    message.name = object.name ?? ''
    message.gridCols = object.gridCols ?? 0
    message.gridMargin = object.gridMargin ?? 0
    message.widgets = object.widgets?.map((e) => SharedWidget.fromPartial(e)) || []
    message.createdAt = object.createdAt ?? '0'
    return message
  },
}

function createBaseWatchlistEntry(): WatchlistEntry {
  return { exchange: 0, symbol: '' }
}

export const WatchlistEntry: MessageFns<WatchlistEntry> = {
  encode(message: WatchlistEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchlistEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWatchlistEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WatchlistEntry {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
    }
  },

  toJSON(message: WatchlistEntry): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WatchlistEntry>, I>>(base?: I): WatchlistEntry {
    return WatchlistEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WatchlistEntry>, I>>(object: I): WatchlistEntry {
    const message = createBaseWatchlistEntry()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    return message
  },
}

function createBaseWatchlist(): Watchlist {
  return {
    watchlistId: '',
    name: '',
    createdAt: '0',
    updatedAt: '0',
    orderedEntries: [],
    generatedFromPrompt: undefined,
    lastRefreshedAtMs: undefined,
    refreshIntervalMs: undefined,
  }
}

export const Watchlist: MessageFns<Watchlist> = {
  encode(message: Watchlist, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watchlistId !== '') {
      writer.uint32(10).string(message.watchlistId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(40).int64(message.updatedAt)
    }
    for (const v of message.orderedEntries) {
      WatchlistEntry.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.generatedFromPrompt !== undefined) {
      writer.uint32(58).string(message.generatedFromPrompt)
    }
    if (message.lastRefreshedAtMs !== undefined) {
      writer.uint32(64).int64(message.lastRefreshedAtMs)
    }
    if (message.refreshIntervalMs !== undefined) {
      writer.uint32(72).int64(message.refreshIntervalMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Watchlist {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWatchlist()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.orderedEntries.push(WatchlistEntry.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.generatedFromPrompt = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.lastRefreshedAtMs = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.refreshIntervalMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Watchlist {
    return {
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      orderedEntries: globalThis.Array.isArray(object?.orderedEntries)
        ? object.orderedEntries.map((e: any) => WatchlistEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_entries)
          ? object.ordered_entries.map((e: any) => WatchlistEntry.fromJSON(e))
          : [],
      generatedFromPrompt: isSet(object.generatedFromPrompt)
        ? globalThis.String(object.generatedFromPrompt)
        : isSet(object.generated_from_prompt)
          ? globalThis.String(object.generated_from_prompt)
          : undefined,
      lastRefreshedAtMs: isSet(object.lastRefreshedAtMs)
        ? globalThis.String(object.lastRefreshedAtMs)
        : isSet(object.last_refreshed_at_ms)
          ? globalThis.String(object.last_refreshed_at_ms)
          : undefined,
      refreshIntervalMs: isSet(object.refreshIntervalMs)
        ? globalThis.String(object.refreshIntervalMs)
        : isSet(object.refresh_interval_ms)
          ? globalThis.String(object.refresh_interval_ms)
          : undefined,
    }
  },

  toJSON(message: Watchlist): unknown {
    const obj: any = {}
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.orderedEntries?.length) {
      obj.orderedEntries = message.orderedEntries.map((e) => WatchlistEntry.toJSON(e))
    }
    if (message.generatedFromPrompt !== undefined) {
      obj.generatedFromPrompt = message.generatedFromPrompt
    }
    if (message.lastRefreshedAtMs !== undefined) {
      obj.lastRefreshedAtMs = message.lastRefreshedAtMs
    }
    if (message.refreshIntervalMs !== undefined) {
      obj.refreshIntervalMs = message.refreshIntervalMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Watchlist>, I>>(base?: I): Watchlist {
    return Watchlist.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Watchlist>, I>>(object: I): Watchlist {
    const message = createBaseWatchlist()
    message.watchlistId = object.watchlistId ?? ''
    message.name = object.name ?? ''
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.orderedEntries = object.orderedEntries?.map((e) => WatchlistEntry.fromPartial(e)) || []
    message.generatedFromPrompt = object.generatedFromPrompt ?? undefined
    message.lastRefreshedAtMs = object.lastRefreshedAtMs ?? undefined
    message.refreshIntervalMs = object.refreshIntervalMs ?? undefined
    return message
  },
}

function createBaseCreateWatchlistRequest(): CreateWatchlistRequest {
  return { name: '' }
}

export const CreateWatchlistRequest: MessageFns<CreateWatchlistRequest> = {
  encode(message: CreateWatchlistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateWatchlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateWatchlistRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateWatchlistRequest {
    return { name: isSet(object.name) ? globalThis.String(object.name) : '' }
  },

  toJSON(message: CreateWatchlistRequest): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateWatchlistRequest>, I>>(
    base?: I
  ): CreateWatchlistRequest {
    return CreateWatchlistRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateWatchlistRequest>, I>>(
    object: I
  ): CreateWatchlistRequest {
    const message = createBaseCreateWatchlistRequest()
    message.name = object.name ?? ''
    return message
  },
}

function createBaseGenerateWatchlistRequest(): GenerateWatchlistRequest {
  return { prompt: '', name: '' }
}

export const GenerateWatchlistRequest: MessageFns<GenerateWatchlistRequest> = {
  encode(
    message: GenerateWatchlistRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.prompt !== '') {
      writer.uint32(10).string(message.prompt)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateWatchlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGenerateWatchlistRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.prompt = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GenerateWatchlistRequest {
    return {
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
    }
  },

  toJSON(message: GenerateWatchlistRequest): unknown {
    const obj: any = {}
    if (message.prompt !== '') {
      obj.prompt = message.prompt
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GenerateWatchlistRequest>, I>>(
    base?: I
  ): GenerateWatchlistRequest {
    return GenerateWatchlistRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GenerateWatchlistRequest>, I>>(
    object: I
  ): GenerateWatchlistRequest {
    const message = createBaseGenerateWatchlistRequest()
    message.prompt = object.prompt ?? ''
    message.name = object.name ?? ''
    return message
  },
}

function createBaseGetWatchlistsRequest(): GetWatchlistsRequest {
  return {}
}

export const GetWatchlistsRequest: MessageFns<GetWatchlistsRequest> = {
  encode(_: GetWatchlistsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWatchlistsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetWatchlistsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetWatchlistsRequest {
    return {}
  },

  toJSON(_: GetWatchlistsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetWatchlistsRequest>, I>>(base?: I): GetWatchlistsRequest {
    return GetWatchlistsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetWatchlistsRequest>, I>>(_: I): GetWatchlistsRequest {
    const message = createBaseGetWatchlistsRequest()
    return message
  },
}

function createBaseReorderWatchlistsRequest(): ReorderWatchlistsRequest {
  return { orderedWatchlistIds: [] }
}

export const ReorderWatchlistsRequest: MessageFns<ReorderWatchlistsRequest> = {
  encode(
    message: ReorderWatchlistsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.orderedWatchlistIds) {
      writer.uint32(10).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReorderWatchlistsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReorderWatchlistsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderedWatchlistIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ReorderWatchlistsRequest {
    return {
      orderedWatchlistIds: globalThis.Array.isArray(object?.orderedWatchlistIds)
        ? object.orderedWatchlistIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ordered_watchlist_ids)
          ? object.ordered_watchlist_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: ReorderWatchlistsRequest): unknown {
    const obj: any = {}
    if (message.orderedWatchlistIds?.length) {
      obj.orderedWatchlistIds = message.orderedWatchlistIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ReorderWatchlistsRequest>, I>>(
    base?: I
  ): ReorderWatchlistsRequest {
    return ReorderWatchlistsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ReorderWatchlistsRequest>, I>>(
    object: I
  ): ReorderWatchlistsRequest {
    const message = createBaseReorderWatchlistsRequest()
    message.orderedWatchlistIds = object.orderedWatchlistIds?.map((e) => e) || []
    return message
  },
}

function createBaseGetWatchlistsResponse(): GetWatchlistsResponse {
  return { watchlists: [] }
}

export const GetWatchlistsResponse: MessageFns<GetWatchlistsResponse> = {
  encode(message: GetWatchlistsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.watchlists) {
      Watchlist.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWatchlistsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetWatchlistsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.watchlists.push(Watchlist.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetWatchlistsResponse {
    return {
      watchlists: globalThis.Array.isArray(object?.watchlists)
        ? object.watchlists.map((e: any) => Watchlist.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GetWatchlistsResponse): unknown {
    const obj: any = {}
    if (message.watchlists?.length) {
      obj.watchlists = message.watchlists.map((e) => Watchlist.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetWatchlistsResponse>, I>>(base?: I): GetWatchlistsResponse {
    return GetWatchlistsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetWatchlistsResponse>, I>>(
    object: I
  ): GetWatchlistsResponse {
    const message = createBaseGetWatchlistsResponse()
    message.watchlists = object.watchlists?.map((e) => Watchlist.fromPartial(e)) || []
    return message
  },
}

function createBaseSetWatchlistRequest(): SetWatchlistRequest {
  return { watchlistId: '', orderedEntries: [] }
}

export const SetWatchlistRequest: MessageFns<SetWatchlistRequest> = {
  encode(message: SetWatchlistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watchlistId !== '') {
      writer.uint32(10).string(message.watchlistId)
    }
    for (const v of message.orderedEntries) {
      WatchlistEntry.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetWatchlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetWatchlistRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.orderedEntries.push(WatchlistEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetWatchlistRequest {
    return {
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
      orderedEntries: globalThis.Array.isArray(object?.orderedEntries)
        ? object.orderedEntries.map((e: any) => WatchlistEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_entries)
          ? object.ordered_entries.map((e: any) => WatchlistEntry.fromJSON(e))
          : [],
    }
  },

  toJSON(message: SetWatchlistRequest): unknown {
    const obj: any = {}
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    if (message.orderedEntries?.length) {
      obj.orderedEntries = message.orderedEntries.map((e) => WatchlistEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetWatchlistRequest>, I>>(base?: I): SetWatchlistRequest {
    return SetWatchlistRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetWatchlistRequest>, I>>(
    object: I
  ): SetWatchlistRequest {
    const message = createBaseSetWatchlistRequest()
    message.watchlistId = object.watchlistId ?? ''
    message.orderedEntries = object.orderedEntries?.map((e) => WatchlistEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseRenameWatchlistRequest(): RenameWatchlistRequest {
  return { watchlistId: '', newName: '' }
}

export const RenameWatchlistRequest: MessageFns<RenameWatchlistRequest> = {
  encode(message: RenameWatchlistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watchlistId !== '') {
      writer.uint32(10).string(message.watchlistId)
    }
    if (message.newName !== '') {
      writer.uint32(18).string(message.newName)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RenameWatchlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRenameWatchlistRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.newName = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RenameWatchlistRequest {
    return {
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
      newName: isSet(object.newName)
        ? globalThis.String(object.newName)
        : isSet(object.new_name)
          ? globalThis.String(object.new_name)
          : '',
    }
  },

  toJSON(message: RenameWatchlistRequest): unknown {
    const obj: any = {}
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    if (message.newName !== '') {
      obj.newName = message.newName
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RenameWatchlistRequest>, I>>(
    base?: I
  ): RenameWatchlistRequest {
    return RenameWatchlistRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RenameWatchlistRequest>, I>>(
    object: I
  ): RenameWatchlistRequest {
    const message = createBaseRenameWatchlistRequest()
    message.watchlistId = object.watchlistId ?? ''
    message.newName = object.newName ?? ''
    return message
  },
}

function createBaseDeleteWatchlistRequest(): DeleteWatchlistRequest {
  return { watchlistId: '' }
}

export const DeleteWatchlistRequest: MessageFns<DeleteWatchlistRequest> = {
  encode(message: DeleteWatchlistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watchlistId !== '') {
      writer.uint32(10).string(message.watchlistId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteWatchlistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteWatchlistRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteWatchlistRequest {
    return {
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
    }
  },

  toJSON(message: DeleteWatchlistRequest): unknown {
    const obj: any = {}
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteWatchlistRequest>, I>>(
    base?: I
  ): DeleteWatchlistRequest {
    return DeleteWatchlistRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteWatchlistRequest>, I>>(
    object: I
  ): DeleteWatchlistRequest {
    const message = createBaseDeleteWatchlistRequest()
    message.watchlistId = object.watchlistId ?? ''
    return message
  },
}

function createBaseWatchlistMutationResponse(): WatchlistMutationResponse {
  return { success: false, message: '', watchlist: undefined }
}

export const WatchlistMutationResponse: MessageFns<WatchlistMutationResponse> = {
  encode(
    message: WatchlistMutationResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.watchlist !== undefined) {
      Watchlist.encode(message.watchlist, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchlistMutationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWatchlistMutationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.watchlist = Watchlist.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WatchlistMutationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      watchlist: isSet(object.watchlist) ? Watchlist.fromJSON(object.watchlist) : undefined,
    }
  },

  toJSON(message: WatchlistMutationResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.watchlist !== undefined) {
      obj.watchlist = Watchlist.toJSON(message.watchlist)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WatchlistMutationResponse>, I>>(
    base?: I
  ): WatchlistMutationResponse {
    return WatchlistMutationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WatchlistMutationResponse>, I>>(
    object: I
  ): WatchlistMutationResponse {
    const message = createBaseWatchlistMutationResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    message.watchlist =
      object.watchlist !== undefined && object.watchlist !== null
        ? Watchlist.fromPartial(object.watchlist)
        : undefined
    return message
  },
}

function createBaseWatchlistRefreshRequest(): WatchlistRefreshRequest {
  return { userId: '', watchlistId: '', prompt: '' }
}

export const WatchlistRefreshRequest: MessageFns<WatchlistRefreshRequest> = {
  encode(
    message: WatchlistRefreshRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.watchlistId !== '') {
      writer.uint32(18).string(message.watchlistId)
    }
    if (message.prompt !== '') {
      writer.uint32(26).string(message.prompt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchlistRefreshRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWatchlistRefreshRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.prompt = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WatchlistRefreshRequest {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : '',
    }
  },

  toJSON(message: WatchlistRefreshRequest): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    if (message.prompt !== '') {
      obj.prompt = message.prompt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WatchlistRefreshRequest>, I>>(
    base?: I
  ): WatchlistRefreshRequest {
    return WatchlistRefreshRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WatchlistRefreshRequest>, I>>(
    object: I
  ): WatchlistRefreshRequest {
    const message = createBaseWatchlistRefreshRequest()
    message.userId = object.userId ?? ''
    message.watchlistId = object.watchlistId ?? ''
    message.prompt = object.prompt ?? ''
    return message
  },
}

function createBaseWatchlistRefreshResult(): WatchlistRefreshResult {
  return { userId: '', watchlistId: '', orderedEntries: [], refreshIntervalMs: undefined }
}

export const WatchlistRefreshResult: MessageFns<WatchlistRefreshResult> = {
  encode(message: WatchlistRefreshResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.watchlistId !== '') {
      writer.uint32(18).string(message.watchlistId)
    }
    for (const v of message.orderedEntries) {
      WatchlistEntry.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.refreshIntervalMs !== undefined) {
      writer.uint32(32).int64(message.refreshIntervalMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WatchlistRefreshResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWatchlistRefreshResult()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.watchlistId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.orderedEntries.push(WatchlistEntry.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.refreshIntervalMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WatchlistRefreshResult {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      watchlistId: isSet(object.watchlistId)
        ? globalThis.String(object.watchlistId)
        : isSet(object.watchlist_id)
          ? globalThis.String(object.watchlist_id)
          : '',
      orderedEntries: globalThis.Array.isArray(object?.orderedEntries)
        ? object.orderedEntries.map((e: any) => WatchlistEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.ordered_entries)
          ? object.ordered_entries.map((e: any) => WatchlistEntry.fromJSON(e))
          : [],
      refreshIntervalMs: isSet(object.refreshIntervalMs)
        ? globalThis.String(object.refreshIntervalMs)
        : isSet(object.refresh_interval_ms)
          ? globalThis.String(object.refresh_interval_ms)
          : undefined,
    }
  },

  toJSON(message: WatchlistRefreshResult): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.watchlistId !== '') {
      obj.watchlistId = message.watchlistId
    }
    if (message.orderedEntries?.length) {
      obj.orderedEntries = message.orderedEntries.map((e) => WatchlistEntry.toJSON(e))
    }
    if (message.refreshIntervalMs !== undefined) {
      obj.refreshIntervalMs = message.refreshIntervalMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WatchlistRefreshResult>, I>>(
    base?: I
  ): WatchlistRefreshResult {
    return WatchlistRefreshResult.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WatchlistRefreshResult>, I>>(
    object: I
  ): WatchlistRefreshResult {
    const message = createBaseWatchlistRefreshResult()
    message.userId = object.userId ?? ''
    message.watchlistId = object.watchlistId ?? ''
    message.orderedEntries = object.orderedEntries?.map((e) => WatchlistEntry.fromPartial(e)) || []
    message.refreshIntervalMs = object.refreshIntervalMs ?? undefined
    return message
  },
}

function createBaseExecutionBatch(): ExecutionBatch {
  return { executionCommands: undefined, algoCommands: undefined, cancelAllOrders: undefined }
}

export const ExecutionBatch: MessageFns<ExecutionBatch> = {
  encode(message: ExecutionBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.executionCommands !== undefined) {
      OrderExecutionCommandList.encode(message.executionCommands, writer.uint32(10).fork()).join()
    }
    if (message.algoCommands !== undefined) {
      AlgoServiceCommandList.encode(message.algoCommands, writer.uint32(18).fork()).join()
    }
    if (message.cancelAllOrders !== undefined) {
      CancelAllOrdersCommand.encode(message.cancelAllOrders, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionBatch()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.executionCommands = OrderExecutionCommandList.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoCommands = AlgoServiceCommandList.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.cancelAllOrders = CancelAllOrdersCommand.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionBatch {
    return {
      executionCommands: isSet(object.executionCommands)
        ? OrderExecutionCommandList.fromJSON(object.executionCommands)
        : isSet(object.execution_commands)
          ? OrderExecutionCommandList.fromJSON(object.execution_commands)
          : undefined,
      algoCommands: isSet(object.algoCommands)
        ? AlgoServiceCommandList.fromJSON(object.algoCommands)
        : isSet(object.algo_commands)
          ? AlgoServiceCommandList.fromJSON(object.algo_commands)
          : undefined,
      cancelAllOrders: isSet(object.cancelAllOrders)
        ? CancelAllOrdersCommand.fromJSON(object.cancelAllOrders)
        : isSet(object.cancel_all_orders)
          ? CancelAllOrdersCommand.fromJSON(object.cancel_all_orders)
          : undefined,
    }
  },

  toJSON(message: ExecutionBatch): unknown {
    const obj: any = {}
    if (message.executionCommands !== undefined) {
      obj.executionCommands = OrderExecutionCommandList.toJSON(message.executionCommands)
    }
    if (message.algoCommands !== undefined) {
      obj.algoCommands = AlgoServiceCommandList.toJSON(message.algoCommands)
    }
    if (message.cancelAllOrders !== undefined) {
      obj.cancelAllOrders = CancelAllOrdersCommand.toJSON(message.cancelAllOrders)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionBatch>, I>>(base?: I): ExecutionBatch {
    return ExecutionBatch.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionBatch>, I>>(object: I): ExecutionBatch {
    const message = createBaseExecutionBatch()
    message.executionCommands =
      object.executionCommands !== undefined && object.executionCommands !== null
        ? OrderExecutionCommandList.fromPartial(object.executionCommands)
        : undefined
    message.algoCommands =
      object.algoCommands !== undefined && object.algoCommands !== null
        ? AlgoServiceCommandList.fromPartial(object.algoCommands)
        : undefined
    message.cancelAllOrders =
      object.cancelAllOrders !== undefined && object.cancelAllOrders !== null
        ? CancelAllOrdersCommand.fromPartial(object.cancelAllOrders)
        : undefined
    return message
  },
}

function createBaseCancelAllOrdersCommand(): CancelAllOrdersCommand {
  return { accountId: [] }
}

export const CancelAllOrdersCommand: MessageFns<CancelAllOrdersCommand> = {
  encode(message: CancelAllOrdersCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.accountId) {
      writer.uint32(10).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAllOrdersCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAllOrdersCommand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAllOrdersCommand {
    return {
      accountId: globalThis.Array.isArray(object?.accountId)
        ? object.accountId.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_id)
          ? object.account_id.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: CancelAllOrdersCommand): unknown {
    const obj: any = {}
    if (message.accountId?.length) {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAllOrdersCommand>, I>>(
    base?: I
  ): CancelAllOrdersCommand {
    return CancelAllOrdersCommand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAllOrdersCommand>, I>>(
    object: I
  ): CancelAllOrdersCommand {
    const message = createBaseCancelAllOrdersCommand()
    message.accountId = object.accountId?.map((e) => e) || []
    return message
  },
}

function createBaseHistoryRequest(): HistoryRequest {
  return {
    accountId: '',
    accountIds: [],
    symbols: [],
    currency: [],
    from: undefined,
    to: undefined,
    limit: undefined,
  }
}

export const HistoryRequest: MessageFns<HistoryRequest> = {
  encode(message: HistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(58).string(v!)
    }
    for (const v of message.symbols) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.currency) {
      writer.uint32(26).string(v!)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHistoryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HistoryRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      currency: globalThis.Array.isArray(object?.currency)
        ? object.currency.map((e: any) => globalThis.String(e))
        : [],
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
    }
  },

  toJSON(message: HistoryRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.currency?.length) {
      obj.currency = message.currency
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HistoryRequest>, I>>(base?: I): HistoryRequest {
    return HistoryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HistoryRequest>, I>>(object: I): HistoryRequest {
    const message = createBaseHistoryRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.symbols = object.symbols?.map((e) => e) || []
    message.currency = object.currency?.map((e) => e) || []
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    return message
  },
}

function createBaseInstrumentListRequest(): InstrumentListRequest {
  return { exchange: 0 }
}

export const InstrumentListRequest: MessageFns<InstrumentListRequest> = {
  encode(message: InstrumentListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentListRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentListRequest {
    return { exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0 }
  },

  toJSON(message: InstrumentListRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentListRequest>, I>>(base?: I): InstrumentListRequest {
    return InstrumentListRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentListRequest>, I>>(
    object: I
  ): InstrumentListRequest {
    const message = createBaseInstrumentListRequest()
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseMasterInstrumentListRequest(): MasterInstrumentListRequest {
  return { exchange: 0 }
}

export const MasterInstrumentListRequest: MessageFns<MasterInstrumentListRequest> = {
  encode(
    message: MasterInstrumentListRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MasterInstrumentListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMasterInstrumentListRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MasterInstrumentListRequest {
    return { exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0 }
  },

  toJSON(message: MasterInstrumentListRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MasterInstrumentListRequest>, I>>(
    base?: I
  ): MasterInstrumentListRequest {
    return MasterInstrumentListRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MasterInstrumentListRequest>, I>>(
    object: I
  ): MasterInstrumentListRequest {
    const message = createBaseMasterInstrumentListRequest()
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseTime(): Time {
  return {}
}

export const Time: MessageFns<Time> = {
  encode(_: Time, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Time {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTime()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): Time {
    return {}
  },

  toJSON(_: Time): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<Time>, I>>(base?: I): Time {
    return Time.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Time>, I>>(_: I): Time {
    const message = createBaseTime()
    return message
  },
}

function createBaseOrderHistory(): OrderHistory {
  return {
    accountSource: undefined,
    symbols: [],
    instruments: [],
    instrumentKinds: [],
    expiries: [],
    strikeRange: undefined,
    fromTo: undefined,
    orderSize: undefined,
    orderType: undefined,
    orderStatus: undefined,
    limit: undefined,
    cursor: undefined,
  }
}

export const OrderHistory: MessageFns<OrderHistory> = {
  encode(message: OrderHistory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountSource !== undefined) {
      AccountSource.encode(message.accountSource, writer.uint32(10).fork()).join()
    }
    for (const v of message.symbols) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.instruments) {
      writer.uint32(26).string(v!)
    }
    writer.uint32(34).fork()
    for (const v of message.instrumentKinds) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.expiries) {
      writer.int64(v)
    }
    writer.join()
    if (message.strikeRange !== undefined) {
      IntRange.encode(message.strikeRange, writer.uint32(50).fork()).join()
    }
    if (message.fromTo !== undefined) {
      IntRange.encode(message.fromTo, writer.uint32(58).fork()).join()
    }
    if (message.orderSize !== undefined) {
      IntRange.encode(message.orderSize, writer.uint32(66).fork()).join()
    }
    if (message.orderType !== undefined) {
      writer.uint32(72).int32(message.orderType)
    }
    if (message.orderStatus !== undefined) {
      writer.uint32(80).int32(message.orderStatus)
    }
    if (message.limit !== undefined) {
      writer.uint32(88).int32(message.limit)
    }
    if (message.cursor !== undefined) {
      writer.uint32(96).int64(message.cursor)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderHistory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderHistory()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountSource = AccountSource.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.instruments.push(reader.string())
          continue
        }
        case 4: {
          if (tag === 32) {
            message.instrumentKinds.push(reader.int32() as any)

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.instrumentKinds.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 40) {
            message.expiries.push(reader.int64().toString())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.expiries.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.strikeRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.fromTo = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.orderSize = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.orderStatus = reader.int32() as any
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.cursor = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderHistory {
    return {
      accountSource: isSet(object.accountSource)
        ? AccountSource.fromJSON(object.accountSource)
        : isSet(object.account_source)
          ? AccountSource.fromJSON(object.account_source)
          : undefined,
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => globalThis.String(e))
        : [],
      instrumentKinds: globalThis.Array.isArray(object?.instrumentKinds)
        ? object.instrumentKinds.map((e: any) => instrumentKindFromJSON(e))
        : globalThis.Array.isArray(object?.instrument_kinds)
          ? object.instrument_kinds.map((e: any) => instrumentKindFromJSON(e))
          : [],
      expiries: globalThis.Array.isArray(object?.expiries)
        ? object.expiries.map((e: any) => globalThis.String(e))
        : [],
      strikeRange: isSet(object.strikeRange)
        ? IntRange.fromJSON(object.strikeRange)
        : isSet(object.strike_range)
          ? IntRange.fromJSON(object.strike_range)
          : undefined,
      fromTo: isSet(object.fromTo)
        ? IntRange.fromJSON(object.fromTo)
        : isSet(object.from_to)
          ? IntRange.fromJSON(object.from_to)
          : undefined,
      orderSize: isSet(object.orderSize)
        ? IntRange.fromJSON(object.orderSize)
        : isSet(object.order_size)
          ? IntRange.fromJSON(object.order_size)
          : undefined,
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : undefined,
      orderStatus: isSet(object.orderStatus)
        ? orderStatusFromJSON(object.orderStatus)
        : isSet(object.order_status)
          ? orderStatusFromJSON(object.order_status)
          : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
    }
  },

  toJSON(message: OrderHistory): unknown {
    const obj: any = {}
    if (message.accountSource !== undefined) {
      obj.accountSource = AccountSource.toJSON(message.accountSource)
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.instruments?.length) {
      obj.instruments = message.instruments
    }
    if (message.instrumentKinds?.length) {
      obj.instrumentKinds = message.instrumentKinds.map((e) => instrumentKindToJSON(e))
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries
    }
    if (message.strikeRange !== undefined) {
      obj.strikeRange = IntRange.toJSON(message.strikeRange)
    }
    if (message.fromTo !== undefined) {
      obj.fromTo = IntRange.toJSON(message.fromTo)
    }
    if (message.orderSize !== undefined) {
      obj.orderSize = IntRange.toJSON(message.orderSize)
    }
    if (message.orderType !== undefined) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    if (message.orderStatus !== undefined) {
      obj.orderStatus = orderStatusToJSON(message.orderStatus)
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderHistory>, I>>(base?: I): OrderHistory {
    return OrderHistory.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderHistory>, I>>(object: I): OrderHistory {
    const message = createBaseOrderHistory()
    message.accountSource =
      object.accountSource !== undefined && object.accountSource !== null
        ? AccountSource.fromPartial(object.accountSource)
        : undefined
    message.symbols = object.symbols?.map((e) => e) || []
    message.instruments = object.instruments?.map((e) => e) || []
    message.instrumentKinds = object.instrumentKinds?.map((e) => e) || []
    message.expiries = object.expiries?.map((e) => e) || []
    message.strikeRange =
      object.strikeRange !== undefined && object.strikeRange !== null
        ? IntRange.fromPartial(object.strikeRange)
        : undefined
    message.fromTo =
      object.fromTo !== undefined && object.fromTo !== null
        ? IntRange.fromPartial(object.fromTo)
        : undefined
    message.orderSize =
      object.orderSize !== undefined && object.orderSize !== null
        ? IntRange.fromPartial(object.orderSize)
        : undefined
    message.orderType = object.orderType ?? undefined
    message.orderStatus = object.orderStatus ?? undefined
    message.limit = object.limit ?? undefined
    message.cursor = object.cursor ?? undefined
    return message
  },
}

function createBaseOpenOrders(): OpenOrders {
  return {
    accountSource: undefined,
    symbols: [],
    instruments: [],
    instrumentKinds: [],
    expiries: [],
    strikeRange: undefined,
    orderSize: undefined,
    orderType: undefined,
  }
}

export const OpenOrders: MessageFns<OpenOrders> = {
  encode(message: OpenOrders, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountSource !== undefined) {
      AccountSource.encode(message.accountSource, writer.uint32(10).fork()).join()
    }
    for (const v of message.symbols) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.instruments) {
      writer.uint32(26).string(v!)
    }
    writer.uint32(34).fork()
    for (const v of message.instrumentKinds) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.expiries) {
      writer.int64(v)
    }
    writer.join()
    if (message.strikeRange !== undefined) {
      IntRange.encode(message.strikeRange, writer.uint32(50).fork()).join()
    }
    if (message.orderSize !== undefined) {
      IntRange.encode(message.orderSize, writer.uint32(58).fork()).join()
    }
    if (message.orderType !== undefined) {
      writer.uint32(64).int32(message.orderType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OpenOrders {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOpenOrders()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountSource = AccountSource.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.instruments.push(reader.string())
          continue
        }
        case 4: {
          if (tag === 32) {
            message.instrumentKinds.push(reader.int32() as any)

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.instrumentKinds.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 40) {
            message.expiries.push(reader.int64().toString())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.expiries.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.strikeRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.orderSize = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OpenOrders {
    return {
      accountSource: isSet(object.accountSource)
        ? AccountSource.fromJSON(object.accountSource)
        : isSet(object.account_source)
          ? AccountSource.fromJSON(object.account_source)
          : undefined,
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => globalThis.String(e))
        : [],
      instrumentKinds: globalThis.Array.isArray(object?.instrumentKinds)
        ? object.instrumentKinds.map((e: any) => instrumentKindFromJSON(e))
        : globalThis.Array.isArray(object?.instrument_kinds)
          ? object.instrument_kinds.map((e: any) => instrumentKindFromJSON(e))
          : [],
      expiries: globalThis.Array.isArray(object?.expiries)
        ? object.expiries.map((e: any) => globalThis.String(e))
        : [],
      strikeRange: isSet(object.strikeRange)
        ? IntRange.fromJSON(object.strikeRange)
        : isSet(object.strike_range)
          ? IntRange.fromJSON(object.strike_range)
          : undefined,
      orderSize: isSet(object.orderSize)
        ? IntRange.fromJSON(object.orderSize)
        : isSet(object.order_size)
          ? IntRange.fromJSON(object.order_size)
          : undefined,
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : undefined,
    }
  },

  toJSON(message: OpenOrders): unknown {
    const obj: any = {}
    if (message.accountSource !== undefined) {
      obj.accountSource = AccountSource.toJSON(message.accountSource)
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.instruments?.length) {
      obj.instruments = message.instruments
    }
    if (message.instrumentKinds?.length) {
      obj.instrumentKinds = message.instrumentKinds.map((e) => instrumentKindToJSON(e))
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries
    }
    if (message.strikeRange !== undefined) {
      obj.strikeRange = IntRange.toJSON(message.strikeRange)
    }
    if (message.orderSize !== undefined) {
      obj.orderSize = IntRange.toJSON(message.orderSize)
    }
    if (message.orderType !== undefined) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OpenOrders>, I>>(base?: I): OpenOrders {
    return OpenOrders.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OpenOrders>, I>>(object: I): OpenOrders {
    const message = createBaseOpenOrders()
    message.accountSource =
      object.accountSource !== undefined && object.accountSource !== null
        ? AccountSource.fromPartial(object.accountSource)
        : undefined
    message.symbols = object.symbols?.map((e) => e) || []
    message.instruments = object.instruments?.map((e) => e) || []
    message.instrumentKinds = object.instrumentKinds?.map((e) => e) || []
    message.expiries = object.expiries?.map((e) => e) || []
    message.strikeRange =
      object.strikeRange !== undefined && object.strikeRange !== null
        ? IntRange.fromPartial(object.strikeRange)
        : undefined
    message.orderSize =
      object.orderSize !== undefined && object.orderSize !== null
        ? IntRange.fromPartial(object.orderSize)
        : undefined
    message.orderType = object.orderType ?? undefined
    return message
  },
}

function createBasePositions(): Positions {
  return {
    accountSource: undefined,
    symbols: [],
    instruments: [],
    instrumentKinds: [],
    expiries: [],
    strikeRange: undefined,
    posDeltaRange: undefined,
    instrDeltaRange: undefined,
    quantityRange: undefined,
    unrealizedPnlRange: undefined,
  }
}

export const Positions: MessageFns<Positions> = {
  encode(message: Positions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountSource !== undefined) {
      AccountSource.encode(message.accountSource, writer.uint32(10).fork()).join()
    }
    for (const v of message.symbols) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.instruments) {
      writer.uint32(26).string(v!)
    }
    writer.uint32(34).fork()
    for (const v of message.instrumentKinds) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.expiries) {
      writer.int64(v)
    }
    writer.join()
    if (message.strikeRange !== undefined) {
      IntRange.encode(message.strikeRange, writer.uint32(50).fork()).join()
    }
    if (message.posDeltaRange !== undefined) {
      IntRange.encode(message.posDeltaRange, writer.uint32(58).fork()).join()
    }
    if (message.instrDeltaRange !== undefined) {
      IntRange.encode(message.instrDeltaRange, writer.uint32(66).fork()).join()
    }
    if (message.quantityRange !== undefined) {
      IntRange.encode(message.quantityRange, writer.uint32(74).fork()).join()
    }
    if (message.unrealizedPnlRange !== undefined) {
      IntRange.encode(message.unrealizedPnlRange, writer.uint32(82).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Positions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositions()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountSource = AccountSource.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbols.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.instruments.push(reader.string())
          continue
        }
        case 4: {
          if (tag === 32) {
            message.instrumentKinds.push(reader.int32() as any)

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.instrumentKinds.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 40) {
            message.expiries.push(reader.int64().toString())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.expiries.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.strikeRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.posDeltaRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.instrDeltaRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.quantityRange = IntRange.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.unrealizedPnlRange = IntRange.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Positions {
    return {
      accountSource: isSet(object.accountSource)
        ? AccountSource.fromJSON(object.accountSource)
        : isSet(object.account_source)
          ? AccountSource.fromJSON(object.account_source)
          : undefined,
      symbols: globalThis.Array.isArray(object?.symbols)
        ? object.symbols.map((e: any) => globalThis.String(e))
        : [],
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => globalThis.String(e))
        : [],
      instrumentKinds: globalThis.Array.isArray(object?.instrumentKinds)
        ? object.instrumentKinds.map((e: any) => instrumentKindFromJSON(e))
        : globalThis.Array.isArray(object?.instrument_kinds)
          ? object.instrument_kinds.map((e: any) => instrumentKindFromJSON(e))
          : [],
      expiries: globalThis.Array.isArray(object?.expiries)
        ? object.expiries.map((e: any) => globalThis.String(e))
        : [],
      strikeRange: isSet(object.strikeRange)
        ? IntRange.fromJSON(object.strikeRange)
        : isSet(object.strike_range)
          ? IntRange.fromJSON(object.strike_range)
          : undefined,
      posDeltaRange: isSet(object.posDeltaRange)
        ? IntRange.fromJSON(object.posDeltaRange)
        : isSet(object.pos_delta_range)
          ? IntRange.fromJSON(object.pos_delta_range)
          : undefined,
      instrDeltaRange: isSet(object.instrDeltaRange)
        ? IntRange.fromJSON(object.instrDeltaRange)
        : isSet(object.instr_delta_range)
          ? IntRange.fromJSON(object.instr_delta_range)
          : undefined,
      quantityRange: isSet(object.quantityRange)
        ? IntRange.fromJSON(object.quantityRange)
        : isSet(object.quantity_range)
          ? IntRange.fromJSON(object.quantity_range)
          : undefined,
      unrealizedPnlRange: isSet(object.unrealizedPnlRange)
        ? IntRange.fromJSON(object.unrealizedPnlRange)
        : isSet(object.unrealized_pnl_range)
          ? IntRange.fromJSON(object.unrealized_pnl_range)
          : undefined,
    }
  },

  toJSON(message: Positions): unknown {
    const obj: any = {}
    if (message.accountSource !== undefined) {
      obj.accountSource = AccountSource.toJSON(message.accountSource)
    }
    if (message.symbols?.length) {
      obj.symbols = message.symbols
    }
    if (message.instruments?.length) {
      obj.instruments = message.instruments
    }
    if (message.instrumentKinds?.length) {
      obj.instrumentKinds = message.instrumentKinds.map((e) => instrumentKindToJSON(e))
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries
    }
    if (message.strikeRange !== undefined) {
      obj.strikeRange = IntRange.toJSON(message.strikeRange)
    }
    if (message.posDeltaRange !== undefined) {
      obj.posDeltaRange = IntRange.toJSON(message.posDeltaRange)
    }
    if (message.instrDeltaRange !== undefined) {
      obj.instrDeltaRange = IntRange.toJSON(message.instrDeltaRange)
    }
    if (message.quantityRange !== undefined) {
      obj.quantityRange = IntRange.toJSON(message.quantityRange)
    }
    if (message.unrealizedPnlRange !== undefined) {
      obj.unrealizedPnlRange = IntRange.toJSON(message.unrealizedPnlRange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Positions>, I>>(base?: I): Positions {
    return Positions.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Positions>, I>>(object: I): Positions {
    const message = createBasePositions()
    message.accountSource =
      object.accountSource !== undefined && object.accountSource !== null
        ? AccountSource.fromPartial(object.accountSource)
        : undefined
    message.symbols = object.symbols?.map((e) => e) || []
    message.instruments = object.instruments?.map((e) => e) || []
    message.instrumentKinds = object.instrumentKinds?.map((e) => e) || []
    message.expiries = object.expiries?.map((e) => e) || []
    message.strikeRange =
      object.strikeRange !== undefined && object.strikeRange !== null
        ? IntRange.fromPartial(object.strikeRange)
        : undefined
    message.posDeltaRange =
      object.posDeltaRange !== undefined && object.posDeltaRange !== null
        ? IntRange.fromPartial(object.posDeltaRange)
        : undefined
    message.instrDeltaRange =
      object.instrDeltaRange !== undefined && object.instrDeltaRange !== null
        ? IntRange.fromPartial(object.instrDeltaRange)
        : undefined
    message.quantityRange =
      object.quantityRange !== undefined && object.quantityRange !== null
        ? IntRange.fromPartial(object.quantityRange)
        : undefined
    message.unrealizedPnlRange =
      object.unrealizedPnlRange !== undefined && object.unrealizedPnlRange !== null
        ? IntRange.fromPartial(object.unrealizedPnlRange)
        : undefined
    return message
  },
}

function createBaseIntRange(): IntRange {
  return { min: '', max: '' }
}

export const IntRange: MessageFns<IntRange> = {
  encode(message: IntRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== '') {
      writer.uint32(10).string(message.min)
    }
    if (message.max !== '') {
      writer.uint32(18).string(message.max)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.min = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.max = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntRange {
    return {
      min: isSet(object.min) ? globalThis.String(object.min) : '',
      max: isSet(object.max) ? globalThis.String(object.max) : '',
    }
  },

  toJSON(message: IntRange): unknown {
    const obj: any = {}
    if (message.min !== '') {
      obj.min = message.min
    }
    if (message.max !== '') {
      obj.max = message.max
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntRange>, I>>(base?: I): IntRange {
    return IntRange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntRange>, I>>(object: I): IntRange {
    const message = createBaseIntRange()
    message.min = object.min ?? ''
    message.max = object.max ?? ''
    return message
  },
}

function createBaseBalances(): Balances {
  return { accountSource: undefined, currencies: [] }
}

export const Balances: MessageFns<Balances> = {
  encode(message: Balances, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountSource !== undefined) {
      AccountSource.encode(message.accountSource, writer.uint32(10).fork()).join()
    }
    for (const v of message.currencies) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Balances {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBalances()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountSource = AccountSource.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currencies.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Balances {
    return {
      accountSource: isSet(object.accountSource)
        ? AccountSource.fromJSON(object.accountSource)
        : isSet(object.account_source)
          ? AccountSource.fromJSON(object.account_source)
          : undefined,
      currencies: globalThis.Array.isArray(object?.currencies)
        ? object.currencies.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: Balances): unknown {
    const obj: any = {}
    if (message.accountSource !== undefined) {
      obj.accountSource = AccountSource.toJSON(message.accountSource)
    }
    if (message.currencies?.length) {
      obj.currencies = message.currencies
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Balances>, I>>(base?: I): Balances {
    return Balances.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Balances>, I>>(object: I): Balances {
    const message = createBaseBalances()
    message.accountSource =
      object.accountSource !== undefined && object.accountSource !== null
        ? AccountSource.fromPartial(object.accountSource)
        : undefined
    message.currencies = object.currencies?.map((e) => e) || []
    return message
  },
}

function createBaseAccountSource(): AccountSource {
  return { accountIds: undefined, tradeVenues: undefined }
}

export const AccountSource: MessageFns<AccountSource> = {
  encode(message: AccountSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountIds !== undefined) {
      AccountIds.encode(message.accountIds, writer.uint32(10).fork()).join()
    }
    if (message.tradeVenues !== undefined) {
      TradeVenues.encode(message.tradeVenues, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountSource()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountIds = AccountIds.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tradeVenues = TradeVenues.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountSource {
    return {
      accountIds: isSet(object.accountIds)
        ? AccountIds.fromJSON(object.accountIds)
        : isSet(object.account_ids)
          ? AccountIds.fromJSON(object.account_ids)
          : undefined,
      tradeVenues: isSet(object.tradeVenues)
        ? TradeVenues.fromJSON(object.tradeVenues)
        : isSet(object.trade_venues)
          ? TradeVenues.fromJSON(object.trade_venues)
          : undefined,
    }
  },

  toJSON(message: AccountSource): unknown {
    const obj: any = {}
    if (message.accountIds !== undefined) {
      obj.accountIds = AccountIds.toJSON(message.accountIds)
    }
    if (message.tradeVenues !== undefined) {
      obj.tradeVenues = TradeVenues.toJSON(message.tradeVenues)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountSource>, I>>(base?: I): AccountSource {
    return AccountSource.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountSource>, I>>(object: I): AccountSource {
    const message = createBaseAccountSource()
    message.accountIds =
      object.accountIds !== undefined && object.accountIds !== null
        ? AccountIds.fromPartial(object.accountIds)
        : undefined
    message.tradeVenues =
      object.tradeVenues !== undefined && object.tradeVenues !== null
        ? TradeVenues.fromPartial(object.tradeVenues)
        : undefined
    return message
  },
}

function createBaseAccountIds(): AccountIds {
  return { ids: [] }
}

export const AccountIds: MessageFns<AccountIds> = {
  encode(message: AccountIds, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(10).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountIds {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountIds()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.ids.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountIds {
    return {
      ids: globalThis.Array.isArray(object?.ids)
        ? object.ids.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: AccountIds): unknown {
    const obj: any = {}
    if (message.ids?.length) {
      obj.ids = message.ids
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountIds>, I>>(base?: I): AccountIds {
    return AccountIds.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountIds>, I>>(object: I): AccountIds {
    const message = createBaseAccountIds()
    message.ids = object.ids?.map((e) => e) || []
    return message
  },
}

function createBaseTradeVenues(): TradeVenues {
  return { tradeVenues: [] }
}

export const TradeVenues: MessageFns<TradeVenues> = {
  encode(message: TradeVenues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.tradeVenues) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TradeVenues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTradeVenues()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.tradeVenues.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.tradeVenues.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TradeVenues {
    return {
      tradeVenues: globalThis.Array.isArray(object?.tradeVenues)
        ? object.tradeVenues.map((e: any) => tradeVenueFromJSON(e))
        : globalThis.Array.isArray(object?.trade_venues)
          ? object.trade_venues.map((e: any) => tradeVenueFromJSON(e))
          : [],
    }
  },

  toJSON(message: TradeVenues): unknown {
    const obj: any = {}
    if (message.tradeVenues?.length) {
      obj.tradeVenues = message.tradeVenues.map((e) => tradeVenueToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TradeVenues>, I>>(base?: I): TradeVenues {
    return TradeVenues.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TradeVenues>, I>>(object: I): TradeVenues {
    const message = createBaseTradeVenues()
    message.tradeVenues = object.tradeVenues?.map((e) => e) || []
    return message
  },
}

function createBaseCreateAccountRequest(): CreateAccountRequest {
  return { name: '', apiKey: undefined, apiSecret: undefined, tradeVenue: 0 }
}

export const CreateAccountRequest: MessageFns<CreateAccountRequest> = {
  encode(message: CreateAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.apiKey !== undefined) {
      writer.uint32(26).string(message.apiKey)
    }
    if (message.apiSecret !== undefined) {
      writer.uint32(34).string(message.apiSecret)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(40).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.apiKey = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.apiSecret = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateAccountRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      apiKey: isSet(object.apiKey)
        ? globalThis.String(object.apiKey)
        : isSet(object.api_key)
          ? globalThis.String(object.api_key)
          : undefined,
      apiSecret: isSet(object.apiSecret)
        ? globalThis.String(object.apiSecret)
        : isSet(object.api_secret)
          ? globalThis.String(object.api_secret)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: CreateAccountRequest): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.apiKey !== undefined) {
      obj.apiKey = message.apiKey
    }
    if (message.apiSecret !== undefined) {
      obj.apiSecret = message.apiSecret
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateAccountRequest>, I>>(base?: I): CreateAccountRequest {
    return CreateAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateAccountRequest>, I>>(
    object: I
  ): CreateAccountRequest {
    const message = createBaseCreateAccountRequest()
    message.name = object.name ?? ''
    message.apiKey = object.apiKey ?? undefined
    message.apiSecret = object.apiSecret ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseCreateAccountResponse(): CreateAccountResponse {
  return { name: '', accountId: '', publicIp: '', tradeVenue: 0 }
}

export const CreateAccountResponse: MessageFns<CreateAccountResponse> = {
  encode(message: CreateAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.accountId !== '') {
      writer.uint32(26).string(message.accountId)
    }
    if (message.publicIp !== '') {
      writer.uint32(34).string(message.publicIp)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(40).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateAccountResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.publicIp = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateAccountResponse {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      publicIp: isSet(object.publicIp)
        ? globalThis.String(object.publicIp)
        : isSet(object.public_ip)
          ? globalThis.String(object.public_ip)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: CreateAccountResponse): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.publicIp !== '') {
      obj.publicIp = message.publicIp
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateAccountResponse>, I>>(base?: I): CreateAccountResponse {
    return CreateAccountResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateAccountResponse>, I>>(
    object: I
  ): CreateAccountResponse {
    const message = createBaseCreateAccountResponse()
    message.name = object.name ?? ''
    message.accountId = object.accountId ?? ''
    message.publicIp = object.publicIp ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseUpdateAccountRequest(): UpdateAccountRequest {
  return {
    accountId: '',
    name: undefined,
    apiKey: undefined,
    apiSecret: undefined,
    disabled: undefined,
  }
}

export const UpdateAccountRequest: MessageFns<UpdateAccountRequest> = {
  encode(message: UpdateAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name)
    }
    if (message.apiKey !== undefined) {
      writer.uint32(26).string(message.apiKey)
    }
    if (message.apiSecret !== undefined) {
      writer.uint32(34).string(message.apiSecret)
    }
    if (message.disabled !== undefined) {
      writer.uint32(40).bool(message.disabled)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.apiKey = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.apiSecret = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.disabled = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateAccountRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      apiKey: isSet(object.apiKey)
        ? globalThis.String(object.apiKey)
        : isSet(object.api_key)
          ? globalThis.String(object.api_key)
          : undefined,
      apiSecret: isSet(object.apiSecret)
        ? globalThis.String(object.apiSecret)
        : isSet(object.api_secret)
          ? globalThis.String(object.api_secret)
          : undefined,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : undefined,
    }
  },

  toJSON(message: UpdateAccountRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.name !== undefined) {
      obj.name = message.name
    }
    if (message.apiKey !== undefined) {
      obj.apiKey = message.apiKey
    }
    if (message.apiSecret !== undefined) {
      obj.apiSecret = message.apiSecret
    }
    if (message.disabled !== undefined) {
      obj.disabled = message.disabled
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateAccountRequest>, I>>(base?: I): UpdateAccountRequest {
    return UpdateAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateAccountRequest>, I>>(
    object: I
  ): UpdateAccountRequest {
    const message = createBaseUpdateAccountRequest()
    message.accountId = object.accountId ?? ''
    message.name = object.name ?? undefined
    message.apiKey = object.apiKey ?? undefined
    message.apiSecret = object.apiSecret ?? undefined
    message.disabled = object.disabled ?? undefined
    return message
  },
}

function createBaseInviteToAccountRequest(): InviteToAccountRequest {
  return { accountId: '', email: '', role: 0 }
}

export const InviteToAccountRequest: MessageFns<InviteToAccountRequest> = {
  encode(message: InviteToAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.email !== '') {
      writer.uint32(18).string(message.email)
    }
    if (message.role !== 0) {
      writer.uint32(24).int32(message.role)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InviteToAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInviteToAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InviteToAccountRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
    }
  },

  toJSON(message: InviteToAccountRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InviteToAccountRequest>, I>>(
    base?: I
  ): InviteToAccountRequest {
    return InviteToAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InviteToAccountRequest>, I>>(
    object: I
  ): InviteToAccountRequest {
    const message = createBaseInviteToAccountRequest()
    message.accountId = object.accountId ?? ''
    message.email = object.email ?? ''
    message.role = object.role ?? 0
    return message
  },
}

function createBaseListAccountAccessRequest(): ListAccountAccessRequest {
  return { accountId: '' }
}

export const ListAccountAccessRequest: MessageFns<ListAccountAccessRequest> = {
  encode(
    message: ListAccountAccessRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAccountAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListAccountAccessRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListAccountAccessRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: ListAccountAccessRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListAccountAccessRequest>, I>>(
    base?: I
  ): ListAccountAccessRequest {
    return ListAccountAccessRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListAccountAccessRequest>, I>>(
    object: I
  ): ListAccountAccessRequest {
    const message = createBaseListAccountAccessRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseAccountMemberEntry(): AccountMemberEntry {
  return { userId: '', email: '', role: 0, createdAt: '0' }
}

export const AccountMemberEntry: MessageFns<AccountMemberEntry> = {
  encode(message: AccountMemberEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.email !== '') {
      writer.uint32(18).string(message.email)
    }
    if (message.role !== 0) {
      writer.uint32(24).int32(message.role)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountMemberEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountMemberEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountMemberEntry {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
    }
  },

  toJSON(message: AccountMemberEntry): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountMemberEntry>, I>>(base?: I): AccountMemberEntry {
    return AccountMemberEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountMemberEntry>, I>>(object: I): AccountMemberEntry {
    const message = createBaseAccountMemberEntry()
    message.userId = object.userId ?? ''
    message.email = object.email ?? ''
    message.role = object.role ?? 0
    message.createdAt = object.createdAt ?? '0'
    return message
  },
}

function createBasePendingInviteEntry(): PendingInviteEntry {
  return { email: '', role: 0, inviterUserId: '', createdAt: '0', expiresAt: '0', inviterEmail: '' }
}

export const PendingInviteEntry: MessageFns<PendingInviteEntry> = {
  encode(message: PendingInviteEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    if (message.role !== 0) {
      writer.uint32(16).int32(message.role)
    }
    if (message.inviterUserId !== '') {
      writer.uint32(26).string(message.inviterUserId)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    if (message.expiresAt !== '0') {
      writer.uint32(40).int64(message.expiresAt)
    }
    if (message.inviterEmail !== '') {
      writer.uint32(50).string(message.inviterEmail)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PendingInviteEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePendingInviteEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.inviterUserId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.inviterEmail = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PendingInviteEntry {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
      inviterUserId: isSet(object.inviterUserId)
        ? globalThis.String(object.inviterUserId)
        : isSet(object.inviter_user_id)
          ? globalThis.String(object.inviter_user_id)
          : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : '0',
      inviterEmail: isSet(object.inviterEmail)
        ? globalThis.String(object.inviterEmail)
        : isSet(object.inviter_email)
          ? globalThis.String(object.inviter_email)
          : '',
    }
  },

  toJSON(message: PendingInviteEntry): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    if (message.inviterUserId !== '') {
      obj.inviterUserId = message.inviterUserId
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.expiresAt !== '0') {
      obj.expiresAt = message.expiresAt
    }
    if (message.inviterEmail !== '') {
      obj.inviterEmail = message.inviterEmail
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PendingInviteEntry>, I>>(base?: I): PendingInviteEntry {
    return PendingInviteEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PendingInviteEntry>, I>>(object: I): PendingInviteEntry {
    const message = createBasePendingInviteEntry()
    message.email = object.email ?? ''
    message.role = object.role ?? 0
    message.inviterUserId = object.inviterUserId ?? ''
    message.createdAt = object.createdAt ?? '0'
    message.expiresAt = object.expiresAt ?? '0'
    message.inviterEmail = object.inviterEmail ?? ''
    return message
  },
}

function createBaseListAccountAccessResponse(): ListAccountAccessResponse {
  return { accountId: '', members: [], pendingInvites: [] }
}

export const ListAccountAccessResponse: MessageFns<ListAccountAccessResponse> = {
  encode(
    message: ListAccountAccessResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.members) {
      AccountMemberEntry.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.pendingInvites) {
      PendingInviteEntry.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAccountAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListAccountAccessResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.members.push(AccountMemberEntry.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.pendingInvites.push(PendingInviteEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListAccountAccessResponse {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      members: globalThis.Array.isArray(object?.members)
        ? object.members.map((e: any) => AccountMemberEntry.fromJSON(e))
        : [],
      pendingInvites: globalThis.Array.isArray(object?.pendingInvites)
        ? object.pendingInvites.map((e: any) => PendingInviteEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.pending_invites)
          ? object.pending_invites.map((e: any) => PendingInviteEntry.fromJSON(e))
          : [],
    }
  },

  toJSON(message: ListAccountAccessResponse): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => AccountMemberEntry.toJSON(e))
    }
    if (message.pendingInvites?.length) {
      obj.pendingInvites = message.pendingInvites.map((e) => PendingInviteEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListAccountAccessResponse>, I>>(
    base?: I
  ): ListAccountAccessResponse {
    return ListAccountAccessResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListAccountAccessResponse>, I>>(
    object: I
  ): ListAccountAccessResponse {
    const message = createBaseListAccountAccessResponse()
    message.accountId = object.accountId ?? ''
    message.members = object.members?.map((e) => AccountMemberEntry.fromPartial(e)) || []
    message.pendingInvites =
      object.pendingInvites?.map((e) => PendingInviteEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseRevokeInviteRequest(): RevokeInviteRequest {
  return { accountId: '', email: '' }
}

export const RevokeInviteRequest: MessageFns<RevokeInviteRequest> = {
  encode(message: RevokeInviteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.email !== '') {
      writer.uint32(18).string(message.email)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeInviteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeInviteRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.email = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeInviteRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      email: isSet(object.email) ? globalThis.String(object.email) : '',
    }
  },

  toJSON(message: RevokeInviteRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.email !== '') {
      obj.email = message.email
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeInviteRequest>, I>>(base?: I): RevokeInviteRequest {
    return RevokeInviteRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeInviteRequest>, I>>(
    object: I
  ): RevokeInviteRequest {
    const message = createBaseRevokeInviteRequest()
    message.accountId = object.accountId ?? ''
    message.email = object.email ?? ''
    return message
  },
}

function createBaseRemoveAccountAccessRequest(): RemoveAccountAccessRequest {
  return { accountId: '', userId: '' }
}

export const RemoveAccountAccessRequest: MessageFns<RemoveAccountAccessRequest> = {
  encode(
    message: RemoveAccountAccessRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.userId !== '') {
      writer.uint32(18).string(message.userId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveAccountAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRemoveAccountAccessRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.userId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RemoveAccountAccessRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
    }
  },

  toJSON(message: RemoveAccountAccessRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RemoveAccountAccessRequest>, I>>(
    base?: I
  ): RemoveAccountAccessRequest {
    return RemoveAccountAccessRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RemoveAccountAccessRequest>, I>>(
    object: I
  ): RemoveAccountAccessRequest {
    const message = createBaseRemoveAccountAccessRequest()
    message.accountId = object.accountId ?? ''
    message.userId = object.userId ?? ''
    return message
  },
}

function createBaseChangeAccountRoleRequest(): ChangeAccountRoleRequest {
  return { accountId: '', userId: '', role: 0 }
}

export const ChangeAccountRoleRequest: MessageFns<ChangeAccountRoleRequest> = {
  encode(
    message: ChangeAccountRoleRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.userId !== '') {
      writer.uint32(18).string(message.userId)
    }
    if (message.role !== 0) {
      writer.uint32(24).int32(message.role)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeAccountRoleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChangeAccountRoleRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChangeAccountRoleRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
    }
  },

  toJSON(message: ChangeAccountRoleRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChangeAccountRoleRequest>, I>>(
    base?: I
  ): ChangeAccountRoleRequest {
    return ChangeAccountRoleRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChangeAccountRoleRequest>, I>>(
    object: I
  ): ChangeAccountRoleRequest {
    const message = createBaseChangeAccountRoleRequest()
    message.accountId = object.accountId ?? ''
    message.userId = object.userId ?? ''
    message.role = object.role ?? 0
    return message
  },
}

function createBaseLeaveAccountRequest(): LeaveAccountRequest {
  return { accountId: '' }
}

export const LeaveAccountRequest: MessageFns<LeaveAccountRequest> = {
  encode(message: LeaveAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLeaveAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LeaveAccountRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: LeaveAccountRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LeaveAccountRequest>, I>>(base?: I): LeaveAccountRequest {
    return LeaveAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LeaveAccountRequest>, I>>(
    object: I
  ): LeaveAccountRequest {
    const message = createBaseLeaveAccountRequest()
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseTransferAccountOwnershipRequest(): TransferAccountOwnershipRequest {
  return { accountId: '', targetUserId: '' }
}

export const TransferAccountOwnershipRequest: MessageFns<TransferAccountOwnershipRequest> = {
  encode(
    message: TransferAccountOwnershipRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.targetUserId !== '') {
      writer.uint32(18).string(message.targetUserId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransferAccountOwnershipRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTransferAccountOwnershipRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.targetUserId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TransferAccountOwnershipRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      targetUserId: isSet(object.targetUserId)
        ? globalThis.String(object.targetUserId)
        : isSet(object.target_user_id)
          ? globalThis.String(object.target_user_id)
          : '',
    }
  },

  toJSON(message: TransferAccountOwnershipRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.targetUserId !== '') {
      obj.targetUserId = message.targetUserId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TransferAccountOwnershipRequest>, I>>(
    base?: I
  ): TransferAccountOwnershipRequest {
    return TransferAccountOwnershipRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TransferAccountOwnershipRequest>, I>>(
    object: I
  ): TransferAccountOwnershipRequest {
    const message = createBaseTransferAccountOwnershipRequest()
    message.accountId = object.accountId ?? ''
    message.targetUserId = object.targetUserId ?? ''
    return message
  },
}

function createBaseListMyInvitesRequest(): ListMyInvitesRequest {
  return {}
}

export const ListMyInvitesRequest: MessageFns<ListMyInvitesRequest> = {
  encode(_: ListMyInvitesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListMyInvitesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListMyInvitesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ListMyInvitesRequest {
    return {}
  },

  toJSON(_: ListMyInvitesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ListMyInvitesRequest>, I>>(base?: I): ListMyInvitesRequest {
    return ListMyInvitesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListMyInvitesRequest>, I>>(_: I): ListMyInvitesRequest {
    const message = createBaseListMyInvitesRequest()
    return message
  },
}

function createBaseMyInviteEntry(): MyInviteEntry {
  return {
    accountId: '',
    accountName: '',
    tradeVenue: 0,
    role: 0,
    inviterEmail: '',
    expiresAt: '0',
    createdAt: '0',
  }
}

export const MyInviteEntry: MessageFns<MyInviteEntry> = {
  encode(message: MyInviteEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.accountName !== '') {
      writer.uint32(18).string(message.accountName)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.role !== 0) {
      writer.uint32(32).int32(message.role)
    }
    if (message.inviterEmail !== '') {
      writer.uint32(42).string(message.inviterEmail)
    }
    if (message.expiresAt !== '0') {
      writer.uint32(48).int64(message.expiresAt)
    }
    if (message.createdAt !== '0') {
      writer.uint32(56).int64(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MyInviteEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMyInviteEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountName = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.inviterEmail = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MyInviteEntry {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
      inviterEmail: isSet(object.inviterEmail)
        ? globalThis.String(object.inviterEmail)
        : isSet(object.inviter_email)
          ? globalThis.String(object.inviter_email)
          : '',
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : '0',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
    }
  },

  toJSON(message: MyInviteEntry): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    if (message.inviterEmail !== '') {
      obj.inviterEmail = message.inviterEmail
    }
    if (message.expiresAt !== '0') {
      obj.expiresAt = message.expiresAt
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MyInviteEntry>, I>>(base?: I): MyInviteEntry {
    return MyInviteEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MyInviteEntry>, I>>(object: I): MyInviteEntry {
    const message = createBaseMyInviteEntry()
    message.accountId = object.accountId ?? ''
    message.accountName = object.accountName ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.role = object.role ?? 0
    message.inviterEmail = object.inviterEmail ?? ''
    message.expiresAt = object.expiresAt ?? '0'
    message.createdAt = object.createdAt ?? '0'
    return message
  },
}

function createBaseListMyInvitesResponse(): ListMyInvitesResponse {
  return { invites: [] }
}

export const ListMyInvitesResponse: MessageFns<ListMyInvitesResponse> = {
  encode(message: ListMyInvitesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      MyInviteEntry.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListMyInvitesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListMyInvitesResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.invites.push(MyInviteEntry.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListMyInvitesResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => MyInviteEntry.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ListMyInvitesResponse): unknown {
    const obj: any = {}
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => MyInviteEntry.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListMyInvitesResponse>, I>>(base?: I): ListMyInvitesResponse {
    return ListMyInvitesResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListMyInvitesResponse>, I>>(
    object: I
  ): ListMyInvitesResponse {
    const message = createBaseListMyInvitesResponse()
    message.invites = object.invites?.map((e) => MyInviteEntry.fromPartial(e)) || []
    return message
  },
}

function createBaseRespondToInviteRequest(): RespondToInviteRequest {
  return { accountId: '', accept: false }
}

export const RespondToInviteRequest: MessageFns<RespondToInviteRequest> = {
  encode(message: RespondToInviteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.accept !== false) {
      writer.uint32(16).bool(message.accept)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RespondToInviteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRespondToInviteRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.accept = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RespondToInviteRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accept: isSet(object.accept) ? globalThis.Boolean(object.accept) : false,
    }
  },

  toJSON(message: RespondToInviteRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accept !== false) {
      obj.accept = message.accept
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RespondToInviteRequest>, I>>(
    base?: I
  ): RespondToInviteRequest {
    return RespondToInviteRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RespondToInviteRequest>, I>>(
    object: I
  ): RespondToInviteRequest {
    const message = createBaseRespondToInviteRequest()
    message.accountId = object.accountId ?? ''
    message.accept = object.accept ?? false
    return message
  },
}

function createBaseGetUserAccountsRequest(): GetUserAccountsRequest {
  return {}
}

export const GetUserAccountsRequest: MessageFns<GetUserAccountsRequest> = {
  encode(_: GetUserAccountsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserAccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetUserAccountsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetUserAccountsRequest {
    return {}
  },

  toJSON(_: GetUserAccountsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetUserAccountsRequest>, I>>(
    base?: I
  ): GetUserAccountsRequest {
    return GetUserAccountsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetUserAccountsRequest>, I>>(
    _: I
  ): GetUserAccountsRequest {
    const message = createBaseGetUserAccountsRequest()
    return message
  },
}

function createBaseRequestPasswordResetRequest(): RequestPasswordResetRequest {
  return { email: '' }
}

export const RequestPasswordResetRequest: MessageFns<RequestPasswordResetRequest> = {
  encode(
    message: RequestPasswordResetRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestPasswordResetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRequestPasswordResetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RequestPasswordResetRequest {
    return { email: isSet(object.email) ? globalThis.String(object.email) : '' }
  },

  toJSON(message: RequestPasswordResetRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RequestPasswordResetRequest>, I>>(
    base?: I
  ): RequestPasswordResetRequest {
    return RequestPasswordResetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RequestPasswordResetRequest>, I>>(
    object: I
  ): RequestPasswordResetRequest {
    const message = createBaseRequestPasswordResetRequest()
    message.email = object.email ?? ''
    return message
  },
}

function createBaseRequestPasswordResetResponse(): RequestPasswordResetResponse {
  return { success: false, message: '' }
}

export const RequestPasswordResetResponse: MessageFns<RequestPasswordResetResponse> = {
  encode(
    message: RequestPasswordResetResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestPasswordResetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRequestPasswordResetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RequestPasswordResetResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
    }
  },

  toJSON(message: RequestPasswordResetResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RequestPasswordResetResponse>, I>>(
    base?: I
  ): RequestPasswordResetResponse {
    return RequestPasswordResetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RequestPasswordResetResponse>, I>>(
    object: I
  ): RequestPasswordResetResponse {
    const message = createBaseRequestPasswordResetResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    return message
  },
}

function createBaseConfirmPasswordResetRequest(): ConfirmPasswordResetRequest {
  return { email: '', verificationCode: '', newPassword: '' }
}

export const ConfirmPasswordResetRequest: MessageFns<ConfirmPasswordResetRequest> = {
  encode(
    message: ConfirmPasswordResetRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    if (message.verificationCode !== '') {
      writer.uint32(18).string(message.verificationCode)
    }
    if (message.newPassword !== '') {
      writer.uint32(26).string(message.newPassword)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasswordResetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasswordResetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.verificationCode = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.newPassword = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasswordResetRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      verificationCode: isSet(object.verificationCode)
        ? globalThis.String(object.verificationCode)
        : isSet(object.verification_code)
          ? globalThis.String(object.verification_code)
          : '',
      newPassword: isSet(object.newPassword)
        ? globalThis.String(object.newPassword)
        : isSet(object.new_password)
          ? globalThis.String(object.new_password)
          : '',
    }
  },

  toJSON(message: ConfirmPasswordResetRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.verificationCode !== '') {
      obj.verificationCode = message.verificationCode
    }
    if (message.newPassword !== '') {
      obj.newPassword = message.newPassword
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasswordResetRequest>, I>>(
    base?: I
  ): ConfirmPasswordResetRequest {
    return ConfirmPasswordResetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasswordResetRequest>, I>>(
    object: I
  ): ConfirmPasswordResetRequest {
    const message = createBaseConfirmPasswordResetRequest()
    message.email = object.email ?? ''
    message.verificationCode = object.verificationCode ?? ''
    message.newPassword = object.newPassword ?? ''
    return message
  },
}

function createBaseConfirmPasswordResetResponse(): ConfirmPasswordResetResponse {
  return { success: false, message: '' }
}

export const ConfirmPasswordResetResponse: MessageFns<ConfirmPasswordResetResponse> = {
  encode(
    message: ConfirmPasswordResetResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasswordResetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasswordResetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasswordResetResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
    }
  },

  toJSON(message: ConfirmPasswordResetResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasswordResetResponse>, I>>(
    base?: I
  ): ConfirmPasswordResetResponse {
    return ConfirmPasswordResetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasswordResetResponse>, I>>(
    object: I
  ): ConfirmPasswordResetResponse {
    const message = createBaseConfirmPasswordResetResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    return message
  },
}

function createBaseVerifyEmailRequest(): VerifyEmailRequest {
  return { email: '', verificationCode: '' }
}

export const VerifyEmailRequest: MessageFns<VerifyEmailRequest> = {
  encode(message: VerifyEmailRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    if (message.verificationCode !== '') {
      writer.uint32(18).string(message.verificationCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyEmailRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerifyEmailRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.verificationCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VerifyEmailRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      verificationCode: isSet(object.verificationCode)
        ? globalThis.String(object.verificationCode)
        : isSet(object.verification_code)
          ? globalThis.String(object.verification_code)
          : '',
    }
  },

  toJSON(message: VerifyEmailRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.verificationCode !== '') {
      obj.verificationCode = message.verificationCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VerifyEmailRequest>, I>>(base?: I): VerifyEmailRequest {
    return VerifyEmailRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VerifyEmailRequest>, I>>(object: I): VerifyEmailRequest {
    const message = createBaseVerifyEmailRequest()
    message.email = object.email ?? ''
    message.verificationCode = object.verificationCode ?? ''
    return message
  },
}

function createBaseVerifyEmailResponse(): VerifyEmailResponse {
  return { success: false, message: '' }
}

export const VerifyEmailResponse: MessageFns<VerifyEmailResponse> = {
  encode(message: VerifyEmailResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyEmailResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerifyEmailResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VerifyEmailResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
    }
  },

  toJSON(message: VerifyEmailResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VerifyEmailResponse>, I>>(base?: I): VerifyEmailResponse {
    return VerifyEmailResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VerifyEmailResponse>, I>>(
    object: I
  ): VerifyEmailResponse {
    const message = createBaseVerifyEmailResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    return message
  },
}

function createBaseVerifyTokenRequest(): VerifyTokenRequest {
  return {}
}

export const VerifyTokenRequest: MessageFns<VerifyTokenRequest> = {
  encode(_: VerifyTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerifyTokenRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): VerifyTokenRequest {
    return {}
  },

  toJSON(_: VerifyTokenRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<VerifyTokenRequest>, I>>(base?: I): VerifyTokenRequest {
    return VerifyTokenRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VerifyTokenRequest>, I>>(_: I): VerifyTokenRequest {
    const message = createBaseVerifyTokenRequest()
    return message
  },
}

function createBaseParsedAuthenticatorToken(): ParsedAuthenticatorToken {
  return { userId: '', emailVerified: false }
}

export const ParsedAuthenticatorToken: MessageFns<ParsedAuthenticatorToken> = {
  encode(
    message: ParsedAuthenticatorToken,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.emailVerified !== false) {
      writer.uint32(16).bool(message.emailVerified)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParsedAuthenticatorToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParsedAuthenticatorToken()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.emailVerified = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParsedAuthenticatorToken {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      emailVerified: isSet(object.emailVerified)
        ? globalThis.Boolean(object.emailVerified)
        : isSet(object.email_verified)
          ? globalThis.Boolean(object.email_verified)
          : false,
    }
  },

  toJSON(message: ParsedAuthenticatorToken): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.emailVerified !== false) {
      obj.emailVerified = message.emailVerified
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParsedAuthenticatorToken>, I>>(
    base?: I
  ): ParsedAuthenticatorToken {
    return ParsedAuthenticatorToken.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParsedAuthenticatorToken>, I>>(
    object: I
  ): ParsedAuthenticatorToken {
    const message = createBaseParsedAuthenticatorToken()
    message.userId = object.userId ?? ''
    message.emailVerified = object.emailVerified ?? false
    return message
  },
}

function createBaseVerifyTokenResponse(): VerifyTokenResponse {
  return { valid: false, token: undefined, errorMessage: undefined }
}

export const VerifyTokenResponse: MessageFns<VerifyTokenResponse> = {
  encode(message: VerifyTokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.valid !== false) {
      writer.uint32(8).bool(message.valid)
    }
    if (message.token !== undefined) {
      ParsedAuthenticatorToken.encode(message.token, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyTokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerifyTokenResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.valid = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.token = ParsedAuthenticatorToken.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VerifyTokenResponse {
    return {
      valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
      token: isSet(object.token) ? ParsedAuthenticatorToken.fromJSON(object.token) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: VerifyTokenResponse): unknown {
    const obj: any = {}
    if (message.valid !== false) {
      obj.valid = message.valid
    }
    if (message.token !== undefined) {
      obj.token = ParsedAuthenticatorToken.toJSON(message.token)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VerifyTokenResponse>, I>>(base?: I): VerifyTokenResponse {
    return VerifyTokenResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VerifyTokenResponse>, I>>(
    object: I
  ): VerifyTokenResponse {
    const message = createBaseVerifyTokenResponse()
    message.valid = object.valid ?? false
    message.token =
      object.token !== undefined && object.token !== null
        ? ParsedAuthenticatorToken.fromPartial(object.token)
        : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseResendVerificationRequest(): ResendVerificationRequest {
  return { email: '' }
}

export const ResendVerificationRequest: MessageFns<ResendVerificationRequest> = {
  encode(
    message: ResendVerificationRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResendVerificationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResendVerificationRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResendVerificationRequest {
    return { email: isSet(object.email) ? globalThis.String(object.email) : '' }
  },

  toJSON(message: ResendVerificationRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResendVerificationRequest>, I>>(
    base?: I
  ): ResendVerificationRequest {
    return ResendVerificationRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResendVerificationRequest>, I>>(
    object: I
  ): ResendVerificationRequest {
    const message = createBaseResendVerificationRequest()
    message.email = object.email ?? ''
    return message
  },
}

function createBaseResendVerificationResponse(): ResendVerificationResponse {
  return { success: false, message: '' }
}

export const ResendVerificationResponse: MessageFns<ResendVerificationResponse> = {
  encode(
    message: ResendVerificationResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResendVerificationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResendVerificationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResendVerificationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
    }
  },

  toJSON(message: ResendVerificationResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResendVerificationResponse>, I>>(
    base?: I
  ): ResendVerificationResponse {
    return ResendVerificationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResendVerificationResponse>, I>>(
    object: I
  ): ResendVerificationResponse {
    const message = createBaseResendVerificationResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    return message
  },
}

function createBaseCrossExchangeScope(): CrossExchangeScope {
  return { exchanges: [], instrumentTypes: [] }
}

export const CrossExchangeScope: MessageFns<CrossExchangeScope> = {
  encode(message: CrossExchangeScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork()
    for (const v of message.exchanges) {
      writer.int32(v)
    }
    writer.join()
    writer.uint32(18).fork()
    for (const v of message.instrumentTypes) {
      writer.int32(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.exchanges.push(reader.int32() as any)

            continue
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.exchanges.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 2: {
          if (tag === 16) {
            message.instrumentTypes.push(reader.int32() as any)

            continue
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.instrumentTypes.push(reader.int32() as any)
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeScope {
    return {
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => exchangeFromJSON(e))
        : [],
      instrumentTypes: globalThis.Array.isArray(object?.instrumentTypes)
        ? object.instrumentTypes.map((e: any) => crossExchangeInstrumentTypeFromJSON(e))
        : globalThis.Array.isArray(object?.instrument_types)
          ? object.instrument_types.map((e: any) => crossExchangeInstrumentTypeFromJSON(e))
          : [],
    }
  },

  toJSON(message: CrossExchangeScope): unknown {
    const obj: any = {}
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges.map((e) => exchangeToJSON(e))
    }
    if (message.instrumentTypes?.length) {
      obj.instrumentTypes = message.instrumentTypes.map((e) => crossExchangeInstrumentTypeToJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeScope>, I>>(base?: I): CrossExchangeScope {
    return CrossExchangeScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeScope>, I>>(object: I): CrossExchangeScope {
    const message = createBaseCrossExchangeScope()
    message.exchanges = object.exchanges?.map((e) => e) || []
    message.instrumentTypes = object.instrumentTypes?.map((e) => e) || []
    return message
  },
}

function createBaseCrossExchangeLeg(): CrossExchangeLeg {
  return { exchange: 0, symbol: '', instrumentType: 0 }
}

export const CrossExchangeLeg: MessageFns<CrossExchangeLeg> = {
  encode(message: CrossExchangeLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.instrumentType !== 0) {
      writer.uint32(24).int32(message.instrumentType)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.instrumentType = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeLeg {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      instrumentType: isSet(object.instrumentType)
        ? crossExchangeInstrumentTypeFromJSON(object.instrumentType)
        : isSet(object.instrument_type)
          ? crossExchangeInstrumentTypeFromJSON(object.instrument_type)
          : 0,
    }
  },

  toJSON(message: CrossExchangeLeg): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.instrumentType !== 0) {
      obj.instrumentType = crossExchangeInstrumentTypeToJSON(message.instrumentType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeLeg>, I>>(base?: I): CrossExchangeLeg {
    return CrossExchangeLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeLeg>, I>>(object: I): CrossExchangeLeg {
    const message = createBaseCrossExchangeLeg()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.instrumentType = object.instrumentType ?? 0
    return message
  },
}

function createBaseChartDataRequest(): ChartDataRequest {
  return {
    symbol: '',
    exchange: 0,
    timeframe: 0,
    from: undefined,
    to: undefined,
    limit: undefined,
    families: [],
    crossExchange: undefined,
  }
}

export const ChartDataRequest: MessageFns<ChartDataRequest> = {
  encode(message: ChartDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    writer.uint32(58).fork()
    for (const v of message.families) {
      writer.int32(v)
    }
    writer.join()
    if (message.crossExchange !== undefined) {
      CrossExchangeScope.encode(message.crossExchange, writer.uint32(66).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartDataRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 7: {
          if (tag === 56) {
            message.families.push(reader.int32() as any)

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.families.push(reader.int32() as any)
            }

            continue
          }

          break
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.crossExchange = CrossExchangeScope.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartDataRequest {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      families: globalThis.Array.isArray(object?.families)
        ? object.families.map((e: any) => candleFamilyFromJSON(e))
        : [],
      crossExchange: isSet(object.crossExchange)
        ? CrossExchangeScope.fromJSON(object.crossExchange)
        : isSet(object.cross_exchange)
          ? CrossExchangeScope.fromJSON(object.cross_exchange)
          : undefined,
    }
  },

  toJSON(message: ChartDataRequest): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.families?.length) {
      obj.families = message.families.map((e) => candleFamilyToJSON(e))
    }
    if (message.crossExchange !== undefined) {
      obj.crossExchange = CrossExchangeScope.toJSON(message.crossExchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartDataRequest>, I>>(base?: I): ChartDataRequest {
    return ChartDataRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartDataRequest>, I>>(object: I): ChartDataRequest {
    const message = createBaseChartDataRequest()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.timeframe = object.timeframe ?? 0
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.families = object.families?.map((e) => e) || []
    message.crossExchange =
      object.crossExchange !== undefined && object.crossExchange !== null
        ? CrossExchangeScope.fromPartial(object.crossExchange)
        : undefined
    return message
  },
}

function createBaseChartData(): ChartData {
  return { symbol: '', exchange: 0, timeframe: 0, candles: undefined, crossExchangeLegs: [] }
}

export const ChartData: MessageFns<ChartData> = {
  encode(message: ChartData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.candles !== undefined) {
      CandleList.encode(message.candles, writer.uint32(42).fork()).join()
    }
    for (const v of message.crossExchangeLegs) {
      CrossExchangeLeg.encode(v!, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.candles = CandleList.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.crossExchangeLegs.push(CrossExchangeLeg.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartData {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      timeframe: isSet(object.timeframe) ? chartTimeframeFromJSON(object.timeframe) : 0,
      candles: isSet(object.candles) ? CandleList.fromJSON(object.candles) : undefined,
      crossExchangeLegs: globalThis.Array.isArray(object?.crossExchangeLegs)
        ? object.crossExchangeLegs.map((e: any) => CrossExchangeLeg.fromJSON(e))
        : globalThis.Array.isArray(object?.cross_exchange_legs)
          ? object.cross_exchange_legs.map((e: any) => CrossExchangeLeg.fromJSON(e))
          : [],
    }
  },

  toJSON(message: ChartData): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.timeframe !== 0) {
      obj.timeframe = chartTimeframeToJSON(message.timeframe)
    }
    if (message.candles !== undefined) {
      obj.candles = CandleList.toJSON(message.candles)
    }
    if (message.crossExchangeLegs?.length) {
      obj.crossExchangeLegs = message.crossExchangeLegs.map((e) => CrossExchangeLeg.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartData>, I>>(base?: I): ChartData {
    return ChartData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartData>, I>>(object: I): ChartData {
    const message = createBaseChartData()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.timeframe = object.timeframe ?? 0
    message.candles =
      object.candles !== undefined && object.candles !== null
        ? CandleList.fromPartial(object.candles)
        : undefined
    message.crossExchangeLegs =
      object.crossExchangeLegs?.map((e) => CrossExchangeLeg.fromPartial(e)) || []
    return message
  },
}

function createBaseVisibleRangeProfileRequest(): VisibleRangeProfileRequest {
  return {
    exchange: 0,
    symbol: '',
    fromMs: '0',
    toMs: '0',
    buckets: undefined,
    priceMin: undefined,
    priceMax: undefined,
  }
}

export const VisibleRangeProfileRequest: MessageFns<VisibleRangeProfileRequest> = {
  encode(
    message: VisibleRangeProfileRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.fromMs !== '0') {
      writer.uint32(24).int64(message.fromMs)
    }
    if (message.toMs !== '0') {
      writer.uint32(32).int64(message.toMs)
    }
    if (message.buckets !== undefined) {
      writer.uint32(40).int32(message.buckets)
    }
    if (message.priceMin !== undefined) {
      writer.uint32(49).double(message.priceMin)
    }
    if (message.priceMax !== undefined) {
      writer.uint32(57).double(message.priceMax)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VisibleRangeProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVisibleRangeProfileRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.fromMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.toMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.buckets = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.priceMin = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.priceMax = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VisibleRangeProfileRequest {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      fromMs: isSet(object.fromMs)
        ? globalThis.String(object.fromMs)
        : isSet(object.from_ms)
          ? globalThis.String(object.from_ms)
          : '0',
      toMs: isSet(object.toMs)
        ? globalThis.String(object.toMs)
        : isSet(object.to_ms)
          ? globalThis.String(object.to_ms)
          : '0',
      buckets: isSet(object.buckets) ? globalThis.Number(object.buckets) : undefined,
      priceMin: isSet(object.priceMin)
        ? globalThis.Number(object.priceMin)
        : isSet(object.price_min)
          ? globalThis.Number(object.price_min)
          : undefined,
      priceMax: isSet(object.priceMax)
        ? globalThis.Number(object.priceMax)
        : isSet(object.price_max)
          ? globalThis.Number(object.price_max)
          : undefined,
    }
  },

  toJSON(message: VisibleRangeProfileRequest): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.fromMs !== '0') {
      obj.fromMs = message.fromMs
    }
    if (message.toMs !== '0') {
      obj.toMs = message.toMs
    }
    if (message.buckets !== undefined) {
      obj.buckets = Math.round(message.buckets)
    }
    if (message.priceMin !== undefined) {
      obj.priceMin = message.priceMin
    }
    if (message.priceMax !== undefined) {
      obj.priceMax = message.priceMax
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VisibleRangeProfileRequest>, I>>(
    base?: I
  ): VisibleRangeProfileRequest {
    return VisibleRangeProfileRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VisibleRangeProfileRequest>, I>>(
    object: I
  ): VisibleRangeProfileRequest {
    const message = createBaseVisibleRangeProfileRequest()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.fromMs = object.fromMs ?? '0'
    message.toMs = object.toMs ?? '0'
    message.buckets = object.buckets ?? undefined
    message.priceMin = object.priceMin ?? undefined
    message.priceMax = object.priceMax ?? undefined
    return message
  },
}

function createBaseVisibleRangeProfile(): VisibleRangeProfile {
  return {
    exchange: 0,
    symbol: '',
    fromMs: '0',
    toMs: '0',
    priceMin: 0,
    bucketWidth: 0,
    buyVolumeBase: [],
    sellVolumeBase: [],
    buyVolumeQuote: [],
    sellVolumeQuote: [],
    buyLiquidationBase: [],
    sellLiquidationBase: [],
    buyLiquidationQuote: [],
    sellLiquidationQuote: [],
    coveredFromMs: undefined,
    coveredToMs: undefined,
    sourceIntervalSeconds: 0,
    openInterestIncreaseBase: [],
    openInterestDecreaseBase: [],
    openInterestIncreaseQuote: [],
    openInterestDecreaseQuote: [],
  }
}

export const VisibleRangeProfile: MessageFns<VisibleRangeProfile> = {
  encode(message: VisibleRangeProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.fromMs !== '0') {
      writer.uint32(24).int64(message.fromMs)
    }
    if (message.toMs !== '0') {
      writer.uint32(32).int64(message.toMs)
    }
    if (message.priceMin !== 0) {
      writer.uint32(41).double(message.priceMin)
    }
    if (message.bucketWidth !== 0) {
      writer.uint32(49).double(message.bucketWidth)
    }
    writer.uint32(58).fork()
    for (const v of message.buyVolumeBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.sellVolumeBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.buyVolumeQuote) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.sellVolumeQuote) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(90).fork()
    for (const v of message.buyLiquidationBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(98).fork()
    for (const v of message.sellLiquidationBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(106).fork()
    for (const v of message.buyLiquidationQuote) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(114).fork()
    for (const v of message.sellLiquidationQuote) {
      writer.double(v)
    }
    writer.join()
    if (message.coveredFromMs !== undefined) {
      writer.uint32(120).int64(message.coveredFromMs)
    }
    if (message.coveredToMs !== undefined) {
      writer.uint32(128).int64(message.coveredToMs)
    }
    if (message.sourceIntervalSeconds !== 0) {
      writer.uint32(136).int32(message.sourceIntervalSeconds)
    }
    writer.uint32(146).fork()
    for (const v of message.openInterestIncreaseBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(154).fork()
    for (const v of message.openInterestDecreaseBase) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(162).fork()
    for (const v of message.openInterestIncreaseQuote) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(170).fork()
    for (const v of message.openInterestDecreaseQuote) {
      writer.double(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VisibleRangeProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVisibleRangeProfile()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.fromMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.toMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.priceMin = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.bucketWidth = reader.double()
          continue
        }
        case 7: {
          if (tag === 57) {
            message.buyVolumeBase.push(reader.double())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyVolumeBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 65) {
            message.sellVolumeBase.push(reader.double())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellVolumeBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 73) {
            message.buyVolumeQuote.push(reader.double())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyVolumeQuote.push(reader.double())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 81) {
            message.sellVolumeQuote.push(reader.double())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellVolumeQuote.push(reader.double())
            }

            continue
          }

          break
        }
        case 11: {
          if (tag === 89) {
            message.buyLiquidationBase.push(reader.double())

            continue
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyLiquidationBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 12: {
          if (tag === 97) {
            message.sellLiquidationBase.push(reader.double())

            continue
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellLiquidationBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 13: {
          if (tag === 105) {
            message.buyLiquidationQuote.push(reader.double())

            continue
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.buyLiquidationQuote.push(reader.double())
            }

            continue
          }

          break
        }
        case 14: {
          if (tag === 113) {
            message.sellLiquidationQuote.push(reader.double())

            continue
          }

          if (tag === 114) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.sellLiquidationQuote.push(reader.double())
            }

            continue
          }

          break
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.coveredFromMs = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.coveredToMs = reader.int64().toString()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.sourceIntervalSeconds = reader.int32()
          continue
        }
        case 18: {
          if (tag === 145) {
            message.openInterestIncreaseBase.push(reader.double())

            continue
          }

          if (tag === 146) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestIncreaseBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 19: {
          if (tag === 153) {
            message.openInterestDecreaseBase.push(reader.double())

            continue
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestDecreaseBase.push(reader.double())
            }

            continue
          }

          break
        }
        case 20: {
          if (tag === 161) {
            message.openInterestIncreaseQuote.push(reader.double())

            continue
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestIncreaseQuote.push(reader.double())
            }

            continue
          }

          break
        }
        case 21: {
          if (tag === 169) {
            message.openInterestDecreaseQuote.push(reader.double())

            continue
          }

          if (tag === 170) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.openInterestDecreaseQuote.push(reader.double())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VisibleRangeProfile {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      fromMs: isSet(object.fromMs)
        ? globalThis.String(object.fromMs)
        : isSet(object.from_ms)
          ? globalThis.String(object.from_ms)
          : '0',
      toMs: isSet(object.toMs)
        ? globalThis.String(object.toMs)
        : isSet(object.to_ms)
          ? globalThis.String(object.to_ms)
          : '0',
      priceMin: isSet(object.priceMin)
        ? globalThis.Number(object.priceMin)
        : isSet(object.price_min)
          ? globalThis.Number(object.price_min)
          : 0,
      bucketWidth: isSet(object.bucketWidth)
        ? globalThis.Number(object.bucketWidth)
        : isSet(object.bucket_width)
          ? globalThis.Number(object.bucket_width)
          : 0,
      buyVolumeBase: globalThis.Array.isArray(object?.buyVolumeBase)
        ? object.buyVolumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_volume_base)
          ? object.buy_volume_base.map((e: any) => globalThis.Number(e))
          : [],
      sellVolumeBase: globalThis.Array.isArray(object?.sellVolumeBase)
        ? object.sellVolumeBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_volume_base)
          ? object.sell_volume_base.map((e: any) => globalThis.Number(e))
          : [],
      buyVolumeQuote: globalThis.Array.isArray(object?.buyVolumeQuote)
        ? object.buyVolumeQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_volume_quote)
          ? object.buy_volume_quote.map((e: any) => globalThis.Number(e))
          : [],
      sellVolumeQuote: globalThis.Array.isArray(object?.sellVolumeQuote)
        ? object.sellVolumeQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_volume_quote)
          ? object.sell_volume_quote.map((e: any) => globalThis.Number(e))
          : [],
      buyLiquidationBase: globalThis.Array.isArray(object?.buyLiquidationBase)
        ? object.buyLiquidationBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_liquidation_base)
          ? object.buy_liquidation_base.map((e: any) => globalThis.Number(e))
          : [],
      sellLiquidationBase: globalThis.Array.isArray(object?.sellLiquidationBase)
        ? object.sellLiquidationBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_liquidation_base)
          ? object.sell_liquidation_base.map((e: any) => globalThis.Number(e))
          : [],
      buyLiquidationQuote: globalThis.Array.isArray(object?.buyLiquidationQuote)
        ? object.buyLiquidationQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.buy_liquidation_quote)
          ? object.buy_liquidation_quote.map((e: any) => globalThis.Number(e))
          : [],
      sellLiquidationQuote: globalThis.Array.isArray(object?.sellLiquidationQuote)
        ? object.sellLiquidationQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.sell_liquidation_quote)
          ? object.sell_liquidation_quote.map((e: any) => globalThis.Number(e))
          : [],
      coveredFromMs: isSet(object.coveredFromMs)
        ? globalThis.String(object.coveredFromMs)
        : isSet(object.covered_from_ms)
          ? globalThis.String(object.covered_from_ms)
          : undefined,
      coveredToMs: isSet(object.coveredToMs)
        ? globalThis.String(object.coveredToMs)
        : isSet(object.covered_to_ms)
          ? globalThis.String(object.covered_to_ms)
          : undefined,
      sourceIntervalSeconds: isSet(object.sourceIntervalSeconds)
        ? globalThis.Number(object.sourceIntervalSeconds)
        : isSet(object.source_interval_seconds)
          ? globalThis.Number(object.source_interval_seconds)
          : 0,
      openInterestIncreaseBase: globalThis.Array.isArray(object?.openInterestIncreaseBase)
        ? object.openInterestIncreaseBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_increase_base)
          ? object.open_interest_increase_base.map((e: any) => globalThis.Number(e))
          : [],
      openInterestDecreaseBase: globalThis.Array.isArray(object?.openInterestDecreaseBase)
        ? object.openInterestDecreaseBase.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_decrease_base)
          ? object.open_interest_decrease_base.map((e: any) => globalThis.Number(e))
          : [],
      openInterestIncreaseQuote: globalThis.Array.isArray(object?.openInterestIncreaseQuote)
        ? object.openInterestIncreaseQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_increase_quote)
          ? object.open_interest_increase_quote.map((e: any) => globalThis.Number(e))
          : [],
      openInterestDecreaseQuote: globalThis.Array.isArray(object?.openInterestDecreaseQuote)
        ? object.openInterestDecreaseQuote.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.open_interest_decrease_quote)
          ? object.open_interest_decrease_quote.map((e: any) => globalThis.Number(e))
          : [],
    }
  },

  toJSON(message: VisibleRangeProfile): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.fromMs !== '0') {
      obj.fromMs = message.fromMs
    }
    if (message.toMs !== '0') {
      obj.toMs = message.toMs
    }
    if (message.priceMin !== 0) {
      obj.priceMin = message.priceMin
    }
    if (message.bucketWidth !== 0) {
      obj.bucketWidth = message.bucketWidth
    }
    if (message.buyVolumeBase?.length) {
      obj.buyVolumeBase = message.buyVolumeBase
    }
    if (message.sellVolumeBase?.length) {
      obj.sellVolumeBase = message.sellVolumeBase
    }
    if (message.buyVolumeQuote?.length) {
      obj.buyVolumeQuote = message.buyVolumeQuote
    }
    if (message.sellVolumeQuote?.length) {
      obj.sellVolumeQuote = message.sellVolumeQuote
    }
    if (message.buyLiquidationBase?.length) {
      obj.buyLiquidationBase = message.buyLiquidationBase
    }
    if (message.sellLiquidationBase?.length) {
      obj.sellLiquidationBase = message.sellLiquidationBase
    }
    if (message.buyLiquidationQuote?.length) {
      obj.buyLiquidationQuote = message.buyLiquidationQuote
    }
    if (message.sellLiquidationQuote?.length) {
      obj.sellLiquidationQuote = message.sellLiquidationQuote
    }
    if (message.coveredFromMs !== undefined) {
      obj.coveredFromMs = message.coveredFromMs
    }
    if (message.coveredToMs !== undefined) {
      obj.coveredToMs = message.coveredToMs
    }
    if (message.sourceIntervalSeconds !== 0) {
      obj.sourceIntervalSeconds = Math.round(message.sourceIntervalSeconds)
    }
    if (message.openInterestIncreaseBase?.length) {
      obj.openInterestIncreaseBase = message.openInterestIncreaseBase
    }
    if (message.openInterestDecreaseBase?.length) {
      obj.openInterestDecreaseBase = message.openInterestDecreaseBase
    }
    if (message.openInterestIncreaseQuote?.length) {
      obj.openInterestIncreaseQuote = message.openInterestIncreaseQuote
    }
    if (message.openInterestDecreaseQuote?.length) {
      obj.openInterestDecreaseQuote = message.openInterestDecreaseQuote
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VisibleRangeProfile>, I>>(base?: I): VisibleRangeProfile {
    return VisibleRangeProfile.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VisibleRangeProfile>, I>>(
    object: I
  ): VisibleRangeProfile {
    const message = createBaseVisibleRangeProfile()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.fromMs = object.fromMs ?? '0'
    message.toMs = object.toMs ?? '0'
    message.priceMin = object.priceMin ?? 0
    message.bucketWidth = object.bucketWidth ?? 0
    message.buyVolumeBase = object.buyVolumeBase?.map((e) => e) || []
    message.sellVolumeBase = object.sellVolumeBase?.map((e) => e) || []
    message.buyVolumeQuote = object.buyVolumeQuote?.map((e) => e) || []
    message.sellVolumeQuote = object.sellVolumeQuote?.map((e) => e) || []
    message.buyLiquidationBase = object.buyLiquidationBase?.map((e) => e) || []
    message.sellLiquidationBase = object.sellLiquidationBase?.map((e) => e) || []
    message.buyLiquidationQuote = object.buyLiquidationQuote?.map((e) => e) || []
    message.sellLiquidationQuote = object.sellLiquidationQuote?.map((e) => e) || []
    message.coveredFromMs = object.coveredFromMs ?? undefined
    message.coveredToMs = object.coveredToMs ?? undefined
    message.sourceIntervalSeconds = object.sourceIntervalSeconds ?? 0
    message.openInterestIncreaseBase = object.openInterestIncreaseBase?.map((e) => e) || []
    message.openInterestDecreaseBase = object.openInterestDecreaseBase?.map((e) => e) || []
    message.openInterestIncreaseQuote = object.openInterestIncreaseQuote?.map((e) => e) || []
    message.openInterestDecreaseQuote = object.openInterestDecreaseQuote?.map((e) => e) || []
    return message
  },
}

function createBaseLiquidationLevelProfile(): LiquidationLevelProfile {
  return {
    exchange: 0,
    symbol: '',
    timestamp: '0',
    mid: 0,
    priceMin: 0,
    bucketWidth: 0,
    longLiquidationLevelNotional: [],
    shortLiquidationLevelNotional: [],
    longLiquidationLevelCount: [],
    shortLiquidationLevelCount: [],
  }
}

export const LiquidationLevelProfile: MessageFns<LiquidationLevelProfile> = {
  encode(
    message: LiquidationLevelProfile,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timestamp !== '0') {
      writer.uint32(24).int64(message.timestamp)
    }
    if (message.mid !== 0) {
      writer.uint32(33).double(message.mid)
    }
    if (message.priceMin !== 0) {
      writer.uint32(41).double(message.priceMin)
    }
    if (message.bucketWidth !== 0) {
      writer.uint32(49).double(message.bucketWidth)
    }
    writer.uint32(58).fork()
    for (const v of message.longLiquidationLevelNotional) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.shortLiquidationLevelNotional) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.longLiquidationLevelCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.shortLiquidationLevelCount) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiquidationLevelProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLiquidationLevelProfile()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.mid = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.priceMin = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.bucketWidth = reader.double()
          continue
        }
        case 7: {
          if (tag === 57) {
            message.longLiquidationLevelNotional.push(reader.double())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.longLiquidationLevelNotional.push(reader.double())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 65) {
            message.shortLiquidationLevelNotional.push(reader.double())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.shortLiquidationLevelNotional.push(reader.double())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 72) {
            message.longLiquidationLevelCount.push(reader.int64().toString())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.longLiquidationLevelCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 80) {
            message.shortLiquidationLevelCount.push(reader.int64().toString())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.shortLiquidationLevelCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LiquidationLevelProfile {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      mid: isSet(object.mid) ? globalThis.Number(object.mid) : 0,
      priceMin: isSet(object.priceMin)
        ? globalThis.Number(object.priceMin)
        : isSet(object.price_min)
          ? globalThis.Number(object.price_min)
          : 0,
      bucketWidth: isSet(object.bucketWidth)
        ? globalThis.Number(object.bucketWidth)
        : isSet(object.bucket_width)
          ? globalThis.Number(object.bucket_width)
          : 0,
      longLiquidationLevelNotional: globalThis.Array.isArray(object?.longLiquidationLevelNotional)
        ? object.longLiquidationLevelNotional.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.long_liquidation_level_notional)
          ? object.long_liquidation_level_notional.map((e: any) => globalThis.Number(e))
          : [],
      shortLiquidationLevelNotional: globalThis.Array.isArray(object?.shortLiquidationLevelNotional)
        ? object.shortLiquidationLevelNotional.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.short_liquidation_level_notional)
          ? object.short_liquidation_level_notional.map((e: any) => globalThis.Number(e))
          : [],
      longLiquidationLevelCount: globalThis.Array.isArray(object?.longLiquidationLevelCount)
        ? object.longLiquidationLevelCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.long_liquidation_level_count)
          ? object.long_liquidation_level_count.map((e: any) => globalThis.String(e))
          : [],
      shortLiquidationLevelCount: globalThis.Array.isArray(object?.shortLiquidationLevelCount)
        ? object.shortLiquidationLevelCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.short_liquidation_level_count)
          ? object.short_liquidation_level_count.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: LiquidationLevelProfile): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.mid !== 0) {
      obj.mid = message.mid
    }
    if (message.priceMin !== 0) {
      obj.priceMin = message.priceMin
    }
    if (message.bucketWidth !== 0) {
      obj.bucketWidth = message.bucketWidth
    }
    if (message.longLiquidationLevelNotional?.length) {
      obj.longLiquidationLevelNotional = message.longLiquidationLevelNotional
    }
    if (message.shortLiquidationLevelNotional?.length) {
      obj.shortLiquidationLevelNotional = message.shortLiquidationLevelNotional
    }
    if (message.longLiquidationLevelCount?.length) {
      obj.longLiquidationLevelCount = message.longLiquidationLevelCount
    }
    if (message.shortLiquidationLevelCount?.length) {
      obj.shortLiquidationLevelCount = message.shortLiquidationLevelCount
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LiquidationLevelProfile>, I>>(
    base?: I
  ): LiquidationLevelProfile {
    return LiquidationLevelProfile.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LiquidationLevelProfile>, I>>(
    object: I
  ): LiquidationLevelProfile {
    const message = createBaseLiquidationLevelProfile()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.mid = object.mid ?? 0
    message.priceMin = object.priceMin ?? 0
    message.bucketWidth = object.bucketWidth ?? 0
    message.longLiquidationLevelNotional = object.longLiquidationLevelNotional?.map((e) => e) || []
    message.shortLiquidationLevelNotional =
      object.shortLiquidationLevelNotional?.map((e) => e) || []
    message.longLiquidationLevelCount = object.longLiquidationLevelCount?.map((e) => e) || []
    message.shortLiquidationLevelCount = object.shortLiquidationLevelCount?.map((e) => e) || []
    return message
  },
}

function createBaseStopLevelProfile(): StopLevelProfile {
  return {
    exchange: 0,
    symbol: '',
    timestamp: '0',
    mid: 0,
    priceMin: 0,
    bucketWidth: 0,
    takeProfitNotional: [],
    stopLossNotional: [],
    takeProfitCount: [],
    stopLossCount: [],
  }
}

export const StopLevelProfile: MessageFns<StopLevelProfile> = {
  encode(message: StopLevelProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.timestamp !== '0') {
      writer.uint32(24).int64(message.timestamp)
    }
    if (message.mid !== 0) {
      writer.uint32(33).double(message.mid)
    }
    if (message.priceMin !== 0) {
      writer.uint32(41).double(message.priceMin)
    }
    if (message.bucketWidth !== 0) {
      writer.uint32(49).double(message.bucketWidth)
    }
    writer.uint32(58).fork()
    for (const v of message.takeProfitNotional) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(66).fork()
    for (const v of message.stopLossNotional) {
      writer.double(v)
    }
    writer.join()
    writer.uint32(74).fork()
    for (const v of message.takeProfitCount) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(82).fork()
    for (const v of message.stopLossCount) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopLevelProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStopLevelProfile()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.mid = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.priceMin = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.bucketWidth = reader.double()
          continue
        }
        case 7: {
          if (tag === 57) {
            message.takeProfitNotional.push(reader.double())

            continue
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.takeProfitNotional.push(reader.double())
            }

            continue
          }

          break
        }
        case 8: {
          if (tag === 65) {
            message.stopLossNotional.push(reader.double())

            continue
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.stopLossNotional.push(reader.double())
            }

            continue
          }

          break
        }
        case 9: {
          if (tag === 72) {
            message.takeProfitCount.push(reader.int64().toString())

            continue
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.takeProfitCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 10: {
          if (tag === 80) {
            message.stopLossCount.push(reader.int64().toString())

            continue
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.stopLossCount.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StopLevelProfile {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      mid: isSet(object.mid) ? globalThis.Number(object.mid) : 0,
      priceMin: isSet(object.priceMin)
        ? globalThis.Number(object.priceMin)
        : isSet(object.price_min)
          ? globalThis.Number(object.price_min)
          : 0,
      bucketWidth: isSet(object.bucketWidth)
        ? globalThis.Number(object.bucketWidth)
        : isSet(object.bucket_width)
          ? globalThis.Number(object.bucket_width)
          : 0,
      takeProfitNotional: globalThis.Array.isArray(object?.takeProfitNotional)
        ? object.takeProfitNotional.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.take_profit_notional)
          ? object.take_profit_notional.map((e: any) => globalThis.Number(e))
          : [],
      stopLossNotional: globalThis.Array.isArray(object?.stopLossNotional)
        ? object.stopLossNotional.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.stop_loss_notional)
          ? object.stop_loss_notional.map((e: any) => globalThis.Number(e))
          : [],
      takeProfitCount: globalThis.Array.isArray(object?.takeProfitCount)
        ? object.takeProfitCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.take_profit_count)
          ? object.take_profit_count.map((e: any) => globalThis.String(e))
          : [],
      stopLossCount: globalThis.Array.isArray(object?.stopLossCount)
        ? object.stopLossCount.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.stop_loss_count)
          ? object.stop_loss_count.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: StopLevelProfile): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.mid !== 0) {
      obj.mid = message.mid
    }
    if (message.priceMin !== 0) {
      obj.priceMin = message.priceMin
    }
    if (message.bucketWidth !== 0) {
      obj.bucketWidth = message.bucketWidth
    }
    if (message.takeProfitNotional?.length) {
      obj.takeProfitNotional = message.takeProfitNotional
    }
    if (message.stopLossNotional?.length) {
      obj.stopLossNotional = message.stopLossNotional
    }
    if (message.takeProfitCount?.length) {
      obj.takeProfitCount = message.takeProfitCount
    }
    if (message.stopLossCount?.length) {
      obj.stopLossCount = message.stopLossCount
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StopLevelProfile>, I>>(base?: I): StopLevelProfile {
    return StopLevelProfile.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StopLevelProfile>, I>>(object: I): StopLevelProfile {
    const message = createBaseStopLevelProfile()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.mid = object.mid ?? 0
    message.priceMin = object.priceMin ?? 0
    message.bucketWidth = object.bucketWidth ?? 0
    message.takeProfitNotional = object.takeProfitNotional?.map((e) => e) || []
    message.stopLossNotional = object.stopLossNotional?.map((e) => e) || []
    message.takeProfitCount = object.takeProfitCount?.map((e) => e) || []
    message.stopLossCount = object.stopLossCount?.map((e) => e) || []
    return message
  },
}

function createBasePerpPositionRow(): PerpPositionRow {
  return {
    account: '',
    size: 0,
    notionalUsd: 0,
    entryPrice: undefined,
    markPrice: undefined,
    unrealizedPnl: undefined,
    liquidationPrice: undefined,
    leverage: undefined,
    isolated: undefined,
    accountValue: undefined,
    fundingPnl: undefined,
  }
}

export const PerpPositionRow: MessageFns<PerpPositionRow> = {
  encode(message: PerpPositionRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.account !== '') {
      writer.uint32(10).string(message.account)
    }
    if (message.size !== 0) {
      writer.uint32(17).double(message.size)
    }
    if (message.notionalUsd !== 0) {
      writer.uint32(25).double(message.notionalUsd)
    }
    if (message.entryPrice !== undefined) {
      writer.uint32(33).double(message.entryPrice)
    }
    if (message.markPrice !== undefined) {
      writer.uint32(41).double(message.markPrice)
    }
    if (message.unrealizedPnl !== undefined) {
      writer.uint32(49).double(message.unrealizedPnl)
    }
    if (message.liquidationPrice !== undefined) {
      writer.uint32(57).double(message.liquidationPrice)
    }
    if (message.leverage !== undefined) {
      writer.uint32(65).double(message.leverage)
    }
    if (message.isolated !== undefined) {
      writer.uint32(72).bool(message.isolated)
    }
    if (message.accountValue !== undefined) {
      writer.uint32(81).double(message.accountValue)
    }
    if (message.fundingPnl !== undefined) {
      writer.uint32(89).double(message.fundingPnl)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PerpPositionRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePerpPositionRow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.account = reader.string()
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.size = reader.double()
          continue
        }
        case 3: {
          if (tag !== 25) {
            break
          }

          message.notionalUsd = reader.double()
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.entryPrice = reader.double()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.markPrice = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.unrealizedPnl = reader.double()
          continue
        }
        case 7: {
          if (tag !== 57) {
            break
          }

          message.liquidationPrice = reader.double()
          continue
        }
        case 8: {
          if (tag !== 65) {
            break
          }

          message.leverage = reader.double()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.isolated = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 81) {
            break
          }

          message.accountValue = reader.double()
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.fundingPnl = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PerpPositionRow {
    return {
      account: isSet(object.account) ? globalThis.String(object.account) : '',
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      notionalUsd: isSet(object.notionalUsd)
        ? globalThis.Number(object.notionalUsd)
        : isSet(object.notional_usd)
          ? globalThis.Number(object.notional_usd)
          : 0,
      entryPrice: isSet(object.entryPrice)
        ? globalThis.Number(object.entryPrice)
        : isSet(object.entry_price)
          ? globalThis.Number(object.entry_price)
          : undefined,
      markPrice: isSet(object.markPrice)
        ? globalThis.Number(object.markPrice)
        : isSet(object.mark_price)
          ? globalThis.Number(object.mark_price)
          : undefined,
      unrealizedPnl: isSet(object.unrealizedPnl)
        ? globalThis.Number(object.unrealizedPnl)
        : isSet(object.unrealized_pnl)
          ? globalThis.Number(object.unrealized_pnl)
          : undefined,
      liquidationPrice: isSet(object.liquidationPrice)
        ? globalThis.Number(object.liquidationPrice)
        : isSet(object.liquidation_price)
          ? globalThis.Number(object.liquidation_price)
          : undefined,
      leverage: isSet(object.leverage) ? globalThis.Number(object.leverage) : undefined,
      isolated: isSet(object.isolated) ? globalThis.Boolean(object.isolated) : undefined,
      accountValue: isSet(object.accountValue)
        ? globalThis.Number(object.accountValue)
        : isSet(object.account_value)
          ? globalThis.Number(object.account_value)
          : undefined,
      fundingPnl: isSet(object.fundingPnl)
        ? globalThis.Number(object.fundingPnl)
        : isSet(object.funding_pnl)
          ? globalThis.Number(object.funding_pnl)
          : undefined,
    }
  },

  toJSON(message: PerpPositionRow): unknown {
    const obj: any = {}
    if (message.account !== '') {
      obj.account = message.account
    }
    if (message.size !== 0) {
      obj.size = message.size
    }
    if (message.notionalUsd !== 0) {
      obj.notionalUsd = message.notionalUsd
    }
    if (message.entryPrice !== undefined) {
      obj.entryPrice = message.entryPrice
    }
    if (message.markPrice !== undefined) {
      obj.markPrice = message.markPrice
    }
    if (message.unrealizedPnl !== undefined) {
      obj.unrealizedPnl = message.unrealizedPnl
    }
    if (message.liquidationPrice !== undefined) {
      obj.liquidationPrice = message.liquidationPrice
    }
    if (message.leverage !== undefined) {
      obj.leverage = message.leverage
    }
    if (message.isolated !== undefined) {
      obj.isolated = message.isolated
    }
    if (message.accountValue !== undefined) {
      obj.accountValue = message.accountValue
    }
    if (message.fundingPnl !== undefined) {
      obj.fundingPnl = message.fundingPnl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PerpPositionRow>, I>>(base?: I): PerpPositionRow {
    return PerpPositionRow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PerpPositionRow>, I>>(object: I): PerpPositionRow {
    const message = createBasePerpPositionRow()
    message.account = object.account ?? ''
    message.size = object.size ?? 0
    message.notionalUsd = object.notionalUsd ?? 0
    message.entryPrice = object.entryPrice ?? undefined
    message.markPrice = object.markPrice ?? undefined
    message.unrealizedPnl = object.unrealizedPnl ?? undefined
    message.liquidationPrice = object.liquidationPrice ?? undefined
    message.leverage = object.leverage ?? undefined
    message.isolated = object.isolated ?? undefined
    message.accountValue = object.accountValue ?? undefined
    message.fundingPnl = object.fundingPnl ?? undefined
    return message
  },
}

function createBasePerpPositionsSnapshot(): PerpPositionsSnapshot {
  return {
    exchange: 0,
    instrument: '',
    asOfMs: '0',
    totalPositions: 0,
    longNotionalUsd: 0,
    shortNotionalUsd: 0,
    longAccounts: 0,
    shortAccounts: 0,
    coveragePct: undefined,
    rows: [],
    longUpnlUsd: undefined,
    shortUpnlUsd: undefined,
  }
}

export const PerpPositionsSnapshot: MessageFns<PerpPositionsSnapshot> = {
  encode(message: PerpPositionsSnapshot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.instrument !== '') {
      writer.uint32(18).string(message.instrument)
    }
    if (message.asOfMs !== '0') {
      writer.uint32(24).int64(message.asOfMs)
    }
    if (message.totalPositions !== 0) {
      writer.uint32(32).uint32(message.totalPositions)
    }
    if (message.longNotionalUsd !== 0) {
      writer.uint32(41).double(message.longNotionalUsd)
    }
    if (message.shortNotionalUsd !== 0) {
      writer.uint32(49).double(message.shortNotionalUsd)
    }
    if (message.longAccounts !== 0) {
      writer.uint32(56).uint32(message.longAccounts)
    }
    if (message.shortAccounts !== 0) {
      writer.uint32(64).uint32(message.shortAccounts)
    }
    if (message.coveragePct !== undefined) {
      writer.uint32(73).double(message.coveragePct)
    }
    for (const v of message.rows) {
      PerpPositionRow.encode(v!, writer.uint32(82).fork()).join()
    }
    if (message.longUpnlUsd !== undefined) {
      writer.uint32(89).double(message.longUpnlUsd)
    }
    if (message.shortUpnlUsd !== undefined) {
      writer.uint32(97).double(message.shortUpnlUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PerpPositionsSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePerpPositionsSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.totalPositions = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 41) {
            break
          }

          message.longNotionalUsd = reader.double()
          continue
        }
        case 6: {
          if (tag !== 49) {
            break
          }

          message.shortNotionalUsd = reader.double()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.longAccounts = reader.uint32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.shortAccounts = reader.uint32()
          continue
        }
        case 9: {
          if (tag !== 73) {
            break
          }

          message.coveragePct = reader.double()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.rows.push(PerpPositionRow.decode(reader, reader.uint32()))
          continue
        }
        case 11: {
          if (tag !== 89) {
            break
          }

          message.longUpnlUsd = reader.double()
          continue
        }
        case 12: {
          if (tag !== 97) {
            break
          }

          message.shortUpnlUsd = reader.double()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PerpPositionsSnapshot {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : '',
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
      totalPositions: isSet(object.totalPositions)
        ? globalThis.Number(object.totalPositions)
        : isSet(object.total_positions)
          ? globalThis.Number(object.total_positions)
          : 0,
      longNotionalUsd: isSet(object.longNotionalUsd)
        ? globalThis.Number(object.longNotionalUsd)
        : isSet(object.long_notional_usd)
          ? globalThis.Number(object.long_notional_usd)
          : 0,
      shortNotionalUsd: isSet(object.shortNotionalUsd)
        ? globalThis.Number(object.shortNotionalUsd)
        : isSet(object.short_notional_usd)
          ? globalThis.Number(object.short_notional_usd)
          : 0,
      longAccounts: isSet(object.longAccounts)
        ? globalThis.Number(object.longAccounts)
        : isSet(object.long_accounts)
          ? globalThis.Number(object.long_accounts)
          : 0,
      shortAccounts: isSet(object.shortAccounts)
        ? globalThis.Number(object.shortAccounts)
        : isSet(object.short_accounts)
          ? globalThis.Number(object.short_accounts)
          : 0,
      coveragePct: isSet(object.coveragePct)
        ? globalThis.Number(object.coveragePct)
        : isSet(object.coverage_pct)
          ? globalThis.Number(object.coverage_pct)
          : undefined,
      rows: globalThis.Array.isArray(object?.rows)
        ? object.rows.map((e: any) => PerpPositionRow.fromJSON(e))
        : [],
      longUpnlUsd: isSet(object.longUpnlUsd)
        ? globalThis.Number(object.longUpnlUsd)
        : isSet(object.long_upnl_usd)
          ? globalThis.Number(object.long_upnl_usd)
          : undefined,
      shortUpnlUsd: isSet(object.shortUpnlUsd)
        ? globalThis.Number(object.shortUpnlUsd)
        : isSet(object.short_upnl_usd)
          ? globalThis.Number(object.short_upnl_usd)
          : undefined,
    }
  },

  toJSON(message: PerpPositionsSnapshot): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.instrument !== '') {
      obj.instrument = message.instrument
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    if (message.totalPositions !== 0) {
      obj.totalPositions = Math.round(message.totalPositions)
    }
    if (message.longNotionalUsd !== 0) {
      obj.longNotionalUsd = message.longNotionalUsd
    }
    if (message.shortNotionalUsd !== 0) {
      obj.shortNotionalUsd = message.shortNotionalUsd
    }
    if (message.longAccounts !== 0) {
      obj.longAccounts = Math.round(message.longAccounts)
    }
    if (message.shortAccounts !== 0) {
      obj.shortAccounts = Math.round(message.shortAccounts)
    }
    if (message.coveragePct !== undefined) {
      obj.coveragePct = message.coveragePct
    }
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => PerpPositionRow.toJSON(e))
    }
    if (message.longUpnlUsd !== undefined) {
      obj.longUpnlUsd = message.longUpnlUsd
    }
    if (message.shortUpnlUsd !== undefined) {
      obj.shortUpnlUsd = message.shortUpnlUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PerpPositionsSnapshot>, I>>(base?: I): PerpPositionsSnapshot {
    return PerpPositionsSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PerpPositionsSnapshot>, I>>(
    object: I
  ): PerpPositionsSnapshot {
    const message = createBasePerpPositionsSnapshot()
    message.exchange = object.exchange ?? 0
    message.instrument = object.instrument ?? ''
    message.asOfMs = object.asOfMs ?? '0'
    message.totalPositions = object.totalPositions ?? 0
    message.longNotionalUsd = object.longNotionalUsd ?? 0
    message.shortNotionalUsd = object.shortNotionalUsd ?? 0
    message.longAccounts = object.longAccounts ?? 0
    message.shortAccounts = object.shortAccounts ?? 0
    message.coveragePct = object.coveragePct ?? undefined
    message.rows = object.rows?.map((e) => PerpPositionRow.fromPartial(e)) || []
    message.longUpnlUsd = object.longUpnlUsd ?? undefined
    message.shortUpnlUsd = object.shortUpnlUsd ?? undefined
    return message
  },
}

function createBasePortfolioLineChartRequest(): PortfolioLineChartRequest {
  return {
    accountId: '',
    accountIds: [],
    timeframe: 0,
    from: undefined,
    to: undefined,
    limit: undefined,
    tradeVenue: 0,
  }
}

export const PortfolioLineChartRequest: MessageFns<PortfolioLineChartRequest> = {
  encode(
    message: PortfolioLineChartRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.accountIds) {
      writer.uint32(66).string(v!)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    if (message.from !== undefined) {
      writer.uint32(32).int64(message.from)
    }
    if (message.to !== undefined) {
      writer.uint32(40).int64(message.to)
    }
    if (message.limit !== undefined) {
      writer.uint32(48).int32(message.limit)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(56).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioLineChartRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioLineChartRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.from = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.to = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.limit = reader.int32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioLineChartRequest {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      timeframe: isSet(object.timeframe) ? globalThis.Number(object.timeframe) : 0,
      from: isSet(object.from) ? globalThis.String(object.from) : undefined,
      to: isSet(object.to) ? globalThis.String(object.to) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: PortfolioLineChartRequest): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.timeframe !== 0) {
      obj.timeframe = Math.round(message.timeframe)
    }
    if (message.from !== undefined) {
      obj.from = message.from
    }
    if (message.to !== undefined) {
      obj.to = message.to
    }
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioLineChartRequest>, I>>(
    base?: I
  ): PortfolioLineChartRequest {
    return PortfolioLineChartRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioLineChartRequest>, I>>(
    object: I
  ): PortfolioLineChartRequest {
    const message = createBasePortfolioLineChartRequest()
    message.accountId = object.accountId ?? ''
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.timeframe = object.timeframe ?? 0
    message.from = object.from ?? undefined
    message.to = object.to ?? undefined
    message.limit = object.limit ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBasePortfolioLineChart(): PortfolioLineChart {
  return { accountId: '', timeframe: 0, ticks: [], values: [], tradeVenue: 0 }
}

export const PortfolioLineChart: MessageFns<PortfolioLineChart> = {
  encode(message: PortfolioLineChart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.timeframe !== 0) {
      writer.uint32(24).int32(message.timeframe)
    }
    writer.uint32(34).fork()
    for (const v of message.ticks) {
      writer.int64(v)
    }
    writer.join()
    writer.uint32(42).fork()
    for (const v of message.values) {
      writer.float(v)
    }
    writer.join()
    if (message.tradeVenue !== 0) {
      writer.uint32(48).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioLineChart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioLineChart()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeframe = reader.int32()
          continue
        }
        case 4: {
          if (tag === 32) {
            message.ticks.push(reader.int64().toString())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.ticks.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag === 45) {
            message.values.push(reader.float())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.values.push(reader.float())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioLineChart {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      timeframe: isSet(object.timeframe) ? globalThis.Number(object.timeframe) : 0,
      ticks: globalThis.Array.isArray(object?.ticks)
        ? object.ticks.map((e: any) => globalThis.String(e))
        : [],
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => globalThis.Number(e))
        : [],
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: PortfolioLineChart): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.timeframe !== 0) {
      obj.timeframe = Math.round(message.timeframe)
    }
    if (message.ticks?.length) {
      obj.ticks = message.ticks
    }
    if (message.values?.length) {
      obj.values = message.values
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioLineChart>, I>>(base?: I): PortfolioLineChart {
    return PortfolioLineChart.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioLineChart>, I>>(object: I): PortfolioLineChart {
    const message = createBasePortfolioLineChart()
    message.accountId = object.accountId ?? ''
    message.timeframe = object.timeframe ?? 0
    message.ticks = object.ticks?.map((e) => e) || []
    message.values = object.values?.map((e) => e) || []
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBasePortfolioLineChartList(): PortfolioLineChartList {
  return { charts: [] }
}

export const PortfolioLineChartList: MessageFns<PortfolioLineChartList> = {
  encode(message: PortfolioLineChartList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.charts) {
      PortfolioLineChart.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioLineChartList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioLineChartList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.charts.push(PortfolioLineChart.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioLineChartList {
    return {
      charts: globalThis.Array.isArray(object?.charts)
        ? object.charts.map((e: any) => PortfolioLineChart.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PortfolioLineChartList): unknown {
    const obj: any = {}
    if (message.charts?.length) {
      obj.charts = message.charts.map((e) => PortfolioLineChart.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioLineChartList>, I>>(
    base?: I
  ): PortfolioLineChartList {
    return PortfolioLineChartList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioLineChartList>, I>>(
    object: I
  ): PortfolioLineChartList {
    const message = createBasePortfolioLineChartList()
    message.charts = object.charts?.map((e) => PortfolioLineChart.fromPartial(e)) || []
    return message
  },
}

function createBaseMintMessagingLinkNonceRequest(): MintMessagingLinkNonceRequest {
  return { channel: 0, surface: 0 }
}

export const MintMessagingLinkNonceRequest: MessageFns<MintMessagingLinkNonceRequest> = {
  encode(
    message: MintMessagingLinkNonceRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.channel !== 0) {
      writer.uint32(8).int32(message.channel)
    }
    if (message.surface !== 0) {
      writer.uint32(16).int32(message.surface)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MintMessagingLinkNonceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMintMessagingLinkNonceRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.channel = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.surface = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MintMessagingLinkNonceRequest {
    return {
      channel: isSet(object.channel) ? messagingChannelFromJSON(object.channel) : 0,
      surface: isSet(object.surface) ? messagingSurfaceFromJSON(object.surface) : 0,
    }
  },

  toJSON(message: MintMessagingLinkNonceRequest): unknown {
    const obj: any = {}
    if (message.channel !== 0) {
      obj.channel = messagingChannelToJSON(message.channel)
    }
    if (message.surface !== 0) {
      obj.surface = messagingSurfaceToJSON(message.surface)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MintMessagingLinkNonceRequest>, I>>(
    base?: I
  ): MintMessagingLinkNonceRequest {
    return MintMessagingLinkNonceRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MintMessagingLinkNonceRequest>, I>>(
    object: I
  ): MintMessagingLinkNonceRequest {
    const message = createBaseMintMessagingLinkNonceRequest()
    message.channel = object.channel ?? 0
    message.surface = object.surface ?? 0
    return message
  },
}

function createBaseMintMessagingLinkNonceResponse(): MintMessagingLinkNonceResponse {
  return {
    success: false,
    nonce: undefined,
    expiresAt: undefined,
    errorMessage: undefined,
    deepLink: undefined,
  }
}

export const MintMessagingLinkNonceResponse: MessageFns<MintMessagingLinkNonceResponse> = {
  encode(
    message: MintMessagingLinkNonceResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.nonce !== undefined) {
      writer.uint32(18).string(message.nonce)
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(24).int64(message.expiresAt)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    if (message.deepLink !== undefined) {
      writer.uint32(42).string(message.deepLink)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MintMessagingLinkNonceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMintMessagingLinkNonceResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.nonce = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.deepLink = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MintMessagingLinkNonceResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      deepLink: isSet(object.deepLink)
        ? globalThis.String(object.deepLink)
        : isSet(object.deep_link)
          ? globalThis.String(object.deep_link)
          : undefined,
    }
  },

  toJSON(message: MintMessagingLinkNonceResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.nonce !== undefined) {
      obj.nonce = message.nonce
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.deepLink !== undefined) {
      obj.deepLink = message.deepLink
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MintMessagingLinkNonceResponse>, I>>(
    base?: I
  ): MintMessagingLinkNonceResponse {
    return MintMessagingLinkNonceResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MintMessagingLinkNonceResponse>, I>>(
    object: I
  ): MintMessagingLinkNonceResponse {
    const message = createBaseMintMessagingLinkNonceResponse()
    message.success = object.success ?? false
    message.nonce = object.nonce ?? undefined
    message.expiresAt = object.expiresAt ?? undefined
    message.errorMessage = object.errorMessage ?? undefined
    message.deepLink = object.deepLink ?? undefined
    return message
  },
}

function createBaseCreateApiKeyRequest(): CreateApiKeyRequest {
  return {
    label: '',
    scopes: [],
    expiresAt: undefined,
    currentPassword: '',
    totpCode: undefined,
    emailCode: undefined,
    backupCode: undefined,
  }
}

export const CreateApiKeyRequest: MessageFns<CreateApiKeyRequest> = {
  encode(message: CreateApiKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    for (const v of message.scopes) {
      writer.uint32(18).string(v!)
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(24).int64(message.expiresAt)
    }
    if (message.currentPassword !== '') {
      writer.uint32(34).string(message.currentPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(42).string(message.totpCode)
    }
    if (message.emailCode !== undefined) {
      writer.uint32(50).string(message.emailCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(58).string(message.backupCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateApiKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateApiKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scopes.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.emailCode = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateApiKeyRequest {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      scopes: globalThis.Array.isArray(object?.scopes)
        ? object.scopes.map((e: any) => globalThis.String(e))
        : [],
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : '',
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      emailCode: isSet(object.emailCode)
        ? globalThis.String(object.emailCode)
        : isSet(object.email_code)
          ? globalThis.String(object.email_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
    }
  },

  toJSON(message: CreateApiKeyRequest): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.scopes?.length) {
      obj.scopes = message.scopes
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    if (message.currentPassword !== '') {
      obj.currentPassword = message.currentPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.emailCode !== undefined) {
      obj.emailCode = message.emailCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateApiKeyRequest>, I>>(base?: I): CreateApiKeyRequest {
    return CreateApiKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateApiKeyRequest>, I>>(
    object: I
  ): CreateApiKeyRequest {
    const message = createBaseCreateApiKeyRequest()
    message.label = object.label ?? ''
    message.scopes = object.scopes?.map((e) => e) || []
    message.expiresAt = object.expiresAt ?? undefined
    message.currentPassword = object.currentPassword ?? ''
    message.totpCode = object.totpCode ?? undefined
    message.emailCode = object.emailCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    return message
  },
}

function createBaseCreateApiKeyResponse(): CreateApiKeyResponse {
  return { success: false, apiKey: undefined, key: undefined, errorMessage: undefined }
}

export const CreateApiKeyResponse: MessageFns<CreateApiKeyResponse> = {
  encode(message: CreateApiKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.apiKey !== undefined) {
      writer.uint32(18).string(message.apiKey)
    }
    if (message.key !== undefined) {
      ApiKeyInfo.encode(message.key, writer.uint32(26).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateApiKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateApiKeyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.apiKey = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.key = ApiKeyInfo.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateApiKeyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      apiKey: isSet(object.apiKey)
        ? globalThis.String(object.apiKey)
        : isSet(object.api_key)
          ? globalThis.String(object.api_key)
          : undefined,
      key: isSet(object.key) ? ApiKeyInfo.fromJSON(object.key) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: CreateApiKeyResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.apiKey !== undefined) {
      obj.apiKey = message.apiKey
    }
    if (message.key !== undefined) {
      obj.key = ApiKeyInfo.toJSON(message.key)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateApiKeyResponse>, I>>(base?: I): CreateApiKeyResponse {
    return CreateApiKeyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateApiKeyResponse>, I>>(
    object: I
  ): CreateApiKeyResponse {
    const message = createBaseCreateApiKeyResponse()
    message.success = object.success ?? false
    message.apiKey = object.apiKey ?? undefined
    message.key =
      object.key !== undefined && object.key !== null
        ? ApiKeyInfo.fromPartial(object.key)
        : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseApiKeyInfo(): ApiKeyInfo {
  return {
    keyId: '',
    label: '',
    scopes: [],
    createdAt: '0',
    expiresAt: undefined,
    revokedAt: undefined,
    executionHaltedAt: undefined,
  }
}

export const ApiKeyInfo: MessageFns<ApiKeyInfo> = {
  encode(message: ApiKeyInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.keyId !== '') {
      writer.uint32(10).string(message.keyId)
    }
    if (message.label !== '') {
      writer.uint32(18).string(message.label)
    }
    for (const v of message.scopes) {
      writer.uint32(26).string(v!)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(40).int64(message.expiresAt)
    }
    if (message.revokedAt !== undefined) {
      writer.uint32(48).int64(message.revokedAt)
    }
    if (message.executionHaltedAt !== undefined) {
      writer.uint32(56).int64(message.executionHaltedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiKeyInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseApiKeyInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.keyId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.scopes.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.revokedAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.executionHaltedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ApiKeyInfo {
    return {
      keyId: isSet(object.keyId)
        ? globalThis.String(object.keyId)
        : isSet(object.key_id)
          ? globalThis.String(object.key_id)
          : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      scopes: globalThis.Array.isArray(object?.scopes)
        ? object.scopes.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
      revokedAt: isSet(object.revokedAt)
        ? globalThis.String(object.revokedAt)
        : isSet(object.revoked_at)
          ? globalThis.String(object.revoked_at)
          : undefined,
      executionHaltedAt: isSet(object.executionHaltedAt)
        ? globalThis.String(object.executionHaltedAt)
        : isSet(object.execution_halted_at)
          ? globalThis.String(object.execution_halted_at)
          : undefined,
    }
  },

  toJSON(message: ApiKeyInfo): unknown {
    const obj: any = {}
    if (message.keyId !== '') {
      obj.keyId = message.keyId
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.scopes?.length) {
      obj.scopes = message.scopes
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    if (message.revokedAt !== undefined) {
      obj.revokedAt = message.revokedAt
    }
    if (message.executionHaltedAt !== undefined) {
      obj.executionHaltedAt = message.executionHaltedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ApiKeyInfo>, I>>(base?: I): ApiKeyInfo {
    return ApiKeyInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ApiKeyInfo>, I>>(object: I): ApiKeyInfo {
    const message = createBaseApiKeyInfo()
    message.keyId = object.keyId ?? ''
    message.label = object.label ?? ''
    message.scopes = object.scopes?.map((e) => e) || []
    message.createdAt = object.createdAt ?? '0'
    message.expiresAt = object.expiresAt ?? undefined
    message.revokedAt = object.revokedAt ?? undefined
    message.executionHaltedAt = object.executionHaltedAt ?? undefined
    return message
  },
}

function createBaseListApiKeysRequest(): ListApiKeysRequest {
  return {}
}

export const ListApiKeysRequest: MessageFns<ListApiKeysRequest> = {
  encode(_: ListApiKeysRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListApiKeysRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListApiKeysRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ListApiKeysRequest {
    return {}
  },

  toJSON(_: ListApiKeysRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ListApiKeysRequest>, I>>(base?: I): ListApiKeysRequest {
    return ListApiKeysRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListApiKeysRequest>, I>>(_: I): ListApiKeysRequest {
    const message = createBaseListApiKeysRequest()
    return message
  },
}

function createBaseListApiKeysResponse(): ListApiKeysResponse {
  return { success: false, keys: [], errorMessage: undefined }
}

export const ListApiKeysResponse: MessageFns<ListApiKeysResponse> = {
  encode(message: ListApiKeysResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.keys) {
      ApiKeyInfo.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListApiKeysResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListApiKeysResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.keys.push(ApiKeyInfo.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListApiKeysResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      keys: globalThis.Array.isArray(object?.keys)
        ? object.keys.map((e: any) => ApiKeyInfo.fromJSON(e))
        : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: ListApiKeysResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.keys?.length) {
      obj.keys = message.keys.map((e) => ApiKeyInfo.toJSON(e))
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListApiKeysResponse>, I>>(base?: I): ListApiKeysResponse {
    return ListApiKeysResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListApiKeysResponse>, I>>(
    object: I
  ): ListApiKeysResponse {
    const message = createBaseListApiKeysResponse()
    message.success = object.success ?? false
    message.keys = object.keys?.map((e) => ApiKeyInfo.fromPartial(e)) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseRevokeApiKeyRequest(): RevokeApiKeyRequest {
  return { keyId: '' }
}

export const RevokeApiKeyRequest: MessageFns<RevokeApiKeyRequest> = {
  encode(message: RevokeApiKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.keyId !== '') {
      writer.uint32(10).string(message.keyId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeApiKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeApiKeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.keyId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeApiKeyRequest {
    return {
      keyId: isSet(object.keyId)
        ? globalThis.String(object.keyId)
        : isSet(object.key_id)
          ? globalThis.String(object.key_id)
          : '',
    }
  },

  toJSON(message: RevokeApiKeyRequest): unknown {
    const obj: any = {}
    if (message.keyId !== '') {
      obj.keyId = message.keyId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeApiKeyRequest>, I>>(base?: I): RevokeApiKeyRequest {
    return RevokeApiKeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeApiKeyRequest>, I>>(
    object: I
  ): RevokeApiKeyRequest {
    const message = createBaseRevokeApiKeyRequest()
    message.keyId = object.keyId ?? ''
    return message
  },
}

function createBaseRevokeApiKeyResponse(): RevokeApiKeyResponse {
  return { success: false, errorMessage: undefined }
}

export const RevokeApiKeyResponse: MessageFns<RevokeApiKeyResponse> = {
  encode(message: RevokeApiKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeApiKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeApiKeyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeApiKeyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: RevokeApiKeyResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeApiKeyResponse>, I>>(base?: I): RevokeApiKeyResponse {
    return RevokeApiKeyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeApiKeyResponse>, I>>(
    object: I
  ): RevokeApiKeyResponse {
    const message = createBaseRevokeApiKeyResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseCreditPrice(): CreditPrice {
  return { unitAmount: '0', currency: '', minCredits: '0', maxCredits: '0', presetAmounts: [] }
}

export const CreditPrice: MessageFns<CreditPrice> = {
  encode(message: CreditPrice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unitAmount !== '0') {
      writer.uint32(8).int64(message.unitAmount)
    }
    if (message.currency !== '') {
      writer.uint32(18).string(message.currency)
    }
    if (message.minCredits !== '0') {
      writer.uint32(24).int64(message.minCredits)
    }
    if (message.maxCredits !== '0') {
      writer.uint32(32).int64(message.maxCredits)
    }
    writer.uint32(42).fork()
    for (const v of message.presetAmounts) {
      writer.int64(v)
    }
    writer.join()
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditPrice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditPrice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.unitAmount = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.minCredits = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.maxCredits = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag === 40) {
            message.presetAmounts.push(reader.int64().toString())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.presetAmounts.push(reader.int64().toString())
            }

            continue
          }

          break
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditPrice {
    return {
      unitAmount: isSet(object.unitAmount)
        ? globalThis.String(object.unitAmount)
        : isSet(object.unit_amount)
          ? globalThis.String(object.unit_amount)
          : '0',
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      minCredits: isSet(object.minCredits)
        ? globalThis.String(object.minCredits)
        : isSet(object.min_credits)
          ? globalThis.String(object.min_credits)
          : '0',
      maxCredits: isSet(object.maxCredits)
        ? globalThis.String(object.maxCredits)
        : isSet(object.max_credits)
          ? globalThis.String(object.max_credits)
          : '0',
      presetAmounts: globalThis.Array.isArray(object?.presetAmounts)
        ? object.presetAmounts.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.preset_amounts)
          ? object.preset_amounts.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: CreditPrice): unknown {
    const obj: any = {}
    if (message.unitAmount !== '0') {
      obj.unitAmount = message.unitAmount
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.minCredits !== '0') {
      obj.minCredits = message.minCredits
    }
    if (message.maxCredits !== '0') {
      obj.maxCredits = message.maxCredits
    }
    if (message.presetAmounts?.length) {
      obj.presetAmounts = message.presetAmounts
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditPrice>, I>>(base?: I): CreditPrice {
    return CreditPrice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditPrice>, I>>(object: I): CreditPrice {
    const message = createBaseCreditPrice()
    message.unitAmount = object.unitAmount ?? '0'
    message.currency = object.currency ?? ''
    message.minCredits = object.minCredits ?? '0'
    message.maxCredits = object.maxCredits ?? '0'
    message.presetAmounts = object.presetAmounts?.map((e) => e) || []
    return message
  },
}

function createBaseApiBillingSettings(): ApiBillingSettings {
  return {
    spendLimitWeekly: undefined,
    refillEnabled: false,
    refillThreshold: '0',
    refillCredits: '0',
  }
}

export const ApiBillingSettings: MessageFns<ApiBillingSettings> = {
  encode(message: ApiBillingSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spendLimitWeekly !== undefined) {
      writer.uint32(8).int64(message.spendLimitWeekly)
    }
    if (message.refillEnabled !== false) {
      writer.uint32(16).bool(message.refillEnabled)
    }
    if (message.refillThreshold !== '0') {
      writer.uint32(24).int64(message.refillThreshold)
    }
    if (message.refillCredits !== '0') {
      writer.uint32(40).int64(message.refillCredits)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiBillingSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseApiBillingSettings()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.spendLimitWeekly = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.refillEnabled = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.refillThreshold = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.refillCredits = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ApiBillingSettings {
    return {
      spendLimitWeekly: isSet(object.spendLimitWeekly)
        ? globalThis.String(object.spendLimitWeekly)
        : isSet(object.spend_limit_weekly)
          ? globalThis.String(object.spend_limit_weekly)
          : undefined,
      refillEnabled: isSet(object.refillEnabled)
        ? globalThis.Boolean(object.refillEnabled)
        : isSet(object.refill_enabled)
          ? globalThis.Boolean(object.refill_enabled)
          : false,
      refillThreshold: isSet(object.refillThreshold)
        ? globalThis.String(object.refillThreshold)
        : isSet(object.refill_threshold)
          ? globalThis.String(object.refill_threshold)
          : '0',
      refillCredits: isSet(object.refillCredits)
        ? globalThis.String(object.refillCredits)
        : isSet(object.refill_credits)
          ? globalThis.String(object.refill_credits)
          : '0',
    }
  },

  toJSON(message: ApiBillingSettings): unknown {
    const obj: any = {}
    if (message.spendLimitWeekly !== undefined) {
      obj.spendLimitWeekly = message.spendLimitWeekly
    }
    if (message.refillEnabled !== false) {
      obj.refillEnabled = message.refillEnabled
    }
    if (message.refillThreshold !== '0') {
      obj.refillThreshold = message.refillThreshold
    }
    if (message.refillCredits !== '0') {
      obj.refillCredits = message.refillCredits
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ApiBillingSettings>, I>>(base?: I): ApiBillingSettings {
    return ApiBillingSettings.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ApiBillingSettings>, I>>(object: I): ApiBillingSettings {
    const message = createBaseApiBillingSettings()
    message.spendLimitWeekly = object.spendLimitWeekly ?? undefined
    message.refillEnabled = object.refillEnabled ?? false
    message.refillThreshold = object.refillThreshold ?? '0'
    message.refillCredits = object.refillCredits ?? '0'
    return message
  },
}

function createBaseGetApiBillingRequest(): GetApiBillingRequest {
  return {}
}

export const GetApiBillingRequest: MessageFns<GetApiBillingRequest> = {
  encode(_: GetApiBillingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetApiBillingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetApiBillingRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetApiBillingRequest {
    return {}
  },

  toJSON(_: GetApiBillingRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetApiBillingRequest>, I>>(base?: I): GetApiBillingRequest {
    return GetApiBillingRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetApiBillingRequest>, I>>(_: I): GetApiBillingRequest {
    const message = createBaseGetApiBillingRequest()
    return message
  },
}

function createBaseGetApiBillingResponse(): GetApiBillingResponse {
  return {
    success: false,
    balance: undefined,
    grantedTotal: '0',
    spentTotal: '0',
    settings: undefined,
    spentThisWeek: '0',
    cardBrand: undefined,
    cardLast4: undefined,
    errorMessage: undefined,
    creditPrice: undefined,
  }
}

export const GetApiBillingResponse: MessageFns<GetApiBillingResponse> = {
  encode(message: GetApiBillingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.balance !== undefined) {
      writer.uint32(16).int64(message.balance)
    }
    if (message.grantedTotal !== '0') {
      writer.uint32(24).int64(message.grantedTotal)
    }
    if (message.spentTotal !== '0') {
      writer.uint32(32).int64(message.spentTotal)
    }
    if (message.settings !== undefined) {
      ApiBillingSettings.encode(message.settings, writer.uint32(42).fork()).join()
    }
    if (message.spentThisWeek !== '0') {
      writer.uint32(48).int64(message.spentThisWeek)
    }
    if (message.cardBrand !== undefined) {
      writer.uint32(58).string(message.cardBrand)
    }
    if (message.cardLast4 !== undefined) {
      writer.uint32(66).string(message.cardLast4)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(82).string(message.errorMessage)
    }
    if (message.creditPrice !== undefined) {
      CreditPrice.encode(message.creditPrice, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetApiBillingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetApiBillingResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.balance = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.grantedTotal = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.spentTotal = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.settings = ApiBillingSettings.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.spentThisWeek = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.cardBrand = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.cardLast4 = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.creditPrice = CreditPrice.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetApiBillingResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      balance: isSet(object.balance) ? globalThis.String(object.balance) : undefined,
      grantedTotal: isSet(object.grantedTotal)
        ? globalThis.String(object.grantedTotal)
        : isSet(object.granted_total)
          ? globalThis.String(object.granted_total)
          : '0',
      spentTotal: isSet(object.spentTotal)
        ? globalThis.String(object.spentTotal)
        : isSet(object.spent_total)
          ? globalThis.String(object.spent_total)
          : '0',
      settings: isSet(object.settings) ? ApiBillingSettings.fromJSON(object.settings) : undefined,
      spentThisWeek: isSet(object.spentThisWeek)
        ? globalThis.String(object.spentThisWeek)
        : isSet(object.spent_this_week)
          ? globalThis.String(object.spent_this_week)
          : '0',
      cardBrand: isSet(object.cardBrand)
        ? globalThis.String(object.cardBrand)
        : isSet(object.card_brand)
          ? globalThis.String(object.card_brand)
          : undefined,
      cardLast4: isSet(object.cardLast4)
        ? globalThis.String(object.cardLast4)
        : isSet(object.card_last4)
          ? globalThis.String(object.card_last4)
          : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      creditPrice: isSet(object.creditPrice)
        ? CreditPrice.fromJSON(object.creditPrice)
        : isSet(object.credit_price)
          ? CreditPrice.fromJSON(object.credit_price)
          : undefined,
    }
  },

  toJSON(message: GetApiBillingResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.balance !== undefined) {
      obj.balance = message.balance
    }
    if (message.grantedTotal !== '0') {
      obj.grantedTotal = message.grantedTotal
    }
    if (message.spentTotal !== '0') {
      obj.spentTotal = message.spentTotal
    }
    if (message.settings !== undefined) {
      obj.settings = ApiBillingSettings.toJSON(message.settings)
    }
    if (message.spentThisWeek !== '0') {
      obj.spentThisWeek = message.spentThisWeek
    }
    if (message.cardBrand !== undefined) {
      obj.cardBrand = message.cardBrand
    }
    if (message.cardLast4 !== undefined) {
      obj.cardLast4 = message.cardLast4
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.creditPrice !== undefined) {
      obj.creditPrice = CreditPrice.toJSON(message.creditPrice)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetApiBillingResponse>, I>>(base?: I): GetApiBillingResponse {
    return GetApiBillingResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetApiBillingResponse>, I>>(
    object: I
  ): GetApiBillingResponse {
    const message = createBaseGetApiBillingResponse()
    message.success = object.success ?? false
    message.balance = object.balance ?? undefined
    message.grantedTotal = object.grantedTotal ?? '0'
    message.spentTotal = object.spentTotal ?? '0'
    message.settings =
      object.settings !== undefined && object.settings !== null
        ? ApiBillingSettings.fromPartial(object.settings)
        : undefined
    message.spentThisWeek = object.spentThisWeek ?? '0'
    message.cardBrand = object.cardBrand ?? undefined
    message.cardLast4 = object.cardLast4 ?? undefined
    message.errorMessage = object.errorMessage ?? undefined
    message.creditPrice =
      object.creditPrice !== undefined && object.creditPrice !== null
        ? CreditPrice.fromPartial(object.creditPrice)
        : undefined
    return message
  },
}

function createBaseUpdateApiBillingSettingsRequest(): UpdateApiBillingSettingsRequest {
  return {
    settings: undefined,
    currentPassword: '',
    totpCode: undefined,
    emailCode: undefined,
    backupCode: undefined,
  }
}

export const UpdateApiBillingSettingsRequest: MessageFns<UpdateApiBillingSettingsRequest> = {
  encode(
    message: UpdateApiBillingSettingsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.settings !== undefined) {
      ApiBillingSettings.encode(message.settings, writer.uint32(10).fork()).join()
    }
    if (message.currentPassword !== '') {
      writer.uint32(18).string(message.currentPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(26).string(message.totpCode)
    }
    if (message.emailCode !== undefined) {
      writer.uint32(34).string(message.emailCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(42).string(message.backupCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateApiBillingSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateApiBillingSettingsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.settings = ApiBillingSettings.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.emailCode = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateApiBillingSettingsRequest {
    return {
      settings: isSet(object.settings) ? ApiBillingSettings.fromJSON(object.settings) : undefined,
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : '',
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      emailCode: isSet(object.emailCode)
        ? globalThis.String(object.emailCode)
        : isSet(object.email_code)
          ? globalThis.String(object.email_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
    }
  },

  toJSON(message: UpdateApiBillingSettingsRequest): unknown {
    const obj: any = {}
    if (message.settings !== undefined) {
      obj.settings = ApiBillingSettings.toJSON(message.settings)
    }
    if (message.currentPassword !== '') {
      obj.currentPassword = message.currentPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.emailCode !== undefined) {
      obj.emailCode = message.emailCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateApiBillingSettingsRequest>, I>>(
    base?: I
  ): UpdateApiBillingSettingsRequest {
    return UpdateApiBillingSettingsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateApiBillingSettingsRequest>, I>>(
    object: I
  ): UpdateApiBillingSettingsRequest {
    const message = createBaseUpdateApiBillingSettingsRequest()
    message.settings =
      object.settings !== undefined && object.settings !== null
        ? ApiBillingSettings.fromPartial(object.settings)
        : undefined
    message.currentPassword = object.currentPassword ?? ''
    message.totpCode = object.totpCode ?? undefined
    message.emailCode = object.emailCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    return message
  },
}

function createBaseUpdateApiBillingSettingsResponse(): UpdateApiBillingSettingsResponse {
  return { success: false, settings: undefined, errorMessage: undefined }
}

export const UpdateApiBillingSettingsResponse: MessageFns<UpdateApiBillingSettingsResponse> = {
  encode(
    message: UpdateApiBillingSettingsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.settings !== undefined) {
      ApiBillingSettings.encode(message.settings, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateApiBillingSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateApiBillingSettingsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.settings = ApiBillingSettings.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateApiBillingSettingsResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      settings: isSet(object.settings) ? ApiBillingSettings.fromJSON(object.settings) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: UpdateApiBillingSettingsResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.settings !== undefined) {
      obj.settings = ApiBillingSettings.toJSON(message.settings)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateApiBillingSettingsResponse>, I>>(
    base?: I
  ): UpdateApiBillingSettingsResponse {
    return UpdateApiBillingSettingsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateApiBillingSettingsResponse>, I>>(
    object: I
  ): UpdateApiBillingSettingsResponse {
    const message = createBaseUpdateApiBillingSettingsResponse()
    message.success = object.success ?? false
    message.settings =
      object.settings !== undefined && object.settings !== null
        ? ApiBillingSettings.fromPartial(object.settings)
        : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseCreateCreditCheckoutSessionRequest(): CreateCreditCheckoutSessionRequest {
  return { credits: '0', saveCardForRefill: false, successUrl: '', cancelUrl: '' }
}

export const CreateCreditCheckoutSessionRequest: MessageFns<CreateCreditCheckoutSessionRequest> = {
  encode(
    message: CreateCreditCheckoutSessionRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.credits !== '0') {
      writer.uint32(40).int64(message.credits)
    }
    if (message.saveCardForRefill !== false) {
      writer.uint32(16).bool(message.saveCardForRefill)
    }
    if (message.successUrl !== '') {
      writer.uint32(26).string(message.successUrl)
    }
    if (message.cancelUrl !== '') {
      writer.uint32(34).string(message.cancelUrl)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCreditCheckoutSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateCreditCheckoutSessionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 5: {
          if (tag !== 40) {
            break
          }

          message.credits = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.saveCardForRefill = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.successUrl = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.cancelUrl = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateCreditCheckoutSessionRequest {
    return {
      credits: isSet(object.credits) ? globalThis.String(object.credits) : '0',
      saveCardForRefill: isSet(object.saveCardForRefill)
        ? globalThis.Boolean(object.saveCardForRefill)
        : isSet(object.save_card_for_refill)
          ? globalThis.Boolean(object.save_card_for_refill)
          : false,
      successUrl: isSet(object.successUrl)
        ? globalThis.String(object.successUrl)
        : isSet(object.success_url)
          ? globalThis.String(object.success_url)
          : '',
      cancelUrl: isSet(object.cancelUrl)
        ? globalThis.String(object.cancelUrl)
        : isSet(object.cancel_url)
          ? globalThis.String(object.cancel_url)
          : '',
    }
  },

  toJSON(message: CreateCreditCheckoutSessionRequest): unknown {
    const obj: any = {}
    if (message.credits !== '0') {
      obj.credits = message.credits
    }
    if (message.saveCardForRefill !== false) {
      obj.saveCardForRefill = message.saveCardForRefill
    }
    if (message.successUrl !== '') {
      obj.successUrl = message.successUrl
    }
    if (message.cancelUrl !== '') {
      obj.cancelUrl = message.cancelUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateCreditCheckoutSessionRequest>, I>>(
    base?: I
  ): CreateCreditCheckoutSessionRequest {
    return CreateCreditCheckoutSessionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateCreditCheckoutSessionRequest>, I>>(
    object: I
  ): CreateCreditCheckoutSessionRequest {
    const message = createBaseCreateCreditCheckoutSessionRequest()
    message.credits = object.credits ?? '0'
    message.saveCardForRefill = object.saveCardForRefill ?? false
    message.successUrl = object.successUrl ?? ''
    message.cancelUrl = object.cancelUrl ?? ''
    return message
  },
}

function createBaseCreateCreditCheckoutSessionResponse(): CreateCreditCheckoutSessionResponse {
  return { success: false, checkoutUrl: undefined, errorMessage: undefined }
}

export const CreateCreditCheckoutSessionResponse: MessageFns<CreateCreditCheckoutSessionResponse> =
  {
    encode(
      message: CreateCreditCheckoutSessionResponse,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.success !== false) {
        writer.uint32(8).bool(message.success)
      }
      if (message.checkoutUrl !== undefined) {
        writer.uint32(18).string(message.checkoutUrl)
      }
      if (message.errorMessage !== undefined) {
        writer.uint32(26).string(message.errorMessage)
      }
      return writer
    },

    decode(input: BinaryReader | Uint8Array, length?: number): CreateCreditCheckoutSessionResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseCreateCreditCheckoutSessionResponse()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break
            }

            message.success = reader.bool()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.checkoutUrl = reader.string()
            continue
          }
          case 3: {
            if (tag !== 26) {
              break
            }

            message.errorMessage = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): CreateCreditCheckoutSessionResponse {
      return {
        success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
        checkoutUrl: isSet(object.checkoutUrl)
          ? globalThis.String(object.checkoutUrl)
          : isSet(object.checkout_url)
            ? globalThis.String(object.checkout_url)
            : undefined,
        errorMessage: isSet(object.errorMessage)
          ? globalThis.String(object.errorMessage)
          : isSet(object.error_message)
            ? globalThis.String(object.error_message)
            : undefined,
      }
    },

    toJSON(message: CreateCreditCheckoutSessionResponse): unknown {
      const obj: any = {}
      if (message.success !== false) {
        obj.success = message.success
      }
      if (message.checkoutUrl !== undefined) {
        obj.checkoutUrl = message.checkoutUrl
      }
      if (message.errorMessage !== undefined) {
        obj.errorMessage = message.errorMessage
      }
      return obj
    },

    create<I extends Exact<DeepPartial<CreateCreditCheckoutSessionResponse>, I>>(
      base?: I
    ): CreateCreditCheckoutSessionResponse {
      return CreateCreditCheckoutSessionResponse.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<CreateCreditCheckoutSessionResponse>, I>>(
      object: I
    ): CreateCreditCheckoutSessionResponse {
      const message = createBaseCreateCreditCheckoutSessionResponse()
      message.success = object.success ?? false
      message.checkoutUrl = object.checkoutUrl ?? undefined
      message.errorMessage = object.errorMessage ?? undefined
      return message
    },
  }

function createBaseListCreditLedgerRequest(): ListCreditLedgerRequest {
  return { keyId: undefined, cursor: undefined, limit: 0 }
}

export const ListCreditLedgerRequest: MessageFns<ListCreditLedgerRequest> = {
  encode(
    message: ListCreditLedgerRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.keyId !== undefined) {
      writer.uint32(10).string(message.keyId)
    }
    if (message.cursor !== undefined) {
      writer.uint32(18).string(message.cursor)
    }
    if (message.limit !== 0) {
      writer.uint32(24).uint32(message.limit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCreditLedgerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListCreditLedgerRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.keyId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.cursor = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.limit = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListCreditLedgerRequest {
    return {
      keyId: isSet(object.keyId)
        ? globalThis.String(object.keyId)
        : isSet(object.key_id)
          ? globalThis.String(object.key_id)
          : undefined,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
    }
  },

  toJSON(message: ListCreditLedgerRequest): unknown {
    const obj: any = {}
    if (message.keyId !== undefined) {
      obj.keyId = message.keyId
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListCreditLedgerRequest>, I>>(
    base?: I
  ): ListCreditLedgerRequest {
    return ListCreditLedgerRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListCreditLedgerRequest>, I>>(
    object: I
  ): ListCreditLedgerRequest {
    const message = createBaseListCreditLedgerRequest()
    message.keyId = object.keyId ?? undefined
    message.cursor = object.cursor ?? undefined
    message.limit = object.limit ?? 0
    return message
  },
}

function createBaseCreditLedgerEntry(): CreditLedgerEntry {
  return {
    kind: 0,
    credits: '0',
    createdAtMs: '0',
    reference: '',
    keyId: '',
    source: '',
    dataset: '',
  }
}

export const CreditLedgerEntry: MessageFns<CreditLedgerEntry> = {
  encode(message: CreditLedgerEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.credits !== '0') {
      writer.uint32(16).int64(message.credits)
    }
    if (message.createdAtMs !== '0') {
      writer.uint32(24).int64(message.createdAtMs)
    }
    if (message.reference !== '') {
      writer.uint32(34).string(message.reference)
    }
    if (message.keyId !== '') {
      writer.uint32(42).string(message.keyId)
    }
    if (message.source !== '') {
      writer.uint32(50).string(message.source)
    }
    if (message.dataset !== '') {
      writer.uint32(58).string(message.dataset)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditLedgerEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditLedgerEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.credits = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.createdAtMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.reference = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.keyId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.source = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.dataset = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditLedgerEntry {
    return {
      kind: isSet(object.kind) ? creditLedgerKindFromJSON(object.kind) : 0,
      credits: isSet(object.credits) ? globalThis.String(object.credits) : '0',
      createdAtMs: isSet(object.createdAtMs)
        ? globalThis.String(object.createdAtMs)
        : isSet(object.created_at_ms)
          ? globalThis.String(object.created_at_ms)
          : '0',
      reference: isSet(object.reference) ? globalThis.String(object.reference) : '',
      keyId: isSet(object.keyId)
        ? globalThis.String(object.keyId)
        : isSet(object.key_id)
          ? globalThis.String(object.key_id)
          : '',
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      dataset: isSet(object.dataset) ? globalThis.String(object.dataset) : '',
    }
  },

  toJSON(message: CreditLedgerEntry): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = creditLedgerKindToJSON(message.kind)
    }
    if (message.credits !== '0') {
      obj.credits = message.credits
    }
    if (message.createdAtMs !== '0') {
      obj.createdAtMs = message.createdAtMs
    }
    if (message.reference !== '') {
      obj.reference = message.reference
    }
    if (message.keyId !== '') {
      obj.keyId = message.keyId
    }
    if (message.source !== '') {
      obj.source = message.source
    }
    if (message.dataset !== '') {
      obj.dataset = message.dataset
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditLedgerEntry>, I>>(base?: I): CreditLedgerEntry {
    return CreditLedgerEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditLedgerEntry>, I>>(object: I): CreditLedgerEntry {
    const message = createBaseCreditLedgerEntry()
    message.kind = object.kind ?? 0
    message.credits = object.credits ?? '0'
    message.createdAtMs = object.createdAtMs ?? '0'
    message.reference = object.reference ?? ''
    message.keyId = object.keyId ?? ''
    message.source = object.source ?? ''
    message.dataset = object.dataset ?? ''
    return message
  },
}

function createBaseListCreditLedgerResponse(): ListCreditLedgerResponse {
  return { success: false, entries: [], nextCursor: undefined, errorMessage: undefined }
}

export const ListCreditLedgerResponse: MessageFns<ListCreditLedgerResponse> = {
  encode(
    message: ListCreditLedgerResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.entries) {
      CreditLedgerEntry.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.nextCursor !== undefined) {
      writer.uint32(26).string(message.nextCursor)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCreditLedgerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListCreditLedgerResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.entries.push(CreditLedgerEntry.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.nextCursor = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListCreditLedgerResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => CreditLedgerEntry.fromJSON(e))
        : [],
      nextCursor: isSet(object.nextCursor)
        ? globalThis.String(object.nextCursor)
        : isSet(object.next_cursor)
          ? globalThis.String(object.next_cursor)
          : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: ListCreditLedgerResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => CreditLedgerEntry.toJSON(e))
    }
    if (message.nextCursor !== undefined) {
      obj.nextCursor = message.nextCursor
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListCreditLedgerResponse>, I>>(
    base?: I
  ): ListCreditLedgerResponse {
    return ListCreditLedgerResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListCreditLedgerResponse>, I>>(
    object: I
  ): ListCreditLedgerResponse {
    const message = createBaseListCreditLedgerResponse()
    message.success = object.success ?? false
    message.entries = object.entries?.map((e) => CreditLedgerEntry.fromPartial(e)) || []
    message.nextCursor = object.nextCursor ?? undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseGetCreditSpendStatsRequest(): GetCreditSpendStatsRequest {
  return { fromDay: undefined, toDay: undefined }
}

export const GetCreditSpendStatsRequest: MessageFns<GetCreditSpendStatsRequest> = {
  encode(
    message: GetCreditSpendStatsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.fromDay !== undefined) {
      writer.uint32(10).string(message.fromDay)
    }
    if (message.toDay !== undefined) {
      writer.uint32(18).string(message.toDay)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditSpendStatsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetCreditSpendStatsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.fromDay = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.toDay = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetCreditSpendStatsRequest {
    return {
      fromDay: isSet(object.fromDay)
        ? globalThis.String(object.fromDay)
        : isSet(object.from_day)
          ? globalThis.String(object.from_day)
          : undefined,
      toDay: isSet(object.toDay)
        ? globalThis.String(object.toDay)
        : isSet(object.to_day)
          ? globalThis.String(object.to_day)
          : undefined,
    }
  },

  toJSON(message: GetCreditSpendStatsRequest): unknown {
    const obj: any = {}
    if (message.fromDay !== undefined) {
      obj.fromDay = message.fromDay
    }
    if (message.toDay !== undefined) {
      obj.toDay = message.toDay
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetCreditSpendStatsRequest>, I>>(
    base?: I
  ): GetCreditSpendStatsRequest {
    return GetCreditSpendStatsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditSpendStatsRequest>, I>>(
    object: I
  ): GetCreditSpendStatsRequest {
    const message = createBaseGetCreditSpendStatsRequest()
    message.fromDay = object.fromDay ?? undefined
    message.toDay = object.toDay ?? undefined
    return message
  },
}

function createBaseCreditSpendDay(): CreditSpendDay {
  return { day: '', total: '0', byDataset: {}, bySource: {}, byKey: {} }
}

export const CreditSpendDay: MessageFns<CreditSpendDay> = {
  encode(message: CreditSpendDay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.day !== '') {
      writer.uint32(10).string(message.day)
    }
    if (message.total !== '0') {
      writer.uint32(16).int64(message.total)
    }
    globalThis.Object.entries(message.byDataset).forEach(([key, value]: [string, string]) => {
      CreditSpendDay_ByDatasetEntry.encode(
        { key: key as any, value },
        writer.uint32(26).fork()
      ).join()
    })
    globalThis.Object.entries(message.bySource).forEach(([key, value]: [string, string]) => {
      CreditSpendDay_BySourceEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork()
      ).join()
    })
    globalThis.Object.entries(message.byKey).forEach(([key, value]: [string, string]) => {
      CreditSpendDay_ByKeyEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join()
    })
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditSpendDay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditSpendDay()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.day = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.total = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          const entry3 = CreditSpendDay_ByDatasetEntry.decode(reader, reader.uint32())
          if (entry3.value !== undefined) {
            message.byDataset[entry3.key] = entry3.value
          }
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          const entry4 = CreditSpendDay_BySourceEntry.decode(reader, reader.uint32())
          if (entry4.value !== undefined) {
            message.bySource[entry4.key] = entry4.value
          }
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          const entry5 = CreditSpendDay_ByKeyEntry.decode(reader, reader.uint32())
          if (entry5.value !== undefined) {
            message.byKey[entry5.key] = entry5.value
          }
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditSpendDay {
    return {
      day: isSet(object.day) ? globalThis.String(object.day) : '',
      total: isSet(object.total) ? globalThis.String(object.total) : '0',
      byDataset: isObject(object.byDataset)
        ? (globalThis.Object.entries(object.byDataset) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_dataset)
          ? (globalThis.Object.entries(object.by_dataset) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      bySource: isObject(object.bySource)
        ? (globalThis.Object.entries(object.bySource) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_source)
          ? (globalThis.Object.entries(object.by_source) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      byKey: isObject(object.byKey)
        ? (globalThis.Object.entries(object.byKey) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_key)
          ? (globalThis.Object.entries(object.by_key) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
    }
  },

  toJSON(message: CreditSpendDay): unknown {
    const obj: any = {}
    if (message.day !== '') {
      obj.day = message.day
    }
    if (message.total !== '0') {
      obj.total = message.total
    }
    if (message.byDataset) {
      const entries = globalThis.Object.entries(message.byDataset) as [string, string][]
      if (entries.length > 0) {
        obj.byDataset = {}
        entries.forEach(([k, v]) => {
          obj.byDataset[k] = v
        })
      }
    }
    if (message.bySource) {
      const entries = globalThis.Object.entries(message.bySource) as [string, string][]
      if (entries.length > 0) {
        obj.bySource = {}
        entries.forEach(([k, v]) => {
          obj.bySource[k] = v
        })
      }
    }
    if (message.byKey) {
      const entries = globalThis.Object.entries(message.byKey) as [string, string][]
      if (entries.length > 0) {
        obj.byKey = {}
        entries.forEach(([k, v]) => {
          obj.byKey[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditSpendDay>, I>>(base?: I): CreditSpendDay {
    return CreditSpendDay.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditSpendDay>, I>>(object: I): CreditSpendDay {
    const message = createBaseCreditSpendDay()
    message.day = object.day ?? ''
    message.total = object.total ?? '0'
    message.byDataset = (
      globalThis.Object.entries(object.byDataset ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.bySource = (
      globalThis.Object.entries(object.bySource ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.byKey = (globalThis.Object.entries(object.byKey ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    return message
  },
}

function createBaseCreditSpendDay_ByDatasetEntry(): CreditSpendDay_ByDatasetEntry {
  return { key: '', value: '0' }
}

export const CreditSpendDay_ByDatasetEntry: MessageFns<CreditSpendDay_ByDatasetEntry> = {
  encode(
    message: CreditSpendDay_ByDatasetEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '0') {
      writer.uint32(16).int64(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditSpendDay_ByDatasetEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditSpendDay_ByDatasetEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.value = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditSpendDay_ByDatasetEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '0',
    }
  },

  toJSON(message: CreditSpendDay_ByDatasetEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '0') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditSpendDay_ByDatasetEntry>, I>>(
    base?: I
  ): CreditSpendDay_ByDatasetEntry {
    return CreditSpendDay_ByDatasetEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditSpendDay_ByDatasetEntry>, I>>(
    object: I
  ): CreditSpendDay_ByDatasetEntry {
    const message = createBaseCreditSpendDay_ByDatasetEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? '0'
    return message
  },
}

function createBaseCreditSpendDay_BySourceEntry(): CreditSpendDay_BySourceEntry {
  return { key: '', value: '0' }
}

export const CreditSpendDay_BySourceEntry: MessageFns<CreditSpendDay_BySourceEntry> = {
  encode(
    message: CreditSpendDay_BySourceEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '0') {
      writer.uint32(16).int64(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditSpendDay_BySourceEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditSpendDay_BySourceEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.value = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditSpendDay_BySourceEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '0',
    }
  },

  toJSON(message: CreditSpendDay_BySourceEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '0') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditSpendDay_BySourceEntry>, I>>(
    base?: I
  ): CreditSpendDay_BySourceEntry {
    return CreditSpendDay_BySourceEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditSpendDay_BySourceEntry>, I>>(
    object: I
  ): CreditSpendDay_BySourceEntry {
    const message = createBaseCreditSpendDay_BySourceEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? '0'
    return message
  },
}

function createBaseCreditSpendDay_ByKeyEntry(): CreditSpendDay_ByKeyEntry {
  return { key: '', value: '0' }
}

export const CreditSpendDay_ByKeyEntry: MessageFns<CreditSpendDay_ByKeyEntry> = {
  encode(
    message: CreditSpendDay_ByKeyEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '0') {
      writer.uint32(16).int64(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditSpendDay_ByKeyEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreditSpendDay_ByKeyEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.value = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreditSpendDay_ByKeyEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '0',
    }
  },

  toJSON(message: CreditSpendDay_ByKeyEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '0') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreditSpendDay_ByKeyEntry>, I>>(
    base?: I
  ): CreditSpendDay_ByKeyEntry {
    return CreditSpendDay_ByKeyEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreditSpendDay_ByKeyEntry>, I>>(
    object: I
  ): CreditSpendDay_ByKeyEntry {
    const message = createBaseCreditSpendDay_ByKeyEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? '0'
    return message
  },
}

function createBaseGetCreditSpendStatsResponse(): GetCreditSpendStatsResponse {
  return {
    success: false,
    days: [],
    total: '0',
    byDataset: {},
    bySource: {},
    byKey: {},
    errorMessage: undefined,
  }
}

export const GetCreditSpendStatsResponse: MessageFns<GetCreditSpendStatsResponse> = {
  encode(
    message: GetCreditSpendStatsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.days) {
      CreditSpendDay.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.total !== '0') {
      writer.uint32(24).int64(message.total)
    }
    globalThis.Object.entries(message.byDataset).forEach(([key, value]: [string, string]) => {
      GetCreditSpendStatsResponse_ByDatasetEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork()
      ).join()
    })
    globalThis.Object.entries(message.bySource).forEach(([key, value]: [string, string]) => {
      GetCreditSpendStatsResponse_BySourceEntry.encode(
        { key: key as any, value },
        writer.uint32(42).fork()
      ).join()
    })
    globalThis.Object.entries(message.byKey).forEach(([key, value]: [string, string]) => {
      GetCreditSpendStatsResponse_ByKeyEntry.encode(
        { key: key as any, value },
        writer.uint32(50).fork()
      ).join()
    })
    if (message.errorMessage !== undefined) {
      writer.uint32(58).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditSpendStatsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetCreditSpendStatsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.days.push(CreditSpendDay.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.total = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          const entry4 = GetCreditSpendStatsResponse_ByDatasetEntry.decode(reader, reader.uint32())
          if (entry4.value !== undefined) {
            message.byDataset[entry4.key] = entry4.value
          }
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          const entry5 = GetCreditSpendStatsResponse_BySourceEntry.decode(reader, reader.uint32())
          if (entry5.value !== undefined) {
            message.bySource[entry5.key] = entry5.value
          }
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          const entry6 = GetCreditSpendStatsResponse_ByKeyEntry.decode(reader, reader.uint32())
          if (entry6.value !== undefined) {
            message.byKey[entry6.key] = entry6.value
          }
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetCreditSpendStatsResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      days: globalThis.Array.isArray(object?.days)
        ? object.days.map((e: any) => CreditSpendDay.fromJSON(e))
        : [],
      total: isSet(object.total) ? globalThis.String(object.total) : '0',
      byDataset: isObject(object.byDataset)
        ? (globalThis.Object.entries(object.byDataset) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_dataset)
          ? (globalThis.Object.entries(object.by_dataset) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      bySource: isObject(object.bySource)
        ? (globalThis.Object.entries(object.bySource) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_source)
          ? (globalThis.Object.entries(object.by_source) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      byKey: isObject(object.byKey)
        ? (globalThis.Object.entries(object.byKey) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.by_key)
          ? (globalThis.Object.entries(object.by_key) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: GetCreditSpendStatsResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.days?.length) {
      obj.days = message.days.map((e) => CreditSpendDay.toJSON(e))
    }
    if (message.total !== '0') {
      obj.total = message.total
    }
    if (message.byDataset) {
      const entries = globalThis.Object.entries(message.byDataset) as [string, string][]
      if (entries.length > 0) {
        obj.byDataset = {}
        entries.forEach(([k, v]) => {
          obj.byDataset[k] = v
        })
      }
    }
    if (message.bySource) {
      const entries = globalThis.Object.entries(message.bySource) as [string, string][]
      if (entries.length > 0) {
        obj.bySource = {}
        entries.forEach(([k, v]) => {
          obj.bySource[k] = v
        })
      }
    }
    if (message.byKey) {
      const entries = globalThis.Object.entries(message.byKey) as [string, string][]
      if (entries.length > 0) {
        obj.byKey = {}
        entries.forEach(([k, v]) => {
          obj.byKey[k] = v
        })
      }
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetCreditSpendStatsResponse>, I>>(
    base?: I
  ): GetCreditSpendStatsResponse {
    return GetCreditSpendStatsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditSpendStatsResponse>, I>>(
    object: I
  ): GetCreditSpendStatsResponse {
    const message = createBaseGetCreditSpendStatsResponse()
    message.success = object.success ?? false
    message.days = object.days?.map((e) => CreditSpendDay.fromPartial(e)) || []
    message.total = object.total ?? '0'
    message.byDataset = (
      globalThis.Object.entries(object.byDataset ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.bySource = (
      globalThis.Object.entries(object.bySource ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.byKey = (globalThis.Object.entries(object.byKey ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseGetCreditSpendStatsResponse_ByDatasetEntry(): GetCreditSpendStatsResponse_ByDatasetEntry {
  return { key: '', value: '0' }
}

export const GetCreditSpendStatsResponse_ByDatasetEntry: MessageFns<GetCreditSpendStatsResponse_ByDatasetEntry> =
  {
    encode(
      message: GetCreditSpendStatsResponse_ByDatasetEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '0') {
        writer.uint32(16).int64(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): GetCreditSpendStatsResponse_ByDatasetEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseGetCreditSpendStatsResponse_ByDatasetEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 16) {
              break
            }

            message.value = reader.int64().toString()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): GetCreditSpendStatsResponse_ByDatasetEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '0',
      }
    },

    toJSON(message: GetCreditSpendStatsResponse_ByDatasetEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '0') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_ByDatasetEntry>, I>>(
      base?: I
    ): GetCreditSpendStatsResponse_ByDatasetEntry {
      return GetCreditSpendStatsResponse_ByDatasetEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_ByDatasetEntry>, I>>(
      object: I
    ): GetCreditSpendStatsResponse_ByDatasetEntry {
      const message = createBaseGetCreditSpendStatsResponse_ByDatasetEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? '0'
      return message
    },
  }

function createBaseGetCreditSpendStatsResponse_BySourceEntry(): GetCreditSpendStatsResponse_BySourceEntry {
  return { key: '', value: '0' }
}

export const GetCreditSpendStatsResponse_BySourceEntry: MessageFns<GetCreditSpendStatsResponse_BySourceEntry> =
  {
    encode(
      message: GetCreditSpendStatsResponse_BySourceEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '0') {
        writer.uint32(16).int64(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): GetCreditSpendStatsResponse_BySourceEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseGetCreditSpendStatsResponse_BySourceEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 16) {
              break
            }

            message.value = reader.int64().toString()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): GetCreditSpendStatsResponse_BySourceEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '0',
      }
    },

    toJSON(message: GetCreditSpendStatsResponse_BySourceEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '0') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_BySourceEntry>, I>>(
      base?: I
    ): GetCreditSpendStatsResponse_BySourceEntry {
      return GetCreditSpendStatsResponse_BySourceEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_BySourceEntry>, I>>(
      object: I
    ): GetCreditSpendStatsResponse_BySourceEntry {
      const message = createBaseGetCreditSpendStatsResponse_BySourceEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? '0'
      return message
    },
  }

function createBaseGetCreditSpendStatsResponse_ByKeyEntry(): GetCreditSpendStatsResponse_ByKeyEntry {
  return { key: '', value: '0' }
}

export const GetCreditSpendStatsResponse_ByKeyEntry: MessageFns<GetCreditSpendStatsResponse_ByKeyEntry> =
  {
    encode(
      message: GetCreditSpendStatsResponse_ByKeyEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '0') {
        writer.uint32(16).int64(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): GetCreditSpendStatsResponse_ByKeyEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBaseGetCreditSpendStatsResponse_ByKeyEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 16) {
              break
            }

            message.value = reader.int64().toString()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): GetCreditSpendStatsResponse_ByKeyEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '0',
      }
    },

    toJSON(message: GetCreditSpendStatsResponse_ByKeyEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '0') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_ByKeyEntry>, I>>(
      base?: I
    ): GetCreditSpendStatsResponse_ByKeyEntry {
      return GetCreditSpendStatsResponse_ByKeyEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<GetCreditSpendStatsResponse_ByKeyEntry>, I>>(
      object: I
    ): GetCreditSpendStatsResponse_ByKeyEntry {
      const message = createBaseGetCreditSpendStatsResponse_ByKeyEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? '0'
      return message
    },
  }

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'))
  } else {
    const bin = globalThis.atob(b64)
    const arr = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i)
    }
    return arr
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString('base64')
  } else {
    const bin: string[] = []
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte))
    })
    return globalThis.btoa(bin.join(''))
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
